import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  ISO8601Date: any;
  ISO8601DateTime: any;
  JSON: any;
};

/** Autogenerated input type of AccountingAsync */
export type AccountingAsyncInput = {
  accountingAsyncAttributes?: InputMaybe<BackOfficeAsyncInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of AccountingAsync */
export type AccountingAsyncPayload = {
  __typename?: 'AccountingAsyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AccountingExport = {
  __typename?: 'AccountingExport';
  collection: Array<Collection>;
};

/** Autogenerated input type of AcknowledgeNote */
export type AcknowledgeNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: NoteAcknowledgeInput;
};

/** Autogenerated return type of AcknowledgeNote */
export type AcknowledgeNotePayload = {
  __typename?: 'AcknowledgeNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  note?: Maybe<Note>;
};

/** Autogenerated input type of AddAssetForWarehouse */
export type AddAssetForWarehouseInput = {
  assetId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryOrderId: Scalars['ID'];
  productId: Scalars['ID'];
  requestedVolume?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<DeliveryOrderLineItemTypeEnum>;
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of AddAssetForWarehouse */
export type AddAssetForWarehousePayload = {
  __typename?: 'AddAssetForWarehousePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deliveryOrderLineItem?: Maybe<DeliveryOrderLineItem>;
  message: Scalars['String'];
};

/** Autogenerated input type of AddAssetToDeliveryOrder */
export type AddAssetToDeliveryOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryOrderId: Scalars['ID'];
  requestedVolume?: InputMaybe<Scalars['Float']>;
  subscriptionId: Scalars['ID'];
  topOff?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<DeliveryOrderLineItemTypeEnum>;
};

/** Autogenerated return type of AddAssetToDeliveryOrder */
export type AddAssetToDeliveryOrderPayload = {
  __typename?: 'AddAssetToDeliveryOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deliveryOrderLineItem?: Maybe<DeliveryOrderLineItem>;
  message: Scalars['String'];
};

/** Add Code To Asset Input */
export type AddCodeInput = {
  assetId: Scalars['ID'];
  code: Scalars['String'];
  codeType: CodeTypeEnum;
};

/** Autogenerated input type of AddCodeToAsset */
export type AddCodeToAssetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  codeAttributes: AddCodeInput;
};

/** Autogenerated return type of AddCodeToAsset */
export type AddCodeToAssetPayload = {
  __typename?: 'AddCodeToAssetPayload';
  asset?: Maybe<Asset>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of AddFeeToOrderGroup */
export type AddFeeToOrderGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  feeId: Scalars['ID'];
  isManuallyUpdated?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Float']>;
  offsetRate?: InputMaybe<Scalars['Float']>;
  orderGroupId: Scalars['ID'];
  price: Scalars['Float'];
  quantity: Scalars['Float'];
};

/** Autogenerated return type of AddFeeToOrderGroup */
export type AddFeeToOrderGroupPayload = {
  __typename?: 'AddFeeToOrderGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
};

/** Autogenerated input type of AddFeesToOrderGroup */
export type AddFeesToOrderGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  feeIds: Array<Scalars['ID']>;
  orderGroupId: Scalars['ID'];
};

/** Autogenerated return type of AddFeesToOrderGroup */
export type AddFeesToOrderGroupPayload = {
  __typename?: 'AddFeesToOrderGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
};

/** Autogenerated input type of AddOrderGroupsToShift */
export type AddOrderGroupsToShiftInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  isBulk?: InputMaybe<Scalars['Boolean']>;
  orderGroupIds: Array<Scalars['ID']>;
  shiftId: Scalars['ID'];
};

/** Autogenerated return type of AddOrderGroupsToShift */
export type AddOrderGroupsToShiftPayload = {
  __typename?: 'AddOrderGroupsToShiftPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errorMsg?: Maybe<Scalars['String']>;
  orderGroups?: Maybe<Array<OrderGroup>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of AddQrCodeToAsset */
export type AddQrCodeToAssetInput = {
  assetId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  qrCodeText: Scalars['String'];
};

/** Autogenerated return type of AddQrCodeToAsset */
export type AddQrCodeToAssetPayload = {
  __typename?: 'AddQrCodeToAssetPayload';
  asset?: Maybe<Asset>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AddressBook = {
  __typename?: 'AddressBook';
  address?: Maybe<Scalars['String']>;
  addressBookType?: Maybe<Scalars['String']>;
  customerBranches?: Maybe<Array<CustomerBranch>>;
  customers?: Maybe<Array<Customer>>;
  email?: Maybe<Scalars['String']>;
  hasAccessToCustomerPortal?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  image?: Maybe<AttachedFile>;
  isDeliveryTicketRecipient?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  showInviteLink?: Maybe<Scalars['Boolean']>;
};

export type AddressBookCollection = {
  __typename?: 'AddressBookCollection';
  collection: Array<AddressBook>;
  metadata: MetaQuery;
};

export type AddressBookFilter = {
  address?: InputMaybe<Scalars['String']>;
  all?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<AddressBookFilter>>;
  phone?: InputMaybe<Scalars['String']>;
};

/** Point of contact Input */
export type AddressBookInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  addressBookType?: InputMaybe<AddressBookTypeEnum>;
  email?: InputMaybe<Scalars['String']>;
  hasAccessToCustomerPortal?: InputMaybe<Scalars['Boolean']>;
  /** ID of point of contact. */
  id?: InputMaybe<Scalars['ID']>;
  imageSignedBlobId?: InputMaybe<Scalars['ID']>;
  isDeliveryTicketRecipient?: InputMaybe<Scalars['Boolean']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type AddressBookSorter = {
  field: AddressBookSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum AddressBookSorterEnum {
  Address = 'ADDRESS',
  Email = 'EMAIL',
  Name = 'NAME',
  Phone = 'PHONE'
}

export enum AddressBookTypeEnum {
  /** Credit Representative */
  CreditRep = 'credit_rep',
  /** Delivery Ticket Recipient */
  DeliveryTicketRecipient = 'delivery_ticket_recipient',
  /** Sales Representative */
  SalesRep = 'sales_rep'
}

/** Inventory Adjustment Inventory Input */
export type AdjustInput = {
  adjustmentId?: InputMaybe<Scalars['ID']>;
  adjustmentVolume: Scalars['Float'];
  assetId?: InputMaybe<Scalars['ID']>;
  assetName?: InputMaybe<Scalars['String']>;
  bolNumber?: InputMaybe<Scalars['String']>;
  compartmentId: Scalars['ID'];
  customerName?: InputMaybe<Scalars['String']>;
  extractionOrderId?: InputMaybe<Scalars['ID']>;
  inventoryVolume?: InputMaybe<Scalars['Float']>;
  isUpdated?: InputMaybe<Scalars['String']>;
  loadingReceiptId?: InputMaybe<Scalars['ID']>;
  orderGroupId?: InputMaybe<Scalars['ID']>;
  productId: Scalars['ID'];
  reason: Scalars['String'];
  startedOn?: InputMaybe<Scalars['String']>;
  terminalId?: InputMaybe<Scalars['ID']>;
  terminalName?: InputMaybe<Scalars['String']>;
  transferOrderId?: InputMaybe<Scalars['ID']>;
};

/** Inventory Adjustment Input */
export type AdjustInventoriesInput = {
  assetId: Scalars['ID'];
  inventories?: InputMaybe<Array<AdjustInput>>;
};

/** Autogenerated input type of AdjustInventory */
export type AdjustInventoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  shiftDeliveryAssets: Array<AdjustInventoriesInput>;
  shiftId: Scalars['ID'];
};

/** Autogenerated return type of AdjustInventory */
export type AdjustInventoryPayload = {
  __typename?: 'AdjustInventoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  shift?: Maybe<Shift>;
};

export type AliasMapping = {
  __typename?: 'AliasMapping';
  createdAt: Scalars['ISO8601DateTime'];
  dataSource: Scalars['String'];
  id: Scalars['ID'];
  mappable?: Maybe<Mappable>;
  mappableId?: Maybe<Scalars['ID']>;
  mappableType?: Maybe<MappableTypeEnum>;
  sourceValue?: Maybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type AliasMappingCollection = {
  __typename?: 'AliasMappingCollection';
  collection: Array<AliasMapping>;
  metadata: MetaQuery;
};

export type AliasMappingInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  dataSource: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  mappableId?: InputMaybe<Scalars['ID']>;
  mappableType: MappableTypeEnum;
  sourceValue: Scalars['String'];
};

export type AppData = {
  __typename?: 'AppData';
  appBuild?: Maybe<Scalars['String']>;
  appOta?: Maybe<Scalars['String']>;
  appVersion?: Maybe<Scalars['String']>;
  authorization?: Maybe<Scalars['String']>;
  batteryLevel?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  controllerAction?: Maybe<Scalars['String']>;
  ip?: Maybe<Scalars['String']>;
  isLocationEnabled?: Maybe<Scalars['String']>;
  isLocationPermissionEnabled?: Maybe<Scalars['String']>;
  lastSyncedAt?: Maybe<Scalars['ISO8601DateTime']>;
  lowPowerMode?: Maybe<Scalars['String']>;
  mac?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  os?: Maybe<Scalars['String']>;
  osVersion?: Maybe<Scalars['String']>;
};

export type AppVersion = {
  __typename?: 'AppVersion';
  buildNumber?: Maybe<Scalars['String']>;
  environment?: Maybe<Scalars['String']>;
  firmwareFiles?: Maybe<Array<AttachedFile>>;
  id: Scalars['ID'];
  ota?: Maybe<Scalars['String']>;
  platform: Scalars['String'];
  updatedAt?: Maybe<Scalars['Int']>;
  versionNumber?: Maybe<Scalars['String']>;
};

export type AppVersionCollection = {
  __typename?: 'AppVersionCollection';
  collection: Array<AppVersion>;
  metadata: MetaQuery;
};

export type AppVersionFilter = {
  search?: InputMaybe<Scalars['String']>;
};

/** Data to create App Version */
export type AppVersionInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  buildNumber?: InputMaybe<Scalars['String']>;
  environment?: InputMaybe<Scalars['String']>;
  firmwareFiles?: InputMaybe<Array<DirectAttachmentInput>>;
  id?: InputMaybe<Scalars['ID']>;
  ota?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  versionNumber?: InputMaybe<Scalars['String']>;
};

export type ApplicableFee = {
  __typename?: 'ApplicableFee';
  fee?: Maybe<Fee>;
  feeable?: Maybe<Feeable>;
  feeableId: Scalars['ID'];
  feeableType: Scalars['String'];
  hardcoded?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isDefault?: Maybe<Scalars['Boolean']>;
  netsuiteId?: Maybe<Scalars['ID']>;
  parentFeeId?: Maybe<Scalars['ID']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

export type ApplicableFeeCollection = {
  __typename?: 'ApplicableFeeCollection';
  collection: Array<ApplicableFee>;
  metadata: MetaQuery;
};

export type ApplicableFeeFilter = {
  all?: InputMaybe<Scalars['String']>;
  feeId?: InputMaybe<Scalars['ID']>;
  feeableId?: InputMaybe<Scalars['ID']>;
  feeableType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<ApplicableFeeFilter>>;
  priceGte?: InputMaybe<Scalars['Float']>;
  priceLte?: InputMaybe<Scalars['Float']>;
};

export type ApplicableFeeSorter = {
  field: ApplicableFeeSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum ApplicableFeeSorterEnum {
  Name = 'NAME',
  Price = 'PRICE'
}

/** Data to create order quote */
export type ApplicableFeesInput = {
  id: Scalars['ID'];
  rate?: InputMaybe<Scalars['Float']>;
};

export type ApplicableMargin = {
  __typename?: 'ApplicableMargin';
  id?: Maybe<Scalars['ID']>;
  margin?: Maybe<Margin>;
  parentMargin?: Maybe<ApplicableMargin>;
  parentMarginId?: Maybe<Scalars['ID']>;
};

/** Default ApplicableMargins Input */
export type ApplicableMarginsInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  marginId?: InputMaybe<Scalars['ID']>;
  parentMarginId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type ApplicableTax = {
  __typename?: 'ApplicableTax';
  id?: Maybe<Scalars['ID']>;
  parentTax?: Maybe<ApplicableTax>;
  parentTaxId?: Maybe<Scalars['ID']>;
  position?: Maybe<Scalars['Int']>;
  tax?: Maybe<Tax>;
};

/** Default ApplicableTaxes Input */
export type ApplicableTaxesInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  parentTaxId?: InputMaybe<Scalars['ID']>;
  position?: InputMaybe<Scalars['Int']>;
  taxId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};

/** Enum for fee applicable types */
export enum ApplicableTypeEnum {
  /** For credit card type */
  CreditCard = 'credit_card',
  /** For delivery type */
  Delivery = 'delivery',
  /** For minimum load fee type */
  MinimumLoadFee = 'minimum_load_fee',
  /** For service type */
  Service = 'service'
}

export type AppliedMargin = {
  __typename?: 'AppliedMargin';
  applicableMargin?: Maybe<ApplicableMargin>;
  id?: Maybe<Scalars['ID']>;
  marginsProduct?: Maybe<MarginsProduct>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** Applied Margins Input */
export type AppliedMarginsInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Float']>;
  quantity?: InputMaybe<Scalars['Float']>;
  total?: InputMaybe<Scalars['Float']>;
};

export type AppliedPricing = {
  __typename?: 'AppliedPricing';
  appliedMargins?: Maybe<Array<AppliedMargin>>;
  appliedTaxes?: Maybe<Array<AppliedTax>>;
  cardInTime?: Maybe<Scalars['ISO8601DateTime']>;
  completedOn?: Maybe<Scalars['ISO8601DateTime']>;
  customer?: Maybe<ResourceDetails>;
  customerBranch?: Maybe<ResourceDetails>;
  data?: Maybe<Scalars['String']>;
  /** Deprecated, use delivery_order_line_item_ids instead */
  deliveryOrderLineItemId?: Maybe<Scalars['ID']>;
  deliveryOrderLineItemIds?: Maybe<Array<Scalars['ID']>>;
  discount?: Maybe<Scalars['Float']>;
  error?: Maybe<AppliedPricingError>;
  hubId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  isManuallyUpdated?: Maybe<Scalars['Boolean']>;
  isMobileOffline?: Maybe<Scalars['Boolean']>;
  isTemporaryPricing?: Maybe<Scalars['Boolean']>;
  /** Deprecated, use loading_order_line_item_ids instead */
  loadingOrderLineItemId?: Maybe<Scalars['ID']>;
  loadingOrderLineItemIds?: Maybe<Array<Scalars['ID']>>;
  marketId?: Maybe<Scalars['ID']>;
  orderGroupId?: Maybe<Scalars['ID']>;
  orderType?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  pricing?: Maybe<Pricing>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']>;
  quantity?: Maybe<Scalars['Float']>;
  receiptNumber?: Maybe<Scalars['String']>;
  resourcePricing?: Maybe<ResourcePricing>;
  success?: Maybe<Scalars['Boolean']>;
  sumTotal?: Maybe<Scalars['Float']>;
  supplierId?: Maybe<Scalars['ID']>;
  temporaryPricingData?: Maybe<TemporaryPricingDate>;
  terminalId?: Maybe<Scalars['ID']>;
  total?: Maybe<Scalars['Float']>;
  updateActDriverId?: Maybe<Scalars['ID']>;
};

export type AppliedPricingError = {
  __typename?: 'AppliedPricingError';
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type AppliedTax = {
  __typename?: 'AppliedTax';
  applicableTax?: Maybe<ApplicableTax>;
  id?: Maybe<Scalars['ID']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** Applied Tax Input */
export type AppliedTaxesInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  isManuallyDeleted?: InputMaybe<Scalars['Boolean']>;
  price?: InputMaybe<Scalars['Float']>;
  quantity?: InputMaybe<Scalars['Float']>;
  total?: InputMaybe<Scalars['Float']>;
};

export enum ApplyAsOnFeeEnum {
  /** Default Option */
  Default = '_default',
  /** Per Asset */
  PerAsset = 'per_asset',
  /** Per Delivery */
  PerDelivery = 'per_delivery',
  /** Per Gallon */
  PerGallon = 'per_gallon',
  /** Per Hour */
  PerHour = 'per_hour',
  /** Per Mile */
  PerMile = 'per_mile',
  /** Per Minute */
  PerMinute = 'per_minute'
}

export type ApproveOrCancelOrderInput = {
  /** Action to perform: 'APPROVE' or 'CANCEL' */
  action: OrderApproveCancelEnum;
  assetIdsAndOrderIds?: InputMaybe<Array<AssetIdsAndOrderIds>>;
  orderIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Autogenerated input type of ArchiveDrivers */
export type ArchiveDriversInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Autogenerated return type of ArchiveDrivers */
export type ArchiveDriversPayload = {
  __typename?: 'ArchiveDriversPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  drivers?: Maybe<Array<Driver>>;
};

/** Autogenerated input type of ArrivedAtCustomer */
export type ArrivedAtCustomerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryOrderId?: InputMaybe<Scalars['ID']>;
  /** Don't use, deprecated! */
  taskId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of ArrivedAtCustomer */
export type ArrivedAtCustomerPayload = {
  __typename?: 'ArrivedAtCustomerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
  /** Don't use, deprecated! */
  task?: Maybe<Task>;
};

/** Autogenerated input type of ArrivedAtTerminal */
export type ArrivedAtTerminalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  loadingOrderId?: InputMaybe<Scalars['ID']>;
  /** Don't use, deprecated! */
  taskId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of ArrivedAtTerminal */
export type ArrivedAtTerminalPayload = {
  __typename?: 'ArrivedAtTerminalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
  /** Don't use, deprecated! */
  task?: Maybe<Task>;
};

export type Asset = {
  __typename?: 'Asset';
  activeLease?: Maybe<Scalars['Boolean']>;
  activeShift?: Maybe<Shift>;
  actualRoi?: Maybe<Scalars['Float']>;
  assetMovementLocation?: Maybe<AssetMovementLocation>;
  assetProductCategories?: Maybe<Array<AssetProductCategory>>;
  assetsPeripherals?: Maybe<Array<AssetsPeripheral>>;
  assignedPandaBox?: Maybe<PandaBox>;
  averageDaysBetweenFills?: Maybe<Scalars['Int']>;
  averageUtilization?: Maybe<Scalars['Int']>;
  barcodeText?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  categoryProducts?: Maybe<Array<Product>>;
  color?: Maybe<Scalars['String']>;
  compartments?: Maybe<Array<Compartment>>;
  costOfTank?: Maybe<Scalars['Float']>;
  createdBy?: Maybe<User>;
  customer?: Maybe<Customer>;
  customerBranch?: Maybe<CustomerBranch>;
  data?: Maybe<Scalars['JSON']>;
  enableZone?: Maybe<Scalars['Boolean']>;
  erpId?: Maybe<Scalars['String']>;
  estimatedGallonsPerMonth?: Maybe<Scalars['Float']>;
  existingActiveMovementOrderIds?: Maybe<Array<Scalars['ID']>>;
  expectedRoi?: Maybe<Scalars['Float']>;
  fuelCategories?: Maybe<Array<Scalars['String']>>;
  /** @deprecated Use fuel_categories instead. */
  fuelCategory?: Maybe<Array<Scalars['String']>>;
  fuelTypeProducts?: Maybe<Array<Product>>;
  /** Supported for Company, Rental and Delivery Assets only */
  hubResources?: Maybe<Array<HubResource>>;
  /** Supported for Company, Rental and Delivery Assets only */
  hubs?: Maybe<Array<Hub>>;
  id: Scalars['ID'];
  installDate?: Maybe<Scalars['ISO8601Date']>;
  irelyId?: Maybe<Scalars['String']>;
  isRunningFuelOffsetAsset?: Maybe<Scalars['Boolean']>;
  isTransport?: Maybe<Scalars['Boolean']>;
  lastActiveTenantId?: Maybe<Scalars['ID']>;
  lastActiveTenantName?: Maybe<Scalars['String']>;
  /** Timestamp when the asset was last delivered */
  lastDeliveredTimestamp?: Maybe<Scalars['Int']>;
  lastDeliveredVolume?: Maybe<Scalars['Float']>;
  lastSyncedTime?: Maybe<Scalars['String']>;
  /** Deprecated, use asset_movement_location instead */
  lat?: Maybe<Scalars['String']>;
  licensePlateNumber?: Maybe<Scalars['String']>;
  lineOfServices?: Maybe<Array<LineOfService>>;
  /** Deprecated, use asset_movement_location instead */
  lng?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  margin?: Maybe<Scalars['Float']>;
  marketValue?: Maybe<Scalars['Float']>;
  model?: Maybe<Scalars['String']>;
  movementOrders?: Maybe<Array<MovementOrder>>;
  name?: Maybe<Scalars['String']>;
  netsuiteId?: Maybe<Scalars['ID']>;
  noOfZone?: Maybe<Scalars['Int']>;
  numberOfDays?: Maybe<Scalars['Int']>;
  pandaDocuments?: Maybe<Array<PandaDocument>>;
  productSubscriptions?: Maybe<Array<Subscription>>;
  purchasedOn?: Maybe<Scalars['ISO8601DateTime']>;
  qrCodeText?: Maybe<Scalars['String']>;
  rentalAssetAtCustomer: Scalars['Boolean'];
  rfidCode?: Maybe<Scalars['String']>;
  routingVehicleType?: Maybe<Scalars['String']>;
  site?: Maybe<Site>;
  startDate?: Maybe<Scalars['ISO8601Date']>;
  status?: Maybe<Scalars['String']>;
  subscriptions?: Maybe<Array<Subscription>>;
  taggings?: Maybe<Array<Tagging>>;
  tankMonitor?: Maybe<Device>;
  tankSize?: Maybe<Scalars['String']>;
  tankType?: Maybe<Scalars['String']>;
  terminals?: Maybe<Array<Terminal>>;
  /** Timestamp when the asset was last delivered (from Tank Monitor) */
  tmLastDeliveredTimestamp?: Maybe<Scalars['Int']>;
  tmLastDeliveredVolume?: Maybe<Scalars['Float']>;
  trackInventory?: Maybe<Scalars['Boolean']>;
  transitCustomerBranch?: Maybe<CustomerBranch>;
  type?: Maybe<Scalars['String']>;
  useInDelivery?: Maybe<Scalars['Boolean']>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
  zoneProductBatches?: Maybe<Array<ZoneProductBatch>>;
};


export type AssetCompartmentsArgs = {
  deletedAfter?: InputMaybe<Scalars['Int']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type AssetSubscriptionsArgs = {
  showAll?: InputMaybe<Scalars['Boolean']>;
};

export enum AssetApprovalStatusEnum {
  /** Approved */
  Approved = 'approved',
  /** Pending */
  Pending = 'pending',
  /** Rejected */
  Rejected = 'rejected'
}

export enum AssetCategoryEnum {
  /** Above Ground Storage Tank */
  AboveGroundStorageTank = 'above_ground_storage_tank',
  /** Box Truck */
  BoxTruck = 'box_truck',
  /** Card Lock Pump */
  CardLockPump = 'card_lock_pump',
  /** Drum */
  Drum = 'drum',
  /** Equipment */
  Equipment = 'equipment',
  /** Fire Pump */
  FirePump = 'fire_pump',
  /** Flatbed Truck */
  FlatbedTruck = 'flatbed_truck',
  /** Gas Station Generator */
  GasStationGenerator = 'gas_station_generator',
  /** Generator */
  Generator = 'generator',
  /** Marine Vessel */
  MarineVessel = 'marine_vessel',
  /** Mobile Generator */
  MobileGenerator = 'mobile_generator',
  /** Others */
  Others = 'others',
  /** Permanent Generator */
  PermanentGenerator = 'permanent_generator',
  /** Reefer */
  Reefer = 'reefer',
  /** Semi */
  Semi = 'semi',
  /** Tank */
  Tank = 'tank',
  /** Tank wagon */
  TankWagon = 'tank_wagon',
  /** Tote */
  Tote = 'tote',
  /** Tractor */
  Tractor = 'tractor',
  /** Trailer */
  Trailer = 'trailer',
  /** Train */
  Train = 'train',
  /** Truck */
  Truck = 'truck',
  /** Under Ground Storage Tank */
  UnderGroundStorageTank = 'under_ground_storage_tank',
  /** Vehicle */
  Vehicle = 'vehicle'
}

export type AssetCollection = {
  __typename?: 'AssetCollection';
  collection: Array<Asset>;
  metadata: MetaQuery;
};

export type AssetFilter = {
  all?: InputMaybe<Scalars['String']>;
  approvalStatus?: InputMaybe<AssetApprovalStatusEnum>;
  atSelfCustomerLocation?: InputMaybe<Scalars['Boolean']>;
  availableForMovementOrder?: InputMaybe<Scalars['Boolean']>;
  /** Any categories among ["tank_wagon", "truck", "box_truck", "flatbed_truck", "trailer", "tank", "vehicle", "others", "equipment", "generator", "reefer", "card_lock_pump", "tractor", "semi", "fire_pump", "mobile_generator", "permanent_generator", "gas_station_generator", "above_ground_storage_tank", "under_ground_storage_tank", "marine_vessel", "train", "drum", "tote"] */
  categories?: InputMaybe<Array<Scalars['String']>>;
  customerBranchId?: InputMaybe<Array<Scalars['ID']>>;
  customerIds?: InputMaybe<Array<Scalars['ID']>>;
  isLeoAssetFilter?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<AssetFilter>>;
  productCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  qrCode?: InputMaybe<Scalars['String']>;
  /** Any status among ["active", "inactive", "paused"] */
  statuses?: InputMaybe<Array<Scalars['String']>>;
  tankSize?: InputMaybe<Scalars['Float']>;
  tankType?: InputMaybe<TankTypeEnum>;
  type?: InputMaybe<AssetTypeEnum>;
  types?: InputMaybe<Array<AssetTypeEnum>>;
  /** Filter only unlinked assets */
  unlinked?: InputMaybe<Scalars['Boolean']>;
  useInDelivery?: InputMaybe<Scalars['Boolean']>;
};

export type AssetIdsAndOrderIds = {
  assetId: Scalars['ID'];
  orderId: Scalars['ID'];
};

/** Asset Input */
export type AssetInput = {
  category?: InputMaybe<Scalars['String']>;
  deliveryOrderLineItemsAttributes?: InputMaybe<Array<DeliveryOrderLineItemInput>>;
  licensePlate?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['ID']>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type AssetInventoriesFilter = {
  assetId?: InputMaybe<Scalars['ID']>;
  fromDate?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['ID']>;
  toDate?: InputMaybe<Scalars['Int']>;
};

/** AssetInventories Input */
export type AssetInventoriesInput = {
  assetId: Scalars['ID'];
  inventories?: InputMaybe<Array<InventoryInput>>;
};

export type AssetInventoryFilter = {
  assetIds?: InputMaybe<Array<Scalars['ID']>>;
  fromDate: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  toDate?: InputMaybe<Scalars['Int']>;
};

export enum AssetLinkStateEnum {
  /** Devices linked to assets */
  Linked = 'LINKED',
  /** Devices not linked to assets */
  Unlinked = 'UNLINKED'
}

/** AssetMovementLocation Type */
export type AssetMovementLocation = {
  __typename?: 'AssetMovementLocation';
  id: Scalars['ID'];
  lat?: Maybe<Scalars['String']>;
  lng?: Maybe<Scalars['String']>;
  orderGroupId?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  updatable?: Maybe<Updatable>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** AssetMovementLocation Input */
export type AssetMovementLocationInput = {
  id?: InputMaybe<Scalars['ID']>;
  lat?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['String']>;
  orderGroupId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
};

/** AssetMovementOrderHistoryList Type */
export type AssetMovementOrderHistory = {
  __typename?: 'AssetMovementOrderHistory';
  actualRoi?: Maybe<Scalars['Float']>;
  averageDaysBetweenFills?: Maybe<Scalars['Int']>;
  completedDate?: Maybe<Scalars['ISO8601Date']>;
  customerBranchId?: Maybe<Scalars['String']>;
  customerBranchName?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  expectedRoi?: Maybe<Scalars['Float']>;
  numberOfDays?: Maybe<Scalars['Int']>;
  startedDate?: Maybe<Scalars['ISO8601Date']>;
};

/** AssetMovementOrderHistoryList Type */
export type AssetMovementOrderHistoryList = {
  __typename?: 'AssetMovementOrderHistoryList';
  completedOn?: Maybe<Scalars['ISO8601DateTime']>;
  driverName?: Maybe<Scalars['String']>;
  licensePlateNumber?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  volume?: Maybe<Scalars['Float']>;
};

export type AssetMovementOrderHistoryListCollection = {
  __typename?: 'AssetMovementOrderHistoryListCollection';
  collection: Array<AssetMovementOrderHistoryList>;
  metadata: MetaQuery;
};

export type AssetMovementOrderHistoryListFilter = {
  all?: InputMaybe<Scalars['String']>;
  completedOn?: InputMaybe<Scalars['ISO8601DateTime']>;
  customerBranchId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<AssetMovementOrderHistoryListFilter>>;
  rentalAssetId: Scalars['ID'];
  startedOn?: InputMaybe<Scalars['ISO8601DateTime']>;
};

export type AssetMovementOrderHistorySorter = {
  field: AssetMovementOrderHistorySorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum AssetMovementOrderHistorySorterEnum {
  Completedon = 'COMPLETEDON',
  Licenseplatenumber = 'LICENSEPLATENUMBER',
  Productname = 'PRODUCTNAME',
  Workername = 'WORKERNAME'
}

export type AssetProductCategory = {
  __typename?: 'AssetProductCategory';
  id: Scalars['ID'];
  networkName?: Maybe<Scalars['String']>;
  networkNumber?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  productCategory?: Maybe<ProductCategory>;
  registerModel?: Maybe<Scalars['String']>;
  totalizer?: Maybe<Scalars['Float']>;
};

export enum AssetRoutingVehicleTypesEnum {
  /** Car */
  Car = 'car',
  /** Small Truck */
  SmallTruck = 'small_truck',
  /** Truck */
  Truck = 'truck'
}

export type AssetSorter = {
  field: AssetSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum AssetSorterEnum {
  Createdby = 'CREATEDBY',
  Erpid = 'ERPID',
  Installdate = 'INSTALLDATE',
  Name = 'NAME',
  Shipto = 'SHIPTO',
  Status = 'STATUS',
  Type = 'TYPE',
  TankSize = 'TankSize',
  Uniqueid = 'UNIQUEID'
}

export enum AssetStatusEnum {
  /** Active */
  Active = 'active',
  /** Inactive */
  Inactive = 'inactive',
  /** Inactive */
  Paused = 'paused'
}

/** Enum for asset types */
export enum AssetTypeEnum {
  /** For company assets type */
  CompanyAsset = 'CompanyAsset',
  /** For customer assets type */
  CustomerAsset = 'CustomerAsset',
  /** For delivery assets type */
  DeliveryAsset = 'DeliveryAsset',
  /** For rental assets type */
  RentalAsset = 'RentalAsset'
}

export type AssetsInventoriesInventoryRecordType = {
  __typename?: 'AssetsInventoriesInventoryRecordType';
  asset: Asset;
  averageCost?: Maybe<Scalars['Float']>;
  date: Scalars['Int'];
  linkedReferences: Array<Scalars['JSON']>;
  orderType: Scalars['String'];
  product?: Maybe<Product>;
  quantity?: Maybe<Scalars['Float']>;
  startingBalance?: Maybe<Scalars['Float']>;
  totalAdjustmentVolume?: Maybe<Scalars['Float']>;
  totalCost?: Maybe<Scalars['Float']>;
  totalExtractedVolume?: Maybe<Scalars['Float']>;
  totalPurchaseVolume?: Maybe<Scalars['Float']>;
  totalSalesVolume?: Maybe<Scalars['Float']>;
  totalTransferVolume?: Maybe<Scalars['Float']>;
  transactionType?: Maybe<Scalars['String']>;
  users?: Maybe<Scalars['String']>;
  volume?: Maybe<Scalars['Float']>;
};

export type AssetsInventoriesInventoryRecordTypeCollection = {
  __typename?: 'AssetsInventoriesInventoryRecordTypeCollection';
  collection: Array<AssetsInventoriesInventoryRecordType>;
  metadata: MetaQuery;
};

export type AssetsPeripheral = {
  __typename?: 'AssetsPeripheral';
  assetId?: Maybe<Scalars['ID']>;
  assetsPeripheralsRecords?: Maybe<Array<AssetsPeripheralsRecord>>;
  id: Scalars['ID'];
  peripheralId: Scalars['ID'];
};

export type AssetsPeripheralInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  assetId?: InputMaybe<Scalars['ID']>;
  assetsPeripheralsRecordsAttributes?: InputMaybe<Array<AssetsPeripheralsRecordInput>>;
  id?: InputMaybe<Scalars['ID']>;
  peripheralId: Scalars['ID'];
};

export type AssetsPeripheralsRecord = {
  __typename?: 'AssetsPeripheralsRecord';
  assetsPeripheralId?: Maybe<Scalars['Int']>;
  fileUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  peripheralAttributeId: Scalars['Int'];
  value?: Maybe<Scalars['String']>;
};

export type AssetsPeripheralsRecordInput = {
  assetsPeripheralId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  peripheralAttributeId: Scalars['ID'];
  value?: InputMaybe<Scalars['String']>;
};

/** Assign Panda box */
export type AssignBoxInput = {
  active: Scalars['Boolean'];
  assetId: Scalars['ID'];
  pandaBoxId: Scalars['ID'];
};

/** Autogenerated input type of AssignDeliveryAssetWithInventory */
export type AssignDeliveryAssetWithInventoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  preShiftTotalizerNotes?: InputMaybe<Array<TotalizerInput>>;
  shiftDeliveryAssets: Array<AssetInventoriesInput>;
  shiftId: Scalars['ID'];
};

/** Autogenerated return type of AssignDeliveryAssetWithInventory */
export type AssignDeliveryAssetWithInventoryPayload = {
  __typename?: 'AssignDeliveryAssetWithInventoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  shift?: Maybe<Shift>;
};

/** Autogenerated input type of AssignPandaBox */
export type AssignPandaBoxInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: Array<AssignBoxInput>;
};

/** Autogenerated return type of AssignPandaBox */
export type AssignPandaBoxPayload = {
  __typename?: 'AssignPandaBoxPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type AssignedInput = {
  ccTenantId?: InputMaybe<Scalars['ID']>;
  orders: Array<OrderInput>;
  workerId?: InputMaybe<Scalars['ID']>;
};

/** Associate Irely Entity with Fleetpanda Input */
export type AssociateIrelyEntityInput = {
  fpValue: Scalars['String'];
  irelyEntityId: Scalars['ID'];
  /** Enity Type */
  irelyEntityType: IrelyEntityEnum;
};

/** Autogenerated input type of AssociateIrelyEntityWithFp */
export type AssociateIrelyEntityWithFpInput = {
  associateIrelyEntityAttributes: AssociateIrelyEntityInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of AssociateIrelyEntityWithFp */
export type AssociateIrelyEntityWithFpPayload = {
  __typename?: 'AssociateIrelyEntityWithFpPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AttachedAsset = {
  __typename?: 'AttachedAsset';
  asset?: Maybe<Asset>;
  assetId?: Maybe<Scalars['ID']>;
  assetTankCapacity?: Maybe<Scalars['Float']>;
  autoOrder?: Maybe<Scalars['Boolean']>;
  consumptionCalculationDays?: Maybe<Scalars['Int']>;
  customer?: Maybe<Customer>;
  customerBranch?: Maybe<CustomerBranch>;
  draftAsset?: Maybe<Asset>;
  draftAssetId?: Maybe<Scalars['ID']>;
  hubIds?: Maybe<Array<Scalars['ID']>>;
  hubs?: Maybe<Array<Subject>>;
  id?: Maybe<Scalars['ID']>;
  maxThreshold?: Maybe<Scalars['Float']>;
  minThreshold?: Maybe<Scalars['Float']>;
  orderConfirmation?: Maybe<Scalars['Boolean']>;
  orderFillPercentage?: Maybe<Scalars['Float']>;
  orderType?: Maybe<TmOrderTypeEnum>;
  poNumber?: Maybe<Scalars['String']>;
  preferenceAvailability?: Maybe<Array<AttachedAssetAvailability>>;
  purchaseOrder?: Maybe<Scalars['Boolean']>;
  quantity?: Maybe<Scalars['Float']>;
  refuelTanksThreshold?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  topOffBy?: Maybe<Scalars['String']>;
  topOffQuantity?: Maybe<Scalars['Float']>;
};

export type AttachedAssetAvailability = {
  __typename?: 'AttachedAssetAvailability';
  bestEndTime?: Maybe<Scalars['String']>;
  bestStartTime?: Maybe<Scalars['String']>;
  day?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  preferredEndTime?: Maybe<Scalars['String']>;
  preferredStartTime?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
};

/** Attached file information */
export type AttachedFile = {
  __typename?: 'AttachedFile';
  contentType?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['String']>;
};

/** Attachment Input */
export type AttachmentInput = {
  /** Base64 conversion of file */
  base64Data: Scalars['String'];
  /** Specify if attachment is of special, like: signature, completion, delivery_ticket, attachments, tank_chart, invoices, driver_signature, shift_documents, customer_assets, lea_pre_signatures, lea_post_signatures, panda_boxes, panda_box_meters, power_source, meter_wiring, preshift_checklist_documents, raw_pricing_file, normalized_pricing_file, failed_pricing_file, temp_pricing_file, transfer_order_bol_image, notes, and transposition_data */
  documentType?: InputMaybe<Scalars['String']>;
  /** ID of resource to which this document is to be associated */
  documentableId?: InputMaybe<Scalars['ID']>;
  /** Resource Name[ex: DeliveryOrder, Shift, LoadingOrder] to which this document is to be associated */
  documentableType?: InputMaybe<Scalars['String']>;
  /** Name of the file */
  fileName: Scalars['String'];
  /** Deprecated, use document_type */
  type?: InputMaybe<Scalars['String']>;
};

export type AuthInput = {
  password: Scalars['String'];
  phone: Scalars['String'];
};

/** Autogenerated input type of AutoLinkOrders */
export type AutoLinkOrdersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  shiftId: Scalars['ID'];
};

/** Autogenerated return type of AutoLinkOrders */
export type AutoLinkOrdersPayload = {
  __typename?: 'AutoLinkOrdersPayload';
  autoLinkOrders?: Maybe<AutoLinkOrdersResponse>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AutoLinkOrdersResponse = {
  __typename?: 'AutoLinkOrdersResponse';
  errors?: Maybe<Array<Scalars['JSON']>>;
  success: Scalars['Boolean'];
};

export type Availability = {
  __typename?: 'Availability';
  bestEndTime?: Maybe<Scalars['String']>;
  bestStartTime?: Maybe<Scalars['String']>;
  day?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  preferredEndTime?: Maybe<Scalars['String']>;
  preferredStartTime?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
};

/** Resource Schedule Availability Input */
export type AvailabilityInput = {
  /** Best end time of availability, eg: Seconds value in a day example 3pm = 10800 second */
  bestEndTime?: InputMaybe<Scalars['String']>;
  /** Best start time of availability, eg: Seconds value in a day example 3pm = 10800 second */
  bestStartTime?: InputMaybe<Scalars['String']>;
  /** Day of the week */
  day?: InputMaybe<Scalars['String']>;
  /** End time of availability, eg: Seconds value in a day example 3pm = 10800 second */
  endTime?: InputMaybe<Scalars['String']>;
  /** Preferred end time of availability, eg: Seconds value in a day example 3pm = 10800 second */
  preferredEndTime?: InputMaybe<Scalars['String']>;
  /** Preferred start time of availability, eg: Seconds value in a day example 3pm = 10800 second */
  preferredStartTime?: InputMaybe<Scalars['String']>;
  /** Start time of availability, eg: Seconds value in a day example 3pm = 10800 seconds */
  startTime?: InputMaybe<Scalars['String']>;
};

/** Input of accounting async */
export type BackOfficeAsyncInput = {
  shiftIds: Array<Scalars['ID']>;
  vendorName: VendorNameEnum;
};

export type BaseSorter = {
  field: Scalars['String'];
  order?: InputMaybe<FieldOrder>;
};

export type Batch = {
  __typename?: 'Batch';
  batchNumber?: Maybe<Scalars['String']>;
  customerBranch?: Maybe<CustomerBranch>;
  hoseNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  products?: Maybe<Array<Product>>;
  quantity?: Maybe<Scalars['Float']>;
  toteNumber?: Maybe<Scalars['String']>;
  zoneProductBatches?: Maybe<Array<ZoneProductBatch>>;
};

/** Batch Input */
export type BatchInput = {
  batchNumber?: InputMaybe<Scalars['String']>;
  customerBranchId?: InputMaybe<Scalars['ID']>;
  hoseNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  initialQty?: InputMaybe<Scalars['Float']>;
  quantity?: InputMaybe<Scalars['Float']>;
  toteNumber?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of BatchOperations */
export type BatchOperationsInput = {
  bulkUpdateAttributes?: InputMaybe<Array<BulksInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of BatchOperations */
export type BatchOperationsPayload = {
  __typename?: 'BatchOperationsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  result?: Maybe<BulkAssign>;
};

export type BiResponse = {
  __typename?: 'BiResponse';
  response: Scalars['String'];
  success: Scalars['Boolean'];
};

export type BlendLoadingProduct = {
  __typename?: 'BlendLoadingProduct';
  blendProduct: Product;
  id: Scalars['ID'];
};

export type BlendVolumeValidationError = {
  __typename?: 'BlendVolumeValidationError';
  blendProductId: Scalars['ID'];
  blendProductName: Scalars['String'];
  loadingOrderId: Scalars['ID'];
  message: Scalars['String'];
  orderGroupId: Scalars['ID'];
  productId: Scalars['ID'];
  productName: Scalars['String'];
};

export type Bol = {
  __typename?: 'Bol';
  bolNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  pandaDocuments: Array<PandaDocument>;
  supplier: Supplier;
};

export type BolError = {
  __typename?: 'BolError';
  compartmentId?: Maybe<Scalars['ID']>;
  orderGroupId?: Maybe<Scalars['ID']>;
  productId?: Maybe<Scalars['ID']>;
  shiftId?: Maybe<Scalars['ID']>;
  volume?: Maybe<Scalars['Float']>;
};

export type BolPricing = {
  __typename?: 'BolPricing';
  id: Scalars['ID'];
  itemType: Scalars['String'];
  loadingReceipt?: Maybe<LoadingReceipt>;
  orderGroup?: Maybe<OrderGroup>;
  product: Product;
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  tax?: Maybe<BolPricingsTaxType>;
  total?: Maybe<Scalars['Float']>;
};

/** Create Bol Pricing input */
export type BolPricingsCreateBolPricingInput = {
  itemType: ItemTypeEnum;
  loadingReceiptId: Scalars['ID'];
  orderGroupId: Scalars['ID'];
  productId: Scalars['ID'];
  rate?: InputMaybe<Scalars['Float']>;
  taxId?: InputMaybe<Scalars['ID']>;
};

export type BolPricingsTaxType = {
  __typename?: 'BolPricingsTaxType';
  erpId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  productCategoryId?: Maybe<Scalars['ID']>;
  rateType: Scalars['String'];
};

/** Update Bol Pricing input */
export type BolPricingsUpdateBolPricingInput = {
  id: Scalars['ID'];
  rate?: InputMaybe<Scalars['Float']>;
  taxId?: InputMaybe<Scalars['ID']>;
};

export type BolReport = {
  __typename?: 'BolReport';
  adjustedVolume?: Maybe<Scalars['Float']>;
  asset?: Maybe<Scalars['String']>;
  bol: Scalars['String'];
  deliveries?: Maybe<Array<Scalars['JSON']>>;
  externalId?: Maybe<Scalars['String']>;
  fromState?: Maybe<Scalars['String']>;
  grossVolume?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  loadingOrder?: Maybe<LoadingOrder>;
  netVolume?: Maybe<Scalars['Float']>;
  notes?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  residualVolume?: Maybe<Scalars['Float']>;
  supplier?: Maybe<Supplier>;
  terminal?: Maybe<Terminal>;
  transfers?: Maybe<Array<Scalars['JSON']>>;
  worker?: Maybe<Driver>;
};

export type BolReportCollection = {
  __typename?: 'BolReportCollection';
  collection: Array<BolReport>;
  metadata: MetaQuery;
};

export type BolReportFilter = {
  cardInTimestamp?: InputMaybe<Scalars['Int']>;
  cardOutTimestamp?: InputMaybe<Scalars['Int']>;
  divergenceOrder?: InputMaybe<Scalars['Boolean']>;
  supplierIds?: InputMaybe<Array<Scalars['ID']>>;
  terminalIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type BolRetain = {
  __typename?: 'BolRetain';
  id: Scalars['ID'];
  orderGroup?: Maybe<OrderGroup>;
  product?: Maybe<Product>;
  shiftId?: Maybe<Scalars['ID']>;
  timeTimestamp?: Maybe<Scalars['Int']>;
  volume?: Maybe<Scalars['Float']>;
};

/** Bol Retain Input */
export type BolRetainInput = {
  orderGroupId?: InputMaybe<Scalars['ID']>;
  productId: Scalars['ID'];
  shiftId: Scalars['ID'];
  volume: Scalars['Float'];
};

export enum BolTimeAtEnum {
  /** Card in */
  CardIn = 'card_in',
  /** Card out */
  CardOut = 'card_out'
}

export type BoxTransactionFilter = {
  completedOn?: InputMaybe<Scalars['Int']>;
  pandaBoxId: Scalars['ID'];
};

export type Brand = {
  __typename?: 'Brand';
  brandType?: Maybe<BrandTypeEnum>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

/** Brand type enum */
export enum BrandTypeEnum {
  Default = 'default',
  Supplier = 'supplier'
}

/** Autogenerated input type of BrokerageCreateOrderGroupMutation */
export type BrokerageCreateOrderGroupMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Order group input type. */
  orderGroupAttributes?: InputMaybe<BrokerageOrderGroupInput>;
};

/** Autogenerated return type of BrokerageCreateOrderGroupMutation */
export type BrokerageCreateOrderGroupMutationPayload = {
  __typename?: 'BrokerageCreateOrderGroupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Order group type. */
  orderGroup?: Maybe<OrderGroup>;
};

/** Brokerage DeliveryOrder Input */
export type BrokerageDeliveryOrderInput = {
  /** Deprecated. DO NOT USE. */
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** Deprecated. DO NOT USE. */
  attachmentsAttributes?: InputMaybe<Array<AttachmentInput>>;
  customerBranchErpId?: InputMaybe<Scalars['String']>;
  /** Customer Branch/Site ID. */
  customerBranchId?: InputMaybe<Scalars['ID']>;
  /** Descriptive delivery instructions. */
  deliveryInstruction?: InputMaybe<Scalars['String']>;
  /** DeliveryOrderLineItemInput object. */
  deliveryOrderLineItemsAttributes?: InputMaybe<Array<BrokerageDeliveryOrderLineItemInput>>;
  /** Discrepency Value. */
  discrepancyValue?: InputMaybe<Scalars['Float']>;
  diversionNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** PandaDocumentInput object. */
  driverSignatureAttributes?: InputMaybe<PandaDocumentInput>;
  /** DeliveryOrder ID. */
  id?: InputMaybe<Scalars['ID']>;
  /** Invoice Number. */
  invoiceNumber?: InputMaybe<Scalars['String']>;
  invoices?: InputMaybe<Array<DirectAttachmentInput>>;
  /** AssetsInputs */
  newAssetsAttributes?: InputMaybe<Array<AssetInput>>;
  /** Delivery Note Input. */
  notesAttributes?: InputMaybe<Array<NoteInput>>;
  orderEndLocation?: InputMaybe<GenericLocationInput>;
  /** OrderGroupInput object. */
  orderGroup?: InputMaybe<OrderGroupInput>;
  /** Customer's purchase order number. */
  orderNumber?: InputMaybe<Scalars['String']>;
  orderStartLocation?: InputMaybe<GenericLocationInput>;
  pandaDocuments?: InputMaybe<Array<DirectAttachmentInput>>;
  /** PandaDocumentInput object. */
  postDeliveryPhotosAttributes?: InputMaybe<Array<PandaDocumentInput>>;
  printedName?: InputMaybe<Scalars['String']>;
  /** PandaDocumentInput object. */
  signatureAttributes?: InputMaybe<PandaDocumentInput>;
  /** Source of the DeliveryOrder */
  source?: InputMaybe<Scalars['String']>;
  totalizers?: InputMaybe<Array<TotalizerInput>>;
  type?: InputMaybe<DeliveryOrderTypeEnum>;
};

/** Brokerage DeliveryOrderLineItem Input */
export type BrokerageDeliveryOrderLineItemInput = {
  /** Deprecated. DO NOT USE. */
  _destroy?: InputMaybe<Scalars['Boolean']>;
  assetErpId?: InputMaybe<Scalars['String']>;
  /** Asset ID. */
  assetId?: InputMaybe<Scalars['ID']>;
  /** CompartmentInstanceInput object. */
  compartmentInstancesAttributes?: InputMaybe<Array<CompartmentInstanceInput>>;
  /** Customer Branch/Site ID. */
  customerBranchId?: InputMaybe<Scalars['ID']>;
  /** Miscellaneous JSON data. */
  data?: InputMaybe<Scalars['JSON']>;
  /** DeliveryOrderLineItem ID. */
  id?: InputMaybe<Scalars['ID']>;
  lat?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['String']>;
  /** Name of LCR meter */
  meterName?: InputMaybe<Scalars['String']>;
  mobileGeneratedId?: InputMaybe<Scalars['String']>;
  /** Add/Update Driver Notes. */
  notes?: InputMaybe<Scalars['String']>;
  /** PandaBoxes transactions. */
  pandaBoxTransactionsAttributes?: InputMaybe<Array<PandaBoxTransactionInput>>;
  productErpId?: InputMaybe<Scalars['String']>;
  /** Product ID. */
  productId?: InputMaybe<Scalars['ID']>;
  /** Product Resource ID. */
  productResourceId?: InputMaybe<Scalars['ID']>;
  /** Requested volume. */
  requestedVolume?: InputMaybe<Scalars['Float']>;
  /** Delivery skip reason. */
  skipReason?: InputMaybe<Scalars['String']>;
  /** Source of the DeliveryOrderLineItem. */
  source?: InputMaybe<Scalars['String']>;
  /** SourceCompartmentInput object. */
  sourceAssetsAttributes?: InputMaybe<Array<SourceAssetInput>>;
  /** SourceCompartmentInput object. */
  sourceCompartmentsAttributes?: InputMaybe<Array<SourceCompartmentInput>>;
  /** Status of the DeliveryOrderLineItem. */
  status?: InputMaybe<Scalars['String']>;
  /** Subscription ID. */
  subscriptionId?: InputMaybe<Scalars['ID']>;
  /** Fuel test result */
  testResult?: InputMaybe<ProductTestEnum>;
  /** Whether top off was requested */
  topOff?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<DeliveryOrderLineItemTypeEnum>;
  /** Flag parameter to specify whether to sync requested volume of loading order. */
  updateRequestedLoadingVolume?: InputMaybe<Scalars['Boolean']>;
  /** Id of warehouse from which packaged product is to be loaded. */
  warehouseId?: InputMaybe<Scalars['ID']>;
  /** Water test result */
  waterTestResult?: InputMaybe<WaterTestResultEnum>;
};

/** Brokerage OrderGroup Input */
export type BrokerageOrderGroupInput = {
  /** Asset ID used while creating the order for pick and pack */
  assetId?: InputMaybe<Scalars['ID']>;
  /** Asset Movement Location. */
  assetMovementLocationsAttribute?: InputMaybe<AssetMovementLocationInput>;
  /** Carrier order number. */
  carrierNumber?: InputMaybe<Scalars['String']>;
  /** CC Tenant ID. */
  ccTenantId?: InputMaybe<Scalars['ID']>;
  /** Completed time. Required if driver is provided. */
  completedOnTimestamp?: InputMaybe<Scalars['Int']>;
  /** Credit Card Payment */
  creditCardPayment?: InputMaybe<Scalars['Boolean']>;
  /** Customer Branch ID. */
  customerBranchId?: InputMaybe<Scalars['ID']>;
  /** Delivery order input object. */
  deliveryOrderAttributes?: InputMaybe<BrokerageDeliveryOrderInput>;
  /** Delivery order input object. */
  deliveryOrdersAttributes?: InputMaybe<Array<DeliveryOrderInput>>;
  /** Departed time. Required if driver is provided. */
  departedOnTimestamp?: InputMaybe<Scalars['Int']>;
  /** ERP ID of the */
  erpId?: InputMaybe<Scalars['String']>;
  /** Geofence in record locations and timestamps */
  fenceIns?: InputMaybe<Array<GeofenceRecordInput>>;
  /** Geofence out records locations and timestamps */
  fenceOuts?: InputMaybe<Array<GeofenceRecordInput>>;
  /** geofence errors */
  geoError?: InputMaybe<GeofenceErrorEnum>;
  /** ID of the order group. Required during update. */
  id?: InputMaybe<Scalars['ID']>;
  isDriverLinkable?: InputMaybe<Scalars['Boolean']>;
  /** Is linked order group */
  isLinkedOrderGroup?: InputMaybe<Scalars['Boolean']>;
  isWarehouseAssetLinkable?: InputMaybe<Scalars['Boolean']>;
  /** Loading order input object. */
  loadingOrderAttributes?: InputMaybe<LoadingOrderInput>;
  /** Loading order input object. */
  loadingOrdersAttributes?: InputMaybe<Array<LoadingOrderInput>>;
  /** Lock pricing for order group while creating order */
  lockPricing?: InputMaybe<Scalars['Boolean']>;
  /** Transfer order input object. */
  movementOrderAttributes?: InputMaybe<MovementOrderInput>;
  /** Set this value to true incase of offline */
  offlineOperation?: InputMaybe<Scalars['Boolean']>;
  orderEndLocation?: InputMaybe<GenericLocationInput>;
  orderGroupsFeesAttributes?: InputMaybe<Array<UpdateOrderGroupFeeInput>>;
  orderStartLocation?: InputMaybe<GenericLocationInput>;
  /** Indicates if order group is outside available time slots */
  outsideAvailability?: InputMaybe<Scalars['Boolean']>;
  /** Paid/Unpaid status of cash */
  paid?: InputMaybe<Scalars['Boolean']>;
  /** Panda documents for order group */
  pandaDocuments?: InputMaybe<Array<NestedPandaDocumentsInput>>;
  /** Payment Type Name */
  paymentTypeName?: InputMaybe<PaymentTypeEnum>;
  /** Customer's purchase order number. */
  poNumber?: InputMaybe<Scalars['String']>;
  /** Should be either urgent or normal */
  priority?: InputMaybe<OrderGroupPriorityEnum>;
  purchaseOrderType?: InputMaybe<PurchaseOrderTypeEnum>;
  /** Raw Shift ID. */
  rawShiftId?: InputMaybe<Scalars['ID']>;
  /** Recurrence configuration */
  recurrence?: InputMaybe<RecurrenceInput>;
  /** Order of the order in Route */
  routingOrder?: InputMaybe<Scalars['Int']>;
  /** Send carrier email. */
  sendCarrierEmail?: InputMaybe<Scalars['Boolean']>;
  /** Send driver email */
  sendDriverEmail?: InputMaybe<Scalars['Boolean']>;
  /** Shift ID. */
  shiftId?: InputMaybe<Scalars['ID']>;
  /** Start time. Required if driver is provided. */
  startOnTimestamp?: InputMaybe<Scalars['Int']>;
  /** Started time. Required if driver is provided. */
  startedOnTimestamp?: InputMaybe<Scalars['Int']>;
  /** Status of the order; When scheduled is changed to any status, It is required to have shift defined for driver. */
  status?: InputMaybe<Scalars['String']>;
  taggingsAttributes?: InputMaybe<Array<TaggingInput>>;
  /** To Start On time. Required for certain planned time window. */
  toStartOnTimestamp?: InputMaybe<Scalars['Int']>;
  /** Transfer order input object. */
  transferOrderAttributes?: InputMaybe<TransferOrderInput>;
  /** Assigned User ID. */
  userId?: InputMaybe<Scalars['ID']>;
  warehouseAssetId?: InputMaybe<Scalars['ID']>;
  /** Driver ID. */
  workerId?: InputMaybe<Scalars['ID']>;
  zoneProductBatchesAttributes?: InputMaybe<Array<ZoneProductBatchInput>>;
};

export type BulkAssign = {
  __typename?: 'BulkAssign';
  orderGroups?: Maybe<Array<Result>>;
};

/** Autogenerated input type of BulkAsyncRefetchOrderQueueStatus */
export type BulkAsyncRefetchOrderQueueStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryOrderIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of BulkAsyncRefetchOrderQueueStatus */
export type BulkAsyncRefetchOrderQueueStatusPayload = {
  __typename?: 'BulkAsyncRefetchOrderQueueStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type BulkEmail = {
  __typename?: 'BulkEmail';
  deliveryOrder?: Maybe<BulkEmailDeliveryOrder>;
  driverEmail?: Maybe<Scalars['String']>;
  driverName?: Maybe<Scalars['String']>;
  loadingOrderDetails?: Maybe<Array<BulkEmailLoadingOrder>>;
  orderGroupId?: Maybe<Scalars['ID']>;
};

export type BulkEmailDeliveryOrder = {
  __typename?: 'BulkEmailDeliveryOrder';
  customer: Scalars['String'];
  customerBranch?: Maybe<Scalars['JSON']>;
  deliveryInstruction?: Maybe<Scalars['String']>;
  deliveryOrderLineItems?: Maybe<Array<BulkEmailDoli>>;
  plannedAt?: Maybe<Scalars['String']>;
  toPlannedAt?: Maybe<Scalars['String']>;
};

export type BulkEmailDoli = {
  __typename?: 'BulkEmailDoli';
  assetName?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
};

export type BulkEmailLoadingOrder = {
  __typename?: 'BulkEmailLoadingOrder';
  isSplitOrder?: Maybe<Scalars['Boolean']>;
  loadingInstruction?: Maybe<Scalars['String']>;
  loadingOrderLineItems?: Maybe<Array<BulkEmailLoli>>;
  orderGroupId?: Maybe<Scalars['ID']>;
  terminal: Scalars['String'];
  terminalAddress?: Maybe<Scalars['String']>;
};

export type BulkEmailLoli = {
  __typename?: 'BulkEmailLoli';
  preferredSuppliers?: Maybe<Array<BulkEmailSupplier>>;
  productName?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['String']>;
};

export type BulkEmailSupplier = {
  __typename?: 'BulkEmailSupplier';
  carrierCustomerCode?: Maybe<Scalars['String']>;
  loadingAccountNumber?: Maybe<Scalars['String']>;
  supplierName?: Maybe<Scalars['String']>;
};

/** Bulk Input */
export type BulkInput = {
  assetId?: InputMaybe<Scalars['ID']>;
  ccTenantId?: InputMaybe<Scalars['ID']>;
  completedOn?: InputMaybe<Scalars['ISO8601DateTime']>;
  duplicate?: InputMaybe<Scalars['Boolean']>;
  ids: Array<Scalars['ID']>;
  plannedTime?: InputMaybe<Scalars['String']>;
  poNumber?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['String']>;
  startedOn?: InputMaybe<Scalars['ISO8601DateTime']>;
  status?: InputMaybe<OrderGroupStatusEnum>;
  tagIds?: InputMaybe<Array<Scalars['ID']>>;
  toStartOn?: InputMaybe<Scalars['ISO8601DateTime']>;
  trailerIds?: InputMaybe<Array<Scalars['ID']>>;
  workerId?: InputMaybe<Scalars['ID']>;
};

/** send email to driver */
export type BulkOrderEmailToDriverInput = {
  bccs?: InputMaybe<Array<Scalars['String']>>;
  ccs?: InputMaybe<Array<Scalars['String']>>;
  orderGroupIds: Array<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  tos?: InputMaybe<Array<Scalars['String']>>;
};

/** Bulk Order Unblocks Result */
export type BulkOrderUnblocksResult = {
  __typename?: 'BulkOrderUnblocksResult';
  errors?: Maybe<Array<Scalars['String']>>;
  failureIds?: Maybe<Array<Scalars['ID']>>;
  invalidIds?: Maybe<Array<Scalars['ID']>>;
  successIds?: Maybe<Array<Scalars['ID']>>;
};

export type BulkPlantInventory = {
  __typename?: 'BulkPlantInventory';
  asset?: Maybe<Asset>;
  dispatchInitialQty?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  previousShiftQty?: Maybe<Scalars['ID']>;
  product?: Maybe<Product>;
  resource?: Maybe<ShiftResource>;
  retainQty?: Maybe<Scalars['ID']>;
  startQty?: Maybe<Scalars['ID']>;
};

/** AssetInventories Input */
export type BulkPlantsAssetInventoriesInput = {
  assetId: Scalars['ID'];
  inventories?: InputMaybe<Array<BulkPlantsInventoryInput>>;
};

export type BulkPlantsFiltersInput = {
  timestamp?: InputMaybe<Scalars['Int']>;
};

/** Inventory Input */
export type BulkPlantsInventoryInput = {
  adjustmentType: ShiftInventoryAdjustmentTypes;
  adjustmentVolume: Scalars['Float'];
  productId?: InputMaybe<Scalars['ID']>;
};

export type BulkPlantsOrderGroupType = {
  __typename?: 'BulkPlantsOrderGroupType';
  allNotes?: Maybe<Array<Note>>;
  assignable?: Maybe<Groupable>;
  carrierEmailSentAt?: Maybe<Scalars['ISO8601DateTime']>;
  carrierNumber?: Maybe<Scalars['String']>;
  ccDeliveryAddress?: Maybe<Scalars['String']>;
  ccTenant?: Maybe<CcTenant>;
  ccTenantId?: Maybe<Scalars['Int']>;
  completeOnTimestamp?: Maybe<Scalars['Int']>;
  completedOn?: Maybe<Scalars['Int']>;
  completedOnTimestamp?: Maybe<Scalars['Int']>;
  creatable?: Maybe<Groupable>;
  createdAtTimestamp: Scalars['Int'];
  customerBranch?: Maybe<CustomerBranch>;
  deliveryOrder?: Maybe<DeliveryOrder>;
  departedOn?: Maybe<Scalars['ISO8601DateTime']>;
  departedOnTimestamp?: Maybe<Scalars['Int']>;
  destinationOrderLinks?: Maybe<Array<SourceAssociation>>;
  driver?: Maybe<Driver>;
  driverAcceptance: Scalars['String'];
  extractionOrder?: Maybe<ExtractionOrder>;
  fees?: Maybe<Array<Fee>>;
  feesPricingStatus?: Maybe<FeesPricingStatusEnum>;
  hub?: Maybe<Hub>;
  id: Scalars['ID'];
  lineOfService?: Maybe<LineOfService>;
  loadingOrder?: Maybe<LoadingOrder>;
  mainOrderGroupId?: Maybe<Scalars['ID']>;
  mainOrderGroupTenant?: Maybe<Scalars['String']>;
  movementOrder?: Maybe<MovementOrder>;
  offlineOperation?: Maybe<Scalars['Boolean']>;
  orderEndLocation?: Maybe<GenericLocation>;
  orderGroupChildren?: Maybe<Array<OrderGroup>>;
  orderGroupCustomer?: Maybe<Customer>;
  orderGroupsFees?: Maybe<Array<OrderGroupsFee>>;
  orderStartLocation?: Maybe<GenericLocation>;
  poNumber?: Maybe<Scalars['String']>;
  priority?: Maybe<OrderGroupPriorityEnum>;
  purchaseOrderRequired?: Maybe<Scalars['Boolean']>;
  purchaseOrderType?: Maybe<Scalars['String']>;
  rawShiftId?: Maybe<Scalars['ID']>;
  routingOrder?: Maybe<Scalars['Int']>;
  sendCarrierEmail?: Maybe<Scalars['Boolean']>;
  shift?: Maybe<Shift>;
  shiftId?: Maybe<Scalars['ID']>;
  sourceOrderLinks?: Maybe<Array<DestinationAssociation>>;
  startOn?: Maybe<Scalars['ISO8601DateTime']>;
  startOnTimestamp?: Maybe<Scalars['Int']>;
  startedOn?: Maybe<Scalars['ISO8601DateTime']>;
  startedOnTimestamp?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  /** @deprecated Dont use this. This uses too much resources */
  tasks?: Maybe<Array<Task>>;
  ticketId: Scalars['Int'];
  transferOrder?: Maybe<TransferOrder>;
  unloadOrder?: Maybe<UnloadOrder>;
  user?: Maybe<User>;
  worker?: Maybe<Worker>;
};

export type BulkPlantsShiftResourceType = {
  __typename?: 'BulkPlantsShiftResourceType';
  bulkPlantInventories?: Maybe<Array<BulkPlantInventory>>;
  id: Scalars['ID'];
  resourceable?: Maybe<ShiftResource>;
  shiftResourceType: Scalars['String'];
};

export type BulkPlantsShiftType = {
  __typename?: 'BulkPlantsShiftType';
  activity?: Maybe<Scalars['JSON']>;
  actualDuration?: Maybe<Scalars['Int']>;
  adjustedInventories?: Maybe<Array<InventoryAdjustment>>;
  bolErrors?: Maybe<Array<BolError>>;
  bolRetains?: Maybe<Array<BolRetain>>;
  bulkPlantShiftResource?: Maybe<BulkPlantsShiftResourceType>;
  deliveryTruck?: Maybe<DeliveryAsset>;
  distributionTransferOrders?: Maybe<Array<TransferOrder>>;
  duration?: Maybe<Scalars['Int']>;
  enableClearingAccountingData?: Maybe<Scalars['Boolean']>;
  endLocation?: Maybe<Scalars['String']>;
  endOnTimestamp?: Maybe<Scalars['Int']>;
  errors?: Maybe<Scalars['JSON']>;
  hasData?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  notes?: Maybe<Array<Note>>;
  offlineOperation?: Maybe<Scalars['Boolean']>;
  orderGroups?: Maybe<Array<BulkPlantsOrderGroupType>>;
  orphanTransferOrders?: Maybe<Array<TransferOrder>>;
  receiptTransferOrders?: Maybe<Array<TransferOrder>>;
  shiftAssetProducts?: Maybe<Array<ShiftAssetProduct>>;
  shiftCompartmentInstances?: Maybe<Array<ShiftCompartmentInstance>>;
  shiftDeliveryUnitsAssets?: Maybe<Array<ShiftDeliveryUnitsAsset>>;
  skipNote?: Maybe<Note>;
  startLocation?: Maybe<Scalars['String']>;
  startOnTimestamp?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  worker?: Maybe<Worker>;
};

export type BulkUpdateAttributesInput = {
  assigned?: InputMaybe<AssignedInput>;
  unassigned?: InputMaybe<UnassignedInput>;
};

/** Autogenerated input type of BulkUpdatePricings */
export type BulkUpdatePricingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  shiftIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of BulkUpdatePricings */
export type BulkUpdatePricingsPayload = {
  __typename?: 'BulkUpdatePricingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Bulks Update Input */
export type BulksInput = {
  orderGroups?: InputMaybe<Array<BulkInput>>;
};

/** Autogenerated input type of CalculatePricing */
export type CalculatePricingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderGroupId: Scalars['ID'];
};

/** Autogenerated return type of CalculatePricing */
export type CalculatePricingPayload = {
  __typename?: 'CalculatePricingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  pricing?: Maybe<AppliedPricing>;
};

export enum CalculatedAsOnFeeEnum {
  /**  Delivery start to complete */
  DeliveryStartToComplete = 'delivery_start_to_complete',
  /** Delivered Volume */
  Gallon = 'gallon',
  /** Geo in Geo out */
  GeoInGeoOut = 'geo_in_geo_out',
  /** Loading complete to delivery complete */
  LoadingCompleteToDeliveryComplete = 'loading_complete_to_delivery_complete',
  /**  Shift start to delivery complete */
  ShiftStartToDeliveryComplete = 'shift_start_to_delivery_complete',
  /** Shipto To Shipto */
  ShiptoToShipto = 'shipto_to_shipto',
  /** Terminal To Shipto */
  TerminalToShipto = 'terminal_to_shipto',
  /** Yard To Shipto */
  YardToShipto = 'yard_to_shipto'
}

export type Capacity = {
  __typename?: 'Capacity';
  fuelType: Scalars['String'];
  id: Scalars['ID'];
  productCategory?: Maybe<ProductCategory>;
  unit: Scalars['String'];
  usablePercentage?: Maybe<Scalars['Float']>;
  value: Scalars['Int'];
};

export type CapacityTypes = {
  __typename?: 'CapacityTypes';
  description: Scalars['String'];
  value: Scalars['ID'];
};

export type CardLockFilters = {
  customerIds?: InputMaybe<Array<Scalars['ID']>>;
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  searchParam?: InputMaybe<Scalars['String']>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
};

export type CardLockTransaction = {
  __typename?: 'CardLockTransaction';
  asset?: Maybe<Asset>;
  customer?: Maybe<Customer>;
  customerBranch?: Maybe<CustomerBranch>;
  fleetCardNumber?: Maybe<Scalars['String']>;
  gallon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceNumbers?: Maybe<Array<Scalars['String']>>;
  invoiceStatus?: Maybe<Scalars['String']>;
  mileage?: Maybe<Scalars['String']>;
  penzoilAccount?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  productCode?: Maybe<Scalars['String']>;
  pump?: Maybe<Scalars['String']>;
  sequenceNumbers?: Maybe<Scalars['String']>;
  site?: Maybe<Scalars['String']>;
  siteNumber?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['String']>;
  transactionTime?: Maybe<Scalars['String']>;
  truckNumber?: Maybe<Scalars['String']>;
};

export type CardLockTransactionCollection = {
  __typename?: 'CardLockTransactionCollection';
  collection: Array<CardLockTransaction>;
  metadata: MetaQuery;
};

export type CardLockTransactionFilters = {
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  searchParam?: InputMaybe<Scalars['String']>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
};

/** Default CardLockTransaction Input */
export type CardLockTransactionInput = {
  customerBranchId?: InputMaybe<Scalars['Int']>;
  customerId?: InputMaybe<Scalars['Int']>;
  erpId?: InputMaybe<Scalars['String']>;
  fleetCardNumber?: InputMaybe<Scalars['String']>;
  gallon?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  invoiceNumbers?: InputMaybe<Array<Scalars['String']>>;
  invoiceStatus?: InputMaybe<Scalars['Boolean']>;
  mileage?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  productCode?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['Int']>;
  pump?: InputMaybe<Scalars['String']>;
  sequenceNumbers?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Scalars['String']>;
  siteNumber?: InputMaybe<Scalars['String']>;
  transactionTime?: InputMaybe<Scalars['String']>;
  truckNumber?: InputMaybe<Scalars['String']>;
};

export type CcTenant = {
  __typename?: 'CcTenant';
  address?: Maybe<Scalars['String']>;
  carrierTenant: Tenant;
  carrierTenantId: Scalars['ID'];
  erpId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  secondaryEmails?: Maybe<Array<Scalars['String']>>;
  site?: Maybe<Site>;
  tenant: Tenant;
  userAttributes?: Maybe<Scalars['JSON']>;
};

export type CcTenantCollection = {
  __typename?: 'CcTenantCollection';
  collection: Array<CcTenant>;
  metadata: MetaQuery;
};

export type CcTenantFilter = {
  address?: InputMaybe<Scalars['String']>;
  all?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  use3plPortal?: InputMaybe<Scalars['Boolean']>;
};

export type CcTenantFilterInput = {
  use3plPortal?: InputMaybe<Scalars['Boolean']>;
};

export type CcTenantInput = {
  address?: InputMaybe<Scalars['String']>;
  erpId: Scalars['String'];
  name: Scalars['String'];
  secondaryEmails?: InputMaybe<Array<Scalars['String']>>;
  siteAttributes?: InputMaybe<SiteInput>;
};

export type CcTenantSorter = {
  field?: InputMaybe<CcTenantSorterEnum>;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum CcTenantSorterEnum {
  Name = 'NAME'
}

/** Autogenerated input type of ChangeAsset */
export type ChangeAssetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fromAssetId?: InputMaybe<Scalars['ID']>;
  shiftId: Scalars['ID'];
  toAssetId: Scalars['ID'];
};

/** Autogenerated return type of ChangeAsset */
export type ChangeAssetPayload = {
  __typename?: 'ChangeAssetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Contains error if success if false */
  errors?: Maybe<Scalars['String']>;
  shift?: Maybe<Shift>;
  /** Show if request was success or not */
  success: Scalars['Boolean'];
};

/** Autogenerated input type of ChangeDriverOtp */
export type ChangeDriverOtpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  driverId: Scalars['ID'];
};

/** Autogenerated return type of ChangeDriverOtp */
export type ChangeDriverOtpPayload = {
  __typename?: 'ChangeDriverOtpPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  driver?: Maybe<Driver>;
};

/** Autogenerated input type of ChangeOrderGroupAssignment */
export type ChangeOrderGroupAssignmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Timestamp */
  completeTime?: InputMaybe<Scalars['String']>;
  driverId?: InputMaybe<Scalars['ID']>;
  isDriverLinkable?: InputMaybe<Scalars['Boolean']>;
  orderGroupId: Scalars['ID'];
  /** Whether the order group is being assigned outside of driver availability */
  outsideAvailability?: InputMaybe<Scalars['Boolean']>;
  /** Timestamp */
  startTime?: InputMaybe<Scalars['String']>;
  /** Timestamp */
  toStartOn?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ChangeOrderGroupAssignment */
export type ChangeOrderGroupAssignmentPayload = {
  __typename?: 'ChangeOrderGroupAssignmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderGroup: OrderGroup;
};

/** Autogenerated input type of ChangeUserOtp */
export type ChangeUserOtpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};

/** Autogenerated return type of ChangeUserOtp */
export type ChangeUserOtpPayload = {
  __typename?: 'ChangeUserOtpPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type Changeset = {
  __typename?: 'Changeset';
  key: Scalars['String'];
  values: Array<Maybe<Scalars['String']>>;
};

export type ChecklistHeader = {
  __typename?: 'ChecklistHeader';
  checklistItems?: Maybe<Array<ChecklistItem>>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
};

export type ChecklistItem = {
  __typename?: 'ChecklistItem';
  checklistHeader?: Maybe<ChecklistHeader>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
};

export type ChecklistItems = {
  __typename?: 'ChecklistItems';
  checked?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
};

/** Autogenerated input type of ClearDataShift */
export type ClearDataShiftInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of ClearDataShift */
export type ClearDataShiftPayload = {
  __typename?: 'ClearDataShiftPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  shift?: Maybe<Shift>;
};

export enum CodeTypeEnum {
  /** Barcode */
  Barcode = 'barcode',
  /** Qr Code */
  QrCode = 'qr_code'
}

export enum CodeUsageEnum {
  /** Shift end */
  ShiftEnd = 'shift_end',
  /** Shift start */
  ShiftStart = 'shift_start'
}

export type Collection = {
  __typename?: 'Collection';
  files: Array<CsvFileExport>;
  zipFileName: Scalars['String'];
};

export type Commenter = {
  __typename?: 'Commenter';
  avatar?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

/** A Company Asset */
export type CompanyAsset = {
  __typename?: 'CompanyAsset';
  activeLease?: Maybe<Scalars['Boolean']>;
  activeShift?: Maybe<Shift>;
  actualRoi?: Maybe<Scalars['Float']>;
  assetMovementLocation?: Maybe<AssetMovementLocation>;
  assetProductCategories?: Maybe<Array<AssetProductCategory>>;
  assetsPeripherals?: Maybe<Array<AssetsPeripheral>>;
  assignedPandaBox?: Maybe<PandaBox>;
  averageDaysBetweenFills?: Maybe<Scalars['Int']>;
  averageUtilization?: Maybe<Scalars['Int']>;
  barcodeText?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  categoryProducts?: Maybe<Array<Product>>;
  color?: Maybe<Scalars['String']>;
  compartments?: Maybe<Array<Compartment>>;
  costOfTank?: Maybe<Scalars['Float']>;
  createdBy?: Maybe<User>;
  customer?: Maybe<Customer>;
  customerBranch?: Maybe<CustomerBranch>;
  data?: Maybe<Scalars['JSON']>;
  enableZone?: Maybe<Scalars['Boolean']>;
  erpId?: Maybe<Scalars['String']>;
  estimatedGallonsPerMonth?: Maybe<Scalars['Float']>;
  existingActiveMovementOrderIds?: Maybe<Array<Scalars['ID']>>;
  expectedRoi?: Maybe<Scalars['Float']>;
  fuelCategories?: Maybe<Array<Scalars['String']>>;
  /** @deprecated Use fuel_categories instead. */
  fuelCategory?: Maybe<Array<Scalars['String']>>;
  fuelTypeProducts?: Maybe<Array<Product>>;
  /** Supported for Company, Rental and Delivery Assets only */
  hubResources?: Maybe<Array<HubResource>>;
  /** Supported for Company, Rental and Delivery Assets only */
  hubs?: Maybe<Array<Hub>>;
  id: Scalars['ID'];
  installDate?: Maybe<Scalars['ISO8601Date']>;
  irelyId?: Maybe<Scalars['String']>;
  isRunningFuelOffsetAsset?: Maybe<Scalars['Boolean']>;
  isTransport?: Maybe<Scalars['Boolean']>;
  lastActiveTenantId?: Maybe<Scalars['ID']>;
  lastActiveTenantName?: Maybe<Scalars['String']>;
  /** Timestamp when the asset was last delivered */
  lastDeliveredTimestamp?: Maybe<Scalars['Int']>;
  lastDeliveredVolume?: Maybe<Scalars['Float']>;
  lastSyncedTime?: Maybe<Scalars['String']>;
  /** Deprecated, use asset_movement_location instead */
  lat?: Maybe<Scalars['String']>;
  licensePlateNumber?: Maybe<Scalars['String']>;
  lineOfServices?: Maybe<Array<LineOfService>>;
  /** Deprecated, use asset_movement_location instead */
  lng?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  margin?: Maybe<Scalars['Float']>;
  marketValue?: Maybe<Scalars['Float']>;
  model?: Maybe<Scalars['String']>;
  movementOrders?: Maybe<Array<MovementOrder>>;
  name?: Maybe<Scalars['String']>;
  netsuiteId?: Maybe<Scalars['ID']>;
  noOfZone?: Maybe<Scalars['Int']>;
  numberOfDays?: Maybe<Scalars['Int']>;
  pandaDocuments?: Maybe<Array<PandaDocument>>;
  productSubscriptions?: Maybe<Array<Subscription>>;
  purchasedOn?: Maybe<Scalars['ISO8601DateTime']>;
  qrCodeText?: Maybe<Scalars['String']>;
  rentalAssetAtCustomer: Scalars['Boolean'];
  rfidCode?: Maybe<Scalars['String']>;
  routingVehicleType?: Maybe<Scalars['String']>;
  site?: Maybe<Site>;
  startDate?: Maybe<Scalars['ISO8601Date']>;
  status?: Maybe<Scalars['String']>;
  subscriptions?: Maybe<Array<Subscription>>;
  taggings?: Maybe<Array<Tagging>>;
  tankMonitor?: Maybe<Device>;
  tankSize?: Maybe<Scalars['String']>;
  tankType?: Maybe<Scalars['String']>;
  terminals?: Maybe<Array<Terminal>>;
  /** Timestamp when the asset was last delivered (from Tank Monitor) */
  tmLastDeliveredTimestamp?: Maybe<Scalars['Int']>;
  tmLastDeliveredVolume?: Maybe<Scalars['Float']>;
  trackInventory?: Maybe<Scalars['Boolean']>;
  transitCustomerBranch?: Maybe<CustomerBranch>;
  type?: Maybe<Scalars['String']>;
  useInDelivery?: Maybe<Scalars['Boolean']>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
  zoneProductBatches?: Maybe<Array<ZoneProductBatch>>;
};


/** A Company Asset */
export type CompanyAssetCompartmentsArgs = {
  deletedAfter?: InputMaybe<Scalars['Int']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


/** A Company Asset */
export type CompanyAssetSubscriptionsArgs = {
  showAll?: InputMaybe<Scalars['Boolean']>;
};

export type ComparableProductSummary = {
  __typename?: 'ComparableProductSummary';
  comparableProductId?: Maybe<Scalars['ID']>;
  comparableProductShortName?: Maybe<Scalars['String']>;
  volume?: Maybe<Scalars['Float']>;
};

export type Compartment = {
  __typename?: 'Compartment';
  /** Compartment is deleted or not */
  active?: Maybe<Scalars['Boolean']>;
  alignment?: Maybe<Scalars['String']>;
  asset?: Maybe<Asset>;
  capacities?: Maybe<Array<Capacity>>;
  /** Contains timestamp of deleted */
  deletedAtTimestamp?: Maybe<Scalars['Int']>;
  diameter?: Maybe<Scalars['Float']>;
  empty?: Maybe<Scalars['String']>;
  erpId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  initialInventory?: Maybe<Inventory>;
  lastBols?: Maybe<Array<Bol>>;
  lastCompartmentInstance?: Maybe<CompartmentInstance>;
  /** Obsolete, use latest inventory1 */
  lastInventory?: Maybe<Array<Inventory>>;
  lastLoadingOrderLineItem?: Maybe<LoadingOrderLineItem>;
  latestInventory?: Maybe<Inventory>;
  length?: Maybe<Scalars['Float']>;
  liquidControls?: Maybe<Scalars['String']>;
  meterInfo?: Maybe<Scalars['String']>;
  meterNetworkAddress?: Maybe<Scalars['String']>;
  meterNumber?: Maybe<Scalars['String']>;
  midCom?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  networkName?: Maybe<Scalars['String']>;
  networkNumber?: Maybe<Scalars['String']>;
  subscriptionProducts?: Maybe<Array<Product>>;
  totalControlSystems?: Maybe<Scalars['String']>;
};


export type CompartmentLastCompartmentInstanceArgs = {
  before?: InputMaybe<Scalars['Int']>;
};

export enum CompartmentAlignmentEnum {
  /** Horizontal */
  Horizontal = 'horizontal',
  /** Vertical */
  Vertical = 'vertical'
}

export type CompartmentInstance = {
  __typename?: 'CompartmentInstance';
  afterStick?: Maybe<Scalars['String']>;
  afterStickUnit?: Maybe<Scalars['String']>;
  beforeStick?: Maybe<Scalars['String']>;
  beforeStickUnit?: Maybe<Scalars['String']>;
  compartment: Compartment;
  compartmentId: Scalars['ID'];
  generatorRunningHours?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  oilOnlyPercentageReading?: Maybe<Scalars['String']>;
  oilWaterPercentageReading?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  volume?: Maybe<Scalars['Float']>;
  waterPostStick?: Maybe<Scalars['String']>;
  waterPostStickUnit?: Maybe<Scalars['String']>;
  waterPreStick?: Maybe<Scalars['String']>;
  waterPreStickUnit?: Maybe<Scalars['String']>;
  waterReadings?: Maybe<Scalars['JSON']>;
};

/** Compartment Instance Input */
export type CompartmentInstanceInput = {
  /** Post stick measurement. */
  afterStick?: InputMaybe<Scalars['String']>;
  /** Post stick measurment unit. */
  afterStickUnit?: InputMaybe<Scalars['String']>;
  /** Pre stick measurement. */
  beforeStick?: InputMaybe<Scalars['String']>;
  /** Pre stick measurment unit. */
  beforeStickUnit?: InputMaybe<Scalars['String']>;
  /** Compartment ID. */
  compartmentId?: InputMaybe<Scalars['ID']>;
  /** Generator running hours */
  generatorRunningHours?: InputMaybe<Scalars['Float']>;
  /** CompartmentInstance ID. */
  id?: InputMaybe<Scalars['ID']>;
  /** Oil only percentage reading */
  oilOnlyPercentageReading?: InputMaybe<Scalars['String']>;
  /** Oil and water percentage reading */
  oilWaterPercentageReading?: InputMaybe<Scalars['String']>;
  /** Product ID. */
  productId?: InputMaybe<Scalars['ID']>;
  /** Required in case of Source Compartment while updating DeliveryOrderLineItem */
  volume?: InputMaybe<Scalars['Float']>;
  /** Water post stick measurement. */
  waterPostStick?: InputMaybe<Scalars['String']>;
  /** Water post stick measurment unit. */
  waterPostStickUnit?: InputMaybe<Scalars['String']>;
  /** Water pre stick measurement. */
  waterPreStick?: InputMaybe<Scalars['String']>;
  /** Water pre stick measurment unit. */
  waterPreStickUnit?: InputMaybe<Scalars['String']>;
  /** Miscellaneous data. Example: Chlorine content in water. */
  waterReadings?: InputMaybe<Scalars['JSON']>;
};

/** Updating transfer orders assets */
export type CompartmentMappingInput = {
  /** ID of new compartment */
  compartmentId?: InputMaybe<Scalars['ID']>;
  /** ID of old compartment */
  oldCompartmentId?: InputMaybe<Scalars['ID']>;
};

export type CompartmentMismatch = {
  __typename?: 'CompartmentMismatch';
  actualCompartmentId?: Maybe<Scalars['ID']>;
  actualProductId?: Maybe<Scalars['ID']>;
  currentCompartmentId?: Maybe<Scalars['ID']>;
  currentProductId?: Maybe<Scalars['ID']>;
  error?: Maybe<Scalars['String']>;
  lineItemId?: Maybe<Scalars['ID']>;
  volume?: Maybe<Scalars['Float']>;
};

export enum CompartmentMismatchOrderTypeEnum {
  DeliveryOrder = 'DeliveryOrder',
  TransferOrder = 'TransferOrder'
}

export type Condition = {
  __typename?: 'Condition';
  field: Scalars['String'];
  value: Scalars['String'];
};

/** Route Flushing from/to Condition Input */
export type ConditionInput = {
  field: RouteFlushingConditionEnum;
  value: Scalars['String'];
};

export type ConfirmOrCancelOrderInput = {
  /** Action to perform: 'confirm' or 'cancel' */
  action: OrderActionEnum;
  orderAndAssetIds?: InputMaybe<Array<OrderIdAndAssetId>>;
  orderIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Autogenerated return type of ConfirmOrCancelOrders */
export type ConfirmOrCancelOrdersPayload = {
  __typename?: 'ConfirmOrCancelOrdersPayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of ConfirmTwoFactor */
export type ConfirmTwoFactorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  otpCode: Scalars['String'];
  userId: Scalars['ID'];
};

/** Autogenerated return type of ConfirmTwoFactor */
export type ConfirmTwoFactorPayload = {
  __typename?: 'ConfirmTwoFactorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  otpBackupCodes?: Maybe<Array<Scalars['String']>>;
  refreshToken?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  token?: Maybe<Scalars['String']>;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  lat?: Maybe<Scalars['String']>;
  lng?: Maybe<Scalars['String']>;
};

export type CoordinatesFilter = {
  centerLat: Scalars['String'];
  centerLng: Scalars['String'];
  radiusMiles: Scalars['String'];
};

/** Autogenerated input type of CopyPreviousRecords */
export type CopyPreviousRecordsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  effectiveEndTimestamp: Scalars['Int'];
  effectiveStartTimestamp: Scalars['Int'];
};

/** Autogenerated return type of CopyPreviousRecords */
export type CopyPreviousRecordsPayload = {
  __typename?: 'CopyPreviousRecordsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of CreateAppVersion */
export type CreateAppVersionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: AppVersionInput;
};

/** Autogenerated return type of CreateAppVersion */
export type CreateAppVersionPayload = {
  __typename?: 'CreateAppVersionPayload';
  appVersion?: Maybe<AppVersion>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  success: Scalars['Boolean'];
};

/** Create asset input */
export type CreateAssetInput = {
  approvalStatus?: InputMaybe<AssetApprovalStatusEnum>;
  /** Use this for multiple locations. */
  assetMovementLocationsAttributes?: InputMaybe<Array<AssetMovementLocationInput>>;
  assetProductCategoriesAttributes?: InputMaybe<Array<NestedAssetProductCategoryInput>>;
  assetsPeripheralsAttributes?: InputMaybe<Array<AssetsPeripheralInput>>;
  bulkAssetFeature?: InputMaybe<Scalars['Boolean']>;
  category: AssetCategoryEnum;
  color?: InputMaybe<Scalars['String']>;
  compartmentsAttributes?: InputMaybe<Array<NestedCompartmentInput>>;
  completeMovementOrder?: InputMaybe<Scalars['Boolean']>;
  costOfTank?: InputMaybe<Scalars['Float']>;
  customerBranchId?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  enableZone?: InputMaybe<Scalars['Boolean']>;
  erpId?: InputMaybe<Scalars['String']>;
  estimatedGallonsPerMonth?: InputMaybe<Scalars['Float']>;
  /** Send form_type in CamelCase example: rental asset would be RentalAsset */
  formType?: InputMaybe<Scalars['String']>;
  fuelCategories?: InputMaybe<Array<Scalars['String']>>;
  hubResourcesAttributes?: InputMaybe<Array<HubResourceInput>>;
  installDate?: InputMaybe<Scalars['ISO8601Date']>;
  isRunningFuelOffsetAsset?: InputMaybe<Scalars['Boolean']>;
  isTransport?: InputMaybe<Scalars['Boolean']>;
  lat?: InputMaybe<Scalars['String']>;
  licensePlateNumber: Scalars['String'];
  lineOfServiceIds?: InputMaybe<Array<Scalars['ID']>>;
  lng?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  margin?: InputMaybe<Scalars['Float']>;
  marketValue?: InputMaybe<Scalars['Float']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  noOfZone?: InputMaybe<Scalars['Int']>;
  pandaBoxAttributes?: InputMaybe<PandaBoxInput>;
  pandaBoxId?: InputMaybe<Scalars['ID']>;
  pandaDocuments?: InputMaybe<Array<NestedPandaDocumentsInput>>;
  purchasedOn?: InputMaybe<Scalars['ISO8601DateTime']>;
  rfidCode?: InputMaybe<Scalars['String']>;
  routingVehicleType?: InputMaybe<AssetRoutingVehicleTypesEnum>;
  sites?: InputMaybe<Array<SiteInput>>;
  status: AssetStatusEnum;
  subscriptionsAttributes?: InputMaybe<Array<NestedSubscriptionsInput>>;
  taggingsAttributes?: InputMaybe<Array<TaggingInput>>;
  tankSize?: InputMaybe<Scalars['String']>;
  tankType?: InputMaybe<Scalars['String']>;
  terminals?: InputMaybe<Array<NestedTerminalInput>>;
  trackInventory?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  unassignPandaBox?: InputMaybe<Scalars['Boolean']>;
  useInDelivery?: InputMaybe<Scalars['Boolean']>;
  vin?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of CreateAssets */
export type CreateAssetsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CreateAssetInput;
};

/** Autogenerated return type of CreateAssets */
export type CreateAssetsPayload = {
  __typename?: 'CreateAssetsPayload';
  asset?: Maybe<Asset>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateAttachedAssetAvailability */
export type CreateAttachedAssetAvailabilityInput = {
  availabilityData: CreateAttachedAssetPreferenceAvailabilityInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateAttachedAssetAvailability */
export type CreateAttachedAssetAvailabilityPayload = {
  __typename?: 'CreateAttachedAssetAvailabilityPayload';
  availability?: Maybe<Array<AttachedAssetAvailability>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateAttachedAsset */
export type CreateAttachedAssetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: Array<CreateAttachedAssetsInput>;
};

/** Autogenerated return type of CreateAttachedAsset */
export type CreateAttachedAssetPayload = {
  __typename?: 'CreateAttachedAssetPayload';
  attachedAsset?: Maybe<Array<AttachedAsset>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Tank Monitor attached asset availability input */
export type CreateAttachedAssetPreferenceAvailabilityInput = {
  attachedAssetId: Scalars['ID'];
  /** Type of order for the attached asset */
  orderType?: InputMaybe<TmOrderTypeEnum>;
  /** Preference availability for the attached asset */
  preferenceAvailability?: InputMaybe<Array<PreferenceAvailabilityInput>>;
};

/** Tank Monitor attached assets input */
export type CreateAttachedAssetsInput = {
  assetId?: InputMaybe<Scalars['String']>;
  assetTankCapacity?: InputMaybe<Scalars['Float']>;
  autoOrder?: InputMaybe<Scalars['Boolean']>;
  consumptionCalculationDays?: InputMaybe<Scalars['Int']>;
  detachedAt?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['ID']>;
  draftAssetId?: InputMaybe<Scalars['ID']>;
  gracePeriod?: InputMaybe<Scalars['Int']>;
  gracePeriodType?: InputMaybe<Scalars['String']>;
  hubIds?: InputMaybe<Array<Scalars['ID']>>;
  maxThreshold?: InputMaybe<Scalars['Float']>;
  minThreshold?: InputMaybe<Scalars['Float']>;
  orderConfirmation?: InputMaybe<Scalars['Boolean']>;
  orderFillPercentage?: InputMaybe<Scalars['Float']>;
  orderType?: InputMaybe<TmOrderTypeEnum>;
  /** Preference availability for the attached asset */
  preferenceAvailability?: InputMaybe<Array<PreferenceAvailabilityInput>>;
  purchaseOrder?: InputMaybe<Scalars['Boolean']>;
  refuelTanksThreshold?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  tankMonitorId?: InputMaybe<Scalars['String']>;
  topOffBy?: InputMaybe<TopOffByEnum>;
  topOffQuantity?: InputMaybe<Scalars['Float']>;
};

/** Autogenerated input type of CreateBolPricing */
export type CreateBolPricingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: BolPricingsCreateBolPricingInput;
};

/** Autogenerated return type of CreateBolPricing */
export type CreateBolPricingPayload = {
  __typename?: 'CreateBolPricingPayload';
  bolPricing?: Maybe<BolPricing>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateBolRetain */
export type CreateBolRetainInput = {
  bolRetainsAttributes: Array<BolRetainInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateBolRetain */
export type CreateBolRetainPayload = {
  __typename?: 'CreateBolRetainPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['JSON']>;
};

/** Create Brand input */
export type CreateBrandInput = {
  brandType?: InputMaybe<BrandTypeEnum>;
  name: Scalars['String'];
};

/** Autogenerated input type of CreateBrands */
export type CreateBrandsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CreateBrandInput;
};

/** Autogenerated return type of CreateBrands */
export type CreateBrandsPayload = {
  __typename?: 'CreateBrandsPayload';
  brand?: Maybe<Brand>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateCommonCarrier */
export type CreateCommonCarrierInput = {
  ccTenantAttributes: CcTenantInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  userAttributes: UserInput;
};

/** Autogenerated return type of CreateCommonCarrier */
export type CreateCommonCarrierPayload = {
  __typename?: 'CreateCommonCarrierPayload';
  ccTenant?: Maybe<CcTenant>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errorMsg?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateCrudePricing */
export type CreateCrudePricingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CrudePricingsInput;
};

/** Autogenerated return type of CreateCrudePricing */
export type CreateCrudePricingPayload = {
  __typename?: 'CreateCrudePricingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  crudePricing?: Maybe<CrudePricing>;
};

/** Autogenerated input type of CreateCustomerAsset */
export type CreateCustomerAssetInput = {
  alignment?: InputMaybe<Scalars['String']>;
  capacityType?: InputMaybe<Scalars['String']>;
  capacityUnit?: InputMaybe<Scalars['String']>;
  capacityValue?: InputMaybe<Scalars['Float']>;
  category: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  customerBranchId: Scalars['ID'];
  deliveryOrderId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  diameter?: InputMaybe<Scalars['Float']>;
  length?: InputMaybe<Scalars['Float']>;
  licensePlateNumber?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** Documents */
  pandaDocuments?: InputMaybe<Array<PandaDocumentInput>>;
  productId?: InputMaybe<Scalars['ID']>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  qrCodeText?: InputMaybe<Scalars['String']>;
  requestedVolume?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  topOff?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<DeliveryOrderLineItemTypeEnum>;
  vin?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of CreateCustomerAsset */
export type CreateCustomerAssetPayload = {
  __typename?: 'CreateCustomerAssetPayload';
  asset?: Maybe<Asset>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Create ShipTos input */
export type CreateCustomerBranchInput = {
  addressBooksAttributes?: InputMaybe<Array<AddressBookInput>>;
  applicableFeesAttributes?: InputMaybe<Array<UpdateApplicableFeeInput>>;
  attachBolOnDeliveryTicket?: InputMaybe<Scalars['Boolean']>;
  autoEmailDeliveryTicket?: InputMaybe<Scalars['Boolean']>;
  cardLockSiteNumber?: InputMaybe<Scalars['String']>;
  crudePricingsAttributes?: InputMaybe<Array<UpdateCrudePricingsInput>>;
  customerErpId?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['ID']>;
  deliveryInstruction?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  hubResourcesAttributes?: InputMaybe<Array<HubResourceInput>>;
  isCustomerSignatureRequired?: InputMaybe<Scalars['Boolean']>;
  isHub?: InputMaybe<Scalars['Boolean']>;
  lineOfServiceIds?: InputMaybe<Array<Scalars['ID']>>;
  loadingAccountIds?: InputMaybe<Array<Scalars['ID']>>;
  marketResourcesAttributes?: InputMaybe<Array<MarketResourceInput>>;
  name?: InputMaybe<Scalars['String']>;
  onlyShowGrossGallonsInDeliveryTicket?: InputMaybe<Scalars['Boolean']>;
  pandaDocuments?: InputMaybe<Array<DirectAttachmentInput>>;
  pickupPointCodeIds?: InputMaybe<Array<Scalars['ID']>>;
  poNumber?: InputMaybe<Scalars['String']>;
  preferredProductTerminalsAttributes?: InputMaybe<Array<PreferredProductTerminalInput>>;
  priceCode?: InputMaybe<Scalars['String']>;
  purchaseOrder?: InputMaybe<Scalars['Boolean']>;
  purchaseOrderType?: InputMaybe<PurchaseOrderTypeEnum>;
  qboItemizeLineItemOnSalesOrder?: InputMaybe<Scalars['Boolean']>;
  siteAttributes?: InputMaybe<SiteInput>;
  status?: InputMaybe<Scalars['Boolean']>;
  supplierIds?: InputMaybe<Array<Scalars['ID']>>;
  syncSalesToD1?: InputMaybe<Scalars['Boolean']>;
  taggingsAttributes?: InputMaybe<Array<TaggingInput>>;
  terminalDriverRates?: InputMaybe<Scalars['JSON']>;
};

/** Autogenerated input type of CreateCustomerBranches */
export type CreateCustomerBranchesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CreateCustomerBranchInput;
};

/** Autogenerated return type of CreateCustomerBranches */
export type CreateCustomerBranchesPayload = {
  __typename?: 'CreateCustomerBranchesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customerBranch?: Maybe<CustomerBranch>;
};

/** Create customer input */
export type CreateCustomerInput = {
  accountId?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  addressBooksAttributes?: InputMaybe<Array<AddressBookInput>>;
  agreedLoadGallon?: InputMaybe<Scalars['Int']>;
  applicableFeesAttributes?: InputMaybe<Array<UpdateApplicableFeeInput>>;
  arDivisionNumber?: InputMaybe<Scalars['String']>;
  attachPostDeliveryImageOnDeliveryTicket?: InputMaybe<Scalars['Boolean']>;
  canManagePortalAssets?: InputMaybe<Scalars['Boolean']>;
  canManagePortalScheduleReports?: InputMaybe<Scalars['Boolean']>;
  canManagePortalSettings?: InputMaybe<Scalars['Boolean']>;
  canManagePortalShipTos?: InputMaybe<Scalars['Boolean']>;
  creditChecked?: InputMaybe<Scalars['Boolean']>;
  creditLimit?: InputMaybe<Scalars['String']>;
  creditLimitDaysOverdueBuffer?: InputMaybe<Scalars['String']>;
  creditLimitPercentageBuffer?: InputMaybe<Scalars['String']>;
  crudePricingsAttributes?: InputMaybe<Array<UpdateCrudePricingsInput>>;
  currentBalance?: InputMaybe<Scalars['String']>;
  customerBranchesAttributes?: InputMaybe<Array<NestedCustomerBranchInput>>;
  customerSegmentId?: InputMaybe<Scalars['ID']>;
  daysOverdue?: InputMaybe<Scalars['String']>;
  deliveryInstruction?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  enableCreateDeliveryOrder?: InputMaybe<Scalars['Boolean']>;
  epaId?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  exemptStatus?: InputMaybe<Array<ExemptStatusTypeEnum>>;
  fees?: InputMaybe<Array<NestedFeeInput>>;
  feinNumber?: InputMaybe<Scalars['String']>;
  fleetCardNumbers?: InputMaybe<Array<Scalars['String']>>;
  hideVendorPricing?: InputMaybe<Scalars['Boolean']>;
  hubResourcesAttributes?: InputMaybe<Array<HubResourceInput>>;
  isTenant?: InputMaybe<Scalars['Boolean']>;
  lineOfServiceIds?: InputMaybe<Array<Scalars['ID']>>;
  marketResourcesAttributes?: InputMaybe<Array<MarketResourceInput>>;
  name: Scalars['String'];
  originalCustomerId?: InputMaybe<Scalars['String']>;
  paymentTermId?: InputMaybe<Scalars['ID']>;
  paymentTypeName?: InputMaybe<PaymentTypeEnum>;
  permitNumber?: InputMaybe<Scalars['String']>;
  poBoxNumber?: InputMaybe<Scalars['String']>;
  poNumber?: InputMaybe<Scalars['String']>;
  portalAccessLevel?: InputMaybe<PortalAccessLevelEnum>;
  preferredDrivers?: InputMaybe<Array<NestedDriverInput>>;
  preferredProductTerminalsAttributes?: InputMaybe<Array<PreferredProductTerminalInput>>;
  productPurchaseLimitId?: InputMaybe<Scalars['ID']>;
  purchaseOrder?: InputMaybe<Scalars['Boolean']>;
  purchaseOrderType?: InputMaybe<PurchaseOrderTypeEnum>;
  quickbridgeId?: InputMaybe<Scalars['String']>;
  siteAttributes?: InputMaybe<SiteInput>;
  status?: InputMaybe<StatusEnum>;
  taggingsAttributes?: InputMaybe<Array<TaggingInput>>;
  tankReadingMaxThreshold?: InputMaybe<Scalars['Float']>;
  tankReadingThreshold?: InputMaybe<Scalars['Float']>;
  thirdPartyDelivery?: InputMaybe<Scalars['Boolean']>;
  usersAttributes?: InputMaybe<Array<NestedUserInput>>;
  vendorErpId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreateCustomerSegments */
export type CreateCustomerSegmentsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CustomerSegmentInput;
};

/** Autogenerated return type of CreateCustomerSegments */
export type CreateCustomerSegmentsPayload = {
  __typename?: 'CreateCustomerSegmentsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customerSegment?: Maybe<CustomerSegment>;
};

/** Autogenerated input type of CreateCustomerUsers */
export type CreateCustomerUsersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CustomerUserInput;
};

/** Autogenerated return type of CreateCustomerUsers */
export type CreateCustomerUsersPayload = {
  __typename?: 'CreateCustomerUsersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customerUser?: Maybe<CustomerUser>;
};

/** Autogenerated input type of CreateCustomers */
export type CreateCustomersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CreateCustomerInput;
};

/** Autogenerated return type of CreateCustomers */
export type CreateCustomersPayload = {
  __typename?: 'CreateCustomersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customer?: Maybe<Customer>;
};

/** Autogenerated return type of CreateDegreeDaySetting */
export type CreateDegreeDaySettingPayload = {
  __typename?: 'CreateDegreeDaySettingPayload';
  degreeDaySettings?: Maybe<Array<DegreeDaySetting>>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of CreateDeliveryOrder */
export type CreateDeliveryOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryOrderAttributes: DeliveryOrderInput;
  driverId: Scalars['ID'];
  executionTime: Scalars['Int'];
};

/** Autogenerated return type of CreateDeliveryOrder */
export type CreateDeliveryOrderPayload = {
  __typename?: 'CreateDeliveryOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
};

/** File information required to prepare a direct upload */
export type CreateDirectUpload = {
  /** File size (bytes) */
  byteSize: Scalars['Int'];
  /** MD5 file checksum as base64 */
  checksum: Scalars['String'];
  /** File content type */
  contentType: Scalars['String'];
  /** Original file name */
  filename: Scalars['String'];
  /** File key */
  key?: InputMaybe<Scalars['String']>;
  /** Service name for alternative bucket */
  serviceName?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreateDirectUpload */
export type CreateDirectUploadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  input: CreateDirectUpload;
};

/** Autogenerated input type of CreateDriverDemurrage */
export type CreateDriverDemurrageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: DriverDemurrageInput;
};

/** Autogenerated return type of CreateDriverDemurrage */
export type CreateDriverDemurragePayload = {
  __typename?: 'CreateDriverDemurragePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  driverDemurrage?: Maybe<DriverDemurrage>;
};

/** Create driver input */
export type CreateDriverInput = {
  contractSignDate?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  homeAddress?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hubResourcesAttributes?: InputMaybe<Array<HubResourceInput>>;
  imageSignedBlobId?: InputMaybe<Scalars['ID']>;
  licenceExpiryDate?: InputMaybe<Scalars['String']>;
  lineOfServiceIds?: InputMaybe<Array<Scalars['ID']>>;
  name: Scalars['String'];
  paymentStrategy?: InputMaybe<Scalars['String']>;
  phoneNumbersAttributes: Array<NestedPhoneInput>;
  reasonForLeaving?: InputMaybe<Scalars['String']>;
  s3BackgroundCheckBlobId?: InputMaybe<Scalars['ID']>;
  s3DriverApplicationBlobId?: InputMaybe<Scalars['ID']>;
  s3H6BlobId?: InputMaybe<Scalars['ID']>;
  s3Licenses?: InputMaybe<Array<LicenseInput>>;
  startDate?: InputMaybe<Scalars['String']>;
  status: DriverStatusEnum;
  weeklySchedulesAttributes?: InputMaybe<Array<NestedWeekScheduleInput>>;
};

/** Autogenerated input type of CreateDriverRates */
export type CreateDriverRatesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: DriverRateInput;
};

/** Autogenerated return type of CreateDriverRates */
export type CreateDriverRatesPayload = {
  __typename?: 'CreateDriverRatesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  driverRate?: Maybe<DriverRate>;
};

/** Autogenerated input type of CreateDrivers */
export type CreateDriversInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CreateDriverInput;
};

/** Autogenerated return type of CreateDrivers */
export type CreateDriversPayload = {
  __typename?: 'CreateDriversPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  driver?: Maybe<Driver>;
};

/** Create fee input */
export type CreateFeeInput = {
  applicableType?: InputMaybe<ApplicableTypeEnum>;
  applyAsOnFee?: InputMaybe<ApplyAsOnFeeEnum>;
  baseFeeId?: InputMaybe<Scalars['ID']>;
  calculatedAsOnFee?: InputMaybe<CalculatedAsOnFeeEnum>;
  code?: InputMaybe<Scalars['String']>;
  defaultMovementFee?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  feeProductCategoriesAttributes?: InputMaybe<Array<FeeProductCategoryInput>>;
  feeType?: InputMaybe<FeeTypeEnum>;
  glCode?: InputMaybe<Scalars['String']>;
  lineOfServiceIds?: InputMaybe<Array<Scalars['ID']>>;
  lineOfServiceRecordsAttributes?: InputMaybe<Array<NestedLineOfServiceRecord>>;
  name: Scalars['String'];
  nsManualVolume?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Float']>;
  offsetRate?: InputMaybe<Scalars['Float']>;
  parentFeeId?: InputMaybe<Scalars['ID']>;
  percentOnFee?: InputMaybe<Scalars['Float']>;
  price?: InputMaybe<Scalars['Float']>;
  productCategoryId?: InputMaybe<Scalars['ID']>;
  rangeAttribute?: InputMaybe<Array<RangeAttributeInput>>;
  rangeCalculatedAsOnFee?: InputMaybe<CalculatedAsOnFeeEnum>;
  rangeTypeOnFee?: InputMaybe<RangeTypeOnFeeEnum>;
  rateOnFee?: InputMaybe<Scalars['Float']>;
  rateUnitOnFee?: InputMaybe<RateUnitOnFeeEnum>;
  roundUpQuantity?: InputMaybe<Scalars['Boolean']>;
  surchargeId?: InputMaybe<Scalars['ID']>;
};

/** Create feedback input */
export type CreateFeedbackInput = {
  content?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreateFeedbacks */
export type CreateFeedbacksInput = {
  attributes: CreateFeedbackInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateFeedbacks */
export type CreateFeedbacksPayload = {
  __typename?: 'CreateFeedbacksPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  feedback?: Maybe<Feedback>;
};

/** Autogenerated input type of CreateFees */
export type CreateFeesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CreateFeeInput;
};

/** Autogenerated return type of CreateFees */
export type CreateFeesPayload = {
  __typename?: 'CreateFeesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  fee?: Maybe<Fee>;
};

/** Autogenerated input type of CreateGroup */
export type CreateGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CreateGroupsInput;
};

/** Autogenerated return type of CreateGroup */
export type CreateGroupPayload = {
  __typename?: 'CreateGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  group?: Maybe<Group>;
};

/** Create Group Input */
export type CreateGroupsInput = {
  groupMembershipsAttributes?: InputMaybe<Array<NestedGroupMembershipInput>>;
  /** Id of Group */
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

/** Autogenerated input type of CreateInventoryRecord */
export type CreateInventoryRecordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  inventoryRecordAttributes: InventoryRecordsInput;
};

/** Autogenerated return type of CreateInventoryRecord */
export type CreateInventoryRecordPayload = {
  __typename?: 'CreateInventoryRecordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  inventoryRecord?: Maybe<AssetsInventoriesInventoryRecordType>;
};

/** Autogenerated input type of CreateInvoice */
export type CreateInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: InvoiceInput;
};

/** Autogenerated return type of CreateInvoice */
export type CreateInvoicePayload = {
  __typename?: 'CreateInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  invoices?: Maybe<Array<Invoice>>;
};

/** Autogenerated input type of CreateLeaCore */
export type CreateLeaCoreInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  leaCoreAttributes?: InputMaybe<LeaCoreInput>;
};

/** Autogenerated return type of CreateLeaCore */
export type CreateLeaCorePayload = {
  __typename?: 'CreateLeaCorePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  leaType?: Maybe<Lea>;
};

/** Autogenerated input type of CreateLeaMovementOrders */
export type CreateLeaMovementOrdersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  leaCoreId: Scalars['ID'];
};

/** Autogenerated return type of CreateLeaMovementOrders */
export type CreateLeaMovementOrdersPayload = {
  __typename?: 'CreateLeaMovementOrdersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  leaType: Lea;
};

/** Autogenerated input type of CreateLineOfServices */
export type CreateLineOfServicesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: LineOfServiceInput;
};

/** Autogenerated return type of CreateLineOfServices */
export type CreateLineOfServicesPayload = {
  __typename?: 'CreateLineOfServicesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lineOfService?: Maybe<LineOfService>;
};

/** Autogenerated input type of CreateLoadingAccounts */
export type CreateLoadingAccountsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: LoadingAccountInput;
};

/** Autogenerated return type of CreateLoadingAccounts */
export type CreateLoadingAccountsPayload = {
  __typename?: 'CreateLoadingAccountsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  loadingAccount?: Maybe<LoadingAccount>;
};

/** Autogenerated input type of CreateLoadingOrder */
export type CreateLoadingOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  driverId: Scalars['ID'];
  executionTime: Scalars['Int'];
  loadingOrderAttributes: LoadingOrderInput;
};

/** Autogenerated return type of CreateLoadingOrder */
export type CreateLoadingOrderPayload = {
  __typename?: 'CreateLoadingOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
};

/** Autogenerated input type of CreateMargin */
export type CreateMarginInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CreateMarginsInput;
};

/** Autogenerated return type of CreateMargin */
export type CreateMarginPayload = {
  __typename?: 'CreateMarginPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  margin?: Maybe<Margin>;
};

/** Create Margin Input */
export type CreateMarginsInput = {
  marginRate?: InputMaybe<Scalars['Float']>;
  marginType: MarginTypeEnum;
  marginUnit?: InputMaybe<RateUnitEnum>;
  name: Scalars['String'];
  range?: InputMaybe<Array<MarginRangeAttributeInput>>;
};

/** Create market input */
export type CreateMarketInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  hubResourcesAttributes?: InputMaybe<Array<HubResourceInput>>;
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreateMarkets */
export type CreateMarketsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CreateMarketInput;
};

/** Autogenerated return type of CreateMarkets */
export type CreateMarketsPayload = {
  __typename?: 'CreateMarketsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  market?: Maybe<Market>;
};

/** Autogenerated input type of CreateMovementOrder */
export type CreateMovementOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  movementOrderAttributes?: InputMaybe<MovementOrderInput>;
};

/** Autogenerated return type of CreateMovementOrder */
export type CreateMovementOrderPayload = {
  __typename?: 'CreateMovementOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  movementOrder?: Maybe<MovementOrder>;
};

/** Autogenerated return type of CreateMultiOrderTopOff */
export type CreateMultiOrderTopOffPayload = {
  __typename?: 'CreateMultiOrderTopOffPayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of CreateNote */
export type CreateNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  content: Scalars['String'];
  notableId: Scalars['ID'];
  notableType: Scalars['String'];
  pandaDocumentId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of CreateNote */
export type CreateNotePayload = {
  __typename?: 'CreateNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  note?: Maybe<Note>;
};

/** Autogenerated input type of CreateOrUpdateConfigView */
export type CreateOrUpdateConfigViewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  input: Array<SavedViewInput>;
};

/** Autogenerated return type of CreateOrUpdateConfigView */
export type CreateOrUpdateConfigViewPayload = {
  __typename?: 'CreateOrUpdateConfigViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  savedViews?: Maybe<Array<SavedView>>;
};

/** Autogenerated input type of CreateOrUpdateCustomerPortalConfiguration */
export type CreateOrUpdateCustomerPortalConfigurationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CustomerPortalConfigurationInput;
};

/** Autogenerated return type of CreateOrUpdateCustomerPortalConfiguration */
export type CreateOrUpdateCustomerPortalConfigurationPayload = {
  __typename?: 'CreateOrUpdateCustomerPortalConfigurationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customerPortalConfiguration?: Maybe<CustomerPortalConfiguration>;
  errors?: Maybe<Array<Scalars['String']>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of CreateOrUpdateFormProgress */
export type CreateOrUpdateFormProgressInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  formProgressAttributes: FormProgressInput;
};

/** Autogenerated return type of CreateOrUpdateFormProgress */
export type CreateOrUpdateFormProgressPayload = {
  __typename?: 'CreateOrUpdateFormProgressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  formProgress?: Maybe<FormProgress>;
};

/** Autogenerated input type of CreateOrUpdate */
export type CreateOrUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: FlushingInput;
};

/** Autogenerated input type of CreateOrUpdateMovementOrderLineItem */
export type CreateOrUpdateMovementOrderLineItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  movementOrderLineAttributes?: InputMaybe<MovementOrderLineItemInput>;
};

/** Autogenerated return type of CreateOrUpdateMovementOrderLineItem */
export type CreateOrUpdateMovementOrderLineItemPayload = {
  __typename?: 'CreateOrUpdateMovementOrderLineItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  movementOrderLineItem: MovementOrderLineItem;
};

/** Autogenerated input type of CreateOrUpdateNotificationTemplate */
export type CreateOrUpdateNotificationTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: NotificationTemplateInput;
};

/** Autogenerated return type of CreateOrUpdateNotificationTemplate */
export type CreateOrUpdateNotificationTemplatePayload = {
  __typename?: 'CreateOrUpdateNotificationTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  notificationTemplate?: Maybe<NotificationTemplate>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of CreateOrUpdate */
export type CreateOrUpdatePayload = {
  __typename?: 'CreateOrUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Scalars['String']>;
  routeFlushing?: Maybe<Flushing>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of CreateOrUpdateQrCode */
export type CreateOrUpdateQrCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  qrCodeAttributes: QrCodeInput;
};

/** Autogenerated return type of CreateOrUpdateQrCode */
export type CreateOrUpdateQrCodePayload = {
  __typename?: 'CreateOrUpdateQrCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  qrCode?: Maybe<QrCode>;
};

/** Autogenerated input type of CreateOrUpdateRole */
export type CreateOrUpdateRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  roleAttributes: RoleInput;
};

/** Autogenerated return type of CreateOrUpdateRole */
export type CreateOrUpdateRolePayload = {
  __typename?: 'CreateOrUpdateRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  role?: Maybe<Role>;
};

/** Autogenerated input type of CreateOrUpdateTag */
export type CreateOrUpdateTagInput = {
  attributes?: InputMaybe<TagInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateOrUpdateTag */
export type CreateOrUpdateTagPayload = {
  __typename?: 'CreateOrUpdateTagPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  tag?: Maybe<Tag>;
};

/** Autogenerated input type of CreateOrUpdateTransferOrderLineItem */
export type CreateOrUpdateTransferOrderLineItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  transferOrderLineAttributes?: InputMaybe<TransferOrderLineItemInput>;
};

/** Autogenerated return type of CreateOrUpdateTransferOrderLineItem */
export type CreateOrUpdateTransferOrderLineItemPayload = {
  __typename?: 'CreateOrUpdateTransferOrderLineItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  transferOrderLineItem: TransferOrderLineItem;
};

/** Autogenerated input type of CreateOrderGroup */
export type CreateOrderGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Flag to create associated fuel orders. */
  createAssociatedFuelOrders?: InputMaybe<FuelOrderTypeInput>;
  /** Order group input type. */
  orderGroupAttributes?: InputMaybe<OrderGroupInput>;
};

/** Autogenerated return type of CreateOrderGroup */
export type CreateOrderGroupPayload = {
  __typename?: 'CreateOrderGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Order group type. */
  orderGroup?: Maybe<OrderGroup>;
};

/** Autogenerated input type of CreateOrderGroupTaxes */
export type CreateOrderGroupTaxesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  input: OrderGroupTaxInput;
};

/** Autogenerated return type of CreateOrderGroupTaxes */
export type CreateOrderGroupTaxesPayload = {
  __typename?: 'CreateOrderGroupTaxesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  response?: Maybe<OrderGroupTaxResponse>;
};

/** Autogenerated input type of CreateOrderGroups */
export type CreateOrderGroupsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery order group id to which the order links will be created for. */
  deliveryOrderGroupIdForLinking?: InputMaybe<Scalars['ID']>;
  /** List of order links attributes to be created. */
  deliveryOrderIdsForLinking?: InputMaybe<Array<Scalars['ID']>>;
  /** Array of Order groups input. */
  orderGroupsAttributes: Array<OrderGroupInput>;
};

/** Autogenerated return type of CreateOrderGroups */
export type CreateOrderGroupsPayload = {
  __typename?: 'CreateOrderGroupsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderGroups?: Maybe<Array<OrderGroup>>;
  orderLinks?: Maybe<Array<OrderLink>>;
};

/** Autogenerated input type of CreateOrderInvoice */
export type CreateOrderInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  mobileOffline?: InputMaybe<Scalars['Boolean']>;
  orderGroupId: Scalars['ID'];
  rebill?: InputMaybe<Scalars['Boolean']>;
  trigger?: InputMaybe<TriggerTypeEnum>;
};

/** Autogenerated return type of CreateOrderInvoice */
export type CreateOrderInvoicePayload = {
  __typename?: 'CreateOrderInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  response?: Maybe<OrderInvoiceResponse>;
};

/** Autogenerated input type of CreateOrderLink */
export type CreateOrderLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CreateOrderLinksInput;
};

/** Autogenerated return type of CreateOrderLink */
export type CreateOrderLinkPayload = {
  __typename?: 'CreateOrderLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderLink?: Maybe<OrderLink>;
};

/** Create order link Input */
export type CreateOrderLinksInput = {
  deliveryOrderId?: InputMaybe<Scalars['ID']>;
  extractionOrderId?: InputMaybe<Scalars['ID']>;
  loadingOrderId?: InputMaybe<Scalars['ID']>;
  transferOrderId?: InputMaybe<Scalars['ID']>;
};

/** Data to create order quote */
export type CreateOrderQuoteInput = {
  applicableFees?: InputMaybe<Array<ApplicableFeesInput>>;
  customerBranchId: Scalars['ID'];
  customerId: Scalars['ID'];
  hubId?: InputMaybe<Scalars['Int']>;
  orderedProductsSummary: Array<OrderedProductsInput>;
  plannedTime: Scalars['Int'];
};

/** Autogenerated input type of CreatePandaBox */
export type CreatePandaBoxInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: PandaBoxInput;
};

/** Autogenerated return type of CreatePandaBox */
export type CreatePandaBoxPayload = {
  __typename?: 'CreatePandaBoxPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  pandaBox?: Maybe<PandaBox>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of CreatePaymentTerms */
export type CreatePaymentTermsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: PaymentTermInput;
};

/** Autogenerated return type of CreatePaymentTerms */
export type CreatePaymentTermsPayload = {
  __typename?: 'CreatePaymentTermsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  paymentTerm?: Maybe<PaymentTerm>;
};

/** Autogenerated input type of CreatePeripheral */
export type CreatePeripheralInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: PeripheralInput;
};

/** Autogenerated return type of CreatePeripheral */
export type CreatePeripheralPayload = {
  __typename?: 'CreatePeripheralPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  peripheral?: Maybe<Peripheral>;
};

/** Create Pickup Point Code input */
export type CreatePickupPointCodeInput = {
  code: Scalars['String'];
  erpId?: InputMaybe<Scalars['String']>;
  loadingAccountId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  terminalsSupplierId: Scalars['ID'];
};

/** Autogenerated input type of CreatePickupPointCodes */
export type CreatePickupPointCodesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CreatePickupPointCodeInput;
};

/** Autogenerated return type of CreatePickupPointCodes */
export type CreatePickupPointCodesPayload = {
  __typename?: 'CreatePickupPointCodesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  pickupPointCode?: Maybe<PickupPointCode>;
};

/** Autogenerated input type of CreatePoc */
export type CreatePocInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerId: Scalars['ID'];
  email: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
};

/** Autogenerated return type of CreatePoc */
export type CreatePocPayload = {
  __typename?: 'CreatePocPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  poc?: Maybe<User>;
};

/** Autogenerated input type of CreatePricing */
export type CreatePricingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CreatePricingsInput;
};

/** Autogenerated return type of CreatePricing */
export type CreatePricingPayload = {
  __typename?: 'CreatePricingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  pricing?: Maybe<Pricing>;
};

/** Create Rate Type input */
export type CreatePricingsInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  customerBranchId?: InputMaybe<Scalars['ID']>;
  effectiveEndDate?: InputMaybe<Scalars['Int']>;
  effectiveStartDate?: InputMaybe<Scalars['Int']>;
  expirationDatetime?: InputMaybe<Scalars['Int']>;
  freight?: InputMaybe<Scalars['Float']>;
  hubId?: InputMaybe<Scalars['ID']>;
  isTemporary?: InputMaybe<Scalars['Boolean']>;
  marketId?: InputMaybe<Scalars['ID']>;
  markup?: InputMaybe<Scalars['Float']>;
  price?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['ID']>;
  rateTypeId: Scalars['ID'];
  supplierId?: InputMaybe<Scalars['ID']>;
  taxes?: InputMaybe<Scalars['Float']>;
  terminalId?: InputMaybe<Scalars['ID']>;
  totalPrice?: InputMaybe<Scalars['Float']>;
  ttlDurationSeconds?: InputMaybe<Scalars['Int']>;
};

/** Create product input */
export type CreateProductInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  allowTopUp?: InputMaybe<Scalars['Boolean']>;
  barcode?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Scalars['ID']>;
  code?: InputMaybe<Scalars['String']>;
  deliveryType?: InputMaybe<ProductDeliveryTypeEnum>;
  erpId?: InputMaybe<Scalars['String']>;
  flowRate?: InputMaybe<Scalars['Int']>;
  /** Only the last 2 digit of gl mapping e.g. for Heating Oil 3010 set 10 */
  glNumber?: InputMaybe<Scalars['String']>;
  hubResourceAttributes?: InputMaybe<HubResourceInput>;
  ignoreNsPush?: InputMaybe<Scalars['Boolean']>;
  legalDescription?: InputMaybe<Scalars['String']>;
  lineOfServiceIds?: InputMaybe<Array<Scalars['ID']>>;
  longDescription?: InputMaybe<Scalars['String']>;
  phoenixNumber?: InputMaybe<Scalars['String']>;
  productCategoryId?: InputMaybe<Scalars['ID']>;
  productConstituentsAttributes?: InputMaybe<Array<NestedProductConstituentsInput>>;
  productResourcesAttributes?: InputMaybe<Array<NestedProductResourceInput>>;
  productSubCategoryId?: InputMaybe<Scalars['ID']>;
  productType: ProductTypeEnum;
  qrCode?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
  soldAs?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<UnitEnum>;
};

/** Autogenerated input type of CreateProductOrderFees */
export type CreateProductOrderFeesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  productOrderFeeInputs: Array<ProductOrderFeeInput>;
};

/** Autogenerated return type of CreateProductOrderFees */
export type CreateProductOrderFeesPayload = {
  __typename?: 'CreateProductOrderFeesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  response?: Maybe<ProductOrderFeeResponse>;
};

/** Autogenerated input type of CreateProductPurchaseLimits */
export type CreateProductPurchaseLimitsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: ProductPurchaseLimitInput;
};

/** Autogenerated return type of CreateProductPurchaseLimits */
export type CreateProductPurchaseLimitsPayload = {
  __typename?: 'CreateProductPurchaseLimitsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  productPurchaseLimit?: Maybe<ProductPurchaseLimit>;
};

/** Autogenerated input type of CreateProducts */
export type CreateProductsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CreateProductInput;
};

/** Autogenerated return type of CreateProducts */
export type CreateProductsPayload = {
  __typename?: 'CreateProductsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
};

/** Autogenerated input type of CreateQuote */
export type CreateQuoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CreateOrderQuoteInput;
};

/** Autogenerated return type of CreateQuote */
export type CreateQuotePayload = {
  __typename?: 'CreateQuotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  response?: Maybe<Quote>;
};

/** Autogenerated input type of CreateRackMarket */
export type CreateRackMarketInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  hubResourcesAttributes?: InputMaybe<Array<HubResourceInput>>;
  name: Scalars['String'];
};

/** Autogenerated return type of CreateRackMarket */
export type CreateRackMarketPayload = {
  __typename?: 'CreateRackMarketPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  rackMarket?: Maybe<RackMarket>;
};

/** Autogenerated input type of CreateRate */
export type CreateRateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CreateRateTypeInput;
};

/** Autogenerated return type of CreateRate */
export type CreateRatePayload = {
  __typename?: 'CreateRatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  rateType?: Maybe<RateType>;
};

/** Create Rate Type input */
export type CreateRateTypeInput = {
  description?: InputMaybe<Scalars['String']>;
  isTemporaryRateType?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  operation: RateTypeOperationEnum;
  status?: InputMaybe<RateTypeStatusEnum>;
};

/** Autogenerated input type of CreateRawShift */
export type CreateRawShiftInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Raw Shift input type. */
  rawShiftAttributes?: InputMaybe<RawShiftCreateInput>;
};

/** Autogenerated return type of CreateRawShift */
export type CreateRawShiftPayload = {
  __typename?: 'CreateRawShiftPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Raw Shift type. */
  rawShift?: Maybe<RawShift>;
};

/** Autogenerated input type of CreateResourceComponent */
export type CreateResourceComponentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  resourceComponentsAttributes: ResourceComponentsInput;
};

/** Autogenerated return type of CreateResourceComponent */
export type CreateResourceComponentPayload = {
  __typename?: 'CreateResourceComponentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  resourceComponentType: ResourceComponent;
};

/** Autogenerated input type of CreateResourcePricing */
export type CreateResourcePricingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CreateResourcePricingsInput;
};

/** Autogenerated return type of CreateResourcePricing */
export type CreateResourcePricingPayload = {
  __typename?: 'CreateResourcePricingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  resourcePricing?: Maybe<ResourcePricing>;
};

/** Create Resource Pricings Input */
export type CreateResourcePricingsInput = {
  /** ApplicableMargin object. */
  applicableMarginsAttributes?: InputMaybe<Array<ApplicableMarginsInput>>;
  /** ApplicableTax object. */
  applicableTaxesAttributes?: InputMaybe<Array<ApplicableTaxesInput>>;
  discount?: InputMaybe<Scalars['Float']>;
  discountUnit?: InputMaybe<RateUnitEnum>;
  marginsProductsAttributes?: InputMaybe<Array<UpdateMarginsProductsInput>>;
  masterApplyApplicableTax?: InputMaybe<Scalars['String']>;
  pocEmail?: InputMaybe<Scalars['String']>;
  pocName?: InputMaybe<Scalars['String']>;
  pocPhone?: InputMaybe<Scalars['String']>;
  /** PriceConfiguration object. */
  priceConfigurationsAttributes?: InputMaybe<Array<PriceConfigurationInput>>;
  /** Deprecated: Use productCategoryResourcesAttributes */
  productCategoryId?: InputMaybe<Scalars['ID']>;
  /** Product Category Resource object. */
  productCategoryResourcesAttributes?: InputMaybe<Array<ProductCategoryResourceInput>>;
  rateTypeId?: InputMaybe<Scalars['ID']>;
  resourceId?: InputMaybe<Scalars['ID']>;
  resourceType?: InputMaybe<ResourcePricingEnum>;
  userId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of CreateResourceSchedule */
export type CreateResourceScheduleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Resource Schedule input type. */
  resourceScheduleAttributes: ResourceScheduleInput;
};

/** Autogenerated return type of CreateResourceSchedule */
export type CreateResourceSchedulePayload = {
  __typename?: 'CreateResourceSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  resourceSchedule?: Maybe<ResourceSchedule>;
};

/** Autogenerated input type of CreateSavedView */
export type CreateSavedViewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  input: SavedViewInput;
};

/** Autogenerated return type of CreateSavedView */
export type CreateSavedViewPayload = {
  __typename?: 'CreateSavedViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  savedView?: Maybe<SavedView>;
};

/** Autogenerated input type of CreateSetting */
export type CreateSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  value: Scalars['String'];
};

/** Autogenerated return type of CreateSetting */
export type CreateSettingPayload = {
  __typename?: 'CreateSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  setting?: Maybe<Setting>;
};

/** Autogenerated input type of CreateShift */
export type CreateShiftInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Shift input type. */
  shiftAttributes?: InputMaybe<ShiftCreateInput>;
};

/** Autogenerated return type of CreateShift */
export type CreateShiftPayload = {
  __typename?: 'CreateShiftPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Shift type. */
  shift?: Maybe<Shift>;
};

/** Autogenerated input type of CreateSiteRecurrence */
export type CreateSiteRecurrenceInput = {
  ccTenantId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerBranchId: Scalars['ID'];
  customerId: Scalars['ID'];
  driverId?: InputMaybe<Scalars['ID']>;
  fromCustomerPortal?: InputMaybe<Scalars['Boolean']>;
  hubId?: InputMaybe<Scalars['ID']>;
  /** Loading order input object. */
  loadingOrderAttributes?: InputMaybe<Array<LoadingOrderInput>>;
  parentDeliveryOrderId?: InputMaybe<Scalars['ID']>;
  /** Manual PO number to assign to the recurring order group. */
  poNumber?: InputMaybe<Scalars['String']>;
  recurrence: RecurrenceInput;
  recurrenceAssets?: InputMaybe<Array<RecurrenceAssetsInput>>;
  startOnTimestamp?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<DeliveryOrderTypeEnum>;
};

/** Autogenerated return type of CreateSiteRecurrence */
export type CreateSiteRecurrencePayload = {
  __typename?: 'CreateSiteRecurrencePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
};

/** Create supplier input */
export type CreateSupplierInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  erpId?: InputMaybe<Scalars['String']>;
  irelyShipFromLocation?: InputMaybe<Scalars['String']>;
  isIrelyInternalSupplier?: InputMaybe<Scalars['Boolean']>;
  lineOfServiceIds?: InputMaybe<Array<Scalars['ID']>>;
  loadingAccountsAttributes?: InputMaybe<Array<NestedLoadingAccountInput>>;
  name: Scalars['String'];
  supplierCode?: InputMaybe<Scalars['String']>;
  supplierType?: InputMaybe<SupplierTypeEnum>;
  terminalsSuppliersAttributes?: InputMaybe<Array<NestedTerminalSupplierInput>>;
};

/** Create supplier input (v3) */
export type CreateSupplierInputV3 = {
  active?: InputMaybe<Scalars['Boolean']>;
  erpId?: InputMaybe<Scalars['String']>;
  irelyShipFromLocation?: InputMaybe<Scalars['String']>;
  isIrelyInternalSupplier?: InputMaybe<Scalars['Boolean']>;
  lineOfServiceIds?: InputMaybe<Array<Scalars['ID']>>;
  loadingAccountsAttributes?: InputMaybe<Array<NestedLoadingAccountInputV3>>;
  name: Scalars['String'];
  supplierCode?: InputMaybe<Scalars['String']>;
  supplierType?: InputMaybe<SupplierTypeEnum>;
  terminalsSuppliersAttributes?: InputMaybe<Array<NestedTerminalSupplierInput>>;
};

/** Autogenerated input type of CreateSuppliers */
export type CreateSuppliersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CreateSupplierInput;
};

/** Autogenerated return type of CreateSuppliers */
export type CreateSuppliersPayload = {
  __typename?: 'CreateSuppliersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  supplier?: Maybe<Supplier>;
};

/** Autogenerated input type of CreateSuppliersV2 */
export type CreateSuppliersV2Input = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CreateSupplierInput;
};

/** Autogenerated return type of CreateSuppliersV2 */
export type CreateSuppliersV2Payload = {
  __typename?: 'CreateSuppliersV2Payload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  supplier?: Maybe<Supplier>;
};

/** Autogenerated input type of CreateSuppliersV3 */
export type CreateSuppliersV3Input = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CreateSupplierInputV3;
};

/** Autogenerated return type of CreateSuppliersV3 */
export type CreateSuppliersV3Payload = {
  __typename?: 'CreateSuppliersV3Payload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  supplier?: Maybe<Supplier>;
};

/** Autogenerated input type of CreateTax */
export type CreateTaxInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CreateTaxesInput;
};

/** Autogenerated return type of CreateTax */
export type CreateTaxPayload = {
  __typename?: 'CreateTaxPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  tax?: Maybe<Tax>;
};

/** Create Tax Input */
export type CreateTaxesInput = {
  amountType?: InputMaybe<TaxAmountTypeEnum>;
  calculationType?: InputMaybe<TaxCalculationTypeEnum>;
  dateRangeAttribute?: InputMaybe<Array<TaxRangeAttributeInput>>;
  description?: InputMaybe<Scalars['String']>;
  doNotRoundUpRate?: InputMaybe<Scalars['Boolean']>;
  erpId: Scalars['String'];
  exempt?: InputMaybe<Scalars['Boolean']>;
  glCode?: InputMaybe<Scalars['String']>;
  marketId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  productCategoryId?: InputMaybe<Scalars['ID']>;
  /** list of product category for tax */
  productCategoryResourcesAttributes?: InputMaybe<Array<ProductCategoryResourceInput>>;
  /** Tax for product */
  productTaxesAttributes?: InputMaybe<Array<ProductTaxesInput>>;
  rateInCurrency?: InputMaybe<Scalars['Float']>;
  rateInPercent?: InputMaybe<Scalars['Float']>;
  rateType: RateUnitEnum;
};

/** Autogenerated input type of CreateTerminals */
export type CreateTerminalsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: TerminalInput;
};

/** Autogenerated return type of CreateTerminals */
export type CreateTerminalsPayload = {
  __typename?: 'CreateTerminalsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  terminal?: Maybe<Terminal>;
};

/** Autogenerated input type of CreateTerminalsSuppliers */
export type CreateTerminalsSuppliersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: TerminalsSupplierInput;
};

/** Autogenerated return type of CreateTerminalsSuppliers */
export type CreateTerminalsSuppliersPayload = {
  __typename?: 'CreateTerminalsSuppliersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  terminalsSupplier?: Maybe<TerminalsSupplier>;
};

/** Autogenerated input type of CreateTransferOrder */
export type CreateTransferOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  transferOrderAttributes?: InputMaybe<TransferOrderInput>;
};

/** Autogenerated return type of CreateTransferOrder */
export type CreateTransferOrderPayload = {
  __typename?: 'CreateTransferOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  transferOrder?: Maybe<TransferOrder>;
};

/** Autogenerated input type of CreateUpdateAliasMapping */
export type CreateUpdateAliasMappingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  mapper: AliasMappingInput;
};

/** Autogenerated return type of CreateUpdateAliasMapping */
export type CreateUpdateAliasMappingPayload = {
  __typename?: 'CreateUpdateAliasMappingPayload';
  aliasMapping?: Maybe<AliasMapping>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateUpdateIrelyFilter */
export type CreateUpdateIrelyFilterInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  irelyFilterAttributes: IrelyFilterInput;
};

/** Autogenerated return type of CreateUpdateIrelyFilter */
export type CreateUpdateIrelyFilterPayload = {
  __typename?: 'CreateUpdateIrelyFilterPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  irelyFilter?: Maybe<IrelyFilter>;
};

/** Autogenerated input type of CreateZoneProductBatches */
export type CreateZoneProductBatchesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  zoneProductBatchesAttributes: Array<ZoneProductBatchInput>;
};

/** Autogenerated return type of CreateZoneProductBatches */
export type CreateZoneProductBatchesPayload = {
  __typename?: 'CreateZoneProductBatchesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  zoneProductBatches?: Maybe<Array<ZoneProductBatch>>;
};

export type CreditLedger = {
  __typename?: 'CreditLedger';
  creditLedgerTransaction?: Maybe<CreditLedgerTransaction>;
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CreditLedgerMonthlyStats = {
  __typename?: 'CreditLedgerMonthlyStats';
  amountCredited?: Maybe<Scalars['Float']>;
  amountDebited?: Maybe<Scalars['Float']>;
  netAmount?: Maybe<Scalars['Float']>;
};

export type CreditLedgerTransaction = {
  __typename?: 'CreditLedgerTransaction';
  amount: Scalars['Float'];
  closingBalance: Scalars['Float'];
  creatable?: Maybe<User>;
  createdAt: Scalars['Int'];
  customer: Customer;
  description: Scalars['String'];
  id: Scalars['ID'];
  orderGroup?: Maybe<OrderGroup>;
  transactionType: CreditLedgerTransactionTypeEnum;
};

export type CreditLedgerTransactionCollection = {
  __typename?: 'CreditLedgerTransactionCollection';
  collection: Array<CreditLedgerTransaction>;
  metadata: MetaQuery;
};

export type CreditLedgerTransactionFilters = {
  customerId: Scalars['ID'];
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  searchParam?: InputMaybe<Scalars['String']>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
  transactionType?: InputMaybe<CreditLedgerTransactionTypeEnum>;
};

/** Customer Credit Ledger Transaction Input */
export type CreditLedgerTransactionInput = {
  amount: Scalars['Float'];
  customerId: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  transactionType: CreditLedgerTransactionTypeEnum;
};

/** Enum for credit ledger transaction type */
export enum CreditLedgerTransactionTypeEnum {
  /** credit */
  Credit = 'credit',
  /** debit */
  Debit = 'debit'
}

export type CrudePricing = {
  __typename?: 'CrudePricing';
  crudePricableId?: Maybe<Scalars['ID']>;
  crudePricableType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  pandaPriceRateType?: Maybe<RateType>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']>;
  range?: Maybe<Scalars['JSON']>;
};

export type CrudePricingCollection = {
  __typename?: 'CrudePricingCollection';
  collection: Array<CrudePricing>;
  metadata: MetaDataQuery;
};

export type CrudePricingFilter = {
  all?: InputMaybe<Scalars['String']>;
  crudePricableId?: InputMaybe<Scalars['ID']>;
  crudePricableType?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<CrudePricingFilter>>;
};

/** Create Rate Type input */
export type CrudePricingsInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  crudePricableId?: InputMaybe<Scalars['ID']>;
  crudePricableType?: InputMaybe<Scalars['String']>;
  pandaPriceRateTypeId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  range?: InputMaybe<Array<RangeInput>>;
};

export type CsvFileExport = {
  __typename?: 'CsvFileExport';
  data?: Maybe<Array<Scalars['JSON']>>;
  fileName: Scalars['String'];
  headers: Array<Scalars['String']>;
};

export type Current = {
  __typename?: 'Current';
  accessibleCustomers: Array<Customer>;
  customer?: Maybe<Customer>;
  features: Array<Scalars['String']>;
  isCarrierOnly: Scalars['Boolean'];
  isCustomerClient: Scalars['Boolean'];
  leaTenants?: Maybe<Array<Tenant>>;
  pusherChannelName?: Maybe<Scalars['String']>;
  settingFeatures: Array<Scalars['String']>;
  settings: Array<Setting>;
  tenant?: Maybe<Tenant>;
  user: User;
};

export type Customer = {
  __typename?: 'Customer';
  accountId?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  addressBooks?: Maybe<Array<AddressBook>>;
  agreedLoadGallon?: Maybe<Scalars['Int']>;
  applicableFees?: Maybe<Array<ApplicableFee>>;
  arDivisionNumber?: Maybe<Scalars['String']>;
  assets?: Maybe<Array<Asset>>;
  attachPostDeliveryImageOnDeliveryTicket?: Maybe<Scalars['Boolean']>;
  cardLockTransactions?: Maybe<Array<CardLockTransaction>>;
  creditChecked?: Maybe<Scalars['Boolean']>;
  creditLedgerBalance?: Maybe<Scalars['String']>;
  creditLimit?: Maybe<Scalars['String']>;
  creditLimitDaysOverdueBuffer?: Maybe<Scalars['String']>;
  creditLimitExceeded?: Maybe<Scalars['Boolean']>;
  creditLimitPercentageBuffer?: Maybe<Scalars['String']>;
  crudePricings?: Maybe<Array<CrudePricing>>;
  currentBalance?: Maybe<Scalars['String']>;
  customerBranchNames?: Maybe<Scalars['String']>;
  customerBranches?: Maybe<Array<CustomerBranch>>;
  customerPortalPermissions?: Maybe<Scalars['JSON']>;
  customerSegment?: Maybe<CustomerSegment>;
  data?: Maybe<Scalars['String']>;
  daysOverdue?: Maybe<Scalars['String']>;
  deliveryInstruction?: Maybe<Scalars['String']>;
  deliveryOrders?: Maybe<Array<DeliveryOrder>>;
  dueDate?: Maybe<Scalars['String']>;
  enableCreateDeliveryOrder?: Maybe<Scalars['Boolean']>;
  epaId?: Maybe<Scalars['String']>;
  erpId?: Maybe<Scalars['String']>;
  exemptStatus?: Maybe<Array<Scalars['String']>>;
  fees?: Maybe<Array<Fee>>;
  feinNumber?: Maybe<Scalars['String']>;
  fleetCardNumbers?: Maybe<Array<Scalars['String']>>;
  groupName?: Maybe<Scalars['String']>;
  hideVendorPricing?: Maybe<Scalars['Boolean']>;
  hubResources?: Maybe<Array<HubResource>>;
  hubs?: Maybe<Array<Hub>>;
  id: Scalars['ID'];
  irelyId?: Maybe<Scalars['String']>;
  isTenant?: Maybe<Scalars['Boolean']>;
  lastOrderGroup?: Maybe<OrderGroup>;
  lastSyncedTime?: Maybe<Scalars['String']>;
  lineOfServices?: Maybe<Array<LineOfService>>;
  marketResources?: Maybe<Array<MarketResource>>;
  markets?: Maybe<Array<Market>>;
  name?: Maybe<Scalars['String']>;
  netsuiteId?: Maybe<Scalars['ID']>;
  netsuiteName?: Maybe<Scalars['String']>;
  nonEditableRecords?: Maybe<Array<Scalars['JSON']>>;
  paymentTerm?: Maybe<PaymentTerm>;
  paymentTypeName?: Maybe<PaymentTypeEnum>;
  permitNumber?: Maybe<Scalars['String']>;
  poBoxNumber?: Maybe<Scalars['String']>;
  poNumber?: Maybe<Scalars['String']>;
  portalAccessLevel?: Maybe<PortalAccessLevelEnum>;
  preferredDrivers?: Maybe<Array<Worker>>;
  preferredProductTerminals?: Maybe<Array<PreferredProductTerminal>>;
  productPurchaseLimit?: Maybe<ProductPurchaseLimit>;
  productPurchaseLimitId?: Maybe<Scalars['ID']>;
  purchaseOrder?: Maybe<Scalars['Boolean']>;
  purchaseOrderType?: Maybe<PurchaseOrderTypeEnum>;
  quickbridgeId?: Maybe<Scalars['String']>;
  resourcePricingId?: Maybe<Scalars['ID']>;
  resourceSchedule?: Maybe<ResourceSchedule>;
  site?: Maybe<Site>;
  status?: Maybe<Scalars['Int']>;
  taggings?: Maybe<Array<Tagging>>;
  tankReadingMaxThreshold?: Maybe<Scalars['Float']>;
  tankReadingThreshold?: Maybe<Scalars['Float']>;
  tenantId?: Maybe<Scalars['ID']>;
  tenantSlug?: Maybe<Scalars['String']>;
  thirdPartyDelivery?: Maybe<Scalars['Boolean']>;
  totalRequestedVolume?: Maybe<Scalars['JSON']>;
  upcomingOrderGroup?: Maybe<OrderGroup>;
  users?: Maybe<Array<User>>;
  vendorErpId?: Maybe<Scalars['String']>;
};


export type CustomerCustomerBranchesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
};


export type CustomerDeliveryOrdersArgs = {
  last?: InputMaybe<Scalars['Int']>;
};


export type CustomerTotalRequestedVolumeArgs = {
  fromDate?: InputMaybe<Scalars['Int']>;
  toDate?: InputMaybe<Scalars['Int']>;
};

export type CustomerBranch = {
  __typename?: 'CustomerBranch';
  address?: Maybe<Scalars['String']>;
  addressBooks?: Maybe<Array<AddressBook>>;
  applicableFees?: Maybe<Array<ApplicableFee>>;
  assets?: Maybe<Array<Asset>>;
  attachBolOnDeliveryTicket: Scalars['Boolean'];
  autoEmailDeliveryTicket: Scalars['Boolean'];
  availableRentalAssetsCount?: Maybe<Scalars['Int']>;
  cardLockSiteNumber?: Maybe<Scalars['String']>;
  crudePricings?: Maybe<Array<CrudePricing>>;
  customer?: Maybe<Customer>;
  deliveryInstruction?: Maybe<Scalars['String']>;
  deliveryInstructionUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  deliveryInstructionUpdatedBy?: Maybe<Scalars['String']>;
  deliveryOrders?: Maybe<Array<DeliveryOrder>>;
  email?: Maybe<Scalars['String']>;
  erpId?: Maybe<Scalars['String']>;
  hubResources?: Maybe<Array<HubResource>>;
  hubs?: Maybe<Array<Hub>>;
  id: Scalars['ID'];
  intransitAssets?: Maybe<Array<Asset>>;
  irelyId?: Maybe<Scalars['String']>;
  isCustomerSignatureRequired: Scalars['Boolean'];
  isHub?: Maybe<Scalars['Boolean']>;
  lastStartOn?: Maybe<Scalars['Int']>;
  lastToStartOn?: Maybe<Scalars['Int']>;
  lineOfServices?: Maybe<Array<LineOfService>>;
  loadingAccounts?: Maybe<Array<LoadingAccount>>;
  marketResources?: Maybe<Array<MarketResource>>;
  markets?: Maybe<Array<Market>>;
  name?: Maybe<Scalars['String']>;
  netsuiteId?: Maybe<Scalars['ID']>;
  netsuiteName?: Maybe<Scalars['String']>;
  nonEditableRecords?: Maybe<Array<Scalars['JSON']>>;
  onlyShowGrossGallonsInDeliveryTicket?: Maybe<Scalars['Boolean']>;
  orderedProductsAverage?: Maybe<Array<OrderedProductsAverage>>;
  pandaDocuments?: Maybe<Array<PandaDocument>>;
  pandaTankMonitorDevices?: Maybe<DeviceCollection>;
  phone?: Maybe<Scalars['String']>;
  pickupPointCodes?: Maybe<Array<PickupPointCode>>;
  poNumber?: Maybe<Scalars['String']>;
  preferredProductTerminals?: Maybe<Array<PreferredProductTerminal>>;
  priceCode?: Maybe<Scalars['String']>;
  purchaseOrder?: Maybe<Scalars['Boolean']>;
  purchaseOrderType?: Maybe<PurchaseOrderTypeEnum>;
  qbAddress?: Maybe<Scalars['String']>;
  qbName?: Maybe<Scalars['String']>;
  qboItemizeLineItemOnSalesOrder?: Maybe<Scalars['Boolean']>;
  resourcePricingId?: Maybe<Scalars['ID']>;
  resourceSchedule?: Maybe<ResourceSchedule>;
  site?: Maybe<Site>;
  status?: Maybe<Scalars['Boolean']>;
  storageAssets?: Maybe<Array<Asset>>;
  suppliers?: Maybe<Array<Supplier>>;
  syncSalesToD1?: Maybe<Scalars['Boolean']>;
  taggings?: Maybe<Array<Tagging>>;
  terminalDriverRates?: Maybe<Scalars['JSON']>;
};


export type CustomerBranchDeliveryOrdersArgs = {
  last?: InputMaybe<Scalars['Int']>;
  lineItemStatus?: InputMaybe<Array<Scalars['String']>>;
  selectLastCreated?: InputMaybe<Scalars['Boolean']>;
};


export type CustomerBranchPandaTankMonitorDevicesArgs = {
  filter?: InputMaybe<DynamicFiltersInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type CustomerBranchCollection = {
  __typename?: 'CustomerBranchCollection';
  collection: Array<CustomerBranch>;
  metadata: MetaQuery;
};

export type CustomerBranchFilter = {
  /** Fetch only active customers */
  active?: InputMaybe<Scalars['Boolean']>;
  all?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['ID']>;
  isHub?: InputMaybe<Scalars['Boolean']>;
  isTenant?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<CustomerBranchFilter>>;
};

export type CustomerBranchSorter = {
  field: CustomerBranchSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum CustomerBranchSorterEnum {
  Erpid = 'ERPID',
  Name = 'NAME'
}

export type CustomerBranchesFilter = {
  customerId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};

export type CustomerCollection = {
  __typename?: 'CustomerCollection';
  collection: Array<Customer>;
  metadata: MetaQuery;
};

export type CustomerFilter = {
  /** Fetch only active customers */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Filter by customer address */
  address?: InputMaybe<Scalars['String']>;
  /** Filter by customer city */
  city?: InputMaybe<Scalars['String']>;
  /** Fetch customers with limit exceeded */
  creditLimitExceeded?: InputMaybe<Scalars['Boolean']>;
  /** Filter by customer branch name */
  customerBranchesName?: InputMaybe<Scalars['String']>;
  /** Filter by customer name */
  customersName?: InputMaybe<Scalars['String']>;
  hubIds?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<CustomerFilter>>;
  resource?: InputMaybe<CustomerFilterEnum>;
  /** Filter by customer state */
  state?: InputMaybe<Scalars['String']>;
  tenant?: InputMaybe<Scalars['Boolean']>;
};

export enum CustomerFilterEnum {
  /** for all customers and shipto search */
  All = 'All',
  /** for customer based search */
  Customer = 'Customer',
  /** for customer branch based search */
  CustomerBranch = 'CustomerBranch',
  /** for customer name and erp id based search */
  CustomerNameAndErpId = 'CustomerNameAndErpId'
}

/** Customer portal configuration object type */
export type CustomerPortalConfiguration = {
  __typename?: 'CustomerPortalConfiguration';
  domains?: Maybe<Array<Scalars['String']>>;
  faviconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  landscapeLogoUrl?: Maybe<Scalars['String']>;
  notificationChannels?: Maybe<Array<Scalars['String']>>;
  notificationEmails?: Maybe<Scalars['String']>;
  notificationPhones?: Maybe<Scalars['String']>;
  notificationTemplates?: Maybe<Array<NotificationTemplate>>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  squareLogoUrl?: Maybe<Scalars['String']>;
  welcomeMessage?: Maybe<Scalars['String']>;
};

export type CustomerPortalConfigurationInput = {
  domains?: InputMaybe<Array<Scalars['String']>>;
  faviconUrl?: InputMaybe<Scalars['String']>;
  landscapeLogoUrl?: InputMaybe<Scalars['String']>;
  notificationChannels?: InputMaybe<Array<Scalars['String']>>;
  notificationEmails?: InputMaybe<Scalars['String']>;
  notificationPhones?: InputMaybe<Scalars['String']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  secondaryColor?: InputMaybe<Scalars['String']>;
  squareLogoUrl?: InputMaybe<Scalars['String']>;
  welcomeMessage?: InputMaybe<Scalars['String']>;
};

/** Customer Portal Invitation input */
export type CustomerPortalInput = {
  /** Attachment with name and url */
  attachments?: InputMaybe<Array<EmailAttachmentInput>>;
  /** BCC Receivers' Email */
  bcc?: InputMaybe<Array<Scalars['String']>>;
  /** Email's body */
  body?: InputMaybe<Scalars['String']>;
  /** CC Receivers' Email */
  cc?: InputMaybe<Array<Scalars['String']>>;
  /** Sender Email */
  from?: InputMaybe<Scalars['String']>;
  /** Customer Portal Access */
  hasAccessToCustomerPortal: Scalars['Boolean'];
  /** Address Book Id */
  id: Scalars['ID'];
  /** Email's Subject */
  subject?: InputMaybe<Scalars['String']>;
  /** Receivers' Email */
  to?: InputMaybe<Array<Scalars['String']>>;
};

export type CustomerReport = {
  __typename?: 'CustomerReport';
  id: Scalars['ID'];
  lastViewedAt?: Maybe<Scalars['ISO8601DateTime']>;
  lastViewedBy?: Maybe<User>;
  name: Scalars['String'];
  owner: User;
  receipients?: Maybe<Scalars['String']>;
  recurrence?: Maybe<RecurrenceOrderGroup>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type CustomerReportCollection = {
  __typename?: 'CustomerReportCollection';
  collection: Array<CustomerReport>;
  metadata: MetaQuery;
};

export type CustomerReportFilter = {
  name?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<CustomerReportFilter>>;
};

/** Input for updating a customer report */
export type CustomerReportInput = {
  /** ID of the customer report to update */
  id: Scalars['ID'];
  /** List of email addresses to send the report to */
  receipients?: InputMaybe<Scalars['String']>;
  /** Recurrence configuration */
  recurrence?: InputMaybe<RecurrenceInput>;
};

export type CustomerReportSorter = {
  field: CustomerReportSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum CustomerReportSorterEnum {
  Name = 'NAME'
}

/** Customer Representative in LEA Questionnaire */
export type CustomerRepresentative = {
  __typename?: 'CustomerRepresentative';
  billingAddress?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  pocId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

/** Customer Representative Input in LEA Questionnaire */
export type CustomerRepresentativeInput = {
  billingAddress?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  pocId?: InputMaybe<Scalars['ID']>;
  state?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** Merge customer resources input */
export type CustomerResourceInput = {
  /** Duplicate: Same license plate number customer asset already exists in the primary record */
  mergeDuplicateSecondaryCustomerAssets?: InputMaybe<Scalars['Boolean']>;
  /** Duplicate: Same name customer branch already exists in the primary record */
  mergeDuplicateSecondaryCustomerBranches?: InputMaybe<Scalars['Boolean']>;
  primaryRecordId: Scalars['ID'];
  recordType: CustomerResourceTypeEnum;
  removeSecondaryCustomerAssetsWithoutOrders?: InputMaybe<Scalars['Boolean']>;
  removeSecondaryCustomerBranchesWithoutOrders?: InputMaybe<Scalars['Boolean']>;
  secondaryRecordId: Scalars['ID'];
};

/** Customer Resources That can be merged */
export enum CustomerResourceTypeEnum {
  Customer = 'Customer',
  CustomerAsset = 'CustomerAsset',
  CustomerBranch = 'CustomerBranch'
}

/** Autogenerated input type of CustomerResources */
export type CustomerResourcesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CustomerResourceInput;
};

/** Autogenerated return type of CustomerResources */
export type CustomerResourcesPayload = {
  __typename?: 'CustomerResourcesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CustomerSegment = {
  __typename?: 'CustomerSegment';
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  segmentType?: Maybe<Scalars['String']>;
};

export type CustomerSegmentInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<CustomerSegmentNameEnum>;
  segmentType?: InputMaybe<Scalars['String']>;
};

export enum CustomerSegmentNameEnum {
  /** Commercial Customer */
  Commercial = 'commercial',
  /** EFS Customer */
  Efs = 'efs',
  /** Fleet Customer */
  Fleet = 'fleet',
  /** Internal Fuel Customer */
  InternalFuel = 'internal_fuel',
  /** Residential Customer */
  Residential = 'residential'
}

export type CustomerSorter = {
  field: CustomerSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a customer query */
export enum CustomerSorterEnum {
  Address = 'ADDRESS',
  CreditChecked = 'CREDIT_CHECKED',
  ErpId = 'ERP_ID',
  Hubs = 'HUBS',
  Name = 'NAME',
  Status = 'STATUS'
}

export type CustomerUser = {
  __typename?: 'CustomerUser';
  active?: Maybe<Scalars['Boolean']>;
  customer?: Maybe<Customer>;
  customerBranch?: Maybe<CustomerBranch>;
  hubResources?: Maybe<Array<HubResource>>;
  hubs?: Maybe<Array<Hub>>;
  id: Scalars['ID'];
  lineOfServices?: Maybe<Array<LineOfService>>;
  user?: Maybe<User>;
};

export type CustomerUserCollection = {
  __typename?: 'CustomerUserCollection';
  collection: Array<CustomerUser>;
  metadata: MetaQuery;
};

export type CustomerUserFilter = {
  all?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  or?: InputMaybe<Array<CustomerUserFilter>>;
  userId?: InputMaybe<Scalars['ID']>;
};

/** Default customer user Input */
export type CustomerUserInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  customerBranchId?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
  hubResourcesAttributes?: InputMaybe<Array<HubResourceInput>>;
  lineOfServiceIds?: InputMaybe<Array<Scalars['ID']>>;
  userAttributes?: InputMaybe<NestedUserAttributesInput>;
};

export type CustomerUserSorter = {
  field: CustomerUserSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum CustomerUserSorterEnum {
  Email = 'EMAIL',
  Phone = 'PHONE',
  Username = 'USERNAME'
}

export type CustomersFilter = {
  name?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};

export type DataFetchLogger = {
  __typename?: 'DataFetchLogger';
  createdAtTimestamp: Scalars['Int'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type DataFetchLoggerCollection = {
  __typename?: 'DataFetchLoggerCollection';
  collection: Array<DataFetchLogger>;
  metadata: MetaQuery;
};

export type DataFetchLoggerFilter = {
  name: ResourceNameEnum;
  or?: InputMaybe<Array<DataFetchLoggerFilter>>;
  type: DataFetchLoggerSubclassEnum;
};

export type DataFetchLoggerSorter = {
  field: DataFetchLoggerSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum DataFetchLoggerSorterEnum {
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

/** Enum for classes that inherit api_data_fetch_logger */
export enum DataFetchLoggerSubclassEnum {
  AgvanceFetchLogger = 'AgvanceFetchLogger',
  IrelyFetchLogger = 'IrelyFetchLogger',
  NetSuiteRecordFetchInfo = 'NetSuiteRecordFetchInfo',
  NetSuiteRecordsFetchInfo = 'NetSuiteRecordsFetchInfo',
  QbOnlineFetchLogger = 'QbOnlineFetchLogger',
  QuickbooksRecordFetchInfo = 'QuickbooksRecordFetchInfo'
}

export type DataImport = {
  __typename?: 'DataImport';
  createdAtTimestamp?: Maybe<Scalars['Int']>;
  errorFileUrl?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  importableId?: Maybe<Scalars['ID']>;
  importableType?: Maybe<ImportableTypeEnum>;
  pandaDocumentId?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type DataImportProgress = {
  __typename?: 'DataImportProgress';
  dataImportType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  processedRecordIds?: Maybe<Array<Scalars['ID']>>;
  status?: Maybe<Scalars['String']>;
  totalRecordIds?: Maybe<Array<Scalars['ID']>>;
};

/** Enum for Data Import Progress Import Types */
export enum DataImportProgressImportEnum {
  /** Order Group Update */
  OrderGroup = 'order_group'
}

/** Generic date range filter with from date and to date */
export type DateRangeFilterInput = {
  fromDate?: InputMaybe<Scalars['ISO8601Date']>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
};

export type DateRangeInput = {
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};

/** Enum for order groups recurrence days of week */
export enum DaysOfWeek {
  /** Friday */
  Friday = 'friday',
  /** Monday */
  Monday = 'monday',
  /** Saturday */
  Saturday = 'saturday',
  /** Sunday */
  Sunday = 'sunday',
  /** Thursday */
  Thursday = 'thursday',
  /** Tuesday */
  Tuesday = 'tuesday',
  /** Wednesday */
  Wednesday = 'wednesday'
}

export type DdPreferenceAvailability = {
  __typename?: 'DdPreferenceAvailability';
  bestEndTime?: Maybe<Scalars['String']>;
  bestStartTime?: Maybe<Scalars['String']>;
  day?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  preferredEndTime?: Maybe<Scalars['String']>;
  preferredStartTime?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
};

/** Tank Monitor attached asset preference availability input */
export type DdPreferenceAvailabilityInput = {
  /** Best end time of availability, eg: Seconds value in a day example 3pm = 10800 second */
  bestEndTime?: InputMaybe<Scalars['String']>;
  /** Best start time of availability, eg: Seconds value in a day example 3pm = 10800 second */
  bestStartTime?: InputMaybe<Scalars['String']>;
  /** Day of the week */
  day?: InputMaybe<Scalars['String']>;
  /** End time of availability, eg: Seconds value in a day example 3pm = 10800 second */
  endTime?: InputMaybe<Scalars['String']>;
  /** Preferred end time of availability, eg: Seconds value in a day example 3pm = 10800 second */
  preferredEndTime?: InputMaybe<Scalars['String']>;
  /** Preferred start time of availability, eg: Seconds value in a day example 3pm = 10800 second */
  preferredStartTime?: InputMaybe<Scalars['String']>;
  /** Start time of availability, eg: Seconds value in a day example 3pm = 10800 seconds */
  startTime?: InputMaybe<Scalars['String']>;
};

export type DegreeDay = {
  __typename?: 'DegreeDay';
  assetId?: Maybe<Scalars['Int']>;
  avgDailyTemp?: Maybe<Scalars['Float']>;
  avgDailyUsage?: Maybe<Scalars['Float']>;
  createdAt: Scalars['ISO8601DateTime'];
  cumulativeDegreeDays?: Maybe<Scalars['Float']>;
  currentTankLevel?: Maybe<Scalars['Float']>;
  degreeDaysPerDay?: Maybe<Scalars['Float']>;
  deliveryDate?: Maybe<Scalars['ISO8601DateTime']>;
  estTillEmptyDays?: Maybe<Scalars['Float']>;
  estimatedRunOutDate?: Maybe<Scalars['ISO8601DateTime']>;
  gallonsDelivered?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  kFactor?: Maybe<Scalars['Float']>;
  lastDeliveryDate?: Maybe<Scalars['ISO8601DateTime']>;
  orderGroupId?: Maybe<Scalars['Int']>;
  pandaTankMonitorAttachedAssetId?: Maybe<Scalars['Int']>;
  pandaTankMonitorDeviceId?: Maybe<Scalars['Int']>;
  rorScore?: Maybe<Scalars['Float']>;
  tenantId: Scalars['Int'];
  totalDegreeDays?: Maybe<Scalars['Float']>;
  usedFallback?: Maybe<Scalars['Boolean']>;
};

export type DegreeDayCollection = {
  __typename?: 'DegreeDayCollection';
  collection: Array<DegreeDay>;
  metadata: DegreeDayMetaDataQuery;
};

export type DegreeDayFilterInput = {
  assetId?: InputMaybe<Scalars['ID']>;
  dateRange?: InputMaybe<DateRangeInput>;
  tenantId?: InputMaybe<Scalars['ID']>;
};

/** Meta data used to fetch next records and retrieve total records */
export type DegreeDayMetaDataQuery = {
  __typename?: 'DegreeDayMetaDataQuery';
  hasMore: Scalars['Boolean'];
  totalCount?: Maybe<Scalars['Int']>;
  total_entries?: Maybe<Scalars['Int']>;
};

export enum DegreeDayOrderSourceEnum {
  /** Degree day auto orders. */
  Auto = 'auto',
  /** Degree day manual orders. */
  Manual = 'manual'
}

export enum DegreeDayOrderStatusEnum {
  /** Degree day active orders. */
  Active = 'active',
  /** Degree day orders awaiting confirmation. */
  AwaitingConfirmation = 'awaiting_confirmation',
  /** Degree day scheduled orders. */
  Scheduled = 'scheduled',
  /** Degree day unscheduled orders. */
  Unscheduled = 'unscheduled'
}

export type DegreeDaySetting = {
  __typename?: 'DegreeDaySetting';
  adjustmentQuantity?: Maybe<Scalars['Float']>;
  adjustmentUnit?: Maybe<Scalars['String']>;
  asset?: Maybe<UnifiedTank>;
  assetId: Scalars['Int'];
  autoOrdering?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['ISO8601DateTime'];
  daysToEmptyThreshold?: Maybe<Scalars['Int']>;
  degreeDayReset?: Maybe<Scalars['JSON']>;
  disabledAt?: Maybe<Scalars['ISO8601DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  gracePeriod?: Maybe<Scalars['Int']>;
  gracePeriodType?: Maybe<Scalars['String']>;
  hubIds?: Maybe<Array<Scalars['Int']>>;
  id: Scalars['ID'];
  kFactor?: Maybe<Scalars['Float']>;
  orderConfirmation?: Maybe<Scalars['Boolean']>;
  orderNumber?: Maybe<Scalars['String']>;
  orderStatus?: Maybe<Scalars['String']>;
  orderType?: Maybe<Scalars['String']>;
  preferenceAvailability?: Maybe<Array<DdPreferenceAvailability>>;
  purchaseOrderRequired?: Maybe<Scalars['Boolean']>;
  safeLimit?: Maybe<Scalars['Float']>;
  tankCapacity?: Maybe<Scalars['Float']>;
  tankType?: Maybe<Scalars['String']>;
  tenantId: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type DegreeDaySettingCollection = {
  __typename?: 'DegreeDaySettingCollection';
  collection: Array<DegreeDaySetting>;
  metadata: DegreeDayMetaDataQuery;
};

export type DegreeDaySettingFilterInput = {
  assetId?: InputMaybe<Scalars['ID']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['ID']>;
  tenantId?: InputMaybe<Scalars['ID']>;
};

export type DegreeDaySettingInput = {
  adjustmentQuantity?: InputMaybe<Scalars['Float']>;
  adjustmentUnit?: InputMaybe<Scalars['String']>;
  assetId: Scalars['Int'];
  autoOrdering?: InputMaybe<Scalars['Boolean']>;
  daysToEmptyThreshold?: InputMaybe<Scalars['Int']>;
  degreeDayReset?: InputMaybe<Scalars['JSON']>;
  disabledAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  gracePeriod?: InputMaybe<Scalars['Int']>;
  gracePeriodType?: InputMaybe<Scalars['String']>;
  hubIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['ID']>;
  kFactor?: InputMaybe<Scalars['Float']>;
  orderConfirmation?: InputMaybe<Scalars['Boolean']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  orderStatus?: InputMaybe<Scalars['String']>;
  preferenceAvailability?: InputMaybe<Array<DdPreferenceAvailabilityInput>>;
  purchaseOrderRequired?: InputMaybe<Scalars['Boolean']>;
  safeLimit?: InputMaybe<Scalars['Float']>;
  tankCapacity?: InputMaybe<Scalars['Float']>;
  tankType?: InputMaybe<Scalars['String']>;
};

export type DegreeDaySettingSorter = {
  field: Scalars['String'];
  order?: InputMaybe<Scalars['String']>;
};

export type DegreeDaySorter = {
  field: Scalars['String'];
  order?: InputMaybe<Scalars['String']>;
};

/** Delay Input */
export type DelayInput = {
  delayNote: Scalars['String'];
};

/** Autogenerated input type of DeleteAssets */
export type DeleteAssetsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteAssets */
export type DeleteAssetsPayload = {
  __typename?: 'DeleteAssetsPayload';
  asset?: Maybe<Asset>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of DeleteBolPricing */
export type DeleteBolPricingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteBolPricing */
export type DeleteBolPricingPayload = {
  __typename?: 'DeleteBolPricingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  response?: Maybe<DeleteResponse>;
};

/** Autogenerated input type of DeleteBrands */
export type DeleteBrandsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteBrands */
export type DeleteBrandsPayload = {
  __typename?: 'DeleteBrandsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  response?: Maybe<DeleteResponse>;
};

/** Autogenerated input type of DeleteCustomerBranches */
export type DeleteCustomerBranchesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteCustomerBranches */
export type DeleteCustomerBranchesPayload = {
  __typename?: 'DeleteCustomerBranchesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  response?: Maybe<DeleteResponse>;
};

/** Autogenerated return type of DeleteDegreeDaySetting */
export type DeleteDegreeDaySettingPayload = {
  __typename?: 'DeleteDegreeDaySettingPayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of DeleteDeliveryOrder */
export type DeleteDeliveryOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteDeliveryOrder */
export type DeleteDeliveryOrderPayload = {
  __typename?: 'DeleteDeliveryOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
};

/** Autogenerated input type of DeleteFees */
export type DeleteFeesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteFees */
export type DeleteFeesPayload = {
  __typename?: 'DeleteFeesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  response?: Maybe<DeleteResponse>;
};

/** Autogenerated input type of Delete */
export type DeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteLeaCore */
export type DeleteLeaCoreInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteLeaCore */
export type DeleteLeaCorePayload = {
  __typename?: 'DeleteLeaCorePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  leaType?: Maybe<Lea>;
};

/** Autogenerated input type of DeleteLineOfServices */
export type DeleteLineOfServicesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteLineOfServices */
export type DeleteLineOfServicesPayload = {
  __typename?: 'DeleteLineOfServicesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  response?: Maybe<DeleteResponse>;
};

/** Autogenerated input type of DeleteLoadingOrder */
export type DeleteLoadingOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteLoadingOrder */
export type DeleteLoadingOrderPayload = {
  __typename?: 'DeleteLoadingOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
};

/** Autogenerated input type of DeleteMovementOrder */
export type DeleteMovementOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteMovementOrder */
export type DeleteMovementOrderPayload = {
  __typename?: 'DeleteMovementOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
};

/** Autogenerated input type of DeleteOrderLink */
export type DeleteOrderLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<DeleteOrderLinksInput>;
  id?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of DeleteOrderLink */
export type DeleteOrderLinkPayload = {
  __typename?: 'DeleteOrderLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderLink?: Maybe<OrderLink>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Delete order link Input */
export type DeleteOrderLinksInput = {
  deliveryOrderId?: InputMaybe<Scalars['ID']>;
  extractionOrderId?: InputMaybe<Scalars['ID']>;
  loadingOrderId?: InputMaybe<Scalars['ID']>;
  transferOrderId?: InputMaybe<Scalars['ID']>;
};

/** Enum for delete panda price resource */
export enum DeletePandaPriceResourceEnum {
  /** Panda Price Rate Type */
  RateType = 'rate_type'
}

/** Autogenerated input type of DeletePandaPriceResource */
export type DeletePandaPriceResourceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
  resource: DeletePandaPriceResourceEnum;
};

/** Autogenerated return type of DeletePandaPriceResource */
export type DeletePandaPriceResourcePayload = {
  __typename?: 'DeletePandaPriceResourcePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['JSON']>;
};

/** Autogenerated return type of Delete */
export type DeletePayload = {
  __typename?: 'DeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  routeFlushing?: Maybe<Flushing>;
};

/** Autogenerated input type of DeletePeripheral */
export type DeletePeripheralInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeletePeripheral */
export type DeletePeripheralPayload = {
  __typename?: 'DeletePeripheralPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  peripheral?: Maybe<Peripheral>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of DeletePickupPointCodes */
export type DeletePickupPointCodesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeletePickupPointCodes */
export type DeletePickupPointCodesPayload = {
  __typename?: 'DeletePickupPointCodesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  response?: Maybe<DeleteResponse>;
};

export type DeletePricingResponse = {
  __typename?: 'DeletePricingResponse';
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  success: Scalars['Boolean'];
};

/** Autogenerated input type of DeleteRackMarket */
export type DeleteRackMarketInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteRackMarket */
export type DeleteRackMarketPayload = {
  __typename?: 'DeleteRackMarketPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  response?: Maybe<DeleteResponse>;
};

/** Autogenerated input type of DeleteRawShift */
export type DeleteRawShiftInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteRawShift */
export type DeleteRawShiftPayload = {
  __typename?: 'DeleteRawShiftPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  rawShift?: Maybe<RawShift>;
};

/** Autogenerated input type of DeleteRecurrence */
export type DeleteRecurrenceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
};

/** Autogenerated return type of DeleteRecurrence */
export type DeleteRecurrencePayload = {
  __typename?: 'DeleteRecurrencePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Enum for resource */
export enum DeleteResourceEnum {
  /** Address Book */
  AddressBook = 'address_book',
  /** Adjusted Inventory */
  AdjustedInventory = 'adjusted_inventory',
  /** Bol Retain */
  BolRetain = 'bol_retain',
  /** Common Carrier Tenant */
  CcTenant = 'cc_tenant',
  /** Customer Segment */
  CustomerSegment = 'customer_segment',
  /** Driver Demurrage */
  DriverDemurrage = 'driver_demurrage',
  /** Driver Rate */
  DriverRate = 'driver_rate',
  /** Fee */
  Fee = 'fee',
  /** Inventory Adjustment */
  InventoryAdjustment = 'inventory_adjustment',
  /** Market */
  Market = 'market',
  /** Movement Order */
  MovementOrder = 'movement_order',
  /** Order Group */
  OrderGroup = 'order_group',
  /** Panda Document */
  PandaDocument = 'panda_document',
  /** Panda Document BOL Image Common Carrier */
  PandaDocumentBolImageCc = 'panda_document_bol_image_cc',
  /** Payment Term */
  PaymentTerm = 'payment_term',
  /** Preferred Supplier */
  PreferredSupplier = 'preferred_supplier',
  /** Raw Shift */
  RawShift = 'raw_shift',
  /** Saved View */
  SavedView = 'saved_view'
}

/** Autogenerated input type of DeleteResource */
export type DeleteResourceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
  resource: DeleteResourceEnum;
};

/** Autogenerated return type of DeleteResource */
export type DeleteResourcePayload = {
  __typename?: 'DeleteResourcePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['JSON']>;
};

export type DeleteResponse = {
  __typename?: 'DeleteResponse';
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  success: Scalars['Boolean'];
};

/** Autogenerated input type of DeleteShiftPlan */
export type DeleteShiftPlanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteShiftPlan */
export type DeleteShiftPlanPayload = {
  __typename?: 'DeleteShiftPlanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  shiftPlan?: Maybe<ShiftPlan>;
};

/** Autogenerated input type of DeleteSiteRecurrence */
export type DeleteSiteRecurrenceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
};

/** Autogenerated return type of DeleteSiteRecurrence */
export type DeleteSiteRecurrencePayload = {
  __typename?: 'DeleteSiteRecurrencePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of DeleteSuppliers */
export type DeleteSuppliersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteSuppliers */
export type DeleteSuppliersPayload = {
  __typename?: 'DeleteSuppliersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  supplier?: Maybe<Supplier>;
};

/** Autogenerated input type of DeleteTerminals */
export type DeleteTerminalsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteTerminals */
export type DeleteTerminalsPayload = {
  __typename?: 'DeleteTerminalsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  terminal?: Maybe<Terminal>;
};

/** Autogenerated input type of DeleteTransferOrder */
export type DeleteTransferOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteTransferOrder */
export type DeleteTransferOrderPayload = {
  __typename?: 'DeleteTransferOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
};

/** Autogenerated input type of DeleteZoneProductBatches */
export type DeleteZoneProductBatchesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** IDs of ZoneProductBatches to delete */
  ids: Array<Scalars['ID']>;
};

/** Autogenerated return type of DeleteZoneProductBatches */
export type DeleteZoneProductBatchesPayload = {
  __typename?: 'DeleteZoneProductBatchesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  zoneProductBatches?: Maybe<Array<ZoneProductBatch>>;
};

export type DeliveryAsset = {
  __typename?: 'DeliveryAsset';
  /** @deprecated Not available anymore */
  activeInspectionForm?: Maybe<Array<DvirBeCompatibilitySupport>>;
  activeShift?: Maybe<Shift>;
  assetProductCategories?: Maybe<Array<AssetProductCategory>>;
  assignedPandaBox?: Maybe<PandaBox>;
  category?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  compartments?: Maybe<Array<Compartment>>;
  currentShiftTotalizers?: Maybe<Array<Totalizer>>;
  enableZone?: Maybe<Scalars['Boolean']>;
  erpId?: Maybe<Scalars['String']>;
  /** Link with Hub */
  hubResources?: Maybe<Array<HubResource>>;
  /** Associated hubs */
  hubs?: Maybe<Array<Hub>>;
  id: Scalars['ID'];
  licensePlateNumber?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  noOfZone?: Maybe<Scalars['Int']>;
  previousShift?: Maybe<Shift>;
  previousShiftTotalizers?: Maybe<Array<Totalizer>>;
  qrCodeText?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
  zoneProductBatches?: Maybe<Array<ZoneProductBatch>>;
};


export type DeliveryAssetCompartmentsArgs = {
  deletedAfter?: InputMaybe<Scalars['Int']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type DeliveryAssetCollection = {
  __typename?: 'DeliveryAssetCollection';
  collection: Array<DeliveryAsset>;
  metadata: MetaQuery;
};

export type DeliveryAssetFilter = {
  all?: InputMaybe<Scalars['String']>;
  hubIds?: InputMaybe<Array<Scalars['ID']>>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  or?: InputMaybe<Array<DeliveryAssetFilter>>;
};

export type DeliveryOrder = {
  __typename?: 'DeliveryOrder';
  backofficeId?: Maybe<Scalars['String']>;
  backofficeStatus?: Maybe<Scalars['String']>;
  customerBranch?: Maybe<CustomerBranch>;
  data?: Maybe<Scalars['JSON']>;
  deliveryDate?: Maybe<Scalars['ISO8601Date']>;
  deliveryDateTimestamp?: Maybe<Scalars['Int']>;
  deliveryInstruction?: Maybe<Scalars['String']>;
  deliveryOrderLineItems: Array<DeliveryOrderLineItem>;
  discrepancyValue?: Maybe<Scalars['Float']>;
  divergenceOrder: Scalars['Boolean'];
  diversionNumbers?: Maybe<Array<Scalars['String']>>;
  driverSignature?: Maybe<PandaDocument>;
  expectedDeliveryTimeTimestamp?: Maybe<Scalars['Int']>;
  externalBoId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  invoiceNumber?: Maybe<Scalars['String']>;
  /** @deprecated Use `panda_document_invoices` field instead */
  invoices?: Maybe<Array<PandaDocument>>;
  lineItemSummary?: Maybe<Array<LineItem>>;
  lineItems: Array<DeliveryOrderLineItem>;
  /** @deprecated Overridden by orderLinks. */
  linkedOrders?: Maybe<Array<LoadingOrder>>;
  notes?: Maybe<Array<Note>>;
  orderGroup?: Maybe<OrderGroup>;
  orderGroupId?: Maybe<Scalars['Int']>;
  orderLinks?: Maybe<Array<OrderLink>>;
  orderNumber?: Maybe<Scalars['String']>;
  orderedProductsSummary?: Maybe<Array<DeliveryOrderOrderedProductsSummary>>;
  pandaBoxNotes?: Maybe<Array<Note>>;
  pandaBoxTransactions?: Maybe<Array<PandaBoxTransaction>>;
  pandaDocumentInvoices?: Maybe<Array<PandaDocument>>;
  postDeliveryNote?: Maybe<Note>;
  /** @deprecated We have mutiple post delivery photos. Use postDeliveryPhotos */
  postDeliveryPhoto?: Maybe<PandaDocument>;
  postDeliveryPhotos?: Maybe<Array<PandaDocument>>;
  printedName?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Product>>;
  pushToFdn?: Maybe<Scalars['Boolean']>;
  quickbookQueueStatus?: Maybe<Scalars['String']>;
  quickbridgeStatus?: Maybe<Scalars['String']>;
  recentLoadingReceipts?: Maybe<Array<LoadingReceipt>>;
  signature?: Maybe<PandaDocument>;
  source?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  /** @deprecated Dont use this. This uses too much resuorces. */
  task?: Maybe<Task>;
  /** @deprecated Dont use this. This uses too much resuorces. */
  tasks?: Maybe<Array<Task>>;
  tenantName?: Maybe<Scalars['String']>;
  ticketId: Scalars['Int'];
  ticketMailedAtTimestamp?: Maybe<Scalars['Int']>;
  totalRequestedVolume?: Maybe<Scalars['JSON']>;
  totalizers?: Maybe<Array<Totalizer>>;
  type?: Maybe<Scalars['String']>;
};

/** DeliveryOrder Input */
export type DeliveryOrderInput = {
  /** Deprecated. DO NOT USE. */
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** Deprecated. DO NOT USE. */
  attachmentsAttributes?: InputMaybe<Array<AttachmentInput>>;
  /** Customer Branch/Site ID. */
  customerBranchId?: InputMaybe<Scalars['ID']>;
  /** Descriptive delivery instructions. */
  deliveryInstruction?: InputMaybe<Scalars['String']>;
  /** DeliveryOrderLineItemInput object. */
  deliveryOrderLineItemsAttributes?: InputMaybe<Array<DeliveryOrderLineItemInput>>;
  /** Discrepency Value. */
  discrepancyValue?: InputMaybe<Scalars['Float']>;
  diversionNumbers?: InputMaybe<Array<Scalars['String']>>;
  /** PandaDocumentInput object. */
  driverSignatureAttributes?: InputMaybe<PandaDocumentInput>;
  /** DeliveryOrder ID. */
  id?: InputMaybe<Scalars['ID']>;
  /** Invoice Number. */
  invoiceNumber?: InputMaybe<Scalars['String']>;
  invoices?: InputMaybe<Array<DirectAttachmentInput>>;
  /** AssetsInputs */
  newAssetsAttributes?: InputMaybe<Array<AssetInput>>;
  /** Delivery Note Input. */
  notesAttributes?: InputMaybe<Array<NoteInput>>;
  orderEndLocation?: InputMaybe<GenericLocationInput>;
  /** OrderGroupInput object. */
  orderGroup?: InputMaybe<OrderGroupInput>;
  /** Customer's purchase order number. */
  orderNumber?: InputMaybe<Scalars['String']>;
  orderStartLocation?: InputMaybe<GenericLocationInput>;
  pandaDocuments?: InputMaybe<Array<DirectAttachmentInput>>;
  /** PandaDocumentInput object. */
  postDeliveryPhotosAttributes?: InputMaybe<Array<PandaDocumentInput>>;
  printedName?: InputMaybe<Scalars['String']>;
  /** PandaDocumentInput object. */
  signatureAttributes?: InputMaybe<PandaDocumentInput>;
  /** Source of the DeliveryOrder */
  source?: InputMaybe<Scalars['String']>;
  totalizers?: InputMaybe<Array<TotalizerInput>>;
  type?: InputMaybe<DeliveryOrderTypeEnum>;
};

export type DeliveryOrderLineItem = {
  __typename?: 'DeliveryOrderLineItem';
  asset?: Maybe<Asset>;
  backofficeId?: Maybe<Scalars['String']>;
  backofficeStatus?: Maybe<Scalars['String']>;
  canSyncRequestedLoadingVolume: Scalars['Boolean'];
  comparableProduct?: Maybe<Product>;
  data?: Maybe<Scalars['JSON']>;
  deliveryDateTimestamp?: Maybe<Scalars['Int']>;
  deliveryOrder?: Maybe<DeliveryOrder>;
  id: Scalars['ID'];
  isExtraction?: Maybe<Scalars['Boolean']>;
  lat?: Maybe<Scalars['String']>;
  lng?: Maybe<Scalars['String']>;
  meterName?: Maybe<Scalars['String']>;
  mobileGeneratedId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  productResource?: Maybe<Product>;
  requestedVolume?: Maybe<Scalars['Float']>;
  skipReason?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  sourceAssets?: Maybe<Array<SourceAsset>>;
  sourceCompartmentInstances?: Maybe<Array<CompartmentInstance>>;
  sourceCompartments?: Maybe<Array<SourceCompartment>>;
  status: Scalars['String'];
  subscription?: Maybe<Subscription>;
  targetCompartmentInstance?: Maybe<CompartmentInstance>;
  testResult?: Maybe<Scalars['String']>;
  topOff?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  volume?: Maybe<Scalars['Float']>;
  warehouse?: Maybe<Terminal>;
  warehouseId?: Maybe<Scalars['ID']>;
  waterTestResult?: Maybe<WaterTestResultEnum>;
};

export type DeliveryOrderLineItemCollection = {
  __typename?: 'DeliveryOrderLineItemCollection';
  collection: Array<DeliveryOrderLineItem>;
  metadata: MetaQuery;
};

/** Generic date range filter with from date and to date */
export type DeliveryOrderLineItemDateRangeFilterInput = {
  fromDate?: InputMaybe<Scalars['ISO8601Date']>;
  toDate?: InputMaybe<Scalars['ISO8601Date']>;
};

/** Enum for delivery order line item delivery types */
export enum DeliveryOrderLineItemDeliveryTypeEnum {
  /** Delivery order type */
  Delivery = 'delivery',
  /** Extraction order type */
  Extraction = 'extraction'
}

/** DeliveryOrderLineItem Input */
export type DeliveryOrderLineItemInput = {
  /** Deprecated. DO NOT USE. */
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** Asset ID. */
  assetId?: InputMaybe<Scalars['ID']>;
  /** CompartmentInstanceInput object. */
  compartmentInstancesAttributes?: InputMaybe<Array<CompartmentInstanceInput>>;
  /** Customer Branch/Site ID. */
  customerBranchId?: InputMaybe<Scalars['ID']>;
  /** Miscellaneous JSON data. */
  data?: InputMaybe<Scalars['JSON']>;
  /** DeliveryOrderLineItem ID. */
  id?: InputMaybe<Scalars['ID']>;
  lat?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['String']>;
  /** Name of LCR meter */
  meterName?: InputMaybe<Scalars['String']>;
  mobileGeneratedId?: InputMaybe<Scalars['String']>;
  /** Add/Update Driver Notes. */
  notes?: InputMaybe<Scalars['String']>;
  /** PandaBoxes transactions. */
  pandaBoxTransactionsAttributes?: InputMaybe<Array<PandaBoxTransactionInput>>;
  /** Product ID. */
  productId?: InputMaybe<Scalars['ID']>;
  /** Product Resource ID. */
  productResourceId?: InputMaybe<Scalars['ID']>;
  /** Requested volume. */
  requestedVolume?: InputMaybe<Scalars['Float']>;
  /** Delivery skip reason. */
  skipReason?: InputMaybe<Scalars['String']>;
  /** Source of the DeliveryOrderLineItem. */
  source?: InputMaybe<Scalars['String']>;
  /** SourceCompartmentInput object. */
  sourceAssetsAttributes?: InputMaybe<Array<SourceAssetInput>>;
  /** SourceCompartmentInput object. */
  sourceCompartmentsAttributes?: InputMaybe<Array<SourceCompartmentInput>>;
  /** Status of the DeliveryOrderLineItem. */
  status?: InputMaybe<Scalars['String']>;
  /** Subscription ID. */
  subscriptionId?: InputMaybe<Scalars['ID']>;
  /** Fuel test result */
  testResult?: InputMaybe<ProductTestEnum>;
  /** Whether top off was requested */
  topOff?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<DeliveryOrderLineItemTypeEnum>;
  /** Flag parameter to specify whether to sync requested volume of loading order. */
  updateRequestedLoadingVolume?: InputMaybe<Scalars['Boolean']>;
  /** Id of warehouse from which packaged product is to be loaded. */
  warehouseId?: InputMaybe<Scalars['ID']>;
  /** Water test result */
  waterTestResult?: InputMaybe<WaterTestResultEnum>;
};

/** Enum for delivery order line item order types */
export enum DeliveryOrderLineItemOrderTypeEnum {
  /** Degree day automatic order type */
  Auto = 'auto',
  /** Degree day manual order type */
  Manual = 'manual'
}

/** Enum for delivery order line item Tank Monitor order types */
export enum DeliveryOrderLineItemTmOrderTypeEnum {
  /** Degree day automatic order type */
  TankMonitorAuto = 'tank_monitor_auto',
  /** Degree day manual order type */
  TankMonitorManual = 'tank_monitor_manual'
}

/** Enum to use for filter delivery order line item type */
export enum DeliveryOrderLineItemTypeEnum {
  /** Delivery order line item */
  DeliveryOrderLineItem = 'DeliveryOrderLineItem',
  /** Extraction order line item */
  ExtractionOrderLineItem = 'ExtractionOrderLineItem'
}

export type DeliveryOrderLineItemsSorter = {
  field: DeliveryOrderLineItemsSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum DeliveryOrderLineItemsSorterEnum {
  AssetName = 'asset_name',
  CreatedOn = 'created_on',
  CustomerName = 'customer_name',
  DeliveredAt = 'delivered_at',
  DeliveredQuantity = 'delivered_quantity',
  OrderId = 'order_id',
  OrderType = 'order_type',
  PlannedAt = 'planned_at',
  ProductName = 'product_name',
  ShipTo = 'ship_to'
}

export type DeliveryOrderOrderedProductsSummary = {
  __typename?: 'DeliveryOrderOrderedProductsSummary';
  comparableProductSummaries?: Maybe<Array<ComparableProductSummary>>;
  /** @deprecated use product_id instead */
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']>;
  skipWarehouse?: Maybe<Scalars['Boolean']>;
  totalDeliveredVolume: Scalars['Float'];
  totalRequestedVolume: Scalars['Float'];
  totalTopOffRequestCount: Scalars['Int'];
  /** @deprecated use total_requested_volume instead */
  value: Scalars['Float'];
  warehouseId?: Maybe<Scalars['ID']>;
};

/** Enum to use for filter delivery type */
export enum DeliveryOrderTypeEnum {
  /** Delivery order */
  DeliveryOrder = 'DeliveryOrder',
  /** Extraction order */
  ExtractionOrder = 'ExtractionOrder'
}

/** Delivery Ticket Email input */
export type DeliveryTicketEmailInput = {
  /** Attachment with name and url */
  attachments?: InputMaybe<Array<EmailAttachmentInput>>;
  /** BCC Receivers' Email */
  bcc?: InputMaybe<Array<Scalars['String']>>;
  /** Email's body */
  body?: InputMaybe<Scalars['String']>;
  /** CC Receivers' Email */
  cc?: InputMaybe<Array<Scalars['String']>>;
  /** DeliveryOrder Id */
  deliveryOrderId: Scalars['ID'];
  /** URL for Delivery Ticket */
  deliveryTicketUrl: Scalars['String'];
  /** Sender Email */
  from?: InputMaybe<Scalars['String']>;
  /** Email's Subject */
  subject?: InputMaybe<Scalars['String']>;
  /** Receivers' Email */
  to?: InputMaybe<Array<Scalars['String']>>;
};

export type DestinationAssociation = {
  __typename?: 'DestinationAssociation';
  deliveryOrder?: Maybe<DeliveryOrder>;
  id: Scalars['ID'];
  loadingOrder?: Maybe<LoadingOrder>;
  transferOrder?: Maybe<TransferOrder>;
};

/** Autogenerated input type of DetachAsset */
export type DetachAssetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DetachAsset */
export type DetachAssetPayload = {
  __typename?: 'DetachAssetPayload';
  attachedAsset?: Maybe<AttachedAsset>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

export type Device = {
  __typename?: 'Device';
  asset?: Maybe<Asset>;
  attachedAsset?: Maybe<Scalars['JSON']>;
  consumptionSummary?: Maybe<Scalars['JSON']>;
  customer?: Maybe<Customer>;
  customerBranch?: Maybe<CustomerBranch>;
  deviceId: Scalars['ID'];
  deviceProvider?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isStale?: Maybe<Scalars['Boolean']>;
  lastReadAt?: Maybe<Scalars['String']>;
  lastSyncedAt?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  reading?: Maybe<Scalars['JSON']>;
  tankCapacity?: Maybe<Scalars['String']>;
};

export type DeviceCollection = {
  __typename?: 'DeviceCollection';
  collection: Array<Device>;
  metadata: TankMonitorMetaDataQuery;
};

export type DeviceFilterInput = {
  /** Filter devices based on whether they are linked to assets */
  assetLinkState?: InputMaybe<AssetLinkStateEnum>;
  deviceFilter?: InputMaybe<DynamicFiltersInput>;
  /** Filter for active orders */
  filterAttributes?: InputMaybe<Array<DevicesFilterEnum>>;
  hub?: InputMaybe<Array<Scalars['ID']>>;
  isUnlinked?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  orderGroupType?: InputMaybe<TmOrderTypeEnum>;
  /** Filter for provider */
  provider?: InputMaybe<Array<ProvidersEnum>>;
};

/** Enum to use on sorter fields */
export enum DevicesFilterEnum {
  ActiveOrder = 'ActiveOrder',
  BelowThreshold = 'BelowThreshold',
  RequiresConfirmation = 'RequiresConfirmation'
}

/** Enum to use on sorter fields */
export enum DevicesSorterEnum {
  AvailableQuantity = 'AVAILABLE_QUANTITY',
  Capacity = 'CAPACITY',
  CreatedAt = 'CREATED_AT',
  DeliveryThreshold = 'DELIVERY_THRESHOLD',
  ExtractionThreshold = 'EXTRACTION_THRESHOLD',
  Inventory = 'INVENTORY',
  LastDeliveryDate = 'LAST_DELIVERY_DATE',
  LastOrderDate = 'LAST_ORDER_DATE',
  LastSyncedAt = 'LAST_SYNCED_AT',
  Name = 'NAME',
  NextDeliveryDate = 'NEXT_DELIVERY_DATE',
  OrderStatus = 'ORDER_STATUS',
  OrderType = 'ORDER_TYPE',
  ProductName = 'PRODUCT_NAME',
  ProviderName = 'PROVIDER_NAME',
  TankName = 'TANK_NAME'
}

/** Direct attachment Input */
export type DirectAttachmentInput = {
  /** True if record is to be deleted, ID must be passed. */
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** Unique ID of the document */
  attachementId?: InputMaybe<Scalars['ID']>;
  /** Specify if attachment is of special, like: signature, completion, delivery_ticket, attachments, tank_chart, invoices, driver_signature, shift_documents, customer_assets, lea_pre_signatures, lea_post_signatures, panda_boxes, panda_box_meters, power_source, meter_wiring, preshift_checklist_documents, raw_pricing_file, normalized_pricing_file, failed_pricing_file, temp_pricing_file, transfer_order_bol_image, notes, and transposition_data */
  documentType?: InputMaybe<Scalars['String']>;
  /** ID of resource to which this document is to be associated */
  documentableId?: InputMaybe<Scalars['ID']>;
  /** Resource Name[ex: DeliveryOrder, Shift, LoadingOrder] to which this document is to be associated */
  documentableType?: InputMaybe<Scalars['String']>;
  /** Panda Document ID to perform update */
  id?: InputMaybe<Scalars['ID']>;
  /** Type of LEA document */
  leaDocumentType?: InputMaybe<Scalars['String']>;
  /** Signed blob id from S3. Required unless _destroy is set true and can be pass empty string */
  signedBlobId: Scalars['String'];
};

/** Represents direct upload credentials */
export type DirectUpload = {
  __typename?: 'DirectUpload';
  /** Created blob record ID */
  blobId?: Maybe<Scalars['ID']>;
  /** HTTP request headers (JSON-encoded) */
  headers?: Maybe<Scalars['String']>;
  /** Created blob record signed ID */
  signedBlobId?: Maybe<Scalars['ID']>;
  /** Upload URL */
  url?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of DirectUploadPandaDocument */
export type DirectUploadPandaDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: DirectAttachmentInput;
};

/** Autogenerated return type of DirectUploadPandaDocument */
export type DirectUploadPandaDocumentPayload = {
  __typename?: 'DirectUploadPandaDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  pandaDocument?: Maybe<PandaDocument>;
};

/** Autogenerated input type of DisableTwoFactor */
export type DisableTwoFactorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  otpCode: Scalars['String'];
};

/** Autogenerated return type of DisableTwoFactor */
export type DisableTwoFactorPayload = {
  __typename?: 'DisableTwoFactorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type DocusealDocument = {
  __typename?: 'DocusealDocument';
  documentType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type DocusealSubmissionResponse = {
  __typename?: 'DocusealSubmissionResponse';
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  auditLogUrl?: Maybe<Scalars['String']>;
  combinedDocumentUrl?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdByUser?: Maybe<DocusealUser>;
  documentType?: Maybe<LeaPreviewDocumentEnum>;
  documents?: Maybe<Array<DocusealDocument>>;
  error?: Maybe<Scalars['String']>;
  expireAt?: Maybe<Scalars['ISO8601DateTime']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  submissionEvents?: Maybe<Array<Scalars['JSON']>>;
  submitters?: Maybe<Array<DocusealSubmitter>>;
  submittersData?: Maybe<Array<Scalars['JSON']>>;
  submittersOrder?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  template?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type DocusealSubmitter = {
  __typename?: 'DocusealSubmitter';
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  declinedAt?: Maybe<Scalars['ISO8601DateTime']>;
  documents?: Maybe<Array<Scalars['JSON']>>;
  email?: Maybe<Scalars['String']>;
  embedSrc?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  metadata?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['ISO8601DateTime']>;
  phone?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['ISO8601DateTime']>;
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  submissionId?: Maybe<Scalars['ID']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  uuid?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Scalars['JSON']>>;
};

export type DocusealUser = {
  __typename?: 'DocusealUser';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lastName?: Maybe<Scalars['String']>;
};

export type DoliCsv = {
  __typename?: 'DoliCsv';
  content?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
};

export type DoliHistoryFilterInput = {
  all?: InputMaybe<Scalars['String']>;
  assetId?: InputMaybe<Scalars['ID']>;
  createdOn?: InputMaybe<DeliveryOrderLineItemDateRangeFilterInput>;
  customerBranchId?: InputMaybe<Scalars['ID']>;
  customerBranchIds?: InputMaybe<Array<Scalars['ID']>>;
  customerIds?: InputMaybe<Array<Scalars['ID']>>;
  deliveredOn?: InputMaybe<DeliveryOrderLineItemDateRangeFilterInput>;
  deliveredQuantity?: InputMaybe<QuantityRangeFilterInput>;
  deliveryType?: InputMaybe<DeliveryOrderLineItemDeliveryTypeEnum>;
  isTankMonitor?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<DoliHistoryFilterInput>>;
  orderGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  orderType?: InputMaybe<DeliveryOrderLineItemOrderTypeEnum>;
  plannedOn?: InputMaybe<DeliveryOrderLineItemDateRangeFilterInput>;
  status?: InputMaybe<Array<StatusTypeEnum>>;
  tmOrderType?: InputMaybe<DeliveryOrderLineItemTmOrderTypeEnum>;
};

export type Driver = {
  __typename?: 'Driver';
  activeShift?: Maybe<Shift>;
  appData?: Maybe<AppData>;
  appStatus?: Maybe<Scalars['Int']>;
  avatarUrl?: Maybe<Scalars['String']>;
  contractSignDate?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  erpId?: Maybe<Scalars['String']>;
  group?: Maybe<Group>;
  hasCompanyPhone?: Maybe<Scalars['Boolean']>;
  homeAddress?: Maybe<Scalars['String']>;
  hourlyRate?: Maybe<Scalars['Float']>;
  hubResources?: Maybe<Array<HubResource>>;
  hubs?: Maybe<Array<Hub>>;
  id: Scalars['ID'];
  image?: Maybe<AttachedFile>;
  irelyId?: Maybe<Scalars['String']>;
  /** @deprecated Use type */
  isCarrier?: Maybe<Scalars['Boolean']>;
  isNonFuel?: Maybe<Scalars['Boolean']>;
  lastShift?: Maybe<Shift>;
  lastSyncedAtTimestamp?: Maybe<Scalars['Int']>;
  lastSyncedTime?: Maybe<Scalars['String']>;
  licenceExpiryDate?: Maybe<Scalars['String']>;
  lineOfServices?: Maybe<Array<LineOfService>>;
  name?: Maybe<Scalars['String']>;
  otp?: Maybe<Scalars['String']>;
  paymentStrategy?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<DriverPhoneNumber>>;
  reasonForLeaving?: Maybe<Scalars['String']>;
  resourceSchedule?: Maybe<ResourceSchedule>;
  s3BackgroundCheck?: Maybe<AttachedFile>;
  s3DriverApplication?: Maybe<AttachedFile>;
  s3H6?: Maybe<AttachedFile>;
  s3Licenses?: Maybe<Array<AttachedFile>>;
  shifts?: Maybe<Array<Shift>>;
  startDate?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  /** @deprecated Dont use this. This uses too much resources */
  tasks?: Maybe<Array<Task>>;
  type?: Maybe<Scalars['String']>;
  unreadNotificationCount?: Maybe<Scalars['Int']>;
  weeklySchedules?: Maybe<Array<WeeklySchedule>>;
};

export type DriverCollection = {
  __typename?: 'DriverCollection';
  collection: Array<Driver>;
  metadata: MetaQuery;
};

export type DriverDemurrage = {
  __typename?: 'DriverDemurrage';
  customer?: Maybe<Customer>;
  id?: Maybe<Scalars['ID']>;
  offsetAmount?: Maybe<Scalars['Float']>;
  offsetRate?: Maybe<Scalars['Float']>;
  offsetType?: Maybe<Scalars['String']>;
  rangeAttribute?: Maybe<Array<RangeAttribute>>;
};

export type DriverDemurrageCollection = {
  __typename?: 'DriverDemurrageCollection';
  collection: Array<DriverDemurrage>;
  metadata: MetaQuery;
};

export type DriverDemurrageInput = {
  customerId: Scalars['ID'];
  offsetAmount: Scalars['Float'];
  offsetRate: Scalars['Float'];
  offsetType: OffsetTypeEnum;
  rangeAttribute?: InputMaybe<Array<RangeAttributeInput>>;
};

export type DriverDemurragesFilter = {
  customerIds?: InputMaybe<Array<Scalars['ID']>>;
  customerName?: InputMaybe<Scalars['String']>;
};

export type DriverFilter = {
  all?: InputMaybe<Scalars['String']>;
  driverTypes?: InputMaybe<Array<DriverTypeEnum>>;
  email?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  hasGroup?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<DriverFilter>>;
};

export type DriverFiltersInput = {
  driverTypes?: InputMaybe<Array<DriverTypeEnum>>;
};

export type DriverPhoneNumber = {
  __typename?: 'DriverPhoneNumber';
  device?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  ownerType?: Maybe<Scalars['String']>;
  primary?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type DriverRate = {
  __typename?: 'DriverRate';
  customerBranch?: Maybe<CustomerBranch>;
  id: Scalars['ID'];
  rate?: Maybe<Scalars['Float']>;
  terminal?: Maybe<Terminal>;
};

export type DriverRateCollection = {
  __typename?: 'DriverRateCollection';
  collection: Array<DriverRate>;
  metadata: MetaQuery;
};

/** Create Driver Rate */
export type DriverRateInput = {
  customerBranchId?: InputMaybe<Scalars['ID']>;
  rate?: InputMaybe<Scalars['Float']>;
  terminalId?: InputMaybe<Scalars['ID']>;
};

export type DriverRatesFilter = {
  all?: InputMaybe<Scalars['String']>;
  customerBranchIds?: InputMaybe<Array<Scalars['ID']>>;
  terminalIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type DriverSorter = {
  field: DriverSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum DriverSorterEnum {
  Address = 'ADDRESS',
  Email = 'EMAIL',
  Erpid = 'ERPID',
  Name = 'NAME',
  Phone = 'PHONE',
  Status = 'STATUS'
}

export enum DriverStatusEnum {
  /** Confirmation Pending */
  ConfirmationPending = 'confirmation_pending',
  /** Inactive */
  Inactive = 'inactive',
  /** Verified */
  Verified = 'verified'
}

/** Enum for asset types */
export enum DriverTypeEnum {
  /** For common carrier driver */
  CommonCarrierDriver = 'CommonCarrierDriver',
  /** For normal driver */
  NormalDriver = 'NormalDriver'
}

/** Autogenerated input type of DuplicateLeaCore */
export type DuplicateLeaCoreInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the LeaCore to duplicate */
  id: Scalars['ID'];
};

/** Autogenerated return type of DuplicateLeaCore */
export type DuplicateLeaCorePayload = {
  __typename?: 'DuplicateLeaCorePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  leaType?: Maybe<Lea>;
};

/** Autogenerated input type of DuplicateOrderGroup */
export type DuplicateOrderGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderGroupId: Scalars['ID'];
};

/** Autogenerated return type of DuplicateOrderGroup */
export type DuplicateOrderGroupPayload = {
  __typename?: 'DuplicateOrderGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  fromOrderGroup?: Maybe<OrderGroup>;
  newOrderGroup?: Maybe<OrderGroup>;
};

export type DvirBeCompatibilitySupport = {
  __typename?: 'DvirBeCompatibilitySupport';
  asset?: Maybe<Asset>;
  id?: Maybe<Scalars['ID']>;
};

/** Input object for dynamic filters */
export type DynamicFiltersInput = {
  /** Search term for different fields associated to tank monitor */
  all?: InputMaybe<Scalars['String']>;
  availableQuantity?: InputMaybe<TmGenericRangeFilter>;
  /** Maximum capacity value to filter by */
  capacityEndValue?: InputMaybe<Scalars['Float']>;
  /** Minimum capacity value to filter by */
  capacityStartValue?: InputMaybe<Scalars['Float']>;
  /** Maximum consumption value to filter by */
  consumptionEndValue?: InputMaybe<Scalars['Int']>;
  /** Minimum consumption value to filter by */
  consumptionStartValue?: InputMaybe<Scalars['Int']>;
  /** List of customer branch IDs to filter by */
  customerBranchIds?: InputMaybe<Array<Scalars['ID']>>;
  /** List of customer IDs to filter by */
  customerIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Number of days to consider for empty tanks */
  daysToEmptyEndValue?: InputMaybe<Scalars['Int']>;
  /** Number of days to consider for empty tanks */
  daysToEmptyStartValue?: InputMaybe<Scalars['Int']>;
  deviceIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Maximum threshold for tank levels */
  endingThreshold?: InputMaybe<Scalars['Float']>;
  /** List of hub IDs to filter by */
  hubIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter tanks above max threshold */
  isAboveThreshold?: InputMaybe<Scalars['Boolean']>;
  /** Filter tanks below min threshold */
  isBelowThreshold?: InputMaybe<Scalars['Boolean']>;
  /** End timestamp for the last delivery */
  lastDeliveryEndTimestamp?: InputMaybe<Scalars['Int']>;
  /** Start timestamp for the last delivery */
  lastDeliveryStartTimestamp?: InputMaybe<Scalars['Int']>;
  lastSync?: InputMaybe<TmDateTimeRangeFilter>;
  /** List of line of service IDs to filter by */
  lineOfServiceIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Type of order group to filter by */
  orderGroupType?: InputMaybe<TmOrderTypeEnum>;
  /** List of order statuses to filter by */
  orderStatuses?: InputMaybe<Array<TankMonitorOrderEnum>>;
  /** Type of order (e.g., Delivery, Extraction) */
  orderType?: InputMaybe<Array<TmOrderTypeEnum>>;
  /** List of product IDs to filter by */
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  /** List of providers to filter by */
  providers?: InputMaybe<Array<ProvidersEnum>>;
  /** Minimum threshold for tank levels */
  startingThreshold?: InputMaybe<Scalars['Float']>;
  /** Zip codes to filter by */
  zipcodes?: InputMaybe<Array<Scalars['String']>>;
};

/** Email Attachment Input */
export type EmailAttachmentInput = {
  /** Name of attachment */
  name: Scalars['String'];
  /** URL for attachment */
  url: Scalars['String'];
};

/** Autogenerated input type of EmailDeliveryTicket */
export type EmailDeliveryTicketInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: DeliveryTicketEmailInput;
};

/** Autogenerated return type of EmailDeliveryTicket */
export type EmailDeliveryTicketPayload = {
  __typename?: 'EmailDeliveryTicketPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deliveryOrder?: Maybe<DeliveryOrder>;
};

/** Autogenerated input type of EmailResourcePricing */
export type EmailResourcePricingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: EmailResourcePricingsInput;
};

/** Autogenerated return type of EmailResourcePricing */
export type EmailResourcePricingPayload = {
  __typename?: 'EmailResourcePricingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  resourcePricing?: Maybe<ResourcePricing>;
};

/** Email Resource Pricings Input */
export type EmailResourcePricingsInput = {
  endDateTimestamp: Scalars['Int'];
  id: Scalars['ID'];
  priceConfigurationIds?: InputMaybe<Array<Scalars['Int']>>;
  startDateTimestamp: Scalars['Int'];
};

/** Autogenerated input type of EnableTwoFactor */
export type EnableTwoFactorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of EnableTwoFactor */
export type EnableTwoFactorPayload = {
  __typename?: 'EnableTwoFactorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  qrCodeUrl: Scalars['String'];
  success: Scalars['Boolean'];
};

export type EnabledFeature = {
  __typename?: 'EnabledFeature';
  featureId: Scalars['ID'];
  id: Scalars['ID'];
};

/** Enabled Features Input */
export type EnabledFeatureInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  featureId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of EndShift */
export type EndShiftInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: ShiftEndInput;
};

/** Autogenerated return type of EndShift */
export type EndShiftPayload = {
  __typename?: 'EndShiftPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  shift?: Maybe<Shift>;
};

/** Enum for exempt */
export enum ExemptStatusTypeEnum {
  /** Non Exempt */
  NonExempt = 'non_exempt',
  /** Oh */
  Oh = 'oh',
  /** Pa */
  Pa = 'pa',
  /** Wv */
  Wv = 'wv'
}

export type ExportDocument = {
  __typename?: 'ExportDocument';
  documentType?: Maybe<Scalars['String']>;
  documentableId?: Maybe<Scalars['ID']>;
  fileData?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Only use when need url is needed for long time */
  permanentFileUrl?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  /** ["pending", "generating", "completed", "error"] */
  status?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of ExportOrdersCsv */
export type ExportOrdersCsvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<OrderGroupFilter>;
  sorter?: InputMaybe<Array<OrderGroupSorter>>;
};

/** Autogenerated return type of ExportOrdersCsv */
export type ExportOrdersCsvPayload = {
  __typename?: 'ExportOrdersCsvPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

/** Autogenerated input type of ExportOrders */
export type ExportOrdersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  exportableFormat?: InputMaybe<Scalars['String']>;
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of ExportOrders */
export type ExportOrdersPayload = {
  __typename?: 'ExportOrdersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  exportDocument?: Maybe<ExportDocument>;
  message: Scalars['String'];
};

/** Autogenerated input type of ExportSuppliersCsv */
export type ExportSuppliersCsvInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  lineOfServiceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  rackMarketIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  supplierIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  supplierTypes?: InputMaybe<Array<InputMaybe<SupplierTypeEnum>>>;
  terminalIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

/** Autogenerated return type of ExportSuppliersCsv */
export type ExportSuppliersCsvPayload = {
  __typename?: 'ExportSuppliersCsvPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  csv?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

/** Autogenerated input type of ExportTransaction */
export type ExportTransactionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerId: Scalars['ID'];
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of ExportTransaction */
export type ExportTransactionPayload = {
  __typename?: 'ExportTransactionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  exportDocument?: Maybe<ExportDocument>;
};

export type ExtractionOrder = {
  __typename?: 'ExtractionOrder';
  customerBranch?: Maybe<CustomerBranch>;
  data?: Maybe<Scalars['JSON']>;
  deliveryDate?: Maybe<Scalars['ISO8601Date']>;
  deliveryDateTimestamp?: Maybe<Scalars['Int']>;
  deliveryInstruction?: Maybe<Scalars['String']>;
  expectedDeliveryTimeTimestamp?: Maybe<Scalars['Int']>;
  extractionOrderLineItems: Array<ExtractionOrderLineItem>;
  id: Scalars['ID'];
  lineItemSummary?: Maybe<Array<LineItem>>;
  lineItems: Array<ExtractionOrderLineItem>;
  linkedOrders?: Maybe<Array<LoadingOrder>>;
  notes?: Maybe<Array<Note>>;
  orderGroup?: Maybe<OrderGroup>;
  orderGroupId?: Maybe<Scalars['Int']>;
  orderLinks?: Maybe<Array<OrderLink>>;
  orderNumber?: Maybe<Scalars['String']>;
  orderedProductsSummary?: Maybe<Array<ExtractionOrderOrderedProductsSummary>>;
  postDeliveryNote?: Maybe<Note>;
  postDeliveryPhotos?: Maybe<Array<PandaDocument>>;
  products?: Maybe<Array<Product>>;
  quickbookQueueStatus?: Maybe<Scalars['String']>;
  recentLoadingReceipts?: Maybe<Array<LoadingReceipt>>;
  signature?: Maybe<PandaDocument>;
  source?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  tenantName?: Maybe<Scalars['String']>;
  ticketId: Scalars['Int'];
  ticketMailedAtTimestamp?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type ExtractionOrderLineItem = {
  __typename?: 'ExtractionOrderLineItem';
  asset?: Maybe<Asset>;
  canSyncRequestedLoadingVolume: Scalars['Boolean'];
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  lat?: Maybe<Scalars['String']>;
  lng?: Maybe<Scalars['String']>;
  meterName?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  requestedVolume?: Maybe<Scalars['Float']>;
  skipReason?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  sourceAssets?: Maybe<Array<SourceAsset>>;
  sourceCompartmentInstances?: Maybe<Array<CompartmentInstance>>;
  sourceCompartments?: Maybe<Array<SourceCompartment>>;
  status: Scalars['String'];
  subscription?: Maybe<Subscription>;
  targetCompartmentInstance?: Maybe<CompartmentInstance>;
  topOff?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  volume?: Maybe<Scalars['Float']>;
  warehouseId?: Maybe<Scalars['ID']>;
};

export type ExtractionOrderOrderedProductsSummary = {
  __typename?: 'ExtractionOrderOrderedProductsSummary';
  productId?: Maybe<Scalars['ID']>;
  totalExtractedVolume: Scalars['Float'];
  totalRequestedVolume: Scalars['Float'];
  totalTopOffRequestCount: Scalars['Int'];
};

export type Feature = {
  __typename?: 'Feature';
  id: Scalars['ID'];
  key: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

/** Default feature Input */
export type FeatureInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Fee = {
  __typename?: 'Fee';
  applicableType?: Maybe<Scalars['String']>;
  applyAsOnFee?: Maybe<Scalars['String']>;
  baseFeeId?: Maybe<Scalars['ID']>;
  calculatedAsOnFee?: Maybe<Scalars['String']>;
  childFees?: Maybe<Array<Fee>>;
  code?: Maybe<Scalars['String']>;
  defaultMovementFee?: Maybe<Scalars['Boolean']>;
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  erpId?: Maybe<Scalars['String']>;
  feeProductCategories?: Maybe<Array<FeeProductCategory>>;
  feeType?: Maybe<Scalars['String']>;
  glCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  irelyId?: Maybe<Scalars['String']>;
  lastSyncedTime?: Maybe<Scalars['String']>;
  lineOfServices?: Maybe<Array<LineOfService>>;
  name?: Maybe<Scalars['String']>;
  netsuiteId?: Maybe<Scalars['ID']>;
  nonEditableRecords?: Maybe<Array<Scalars['JSON']>>;
  nsManualVolume?: Maybe<Scalars['Boolean']>;
  offset?: Maybe<Scalars['Float']>;
  offsetRate?: Maybe<Scalars['Float']>;
  parentFee?: Maybe<Fee>;
  percentOnFee?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  /** Deprecated, use fee_product_categories instead. */
  productCategoryId?: Maybe<Scalars['ID']>;
  rangeAttribute?: Maybe<Array<RangeAttribute>>;
  rangeCalculatedAsOnFee?: Maybe<Scalars['String']>;
  rangeTypeOnFee?: Maybe<Scalars['String']>;
  rateOnFee?: Maybe<Scalars['Float']>;
  rateUnitOnFee?: Maybe<Scalars['String']>;
  roundUpQuantity?: Maybe<Scalars['Boolean']>;
  standard?: Maybe<Scalars['Boolean']>;
  surchargeId?: Maybe<Scalars['ID']>;
};

export type FeeCollection = {
  __typename?: 'FeeCollection';
  collection: Array<Fee>;
  metadata: MetaQuery;
};

export type FeeFilter = {
  all?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<FeeFilter>>;
  priceGte?: InputMaybe<Scalars['Float']>;
  priceLte?: InputMaybe<Scalars['Float']>;
  types?: InputMaybe<Array<ApplicableTypeEnum>>;
};

export type FeeProductCategory = {
  __typename?: 'FeeProductCategory';
  id: Scalars['ID'];
  productCategory?: Maybe<ProductCategory>;
};

export type FeeProductCategoryInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  productCategoryId?: InputMaybe<Scalars['ID']>;
};

export type FeeSorter = {
  field: FeeSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum FeeSorterEnum {
  Code = 'CODE',
  Erpid = 'ERPID',
  Name = 'NAME',
  Price = 'PRICE'
}

export enum FeeTypeEnum {
  /** Flat */
  Flat = 'flat',
  /** Range */
  Range = 'range'
}

/** Feeable resource */
export type Feeable = CustomerBranch;

export type Feedback = {
  __typename?: 'Feedback';
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  rating?: Maybe<Scalars['String']>;
  tenant?: Maybe<Tenant>;
  worker?: Maybe<Worker>;
};

export type FeedbackCollection = {
  __typename?: 'FeedbackCollection';
  collection: Array<Feedback>;
  metadata: MetaQuery;
};

export type FeedbackFilter = {
  all?: InputMaybe<Scalars['String']>;
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
};

export enum FeesPricingStatusEnum {
  /** Pricing and Fees both are available */
  AllAvailable = 'all_available',
  /** Pricing is present but Fees are missing */
  FeeMissing = 'fee_missing',
  /** Pricing and Fees both are not available */
  NotAvailable = 'not_available',
  /** Pricing is missing but Fees are present */
  PricingMissing = 'pricing_missing'
}

/** Enum to use on sorter fields when call a query */
export enum FieldOrder {
  /** ascending sorter */
  Asc = 'asc',
  /** descending sorter */
  Desc = 'desc'
}

/** Enum for Filter type in Irely Configuration Setting */
export enum FilterTypeEnum {
  QueryFilter = 'query_filter',
  RegexFilter = 'regex_filter'
}

/** Enum for Filterable entities from Irely */
export enum FilterableEntityEnum {
  CompanyAsset = 'company_asset',
  Customer = 'customer',
  DeliveryAsset = 'delivery_asset',
  Driver = 'driver',
  Fee = 'fee',
  IrelyProductCategory = 'irely_product_category',
  IrelyUom = 'irely_uom',
  Product = 'product',
  SelfCustomerAsset = 'self_customer_asset',
  Supplier = 'supplier'
}

export type FiltersInput = {
  status?: InputMaybe<RateTypeStatusEnum>;
};

export enum FlowRateUnit {
  /** Gallons/minute */
  GallonsPerMinute = 'gallons_per_minute',
  /** Liters/minute */
  LitersPerMinute = 'liters_per_minute'
}

export type Flushing = {
  __typename?: 'Flushing';
  fromConditions: Array<Condition>;
  id: Scalars['ID'];
  toConditions: Array<Condition>;
  volume: Scalars['Int'];
};

/** Route Flushing Input */
export type FlushingInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  fromConditions: Array<ConditionInput>;
  id?: InputMaybe<Scalars['ID']>;
  toConditions: Array<ConditionInput>;
  volume: Scalars['Int'];
};

export type FormProgress = {
  __typename?: 'FormProgress';
  currentStep?: Maybe<FormProgressCurrentStepTypeEnum>;
  formData?: Maybe<Scalars['JSON']>;
  formType?: Maybe<FormProgressTypeEnum>;
  id: Scalars['ID'];
  status?: Maybe<Scalars['Int']>;
  tenantId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

/** Form progress current step enum */
export enum FormProgressCurrentStepTypeEnum {
  /** Asset Details */
  AssetDetails = 'asset_details',
  /** Fees And Other Details */
  FeesAndOtherDetails = 'fees_and_other_details',
  /** Order Details */
  OrderDetails = 'order_details'
}

/** Attributes for creating or updating FormProgress */
export type FormProgressInput = {
  currentStep: Scalars['String'];
  formData?: InputMaybe<Scalars['JSON']>;
  formType: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
};

/** Form progress form type enum */
export enum FormProgressTypeEnum {
  /** Delivery */
  Delivery = 'delivery',
  /** Pickup */
  Pickup = 'pickup',
  /** Relocate */
  Relocate = 'relocate',
  /** Transfer */
  Transfer = 'transfer'
}

/** Fuel Order Type Input */
export type FuelOrderTypeInput = {
  /** Flag to create fuel delivery order associated with movement order */
  createFuelDeliveryOrder?: InputMaybe<Scalars['Boolean']>;
  /** Flag to create fuel extraction order associated with movement order */
  createFuelExtractionOrder?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated input type of FundCustomerBalance */
export type FundCustomerBalanceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CreditLedgerTransactionInput;
};

/** Autogenerated return type of FundCustomerBalance */
export type FundCustomerBalancePayload = {
  __typename?: 'FundCustomerBalancePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  creditLedgerType?: Maybe<CreditLedger>;
};

/** Autogenerated input type of GenerateInvoice */
export type GenerateInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: Array<Scalars['ID']>;
};

/** Autogenerated return type of GenerateInvoice */
export type GenerateInvoicePayload = {
  __typename?: 'GenerateInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of GeneratePresignedMetabaseUrl */
export type GeneratePresignedMetabaseUrlInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  reportId: Scalars['ID'];
};

/** Autogenerated return type of GeneratePresignedMetabaseUrl */
export type GeneratePresignedMetabaseUrlPayload = {
  __typename?: 'GeneratePresignedMetabaseUrlPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

/** Autogenerated input type of GenerateQrCodes */
export type GenerateQrCodesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  noOfQrCodes: Scalars['Int'];
};

/** Autogenerated return type of GenerateQrCodes */
export type GenerateQrCodesPayload = {
  __typename?: 'GenerateQrCodesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  qrCodePdfString?: Maybe<Scalars['String']>;
};

export type GenerateSalesReportFilterInput = {
  customerBranchId?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of GenerateSalesReport */
export type GenerateSalesReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  endOnTimestamp?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<GenerateSalesReportFilterInput>;
  startOnTimestamp?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of GenerateSalesReport */
export type GenerateSalesReportPayload = {
  __typename?: 'GenerateSalesReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  pandaDocument?: Maybe<PandaDocument>;
};

export type GenerateTaxReportFilterInput = {
  customerBranchId?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of GenerateTaxReport */
export type GenerateTaxReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  endOnTimestamp?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<GenerateTaxReportFilterInput>;
  startOnTimestamp?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of GenerateTaxReport */
export type GenerateTaxReportPayload = {
  __typename?: 'GenerateTaxReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  pandaDocument?: Maybe<PandaDocument>;
};

export type GenericLocation = {
  __typename?: 'GenericLocation';
  lat?: Maybe<Scalars['String']>;
  lng?: Maybe<Scalars['String']>;
};

/** Location Input */
export type GenericLocationInput = {
  lat?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['String']>;
};

export type GeofenceError = {
  __typename?: 'GeofenceError';
  errorCode: Scalars['String'];
  errorMessage: Scalars['String'];
};

export enum GeofenceErrorEnum {
  /** Location Permission Denied */
  LocationPermissionDenied = 'location_permission_denied',
  /** Location Service Is Not Enabled */
  LocationServiceIsNotEnabled = 'location_service_is_not_enabled',
  /** Location Timeout */
  LocationTimeout = 'location_timeout',
  /** Location Unavailable */
  LocationUnavailable = 'location_unavailable'
}

export type GeofenceRecord = {
  __typename?: 'GeofenceRecord';
  lat?: Maybe<Scalars['String']>;
  lng?: Maybe<Scalars['String']>;
  shiftId?: Maybe<Scalars['ID']>;
  timestamp?: Maybe<Scalars['Int']>;
};

/** Location Input */
export type GeofenceRecordInput = {
  lat?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['String']>;
  shiftId?: InputMaybe<Scalars['ID']>;
  timestamp?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of GotoCustomer */
export type GotoCustomerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryOrderId?: InputMaybe<Scalars['ID']>;
  /** Don't use, deprecated! */
  taskId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of GotoCustomer */
export type GotoCustomerPayload = {
  __typename?: 'GotoCustomerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
  /** Don't use, deprecated! */
  task?: Maybe<Task>;
};

/** Autogenerated input type of GotoTerminal */
export type GotoTerminalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  loadingOrderId?: InputMaybe<Scalars['ID']>;
  /** Don't use, deprecated! */
  taskId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of GotoTerminal */
export type GotoTerminalPayload = {
  __typename?: 'GotoTerminalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
  /** Don't use, deprecated! */
  task?: Maybe<Task>;
};

export type Graph = {
  __typename?: 'Graph';
  data: Array<Scalars['JSON']>;
  metadata?: Maybe<Scalars['JSON']>;
};

export type Group = {
  __typename?: 'Group';
  groupMemberships?: Maybe<Array<GroupMembership>>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type GroupCollection = {
  __typename?: 'GroupCollection';
  collection: Array<Group>;
  metadata: MetaQuery;
};

export type GroupFilter = {
  name?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<GroupFilter>>;
};

export type GroupMembership = {
  __typename?: 'GroupMembership';
  groupable?: Maybe<Groupable>;
  groupableType: Scalars['String'];
  id: Scalars['ID'];
};

export type GroupSorter = {
  field: GroupSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum GroupSorterEnum {
  Name = 'NAME'
}

/** Members of groups */
export type Groupable = Customer | Driver | UnknownGroupable | User;

export type GroupedCustomer = {
  __typename?: 'GroupedCustomer';
  customers: Array<Customer>;
  tankMonitorMetadata?: Maybe<Scalars['JSON']>;
};

export type GroupedCustomerBranch = {
  __typename?: 'GroupedCustomerBranch';
  customerBranches: Array<CustomerBranch>;
  tankMonitorMetadata?: Maybe<Scalars['JSON']>;
};

export type GroupedOrder = {
  __typename?: 'GroupedOrder';
  metadata?: Maybe<Scalars['JSON']>;
  orderGroupStatus: TankMonitorOrderEnum;
};

export type GroupedSubject = {
  __typename?: 'GroupedSubject';
  groupedCustomer?: Maybe<Array<GroupedCustomer>>;
  groupedCustomerBranch?: Maybe<Array<GroupedCustomerBranch>>;
  groupedOrder?: Maybe<Array<GroupedOrder>>;
  metadata?: Maybe<TankMonitorMetaDataQuery>;
};

export type Hub = {
  __typename?: 'Hub';
  address?: Maybe<Scalars['JSON']>;
  addressBooks?: Maybe<Array<AddressBook>>;
  applicableFees?: Maybe<Array<ApplicableFee>>;
  assets?: Maybe<Array<Asset>>;
  attachBolOnDeliveryTicket: Scalars['Boolean'];
  autoEmailDeliveryTicket: Scalars['Boolean'];
  customer?: Maybe<Customer>;
  customerBranches?: Maybe<Array<CustomerBranch>>;
  customers?: Maybe<Array<Customer>>;
  deliveryInstruction?: Maybe<Scalars['String']>;
  erpId?: Maybe<Scalars['String']>;
  hubResources?: Maybe<Array<HubResource>>;
  id: Scalars['ID'];
  lineOfServices?: Maybe<Array<LineOfService>>;
  name?: Maybe<Scalars['String']>;
  netsuiteId?: Maybe<Scalars['ID']>;
  netsuiteName?: Maybe<Scalars['String']>;
  nonEditableRecords?: Maybe<Array<Scalars['JSON']>>;
  orderedProductsAverage?: Maybe<Array<OrderedProductsAverage>>;
  pandaDocuments?: Maybe<Array<PandaDocument>>;
  pickupPointCodes?: Maybe<Array<PickupPointCode>>;
  poNumber?: Maybe<Scalars['String']>;
  site?: Maybe<Site>;
  status?: Maybe<Scalars['Boolean']>;
  storageAssets?: Maybe<Array<Asset>>;
  suppliers?: Maybe<Array<Supplier>>;
};

export type HubResource = {
  __typename?: 'HubResource';
  hub: Hub;
  hubable: Hubable;
  hubableId: Scalars['ID'];
  hubableType: Scalars['String'];
  id: Scalars['ID'];
};

/** Manages a connection with hub */
export type HubResourceInput = {
  /** Only pass and set true when need to destroy */
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** ID of hub to be associated with. */
  customerBranchId?: InputMaybe<Scalars['ID']>;
  /** HubResource ID. Required on update. */
  id?: InputMaybe<Scalars['ID']>;
};

/** Members of groups */
export type Hubable = Customer | CustomerBranch | Driver;

export type ImportRecordInput = {
  attachment: DirectAttachmentInput;
  importable?: InputMaybe<ImportableTypeEnum>;
  importableId?: InputMaybe<Scalars['ID']>;
  recordType?: InputMaybe<ImportableTypeEnum>;
};

/** Autogenerated input type of ImportRecords */
export type ImportRecordsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: ImportRecordInput;
};

/** Autogenerated return type of ImportRecords */
export type ImportRecordsPayload = {
  __typename?: 'ImportRecordsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  dataImport?: Maybe<DataImport>;
  pandaDocument?: Maybe<PandaDocument>;
};

/** States of a Raw Pricing Import Session */
export enum ImportSessionStateEnum {
  ImportFailed = 'import_failed',
  ImportPartialSuccess = 'import_partial_success',
  ImportSuccess = 'import_success',
  MappersMissing = 'mappers_missing',
  MappingsResolved = 'mappings_resolved',
  NoMapperAvailable = 'no_mapper_available',
  Normalized = 'normalized',
  ParserFailure = 'parser_failure',
  Processing = 'processing'
}

/** Enum for list of importable types */
export enum ImportableTypeEnum {
  /** AddressBook */
  AddressBook = 'AddressBook',
  /** CardLockTransaction */
  CardLockTransaction = 'CardLockTransaction',
  /** CommonCarrier */
  CommonCarrier = 'CommonCarrier',
  /** CompanyAsset */
  CompanyAsset = 'CompanyAsset',
  /** Compartment */
  Compartment = 'Compartment',
  /** Customer */
  Customer = 'Customer',
  /** CustomerAsset */
  CustomerAsset = 'CustomerAsset',
  /** CustomerBranch */
  CustomerBranch = 'CustomerBranch',
  /** CustomerUser */
  CustomerUser = 'CustomerUser',
  /** Fee */
  Fee = 'Fee',
  /** LoadingAccount */
  LoadingAccount = 'LoadingAccount',
  /** Product */
  Product = 'Product',
  /** Rate Type */
  RateType = 'RateType',
  /** RentalAsset */
  RentalAsset = 'RentalAsset',
  /** Supplier */
  Supplier = 'Supplier',
  /** Temporary Pricing */
  TemporaryPricing = 'TEMPORARY_PRICING',
  /** Terminal */
  Terminal = 'Terminal',
  /** Warehouse */
  Warehouse = 'Warehouse'
}

/** Autogenerated input type of IndexResource */
export type IndexResourceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  resourceSettingName: Scalars['String'];
};

/** Autogenerated return type of IndexResource */
export type IndexResourcePayload = {
  __typename?: 'IndexResourcePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  setting: Setting;
};

export type InitialFeature = {
  __typename?: 'InitialFeature';
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type InteractionProgress = {
  __typename?: 'InteractionProgress';
  completed?: Maybe<Scalars['Boolean']>;
  currentStep?: Maybe<Scalars['Int']>;
  data?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['ID']>;
  progressableId?: Maybe<Scalars['ID']>;
  progressableType?: Maybe<Scalars['String']>;
  subModule?: Maybe<InteractionProgressEnum>;
  totalStep?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['ID']>;
};

/** The submodule for interaction progress */
export enum InteractionProgressEnum {
  /** draft */
  Draft = 'draft',
  /** lea_core */
  LeaCore = 'lea_core',
  /** lea_line_items */
  LeaLineItems = 'lea_line_items',
  /** lea_questionnaire */
  LeaQuestionnaire = 'lea_questionnaire',
  /** lease_generated */
  LeaseGenerated = 'lease_generated',
  /** lease_order_signed */
  LeaseOrderSigned = 'lease_order_signed',
  /** new_order */
  NewOrder = 'new_order',
  /** order_delivered */
  OrderDelivered = 'order_delivered'
}

export type InteractionProgressInput = {
  completed?: InputMaybe<Scalars['Boolean']>;
  currentStep?: InputMaybe<Scalars['Int']>;
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['ID']>;
  progressableId?: InputMaybe<Scalars['ID']>;
  progressableType?: InputMaybe<Scalars['String']>;
  subModule: InteractionProgressEnum;
  totalStep?: InputMaybe<Scalars['Int']>;
};

/** Enum for list of interaction progress types */
export enum InteractionProgressTypeEnum {
  /** draft */
  Draft = 'draft',
  /** lea_core */
  LeaCore = 'lea_core',
  /** lea_line_items */
  LeaLineItems = 'lea_line_items',
  /** lea_questionnaire */
  LeaQuestionnaire = 'lea_questionnaire',
  /** lease_generated */
  LeaseGenerated = 'lease_generated',
  /** lease_order_signed */
  LeaseOrderSigned = 'lease_order_signed',
  /** new_order */
  NewOrder = 'new_order',
  /** order_delivered */
  OrderDelivered = 'order_delivered'
}

export type Inventory = {
  __typename?: 'Inventory';
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']>;
  volume?: Maybe<Scalars['Float']>;
};

export type InventoryAdjustment = {
  __typename?: 'InventoryAdjustment';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  initialVolume: Scalars['Float'];
  product: Product;
  reconciliationVolume: Scalars['Float'];
  shiftCompartmentInstance: ShiftCompartmentInstance;
};

/** InventoryAdjustment Input */
export type InventoryAdjustmentInput = {
  /** ID of the ShiftCompartmentInstance. Required during update. */
  id?: InputMaybe<Scalars['ID']>;
  /** Initial Volume */
  initialVolume?: InputMaybe<Scalars['Float']>;
  /** Product's ID */
  productId?: InputMaybe<Scalars['ID']>;
  /** Reconciliation Volume */
  reconciliationVolume?: InputMaybe<Scalars['Float']>;
  /** 'ShiftCompartmentInstance's Id' */
  shiftCompartmentInstanceId?: InputMaybe<Scalars['ID']>;
};

/** Inventory Input */
export type InventoryInput = {
  adjustmentType: ShiftInventoryAdjustmentTypes;
  adjustmentVolume: Scalars['Float'];
  /** Compartment ID, required if product's unit isn't ea */
  compartmentId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
};

export type InventoryRecordsInput = {
  assetId: Scalars['ID'];
  compartmentId: Scalars['ID'];
  date: Scalars['Int'];
  orderType: OrderTypeEnum;
  productId: Scalars['ID'];
  quantity: Scalars['Float'];
  rate?: InputMaybe<Scalars['Float']>;
  receiptNumber?: InputMaybe<Scalars['String']>;
  totalCost?: InputMaybe<Scalars['Float']>;
  transactionType: TransactionTypeEnum;
};

/** Autogenerated input type of InviteCustomerToPortal */
export type InviteCustomerToPortalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CustomerPortalInput;
};

/** Autogenerated return type of InviteCustomerToPortal */
export type InviteCustomerToPortalPayload = {
  __typename?: 'InviteCustomerToPortalPayload';
  addressBook?: Maybe<AddressBook>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** An Invoice object */
export type Invoice = {
  __typename?: 'Invoice';
  amount?: Maybe<Scalars['Float']>;
  /** Card lock transactions associated with the invoice */
  cardLockTransactions?: Maybe<Array<CardLockTransaction>>;
  closeable?: Maybe<Updatable>;
  closedOn?: Maybe<Scalars['Int']>;
  creatable?: Maybe<Updatable>;
  createdAt?: Maybe<Scalars['Int']>;
  createdOn?: Maybe<Scalars['Int']>;
  customer?: Maybe<Customer>;
  generatable?: Maybe<Updatable>;
  generatedOn?: Maybe<Scalars['Int']>;
  glDate?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  /** Fees associated with the invoice */
  invoiceFees?: Maybe<Array<InvoiceFee>>;
  /** Line items associated with the invoice */
  invoiceLineItems?: Maybe<Array<InvoiceLineItem>>;
  invoiceNumber?: Maybe<Scalars['String']>;
  /** Order group Fee associated with the invoice */
  invoiceOrderGroupFees?: Maybe<Array<InvoiceOrderGroupFee>>;
  /** Order group taxes associated with the invoice */
  invoiceOrderGroupTaxes?: Maybe<Array<InvoiceOrderGroupTax>>;
  /** Taxes associated with the invoice */
  invoiceTaxes?: Maybe<Array<InvoiceTax>>;
  mobileOffline?: Maybe<Scalars['Boolean']>;
  orderGroup?: Maybe<OrderGroup>;
  reverseInvoice?: Maybe<Invoice>;
  reversedInvoices?: Maybe<Array<Invoice>>;
  status?: Maybe<InvoiceStatusEnum>;
  tenantId?: Maybe<Scalars['ID']>;
  updatedAt?: Maybe<Scalars['Int']>;
};

export type InvoiceCollection = {
  __typename?: 'InvoiceCollection';
  collection: Array<Invoice>;
  metadata: MetaQuery;
};

export type InvoiceFee = {
  __typename?: 'InvoiceFee';
  /** The total amount of the fee. */
  amount?: Maybe<Scalars['Float']>;
  customerBranchId?: Maybe<Scalars['ID']>;
  /** The fee associated with the invoice. */
  fee?: Maybe<Fee>;
  /** The unique identifier of the invoice fee. */
  id?: Maybe<Scalars['ID']>;
  /** The unique identifier of the invoice to which this fee belongs. */
  invoiceId?: Maybe<Scalars['ID']>;
  /** Whether this row was generated from temporary pricing */
  isTemporaryPricing?: Maybe<Scalars['Boolean']>;
  /** The product associated with the fee. */
  product?: Maybe<Product>;
  /** The unique identifier of the product associated with the fee. */
  productId?: Maybe<Scalars['ID']>;
  /** The quantity of the fee items. */
  quantity?: Maybe<Scalars['Float']>;
  /** The rate applied to the fee. */
  rate?: Maybe<Scalars['Float']>;
  /** Temporary component key used for this row */
  temporaryPricingKey?: Maybe<Scalars['String']>;
};

export type InvoiceFeeInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  amount: Scalars['Float'];
  feeId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Float'];
  rate: Scalars['Float'];
};

export type InvoiceFilter = {
  all?: InputMaybe<Scalars['String']>;
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  or?: InputMaybe<Array<InvoiceFilter>>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
};

/** Default Invoice Input */
export type InvoiceInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  cardLockTransactionIds?: InputMaybe<Array<Scalars['ID']>>;
  customerId?: InputMaybe<Scalars['ID']>;
  glDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  invoiceFeesAttributes?: InputMaybe<Array<InvoiceFeeInput>>;
  invoiceLineItemsAttributes?: InputMaybe<Array<InvoiceLineItemInput>>;
  /** Required if mobile_offline is true */
  invoiceNumber?: InputMaybe<Scalars['String']>;
  invoiceTaxesAttributes?: InputMaybe<Array<InvoiceTaxInput>>;
  mobileOffline?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
};

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  amount?: Maybe<Scalars['Float']>;
  customerBranch?: Maybe<CustomerBranch>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceId?: Maybe<Scalars['ID']>;
  product: Product;
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  sumTotal?: Maybe<Scalars['Float']>;
};

export type InvoiceLineItemInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  amount: Scalars['Float'];
  id?: InputMaybe<Scalars['ID']>;
  productId: Scalars['ID'];
  quantity: Scalars['Float'];
  rate: Scalars['Float'];
};

export type InvoiceOrderGroupFee = {
  __typename?: 'InvoiceOrderGroupFee';
  /** The fee associated with the invoice. */
  fee?: Maybe<Fee>;
  /** The unique identifier of the invoice fee. */
  id?: Maybe<Scalars['ID']>;
  /** The unique identifier of the invoice to which this fee belongs. */
  invoiceId?: Maybe<Scalars['ID']>;
  /** The quantity of the fee items. */
  quantity?: Maybe<Scalars['Float']>;
  /** The rate applied to the fee. */
  rate?: Maybe<Scalars['Float']>;
  /** The total amount of the fee. */
  total?: Maybe<Scalars['Float']>;
};

/** An Invoice Tax object */
export type InvoiceOrderGroupTax = {
  __typename?: 'InvoiceOrderGroupTax';
  /** Timestamp when the tax was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** ID of the invoice tax */
  id?: Maybe<Scalars['ID']>;
  /** ID of the associated invoice */
  invoiceId?: Maybe<Scalars['ID']>;
  /** Quantity to which the tax is applied */
  quantity?: Maybe<Scalars['Float']>;
  /** Tax rate applied to the invoice */
  rate?: Maybe<Scalars['Float']>;
  /** ID of the associated tax */
  tax?: Maybe<Tax>;
  /** Total amount of the tax */
  total?: Maybe<Scalars['Float']>;
  /** Timestamp when the tax was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum InvoiceStatusEnum {
  /** closed */
  Closed = 'closed',
  /** created */
  Created = 'created',
  /** generated */
  Generated = 'generated',
  /** pending */
  Pending = 'pending',
  /** reversed */
  Reversed = 'reversed',
  /** synced */
  Synced = 'synced',
  /** unsynced */
  Unsynced = 'unsynced'
}

/** An Invoice Tax object */
export type InvoiceTax = {
  __typename?: 'InvoiceTax';
  /** Total amount of the tax */
  amount?: Maybe<Scalars['Float']>;
  /** Timestamp when the tax was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  customerBranchId?: Maybe<Scalars['ID']>;
  /** ID of the invoice tax */
  id?: Maybe<Scalars['ID']>;
  /** ID of the associated invoice */
  invoiceId?: Maybe<Scalars['ID']>;
  /** Whether this row was generated from temporary pricing */
  isTemporaryPricing?: Maybe<Scalars['Boolean']>;
  /** associated product */
  product?: Maybe<Product>;
  /** The unique identifier of the product associated with the fee. */
  productId: Scalars['ID'];
  /** Quantity to which the tax is applied */
  quantity?: Maybe<Scalars['Float']>;
  /** Tax rate applied to the invoice */
  rate?: Maybe<Scalars['Float']>;
  /** ID of the associated tax */
  tax?: Maybe<Tax>;
  /** Temporary component key used for this row */
  temporaryPricingKey?: Maybe<Scalars['String']>;
  /** Timestamp when the tax was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type InvoiceTaxInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  amount?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  rate?: InputMaybe<Scalars['Float']>;
  taxId?: InputMaybe<Scalars['ID']>;
};

/** Enum to Represent the different type of Irely Entity that needs to mapped with Fleetpanda */
export enum IrelyEntityEnum {
  /** Product Category used in irely */
  IrelyProductCategory = 'IrelyProductCategory',
  /** Unit of Measurement used in irely */
  IrelyUom = 'IrelyUom'
}

export type IrelyFilter = {
  __typename?: 'IrelyFilter';
  entity?: Maybe<FilterableEntityEnum>;
  filter?: Maybe<Scalars['String']>;
  filterType?: Maybe<FilterTypeEnum>;
  id: Scalars['ID'];
};

/** Inputs to create/update a filter */
export type IrelyFilterInput = {
  entity: Scalars['String'];
  filter?: InputMaybe<Scalars['String']>;
  filterType: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
};

export type IrelyProductCategory = {
  __typename?: 'IrelyProductCategory';
  categoryCode?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  erpId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isRetailValuation?: Maybe<Scalars['Boolean']>;
  lineOfBusiness?: Maybe<Scalars['String']>;
  productCategory?: Maybe<ProductCategory>;
};

export type IrelyUom = {
  __typename?: 'IrelyUom';
  decimalPlaces?: Maybe<Scalars['Int']>;
  erpId?: Maybe<Scalars['Int']>;
  fpValue?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
  unitType?: Maybe<Scalars['String']>;
};

/** Enum for bol pricing item type */
export enum ItemTypeEnum {
  /** Price */
  Price = 'price',
  /** Tax */
  Tax = 'tax'
}

export type ItemsDetail = {
  __typename?: 'ItemsDetail';
  name: Scalars['String'];
  quantity: Scalars['Float'];
  rate: Scalars['Float'];
  rateUnit?: Maybe<Scalars['String']>;
  total: Scalars['Float'];
  type: Scalars['String'];
};

/** LoadingAccountTerminalProduct brand type */
export enum LatpBrandTypeEnum {
  Branded = 'branded',
  Unbranded = 'unbranded'
}

export type Lea = {
  __typename?: 'Lea';
  error?: Maybe<Scalars['String']>;
  leaCore?: Maybe<LeaCore>;
  success: Scalars['Boolean'];
};

/** LEA Line Item object type */
export type LeaAppliedFee = {
  __typename?: 'LeaAppliedFee';
  applicableFee?: Maybe<ApplicableFee>;
  id: Scalars['ID'];
  isDefault?: Maybe<Scalars['Boolean']>;
};

/** Applied Fees input in Assets data in LEA */
export type LeaAppliedFeeInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  applicableFeeId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
};

/** LEA Core object type */
export type LeaCore = {
  __typename?: 'LeaCore';
  addendumNumber?: Maybe<Scalars['String']>;
  addendums?: Maybe<Array<LeaCore>>;
  agreementSignedDate?: Maybe<Scalars['ISO8601DateTime']>;
  assetReturnHub?: Maybe<Hub>;
  cancellationReason?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['String']>;
  childLeaCore?: Maybe<LeaCore>;
  computedMovementOrderIds?: Maybe<Array<Scalars['ID']>>;
  createdAtTimestamp?: Maybe<Scalars['Int']>;
  customer?: Maybe<Customer>;
  customerBranch?: Maybe<CustomerBranch>;
  data?: Maybe<LeaCoreData>;
  defaultEmailMessage?: Maybe<Scalars['String']>;
  defaultEmailSubject?: Maybe<Scalars['String']>;
  docusealSubmissions: Array<DocusealSubmissionResponse>;
  expiryDate?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  interactionProgresses?: Maybe<Array<InteractionProgress>>;
  isSigned?: Maybe<Scalars['Boolean']>;
  leaCoreWarnings?: Maybe<Scalars['String']>;
  leaLineItems?: Maybe<Array<LeaLineItem>>;
  leaMovementOrders?: Maybe<Array<LeaMovementOrderStatus>>;
  leaNumber?: Maybe<Scalars['String']>;
  leaPostSignatures?: Maybe<Array<PandaDocument>>;
  leaPreSignatures?: Maybe<Array<PandaDocument>>;
  leaQuestionnaire?: Maybe<LeaQuestionnaire>;
  leaseStatus?: Maybe<LeaseStatusEnum>;
  linkedLeaseNumber?: Maybe<Scalars['ID']>;
  movementOrderAttributes?: Maybe<LeaCoreMovementOrder>;
  orderType?: Maybe<MovementOrderTypeEnum>;
  parentLeaCore?: Maybe<LeaCore>;
  plannedDate?: Maybe<Scalars['Int']>;
  previewDocument?: Maybe<LeaDocument>;
  settledMovementOrderIds?: Maybe<Array<Scalars['ID']>>;
  sourceLeaCoreId?: Maybe<Scalars['ID']>;
  state?: Maybe<LeaCoreStateEnum>;
  status?: Maybe<LeaStatusEnum>;
  termAndCondition?: Maybe<Scalars['String']>;
  unsettledMovementOrderIds?: Maybe<Array<Scalars['ID']>>;
};


/** LEA Core object type */
export type LeaCorePreviewDocumentArgs = {
  documentType?: InputMaybe<LeaPreviewDocumentEnum>;
};

export type LeaCoreAddendum = {
  __typename?: 'LeaCoreAddendum';
  addendumLeaCoreId?: Maybe<Scalars['ID']>;
  addendumNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  leaCoreId?: Maybe<Scalars['ID']>;
  movementOrderId?: Maybe<Scalars['ID']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type LeaCoreCollection = {
  __typename?: 'LeaCoreCollection';
  collection: Array<LeaCore>;
  data: LeaCorePaginationData;
  metadata: MetaQuery;
};

/** LEA Core Custom Item object type */
export type LeaCoreCustomItem = {
  __typename?: 'LeaCoreCustomItem';
  costPrice?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  qty?: Maybe<Scalars['Int']>;
  sellingPrice?: Maybe<Scalars['Float']>;
  unitCost?: Maybe<Scalars['Float']>;
};

/** Custom Item input in Assets data in LEA */
export type LeaCoreCustomItemInput = {
  costPrice?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  qty?: InputMaybe<Scalars['Int']>;
  sellingPrice?: InputMaybe<Scalars['Float']>;
  unitCost?: InputMaybe<Scalars['Float']>;
};

export type LeaCoreData = {
  __typename?: 'LeaCoreData';
  computedMovementOrderIds?: Maybe<Array<Scalars['Int']>>;
  computedSettledMovementOrderIds?: Maybe<Array<Scalars['Int']>>;
  expiryDurationDays?: Maybe<Scalars['Int']>;
  expiryReminderDays?: Maybe<Scalars['Int']>;
  expiryUnit?: Maybe<Scalars['String']>;
  leaCoreNotes?: Maybe<Scalars['String']>;
  reminderEmails?: Maybe<Array<Scalars['String']>>;
};

export type LeaCoreDataInput = {
  /** LEA will expire after this many days. */
  expiryDurationDays?: InputMaybe<Scalars['Int']>;
  /** Reminder will be sent before this many days of expiry. */
  expiryReminderDays?: InputMaybe<Scalars['Int']>;
  /** Unit of time for expiry duration, e.g., "months", "years". */
  expiryUnit?: InputMaybe<LeaExpiryUnitEnum>;
  leaCoreNotes?: InputMaybe<Scalars['String']>;
  reminderEmails?: InputMaybe<Array<Scalars['String']>>;
};

/** LEA Core Document Input */
export type LeaCoreDocumentInput = {
  deletedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  leaCoreId: Scalars['ID'];
  leaDocumentType?: InputMaybe<Scalars['String']>;
  leaSignedDocument?: InputMaybe<Scalars['Boolean']>;
  leaState?: InputMaybe<LeaCoreStateEnum>;
  pandaDocumentId: Scalars['ID'];
};

export type LeaCoreEquipments = {
  __typename?: 'LeaCoreEquipments';
  assetTankTypes?: Maybe<Array<RoiEquipments>>;
  customItems?: Maybe<Array<RoiEquipments>>;
  finalTotalCost?: Maybe<Scalars['Float']>;
  peripherals?: Maybe<Array<RoiEquipments>>;
  tankMonitorData?: Maybe<LeaTankMonitorData>;
};

export type LeaCoreFilter = {
  all?: InputMaybe<Scalars['String']>;
  customers?: InputMaybe<Array<Scalars['String']>>;
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  or?: InputMaybe<Array<LeaCoreFilter>>;
  state?: InputMaybe<LeaCoreStateEnum>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
};

/** LEA Core Input */
export type LeaCoreInput = {
  /** ID of the hub where assets should be returned after lease expiry. */
  assetReturnHubId?: InputMaybe<Scalars['ID']>;
  cancellationReason?: InputMaybe<Scalars['String']>;
  customerBranchId?: InputMaybe<Scalars['ID']>;
  data?: InputMaybe<LeaCoreDataInput>;
  editLeaCore?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  interactionProgressesAttributes?: InputMaybe<Array<InteractionProgressInput>>;
  isSigned?: InputMaybe<Scalars['Boolean']>;
  leaLineItemsAttributes?: InputMaybe<Array<LeaLineItemInput>>;
  leaPostSignatureAttributes?: InputMaybe<PandaDocumentInput>;
  leaQuestionnaireAttributes?: InputMaybe<LeaQuestionnaireInput>;
  movementOrderAttributes?: InputMaybe<LeaCoreMovementOrderInput>;
  plannedDate?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<LeaCoreStateEnum>;
  status?: InputMaybe<LeaStatusEnum>;
  termAndCondition?: InputMaybe<Scalars['String']>;
};

/** LEA Core Movement Order object type */
export type LeaCoreMovementOrder = {
  __typename?: 'LeaCoreMovementOrder';
  compartmentsAttributes?: Maybe<Scalars['JSON']>;
  createFuelOrder?: Maybe<Scalars['Boolean']>;
  deliveryWindow?: Maybe<Scalars['JSON']>;
  driverId?: Maybe<Scalars['ID']>;
  fromHubId?: Maybe<Scalars['ID']>;
  getSignatureOnDelivery?: Maybe<Scalars['Boolean']>;
  movementOrderLineItemsAttributes?: Maybe<Array<MovementOrderLineItemAttributes>>;
  notes?: Maybe<Scalars['String']>;
  orderNotes?: Maybe<Scalars['String']>;
  orderType?: Maybe<MovementOrderTypeEnum>;
  pandaDocuments?: Maybe<Array<PandaDocument>>;
};

export type LeaCoreMovementOrderInput = {
  compartmentsAttributes?: InputMaybe<Array<NestedCompartmentInput>>;
  createFuelOrder?: InputMaybe<Scalars['Boolean']>;
  deliveryWindow?: InputMaybe<Scalars['JSON']>;
  driverId?: InputMaybe<Scalars['ID']>;
  fromHubId?: InputMaybe<Scalars['ID']>;
  getSignatureOnDelivery?: InputMaybe<Scalars['Boolean']>;
  /** Movement Order Line Item Input object. */
  movementOrderLineItemsAttributes?: InputMaybe<Array<MovementOrderLineItemInput>>;
  /** Support multiple products in movement order */
  movementOrderRequestedProductsAttributes?: InputMaybe<Array<MovementOrderRequestedProductsInput>>;
  notes?: InputMaybe<Scalars['String']>;
  orderNotes?: InputMaybe<Scalars['String']>;
  /** Movement Order Type */
  orderType?: InputMaybe<MovementOrderTypeEnum>;
  /** Panda documents for order group */
  pandaDocuments?: InputMaybe<Array<NestedPandaDocumentsInput>>;
};

export type LeaCorePaginationData = {
  __typename?: 'LeaCorePaginationData';
  /** Count of signed agreements expiring within the requested number of days. */
  agreementSignedCount: Scalars['Int'];
};


export type LeaCorePaginationDataAgreementSignedCountArgs = {
  withinDays?: Scalars['Int'];
};

export type LeaCoreSorter = {
  field: LeaCoreSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum LeaCoreSorterEnum {
  CreationDate = 'CREATION_DATE',
  CustomerName = 'CUSTOMER_NAME',
  ExpiryDate = 'EXPIRY_DATE'
}

/** The state of the LEA Core */
export enum LeaCoreStateEnum {
  /** agreement_generated */
  AgreementGenerated = 'agreement_generated',
  /** agreement_signed */
  AgreementSigned = 'agreement_signed',
  /** asset_delivery_confirmed_order_list */
  AssetDeliveryConfirmedOrderList = 'asset_delivery_confirmed_order_list',
  /** asset_delivery_draft */
  AssetDeliveryDraft = 'asset_delivery_draft',
  /** asset_delivery_new_order */
  AssetDeliveryNewOrder = 'asset_delivery_new_order',
  /** cancelled */
  Cancelled = 'cancelled',
  /** draft_order */
  DraftOrder = 'draft_order',
  /** expired_agreement */
  ExpiredAgreement = 'expired_agreement',
  /** lease_generated */
  LeaseGenerated = 'lease_generated',
  /** lease_order_signed */
  LeaseOrderSigned = 'lease_order_signed',
  /** new_order */
  NewOrder = 'new_order',
  /** order_delivered */
  OrderDelivered = 'order_delivered'
}

/** LeaCostAndMarginType in LEA LineItem object type */
export type LeaCostAndMargin = {
  __typename?: 'LeaCostAndMargin';
  assetCostPrice?: Maybe<Scalars['Float']>;
  assetSellingPrice?: Maybe<Scalars['Float']>;
  marginGal?: Maybe<Scalars['Float']>;
  salesCommission?: Maybe<Scalars['Float']>;
};

export type LeaCostAndMarginInput = {
  assetCostPrice?: InputMaybe<Scalars['Float']>;
  assetSellingPrice?: InputMaybe<Scalars['Float']>;
  marginGal?: InputMaybe<Scalars['Float']>;
  salesCommission?: InputMaybe<Scalars['Float']>;
};

export type LeaDocument = {
  __typename?: 'LeaDocument';
  content?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
};

/** Enum for LEA Expiry Unit */
export enum LeaExpiryUnitEnum {
  Day = 'day',
  Month = 'month',
  Year = 'year'
}

/** LEA fee object type */
export type LeaFee = {
  __typename?: 'LeaFee';
  fee: Fee;
  id: Scalars['ID'];
};

/** Lea fee input for LEA line item */
export type LeaFeeInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  feeId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
};

/** LEA Line Item object type */
export type LeaLineItem = {
  __typename?: 'LeaLineItem';
  addendumDetail?: Maybe<Array<LeaCoreAddendum>>;
  asset?: Maybe<Asset>;
  assetPositionNumber?: Maybe<Scalars['Int']>;
  bdrCommissionInPercent?: Maybe<Scalars['String']>;
  category?: Maybe<ProductCategory>;
  costAndMargin?: Maybe<LeaCostAndMargin>;
  customItemData?: Maybe<Array<LeaCoreCustomItem>>;
  customerBranch?: Maybe<CustomerBranch>;
  descriptiveReason?: Maybe<Scalars['String']>;
  effectiveMarginInDollar?: Maybe<Scalars['String']>;
  effectiveMarginInPercent?: Maybe<Scalars['String']>;
  equipmentsData?: Maybe<LeaCoreEquipments>;
  estimatedAssetValue?: Maybe<Scalars['String']>;
  estimatedMargin?: Maybe<Scalars['String']>;
  estimatedRoi?: Maybe<Scalars['String']>;
  gallonPerMonth?: Maybe<Scalars['String']>;
  gallonPerVisit?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  leaAppliedFees?: Maybe<Array<LeaAppliedFee>>;
  leaCore?: Maybe<LeaCore>;
  leaFees?: Maybe<Array<LeaFee>>;
  leaLineItemsNotes?: Maybe<Scalars['String']>;
  leaPeripherals?: Maybe<Array<LeaPeripheral>>;
  leaQuestionnaireAsset?: Maybe<LeaQuestionnaireAsset>;
  marginInPercentage?: Maybe<Scalars['String']>;
  marginPerGallonInCents?: Maybe<Scalars['String']>;
  movementOrder?: Maybe<MovementOrder>;
  movementOrderAttributes?: Maybe<LeaCoreMovementOrder>;
  percentageOfCogs?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Product>>;
  reasonType?: Maybe<Scalars['String']>;
  requestProduct?: Maybe<Product>;
  requestTankSize?: Maybe<Scalars['Float']>;
  requestTankType?: Maybe<Scalars['String']>;
  status?: Maybe<LeaLineItemStatusEnum>;
  totalMarginPerMonth?: Maybe<Scalars['String']>;
  unitCost?: Maybe<Scalars['Float']>;
};

export type LeaLineItemCollection = {
  __typename?: 'LeaLineItemCollection';
  collection: Array<LeaLineItem>;
  metadata: MetaQuery;
};

export type LeaLineItemFilter = {
  all?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Int']>;
  or?: InputMaybe<Array<LeaLineItemFilter>>;
  startDate?: InputMaybe<Scalars['Int']>;
};

/** LEA Line Item Input */
export type LeaLineItemInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  assetId?: InputMaybe<Scalars['ID']>;
  assetPositionNumber?: InputMaybe<Scalars['Int']>;
  bdrCommissionInPercent?: InputMaybe<Scalars['String']>;
  costAndMargin?: InputMaybe<LeaCostAndMarginInput>;
  customItemData?: InputMaybe<Array<LeaCoreCustomItemInput>>;
  customerBranchId?: InputMaybe<Scalars['ID']>;
  /** Descriptive (Other) reasons for the requested tank type change. */
  descriptiveReason?: InputMaybe<Scalars['String']>;
  effectiveMarginInDollar?: InputMaybe<Scalars['String']>;
  effectiveMarginInPercent?: InputMaybe<Scalars['String']>;
  estimatedAssetValue?: InputMaybe<Scalars['String']>;
  estimatedMargin?: InputMaybe<Scalars['String']>;
  estimatedRoi?: InputMaybe<Scalars['String']>;
  gallonPerMonth?: InputMaybe<Scalars['String']>;
  gallonPerVisit?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  leaAppliedFeesAttributes?: InputMaybe<Array<LeaAppliedFeeInput>>;
  leaCoreId?: InputMaybe<Scalars['ID']>;
  leaFeesAttributes?: InputMaybe<Array<LeaFeeInput>>;
  leaLineItemsNotes?: InputMaybe<Scalars['String']>;
  leaPeripheralsAttributes?: InputMaybe<Array<LeaPeripheralInput>>;
  marginInPercentage?: InputMaybe<Scalars['String']>;
  marginPerGallonInCents?: InputMaybe<Scalars['String']>;
  movementOrderAttributes?: InputMaybe<LeaCoreMovementOrderInput>;
  percentageOfCogs?: InputMaybe<Scalars['String']>;
  /** List of Product IDs for requested products. */
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Reason for the requested tank type change. */
  reasonType?: InputMaybe<ReasonTypesEnum>;
  requestProductId?: InputMaybe<Scalars['ID']>;
  requestTankSize?: InputMaybe<Scalars['Float']>;
  requestTankType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<LeaLineItemStatusEnum>;
  tankMonitorData?: InputMaybe<LeaTankMonitorDataInput>;
  totalMarginPerMonth?: InputMaybe<Scalars['String']>;
  unitCost?: InputMaybe<Scalars['Float']>;
};

/** Enum for Lea Status */
export enum LeaLineItemStatusEnum {
  /** fresh */
  Fresh = 'fresh',
  /** old */
  Old = 'old'
}

/** Movement order ID and its order group status for a LEA core */
export type LeaMovementOrderStatus = {
  __typename?: 'LeaMovementOrderStatus';
  id: Scalars['ID'];
  orderGroupStatus?: Maybe<OrderGroupStatusEnum>;
};

/** LEA peripheral object type */
export type LeaPeripheral = {
  __typename?: 'LeaPeripheral';
  costPrice?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
  ownershipStatus?: Maybe<LeaPeripheralOwnershipStatusEnum>;
  peripheral?: Maybe<Peripheral>;
  quantity?: Maybe<Scalars['Int']>;
  sellingPrice?: Maybe<Scalars['Float']>;
  status?: Maybe<LeaPeripheralStatusEnum>;
  unitCost?: Maybe<Scalars['Float']>;
};

/** Peripherals input in Assets data in LEA Questionnaire */
export type LeaPeripheralInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  costPrice?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  note?: InputMaybe<Scalars['String']>;
  /** Notes for the lea manager peripheral */
  notes?: InputMaybe<Scalars['String']>;
  ownershipStatus?: InputMaybe<LeaPeripheralOwnershipStatusEnum>;
  peripheralId?: InputMaybe<Scalars['ID']>;
  peripheralType?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  sellingPrice?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  unitCost?: InputMaybe<Scalars['Float']>;
};

/** Enum for Lea Peripheral Ownership Status */
export enum LeaPeripheralOwnershipStatusEnum {
  /** leased */
  Leased = 'leased',
  /** purchased */
  Purchased = 'purchased'
}

/** Enum for Lea Status */
export enum LeaPeripheralStatusEnum {
  /** fresh */
  Fresh = 'fresh',
  /** old */
  Old = 'old'
}

/** Enum for LEA Preview Document */
export enum LeaPreviewDocumentEnum {
  /** Addendum */
  Addendum = 'addendum',
  /** Final Agreement */
  FinalAgreement = 'final_agreement',
  /** Work Order Document */
  WorkOrderDocument = 'work_order_document'
}

/** LEA Questionnaire */
export type LeaQuestionnaire = {
  __typename?: 'LeaQuestionnaire';
  createdAt: Scalars['ISO8601DateTime'];
  customerBillingDetails?: Maybe<CustomerRepresentative>;
  customerRepresentative?: Maybe<CustomerRepresentative>;
  data?: Maybe<LeaQuestionnaireData>;
  id: Scalars['ID'];
  leaCore?: Maybe<LeaCore>;
  leaManager?: Maybe<User>;
  leaQuestionnaireAssets?: Maybe<Array<LeaQuestionnaireAsset>>;
  salesRep?: Maybe<SalesRep>;
  salesRepresentative?: Maybe<User>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** LeaQuestionnaireAssetType in LEA Questionnaire */
export type LeaQuestionnaireAsset = {
  __typename?: 'LeaQuestionnaireAsset';
  costPricePerUnit?: Maybe<Scalars['Float']>;
  gallonPerDelivery?: Maybe<Scalars['String']>;
  gallonPerMonth?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  marginPerGallon?: Maybe<Scalars['Float']>;
  note?: Maybe<Scalars['String']>;
  paybackPeriod?: Maybe<Scalars['Float']>;
  product?: Maybe<Product>;
  products?: Maybe<Array<Product>>;
  salesCommissionPercent?: Maybe<Scalars['Float']>;
  sellingPricePerUnit?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  tankSize?: Maybe<Scalars['String']>;
  tankType?: Maybe<Scalars['String']>;
};

/** LeaQuestionnaireAssetInput in LEA Questionnaire */
export type LeaQuestionnaireAssetInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  costPricePerUnit?: InputMaybe<Scalars['Float']>;
  gallonPerDelivery?: InputMaybe<Scalars['Float']>;
  gallonPerMonth?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  marginPerGallon?: InputMaybe<Scalars['Float']>;
  note?: InputMaybe<Scalars['String']>;
  paybackPeriod?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['ID']>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  salesCommissionPercent?: InputMaybe<Scalars['Float']>;
  sellingPricePerUnit?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  tankSize?: InputMaybe<Scalars['String']>;
  tankType?: InputMaybe<Scalars['String']>;
};

/** data in LEA Questionnaire */
export type LeaQuestionnaireData = {
  __typename?: 'LeaQuestionnaireData';
  customer?: Maybe<Customer>;
  customerBranch?: Maybe<CustomerBranch>;
  customerBranchId?: Maybe<Scalars['ID']>;
  customerId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  source?: Maybe<LeaQuestionnaireSourceEnum>;
};

/** data input in LEA Questionnaire */
export type LeaQuestionnaireDataInput = {
  customerBranchId?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<LeaQuestionnaireSourceEnum>;
};

/** LEA Questionnaire Input */
export type LeaQuestionnaireInput = {
  customerBillingDetails?: InputMaybe<CustomerRepresentativeInput>;
  customerRepresentative?: InputMaybe<CustomerRepresentativeInput>;
  data?: InputMaybe<LeaQuestionnaireDataInput>;
  id?: InputMaybe<Scalars['ID']>;
  leaManagerId?: InputMaybe<Scalars['ID']>;
  leaQuestionnaireAssetsAttributes?: InputMaybe<Array<LeaQuestionnaireAssetInput>>;
  salesRep?: InputMaybe<SalesRepInput>;
  salesRepresentativeId?: InputMaybe<Scalars['ID']>;
};

export enum LeaQuestionnaireSourceEnum {
  /** Mobile */
  Mobile = 'mobile',
  /** Web */
  Web = 'web'
}

/** LEA Report */
export type LeaReport = {
  __typename?: 'LeaReport';
  content?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
};

export type LeaReportFilter = {
  all?: InputMaybe<Scalars['String']>;
  assetName?: InputMaybe<Scalars['String']>;
  customerName?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Int']>;
  or?: InputMaybe<Array<LeaReportFilter>>;
  startDate?: InputMaybe<Scalars['Int']>;
};

/** Enum for Lea Status */
export enum LeaStatusEnum {
  /** draft */
  Draft = 'draft',
  /** generated */
  Generated = 'generated',
  /** staging */
  Staging = 'staging'
}

/** LEA Line Item Tank Monitor Data type */
export type LeaTankMonitorData = {
  __typename?: 'LeaTankMonitorData';
  action?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['ID']>;
  tankMonitorId?: Maybe<Scalars['ID']>;
};

/** LEA Line Item Tank Monitor Data Input */
export type LeaTankMonitorDataInput = {
  action?: InputMaybe<Scalars['String']>;
  assetId?: InputMaybe<Scalars['ID']>;
  tankMonitorId?: InputMaybe<Scalars['ID']>;
};

export enum LeaseStatusEnum {
  /** Active lease */
  Active = 'active',
  /** Expired lease */
  Expired = 'expired'
}

/** Paginated LEM billing report */
export type LemBillingReport = {
  __typename?: 'LemBillingReport';
  exportDocument?: Maybe<PandaDocument>;
  hasMore: Scalars['Boolean'];
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  rows: Array<LemBillingReportRow>;
  total: Scalars['Int'];
};

export type LemBillingReportFilterInput = {
  /** ISO date e.g. 2026-05-31 */
  endDate: Scalars['String'];
  /** Filter rows by lea number, asset name, LP, MO id, or customer */
  search?: InputMaybe<Scalars['String']>;
  /** ISO date e.g. 2026-05-01 */
  startDate: Scalars['String'];
};

/** One charge row in the LEM billing report */
export type LemBillingReportRow = {
  __typename?: 'LemBillingReportRow';
  bdrLeaseManager?: Maybe<Scalars['String']>;
  capacity?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  dispatcher?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  driver?: Maybe<Scalars['String']>;
  erpId?: Maybe<Scalars['String']>;
  fromCustomer?: Maybe<Scalars['String']>;
  fromShipTo?: Maybe<Scalars['String']>;
  hubName?: Maybe<Scalars['String']>;
  itemName?: Maybe<Scalars['String']>;
  itemType?: Maybe<Scalars['String']>;
  leaNumber?: Maybe<Scalars['String']>;
  lpNo?: Maybe<Scalars['String']>;
  movementOrderId?: Maybe<Scalars['ID']>;
  product?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  startTime?: Maybe<Scalars['String']>;
  toCustomer?: Maybe<Scalars['String']>;
  toShipTo?: Maybe<Scalars['String']>;
  totalCost?: Maybe<Scalars['Float']>;
  unitCost?: Maybe<Scalars['Float']>;
};

/** License input for drivers */
export type LicenseInput = {
  id?: InputMaybe<Scalars['ID']>;
  licenseSignedBlobId?: InputMaybe<Scalars['ID']>;
};

export type LineItem = {
  __typename?: 'LineItem';
  deliveredVolume?: Maybe<Scalars['Float']>;
  orderedVolume?: Maybe<Scalars['Float']>;
  product?: Maybe<Scalars['String']>;
  topoff?: Maybe<Scalars['Boolean']>;
};

export type LineOfService = {
  __typename?: 'LineOfService';
  active?: Maybe<Scalars['Boolean']>;
  ancestors: Array<LineOfService>;
  erpId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  nameWithAncestors?: Maybe<Scalars['String']>;
  nonEditableRecords?: Maybe<Array<Scalars['JSON']>>;
  parent?: Maybe<LineOfService>;
  parentId?: Maybe<Scalars['ID']>;
  shortName?: Maybe<Scalars['String']>;
  suppliers?: Maybe<Array<Supplier>>;
};

export type LineOfServiceCollection = {
  __typename?: 'LineOfServiceCollection';
  collection: Array<LineOfService>;
  metadata: MetaQuery;
};

export type LineOfServiceFilter = {
  active?: InputMaybe<Scalars['Boolean']>;
  all?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  losId?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<LineOfServiceFilter>>;
  parentLos?: InputMaybe<Array<Scalars['ID']>>;
  shortName?: InputMaybe<Scalars['String']>;
};

/** Default line of service Input */
export type LineOfServiceInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  erpId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ID']>;
  shortName?: InputMaybe<Scalars['String']>;
};

export type LineOfServiceSorter = {
  field: LineOfServiceSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum LineOfServiceSorterEnum {
  Erpid = 'ERPID',
  Name = 'NAME',
  Shortname = 'SHORTNAME'
}

/** Autogenerated input type of LinkOrUnlinkTags */
export type LinkOrUnlinkTagsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  linkTagIds?: InputMaybe<Array<Scalars['ID']>>;
  orderGroupId: Scalars['ID'];
  unlinkTagIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Autogenerated return type of LinkOrUnlinkTags */
export type LinkOrUnlinkTagsPayload = {
  __typename?: 'LinkOrUnlinkTagsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
  success: Scalars['Boolean'];
};

export type LinkedDriver = {
  __typename?: 'LinkedDriver';
  unassigned?: Maybe<Scalars['Int']>;
  workerWithPendingOrderStatus?: Maybe<Array<Driver>>;
  workerWithoutPendingOrderStatus?: Maybe<Array<Driver>>;
};

/** LoadingFromWarehouse Input */
export type LoadWithoutBolInput = {
  /** NoteInput object. */
  demurrageNotesAttributes?: InputMaybe<Array<NoteInput>>;
  /** Unix timestamp at the time of load. */
  executionTimestamp?: InputMaybe<Scalars['Int']>;
  /** LoadingOrder ID. Required incase of scheduled order. */
  loadingOrderId?: InputMaybe<Scalars['ID']>;
  /** LoadingOrderLineItemInput object. */
  loadingOrderLineItemsAttributes?: InputMaybe<Array<LoadingOrderLineItemInput>>;
  /** NoteInput object. */
  notesAttributes?: InputMaybe<Array<NoteInput>>;
  /** Shift ID. Required incase of packaged load in offline mode */
  shiftId?: InputMaybe<Scalars['ID']>;
  /** Warehouse ID. Required incase of new order. */
  warehouseId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of LoadWithoutBolMutation */
export type LoadWithoutBolMutationInput = {
  attributes: LoadWithoutBolInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of LoadWithoutBolMutation */
export type LoadWithoutBolMutationPayload = {
  __typename?: 'LoadWithoutBolMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
};

export type LoadingAccount = {
  __typename?: 'LoadingAccount';
  abbreviatedDestinationState?: Maybe<Scalars['String']>;
  carrierCustomerCode?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  destinationState?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Whether this loading account was auto-selected (set by backend) */
  isAutoSelected?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  lineOfServices?: Maybe<Array<LineOfService>>;
  loadingAccountTerminalProducts?: Maybe<Array<LoadingAccountTerminalProduct>>;
  loadingNumber?: Maybe<Scalars['String']>;
  /** Score (0-3) for how well this loading account matches given criteria */
  matchScore: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  pickupPointCodes?: Maybe<Array<PickupPointCode>>;
  /** Product categories this loading account handles (feature flag controlled) */
  productCategories?: Maybe<Array<ProductCategory>>;
  supplier?: Maybe<Supplier>;
  supplierCode?: Maybe<Scalars['String']>;
  supplierId?: Maybe<Scalars['ID']>;
};


export type LoadingAccountMatchScoreArgs = {
  productCategoryId: Scalars['ID'];
  state: Scalars['String'];
};

export type LoadingAccountCollection = {
  __typename?: 'LoadingAccountCollection';
  collection: Array<LoadingAccount>;
  metadata: MetaQuery;
};

export type LoadingAccountFilter = {
  all?: InputMaybe<Scalars['String']>;
  carrierCustomerCode?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  loadingNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<LoadingAccountFilter>>;
  supplierId?: InputMaybe<Scalars['ID']>;
};

/** Default loading Account Input */
export type LoadingAccountInput = {
  carrierCustomerCode?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  destinationState?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  loadingAccountTerminalProductsAttributes?: InputMaybe<Array<NestedLoadingAccountTerminalProductInput>>;
  loadingNumber: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  supplierCode?: InputMaybe<Scalars['String']>;
  supplierId: Scalars['ID'];
};

export type LoadingAccountSorter = {
  field: LoadingAccountSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum LoadingAccountSorterEnum {
  Carriercustomercode = 'CARRIERCUSTOMERCODE',
  Erpid = 'ERPID',
  Loadingnumber = 'LOADINGNUMBER',
  Name = 'NAME',
  Suppliercode = 'SUPPLIERCODE'
}

export type LoadingAccountTerminalProduct = {
  __typename?: 'LoadingAccountTerminalProduct';
  active: Scalars['Boolean'];
  brandTypes: Array<LatpBrandTypeEnum>;
  id: Scalars['ID'];
  loadingAccount?: Maybe<LoadingAccount>;
  loadingAccountId: Scalars['ID'];
  product?: Maybe<Product>;
  productId: Scalars['ID'];
  terminalsSupplier?: Maybe<TerminalsSupplier>;
  terminalsSupplierId: Scalars['ID'];
};

export type LoadingOrder = {
  __typename?: 'LoadingOrder';
  allowPartialDelivery?: Maybe<Scalars['Boolean']>;
  blendErrors?: Maybe<Array<BlendVolumeValidationError>>;
  bolNumbers?: Maybe<Scalars['String']>;
  demurrageNotes?: Maybe<Array<Note>>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** @deprecated Use summary */
  lineItemSummary?: Maybe<Array<LineItem>>;
  lineItems: Array<LoadingOrderLineItem>;
  linkedOrders?: Maybe<Array<DeliveryOrder>>;
  loadingInstruction?: Maybe<Scalars['String']>;
  loadingOrderProducts?: Maybe<Array<LoadingOrderProduct>>;
  loadingReceipts?: Maybe<Array<LoadingReceipt>>;
  notes?: Maybe<Array<Note>>;
  orderGroup?: Maybe<OrderGroup>;
  orderGroupId?: Maybe<Scalars['Int']>;
  orderLinks?: Maybe<Array<OrderLink>>;
  splitOrder?: Maybe<Scalars['Boolean']>;
  status: Scalars['String'];
  summary?: Maybe<Array<LoadingOrderSummary>>;
  /** @deprecated Dont use this. This uses too much resuorces */
  task?: Maybe<Task>;
  terminal?: Maybe<Terminal>;
  ticketId: Scalars['Int'];
  warehouseStatus?: Maybe<Scalars['String']>;
};

/** LoadingOrder Input */
export type LoadingOrderInput = {
  /** Deprecated. DO NOT USE. */
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** Allow partial delivery for loading order. */
  allowPartialDelivery?: InputMaybe<Scalars['Boolean']>;
  bolImages?: InputMaybe<Array<DirectAttachmentInput>>;
  /** NoteInput object. */
  demurrageNotesAttributes?: InputMaybe<Array<NoteInput>>;
  externalId?: InputMaybe<Scalars['String']>;
  /** LoadingOrder ID. Required on update. */
  id?: InputMaybe<Scalars['ID']>;
  /** LoadingOrder Instructions */
  loadingInstruction?: InputMaybe<Scalars['String']>;
  /** LoadingOrderProductInput object. */
  loadingOrderProductsAttributes?: InputMaybe<Array<LoadingOrderProductInput>>;
  /** LoadingReceiptInput object. */
  loadingReceiptsAttributes?: InputMaybe<Array<LoadingReceiptInput>>;
  /** NoteInput object. */
  notesAttributes?: InputMaybe<Array<NoteInput>>;
  orderEndLocation?: InputMaybe<GenericLocationInput>;
  /** OrderGroupInput object. */
  orderGroup?: InputMaybe<OrderGroupInput>;
  orderStartLocation?: InputMaybe<GenericLocationInput>;
  splitOrder?: InputMaybe<Scalars['Boolean']>;
  /** Terminal ID for the load. */
  terminalId?: InputMaybe<Scalars['ID']>;
};

export type LoadingOrderLineItem = {
  __typename?: 'LoadingOrderLineItem';
  assetId?: Maybe<Scalars['ID']>;
  backofficeId?: Maybe<Scalars['String']>;
  backofficeStatus?: Maybe<Scalars['String']>;
  blendProduct?: Maybe<Product>;
  blendProductId?: Maybe<Scalars['Int']>;
  compartment?: Maybe<Compartment>;
  compartmentId?: Maybe<Scalars['Int']>;
  data?: Maybe<Scalars['JSON']>;
  deliveryAsset?: Maybe<DeliveryAsset>;
  grossAmount?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  loadingReceiptProduct?: Maybe<LoadingReceiptProduct>;
  netAmount?: Maybe<Scalars['Float']>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['Int']>;
  volume?: Maybe<Scalars['Float']>;
};

export type LoadingOrderLineItemCollection = {
  __typename?: 'LoadingOrderLineItemCollection';
  collection: Array<LoadingOrderLineItem>;
  metadata: MetaQuery;
};

/** Loading Order Line Item Input */
export type LoadingOrderLineItemInput = {
  /** Deprecated. DO NOT USE. */
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** Asset ID. */
  assetId?: InputMaybe<Scalars['ID']>;
  /** ID of blend product that is formed after loading */
  blendProductId?: InputMaybe<Scalars['ID']>;
  /** Compartment ID. */
  compartmentId?: InputMaybe<Scalars['ID']>;
  /** Gross amount. */
  grossAmount?: InputMaybe<Scalars['Float']>;
  /** Gross volume. */
  grossVolume?: InputMaybe<Scalars['Float']>;
  /** LoadingOrderLineItem ID. */
  id?: InputMaybe<Scalars['ID']>;
  /** Loading order product ID. */
  loadingOrderProductId?: InputMaybe<Scalars['ID']>;
  /** LoadingReceiptProduct ID. */
  loadingReceiptProductId?: InputMaybe<Scalars['ID']>;
  /** Net amount. */
  netAmount?: InputMaybe<Scalars['Float']>;
  /** Net volume. */
  netVolume?: InputMaybe<Scalars['Float']>;
  /** Product ID */
  productId?: InputMaybe<Scalars['ID']>;
};

export type LoadingOrderProduct = {
  __typename?: 'LoadingOrderProduct';
  blendLoadingProduct?: Maybe<BlendLoadingProduct>;
  canSyncRequestedDeliveryVolume: Scalars['Boolean'];
  /** @deprecated Use Quantity */
  grossQuantity?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  /** @deprecated Use loadingReceipt -> loadingReceiptProducts -> loadingOrderLineItems */
  loadingOrderLineItems?: Maybe<Array<LoadingOrderLineItem>>;
  /** @deprecated Use Quantity */
  netQuantity?: Maybe<Scalars['Float']>;
  preferredSuppliers?: Maybe<Array<PreferredSupplier>>;
  product: Product;
  quantity?: Maybe<Scalars['Float']>;
  requestedQuantity?: Maybe<Scalars['Float']>;
};

/** LoadingProduct Input */
export type LoadingOrderProductInput = {
  /** Deprecated. DO NOT USE. */
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** ID of blend product that is formed after loading */
  blendProductId?: InputMaybe<Scalars['ID']>;
  /** Gross quantity. */
  grossQuantity?: InputMaybe<Scalars['Float']>;
  /** LoadingOrderProduct ID. Required on update. */
  id?: InputMaybe<Scalars['ID']>;
  /** PreferredSupplierInput object. */
  preferredSuppliersAttributes?: InputMaybe<Array<PreferredSupplierInput>>;
  /** Product ID. */
  productId?: InputMaybe<Scalars['ID']>;
  /** Requested quantity for the product in the loading order. */
  requestedQuantity?: InputMaybe<Scalars['Float']>;
  /** Flag parameter to specify whether to sync requested volume of delivery order. */
  updateRequestedDeliveryVolume?: InputMaybe<Scalars['Boolean']>;
};

export type LoadingOrderSummary = {
  __typename?: 'LoadingOrderSummary';
  productId?: Maybe<Scalars['ID']>;
  totalLoadedVolume?: Maybe<Scalars['Float']>;
  totalRequestedVolume?: Maybe<Scalars['Float']>;
};

export type LoadingReceipt = {
  __typename?: 'LoadingReceipt';
  bolPricings?: Maybe<Array<BolPricing>>;
  cardInTimestamp?: Maybe<Scalars['Int']>;
  cardOutTimestamp?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  loadingAccount?: Maybe<LoadingAccount>;
  loadingOrder: LoadingOrder;
  loadingReceiptProducts: Array<LoadingReceiptProduct>;
  name?: Maybe<Scalars['String']>;
  orderGroupsFees?: Maybe<Array<OrderGroupsFee>>;
  pandaDocuments?: Maybe<Array<PandaDocument>>;
  pickupPointCode?: Maybe<PickupPointCode>;
  receiptNumber?: Maybe<Scalars['String']>;
  terminalsSupplier?: Maybe<TerminalsSupplier>;
};

/** Loading Receipt Input */
export type LoadingReceiptInput = {
  /** Deprecated. DO NOT USE. */
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** Attachment containing Base64 conversion of BOL images. */
  attachmentsAttributes?: InputMaybe<Array<AttachmentInput>>;
  /** Card in time. */
  cardInTimestamp?: InputMaybe<Scalars['Int']>;
  /** Card out time. */
  cardOutTimestamp?: InputMaybe<Scalars['Int']>;
  /** Loading Receipt ID. */
  id?: InputMaybe<Scalars['ID']>;
  /** Loading account ID. */
  loadingAccountId?: InputMaybe<Scalars['ID']>;
  /** LoadingReceiptProductInput object. */
  loadingReceiptProductsAttributes?: InputMaybe<Array<LoadingReceiptProductInput>>;
  /** OrderGroupsFeeInput object. */
  orderGroupsFeesAttributes?: InputMaybe<Array<OrderGroupsFeeInput>>;
  /** Attachment IDs (Example BOLs). */
  pandaDocumentIds?: InputMaybe<Array<Scalars['ID']>>;
  /** PandaDocumentInput object. */
  pandaDocumentsAttributes?: InputMaybe<Array<PandaDocumentInput>>;
  /** Supplier ID. */
  pickupPointCodeId?: InputMaybe<Scalars['ID']>;
  /** Receipt identifier (Example: BOL number). */
  receiptNumber?: InputMaybe<Scalars['String']>;
  /** Supplier ID. */
  terminalsSupplierId?: InputMaybe<Scalars['ID']>;
};

export type LoadingReceiptProduct = {
  __typename?: 'LoadingReceiptProduct';
  blendLoadingProduct?: Maybe<BlendLoadingProduct>;
  data?: Maybe<Scalars['JSON']>;
  /** @deprecated Compute by adding line item's gross value */
  grossVolume?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  loadingOrderLineItems?: Maybe<Array<LoadingOrderLineItem>>;
  /** @deprecated Compute by adding line item's net value */
  netVolume?: Maybe<Scalars['Float']>;
  product?: Maybe<Product>;
  /** @deprecated Compute by adding line item's net/gross value, based on setting 'volume_net_gross_setting'' */
  volume?: Maybe<Scalars['Float']>;
};

/** Loading Receipt Product */
export type LoadingReceiptProductInput = {
  /** Deprecated. DO NOT USE. */
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** ID of blend_loading_products, required if loading is done for blend product. */
  blendLoadingProductId?: InputMaybe<Scalars['ID']>;
  /** Miscellaneous data. */
  data?: InputMaybe<Scalars['JSON']>;
  /** Gross volume. */
  grossVolume?: InputMaybe<Scalars['Float']>;
  /** LoadingReceiptProduct ID. */
  id?: InputMaybe<Scalars['ID']>;
  /** LoadingOrderLineItemInput object. */
  loadingOrderLineItemsAttributes?: InputMaybe<Array<LoadingOrderLineItemInput>>;
  /** Net volume. */
  netVolume?: InputMaybe<Scalars['Float']>;
  /** Product ID. */
  productId?: InputMaybe<Scalars['ID']>;
};

export type LoadingReceiptsFilter = {
  assetId: Scalars['ID'];
  bolNumber?: InputMaybe<Scalars['String']>;
  productId: Scalars['ID'];
};

/** Tank Monitor manual sync input */
export type ManualSyncInput = {
  deviceId: Scalars['String'];
  deviceProvider: ProvidersEnum;
};

/** Applied Margins Input */
export type ManualUpdateInput = {
  /** Send quantity inplace of amount. */
  amount?: InputMaybe<Scalars['Float']>;
  /** Applied Pricing */
  appliedPricingId?: InputMaybe<Scalars['ID']>;
  cardInTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  completedOn?: InputMaybe<Scalars['ISO8601DateTime']>;
  customer?: InputMaybe<ResourceDetailsInput>;
  customerBranch?: InputMaybe<ResourceDetailsInput>;
  doliIds?: InputMaybe<Array<Scalars['ID']>>;
  hubId?: InputMaybe<Scalars['ID']>;
  isManuallyUpdated?: InputMaybe<Scalars['Boolean']>;
  loliIds?: InputMaybe<Array<Scalars['ID']>>;
  marketId?: InputMaybe<Scalars['ID']>;
  /** These are delivery order line items. */
  orderGroupId?: InputMaybe<Scalars['ID']>;
  pricingId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  receiptNumber?: InputMaybe<Scalars['String']>;
  resetAll?: InputMaybe<Scalars['Boolean']>;
  resourcePricingId?: InputMaybe<Scalars['ID']>;
  supplierId?: InputMaybe<Scalars['ID']>;
  terminalId?: InputMaybe<Scalars['ID']>;
  /** Add OrderType Enum from AppliedPricing query */
  type?: InputMaybe<Scalars['String']>;
};

export type Mappable = Market | Product | RateType | Supplier;

export enum MappableTypeEnum {
  /** Market */
  Market = 'Market',
  /** PandaPrice::RateType */
  PandaPriceRateType = 'PandaPrice_RateType',
  /** Product */
  Product = 'Product',
  /** Supplier */
  Supplier = 'Supplier'
}

export type Margin = {
  __typename?: 'Margin';
  id?: Maybe<Scalars['ID']>;
  marginRate?: Maybe<Scalars['Float']>;
  marginType?: Maybe<Scalars['String']>;
  marginUnit?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  range?: Maybe<Array<MarginRangeAttribute>>;
  rateType?: Maybe<Scalars['String']>;
};

export type MarginCollection = {
  __typename?: 'MarginCollection';
  collection: Array<Margin>;
  metadata: MetaDataQuery;
};

export type MarginFilter = {
  all?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<MarginFilter>>;
};

export type MarginRangeAttribute = {
  __typename?: 'MarginRangeAttribute';
  endRange?: Maybe<Scalars['String']>;
  rangeRate?: Maybe<Scalars['String']>;
  startRange?: Maybe<Scalars['String']>;
};

/** Range Input */
export type MarginRangeAttributeInput = {
  endRange?: InputMaybe<Scalars['String']>;
  rangeRate?: InputMaybe<Scalars['String']>;
  startRange?: InputMaybe<Scalars['String']>;
};

/** Enum for margin type */
export enum MarginTypeEnum {
  /** fixed */
  Fixed = 'fixed',
  /** volume based */
  VolumeBased = 'volume_based'
}

export type MarginsProduct = {
  __typename?: 'MarginsProduct';
  id?: Maybe<Scalars['ID']>;
  margin?: Maybe<Margin>;
  productId: Scalars['ID'];
  resourcePricing?: Maybe<ResourcePricing>;
};

export type Market = {
  __typename?: 'Market';
  active?: Maybe<Scalars['Boolean']>;
  address?: Maybe<Scalars['String']>;
  hubResources?: Maybe<Array<HubResource>>;
  hubs?: Maybe<Array<Hub>>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type MarketResource = {
  __typename?: 'MarketResource';
  id: Scalars['ID'];
  market: Market;
  marketable: Marketable;
  marketableId: Scalars['ID'];
  marketableType: Scalars['String'];
};

/** Manages a connection with market */
export type MarketResourceInput = {
  /** Only pass and set true when need to destroy */
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** Market Resource ID. Required on update. */
  id?: InputMaybe<Scalars['ID']>;
  /** ID of market to be associated with. */
  marketId?: InputMaybe<Scalars['ID']>;
};

/** Marketable Type */
export type Marketable = Customer | CustomerBranch;

/** Meta data used to fetch next records and retrive total records */
export type MetaDataQuery = {
  __typename?: 'MetaDataQuery';
  hasMore: Scalars['Boolean'];
  totalCount?: Maybe<Scalars['Int']>;
  total_entries?: Maybe<Scalars['Int']>;
};

/** Meta data used to fetch next records and retrive total records */
export type MetaQuery = {
  __typename?: 'MetaQuery';
  hasMore: Scalars['Boolean'];
  totalCount?: Maybe<Scalars['Int']>;
  total_entries?: Maybe<Scalars['Int']>;
};

export type MigrationConfig = {
  __typename?: 'MigrationConfig';
  migrationV1Api?: Maybe<Scalars['String']>;
  migrationV1XApiKey?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of ModifyInventory */
export type ModifyInventoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  shiftAsset: BulkPlantsAssetInventoriesInput;
  shiftId: Scalars['ID'];
};

/** Autogenerated return type of ModifyInventory */
export type ModifyInventoryPayload = {
  __typename?: 'ModifyInventoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  shift?: Maybe<Shift>;
};

/** Autogenerated input type of ModifyLineItemProduct */
export type ModifyLineItemProductInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Flag to indicate if the request is from the customer portal */
  fromCustomerPortal?: InputMaybe<Scalars['Boolean']>;
  /** DeliveryOrderLineItem ID */
  id: Scalars['ID'];
  /** The new product ID */
  productId: Scalars['ID'];
};

/** Autogenerated return type of ModifyLineItemProduct */
export type ModifyLineItemProductPayload = {
  __typename?: 'ModifyLineItemProductPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
};

/** Autogenerated input type of ModifyShiftInventory */
export type ModifyShiftInventoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  shiftDeliveryAssets: Array<AssetInventoriesInput>;
  shiftId: Scalars['ID'];
};

/** Autogenerated return type of ModifyShiftInventory */
export type ModifyShiftInventoryPayload = {
  __typename?: 'ModifyShiftInventoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  shift?: Maybe<Shift>;
};

/** Enum for various action of movement order line item */
export enum MovementActionEnum {
  BackToYard = 'back_to_yard',
  KeepItAttached = 'keep_it_attached',
  LeaveAtCustomerLocation = 'leave_at_customer_location',
  LeaveAtYard = 'leave_at_yard'
}

export type MovementOrder = {
  __typename?: 'MovementOrder';
  addendumAgreementDocuments?: Maybe<Array<DocusealDocument>>;
  asset?: Maybe<Asset>;
  assetDetailsNotes?: Maybe<Scalars['String']>;
  assetMovementLocation?: Maybe<AssetMovementLocation>;
  assignedTankSize?: Maybe<Scalars['String']>;
  assignedTankType?: Maybe<Scalars['String']>;
  customerSignature?: Maybe<PandaDocument>;
  data?: Maybe<MovementOrderData>;
  fromCustomerBranch?: Maybe<CustomerBranch>;
  getSignatureOnDelivery?: Maybe<Scalars['Boolean']>;
  hasActiveAddendumAgreement?: Maybe<Scalars['Boolean']>;
  hub?: Maybe<Hub>;
  id: Scalars['ID'];
  instruction?: Maybe<Scalars['String']>;
  leaLineItem?: Maybe<LeaLineItem>;
  movementOrderCustomItems?: Maybe<Array<MovementOrderCustomItems>>;
  movementOrderLineItems?: Maybe<Array<MovementOrderLineItem>>;
  notes?: Maybe<Array<Note>>;
  orderGroup: OrderGroup;
  orderGroupId: Scalars['ID'];
  orderLinks?: Maybe<Array<OrderLink>>;
  orderNotes?: Maybe<Scalars['String']>;
  orderType?: Maybe<MovementOrderTypeEnum>;
  product?: Maybe<Product>;
  requestedMovementOrderLineItems?: Maybe<Array<RequestedMovementOrderLineItem>>;
  requestedProducts?: Maybe<Array<Product>>;
  requestedTankSize?: Maybe<Scalars['String']>;
  requestedTankType?: Maybe<Scalars['String']>;
  resetTank?: Maybe<Scalars['Boolean']>;
  resourceStatuses?: Maybe<Array<ResourceStatus>>;
  signature?: Maybe<PandaDocument>;
  skipReason?: Maybe<Scalars['String']>;
  toCustomerBranch: CustomerBranch;
  totalDeliveriesCount?: Maybe<Scalars['Int']>;
  totalGallonsDelivered?: Maybe<Scalars['Float']>;
};


export type MovementOrderTotalDeliveriesCountArgs = {
  endDate?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Int']>;
};


export type MovementOrderTotalGallonsDeliveredArgs = {
  endDate?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Int']>;
};

export type MovementOrderCollection = {
  __typename?: 'MovementOrderCollection';
  collection: Array<MovementOrder>;
  metadata: MetaQuery;
};

export type MovementOrderCustomItems = {
  __typename?: 'MovementOrderCustomItems';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
};

/** Movement Order Customer Items Input */
export type MovementOrderCustomItemsInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** ID of Custom Item. Required on update. */
  id?: InputMaybe<Scalars['ID']>;
  /** Movement Order ID. */
  movementOrderId?: InputMaybe<Scalars['ID']>;
  /** Name of the Custom Item. */
  name?: InputMaybe<Scalars['String']>;
  /** Quantity of the Custom Item. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type MovementOrderData = {
  __typename?: 'MovementOrderData';
  /** List of custom items in the movement order */
  customItems?: Maybe<Array<LeaCoreCustomItem>>;
  tankMonitorData?: Maybe<LeaTankMonitorData>;
};

/** Movement Order Input */
export type MovementOrderInput = {
  /** Asset Details Notes */
  assetDetailsNotes?: InputMaybe<Scalars['String']>;
  /** Asset ID. */
  assetId?: InputMaybe<Scalars['ID']>;
  /** Assigned Tank Size. */
  assignedTankSize?: InputMaybe<Scalars['Float']>;
  /** Assigned Tank Type. */
  assignedTankType?: InputMaybe<Scalars['String']>;
  /** Compartments Attributes for the Movement Order Asset. */
  compartmentsAttributes?: InputMaybe<Array<NestedCompartmentInput>>;
  /** Custom Items Input object. */
  customItems?: InputMaybe<Array<LeaCoreCustomItemInput>>;
  /** PandaDocumentInput object. */
  customerSignatureAttributes?: InputMaybe<PandaDocumentInput>;
  /** From Customer Branch/Site ID. */
  fromCustomerBranchId?: InputMaybe<Scalars['ID']>;
  /** Get Signature On Delivery */
  getSignatureOnDelivery?: InputMaybe<Scalars['Boolean']>;
  /** Customer Branch/Site Hub ID. */
  hubId?: InputMaybe<Scalars['ID']>;
  /** Movement Order ID. */
  id?: InputMaybe<Scalars['ID']>;
  /** MovementOrder Instruction Type. */
  instruction?: InputMaybe<Scalars['String']>;
  /** Movement order Custom Items Input object. */
  movementOrderCustomItemsAttributes?: InputMaybe<Array<MovementOrderCustomItemsInput>>;
  /** Movement Order Line Item Input object. */
  movementOrderLineItemsAttributes?: InputMaybe<Array<MovementOrderLineItemInput>>;
  /** Support multiple products in movement order */
  movementOrderRequestedProductsAttributes?: InputMaybe<Array<MovementOrderRequestedProductsInput>>;
  /** Movement Order Note Input. */
  notesAttributes?: InputMaybe<Array<NoteInput>>;
  /** Descriptive order notes. */
  orderNotes?: InputMaybe<Scalars['String']>;
  /** Movement Order Type */
  orderType?: InputMaybe<MovementOrderTypeEnum>;
  /** Requested Product */
  productId?: InputMaybe<Scalars['ID']>;
  /** Movement Order Line Item Input object. */
  requestedMovementOrderLineItemsAttributes?: InputMaybe<Array<RequestedMovementOrderLineItemInput>>;
  /** Requested Tank Size. */
  requestedTankSize?: InputMaybe<Scalars['Float']>;
  /** Requested Tank Type. */
  requestedTankType?: InputMaybe<Scalars['String']>;
  /** Indicates whether the tank should be reset after movement order completion */
  resetTank?: InputMaybe<Scalars['Boolean']>;
  resourceStatusesAttributes?: InputMaybe<Array<ResourceStatusInput>>;
  /** PandaDocumentInput object. */
  signatureAttributes?: InputMaybe<PandaDocumentInput>;
  skipReason?: InputMaybe<Scalars['String']>;
  tankMonitorData?: InputMaybe<LeaTankMonitorDataInput>;
  /** To Customer Branch/Site ID. */
  toCustomerBranchId?: InputMaybe<Scalars['ID']>;
};

export type MovementOrderLineItem = {
  __typename?: 'MovementOrderLineItem';
  action?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isPeripheralRemoved?: Maybe<Scalars['Boolean']>;
  ownershipStatus?: Maybe<Scalars['String']>;
  peripheral?: Maybe<Peripheral>;
  peripheralInstances?: Maybe<Array<PeripheralInstance>>;
  resourceStatuses?: Maybe<Array<ResourceStatus>>;
};

export type MovementOrderLineItemAttributes = {
  __typename?: 'MovementOrderLineItemAttributes';
  action?: Maybe<Scalars['String']>;
  assetsPeripheralsAttributes?: Maybe<Array<AssetsPeripheral>>;
  ownershipStatus?: Maybe<Scalars['String']>;
  peripheralId?: Maybe<Scalars['ID']>;
};

/** Movement Order Line Item Input */
export type MovementOrderLineItemInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** Action of movement order line item. */
  action?: InputMaybe<MovementActionEnum>;
  assetsPeripheralsAttributes?: InputMaybe<Array<AssetsPeripheralInput>>;
  /** Condition of the peripheral (e.g. new, old). */
  condition?: InputMaybe<Scalars['String']>;
  /** ID of Movement Order Line Item. Required on update. */
  id?: InputMaybe<Scalars['ID']>;
  isPeripheralRemoved?: InputMaybe<Scalars['Boolean']>;
  /** Movement Order ID. */
  movementOrderId?: InputMaybe<Scalars['ID']>;
  /** Ownership status of movement order line item. */
  ownershipStatus?: InputMaybe<MovementOwnershipStatusEnum>;
  /** Peripheral Input object */
  peripheralAttributes?: InputMaybe<PeripheralInput>;
  /** Peripheral ID. */
  peripheralId?: InputMaybe<Scalars['ID']>;
  /** Peripheral Instance Input object. */
  peripheralInstancesAttributes?: InputMaybe<Array<PeripheralInstanceInput>>;
  /** Resource Statuses Attributes. */
  resourceStatusesAttributes?: InputMaybe<Array<ResourceStatusInput>>;
};

/** Movement Order Requested Products Input */
export type MovementOrderRequestedProductsInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** ID of Movement order requested product. Required on update. */
  id?: InputMaybe<Scalars['ID']>;
  /** Movement Order ID. */
  movementOrderId?: InputMaybe<Scalars['ID']>;
  /** Product ID. */
  productId?: InputMaybe<Scalars['ID']>;
};

/** Enum for various type of movement order */
export enum MovementOrderTypeEnum {
  Delivery = 'delivery',
  Pickup = 'pickup',
  Relocate = 'relocate',
  Transfer = 'transfer'
}

/** Enum for ownership status of movement order line item */
export enum MovementOwnershipStatusEnum {
  Leased = 'leased',
  Purchased = 'purchased'
}

export type Mutation = {
  __typename?: 'Mutation';
  accountingAsync?: Maybe<AccountingAsyncPayload>;
  acknowledgeNote?: Maybe<AcknowledgeNotePayload>;
  addAssetForWarehouse?: Maybe<AddAssetForWarehousePayload>;
  addAssetToDeliveryOrder?: Maybe<AddAssetToDeliveryOrderPayload>;
  addCodeToAsset?: Maybe<AddCodeToAssetPayload>;
  addFeeToOrderGroup?: Maybe<AddFeeToOrderGroupPayload>;
  addFeesToOrderGroup?: Maybe<AddFeesToOrderGroupPayload>;
  addOrderGroupTax?: Maybe<CreateOrderGroupTaxesPayload>;
  addOrderGroupsToShift?: Maybe<AddOrderGroupsToShiftPayload>;
  addQrCodeToAsset?: Maybe<AddQrCodeToAssetPayload>;
  adjustInventory?: Maybe<AdjustInventoryPayload>;
  archiveDriver?: Maybe<ArchiveDriversPayload>;
  arrivedAtCustomer?: Maybe<ArrivedAtCustomerPayload>;
  arrivedAtTerminal?: Maybe<ArrivedAtTerminalPayload>;
  assignDeliveryAssetWithInventory?: Maybe<AssignDeliveryAssetWithInventoryPayload>;
  assignPandaBox?: Maybe<AssignPandaBoxPayload>;
  associateIrelyEntityWithFp?: Maybe<AssociateIrelyEntityWithFpPayload>;
  autoLinkOrders?: Maybe<AutoLinkOrdersPayload>;
  brokerageCreateOrderGroup?: Maybe<BrokerageCreateOrderGroupMutationPayload>;
  /** Pending Order Groups worker bulk update */
  bulkAssigns?: Maybe<BatchOperationsPayload>;
  bulkAsyncRefetchOrderQueueStatus?: Maybe<BulkAsyncRefetchOrderQueueStatusPayload>;
  /** Blocked Order Groups bulk unblock */
  bulkOrderUnblocks?: Maybe<UpdateStatusPayload>;
  bulkUpdatePricings?: Maybe<BulkUpdatePricingsPayload>;
  calculatePricing?: Maybe<CalculatePricingPayload>;
  changeOrderGroupAssignment?: Maybe<ChangeOrderGroupAssignmentPayload>;
  changeShiftAsset?: Maybe<ChangeAssetPayload>;
  clearDataShift?: Maybe<ClearDataShiftPayload>;
  /** Create or update a configuration saved view */
  configView?: Maybe<CreateOrUpdateConfigViewPayload>;
  confirmOrCancelOrders?: Maybe<ConfirmOrCancelOrdersPayload>;
  confirmTwoFactor?: Maybe<ConfirmTwoFactorPayload>;
  copyPreviousRecords?: Maybe<CopyPreviousRecordsPayload>;
  createAppVersion?: Maybe<CreateAppVersionPayload>;
  createAsset?: Maybe<CreateAssetsPayload>;
  createAttachedAsset?: Maybe<CreateAttachedAssetPayload>;
  createAttachedAssetAvailability?: Maybe<CreateAttachedAssetAvailabilityPayload>;
  createBolPricing?: Maybe<CreateBolPricingPayload>;
  createBolRetain?: Maybe<CreateBolRetainPayload>;
  createBrand?: Maybe<CreateBrandsPayload>;
  createCommonCarrier?: Maybe<CreateCommonCarrierPayload>;
  /** Creates delivery order from self dispatch */
  createCompletedDeliveryOrder?: Maybe<CreateDeliveryOrderPayload>;
  /** Creates loading order from self dispatch */
  createCompletedLoadingOrder?: Maybe<CreateLoadingOrderPayload>;
  createCrudePricings?: Maybe<CreateCrudePricingPayload>;
  createCustomer?: Maybe<CreateCustomersPayload>;
  createCustomerAsset?: Maybe<CreateCustomerAssetPayload>;
  createCustomerBranch?: Maybe<CreateCustomerBranchesPayload>;
  createCustomerSegment?: Maybe<CreateCustomerSegmentsPayload>;
  createCustomerUser?: Maybe<CreateCustomerUsersPayload>;
  createDegreeDaySetting?: Maybe<CreateDegreeDaySettingPayload>;
  createDirectUpload?: Maybe<DirectUpload>;
  createDriver?: Maybe<CreateDriversPayload>;
  createDriverDemurrage?: Maybe<CreateDriverDemurragePayload>;
  createDriverRates?: Maybe<CreateDriverRatesPayload>;
  createFee?: Maybe<CreateFeesPayload>;
  createFeedback?: Maybe<CreateFeedbacksPayload>;
  createGroup?: Maybe<CreateGroupPayload>;
  createInventoryRecord?: Maybe<CreateInventoryRecordPayload>;
  createInvoice?: Maybe<CreateInvoicePayload>;
  createLeaCore?: Maybe<CreateLeaCorePayload>;
  createLeaMovementOrders?: Maybe<CreateLeaMovementOrdersPayload>;
  createLineOfService?: Maybe<CreateLineOfServicesPayload>;
  createLoadingAccount?: Maybe<CreateLoadingAccountsPayload>;
  createMargin?: Maybe<CreateMarginPayload>;
  createMarket?: Maybe<CreateMarketsPayload>;
  createMovementOrder?: Maybe<CreateMovementOrderPayload>;
  createMultiOrderTopOff?: Maybe<CreateMultiOrderTopOffPayload>;
  createNote?: Maybe<CreateNotePayload>;
  createOrUpdateCustomerPortalConfiguration?: Maybe<CreateOrUpdateCustomerPortalConfigurationPayload>;
  createOrUpdateFormProgress?: Maybe<CreateOrUpdateFormProgressPayload>;
  createOrUpdateMovementOrderLineItem?: Maybe<CreateOrUpdateMovementOrderLineItemPayload>;
  createOrUpdateNotificationTemplate?: Maybe<CreateOrUpdateNotificationTemplatePayload>;
  createOrUpdateQrCode?: Maybe<CreateOrUpdateQrCodePayload>;
  createOrUpdateRole?: Maybe<CreateOrUpdateRolePayload>;
  createOrUpdateRouteFlushing?: Maybe<CreateOrUpdatePayload>;
  createOrUpdateTags?: Maybe<CreateOrUpdateTagPayload>;
  createOrUpdateTransferOrderLineItem?: Maybe<CreateOrUpdateTransferOrderLineItemPayload>;
  createOrderGroup?: Maybe<CreateOrderGroupPayload>;
  createOrderGroups?: Maybe<CreateOrderGroupsPayload>;
  createOrderInvoice?: Maybe<CreateOrderInvoicePayload>;
  createOrderLink?: Maybe<CreateOrderLinkPayload>;
  createOrderQuote?: Maybe<CreateQuotePayload>;
  createPandaBox?: Maybe<CreatePandaBoxPayload>;
  createPaymentTerm?: Maybe<CreatePaymentTermsPayload>;
  createPeripheral?: Maybe<CreatePeripheralPayload>;
  createPickupPointCode?: Maybe<CreatePickupPointCodesPayload>;
  createPoc?: Maybe<CreatePocPayload>;
  createPricings?: Maybe<CreatePricingPayload>;
  createProduct?: Maybe<CreateProductsPayload>;
  createProductOrderFees?: Maybe<CreateProductOrderFeesPayload>;
  createProductPurchaseLimit?: Maybe<CreateProductPurchaseLimitsPayload>;
  createRackMarket?: Maybe<CreateRackMarketPayload>;
  createRateType?: Maybe<CreateRatePayload>;
  createRawShift?: Maybe<CreateRawShiftPayload>;
  createResourceComponent?: Maybe<CreateResourceComponentPayload>;
  createResourcePricings?: Maybe<CreateResourcePricingPayload>;
  createResourceSchedule?: Maybe<CreateResourceSchedulePayload>;
  /** Create a saved view */
  createSavedView?: Maybe<CreateSavedViewPayload>;
  createSetting?: Maybe<CreateSettingPayload>;
  createShift?: Maybe<CreateShiftPayload>;
  createSiteRecurrence?: Maybe<CreateSiteRecurrencePayload>;
  createSupplier?: Maybe<CreateSuppliersPayload>;
  createSupplierV2?: Maybe<CreateSuppliersV2Payload>;
  createSupplierV3?: Maybe<CreateSuppliersV3Payload>;
  createTax?: Maybe<CreateTaxPayload>;
  createTerminal?: Maybe<CreateTerminalsPayload>;
  createTerminalsSupplier?: Maybe<CreateTerminalsSuppliersPayload>;
  createTransferOrder?: Maybe<CreateTransferOrderPayload>;
  createUpdateAliasMapping?: Maybe<CreateUpdateAliasMappingPayload>;
  createUpdateIrelyFilter?: Maybe<CreateUpdateIrelyFilterPayload>;
  createZoneProductBatches?: Maybe<CreateZoneProductBatchesPayload>;
  deleteAsset?: Maybe<DeleteAssetsPayload>;
  deleteBolPricing?: Maybe<DeleteBolPricingPayload>;
  deleteBrand?: Maybe<DeleteBrandsPayload>;
  deleteCustomerBranch?: Maybe<DeleteCustomerBranchesPayload>;
  deleteDegreeDaySetting?: Maybe<DeleteDegreeDaySettingPayload>;
  deleteDeliveryOrder?: Maybe<DeleteDeliveryOrderPayload>;
  deleteFee?: Maybe<DeleteFeesPayload>;
  deleteLeaCore?: Maybe<DeleteLeaCorePayload>;
  deleteLineOfService?: Maybe<DeleteLineOfServicesPayload>;
  deleteLoadingOrder?: Maybe<DeleteLoadingOrderPayload>;
  deleteMovementOrder?: Maybe<DeleteMovementOrderPayload>;
  deleteOrderLink?: Maybe<DeleteOrderLinkPayload>;
  deletePandaPriceResource?: Maybe<DeletePandaPriceResourcePayload>;
  deletePeripheral?: Maybe<DeletePeripheralPayload>;
  deletePickupPointCode?: Maybe<DeletePickupPointCodesPayload>;
  deleteRackMarket?: Maybe<DeleteRackMarketPayload>;
  deleteRawShift?: Maybe<DeleteRawShiftPayload>;
  deleteRecurrence?: Maybe<DeleteRecurrencePayload>;
  deleteResource?: Maybe<DeleteResourcePayload>;
  deleteRouteFlushing?: Maybe<DeletePayload>;
  deleteShiftPlan?: Maybe<DeleteShiftPlanPayload>;
  deleteSiteRecurrence?: Maybe<DeleteSiteRecurrencePayload>;
  deleteSupplier?: Maybe<DeleteSuppliersPayload>;
  deleteTerminal?: Maybe<DeleteTerminalsPayload>;
  deleteTransferOrder?: Maybe<DeleteTransferOrderPayload>;
  deleteZoneProductBatches?: Maybe<DeleteZoneProductBatchesPayload>;
  detachAttachedAsset?: Maybe<DetachAssetPayload>;
  directUploadPandaDocument?: Maybe<DirectUploadPandaDocumentPayload>;
  disableTwoFactor?: Maybe<DisableTwoFactorPayload>;
  duplicateLeaCore?: Maybe<DuplicateLeaCorePayload>;
  duplicateOrder?: Maybe<DuplicateOrderGroupPayload>;
  emailDeliveryTicket?: Maybe<EmailDeliveryTicketPayload>;
  emailResourcePricing?: Maybe<EmailResourcePricingPayload>;
  enableTwoFactor?: Maybe<EnableTwoFactorPayload>;
  endShift?: Maybe<EndShiftPayload>;
  exportOrders?: Maybe<ExportOrdersPayload>;
  exportOrdersCsv: ExportOrdersCsvPayload;
  exportSuppliersCsv: ExportSuppliersCsvPayload;
  exportTransactions?: Maybe<ExportTransactionPayload>;
  fundCustomerBalance?: Maybe<FundCustomerBalancePayload>;
  generateInvoice?: Maybe<GenerateInvoicePayload>;
  generatePresignedMetabaseUrl?: Maybe<GeneratePresignedMetabaseUrlPayload>;
  generateQrCodes?: Maybe<GenerateQrCodesPayload>;
  generateSalesReport?: Maybe<GenerateSalesReportPayload>;
  generateTaxReport?: Maybe<GenerateTaxReportPayload>;
  gotoCustomer?: Maybe<GotoCustomerPayload>;
  gotoTerminal?: Maybe<GotoTerminalPayload>;
  importRecords?: Maybe<ImportRecordsPayload>;
  indexResource?: Maybe<IndexResourcePayload>;
  inviteCustomerToPortal?: Maybe<InviteCustomerToPortalPayload>;
  linkOrUnlinkTags?: Maybe<LinkOrUnlinkTagsPayload>;
  mergeCustomerResources?: Maybe<CustomerResourcesPayload>;
  modifyInventory?: Maybe<ModifyInventoryPayload>;
  modifyLineItemProduct?: Maybe<ModifyLineItemProductPayload>;
  modifyShiftInventory?: Maybe<ModifyShiftInventoryPayload>;
  optimizeShiftPlan?: Maybe<OptimizeShiftPlanPayload>;
  partialSync?: Maybe<PartialSyncPayload>;
  postDeliveryNoteCreate?: Maybe<PostDeliveryNoteCreatePayload>;
  purgeUserImage?: Maybe<PurgeUserImagePayload>;
  pushOrderToFdn?: Maybe<PushOrderToFdnPayload>;
  quickbookDeliveryOrderSync?: Maybe<SalesOrderSyncPayload>;
  quickbookShiftSync?: Maybe<ShiftsSyncPayload>;
  /** Reauthenticates the users by recreating access token based on refresh token */
  reauthenticateUser?: Maybe<ReauthenticatePayload>;
  recalculateInventoryRecords?: Maybe<RecalculateInventoryRecordsPayload>;
  recalculatePricing?: Maybe<RecalculatePricingPayload>;
  refetchCustomersAsynchronously?: Maybe<RefetchCustomersAsynchronouslyPayload>;
  refetchOrderQueueStatus?: Maybe<RefetchOrderQueueStatusPayload>;
  refreshApiToken?: Maybe<RefreshApiTokenPayload>;
  removeCodeFromAsset?: Maybe<RemoveCodePayload>;
  removeFeeToOrderGroup?: Maybe<RemoveFeeToOrderGroupPayload>;
  removeFeesFromOrderGroup?: Maybe<RemoveFeesFromOrderGroupPayload>;
  removeFormProgress?: Maybe<RemoveFormProgressPayload>;
  removeQrCodeFromAsset?: Maybe<RemoveQrCodePayload>;
  requestContactOtp?: Maybe<RequestContactOtpPayload>;
  resendDocusealEmail?: Maybe<ResendDocusealEmailPayload>;
  resetPassword?: Maybe<ResetPasswordPayload>;
  resetPricing?: Maybe<ResetPricingPayload>;
  saveTenantContent?: Maybe<SaveTenantContentPayload>;
  sendBulkOrderEmailToDriver?: Maybe<SendBulkOrderEmailToDriverPayload>;
  sendCommonCarrierEmail?: Maybe<SendCommonCarrierEmailPayload>;
  sendLeaMail?: Maybe<SendLeaMailPayload>;
  sendMailToPoc?: Maybe<SendMailToPocPayload>;
  sendManualNotification?: Maybe<SendManualNotificationPayload>;
  sendOrderCreatedEmailToDriver?: Maybe<SendOrderCreateEmailToDriverPayload>;
  sendPasswordResetInstruction?: Maybe<SendPasswordResetInstructionPayload>;
  sendTestNotificationTemplate?: Maybe<SendTestNotificationTemplatePayload>;
  shiftReconciliation?: Maybe<ShiftReconciliationPayload>;
  /** Signs in user */
  signInUser?: Maybe<SignInPayload>;
  startShift?: Maybe<StartShiftPayload>;
  submitDelivery?: Maybe<SubmitDeliveryPayload>;
  submitLoading?: Maybe<SubmitLoadingPayload>;
  /** Load  from warehouse without BOL */
  submitLoadingWithoutBol?: Maybe<LoadWithoutBolMutationPayload>;
  switchTenant?: Maybe<SwitchTenantPayload>;
  syncAllTanks?: Maybe<SyncAllPayload>;
  syncDataFromVendor?: Maybe<SyncDataFromVendorPayload>;
  syncIndividualTank?: Maybe<SyncIndividualTankPayload>;
  tmApproveOrCancelOrders?: Maybe<TmApproveOrCancelOrdersPayload>;
  tmCreateMultiOrderTopOff?: Maybe<TmCreateMultiOrderTopOffPayload>;
  unlinkTankMonitor?: Maybe<UnlinkTankMonitorPayload>;
  updateAppliedPricing?: Maybe<UpdateAppliedPricingPayload>;
  updateAsset?: Maybe<UpdateAssetsPayload>;
  updateAttachedAssets?: Maybe<UpdateAttachedAssetPayload>;
  updateBolPricing?: Maybe<UpdateBolPricingPayload>;
  updateBrand?: Maybe<UpdateBrandsPayload>;
  updateCardLockTransaction?: Maybe<UpdateCardLockTransactionPayload>;
  updateCommonCarrier?: Maybe<UpdateCommonCarrierPayload>;
  updateCrudePricings?: Maybe<UpdateCrudePricingPayload>;
  updateCustomer?: Maybe<UpdateCustomersPayload>;
  updateCustomerBranch?: Maybe<UpdateCustomerBranchesPayload>;
  updateCustomerPreferences?: Maybe<UpdateCustomerPreferencesPayload>;
  updateCustomerReport?: Maybe<CustomerReport>;
  updateCustomerSegment?: Maybe<UpdateCustomerSegmentsPayload>;
  updateCustomerUser?: Maybe<UpdateCustomerUsersPayload>;
  updateDegreeDaySetting?: Maybe<UpdateDegreeDaySettingPayload>;
  updateDeliveryOrder?: Maybe<UpdateDeliveryOrderPayload>;
  updateDeliveryOrderLineItem?: Maybe<UpdateDeliveryOrderLineItemPayload>;
  updateDriver?: Maybe<UpdateDriversPayload>;
  updateDriverDemurrage?: Maybe<UpdateDriverDemurragePayload>;
  updateDriverOtp?: Maybe<ChangeDriverOtpPayload>;
  updateDriverShift?: Maybe<UpdateDriverShiftPayload>;
  updateFee?: Maybe<UpdateFeesPayload>;
  updateGroup?: Maybe<UpdateGroupPayload>;
  updateInvoice?: Maybe<UpdateInvoicePayload>;
  updateLeaCore?: Maybe<UpdateLeaCorePayload>;
  updateLeaDocument?: Maybe<UpdateLeaDocumentPayload>;
  updateLineOfService?: Maybe<UpdateLineOfServicesPayload>;
  updateLoadingAccount?: Maybe<UpdateLoadingAccountsPayload>;
  updateLoadingOrder?: Maybe<UpdateLoadingOrderPayload>;
  updateLoadingOrderLineItem?: Maybe<UpdateLoadingOrderLineItemPayload>;
  updateMargin?: Maybe<UpdateMarginPayload>;
  updateMarket?: Maybe<UpdateMarketsPayload>;
  updateMovementOrder?: Maybe<UpdateMovementOrderPayload>;
  updateNote?: Maybe<UpdateNotePayload>;
  updateNotificationTemplateStatus?: Maybe<UpdateNotificationTemplateStatusPayload>;
  updateOrderGroup?: Maybe<UpdateOrderGroupMutationPayload>;
  updateOrderLink?: Maybe<UpdateOrderLinkPayload>;
  /** Update Order Group Worker and Start On */
  updateOrderWorkerDate?: Maybe<UpdateOrderWorkerDatePayload>;
  updatePaymentTerm?: Maybe<UpdatePaymentTermsPayload>;
  updatePeripheral?: Maybe<UpdatePeripheralPayload>;
  updatePickupPointCode?: Maybe<UpdatePickupPointCodesPayload>;
  updatePoc?: Maybe<UpdatePocPayload>;
  updatePostDeliveryPhoto?: Maybe<UpdatePostDeliveryPhotoPayload>;
  updatePricings?: Maybe<UpdatePricingPayload>;
  updateProduct?: Maybe<UpdateProductsPayload>;
  updateProductPurchaseLimit?: Maybe<UpdateProductPurchaseLimitsPayload>;
  updateRackMarket?: Maybe<UpdateRackMarketPayload>;
  updateRateType?: Maybe<UpdateRatePayload>;
  updateRawPricingImportSession?: Maybe<UpdateRawPricingImportSessionPayload>;
  updateRawShift?: Maybe<UpdateRawShiftPayload>;
  updateResource?: Maybe<UpdateResourcePayload>;
  updateResourcePricings?: Maybe<UpdateResourcePricingPayload>;
  updateRouteConfig?: Maybe<UpdateRouteConfigPayload>;
  /** Update a saved view */
  updateSavedView?: Maybe<UpdateSavedViewPayload>;
  updateSettings?: Maybe<UpdateSettingsPayload>;
  updateShift?: Maybe<UpdateShiftPayload>;
  updateShiftPlanDelivery?: Maybe<UpdateStopDetailsPayload>;
  updateShiftPlanTruck?: Maybe<UpdateTruckDetailsPayload>;
  updateShifts?: Maybe<UpdateShiftsPayload>;
  updateSiteRecurrence?: Maybe<UpdateSiteRecurrencePayload>;
  updateSupplier?: Maybe<UpdateSuppliersPayload>;
  updateSupplierV2?: Maybe<UpdateSuppliersV2Payload>;
  updateSupplierV3?: Maybe<UpdateSuppliersV3Payload>;
  updateTax?: Maybe<UpdateTaxPayload>;
  updateTerminal?: Maybe<UpdateTerminalsPayload>;
  updateTerminalsSupplier?: Maybe<UpdateTerminalsSuppliersPayload>;
  updateTransferOrder?: Maybe<UpdateTransferOrderPayload>;
  updateTransferOrderAssets?: Maybe<UpdateTransferOrderAssetsPayload>;
  updateUser?: Maybe<UpdateUsersPayload>;
  updateUserOtp?: Maybe<ChangeUserOtpPayload>;
  updateZoneProductBatches?: Maybe<UpdateZoneProductBatchesPayload>;
  uploadPandaDocument?: Maybe<UploadPandaDocumentPayload>;
  validateToken?: Maybe<ValidateTokenPayload>;
  verifyAndUpdateUser?: Maybe<VerifyAndUpdateUserPayload>;
};


export type MutationAccountingAsyncArgs = {
  input: AccountingAsyncInput;
};


export type MutationAcknowledgeNoteArgs = {
  input: AcknowledgeNoteInput;
};


export type MutationAddAssetForWarehouseArgs = {
  input: AddAssetForWarehouseInput;
};


export type MutationAddAssetToDeliveryOrderArgs = {
  input: AddAssetToDeliveryOrderInput;
};


export type MutationAddCodeToAssetArgs = {
  input: AddCodeToAssetInput;
};


export type MutationAddFeeToOrderGroupArgs = {
  input: AddFeeToOrderGroupInput;
};


export type MutationAddFeesToOrderGroupArgs = {
  input: AddFeesToOrderGroupInput;
};


export type MutationAddOrderGroupTaxArgs = {
  input: CreateOrderGroupTaxesInput;
};


export type MutationAddOrderGroupsToShiftArgs = {
  input: AddOrderGroupsToShiftInput;
};


export type MutationAddQrCodeToAssetArgs = {
  input: AddQrCodeToAssetInput;
};


export type MutationAdjustInventoryArgs = {
  input: AdjustInventoryInput;
};


export type MutationArchiveDriverArgs = {
  input: ArchiveDriversInput;
};


export type MutationArrivedAtCustomerArgs = {
  input: ArrivedAtCustomerInput;
};


export type MutationArrivedAtTerminalArgs = {
  input: ArrivedAtTerminalInput;
};


export type MutationAssignDeliveryAssetWithInventoryArgs = {
  input: AssignDeliveryAssetWithInventoryInput;
};


export type MutationAssignPandaBoxArgs = {
  input: AssignPandaBoxInput;
};


export type MutationAssociateIrelyEntityWithFpArgs = {
  input: AssociateIrelyEntityWithFpInput;
};


export type MutationAutoLinkOrdersArgs = {
  input: AutoLinkOrdersInput;
};


export type MutationBrokerageCreateOrderGroupArgs = {
  input: BrokerageCreateOrderGroupMutationInput;
};


export type MutationBulkAssignsArgs = {
  input: BatchOperationsInput;
};


export type MutationBulkAsyncRefetchOrderQueueStatusArgs = {
  input: BulkAsyncRefetchOrderQueueStatusInput;
};


export type MutationBulkOrderUnblocksArgs = {
  input: UpdateStatusInput;
};


export type MutationBulkUpdatePricingsArgs = {
  input: BulkUpdatePricingsInput;
};


export type MutationCalculatePricingArgs = {
  input: CalculatePricingInput;
};


export type MutationChangeOrderGroupAssignmentArgs = {
  input: ChangeOrderGroupAssignmentInput;
};


export type MutationChangeShiftAssetArgs = {
  input: ChangeAssetInput;
};


export type MutationClearDataShiftArgs = {
  input: ClearDataShiftInput;
};


export type MutationConfigViewArgs = {
  input: CreateOrUpdateConfigViewInput;
};


export type MutationConfirmOrCancelOrdersArgs = {
  input: ConfirmOrCancelOrderInput;
};


export type MutationConfirmTwoFactorArgs = {
  input: ConfirmTwoFactorInput;
};


export type MutationCopyPreviousRecordsArgs = {
  input: CopyPreviousRecordsInput;
};


export type MutationCreateAppVersionArgs = {
  input: CreateAppVersionInput;
};


export type MutationCreateAssetArgs = {
  input: CreateAssetsInput;
};


export type MutationCreateAttachedAssetArgs = {
  input: CreateAttachedAssetInput;
};


export type MutationCreateAttachedAssetAvailabilityArgs = {
  input: CreateAttachedAssetAvailabilityInput;
};


export type MutationCreateBolPricingArgs = {
  input: CreateBolPricingInput;
};


export type MutationCreateBolRetainArgs = {
  input: CreateBolRetainInput;
};


export type MutationCreateBrandArgs = {
  input: CreateBrandsInput;
};


export type MutationCreateCommonCarrierArgs = {
  input: CreateCommonCarrierInput;
};


export type MutationCreateCompletedDeliveryOrderArgs = {
  input: CreateDeliveryOrderInput;
};


export type MutationCreateCompletedLoadingOrderArgs = {
  input: CreateLoadingOrderInput;
};


export type MutationCreateCrudePricingsArgs = {
  input: CreateCrudePricingInput;
};


export type MutationCreateCustomerArgs = {
  input: CreateCustomersInput;
};


export type MutationCreateCustomerAssetArgs = {
  input: CreateCustomerAssetInput;
};


export type MutationCreateCustomerBranchArgs = {
  input: CreateCustomerBranchesInput;
};


export type MutationCreateCustomerSegmentArgs = {
  input: CreateCustomerSegmentsInput;
};


export type MutationCreateCustomerUserArgs = {
  input: CreateCustomerUsersInput;
};


export type MutationCreateDegreeDaySettingArgs = {
  input: Array<DegreeDaySettingInput>;
};


export type MutationCreateDirectUploadArgs = {
  input: CreateDirectUploadInput;
};


export type MutationCreateDriverArgs = {
  input: CreateDriversInput;
};


export type MutationCreateDriverDemurrageArgs = {
  input: CreateDriverDemurrageInput;
};


export type MutationCreateDriverRatesArgs = {
  input: CreateDriverRatesInput;
};


export type MutationCreateFeeArgs = {
  input: CreateFeesInput;
};


export type MutationCreateFeedbackArgs = {
  input: CreateFeedbacksInput;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateInventoryRecordArgs = {
  input: CreateInventoryRecordInput;
};


export type MutationCreateInvoiceArgs = {
  input: CreateInvoiceInput;
};


export type MutationCreateLeaCoreArgs = {
  input: CreateLeaCoreInput;
};


export type MutationCreateLeaMovementOrdersArgs = {
  input: CreateLeaMovementOrdersInput;
};


export type MutationCreateLineOfServiceArgs = {
  input: CreateLineOfServicesInput;
};


export type MutationCreateLoadingAccountArgs = {
  input: CreateLoadingAccountsInput;
};


export type MutationCreateMarginArgs = {
  input: CreateMarginInput;
};


export type MutationCreateMarketArgs = {
  input: CreateMarketsInput;
};


export type MutationCreateMovementOrderArgs = {
  input: CreateMovementOrderInput;
};


export type MutationCreateMultiOrderTopOffArgs = {
  assetIds: Array<Scalars['ID']>;
  isSelectAll?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};


export type MutationCreateOrUpdateCustomerPortalConfigurationArgs = {
  input: CreateOrUpdateCustomerPortalConfigurationInput;
};


export type MutationCreateOrUpdateFormProgressArgs = {
  input: CreateOrUpdateFormProgressInput;
};


export type MutationCreateOrUpdateMovementOrderLineItemArgs = {
  input: CreateOrUpdateMovementOrderLineItemInput;
};


export type MutationCreateOrUpdateNotificationTemplateArgs = {
  input: CreateOrUpdateNotificationTemplateInput;
};


export type MutationCreateOrUpdateQrCodeArgs = {
  input: CreateOrUpdateQrCodeInput;
};


export type MutationCreateOrUpdateRoleArgs = {
  input: CreateOrUpdateRoleInput;
};


export type MutationCreateOrUpdateRouteFlushingArgs = {
  input: CreateOrUpdateInput;
};


export type MutationCreateOrUpdateTagsArgs = {
  input: CreateOrUpdateTagInput;
};


export type MutationCreateOrUpdateTransferOrderLineItemArgs = {
  input: CreateOrUpdateTransferOrderLineItemInput;
};


export type MutationCreateOrderGroupArgs = {
  input: CreateOrderGroupInput;
};


export type MutationCreateOrderGroupsArgs = {
  input: CreateOrderGroupsInput;
};


export type MutationCreateOrderInvoiceArgs = {
  input: CreateOrderInvoiceInput;
};


export type MutationCreateOrderLinkArgs = {
  input: CreateOrderLinkInput;
};


export type MutationCreateOrderQuoteArgs = {
  input: CreateQuoteInput;
};


export type MutationCreatePandaBoxArgs = {
  input: CreatePandaBoxInput;
};


export type MutationCreatePaymentTermArgs = {
  input: CreatePaymentTermsInput;
};


export type MutationCreatePeripheralArgs = {
  input: CreatePeripheralInput;
};


export type MutationCreatePickupPointCodeArgs = {
  input: CreatePickupPointCodesInput;
};


export type MutationCreatePocArgs = {
  input: CreatePocInput;
};


export type MutationCreatePricingsArgs = {
  input: CreatePricingInput;
};


export type MutationCreateProductArgs = {
  input: CreateProductsInput;
};


export type MutationCreateProductOrderFeesArgs = {
  input: CreateProductOrderFeesInput;
};


export type MutationCreateProductPurchaseLimitArgs = {
  input: CreateProductPurchaseLimitsInput;
};


export type MutationCreateRackMarketArgs = {
  input: CreateRackMarketInput;
};


export type MutationCreateRateTypeArgs = {
  input: CreateRateInput;
};


export type MutationCreateRawShiftArgs = {
  input: CreateRawShiftInput;
};


export type MutationCreateResourceComponentArgs = {
  input: CreateResourceComponentInput;
};


export type MutationCreateResourcePricingsArgs = {
  input: CreateResourcePricingInput;
};


export type MutationCreateResourceScheduleArgs = {
  input: CreateResourceScheduleInput;
};


export type MutationCreateSavedViewArgs = {
  input: CreateSavedViewInput;
};


export type MutationCreateSettingArgs = {
  input: CreateSettingInput;
};


export type MutationCreateShiftArgs = {
  input: CreateShiftInput;
};


export type MutationCreateSiteRecurrenceArgs = {
  input: CreateSiteRecurrenceInput;
};


export type MutationCreateSupplierArgs = {
  input: CreateSuppliersInput;
};


export type MutationCreateSupplierV2Args = {
  input: CreateSuppliersV2Input;
};


export type MutationCreateSupplierV3Args = {
  input: CreateSuppliersV3Input;
};


export type MutationCreateTaxArgs = {
  input: CreateTaxInput;
};


export type MutationCreateTerminalArgs = {
  input: CreateTerminalsInput;
};


export type MutationCreateTerminalsSupplierArgs = {
  input: CreateTerminalsSuppliersInput;
};


export type MutationCreateTransferOrderArgs = {
  input: CreateTransferOrderInput;
};


export type MutationCreateUpdateAliasMappingArgs = {
  input: CreateUpdateAliasMappingInput;
};


export type MutationCreateUpdateIrelyFilterArgs = {
  input: CreateUpdateIrelyFilterInput;
};


export type MutationCreateZoneProductBatchesArgs = {
  input: CreateZoneProductBatchesInput;
};


export type MutationDeleteAssetArgs = {
  input: DeleteAssetsInput;
};


export type MutationDeleteBolPricingArgs = {
  input: DeleteBolPricingInput;
};


export type MutationDeleteBrandArgs = {
  input: DeleteBrandsInput;
};


export type MutationDeleteCustomerBranchArgs = {
  input: DeleteCustomerBranchesInput;
};


export type MutationDeleteDegreeDaySettingArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDeliveryOrderArgs = {
  input: DeleteDeliveryOrderInput;
};


export type MutationDeleteFeeArgs = {
  input: DeleteFeesInput;
};


export type MutationDeleteLeaCoreArgs = {
  input: DeleteLeaCoreInput;
};


export type MutationDeleteLineOfServiceArgs = {
  input: DeleteLineOfServicesInput;
};


export type MutationDeleteLoadingOrderArgs = {
  input: DeleteLoadingOrderInput;
};


export type MutationDeleteMovementOrderArgs = {
  input: DeleteMovementOrderInput;
};


export type MutationDeleteOrderLinkArgs = {
  input: DeleteOrderLinkInput;
};


export type MutationDeletePandaPriceResourceArgs = {
  input: DeletePandaPriceResourceInput;
};


export type MutationDeletePeripheralArgs = {
  input: DeletePeripheralInput;
};


export type MutationDeletePickupPointCodeArgs = {
  input: DeletePickupPointCodesInput;
};


export type MutationDeleteRackMarketArgs = {
  input: DeleteRackMarketInput;
};


export type MutationDeleteRawShiftArgs = {
  input: DeleteRawShiftInput;
};


export type MutationDeleteRecurrenceArgs = {
  input: DeleteRecurrenceInput;
};


export type MutationDeleteResourceArgs = {
  input: DeleteResourceInput;
};


export type MutationDeleteRouteFlushingArgs = {
  input: DeleteInput;
};


export type MutationDeleteShiftPlanArgs = {
  input: DeleteShiftPlanInput;
};


export type MutationDeleteSiteRecurrenceArgs = {
  input: DeleteSiteRecurrenceInput;
};


export type MutationDeleteSupplierArgs = {
  input: DeleteSuppliersInput;
};


export type MutationDeleteTerminalArgs = {
  input: DeleteTerminalsInput;
};


export type MutationDeleteTransferOrderArgs = {
  input: DeleteTransferOrderInput;
};


export type MutationDeleteZoneProductBatchesArgs = {
  input: DeleteZoneProductBatchesInput;
};


export type MutationDetachAttachedAssetArgs = {
  input: DetachAssetInput;
};


export type MutationDirectUploadPandaDocumentArgs = {
  input: DirectUploadPandaDocumentInput;
};


export type MutationDisableTwoFactorArgs = {
  input: DisableTwoFactorInput;
};


export type MutationDuplicateLeaCoreArgs = {
  input: DuplicateLeaCoreInput;
};


export type MutationDuplicateOrderArgs = {
  input: DuplicateOrderGroupInput;
};


export type MutationEmailDeliveryTicketArgs = {
  input: EmailDeliveryTicketInput;
};


export type MutationEmailResourcePricingArgs = {
  input: EmailResourcePricingInput;
};


export type MutationEnableTwoFactorArgs = {
  input: EnableTwoFactorInput;
};


export type MutationEndShiftArgs = {
  input: EndShiftInput;
};


export type MutationExportOrdersArgs = {
  input: ExportOrdersInput;
};


export type MutationExportOrdersCsvArgs = {
  input: ExportOrdersCsvInput;
};


export type MutationExportSuppliersCsvArgs = {
  input: ExportSuppliersCsvInput;
};


export type MutationExportTransactionsArgs = {
  input: ExportTransactionInput;
};


export type MutationFundCustomerBalanceArgs = {
  input: FundCustomerBalanceInput;
};


export type MutationGenerateInvoiceArgs = {
  input: GenerateInvoiceInput;
};


export type MutationGeneratePresignedMetabaseUrlArgs = {
  input: GeneratePresignedMetabaseUrlInput;
};


export type MutationGenerateQrCodesArgs = {
  input: GenerateQrCodesInput;
};


export type MutationGenerateSalesReportArgs = {
  input: GenerateSalesReportInput;
};


export type MutationGenerateTaxReportArgs = {
  input: GenerateTaxReportInput;
};


export type MutationGotoCustomerArgs = {
  input: GotoCustomerInput;
};


export type MutationGotoTerminalArgs = {
  input: GotoTerminalInput;
};


export type MutationImportRecordsArgs = {
  input: ImportRecordsInput;
};


export type MutationIndexResourceArgs = {
  input: IndexResourceInput;
};


export type MutationInviteCustomerToPortalArgs = {
  input: InviteCustomerToPortalInput;
};


export type MutationLinkOrUnlinkTagsArgs = {
  input: LinkOrUnlinkTagsInput;
};


export type MutationMergeCustomerResourcesArgs = {
  input: CustomerResourcesInput;
};


export type MutationModifyInventoryArgs = {
  input: ModifyInventoryInput;
};


export type MutationModifyLineItemProductArgs = {
  input: ModifyLineItemProductInput;
};


export type MutationModifyShiftInventoryArgs = {
  input: ModifyShiftInventoryInput;
};


export type MutationOptimizeShiftPlanArgs = {
  input: OptimizeShiftPlanInput;
};


export type MutationPartialSyncArgs = {
  input: PartialSyncInput;
};


export type MutationPostDeliveryNoteCreateArgs = {
  input: PostDeliveryNoteCreateInput;
};


export type MutationPurgeUserImageArgs = {
  input: PurgeUserImageInput;
};


export type MutationPushOrderToFdnArgs = {
  input: PushOrderToFdnInput;
};


export type MutationQuickbookDeliveryOrderSyncArgs = {
  input: SalesOrderSyncInput;
};


export type MutationQuickbookShiftSyncArgs = {
  input: ShiftsSyncInput;
};


export type MutationReauthenticateUserArgs = {
  input: ReauthenticateInput;
};


export type MutationRecalculateInventoryRecordsArgs = {
  input: RecalculateInventoryRecordsInput;
};


export type MutationRecalculatePricingArgs = {
  input: RecalculatePricingInput;
};


export type MutationRefetchCustomersAsynchronouslyArgs = {
  input: RefetchCustomersAsynchronouslyInput;
};


export type MutationRefetchOrderQueueStatusArgs = {
  input: RefetchOrderQueueStatusInput;
};


export type MutationRefreshApiTokenArgs = {
  input: RefreshApiTokenInput;
};


export type MutationRemoveCodeFromAssetArgs = {
  input: RemoveCodeInput;
};


export type MutationRemoveFeeToOrderGroupArgs = {
  input: RemoveFeeToOrderGroupInput;
};


export type MutationRemoveFeesFromOrderGroupArgs = {
  input: RemoveFeesFromOrderGroupInput;
};


export type MutationRemoveFormProgressArgs = {
  input: RemoveFormProgressInput;
};


export type MutationRemoveQrCodeFromAssetArgs = {
  input: RemoveQrCodeInput;
};


export type MutationRequestContactOtpArgs = {
  input: RequestContactOtpInput;
};


export type MutationResendDocusealEmailArgs = {
  input: ResendDocusealEmailInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResetPricingArgs = {
  input: ResetPricingInput;
};


export type MutationSaveTenantContentArgs = {
  input: SaveTenantContentInput;
};


export type MutationSendBulkOrderEmailToDriverArgs = {
  input: SendBulkOrderEmailToDriverInput;
};


export type MutationSendCommonCarrierEmailArgs = {
  input: SendCommonCarrierEmailInput;
};


export type MutationSendLeaMailArgs = {
  input: SendLeaMailInput;
};


export type MutationSendMailToPocArgs = {
  input: SendMailToPocInput;
};


export type MutationSendManualNotificationArgs = {
  input: SendManualNotificationInput;
};


export type MutationSendOrderCreatedEmailToDriverArgs = {
  input: SendOrderCreateEmailToDriverInput;
};


export type MutationSendPasswordResetInstructionArgs = {
  input: SendPasswordResetInstructionInput;
};


export type MutationSendTestNotificationTemplateArgs = {
  input: SendTestNotificationTemplateInput;
};


export type MutationShiftReconciliationArgs = {
  input: ShiftReconciliationInput;
};


export type MutationSignInUserArgs = {
  input: SignInInput;
};


export type MutationStartShiftArgs = {
  input: StartShiftInput;
};


export type MutationSubmitDeliveryArgs = {
  input: SubmitDeliveryInput;
};


export type MutationSubmitLoadingArgs = {
  input: SubmitLoadingInput;
};


export type MutationSubmitLoadingWithoutBolArgs = {
  input: LoadWithoutBolMutationInput;
};


export type MutationSwitchTenantArgs = {
  input: SwitchTenantInput;
};


export type MutationSyncAllTanksArgs = {
  input: SyncAllInput;
};


export type MutationSyncDataFromVendorArgs = {
  input: SyncDataFromVendorInput;
};


export type MutationSyncIndividualTankArgs = {
  input: SyncIndividualTankInput;
};


export type MutationTmApproveOrCancelOrdersArgs = {
  input: TmApproveOrCancelOrdersInput;
};


export type MutationTmCreateMultiOrderTopOffArgs = {
  deviceIds: Array<Scalars['ID']>;
  isSelectAll?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUnlinkTankMonitorArgs = {
  input: UnlinkTankMonitorInput;
};


export type MutationUpdateAppliedPricingArgs = {
  input: UpdateAppliedPricingInput;
};


export type MutationUpdateAssetArgs = {
  input: UpdateAssetsInput;
};


export type MutationUpdateAttachedAssetsArgs = {
  input: UpdateAttachedAssetInput;
};


export type MutationUpdateBolPricingArgs = {
  input: UpdateBolPricingInput;
};


export type MutationUpdateBrandArgs = {
  input: UpdateBrandsInput;
};


export type MutationUpdateCardLockTransactionArgs = {
  input: UpdateCardLockTransactionInput;
};


export type MutationUpdateCommonCarrierArgs = {
  input: UpdateCommonCarrierInput;
};


export type MutationUpdateCrudePricingsArgs = {
  input: UpdateCrudePricingInput;
};


export type MutationUpdateCustomerArgs = {
  input: UpdateCustomersInput;
};


export type MutationUpdateCustomerBranchArgs = {
  input: UpdateCustomerBranchesInput;
};


export type MutationUpdateCustomerPreferencesArgs = {
  input: UpdateCustomerPreferencesInput;
};


export type MutationUpdateCustomerReportArgs = {
  input: UpdateCustomerReportInput;
};


export type MutationUpdateCustomerSegmentArgs = {
  input: UpdateCustomerSegmentsInput;
};


export type MutationUpdateCustomerUserArgs = {
  input: UpdateCustomerUsersInput;
};


export type MutationUpdateDegreeDaySettingArgs = {
  input: Array<DegreeDaySettingInput>;
};


export type MutationUpdateDeliveryOrderArgs = {
  input: UpdateDeliveryOrderInput;
};


export type MutationUpdateDeliveryOrderLineItemArgs = {
  input: UpdateDeliveryOrderLineItemInput;
};


export type MutationUpdateDriverArgs = {
  input: UpdateDriversInput;
};


export type MutationUpdateDriverDemurrageArgs = {
  input: UpdateDriverDemurrageInput;
};


export type MutationUpdateDriverOtpArgs = {
  input: ChangeDriverOtpInput;
};


export type MutationUpdateDriverShiftArgs = {
  input: UpdateDriverShiftInput;
};


export type MutationUpdateFeeArgs = {
  input: UpdateFeesInput;
};


export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


export type MutationUpdateInvoiceArgs = {
  input: UpdateInvoiceInput;
};


export type MutationUpdateLeaCoreArgs = {
  input: UpdateLeaCoreInput;
};


export type MutationUpdateLeaDocumentArgs = {
  input: UpdateLeaDocumentInput;
};


export type MutationUpdateLineOfServiceArgs = {
  input: UpdateLineOfServicesInput;
};


export type MutationUpdateLoadingAccountArgs = {
  input: UpdateLoadingAccountsInput;
};


export type MutationUpdateLoadingOrderArgs = {
  input: UpdateLoadingOrderInput;
};


export type MutationUpdateLoadingOrderLineItemArgs = {
  input: UpdateLoadingOrderLineItemInput;
};


export type MutationUpdateMarginArgs = {
  input: UpdateMarginInput;
};


export type MutationUpdateMarketArgs = {
  input: UpdateMarketsInput;
};


export type MutationUpdateMovementOrderArgs = {
  input: UpdateMovementOrderInput;
};


export type MutationUpdateNoteArgs = {
  input: UpdateNoteInput;
};


export type MutationUpdateNotificationTemplateStatusArgs = {
  input: UpdateNotificationTemplateStatusInput;
};


export type MutationUpdateOrderGroupArgs = {
  input: UpdateOrderGroupMutationInput;
};


export type MutationUpdateOrderLinkArgs = {
  input: UpdateOrderLinkInput;
};


export type MutationUpdateOrderWorkerDateArgs = {
  input: UpdateOrderWorkerDateInput;
};


export type MutationUpdatePaymentTermArgs = {
  input: UpdatePaymentTermsInput;
};


export type MutationUpdatePeripheralArgs = {
  input: UpdatePeripheralInput;
};


export type MutationUpdatePickupPointCodeArgs = {
  input: UpdatePickupPointCodesInput;
};


export type MutationUpdatePocArgs = {
  input: UpdatePocInput;
};


export type MutationUpdatePostDeliveryPhotoArgs = {
  input: UpdatePostDeliveryPhotoInput;
};


export type MutationUpdatePricingsArgs = {
  input: UpdatePricingInput;
};


export type MutationUpdateProductArgs = {
  input: UpdateProductsInput;
};


export type MutationUpdateProductPurchaseLimitArgs = {
  input: UpdateProductPurchaseLimitsInput;
};


export type MutationUpdateRackMarketArgs = {
  input: UpdateRackMarketInput;
};


export type MutationUpdateRateTypeArgs = {
  input: UpdateRateInput;
};


export type MutationUpdateRawPricingImportSessionArgs = {
  input: UpdateRawPricingImportSessionInput;
};


export type MutationUpdateRawShiftArgs = {
  input: UpdateRawShiftInput;
};


export type MutationUpdateResourceArgs = {
  input: UpdateResourceInput;
};


export type MutationUpdateResourcePricingsArgs = {
  input: UpdateResourcePricingInput;
};


export type MutationUpdateRouteConfigArgs = {
  input: UpdateRouteConfigInput;
};


export type MutationUpdateSavedViewArgs = {
  input: UpdateSavedViewInput;
};


export type MutationUpdateSettingsArgs = {
  input: UpdateSettingsInput;
};


export type MutationUpdateShiftArgs = {
  input: UpdateShiftInput;
};


export type MutationUpdateShiftPlanDeliveryArgs = {
  input: UpdateStopDetailsInput;
};


export type MutationUpdateShiftPlanTruckArgs = {
  input: UpdateTruckDetailsInput;
};


export type MutationUpdateShiftsArgs = {
  input: UpdateShiftsInput;
};


export type MutationUpdateSiteRecurrenceArgs = {
  input: UpdateSiteRecurrenceInput;
};


export type MutationUpdateSupplierArgs = {
  input: UpdateSuppliersInput;
};


export type MutationUpdateSupplierV2Args = {
  input: UpdateSuppliersV2Input;
};


export type MutationUpdateSupplierV3Args = {
  input: UpdateSuppliersV3Input;
};


export type MutationUpdateTaxArgs = {
  input: UpdateTaxInput;
};


export type MutationUpdateTerminalArgs = {
  input: UpdateTerminalsInput;
};


export type MutationUpdateTerminalsSupplierArgs = {
  input: UpdateTerminalsSuppliersInput;
};


export type MutationUpdateTransferOrderArgs = {
  input: UpdateTransferOrderInput;
};


export type MutationUpdateTransferOrderAssetsArgs = {
  input: UpdateTransferOrderAssetsInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUsersInput;
};


export type MutationUpdateUserOtpArgs = {
  input: ChangeUserOtpInput;
};


export type MutationUpdateZoneProductBatchesArgs = {
  input: UpdateZoneProductBatchesInput;
};


export type MutationUploadPandaDocumentArgs = {
  input: UploadPandaDocumentInput;
};


export type MutationValidateTokenArgs = {
  input: ValidateTokenInput;
};


export type MutationVerifyAndUpdateUserArgs = {
  input: VerifyAndUpdateUserInput;
};

/** Nested asset product category input for assets */
export type NestedAssetProductCategoryInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  networkName?: InputMaybe<Scalars['String']>;
  networkNumber?: InputMaybe<Scalars['String']>;
  productCategoryId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  registerModel?: InputMaybe<Scalars['String']>;
  totalizer?: InputMaybe<Scalars['Float']>;
};

/** Nested capacity input for compartment */
export type NestedCapacityInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  fuelType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  productCategoryId?: InputMaybe<Scalars['ID']>;
  unit: UnitEnum;
  usablePercentage?: InputMaybe<Scalars['Float']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** Nested compartment input for assets */
export type NestedCompartmentInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  alignment?: InputMaybe<CompartmentAlignmentEnum>;
  capacitiesAttributes?: InputMaybe<Array<NestedCapacityInput>>;
  diameter?: InputMaybe<Scalars['Float']>;
  empty?: InputMaybe<Scalars['Boolean']>;
  erpId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  length?: InputMaybe<Scalars['Float']>;
  liquidControls?: InputMaybe<Scalars['String']>;
  meterNetworkAddress?: InputMaybe<Scalars['String']>;
  meterNumber?: InputMaybe<Scalars['String']>;
  midCom?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  networkName?: InputMaybe<Scalars['String']>;
  networkNumber?: InputMaybe<Scalars['String']>;
  totalControlSystems?: InputMaybe<Scalars['String']>;
};

/** Nested ShipTos input */
export type NestedCustomerBranchInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  addressBooksAttributes?: InputMaybe<Array<AddressBookInput>>;
  applicableFeesAttributes?: InputMaybe<Array<UpdateApplicableFeeInput>>;
  attachBolOnDeliveryTicket?: InputMaybe<Scalars['Boolean']>;
  autoEmailDeliveryTicket?: InputMaybe<Scalars['Boolean']>;
  cardLockSiteNumber?: InputMaybe<Scalars['String']>;
  crudePricingsAttributes?: InputMaybe<Array<UpdateCrudePricingsInput>>;
  deliveryInstruction?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  hubResourcesAttributes?: InputMaybe<Array<HubResourceInput>>;
  id?: InputMaybe<Scalars['ID']>;
  isCustomerSignatureRequired?: InputMaybe<Scalars['Boolean']>;
  isHub?: InputMaybe<Scalars['Boolean']>;
  lineOfServiceIds?: InputMaybe<Array<Scalars['ID']>>;
  loadingAccountIds?: InputMaybe<Array<Scalars['ID']>>;
  marketResourcesAttributes?: InputMaybe<Array<MarketResourceInput>>;
  name?: InputMaybe<Scalars['String']>;
  onlyShowGrossGallonsInDeliveryTicket?: InputMaybe<Scalars['Boolean']>;
  pandaDocuments?: InputMaybe<Array<DirectAttachmentInput>>;
  pickupPointCodeIds?: InputMaybe<Array<Scalars['ID']>>;
  poNumber?: InputMaybe<Scalars['String']>;
  preferredProductTerminalsAttributes?: InputMaybe<Array<PreferredProductTerminalInput>>;
  priceCode?: InputMaybe<Scalars['String']>;
  purchaseOrder?: InputMaybe<Scalars['Boolean']>;
  purchaseOrderType?: InputMaybe<PurchaseOrderTypeEnum>;
  qboItemizeLineItemOnSalesOrder?: InputMaybe<Scalars['Boolean']>;
  siteAttributes?: InputMaybe<SiteInput>;
  status?: InputMaybe<Scalars['Boolean']>;
  supplierIds?: InputMaybe<Array<Scalars['ID']>>;
  syncSalesToD1?: InputMaybe<Scalars['Boolean']>;
  taggingsAttributes?: InputMaybe<Array<TaggingInput>>;
  terminalDriverRates?: InputMaybe<Scalars['JSON']>;
};

/** Customer preferred driver Input */
export type NestedDriverInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  workerId?: InputMaybe<Scalars['ID']>;
};

/** Customer fee Input */
export type NestedFeeInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  feeId?: InputMaybe<Scalars['ID']>;
};

/** Nested GroupMembership Input */
export type NestedGroupMembershipInput = {
  /** Set to true while removing from group */
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** Id of User/Driver; Required while assigning to group */
  groupableId?: InputMaybe<Scalars['ID']>;
  /** One Value among User, or Driver; Required while assigning to group */
  groupableType?: InputMaybe<Scalars['String']>;
  /** Required while removing from group */
  id?: InputMaybe<Scalars['ID']>;
};

/** Nested line of service record */
export type NestedLineOfServiceRecord = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  lineOfServiceId: Scalars['ID'];
};

/** Nested loading account Input */
export type NestedLoadingAccountInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  carrierCustomerCode?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  destinationState?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  loadingAccountTerminalProductsAttributes?: InputMaybe<Array<NestedLoadingAccountTerminalProductInput>>;
  loadingNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  supplierCode?: InputMaybe<Scalars['String']>;
  terminalProducts?: InputMaybe<Array<TerminalProductsInput>>;
};

/** Nested loading account Input (v3) — supports multiple pickup point codes per terminal product */
export type NestedLoadingAccountInputV3 = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  carrierCustomerCode?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  destinationState?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  loadingAccountTerminalProductsAttributes?: InputMaybe<Array<NestedLoadingAccountTerminalProductInput>>;
  loadingNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  supplierCode?: InputMaybe<Scalars['String']>;
  terminalProducts?: InputMaybe<Array<TerminalProductsInputV3>>;
};

export type NestedLoadingAccountTerminalProductInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  pickupPointCode?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['ID']>;
  rackMarketId?: InputMaybe<Scalars['ID']>;
  terminalId?: InputMaybe<Scalars['ID']>;
  terminalsSupplierId?: InputMaybe<Scalars['ID']>;
};

/** Nested panda documents input for assets */
export type NestedPandaDocumentsInput = {
  documentType?: InputMaybe<PandaDocumentTypeEnum>;
  id?: InputMaybe<Scalars['ID']>;
  signedBlobId?: InputMaybe<Scalars['ID']>;
};

/** Nested phone input for drivers */
export type NestedPhoneInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  device?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  primary?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Nested pickup point code attached to a terminal product (v3) */
export type NestedPickupPointCodeForTerminalProductInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Nested terminal supplier Input */
export type NestedPickupPointCodeInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  loadingAccountId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Nested product constituents input */
export type NestedProductConstituentsInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  basicProductId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  percentage?: InputMaybe<Scalars['Float']>;
};

/** Terminal product Input */
export type NestedProductInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  minimalLoad?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['ID']>;
};

/** Nested product resource input */
export type NestedProductResourceInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  resourceId?: InputMaybe<Scalars['ID']>;
  resourceType?: InputMaybe<Scalars['String']>;
};

/** Nested site input for terminal */
export type NestedSiteInput = {
  address?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['ID']>;
  lat?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['String']>;
  radius?: InputMaybe<Scalars['Float']>;
  tags?: InputMaybe<Scalars['JSON']>;
};

/** Nested subscriptions input for assets */
export type NestedSubscriptionsInput = {
  compartmentAttributes?: InputMaybe<NestedCompartmentInput>;
  compartmentId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<StatusStringEnum>;
};

/** Terminal asset Input */
export type NestedTerminalInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  terminalId?: InputMaybe<Scalars['ID']>;
};

/** Nested terminal supplier Input */
export type NestedTerminalSupplierInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  bolTimeAt?: InputMaybe<BolTimeAtEnum>;
  id?: InputMaybe<Scalars['ID']>;
  irelySubstituteTerminal?: InputMaybe<Scalars['String']>;
  pickupPointCode?: InputMaybe<Scalars['String']>;
  pickupPointCodesAttributes?: InputMaybe<Array<NestedPickupPointCodeInput>>;
  supplierId?: InputMaybe<Scalars['ID']>;
  terminalId?: InputMaybe<Scalars['ID']>;
};

/** Nested user input for customer */
export type NestedUserAttributesInput = {
  address?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  passwordConfirmation?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<StatusEnum>;
};

/** Customer user Input */
export type NestedUserInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StatusEnum>;
};

/** Nested week schedule input for drivers */
export type NestedWeekScheduleInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  breakMinutes?: InputMaybe<Scalars['Int']>;
  earliest?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  latest?: InputMaybe<Scalars['Int']>;
  scheduleType: WeeklyScheduleTypeEnum;
  weekDay: WeekDayEnum;
};

export type Note = {
  __typename?: 'Note';
  acknowledgedAt?: Maybe<Scalars['Int']>;
  acknowledger?: Maybe<Scalars['String']>;
  acknowledgerId?: Maybe<Scalars['ID']>;
  commenter?: Maybe<Scalars['String']>;
  commenterUser?: Maybe<Commenter>;
  content?: Maybe<Scalars['String']>;
  createdAtTimestamp?: Maybe<Scalars['Int']>;
  generated?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  notableType?: Maybe<Scalars['String']>;
  noteType?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
  pandaDocument?: Maybe<PandaDocument>;
  showInDeliveryTicket?: Maybe<Scalars['Boolean']>;
  showInInvoice?: Maybe<Scalars['Boolean']>;
};

/** Acknowledger Input */
export type NoteAcknowledgeInput = {
  /** Note Acknowledgement */
  acknowledged: Scalars['Boolean'];
  id: Scalars['ID'];
};

export type NoteCollection = {
  __typename?: 'NoteCollection';
  collection: Array<Note>;
  metadata: MetaQuery;
};

/** Note Input */
export type NoteInput = {
  content: Scalars['String'];
  noteType?: InputMaybe<NoteTypeEnum>;
};

/** Enum for note types */
export enum NoteTypeEnum {
  /** Demurrage */
  Demurrage = 'demurrage',
  /** Panda Box */
  PandaBox = 'panda_box',
  /** Post Delivery */
  PostDelivery = 'post_delivery',
  /** Preshift Checklist */
  PreshiftChecklist = 'preshift_checklist'
}

export type NotesFilter = {
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
};

/** Notification template object type */
export type NotificationTemplate = {
  __typename?: 'NotificationTemplate';
  body: Scalars['String'];
  id: Scalars['ID'];
  logoUrl?: Maybe<Scalars['String']>;
  notificationType: Scalars['String'];
  orderStatus: Scalars['String'];
  status: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
  variables?: Maybe<Array<Scalars['String']>>;
};

export type NotificationTemplateInput = {
  body: Scalars['String'];
  logoUrl?: InputMaybe<Scalars['String']>;
  notificationType: Scalars['String'];
  orderStatus: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  variables?: InputMaybe<Array<Scalars['String']>>;
};

/** Enum for offset-type */
export enum OffsetTypeEnum {
  Time = 'time'
}

/** Autogenerated input type of OptimizeShiftPlan */
export type OptimizeShiftPlanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
};

/** Autogenerated return type of OptimizeShiftPlan */
export type OptimizeShiftPlanPayload = {
  __typename?: 'OptimizeShiftPlanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  queued?: Maybe<Scalars['Boolean']>;
};

export enum OrderActionEnum {
  /** Cancel the order */
  Cancel = 'CANCEL',
  /** Confirm the order */
  Confirm = 'CONFIRM'
}

export enum OrderApproveCancelEnum {
  Approve = 'APPROVE',
  Cancel = 'CANCEL'
}

export type OrderGroup = {
  __typename?: 'OrderGroup';
  allNotes?: Maybe<Array<Note>>;
  amountPrecision?: Maybe<Scalars['Int']>;
  applicableFees?: Maybe<Array<ApplicableFee>>;
  /** Asset used while creating the order for pick and pack */
  asset?: Maybe<Asset>;
  assignable?: Maybe<Groupable>;
  backofficeId?: Maybe<Scalars['String']>;
  backofficeStatus?: Maybe<Scalars['String']>;
  bolPricings: Array<BolPricing>;
  carrierEmailSentAt?: Maybe<Scalars['ISO8601DateTime']>;
  carrierNumber?: Maybe<Scalars['String']>;
  ccDeliveryAddress?: Maybe<Scalars['String']>;
  ccOrderGroupId?: Maybe<Scalars['ID']>;
  ccTenant?: Maybe<CcTenant>;
  ccTenantId?: Maybe<Scalars['Int']>;
  ccTerminal?: Maybe<Scalars['String']>;
  completeOnTimestamp?: Maybe<Scalars['Int']>;
  completedOn?: Maybe<Scalars['Int']>;
  completedOnTimestamp?: Maybe<Scalars['Int']>;
  creatable?: Maybe<Groupable>;
  createdAtTimestamp: Scalars['Int'];
  creditCardPayment?: Maybe<Scalars['Boolean']>;
  customerBranch?: Maybe<CustomerBranch>;
  data?: Maybe<Scalars['JSON']>;
  deliveryOrder?: Maybe<DeliveryOrder>;
  /** @deprecated Resolve it from deliveryOrder */
  deliveryOrders?: Maybe<Array<DeliveryOrder>>;
  departedOn?: Maybe<Scalars['ISO8601DateTime']>;
  departedOnTimestamp?: Maybe<Scalars['Int']>;
  draftInvoiceNumber?: Maybe<Scalars['String']>;
  driver?: Maybe<Driver>;
  driverAcceptance: Scalars['String'];
  enableRebill?: Maybe<Scalars['Boolean']>;
  extractionOrder?: Maybe<ExtractionOrder>;
  fees?: Maybe<Array<Fee>>;
  feesPricingStatus?: Maybe<FeesPricingStatusEnum>;
  fenceIns?: Maybe<Array<GeofenceRecord>>;
  fenceOuts?: Maybe<Array<GeofenceRecord>>;
  fromCustomerPortal?: Maybe<Scalars['Boolean']>;
  geoError?: Maybe<GeofenceError>;
  hub?: Maybe<Hub>;
  id: Scalars['ID'];
  invoiceNumbers?: Maybe<Array<Scalars['String']>>;
  invoices?: Maybe<Array<Invoice>>;
  isLinkedOrderGroup?: Maybe<Scalars['Boolean']>;
  latestInvoiceStatus?: Maybe<Scalars['String']>;
  lineOfService?: Maybe<LineOfService>;
  linkedOrders?: Maybe<Array<Scalars['ID']>>;
  loadedTimestamp?: Maybe<Scalars['Int']>;
  loadingOrder?: Maybe<LoadingOrder>;
  /** @deprecated Resolve it from loadingOrder */
  loadingOrders?: Maybe<Array<LoadingOrder>>;
  mainOrderGroupId?: Maybe<Scalars['ID']>;
  mainOrderGroupTenant?: Maybe<Scalars['String']>;
  movementOrder?: Maybe<MovementOrder>;
  offlineOperation?: Maybe<Scalars['Boolean']>;
  orderEndLocation?: Maybe<GenericLocation>;
  orderGroupChildren?: Maybe<Array<OrderGroup>>;
  /** @deprecated Dont use this. */
  orderGroupCustomer?: Maybe<Customer>;
  orderGroupTaxes?: Maybe<Array<OrderGroupTax>>;
  orderGroupsFees?: Maybe<Array<OrderGroupsFee>>;
  orderStartLocation?: Maybe<GenericLocation>;
  outsideAvailability?: Maybe<Scalars['Boolean']>;
  packedTimestamp?: Maybe<Scalars['Int']>;
  paid?: Maybe<Scalars['Boolean']>;
  pandaDocuments?: Maybe<Array<PandaDocument>>;
  paymentTypeName?: Maybe<Scalars['String']>;
  poNumber?: Maybe<Scalars['String']>;
  pricingMarginStatus?: Maybe<PricingMarginStatusEnum>;
  priority?: Maybe<OrderGroupPriorityEnum>;
  processingRecurrence?: Maybe<Scalars['Boolean']>;
  productLineOfServices?: Maybe<Array<Scalars['String']>>;
  productOrderFees?: Maybe<Array<ProductOrderFee>>;
  purchaseOrderRequired?: Maybe<Scalars['Boolean']>;
  purchaseOrderType?: Maybe<Scalars['String']>;
  ratePrecision?: Maybe<Scalars['Int']>;
  rawShiftId?: Maybe<Scalars['ID']>;
  rbOrderSequence?: Maybe<Scalars['Int']>;
  /** @deprecated Use recurrence data instead. */
  recurrence?: Maybe<RecurrenceOrderGroup>;
  recurrenceData?: Maybe<RecurrenceData>;
  routeId?: Maybe<Scalars['String']>;
  routingOrder?: Maybe<Scalars['Int']>;
  sendCarrierEmail?: Maybe<Scalars['Boolean']>;
  sendDriverEmail?: Maybe<Scalars['Boolean']>;
  shift?: Maybe<Shift>;
  shiftId?: Maybe<Scalars['ID']>;
  startOn?: Maybe<Scalars['ISO8601DateTime']>;
  startOnTimestamp?: Maybe<Scalars['Int']>;
  startedOn?: Maybe<Scalars['ISO8601DateTime']>;
  startedOnTimestamp?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  syncErrors?: Maybe<Scalars['String']>;
  taggings?: Maybe<Array<Tagging>>;
  /** @deprecated Dont use this. This uses too much resources */
  tasks?: Maybe<Array<Task>>;
  ticketId: Scalars['Int'];
  toStartOn?: Maybe<Scalars['ISO8601DateTime']>;
  toStartOnTimestamp?: Maybe<Scalars['Int']>;
  transferOrder?: Maybe<TransferOrder>;
  /** @deprecated Resolve it from transferOrder */
  transferOrders?: Maybe<Array<TransferOrder>>;
  unloadOrder?: Maybe<UnloadOrder>;
  usedAssets?: Maybe<Array<UsedAsset>>;
  user?: Maybe<User>;
  verifiedBy?: Maybe<Scalars['String']>;
  warehouseAsset?: Maybe<Asset>;
  warehouseStatus?: Maybe<Scalars['String']>;
  worker?: Maybe<Worker>;
  zoneProductBatches?: Maybe<Array<ZoneProductBatch>>;
};

export type OrderGroupAdjustment = {
  __typename?: 'OrderGroupAdjustment';
  id: Scalars['ID'];
  lineItems?: Maybe<Scalars['JSON']>;
};

export type OrderGroupCollection = {
  __typename?: 'OrderGroupCollection';
  collection: Array<OrderGroup>;
  metadata: MetaQuery;
};

export type OrderGroupFilter = {
  all?: InputMaybe<Scalars['String']>;
  /** Ids of assets */
  assetIds?: InputMaybe<Array<Scalars['ID']>>;
  cities?: InputMaybe<Array<Scalars['String']>>;
  customerBranchId?: InputMaybe<Scalars['ID']>;
  expired?: InputMaybe<Scalars['Boolean']>;
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  or?: InputMaybe<Array<OrderGroupFilter>>;
  product?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['ID']>;
  recurring?: InputMaybe<Scalars['Boolean']>;
  /** one among: completed, verified, accounting_synced, archived, departed, started, billed, credited, ready_to_sync, packing, packed, loading_finished, blocked, canceled, awaiting_confirmation, unassigned, scheduled, limit_exceeded, and skipped */
  status?: InputMaybe<Scalars['String']>;
  /** Array has one or more element among: completed, verified, accounting_synced, archived, departed, started, billed, credited, ready_to_sync, packing, packed, loading_finished, blocked, canceled, awaiting_confirmation, unassigned, scheduled, limit_exceeded, and skipped */
  statuses?: InputMaybe<Array<Scalars['String']>>;
  /** one among: today, this_week, next_week, fortnight */
  timeFrame?: InputMaybe<Scalars['String']>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<OrderGroupTypeEnum>;
  /** If true, filter order groups without assigned worker */
  unassigned?: InputMaybe<Scalars['Boolean']>;
  /** Warehouse asset ids */
  warehouseAssetIds?: InputMaybe<Array<Scalars['ID']>>;
  warehouseId?: InputMaybe<Scalars['ID']>;
  warehouseStatuses?: InputMaybe<Array<Scalars['String']>>;
  /** Ids of workers/drivers */
  workerIds?: InputMaybe<Array<Scalars['ID']>>;
  zipCodes?: InputMaybe<Array<Scalars['String']>>;
};

export type OrderGroupFiltersInput = {
  /** Asset Ids used during order create for pick and pack */
  assetIds?: InputMaybe<Array<Scalars['ID']>>;
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  linkedOrderId?: InputMaybe<Scalars['ID']>;
  product?: InputMaybe<Scalars['String']>;
  /** Shift id */
  shiftId?: InputMaybe<Scalars['ID']>;
  /** one among: unassigned, assigned, all */
  shiftStatus?: InputMaybe<Scalars['String']>;
  /** one among: unassigned, scheduled, started, completed */
  status?: InputMaybe<Scalars['String']>;
  /** Array has one or more element among: unassigned, scheduled, started, completed */
  statuses?: InputMaybe<Array<Scalars['String']>>;
  /** one among: today, this_week, next_week, fortnight */
  timeFrame?: InputMaybe<Scalars['String']>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
  /** Warehouse asset ids */
  warehouseAssetIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Order groups of a particular driver */
  workerId?: InputMaybe<Scalars['ID']>;
};

/** OrderGroup Input */
export type OrderGroupInput = {
  /** Asset ID used while creating the order for pick and pack */
  assetId?: InputMaybe<Scalars['ID']>;
  /** Asset Movement Location. */
  assetMovementLocationsAttribute?: InputMaybe<AssetMovementLocationInput>;
  /** Carrier order number. */
  carrierNumber?: InputMaybe<Scalars['String']>;
  /** CC Tenant ID. */
  ccTenantId?: InputMaybe<Scalars['ID']>;
  /** Completed time. Required if driver is provided. */
  completedOnTimestamp?: InputMaybe<Scalars['Int']>;
  /** Credit Card Payment */
  creditCardPayment?: InputMaybe<Scalars['Boolean']>;
  /** Customer Branch ID. */
  customerBranchId?: InputMaybe<Scalars['ID']>;
  /** Delivery order input object. */
  deliveryOrderAttributes?: InputMaybe<DeliveryOrderInput>;
  /** Delivery order input object. */
  deliveryOrdersAttributes?: InputMaybe<Array<DeliveryOrderInput>>;
  /** Departed time. Required if driver is provided. */
  departedOnTimestamp?: InputMaybe<Scalars['Int']>;
  /** ERP ID of the */
  erpId?: InputMaybe<Scalars['String']>;
  /** Geofence in record locations and timestamps */
  fenceIns?: InputMaybe<Array<GeofenceRecordInput>>;
  /** Geofence out records locations and timestamps */
  fenceOuts?: InputMaybe<Array<GeofenceRecordInput>>;
  /** geofence errors */
  geoError?: InputMaybe<GeofenceErrorEnum>;
  /** ID of the order group. Required during update. */
  id?: InputMaybe<Scalars['ID']>;
  isDriverLinkable?: InputMaybe<Scalars['Boolean']>;
  /** Is linked order group */
  isLinkedOrderGroup?: InputMaybe<Scalars['Boolean']>;
  isWarehouseAssetLinkable?: InputMaybe<Scalars['Boolean']>;
  /** Loading order input object. */
  loadingOrderAttributes?: InputMaybe<LoadingOrderInput>;
  /** Loading order input object. */
  loadingOrdersAttributes?: InputMaybe<Array<LoadingOrderInput>>;
  /** Lock pricing for order group while creating order */
  lockPricing?: InputMaybe<Scalars['Boolean']>;
  /** Transfer order input object. */
  movementOrderAttributes?: InputMaybe<MovementOrderInput>;
  /** Set this value to true incase of offline */
  offlineOperation?: InputMaybe<Scalars['Boolean']>;
  orderEndLocation?: InputMaybe<GenericLocationInput>;
  orderGroupsFeesAttributes?: InputMaybe<Array<UpdateOrderGroupFeeInput>>;
  orderStartLocation?: InputMaybe<GenericLocationInput>;
  /** Indicates if order group is outside available time slots */
  outsideAvailability?: InputMaybe<Scalars['Boolean']>;
  /** Paid/Unpaid status of cash */
  paid?: InputMaybe<Scalars['Boolean']>;
  /** Panda documents for order group */
  pandaDocuments?: InputMaybe<Array<NestedPandaDocumentsInput>>;
  /** Payment Type Name */
  paymentTypeName?: InputMaybe<PaymentTypeEnum>;
  /** Customer's purchase order number. */
  poNumber?: InputMaybe<Scalars['String']>;
  /** Should be either urgent or normal */
  priority?: InputMaybe<OrderGroupPriorityEnum>;
  purchaseOrderType?: InputMaybe<PurchaseOrderTypeEnum>;
  /** Raw Shift ID. */
  rawShiftId?: InputMaybe<Scalars['ID']>;
  /** Recurrence configuration */
  recurrence?: InputMaybe<RecurrenceInput>;
  /** Order of the order in Route */
  routingOrder?: InputMaybe<Scalars['Int']>;
  /** Send carrier email. */
  sendCarrierEmail?: InputMaybe<Scalars['Boolean']>;
  /** Send driver email */
  sendDriverEmail?: InputMaybe<Scalars['Boolean']>;
  /** Shift ID. */
  shiftId?: InputMaybe<Scalars['ID']>;
  /** Start time. Required if driver is provided. */
  startOnTimestamp?: InputMaybe<Scalars['Int']>;
  /** Started time. Required if driver is provided. */
  startedOnTimestamp?: InputMaybe<Scalars['Int']>;
  /** Status of the order; When scheduled is changed to any status, It is required to have shift defined for driver. */
  status?: InputMaybe<Scalars['String']>;
  taggingsAttributes?: InputMaybe<Array<TaggingInput>>;
  /** To Start On time. Required for certain planned time window. */
  toStartOnTimestamp?: InputMaybe<Scalars['Int']>;
  /** Transfer order input object. */
  transferOrderAttributes?: InputMaybe<TransferOrderInput>;
  /** Assigned User ID. */
  userId?: InputMaybe<Scalars['ID']>;
  warehouseAssetId?: InputMaybe<Scalars['ID']>;
  /** Driver ID. */
  workerId?: InputMaybe<Scalars['ID']>;
  zoneProductBatchesAttributes?: InputMaybe<Array<ZoneProductBatchInput>>;
};

/** Enum to set priorities for order groups */
export enum OrderGroupPriorityEnum {
  /** Normal */
  Normal = 'normal',
  /** Urgent */
  Urgent = 'urgent'
}

export type OrderGroupSorter = {
  field: OrderGroupSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum OrderGroupSorterEnum {
  Bolnumbers = 'BOLNUMBERS',
  Completedon = 'COMPLETEDON',
  Customer = 'CUSTOMER',
  Deliveredgals = 'DELIVEREDGALS',
  Deliveryid = 'DELIVERYID',
  Departedon = 'DEPARTEDON',
  Driver = 'DRIVER',
  Drivergroup = 'DRIVERGROUP',
  Erpid = 'ERPID',
  Hub = 'HUB',
  Loadedgals = 'LOADEDGALS',
  Loadingid = 'LOADINGID',
  Loadingorderproducts = 'LOADINGORDERPRODUCTS',
  Ordergroupid = 'ORDERGROUPID',
  Plannedgals = 'PLANNEDGALS',
  Ponumber = 'PONUMBER',
  Priority = 'PRIORITY',
  Requestedgals = 'REQUESTEDGALS',
  Shipto = 'SHIPTO',
  Shiptoerpid = 'SHIPTOERPID',
  Startedon = 'STARTEDON',
  Starton = 'STARTON',
  Status = 'STATUS',
  Supplier = 'SUPPLIER',
  Terminal = 'TERMINAL',
  Verifiedby = 'VERIFIEDBY'
}

/** Enum for order group sources */
export enum OrderGroupSourceEnum {
  /** Api */
  Api = 'api',
  /** Manual */
  Manual = 'manual',
  /** Recurring */
  Recurring = 'recurring',
  /** Tank Monitor */
  TankMonitorAuto = 'tank_monitor_auto',
  /** Tank Monitor */
  TankMonitorManual = 'tank_monitor_manual'
}

/** Enum for order group statuses */
export enum OrderGroupStatusEnum {
  /** Accounting Synced */
  AccountingSynced = 'accounting_synced',
  /** Archived */
  Archived = 'archived',
  /** Awaiting Confirmation */
  AwaitingConfirmation = 'awaiting_confirmation',
  /** Billed */
  Billed = 'billed',
  /** Blocked */
  Blocked = 'blocked',
  /** Canceled */
  Canceled = 'canceled',
  /** Completed */
  Completed = 'completed',
  /** Credited */
  Credited = 'credited',
  /** Departed */
  Departed = 'departed',
  /** Limit Exceeded */
  LimitExceeded = 'limit_exceeded',
  /** Loading Finished */
  LoadingFinished = 'loading_finished',
  /** Packed */
  Packed = 'packed',
  /** Packing */
  Packing = 'packing',
  /** Ready to Sync */
  ReadyToSync = 'ready_to_sync',
  /** Scheduled */
  Scheduled = 'scheduled',
  /** Skipped */
  Skipped = 'skipped',
  /** Started */
  Started = 'started',
  /** Unassigned */
  Unassigned = 'unassigned',
  /** Verified */
  Verified = 'verified'
}

export type OrderGroupSyncReport = {
  __typename?: 'OrderGroupSyncReport';
  allNotes?: Maybe<Array<Note>>;
  amountPrecision?: Maybe<Scalars['Int']>;
  applicableFees?: Maybe<Array<ApplicableFee>>;
  /** Asset used while creating the order for pick and pack */
  asset?: Maybe<Asset>;
  assignable?: Maybe<Groupable>;
  backofficeId?: Maybe<Scalars['String']>;
  backofficeStatus?: Maybe<Scalars['String']>;
  bolPricings: Array<BolPricing>;
  carrierEmailSentAt?: Maybe<Scalars['ISO8601DateTime']>;
  carrierNumber?: Maybe<Scalars['String']>;
  ccDeliveryAddress?: Maybe<Scalars['String']>;
  ccOrderGroupId?: Maybe<Scalars['ID']>;
  ccTenant?: Maybe<CcTenant>;
  ccTenantId?: Maybe<Scalars['Int']>;
  ccTerminal?: Maybe<Scalars['String']>;
  completeOnTimestamp?: Maybe<Scalars['Int']>;
  completedOn?: Maybe<Scalars['Int']>;
  completedOnTimestamp?: Maybe<Scalars['Int']>;
  creatable?: Maybe<Groupable>;
  createdAtTimestamp: Scalars['Int'];
  creditCardPayment?: Maybe<Scalars['Boolean']>;
  customerBranch?: Maybe<CustomerBranch>;
  data?: Maybe<Scalars['JSON']>;
  deliveryOrder?: Maybe<DeliveryOrder>;
  /** @deprecated Resolve it from deliveryOrder */
  deliveryOrders?: Maybe<Array<DeliveryOrder>>;
  departedOn?: Maybe<Scalars['ISO8601DateTime']>;
  departedOnTimestamp?: Maybe<Scalars['Int']>;
  draftInvoiceNumber?: Maybe<Scalars['String']>;
  driver?: Maybe<Driver>;
  driverAcceptance: Scalars['String'];
  enableRebill?: Maybe<Scalars['Boolean']>;
  extractionOrder?: Maybe<ExtractionOrder>;
  fees?: Maybe<Array<Fee>>;
  feesPricingStatus?: Maybe<FeesPricingStatusEnum>;
  fenceIns?: Maybe<Array<GeofenceRecord>>;
  fenceOuts?: Maybe<Array<GeofenceRecord>>;
  fromCustomerPortal?: Maybe<Scalars['Boolean']>;
  geoError?: Maybe<GeofenceError>;
  hub?: Maybe<Hub>;
  id: Scalars['ID'];
  invoiceNumbers?: Maybe<Array<Scalars['String']>>;
  invoices?: Maybe<Array<Invoice>>;
  isLinkedOrderGroup?: Maybe<Scalars['Boolean']>;
  isSynced: Scalars['Boolean'];
  latestInvoiceStatus?: Maybe<Scalars['String']>;
  lineOfService?: Maybe<LineOfService>;
  linkedOrders?: Maybe<Array<Scalars['ID']>>;
  loadedTimestamp?: Maybe<Scalars['Int']>;
  loadingOrder?: Maybe<LoadingOrder>;
  /** @deprecated Resolve it from loadingOrder */
  loadingOrders?: Maybe<Array<LoadingOrder>>;
  mainOrderGroupId?: Maybe<Scalars['ID']>;
  mainOrderGroupTenant?: Maybe<Scalars['String']>;
  movementOrder?: Maybe<MovementOrder>;
  offlineOperation?: Maybe<Scalars['Boolean']>;
  orderEndLocation?: Maybe<GenericLocation>;
  orderGroupChildren?: Maybe<Array<OrderGroup>>;
  /** @deprecated Dont use this. */
  orderGroupCustomer?: Maybe<Customer>;
  orderGroupTaxes?: Maybe<Array<OrderGroupTax>>;
  orderGroupsFees?: Maybe<Array<OrderGroupsFee>>;
  orderStartLocation?: Maybe<GenericLocation>;
  outsideAvailability?: Maybe<Scalars['Boolean']>;
  packedTimestamp?: Maybe<Scalars['Int']>;
  paid?: Maybe<Scalars['Boolean']>;
  pandaDocuments?: Maybe<Array<PandaDocument>>;
  paymentTypeName?: Maybe<Scalars['String']>;
  poNumber?: Maybe<Scalars['String']>;
  pricingMarginStatus?: Maybe<PricingMarginStatusEnum>;
  priority?: Maybe<OrderGroupPriorityEnum>;
  processingRecurrence?: Maybe<Scalars['Boolean']>;
  productLineOfServices?: Maybe<Array<Scalars['String']>>;
  productOrderFees?: Maybe<Array<ProductOrderFee>>;
  purchaseOrderRequired?: Maybe<Scalars['Boolean']>;
  purchaseOrderType?: Maybe<Scalars['String']>;
  ratePrecision?: Maybe<Scalars['Int']>;
  rawShiftId?: Maybe<Scalars['ID']>;
  rbOrderSequence?: Maybe<Scalars['Int']>;
  /** @deprecated Use recurrence data instead. */
  recurrence?: Maybe<RecurrenceOrderGroup>;
  recurrenceData?: Maybe<RecurrenceData>;
  routeId?: Maybe<Scalars['String']>;
  routingOrder?: Maybe<Scalars['Int']>;
  sendCarrierEmail?: Maybe<Scalars['Boolean']>;
  sendDriverEmail?: Maybe<Scalars['Boolean']>;
  shift?: Maybe<Shift>;
  shiftId?: Maybe<Scalars['ID']>;
  startOn?: Maybe<Scalars['ISO8601DateTime']>;
  startOnTimestamp?: Maybe<Scalars['Int']>;
  startedOn?: Maybe<Scalars['ISO8601DateTime']>;
  startedOnTimestamp?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  syncErrors?: Maybe<Scalars['String']>;
  taggings?: Maybe<Array<Tagging>>;
  /** @deprecated Dont use this. This uses too much resources */
  tasks?: Maybe<Array<Task>>;
  ticketId: Scalars['Int'];
  toStartOn?: Maybe<Scalars['ISO8601DateTime']>;
  toStartOnTimestamp?: Maybe<Scalars['Int']>;
  transferOrder?: Maybe<TransferOrder>;
  /** @deprecated Resolve it from transferOrder */
  transferOrders?: Maybe<Array<TransferOrder>>;
  unloadOrder?: Maybe<UnloadOrder>;
  usedAssets?: Maybe<Array<UsedAsset>>;
  user?: Maybe<User>;
  vendor?: Maybe<VendorNameEnum>;
  verifiedBy?: Maybe<Scalars['String']>;
  warehouseAsset?: Maybe<Asset>;
  warehouseStatus?: Maybe<Scalars['String']>;
  worker?: Maybe<Worker>;
  zoneProductBatches?: Maybe<Array<ZoneProductBatch>>;
};

export type OrderGroupSyncReportCollection = {
  __typename?: 'OrderGroupSyncReportCollection';
  collection: Array<OrderGroupSyncReport>;
  metadata: MetaQuery;
};

export type OrderGroupTax = {
  __typename?: 'OrderGroupTax';
  data?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['ID']>;
  orderGroup?: Maybe<OrderGroup>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  tax?: Maybe<BolPricingsTaxType>;
  total?: Maybe<Scalars['Float']>;
};

export type OrderGroupTaxInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['ID']>;
  orderGroupId?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Float']>;
  quantity?: InputMaybe<Scalars['Float']>;
  taxId?: InputMaybe<Scalars['ID']>;
  total?: InputMaybe<Scalars['Float']>;
};

export type OrderGroupTaxResponse = {
  __typename?: 'OrderGroupTaxResponse';
  error?: Maybe<Scalars['String']>;
  orderGroupTax?: Maybe<OrderGroupTax>;
  success: Scalars['Boolean'];
};

/** Enum to use for filter order groups */
export enum OrderGroupTypeEnum {
  /** Delivery order */
  Delivery = 'delivery',
  /** Extraction order */
  Extraction = 'extraction',
  /** Loading order */
  Loading = 'loading',
  /** Movement order */
  Movement = 'movement',
  /** Transfer order */
  Transfer = 'transfer'
}

export type OrderGroupsFee = {
  __typename?: 'OrderGroupsFee';
  fee: Fee;
  id: Scalars['ID'];
  offset?: Maybe<Scalars['Float']>;
  offsetRate?: Maybe<Scalars['Float']>;
  orderGroup: OrderGroup;
  price?: Maybe<Scalars['Float']>;
  quantity: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
};

/** Order Groups Fee Input */
export type OrderGroupsFeeInput = {
  /** Deprecated. DO NOT USE. */
  _destroy?: InputMaybe<Scalars['Boolean']>;
  feeId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  orderGroupId?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Float']>;
  quantity?: InputMaybe<Scalars['Float']>;
};

export type OrderIdAndAssetId = {
  assetIds: Array<Scalars['ID']>;
  orderId: Scalars['ID'];
};

export type OrderInput = {
  id: Scalars['ID'];
  startOn?: InputMaybe<Scalars['ISO8601DateTime']>;
};

export type OrderInvoiceResponse = {
  __typename?: 'OrderInvoiceResponse';
  error?: Maybe<Scalars['String']>;
  invoice?: Maybe<Invoice>;
  success: Scalars['Boolean'];
  warning?: Maybe<Warning>;
};

export type OrderLink = {
  __typename?: 'OrderLink';
  data?: Maybe<Scalars['JSON']>;
  deliveryOrder?: Maybe<DeliveryOrder>;
  extractionOrder?: Maybe<ExtractionOrder>;
  id: Scalars['ID'];
  loadingOrder?: Maybe<LoadingOrder>;
  movementOrder?: Maybe<MovementOrder>;
  transferOrder?: Maybe<TransferOrder>;
};

export type OrderLinkCollection = {
  __typename?: 'OrderLinkCollection';
  collection: Array<OrderLink>;
  metadata: MetaQuery;
};

export type OrderLinkFilter = {
  deliveryOrderId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  loadingOrderId?: InputMaybe<Scalars['ID']>;
  or?: InputMaybe<Array<OrderLinkFilter>>;
};

/** Enum for transaction type for inventory records */
export enum OrderTypeEnum {
  Adjustment = 'Adjustment',
  DeliveryOrder = 'DeliveryOrder',
  ExtractionOrder = 'ExtractionOrder',
  LoadingOrder = 'LoadingOrder',
  TransferOrder = 'TransferOrder'
}

export type OrderWell = {
  __typename?: 'OrderWell';
  address?: Maybe<Scalars['String']>;
  assignedBy?: Maybe<Scalars['String']>;
  carrierId?: Maybe<Scalars['ID']>;
  carrierName?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Coordinates>;
  createdAtTimestamp?: Maybe<Scalars['Int']>;
  createdBy?: Maybe<Scalars['String']>;
  customerBranchSchedule?: Maybe<ResourceSchedule>;
  customerErpId?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  customerPurchaseOrder?: Maybe<Scalars['Boolean']>;
  customerSchedule?: Maybe<ResourceSchedule>;
  deliveredGal?: Maybe<Scalars['Float']>;
  deliveredQty?: Maybe<Scalars['Float']>;
  deliveryTruckNames?: Maybe<Array<Scalars['String']>>;
  destinationStates?: Maybe<Array<Scalars['String']>>;
  divergenceOrder?: Maybe<Scalars['Boolean']>;
  driverAcceptance?: Maybe<Scalars['String']>;
  driverEmail?: Maybe<Scalars['String']>;
  driverGroupName?: Maybe<Scalars['String']>;
  driverId?: Maybe<Scalars['ID']>;
  driverName?: Maybe<Scalars['String']>;
  endAt?: Maybe<Scalars['Int']>;
  externalBoId?: Maybe<Scalars['String']>;
  feesPricingStatus?: Maybe<FeesPricingStatusEnum>;
  fuelingDuration?: Maybe<Scalars['Float']>;
  /** Present only for delivery order */
  hubName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  latestInvoiceStatus?: Maybe<Scalars['String']>;
  linkedOrders?: Maybe<Array<Scalars['ID']>>;
  loadingReceipts?: Maybe<Array<LoadingReceipt>>;
  mainOrderGroupId?: Maybe<Scalars['ID']>;
  mainOrderGroupTenant?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  outsideAvailability?: Maybe<Scalars['Boolean']>;
  parentOrderGroupId?: Maybe<Scalars['ID']>;
  plannedAt?: Maybe<Scalars['Int']>;
  plannedGal?: Maybe<Scalars['Float']>;
  plannedQty?: Maybe<Scalars['Float']>;
  poNumber?: Maybe<Scalars['String']>;
  poc?: Maybe<Scalars['String']>;
  pocPhoneNumber?: Maybe<Scalars['String']>;
  /** Present only if order type is loading */
  preferredSupplierNames?: Maybe<Array<Scalars['String']>>;
  pricingMarginStatus?: Maybe<PricingMarginStatusEnum>;
  priority?: Maybe<OrderGroupPriorityEnum>;
  productNames?: Maybe<Array<Scalars['String']>>;
  purchaseOrderIsRequired?: Maybe<Scalars['Boolean']>;
  purchaseOrderType?: Maybe<Scalars['String']>;
  rbOrderSequence?: Maybe<Scalars['Int']>;
  routeId?: Maybe<Scalars['String']>;
  shipToName?: Maybe<Scalars['String']>;
  shipToPurchaseOrder?: Maybe<Scalars['Boolean']>;
  source?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  /** Present only after loading is performed */
  supplierNames?: Maybe<Array<Scalars['String']>>;
  /** Tags associated with the order */
  tags?: Maybe<Array<Tag>>;
  ticketId: Scalars['ID'];
  toStartAt?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  warehouseStatus?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type OrderWellCollection = {
  __typename?: 'OrderWellCollection';
  collection: Array<OrderWell>;
  metadata: MetaQuery;
};

export type OrderWellFilter = {
  customerBranchId?: InputMaybe<Scalars['ID']>;
  /** Filter by Address */
  filterAddress?: InputMaybe<Scalars['String']>;
  /** Filter by Assigned By */
  filterAssignedBy?: InputMaybe<Scalars['String']>;
  /** Filter by BOL (external BO ID) */
  filterBol?: InputMaybe<Scalars['String']>;
  /** Filter by Carrier name */
  filterCarrierName?: InputMaybe<Scalars['String']>;
  /** Filter by City */
  filterCity?: InputMaybe<Scalars['String']>;
  /** Filter by Created By */
  filterCreatedBy?: InputMaybe<Scalars['String']>;
  /** Filter by Customer name */
  filterCustomer?: InputMaybe<Scalars['String']>;
  /** Filter by Customer ERP ID */
  filterCustomerErpId?: InputMaybe<Scalars['String']>;
  /** Filter by Driver name */
  filterDriver?: InputMaybe<Scalars['String']>;
  /** Filter by Driver Group name */
  filterDriverGroup?: InputMaybe<Scalars['String']>;
  /** Filter by Hub name */
  filterHub?: InputMaybe<Scalars['String']>;
  /** Filter by PO number */
  filterPo?: InputMaybe<Scalars['String']>;
  /** Filter by Product names */
  filterProducts?: InputMaybe<Scalars['String']>;
  /** Filter by ShipTo name */
  filterShipTo?: InputMaybe<Scalars['String']>;
  /** Filter by State */
  filterState?: InputMaybe<Scalars['String']>;
  /** Filter by Ticket ID */
  filterTicketId?: InputMaybe<Scalars['String']>;
  /** Filter by Truck names */
  filterTrucks?: InputMaybe<Scalars['String']>;
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  /** DD/MM/YYYY */
  plannedDate?: InputMaybe<Scalars['String']>;
  /** Full-text search across order fields */
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<OrderGroupStatusEnum>>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
};

/** Columns that can be used to summarize Order Well grouped counts */
export enum OrderWellGroupByEnum {
  CarrierName = 'CARRIER_NAME',
  City = 'CITY',
  Customer = 'CUSTOMER',
  Hub = 'HUB',
  ShipTo = 'SHIP_TO',
  State = 'STATE',
  Status = 'STATUS',
  Worker = 'WORKER'
}

export type OrderWellGroupingSummary = {
  __typename?: 'OrderWellGroupingSummary';
  count: Scalars['Int'];
  groupBy: OrderWellGroupByEnum;
  groupValue?: Maybe<Scalars['String']>;
  groupValueId?: Maybe<Scalars['String']>;
};

export type OrderWellSorter = {
  field: OrderWellSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query for Order Well */
export enum OrderWellSorterEnum {
  Address = 'ADDRESS',
  CarrierName = 'CARRIER_NAME',
  City = 'CITY',
  CreatedAt = 'CREATED_AT',
  Customer = 'CUSTOMER',
  CustomerErpId = 'CUSTOMER_ERP_ID',
  Driver = 'DRIVER',
  EndAt = 'END_AT',
  Hub = 'HUB',
  PlannedAt = 'PLANNED_AT',
  PoNumber = 'PO_NUMBER',
  Priority = 'PRIORITY',
  ShipTo = 'SHIP_TO',
  Source = 'SOURCE',
  StartAt = 'START_AT',
  State = 'STATE',
  Status = 'STATUS',
  TicketId = 'TICKET_ID',
  Type = 'TYPE',
  Zip = 'ZIP'
}

export type OrderedProductsAverage = {
  __typename?: 'OrderedProductsAverage';
  orderCount?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['ID']>;
  volume?: Maybe<Scalars['Float']>;
};

/** Data to create order quote */
export type OrderedProductsInput = {
  productId: Scalars['ID'];
  requestedVolume: Scalars['Float'];
  topOff?: InputMaybe<Scalars['Boolean']>;
  totalAssets: Scalars['Int'];
};

export type PandaBox = {
  __typename?: 'PandaBox';
  assignedAsset?: Maybe<Asset>;
  id: Scalars['ID'];
  imeiNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pandaBoxAssets: Array<PandaBoxAsset>;
  pandaBoxMeters?: Maybe<Array<PandaBoxMeter>>;
  pandaDocuments?: Maybe<Array<PandaDocument>>;
  powerSource?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type PandaBoxAsset = {
  __typename?: 'PandaBoxAsset';
  active: Scalars['Boolean'];
  asset?: Maybe<Asset>;
  id: Scalars['ID'];
  lastAssignedAt?: Maybe<Scalars['Int']>;
  pandaBox?: Maybe<PandaBox>;
};

/** Data to create Panda Box Asset */
export type PandaBoxAssetInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  assetId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type PandaBoxCollection = {
  __typename?: 'PandaBoxCollection';
  collection: Array<PandaBox>;
  metadata: MetaQuery;
};

export type PandaBoxFilter = {
  assetId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  unassigned?: InputMaybe<Scalars['Boolean']>;
};

/** Data to create Panda Box */
export type PandaBoxInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  assetId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  imeiNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pandaBoxAssetsAttributes?: InputMaybe<Array<PandaBoxAssetInput>>;
  pandaBoxImages?: InputMaybe<Array<PandaDocumentInput>>;
  pandaBoxMetersAttributes?: InputMaybe<Array<PandaBoxMeterInput>>;
  powerSource?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};

export type PandaBoxMeter = {
  __typename?: 'PandaBoxMeter';
  boardVersion?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastSyncedAt?: Maybe<Scalars['Int']>;
  lcpNode?: Maybe<Scalars['String']>;
  meterModel?: Maybe<Scalars['String']>;
  meterName?: Maybe<Scalars['String']>;
  pandaBox?: Maybe<PandaBox>;
  pandaDocuments?: Maybe<Array<PandaDocument>>;
  portNumber?: Maybe<Scalars['String']>;
  productCategory?: Maybe<ProductCategory>;
  totalizers?: Maybe<Scalars['Float']>;
};

/** Data to create PandaBoxMeter */
export type PandaBoxMeterInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  boardVersion?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  lcpNode?: InputMaybe<Scalars['String']>;
  meterImages?: InputMaybe<Array<PandaDocumentInput>>;
  meterModel?: InputMaybe<Scalars['String']>;
  meterName?: InputMaybe<Scalars['String']>;
  pandaBoxId?: InputMaybe<Scalars['ID']>;
  portNumber?: InputMaybe<Scalars['String']>;
  productCategoryId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  totalizers?: InputMaybe<Scalars['Float']>;
};

export type PandaBoxTransaction = {
  __typename?: 'PandaBoxTransaction';
  delivered?: Maybe<Scalars['String']>;
  deliveryOrder?: Maybe<DeliveryOrder>;
  discrepancy?: Maybe<Scalars['Float']>;
  extractionOrder?: Maybe<ExtractionOrder>;
  finalTotalizer?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  initialTotalizer?: Maybe<Scalars['Float']>;
  pandaBoxMeter?: Maybe<PandaBoxMeter>;
  readingMode?: Maybe<Scalars['String']>;
  totalizers?: Maybe<Scalars['JSON']>;
  transferOrder?: Maybe<TransferOrder>;
};

export type PandaBoxTransactionCollection = {
  __typename?: 'PandaBoxTransactionCollection';
  collection: Array<PandaBoxTransaction>;
  metadata: MetaQuery;
};

/** Fetch PandaBox Transaction */
export type PandaBoxTransactionInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  delivered?: InputMaybe<Scalars['Float']>;
  discrepancy?: InputMaybe<Scalars['Float']>;
  finalTotalizer?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  initialTotalizer?: InputMaybe<Scalars['Float']>;
  pandaBoxMeterId: Scalars['ID'];
  readingMode?: InputMaybe<ReadingModeEnum>;
};

export type PandaDocument = {
  __typename?: 'PandaDocument';
  blobFileUrl?: Maybe<Scalars['String']>;
  blobFileUrlDownload?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  documentType?: Maybe<Scalars['String']>;
  documentableId?: Maybe<Scalars['ID']>;
  documentableType?: Maybe<Scalars['String']>;
  externalFileData?: Maybe<AttachedFile>;
  fileData?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  leaCreatedById?: Maybe<Scalars['ID']>;
  leaCreatedByName?: Maybe<Scalars['String']>;
  leaDocumentType?: Maybe<Scalars['String']>;
  leaSignedDocument?: Maybe<Scalars['Boolean']>;
  leaUpdatedById?: Maybe<Scalars['ID']>;
  leaUpdatedByName?: Maybe<Scalars['String']>;
  showInDeliveryTicket?: Maybe<Scalars['Boolean']>;
};

/** Panda Document Input */
export type PandaDocumentInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** URL to file, should be permanent */
  directUploadFileUrl?: InputMaybe<Scalars['String']>;
  /** Document type of the Panda Document. */
  documentType?: InputMaybe<Scalars['String']>;
  /** Signed Blob Id to be attached to PandaDocument */
  externalFileDataBlobId?: InputMaybe<Scalars['String']>;
  /** Binary file data. */
  fileData?: InputMaybe<Scalars['String']>;
  /** URL of the document. */
  fileUrl?: InputMaybe<Scalars['String']>;
  /** filename */
  filename?: InputMaybe<Scalars['String']>;
  /** ID of the document. */
  id?: InputMaybe<Scalars['ID']>;
  /** Indicates if the LEA document is a mobile upload/dispatcher app. Only use for LeaCore! */
  leaIsMobileUpload?: InputMaybe<Scalars['Boolean']>;
  /** Indicates if the LEA document is a signed document. Only use for LeaCore! */
  leaSignedDocument?: InputMaybe<Scalars['Boolean']>;
};

export enum PandaDocumentTypeEnum {
  /** completion */
  Completion = 'completion',
  /** Invoices */
  Invoices = 'invoices',
  /** Signature */
  Signature = 'signature',
  /** Tank Chart */
  TankChart = 'tank_chart'
}

/** Enum to use on sorter fields when call a query */
export enum PandaTankMonitorFieldOrder {
  /** ascending sorter */
  Asc = 'asc',
  /** descending sorter */
  Desc = 'desc'
}

/** Autogenerated input type of PartialSync */
export type PartialSyncInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderGroupId: Scalars['ID'];
  shiftId: Scalars['ID'];
};

/** Autogenerated return type of PartialSync */
export type PartialSyncPayload = {
  __typename?: 'PartialSyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['JSON']>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type PaymentTerm = {
  __typename?: 'PaymentTerm';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  netDaysToPay?: Maybe<Scalars['Int']>;
};

export type PaymentTermInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  netDaysToPay?: InputMaybe<Scalars['Int']>;
};

export enum PaymentTypeEnum {
  /** Cash */
  Cash = 'cash',
  /** Check */
  Check = 'check',
  /** Credit Card */
  CreditCard = 'credit_card',
  /** Eft */
  Eft = 'eft',
  /** Na */
  Na = 'na',
  /** Other */
  Other = 'other'
}

export type Peripheral = {
  __typename?: 'Peripheral';
  cost?: Maybe<Scalars['Float']>;
  erpId?: Maybe<Scalars['String']>;
  flowRate?: Maybe<Scalars['Int']>;
  flowRateUnit?: Maybe<FlowRateUnit>;
  id: Scalars['ID'];
  legalDescription?: Maybe<Scalars['String']>;
  lineOfServices?: Maybe<Array<LineOfService>>;
  peripheralCategory?: Maybe<PeripheralCategory>;
  soldAs?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subType?: Maybe<Scalars['String']>;
};

export type PeripheralAttribute = {
  __typename?: 'PeripheralAttribute';
  formLabel?: Maybe<Scalars['String']>;
  formName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  peripheralAttributeType?: Maybe<Scalars['String']>;
  peripheralFormAttributeType?: Maybe<PeripheralFormAttribute>;
};

export type PeripheralCategory = {
  __typename?: 'PeripheralCategory';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type PeripheralCollection = {
  __typename?: 'PeripheralCollection';
  collection: Array<Peripheral>;
  metadata: MetaQuery;
};

export type PeripheralFilter = {
  all?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<PeripheralFilter>>;
};

export type PeripheralFormAttribute = {
  __typename?: 'PeripheralFormAttribute';
  options?: Maybe<Array<PeripheralFormOptionAttribute>>;
  placeholder?: Maybe<Scalars['String']>;
};

export type PeripheralFormOptionAttribute = {
  __typename?: 'PeripheralFormOptionAttribute';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** peripheral input */
export type PeripheralInput = {
  cost?: InputMaybe<Scalars['Float']>;
  erpId?: InputMaybe<Scalars['String']>;
  flowRate?: InputMaybe<Scalars['Int']>;
  flowRateUnit?: InputMaybe<FlowRateUnit>;
  id?: InputMaybe<Scalars['ID']>;
  legalDescription?: InputMaybe<Scalars['String']>;
  lineOfServiceIds?: InputMaybe<Array<Scalars['ID']>>;
  peripheralCategoryId: Scalars['ID'];
  soldAs?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subType?: InputMaybe<Scalars['String']>;
};

export type PeripheralInstance = {
  __typename?: 'PeripheralInstance';
  fileUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  peripheralAttribute?: Maybe<PeripheralAttribute>;
  value?: Maybe<Scalars['String']>;
};

/** Peripheral Instance Input */
export type PeripheralInstanceInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** ID of PeripheralInstance. Required on update. */
  id?: InputMaybe<Scalars['ID']>;
  /** Movement Order Line Item ID. */
  movementOrderLineItemId?: InputMaybe<Scalars['ID']>;
  /** Peripheral Attribute ID. */
  peripheralAttributeId?: InputMaybe<Scalars['ID']>;
  /** Peripheral Attribute Value. */
  value?: InputMaybe<Scalars['String']>;
};

export type PickupPointCode = {
  __typename?: 'PickupPointCode';
  code?: Maybe<Scalars['String']>;
  erpId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  loadingAccount?: Maybe<LoadingAccount>;
  loadingAccountId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  netsuiteId?: Maybe<Scalars['String']>;
  products: Array<Product>;
  supplier: Supplier;
  terminal: Terminal;
  terminalsSupplier: TerminalsSupplier;
  terminalsSupplierId: Scalars['ID'];
};

export type PickupPointCodeCollection = {
  __typename?: 'PickupPointCodeCollection';
  collection: Array<PickupPointCode>;
  metadata: MetaQuery;
};

export type PickupPointCodeFilter = {
  all?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<PickupPointCodeFilter>>;
  supplierName?: InputMaybe<Scalars['String']>;
  terminalName?: InputMaybe<Scalars['String']>;
};

export type PickupPointCodeSorter = {
  field: PickupPointCodeSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum PickupPointCodeSorterEnum {
  Code = 'CODE',
  Name = 'NAME',
  Suppliername = 'SUPPLIERNAME',
  Terminalname = 'TERMINALNAME'
}

export enum PortalAccessLevelEnum {
  /** Provides edit access to customer portal */
  Edit = 'edit',
  /** Provides view only access to customer portal */
  View = 'view'
}

/** Autogenerated input type of PostDeliveryNoteCreate */
export type PostDeliveryNoteCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryOrderId: Scalars['ID'];
  postDeliveryNote?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of PostDeliveryNoteCreate */
export type PostDeliveryNoteCreatePayload = {
  __typename?: 'PostDeliveryNoteCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deliveryOrder?: Maybe<DeliveryOrder>;
};

/** Tank Monitor attached asset preference availability input */
export type PreferenceAvailabilityInput = {
  /** Best end time of availability, in HH:MM format (e.g., 15:00 for 3pm) */
  bestEndTime?: InputMaybe<Scalars['String']>;
  /** Best start time of availability, in HH:MM format (e.g., 15:00 for 3pm) */
  bestStartTime?: InputMaybe<Scalars['String']>;
  /** Day of the week */
  day?: InputMaybe<Scalars['String']>;
  /** End time of availability, in HH:MM format (e.g., 15:00 for 3pm) */
  endTime?: InputMaybe<Scalars['String']>;
  /** Preferred end time of availability, in HH:MM format (e.g., 15:00 for 3pm) */
  preferredEndTime?: InputMaybe<Scalars['String']>;
  /** Preferred start time of availability, in HH:MM format (e.g., 15:00 for 3pm) */
  preferredStartTime?: InputMaybe<Scalars['String']>;
  /** Start time of availability, in HH:MM format (e.g., 15:00 for 3pm) */
  startTime?: InputMaybe<Scalars['String']>;
};

export enum PreferrableTypeEnum {
  /** Customer record */
  Customer = 'Customer',
  /** CustomerBranch record */
  CustomerBranch = 'CustomerBranch',
  /** Worker record */
  Worker = 'Worker'
}

export type PreferredProductTerminal = {
  __typename?: 'PreferredProductTerminal';
  fee?: Maybe<Fee>;
  id: Scalars['ID'];
  isDefault?: Maybe<Scalars['Boolean']>;
  preferredProductTerminalSuppliers?: Maybe<Array<PreferredProductTerminalSupplier>>;
  product: Product;
  rate?: Maybe<Scalars['Float']>;
  terminal: Terminal;
};

/** Attributes for creating or updating a preferred product terminal */
export type PreferredProductTerminalInput = {
  /** Mark the preferred product terminal for destruction */
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** ID of the fee */
  feeId?: InputMaybe<Scalars['ID']>;
  /** ID of the preferred product terminal */
  id?: InputMaybe<Scalars['ID']>;
  /** Is the preferred product terminal default */
  isDefault?: InputMaybe<Scalars['Boolean']>;
  /** Suppliers for the preferred product terminal */
  preferredProductTerminalSuppliersAttributes?: InputMaybe<Array<PreferredProductTerminalSupplierInput>>;
  /** ID of the product */
  productId: Scalars['ID'];
  /** Rate of the supplier */
  rate?: InputMaybe<Scalars['Float']>;
  /** ID of the terminal */
  terminalId: Scalars['ID'];
};

export type PreferredProductTerminalSupplier = {
  __typename?: 'PreferredProductTerminalSupplier';
  id: Scalars['ID'];
  priority: Scalars['Int'];
  supplier: Supplier;
};

/** Attributes for creating or updating a preferred product terminal supplier */
export type PreferredProductTerminalSupplierInput = {
  /** Mark the preferred product terminal supplier for destruction */
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** ID of the preferred product terminal supplier */
  id?: InputMaybe<Scalars['ID']>;
  /** Priority of the supplier */
  priority?: InputMaybe<Scalars['Int']>;
  /** ID of the supplier */
  supplierId: Scalars['ID'];
};

export type PreferredSupplier = {
  __typename?: 'PreferredSupplier';
  id: Scalars['ID'];
  loadingAccount?: Maybe<LoadingAccount>;
  priority?: Maybe<Scalars['Int']>;
};

/** PreferredSupplier Input */
export type PreferredSupplierInput = {
  /** Deprecated. DO NOT USE. */
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** PreferredSupplier ID. Required on update. */
  id?: InputMaybe<Scalars['ID']>;
  /** Loading account ID. */
  loadingAccountId?: InputMaybe<Scalars['ID']>;
  /** Priority of Supplier, and should be one among 1, 2, and 3. */
  priority?: InputMaybe<Scalars['Int']>;
};

export type PriceConfiguration = {
  __typename?: 'PriceConfiguration';
  calculatedDiscount?: Maybe<Scalars['Float']>;
  calculatedFees?: Maybe<Scalars['JSON']>;
  calculatedMargins?: Maybe<Scalars['JSON']>;
  calculatedTaxes?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  pricing: Pricing;
  totalPrice?: Maybe<Scalars['Float']>;
};

/** Create Resource Pricing Type input */
export type PriceConfigurationInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  pricingId?: InputMaybe<Scalars['ID']>;
};

export type Pricing = {
  __typename?: 'Pricing';
  createdAtTimestamp?: Maybe<Scalars['String']>;
  customerBranchId?: Maybe<Scalars['ID']>;
  effectiveEndTimestamp?: Maybe<Scalars['String']>;
  effectiveStartTimestamp?: Maybe<Scalars['String']>;
  expirationDatetimeTimestamp?: Maybe<Scalars['String']>;
  freight?: Maybe<Scalars['Float']>;
  hubId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  isTemporary?: Maybe<Scalars['Boolean']>;
  marketId?: Maybe<Scalars['ID']>;
  markup?: Maybe<Scalars['Float']>;
  previousPrice?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  productId?: Maybe<Scalars['ID']>;
  rateType?: Maybe<RateType>;
  supplierId?: Maybe<Scalars['ID']>;
  taxes?: Maybe<Scalars['Float']>;
  terminalId?: Maybe<Scalars['ID']>;
  totalPrice?: Maybe<Scalars['Float']>;
  ttlDurationSeconds?: Maybe<Scalars['Int']>;
};

export type PricingCollection = {
  __typename?: 'PricingCollection';
  collection: Array<Pricing>;
  metadata: MetaDataQuery;
};

export type PricingFilter = {
  endDateTimestamp: Scalars['Int'];
  rateType: Scalars['String'];
  startDateTimestamp: Scalars['Int'];
};

export type PricingFiltersInput = {
  productIds: Array<Scalars['ID']>;
  rateTypeId: Scalars['ID'];
};

/** Pricing history type */
export type PricingHistory = {
  __typename?: 'PricingHistory';
  /** The date the pricing was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The effective from timestamp date of the pricing */
  effectiveFromTimestamp?: Maybe<Scalars['Int']>;
  /** The effective to timestamp date of the pricing */
  effectiveToTimestamp?: Maybe<Scalars['Int']>;
  /** Historable Name */
  historableName: Scalars['String'];
  /** Historable Type */
  historableType: Scalars['String'];
  /** The ID of the pricing history */
  id: Scalars['ID'];
  /** The resource pricing */
  resourcePricing: ResourcePricing;
  /** The status of the pricing */
  status: Scalars['String'];
  /** The date the pricing was updated */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The name of the user who created the pricing */
  userName?: Maybe<Scalars['String']>;
};

export enum PricingMarginStatusEnum {
  /** Margin is available */
  MarginAvailable = 'margin_available',
  /** Margin is missing */
  MarginMissing = 'margin_missing'
}

export type Product = {
  __typename?: 'Product';
  active: Scalars['Boolean'];
  allowTopUp?: Maybe<Scalars['Boolean']>;
  barcode?: Maybe<Scalars['String']>;
  brand?: Maybe<Brand>;
  brandId?: Maybe<Scalars['ID']>;
  category: Scalars['String'];
  code?: Maybe<Scalars['String']>;
  colorCode?: Maybe<Scalars['String']>;
  comparableProducts?: Maybe<Array<ProductResource>>;
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  deliveryType?: Maybe<Scalars['String']>;
  downgradableProducts?: Maybe<Array<ProductResource>>;
  erpId?: Maybe<Scalars['String']>;
  flowRate?: Maybe<Scalars['Int']>;
  glNumber?: Maybe<Scalars['String']>;
  hub?: Maybe<Hub>;
  hubResource?: Maybe<HubResource>;
  id: Scalars['ID'];
  ignoreNsPush?: Maybe<Scalars['Boolean']>;
  imageUrl?: Maybe<Scalars['String']>;
  irelyId?: Maybe<Scalars['String']>;
  lastSyncedTime?: Maybe<Scalars['String']>;
  legalDescription?: Maybe<Scalars['String']>;
  lineOfServices?: Maybe<Array<LineOfService>>;
  longDescription?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  netsuiteId?: Maybe<Scalars['ID']>;
  nonEditableRecords?: Maybe<Array<Scalars['JSON']>>;
  phoenixNumber?: Maybe<Scalars['String']>;
  productCategory?: Maybe<ProductCategory>;
  productConstituents?: Maybe<Array<ProductConstituent>>;
  productSubCategory?: Maybe<ProductSubCategory>;
  productType: Scalars['String'];
  qrCode?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  soldAs?: Maybe<Scalars['String']>;
  subCategory?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
};

/** Categorable Type */
export type ProductCategorable = ResourcePricing;

export type ProductCategory = {
  __typename?: 'ProductCategory';
  categoryType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  productCategoryProductSubCategories?: Maybe<Array<ProductCategoryProductSubCategory>>;
  productSubCategories?: Maybe<Array<ProductSubCategory>>;
};

export type ProductCategoryProductSubCategory = {
  __typename?: 'ProductCategoryProductSubCategory';
  id: Scalars['ID'];
  productCategory: ProductCategory;
  productSubCategory: ProductSubCategory;
};

export type ProductCategoryResource = {
  __typename?: 'ProductCategoryResource';
  id: Scalars['ID'];
  productCategorable: ProductCategorable;
  productCategorableId: Scalars['ID'];
  productCategorableType: Scalars['String'];
  productCategory: ProductCategory;
};

/** Manages a connection with product category */
export type ProductCategoryResourceInput = {
  /** Only pass and set true when need to destroy */
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** Product Category Resource ID. Required on update. */
  id?: InputMaybe<Scalars['ID']>;
  /** ID of Product Category to be associated with. */
  productCategoryId?: InputMaybe<Scalars['ID']>;
  /** User ID who is creating or updating the record. */
  userId?: InputMaybe<Scalars['ID']>;
};

export type ProductCollection = {
  __typename?: 'ProductCollection';
  collection: Array<Product>;
  metadata: MetaQuery;
};

export type ProductConstituent = {
  __typename?: 'ProductConstituent';
  basicProduct: Product;
  id: Scalars['ID'];
  percentage?: Maybe<Scalars['Float']>;
};

/** Product delivery type enum */
export enum ProductDeliveryTypeEnum {
  /** Products with unit gal */
  BulkLube = 'bulk_lube',
  /** All manual/metered products (liquid volume products) */
  Normal = 'normal',
  /** Products with unit ea, pound, quart, tubes */
  PackageLube = 'package_lube'
}

export type ProductDetail = {
  __typename?: 'ProductDetail';
  applicableTaxDetails?: Maybe<Array<TaxDetail>>;
  error?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['ID']>;
  productPricingDetails?: Maybe<ItemsDetail>;
  topOff?: Maybe<Scalars['Boolean']>;
};

export type ProductFilter = {
  /** Fetch only active products */
  active?: InputMaybe<Scalars['Boolean']>;
  all?: InputMaybe<Scalars['String']>;
  brand?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  /** Fetch only products that are available in the customer portal for the given customer */
  customerId?: InputMaybe<Scalars['ID']>;
  /** Filter products by delivery type */
  deliveryType?: InputMaybe<ProductDeliveryTypeEnum>;
  /** Filter products by delivery types */
  deliveryTypes?: InputMaybe<Array<ProductDeliveryTypeEnum>>;
  erpId?: InputMaybe<Scalars['String']>;
  /** Fetch only products that are available in the customer portal */
  fromCustomerPortal?: InputMaybe<Scalars['Boolean']>;
  hubIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter branded (true) or unbranded (false) products */
  isBranded?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<ProductFilter>>;
  productCategoryId?: InputMaybe<Scalars['ID']>;
  productCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  unit?: InputMaybe<UnitEnum>;
  units?: InputMaybe<Array<UnitEnum>>;
};

export type ProductOrderFee = {
  __typename?: 'ProductOrderFee';
  amount?: Maybe<Scalars['Float']>;
  data: Scalars['JSON'];
  fee?: Maybe<Fee>;
  id?: Maybe<Scalars['ID']>;
  isManuallyUpdated: Scalars['Boolean'];
  orderGroup?: Maybe<OrderGroup>;
  product?: Maybe<Product>;
  quantity?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

export type ProductOrderFeeInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  amount?: InputMaybe<Scalars['Float']>;
  data?: InputMaybe<Scalars['JSON']>;
  feeId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  mobileOffline?: InputMaybe<Scalars['Boolean']>;
  orderGroupId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Float']>;
  total?: InputMaybe<Scalars['Float']>;
};

export type ProductOrderFeeResponse = {
  __typename?: 'ProductOrderFeeResponse';
  error?: Maybe<Scalars['String']>;
  productOrderFees?: Maybe<Array<ProductOrderFee>>;
  success: Scalars['Boolean'];
  warning?: Maybe<Warning>;
};

export type ProductPurchaseLimit = {
  __typename?: 'ProductPurchaseLimit';
  customers?: Maybe<Array<Customer>>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  timeUnit?: Maybe<TimeUnitEnum>;
  volume?: Maybe<Scalars['String']>;
};

export type ProductPurchaseLimitCollection = {
  __typename?: 'ProductPurchaseLimitCollection';
  collection: Array<ProductPurchaseLimit>;
  metadata: MetaQuery;
};

export type ProductPurchaseLimitFilter = {
  name?: InputMaybe<Scalars['String']>;
};

/** Default product purchase limit Input */
export type ProductPurchaseLimitInput = {
  name: Scalars['String'];
  productId: Scalars['Int'];
  timeUnit?: InputMaybe<TimeUnitEnum>;
  volume: Scalars['Int'];
};

export type ProductResource = {
  __typename?: 'ProductResource';
  comparableProductId: Scalars['ID'];
  downgradableProductId: Scalars['ID'];
  id: Scalars['ID'];
  productResource: Product;
  resourceId: Scalars['ID'];
  resourceType: Scalars['String'];
};

export type ProductSorter = {
  field: ProductSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum ProductSorterEnum {
  Alias = 'ALIAS',
  Category = 'CATEGORY',
  Code = 'CODE',
  Deliverytype = 'DELIVERYTYPE',
  Erpid = 'ERPID',
  Soldas = 'SOLDAS',
  Subcat = 'SUBCAT',
  Type = 'TYPE',
  Unit = 'UNIT'
}

export type ProductSubCategory = {
  __typename?: 'ProductSubCategory';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  productCategories?: Maybe<Array<ProductCategory>>;
  productCategoryProductSubCategories?: Maybe<Array<ProductCategoryProductSubCategory>>;
  value?: Maybe<Scalars['String']>;
};

export type ProductTax = {
  __typename?: 'ProductTax';
  glCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  pandaPriceTaxId?: Maybe<Scalars['ID']>;
  productId?: Maybe<Scalars['ID']>;
};

/** Tax Input */
export type ProductTaxesInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  glCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  pandaPriceTaxId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
};

export type ProductTerminal = {
  __typename?: 'ProductTerminal';
  id: Scalars['ID'];
  minimalLoad?: Maybe<Scalars['Int']>;
  product: Product;
};

export enum ProductTestEnum {
  /** Halogen Genkno test >1000 */
  HalogenGenknoTestGreaterThanThousand = 'halogen_genkno_test_greater_than_thousand',
  /** Halogen Genkno test <1000 */
  HalogenGenknoTestSmallerThanThousand = 'halogen_genkno_test_smaller_than_thousand',
  /** Halogen Test >1000 */
  HalogenTestGreaterThanThousand = 'halogen_test_greater_than_thousand',
  /** Halogen Test <1000 */
  HalogenTestSmallerThanThousand = 'halogen_test_smaller_than_thousand'
}

export enum ProductTypeEnum {
  /** Basic */
  Basic = 'basic',
  /** Blend */
  Blend = 'blend'
}

/** Product reference with brand types (v3) */
export type ProductWithBrandTypesInput = {
  brandTypes?: InputMaybe<Array<LatpBrandTypeEnum>>;
  productId: Scalars['ID'];
};

/** Enum for list of providers */
export enum ProvidersEnum {
  Anova = 'Anova',
  AnovaUnify = 'AnovaUnify',
  Centeron = 'Centeron',
  Evo = 'EVO',
  EcoGreen = 'EcoGreen',
  Gaslog = 'Gaslog',
  Graco = 'Graco',
  Kii = 'KII',
  MyTankApp = 'MyTankApp',
  MyTankInfo = 'MyTankInfo',
  OtoData = 'OtoData',
  Pneumercator = 'Pneumercator',
  Samsara = 'Samsara',
  SmartTank = 'SmartTank',
  TankScan = 'TankScan',
  Telapoint = 'Telapoint',
  Titan = 'Titan',
  VeederRoot = 'VeederRoot',
  WesRock = 'WesRock'
}

/** Enum for purchase order type */
export enum PurchaseOrderTypeEnum {
  /** Dollar Amount / Blanket PO */
  BlanketPo = 'blanket_po',
  /** Job PO */
  JobPo = 'job_po',
  /** Job plus Order PO */
  JobPoPlus = 'job_po_plus',
  /** Order PO - After */
  OrderPoAfter = 'order_po_after',
  /** Order PO - Before */
  OrderPoBefore = 'order_po_before'
}

/** Autogenerated input type of PurgeUserImage */
export type PurgeUserImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of PurgeUserImage */
export type PurgeUserImagePayload = {
  __typename?: 'PurgeUserImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type PushOrderToFdnData = {
  __typename?: 'PushOrderToFdnData';
  loadingOrderGroupIds?: Maybe<Array<Scalars['ID']>>;
};

/** Autogenerated input type of PushOrderToFdn */
export type PushOrderToFdnInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  pushRecurringOrders: Scalars['Boolean'];
};

/** Autogenerated return type of PushOrderToFdn */
export type PushOrderToFdnPayload = {
  __typename?: 'PushOrderToFdnPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  data?: Maybe<PushOrderToFdnData>;
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type QrCode = {
  __typename?: 'QrCode';
  code?: Maybe<Scalars['String']>;
  codeType?: Maybe<Scalars['String']>;
  codeableType?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  purpose?: Maybe<Scalars['String']>;
};

export type QrCodeCollection = {
  __typename?: 'QrCodeCollection';
  collection: Array<QrCode>;
  metadata: MetaQuery;
};

export type QrCodeFilter = {
  codeType?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<QrCodeFilter>>;
  purpose?: InputMaybe<Scalars['String']>;
};

export type QrCodeInput = {
  code: Scalars['String'];
  codeType?: InputMaybe<CodeTypeEnum>;
  id?: InputMaybe<Scalars['ID']>;
  usage?: InputMaybe<CodeUsageEnum>;
};

export type QrCodeSorter = {
  field: QrCodeSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum QrCodeSorterEnum {
  Code = 'CODE',
  CreatedAt = 'CREATED_AT',
  Purpose = 'PURPOSE'
}

export type QuantityRangeFilterInput = {
  maxQuantity?: InputMaybe<Scalars['Int']>;
  minQuantity?: InputMaybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  aliasMappings: AliasMappingCollection;
  appVersion: AppVersion;
  appliedPricings?: Maybe<Array<AppliedPricing>>;
  asset: Asset;
  assetInventories: AssetsInventoriesInventoryRecordTypeCollection;
  assetInventorySummary: Scalars['JSON'];
  assetMovementOrderHistory: Array<AssetMovementOrderHistory>;
  assets: Array<Asset>;
  assetsDevice: Array<Device>;
  assetsInventories: AssetsInventoriesInventoryRecordTypeCollection;
  assetsWithZones: Array<Asset>;
  associatedTenants?: Maybe<Array<Tenant>>;
  biMetabaseReport?: Maybe<BiResponse>;
  bolReports: BolReportCollection;
  brand: Brand;
  brands: Array<Brand>;
  bulkEmailSummary: Array<BulkEmail>;
  bulkPlantShift?: Maybe<BulkPlantsShiftType>;
  bulkPlants: Array<BulkPlantsShiftType>;
  capacityTypes: Array<CapacityTypes>;
  ccTenants?: Maybe<Array<CcTenant>>;
  cities?: Maybe<Array<Scalars['String']>>;
  compartmentMismatch?: Maybe<Array<CompartmentMismatch>>;
  countryCodes: Scalars['JSON'];
  creditLedgerMonthlyStats?: Maybe<CreditLedgerMonthlyStats>;
  crudePricing: CrudePricingCollection;
  current: Current;
  customer: Customer;
  customerAddressBook: AddressBook;
  customerBranch: CustomerBranch;
  customerPortalConfig: CustomerPortalConfiguration;
  customerSegment: CustomerSegment;
  customerSegments: Array<CustomerSegment>;
  customers: Array<Customer>;
  dataImportProgresses?: Maybe<DataImportProgress>;
  dataImports: Array<DataImport>;
  degreeDayReportSummary: Scalars['JSON'];
  degreeDaySettingByAsset?: Maybe<DegreeDaySetting>;
  degreeDaySettings: DegreeDaySettingCollection;
  degreeDayTanks: UnifiedTankCollection;
  degreeDays: DegreeDayCollection;
  degreeDaysCsv?: Maybe<DoliCsv>;
  deliveryAsset: DeliveryAsset;
  deliveryAssets: Array<DeliveryAsset>;
  deliveryOrder: DeliveryOrder;
  deliveryOrderLineItemCsv?: Maybe<DoliCsv>;
  deliveryOrders?: Maybe<Array<DeliveryOrder>>;
  device: Device;
  devicesSummary: Scalars['JSON'];
  distinctCardLockCustomers: CustomerCollection;
  driver: Driver;
  driverDemurrage: DriverDemurrage;
  drivers: Array<Driver>;
  exportDocument?: Maybe<ExportDocument>;
  exportLineOfServicesCsv?: Maybe<DoliCsv>;
  exportPpcCsv?: Maybe<DoliCsv>;
  exportRackMarketsCsv?: Maybe<DoliCsv>;
  exportTerminalsCsv?: Maybe<DoliCsv>;
  extractionOrder: ExtractionOrder;
  features: Array<Feature>;
  fee: Fee;
  feedbacks: FeedbackCollection;
  fees: Array<Fee>;
  fetchCities?: Maybe<Array<Scalars['String']>>;
  fetchCreditLedgerTransactions?: Maybe<CreditLedgerTransactionCollection>;
  fetchGraphData?: Maybe<Graph>;
  fetchInteractionProgress?: Maybe<InteractionProgress>;
  fetchLeaGeneralTemplate?: Maybe<LeaDocument>;
  fetchLeaTenantContent?: Maybe<TenantContent>;
  fetchNestedLinkedOrderGroupIds?: Maybe<Array<Scalars['ID']>>;
  fetchOrderGroup: OrderGroupAdjustment;
  fetchResourceByIds: Array<ResourceFetchableById>;
  fetchResourceNames: Scalars['JSON'];
  fetchResourceTenantCustomerBranches: ResourceTenantCustomerBranchCollection;
  fetchResourceTenantCustomers: ResourceTenantCustomerCollection;
  fetchRouteFlushing: Flushing;
  fetchRouteFlushings: Array<Flushing>;
  fetchZips?: Maybe<Array<Scalars['String']>>;
  fetchZoneProductBatches?: Maybe<Array<ZoneProductBatch>>;
  filterRouteSettingsHistory: VersionCollection;
  filteredAccountingExport: AccountingExport;
  filteredAddressBooks: AddressBookCollection;
  filteredAppVersions: AppVersionCollection;
  filteredApplicableFees: ApplicableFeeCollection;
  filteredAssetMovementOrderHistoryList: AssetMovementOrderHistoryListCollection;
  filteredAssets: AssetCollection;
  filteredBoxTransactions: PandaBoxTransactionCollection;
  filteredCardLockTransactions: CardLockTransactionCollection;
  filteredCcTenants?: Maybe<CcTenantCollection>;
  filteredCustomerBranches: CustomerBranchCollection;
  filteredCustomerReports: CustomerReportCollection;
  filteredCustomerUsers: CustomerUserCollection;
  /** @deprecated This query is deprecated. Please use 'filtered_customers_sorter' instead. */
  filteredCustomers: CustomerCollection;
  filteredCustomersSorter: CustomerCollection;
  filteredDataFetchLogger: DataFetchLoggerCollection;
  filteredDeliveryAssets: DeliveryAssetCollection;
  filteredDeliveryOrderLineItems: DeliveryOrderLineItemCollection;
  filteredDriverDemurrage: DriverDemurrageCollection;
  filteredDriverRates: DriverRateCollection;
  filteredDrivers: DriverCollection;
  filteredFees: FeeCollection;
  filteredGroups: GroupCollection;
  filteredInvoice: InvoiceCollection;
  filteredLeaReport: MovementOrderCollection;
  filteredLeaRoiReport: LeaLineItemCollection;
  filteredLeas: LeaCoreCollection;
  filteredLineOfServices: LineOfServiceCollection;
  filteredLoadOrderLineItems: LoadingOrderLineItemCollection;
  filteredLoadingAccounts: LoadingAccountCollection;
  filteredMargins: MarginCollection;
  filteredNotes: NoteCollection;
  filteredOrderGroups: OrderGroupCollection;
  filteredOrderLinks: OrderLinkCollection;
  filteredOrderWell: OrderWellCollection;
  filteredPandaBoxAssets: Array<Asset>;
  filteredPandaBoxes: PandaBoxCollection;
  filteredPeripherals: PeripheralCollection;
  filteredPickupPointCodes: PickupPointCodeCollection;
  filteredPricings: Array<Pricing>;
  filteredProductPurchaseLimit: ProductPurchaseLimitCollection;
  filteredProducts: ProductCollection;
  filteredQrCodes: QrCodeCollection;
  filteredRawShifts: RawShiftCollection;
  filteredRoles: RoleCollection;
  filteredSalesReport?: Maybe<Scalars['JSON']>;
  filteredShiftBuilderOrders: OrderWellCollection;
  filteredShiftPlans: ShiftPlanCollection;
  filteredShifts: ShiftCollection;
  filteredSidekiqRequest: SidekiqRequestCollection;
  filteredSuppliers: SupplierCollection;
  filteredSyncedOrders: OrderGroupSyncReportCollection;
  filteredTags: TagCollection;
  filteredTankMonitors: DeviceCollection;
  filteredTaxReport?: Maybe<Scalars['JSON']>;
  filteredTaxes: TaxCollection;
  filteredTemporaryPricingCustomerBranches: CustomerBranchCollection;
  filteredTemporaryPricingCustomers: CustomerCollection;
  filteredTemporaryPricings: Array<Pricing>;
  filteredTerminals: TerminalCollection;
  filteredTerminalsSuppliers: TerminalsSupplierCollection;
  filteredTmDynamicCount?: Maybe<Scalars['String']>;
  filteredTransferOrders: TransferOrderCollection;
  formProgresses?: Maybe<FormProgress>;
  group: Group;
  initialFeatures: Array<InitialFeature>;
  invoice: Invoice;
  irelyFilters?: Maybe<Array<IrelyFilter>>;
  irelyProductCategories?: Maybe<Array<IrelyProductCategory>>;
  irelyUoms?: Maybe<Array<IrelyUom>>;
  leaCore: LeaCore;
  leaDocusealSubmission: DocusealSubmissionResponse;
  leaDocusealSubmissionDocuments: Array<DocusealDocument>;
  leaManagers: Array<User>;
  leaReports: LeaReport;
  lemBillingReport: LemBillingReport;
  lineOfService: LineOfService;
  lineOfServices: Array<LineOfService>;
  linkedOrdersDriversLists?: Maybe<Array<LinkedDriver>>;
  loadingAccount: LoadingAccount;
  loadingLineOrderItems: Array<LoadingOrderLineItem>;
  loadingOrder: LoadingOrder;
  loadingOrders?: Maybe<Array<LoadingOrder>>;
  loadingReceipts?: Maybe<Array<LoadingReceipt>>;
  margin: Margin;
  market: Market;
  markets: Array<Market>;
  migrationConfig: MigrationConfig;
  movementOrder: MovementOrder;
  notificationTemplate?: Maybe<NotificationTemplate>;
  notificationTemplates?: Maybe<Array<NotificationTemplate>>;
  orderGroup: OrderGroup;
  orderGroups?: Maybe<Array<OrderGroup>>;
  orderHistory?: Maybe<Array<Version>>;
  orderPricingImportCompletion: Scalars['Boolean'];
  orderWell?: Maybe<Array<OrderWell>>;
  orderWellGroupingSummary: Array<OrderWellGroupingSummary>;
  orderWellOrders?: Maybe<Array<OrderWell>>;
  ownAssets: Array<Asset>;
  pandaBox: PandaBox;
  pandaBoxLogs?: Maybe<Array<S3Object>>;
  paymentTerm: PaymentTerm;
  paymentTerms: Array<PaymentTerm>;
  peripheral: Peripheral;
  peripheralAttributes: Array<PeripheralAttribute>;
  peripherals: Array<Peripheral>;
  peripheralsCategories: Array<PeripheralCategory>;
  pickupPointCodes: Array<PickupPointCode>;
  preferredCustomers: Array<Customer>;
  preshiftChecklists: Array<ShiftChecklist>;
  pricing: Pricing;
  pricingHistory?: Maybe<Array<PricingHistory>>;
  product: Product;
  productCategories: Array<ProductCategory>;
  productPurchaseLimit: ProductPurchaseLimit;
  productSubCategories: Array<ProductSubCategory>;
  products: Array<Product>;
  qboTokenStatus: TokenStatus;
  rackMarkets: RackMarketCollection;
  rateType: RateType;
  rateTypes: Array<RateType>;
  rawPricingImportSessions: RawPricingImportSessionCollection;
  rawShift: RawShift;
  rawShiftSummary?: Maybe<RawShiftSummary>;
  rawShifts?: Maybe<Array<RawShift>>;
  recommendations: Recommendation;
  recurrencesOrders: Array<RecurrenceOrder>;
  resourcePricing: ResourcePricing;
  resourcePricings: Array<ResourcePricing>;
  resourceStatusType: Array<ResourceStatusTypes>;
  role: Role;
  roles: Array<Role>;
  routeSettings: SettingCollection;
  routeStaticTimes: RouteStaticTimeCollection;
  /** Fetch a saved view by ID */
  savedView?: Maybe<SavedView>;
  /** Fetch all saved views for the current user */
  savedViews?: Maybe<Array<SavedView>>;
  searchDeliveryOrders: Array<DeliveryOrder>;
  searchExtractionOrders: Array<ExtractionOrder>;
  searchLoadingOrders: Array<LoadingOrder>;
  searchTransferOrders: Array<TransferOrder>;
  setting: Setting;
  settings: Array<Setting>;
  shift: Shift;
  shiftPlanDeliveries: Array<ShiftPlanDeliveries>;
  shiftPlanDeliveryTimeWindows?: Maybe<Array<ShiftPlanDeliveryTimeWindows>>;
  shiftPlanInventory?: Maybe<ShiftPlanInventory>;
  shiftPlannerDriverOrders: ShiftPlannerDriverOrderCollection;
  shiftPlannerDriverSummary: Array<ShiftPlannerDriverSummary>;
  shiftStates: Scalars['JSON'];
  shifts?: Maybe<Array<Shift>>;
  supplier: Supplier;
  supplierDetail?: Maybe<SupplierDetailSupplier>;
  supplierDetailV3?: Maybe<SupplierDetailV3Supplier>;
  suppliers: Array<Supplier>;
  suppliersForCriteria: Array<Supplier>;
  syncAllStatus: Scalars['JSON'];
  tag?: Maybe<Tag>;
  /** @deprecated Dont use this. This uses too much resuorces */
  tasks: Array<Task>;
  tax: Tax;
  terminal: Terminal;
  terminalDistance: Array<TerminalDistance>;
  terminals: Array<Terminal>;
  timezones: Scalars['JSON'];
  tmFilteredCustomerBranches: GroupedSubject;
  tmFilteredCustomers: GroupedSubject;
  tmFilteredOrderGroups: GroupedSubject;
  todaysPricings: PricingCollection;
  transferOrder: TransferOrder;
  transferOrders?: Maybe<Array<TransferOrder>>;
  user: User;
  users: Array<User>;
};


export type QueryAliasMappingsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryAppVersionArgs = {
  id: Scalars['ID'];
};


export type QueryAppliedPricingsArgs = {
  orderGroupId: Scalars['ID'];
  orderStatus?: InputMaybe<Scalars['String']>;
  shiftStatus?: InputMaybe<Scalars['String']>;
};


export type QueryAssetArgs = {
  id: Scalars['ID'];
};


export type QueryAssetInventoriesArgs = {
  filter?: InputMaybe<AssetInventoriesFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryAssetInventorySummaryArgs = {
  assetId?: InputMaybe<Scalars['ID']>;
  fromDate?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['ID']>;
  toDate?: InputMaybe<Scalars['Int']>;
};


export type QueryAssetMovementOrderHistoryArgs = {
  id: Scalars['ID'];
};


export type QueryAssetsDeviceArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryAssetsInventoriesArgs = {
  filter?: InputMaybe<AssetInventoryFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryAssociatedTenantsArgs = {
  tenantId: Scalars['ID'];
};


export type QueryBiMetabaseReportArgs = {
  params: Scalars['JSON'];
  reportId: Scalars['Int'];
  reportType: ReportEnum;
};


export type QueryBolReportsArgs = {
  filter?: InputMaybe<BolReportFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryBrandArgs = {
  id: Scalars['ID'];
};


export type QueryBrandsArgs = {
  brandType?: InputMaybe<BrandTypeEnum>;
};


export type QueryBulkEmailSummaryArgs = {
  orderGroupIds: Array<Scalars['ID']>;
};


export type QueryBulkPlantShiftArgs = {
  date: Scalars['Int'];
  resourceId: Scalars['ID'];
  resourceType: ResourceTypeEnum;
};


export type QueryBulkPlantsArgs = {
  filter?: InputMaybe<BulkPlantsFiltersInput>;
};


export type QueryCcTenantsArgs = {
  filter?: InputMaybe<CcTenantFilterInput>;
};


export type QueryCompartmentMismatchArgs = {
  orderGroupId: Scalars['ID'];
  type: CompartmentMismatchOrderTypeEnum;
};


export type QueryCreditLedgerMonthlyStatsArgs = {
  customerId: Scalars['ID'];
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
};


export type QueryCrudePricingArgs = {
  filter?: InputMaybe<CrudePricingFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryCustomerArgs = {
  id: Scalars['ID'];
};


export type QueryCustomerAddressBookArgs = {
  addressBookId: Scalars['ID'];
  customerId: Scalars['ID'];
};


export type QueryCustomerBranchArgs = {
  id: Scalars['ID'];
};


export type QueryCustomerSegmentArgs = {
  id: Scalars['ID'];
};


export type QueryCustomersArgs = {
  tenant?: InputMaybe<Scalars['Boolean']>;
};


export type QueryDataImportProgressesArgs = {
  dataImportType?: InputMaybe<DataImportProgressImportEnum>;
};


export type QueryDataImportsArgs = {
  importableType?: InputMaybe<ImportableTypeEnum>;
};


export type QueryDegreeDayReportSummaryArgs = {
  assetId: Scalars['ID'];
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};


export type QueryDegreeDaySettingByAssetArgs = {
  assetId: Scalars['Int'];
};


export type QueryDegreeDaySettingsArgs = {
  filter?: InputMaybe<DegreeDaySettingFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<DegreeDaySettingSorter>>;
};


export type QueryDegreeDayTanksArgs = {
  filter?: InputMaybe<UnifiedTankFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<UnifiedTankSorter>>;
};


export type QueryDegreeDaysArgs = {
  filter?: InputMaybe<DegreeDayFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<DegreeDaySorter>>;
};


export type QueryDegreeDaysCsvArgs = {
  assetId?: InputMaybe<Scalars['ID']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};


export type QueryDeliveryAssetArgs = {
  id: Scalars['ID'];
};


export type QueryDeliveryAssetsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryDeliveryOrderArgs = {
  id: Scalars['ID'];
};


export type QueryDeliveryOrderLineItemCsvArgs = {
  assetId?: InputMaybe<Scalars['ID']>;
  customerBranchId?: InputMaybe<Scalars['ID']>;
  deliveryType?: InputMaybe<DeliveryOrderLineItemDeliveryTypeEnum>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  isTankMonitor?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<Array<StatusTypeEnum>>;
};


export type QueryDeliveryOrdersArgs = {
  filter?: InputMaybe<OrderGroupFiltersInput>;
};


export type QueryDeviceArgs = {
  id: Scalars['ID'];
};


export type QueryDevicesSummaryArgs = {
  filter?: InputMaybe<DeviceFilterInput>;
};


export type QueryDistinctCardLockCustomersArgs = {
  filter?: InputMaybe<CardLockTransactionFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryDriverArgs = {
  id: Scalars['ID'];
};


export type QueryDriverDemurrageArgs = {
  id: Scalars['ID'];
};


export type QueryDriversArgs = {
  filter?: InputMaybe<DriverFiltersInput>;
};


export type QueryExportDocumentArgs = {
  exportDocumentId: Scalars['ID'];
};


export type QueryExportLineOfServicesCsvArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  losId?: InputMaybe<Array<Scalars['ID']>>;
  parentLos?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryExportRackMarketsCsvArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  hubId?: InputMaybe<Array<Scalars['ID']>>;
  rackMarketId?: InputMaybe<Array<Scalars['ID']>>;
  terminalId?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryExportTerminalsCsvArgs = {
  rackMarketId?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<Scalars['Boolean']>;
  supplierId?: InputMaybe<Array<Scalars['ID']>>;
  terminalId?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryExtractionOrderArgs = {
  id: Scalars['ID'];
};


export type QueryFeaturesArgs = {
  fetchAll?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFeeArgs = {
  id: Scalars['ID'];
};


export type QueryFeedbacksArgs = {
  filter?: InputMaybe<FeedbackFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFetchCreditLedgerTransactionsArgs = {
  filter?: InputMaybe<CreditLedgerTransactionFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFetchGraphDataArgs = {
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
};


export type QueryFetchInteractionProgressArgs = {
  subModule: InteractionProgressTypeEnum;
};


export type QueryFetchNestedLinkedOrderGroupIdsArgs = {
  id: Scalars['ID'];
  orderGroupType: OrderTypeEnum;
};


export type QueryFetchOrderGroupArgs = {
  id: Scalars['ID'];
};


export type QueryFetchResourceByIdsArgs = {
  ids: Array<Scalars['ID']>;
  resource: ResourceFetchEnum;
};


export type QueryFetchResourceNamesArgs = {
  ids: Array<Scalars['ID']>;
  resource: ResourceFetchEnum;
};


export type QueryFetchResourceTenantCustomerBranchesArgs = {
  filter?: InputMaybe<CustomerBranchesFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFetchResourceTenantCustomersArgs = {
  filter?: InputMaybe<CustomersFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFetchRouteFlushingArgs = {
  id: Scalars['ID'];
};


export type QueryFetchZoneProductBatchesArgs = {
  filter?: InputMaybe<ZoneProductBatchesFilterInput>;
};


export type QueryFilterRouteSettingsHistoryArgs = {
  filter?: InputMaybe<RouteSettingsPaginationFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFilteredAccountingExportArgs = {
  shiftIds: Array<Scalars['String']>;
};


export type QueryFilteredAddressBooksArgs = {
  filter?: InputMaybe<AddressBookFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<AddressBookSorter>>;
};


export type QueryFilteredAppVersionsArgs = {
  filter?: InputMaybe<AppVersionFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFilteredApplicableFeesArgs = {
  filter?: InputMaybe<ApplicableFeeFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<ApplicableFeeSorter>>;
};


export type QueryFilteredAssetMovementOrderHistoryListArgs = {
  filter?: InputMaybe<AssetMovementOrderHistoryListFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<AssetMovementOrderHistorySorter>>;
};


export type QueryFilteredAssetsArgs = {
  filter?: InputMaybe<AssetFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<AssetSorter>>;
};


export type QueryFilteredBoxTransactionsArgs = {
  filter?: InputMaybe<BoxTransactionFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFilteredCardLockTransactionsArgs = {
  filter?: InputMaybe<CardLockFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFilteredCcTenantsArgs = {
  filter?: InputMaybe<CcTenantFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<CcTenantSorter>>;
};


export type QueryFilteredCustomerBranchesArgs = {
  filter?: InputMaybe<CustomerBranchFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<CustomerBranchSorter>>;
};


export type QueryFilteredCustomerReportsArgs = {
  filter?: InputMaybe<CustomerReportFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<CustomerReportSorter>>;
};


export type QueryFilteredCustomerUsersArgs = {
  filter?: InputMaybe<CustomerUserFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<CustomerUserSorter>>;
};


export type QueryFilteredCustomersArgs = {
  filter?: InputMaybe<CustomerFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<BaseSorter>>;
};


export type QueryFilteredCustomersSorterArgs = {
  filter?: InputMaybe<CustomerFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<CustomerSorter>>;
};


export type QueryFilteredDataFetchLoggerArgs = {
  filter?: InputMaybe<DataFetchLoggerFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<DataFetchLoggerSorter>>;
};


export type QueryFilteredDeliveryAssetsArgs = {
  filter?: InputMaybe<DeliveryAssetFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<BaseSorter>>;
};


export type QueryFilteredDeliveryOrderLineItemsArgs = {
  filter?: InputMaybe<DoliHistoryFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<DeliveryOrderLineItemsSorter>>;
};


export type QueryFilteredDriverDemurrageArgs = {
  filter?: InputMaybe<DriverDemurragesFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<BaseSorter>>;
};


export type QueryFilteredDriverRatesArgs = {
  filter?: InputMaybe<DriverRatesFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<BaseSorter>>;
};


export type QueryFilteredDriversArgs = {
  filter?: InputMaybe<DriverFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<DriverSorter>>;
};


export type QueryFilteredFeesArgs = {
  filter?: InputMaybe<FeeFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<FeeSorter>>;
};


export type QueryFilteredGroupsArgs = {
  filter?: InputMaybe<GroupFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<GroupSorter>>;
};


export type QueryFilteredInvoiceArgs = {
  filter?: InputMaybe<InvoiceFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<BaseSorter>>;
};


export type QueryFilteredLeaReportArgs = {
  filter?: InputMaybe<LeaReportFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFilteredLeaRoiReportArgs = {
  filter?: InputMaybe<LeaLineItemFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFilteredLeasArgs = {
  filter?: InputMaybe<LeaCoreFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<LeaCoreSorter>;
};


export type QueryFilteredLineOfServicesArgs = {
  filter?: InputMaybe<LineOfServiceFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<LineOfServiceSorter>>;
};


export type QueryFilteredLoadOrderLineItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<BaseSorter>>;
};


export type QueryFilteredLoadingAccountsArgs = {
  filter?: InputMaybe<LoadingAccountFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<LoadingAccountSorter>>;
};


export type QueryFilteredMarginsArgs = {
  filter?: InputMaybe<MarginFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFilteredNotesArgs = {
  filter?: InputMaybe<NotesFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFilteredOrderGroupsArgs = {
  filter?: InputMaybe<OrderGroupFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<OrderGroupSorter>>;
};


export type QueryFilteredOrderLinksArgs = {
  filter?: InputMaybe<OrderLinkFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFilteredOrderWellArgs = {
  filter?: InputMaybe<OrderWellFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<OrderWellSorter>>;
};


export type QueryFilteredPandaBoxesArgs = {
  filter?: InputMaybe<PandaBoxFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFilteredPeripheralsArgs = {
  filter?: InputMaybe<PeripheralFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<BaseSorter>>;
};


export type QueryFilteredPickupPointCodesArgs = {
  filter?: InputMaybe<PickupPointCodeFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<PickupPointCodeSorter>>;
};


export type QueryFilteredPricingsArgs = {
  filter?: InputMaybe<PricingFiltersInput>;
};


export type QueryFilteredProductPurchaseLimitArgs = {
  filter?: InputMaybe<ProductPurchaseLimitFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFilteredProductsArgs = {
  filter?: InputMaybe<ProductFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<ProductSorter>>;
};


export type QueryFilteredQrCodesArgs = {
  filter?: InputMaybe<QrCodeFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<QrCodeSorter>>;
};


export type QueryFilteredRawShiftsArgs = {
  filter?: InputMaybe<RawShiftFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<RawShiftSorter>>;
};


export type QueryFilteredRolesArgs = {
  filter?: InputMaybe<RoleFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFilteredSalesReportArgs = {
  endOnTimestamp?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<SalesReportFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  startOnTimestamp?: InputMaybe<Scalars['Int']>;
};


export type QueryFilteredShiftBuilderOrdersArgs = {
  filter?: InputMaybe<ShiftBuilderOrderWellFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<ShiftBuilderOrderSorter>>;
};


export type QueryFilteredShiftPlansArgs = {
  filter?: InputMaybe<ShiftPlanFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<ShiftPlanSorter>>;
};


export type QueryFilteredShiftsArgs = {
  filter?: InputMaybe<ShiftFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<ShiftSorter>>;
};


export type QueryFilteredSidekiqRequestArgs = {
  filter?: InputMaybe<SidekiqRequestFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<SidekiqRequestSorter>>;
};


export type QueryFilteredSuppliersArgs = {
  filter?: InputMaybe<SupplierFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<SupplierSorter>>;
};


export type QueryFilteredSyncedOrdersArgs = {
  filter?: InputMaybe<SyncOrdersFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFilteredTagsArgs = {
  filter?: InputMaybe<TagFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<BaseSorter>>;
};


export type QueryFilteredTankMonitorsArgs = {
  filter?: InputMaybe<DeviceFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<TankMonitorSorter>>;
};


export type QueryFilteredTaxReportArgs = {
  endOnTimestamp?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<TaxReportFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  startOnTimestamp?: InputMaybe<Scalars['Int']>;
};


export type QueryFilteredTaxesArgs = {
  filter?: InputMaybe<TaxFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFilteredTemporaryPricingCustomerBranchesArgs = {
  filter?: InputMaybe<TemporaryPricingCustomerBranchesFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFilteredTemporaryPricingCustomersArgs = {
  filter?: InputMaybe<TemporaryPricingCustomersFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryFilteredTemporaryPricingsArgs = {
  filter: TemporaryPricingsByBranchFilter;
};


export type QueryFilteredTerminalsArgs = {
  filter?: InputMaybe<TerminalFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<TerminalSorter>>;
};


export type QueryFilteredTerminalsSuppliersArgs = {
  filter?: InputMaybe<TerminalsSupplierFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<TerminalsSupplierSorter>>;
};


export type QueryFilteredTmDynamicCountArgs = {
  filters?: InputMaybe<DynamicFiltersInput>;
};


export type QueryFilteredTransferOrdersArgs = {
  filter?: InputMaybe<TransferOrderFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<TransferOrderSorter>>;
};


export type QueryFormProgressesArgs = {
  type: FormProgressTypeEnum;
};


export type QueryGroupArgs = {
  id: Scalars['ID'];
};


export type QueryInitialFeaturesArgs = {
  onlySettings?: InputMaybe<Scalars['Boolean']>;
};


export type QueryInvoiceArgs = {
  id: Scalars['ID'];
};


export type QueryLeaCoreArgs = {
  id: Scalars['ID'];
};


export type QueryLeaDocusealSubmissionArgs = {
  documentType: LeaPreviewDocumentEnum;
  leaCoreId: Scalars['ID'];
};


export type QueryLeaDocusealSubmissionDocumentsArgs = {
  documentType: LeaPreviewDocumentEnum;
  leaCoreId: Scalars['ID'];
};


export type QueryLeaReportsArgs = {
  movementOrderIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryLemBillingReportArgs = {
  export?: InputMaybe<Scalars['Boolean']>;
  filter: LemBillingReportFilterInput;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};


export type QueryLineOfServiceArgs = {
  id: Scalars['ID'];
};


export type QueryLineOfServicesArgs = {
  supplierId?: InputMaybe<Scalars['ID']>;
};


export type QueryLinkedOrdersDriversListsArgs = {
  orderGroupId: Scalars['ID'];
};


export type QueryLoadingAccountArgs = {
  id: Scalars['ID'];
};


export type QueryLoadingOrderArgs = {
  id: Scalars['ID'];
};


export type QueryLoadingOrdersArgs = {
  filter?: InputMaybe<OrderGroupFiltersInput>;
};


export type QueryLoadingReceiptsArgs = {
  filter?: InputMaybe<LoadingReceiptsFilter>;
};


export type QueryMarginArgs = {
  id: Scalars['ID'];
};


export type QueryMarketArgs = {
  id: Scalars['ID'];
};


export type QueryMovementOrderArgs = {
  id: Scalars['ID'];
};


export type QueryNotificationTemplateArgs = {
  notificationType: Scalars['String'];
  orderStatus: Scalars['String'];
};


export type QueryNotificationTemplatesArgs = {
  notificationType?: InputMaybe<Scalars['String']>;
  orderStatus?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryOrderGroupArgs = {
  id: Scalars['ID'];
};


export type QueryOrderGroupsArgs = {
  filter?: InputMaybe<OrderGroupFiltersInput>;
};


export type QueryOrderHistoryArgs = {
  id: Scalars['ID'];
};


export type QueryOrderPricingImportCompletionArgs = {
  id: Scalars['ID'];
  selected: ShiftOrOrderEnum;
};


export type QueryOrderWellArgs = {
  fromTimestamp: Scalars['Int'];
  toTimestamp: Scalars['Int'];
};


export type QueryOrderWellGroupingSummaryArgs = {
  filter?: InputMaybe<OrderWellFilter>;
  groupBy: OrderWellGroupByEnum;
};


export type QueryOrderWellOrdersArgs = {
  ids: Array<Scalars['Int']>;
};


export type QueryOwnAssetsArgs = {
  hubIds?: InputMaybe<Array<Scalars['ID']>>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryPandaBoxArgs = {
  id: Scalars['ID'];
};


export type QueryPandaBoxLogsArgs = {
  orderId: Scalars['String'];
};


export type QueryPaymentTermArgs = {
  id: Scalars['ID'];
};


export type QueryPeripheralArgs = {
  id: Scalars['ID'];
};


export type QueryPreshiftChecklistsArgs = {
  shiftId?: InputMaybe<Scalars['ID']>;
};


export type QueryPricingArgs = {
  id: Scalars['ID'];
};


export type QueryPricingHistoryArgs = {
  resourcePricingId: Scalars['ID'];
};


export type QueryProductArgs = {
  id: Scalars['ID'];
};


export type QueryProductCategoriesArgs = {
  applicableCategory?: InputMaybe<Scalars['Boolean']>;
  onlyBoxMeasured?: InputMaybe<Scalars['Boolean']>;
};


export type QueryProductPurchaseLimitArgs = {
  id: Scalars['ID'];
};


export type QueryRackMarketsArgs = {
  filter?: InputMaybe<RackMarketFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryRateTypeArgs = {
  id: Scalars['ID'];
};


export type QueryRateTypesArgs = {
  filter?: InputMaybe<FiltersInput>;
};


export type QueryRawPricingImportSessionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<BaseSorter>>;
};


export type QueryRawShiftArgs = {
  id: Scalars['ID'];
};


export type QueryRawShiftSummaryArgs = {
  id: Scalars['ID'];
  refresh?: InputMaybe<Scalars['Boolean']>;
  routeCalculationType?: InputMaybe<RouteCalculationEnum>;
};


export type QueryRawShiftsArgs = {
  filter?: InputMaybe<RawShiftFiltersInput>;
};


export type QueryRecurrencesOrdersArgs = {
  dateFrom?: InputMaybe<Scalars['String']>;
  dateUntil?: InputMaybe<Scalars['String']>;
};


export type QueryResourcePricingArgs = {
  filter?: InputMaybe<ResourcePricingFilter>;
  id: Scalars['ID'];
};


export type QueryResourcePricingsArgs = {
  filter?: InputMaybe<ResourcePricingFiltersInput>;
};


export type QueryRoleArgs = {
  roleId: Scalars['ID'];
};


export type QueryRouteSettingsArgs = {
  filter?: InputMaybe<RouteSettingsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<RouteSettingsSorter>>;
};


export type QueryRouteStaticTimesArgs = {
  filter?: InputMaybe<RouteStaticTimeFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<RouteStaticTimeSorter>>;
};


export type QuerySavedViewArgs = {
  id: Scalars['ID'];
};


export type QuerySavedViewsArgs = {
  viewType: SavedViewEnum;
};


export type QuerySearchDeliveryOrdersArgs = {
  filter?: InputMaybe<OrderGroupFiltersInput>;
  search: Scalars['String'];
};


export type QuerySearchExtractionOrdersArgs = {
  filter?: InputMaybe<OrderGroupFiltersInput>;
  search: Scalars['String'];
};


export type QuerySearchLoadingOrdersArgs = {
  filter?: InputMaybe<OrderGroupFiltersInput>;
  search: Scalars['String'];
};


export type QuerySearchTransferOrdersArgs = {
  filter?: InputMaybe<OrderGroupFiltersInput>;
  search: Scalars['String'];
};


export type QuerySettingArgs = {
  id: Scalars['ID'];
};


export type QueryShiftArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryShiftPlanDeliveriesArgs = {
  id: Scalars['ID'];
};


export type QueryShiftPlanDeliveryTimeWindowsArgs = {
  id: Scalars['ID'];
  salesOrder: Scalars['String'];
};


export type QueryShiftPlanInventoryArgs = {
  assetId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['ISO8601DateTime']>;
  shiftPlanId?: InputMaybe<Scalars['ID']>;
  truckId?: InputMaybe<Scalars['String']>;
};


export type QueryShiftPlannerDriverOrdersArgs = {
  driverId: Scalars['ID'];
  fromTimestamp: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  toTimestamp: Scalars['Int'];
};


export type QueryShiftPlannerDriverSummaryArgs = {
  fromTimestamp: Scalars['Int'];
  toTimestamp: Scalars['Int'];
};


export type QueryShiftsArgs = {
  filter?: InputMaybe<ShiftFiltersInput>;
};


export type QuerySupplierArgs = {
  id: Scalars['ID'];
};


export type QuerySupplierDetailArgs = {
  id: Scalars['ID'];
};


export type QuerySupplierDetailV3Args = {
  id: Scalars['ID'];
};


export type QuerySuppliersForCriteriaArgs = {
  customerBranchId?: InputMaybe<Scalars['ID']>;
  productCategoryId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  state?: InputMaybe<Scalars['String']>;
  terminalId?: InputMaybe<Scalars['ID']>;
};


export type QueryTagArgs = {
  id: Scalars['ID'];
};


export type QueryTasksArgs = {
  filter?: InputMaybe<TaskFiltersInput>;
};


export type QueryTaxArgs = {
  id: Scalars['ID'];
};


export type QueryTerminalArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type QueryTerminalDistanceArgs = {
  address?: InputMaybe<Scalars['String']>;
  assetId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Boolean']>;
  lat?: InputMaybe<Scalars['Float']>;
  lon?: InputMaybe<Scalars['Float']>;
  products?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryTmFilteredCustomerBranchesArgs = {
  filter?: InputMaybe<DynamicFiltersInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryTmFilteredCustomersArgs = {
  filter?: InputMaybe<DynamicFiltersInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryTmFilteredOrderGroupsArgs = {
  filter?: InputMaybe<DynamicFiltersInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryTodaysPricingsArgs = {
  filter?: InputMaybe<PricingFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryTransferOrderArgs = {
  id: Scalars['ID'];
};


export type QueryTransferOrdersArgs = {
  filter?: InputMaybe<OrderGroupFiltersInput>;
  sourceAssetIds?: InputMaybe<Array<Scalars['ID']>>;
  type?: InputMaybe<TransferOrderTypeEnum>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};

export type Quote = {
  __typename?: 'Quote';
  applicableFeeDetails?: Maybe<Array<ItemsDetail>>;
  fileUrl?: Maybe<Scalars['String']>;
  productSummary?: Maybe<Array<ProductDetail>>;
};

export type RackMarket = {
  __typename?: 'RackMarket';
  active?: Maybe<Scalars['Boolean']>;
  erpId?: Maybe<Scalars['String']>;
  hubResources?: Maybe<Array<HubResource>>;
  hubs?: Maybe<Array<Hub>>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  terminals?: Maybe<Array<Terminal>>;
};

export type RackMarketCollection = {
  __typename?: 'RackMarketCollection';
  collection: Array<RackMarket>;
  metadata: MetaQuery;
};

export type RackMarketFilter = {
  active?: InputMaybe<Scalars['Boolean']>;
  /** Search by name or address */
  all?: InputMaybe<Scalars['String']>;
  hubsIds?: InputMaybe<Array<Scalars['ID']>>;
  rackMarketIds?: InputMaybe<Array<Scalars['ID']>>;
  terminalIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type RangeAttribute = {
  __typename?: 'RangeAttribute';
  endRange?: Maybe<Scalars['String']>;
  rangeRate?: Maybe<Scalars['String']>;
  startRange?: Maybe<Scalars['String']>;
};

/** RangeAttribute Input */
export type RangeAttributeInput = {
  endRange?: InputMaybe<Scalars['String']>;
  rangeRate?: InputMaybe<Scalars['String']>;
  startRange?: InputMaybe<Scalars['String']>;
};

/** Generic range filter with min and max */
export type RangeFilterInput = {
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
};

export type RangeInput = {
  endPrice: Scalars['Float'];
  rate: Scalars['Float'];
  startPrice: Scalars['Float'];
};

export enum RangeTypeOnFeeEnum {
  /** Distance Based */
  DistanceBased = 'distance_based',
  /** Quantity Based */
  QuantityBased = 'quantity_based',
  /** Time Based */
  TimeBased = 'time_based'
}

export type RateType = {
  __typename?: 'RateType';
  default: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isTemporaryRateType: Scalars['Boolean'];
  name: Scalars['String'];
  operation: Scalars['String'];
  status: Scalars['String'];
};

/** Enum for rate type operations */
export enum RateTypeOperationEnum {
  /** add */
  Add = 'add',
  /** no operation */
  NoOperation = 'no_operation'
}

/** Enum for rate type status */
export enum RateTypeStatusEnum {
  /** active */
  Active = 'active',
  /** inactive */
  Inactive = 'inactive'
}

/** Enum for margin unit */
export enum RateUnitEnum {
  /** currency */
  Currency = 'currency',
  /** percentage */
  Percentage = 'percentage'
}

export enum RateUnitOnFeeEnum {
  /** Currency */
  Currency = 'currency',
  /** Percent */
  Percent = 'percent'
}

export type RawPricingImportSession = {
  __typename?: 'RawPricingImportSession';
  aliasMappings: Array<AliasMapping>;
  createdAt: Scalars['ISO8601DateTime'];
  dataSource?: Maybe<Scalars['String']>;
  errorDocument?: Maybe<PandaDocument>;
  id: Scalars['ID'];
  normalizedDocument?: Maybe<PandaDocument>;
  provider: Scalars['String'];
  sourceDocument: PandaDocument;
  state: ImportSessionStateEnum;
  tenantId: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type RawPricingImportSessionCollection = {
  __typename?: 'RawPricingImportSessionCollection';
  collection: Array<RawPricingImportSession>;
  metadata: MetaQuery;
};

export type RawShift = {
  __typename?: 'RawShift';
  asset?: Maybe<Asset>;
  completedOrderGroups?: Maybe<Scalars['Int']>;
  creatable?: Maybe<User>;
  createdAtTimestamp?: Maybe<Scalars['Int']>;
  dispatchable?: Maybe<User>;
  dispatchedOnTimestamp?: Maybe<Scalars['Int']>;
  endHub?: Maybe<CustomerBranch>;
  endOnTimestamp?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: Maybe<Array<Note>>;
  orderGroups?: Maybe<Array<OrderGroup>>;
  routingTechnique?: Maybe<Scalars['String']>;
  service?: Maybe<Scalars['String']>;
  startHub?: Maybe<CustomerBranch>;
  startOnTimestamp?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  totalOrderGroups?: Maybe<Scalars['Int']>;
  worker?: Maybe<Worker>;
};

export type RawShiftCollection = {
  __typename?: 'RawShiftCollection';
  collection: Array<RawShift>;
  metadata: MetaQuery;
};

/** Create Shift Input */
export type RawShiftCreateInput = {
  /** Asset ID. */
  assetId?: InputMaybe<Scalars['ID']>;
  /** End Hub ID. */
  endHubId?: InputMaybe<Scalars['ID']>;
  /** Shift end time value in Unix. */
  endOnTimestamp?: InputMaybe<Scalars['Int']>;
  /** Shift's ID. */
  id?: InputMaybe<Scalars['ID']>;
  /** Name */
  name?: InputMaybe<Scalars['String']>;
  /** OrderGroups object. */
  orderGroupsAttributes?: InputMaybe<Array<OrderGroupInput>>;
  /** Start Hub ID. */
  startHubId?: InputMaybe<Scalars['ID']>;
  /** Shift start time value in Unix. */
  startOnTimestamp?: InputMaybe<Scalars['Int']>;
  /** One among staged, dispatched, active, and completed. */
  status?: InputMaybe<Scalars['String']>;
  /** Driver's ID. */
  workerId?: InputMaybe<Scalars['ID']>;
};

export type RawShiftFilter = {
  all?: InputMaybe<Scalars['String']>;
  /** ID of Asset */
  assetId?: InputMaybe<Scalars['ID']>;
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  /** Name of Raw Shift */
  name?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<RawShiftFilter>>;
  /** ID of Raw Shift */
  shiftId?: InputMaybe<Scalars['ID']>;
  /** Array has one or more element among: staged, dispatched and active */
  statuses?: InputMaybe<Array<Scalars['String']>>;
  /** one among: today, this_week, next_week, fortnight */
  timeFrame?: InputMaybe<Scalars['String']>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
  workerId?: InputMaybe<Scalars['ID']>;
};

export type RawShiftFiltersInput = {
  /** Raw Shift Name or ID or Wroker Name or Asset Name */
  all?: InputMaybe<Scalars['String']>;
  /** ID of Asset */
  assetId?: InputMaybe<Scalars['ID']>;
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  /** Name of Raw Shift */
  name?: InputMaybe<Scalars['String']>;
  /** ID of Raw Shift */
  shiftId?: InputMaybe<Scalars['ID']>;
  /** Array has one or more element among: active and completed */
  statuses?: InputMaybe<Array<Scalars['String']>>;
  /** one among: today, this_week, next_week, fortnight */
  timeFrame?: InputMaybe<Scalars['String']>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
  workerId?: InputMaybe<Scalars['ID']>;
};

export type RawShiftSorter = {
  field: RawShiftSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum RawShiftSorterEnum {
  Asset = 'ASSET',
  Driver = 'DRIVER',
  Enddate = 'ENDDATE',
  Id = 'ID',
  Name = 'NAME',
  Startdate = 'STARTDATE',
  Status = 'STATUS'
}

export type RawShiftSummary = {
  __typename?: 'RawShiftSummary';
  estimatedAtTimestamp?: Maybe<Scalars['Int']>;
  estimatedDistance?: Maybe<Scalars['Int']>;
  estimatedDuration?: Maybe<Scalars['Int']>;
  estimatedDurationInTraffic?: Maybe<Scalars['Int']>;
  estimatedFuelingDuration?: Maybe<Scalars['Int']>;
  rawShiftStops?: Maybe<Scalars['JSON']>;
  routingTechnique?: Maybe<Scalars['String']>;
};

/** Reading Mode Input */
export enum ReadingModeEnum {
  /** Reading Mode continuous */
  Continuous = 'CONTINUOUS',
  /** Reading Mode non_continuous */
  NonContinuous = 'NON_CONTINUOUS'
}

/** Reason types for change of requested tank type in lea line item. */
export enum ReasonTypesEnum {
  OperationalConstraints = 'operational_constraints',
  Other = 'other',
  RequestedCapacityUnavailable = 'requested_capacity_unavailable',
  RequestedTankUnavailable = 'requested_tank_unavailable'
}

/** Autogenerated input type of Reauthenticate */
export type ReauthenticateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  refreshToken: Scalars['String'];
};

/** Autogenerated return type of Reauthenticate */
export type ReauthenticatePayload = {
  __typename?: 'ReauthenticatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of RecalculateInventoryRecords */
export type RecalculateInventoryRecordsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of RecalculateInventoryRecords */
export type RecalculateInventoryRecordsPayload = {
  __typename?: 'RecalculateInventoryRecordsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of RecalculatePricing */
export type RecalculatePricingInput = {
  appliedPricingIds: Array<Scalars['Int']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  resetAll?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of RecalculatePricing */
export type RecalculatePricingPayload = {
  __typename?: 'RecalculatePricingPayload';
  appliedPricings?: Maybe<Array<AppliedPricing>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

export type Recommendation = {
  __typename?: 'Recommendation';
  customerBranches: Array<Subject>;
  customers: Array<Subject>;
  hubs: Array<Subject>;
  lineOfServices: Array<Subject>;
  products: Array<Subject>;
  providers: Array<Subject>;
};

/** Enum for order groups recurrence types */
export enum Recurrence {
  /** Daily recurrence */
  Daily = 'daily',
  /** Monthly recurrence */
  Monthly = 'monthly',
  /** Weekly recurrence */
  Weekly = 'weekly',
  /** Yearly recurrence */
  Yearly = 'yearly'
}

/** Recurrence Assets Input for order groups */
export type RecurrenceAssetsInput = {
  assetId?: InputMaybe<Scalars['ID']>;
  productId: Scalars['ID'];
  requestedVolume?: InputMaybe<Scalars['Float']>;
  warehouseId?: InputMaybe<Scalars['ID']>;
};

export type RecurrenceData = {
  __typename?: 'RecurrenceData';
  lastDelivery?: Maybe<Scalars['String']>;
  lastOrderGroup?: Maybe<OrderGroup>;
  nextDate?: Maybe<Scalars['String']>;
  nextOrderGroup?: Maybe<OrderGroup>;
  recurrence: RecurrenceOrderGroup;
};

export type RecurrenceDayNthWeek = {
  __typename?: 'RecurrenceDayNthWeek';
  friday?: Maybe<Array<Scalars['Int']>>;
  monday?: Maybe<Array<Scalars['Int']>>;
  saturday?: Maybe<Array<Scalars['Int']>>;
  sunday?: Maybe<Array<Scalars['Int']>>;
  thursday?: Maybe<Array<Scalars['Int']>>;
  tuesday?: Maybe<Array<Scalars['Int']>>;
  wednesday?: Maybe<Array<Scalars['Int']>>;
};

/** Recurrence monthly when day happens in Nth week of the month */
export type RecurrenceDayNthWeekInput = {
  friday?: InputMaybe<Array<Scalars['Int']>>;
  monday?: InputMaybe<Array<Scalars['Int']>>;
  saturday?: InputMaybe<Array<Scalars['Int']>>;
  sunday?: InputMaybe<Array<Scalars['Int']>>;
  thursday?: InputMaybe<Array<Scalars['Int']>>;
  tuesday?: InputMaybe<Array<Scalars['Int']>>;
  wednesday?: InputMaybe<Array<Scalars['Int']>>;
};

/** Recurrence Input for order groups */
export type RecurrenceInput = {
  recurrenceAllAssets?: InputMaybe<Scalars['Boolean']>;
  recurrenceAutoExpired?: InputMaybe<Scalars['Boolean']>;
  recurrenceDates?: InputMaybe<Array<Scalars['String']>>;
  recurrenceDayNthWeek?: InputMaybe<RecurrenceDayNthWeekInput>;
  recurrenceDays?: InputMaybe<Array<Scalars['Int']>>;
  recurrenceDaysInAdvance?: InputMaybe<Scalars['Int']>;
  recurrenceDaysOfWeek?: InputMaybe<Array<DaysOfWeek>>;
  recurrenceFromTimestamp?: InputMaybe<Scalars['Int']>;
  recurrenceInterval?: InputMaybe<Scalars['Int']>;
  recurrenceOccurrences?: InputMaybe<Scalars['Int']>;
  recurrenceType: Recurrence;
  recurrenceUntil?: InputMaybe<Scalars['String']>;
};

export type RecurrenceOrder = {
  __typename?: 'RecurrenceOrder';
  customer?: Maybe<Customer>;
  customerBranch?: Maybe<CustomerBranch>;
  lastDelivery?: Maybe<Scalars['String']>;
  lastOrderGroup?: Maybe<OrderGroup>;
  nextDate?: Maybe<Scalars['String']>;
  nextOrderGroup?: Maybe<OrderGroup>;
  orderGroup: OrderGroup;
  recurrence: RecurrenceOrderGroup;
};

export type RecurrenceOrderGroup = {
  __typename?: 'RecurrenceOrderGroup';
  recurrenceAutoExpired?: Maybe<Scalars['Boolean']>;
  recurrenceDates?: Maybe<Array<Scalars['String']>>;
  recurrenceDayNthWeek?: Maybe<RecurrenceDayNthWeek>;
  recurrenceDays?: Maybe<Array<Scalars['Int']>>;
  recurrenceDaysInAdvance?: Maybe<Scalars['Int']>;
  recurrenceDaysOfWeek?: Maybe<Array<DaysOfWeek>>;
  recurrenceFromTimestamp?: Maybe<Scalars['String']>;
  recurrenceInterval?: Maybe<Scalars['Int']>;
  recurrenceOccurrences?: Maybe<Scalars['Int']>;
  recurrenceType: Recurrence;
  recurrenceUntil?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of RefetchCustomersAsynchronously */
export type RefetchCustomersAsynchronouslyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of RefetchCustomersAsynchronously */
export type RefetchCustomersAsynchronouslyPayload = {
  __typename?: 'RefetchCustomersAsynchronouslyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of RefetchOrderQueueStatus */
export type RefetchOrderQueueStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryOrderId: Scalars['ID'];
};

/** Autogenerated return type of RefetchOrderQueueStatus */
export type RefetchOrderQueueStatusPayload = {
  __typename?: 'RefetchOrderQueueStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deliveryOrder?: Maybe<DeliveryOrder>;
};

/** Autogenerated input type of RefreshApiToken */
export type RefreshApiTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of RefreshApiToken */
export type RefreshApiTokenPayload = {
  __typename?: 'RefreshApiTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  setting?: Maybe<Setting>;
};

/** Autogenerated input type of RemoveCode */
export type RemoveCodeInput = {
  assetId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
};

/** Autogenerated return type of RemoveCode */
export type RemoveCodePayload = {
  __typename?: 'RemoveCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of RemoveFeeToOrderGroup */
export type RemoveFeeToOrderGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderGroupsFeeId: Scalars['ID'];
};

/** Autogenerated return type of RemoveFeeToOrderGroup */
export type RemoveFeeToOrderGroupPayload = {
  __typename?: 'RemoveFeeToOrderGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
};

/** Autogenerated input type of RemoveFeesFromOrderGroup */
export type RemoveFeesFromOrderGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderGroupId: Scalars['ID'];
  orderGroupsFeeIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of RemoveFeesFromOrderGroup */
export type RemoveFeesFromOrderGroupPayload = {
  __typename?: 'RemoveFeesFromOrderGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
};

/** Autogenerated input type of RemoveFormProgress */
export type RemoveFormProgressInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderType: MovementOrderTypeEnum;
};

/** Autogenerated return type of RemoveFormProgress */
export type RemoveFormProgressPayload = {
  __typename?: 'RemoveFormProgressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of RemoveQrCode */
export type RemoveQrCodeInput = {
  assetId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of RemoveQrCode */
export type RemoveQrCodePayload = {
  __typename?: 'RemoveQrCodePayload';
  asset?: Maybe<Asset>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Enum for metabase report types */
export enum ReportEnum {
  /** Dashboard */
  Dashboard = 'dashboard',
  /** Question */
  Question = 'question'
}

/** Autogenerated input type of RequestContactOtp */
export type RequestContactOtpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  newEmail?: InputMaybe<Scalars['String']>;
  newPhone?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};

/** Autogenerated return type of RequestContactOtp */
export type RequestContactOtpPayload = {
  __typename?: 'RequestContactOtpPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type RequestedMovementOrderLineItem = {
  __typename?: 'RequestedMovementOrderLineItem';
  id: Scalars['ID'];
  peripheral?: Maybe<Peripheral>;
  peripheralApprovedStatus?: Maybe<Scalars['Boolean']>;
  peripheralInstances?: Maybe<Array<PeripheralInstance>>;
  requestedPeripheralInstances?: Maybe<Array<RequestedPeripheralInstance>>;
};

/** Requested Movement Order Line Item Input */
export type RequestedMovementOrderLineItemInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** ID of Movement Order Line Item. Required on update. */
  id?: InputMaybe<Scalars['ID']>;
  /** Movement Order ID. */
  movementOrderId?: InputMaybe<Scalars['ID']>;
  /** Peripheral Approved Status */
  peripheralApprovedStatus?: InputMaybe<Scalars['Boolean']>;
  /** Peripheral Input object */
  peripheralAttributes?: InputMaybe<PeripheralInput>;
  /** Peripheral ID. */
  peripheralId?: InputMaybe<Scalars['ID']>;
  /** Requested Peripheral Instance Input object. */
  requestedPeripheralInstancesAttributes?: InputMaybe<Array<RequestedPeripheralInstanceInput>>;
};

export type RequestedPeripheralInstance = {
  __typename?: 'RequestedPeripheralInstance';
  id?: Maybe<Scalars['ID']>;
  peripheralAttribute?: Maybe<PeripheralAttribute>;
  value?: Maybe<Scalars['String']>;
};

/** Requested Peripheral Instance Input */
export type RequestedPeripheralInstanceInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** ID of PeripheralInstance. Required on update. */
  id?: InputMaybe<Scalars['ID']>;
  /** Peripheral Attribute ID. */
  peripheralAttributeId?: InputMaybe<Scalars['ID']>;
  /** Movement Order Line Item ID. */
  requestedMovementOrderLineItemId?: InputMaybe<Scalars['ID']>;
  /** Peripheral Attribute Value. */
  value?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of ResendDocusealEmail */
export type ResendDocusealEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  emailRecipients?: InputMaybe<Array<Scalars['String']>>;
  submitterId: Scalars['ID'];
};

/** Autogenerated return type of ResendDocusealEmail */
export type ResendDocusealEmailPayload = {
  __typename?: 'ResendDocusealEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of ResetPassword */
export type ResetPasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};

/** Autogenerated return type of ResetPassword */
export type ResetPasswordPayload = {
  __typename?: 'ResetPasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  message?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of ResetPricing */
export type ResetPricingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: ManualUpdateInput;
};

/** Autogenerated return type of ResetPricing */
export type ResetPricingPayload = {
  __typename?: 'ResetPricingPayload';
  appliedPricing?: Maybe<AppliedPricing>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ResourceComponent = {
  __typename?: 'ResourceComponent';
  error?: Maybe<Scalars['String']>;
  resourceTenant?: Maybe<ResourceTenant>;
  success: Scalars['Boolean'];
};

/** Resource Components Input */
export type ResourceComponentsInput = {
  customerBranchId: Scalars['ID'];
  customerId: Scalars['ID'];
  linkedTenantId: Scalars['ID'];
  resourceId: Scalars['ID'];
  resourceType: ResourceComponentsTypeEnum;
};

export enum ResourceComponentsTypeEnum {
  /** Asset Component */
  Asset = 'Asset'
}

export type ResourceDetails = {
  __typename?: 'ResourceDetails';
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
};

export enum ResourceDetailsEnum {
  /** ResourceDetailsEnum 'Customer' for applied pricing enum */
  Customer = 'Customer',
  /** ResourceDetailsEnum 'CustomerBranch' for applied pricing enum */
  CustomerBranch = 'CustomerBranch'
}

/** Applied Tax Input */
export type ResourceDetailsInput = {
  id?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<ResourceDetailsEnum>;
};

/** Enum for resource to be fetch */
export enum ResourceFetchEnum {
  Asset = 'Asset',
  Customer = 'Customer',
  CustomerBranch = 'CustomerBranch',
  Hub = 'Hub',
  Market = 'Market',
  Product = 'Product',
  ProductCategory = 'ProductCategory',
  Supplier = 'Supplier',
  Terminal = 'Terminal'
}

/** Members of resource groups */
export type ResourceFetchableById = Asset | DeliveryAsset;

/** Enum for resource name of provider */
export enum ResourceNameEnum {
  Assets = 'Assets',
  Customers = 'Customers',
  Divisions = 'Divisions',
  Drivers = 'Drivers',
  Fees = 'Fees',
  Hubs = 'Hubs',
  IrelyProductCategories = 'IrelyProductCategories',
  IrelyUoms = 'IrelyUoms',
  Items = 'Items',
  Products = 'Products',
  SelfCustomerAssets = 'SelfCustomerAssets',
  Suppliers = 'Suppliers',
  Vendors = 'Vendors'
}

export type ResourcePricing = {
  __typename?: 'ResourcePricing';
  applicableMargins: Array<ApplicableMargin>;
  applicableTaxes: Array<ApplicableTax>;
  discount?: Maybe<Scalars['Float']>;
  discountUnit?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  marginsProducts?: Maybe<Array<MarginsProduct>>;
  pocEmail?: Maybe<Scalars['String']>;
  pocName?: Maybe<Scalars['String']>;
  pocPhone?: Maybe<Scalars['String']>;
  priceConfigurations: Array<PriceConfiguration>;
  productCategories?: Maybe<Array<ProductCategory>>;
  /** Deprecated: Use productCategoryResources */
  productCategoryId?: Maybe<Scalars['ID']>;
  productCategoryResources?: Maybe<Array<ProductCategoryResource>>;
  rateType: RateType;
  resourceId: Scalars['ID'];
  resourceType: Scalars['String'];
};

/** Enum for resource pricing */
export enum ResourcePricingEnum {
  /** Customer */
  Customer = 'Customer',
  /** Customer Branch */
  CustomerBranch = 'CustomerBranch'
}

export type ResourcePricingFilter = {
  endDateTimestamp: Scalars['Int'];
  startDateTimestamp: Scalars['Int'];
};

export type ResourcePricingFiltersInput = {
  customerId?: InputMaybe<Scalars['ID']>;
  resourceType?: InputMaybe<ResourcePricingEnum>;
};

export type ResourceSchedule = {
  __typename?: 'ResourceSchedule';
  availability?: Maybe<Array<Availability>>;
  id?: Maybe<Scalars['ID']>;
  preferrableId?: Maybe<Scalars['ID']>;
  preferrableType?: Maybe<PreferrableTypeEnum>;
  unavailability?: Maybe<Array<Unavailability>>;
};

/** Resource Schedule Input */
export type ResourceScheduleInput = {
  /** Availability of ResourceSchedule */
  availability?: InputMaybe<Array<AvailabilityInput>>;
  /** ID of ResourceSchedule */
  id?: InputMaybe<Scalars['ID']>;
  /** Preferrable ID of ResourceSchedule */
  preferrableId: Scalars['ID'];
  /** Preferrable Type of ResourceSchedule */
  preferrableType: PreferrableTypeEnum;
  /** Unavailability of ResourceSchedule */
  unavailability?: InputMaybe<Array<UnavailabilityInput>>;
};

export type ResourceStatus = {
  __typename?: 'ResourceStatus';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdAtTimestamp?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  postValue?: Maybe<Scalars['String']>;
  preValue?: Maybe<Scalars['String']>;
  resourceStatusType?: Maybe<ResourceStatusTypes>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  updatedAtTimestamp?: Maybe<Scalars['Int']>;
};

/** Resource Status Input */
export type ResourceStatusInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  postValue?: InputMaybe<Scalars['String']>;
  preValue?: InputMaybe<Scalars['String']>;
  resourceStatusTypeId: Scalars['ID'];
};

export type ResourceStatusTypes = {
  __typename?: 'ResourceStatusTypes';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Scalars['String']>>;
  resourceAttributeType: Scalars['String'];
};

export type ResourceTenant = {
  __typename?: 'ResourceTenant';
  id: Scalars['ID'];
  linkedTenant?: Maybe<Tenant>;
  previousResource?: Maybe<TenantResourceable>;
  previousTenant?: Maybe<Tenant>;
  resource?: Maybe<TenantResourceable>;
  resourceLicensePlateNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type ResourceTenantCustomer = {
  __typename?: 'ResourceTenantCustomer';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type ResourceTenantCustomerBranch = {
  __typename?: 'ResourceTenantCustomerBranch';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  site?: Maybe<Site>;
};

export type ResourceTenantCustomerBranchCollection = {
  __typename?: 'ResourceTenantCustomerBranchCollection';
  collection: Array<ResourceTenantCustomerBranch>;
  metadata: MetaQuery;
};

export type ResourceTenantCustomerCollection = {
  __typename?: 'ResourceTenantCustomerCollection';
  collection: Array<ResourceTenantCustomer>;
  metadata: MetaQuery;
};

export enum ResourceTypeEnum {
  CompanyAsset = 'CompanyAsset',
  Terminal = 'Terminal'
}

/** Members of generic resource */
export type ResourceUpdatable = BolRetain | CcTenant | DriverRate | Setting | Site;

/** Enum for resource */
export enum ResourceUpdateEnum {
  BolRetain = 'BolRetain',
  CcTenant = 'CcTenant',
  DriverRate = 'DriverRate',
  Setting = 'Setting',
  Site = 'Site'
}

/** Default Resource Input for update */
export type ResourceUpdateInput = {
  /** Attribute/field name of resource. */
  fieldName: Scalars['String'];
  /** New value of Attribute/field of resource */
  fieldValue?: InputMaybe<Scalars['String']>;
  /** New values of Attribute/field of resource */
  fieldValues?: InputMaybe<Array<Scalars['String']>>;
  /** ID of resource */
  id: Scalars['ID'];
};

export type Result = {
  __typename?: 'Result';
  errors?: Maybe<Array<Scalars['String']>>;
  failureIds?: Maybe<Array<Scalars['ID']>>;
  successIds?: Maybe<Array<Scalars['ID']>>;
};

export type RoiEquipments = {
  __typename?: 'RoiEquipments';
  costPrice?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  sellingPrice?: Maybe<Scalars['Float']>;
  totalCost?: Maybe<Scalars['Float']>;
  unitCost?: Maybe<Scalars['Float']>;
};

export type Role = {
  __typename?: 'Role';
  adminRole?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  enabledFeatures?: Maybe<Array<EnabledFeature>>;
  features?: Maybe<Array<Feature>>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  resourceType?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['ID']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type RoleCollection = {
  __typename?: 'RoleCollection';
  collection: Array<Role>;
  metadata: MetaQuery;
};

export type RoleFilter = {
  or?: InputMaybe<Array<RoleFilter>>;
};

/** Inputs to create/update or destroy a role */
export type RoleInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  adminRole?: InputMaybe<Scalars['Boolean']>;
  enabledFeaturesAttributes?: InputMaybe<Array<EnabledFeatureInput>>;
  featureIds?: InputMaybe<Array<Scalars['ID']>>;
  id?: InputMaybe<Scalars['ID']>;
  label?: InputMaybe<Scalars['String']>;
};

export enum RouteCalculationEnum {
  /** Optimized routing calculation */
  Optimize = 'optimize',
  /** Priority based routing calculation */
  Priority = 'priority'
}

/** Default route config Input */
export type RouteConfigInput = {
  downgrading?: InputMaybe<Array<FeatureInput>>;
  flushings: Array<FlushingInput>;
  inventory?: InputMaybe<Array<FeatureInput>>;
  others?: InputMaybe<Array<FeatureInput>>;
  routeStaticTimes?: InputMaybe<Array<RouteStaticTimeInput>>;
};

/** Enum for route flushing conditions */
export enum RouteFlushingConditionEnum {
  /** Product */
  Product = 'product',
  /** Product Category */
  ProductCategory = 'product_category',
  /** Product SubCategory */
  ProductSubcategory = 'product_subcategory'
}

export type RouteSettingsFilter = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<RouteSettingsFilter>>;
};

export type RouteSettingsPaginationFilter = {
  or?: InputMaybe<Array<RouteSettingsPaginationFilter>>;
};

export type RouteSettingsSorter = {
  field: RouteSettingsSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum RouteSettingsSorterEnum {
  Name = 'NAME'
}

export type RouteStaticTime = {
  __typename?: 'RouteStaticTime';
  id: Scalars['ID'];
  name: Scalars['String'];
  time: Scalars['Int'];
  timeType: Scalars['String'];
};

export type RouteStaticTimeCollection = {
  __typename?: 'RouteStaticTimeCollection';
  collection: Array<RouteStaticTime>;
  metadata: MetaQuery;
};

export type RouteStaticTimeFilter = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<RouteStaticTimeFilter>>;
  timeType?: InputMaybe<Array<RouteTimeTypeEnum>>;
};

/** Default route static time Input */
export type RouteStaticTimeInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  time: Scalars['Int'];
  timeType: Scalars['String'];
};

export type RouteStaticTimeSorter = {
  field: RouteStaticTimeSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum RouteStaticTimeSorterEnum {
  Name = 'NAME',
  Type = 'TYPE'
}

/** Enum for route time type */
export enum RouteTimeTypeEnum {
  /** Delivery */
  Delivery = 'delivery',
  /** End day */
  EndDay = 'end_day',
  /** Loading */
  Loading = 'loading',
  /** Start Day */
  StartDay = 'start_day'
}

export type S3Object = {
  __typename?: 'S3Object';
  body?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  lastModifiedAt?: Maybe<Scalars['Int']>;
  presignedUrl?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
};

/** Autogenerated input type of SalesOrderSync */
export type SalesOrderSyncInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryOrderId: Scalars['ID'];
};

/** Autogenerated return type of SalesOrderSync */
export type SalesOrderSyncPayload = {
  __typename?: 'SalesOrderSyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['JSON']>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Sales Rep in LEA Questionnaire */
export type SalesRep = {
  __typename?: 'SalesRep';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

/** Sales Rep Input in LEA Questionnaire */
export type SalesRepInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type SalesReportFilterInput = {
  customerBranchId?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of SaveTenantContent */
export type SaveTenantContentInput = {
  attributes?: InputMaybe<TenantContentInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of SaveTenantContent */
export type SaveTenantContentPayload = {
  __typename?: 'SaveTenantContentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  tenantContent?: Maybe<TenantContent>;
};

/** A saved view for a user */
export type SavedView = {
  __typename?: 'SavedView';
  config?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  isDefault?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pinned: Scalars['Boolean'];
  position?: Maybe<Scalars['Int']>;
  preset: Scalars['Boolean'];
  user: User;
  viewType: SavedViewEnum;
};

export enum SavedViewEnum {
  /** Degree day tanks */
  DegreeDayTanks = 'DEGREE_DAY_TANKS',
  /** Order well */
  OrderWell = 'ORDER_WELL',
  /** Suppliers */
  Suppliers = 'SUPPLIERS',
  /** Tank monitor delivery */
  TankMonitorDelivery = 'TANK_MONITOR_DELIVERY',
  /** Tank monitor extraction */
  TankMonitorExtraction = 'TANK_MONITOR_EXTRACTION'
}

/** Attributes for creating or updating a saved view */
export type SavedViewInput = {
  config?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['ID']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<Scalars['Int']>;
  preset?: InputMaybe<Scalars['Boolean']>;
  viewType?: InputMaybe<SavedViewEnum>;
};

/** Autogenerated input type of SendBulkOrderEmailToDriver */
export type SendBulkOrderEmailToDriverInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: BulkOrderEmailToDriverInput;
};

/** Autogenerated return type of SendBulkOrderEmailToDriver */
export type SendBulkOrderEmailToDriverPayload = {
  __typename?: 'SendBulkOrderEmailToDriverPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of SendCommonCarrierEmail */
export type SendCommonCarrierEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderGroupId: Scalars['ID'];
};

/** Autogenerated return type of SendCommonCarrierEmail */
export type SendCommonCarrierEmailPayload = {
  __typename?: 'SendCommonCarrierEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
};

/** Autogenerated input type of SendLeaMail */
export type SendLeaMailInput = {
  bcc?: InputMaybe<Array<Scalars['String']>>;
  body?: InputMaybe<Scalars['String']>;
  cc?: InputMaybe<Array<Scalars['String']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<LeaPreviewDocumentEnum>;
  id: Scalars['ID'];
  sendToDocuseal?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
  to: Array<Scalars['String']>;
};

/** Autogenerated return type of SendLeaMail */
export type SendLeaMailPayload = {
  __typename?: 'SendLeaMailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  submitterData?: Maybe<Array<DocusealSubmitter>>;
  success: Scalars['Boolean'];
  toEmail: Array<Scalars['String']>;
};

/** Autogenerated input type of SendMailToPoc */
export type SendMailToPocInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of SendMailToPoc */
export type SendMailToPocPayload = {
  __typename?: 'SendMailToPocPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of SendManualNotification */
export type SendManualNotificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of SendManualNotification */
export type SendManualNotificationPayload = {
  __typename?: 'SendManualNotificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of SendOrderCreateEmailToDriver */
export type SendOrderCreateEmailToDriverInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: BulkOrderEmailToDriverInput;
};

/** Autogenerated return type of SendOrderCreateEmailToDriver */
export type SendOrderCreateEmailToDriverPayload = {
  __typename?: 'SendOrderCreateEmailToDriverPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
};

/** Autogenerated input type of SendPasswordResetInstruction */
export type SendPasswordResetInstructionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of SendPasswordResetInstruction */
export type SendPasswordResetInstructionPayload = {
  __typename?: 'SendPasswordResetInstructionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  message?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of SendTestNotificationTemplate */
export type SendTestNotificationTemplateInput = {
  body?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  recipients: Array<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

/** Autogenerated return type of SendTestNotificationTemplate */
export type SendTestNotificationTemplatePayload = {
  __typename?: 'SendTestNotificationTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Setting = {
  __typename?: 'Setting';
  id: Scalars['ID'];
  name: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type SettingCollection = {
  __typename?: 'SettingCollection';
  collection: Array<Setting>;
  metadata: MetaQuery;
};

/** Default settings Input */
export type SettingsInput = {
  autoLogoutAfter?: InputMaybe<Scalars['String']>;
  broadcastExpiresAfter?: InputMaybe<Scalars['String']>;
  companyAddress?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  dispatchNumber?: InputMaybe<Scalars['String']>;
  features?: InputMaybe<Array<FeatureInput>>;
  incentiveEffectiveFrom?: InputMaybe<Scalars['String']>;
  multipleBases?: InputMaybe<Scalars['String']>;
  odometerReadingThreshold?: InputMaybe<Scalars['String']>;
  overrideRecipientPhoneNumber?: InputMaybe<Scalars['String']>;
  publishApiKey?: InputMaybe<Scalars['String']>;
  shiftEndAfter?: InputMaybe<Scalars['String']>;
  shiftStartMethod?: InputMaybe<ShiftStartMethodEnum>;
  shiftStartTimeBarrier?: InputMaybe<Scalars['String']>;
  shiftTasksAllowedTimeDifference?: InputMaybe<Scalars['String']>;
  shift_status_id_4?: InputMaybe<Scalars['String']>;
  shift_status_id_5?: InputMaybe<Scalars['String']>;
  shift_status_id_6?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  twimlApplicationSid?: InputMaybe<Scalars['String']>;
  warningMessage?: InputMaybe<Scalars['String']>;
};

export type Shift = {
  __typename?: 'Shift';
  activity?: Maybe<Scalars['JSON']>;
  actualDuration?: Maybe<Scalars['Int']>;
  adjustedInventories?: Maybe<Array<InventoryAdjustment>>;
  bolErrors?: Maybe<Array<BolError>>;
  bolRetains?: Maybe<Array<BolRetain>>;
  checklistCompleted?: Maybe<Scalars['Boolean']>;
  /** @deprecated Do not use this. This uses too much resuorces */
  currentTask?: Maybe<Task>;
  deliveryTruck?: Maybe<DeliveryAsset>;
  distributionTransferOrders?: Maybe<Array<TransferOrder>>;
  divergenceOrderShift: Scalars['Boolean'];
  documents?: Maybe<Array<PandaDocument>>;
  driverNote?: Maybe<Note>;
  duration?: Maybe<Scalars['Int']>;
  enableClearingAccountingData?: Maybe<Scalars['Boolean']>;
  endLocation?: Maybe<Scalars['String']>;
  endOnTimestamp?: Maybe<Scalars['Int']>;
  errors?: Maybe<Scalars['JSON']>;
  hasData?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  /** @deprecated Obselete!!! */
  inspectionFormSubmissions?: Maybe<Array<DvirBeCompatibilitySupport>>;
  notes?: Maybe<Array<Note>>;
  offlineOperation?: Maybe<Scalars['Boolean']>;
  orderGroups?: Maybe<Array<OrderGroup>>;
  orphanTransferOrders?: Maybe<Array<TransferOrder>>;
  preshiftChecklistDocuments?: Maybe<Array<PandaDocument>>;
  receiptTransferOrders?: Maybe<Array<TransferOrder>>;
  shiftAssetProducts?: Maybe<Array<ShiftAssetProduct>>;
  shiftChecklistItems?: Maybe<Array<ShiftChecklistItem>>;
  shiftCompartmentInstances?: Maybe<Array<ShiftCompartmentInstance>>;
  shiftDeliveryUnitsAssets?: Maybe<Array<ShiftDeliveryUnitsAsset>>;
  skipNote?: Maybe<Note>;
  startLocation?: Maybe<Scalars['String']>;
  startOnTimestamp?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  /** @deprecated Dont use this. This uses too much resuorces */
  tasks?: Maybe<Array<Task>>;
  totalizerNotes?: Maybe<Scalars['JSON']>;
  worker?: Maybe<Worker>;
};

export type ShiftAssetProduct = {
  __typename?: 'ShiftAssetProduct';
  deliveryAsset: DeliveryAsset;
  dispatchInitialQty?: Maybe<Scalars['Int']>;
  driverInitialQty?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  previousShiftQty?: Maybe<Scalars['Int']>;
  product: Product;
  reconciliationQty?: Maybe<Scalars['Int']>;
  retainQty: Scalars['Int'];
  shiftStartQty?: Maybe<Scalars['Int']>;
};

export type ShiftBuilderOrderSorter = {
  field: ShiftBuilderOrderSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum ShiftBuilderOrderSorterEnum {
  Customer = 'CUSTOMER',
  Hub = 'HUB',
  Id = 'ID',
  Plannedat = 'PLANNEDAT',
  Product = 'PRODUCT',
  Shipto = 'SHIPTO'
}

export type ShiftBuilderOrderWellFilter = {
  all?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  coordinatesFilter?: InputMaybe<CoordinatesFilter>;
  customerBranchId?: InputMaybe<Scalars['ID']>;
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  hubId?: InputMaybe<Scalars['ID']>;
  /** DD/MM/YYYY */
  plannedDate?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<OrderGroupPriorityEnum>;
  sources?: InputMaybe<Array<OrderGroupSourceEnum>>;
  statuses?: InputMaybe<Array<OrderGroupStatusEnum>>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
  types?: InputMaybe<Array<OrderGroupTypeEnum>>;
  zip?: InputMaybe<Scalars['String']>;
};

export type ShiftChecklist = {
  __typename?: 'ShiftChecklist';
  checkedCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  items?: Maybe<Array<ChecklistItems>>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  totalItemsCount?: Maybe<Scalars['Int']>;
};

export type ShiftChecklistItem = {
  __typename?: 'ShiftChecklistItem';
  checked?: Maybe<Scalars['Boolean']>;
  checklistItem?: Maybe<ChecklistItem>;
  id: Scalars['ID'];
  shift?: Maybe<Shift>;
};

export type ShiftChecklistItemInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  checked?: InputMaybe<Scalars['Boolean']>;
  checklistItemId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type ShiftCollection = {
  __typename?: 'ShiftCollection';
  collection: Array<Shift>;
  metadata: MetaQuery;
};

export type ShiftCompartmentInstance = {
  __typename?: 'ShiftCompartmentInstance';
  compartment: Compartment;
  dispatchInitialInventory?: Maybe<Inventory>;
  driverInitialInventory?: Maybe<Inventory>;
  id: Scalars['ID'];
  /** @deprecated Please use pervious_shift_retain_inventory */
  initialInventory?: Maybe<Inventory>;
  inventoryAdjustments: Array<InventoryAdjustment>;
  latestInventory: Inventory;
  previousShiftRetainInventory?: Maybe<Inventory>;
  previousShiftRetainsInventories?: Maybe<Array<Inventory>>;
  retainInventory?: Maybe<Array<Inventory>>;
  shiftDeliveryUnitsAsset: ShiftDeliveryUnitsAsset;
  shiftStartInventory?: Maybe<Inventory>;
};

/** ShiftCompartmentInstance Input */
export type ShiftCompartmentInstanceInput = {
  /** Compartment's ID. */
  compartmentId?: InputMaybe<Scalars['ID']>;
  /** Product's ID */
  driverInitialProductId?: InputMaybe<Scalars['ID']>;
  /** Initial Volume confimed by Driver */
  driverInitialVolume?: InputMaybe<Scalars['Float']>;
  /** ID of the ShiftCompartmentInstance. Required during update. */
  id?: InputMaybe<Scalars['ID']>;
  /** InventoryAdjustment Object. */
  inventoryAdjustmentsAttributes?: InputMaybe<Array<InventoryAdjustmentInput>>;
  /** ShiftDeliveryUnitsAsset's ID. */
  shiftDeliveryUnitsAssetId?: InputMaybe<Scalars['ID']>;
};

/** Create Shift Input */
export type ShiftCreateInput = {
  /** Deprecated. DO NOT USE. */
  attachmentsAttributes?: InputMaybe<Array<AttachmentInput>>;
  /** Shift end time value in Unix. */
  endOnTimestamp?: InputMaybe<Scalars['Int']>;
  /** Shift's ID. */
  id?: InputMaybe<Scalars['ID']>;
  /** Notes object. */
  notesAttributes?: InputMaybe<Array<NoteInput>>;
  /** Set true incase of offline operation */
  offlineOperation?: InputMaybe<Scalars['Boolean']>;
  /** OrderGroups object. */
  orderGroupsAttributes?: InputMaybe<Array<OrderGroupInput>>;
  /** ShiftDeliveryUnit object */
  shiftDeliveryUnitAttributes?: InputMaybe<ShiftDeliveryUnitInput>;
  /** Shift start time value in Unix. */
  startOnTimestamp?: InputMaybe<Scalars['Int']>;
  /** One among active, completed, verified, review1, review2, review3, accounting_sync_ready, partial_accounting_synced, queued_for_accounting_sync, accounting_synced, and archived. */
  state?: InputMaybe<Scalars['String']>;
  /** Driver's ID. */
  workerId?: InputMaybe<Scalars['ID']>;
};

/** ShiftDeliveryUnit Input */
export type ShiftDeliveryUnitInput = {
  /** ShiftDeliveryUnitsAsset Object. */
  shiftDeliveryUnitsAssetsAttributes?: InputMaybe<Array<ShiftDeliveryUnitsAssetInput>>;
  /** Shift's ID. */
  shiftId?: InputMaybe<Scalars['ID']>;
};

export type ShiftDeliveryUnitsAsset = {
  __typename?: 'ShiftDeliveryUnitsAsset';
  /** @deprecated Not available anymore */
  activeInspectionForm?: Maybe<DvirBeCompatibilitySupport>;
  deliveryAsset?: Maybe<DeliveryAsset>;
  id: Scalars['ID'];
  preInventoryConfirmed: Scalars['Boolean'];
};

/** ShiftDeliveryUnitsAsset Input */
export type ShiftDeliveryUnitsAssetInput = {
  /** DeliveryAsset's ID. */
  assetId?: InputMaybe<Scalars['ID']>;
  /** ID of the ShiftDeliveryUnitsAsset. Required during update. */
  id?: InputMaybe<Scalars['ID']>;
  /** ShiftCompartmentInstance Object. */
  shiftCompartmentInstancesAttributes?: InputMaybe<Array<ShiftCompartmentInstanceInput>>;
};

/** End Shift by Driver */
export type ShiftEndInput = {
  /** QrCode that's been scanned */
  code?: InputMaybe<Scalars['String']>;
  /** Documents */
  documents?: InputMaybe<Array<PandaDocumentInput>>;
  /** Shift's ID. */
  id: Scalars['ID'];
  /** OrderGroup Id's to do later */
  idsToCarryOver?: InputMaybe<Array<Scalars['ID']>>;
  /** OrderGroup Id's to send back to dispatch */
  idsToUnassign?: InputMaybe<Array<Scalars['ID']>>;
  /** Shift end location's latitude */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Shift end location's longitude */
  longitude?: InputMaybe<Scalars['Float']>;
  /** post shift totalizer notes */
  postShiftTotalizerNotes?: InputMaybe<Array<TotalizerInput>>;
  /** Shift skip note */
  skipNote?: InputMaybe<Scalars['String']>;
  /** End time in unix */
  timestamp?: InputMaybe<Scalars['Int']>;
  /** Provide only if unload is performed */
  unloadOrderAttributes?: InputMaybe<UnloadOrderInput>;
};

export type ShiftFilter = {
  all?: InputMaybe<Scalars['String']>;
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  or?: InputMaybe<Array<ShiftFilter>>;
  /** No. of items to display */
  perPage?: InputMaybe<Scalars['Int']>;
  /** Array has one or more element among: active and completed */
  states?: InputMaybe<Array<Scalars['String']>>;
  /** one among: today, this_week, next_week, fortnight */
  timeFrame?: InputMaybe<Scalars['String']>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
  workerId?: InputMaybe<Scalars['ID']>;
};

export type ShiftFiltersInput = {
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  /** Array has one or more element among: active and completed */
  states?: InputMaybe<Array<Scalars['String']>>;
  /** one among: today, this_week, next_week, fortnight */
  timeFrame?: InputMaybe<Scalars['String']>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
};

/** Shift Input */
export type ShiftInput = {
  /** Indicates if the preshift checklist is completed */
  checklistCompleted?: InputMaybe<Scalars['Boolean']>;
  /** Shift end time value in Unix. */
  endOnTimestamp?: InputMaybe<Scalars['Int']>;
  /** Shift's ID. */
  id?: InputMaybe<Scalars['ID']>;
  /** Notes object. */
  notesAttributes?: InputMaybe<Array<NoteInput>>;
  /** Set this to true incase of offline */
  offlineOperation?: InputMaybe<Scalars['Boolean']>;
  /** OrderGroups object. */
  orderGroupsAttributes?: InputMaybe<Array<OrderGroupInput>>;
  /** Preshift checklist documents */
  preshiftChecklistDocumentsAttributes?: InputMaybe<Array<PandaDocumentInput>>;
  /** ShiftChecklistItem object */
  shiftChecklistItemsAttributes?: InputMaybe<Array<ShiftChecklistItemInput>>;
  /** ShiftDeliveryUnit object */
  shiftDeliveryUnitAttributes?: InputMaybe<ShiftDeliveryUnitInput>;
  /** Shift start time value in Unix. */
  startOnTimestamp?: InputMaybe<Scalars['Int']>;
  /** One among active, completed, verified, review1, review2, review3, accounting_sync_ready, partial_accounting_synced, queued_for_accounting_sync, accounting_synced, and archived. */
  state?: InputMaybe<ShiftStateEnum>;
  /** Driver's ID. */
  workerId?: InputMaybe<Scalars['ID']>;
};

export enum ShiftInventoryAdjustmentTypes {
  /** Changes to reflect in initial inventory */
  Initial = 'INITIAL',
  /** Changes to reflect in reconciliation inventory */
  Reconciliation = 'RECONCILIATION'
}

export enum ShiftOrOrderEnum {
  /** Check progress based on Order ID */
  OrderId = 'ORDER_ID',
  /** Check progress based on Shift ID */
  ShiftId = 'SHIFT_ID'
}

export type ShiftPlan = {
  __typename?: 'ShiftPlan';
  completedDeliveries?: Maybe<Array<ShiftPlanDelivery>>;
  completedDeliveriesMetrics?: Maybe<ShiftPlanDeliveryMetric>;
  customerPods?: Maybe<Scalars['String']>;
  deliveries?: Maybe<Array<ShiftPlanDelivery>>;
  deliveriesMetrics?: Maybe<ShiftPlanDeliveryMetric>;
  deliveriesRoutes?: Maybe<Array<Scalars['JSON']>>;
  earliestStart?: Maybe<Scalars['Int']>;
  errors?: Maybe<Array<Scalars['String']>>;
  estimatedVolume?: Maybe<Scalars['Float']>;
  hub?: Maybe<ShiftPlanHub>;
  id: Scalars['ID'];
  latestEnd?: Maybe<Scalars['Int']>;
  lineOfServices?: Maybe<Array<LineOfService>>;
  location?: Maybe<Scalars['String']>;
  noUnassigned?: Maybe<Scalars['Int']>;
  optimized: Scalars['Boolean'];
  optimizedGreaterThanConfigured?: Maybe<Scalars['Boolean']>;
  optimizedReloading?: Maybe<Scalars['Int']>;
  planned?: Maybe<Array<ShiftPlanDelivery>>;
  plannedCount?: Maybe<Scalars['Int']>;
  plannedMetrics?: Maybe<ShiftPlanDeliveryMetric>;
  productsDelivered?: Maybe<Scalars['String']>;
  queued?: Maybe<Scalars['Boolean']>;
  routingRequestId?: Maybe<Scalars['ID']>;
  shift: Scalars['Int'];
  shiftDate: Scalars['ISO8601Date'];
  status: Scalars['String'];
  truckId: Scalars['String'];
  unassignedList?: Maybe<Array<ShiftPlanUnassigned>>;
  worker?: Maybe<Worker>;
};

export type ShiftPlanCollection = {
  __typename?: 'ShiftPlanCollection';
  collection: Array<ShiftPlan>;
  metadata: MetaQuery;
};

export type ShiftPlanDeliveries = {
  __typename?: 'ShiftPlanDeliveries';
  address?: Maybe<Scalars['String']>;
  customerName: Scalars['String'];
  delayTimeAdder?: Maybe<Scalars['Int']>;
  earliest?: Maybe<Scalars['Int']>;
  hhOrderType?: Maybe<Scalars['String']>;
  ignore?: Maybe<Scalars['Boolean']>;
  lat?: Maybe<Scalars['Float']>;
  latest?: Maybe<Scalars['Int']>;
  lon?: Maybe<Scalars['Float']>;
  optimizationError?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  pickupLocation?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
  product?: Maybe<Scalars['String']>;
  timeWindows?: Maybe<Array<ShiftPlanDeliveryTimeWindows>>;
  truckLoad?: Maybe<Scalars['Boolean']>;
  updateTimeWindow?: Maybe<Scalars['Boolean']>;
  volume?: Maybe<Scalars['Float']>;
};

export type ShiftPlanDelivery = {
  __typename?: 'ShiftPlanDelivery';
  address: Scalars['String'];
  arrTime?: Maybe<Scalars['Int']>;
  arriveDateTime?: Maybe<Scalars['String']>;
  arrivingTime?: Maybe<Scalars['Int']>;
  compartment?: Maybe<Scalars['String']>;
  compartments?: Maybe<Array<Scalars['Int']>>;
  completeDateTime?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  /** Delivery Comments */
  deliveryInstruction?: Maybe<Scalars['String']>;
  deliveryZone?: Maybe<Scalars['String']>;
  distanceMiles?: Maybe<Scalars['Float']>;
  division?: Maybe<Scalars['String']>;
  drivingTimeSeconds?: Maybe<Scalars['Int']>;
  estimatedVolume?: Maybe<Scalars['Float']>;
  ffm?: Maybe<Scalars['String']>;
  flushing?: Maybe<Scalars['Boolean']>;
  hoseTime?: Maybe<Scalars['Int']>;
  inconsistent?: Maybe<Scalars['Boolean']>;
  index?: Maybe<Scalars['Int']>;
  inventory?: Maybe<Scalars['Boolean']>;
  lastDeliveryDate?: Maybe<Scalars['String']>;
  lastDistanceInMiles?: Maybe<Scalars['Float']>;
  lastDrivingTime?: Maybe<Scalars['Int']>;
  lastEndTime?: Maybe<Scalars['Int']>;
  lastWaitingTime?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  lineComment?: Maybe<Scalars['String']>;
  lon?: Maybe<Scalars['Float']>;
  orderNumber?: Maybe<Scalars['String']>;
  podNo?: Maybe<Scalars['Int']>;
  product?: Maybe<Scalars['String']>;
  productCode?: Maybe<Scalars['String']>;
  productUsed?: Maybe<Scalars['String']>;
  secondLastDeliveryDate?: Maybe<Scalars['String']>;
  tankSize?: Maybe<Scalars['Float']>;
  timeAdder?: Maybe<Scalars['Int']>;
  timeSeconds?: Maybe<Scalars['Int']>;
  timeWindows?: Maybe<Array<ShiftPlanDeliveryTimeWindows>>;
  type?: Maybe<Scalars['String']>;
  volume?: Maybe<Scalars['Float']>;
  volumeUsed?: Maybe<Scalars['Float']>;
  waitingTimeSeconds?: Maybe<Scalars['Int']>;
};

/** Shift Plan delivery Input */
export type ShiftPlanDeliveryInput = {
  address?: InputMaybe<Scalars['String']>;
  earliest?: InputMaybe<Scalars['Int']>;
  hhOrderType?: InputMaybe<Scalars['String']>;
  ignore?: InputMaybe<Scalars['Boolean']>;
  lat?: InputMaybe<Scalars['Float']>;
  latest?: InputMaybe<Scalars['Int']>;
  lon?: InputMaybe<Scalars['Float']>;
  pickupLocation?: InputMaybe<Scalars['Int']>;
  priority?: InputMaybe<Scalars['Int']>;
  timeAdder?: InputMaybe<Scalars['Int']>;
  timeWindows?: InputMaybe<Array<ShiftPlanTimeWindowInput>>;
  truckLoad?: InputMaybe<Scalars['Boolean']>;
};

export type ShiftPlanDeliveryMetric = {
  __typename?: 'ShiftPlanDeliveryMetric';
  deliveriesCount?: Maybe<Scalars['Int']>;
  distance?: Maybe<Scalars['Float']>;
  hubsDistance?: Maybe<Scalars['Float']>;
  hubsTime?: Maybe<Scalars['Int']>;
  missing?: Maybe<Array<Scalars['String']>>;
  serviceTime?: Maybe<Scalars['Int']>;
  time?: Maybe<Scalars['String']>;
  timeSeconds?: Maybe<Scalars['Int']>;
  volumeDelivered?: Maybe<Scalars['Float']>;
};

export type ShiftPlanDeliveryTimeWindows = {
  __typename?: 'ShiftPlanDeliveryTimeWindows';
  earliest?: Maybe<Scalars['Int']>;
  latest?: Maybe<Scalars['Int']>;
};

export type ShiftPlanFilter = {
  all?: InputMaybe<Scalars['String']>;
  customers?: InputMaybe<Scalars['String']>;
  driver?: InputMaybe<Array<Scalars['ID']>>;
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  lineOfServices?: InputMaybe<Array<Scalars['String']>>;
  location?: InputMaybe<Array<Scalars['String']>>;
  locationName?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<ShiftPlanFilter>>;
  /** No. of items to display */
  perPage?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<Scalars['String']>;
  shift?: InputMaybe<Scalars['Int']>;
  /** Array has one or more element among: 'active', 'completed', 'printed' */
  status?: InputMaybe<Array<Scalars['String']>>;
  /** one among: today, this_week, next_week, fortnight */
  timeFrame?: InputMaybe<Scalars['String']>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
  truckId?: InputMaybe<Scalars['String']>;
};

export type ShiftPlanHub = {
  __typename?: 'ShiftPlanHub';
  address: Scalars['String'];
  lat: Scalars['Float'];
  lon: Scalars['Float'];
  name?: Maybe<Scalars['String']>;
};

export type ShiftPlanInventory = {
  __typename?: 'ShiftPlanInventory';
  asset?: Maybe<Asset>;
  compartments?: Maybe<Array<ShiftPlanInventoryCompartment>>;
  id: Scalars['ID'];
  inventoryDateTime?: Maybe<Scalars['ISO8601DateTime']>;
  truckId?: Maybe<Scalars['String']>;
};

export type ShiftPlanInventoryCompartment = {
  __typename?: 'ShiftPlanInventoryCompartment';
  compartmentId?: Maybe<Scalars['ID']>;
  productId?: Maybe<Scalars['String']>;
  volume?: Maybe<Scalars['Float']>;
};

export type ShiftPlanSorter = {
  field: ShiftPlanSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum ShiftPlanSorterEnum {
  Date = 'DATE',
  Shift = 'SHIFT',
  Truck = 'TRUCK'
}

/** Shift Plan Time Window Input */
export type ShiftPlanTimeWindowInput = {
  earliest?: InputMaybe<Scalars['Int']>;
  latest?: InputMaybe<Scalars['Int']>;
};

/** Shift Plan Truck Input */
export type ShiftPlanTruckInput = {
  compartments?: InputMaybe<Scalars['JSON']>;
  earliestStart?: InputMaybe<Scalars['Int']>;
  latestEnd?: InputMaybe<Scalars['Int']>;
  shiftPlanInventoryId?: InputMaybe<Scalars['ID']>;
  workerId?: InputMaybe<Scalars['ID']>;
};

export type ShiftPlanUnassigned = {
  __typename?: 'ShiftPlanUnassigned';
  code?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
};

export type ShiftPlannerDriverOrder = {
  __typename?: 'ShiftPlannerDriverOrder';
  address?: Maybe<Scalars['String']>;
  carrierName?: Maybe<Scalars['String']>;
  /** complete_on_timestamp (planned end) */
  completeOn?: Maybe<Scalars['Int']>;
  customerBranchSchedule?: Maybe<ResourceSchedule>;
  customerName?: Maybe<Scalars['String']>;
  customerSchedule?: Maybe<ResourceSchedule>;
  deliveryTruckNames?: Maybe<Scalars['JSON']>;
  driverAcceptance?: Maybe<Scalars['String']>;
  driverId?: Maybe<Scalars['ID']>;
  driverName?: Maybe<Scalars['String']>;
  /** completed_on_timestamp */
  endAt?: Maybe<Scalars['Int']>;
  fuelingDuration?: Maybe<Scalars['Int']>;
  hubName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  linkedOrders?: Maybe<Scalars['JSON']>;
  /** delivery_order.id / loading_order.id / transfer_order.id */
  orderId?: Maybe<Scalars['ID']>;
  /** start_on as Unix timestamp */
  plannedAt?: Maybe<Scalars['Int']>;
  preferredSuppliers?: Maybe<Scalars['JSON']>;
  shipToName?: Maybe<Scalars['String']>;
  /** started_on_timestamp */
  startAt?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  suppliers?: Maybe<Scalars['JSON']>;
  /** Alias for order_groups.id */
  ticketId?: Maybe<Scalars['ID']>;
  /** time until start in seconds (planned start - now) */
  toStartAt?: Maybe<Scalars['Int']>;
  /** delivery, loading, transfer, extraction */
  type: Scalars['String'];
};

export type ShiftPlannerDriverOrderCollection = {
  __typename?: 'ShiftPlannerDriverOrderCollection';
  collection: Array<ShiftPlannerDriverOrder>;
  metadata: MetaQuery;
};

export type ShiftPlannerDriverSummary = {
  __typename?: 'ShiftPlannerDriverSummary';
  /** Unix timestamp of earliest order start */
  earliestStart?: Maybe<Scalars['Int']>;
  /** Unix timestamp of latest order end */
  latestEnd?: Maybe<Scalars['Int']>;
  statusCounts: Array<StatusCount>;
  totalOrders: Scalars['Int'];
  workerId: Scalars['ID'];
};

/** Autogenerated input type of ShiftReconciliation */
export type ShiftReconciliationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  shiftIds: Array<Scalars['Int']>;
};

/** Autogenerated return type of ShiftReconciliation */
export type ShiftReconciliationPayload = {
  __typename?: 'ShiftReconciliationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  reconciliation?: Maybe<ShiftReconciliationResponse>;
};

export type ShiftReconciliationResponse = {
  __typename?: 'ShiftReconciliationResponse';
  shiftResponses: Array<ShiftResponse>;
};

/** Members of ShiftResource */
export type ShiftResource = CompanyAsset | Terminal;

export type ShiftResponse = {
  __typename?: 'ShiftResponse';
  errors?: Maybe<Array<Scalars['JSON']>>;
  shiftId: Scalars['ID'];
  success: Scalars['Boolean'];
  successRequests?: Maybe<Array<Scalars['JSON']>>;
};

export type ShiftSorter = {
  field: ShiftSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum ShiftSorterEnum {
  Asset = 'ASSET',
  Date = 'DATE',
  Driver = 'DRIVER',
  Enddate = 'ENDDATE',
  Hub = 'HUB',
  Id = 'ID',
  Startdate = 'STARTDATE',
  Status = 'STATUS'
}

export enum ShiftStartMethodEnum {
  /** Code */
  Code = 'code',
  /** One touch button */
  OneTouchButton = 'one_touch_button'
}

/** Enum for various state of shift */
export enum ShiftStateEnum {
  AccountingSynced = 'ACCOUNTING_SYNCED',
  AccountingSyncReady = 'ACCOUNTING_SYNC_READY',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED',
  PartialAccountingSynced = 'PARTIAL_ACCOUNTING_SYNCED',
  QueuedForAccountingSync = 'QUEUED_FOR_ACCOUNTING_SYNC',
  Review1 = 'REVIEW1',
  Review2 = 'REVIEW2',
  Review3 = 'REVIEW3',
  Verified = 'VERIFIED'
}

/** Autogenerated input type of ShiftsSync */
export type ShiftsSyncInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  shiftIds: Array<Scalars['Int']>;
};

/** Autogenerated return type of ShiftsSync */
export type ShiftsSyncPayload = {
  __typename?: 'ShiftsSyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['JSON']>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SidekiqRequest = {
  __typename?: 'SidekiqRequest';
  caller: Scalars['String'];
  createdAtTimestamp?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  request: Scalars['JSON'];
  result?: Maybe<Scalars['JSON']>;
  resultExists?: Maybe<Scalars['Boolean']>;
  status: Scalars['String'];
};

export type SidekiqRequestCollection = {
  __typename?: 'SidekiqRequestCollection';
  collection: Array<SidekiqRequest>;
  metadata: MetaQuery;
};

export type SidekiqRequestFilter = {
  all?: InputMaybe<Scalars['String']>;
  caller?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
};

export type SidekiqRequestSorter = {
  field: SidekiqRequestSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum SidekiqRequestSorterEnum {
  Id = 'ID'
}

/** Autogenerated input type of SignIn */
export type SignInInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  credentials: AuthInput;
};

/** Autogenerated return type of SignIn */
export type SignInPayload = {
  __typename?: 'SignInPayload';
  accessibleCustomers?: Maybe<Array<Customer>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  isCustomerClient?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  otpRequiredForLogin?: Maybe<Scalars['Boolean']>;
  refreshToken?: Maybe<Scalars['String']>;
  requires2fa?: Maybe<Scalars['Boolean']>;
  token?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type Site = {
  __typename?: 'Site';
  address?: Maybe<Scalars['JSON']>;
  city?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lat?: Maybe<Scalars['String']>;
  lng?: Maybe<Scalars['String']>;
  qbAddress?: Maybe<Scalars['String']>;
  radius?: Maybe<Scalars['Float']>;
  state?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['JSON']>;
  zip?: Maybe<Scalars['String']>;
};

export type SiteInput = {
  /** Shiptos address. */
  address?: InputMaybe<Scalars['JSON']>;
  city?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  lat?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['String']>;
  /** In meters */
  radius?: InputMaybe<Scalars['Float']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type SourceAsset = {
  __typename?: 'SourceAsset';
  asset: Asset;
  deliveryOrderLineItem: DeliveryOrderLineItem;
  dispensedQty?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  zoneProductBatch?: Maybe<ZoneProductBatch>;
};

/** In case of package delivery Source Asset for delivery order line item input */
export type SourceAssetInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** Asset ID. */
  assetId?: InputMaybe<Scalars['ID']>;
  /** Dispensed volume. */
  dispensedQty?: InputMaybe<Scalars['Float']>;
  /** SourceAsset ID. */
  id?: InputMaybe<Scalars['ID']>;
  zoneProductBatchId?: InputMaybe<Scalars['ID']>;
};

export type SourceAssociation = {
  __typename?: 'SourceAssociation';
  deliveryOrder?: Maybe<DeliveryOrder>;
  id: Scalars['ID'];
  loadingOrder?: Maybe<LoadingOrder>;
  transferOrder?: Maybe<TransferOrder>;
};

export type SourceCompartment = {
  __typename?: 'SourceCompartment';
  compartment: Compartment;
  deliveryOrderLineItem: DeliveryOrderLineItem;
  dispensedVolume?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
};

/** Source Compartment for delivery order line item input */
export type SourceCompartmentInput = {
  /** Deprecated. DO NOT USE. */
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** Compartment ID. */
  compartmentId: Scalars['ID'];
  /** Dispensed volume. */
  dispensedVolume: Scalars['Float'];
  /** SourceCompartment ID. */
  id?: InputMaybe<Scalars['ID']>;
  /** Product ID. */
  productId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of StartShift */
export type StartShiftInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  method?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of StartShift */
export type StartShiftPayload = {
  __typename?: 'StartShiftPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  shift?: Maybe<Shift>;
};

export type StatusCount = {
  __typename?: 'StatusCount';
  count: Scalars['Int'];
  status: Scalars['String'];
};

export enum StatusEnum {
  /** Active record */
  Active = 'active',
  /** Inactive record */
  Inactive = 'inactive'
}

export enum StatusStringEnum {
  /** Active */
  Active = 'active',
  /** Inactive */
  Inactive = 'inactive'
}

/** Enum for delivery order line item status types */
export enum StatusTypeEnum {
  /** Completed status type */
  Completed = 'completed',
  /** Pending status type */
  Skipped = 'skipped'
}

export type Subject = {
  __typename?: 'Subject';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of SubmitDelivery */
export type SubmitDeliveryInput = {
  assetProductCategoriesAttributes?: InputMaybe<Array<NestedAssetProductCategoryInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryOrderAttributes: DeliveryOrderInput;
  deliveryOrderId?: InputMaybe<Scalars['ID']>;
  /** Don't use, deprecated! */
  taskId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of SubmitDelivery */
export type SubmitDeliveryPayload = {
  __typename?: 'SubmitDeliveryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
};

/** Autogenerated input type of SubmitLoading */
export type SubmitLoadingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  delay?: InputMaybe<DelayInput>;
  loadingOrderAttributes?: InputMaybe<LoadingOrderInput>;
  loadingOrderId?: InputMaybe<Scalars['ID']>;
  loadingReceiptsAttributes: Array<LoadingReceiptInput>;
  noteAttributes?: InputMaybe<NoteInput>;
  /** Don't use, deprecated! */
  taskId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of SubmitLoading */
export type SubmitLoadingPayload = {
  __typename?: 'SubmitLoadingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  delayNote?: Maybe<Note>;
  loadingOrder?: Maybe<LoadingOrder>;
  loadingReceipts?: Maybe<Array<LoadingReceipt>>;
  message?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
};

export type Subscription = {
  __typename?: 'Subscription';
  asset: Asset;
  compartment?: Maybe<Compartment>;
  id: Scalars['ID'];
  product: Product;
  status?: Maybe<Scalars['String']>;
};

export type Supplier = {
  __typename?: 'Supplier';
  active?: Maybe<Scalars['Boolean']>;
  erpId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  irelyId?: Maybe<Scalars['String']>;
  irelyShipFromLocation?: Maybe<Scalars['String']>;
  isIrelyInternalSupplier?: Maybe<Scalars['Boolean']>;
  lastSyncedTime?: Maybe<Scalars['String']>;
  lineOfServiceCount?: Maybe<Scalars['Int']>;
  lineOfServices?: Maybe<Array<LineOfService>>;
  loadingAccountCount?: Maybe<Scalars['Int']>;
  loadingAccounts?: Maybe<Array<LoadingAccount>>;
  /** Get loading accounts ranked by match score for given criteria */
  loadingAccountsForCriteria?: Maybe<Array<LoadingAccount>>;
  name: Scalars['String'];
  netsuiteId?: Maybe<Scalars['ID']>;
  nonEditableRecords?: Maybe<Array<Scalars['JSON']>>;
  /** Get single best loading account for given criteria */
  preferredLoadingAccount?: Maybe<LoadingAccount>;
  /** Product categories this supplier handles (feature flag controlled) */
  productCategories?: Maybe<Array<ProductCategory>>;
  supplierCode?: Maybe<Scalars['String']>;
  supplierId?: Maybe<Scalars['String']>;
  supplierType?: Maybe<SupplierTypeEnum>;
  terminalCount?: Maybe<Scalars['Int']>;
  terminals?: Maybe<Array<Terminal>>;
  terminalsSuppliers?: Maybe<Array<TerminalsSupplier>>;
};


export type SupplierLoadingAccountsForCriteriaArgs = {
  productCategoryId?: InputMaybe<Scalars['ID']>;
  state?: InputMaybe<Scalars['String']>;
};


export type SupplierPreferredLoadingAccountArgs = {
  productCategoryId?: InputMaybe<Scalars['ID']>;
  state?: InputMaybe<Scalars['String']>;
};

export type SupplierCollection = {
  __typename?: 'SupplierCollection';
  collection: Array<Supplier>;
  metadata: MetaQuery;
};

export type SupplierDetailLoadingAccount = {
  __typename?: 'SupplierDetailLoadingAccount';
  destinationState?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  loadingNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  rackMarkets?: Maybe<Array<SupplierDetailRackMarket>>;
};

export type SupplierDetailRackMarket = {
  __typename?: 'SupplierDetailRackMarket';
  hubResources?: Maybe<Array<HubResource>>;
  hubs?: Maybe<Array<Hub>>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  terminals?: Maybe<Array<SupplierDetailTerminal>>;
};

export type SupplierDetailSupplier = {
  __typename?: 'SupplierDetailSupplier';
  active?: Maybe<Scalars['Boolean']>;
  erpId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lineOfServices?: Maybe<Array<LineOfService>>;
  loadingAccounts?: Maybe<Array<SupplierDetailLoadingAccount>>;
  name: Scalars['String'];
  supplierCode?: Maybe<Scalars['String']>;
  supplierType?: Maybe<SupplierTypeEnum>;
};

export type SupplierDetailTerminal = {
  __typename?: 'SupplierDetailTerminal';
  pickupPointCodes?: Maybe<Array<PickupPointCode>>;
  products?: Maybe<Array<Product>>;
  terminalsSupplier?: Maybe<TerminalsSupplier>;
};

export type SupplierDetailV3LoadingAccount = {
  __typename?: 'SupplierDetailV3LoadingAccount';
  carrierCustomerCode?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  destinationState?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  loadingNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  rackMarkets?: Maybe<Array<SupplierDetailV3RackMarket>>;
  supplierCode?: Maybe<Scalars['String']>;
};

export type SupplierDetailV3RackMarket = {
  __typename?: 'SupplierDetailV3RackMarket';
  hubResources?: Maybe<Array<HubResource>>;
  hubs?: Maybe<Array<Hub>>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  terminals?: Maybe<Array<SupplierDetailV3Terminal>>;
};

export type SupplierDetailV3Supplier = {
  __typename?: 'SupplierDetailV3Supplier';
  active?: Maybe<Scalars['Boolean']>;
  erpId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lineOfServices?: Maybe<Array<LineOfService>>;
  loadingAccounts?: Maybe<Array<SupplierDetailV3LoadingAccount>>;
  name: Scalars['String'];
  supplierCode?: Maybe<Scalars['String']>;
  supplierType?: Maybe<SupplierTypeEnum>;
};

export type SupplierDetailV3Terminal = {
  __typename?: 'SupplierDetailV3Terminal';
  pickupPointCodes?: Maybe<Array<PickupPointCode>>;
  terminalProducts?: Maybe<Array<SupplierDetailV3TerminalProduct>>;
  terminalsSupplier?: Maybe<TerminalsSupplier>;
};

export type SupplierDetailV3TerminalProduct = {
  __typename?: 'SupplierDetailV3TerminalProduct';
  active: Scalars['Boolean'];
  brandTypes: Array<LatpBrandTypeEnum>;
  id: Scalars['ID'];
  product?: Maybe<Product>;
};

export type SupplierFilter = {
  active?: InputMaybe<Scalars['Boolean']>;
  all?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  lineOfServiceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<SupplierFilter>>;
  rackMarketIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  supplierCode?: InputMaybe<Scalars['String']>;
  supplierIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  supplierTypes?: InputMaybe<Array<InputMaybe<SupplierTypeEnum>>>;
  terminalId?: InputMaybe<Scalars['ID']>;
  terminalIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type SupplierSorter = {
  field: SupplierSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum SupplierSorterEnum {
  Erpid = 'ERPID',
  Name = 'NAME',
  Supplierid = 'SUPPLIERID'
}

/** Supplier type enum */
export enum SupplierTypeEnum {
  Carrier = 'carrier',
  Distributor = 'distributor',
  Jobber = 'jobber',
  Marketer = 'marketer',
  Other = 'other'
}

/** Autogenerated input type of SwitchTenant */
export type SwitchTenantInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  toCustomerId: Scalars['ID'];
};

/** Autogenerated return type of SwitchTenant */
export type SwitchTenantPayload = {
  __typename?: 'SwitchTenantPayload';
  accessToken: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Autogenerated input type of SyncAll */
export type SyncAllInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of SyncAll */
export type SyncAllPayload = {
  __typename?: 'SyncAllPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of SyncDataFromVendor */
export type SyncDataFromVendorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  syncDataAttributes: SyncVendorDataInput;
};

/** Autogenerated return type of SyncDataFromVendor */
export type SyncDataFromVendorPayload = {
  __typename?: 'SyncDataFromVendorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of SyncIndividualTank */
export type SyncIndividualTankInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  manualSyncAttributes: Array<ManualSyncInput>;
  workerId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of SyncIndividualTank */
export type SyncIndividualTankPayload = {
  __typename?: 'SyncIndividualTankPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['String']>;
};

export type SyncOrdersFilters = {
  fromTimestamp: Scalars['Int'];
  includeSyncedOrders?: InputMaybe<Scalars['Boolean']>;
  onlyDeliveryOrders?: InputMaybe<Scalars['Boolean']>;
  toTimestamp: Scalars['Int'];
};

/** Input of sync vendeor data */
export type SyncVendorDataInput = {
  referenceIds?: InputMaybe<Array<Scalars['ID']>>;
  resourceName: ResourceNameEnum;
  vendorName: VendorNameEnum;
};

export type TmDateTimeRangeFilter = {
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  toDate?: InputMaybe<Scalars['ISO8601DateTime']>;
};

export type TmGenericRangeFilter = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type Tag = {
  __typename?: 'Tag';
  colorCode?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  erpId?: Maybe<Scalars['String']>;
  iconName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  status?: Maybe<StatusStringEnum>;
  tagType?: Maybe<Scalars['String']>;
};

export type TagCollection = {
  __typename?: 'TagCollection';
  collection: Array<Tag>;
  metadata: MetaQuery;
};

export type TagFilter = {
  all?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<TagFilter>>;
  tagType?: InputMaybe<TagTypeEnum>;
};

export type TagInput = {
  colorCode?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  iconName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  status?: InputMaybe<StatusStringEnum>;
  tagType?: InputMaybe<Scalars['String']>;
};

export enum TagTypeEnum {
  /** asset_level */
  AssetLevel = 'asset_level',
  /** customer_level */
  CustomerLevel = 'customer_level',
  /** order_level */
  OrderLevel = 'order_level',
  /** ship_to_level */
  ShipToLevel = 'ship_to_level'
}

export type Tagging = {
  __typename?: 'Tagging';
  id: Scalars['ID'];
  tag?: Maybe<Tag>;
};

/** Point of contact Input */
export type TaggingInput = {
  /** Flag to destroy the tagging. */
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** ID of point of contact. */
  id?: InputMaybe<Scalars['ID']>;
  tagId?: InputMaybe<Scalars['ID']>;
};

/** Meta data used to fetch next records and retrive total records */
export type TankMonitorMetaDataQuery = {
  __typename?: 'TankMonitorMetaDataQuery';
  hasMore: Scalars['Boolean'];
  totalCount?: Maybe<Scalars['Int']>;
  total_entries?: Maybe<Scalars['Int']>;
};

/** Enum for tank monitor order statuses */
export enum TankMonitorOrderEnum {
  Active = 'Active',
  AwaitingConfirmation = 'AwaitingConfirmation',
  Scheduled = 'Scheduled',
  Unscheduled = 'Unscheduled'
}

export type TankMonitorSorter = {
  field: DevicesSorterEnum;
  order?: InputMaybe<PandaTankMonitorFieldOrder>;
};

export enum TankTypeEnum {
  /** convault */
  Convault = 'convault',
  /** double wall */
  DoubleWall = 'double_wall',
  /** farm */
  Farm = 'farm',
  /** fire guard */
  FireGuard = 'fire_guard',
  /** frac */
  Frac = 'frac',
  /** fuel cube */
  FuelCube = 'fuel_cube',
  /** kicker */
  Kicker = 'kicker',
  /** overhead */
  Overhead = 'overhead',
  /** round */
  Round = 'round',
  /** single wall */
  SingleWall = 'single_wall',
  /** square tank */
  SquareTank = 'square_tank',
  /** standard */
  Standard = 'standard',
  /** super vault */
  SuperVault = 'super_vault',
  /** trailers */
  Trailers = 'trailers',
  /** trans cube */
  TransCube = 'trans_cube',
  /** vertical */
  Vertical = 'vertical'
}

export type Task = {
  __typename?: 'Task';
  completeOnTimestamp?: Maybe<Scalars['Int']>;
  completedOnTimestamp?: Maybe<Scalars['Int']>;
  customerBranch: CustomerBranch;
  data?: Maybe<Scalars['JSON']>;
  deliveryOrderId?: Maybe<Scalars['ID']>;
  departOnTimestamp?: Maybe<Scalars['Int']>;
  departedOnTimestamp?: Maybe<Scalars['Int']>;
  driver?: Maybe<Driver>;
  driverAcceptance: Scalars['String'];
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  site: Site;
  startOnTimestamp?: Maybe<Scalars['Int']>;
  startedOnTimestamp?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  terminal?: Maybe<Terminal>;
  workerId?: Maybe<Scalars['Int']>;
};

export type TaskFiltersInput = {
  driverAcceptance?: InputMaybe<Scalars['String']>;
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  timeFrame?: InputMaybe<Scalars['String']>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
};

export type Tax = {
  __typename?: 'Tax';
  amountType?: Maybe<Scalars['String']>;
  calculationType?: Maybe<Scalars['String']>;
  dateRangeAttribute?: Maybe<Array<TaxRangeAttribute>>;
  description?: Maybe<Scalars['String']>;
  doNotRoundUpRate?: Maybe<Scalars['Boolean']>;
  erpId?: Maybe<Scalars['String']>;
  exempt?: Maybe<Scalars['Boolean']>;
  glCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  marketId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  productCategoryId?: Maybe<Scalars['ID']>;
  productCategoryResources?: Maybe<Array<ProductCategoryResource>>;
  productTaxes?: Maybe<Array<ProductTax>>;
  rateInCurrency?: Maybe<Scalars['Float']>;
  rateInPercent?: Maybe<Scalars['Float']>;
  rateType?: Maybe<Scalars['String']>;
};

/** Enum for tax amount type enum */
export enum TaxAmountTypeEnum {
  /** Sales */
  Sales = 'sales',
  /** Sales Fee */
  SalesFee = 'sales_fee',
  /** Sales Fee Tax */
  SalesFeeTax = 'sales_fee_tax'
}

/** Enum for tax calculation type */
export enum TaxCalculationTypeEnum {
  /** Amount Based */
  AmountBased = 'amount_based',
  /** Quantity Based */
  QuantityBased = 'quantity_based'
}

export type TaxCollection = {
  __typename?: 'TaxCollection';
  collection: Array<Tax>;
  metadata: MetaDataQuery;
};

export type TaxDetail = {
  __typename?: 'TaxDetail';
  erpId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  quantity: Scalars['Float'];
  rate: Scalars['Float'];
  rateUnit?: Maybe<Scalars['String']>;
  total: Scalars['Float'];
  type: Scalars['String'];
};

export type TaxFilter = {
  all?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<TaxFilter>>;
};

export type TaxRangeAttribute = {
  __typename?: 'TaxRangeAttribute';
  endRange?: Maybe<Scalars['Int']>;
  rangeRate?: Maybe<Scalars['String']>;
  startRange?: Maybe<Scalars['Int']>;
};

/** TaxRangeAttribute Input */
export type TaxRangeAttributeInput = {
  endRange?: InputMaybe<Scalars['Int']>;
  rangeRate?: InputMaybe<Scalars['String']>;
  startRange?: InputMaybe<Scalars['Int']>;
};

export type TaxReportFilterInput = {
  customerBranchId?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
};

export type TemporaryPricingBreakdown = {
  __typename?: 'TemporaryPricingBreakdown';
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

export type TemporaryPricingCustomerBranchesFilter = {
  all?: InputMaybe<Scalars['String']>;
  customerId: Scalars['ID'];
};

export type TemporaryPricingCustomersFilter = {
  all?: InputMaybe<Scalars['String']>;
};

export type TemporaryPricingDate = {
  __typename?: 'TemporaryPricingDate';
  freight?: Maybe<TemporaryPricingBreakdown>;
  isTemporary?: Maybe<Scalars['Boolean']>;
  markup?: Maybe<TemporaryPricingBreakdown>;
  price?: Maybe<TemporaryPricingBreakdown>;
  taxes?: Maybe<TemporaryPricingBreakdown>;
  totalPrice?: Maybe<TemporaryPricingBreakdown>;
  ttlDurationSeconds?: Maybe<Scalars['Int']>;
};

export type TemporaryPricingsByBranchFilter = {
  customerBranchId: Scalars['ID'];
};

export type Tenant = {
  __typename?: 'Tenant';
  adminUsers?: Maybe<Array<User>>;
  customers?: Maybe<Array<Customer>>;
  heroImage?: Maybe<AttachedFile>;
  id: Scalars['ID'];
  logo?: Maybe<AttachedFile>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  status: Scalars['Int'];
};

export type TenantContent = {
  __typename?: 'TenantContent';
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  data?: Maybe<Scalars['JSON']>;
  documentType: TenantContentDocumentTypeEnum;
  id: Scalars['ID'];
  tenant: Tenant;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum TenantContentDocumentTypeEnum {
  /** lea_core_content */
  LeaCoreContent = 'lea_core_content'
}

export type TenantContentInput = {
  content?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['JSON']>;
  documentType: TenantContentDocumentTypeEnum;
  id?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};

export type TenantResourceable = Asset;

export type Terminal = {
  __typename?: 'Terminal';
  active?: Maybe<Scalars['Boolean']>;
  erpId?: Maybe<Scalars['String']>;
  feinNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  irelyId?: Maybe<Scalars['String']>;
  isOwnBulkTank?: Maybe<Scalars['Boolean']>;
  isWarehouse?: Maybe<Scalars['Boolean']>;
  lastSyncedTime?: Maybe<Scalars['String']>;
  loadingInstruction?: Maybe<Scalars['String']>;
  loadingOrders?: Maybe<Array<LoadingOrder>>;
  name?: Maybe<Scalars['String']>;
  nonEditableRecords?: Maybe<Array<Scalars['JSON']>>;
  nsTags?: Maybe<Array<Scalars['String']>>;
  productTerminals?: Maybe<Array<ProductTerminal>>;
  products?: Maybe<Array<Product>>;
  rackMarket?: Maybe<RackMarket>;
  site?: Maybe<Site>;
  supplierCounts?: Maybe<Scalars['String']>;
  suppliers?: Maybe<Array<Supplier>>;
  terminalManagers?: Maybe<Array<TerminalManager>>;
  terminalNumber?: Maybe<Scalars['String']>;
  terminalsSuppliers?: Maybe<Array<TerminalsSupplier>>;
};

export type TerminalCollection = {
  __typename?: 'TerminalCollection';
  collection: Array<Terminal>;
  metadata: MetaQuery;
};

export type TerminalDistance = {
  __typename?: 'TerminalDistance';
  distance: Scalars['Float'];
  terminal: Terminal;
};

export type TerminalFilter = {
  active?: InputMaybe<Scalars['Boolean']>;
  all?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  isWarehouse?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<TerminalFilter>>;
  rackMarketId?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<Scalars['Boolean']>;
  supplierId?: InputMaybe<Array<Scalars['ID']>>;
  terminalId?: InputMaybe<Array<Scalars['ID']>>;
};

/** Default terminal Input */
export type TerminalInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  feinNumber?: InputMaybe<Scalars['String']>;
  isOwnBulkTank?: InputMaybe<Scalars['Boolean']>;
  isWarehouse?: InputMaybe<Scalars['Boolean']>;
  loadingInstruction?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nsTags?: InputMaybe<Array<Scalars['String']>>;
  products?: InputMaybe<Array<NestedProductInput>>;
  rackMarketId?: InputMaybe<Scalars['ID']>;
  siteAttributes?: InputMaybe<NestedSiteInput>;
  terminalManagersAttributes?: InputMaybe<Array<TerminalManagersInput>>;
  terminalsSuppliersAttributes?: InputMaybe<Array<NestedTerminalSupplierInput>>;
};

export type TerminalManager = {
  __typename?: 'TerminalManager';
  id?: Maybe<Scalars['ID']>;
  terminal?: Maybe<Terminal>;
  user?: Maybe<User>;
};

export type TerminalManagersInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  terminalId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type TerminalProductsInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  bolTimeAt?: InputMaybe<BolTimeAtEnum>;
  pickupPointCode?: InputMaybe<Scalars['String']>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  rackMarketId?: InputMaybe<Scalars['ID']>;
  terminalId?: InputMaybe<Scalars['ID']>;
  terminalsSupplierId?: InputMaybe<Scalars['ID']>;
};

/** Terminal product input (v3) supporting multiple pickup point codes and brand types per product */
export type TerminalProductsInputV3 = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  bolTimeAt?: InputMaybe<BolTimeAtEnum>;
  pickupPointCodes?: InputMaybe<Array<NestedPickupPointCodeForTerminalProductInput>>;
  products?: InputMaybe<Array<ProductWithBrandTypesInput>>;
  rackMarketId?: InputMaybe<Scalars['ID']>;
  terminalId?: InputMaybe<Scalars['ID']>;
  terminalsSupplierId?: InputMaybe<Scalars['ID']>;
};

export type TerminalSorter = {
  field: TerminalSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum TerminalSorterEnum {
  Erpid = 'ERPID',
  Name = 'NAME'
}

export type TerminalsSupplier = {
  __typename?: 'TerminalsSupplier';
  bolTimeAt?: Maybe<BolTimeAtEnum>;
  id: Scalars['ID'];
  irelySubstituteTerminal?: Maybe<Scalars['String']>;
  nonEditableRecords?: Maybe<Array<Scalars['JSON']>>;
  /** @deprecated Dont use this. Use pickup_point_codes instead */
  pickupPointCode?: Maybe<Scalars['String']>;
  pickupPointCodes?: Maybe<Array<PickupPointCode>>;
  supplier: Supplier;
  terminal: Terminal;
};

export type TerminalsSupplierCollection = {
  __typename?: 'TerminalsSupplierCollection';
  collection: Array<TerminalsSupplier>;
  metadata: MetaQuery;
};

export type TerminalsSupplierFilter = {
  all?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  or?: InputMaybe<Array<TerminalsSupplierFilter>>;
  supplierId?: InputMaybe<Scalars['ID']>;
  terminalId?: InputMaybe<Scalars['ID']>;
};

/** Default terminals supplier Input */
export type TerminalsSupplierInput = {
  bolTimeAt?: InputMaybe<Scalars['String']>;
  irelySubstituteTerminal?: InputMaybe<Scalars['String']>;
  pickupPointCodesAttributes?: InputMaybe<Array<NestedPickupPointCodeInput>>;
  supplierId: Scalars['ID'];
  terminalId: Scalars['ID'];
};

export type TerminalsSupplierSorter = {
  field: TerminalsSupplierSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query on terminal suppliers resolver */
export enum TerminalsSupplierSorterEnum {
  SupplierName = 'SUPPLIER_NAME',
  TerminalName = 'TERMINAL_NAME'
}

export enum TimeUnitEnum {
  /** per_month */
  PerMonth = 'per_month',
  /** per_week */
  PerWeek = 'per_week',
  /** per_year */
  PerYear = 'per_year'
}

/** Autogenerated input type of TmApproveOrCancelOrders */
export type TmApproveOrCancelOrdersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  input: ApproveOrCancelOrderInput;
};

/** Autogenerated return type of TmApproveOrCancelOrders */
export type TmApproveOrCancelOrdersPayload = {
  __typename?: 'TmApproveOrCancelOrdersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** List of error messages if the mutation failed */
  errors: Array<Scalars['String']>;
  /** Indicates if the mutation was successful */
  success: Scalars['Boolean'];
};

/** Autogenerated return type of TmCreateMultiOrderTopOff */
export type TmCreateMultiOrderTopOffPayload = {
  __typename?: 'TmCreateMultiOrderTopOffPayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Enum for order types in Panda Tank Monitor */
export enum TmOrderTypeEnum {
  /** Order for automatic processing */
  Auto = 'auto',
  /** Order for delivery */
  Delivery = 'delivery',
  /** Order for extraction */
  Extraction = 'extraction',
  /** Order for manual processing */
  Manual = 'manual'
}

export type TokenStatus = {
  __typename?: 'TokenStatus';
  expired: Scalars['Boolean'];
};

/** Enum to use on top_off_by fields when call a query */
export enum TopOffByEnum {
  /** Capacity */
  Capacity = 'capacity',
  /** Fixed Quantity */
  FixedQuantity = 'fixed_quantity'
}

export type Totalizer = {
  __typename?: 'Totalizer';
  discrepancy?: Maybe<Scalars['Float']>;
  final?: Maybe<Scalars['Float']>;
  initial?: Maybe<Scalars['Float']>;
  meterName?: Maybe<Scalars['String']>;
};

/** Default Totalizer Input */
export type TotalizerInput = {
  discrepancy: Scalars['Float'];
  final: Scalars['Float'];
  initial: Scalars['Float'];
  meterName: Scalars['String'];
};

/** Enum for transaction type for inventory records */
export enum TransactionTypeEnum {
  AdjustmentOrderLineItem = 'AdjustmentOrderLineItem',
  DeliveryOrderLineItem = 'DeliveryOrderLineItem',
  LoadingOrderLineItem = 'LoadingOrderLineItem',
  TransferOrderLineItem = 'TransferOrderLineItem'
}

export type TransferOrder = {
  __typename?: 'TransferOrder';
  bolId?: Maybe<Scalars['String']>;
  bolImages?: Maybe<Array<PandaDocument>>;
  comments?: Maybe<Array<Note>>;
  customerBranch?: Maybe<CustomerBranch>;
  externalBoId?: Maybe<Scalars['ID']>;
  from?: Maybe<TransferTarget>;
  fromAsset?: Maybe<Asset>;
  fromDriver?: Maybe<Driver>;
  fromShift?: Maybe<Shift>;
  id: Scalars['ID'];
  lineItemSummary?: Maybe<Array<LineItem>>;
  lineItems?: Maybe<Array<TransferOrderLineItem>>;
  notes?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
  orderGroupId?: Maybe<Scalars['Int']>;
  orderLinks?: Maybe<Array<OrderLink>>;
  pandaBoxTransactions?: Maybe<Array<PandaBoxTransaction>>;
  status: Scalars['String'];
  ticketId: Scalars['Int'];
  to?: Maybe<TransferTarget>;
  toAsset?: Maybe<Asset>;
  toDriver?: Maybe<Driver>;
  toShift?: Maybe<Shift>;
  totalizers?: Maybe<Array<Totalizer>>;
  /** Obsolete!! Use orderGroup's completedOnTimestamp */
  transferDateTimestamp?: Maybe<Scalars['BigInt']>;
};

export type TransferOrderCollection = {
  __typename?: 'TransferOrderCollection';
  collection: Array<TransferOrder>;
  metadata: MetaQuery;
};

export type TransferOrderFilter = {
  all?: InputMaybe<Scalars['String']>;
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  or?: InputMaybe<Array<TransferOrderFilter>>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
};

/** TransferOrder Input */
export type TransferOrderInput = {
  /** Deprecated. DO NOT USE. */
  _destroy?: InputMaybe<Scalars['Boolean']>;
  bolId?: InputMaybe<Scalars['String']>;
  /** Transfer order BOL image documents */
  bolImagesAttributes?: InputMaybe<Array<PandaDocumentInput>>;
  /** Branch/Site ID. */
  customerBranchId?: InputMaybe<Scalars['ID']>;
  /** Source asset ID. Required. */
  fromAssetId?: InputMaybe<Scalars['ID']>;
  /** Transfer 'from' Driver ID. */
  fromDriverId?: InputMaybe<Scalars['ID']>;
  /** ID of the source (Asset, Warehouse). */
  fromId?: InputMaybe<Scalars['ID']>;
  /** From(Source) Type */
  fromType?: InputMaybe<TransferTypeEnum>;
  /** Transfer order ID. Required during update. */
  id?: InputMaybe<Scalars['ID']>;
  /** Descriptive notes. */
  notes?: InputMaybe<Scalars['String']>;
  /** Attachment IDs (Example BOLs). */
  pandaDocumentIds?: InputMaybe<Array<Scalars['ID']>>;
  taggingsAttributes?: InputMaybe<Array<TaggingInput>>;
  /** Destination asset ID. Required. */
  toAssetId?: InputMaybe<Scalars['ID']>;
  /** Transfer 'to' Driver ID. */
  toDriverId?: InputMaybe<Scalars['ID']>;
  /** ID of the destination (Asset, Warehouse). */
  toId?: InputMaybe<Scalars['ID']>;
  /** To(Destination) Type */
  toType?: InputMaybe<TransferTypeEnum>;
  totalizers?: InputMaybe<Array<TotalizerInput>>;
  /** Transfer date time. */
  transferDateTimestamp?: InputMaybe<Scalars['Int']>;
  /** TransferOrderLineItemInput object. */
  transferOrderLineItemsAttributes?: InputMaybe<Array<TransferOrderLineItemInput>>;
};

export type TransferOrderLineItem = {
  __typename?: 'TransferOrderLineItem';
  backofficeId?: Maybe<Scalars['String']>;
  backofficeStatus?: Maybe<Scalars['String']>;
  comparableProduct?: Maybe<Product>;
  data?: Maybe<Scalars['JSON']>;
  fromCompartment?: Maybe<Compartment>;
  fromCompartmentInstances?: Maybe<Array<CompartmentInstance>>;
  id: Scalars['ID'];
  product?: Maybe<Product>;
  productResource?: Maybe<ProductResource>;
  requestedVolume?: Maybe<Scalars['Float']>;
  toCompartment?: Maybe<Compartment>;
  toCompartmentInstances?: Maybe<Array<CompartmentInstance>>;
  transferOrder: TransferOrder;
  volume?: Maybe<Scalars['Float']>;
};

/** TransferOrderLineItem Input */
export type TransferOrderLineItemInput = {
  /** Deprecated. DO NOT USE. */
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** 'From' compartment. */
  fromCompartmentId?: InputMaybe<Scalars['ID']>;
  /** ID of TransferOrderLineItem. Required on update. */
  id?: InputMaybe<Scalars['ID']>;
  /** PandaBoxes transactions. */
  pandaBoxTransactionsAttributes?: InputMaybe<Array<PandaBoxTransactionInput>>;
  /** Product ID. */
  productId?: InputMaybe<Scalars['ID']>;
  productResourceId?: InputMaybe<Scalars['ID']>;
  /** Requested volume information. */
  requestedVolume?: InputMaybe<Scalars['Float']>;
  /** 'To' compartment. */
  toCompartmentId?: InputMaybe<Scalars['ID']>;
  /** Transfer order ID. */
  transferOrderId?: InputMaybe<Scalars['ID']>;
  /** Volume information. */
  volume?: InputMaybe<Scalars['Float']>;
};

export type TransferOrderSorter = {
  field: TransferOrderSorterEnum;
  order?: InputMaybe<FieldOrder>;
};

/** Enum to use on sorter fields when call a query */
export enum TransferOrderSorterEnum {
  Fromasset = 'FROMASSET',
  Fromdriver = 'FROMDRIVER',
  Id = 'ID',
  Toasset = 'TOASSET',
  Todriver = 'TODRIVER'
}

export enum TransferOrderTypeEnum {
  /** From */
  From = 'from',
  /** To */
  To = 'to'
}

/** Polymorphic type for transfer from/to */
export type TransferTarget = Asset | Warehouse;

export enum TransferTypeEnum {
  Asset = 'Asset',
  Warehouse = 'Warehouse'
}

export enum TriggerTypeEnum {
  /** Mobile */
  Mobile = 'mobile',
  /** Web */
  Web = 'web'
}

export type UnassignedInput = {
  orders: Array<OrderInput>;
};

export type Unavailability = {
  __typename?: 'Unavailability';
  day?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  unEndTime?: Maybe<Scalars['String']>;
  unStartTime?: Maybe<Scalars['String']>;
};

/** Resource Schedule Availability Input */
export type UnavailabilityInput = {
  /** Day of the week */
  day?: InputMaybe<Scalars['String']>;
  /** Reason for unavailability */
  reason?: InputMaybe<Scalars['String']>;
  /** End time of unavailability, eg: Seconds value in a day example 3pm = 10800 second */
  unEndTime?: InputMaybe<Scalars['String']>;
  /** Start time of unavailability, eg: Seconds value in a day example 3pm = 10800 second */
  unStartTime?: InputMaybe<Scalars['String']>;
};

export type UnifiedTank = {
  __typename?: 'UnifiedTank';
  adjustmentQuantity?: Maybe<Scalars['Float']>;
  adjustmentUnit?: Maybe<Scalars['String']>;
  autoOrdering?: Maybe<Scalars['Boolean']>;
  avgDailyTemp?: Maybe<Scalars['Float']>;
  avgDailyUsage?: Maybe<Scalars['Float']>;
  category?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Float']>;
  currentDegreeDaySetting?: Maybe<DegreeDaySetting>;
  currentTankLevel?: Maybe<Scalars['Float']>;
  customerBranchAddress?: Maybe<Scalars['String']>;
  customerBranchId?: Maybe<Scalars['Int']>;
  customerId?: Maybe<Scalars['Int']>;
  customerName?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
  daysToEmptyThreshold?: Maybe<Scalars['Int']>;
  degreeDayReset?: Maybe<Scalars['ISO8601Date']>;
  deliveryDate?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  disabledAt?: Maybe<Scalars['ISO8601DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  erpId?: Maybe<Scalars['String']>;
  estTillEmptyDays?: Maybe<Scalars['Float']>;
  estimatedRunOutDate?: Maybe<Scalars['ISO8601DateTime']>;
  gallonsDelivered?: Maybe<Scalars['Float']>;
  hubIds?: Maybe<Array<Scalars['Int']>>;
  hubName?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  kFactor?: Maybe<Scalars['Float']>;
  lastDeliveryDate?: Maybe<Scalars['ISO8601DateTime']>;
  latestDegreeDay?: Maybe<DegreeDay>;
  name?: Maybe<Scalars['String']>;
  orderConfirmation?: Maybe<Scalars['Boolean']>;
  orderNumber?: Maybe<Scalars['String']>;
  orderStatus?: Maybe<Scalars['String']>;
  rorScore?: Maybe<Scalars['Float']>;
  safeLimit?: Maybe<Scalars['Float']>;
  settingCreatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  settingId?: Maybe<Scalars['ID']>;
  settingUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  shiptoName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tankCapacity?: Maybe<Scalars['Int']>;
  tankType?: Maybe<Scalars['String']>;
  tenantId: Scalars['Int'];
  totalDegreeDays?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

export type UnifiedTankCollection = {
  __typename?: 'UnifiedTankCollection';
  collection: Array<UnifiedTank>;
  metadata: DegreeDayMetaDataQuery;
};

export type UnifiedTankFilterInput = {
  assetIds?: InputMaybe<Array<Scalars['ID']>>;
  assetName?: InputMaybe<Scalars['String']>;
  avgDailyTemp?: InputMaybe<RangeFilterInput>;
  avgDailyUsage?: InputMaybe<RangeFilterInput>;
  category?: InputMaybe<Scalars['String']>;
  customerBranchIds?: InputMaybe<Array<Scalars['ID']>>;
  customerIds?: InputMaybe<Array<Scalars['ID']>>;
  customerName?: InputMaybe<Scalars['String']>;
  daysToEmpty?: InputMaybe<RangeFilterInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  hubIds?: InputMaybe<Array<Scalars['ID']>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  kFactor?: InputMaybe<RangeFilterInput>;
  lastDelivery?: InputMaybe<DateRangeFilterInput>;
  lowTankLevel?: InputMaybe<Scalars['Boolean']>;
  orderStatus?: InputMaybe<DegreeDayOrderStatusEnum>;
  orderType?: InputMaybe<DegreeDayOrderSourceEnum>;
  searchString?: InputMaybe<Scalars['String']>;
  shiptoName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tankCapacity?: InputMaybe<RangeFilterInput>;
  tenantId?: InputMaybe<Scalars['ID']>;
  totalDegreeDays?: InputMaybe<RangeFilterInput>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UnifiedTankSorter = {
  field: UnifiedTankSorterEnum;
  order?: InputMaybe<Scalars['String']>;
};

export enum UnifiedTankSorterEnum {
  Customer = 'CUSTOMER',
  /** Sort by last delivery date */
  DeliveryDate = 'DELIVERY_DATE',
  EstDaysToEmpty = 'EST_DAYS_TO_EMPTY',
  Shipto = 'SHIPTO',
  TankName = 'TANK_NAME'
}

export enum UnitEnum {
  /** Buck */
  Buck = 'buck',
  /** Drum */
  Drum = 'drum',
  /** Each */
  Ea = 'ea',
  /** Gal */
  Gal = 'gal',
  /** Gallon */
  Gallon = 'gallon',
  /** Jugs */
  Jugs = 'jugs',
  /** Liter */
  Liter = 'liter',
  /** Milliliter */
  Milliliter = 'milliliter',
  /** Once */
  Ounce = 'ounce',
  /** Pail */
  Pail = 'pail',
  /** Pound */
  Pound = 'pound',
  /** Quart */
  Quart = 'quart',
  /** Tubes */
  Tubes = 'tubes'
}

export type UnknownGroupable = {
  __typename?: 'UnknownGroupable';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UnlinkTankMonitor */
export type UnlinkTankMonitorInput = {
  assetId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  plannedTime: Scalars['Int'];
};

/** Autogenerated return type of UnlinkTankMonitor */
export type UnlinkTankMonitorPayload = {
  __typename?: 'UnlinkTankMonitorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type UnloadOrder = {
  __typename?: 'UnloadOrder';
  id: Scalars['ID'];
  notes?: Maybe<Array<Note>>;
  orderGroup: OrderGroup;
  terminal: Terminal;
  unloadOrderLineItems: Array<UnloadOrderLineItem>;
};

/** Unload Order Input */
export type UnloadOrderInput = {
  /** Unload comment and reason */
  note?: InputMaybe<Scalars['String']>;
  /** Warehouse ID. Required incase of new order. */
  terminalId: Scalars['ID'];
  /** LoadingOrderLineItemInput object. */
  unloadOrderLineItemsAttributes?: InputMaybe<Array<UnloadOrderLineItemInput>>;
};

export type UnloadOrderLineItem = {
  __typename?: 'UnloadOrderLineItem';
  asset: DeliveryAsset;
  assetId: Scalars['ID'];
  id?: Maybe<Scalars['ID']>;
  product: Product;
  productId: Scalars['ID'];
  volume: Scalars['Float'];
};

/** Unload Order Line Item Input */
export type UnloadOrderLineItemInput = {
  /** Delivery Asset ID. */
  assetId: Scalars['ID'];
  /** Product ID. */
  productId: Scalars['ID'];
  volume: Scalars['Float'];
};

/** Update TransferOrder Input */
export type UpdTransferOrderInput = {
  /** Deprecated. DO NOT USE. */
  _destroy?: InputMaybe<Scalars['Boolean']>;
  bolId?: InputMaybe<Scalars['String']>;
  /** Transfer order BOL image documents */
  bolImagesAttributes?: InputMaybe<Array<PandaDocumentInput>>;
  /** Branch/Site ID. */
  customerBranchId?: InputMaybe<Scalars['ID']>;
  fromAssetId?: InputMaybe<Scalars['ID']>;
  /** Transfer 'from' Driver ID. */
  fromDriverId?: InputMaybe<Scalars['ID']>;
  /** ID of the source (Asset, Warehouse). */
  fromId?: InputMaybe<Scalars['ID']>;
  /** From(Source) Type */
  fromType?: InputMaybe<TransferTypeEnum>;
  id: Scalars['ID'];
  /** Descriptive notes. */
  notes?: InputMaybe<Scalars['String']>;
  /** Attachment IDs (Example BOLs). */
  pandaDocumentIds?: InputMaybe<Array<Scalars['ID']>>;
  taggingsAttributes?: InputMaybe<Array<TaggingInput>>;
  toAssetId?: InputMaybe<Scalars['ID']>;
  /** Transfer 'to' Driver ID. */
  toDriverId?: InputMaybe<Scalars['ID']>;
  /** ID of the destination (Asset, Warehouse). */
  toId?: InputMaybe<Scalars['ID']>;
  /** To(Destination) Type */
  toType?: InputMaybe<TransferTypeEnum>;
  totalizers?: InputMaybe<Array<TotalizerInput>>;
  /** Transfer date time. */
  transferDateTimestamp?: InputMaybe<Scalars['Int']>;
  /** TransferOrderLineItemInput object. */
  transferOrderLineItemsAttributes?: InputMaybe<Array<TransferOrderLineItemInput>>;
};

export type Updatable = Driver | User | Worker;

/** Update fee input */
export type UpdateApplicableFeeInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  feeId?: InputMaybe<Scalars['ID']>;
  hardcoded?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  parentFeeId?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Float']>;
  quantity?: InputMaybe<Scalars['Float']>;
  /** Resource ID */
  resourceId?: InputMaybe<Scalars['ID']>;
  /** User ID who is creating or updating the record. */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of UpdateAppliedPricing */
export type UpdateAppliedPricingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateAppliedPricingsInput;
};

/** Autogenerated return type of UpdateAppliedPricing */
export type UpdateAppliedPricingPayload = {
  __typename?: 'UpdateAppliedPricingPayload';
  appliedPricings?: Maybe<Array<AppliedPricing>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  warning?: Maybe<Warning>;
};

/** Update Applied Pricing Input */
export type UpdateAppliedPricingsInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  appliedMarginsAttributes?: InputMaybe<Array<AppliedMarginsInput>>;
  appliedTaxesAttributes?: InputMaybe<Array<AppliedTaxesInput>>;
  id: Scalars['ID'];
  isManuallyUpdated?: InputMaybe<Scalars['Boolean']>;
  mobileOffline?: InputMaybe<Scalars['Boolean']>;
  orderGroupId?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Float']>;
  sumTotal?: InputMaybe<Scalars['Float']>;
  total?: InputMaybe<Scalars['Float']>;
  updateActDriverId?: InputMaybe<Scalars['Int']>;
};

/** Update asset input */
export type UpdateAssetInput = {
  approvalStatus?: InputMaybe<AssetApprovalStatusEnum>;
  /** Use this for multiple locations. */
  assetMovementLocationsAttributes?: InputMaybe<Array<AssetMovementLocationInput>>;
  assetProductCategoriesAttributes?: InputMaybe<Array<NestedAssetProductCategoryInput>>;
  assetsPeripheralsAttributes?: InputMaybe<Array<AssetsPeripheralInput>>;
  bulkAssetFeature?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<AssetCategoryEnum>;
  color?: InputMaybe<Scalars['String']>;
  compartmentsAttributes?: InputMaybe<Array<NestedCompartmentInput>>;
  completeMovementOrder?: InputMaybe<Scalars['Boolean']>;
  costOfTank?: InputMaybe<Scalars['Float']>;
  customerBranchId?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  enableZone?: InputMaybe<Scalars['Boolean']>;
  erpId?: InputMaybe<Scalars['String']>;
  estimatedGallonsPerMonth?: InputMaybe<Scalars['Float']>;
  /** Send form_type in CamelCase example: rental asset would be RentalAsset */
  formType?: InputMaybe<Scalars['String']>;
  fuelCategories?: InputMaybe<Array<Scalars['String']>>;
  hubId?: InputMaybe<Scalars['ID']>;
  hubResourcesAttributes?: InputMaybe<Array<HubResourceInput>>;
  id: Scalars['ID'];
  installDate?: InputMaybe<Scalars['ISO8601Date']>;
  isRunningFuelOffsetAsset?: InputMaybe<Scalars['Boolean']>;
  isTransport?: InputMaybe<Scalars['Boolean']>;
  lat?: InputMaybe<Scalars['String']>;
  licensePlateNumber?: InputMaybe<Scalars['String']>;
  lineOfServiceIds?: InputMaybe<Array<Scalars['ID']>>;
  lng?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  margin?: InputMaybe<Scalars['Float']>;
  marketValue?: InputMaybe<Scalars['Float']>;
  model?: InputMaybe<Scalars['String']>;
  movementOrderIds?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  noOfZone?: InputMaybe<Scalars['Int']>;
  pandaBoxAttributes?: InputMaybe<PandaBoxInput>;
  pandaBoxId?: InputMaybe<Scalars['ID']>;
  pandaDocuments?: InputMaybe<Array<NestedPandaDocumentsInput>>;
  purchasedOn?: InputMaybe<Scalars['ISO8601DateTime']>;
  rfidCode?: InputMaybe<Scalars['String']>;
  routingVehicleType?: InputMaybe<AssetRoutingVehicleTypesEnum>;
  sites?: InputMaybe<Array<SiteInput>>;
  status?: InputMaybe<AssetStatusEnum>;
  subscriptionsAttributes?: InputMaybe<Array<NestedSubscriptionsInput>>;
  taggingsAttributes?: InputMaybe<Array<TaggingInput>>;
  tankSize?: InputMaybe<Scalars['String']>;
  tankType?: InputMaybe<Scalars['String']>;
  terminals?: InputMaybe<Array<NestedTerminalInput>>;
  trackInventory?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  unassignPandaBox?: InputMaybe<Scalars['Boolean']>;
  useInDelivery?: InputMaybe<Scalars['Boolean']>;
  vin?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of UpdateAssets */
export type UpdateAssetsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateAssetInput;
};

/** Autogenerated return type of UpdateAssets */
export type UpdateAssetsPayload = {
  __typename?: 'UpdateAssetsPayload';
  asset?: Maybe<Asset>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateAttachedAsset */
export type UpdateAttachedAssetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateAttachedAssetsInput;
};

/** Autogenerated return type of UpdateAttachedAsset */
export type UpdateAttachedAssetPayload = {
  __typename?: 'UpdateAttachedAssetPayload';
  attachedAsset?: Maybe<AttachedAsset>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Tank Monitor attached assets input */
export type UpdateAttachedAssetsInput = {
  assetId?: InputMaybe<Scalars['String']>;
  assetTankCapacity?: InputMaybe<Scalars['Float']>;
  autoOrder?: InputMaybe<Scalars['Boolean']>;
  consumptionCalculationDays?: InputMaybe<Scalars['Int']>;
  detachedAt?: InputMaybe<Scalars['String']>;
  draftAssetId?: InputMaybe<Scalars['ID']>;
  gracePeriod?: InputMaybe<Scalars['Int']>;
  gracePeriodType?: InputMaybe<Scalars['String']>;
  hubIds?: InputMaybe<Array<Scalars['ID']>>;
  id: Scalars['ID'];
  maxThreshold?: InputMaybe<Scalars['Float']>;
  minThreshold?: InputMaybe<Scalars['Float']>;
  orderConfirmation?: InputMaybe<Scalars['Boolean']>;
  orderFillPercentage?: InputMaybe<Scalars['Float']>;
  /** Type of order for the attached asset */
  orderType?: InputMaybe<TmOrderTypeEnum>;
  /** Preference availability for the attached asset */
  preferenceAvailability?: InputMaybe<Array<PreferenceAvailabilityInput>>;
  purchaseOrder?: InputMaybe<Scalars['Boolean']>;
  refuelTanksThreshold?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  topOffBy?: InputMaybe<TopOffByEnum>;
  topOffQuantity?: InputMaybe<Scalars['Float']>;
};

/** Autogenerated input type of UpdateBolPricing */
export type UpdateBolPricingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: BolPricingsUpdateBolPricingInput;
};

/** Autogenerated return type of UpdateBolPricing */
export type UpdateBolPricingPayload = {
  __typename?: 'UpdateBolPricingPayload';
  bolPricing?: Maybe<BolPricing>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Update Brand input */
export type UpdateBrandInput = {
  brandType?: InputMaybe<BrandTypeEnum>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateBrands */
export type UpdateBrandsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateBrandInput;
};

/** Autogenerated return type of UpdateBrands */
export type UpdateBrandsPayload = {
  __typename?: 'UpdateBrandsPayload';
  brand?: Maybe<Brand>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateCardLockTransaction */
export type UpdateCardLockTransactionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CardLockTransactionInput;
};

/** Autogenerated return type of UpdateCardLockTransaction */
export type UpdateCardLockTransactionPayload = {
  __typename?: 'UpdateCardLockTransactionPayload';
  cardLockTransaction?: Maybe<CardLockTransaction>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateCcTenantInput = {
  address?: InputMaybe<Scalars['String']>;
  erpId: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  secondaryEmails?: InputMaybe<Array<Scalars['String']>>;
  siteAttributes?: InputMaybe<SiteInput>;
};

/** Autogenerated input type of UpdateCommonCarrier */
export type UpdateCommonCarrierInput = {
  ccTenantAttributes: UpdateCcTenantInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateCommonCarrier */
export type UpdateCommonCarrierPayload = {
  __typename?: 'UpdateCommonCarrierPayload';
  ccTenant?: Maybe<CcTenant>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of UpdateCrudePricing */
export type UpdateCrudePricingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateCrudePricingsInput;
};

/** Autogenerated return type of UpdateCrudePricing */
export type UpdateCrudePricingPayload = {
  __typename?: 'UpdateCrudePricingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  crudePricing?: Maybe<CrudePricing>;
};

/** update Rate Type input */
export type UpdateCrudePricingsInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  crudePricableId?: InputMaybe<Scalars['ID']>;
  crudePricableType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  pandaPriceRateTypeId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  range?: InputMaybe<Array<RangeInput>>;
};

/** Update ShipTos input */
export type UpdateCustomerBranchInput = {
  addressBooksAttributes?: InputMaybe<Array<AddressBookInput>>;
  applicableFeesAttributes?: InputMaybe<Array<UpdateApplicableFeeInput>>;
  attachBolOnDeliveryTicket?: InputMaybe<Scalars['Boolean']>;
  autoEmailDeliveryTicket?: InputMaybe<Scalars['Boolean']>;
  cardLockSiteNumber?: InputMaybe<Scalars['String']>;
  crudePricingsAttributes?: InputMaybe<Array<UpdateCrudePricingsInput>>;
  deliveryInstruction?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  hubResourcesAttributes?: InputMaybe<Array<HubResourceInput>>;
  id: Scalars['ID'];
  isCustomerSignatureRequired?: InputMaybe<Scalars['Boolean']>;
  isHub?: InputMaybe<Scalars['Boolean']>;
  lineOfServiceIds?: InputMaybe<Array<Scalars['ID']>>;
  loadingAccountIds?: InputMaybe<Array<Scalars['ID']>>;
  marketResourcesAttributes?: InputMaybe<Array<MarketResourceInput>>;
  name?: InputMaybe<Scalars['String']>;
  onlyShowGrossGallonsInDeliveryTicket?: InputMaybe<Scalars['Boolean']>;
  pandaDocuments?: InputMaybe<Array<DirectAttachmentInput>>;
  pickupPointCodeIds?: InputMaybe<Array<Scalars['ID']>>;
  poNumber?: InputMaybe<Scalars['String']>;
  preferredProductTerminalsAttributes?: InputMaybe<Array<PreferredProductTerminalInput>>;
  priceCode?: InputMaybe<Scalars['String']>;
  purchaseOrder?: InputMaybe<Scalars['Boolean']>;
  purchaseOrderType?: InputMaybe<PurchaseOrderTypeEnum>;
  qboItemizeLineItemOnSalesOrder?: InputMaybe<Scalars['Boolean']>;
  siteAttributes?: InputMaybe<SiteInput>;
  status?: InputMaybe<Scalars['Boolean']>;
  supplierIds?: InputMaybe<Array<Scalars['ID']>>;
  syncSalesToD1?: InputMaybe<Scalars['Boolean']>;
  taggingsAttributes?: InputMaybe<Array<TaggingInput>>;
  terminalDriverRates?: InputMaybe<Scalars['JSON']>;
};

/** Autogenerated input type of UpdateCustomerBranches */
export type UpdateCustomerBranchesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateCustomerBranchInput;
};

/** Autogenerated return type of UpdateCustomerBranches */
export type UpdateCustomerBranchesPayload = {
  __typename?: 'UpdateCustomerBranchesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customerBranch?: Maybe<CustomerBranch>;
};

/** Update customer input */
export type UpdateCustomerInput = {
  accountId?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  addressBooksAttributes?: InputMaybe<Array<AddressBookInput>>;
  agreedLoadGallon?: InputMaybe<Scalars['Int']>;
  applicableFeesAttributes?: InputMaybe<Array<UpdateApplicableFeeInput>>;
  arDivisionNumber?: InputMaybe<Scalars['String']>;
  attachPostDeliveryImageOnDeliveryTicket?: InputMaybe<Scalars['Boolean']>;
  canManagePortalAssets?: InputMaybe<Scalars['Boolean']>;
  canManagePortalScheduleReports?: InputMaybe<Scalars['Boolean']>;
  canManagePortalSettings?: InputMaybe<Scalars['Boolean']>;
  canManagePortalShipTos?: InputMaybe<Scalars['Boolean']>;
  creditChecked?: InputMaybe<Scalars['Boolean']>;
  creditLimit?: InputMaybe<Scalars['String']>;
  creditLimitDaysOverdueBuffer?: InputMaybe<Scalars['String']>;
  creditLimitPercentageBuffer?: InputMaybe<Scalars['String']>;
  crudePricingsAttributes?: InputMaybe<Array<UpdateCrudePricingsInput>>;
  currentBalance?: InputMaybe<Scalars['String']>;
  customerBranchesAttributes?: InputMaybe<Array<NestedCustomerBranchInput>>;
  customerSegmentId?: InputMaybe<Scalars['ID']>;
  daysOverdue?: InputMaybe<Scalars['String']>;
  deliveryInstruction?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  enableCreateDeliveryOrder?: InputMaybe<Scalars['Boolean']>;
  epaId?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  exemptStatus?: InputMaybe<Array<ExemptStatusTypeEnum>>;
  fees?: InputMaybe<Array<NestedFeeInput>>;
  feinNumber?: InputMaybe<Scalars['String']>;
  fleetCardNumbers?: InputMaybe<Array<Scalars['String']>>;
  hideVendorPricing?: InputMaybe<Scalars['Boolean']>;
  hubResourcesAttributes?: InputMaybe<Array<HubResourceInput>>;
  id: Scalars['ID'];
  isTenant?: InputMaybe<Scalars['Boolean']>;
  lineOfServiceIds?: InputMaybe<Array<Scalars['ID']>>;
  marketResourcesAttributes?: InputMaybe<Array<MarketResourceInput>>;
  name?: InputMaybe<Scalars['String']>;
  originalCustomerId?: InputMaybe<Scalars['String']>;
  paymentTermId?: InputMaybe<Scalars['ID']>;
  paymentTypeName?: InputMaybe<PaymentTypeEnum>;
  permitNumber?: InputMaybe<Scalars['String']>;
  poBoxNumber?: InputMaybe<Scalars['String']>;
  poNumber?: InputMaybe<Scalars['String']>;
  portalAccessLevel?: InputMaybe<PortalAccessLevelEnum>;
  preferredDrivers?: InputMaybe<Array<NestedDriverInput>>;
  preferredProductTerminalsAttributes?: InputMaybe<Array<PreferredProductTerminalInput>>;
  productPurchaseLimitId?: InputMaybe<Scalars['ID']>;
  purchaseOrder?: InputMaybe<Scalars['Boolean']>;
  purchaseOrderType?: InputMaybe<PurchaseOrderTypeEnum>;
  quickbridgeId?: InputMaybe<Scalars['String']>;
  siteAttributes?: InputMaybe<SiteInput>;
  status?: InputMaybe<StatusEnum>;
  taggingsAttributes?: InputMaybe<Array<TaggingInput>>;
  tankReadingMaxThreshold?: InputMaybe<Scalars['Float']>;
  tankReadingThreshold?: InputMaybe<Scalars['Float']>;
  thirdPartyDelivery?: InputMaybe<Scalars['Boolean']>;
  updateAllThreshold?: InputMaybe<Scalars['Boolean']>;
  usersAttributes?: InputMaybe<Array<NestedUserInput>>;
  vendorErpId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateCustomerPreferences */
export type UpdateCustomerPreferencesInput = {
  addressBook: AddressBookInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateCustomerPreferences */
export type UpdateCustomerPreferencesPayload = {
  __typename?: 'UpdateCustomerPreferencesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customer?: Maybe<Customer>;
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateCustomerReport */
export type UpdateCustomerReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CustomerReportInput;
};

/** Autogenerated input type of UpdateCustomerSegments */
export type UpdateCustomerSegmentsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: CustomerSegmentInput;
};

/** Autogenerated return type of UpdateCustomerSegments */
export type UpdateCustomerSegmentsPayload = {
  __typename?: 'UpdateCustomerSegmentsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customerSegment?: Maybe<CustomerSegment>;
};

/** Update customer user input */
export type UpdateCustomerUserInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  customerBranchId?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
  hubResourcesAttributes?: InputMaybe<Array<HubResourceInput>>;
  id: Scalars['ID'];
  lineOfServiceIds?: InputMaybe<Array<Scalars['ID']>>;
  userAttributes?: InputMaybe<NestedUserAttributesInput>;
};

/** Autogenerated input type of UpdateCustomerUsers */
export type UpdateCustomerUsersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateCustomerUserInput;
};

/** Autogenerated return type of UpdateCustomerUsers */
export type UpdateCustomerUsersPayload = {
  __typename?: 'UpdateCustomerUsersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customerUser?: Maybe<CustomerUser>;
};

/** Autogenerated input type of UpdateCustomers */
export type UpdateCustomersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateCustomerInput;
};

/** Autogenerated return type of UpdateCustomers */
export type UpdateCustomersPayload = {
  __typename?: 'UpdateCustomersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customer?: Maybe<Customer>;
};

/** Autogenerated return type of UpdateDegreeDaySetting */
export type UpdateDegreeDaySettingPayload = {
  __typename?: 'UpdateDegreeDaySettingPayload';
  degreeDaySettings?: Maybe<Array<DegreeDaySetting>>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of UpdateDeliveryOrder */
export type UpdateDeliveryOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryOrderAttributes?: InputMaybe<DeliveryOrderInput>;
  fromCustomerPortal?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated input type of UpdateDeliveryOrderLineItem */
export type UpdateDeliveryOrderLineItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  comparableProductId?: InputMaybe<Scalars['ID']>;
  data?: InputMaybe<Scalars['JSON']>;
  id: Scalars['ID'];
  lat?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['String']>;
  /** Name of LCR meter */
  meterName?: InputMaybe<Scalars['String']>;
  mobileGeneratedId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  /** Panda Box transactions */
  pandaBoxTransactionsAttributes?: InputMaybe<Array<PandaBoxTransactionInput>>;
  productId?: InputMaybe<Scalars['ID']>;
  productResourceId?: InputMaybe<Scalars['ID']>;
  skipReason?: InputMaybe<Scalars['String']>;
  source: Scalars['String'];
  sourceAssetsAttributes?: InputMaybe<Array<SourceAssetInput>>;
  sourceCompartmentInstanceAttributes?: InputMaybe<Array<CompartmentInstanceInput>>;
  status: Scalars['String'];
  targetCompartmentInstanceAttributes?: InputMaybe<CompartmentInstanceInput>;
  /** Fuel test result */
  testResult?: InputMaybe<ProductTestEnum>;
  volume?: InputMaybe<Scalars['Float']>;
  waterTestResult?: InputMaybe<WaterTestResultEnum>;
};

/** Autogenerated return type of UpdateDeliveryOrderLineItem */
export type UpdateDeliveryOrderLineItemPayload = {
  __typename?: 'UpdateDeliveryOrderLineItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deliveryOrderLineItem?: Maybe<DeliveryOrderLineItem>;
};

/** Autogenerated return type of UpdateDeliveryOrder */
export type UpdateDeliveryOrderPayload = {
  __typename?: 'UpdateDeliveryOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deliveryOrder?: Maybe<DeliveryOrder>;
};

export type UpdateDemurrageInput = {
  customerId: Scalars['ID'];
  id: Scalars['ID'];
  offsetAmount: Scalars['Float'];
  offsetRate: Scalars['Float'];
  offsetType: OffsetTypeEnum;
  rangeAttribute?: InputMaybe<Array<RangeAttributeInput>>;
};

/** Autogenerated input type of UpdateDriverDemurrage */
export type UpdateDriverDemurrageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateDemurrageInput;
};

/** Autogenerated return type of UpdateDriverDemurrage */
export type UpdateDriverDemurragePayload = {
  __typename?: 'UpdateDriverDemurragePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  driverDemurrage?: Maybe<DriverDemurrage>;
};

/** Update driver input */
export type UpdateDriverInput = {
  contractSignDate?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  homeAddress?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hubResourcesAttributes?: InputMaybe<Array<HubResourceInput>>;
  id: Scalars['ID'];
  imageSignedBlobId?: InputMaybe<Scalars['ID']>;
  licenceExpiryDate?: InputMaybe<Scalars['String']>;
  lineOfServiceIds?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  paymentStrategy?: InputMaybe<Scalars['String']>;
  phoneNumbersAttributes?: InputMaybe<Array<NestedPhoneInput>>;
  reasonForLeaving?: InputMaybe<Scalars['String']>;
  s3BackgroundCheckBlobId?: InputMaybe<Scalars['ID']>;
  s3DriverApplicationBlobId?: InputMaybe<Scalars['ID']>;
  s3H6BlobId?: InputMaybe<Scalars['ID']>;
  s3Licenses?: InputMaybe<Array<LicenseInput>>;
  startDate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  weeklySchedulesAttributes?: InputMaybe<Array<NestedWeekScheduleInput>>;
};

/** Autogenerated input type of UpdateDriverShift */
export type UpdateDriverShiftInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Shift input type. */
  shiftAttributes?: InputMaybe<ShiftCreateInput>;
};

/** Autogenerated return type of UpdateDriverShift */
export type UpdateDriverShiftPayload = {
  __typename?: 'UpdateDriverShiftPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Shift type. */
  shift?: Maybe<Shift>;
};

/** Autogenerated input type of UpdateDrivers */
export type UpdateDriversInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateDriverInput;
};

/** Autogenerated return type of UpdateDrivers */
export type UpdateDriversPayload = {
  __typename?: 'UpdateDriversPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  driver?: Maybe<Driver>;
};

/** Update fee input */
export type UpdateFeeInput = {
  applicableType?: InputMaybe<ApplicableTypeEnum>;
  applyAsOnFee?: InputMaybe<ApplyAsOnFeeEnum>;
  baseFeeId?: InputMaybe<Scalars['ID']>;
  calculatedAsOnFee?: InputMaybe<CalculatedAsOnFeeEnum>;
  code?: InputMaybe<Scalars['String']>;
  defaultMovementFee?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  feeProductCategoriesAttributes?: InputMaybe<Array<FeeProductCategoryInput>>;
  feeType?: InputMaybe<FeeTypeEnum>;
  glCode?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lineOfServiceIds?: InputMaybe<Array<Scalars['ID']>>;
  lineOfServiceRecordsAttributes?: InputMaybe<Array<NestedLineOfServiceRecord>>;
  name?: InputMaybe<Scalars['String']>;
  nsManualVolume?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Float']>;
  offsetRate?: InputMaybe<Scalars['Float']>;
  parentFeeId?: InputMaybe<Scalars['ID']>;
  percentOnFee?: InputMaybe<Scalars['Float']>;
  price?: InputMaybe<Scalars['Float']>;
  productCategoryId?: InputMaybe<Scalars['ID']>;
  rangeAttribute?: InputMaybe<Array<RangeAttributeInput>>;
  rangeCalculatedAsOnFee?: InputMaybe<CalculatedAsOnFeeEnum>;
  rangeTypeOnFee?: InputMaybe<RangeTypeOnFeeEnum>;
  rateOnFee?: InputMaybe<Scalars['Float']>;
  rateUnitOnFee?: InputMaybe<RateUnitOnFeeEnum>;
  roundUpQuantity?: InputMaybe<Scalars['Boolean']>;
  surchargeId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of UpdateFees */
export type UpdateFeesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateFeeInput;
};

/** Autogenerated return type of UpdateFees */
export type UpdateFeesPayload = {
  __typename?: 'UpdateFeesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  fee?: Maybe<Fee>;
};

/** Autogenerated input type of UpdateGroup */
export type UpdateGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateGroupsInput;
};

/** Autogenerated return type of UpdateGroup */
export type UpdateGroupPayload = {
  __typename?: 'UpdateGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  group?: Maybe<Group>;
};

/** Update group Input */
export type UpdateGroupsInput = {
  groupMembershipsAttributes?: InputMaybe<Array<NestedGroupMembershipInput>>;
  id: Scalars['ID'];
  /** Name of Group; letter, number, underscore and hypen are only accepted */
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateInvoice */
export type UpdateInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: InvoiceInput;
};

/** Autogenerated return type of UpdateInvoice */
export type UpdateInvoicePayload = {
  __typename?: 'UpdateInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  invoice?: Maybe<Invoice>;
  reverseInvoice?: Maybe<Invoice>;
  warning?: Maybe<Warning>;
};

/** Autogenerated input type of UpdateLeaCore */
export type UpdateLeaCoreInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  leaCoreAttributes: LeaCoreInput;
};

/** Autogenerated return type of UpdateLeaCore */
export type UpdateLeaCorePayload = {
  __typename?: 'UpdateLeaCorePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  leaType: Lea;
};

/** Autogenerated input type of UpdateLeaDocument */
export type UpdateLeaDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  leaCoreDocumentAttributes: LeaCoreDocumentInput;
};

/** Autogenerated return type of UpdateLeaDocument */
export type UpdateLeaDocumentPayload = {
  __typename?: 'UpdateLeaDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  pandaDocument?: Maybe<PandaDocument>;
};

/** Default line of service Input */
export type UpdateLineOfServiceInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  erpId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ID']>;
  shortName?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateLineOfServices */
export type UpdateLineOfServicesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateLineOfServiceInput;
};

/** Autogenerated return type of UpdateLineOfServices */
export type UpdateLineOfServicesPayload = {
  __typename?: 'UpdateLineOfServicesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lineOfService?: Maybe<LineOfService>;
};

/** Default loading Account Input */
export type UpdateLoadingAccountInput = {
  carrierCustomerCode?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  destinationState?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  loadingAccountTerminalProductsAttributes?: InputMaybe<Array<NestedLoadingAccountTerminalProductInput>>;
  loadingNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  supplierCode?: InputMaybe<Scalars['String']>;
  supplierId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of UpdateLoadingAccounts */
export type UpdateLoadingAccountsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateLoadingAccountInput;
};

/** Autogenerated return type of UpdateLoadingAccounts */
export type UpdateLoadingAccountsPayload = {
  __typename?: 'UpdateLoadingAccountsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  loadingAccount?: Maybe<LoadingAccount>;
};

/** Autogenerated input type of UpdateLoadingOrder */
export type UpdateLoadingOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  loadingOrderAttributes?: InputMaybe<LoadingOrderInput>;
};

/** Autogenerated input type of UpdateLoadingOrderLineItem */
export type UpdateLoadingOrderLineItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  lineItemParams?: InputMaybe<LoadingOrderLineItemInput>;
};

/** Autogenerated return type of UpdateLoadingOrderLineItem */
export type UpdateLoadingOrderLineItemPayload = {
  __typename?: 'UpdateLoadingOrderLineItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  loadingOrderLineItem?: Maybe<LoadingOrderLineItem>;
};

/** Autogenerated return type of UpdateLoadingOrder */
export type UpdateLoadingOrderPayload = {
  __typename?: 'UpdateLoadingOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  loadingOrder?: Maybe<LoadingOrder>;
};

/** Autogenerated input type of UpdateMargin */
export type UpdateMarginInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateMarginsInput;
};

/** Autogenerated return type of UpdateMargin */
export type UpdateMarginPayload = {
  __typename?: 'UpdateMarginPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  margin?: Maybe<Margin>;
};

/** Update Margin Input */
export type UpdateMarginsInput = {
  id: Scalars['ID'];
  marginRate?: InputMaybe<Scalars['Float']>;
  marginType: MarginTypeEnum;
  marginUnit?: InputMaybe<RateUnitEnum>;
  name: Scalars['String'];
  range?: InputMaybe<Array<MarginRangeAttributeInput>>;
};

/** Input object for updating margins products */
export type UpdateMarginsProductsInput = {
  /** Flag to destroy the record */
  _destroy?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the margins product */
  id?: InputMaybe<Scalars['ID']>;
  /** The margin value for the product */
  marginId: Scalars['ID'];
  /** The ID of the product */
  productId: Scalars['ID'];
  /** The ID of the resource pricing */
  resourcePricingId?: InputMaybe<Scalars['ID']>;
};

/** Update market input */
export type UpdateMarketInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  hubResourcesAttributes?: InputMaybe<Array<HubResourceInput>>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateMarkets */
export type UpdateMarketsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateMarketInput;
};

/** Autogenerated return type of UpdateMarkets */
export type UpdateMarketsPayload = {
  __typename?: 'UpdateMarketsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  market?: Maybe<Market>;
};

/** Autogenerated input type of UpdateMovementOrder */
export type UpdateMovementOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  movementOrderAttributes?: InputMaybe<MovementOrderInput>;
};

/** Autogenerated return type of UpdateMovementOrder */
export type UpdateMovementOrderPayload = {
  __typename?: 'UpdateMovementOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  movementOrder?: Maybe<MovementOrder>;
};

/** Autogenerated input type of UpdateNote */
export type UpdateNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  showInDeliveryTicket?: InputMaybe<Scalars['Boolean']>;
  showInInvoice?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of UpdateNote */
export type UpdateNotePayload = {
  __typename?: 'UpdateNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  note?: Maybe<Note>;
};

/** Autogenerated input type of UpdateNotificationTemplateStatus */
export type UpdateNotificationTemplateStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  status: Scalars['String'];
};

/** Autogenerated return type of UpdateNotificationTemplateStatus */
export type UpdateNotificationTemplateStatusPayload = {
  __typename?: 'UpdateNotificationTemplateStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  notificationTemplate?: Maybe<NotificationTemplate>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Update Order-Group-Fee input */
export type UpdateOrderGroupFeeInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  feeId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  isManuallyUpdated?: InputMaybe<Scalars['Boolean']>;
  price?: InputMaybe<Scalars['Float']>;
  quantity?: InputMaybe<Scalars['Float']>;
};

/** Autogenerated input type of UpdateOrderGroupMutation */
export type UpdateOrderGroupMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['ID']>;
  fromCustomerPortal?: InputMaybe<Scalars['Boolean']>;
  orderGroupAttributes?: InputMaybe<OrderGroupInput>;
};

/** Autogenerated return type of UpdateOrderGroupMutation */
export type UpdateOrderGroupMutationPayload = {
  __typename?: 'UpdateOrderGroupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderGroup?: Maybe<OrderGroup>;
};

/** Autogenerated input type of UpdateOrderLink */
export type UpdateOrderLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateOrderLinksInput;
};

/** Autogenerated return type of UpdateOrderLink */
export type UpdateOrderLinkPayload = {
  __typename?: 'UpdateOrderLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderLink?: Maybe<OrderLink>;
};

/** Update order link Input */
export type UpdateOrderLinksInput = {
  deliveryOrderId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  loadingOrderId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of UpdateOrderWorkerDate */
export type UpdateOrderWorkerDateInput = {
  bulkUpdateAttributes: BulkUpdateAttributesInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateOrderWorkerDate */
export type UpdateOrderWorkerDatePayload = {
  __typename?: 'UpdateOrderWorkerDatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  result?: Maybe<BulkAssign>;
};

/** Autogenerated input type of UpdatePaymentTerms */
export type UpdatePaymentTermsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: PaymentTermInput;
};

/** Autogenerated return type of UpdatePaymentTerms */
export type UpdatePaymentTermsPayload = {
  __typename?: 'UpdatePaymentTermsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  paymentTerm?: Maybe<PaymentTerm>;
};

/** Autogenerated input type of UpdatePeripheral */
export type UpdatePeripheralInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: PeripheralInput;
};

/** Autogenerated return type of UpdatePeripheral */
export type UpdatePeripheralPayload = {
  __typename?: 'UpdatePeripheralPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  peripheral?: Maybe<Peripheral>;
};

/** Update Pickup Point Code input */
export type UpdatePickupPointCodeInput = {
  code?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  loadingAccountId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  terminalsSupplierId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of UpdatePickupPointCodes */
export type UpdatePickupPointCodesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdatePickupPointCodeInput;
};

/** Autogenerated return type of UpdatePickupPointCodes */
export type UpdatePickupPointCodesPayload = {
  __typename?: 'UpdatePickupPointCodesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  pickupPointCode?: Maybe<PickupPointCode>;
};

/** Autogenerated input type of UpdatePoc */
export type UpdatePocInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  userId: Scalars['ID'];
};

/** Autogenerated return type of UpdatePoc */
export type UpdatePocPayload = {
  __typename?: 'UpdatePocPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  poc?: Maybe<User>;
};

/** Autogenerated input type of UpdatePostDeliveryPhoto */
export type UpdatePostDeliveryPhotoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  showInDeliveryTicket: Scalars['Boolean'];
};

/** Autogenerated return type of UpdatePostDeliveryPhoto */
export type UpdatePostDeliveryPhotoPayload = {
  __typename?: 'UpdatePostDeliveryPhotoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  pandaDocument?: Maybe<PandaDocument>;
};

/** Autogenerated input type of UpdatePricing */
export type UpdatePricingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdatePricingsInput;
};

/** Autogenerated return type of UpdatePricing */
export type UpdatePricingPayload = {
  __typename?: 'UpdatePricingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  response?: Maybe<DeletePricingResponse>;
};

/** Update Rate Type input */
export type UpdatePricingsInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  customerBranchId?: InputMaybe<Scalars['ID']>;
  effectiveEndDate?: InputMaybe<Scalars['Int']>;
  effectiveStartDate?: InputMaybe<Scalars['Int']>;
  expirationDatetime?: InputMaybe<Scalars['Int']>;
  freight?: InputMaybe<Scalars['Float']>;
  hubId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  isTemporary?: InputMaybe<Scalars['Boolean']>;
  marketId?: InputMaybe<Scalars['ID']>;
  markup?: InputMaybe<Scalars['Float']>;
  price?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['ID']>;
  supplierId?: InputMaybe<Scalars['ID']>;
  taxes?: InputMaybe<Scalars['Float']>;
  terminalId?: InputMaybe<Scalars['ID']>;
  totalPrice?: InputMaybe<Scalars['Float']>;
  ttlDurationSeconds?: InputMaybe<Scalars['Int']>;
};

/** Update product input */
export type UpdateProductInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  allowTopUp?: InputMaybe<Scalars['Boolean']>;
  barcode?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Scalars['ID']>;
  code?: InputMaybe<Scalars['String']>;
  deliveryType?: InputMaybe<ProductDeliveryTypeEnum>;
  erpId?: InputMaybe<Scalars['String']>;
  flowRate?: InputMaybe<Scalars['Int']>;
  /** Only the last 2 digit of gl mapping e.g. for Heating Oil 3010 set 10 */
  glNumber?: InputMaybe<Scalars['String']>;
  hubResourceAttributes?: InputMaybe<HubResourceInput>;
  id: Scalars['ID'];
  ignoreNsPush?: InputMaybe<Scalars['Boolean']>;
  legalDescription?: InputMaybe<Scalars['String']>;
  lineOfServiceIds?: InputMaybe<Array<Scalars['ID']>>;
  longDescription?: InputMaybe<Scalars['String']>;
  phoenixNumber?: InputMaybe<Scalars['String']>;
  productCategoryId?: InputMaybe<Scalars['ID']>;
  productConstituentsAttributes?: InputMaybe<Array<NestedProductConstituentsInput>>;
  productResourcesAttributes?: InputMaybe<Array<NestedProductResourceInput>>;
  productSubCategoryId?: InputMaybe<Scalars['ID']>;
  productType?: InputMaybe<ProductTypeEnum>;
  qrCode?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
  soldAs?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<UnitEnum>;
};

/** Update Product Purchase Limits input */
export type UpdateProductPurchaseLimitInput = {
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  productId: Scalars['Int'];
  timeUnit?: InputMaybe<TimeUnitEnum>;
  volume: Scalars['Int'];
};

/** Autogenerated input type of UpdateProductPurchaseLimits */
export type UpdateProductPurchaseLimitsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateProductPurchaseLimitInput;
};

/** Autogenerated return type of UpdateProductPurchaseLimits */
export type UpdateProductPurchaseLimitsPayload = {
  __typename?: 'UpdateProductPurchaseLimitsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  productPurchaseLimit?: Maybe<ProductPurchaseLimit>;
};

/** Autogenerated input type of UpdateProducts */
export type UpdateProductsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateProductInput;
};

/** Autogenerated return type of UpdateProducts */
export type UpdateProductsPayload = {
  __typename?: 'UpdateProductsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
};

/** Autogenerated input type of UpdateRackMarket */
export type UpdateRackMarketInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  hubResourcesAttributes?: InputMaybe<Array<HubResourceInput>>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateRackMarket */
export type UpdateRackMarketPayload = {
  __typename?: 'UpdateRackMarketPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  rackMarket?: Maybe<RackMarket>;
};

/** Autogenerated input type of UpdateRate */
export type UpdateRateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateRateTypeInput;
};

/** Autogenerated return type of UpdateRate */
export type UpdateRatePayload = {
  __typename?: 'UpdateRatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  rateType?: Maybe<RateType>;
};

/** Update Rate Type input */
export type UpdateRateTypeInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isTemporaryRateType?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  status?: InputMaybe<RateTypeStatusEnum>;
};

/** Autogenerated input type of UpdateRawPricingImportSession */
export type UpdateRawPricingImportSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateRawPricingImportSession */
export type UpdateRawPricingImportSessionPayload = {
  __typename?: 'UpdateRawPricingImportSessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  rawPricingImportSession: RawPricingImportSession;
};

/** Autogenerated input type of UpdateRawShift */
export type UpdateRawShiftInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Raw Shift input type. */
  rawShiftAttributes?: InputMaybe<RawShiftCreateInput>;
};

/** Autogenerated return type of UpdateRawShift */
export type UpdateRawShiftPayload = {
  __typename?: 'UpdateRawShiftPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Raw Shift type. */
  rawShift?: Maybe<RawShift>;
};

/** Autogenerated input type of UpdateResource */
export type UpdateResourceInput = {
  attributes: Array<ResourceUpdateInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  resource: ResourceUpdateEnum;
};

/** Autogenerated return type of UpdateResource */
export type UpdateResourcePayload = {
  __typename?: 'UpdateResourcePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  records?: Maybe<Array<ResourceUpdatable>>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of UpdateResourcePricing */
export type UpdateResourcePricingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateResourcePricingsInput;
};

/** Autogenerated return type of UpdateResourcePricing */
export type UpdateResourcePricingPayload = {
  __typename?: 'UpdateResourcePricingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  resourcePricing?: Maybe<ResourcePricing>;
};

/** Update Resource Pricings Input */
export type UpdateResourcePricingsInput = {
  /** ApplicableMargin object. */
  applicableMarginsAttributes?: InputMaybe<Array<ApplicableMarginsInput>>;
  /** ApplicableTax object. */
  applicableTaxesAttributes?: InputMaybe<Array<ApplicableTaxesInput>>;
  discount?: InputMaybe<Scalars['Float']>;
  discountUnit?: InputMaybe<RateUnitEnum>;
  id: Scalars['ID'];
  marginsProductsAttributes?: InputMaybe<Array<UpdateMarginsProductsInput>>;
  masterApplyApplicableTax?: InputMaybe<Scalars['String']>;
  pocEmail?: InputMaybe<Scalars['String']>;
  pocName?: InputMaybe<Scalars['String']>;
  pocPhone?: InputMaybe<Scalars['String']>;
  /** PriceConfiguration object. */
  priceConfigurationsAttributes?: InputMaybe<Array<PriceConfigurationInput>>;
  /** Deprecated: Use productCategoryResourcesAttributes */
  productCategoryId?: InputMaybe<Scalars['ID']>;
  /** Product Category Resource object. */
  productCategoryResourcesAttributes?: InputMaybe<Array<ProductCategoryResourceInput>>;
  rateTypeId?: InputMaybe<Scalars['ID']>;
  resourceId?: InputMaybe<Scalars['ID']>;
  resourceType?: InputMaybe<ResourcePricingEnum>;
  userId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of UpdateRouteConfig */
export type UpdateRouteConfigInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: RouteConfigInput;
};

/** Autogenerated return type of UpdateRouteConfig */
export type UpdateRouteConfigPayload = {
  __typename?: 'UpdateRouteConfigPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Attributes for updating a saved view */
export type UpdateSavedView = {
  config?: InputMaybe<Scalars['JSON']>;
  /** ID of the saved view */
  id: Scalars['ID'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<Scalars['Int']>;
  preset?: InputMaybe<Scalars['Boolean']>;
  viewType?: InputMaybe<SavedViewEnum>;
};

/** Autogenerated input type of UpdateSavedView */
export type UpdateSavedViewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateSavedView;
};

/** Autogenerated return type of UpdateSavedView */
export type UpdateSavedViewPayload = {
  __typename?: 'UpdateSavedViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  savedView?: Maybe<SavedView>;
};

/** Autogenerated input type of UpdateSettings */
export type UpdateSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: SettingsInput;
};

/** Autogenerated return type of UpdateSettings */
export type UpdateSettingsPayload = {
  __typename?: 'UpdateSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  settings?: Maybe<Array<Setting>>;
};

/** Autogenerated input type of UpdateShift */
export type UpdateShiftInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Shift input type. */
  shiftAttributes?: InputMaybe<ShiftInput>;
};

/** Autogenerated return type of UpdateShift */
export type UpdateShiftPayload = {
  __typename?: 'UpdateShiftPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Shift type. */
  shift?: Maybe<Shift>;
};

/** Autogenerated input type of UpdateShifts */
export type UpdateShiftsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Shift input type. */
  shiftsAttributes?: InputMaybe<Array<ShiftInput>>;
};

/** Autogenerated return type of UpdateShifts */
export type UpdateShiftsPayload = {
  __typename?: 'UpdateShiftsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Shift type. */
  shifts?: Maybe<Array<Shift>>;
};

/** Autogenerated input type of UpdateSiteRecurrence */
export type UpdateSiteRecurrenceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['ID']>;
  fromCustomerPortal?: InputMaybe<Scalars['Boolean']>;
  orderGroupAttributes?: InputMaybe<Array<OrderGroupInput>>;
};

/** Autogenerated return type of UpdateSiteRecurrence */
export type UpdateSiteRecurrencePayload = {
  __typename?: 'UpdateSiteRecurrencePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderGroups?: Maybe<Array<OrderGroup>>;
};

/** Autogenerated input type of UpdateStatus */
export type UpdateStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
};

/** Autogenerated return type of UpdateStatus */
export type UpdateStatusPayload = {
  __typename?: 'UpdateStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  result?: Maybe<BulkOrderUnblocksResult>;
};

/** Autogenerated input type of UpdateStopDetails */
export type UpdateStopDetailsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: ShiftPlanDeliveryInput;
  id: Scalars['ID'];
  salesOrder: Scalars['ID'];
};

/** Autogenerated return type of UpdateStopDetails */
export type UpdateStopDetailsPayload = {
  __typename?: 'UpdateStopDetailsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Update supplier input */
export type UpdateSupplierInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  erpId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  irelyShipFromLocation?: InputMaybe<Scalars['String']>;
  isIrelyInternalSupplier?: InputMaybe<Scalars['Boolean']>;
  lineOfServiceIds?: InputMaybe<Array<Scalars['ID']>>;
  loadingAccountsAttributes?: InputMaybe<Array<NestedLoadingAccountInput>>;
  name?: InputMaybe<Scalars['String']>;
  supplierCode?: InputMaybe<Scalars['String']>;
  supplierType?: InputMaybe<SupplierTypeEnum>;
  terminalsSuppliersAttributes?: InputMaybe<Array<NestedTerminalSupplierInput>>;
};

/** Update supplier input (v3) */
export type UpdateSupplierInputV3 = {
  active?: InputMaybe<Scalars['Boolean']>;
  erpId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  irelyShipFromLocation?: InputMaybe<Scalars['String']>;
  isIrelyInternalSupplier?: InputMaybe<Scalars['Boolean']>;
  lineOfServiceIds?: InputMaybe<Array<Scalars['ID']>>;
  loadingAccountsAttributes?: InputMaybe<Array<NestedLoadingAccountInputV3>>;
  name?: InputMaybe<Scalars['String']>;
  supplierCode?: InputMaybe<Scalars['String']>;
  supplierType?: InputMaybe<SupplierTypeEnum>;
  terminalsSuppliersAttributes?: InputMaybe<Array<NestedTerminalSupplierInput>>;
};

/** Autogenerated input type of UpdateSuppliers */
export type UpdateSuppliersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateSupplierInput;
};

/** Autogenerated return type of UpdateSuppliers */
export type UpdateSuppliersPayload = {
  __typename?: 'UpdateSuppliersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  supplier?: Maybe<Supplier>;
};

/** Autogenerated input type of UpdateSuppliersV2 */
export type UpdateSuppliersV2Input = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateSupplierInput;
};

/** Autogenerated return type of UpdateSuppliersV2 */
export type UpdateSuppliersV2Payload = {
  __typename?: 'UpdateSuppliersV2Payload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  supplier?: Maybe<Supplier>;
};

/** Autogenerated input type of UpdateSuppliersV3 */
export type UpdateSuppliersV3Input = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateSupplierInputV3;
};

/** Autogenerated return type of UpdateSuppliersV3 */
export type UpdateSuppliersV3Payload = {
  __typename?: 'UpdateSuppliersV3Payload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  supplier?: Maybe<Supplier>;
};

/** Autogenerated input type of UpdateTax */
export type UpdateTaxInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateTaxesInput;
};

/** Autogenerated return type of UpdateTax */
export type UpdateTaxPayload = {
  __typename?: 'UpdateTaxPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  tax?: Maybe<Tax>;
};

/** Update Tax Input */
export type UpdateTaxesInput = {
  amountType?: InputMaybe<TaxAmountTypeEnum>;
  calculationType?: InputMaybe<TaxCalculationTypeEnum>;
  dateRangeAttribute?: InputMaybe<Array<TaxRangeAttributeInput>>;
  description?: InputMaybe<Scalars['String']>;
  doNotRoundUpRate?: InputMaybe<Scalars['Boolean']>;
  erpId: Scalars['String'];
  exempt?: InputMaybe<Scalars['Boolean']>;
  glCode?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  marketId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  productCategoryId?: InputMaybe<Scalars['ID']>;
  /** list of product category for tax */
  productCategoryResourcesAttributes?: InputMaybe<Array<ProductCategoryResourceInput>>;
  /** Tax for product */
  productTaxesAttributes?: InputMaybe<Array<ProductTaxesInput>>;
  rateInCurrency?: InputMaybe<Scalars['Float']>;
  rateInPercent?: InputMaybe<Scalars['Float']>;
  rateType: RateUnitEnum;
};

/** Update terminal input */
export type UpdateTerminalInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  erpId?: InputMaybe<Scalars['String']>;
  feinNumber?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isOwnBulkTank?: InputMaybe<Scalars['Boolean']>;
  isWarehouse?: InputMaybe<Scalars['Boolean']>;
  loadingInstruction?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nsTags?: InputMaybe<Array<Scalars['String']>>;
  products?: InputMaybe<Array<NestedProductInput>>;
  rackMarketId?: InputMaybe<Scalars['ID']>;
  siteAttributes?: InputMaybe<NestedSiteInput>;
  terminalManagersAttributes?: InputMaybe<Array<TerminalManagersInput>>;
  terminalsSuppliersAttributes?: InputMaybe<Array<NestedTerminalSupplierInput>>;
};

/** Autogenerated input type of UpdateTerminals */
export type UpdateTerminalsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateTerminalInput;
};

/** Autogenerated return type of UpdateTerminals */
export type UpdateTerminalsPayload = {
  __typename?: 'UpdateTerminalsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  terminal?: Maybe<Terminal>;
};

/** Update terminals supplier input */
export type UpdateTerminalsSupplierInput = {
  bolTimeAt?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  irelySubstituteTerminal?: InputMaybe<Scalars['String']>;
  pickupPointCodesAttributes?: InputMaybe<Array<NestedPickupPointCodeInput>>;
  supplierId?: InputMaybe<Scalars['ID']>;
  terminalId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of UpdateTerminalsSuppliers */
export type UpdateTerminalsSuppliersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateTerminalsSupplierInput;
};

/** Autogenerated return type of UpdateTerminalsSuppliers */
export type UpdateTerminalsSuppliersPayload = {
  __typename?: 'UpdateTerminalsSuppliersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  terminalsSupplier?: Maybe<TerminalsSupplier>;
};

/** Updating transfer orders assets */
export type UpdateTransferOrderAssetInput = {
  /** ID of new from_asset */
  fromAssetId?: InputMaybe<Scalars['ID']>;
  /** Compartments of from_asset for mapping */
  fromCompartmentAttributes?: InputMaybe<Array<CompartmentMappingInput>>;
  /** ID of the from */
  fromId?: InputMaybe<Scalars['ID']>;
  fromType?: InputMaybe<TransferTypeEnum>;
  /** ID of order group */
  id?: InputMaybe<Scalars['ID']>;
  /** ID of old from_asset */
  oldFromAssetId?: InputMaybe<Scalars['ID']>;
  /** ID of old to_asset */
  oldToAssetId?: InputMaybe<Scalars['ID']>;
  /** ID of new to_asset */
  toAssetId?: InputMaybe<Scalars['ID']>;
  /** Compartments of to_asset for mapping */
  toCompartmentAttributes?: InputMaybe<Array<CompartmentMappingInput>>;
  toId?: InputMaybe<Scalars['ID']>;
  toType?: InputMaybe<TransferTypeEnum>;
};

/** Autogenerated input type of UpdateTransferOrderAssets */
export type UpdateTransferOrderAssetsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateTransferOrderAssetInput;
};

/** Autogenerated return type of UpdateTransferOrderAssets */
export type UpdateTransferOrderAssetsPayload = {
  __typename?: 'UpdateTransferOrderAssetsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderGroup: OrderGroup;
};

/** Autogenerated input type of UpdateTransferOrder */
export type UpdateTransferOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  transferOrderAttributes?: InputMaybe<UpdTransferOrderInput>;
};

/** Autogenerated return type of UpdateTransferOrder */
export type UpdateTransferOrderPayload = {
  __typename?: 'UpdateTransferOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  transferOrder?: Maybe<TransferOrder>;
};

/** Autogenerated input type of UpdateTruckDetails */
export type UpdateTruckDetailsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: ShiftPlanTruckInput;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateTruckDetails */
export type UpdateTruckDetailsPayload = {
  __typename?: 'UpdateTruckDetailsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Update user input */
export type UpdateUserInput = {
  address?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  imageSignedBlobId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  otp?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateUsers */
export type UpdateUsersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateUserInput;
};

/** Autogenerated return type of UpdateUsers */
export type UpdateUsersPayload = {
  __typename?: 'UpdateUsersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of UpdateZoneProductBatches */
export type UpdateZoneProductBatchesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  zoneProductBatchesAttributes?: InputMaybe<Array<ZoneProductBatchInput>>;
};

/** Autogenerated return type of UpdateZoneProductBatches */
export type UpdateZoneProductBatchesPayload = {
  __typename?: 'UpdateZoneProductBatchesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  zoneProductBatches?: Maybe<Array<ZoneProductBatch>>;
};

/** Autogenerated input type of UploadPandaDocument */
export type UploadPandaDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: AttachmentInput;
};

/** Autogenerated return type of UploadPandaDocument */
export type UploadPandaDocumentPayload = {
  __typename?: 'UploadPandaDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  pandaDocument?: Maybe<PandaDocument>;
  success: Scalars['Boolean'];
};

export type UsedAsset = {
  __typename?: 'UsedAsset';
  assetId?: Maybe<Scalars['ID']>;
  usedCompartmentCount?: Maybe<Scalars['Int']>;
};

export type User = {
  __typename?: 'User';
  address?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  gravatar?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<AttachedFile>;
  isSuperAdmin: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  otp?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Role>>;
  status?: Maybe<Scalars['Int']>;
  terminals?: Maybe<Array<Terminal>>;
};

/** Default user input */
export type UserInput = {
  address?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  imageSignedBlobId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of ValidateToken */
export type ValidateTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};

/** Autogenerated return type of ValidateToken */
export type ValidateTokenPayload = {
  __typename?: 'ValidateTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  message?: Maybe<Scalars['String']>;
};

/** Enum to represent Vender list to Sync Data */
export enum VendorNameEnum {
  Agvance = 'Agvance',
  Bookworks = 'Bookworks',
  Cargas = 'Cargas',
  D1Connect = 'D1Connect',
  HuntAndSon = 'HuntAndSon',
  Irely = 'Irely',
  QuickBooksOnline = 'QuickBooksOnline'
}

/** Autogenerated input type of VerifyAndUpdateUser */
export type VerifyAndUpdateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: UpdateUserInput;
};

/** Autogenerated return type of VerifyAndUpdateUser */
export type VerifyAndUpdateUserPayload = {
  __typename?: 'VerifyAndUpdateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type Version = {
  __typename?: 'Version';
  changeset?: Maybe<Array<Changeset>>;
  date?: Maybe<Scalars['String']>;
  event: Scalars['String'];
  id: Scalars['ID'];
  itemType: Scalars['String'];
  objectChanges?: Maybe<Scalars['String']>;
  whodunnit?: Maybe<User>;
};

export type VersionCollection = {
  __typename?: 'VersionCollection';
  collection: Array<Version>;
  metadata: MetaQuery;
};

export type Warehouse = {
  __typename?: 'Warehouse';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type Warning = {
  __typename?: 'Warning';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
};

export enum WaterTestResultEnum {
  /** Blank */
  Blank = 'blank',
  /** Negative */
  Negative = 'negative',
  /** Positive */
  Positive = 'positive'
}

export enum WeekDayEnum {
  /** Friday */
  Friday = 'friday',
  /** Monday */
  Monday = 'monday',
  /** Saturday */
  Saturday = 'saturday',
  /** Sunday */
  Sunday = 'sunday',
  /** Thursday */
  Thursday = 'thursday',
  /** Tuesday */
  Tuesday = 'tuesday',
  /** Wednesday */
  Wednesday = 'wednesday'
}

export type WeeklySchedule = {
  __typename?: 'WeeklySchedule';
  breakMinutes?: Maybe<Scalars['Int']>;
  earliest?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  latest?: Maybe<Scalars['Int']>;
  scheduleType: WeeklyScheduleTypeEnum;
  weekDay: WeekDayEnum;
};

export enum WeeklyScheduleTypeEnum {
  /** Break */
  Break = 'break',
  /** Work */
  Work = 'work'
}

export type Worker = {
  __typename?: 'Worker';
  email?: Maybe<Scalars['String']>;
  homeAddress?: Maybe<Scalars['String']>;
  hourlyRate?: Maybe<Scalars['Float']>;
  hubResources?: Maybe<Array<HubResource>>;
  hubs?: Maybe<Array<Hub>>;
  id: Scalars['ID'];
  /** @deprecated Use type */
  isCarrier?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  phoneModel?: Maybe<Scalars['String']>;
  resourceSchedule?: Maybe<ResourceSchedule>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ZoneProductBatch = {
  __typename?: 'ZoneProductBatch';
  asset: Asset;
  batch: Batch;
  id: Scalars['ID'];
  orderGroup?: Maybe<OrderGroup>;
  product: Product;
  zoneIndex?: Maybe<Scalars['Int']>;
};

/** ZoneProductBatch Input */
export type ZoneProductBatchInput = {
  _destroy?: InputMaybe<Scalars['Boolean']>;
  assetId?: InputMaybe<Scalars['ID']>;
  batchAttributes?: InputMaybe<BatchInput>;
  id?: InputMaybe<Scalars['ID']>;
  orderGroupId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  zoneIndex?: InputMaybe<Scalars['Int']>;
};

export type ZoneProductBatchesFilterInput = {
  assetId?: InputMaybe<Scalars['ID']>;
  orderGroupIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type BulkEmailToDriverSummaryQueryVariables = Exact<{
  orderGroupIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type BulkEmailToDriverSummaryQuery = { __typename?: 'Query', bulkEmailSummary: Array<{ __typename?: 'BulkEmail', driverEmail?: string | null, driverName?: string | null, orderGroupId?: string | null, deliveryOrder?: { __typename?: 'BulkEmailDeliveryOrder', customer: string, customerBranch?: any | null, plannedAt?: string | null, toPlannedAt?: string | null, deliveryInstruction?: string | null, deliveryOrderLineItems?: Array<{ __typename?: 'BulkEmailDoli', productName?: string | null, quantity?: number | null, assetName?: string | null }> | null } | null, loadingOrderDetails?: Array<{ __typename?: 'BulkEmailLoadingOrder', terminal: string, terminalAddress?: string | null, loadingInstruction?: string | null, isSplitOrder?: boolean | null, orderGroupId?: string | null, loadingOrderLineItems?: Array<{ __typename?: 'BulkEmailLoli', productName?: string | null, quantity?: string | null, preferredSuppliers?: Array<{ __typename?: 'BulkEmailSupplier', carrierCustomerCode?: string | null, loadingAccountNumber?: string | null, supplierName?: string | null }> | null }> | null }> | null }> };

export type SendBulkOrderEmailToDriverMutationVariables = Exact<{
  input: SendBulkOrderEmailToDriverInput;
}>;


export type SendBulkOrderEmailToDriverMutation = { __typename?: 'Mutation', sendBulkOrderEmailToDriver?: { __typename?: 'SendBulkOrderEmailToDriverPayload', success?: boolean | null } | null };

export type UpdateOrderGroupStatusMutationVariables = Exact<{
  input: UpdateOrderGroupMutationInput;
}>;


export type UpdateOrderGroupStatusMutation = { __typename?: 'Mutation', updateOrderGroup?: { __typename?: 'UpdateOrderGroupMutationPayload', orderGroup?: { __typename?: 'OrderGroup', id: string, status: string } | null } | null };

export type UpdateOrderGroupTagsMutationVariables = Exact<{
  input: LinkOrUnlinkTagsInput;
}>;


export type UpdateOrderGroupTagsMutation = { __typename?: 'Mutation', linkOrUnlinkTags?: { __typename?: 'LinkOrUnlinkTagsPayload', error?: string | null, success: boolean, orderGroup?: { __typename?: 'OrderGroup', id: string, taggings?: Array<{ __typename?: 'Tagging', tag?: { __typename?: 'Tag', id: string, name: string, erpId?: string | null, description?: string | null, colorCode?: string | null, iconName?: string | null, status?: StatusStringEnum | null, tagType?: string | null } | null }> | null } | null } | null };

export type FetchRentalAssetsQueryVariables = Exact<{
  types?: InputMaybe<Array<AssetTypeEnum> | AssetTypeEnum>;
  statuses?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  all?: InputMaybe<Scalars['String']>;
}>;


export type FetchRentalAssetsQuery = { __typename?: 'Query', filteredAssets: { __typename?: 'AssetCollection', collection: Array<{ __typename?: 'Asset', id: string, name?: string | null, existingActiveMovementOrderIds?: Array<string> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean } } };

export type FetchMovementOrderOtherDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchMovementOrderOtherDetailsQuery = { __typename?: 'Query', movementOrder: { __typename?: 'MovementOrder', id: string, orderNotes?: string | null, instruction?: string | null, assetDetailsNotes?: string | null, signature?: { __typename?: 'PandaDocument', blobFileUrl?: string | null } | null, orderGroup: { __typename?: 'OrderGroup', id: string, pandaDocuments?: Array<{ __typename?: 'PandaDocument', id: string, fileName?: string | null, fileUrl?: string | null, blobFileUrl?: string | null, blobFileUrlDownload?: string | null, externalFileData?: { __typename?: 'AttachedFile', filename?: string | null, url?: string | null } | null }> | null } } };

export type CreateAssetMovementOrderMutationVariables = Exact<{
  input: CreateOrderGroupInput;
}>;


export type CreateAssetMovementOrderMutation = { __typename?: 'Mutation', createOrderGroup?: { __typename?: 'CreateOrderGroupPayload', orderGroup?: { __typename?: 'OrderGroup', id: string, movementOrder?: { __typename?: 'MovementOrder', id: string, requestedTankSize?: string | null, requestedTankType?: string | null } | null } | null } | null };

export type CreateNoteMutationVariables = Exact<{
  input: CreateNoteInput;
}>;


export type CreateNoteMutation = { __typename?: 'Mutation', createNote?: { __typename?: 'CreateNotePayload', note?: { __typename?: 'Note', id: string, createdAtTimestamp?: number | null, content?: string | null, generated?: boolean | null, showInDeliveryTicket?: boolean | null, showInInvoice?: boolean | null, commenterUser?: { __typename?: 'Commenter', id: string, name?: string | null, avatar?: string | null, type: string } | null, pandaDocument?: { __typename?: 'PandaDocument', id: string, blobFileUrl?: string | null } | null } | null } | null };

export type FetchAssetMovementOrderFeesQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type FetchAssetMovementOrderFeesQuery = { __typename?: 'Query', movementOrder: { __typename?: 'MovementOrder', id: string, orderGroupId: string, orderGroup: { __typename?: 'OrderGroup', orderGroupsFees?: Array<{ __typename?: 'OrderGroupsFee', id: string, price?: number | null, quantity: number, fee: { __typename?: 'Fee', id: string, description?: string | null, name?: string | null, standard?: boolean | null, deleted?: boolean | null } }> | null } } };

export type FetchMovementOrderHistoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchMovementOrderHistoryQuery = { __typename?: 'Query', assetMovementOrderHistory: Array<{ __typename?: 'AssetMovementOrderHistory', actualRoi?: number | null, expectedRoi?: number | null, startedDate?: any | null, completedDate?: any | null, customerBranchName?: string | null, customerName?: string | null, numberOfDays?: number | null, customerBranchId?: string | null, averageDaysBetweenFills?: number | null }> };

export type FetchMovementOrderHistoryListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<AssetMovementOrderHistoryListFilter>;
  sorter?: InputMaybe<Array<AssetMovementOrderHistorySorter> | AssetMovementOrderHistorySorter>;
}>;


export type FetchMovementOrderHistoryListQuery = { __typename?: 'Query', filteredAssetMovementOrderHistoryList: { __typename?: 'AssetMovementOrderHistoryListCollection', collection: Array<{ __typename?: 'AssetMovementOrderHistoryList', driverName?: string | null, productName?: string | null, volume?: number | null, completedOn?: any | null, licensePlateNumber?: string | null }>, metadata: { __typename?: 'MetaQuery', totalCount?: number | null, hasMore: boolean, total_entries?: number | null } } };

export type FetchAssetMovementOrderWellQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<OrderGroupFilter>;
  sorter?: InputMaybe<Array<OrderGroupSorter> | OrderGroupSorter>;
}>;


export type FetchAssetMovementOrderWellQuery = { __typename?: 'Query', filteredOrderGroups: { __typename?: 'OrderGroupCollection', collection: Array<{ __typename?: 'OrderGroup', id: string, status: string, startOnTimestamp?: number | null, toStartOnTimestamp?: number | null, completedOnTimestamp?: number | null, poNumber?: string | null, priority?: OrderGroupPriorityEnum | null, movementOrder?: { __typename?: 'MovementOrder', id: string, orderType?: MovementOrderTypeEnum | null, orderNotes?: string | null, requestedTankSize?: string | null, requestedTankType?: string | null, assignedTankSize?: string | null, assignedTankType?: string | null, requestedProducts?: Array<{ __typename?: 'Product', name?: string | null }> | null, assetMovementLocation?: { __typename?: 'AssetMovementLocation', id: string, lat?: string | null, lng?: string | null, orderGroupId?: string | null } | null, orderGroup: { __typename?: 'OrderGroup', id: string, driver?: { __typename?: 'Driver', id: string, name?: string | null } | null, user?: { __typename?: 'User', id: string, name?: string | null } | null, worker?: { __typename?: 'Worker', id: string, name?: string | null } | null }, asset?: { __typename?: 'Asset', id: string, name?: string | null } | null, fromCustomerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, customer?: { __typename?: 'Customer', name?: string | null } | null } | null, toCustomerBranch: { __typename?: 'CustomerBranch', id: string, name?: string | null, customer?: { __typename?: 'Customer', name?: string | null } | null }, hub?: { __typename?: 'Hub', id: string, name?: string | null, address?: any | null } | null, product?: { __typename?: 'Product', name?: string | null } | null } | null }>, metadata: { __typename?: 'MetaQuery', totalCount?: number | null, hasMore: boolean } } };

export type FetchCustomItemsForLeoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchCustomItemsForLeoQuery = { __typename?: 'Query', movementOrder: { __typename?: 'MovementOrder', id: string, data?: { __typename?: 'MovementOrderData', customItems?: Array<{ __typename?: 'LeaCoreCustomItem', name?: string | null, qty?: number | null }> | null } | null } };

export type FetchLineItemsForLeoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchLineItemsForLeoQuery = { __typename?: 'Query', movementOrder: { __typename?: 'MovementOrder', id: string, orderType?: MovementOrderTypeEnum | null, movementOrderLineItems?: Array<{ __typename?: 'MovementOrderLineItem', id: string, action?: string | null, ownershipStatus?: string | null, isPeripheralRemoved?: boolean | null, peripheral?: { __typename?: 'Peripheral', id: string, erpId?: string | null, subType?: string | null, peripheralCategory?: { __typename?: 'PeripheralCategory', id: string, name?: string | null } | null } | null, peripheralInstances?: Array<{ __typename?: 'PeripheralInstance', id?: string | null, value?: string | null, peripheralAttribute?: { __typename?: 'PeripheralAttribute', id?: string | null, formName?: string | null, formLabel?: string | null, peripheralAttributeType?: string | null } | null }> | null }> | null } };

export type FetchMovementOrderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchMovementOrderQuery = { __typename?: 'Query', movementOrder: { __typename?: 'MovementOrder', id: string, orderType?: MovementOrderTypeEnum | null, hasActiveAddendumAgreement?: boolean | null, orderNotes?: string | null, instruction?: string | null, requestedTankSize?: string | null, requestedTankType?: string | null, assignedTankSize?: string | null, assignedTankType?: string | null, addendumAgreementDocuments?: Array<{ __typename?: 'DocusealDocument', name?: string | null, url?: string | null, documentType?: string | null }> | null, orderGroup: { __typename?: 'OrderGroup', id: string, status: string, startOnTimestamp?: number | null, toStartOnTimestamp?: number | null, createdAtTimestamp: number, completedOnTimestamp?: number | null, poNumber?: string | null, driver?: { __typename?: 'Driver', id: string, name?: string | null } | null, user?: { __typename?: 'User', id: string, name?: string | null } | null }, data?: { __typename?: 'MovementOrderData', customItems?: Array<{ __typename?: 'LeaCoreCustomItem', name?: string | null, qty?: number | null, unitCost?: number | null }> | null } | null, assetMovementLocation?: { __typename?: 'AssetMovementLocation', id: string, lat?: string | null, lng?: string | null, orderGroupId?: string | null } | null, asset?: { __typename?: 'Asset', id: string, name?: string | null, erpId?: string | null, type?: string | null, tankSize?: string | null, tankType?: string | null, licensePlateNumber?: string | null, assetProductCategories?: Array<{ __typename?: 'AssetProductCategory', productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null, compartments?: Array<{ __typename?: 'Compartment', id: string }> | null, assetMovementLocation?: { __typename?: 'AssetMovementLocation', lat?: string | null, lng?: string | null } | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, erpId?: string | null } | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null, address?: any | null }> | null, fuelTypeProducts?: Array<{ __typename?: 'Product', id: string, name?: string | null }> | null } | null, toCustomerBranch: { __typename?: 'CustomerBranch', id: string, name?: string | null, address?: string | null, deliveryInstruction?: string | null, customer?: { __typename?: 'Customer', name?: string | null, erpId?: string | null, deliveryInstruction?: string | null } | null }, fromCustomerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, customer?: { __typename?: 'Customer', name?: string | null } | null } | null, hub?: { __typename?: 'Hub', id: string, name?: string | null, address?: any | null } | null, product?: { __typename?: 'Product', id: string, name?: string | null } | null } };

export type FetchMovementOrderLineItemsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchMovementOrderLineItemsQuery = { __typename?: 'Query', movementOrder: { __typename?: 'MovementOrder', id: string, movementOrderLineItems?: Array<{ __typename?: 'MovementOrderLineItem', id: string, peripheral?: { __typename?: 'Peripheral', id: string, soldAs?: string | null, subType?: string | null, legalDescription?: string | null, peripheralCategory?: { __typename?: 'PeripheralCategory', id: string, name?: string | null } | null } | null, peripheralInstances?: Array<{ __typename?: 'PeripheralInstance', id?: string | null, value?: string | null, peripheralAttribute?: { __typename?: 'PeripheralAttribute', id?: string | null, name?: string | null, peripheralAttributeType?: string | null } | null }> | null, resourceStatuses?: Array<{ __typename?: 'ResourceStatus', id?: string | null, name?: string | null, preValue?: string | null, postValue?: string | null, resourceStatusType?: { __typename?: 'ResourceStatusTypes', id: string } | null }> | null }> | null } };

export type FetchMovementOrderLinkOrdersQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchMovementOrderLinkOrdersQuery = { __typename?: 'Query', movementOrder: { __typename?: 'MovementOrder', id: string, orderLinks?: Array<{ __typename?: 'OrderLink', id: string, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, orderGroup?: { __typename?: 'OrderGroup', id: string } | null } | null, extractionOrder?: { __typename?: 'ExtractionOrder', id: string, orderGroup?: { __typename?: 'OrderGroup', id: string } | null } | null }> | null } };

export type FetchMovementOrderNotesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchMovementOrderNotesQuery = { __typename?: 'Query', movementOrder: { __typename?: 'MovementOrder', id: string, resourceStatuses?: Array<{ __typename?: 'ResourceStatus', id?: string | null, createdAtTimestamp?: number | null, preValue?: string | null, postValue?: string | null, resourceStatusType?: { __typename?: 'ResourceStatusTypes', resourceAttributeType: string } | null }> | null, orderGroup: { __typename?: 'OrderGroup', id: string, allNotes?: Array<{ __typename?: 'Note', id: string, createdAtTimestamp?: number | null, content?: string | null, generated?: boolean | null, showInDeliveryTicket?: boolean | null, commenterUser?: { __typename?: 'Commenter', id: string, name?: string | null, avatar?: string | null, type: string } | null }> | null, driver?: { __typename?: 'Driver', name?: string | null } | null } } };

export type FetchMovementOrderRequestedLineItemsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchMovementOrderRequestedLineItemsQuery = { __typename?: 'Query', movementOrder: { __typename?: 'MovementOrder', id: string, asset?: { __typename?: 'Asset', id: string } | null, requestedMovementOrderLineItems?: Array<{ __typename?: 'RequestedMovementOrderLineItem', id: string, peripheralApprovedStatus?: boolean | null, peripheral?: { __typename?: 'Peripheral', id: string, soldAs?: string | null, subType?: string | null, legalDescription?: string | null, peripheralCategory?: { __typename?: 'PeripheralCategory', id: string, name?: string | null } | null } | null, requestedPeripheralInstances?: Array<{ __typename?: 'RequestedPeripheralInstance', id?: string | null, value?: string | null, peripheralAttribute?: { __typename?: 'PeripheralAttribute', id?: string | null, name?: string | null, peripheralAttributeType?: string | null } | null }> | null }> | null } };

export type FetchPeripheralsForNewMovementOrderQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchPeripheralsForNewMovementOrderQuery = { __typename?: 'Query', peripherals: Array<{ __typename?: 'Peripheral', id: string, erpId?: string | null, soldAs?: string | null, status?: string | null, subType?: string | null, peripheralCategory?: { __typename?: 'PeripheralCategory', id: string, name?: string | null } | null }> };

export type FetchResourceStatusTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchResourceStatusTypeQuery = { __typename?: 'Query', resourceStatusType: Array<{ __typename?: 'ResourceStatusTypes', id: string, resourceAttributeType: string, name?: string | null }> };

export type FilteredFeesForMovementOrderDetailQueryVariables = Exact<{
  filter?: InputMaybe<FeeFilter>;
}>;


export type FilteredFeesForMovementOrderDetailQuery = { __typename?: 'Query', filteredFees: { __typename?: 'FeeCollection', collection: Array<{ __typename?: 'Fee', id: string, description?: string | null, name?: string | null, standard?: boolean | null, deleted?: boolean | null }> } };

export type OrderGroupFragment = { __typename?: 'OrderGroup', id: string, status: string, startOnTimestamp?: number | null, toStartOnTimestamp?: number | null, completedOnTimestamp?: number | null, poNumber?: string | null, priority?: OrderGroupPriorityEnum | null, movementOrder?: { __typename?: 'MovementOrder', id: string, orderType?: MovementOrderTypeEnum | null, orderNotes?: string | null, requestedTankSize?: string | null, requestedTankType?: string | null, assignedTankSize?: string | null, assignedTankType?: string | null, requestedProducts?: Array<{ __typename?: 'Product', name?: string | null }> | null, assetMovementLocation?: { __typename?: 'AssetMovementLocation', id: string, lat?: string | null, lng?: string | null, orderGroupId?: string | null } | null, orderGroup: { __typename?: 'OrderGroup', id: string, driver?: { __typename?: 'Driver', id: string, name?: string | null } | null, user?: { __typename?: 'User', id: string, name?: string | null } | null, worker?: { __typename?: 'Worker', id: string, name?: string | null } | null }, asset?: { __typename?: 'Asset', id: string, name?: string | null } | null, fromCustomerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, customer?: { __typename?: 'Customer', name?: string | null } | null } | null, toCustomerBranch: { __typename?: 'CustomerBranch', id: string, name?: string | null, customer?: { __typename?: 'Customer', name?: string | null } | null }, hub?: { __typename?: 'Hub', id: string, name?: string | null, address?: any | null } | null, product?: { __typename?: 'Product', name?: string | null } | null } | null };

export type UpdateMovementOrderMutationVariables = Exact<{
  input: UpdateMovementOrderInput;
}>;


export type UpdateMovementOrderMutation = { __typename?: 'Mutation', updateMovementOrder?: { __typename?: 'UpdateMovementOrderPayload', movementOrder?: { __typename?: 'MovementOrder', id: string } | null } | null };

export type UpdateOrderGroupMutationVariables = Exact<{
  input: UpdateOrderGroupMutationInput;
}>;


export type UpdateOrderGroupMutation = { __typename?: 'Mutation', updateOrderGroup?: { __typename?: 'UpdateOrderGroupMutationPayload', orderGroup?: { __typename?: 'OrderGroup', id: string, status: string, startOnTimestamp?: number | null, toStartOnTimestamp?: number | null, completedOnTimestamp?: number | null, poNumber?: string | null, priority?: OrderGroupPriorityEnum | null, movementOrder?: { __typename?: 'MovementOrder', id: string, orderType?: MovementOrderTypeEnum | null, orderNotes?: string | null, requestedTankSize?: string | null, requestedTankType?: string | null, assignedTankSize?: string | null, assignedTankType?: string | null, requestedProducts?: Array<{ __typename?: 'Product', name?: string | null }> | null, assetMovementLocation?: { __typename?: 'AssetMovementLocation', id: string, lat?: string | null, lng?: string | null, orderGroupId?: string | null } | null, orderGroup: { __typename?: 'OrderGroup', id: string, driver?: { __typename?: 'Driver', id: string, name?: string | null } | null, user?: { __typename?: 'User', id: string, name?: string | null } | null, worker?: { __typename?: 'Worker', id: string, name?: string | null } | null }, asset?: { __typename?: 'Asset', id: string, name?: string | null } | null, fromCustomerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, customer?: { __typename?: 'Customer', name?: string | null } | null } | null, toCustomerBranch: { __typename?: 'CustomerBranch', id: string, name?: string | null, customer?: { __typename?: 'Customer', name?: string | null } | null }, hub?: { __typename?: 'Hub', id: string, name?: string | null, address?: any | null } | null, product?: { __typename?: 'Product', name?: string | null } | null } | null } | null } | null };

export type FetchCurrentQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchCurrentQuery = { __typename?: 'Query', current: { __typename?: 'Current', pusherChannelName?: string | null, isCarrierOnly: boolean, isCustomerClient: boolean, userFeatureFlags: Array<string>, customerSettings: Array<string>, accessibleCustomers: Array<{ __typename?: 'Customer', id: string, name?: string | null }>, user: { __typename?: 'User', id: string, name?: string | null, email: string, phone?: string | null, address?: string | null, isSuperAdmin: boolean, roles?: Array<{ __typename?: 'Role', name?: string | null }> | null, image?: { __typename?: 'AttachedFile', id?: string | null, filename?: string | null, url?: string | null } | null }, customer?: { __typename?: 'Customer', id: string, tenantSlug?: string | null, name?: string | null, site?: { __typename?: 'Site', lat?: string | null, lng?: string | null } | null } | null, settings: Array<{ __typename?: 'Setting', id: string, name: string, value?: string | null }>, tenant?: { __typename?: 'Tenant', id: string, name?: string | null, slug?: string | null } | null } };

export type SettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsQuery = { __typename?: 'Query', settings: Array<{ __typename?: 'Setting', id: string, name: string, value?: string | null }> };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'ResetPasswordPayload', errors?: Array<string> | null, message?: string | null } | null };

export type SendPasswordResetInstructionMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SendPasswordResetInstructionMutation = { __typename?: 'Mutation', sendPasswordResetInstruction?: { __typename?: 'SendPasswordResetInstructionPayload', clientMutationId?: string | null, errors?: Array<string> | null, message?: string | null } | null };

export type UserSignInMutationVariables = Exact<{
  credentials: AuthInput;
}>;


export type UserSignInMutation = { __typename?: 'Mutation', signInUser?: { __typename?: 'SignInPayload', token?: string | null, message?: string | null, refreshToken?: string | null, clientMutationId?: string | null, isCustomerClient?: boolean | null, requires2fa?: boolean | null, otpRequiredForLogin?: boolean | null, user?: { __typename?: 'User', id: string, name?: string | null, phone?: string | null, email: string } | null } | null };

export type SwitchTenantMutationVariables = Exact<{
  input: SwitchTenantInput;
}>;


export type SwitchTenantMutation = { __typename?: 'Mutation', switchTenant?: { __typename?: 'SwitchTenantPayload', accessToken: string, clientMutationId?: string | null } | null };

export type ValidateTokenMutationVariables = Exact<{
  input: ValidateTokenInput;
}>;


export type ValidateTokenMutation = { __typename?: 'Mutation', validateToken?: { __typename?: 'ValidateTokenPayload', clientMutationId?: string | null, errors?: Array<string> | null, message?: string | null } | null };

export type CreateInvoiceMutationVariables = Exact<{
  input: CreateInvoiceInput;
}>;


export type CreateInvoiceMutation = { __typename?: 'Mutation', createInvoice?: { __typename?: 'CreateInvoicePayload', invoices?: Array<{ __typename?: 'Invoice', id: string }> | null } | null };

export type EmailInvoiceMutationVariables = Exact<{
  data: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type EmailInvoiceMutation = { __typename?: 'Mutation', generateInvoice?: { __typename?: 'GenerateInvoicePayload', success: boolean } | null };

export type FetchCardLockTranscationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<CardLockTransactionFilters>;
}>;


export type FetchCardLockTranscationsQuery = { __typename?: 'Query', distinctCardLockCustomers: { __typename?: 'CustomerCollection', collection: Array<{ __typename?: 'Customer', id: string, erpId?: string | null, name?: string | null }>, metadata: { __typename?: 'MetaQuery', totalCount?: number | null } } };

export type FetchInvoiceDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchInvoiceDetailsQuery = { __typename?: 'Query', invoice: { __typename?: 'Invoice', id: string, invoiceNumber?: string | null, status?: InvoiceStatusEnum | null, createdOn?: number | null, generatedOn?: number | null, glDate?: any | null, closedOn?: number | null, amount?: number | null, creatable?: { __typename?: 'Driver', id: string, name?: string | null } | { __typename?: 'User', id: string, name?: string | null } | { __typename?: 'Worker', id: string, name?: string | null } | null, generatable?: { __typename?: 'Driver', id: string, name?: string | null } | { __typename?: 'User', id: string, name?: string | null } | { __typename?: 'Worker', id: string, name?: string | null } | null, closeable?: { __typename?: 'Driver', id: string, name?: string | null } | { __typename?: 'User', id: string, name?: string | null } | { __typename?: 'Worker', id: string, name?: string | null } | null, customer?: { __typename?: 'Customer', name?: string | null, address?: string | null, erpId?: string | null, site?: { __typename?: 'Site', address?: any | null } | null } | null, invoiceLineItems?: Array<{ __typename?: 'InvoiceLineItem', amount?: number | null, rate?: number | null, quantity?: number | null, sumTotal?: number | null, product: { __typename?: 'Product', id: string, name?: string | null, erpId?: string | null }, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null }> | null, invoiceFees?: Array<{ __typename?: 'InvoiceFee', customerBranchId?: string | null, amount?: number | null, rate?: number | null, quantity?: number | null, product?: { __typename?: 'Product', id: string } | null, fee?: { __typename?: 'Fee', name?: string | null } | null }> | null, invoiceOrderGroupFees?: Array<{ __typename?: 'InvoiceOrderGroupFee', total?: number | null, rate?: number | null, quantity?: number | null, fee?: { __typename?: 'Fee', name?: string | null } | null }> | null, invoiceOrderGroupTaxes?: Array<{ __typename?: 'InvoiceOrderGroupTax', total?: number | null, rate?: number | null, quantity?: number | null, tax?: { __typename?: 'Tax', name?: string | null, rateType?: string | null } | null }> | null, invoiceTaxes?: Array<{ __typename?: 'InvoiceTax', customerBranchId?: string | null, amount?: number | null, rate?: number | null, quantity?: number | null, product?: { __typename?: 'Product', id: string } | null, tax?: { __typename?: 'Tax', name?: string | null, erpId?: string | null, rateType?: string | null } | null }> | null, orderGroup?: { __typename?: 'OrderGroup', id: string, completedOnTimestamp?: number | null, ratePrecision?: number | null, amountPrecision?: number | null, customerBranch?: { __typename?: 'CustomerBranch', erpId?: string | null } | null } | null } };

export type FilteredCardLockTranscationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<CardLockFilters>;
}>;


export type FilteredCardLockTranscationsQuery = { __typename?: 'Query', filteredCardLockTransactions: { __typename?: 'CardLockTransactionCollection', collection: Array<{ __typename?: 'CardLockTransaction', id: string, fleetCardNumber?: string | null, gallon?: string | null, invoiceStatus?: string | null, invoiceNumbers?: Array<string> | null, price?: string | null, pump?: string | null, sequenceNumbers?: string | null, site?: string | null, total?: string | null, transactionTime?: string | null, truckNumber?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null } | null, product?: { __typename?: 'Product', erpId?: string | null, shortName?: string | null } | null }>, metadata: { __typename?: 'MetaQuery', totalCount?: number | null } } };

export type FilteredInvoicesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<InvoiceFilter>;
  sorter?: InputMaybe<Array<BaseSorter> | BaseSorter>;
}>;


export type FilteredInvoicesQuery = { __typename?: 'Query', filteredInvoice: { __typename?: 'InvoiceCollection', metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null }, collection: Array<{ __typename?: 'Invoice', id: string, invoiceNumber?: string | null, status?: InvoiceStatusEnum | null, createdOn?: number | null, generatedOn?: number | null, closedOn?: number | null, amount?: number | null, creatable?: { __typename?: 'Driver', id: string, name?: string | null } | { __typename?: 'User', id: string, name?: string | null } | { __typename?: 'Worker', id: string, name?: string | null } | null, generatable?: { __typename?: 'Driver', id: string, name?: string | null } | { __typename?: 'User', id: string, name?: string | null } | { __typename?: 'Worker', id: string, name?: string | null } | null, closeable?: { __typename?: 'Driver', id: string, name?: string | null } | { __typename?: 'User', id: string, name?: string | null } | { __typename?: 'Worker', id: string, name?: string | null } | null, customer?: { __typename?: 'Customer', name?: string | null, site?: { __typename?: 'Site', address?: any | null } | null } | null, reversedInvoices?: Array<{ __typename?: 'Invoice', id: string, invoiceNumber?: string | null }> | null, orderGroup?: { __typename?: 'OrderGroup', deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, type?: string | null, customerBranch?: { __typename?: 'CustomerBranch', name?: string | null } | null } | null } | null }> } };

export type UpdateInvoiceMutationVariables = Exact<{
  data: InvoiceInput;
}>;


export type UpdateInvoiceMutation = { __typename?: 'Mutation', updateInvoice?: { __typename?: 'UpdateInvoicePayload', invoice?: { __typename?: 'Invoice', id: string } | null } | null };

export type ExportTransactionMutationVariables = Exact<{
  input: ExportTransactionInput;
}>;


export type ExportTransactionMutation = { __typename?: 'Mutation', exportTransactions?: { __typename: 'ExportTransactionPayload', exportDocument?: { __typename: 'ExportDocument', id: string, status?: string | null } | null } | null };

export type FetchCreditLedgerMonthlyStatsQueryVariables = Exact<{
  customerId: Scalars['ID'];
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
}>;


export type FetchCreditLedgerMonthlyStatsQuery = { __typename?: 'Query', creditLedgerMonthlyStats?: { __typename?: 'CreditLedgerMonthlyStats', amountDebited?: number | null, amountCredited?: number | null, netAmount?: number | null } | null };

export type FetchCreditLedgerTransactionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<CreditLedgerTransactionFilters>;
}>;


export type FetchCreditLedgerTransactionsQuery = { __typename?: 'Query', fetchCreditLedgerTransactions?: { __typename?: 'CreditLedgerTransactionCollection', collection: Array<{ __typename?: 'CreditLedgerTransaction', id: string, closingBalance: number, transactionType: CreditLedgerTransactionTypeEnum, createdAt: number, amount: number, description: string, orderGroup?: { __typename?: 'OrderGroup', id: string, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string } | null } | null, customer: { __typename?: 'Customer', id: string, name?: string | null }, creatable?: { __typename?: 'User', id: string, name?: string | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null } } | null };

export type FetchCreditLedgerBalanceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchCreditLedgerBalanceQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, creditLedgerBalance?: string | null, creditLimitExceeded?: boolean | null } };

export type FundCustomerBalanceMutationVariables = Exact<{
  input: FundCustomerBalanceInput;
}>;


export type FundCustomerBalanceMutation = { __typename?: 'Mutation', fundCustomerBalance?: { __typename?: 'FundCustomerBalancePayload', creditLedgerType?: { __typename?: 'CreditLedger', success: boolean, error?: string | null, creditLedgerTransaction?: { __typename?: 'CreditLedgerTransaction', id: string, amount: number } | null } | null } | null };

export type CreateOrUpdateCustomerPortalConfigurationMutationVariables = Exact<{
  input: CreateOrUpdateCustomerPortalConfigurationInput;
}>;


export type CreateOrUpdateCustomerPortalConfigurationMutation = { __typename?: 'Mutation', createOrUpdateCustomerPortalConfiguration?: { __typename?: 'CreateOrUpdateCustomerPortalConfigurationPayload', success?: boolean | null, errors?: Array<string> | null, customerPortalConfiguration?: { __typename?: 'CustomerPortalConfiguration', id: string, landscapeLogoUrl?: string | null, squareLogoUrl?: string | null, primaryColor?: string | null, secondaryColor?: string | null, welcomeMessage?: string | null, notificationEmails?: string | null } | null } | null };

export type FetchCustomerPortalConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchCustomerPortalConfigQuery = { __typename?: 'Query', customerPortalConfig: { __typename?: 'CustomerPortalConfiguration', secondaryColor?: string | null, primaryColor?: string | null, landscapeLogoUrl?: string | null, squareLogoUrl?: string | null, welcomeMessage?: string | null, id: string, domains?: Array<string> | null, notificationEmails?: string | null, notificationPhones?: string | null, notificationChannels?: Array<string> | null } };

export type CreateOrderGroupsMutationVariables = Exact<{
  orderGroups: Array<OrderGroupInput> | OrderGroupInput;
}>;


export type CreateOrderGroupsMutation = { __typename?: 'Mutation', createOrderGroups?: { __typename?: 'CreateOrderGroupsPayload', orderGroups?: Array<{ __typename?: 'OrderGroup', id: string }> | null } | null };

export type CreateSiteRecurrenceMutationVariables = Exact<{
  input: CreateSiteRecurrenceInput;
}>;


export type CreateSiteRecurrenceMutation = { __typename?: 'Mutation', createSiteRecurrence?: { __typename?: 'CreateSiteRecurrencePayload', orderGroup?: { __typename?: 'OrderGroup', id: string } | null } | null };

export type FetchCustomerByIdForOrderQueryVariables = Exact<{
  customerId: Scalars['ID'];
}>;


export type FetchCustomerByIdForOrderQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, name?: string | null, address?: string | null, purchaseOrderType?: PurchaseOrderTypeEnum | null, customerBranches?: Array<{ __typename?: 'CustomerBranch', id: string, name?: string | null, email?: string | null, phone?: string | null, address?: string | null, purchaseOrder?: boolean | null, purchaseOrderType?: PurchaseOrderTypeEnum | null, deliveryInstruction?: string | null, site?: { __typename?: 'Site', address?: any | null } | null, storageAssets?: Array<{ __typename?: 'Asset', id: string, name?: string | null, category?: string | null, useInDelivery?: boolean | null, licensePlateNumber?: string | null, subscriptions?: Array<{ __typename?: 'Subscription', id: string, product: { __typename?: 'Product', id: string, name?: string | null } }> | null }> | null }> | null } };

export type FilteredCustomerBranchesForDropdownQueryVariables = Exact<{
  sorter?: InputMaybe<Array<CustomerBranchSorter> | CustomerBranchSorter>;
  perPage?: InputMaybe<Scalars['Int']>;
  offSet?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['ID']>;
}>;


export type FilteredCustomerBranchesForDropdownQuery = { __typename?: 'Query', filteredCustomerBranches: { __typename?: 'CustomerBranchCollection', collection: Array<{ __typename?: 'CustomerBranch', id: string, name?: string | null, address?: string | null, status?: boolean | null, deliveryInstruction?: string | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean } } };

export type FilteredCustomerBranchesShipToQueryVariables = Exact<{
  sorter?: InputMaybe<Array<CustomerBranchSorter> | CustomerBranchSorter>;
  perPage?: InputMaybe<Scalars['Int']>;
  offSet?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type FilteredCustomerBranchesShipToQuery = { __typename?: 'Query', filteredCustomerBranches: { __typename?: 'CustomerBranchCollection', collection: Array<{ __typename?: 'CustomerBranch', id: string, name?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean } } };

export type FilteredCustomersQueryVariables = Exact<{
  sorter?: InputMaybe<Array<BaseSorter> | BaseSorter>;
  perPage?: InputMaybe<Scalars['Int']>;
  offSet?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type FilteredCustomersQuery = { __typename?: 'Query', filteredCustomers: { __typename?: 'CustomerCollection', collection: Array<{ __typename?: 'Customer', id: string, name?: string | null, address?: string | null, erpId?: string | null, deliveryInstruction?: string | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean } } };

export type FetchFilteredRecurrenceOrdersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<OrderGroupSorter> | OrderGroupSorter>;
  filter?: InputMaybe<OrderGroupFilter>;
}>;


export type FetchFilteredRecurrenceOrdersQuery = { __typename?: 'Query', filteredOrderGroups: { __typename?: 'OrderGroupCollection', collection: Array<{ __typename?: 'OrderGroup', id: string, status: string, creatable?: { __typename?: 'Customer', type: 'Customer' } | { __typename?: 'Driver', type: 'Driver' } | { __typename?: 'UnknownGroupable', type: 'UnknownGroupable' } | { __typename?: 'User', name?: string | null, type: 'User' } | null, recurrenceData?: { __typename?: 'RecurrenceData', lastDelivery?: string | null, nextDate?: string | null, recurrence: { __typename?: 'RecurrenceOrderGroup', recurrenceFromTimestamp?: string | null, recurrenceType: Recurrence, recurrenceDates?: Array<string> | null, recurrenceDays?: Array<number> | null, recurrenceInterval?: number | null, recurrenceUntil?: string | null, recurrenceOccurrences?: number | null, recurrenceDaysOfWeek?: Array<DaysOfWeek> | null, recurrenceDaysInAdvance?: number | null, recurrenceAutoExpired?: boolean | null, recurrenceDayNthWeek?: { __typename?: 'RecurrenceDayNthWeek', sunday?: Array<number> | null, monday?: Array<number> | null, tuesday?: Array<number> | null, wednesday?: Array<number> | null, thursday?: Array<number> | null, friday?: Array<number> | null, saturday?: Array<number> | null } | null } } | null, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, status: string, source?: string | null, tenantName?: string | null, deliveryOrderLineItems: Array<{ __typename?: 'DeliveryOrderLineItem', id: string, topOff?: boolean | null, requestedVolume?: number | null, warehouseId?: string | null, warehouse?: { __typename?: 'Terminal', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name?: string | null, productType: string, shortName?: string | null, unit?: string | null, code?: string | null, colorCode?: string | null } | null, subscription?: { __typename?: 'Subscription', id: string, asset: { __typename?: 'Asset', id: string, name?: string | null, status?: string | null }, product: { __typename?: 'Product', id: string, name?: string | null } } | null }>, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, status?: boolean | null, customer?: { __typename?: 'Customer', id: string, name?: string | null } | null } | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type UpdateSiteRecurrenceMutationVariables = Exact<{
  input: UpdateSiteRecurrenceInput;
}>;


export type UpdateSiteRecurrenceMutation = { __typename?: 'Mutation', updateSiteRecurrence?: { __typename?: 'UpdateSiteRecurrencePayload', orderGroups?: Array<{ __typename?: 'OrderGroup', id: string }> | null } | null };

export type BulkAssignMutationVariables = Exact<{
  input: BatchOperationsInput;
}>;


export type BulkAssignMutation = { __typename?: 'Mutation', bulkAssigns?: { __typename?: 'BatchOperationsPayload', result?: { __typename?: 'BulkAssign', orderGroups?: Array<{ __typename?: 'Result', successIds?: Array<string> | null, failureIds?: Array<string> | null, errors?: Array<string> | null }> | null } | null } | null };

export type BulkOrderUnblockMutationVariables = Exact<{
  orderIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type BulkOrderUnblockMutation = { __typename?: 'Mutation', bulkOrderUnblocks?: { __typename?: 'UpdateStatusPayload', result?: { __typename?: 'BulkOrderUnblocksResult', successIds?: Array<string> | null, failureIds?: Array<string> | null, invalidIds?: Array<string> | null, errors?: Array<string> | null } | null } | null };

export type CcTenantsQueryVariables = Exact<{
  filter?: InputMaybe<CcTenantFilterInput>;
}>;


export type CcTenantsQuery = { __typename?: 'Query', ccTenants?: Array<{ __typename?: 'CcTenant', id: string, name: string, carrierTenant: { __typename?: 'Tenant', id: string } }> | null };

export type FetchCustomerTimeQueryVariables = Exact<{
  customerId: Scalars['ID'];
}>;


export type FetchCustomerTimeQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', resourceSchedule?: { __typename?: 'ResourceSchedule', availability?: Array<{ __typename?: 'Availability', day?: string | null, startTime?: string | null, endTime?: string | null }> | null } | null } };

export type FetchShipToTimeQueryVariables = Exact<{
  customerBranchId: Scalars['ID'];
}>;


export type FetchShipToTimeQuery = { __typename?: 'Query', customerBranch: { __typename?: 'CustomerBranch', resourceSchedule?: { __typename?: 'ResourceSchedule', availability?: Array<{ __typename?: 'Availability', day?: string | null, startTime?: string | null, endTime?: string | null, bestEndTime?: string | null, bestStartTime?: string | null }> | null } | null } };

export type FetchActiveCountQueryVariables = Exact<{
  filter?: InputMaybe<UnifiedTankFilterInput>;
}>;


export type FetchActiveCountQuery = { __typename?: 'Query', degreeDayTanks: { __typename?: 'UnifiedTankCollection', metadata: { __typename?: 'DegreeDayMetaDataQuery', totalCount?: number | null } } };

export type FetchFilterCustomerBranchQueryVariables = Exact<{
  isHub?: InputMaybe<Scalars['Boolean']>;
  searchText?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['ID']>;
}>;


export type FetchFilterCustomerBranchQuery = { __typename?: 'Query', filteredCustomerBranches: { __typename?: 'CustomerBranchCollection', collection: Array<{ __typename?: 'CustomerBranch', id: string, name?: string | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean } } };

export type FetchFilterCustomersQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type FetchFilterCustomersQuery = { __typename?: 'Query', filteredCustomers: { __typename?: 'CustomerCollection', collection: Array<{ __typename?: 'Customer', id: string, name?: string | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean } } };

export type FetchFilterOrderIdQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type FetchFilterOrderIdQuery = { __typename?: 'Query', filteredDeliveryOrderLineItems: { __typename?: 'DeliveryOrderLineItemCollection', collection: Array<{ __typename?: 'DeliveryOrderLineItem', id: string, deliveryOrder?: { __typename?: 'DeliveryOrder', orderGroup?: { __typename?: 'OrderGroup', id: string } | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean } } };

export type FetchFilterTanksQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type FetchFilterTanksQuery = { __typename?: 'Query', filteredAssets: { __typename?: 'AssetCollection', collection: Array<{ __typename?: 'Asset', id: string, name?: string | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean } } };

export type FetchOrderHistoryCountQueryVariables = Exact<{
  filter?: InputMaybe<DoliHistoryFilterInput>;
}>;


export type FetchOrderHistoryCountQuery = { __typename?: 'Query', filteredDeliveryOrderLineItems: { __typename?: 'DeliveryOrderLineItemCollection', metadata: { __typename?: 'MetaQuery', totalCount?: number | null } } };

export type CreateDegreeDaySettingMutationVariables = Exact<{
  input: Array<DegreeDaySettingInput> | DegreeDaySettingInput;
}>;


export type CreateDegreeDaySettingMutation = { __typename?: 'Mutation', createDegreeDaySetting?: { __typename?: 'CreateDegreeDaySettingPayload', errors: Array<string>, success: boolean, degreeDaySettings?: Array<{ __typename?: 'DegreeDaySetting', adjustmentUnit?: string | null, adjustmentQuantity?: number | null, assetId: number, autoOrdering?: boolean | null, createdAt: any, daysToEmptyThreshold?: number | null, degreeDayReset?: any | null, disabledAt?: any | null, enabled?: boolean | null, hubIds?: Array<number> | null, id: string, kFactor?: number | null, orderConfirmation?: boolean | null, orderNumber?: string | null, orderStatus?: string | null, purchaseOrderRequired?: boolean | null, safeLimit?: number | null, tankCapacity?: number | null, tankType?: string | null, tenantId: number, updatedAt: any }> | null } | null };

export type CreateAutoOrderMutationVariables = Exact<{
  input: Array<DegreeDaySettingInput> | DegreeDaySettingInput;
}>;


export type CreateAutoOrderMutation = { __typename?: 'Mutation', updateDegreeDaySetting?: { __typename?: 'UpdateDegreeDaySettingPayload', errors: Array<string>, success: boolean, degreeDaySettings?: Array<{ __typename?: 'DegreeDaySetting', id: string, assetId: number, autoOrdering?: boolean | null }> | null } | null };

export type CreateMultiOrderTopOffMutationVariables = Exact<{
  assetIds: Array<Scalars['ID']> | Scalars['ID'];
  isSelectAll?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateMultiOrderTopOffMutation = { __typename?: 'Mutation', createMultiOrderTopOff?: { __typename?: 'CreateMultiOrderTopOffPayload', success: boolean, errors: Array<string> } | null };

export type ConfirmOrCancelOrdersMutationVariables = Exact<{
  input: ConfirmOrCancelOrderInput;
}>;


export type ConfirmOrCancelOrdersMutation = { __typename?: 'Mutation', confirmOrCancelOrders?: { __typename?: 'ConfirmOrCancelOrdersPayload', errors: Array<string>, success: boolean } | null };

export type CreateManualOrderMutationVariables = Exact<{
  input: CreateOrderGroupsInput;
}>;


export type CreateManualOrderMutation = { __typename?: 'Mutation', createOrderGroups?: { __typename?: 'CreateOrderGroupsPayload', orderGroups?: Array<{ __typename?: 'OrderGroup', id: string, startedOn?: any | null, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string } | null }> | null } | null };

export type DegreeDaysActiveTanksListQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  sorter?: InputMaybe<Array<UnifiedTankSorter> | UnifiedTankSorter>;
  filter?: InputMaybe<UnifiedTankFilterInput>;
}>;


export type DegreeDaysActiveTanksListQuery = { __typename?: 'Query', degreeDayTanks: { __typename?: 'UnifiedTankCollection', collection: Array<{ __typename?: 'UnifiedTank', id: string, customerName?: string | null, shiptoName?: string | null, name?: string | null, autoOrdering?: boolean | null, tankCapacity?: number | null, daysToEmptyThreshold?: number | null, lastDeliveryDate?: any | null, orderStatus?: string | null, customerBranchId?: number | null, currentTankLevel?: number | null, customerId?: number | null, customerBranchAddress?: string | null, settingId?: string | null, avgDailyUsage?: number | null, kFactor?: number | null, avgDailyTemp?: number | null, totalDegreeDays?: number | null, hubName?: Array<string> | null, currentDegreeDaySetting?: { __typename?: 'DegreeDaySetting', id: string, orderNumber?: string | null, orderType?: string | null, autoOrdering?: boolean | null } | null, latestDegreeDay?: { __typename?: 'DegreeDay', degreeDaysPerDay?: number | null, createdAt: any, currentTankLevel?: number | null, gallonsDelivered?: number | null, estTillEmptyDays?: number | null, estimatedRunOutDate?: any | null } | null }>, metadata: { __typename?: 'DegreeDayMetaDataQuery', totalCount?: number | null, hasMore: boolean } } };

export type DegreeDaysInactiveTanksCountQueryVariables = Exact<{ [key: string]: never; }>;


export type DegreeDaysInactiveTanksCountQuery = { __typename?: 'Query', degreeDayTanks: { __typename?: 'UnifiedTankCollection', metadata: { __typename?: 'DegreeDayMetaDataQuery', totalCount?: number | null } } };

export type DegreeDaysInactiveTanksListQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  sorter?: InputMaybe<Array<UnifiedTankSorter> | UnifiedTankSorter>;
  filter?: InputMaybe<UnifiedTankFilterInput>;
}>;


export type DegreeDaysInactiveTanksListQuery = { __typename?: 'Query', degreeDayTanks: { __typename?: 'UnifiedTankCollection', collection: Array<{ __typename?: 'UnifiedTank', id: string, adjustmentUnit?: string | null, adjustmentQuantity?: number | null, customerName?: string | null, shiptoName?: string | null, name?: string | null, autoOrdering?: boolean | null, tankCapacity?: number | null, daysToEmptyThreshold?: number | null, customerBranchId?: number | null, customerId?: number | null, customerBranchAddress?: string | null, settingId?: string | null, kFactor?: number | null, avgDailyTemp?: number | null, totalDegreeDays?: number | null, disabledAt?: any | null, degreeDayReset?: any | null, enabled?: boolean | null, safeLimit?: number | null, currentDegreeDaySetting?: { __typename?: 'DegreeDaySetting', degreeDayReset?: any | null } | null }>, metadata: { __typename?: 'DegreeDayMetaDataQuery', totalCount?: number | null, hasMore: boolean } } };

export type DegreeDaysLowFuelTanksCountQueryVariables = Exact<{
  filter?: InputMaybe<UnifiedTankFilterInput>;
}>;


export type DegreeDaysLowFuelTanksCountQuery = { __typename?: 'Query', degreeDayTanks: { __typename?: 'UnifiedTankCollection', metadata: { __typename?: 'DegreeDayMetaDataQuery', totalCount?: number | null } } };

export type DegreeDaysSummaryReportQueryVariables = Exact<{
  assetId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
}>;


export type DegreeDaysSummaryReportQuery = { __typename?: 'Query', degreeDayReportSummary: any };

export type DegreeDaysViewReportQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<DegreeDaySorter> | DegreeDaySorter>;
  filter?: InputMaybe<DegreeDayFilterInput>;
}>;


export type DegreeDaysViewReportQuery = { __typename?: 'Query', degreeDays: { __typename?: 'DegreeDayCollection', collection: Array<{ __typename?: 'DegreeDay', id: string, orderGroupId?: number | null, deliveryDate?: any | null, kFactor?: number | null, gallonsDelivered?: number | null, degreeDaysPerDay?: number | null, cumulativeDegreeDays?: number | null }>, metadata: { __typename?: 'DegreeDayMetaDataQuery', hasMore: boolean, totalCount?: number | null } } };

export type FetchAssetDetailsForDegreeDaysQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchAssetDetailsForDegreeDaysQuery = { __typename?: 'Query', asset: { __typename?: 'Asset', id: string, tankSize?: string | null, subscriptions?: Array<{ __typename?: 'Subscription', id: string, product: { __typename?: 'Product', id: string, name?: string | null } }> | null } };

export type FetchDegreeDaySettingByAssetQueryVariables = Exact<{
  assetId: Scalars['Int'];
}>;


export type FetchDegreeDaySettingByAssetQuery = { __typename?: 'Query', degreeDaySettingByAsset?: { __typename?: 'DegreeDaySetting', adjustmentQuantity?: number | null, adjustmentUnit?: string | null, assetId: number, autoOrdering?: boolean | null, createdAt: any, daysToEmptyThreshold?: number | null, degreeDayReset?: any | null, disabledAt?: any | null, enabled?: boolean | null, hubIds?: Array<number> | null, id: string, gracePeriod?: number | null, gracePeriodType?: string | null, kFactor?: number | null, orderConfirmation?: boolean | null, orderNumber?: string | null, orderStatus?: string | null, purchaseOrderRequired?: boolean | null, safeLimit?: number | null, tankCapacity?: number | null, tankType?: string | null, tenantId: number, updatedAt: any, asset?: { __typename?: 'UnifiedTank', name?: string | null, customerName?: string | null, customerBranchAddress?: string | null } | null, preferenceAvailability?: Array<{ __typename?: 'DdPreferenceAvailability', bestEndTime?: string | null, bestStartTime?: string | null, day?: string | null, endTime?: string | null, preferredEndTime?: string | null, preferredStartTime?: string | null, startTime?: string | null }> | null } | null };

export type FetchFilteredApplicableFeesForDegreeDaysQueryVariables = Exact<{
  filter?: InputMaybe<ApplicableFeeFilter>;
}>;


export type FetchFilteredApplicableFeesForDegreeDaysQuery = { __typename?: 'Query', filteredApplicableFees: { __typename?: 'ApplicableFeeCollection', collection: Array<{ __typename?: 'ApplicableFee', id: string, isDefault?: boolean | null, price?: number | null, quantity?: number | null, fee?: { __typename?: 'Fee', id: string, code?: string | null, name?: string | null, price?: number | null, deleted?: boolean | null, applicableType?: string | null } | null }> } };

export type FilteredDeliveryOrderLineItemsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<DoliHistoryFilterInput>;
  sorter?: InputMaybe<Array<DeliveryOrderLineItemsSorter> | DeliveryOrderLineItemsSorter>;
}>;


export type FilteredDeliveryOrderLineItemsQuery = { __typename?: 'Query', filteredDeliveryOrderLineItems: { __typename?: 'DeliveryOrderLineItemCollection', collection: Array<{ __typename?: 'DeliveryOrderLineItem', id: string, volume?: number | null, source: string, deliveryDateTimestamp?: number | null, asset?: { __typename?: 'Asset', name?: string | null } | null, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null } | null } | null, orderGroup?: { __typename?: 'OrderGroup', id: string, startOn?: any | null, createdAtTimestamp: number, status: string } | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null } } };

export type GetDegreeDaysViewReportCsvQueryVariables = Exact<{
  assetId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
}>;


export type GetDegreeDaysViewReportCsvQuery = { __typename?: 'Query', degreeDaysCsv?: { __typename?: 'DoliCsv', fileName?: string | null, content?: string | null, error?: string | null } | null };

export type GetDeliveryOrderLineItemCsvQueryVariables = Exact<{
  customerBranchId?: InputMaybe<Scalars['ID']>;
  assetId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<Array<StatusTypeEnum> | StatusTypeEnum>;
}>;


export type GetDeliveryOrderLineItemCsvQuery = { __typename?: 'Query', deliveryOrderLineItemCsv?: { __typename?: 'DoliCsv', fileName?: string | null, content?: string | null, error?: string | null } | null };

export type UpdateDegreeDaySettingMutationVariables = Exact<{
  input: Array<DegreeDaySettingInput> | DegreeDaySettingInput;
}>;


export type UpdateDegreeDaySettingMutation = { __typename?: 'Mutation', updateDegreeDaySetting?: { __typename?: 'UpdateDegreeDaySettingPayload', errors: Array<string>, success: boolean, degreeDaySettings?: Array<{ __typename?: 'DegreeDaySetting', adjustmentQuantity?: number | null, adjustmentUnit?: string | null, assetId: number, autoOrdering?: boolean | null, createdAt: any, daysToEmptyThreshold?: number | null, degreeDayReset?: any | null, disabledAt?: any | null, enabled?: boolean | null, hubIds?: Array<number> | null, id: string, kFactor?: number | null, orderConfirmation?: boolean | null, orderNumber?: string | null, orderStatus?: string | null, purchaseOrderRequired?: boolean | null, safeLimit?: number | null, tankCapacity?: number | null, tankType?: string | null, tenantId: number, updatedAt: any }> | null } | null };

export type CreateOrUpdateQrMutationVariables = Exact<{
  input: CreateOrUpdateQrCodeInput;
}>;


export type CreateOrUpdateQrMutation = { __typename?: 'Mutation', createOrUpdateQrCode?: { __typename?: 'CreateOrUpdateQrCodePayload', qrCode?: { __typename?: 'QrCode', id: string, code?: string | null, image?: string | null } | null } | null };

export type FetchFilteredDriversQueryVariables = Exact<{
  sorter?: InputMaybe<Array<DriverSorter> | DriverSorter>;
}>;


export type FetchFilteredDriversQuery = { __typename?: 'Query', filteredDrivers: { __typename?: 'DriverCollection', metadata: { __typename?: 'MetaQuery', hasMore: boolean }, collection: Array<{ __typename?: 'Driver', id: string, name?: string | null, group?: { __typename?: 'Group', id: string, name: string } | null }> } };

export type FilteredQrCodesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<QrCodeSorter> | QrCodeSorter>;
  filter?: InputMaybe<QrCodeFilter>;
}>;


export type FilteredQrCodesQuery = { __typename?: 'Query', filteredQrCodes: { __typename?: 'QrCodeCollection', collection: Array<{ __typename?: 'QrCode', id: string, code?: string | null, image?: string | null, purpose?: string | null }>, metadata: { __typename?: 'MetaQuery', totalCount?: number | null, hasMore: boolean } } };

export type GenerateQrCodesMutationVariables = Exact<{
  input: GenerateQrCodesInput;
}>;


export type GenerateQrCodesMutation = { __typename?: 'Mutation', generateQrCodes?: { __typename?: 'GenerateQrCodesPayload', qrCodePdfString?: string | null } | null };

export type CreateLeaseEquipmentOrderMutationVariables = Exact<{
  input: CreateOrderGroupInput;
}>;


export type CreateLeaseEquipmentOrderMutation = { __typename?: 'Mutation', createOrderGroup?: { __typename?: 'CreateOrderGroupPayload', orderGroup?: { __typename?: 'OrderGroup', id: string } | null } | null };

export type CreateOrUpdateFormProgressMutationVariables = Exact<{
  input: FormProgressInput;
}>;


export type CreateOrUpdateFormProgressMutation = { __typename?: 'Mutation', createOrUpdateFormProgress?: { __typename?: 'CreateOrUpdateFormProgressPayload', errors: Array<string>, formProgress?: { __typename?: 'FormProgress', id: string, currentStep?: FormProgressCurrentStepTypeEnum | null, formData?: any | null, formType?: FormProgressTypeEnum | null } | null } | null };

export type FetchCompartmentDataForLeoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchCompartmentDataForLeoQuery = { __typename?: 'Query', asset: { __typename?: 'Asset', id: string, compartments?: Array<{ __typename?: 'Compartment', id: string, name?: string | null, erpId?: string | null, subscriptionProducts?: Array<{ __typename?: 'Product', id: string, name?: string | null }> | null, capacities?: Array<{ __typename?: 'Capacity', id: string, unit: string, value: number, fuelType: string, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null }> | null } };

export type FilteredDriversForLeoQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  all?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<Array<DriverSorter> | DriverSorter>;
  driverTypes?: InputMaybe<Array<DriverTypeEnum> | DriverTypeEnum>;
}>;


export type FilteredDriversForLeoQuery = { __typename?: 'Query', filteredDrivers: { __typename?: 'DriverCollection', collection: Array<{ __typename?: 'Driver', id: string, name?: string | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null } } };

export type FetchFeesForLeoQueryVariables = Exact<{
  filter?: InputMaybe<FeeFilter>;
}>;


export type FetchFeesForLeoQuery = { __typename?: 'Query', filteredFees: { __typename?: 'FeeCollection', collection: Array<{ __typename?: 'Fee', id: string, name?: string | null, defaultMovementFee?: boolean | null }> } };

export type FetchFormProgressQueryVariables = Exact<{
  formType: FormProgressTypeEnum;
}>;


export type FetchFormProgressQuery = { __typename?: 'Query', formProgresses?: { __typename?: 'FormProgress', id: string, currentStep?: FormProgressCurrentStepTypeEnum | null, formData?: any | null, formType?: FormProgressTypeEnum | null } | null };

export type FetchLeasedAssetsForLeoQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<AssetSorter> | AssetSorter>;
  customFilter?: InputMaybe<AssetFilter>;
}>;


export type FetchLeasedAssetsForLeoQuery = { __typename?: 'Query', filteredAssets: { __typename?: 'AssetCollection', collection: Array<{ __typename?: 'Asset', id: string, status?: string | null, name?: string | null, category?: string | null, qrCodeText?: string | null, licensePlateNumber?: string | null, activeLease?: boolean | null, tankType?: string | null, tankSize?: string | null, compartments?: Array<{ __typename?: 'Compartment', id: string, name?: string | null }> | null, assetProductCategories?: Array<{ __typename?: 'AssetProductCategory', productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null, tankMonitor?: { __typename?: 'Device', id: string, name?: string | null, deviceId: string, deviceProvider?: string | null } | null, assetsPeripherals?: Array<{ __typename?: 'AssetsPeripheral', id: string, peripheralId: string, assetsPeripheralsRecords?: Array<{ __typename?: 'AssetsPeripheralsRecord', id: string, peripheralAttributeId: number, value?: string | null }> | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null } } };

export type LineOfServicesForLeoQueryVariables = Exact<{ [key: string]: never; }>;


export type LineOfServicesForLeoQuery = { __typename?: 'Query', lineOfServices: Array<{ __typename?: 'LineOfService', id: string, nameWithAncestors?: string | null }> };

export type FetchProductCategoriesForLeoQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchProductCategoriesForLeoQuery = { __typename?: 'Query', productCategories: Array<{ __typename?: 'ProductCategory', id: string, name?: string | null }> };

export type FetchYardForLeoQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  customerId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  isHub?: InputMaybe<Scalars['Boolean']>;
  all?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type FetchYardForLeoQuery = { __typename?: 'Query', filteredCustomerBranches: { __typename?: 'CustomerBranchCollection', collection: Array<{ __typename?: 'CustomerBranch', id: string, name?: string | null, isHub?: boolean | null, address?: string | null, status?: boolean | null, availableRentalAssetsCount?: number | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type RemoveFormProgressMutationVariables = Exact<{
  orderType: MovementOrderTypeEnum;
}>;


export type RemoveFormProgressMutation = { __typename?: 'Mutation', removeFormProgress?: { __typename?: 'RemoveFormProgressPayload', success: boolean } | null };

export type UnlinkTankMonitorMutationVariables = Exact<{
  assetId: Scalars['ID'];
  plannedTime: Scalars['Int'];
}>;


export type UnlinkTankMonitorMutation = { __typename?: 'Mutation', unlinkTankMonitor?: { __typename?: 'UnlinkTankMonitorPayload', success: boolean } | null };

export type CreateOrUpdateNotificationTemplateMutationVariables = Exact<{
  data: NotificationTemplateInput;
}>;


export type CreateOrUpdateNotificationTemplateMutation = { __typename?: 'Mutation', createOrUpdateNotificationTemplate?: { __typename?: 'CreateOrUpdateNotificationTemplatePayload', success?: boolean | null, errors?: Array<string> | null, notificationTemplate?: { __typename?: 'NotificationTemplate', id: string, notificationType: string, orderStatus: string, status: string, subject?: string | null, body: string, logoUrl?: string | null, variables?: Array<string> | null } | null } | null };

export type GetNotificationTemplateQueryVariables = Exact<{
  notificationType: Scalars['String'];
  orderStatus: Scalars['String'];
}>;


export type GetNotificationTemplateQuery = { __typename?: 'Query', notificationTemplate?: { __typename?: 'NotificationTemplate', id: string, notificationType: string, orderStatus: string, status: string, subject?: string | null, body: string, logoUrl?: string | null, variables?: Array<string> | null } | null };

export type GetNotificationTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationTemplatesQuery = { __typename?: 'Query', notificationTemplates?: Array<{ __typename?: 'NotificationTemplate', id: string, notificationType: string, orderStatus: string, status: string, subject?: string | null, body: string, logoUrl?: string | null, variables?: Array<string> | null }> | null };

export type SendTestNotificationTemplateMutationVariables = Exact<{
  input: SendTestNotificationTemplateInput;
}>;


export type SendTestNotificationTemplateMutation = { __typename?: 'Mutation', sendTestNotificationTemplate?: { __typename?: 'SendTestNotificationTemplatePayload', success?: boolean | null, errors?: Array<string> | null } | null };

export type UpdateNotificationTemplateStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: Scalars['String'];
}>;


export type UpdateNotificationTemplateStatusMutation = { __typename?: 'Mutation', updateNotificationTemplateStatus?: { __typename?: 'UpdateNotificationTemplateStatusPayload', success?: boolean | null, errors?: Array<string> | null, notificationTemplate?: { __typename?: 'NotificationTemplate', id: string, status: string } | null } | null };

export type CreateNewLeaCoreMutationVariables = Exact<{
  input: CreateLeaCoreInput;
}>;


export type CreateNewLeaCoreMutation = { __typename?: 'Mutation', createLeaCore?: { __typename?: 'CreateLeaCorePayload', leaType?: { __typename?: 'Lea', success: boolean, error?: string | null, leaCore?: { __typename?: 'LeaCore', id: string, state?: LeaCoreStateEnum | null, leaNumber?: string | null, createdAtTimestamp?: number | null, customer?: { __typename?: 'Customer', id: string, name?: string | null } | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null, interactionProgresses?: Array<{ __typename?: 'InteractionProgress', completed?: boolean | null, currentStep?: number | null, data?: any | null, id?: string | null, subModule?: InteractionProgressEnum | null, totalStep?: number | null }> | null, leaQuestionnaire?: { __typename?: 'LeaQuestionnaire', id: string, data?: { __typename?: 'LeaQuestionnaireData', customer?: { __typename?: 'Customer', id: string } | null } | null } | null } | null } | null } | null };

export type CreateLeaMovementOrderMutationVariables = Exact<{
  input: CreateLeaMovementOrdersInput;
}>;


export type CreateLeaMovementOrderMutation = { __typename?: 'Mutation', createLeaMovementOrders?: { __typename?: 'CreateLeaMovementOrdersPayload', leaType: { __typename?: 'Lea', success: boolean, error?: string | null, leaCore?: { __typename?: 'LeaCore', leaLineItems?: Array<{ __typename?: 'LeaLineItem', movementOrder?: { __typename?: 'MovementOrder', id: string, requestedTankSize?: string | null, requestedTankType?: string | null, asset?: { __typename?: 'Asset', name?: string | null, averageUtilization?: number | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null } | null, assetMovementLocation?: { __typename?: 'AssetMovementLocation', lat?: string | null, lng?: string | null } | null, orderGroup: { __typename?: 'OrderGroup', status: string, startOn?: any | null } } | null }> | null } | null } } | null };

export type FetchAssetDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchAssetDetailsQuery = { __typename?: 'Query', leaCore: { __typename?: 'LeaCore', id: string, plannedDate?: number | null, createdAtTimestamp?: number | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null, leaLineItems?: Array<{ __typename?: 'LeaLineItem', id: string, requestTankType?: string | null, requestTankSize?: number | null, status?: LeaLineItemStatusEnum | null, unitCost?: number | null, requestProduct?: { __typename?: 'Product', id: string, name?: string | null } | null, customItemData?: Array<{ __typename?: 'LeaCoreCustomItem', name?: string | null, qty?: number | null, unitCost?: number | null }> | null, leaPeripherals?: Array<{ __typename?: 'LeaPeripheral', id: string, quantity?: number | null, notes?: string | null, status?: LeaPeripheralStatusEnum | null, unitCost?: number | null, peripheral?: { __typename?: 'Peripheral', id: string, soldAs?: string | null } | null }> | null, leaAppliedFees?: Array<{ __typename?: 'LeaAppliedFee', id: string, applicableFee?: { __typename?: 'ApplicableFee', fee?: { __typename?: 'Fee', name?: string | null } | null } | null }> | null, movementOrder?: { __typename?: 'MovementOrder', id: string, requestedTankSize?: string | null, requestedTankType?: string | null, asset?: { __typename?: 'Asset', id: string, name?: string | null } | null, orderGroup: { __typename?: 'OrderGroup', id: string, startOn?: any | null, status: string }, assetMovementLocation?: { __typename?: 'AssetMovementLocation', lat?: string | null, lng?: string | null } | null } | null }> | null } };

export type FetchChildLeaCoreQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchChildLeaCoreQuery = { __typename?: 'Query', leaCore: { __typename?: 'LeaCore', id: string, leaNumber?: string | null, plannedDate?: number | null, status?: LeaStatusEnum | null, state?: LeaCoreStateEnum | null, customer?: { __typename?: 'Customer', id: string, name?: string | null } | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null, childLeaCore?: { __typename?: 'LeaCore', id: string, leaNumber?: string | null, plannedDate?: number | null, status?: LeaStatusEnum | null, data?: { __typename?: 'LeaCoreData', computedMovementOrderIds?: Array<number> | null, computedSettledMovementOrderIds?: Array<number> | null } | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null, customer?: { __typename?: 'Customer', id: string, name?: string | null } | null, leaLineItems?: Array<{ __typename?: 'LeaLineItem', id: string, status?: LeaLineItemStatusEnum | null, requestTankSize?: number | null, requestTankType?: string | null, unitCost?: number | null, reasonType?: string | null, descriptiveReason?: string | null, leaLineItemsNotes?: string | null, asset?: { __typename?: 'Asset', id: string, name?: string | null, site?: { __typename?: 'Site', lat?: string | null, lng?: string | null } | null } | null, customItemData?: Array<{ __typename?: 'LeaCoreCustomItem', name?: string | null, qty?: number | null, unitCost?: number | null }> | null, requestProduct?: { __typename?: 'Product', id: string, name?: string | null, shortName?: string | null } | null, leaPeripherals?: Array<{ __typename?: 'LeaPeripheral', id: string, quantity?: number | null, unitCost?: number | null, notes?: string | null, status?: LeaPeripheralStatusEnum | null, peripheral?: { __typename?: 'Peripheral', id: string, soldAs?: string | null, peripheralCategory?: { __typename?: 'PeripheralCategory', id: string, name?: string | null } | null } | null }> | null, leaAppliedFees?: Array<{ __typename?: 'LeaAppliedFee', id: string, applicableFee?: { __typename?: 'ApplicableFee', id: string, fee?: { __typename?: 'Fee', id: string, name?: string | null } | null } | null }> | null, movementOrder?: { __typename?: 'MovementOrder', id: string, requestedTankSize?: string | null, requestedTankType?: string | null, asset?: { __typename?: 'Asset', name?: string | null, averageUtilization?: number | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null } | null, assetMovementLocation?: { __typename?: 'AssetMovementLocation', lat?: string | null, lng?: string | null } | null, orderGroup: { __typename?: 'OrderGroup', status: string, startOn?: any | null } } | null }> | null } | null } };

export type FetchFilteredAssetReportQueryVariables = Exact<{
  filter?: InputMaybe<LeaReportFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type FetchFilteredAssetReportQuery = { __typename?: 'Query', filteredLeaReport: { __typename?: 'MovementOrderCollection', collection: Array<{ __typename?: 'MovementOrder', id: string, requestedTankSize?: string | null, totalDeliveriesCount?: number | null, totalGallonsDelivered?: number | null, orderGroup: { __typename?: 'OrderGroup', id: string, status: string, createdAtTimestamp: number, startedOnTimestamp?: number | null, completedOnTimestamp?: number | null }, asset?: { __typename: 'Asset', id: string, name?: string | null, status?: string | null, erpId?: string | null, tankSize?: string | null, category?: string | null, licensePlateNumber?: string | null } | null, toCustomerBranch: { __typename?: 'CustomerBranch', erpId?: string | null, name?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null } | null }, leaLineItem?: { __typename?: 'LeaLineItem', gallonPerMonth?: string | null, marginPerGallonInCents?: string | null, bdrCommissionInPercent?: string | null, requestProduct?: { __typename?: 'Product', id: string, name?: string | null } | null, leaCore?: { __typename?: 'LeaCore', parentLeaCore?: { __typename?: 'LeaCore', isSigned?: boolean | null, leaQuestionnaire?: { __typename?: 'LeaQuestionnaire', salesRepresentative?: { __typename?: 'User', id: string, name?: string | null } | null } | null } | null } | null } | null }>, metadata: { __typename?: 'MetaQuery', totalCount?: number | null } } };

export type FilteredRoiReportQueryVariables = Exact<{
  filter?: InputMaybe<LeaLineItemFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type FilteredRoiReportQuery = { __typename?: 'Query', filteredLeaRoiReport: { __typename?: 'LeaLineItemCollection', collection: Array<{ __typename?: 'LeaLineItem', id: string, estimatedRoi?: string | null, customItemData?: Array<{ __typename?: 'LeaCoreCustomItem', name?: string | null }> | null, leaCore?: { __typename?: 'LeaCore', customer?: { __typename?: 'Customer', name?: string | null } | null, data?: { __typename?: 'LeaCoreData', expiryDurationDays?: number | null } | null } | null, asset?: { __typename?: 'Asset', id: string, name?: string | null } | null, leaPeripherals?: Array<{ __typename?: 'LeaPeripheral', peripheral?: { __typename?: 'Peripheral', soldAs?: string | null } | null }> | null, equipmentsData?: { __typename?: 'LeaCoreEquipments', finalTotalCost?: number | null } | null }>, metadata: { __typename?: 'MetaQuery', totalCount?: number | null } } };

export type FetchLeaCoreQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchLeaCoreQuery = { __typename?: 'Query', leaCore: { __typename?: 'LeaCore', id: string, leaNumber?: string | null, plannedDate?: number | null, createdAtTimestamp?: number | null, status?: LeaStatusEnum | null, termAndCondition?: string | null, data?: { __typename?: 'LeaCoreData', expiryDurationDays?: number | null, expiryUnit?: string | null, expiryReminderDays?: number | null, reminderEmails?: Array<string> | null, computedMovementOrderIds?: Array<number> | null, computedSettledMovementOrderIds?: Array<number> | null, leaCoreNotes?: string | null } | null, childLeaCore?: { __typename?: 'LeaCore', id: string, data?: { __typename?: 'LeaCoreData', computedMovementOrderIds?: Array<number> | null, computedSettledMovementOrderIds?: Array<number> | null } | null } | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null, customer?: { __typename?: 'Customer', id: string, name?: string | null } | null, leaLineItems?: Array<{ __typename?: 'LeaLineItem', id: string, leaLineItemsNotes?: string | null, reasonType?: string | null, descriptiveReason?: string | null, gallonPerMonth?: string | null, gallonPerVisit?: string | null, assetPositionNumber?: number | null, requestTankType?: string | null, requestTankSize?: number | null, status?: LeaLineItemStatusEnum | null, percentageOfCogs?: string | null, estimatedAssetValue?: string | null, estimatedMargin?: string | null, marginInPercentage?: string | null, marginPerGallonInCents?: string | null, totalMarginPerMonth?: string | null, bdrCommissionInPercent?: string | null, effectiveMarginInDollar?: string | null, effectiveMarginInPercent?: string | null, estimatedRoi?: string | null, unitCost?: number | null, equipmentsData?: { __typename?: 'LeaCoreEquipments', finalTotalCost?: number | null, assetTankTypes?: Array<{ __typename?: 'RoiEquipments', name?: string | null, quantity?: number | null, unitCost?: number | null, totalCost?: number | null }> | null, peripherals?: Array<{ __typename?: 'RoiEquipments', name?: string | null, quantity?: number | null, unitCost?: number | null, totalCost?: number | null }> | null, customItems?: Array<{ __typename?: 'RoiEquipments', name?: string | null, quantity?: number | null, unitCost?: number | null, totalCost?: number | null }> | null } | null, movementOrder?: { __typename?: 'MovementOrder', id: string, requestedTankSize?: string | null, requestedTankType?: string | null, assignedTankSize?: string | null, assignedTankType?: string | null, orderGroup: { __typename?: 'OrderGroup', id: string, status: string, startOnTimestamp?: number | null, createdAtTimestamp: number, completedOnTimestamp?: number | null, driver?: { __typename?: 'Driver', id: string, name?: string | null } | null, user?: { __typename?: 'User', id: string, name?: string | null } | null }, product?: { __typename?: 'Product', id: string, shortName?: string | null } | null, assetMovementLocation?: { __typename?: 'AssetMovementLocation', id: string, lat?: string | null, lng?: string | null, orderGroupId?: string | null } | null, asset?: { __typename?: 'Asset', id: string, name?: string | null } | null, toCustomerBranch: { __typename?: 'CustomerBranch', id: string, name?: string | null, customer?: { __typename?: 'Customer', name?: string | null } | null }, fromCustomerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, customer?: { __typename?: 'Customer', name?: string | null } | null } | null } | null, asset?: { __typename?: 'Asset', id: string, name?: string | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null } | null, requestProduct?: { __typename?: 'Product', id: string, name?: string | null, shortName?: string | null } | null, leaPeripherals?: Array<{ __typename?: 'LeaPeripheral', id: string, quantity?: number | null, notes?: string | null, unitCost?: number | null, status?: LeaPeripheralStatusEnum | null, peripheral?: { __typename?: 'Peripheral', id: string, soldAs?: string | null, peripheralCategory?: { __typename?: 'PeripheralCategory', id: string, name?: string | null } | null } | null }> | null, customItemData?: Array<{ __typename?: 'LeaCoreCustomItem', name?: string | null, qty?: number | null, unitCost?: number | null }> | null, leaAppliedFees?: Array<{ __typename?: 'LeaAppliedFee', id: string, applicableFee?: { __typename?: 'ApplicableFee', id: string, fee?: { __typename?: 'Fee', id: string, name?: string | null } | null } | null }> | null }> | null, interactionProgresses?: Array<{ __typename?: 'InteractionProgress', completed?: boolean | null, currentStep?: number | null, data?: any | null, id?: string | null, subModule?: InteractionProgressEnum | null, totalStep?: number | null }> | null, leaQuestionnaire?: { __typename?: 'LeaQuestionnaire', id: string, leaManager?: { __typename?: 'User', id: string, name?: string | null } | null, customerRepresentative?: { __typename?: 'CustomerRepresentative', billingAddress?: string | null, city?: string | null, email?: string | null, name?: string | null, phone?: string | null, state?: string | null, zipCode?: string | null } | null, salesRepresentative?: { __typename?: 'User', id: string, name?: string | null, email: string, phone?: string | null } | null, leaQuestionnaireAssets?: Array<{ __typename?: 'LeaQuestionnaireAsset', gallonPerMonth?: string | null, gallonPerDelivery?: string | null, tankSize?: string | null, product?: { __typename?: 'Product', id: string, name?: string | null } | null }> | null, data?: { __typename?: 'LeaQuestionnaireData', notes?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null } | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null } | null } | null } };

export type FetchLeaListQueryVariables = Exact<{
  filter?: InputMaybe<LeaCoreFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<LeaCoreSorter>;
}>;


export type FetchLeaListQuery = { __typename?: 'Query', filteredLeas: { __typename?: 'LeaCoreCollection', collection: Array<{ __typename?: 'LeaCore', id: string, state?: LeaCoreStateEnum | null, leaNumber?: string | null, createdAtTimestamp?: number | null, customer?: { __typename?: 'Customer', id: string, name?: string | null } | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null, interactionProgresses?: Array<{ __typename?: 'InteractionProgress', completed?: boolean | null, currentStep?: number | null, data?: any | null, id?: string | null, subModule?: InteractionProgressEnum | null, totalStep?: number | null }> | null, leaQuestionnaire?: { __typename?: 'LeaQuestionnaire', id: string, data?: { __typename?: 'LeaQuestionnaireData', customer?: { __typename?: 'Customer', id: string, name?: string | null } | null } | null } | null }>, metadata: { __typename?: 'MetaQuery', totalCount?: number | null, hasMore: boolean } } };

export type FetchLeaMovementOrdersQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchLeaMovementOrdersQuery = { __typename?: 'Query', leaCore: { __typename?: 'LeaCore', id: string, leaLineItems?: Array<{ __typename?: 'LeaLineItem', id: string, movementOrder?: { __typename?: 'MovementOrder', id: string, requestedTankSize?: string | null, requestedTankType?: string | null, assignedTankSize?: string | null, assignedTankType?: string | null, orderGroup: { __typename?: 'OrderGroup', id: string, status: string, startOnTimestamp?: number | null, createdAtTimestamp: number, completedOnTimestamp?: number | null, driver?: { __typename?: 'Driver', id: string, name?: string | null } | null, user?: { __typename?: 'User', id: string, name?: string | null } | null }, product?: { __typename?: 'Product', id: string, shortName?: string | null } | null, assetMovementLocation?: { __typename?: 'AssetMovementLocation', id: string, lat?: string | null, lng?: string | null, orderGroupId?: string | null } | null, asset?: { __typename?: 'Asset', id: string, name?: string | null } | null, toCustomerBranch: { __typename?: 'CustomerBranch', id: string, name?: string | null, customer?: { __typename?: 'Customer', name?: string | null } | null }, fromCustomerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, customer?: { __typename?: 'Customer', name?: string | null } | null } | null } | null }> | null } };

export type FetchLeaRequestedAssetsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<AssetSorter> | AssetSorter>;
  filter?: InputMaybe<AssetFilter>;
}>;


export type FetchLeaRequestedAssetsQuery = { __typename?: 'Query', filteredAssets: { __typename?: 'AssetCollection', collection: Array<{ __typename?: 'Asset', id: string, status?: string | null, name?: string | null, qrCodeText?: string | null, type?: string | null, tankSize?: string | null, tankType?: string | null, averageUtilization?: number | null, lastDeliveredTimestamp?: number | null, lastActiveTenantId?: string | null, actualRoi?: number | null, expectedRoi?: number | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FetchLeaTenantContentQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchLeaTenantContentQuery = { __typename?: 'Query', fetchLeaTenantContent?: { __typename?: 'TenantContent', content?: string | null, data?: any | null, updatedAt?: any | null, documentType: TenantContentDocumentTypeEnum, title?: string | null, tenant: { __typename?: 'Tenant', name?: string | null } } | null };

export type FetchPostSignaturesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchPostSignaturesQuery = { __typename?: 'Query', leaCore: { __typename?: 'LeaCore', id: string, isSigned?: boolean | null, status?: LeaStatusEnum | null, leaNumber?: string | null, data?: { __typename?: 'LeaCoreData', computedMovementOrderIds?: Array<number> | null, computedSettledMovementOrderIds?: Array<number> | null } | null, previewDocument?: { __typename?: 'LeaDocument', fileName?: string | null, content?: string | null, error?: string | null } | null, leaPostSignatures?: Array<{ __typename?: 'PandaDocument', id: string, fileUrl?: string | null, fileData?: string | null, fileName?: string | null, createdAt?: number | null, documentType?: string | null, documentableId?: string | null, leaUpdatedById?: string | null, leaDocumentType?: string | null, leaCreatedByName?: string | null, leaSignedDocument?: boolean | null }> | null } };

export type FetchFilteredApplicableFeesQueryVariables = Exact<{
  feeableId?: InputMaybe<Scalars['ID']>;
}>;


export type FetchFilteredApplicableFeesQuery = { __typename?: 'Query', filteredApplicableFees: { __typename?: 'ApplicableFeeCollection', collection: Array<{ __typename?: 'ApplicableFee', id: string, isDefault?: boolean | null, price?: number | null, quantity?: number | null, fee?: { __typename?: 'Fee', id: string, code?: string | null, name?: string | null, price?: number | null, deleted?: boolean | null, applicableType?: string | null } | null }> } };

export type FilteredApplicableFeesByCustomerBranchQueryVariables = Exact<{
  customerId?: InputMaybe<Scalars['ID']>;
}>;


export type FilteredApplicableFeesByCustomerBranchQuery = { __typename?: 'Query', filteredCustomerBranches: { __typename?: 'CustomerBranchCollection', collection: Array<{ __typename?: 'CustomerBranch', id: string, name?: string | null, applicableFees?: Array<{ __typename?: 'ApplicableFee', id: string, fee?: { __typename?: 'Fee', id: string, name?: string | null, applicableType?: string | null } | null }> | null }> } };

export type FilteredLeasQueryVariables = Exact<{
  filter?: InputMaybe<LeaCoreFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<LeaCoreSorter>;
}>;


export type FilteredLeasQuery = { __typename?: 'Query', filteredLeas: { __typename?: 'LeaCoreCollection', collection: Array<{ __typename?: 'LeaCore', id: string, leaNumber?: string | null, plannedDate?: number | null, status?: LeaStatusEnum | null, isSigned?: boolean | null, state?: LeaCoreStateEnum | null, createdAtTimestamp?: number | null, interactionProgresses?: Array<{ __typename?: 'InteractionProgress', completed?: boolean | null, currentStep?: number | null, data?: any | null, id?: string | null, subModule?: InteractionProgressEnum | null, totalStep?: number | null }> | null, customer?: { __typename?: 'Customer', id: string, name?: string | null } | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null, data?: { __typename?: 'LeaCoreData', expiryDurationDays?: number | null, expiryReminderDays?: number | null, reminderEmails?: Array<string> | null } | null, leaLineItems?: Array<{ __typename?: 'LeaLineItem', id: string, requestTankSize?: number | null, requestTankType?: string | null, status?: LeaLineItemStatusEnum | null, marginInPercentage?: string | null, estimatedMargin?: string | null, estimatedAssetValue?: string | null, percentageOfCogs?: string | null, marginPerGallonInCents?: string | null, totalMarginPerMonth?: string | null, bdrCommissionInPercent?: string | null, effectiveMarginInDollar?: string | null, effectiveMarginInPercent?: string | null, estimatedRoi?: string | null, gallonPerMonth?: string | null, gallonPerVisit?: string | null, unitCost?: number | null, requestProduct?: { __typename?: 'Product', id: string, name?: string | null } | null, leaPeripherals?: Array<{ __typename?: 'LeaPeripheral', id: string, quantity?: number | null, notes?: string | null, unitCost?: number | null, status?: LeaPeripheralStatusEnum | null, peripheral?: { __typename?: 'Peripheral', id: string, soldAs?: string | null, subType?: string | null, peripheralCategory?: { __typename?: 'PeripheralCategory', id: string, name?: string | null } | null } | null }> | null, customItemData?: Array<{ __typename?: 'LeaCoreCustomItem', name?: string | null, qty?: number | null, unitCost?: number | null }> | null, movementOrder?: { __typename?: 'MovementOrder', id: string, requestedTankSize?: string | null, requestedTankType?: string | null, assignedTankSize?: string | null, assignedTankType?: string | null, orderGroup: { __typename?: 'OrderGroup', id: string, status: string, driver?: { __typename?: 'Driver', id: string, name?: string | null } | null, user?: { __typename?: 'User', id: string, name?: string | null } | null }, product?: { __typename?: 'Product', id: string, shortName?: string | null } | null, asset?: { __typename?: 'Asset', id: string, name?: string | null } | null, toCustomerBranch: { __typename?: 'CustomerBranch', id: string, name?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null } | null }, fromCustomerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null } | null } | null } | null }> | null, leaPreSignatures?: Array<{ __typename?: 'PandaDocument', id: string, createdAt?: number | null, fileName?: string | null, fileUrl?: string | null, leaCreatedByName?: string | null, leaUpdatedById?: string | null, documentType?: string | null, leaDocumentType?: string | null, leaSignedDocument?: boolean | null }> | null, leaPostSignatures?: Array<{ __typename?: 'PandaDocument', id: string, createdAt?: number | null, fileName?: string | null, fileUrl?: string | null, leaCreatedByName?: string | null, leaUpdatedById?: string | null, documentType?: string | null, leaDocumentType?: string | null, leaSignedDocument?: boolean | null }> | null, leaQuestionnaire?: { __typename?: 'LeaQuestionnaire', id: string, data?: { __typename?: 'LeaQuestionnaireData', customer?: { __typename?: 'Customer', id: string, name?: string | null } | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null } | null, leaManager?: { __typename?: 'User', name?: string | null } | null, customerRepresentative?: { __typename?: 'CustomerRepresentative', name?: string | null } | null, salesRepresentative?: { __typename?: 'User', name?: string | null } | null, leaQuestionnaireAssets?: Array<{ __typename?: 'LeaQuestionnaireAsset', tankSize?: string | null, product?: { __typename?: 'Product', id: string, name?: string | null } | null }> | null } | null }>, metadata: { __typename?: 'MetaQuery', totalCount?: number | null } } };

export type LeaManagersQueryVariables = Exact<{ [key: string]: never; }>;


export type LeaManagersQuery = { __typename?: 'Query', leaManagers: Array<{ __typename?: 'User', id: string, name?: string | null, address?: string | null, email: string, gravatar?: string | null, isSuperAdmin: boolean, otp?: string | null, phone?: string | null, status?: number | null, image?: { __typename?: 'AttachedFile', contentType?: string | null, filename?: string | null, id?: string | null, url?: string | null } | null }> };

export type SendMailToPocMutationVariables = Exact<{
  input: SendMailToPocInput;
}>;


export type SendMailToPocMutation = { __typename?: 'Mutation', sendMailToPoc?: { __typename?: 'SendMailToPocPayload', success: boolean } | null };

export type UpdateLeaCoreV2MutationVariables = Exact<{
  input: UpdateLeaCoreInput;
}>;


export type UpdateLeaCoreV2Mutation = { __typename?: 'Mutation', updateLeaCore?: { __typename?: 'UpdateLeaCorePayload', leaType: { __typename?: 'Lea', success: boolean, error?: string | null, leaCore?: { __typename?: 'LeaCore', id: string, leaNumber?: string | null, termAndCondition?: string | null, data?: { __typename?: 'LeaCoreData', expiryDurationDays?: number | null, expiryReminderDays?: number | null, expiryUnit?: string | null, reminderEmails?: Array<string> | null, computedMovementOrderIds?: Array<number> | null, computedSettledMovementOrderIds?: Array<number> | null, leaCoreNotes?: string | null } | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null, customer?: { __typename?: 'Customer', id: string, name?: string | null } | null, leaLineItems?: Array<{ __typename?: 'LeaLineItem', id: string, leaLineItemsNotes?: string | null, assetPositionNumber?: number | null, requestTankType?: string | null, requestTankSize?: number | null, status?: LeaLineItemStatusEnum | null, percentageOfCogs?: string | null, estimatedAssetValue?: string | null, estimatedMargin?: string | null, marginInPercentage?: string | null, marginPerGallonInCents?: string | null, totalMarginPerMonth?: string | null, bdrCommissionInPercent?: string | null, effectiveMarginInDollar?: string | null, effectiveMarginInPercent?: string | null, estimatedRoi?: string | null, unitCost?: number | null, gallonPerMonth?: string | null, gallonPerVisit?: string | null, equipmentsData?: { __typename?: 'LeaCoreEquipments', finalTotalCost?: number | null, assetTankTypes?: Array<{ __typename?: 'RoiEquipments', name?: string | null, quantity?: number | null, unitCost?: number | null, totalCost?: number | null }> | null, peripherals?: Array<{ __typename?: 'RoiEquipments', name?: string | null, quantity?: number | null, unitCost?: number | null, totalCost?: number | null }> | null, customItems?: Array<{ __typename?: 'RoiEquipments', name?: string | null, quantity?: number | null, unitCost?: number | null, totalCost?: number | null }> | null } | null, movementOrder?: { __typename?: 'MovementOrder', id: string, requestedTankSize?: string | null, requestedTankType?: string | null, assignedTankSize?: string | null, assignedTankType?: string | null, orderGroup: { __typename?: 'OrderGroup', id: string, status: string, startOnTimestamp?: number | null, createdAtTimestamp: number, completedOnTimestamp?: number | null, driver?: { __typename?: 'Driver', id: string, name?: string | null } | null, user?: { __typename?: 'User', id: string, name?: string | null } | null }, product?: { __typename?: 'Product', id: string, shortName?: string | null } | null, assetMovementLocation?: { __typename?: 'AssetMovementLocation', id: string, lat?: string | null, lng?: string | null, orderGroupId?: string | null } | null, asset?: { __typename?: 'Asset', id: string, name?: string | null } | null, toCustomerBranch: { __typename?: 'CustomerBranch', id: string, name?: string | null, customer?: { __typename?: 'Customer', name?: string | null } | null }, fromCustomerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, customer?: { __typename?: 'Customer', name?: string | null } | null } | null } | null, requestProduct?: { __typename?: 'Product', id: string, name?: string | null, shortName?: string | null } | null, leaPeripherals?: Array<{ __typename?: 'LeaPeripheral', id: string, quantity?: number | null, notes?: string | null, unitCost?: number | null, status?: LeaPeripheralStatusEnum | null, peripheral?: { __typename?: 'Peripheral', id: string, soldAs?: string | null, peripheralCategory?: { __typename?: 'PeripheralCategory', id: string, name?: string | null } | null } | null }> | null, customItemData?: Array<{ __typename?: 'LeaCoreCustomItem', name?: string | null, qty?: number | null, unitCost?: number | null }> | null, leaAppliedFees?: Array<{ __typename?: 'LeaAppliedFee', id: string, applicableFee?: { __typename?: 'ApplicableFee', id: string, fee?: { __typename?: 'Fee', id: string, name?: string | null } | null } | null }> | null }> | null, interactionProgresses?: Array<{ __typename?: 'InteractionProgress', completed?: boolean | null, currentStep?: number | null, data?: any | null, id?: string | null, subModule?: InteractionProgressEnum | null, totalStep?: number | null }> | null } | null } } | null };

export type CreateLeaCoreMutationVariables = Exact<{
  input: CreateLeaCoreInput;
}>;


export type CreateLeaCoreMutation = { __typename?: 'Mutation', createLeaCore?: { __typename?: 'CreateLeaCorePayload', leaType?: { __typename?: 'Lea', success: boolean, error?: string | null, leaCore?: { __typename?: 'LeaCore', id: string } | null } | null } | null };

export type DeleteLeaCoreMutationVariables = Exact<{
  input: DeleteLeaCoreInput;
}>;


export type DeleteLeaCoreMutation = { __typename?: 'Mutation', deleteLeaCore?: { __typename?: 'DeleteLeaCorePayload', leaType?: { __typename?: 'Lea', error?: string | null, success: boolean, leaCore?: { __typename?: 'LeaCore', id: string } | null } | null } | null };

export type FetchLeaDocumentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchLeaDocumentQuery = { __typename?: 'Query', leaCore: { __typename?: 'LeaCore', id: string, status?: LeaStatusEnum | null, previewDocument?: { __typename?: 'LeaDocument', fileName?: string | null, content?: string | null, error?: string | null } | null } };

export type FetchPreSignaturesForWorkOrderDocumentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchPreSignaturesForWorkOrderDocumentQuery = { __typename?: 'Query', leaCore: { __typename?: 'LeaCore', id: string, status?: LeaStatusEnum | null, isSigned?: boolean | null, leaNumber?: string | null, previewDocument?: { __typename?: 'LeaDocument', fileName?: string | null, content?: string | null, error?: string | null } | null, leaPreSignatures?: Array<{ __typename?: 'PandaDocument', id: string, fileUrl?: string | null, fileData?: string | null, fileName?: string | null, createdAt?: number | null, documentType?: string | null, documentableId?: string | null, leaUpdatedById?: string | null, leaDocumentType?: string | null, leaCreatedByName?: string | null, leaSignedDocument?: boolean | null, externalFileData?: { __typename?: 'AttachedFile', contentType?: string | null, filename?: string | null } | null }> | null } };

export type SaveTenantContentMutationVariables = Exact<{
  input: SaveTenantContentInput;
}>;


export type SaveTenantContentMutation = { __typename?: 'Mutation', saveTenantContent?: { __typename?: 'SaveTenantContentPayload', success: boolean, error?: string | null, tenantContent?: { __typename?: 'TenantContent', id: string } | null } | null };

export type SendmailMutationVariables = Exact<{
  input: SendLeaMailInput;
}>;


export type SendmailMutation = { __typename?: 'Mutation', sendLeaMail?: { __typename?: 'SendLeaMailPayload', success: boolean, toEmail: Array<string> } | null };

export type UpdateLeaCoreMutationVariables = Exact<{
  input: UpdateLeaCoreInput;
}>;


export type UpdateLeaCoreMutation = { __typename?: 'Mutation', updateLeaCore?: { __typename?: 'UpdateLeaCorePayload', leaType: { __typename?: 'Lea', success: boolean, error?: string | null, leaCore?: { __typename?: 'LeaCore', id: string, interactionProgresses?: Array<{ __typename?: 'InteractionProgress', completed?: boolean | null, currentStep?: number | null, data?: any | null, id?: string | null, subModule?: InteractionProgressEnum | null, totalStep?: number | null }> | null } | null } } | null };

export type UpdateLeaDocumentMutationVariables = Exact<{
  input: UpdateLeaDocumentInput;
}>;


export type UpdateLeaDocumentMutation = { __typename?: 'Mutation', updateLeaDocument?: { __typename?: 'UpdateLeaDocumentPayload', pandaDocument?: { __typename?: 'PandaDocument', id: string, fileUrl?: string | null, leaSignedDocument?: boolean | null, leaDocumentType?: string | null, leaUpdatedById?: string | null, leaUpdatedByName?: string | null } | null } | null };

export type FetchDeliveryOrderBaseForUpdateDeliveryOrderPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchDeliveryOrderBaseForUpdateDeliveryOrderPageQuery = { __typename?: 'Query', deliveryOrder: { __typename?: 'DeliveryOrder', id: string, deliveryDateTimestamp?: number | null, orderGroupId?: number | null, deliveryInstruction?: string | null, type?: string | null, diversionNumbers?: Array<string> | null, deliveryOrderLineItems: Array<{ __typename?: 'DeliveryOrderLineItem', id: string, status: string, volume?: number | null, requestedVolume?: number | null, subscription?: { __typename?: 'Subscription', product: { __typename?: 'Product', code?: string | null, id: string, name?: string | null }, asset: { __typename?: 'Asset', id: string, name?: string | null } } | null, product?: { __typename?: 'Product', active: boolean, id: string, name?: string | null, soldAs?: string | null, category: string, productType: string, comparableProducts?: Array<{ __typename?: 'ProductResource', id: string, productResource: { __typename?: 'Product', id: string, name?: string | null } }> | null, productConstituents?: Array<{ __typename?: 'ProductConstituent', id: string, percentage?: number | null, basicProduct: { __typename?: 'Product', id: string, name?: string | null, category: string } }> | null } | null, asset?: { __typename?: 'Asset', id: string, name?: string | null, category?: string | null } | null, warehouse?: { __typename?: 'Terminal', id: string, name?: string | null } | null }> } };

export type FetchOrderGroupForUpdateDeliveryOrderPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchOrderGroupForUpdateDeliveryOrderPageQuery = { __typename?: 'Query', deliveryOrder: { __typename?: 'DeliveryOrder', id: string, orderGroup?: { __typename?: 'OrderGroup', purchaseOrderType?: string | null, ccTenantId?: number | null, sendCarrierEmail?: boolean | null, id: string, priority?: OrderGroupPriorityEnum | null, carrierNumber?: string | null, poNumber?: string | null, startOnTimestamp?: number | null, hub?: { __typename?: 'Hub', id: string, name?: string | null } | null, worker?: { __typename?: 'Worker', id: string, name?: string | null } | null, orderGroupsFees?: Array<{ __typename?: 'OrderGroupsFee', id: string, price?: number | null, quantity: number, fee: { __typename?: 'Fee', id: string, code?: string | null, name?: string | null, price?: number | null, standard?: boolean | null, deleted?: boolean | null } }> | null, taggings?: Array<{ __typename?: 'Tagging', id: string, tag?: { __typename?: 'Tag', id: string, colorCode?: string | null, description?: string | null, erpId?: string | null, iconName?: string | null, name: string, status?: StatusStringEnum | null, tagType?: string | null } | null }> | null, ccTenant?: { __typename?: 'CcTenant', id: string, name: string } | null } | null } };

export type FetchLinkedOrdersForUpdateDeliveryOrderPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchLinkedOrdersForUpdateDeliveryOrderPageQuery = { __typename?: 'Query', deliveryOrder: { __typename?: 'DeliveryOrder', id: string, linkedOrders?: Array<{ __typename?: 'LoadingOrder', id: string, orderGroupId?: number | null, loadingInstruction?: string | null, loadingOrderProducts?: Array<{ __typename?: 'LoadingOrderProduct', id: string, preferredSuppliers?: Array<{ __typename?: 'PreferredSupplier', id: string, priority?: number | null, loadingAccount?: { __typename?: 'LoadingAccount', id: string, loadingNumber?: string | null, carrierCustomerCode?: string | null, destinationState?: string | null, supplierCode?: string | null, name?: string | null, label?: string | null, supplier?: { __typename?: 'Supplier', id: string, erpId?: string | null, name: string, supplierCode?: string | null } | null } | null }> | null, product: { __typename?: 'Product', id: string, code?: string | null, name?: string | null, category: string, colorCode?: string | null, shortName?: string | null, productType: string, unit?: string | null, soldAs?: string | null, brand?: { __typename?: 'Brand', id: string, name?: string | null } | null }, blendLoadingProduct?: { __typename?: 'BlendLoadingProduct', id: string, blendProduct: { __typename?: 'Product', id: string, name?: string | null, shortName?: string | null, code?: string | null, category: string, colorCode?: string | null, soldAs?: string | null, productConstituents?: Array<{ __typename?: 'ProductConstituent', id: string, percentage?: number | null, basicProduct: { __typename?: 'Product', id: string, code?: string | null, name?: string | null, category: string, colorCode?: string | null, shortName?: string | null, soldAs?: string | null } }> | null } } | null }> | null, terminal?: { __typename?: 'Terminal', id: string, name?: string | null, active?: boolean | null, suppliers?: Array<{ __typename?: 'Supplier', id: string, name: string, supplierId?: string | null, active?: boolean | null, loadingAccounts?: Array<{ __typename?: 'LoadingAccount', id: string, carrierCustomerCode?: string | null, loadingNumber?: string | null, supplierCode?: string | null, name?: string | null, supplierId?: string | null, label?: string | null }> | null }> | null } | null }> | null } };

export type FetchCustomerBranchForUpdateDeliveryOrderPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchCustomerBranchForUpdateDeliveryOrderPageQuery = { __typename?: 'Query', deliveryOrder: { __typename?: 'DeliveryOrder', id: string, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, address?: string | null, erpId?: string | null, deliveryInstruction?: string | null, site?: { __typename?: 'Site', city?: string | null, state?: string | null } | null, addressBooks?: Array<{ __typename?: 'AddressBook', name?: string | null, phone?: string | null, addressBookType?: string | null }> | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, totalRequestedVolume?: any | null, deliveryInstruction?: string | null, thirdPartyDelivery?: boolean | null, productPurchaseLimit?: { __typename?: 'ProductPurchaseLimit', volume?: string | null, product?: { __typename?: 'Product', id: string, name?: string | null } | null } | null, addressBooks?: Array<{ __typename?: 'AddressBook', name?: string | null, phone?: string | null }> | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string, name?: string | null } | null, customerSegment?: { __typename?: 'CustomerSegment', id: string, name?: string | null } | null } | null } | null } };

export type CreateBolPricingMutationVariables = Exact<{
  input: CreateBolPricingInput;
}>;


export type CreateBolPricingMutation = { __typename?: 'Mutation', createBolPricing?: { __typename?: 'CreateBolPricingPayload', bolPricing?: { __typename?: 'BolPricing', id: string, total?: number | null, itemType: string, rate?: number | null, quantity?: number | null, tax?: { __typename?: 'BolPricingsTaxType', id?: string | null, name: string, productCategoryId?: string | null, rateType: string } | null } | null } | null };

export type AddFeesToOrderGroupMutationVariables = Exact<{
  input: AddFeesToOrderGroupInput;
}>;


export type AddFeesToOrderGroupMutation = { __typename?: 'Mutation', addFeesToOrderGroup?: { __typename?: 'AddFeesToOrderGroupPayload', orderGroup?: { __typename?: 'OrderGroup', id: string, orderGroupsFees?: Array<{ __typename?: 'OrderGroupsFee', id: string, price?: number | null, quantity: number, total?: number | null, offset?: number | null, offsetRate?: number | null, fee: { __typename?: 'Fee', id: string, description?: string | null, name?: string | null, standard?: boolean | null, deleted?: boolean | null } }> | null } | null } | null };

export type ChangeShiftAssetMutationVariables = Exact<{
  input: ChangeAssetInput;
}>;


export type ChangeShiftAssetMutation = { __typename?: 'Mutation', changeShiftAsset?: { __typename?: 'ChangeAssetPayload', shift?: { __typename?: 'Shift', id: string, shiftDeliveryUnitsAssets?: Array<{ __typename?: 'ShiftDeliveryUnitsAsset', deliveryAsset?: { __typename?: 'DeliveryAsset', id: string, name?: string | null, licensePlateNumber?: string | null, category?: string | null, compartments?: Array<{ __typename?: 'Compartment', id: string, length?: number | null, name?: string | null }> | null } | null }> | null } | null } | null };

export type CreateOrderGroupTaxesMutationVariables = Exact<{
  input: CreateOrderGroupTaxesInput;
}>;


export type CreateOrderGroupTaxesMutation = { __typename?: 'Mutation', addOrderGroupTax?: { __typename?: 'CreateOrderGroupTaxesPayload', response?: { __typename?: 'OrderGroupTaxResponse', error?: string | null, success: boolean, orderGroupTax?: { __typename?: 'OrderGroupTax', id?: string | null, price?: number | null, total?: number | null, quantity?: number | null, orderGroup?: { __typename?: 'OrderGroup', id: string } | null, tax?: { __typename?: 'BolPricingsTaxType', id?: string | null, name: string } | null } | null } | null } | null };

export type CreateOrderInvoiceMutationVariables = Exact<{
  input: CreateOrderInvoiceInput;
}>;


export type CreateOrderInvoiceMutation = { __typename?: 'Mutation', createOrderInvoice?: { __typename?: 'CreateOrderInvoicePayload', response?: { __typename?: 'OrderInvoiceResponse', error?: string | null, success: boolean, invoice?: { __typename?: 'Invoice', id: string } | null } | null } | null };

export type CreateProductOrderFeesMutationVariables = Exact<{
  input: CreateProductOrderFeesInput;
}>;


export type CreateProductOrderFeesMutation = { __typename?: 'Mutation', createProductOrderFees?: { __typename?: 'CreateProductOrderFeesPayload', response?: { __typename?: 'ProductOrderFeeResponse', success: boolean, error?: string | null, productOrderFees?: Array<{ __typename?: 'ProductOrderFee', id?: string | null, amount?: number | null, quantity?: number | null, total?: number | null, fee?: { __typename?: 'Fee', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name?: string | null } | null }> | null } | null } | null };

export type CreateZoneProductBatchesMutationVariables = Exact<{
  input: CreateZoneProductBatchesInput;
}>;


export type CreateZoneProductBatchesMutation = { __typename?: 'Mutation', createZoneProductBatches?: { __typename?: 'CreateZoneProductBatchesPayload', zoneProductBatches?: Array<{ __typename?: 'ZoneProductBatch', id: string }> | null } | null };

export type DataImportProgressesQueryVariables = Exact<{
  dataImportType?: InputMaybe<DataImportProgressImportEnum>;
}>;


export type DataImportProgressesQuery = { __typename?: 'Query', dataImportProgresses?: { __typename?: 'DataImportProgress', status?: string | null } | null };

export type DuplicateOrderMutationVariables = Exact<{
  input: DuplicateOrderGroupInput;
}>;


export type DuplicateOrderMutation = { __typename?: 'Mutation', duplicateOrder?: { __typename?: 'DuplicateOrderGroupPayload', newOrderGroup?: { __typename?: 'OrderGroup', id: string, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, status: string } | null, loadingOrder?: { __typename?: 'LoadingOrder', id: string } | null } | null, fromOrderGroup?: { __typename?: 'OrderGroup', id: string } | null } | null };

export type FetchAllNotesQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type FetchAllNotesQuery = { __typename?: 'Query', deliveryOrder: { __typename?: 'DeliveryOrder', orderGroup?: { __typename?: 'OrderGroup', id: string, createdAtTimestamp: number, completedOnTimestamp?: number | null, driver?: { __typename?: 'Driver', id: string, name?: string | null } | null, allNotes?: Array<{ __typename?: 'Note', id: string, createdAtTimestamp?: number | null, content?: string | null, acknowledger?: string | null, generated?: boolean | null, commenter?: string | null, notableType?: string | null, noteType?: string | null, showInDeliveryTicket?: boolean | null, showInInvoice?: boolean | null, commenterUser?: { __typename?: 'Commenter', id: string, name?: string | null, avatar?: string | null, type: string } | null, pandaDocument?: { __typename?: 'PandaDocument', id: string, blobFileUrl?: string | null } | null }> | null } | null, postDeliveryPhotos?: Array<{ __typename?: 'PandaDocument', id: string, fileUrl?: string | null, blobFileUrl?: string | null, showInDeliveryTicket?: boolean | null }> | null } };

export type FetchBillingDetailQueryVariables = Exact<{
  orderGroupId: Scalars['ID'];
  orderStatus?: InputMaybe<Scalars['String']>;
  shiftStatus?: InputMaybe<Scalars['String']>;
}>;


export type FetchBillingDetailQuery = { __typename?: 'Query', appliedPricings?: Array<{ __typename?: 'AppliedPricing', id?: string | null, isManuallyUpdated?: boolean | null, total?: number | null, price?: number | null, sumTotal?: number | null, productId?: string | null, success?: boolean | null, quantity?: number | null, discount?: number | null, loadingOrderLineItemIds?: Array<string> | null, deliveryOrderLineItemIds?: Array<string> | null, receiptNumber?: string | null, orderType?: string | null, orderGroupId?: string | null, terminalId?: string | null, supplierId?: string | null, cardInTime?: any | null, completedOn?: any | null, hubId?: string | null, marketId?: string | null, isTemporaryPricing?: boolean | null, error?: { __typename?: 'AppliedPricingError', description?: string | null, status?: string | null, type?: string | null } | null, resourcePricing?: { __typename?: 'ResourcePricing', id: string } | null, pricing?: { __typename?: 'Pricing', id?: string | null } | null, product?: { __typename?: 'Product', id: string, name?: string | null } | null, appliedTaxes?: Array<{ __typename?: 'AppliedTax', id?: string | null, quantity?: number | null, price?: number | null, total?: number | null, applicableTax?: { __typename?: 'ApplicableTax', tax?: { __typename?: 'Tax', id?: string | null, name?: string | null, erpId?: string | null, rateType?: string | null, calculationType?: string | null } | null } | null }> | null, appliedMargins?: Array<{ __typename?: 'AppliedMargin', id?: string | null, quantity?: number | null, price?: number | null, total?: number | null, applicableMargin?: { __typename?: 'ApplicableMargin', margin?: { __typename?: 'Margin', id?: string | null, name?: string | null } | null } | null, marginsProduct?: { __typename?: 'MarginsProduct', margin?: { __typename?: 'Margin', id?: string | null, name?: string | null } | null } | null }> | null, customer?: { __typename?: 'ResourceDetails', id?: string | null } | null, customerBranch?: { __typename?: 'ResourceDetails', id?: string | null } | null, temporaryPricingData?: { __typename?: 'TemporaryPricingDate', price?: { __typename?: 'TemporaryPricingBreakdown', rate?: number | null, quantity?: number | null, total?: number | null } | null, taxes?: { __typename?: 'TemporaryPricingBreakdown', rate?: number | null, quantity?: number | null, total?: number | null } | null, markup?: { __typename?: 'TemporaryPricingBreakdown', rate?: number | null, quantity?: number | null, total?: number | null } | null, freight?: { __typename?: 'TemporaryPricingBreakdown', rate?: number | null, quantity?: number | null, total?: number | null } | null, totalPrice?: { __typename?: 'TemporaryPricingBreakdown', rate?: number | null, quantity?: number | null, total?: number | null } | null } | null }> | null };

export type FetchBolandTransferQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type FetchBolandTransferQuery = { __typename?: 'Query', deliveryOrder: { __typename?: 'DeliveryOrder', id: string, orderGroupId?: number | null, orderLinks?: Array<{ __typename?: 'OrderLink', id: string, loadingOrder?: { __typename?: 'LoadingOrder', id: string, bolNumbers?: string | null, status: string, terminal?: { __typename?: 'Terminal', id: string, name?: string | null } | null } | null, transferOrder?: { __typename?: 'TransferOrder', id: string, orderGroupId?: number | null, toAsset?: { __typename?: 'Asset', id: string, name?: string | null } | null, orderGroup?: { __typename?: 'OrderGroup', id: string } | null } | null, extractionOrder?: { __typename?: 'ExtractionOrder', id: string, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null } | null, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null } | null, movementOrder?: { __typename?: 'MovementOrder', id: string } | null }> | null } };

export type FetchComparableProductsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchComparableProductsQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: string, name?: string | null, comparableProducts?: Array<{ __typename?: 'ProductResource', id: string, productResource: { __typename?: 'Product', id: string, name?: string | null, code?: string | null, colorCode?: string | null, productType: string, soldAs?: string | null, unit?: string | null, brand?: { __typename?: 'Brand', id: string, name?: string | null } | null } }> | null } };

export type FetchCompartmentMismatchQueryVariables = Exact<{
  orderGroupId: Scalars['ID'];
  type: CompartmentMismatchOrderTypeEnum;
}>;


export type FetchCompartmentMismatchQuery = { __typename?: 'Query', compartmentMismatch?: Array<{ __typename?: 'CompartmentMismatch', lineItemId?: string | null, currentProductId?: string | null, currentCompartmentId?: string | null, actualCompartmentId?: string | null, actualProductId?: string | null, volume?: number | null, error?: string | null }> | null };

export type FetchCustomerBranchByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchCustomerBranchByIdQuery = { __typename?: 'Query', customerBranch: { __typename?: 'CustomerBranch', id: string, name?: string | null, purchaseOrder?: boolean | null, assets?: Array<{ __typename?: 'Asset', id: string, status?: string | null, category?: string | null, name?: string | null, licensePlateNumber?: string | null, useInDelivery?: boolean | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null, subscriptions?: Array<{ __typename?: 'Subscription', id: string, product: { __typename?: 'Product', id: string, category: string, code?: string | null, colorCode?: string | null, name?: string | null, shortName?: string | null, longDescription?: string | null, productType: string } }> | null }> | null } };

export type FetchDeliveryOrderFeesQueryVariables = Exact<{
  orderId: Scalars['ID'];
  fetchCustomerFees?: InputMaybe<Scalars['Boolean']>;
}>;


export type FetchDeliveryOrderFeesQuery = { __typename?: 'Query', deliveryOrder: { __typename?: 'DeliveryOrder', id: string, orderGroupId?: number | null, orderGroup?: { __typename?: 'OrderGroup', applicableFees?: Array<{ __typename?: 'ApplicableFee', id: string, netsuiteId?: string | null, price?: number | null, quantity?: number | null, fee?: { __typename?: 'Fee', id: string, description?: string | null, name?: string | null, standard?: boolean | null, deleted?: boolean | null, applyAsOnFee?: string | null } | null }> | null, customerBranch?: { __typename?: 'CustomerBranch', customer?: { __typename?: 'Customer', id: string, applicableFees?: Array<{ __typename?: 'ApplicableFee', id: string, price?: number | null, netsuiteId?: string | null, isDefault?: boolean | null, fee?: { __typename?: 'Fee', id: string, name?: string | null, standard?: boolean | null, deleted?: boolean | null, applyAsOnFee?: string | null } | null }> | null } | null, applicableFees?: Array<{ __typename?: 'ApplicableFee', id: string, netsuiteId?: string | null, price?: number | null, quantity?: number | null, fee?: { __typename?: 'Fee', id: string, description?: string | null, name?: string | null, standard?: boolean | null, deleted?: boolean | null, applyAsOnFee?: string | null } | null }> | null } | null, orderGroupsFees?: Array<{ __typename?: 'OrderGroupsFee', id: string, price?: number | null, quantity: number, total?: number | null, offset?: number | null, offsetRate?: number | null, fee: { __typename?: 'Fee', id: string, applicableType?: string | null, applyAsOnFee?: string | null, description?: string | null, name?: string | null, standard?: boolean | null, deleted?: boolean | null } }> | null } | null } };

export type FetchDeliveryOrderWithPandaBoxDetailsQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type FetchDeliveryOrderWithPandaBoxDetailsQuery = { __typename?: 'Query', deliveryOrder: { __typename?: 'DeliveryOrder', id: string, orderNumber?: string | null, ticketId: number, source?: string | null, pushToFdn?: boolean | null, deliveryInstruction?: string | null, ticketMailedAtTimestamp?: number | null, orderGroupId?: number | null, externalBoId?: string | null, invoiceNumber?: string | null, diversionNumbers?: Array<string> | null, divergenceOrder: boolean, totalizers?: Array<{ __typename?: 'Totalizer', discrepancy?: number | null, final?: number | null, initial?: number | null, meterName?: string | null }> | null, pandaBoxNotes?: Array<{ __typename?: 'Note', id: string, content?: string | null, createdAtTimestamp?: number | null }> | null, pandaDocumentInvoices?: Array<{ __typename?: 'PandaDocument', id: string, blobFileUrl?: string | null }> | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, address?: string | null, erpId?: string | null, deliveryInstruction?: string | null, site?: { __typename?: 'Site', city?: string | null, state?: string | null } | null, addressBooks?: Array<{ __typename?: 'AddressBook', name?: string | null, phone?: string | null, addressBookType?: string | null }> | null, resourceSchedule?: { __typename?: 'ResourceSchedule', availability?: Array<{ __typename?: 'Availability', day?: string | null, startTime?: string | null, endTime?: string | null, bestEndTime?: string | null, bestStartTime?: string | null }> | null } | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, totalRequestedVolume?: any | null, deliveryInstruction?: string | null, thirdPartyDelivery?: boolean | null, productPurchaseLimit?: { __typename?: 'ProductPurchaseLimit', volume?: string | null, product?: { __typename?: 'Product', id: string, name?: string | null } | null } | null, addressBooks?: Array<{ __typename?: 'AddressBook', name?: string | null, phone?: string | null }> | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string, name?: string | null } | null, customerSegment?: { __typename?: 'CustomerSegment', id: string, name?: string | null } | null, resourceSchedule?: { __typename?: 'ResourceSchedule', availability?: Array<{ __typename?: 'Availability', day?: string | null, startTime?: string | null, endTime?: string | null }> | null } | null } | null } | null, orderGroup?: { __typename?: 'OrderGroup', id: string, startOnTimestamp?: number | null, toStartOnTimestamp?: number | null, startedOnTimestamp?: number | null, completedOnTimestamp?: number | null, ratePrecision?: number | null, amountPrecision?: number | null, productLineOfServices?: Array<string> | null, createdAtTimestamp: number, carrierNumber?: string | null, outsideAvailability?: boolean | null, paymentTypeName?: string | null, purchaseOrderType?: string | null, purchaseOrderRequired?: boolean | null, mainOrderGroupId?: string | null, ccOrderGroupId?: string | null, mainOrderGroupTenant?: string | null, ccDeliveryAddress?: string | null, ccTenantId?: number | null, ticketId: number, poNumber?: string | null, shiftId?: string | null, status: string, priority?: OrderGroupPriorityEnum | null, invoiceNumbers?: Array<string> | null, enableRebill?: boolean | null, warehouseAsset?: { __typename?: 'Asset', id: string, name?: string | null } | null, creatable?: { __typename: 'Customer' } | { __typename: 'Driver' } | { __typename: 'UnknownGroupable' } | { __typename: 'User', name?: string | null, email: string } | null, ccTenant?: { __typename?: 'CcTenant', id: string, name: string, secondaryEmails?: Array<string> | null, carrierTenant: { __typename?: 'Tenant', adminUsers?: Array<{ __typename?: 'User', email: string }> | null } } | null, driver?: { __typename?: 'Driver', id: string, name?: string | null, email?: string | null, isCarrier?: boolean | null } | null, hub?: { __typename?: 'Hub', id: string, name?: string | null, address?: any | null } | null, lineOfService?: { __typename?: 'LineOfService', id: string, name?: string | null, shortName?: string | null } | null, shift?: { __typename?: 'Shift', state?: string | null, deliveryTruck?: { __typename?: 'DeliveryAsset', id: string, name?: string | null } | null } | null, invoices?: Array<{ __typename?: 'Invoice', id: string, status?: InvoiceStatusEnum | null, invoiceNumber?: string | null, createdOn?: number | null }> | null, pandaDocuments?: Array<{ __typename?: 'PandaDocument', id: string, blobFileUrl?: string | null, fileUrl?: string | null, fileName?: string | null }> | null, orderGroupTaxes?: Array<{ __typename?: 'OrderGroupTax', id?: string | null, total?: number | null }> | null } | null, signature?: { __typename?: 'PandaDocument', id: string, fileUrl?: string | null, fileName?: string | null, blobFileUrl?: string | null, blobFileUrlDownload?: string | null } | null } };

export type DeliveryOrderGroupPandaBoxFragmentFragment = { __typename?: 'OrderGroup', id: string, startOnTimestamp?: number | null, toStartOnTimestamp?: number | null, startedOnTimestamp?: number | null, completedOnTimestamp?: number | null, ratePrecision?: number | null, amountPrecision?: number | null, productLineOfServices?: Array<string> | null, createdAtTimestamp: number, carrierNumber?: string | null, outsideAvailability?: boolean | null, paymentTypeName?: string | null, purchaseOrderType?: string | null, purchaseOrderRequired?: boolean | null, mainOrderGroupId?: string | null, ccOrderGroupId?: string | null, mainOrderGroupTenant?: string | null, ccDeliveryAddress?: string | null, ccTenantId?: number | null, ticketId: number, poNumber?: string | null, shiftId?: string | null, status: string, priority?: OrderGroupPriorityEnum | null, invoiceNumbers?: Array<string> | null, enableRebill?: boolean | null, creatable?: { __typename: 'Customer' } | { __typename: 'Driver' } | { __typename: 'UnknownGroupable' } | { __typename: 'User', name?: string | null, email: string } | null, ccTenant?: { __typename?: 'CcTenant', id: string, name: string, secondaryEmails?: Array<string> | null, carrierTenant: { __typename?: 'Tenant', adminUsers?: Array<{ __typename?: 'User', email: string }> | null } } | null, driver?: { __typename?: 'Driver', id: string, name?: string | null, email?: string | null, isCarrier?: boolean | null } | null, hub?: { __typename?: 'Hub', id: string, name?: string | null, address?: any | null } | null, lineOfService?: { __typename?: 'LineOfService', id: string, name?: string | null, shortName?: string | null } | null, shift?: { __typename?: 'Shift', state?: string | null, deliveryTruck?: { __typename?: 'DeliveryAsset', id: string, name?: string | null } | null } | null, invoices?: Array<{ __typename?: 'Invoice', id: string, status?: InvoiceStatusEnum | null, invoiceNumber?: string | null, createdOn?: number | null }> | null, pandaDocuments?: Array<{ __typename?: 'PandaDocument', id: string, blobFileUrl?: string | null, fileUrl?: string | null, fileName?: string | null }> | null, orderGroupTaxes?: Array<{ __typename?: 'OrderGroupTax', id?: string | null, total?: number | null }> | null };

export type FetchDeliveryOrderQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type FetchDeliveryOrderQuery = { __typename?: 'Query', deliveryOrder: { __typename?: 'DeliveryOrder', id: string, orderNumber?: string | null, ticketId: number, pushToFdn?: boolean | null, deliveryInstruction?: string | null, ticketMailedAtTimestamp?: number | null, orderGroupId?: number | null, externalBoId?: string | null, source?: string | null, invoiceNumber?: string | null, diversionNumbers?: Array<string> | null, divergenceOrder: boolean, pandaDocumentInvoices?: Array<{ __typename?: 'PandaDocument', id: string, blobFileUrl?: string | null }> | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, address?: string | null, erpId?: string | null, deliveryInstruction?: string | null, site?: { __typename?: 'Site', city?: string | null, state?: string | null } | null, addressBooks?: Array<{ __typename?: 'AddressBook', name?: string | null, phone?: string | null, addressBookType?: string | null }> | null, resourceSchedule?: { __typename?: 'ResourceSchedule', availability?: Array<{ __typename?: 'Availability', day?: string | null, startTime?: string | null, endTime?: string | null, bestEndTime?: string | null, bestStartTime?: string | null }> | null } | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, totalRequestedVolume?: any | null, deliveryInstruction?: string | null, thirdPartyDelivery?: boolean | null, productPurchaseLimit?: { __typename?: 'ProductPurchaseLimit', volume?: string | null, product?: { __typename?: 'Product', id: string, name?: string | null } | null } | null, addressBooks?: Array<{ __typename?: 'AddressBook', name?: string | null, phone?: string | null }> | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string, name?: string | null } | null, customerSegment?: { __typename?: 'CustomerSegment', id: string, name?: string | null } | null, resourceSchedule?: { __typename?: 'ResourceSchedule', availability?: Array<{ __typename?: 'Availability', day?: string | null, startTime?: string | null, endTime?: string | null }> | null } | null } | null } | null, orderGroup?: { __typename?: 'OrderGroup', id: string, startOnTimestamp?: number | null, toStartOnTimestamp?: number | null, startedOnTimestamp?: number | null, completedOnTimestamp?: number | null, ratePrecision?: number | null, amountPrecision?: number | null, productLineOfServices?: Array<string> | null, createdAtTimestamp: number, carrierNumber?: string | null, outsideAvailability?: boolean | null, paymentTypeName?: string | null, purchaseOrderType?: string | null, purchaseOrderRequired?: boolean | null, mainOrderGroupId?: string | null, ccOrderGroupId?: string | null, mainOrderGroupTenant?: string | null, ccDeliveryAddress?: string | null, ccTenantId?: number | null, ticketId: number, poNumber?: string | null, shiftId?: string | null, status: string, priority?: OrderGroupPriorityEnum | null, invoiceNumbers?: Array<string> | null, enableRebill?: boolean | null, warehouseAsset?: { __typename?: 'Asset', id: string, name?: string | null } | null, creatable?: { __typename: 'Customer' } | { __typename: 'Driver' } | { __typename: 'UnknownGroupable' } | { __typename: 'User', name?: string | null, email: string } | null, ccTenant?: { __typename?: 'CcTenant', id: string, name: string, secondaryEmails?: Array<string> | null, carrierTenant: { __typename?: 'Tenant', adminUsers?: Array<{ __typename?: 'User', email: string }> | null } } | null, driver?: { __typename?: 'Driver', id: string, name?: string | null, email?: string | null, isCarrier?: boolean | null } | null, hub?: { __typename?: 'Hub', id: string, name?: string | null, address?: any | null } | null, lineOfService?: { __typename?: 'LineOfService', id: string, name?: string | null, shortName?: string | null } | null, shift?: { __typename?: 'Shift', state?: string | null, deliveryTruck?: { __typename?: 'DeliveryAsset', id: string, name?: string | null } | null } | null, invoices?: Array<{ __typename?: 'Invoice', id: string, status?: InvoiceStatusEnum | null, invoiceNumber?: string | null, createdOn?: number | null }> | null, pandaDocuments?: Array<{ __typename?: 'PandaDocument', id: string, blobFileUrl?: string | null, fileUrl?: string | null, fileName?: string | null }> | null, orderGroupTaxes?: Array<{ __typename?: 'OrderGroupTax', id?: string | null, total?: number | null }> | null } | null, signature?: { __typename?: 'PandaDocument', id: string, fileUrl?: string | null, fileName?: string | null, blobFileUrl?: string | null, blobFileUrlDownload?: string | null } | null } };

export type DeliveryOrderGroupFragmentFragment = { __typename?: 'OrderGroup', id: string, startOnTimestamp?: number | null, toStartOnTimestamp?: number | null, startedOnTimestamp?: number | null, completedOnTimestamp?: number | null, ratePrecision?: number | null, amountPrecision?: number | null, productLineOfServices?: Array<string> | null, createdAtTimestamp: number, carrierNumber?: string | null, outsideAvailability?: boolean | null, paymentTypeName?: string | null, purchaseOrderType?: string | null, purchaseOrderRequired?: boolean | null, mainOrderGroupId?: string | null, ccOrderGroupId?: string | null, mainOrderGroupTenant?: string | null, ccDeliveryAddress?: string | null, ccTenantId?: number | null, ticketId: number, poNumber?: string | null, shiftId?: string | null, status: string, priority?: OrderGroupPriorityEnum | null, invoiceNumbers?: Array<string> | null, enableRebill?: boolean | null, creatable?: { __typename: 'Customer' } | { __typename: 'Driver' } | { __typename: 'UnknownGroupable' } | { __typename: 'User', name?: string | null, email: string } | null, ccTenant?: { __typename?: 'CcTenant', id: string, name: string, secondaryEmails?: Array<string> | null, carrierTenant: { __typename?: 'Tenant', adminUsers?: Array<{ __typename?: 'User', email: string }> | null } } | null, driver?: { __typename?: 'Driver', id: string, name?: string | null, email?: string | null, isCarrier?: boolean | null } | null, hub?: { __typename?: 'Hub', id: string, name?: string | null, address?: any | null } | null, lineOfService?: { __typename?: 'LineOfService', id: string, name?: string | null, shortName?: string | null } | null, shift?: { __typename?: 'Shift', state?: string | null, deliveryTruck?: { __typename?: 'DeliveryAsset', id: string, name?: string | null } | null } | null, invoices?: Array<{ __typename?: 'Invoice', id: string, status?: InvoiceStatusEnum | null, invoiceNumber?: string | null, createdOn?: number | null }> | null, pandaDocuments?: Array<{ __typename?: 'PandaDocument', id: string, blobFileUrl?: string | null, fileUrl?: string | null, fileName?: string | null }> | null, orderGroupTaxes?: Array<{ __typename?: 'OrderGroupTax', id?: string | null, total?: number | null }> | null };

export type FetchFilteredFeesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchFilteredFeesQuery = { __typename?: 'Query', filteredFees: { __typename?: 'FeeCollection', collection: Array<{ __typename?: 'Fee', id: string, name?: string | null, rateOnFee?: number | null }> } };

export type FetchLineItemsQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type FetchLineItemsQuery = { __typename?: 'Query', deliveryOrder: { __typename?: 'DeliveryOrder', id: string, lineItems: Array<{ __typename?: 'DeliveryOrderLineItem', meterName?: string | null, id: string, status: string, source: string, topOff?: boolean | null, requestedVolume?: number | null, volume?: number | null, skipReason?: string | null, backofficeId?: string | null, backofficeStatus?: string | null, data?: any | null, isExtraction?: boolean | null, canSyncRequestedLoadingVolume: boolean, warehouseId?: string | null, notes?: string | null, warehouse?: { __typename?: 'Terminal', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, category: string, name?: string | null, colorCode?: string | null, shortName?: string | null, code?: string | null, deliveryType?: string | null, unit?: string | null, soldAs?: string | null, brand?: { __typename?: 'Brand', id: string, name?: string | null } | null, comparableProducts?: Array<{ __typename?: 'ProductResource', comparableProductId: string, id: string, productResource: { __typename?: 'Product', id: string, name?: string | null, code?: string | null, colorCode?: string | null, productType: string, soldAs?: string | null, unit?: string | null, deliveryType?: string | null, brand?: { __typename?: 'Brand', id: string, name?: string | null } | null } }> | null } | null, comparableProduct?: { __typename?: 'Product', id: string, name?: string | null, shortName?: string | null } | null, asset?: { __typename?: 'Asset', id: string, licensePlateNumber?: string | null, name?: string | null, category?: string | null, data?: any | null, lat?: string | null, lng?: string | null, transitCustomerBranch?: { __typename?: 'CustomerBranch', id: string } | null, compartments?: Array<{ __typename?: 'Compartment', id: string }> | null } | null, sourceAssets?: Array<{ __typename?: 'SourceAsset', id: string, dispensedQty?: number | null, asset: { __typename?: 'Asset', id: string, name?: string | null }, zoneProductBatch?: { __typename?: 'ZoneProductBatch', id: string, zoneIndex?: number | null, batch: { __typename?: 'Batch', id: string, batchNumber?: string | null } } | null }> | null, sourceCompartments?: Array<{ __typename?: 'SourceCompartment', id: string, dispensedVolume?: number | null, compartment: { __typename?: 'Compartment', id: string, name?: string | null, asset?: { __typename?: 'Asset', id: string, name?: string | null, licensePlateNumber?: string | null, category?: string | null } | null } }> | null, targetCompartmentInstance?: { __typename?: 'CompartmentInstance', id: string, beforeStick?: string | null, beforeStickUnit?: string | null, afterStick?: string | null, afterStickUnit?: string | null, generatorRunningHours?: number | null } | null, subscription?: { __typename?: 'Subscription', id: string } | null }> } };

export type FetchNestedLinkedOrderGroupIdsQueryVariables = Exact<{
  orderGroupId: Scalars['ID'];
}>;


export type FetchNestedLinkedOrderGroupIdsQuery = { __typename?: 'Query', fetchNestedLinkedOrderGroupIds?: Array<string> | null };

export type FetchLinkedOrdersDriverListQueryVariables = Exact<{
  orderGroupId: Scalars['ID'];
}>;


export type FetchLinkedOrdersDriverListQuery = { __typename?: 'Query', linkedOrdersDriversLists?: Array<{ __typename?: 'LinkedDriver', unassigned?: number | null, workerWithPendingOrderStatus?: Array<{ __typename?: 'Driver', id: string, name?: string | null }> | null, workerWithoutPendingOrderStatus?: Array<{ __typename?: 'Driver', id: string, name?: string | null }> | null }> | null };

export type FetchOrderGroupTagsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchOrderGroupTagsQuery = { __typename?: 'Query', orderGroup: { __typename?: 'OrderGroup', id: string, taggings?: Array<{ __typename?: 'Tagging', id: string, tag?: { __typename?: 'Tag', id: string, name: string, erpId?: string | null, description?: string | null, colorCode?: string | null, iconName?: string | null, status?: StatusStringEnum | null, tagType?: string | null } | null }> | null } };

export type FetchOrderGroupTaxesQueryVariables = Exact<{
  orderGroupId: Scalars['ID'];
}>;


export type FetchOrderGroupTaxesQuery = { __typename?: 'Query', orderGroup: { __typename?: 'OrderGroup', id: string, status: string, orderGroupTaxes?: Array<{ __typename?: 'OrderGroupTax', id?: string | null, price?: number | null, quantity?: number | null, total?: number | null, tax?: { __typename?: 'BolPricingsTaxType', id?: string | null, name: string, erpId?: string | null, rateType: string } | null, orderGroup?: { __typename?: 'OrderGroup', id: string, status: string } | null }> | null } };

export type FetchPandaBoxLogsQueryVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type FetchPandaBoxLogsQuery = { __typename?: 'Query', pandaBoxLogs?: Array<{ __typename?: 'S3Object', key: string, lastModifiedAt?: number | null, presignedUrl?: string | null, size?: number | null, body?: string | null }> | null };

export type FetchProcessingRecurrenceStatusQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchProcessingRecurrenceStatusQuery = { __typename?: 'Query', deliveryOrder: { __typename?: 'DeliveryOrder', orderGroup?: { __typename?: 'OrderGroup', processingRecurrence?: boolean | null } | null } };

export type FetchProductOrderFeesQueryVariables = Exact<{
  orderGroupId: Scalars['ID'];
}>;


export type FetchProductOrderFeesQuery = { __typename?: 'Query', orderGroup: { __typename?: 'OrderGroup', id: string, status: string, productOrderFees?: Array<{ __typename?: 'ProductOrderFee', id?: string | null, isManuallyUpdated: boolean, amount?: number | null, quantity?: number | null, total?: number | null, fee?: { __typename?: 'Fee', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name?: string | null } | null, orderGroup?: { __typename?: 'OrderGroup', id: string } | null }> | null } };

export type FetchProductsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  customFilter?: InputMaybe<ProductFilter>;
  sorter?: InputMaybe<Array<ProductSorter> | ProductSorter>;
}>;


export type FetchProductsQuery = { __typename?: 'Query', filteredProducts: { __typename: 'ProductCollection', metadata: { __typename: 'MetaQuery', hasMore: boolean, totalCount?: number | null }, collection: Array<{ __typename: 'Product', id: string, name?: string | null, code?: string | null, colorCode?: string | null, productType: string, soldAs?: string | null, unit?: string | null, deliveryType?: string | null, brand?: { __typename?: 'Brand', id: string, name?: string | null } | null }> } };

export type FilterCommonCarrierDodmQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  customFilter?: InputMaybe<CcTenantFilter>;
  sorter?: InputMaybe<Array<CcTenantSorter> | CcTenantSorter>;
}>;


export type FilterCommonCarrierDodmQuery = { __typename?: 'Query', filteredCcTenants?: { __typename?: 'CcTenantCollection', metadata: { __typename?: 'MetaQuery', hasMore: boolean }, collection: Array<{ __typename?: 'CcTenant', id: string, name: string }> } | null };

export type FilteredAssetsByCustomerBranchIdQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  customFilter?: InputMaybe<AssetFilter>;
  sorter?: InputMaybe<Array<AssetSorter> | AssetSorter>;
}>;


export type FilteredAssetsByCustomerBranchIdQuery = { __typename?: 'Query', filteredAssets: { __typename?: 'AssetCollection', collection: Array<{ __typename?: 'Asset', id: string, status?: string | null, category?: string | null, name?: string | null, licensePlateNumber?: string | null, useInDelivery?: boolean | null, subscriptions?: Array<{ __typename?: 'Subscription', id: string, product: { __typename?: 'Product', id: string, category: string, code?: string | null, colorCode?: string | null, name?: string | null, shortName?: string | null, longDescription?: string | null, productType: string } }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean } } };

export type FilteredDeliveryAssetsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  customFilter?: InputMaybe<DeliveryAssetFilter>;
  sorter?: InputMaybe<Array<BaseSorter> | BaseSorter>;
}>;


export type FilteredDeliveryAssetsQuery = { __typename?: 'Query', filteredDeliveryAssets: { __typename?: 'DeliveryAssetCollection', metadata: { __typename?: 'MetaQuery', hasMore: boolean }, collection: Array<{ __typename?: 'DeliveryAsset', id: string, name?: string | null, category?: string | null, compartments?: Array<{ __typename?: 'Compartment', id: string, length?: number | null, name?: string | null }> | null }> } };

export type ModifyLineItemProductsMutationVariables = Exact<{
  input: ModifyLineItemProductInput;
}>;


export type ModifyLineItemProductsMutation = { __typename?: 'Mutation', modifyLineItemProduct?: { __typename?: 'ModifyLineItemProductPayload', orderGroup?: { __typename?: 'OrderGroup', id: string, deliveryOrder?: { __typename?: 'DeliveryOrder', lineItems: Array<{ __typename?: 'DeliveryOrderLineItem', id: string, subscription?: { __typename?: 'Subscription', id: string } | null }> } | null } | null } | null };

export type OrderPricingImportCompletionQueryVariables = Exact<{
  selected: ShiftOrOrderEnum;
  id: Scalars['ID'];
}>;


export type OrderPricingImportCompletionQuery = { __typename?: 'Query', orderPricingImportCompletion: boolean };

export type PushOrderTo3PlMutationVariables = Exact<{
  input: PushOrderToFdnInput;
}>;


export type PushOrderTo3PlMutation = { __typename?: 'Mutation', pushOrderToFdn?: { __typename?: 'PushOrderToFdnPayload', message?: string | null, data?: { __typename?: 'PushOrderToFdnData', loadingOrderGroupIds?: Array<string> | null } | null } | null };

export type RecalculatePricingMutationVariables = Exact<{
  input: RecalculatePricingInput;
}>;


export type RecalculatePricingMutation = { __typename?: 'Mutation', recalculatePricing?: { __typename?: 'RecalculatePricingPayload', appliedPricings?: Array<{ __typename?: 'AppliedPricing', id?: string | null }> | null } | null };

export type DeleteBolPricingMutationVariables = Exact<{
  input: DeleteBolPricingInput;
}>;


export type DeleteBolPricingMutation = { __typename?: 'Mutation', deleteBolPricing?: { __typename?: 'DeleteBolPricingPayload', response?: { __typename?: 'DeleteResponse', id: string, error?: string | null, success: boolean } | null } | null };

export type RemoveFeesFromOrderGroupMutationVariables = Exact<{
  input: RemoveFeesFromOrderGroupInput;
}>;


export type RemoveFeesFromOrderGroupMutation = { __typename?: 'Mutation', removeFeesFromOrderGroup?: { __typename?: 'RemoveFeesFromOrderGroupPayload', orderGroup?: { __typename?: 'OrderGroup', id: string } | null } | null };

export type ResetAppliedPricingMutationVariables = Exact<{
  data: ManualUpdateInput;
}>;


export type ResetAppliedPricingMutation = { __typename?: 'Mutation', resetPricing?: { __typename?: 'ResetPricingPayload', appliedPricing?: { __typename?: 'AppliedPricing', id?: string | null } | null } | null };

export type SendCommonCarrierEmailMutationVariables = Exact<{
  input: SendCommonCarrierEmailInput;
}>;


export type SendCommonCarrierEmailMutation = { __typename?: 'Mutation', sendCommonCarrierEmail?: { __typename?: 'SendCommonCarrierEmailPayload', orderGroup?: { __typename?: 'OrderGroup', sendCarrierEmail?: boolean | null, carrierEmailSentAt?: any | null } | null } | null };

export type UpdateAppliedPricingMutationVariables = Exact<{
  input: UpdateAppliedPricingInput;
}>;


export type UpdateAppliedPricingMutation = { __typename?: 'Mutation', updateAppliedPricing?: { __typename?: 'UpdateAppliedPricingPayload', appliedPricings?: Array<{ __typename?: 'AppliedPricing', id?: string | null, isManuallyUpdated?: boolean | null, total?: number | null, price?: number | null, productId?: string | null, success?: boolean | null, quantity?: number | null, discount?: number | null, loadingOrderLineItemIds?: Array<string> | null, deliveryOrderLineItemIds?: Array<string> | null, receiptNumber?: string | null, orderType?: string | null, orderGroupId?: string | null, terminalId?: string | null, supplierId?: string | null, cardInTime?: any | null, completedOn?: any | null, hubId?: string | null, marketId?: string | null, error?: { __typename?: 'AppliedPricingError', description?: string | null, status?: string | null, type?: string | null } | null, resourcePricing?: { __typename?: 'ResourcePricing', id: string } | null, pricing?: { __typename?: 'Pricing', id?: string | null } | null, product?: { __typename?: 'Product', id: string, name?: string | null } | null, appliedTaxes?: Array<{ __typename?: 'AppliedTax', id?: string | null, quantity?: number | null, price?: number | null, total?: number | null, applicableTax?: { __typename?: 'ApplicableTax', tax?: { __typename?: 'Tax', id?: string | null, name?: string | null } | null } | null }> | null, appliedMargins?: Array<{ __typename?: 'AppliedMargin', id?: string | null, quantity?: number | null, price?: number | null, total?: number | null, applicableMargin?: { __typename?: 'ApplicableMargin', margin?: { __typename?: 'Margin', id?: string | null, name?: string | null } | null } | null, marginsProduct?: { __typename?: 'MarginsProduct', margin?: { __typename?: 'Margin', id?: string | null, name?: string | null } | null } | null }> | null, customer?: { __typename?: 'ResourceDetails', id?: string | null } | null, customerBranch?: { __typename?: 'ResourceDetails', id?: string | null } | null }> | null } | null };

export type UpdateAssetMovementLocationMutationVariables = Exact<{
  input: UpdateAssetsInput;
}>;


export type UpdateAssetMovementLocationMutation = { __typename?: 'Mutation', updateAsset?: { __typename?: 'UpdateAssetsPayload', asset?: { __typename?: 'Asset', id: string } | null } | null };

export type UpdateBolPricingMutationVariables = Exact<{
  input: UpdateBolPricingInput;
}>;


export type UpdateBolPricingMutation = { __typename?: 'Mutation', updateBolPricing?: { __typename?: 'UpdateBolPricingPayload', bolPricing?: { __typename?: 'BolPricing', id: string, itemType: string, rate?: number | null, quantity?: number | null, total?: number | null, tax?: { __typename?: 'BolPricingsTaxType', id?: string | null, name: string, productCategoryId?: string | null, rateType: string } | null } | null } | null };

export type UpdateFeeOfOrderGroupMutationVariables = Exact<{
  input: AddFeeToOrderGroupInput;
}>;


export type UpdateFeeOfOrderGroupMutation = { __typename?: 'Mutation', addFeeToOrderGroup?: { __typename?: 'AddFeeToOrderGroupPayload', orderGroup?: { __typename?: 'OrderGroup', id: string, orderGroupsFees?: Array<{ __typename?: 'OrderGroupsFee', id: string, price?: number | null, offset?: number | null, offsetRate?: number | null, quantity: number, total?: number | null, fee: { __typename?: 'Fee', id: string, description?: string | null, name?: string | null, standard?: boolean | null, deleted?: boolean | null } }> | null } | null } | null };

export type UpdateNoteMutationVariables = Exact<{
  input: UpdateNoteInput;
}>;


export type UpdateNoteMutation = { __typename?: 'Mutation', updateNote?: { __typename?: 'UpdateNotePayload', note?: { __typename?: 'Note', id: string, acknowledger?: string | null } | null } | null };

export type UpdatePostDeliveryPhotoForDeliveryOrderMutationVariables = Exact<{
  input: UpdatePostDeliveryPhotoInput;
}>;


export type UpdatePostDeliveryPhotoForDeliveryOrderMutation = { __typename?: 'Mutation', updatePostDeliveryPhoto?: { __typename?: 'UpdatePostDeliveryPhotoPayload', clientMutationId?: string | null } | null };

export type UpdateZoneProductBatchesMutationVariables = Exact<{
  input: UpdateZoneProductBatchesInput;
}>;


export type UpdateZoneProductBatchesMutation = { __typename?: 'Mutation', updateZoneProductBatches?: { __typename?: 'UpdateZoneProductBatchesPayload', zoneProductBatches?: Array<{ __typename?: 'ZoneProductBatch', orderGroup?: { __typename?: 'OrderGroup', id: string } | null }> | null } | null };

export type ExportOrdersCsvMutationVariables = Exact<{
  filter?: InputMaybe<OrderGroupFilter>;
  sorter?: InputMaybe<Array<OrderGroupSorter> | OrderGroupSorter>;
}>;


export type ExportOrdersCsvMutation = { __typename?: 'Mutation', exportOrdersCsv: { __typename?: 'ExportOrdersCsvPayload', success: boolean, message: string } };

export type DeleteDeliveryOrderMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteDeliveryOrderMutation = { __typename?: 'Mutation', deleteDeliveryOrder?: { __typename?: 'DeleteDeliveryOrderPayload', orderGroup?: { __typename?: 'OrderGroup', id: string } | null } | null };

export type ChangeOrderGroupAssignmentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ChangeOrderGroupAssignmentMutation = { __typename?: 'Mutation', changeOrderGroupAssignment?: { __typename?: 'ChangeOrderGroupAssignmentPayload', orderGroup: { __typename?: 'OrderGroup', id: string, status: string } } | null };

export type FetchDoListCustomerBranchQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<OrderGroupSorter> | OrderGroupSorter>;
  filter?: InputMaybe<OrderGroupFilter>;
}>;


export type FetchDoListCustomerBranchQuery = { __typename?: 'Query', filteredOrderGroups: { __typename?: 'OrderGroupCollection', collection: Array<{ __typename?: 'OrderGroup', id: string, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, customerBranch?: { __typename?: 'CustomerBranch', id: string, address?: string | null, addressBooks?: Array<{ __typename?: 'AddressBook', name?: string | null, addressBookType?: string | null }> | null } | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FetchDoListLineItemsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<OrderGroupSorter> | OrderGroupSorter>;
  filter?: InputMaybe<OrderGroupFilter>;
}>;


export type FetchDoListLineItemsQuery = { __typename?: 'Query', filteredOrderGroups: { __typename?: 'OrderGroupCollection', collection: Array<{ __typename?: 'OrderGroup', id: string, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, lineItems: Array<{ __typename?: 'DeliveryOrderLineItem', id: string, requestedVolume?: number | null, volume?: number | null, topOff?: boolean | null, product?: { __typename?: 'Product', id: string, unit?: string | null, name?: string | null, deliveryType?: string | null } | null }> } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FetchDoListLinkedOrdersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<OrderGroupSorter> | OrderGroupSorter>;
  filter?: InputMaybe<OrderGroupFilter>;
}>;


export type FetchDoListLinkedOrdersQuery = { __typename?: 'Query', filteredOrderGroups: { __typename?: 'OrderGroupCollection', collection: Array<{ __typename?: 'OrderGroup', id: string, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, orderLinks?: Array<{ __typename?: 'OrderLink', id: string, extractionOrder?: { __typename?: 'ExtractionOrder', id: string, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null } | null, loadingOrder?: { __typename?: 'LoadingOrder', bolNumbers?: string | null, terminal?: { __typename?: 'Terminal', name?: string | null } | null, lineItems: Array<{ __typename?: 'LoadingOrderLineItem', grossAmount?: number | null }> } | null }> | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FetchDoListOrderGroupQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<OrderGroupSorter> | OrderGroupSorter>;
  filter?: InputMaybe<OrderGroupFilter>;
}>;


export type FetchDoListOrderGroupQuery = { __typename?: 'Query', filteredOrderGroups: { __typename?: 'OrderGroupCollection', collection: Array<{ __typename?: 'OrderGroup', id: string, poNumber?: string | null, startOnTimestamp?: number | null, completeOnTimestamp?: number | null, startedOnTimestamp?: number | null, completedOnTimestamp?: number | null, priority?: OrderGroupPriorityEnum | null, verifiedBy?: string | null, latestInvoiceStatus?: string | null, feesPricingStatus?: FeesPricingStatusEnum | null, pricingMarginStatus?: PricingMarginStatusEnum | null, hub?: { __typename?: 'Hub', name?: string | null, address?: any | null } | null, driver?: { __typename?: 'Driver', name?: string | null, group?: { __typename?: 'Group', name: string } | null } | null, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, status: string, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, erpId?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, erpId?: string | null } | null } | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FetchDoListShiftQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<OrderGroupSorter> | OrderGroupSorter>;
  filter?: InputMaybe<OrderGroupFilter>;
}>;


export type FetchDoListShiftQuery = { __typename?: 'Query', filteredOrderGroups: { __typename?: 'OrderGroupCollection', collection: Array<{ __typename?: 'OrderGroup', id: string, shift?: { __typename?: 'Shift', startOnTimestamp?: number | null, endOnTimestamp?: number | null, shiftDeliveryUnitsAssets?: Array<{ __typename?: 'ShiftDeliveryUnitsAsset', deliveryAsset?: { __typename?: 'DeliveryAsset', name?: string | null, licensePlateNumber?: string | null } | null }> | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type AcknowledgeNoteMutationVariables = Exact<{
  input: NoteAcknowledgeInput;
}>;


export type AcknowledgeNoteMutation = { __typename?: 'Mutation', acknowledgeNote?: { __typename?: 'AcknowledgeNotePayload', note?: { __typename?: 'Note', acknowledger?: string | null, notableType?: string | null, acknowledgedAt?: number | null } | null } | null };

export type CreateDuplicateOrderMutationVariables = Exact<{
  input: DuplicateOrderGroupInput;
}>;


export type CreateDuplicateOrderMutation = { __typename?: 'Mutation', duplicateOrder?: { __typename?: 'DuplicateOrderGroupPayload', fromOrderGroup?: { __typename?: 'OrderGroup', id: string } | null, newOrderGroup?: { __typename?: 'OrderGroup', deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, status: string } | null, loadingOrder?: { __typename?: 'LoadingOrder', id: string } | null } | null } | null };

export type DeleteRecurringOrdersByIdsMutationVariables = Exact<{
  recurringOrderIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteRecurringOrdersByIdsMutation = { __typename?: 'Mutation', deleteSiteRecurrence?: { __typename?: 'DeleteSiteRecurrencePayload', success?: boolean | null } | null };

export type FilteredDeliveryOrderQueryVariables = Exact<{
  perPage?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<OrderGroupSorter> | OrderGroupSorter>;
  customFilter?: InputMaybe<OrderGroupFilter>;
}>;


export type FilteredDeliveryOrderQuery = { __typename?: 'Query', filteredOrderGroups: { __typename?: 'OrderGroupCollection', collection: Array<{ __typename?: 'OrderGroup', id: string, poNumber?: string | null, startOnTimestamp?: number | null, completeOnTimestamp?: number | null, startedOnTimestamp?: number | null, completedOnTimestamp?: number | null, priority?: OrderGroupPriorityEnum | null, verifiedBy?: string | null, latestInvoiceStatus?: string | null, feesPricingStatus?: FeesPricingStatusEnum | null, pricingMarginStatus?: PricingMarginStatusEnum | null, hub?: { __typename?: 'Hub', name?: string | null, address?: any | null } | null, driver?: { __typename?: 'Driver', name?: string | null, group?: { __typename?: 'Group', name: string } | null } | null, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, status: string, orderNumber?: string | null, tenantName?: string | null, source?: string | null, orderLinks?: Array<{ __typename?: 'OrderLink', id: string, loadingOrder?: { __typename?: 'LoadingOrder', bolNumbers?: string | null, id: string, terminal?: { __typename?: 'Terminal', name?: string | null, id: string } | null, lineItems: Array<{ __typename?: 'LoadingOrderLineItem', grossAmount?: number | null }> } | null, extractionOrder?: { __typename?: 'ExtractionOrder', id: string, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null } | null }> | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, erpId?: string | null, address?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, erpId?: string | null } | null, addressBooks?: Array<{ __typename?: 'AddressBook', name?: string | null, addressBookType?: string | null }> | null } | null, lineItems: Array<{ __typename?: 'DeliveryOrderLineItem', id: string, requestedVolume?: number | null, volume?: number | null, topOff?: boolean | null, product?: { __typename?: 'Product', id: string, unit?: string | null, name?: string | null, deliveryType?: string | null } | null, subscription?: { __typename?: 'Subscription', asset: { __typename?: 'Asset', category?: string | null, licensePlateNumber?: string | null } } | null }> } | null, shift?: { __typename?: 'Shift', startOnTimestamp?: number | null, endOnTimestamp?: number | null, shiftDeliveryUnitsAssets?: Array<{ __typename?: 'ShiftDeliveryUnitsAsset', deliveryAsset?: { __typename?: 'DeliveryAsset', name?: string | null, licensePlateNumber?: string | null } | null }> | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FetchDeliveryOrderByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchDeliveryOrderByIdQuery = { __typename?: 'Query', orderGroup: { __typename?: 'OrderGroup', id: string, poNumber?: string | null, startOnTimestamp?: number | null, completeOnTimestamp?: number | null, startedOnTimestamp?: number | null, completedOnTimestamp?: number | null, priority?: OrderGroupPriorityEnum | null, verifiedBy?: string | null, latestInvoiceStatus?: string | null, feesPricingStatus?: FeesPricingStatusEnum | null, pricingMarginStatus?: PricingMarginStatusEnum | null, hub?: { __typename?: 'Hub', name?: string | null, address?: any | null } | null, driver?: { __typename?: 'Driver', name?: string | null, group?: { __typename?: 'Group', name: string } | null } | null, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, status: string, orderNumber?: string | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, erpId?: string | null, address?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, address?: string | null, erpId?: string | null } | null, addressBooks?: Array<{ __typename?: 'AddressBook', name?: string | null, addressBookType?: string | null }> | null } | null, lineItems: Array<{ __typename?: 'DeliveryOrderLineItem', id: string, requestedVolume?: number | null, volume?: number | null, topOff?: boolean | null, product?: { __typename?: 'Product', id: string, unit?: string | null, deliveryType?: string | null } | null, subscription?: { __typename?: 'Subscription', asset: { __typename?: 'Asset', category?: string | null, licensePlateNumber?: string | null } } | null }>, orderLinks?: Array<{ __typename?: 'OrderLink', id: string, loadingOrder?: { __typename?: 'LoadingOrder', id: string, terminal?: { __typename?: 'Terminal', id: string, name?: string | null } | null } | null, extractionOrder?: { __typename?: 'ExtractionOrder', id: string, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null } | null }> | null } | null, shift?: { __typename?: 'Shift', startOnTimestamp?: number | null, endOnTimestamp?: number | null, shiftDeliveryUnitsAssets?: Array<{ __typename?: 'ShiftDeliveryUnitsAsset', deliveryAsset?: { __typename?: 'DeliveryAsset', name?: string | null, licensePlateNumber?: string | null } | null }> | null } | null } };

export type FetchExportDocumentQueryVariables = Exact<{
  exportDocumentId: Scalars['ID'];
}>;


export type FetchExportDocumentQuery = { __typename?: 'Query', exportDocument?: { __typename?: 'ExportDocument', id: string, fileUrl?: string | null, status?: string | null, remarks?: string | null } | null };

export type FetchExtractionOrderByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchExtractionOrderByIdQuery = { __typename?: 'Query', orderGroup: { __typename?: 'OrderGroup', id: string, carrierNumber?: string | null, poNumber?: string | null, startOnTimestamp?: number | null, status: string, latestInvoiceStatus?: string | null, driverAcceptance: string, completeOnTimestamp?: number | null, startedOnTimestamp?: number | null, completedOnTimestamp?: number | null, shiftId?: string | null, driver?: { __typename?: 'Driver', name?: string | null } | null, fees?: Array<{ __typename?: 'Fee', id: string, code?: string | null, price?: number | null, description?: string | null, name?: string | null }> | null, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, status: string, orderNumber?: string | null, deliveryInstruction?: string | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, erpId?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, erpId?: string | null, fees?: Array<{ __typename?: 'Fee', id: string, name?: string | null, price?: number | null }> | null } | null } | null, lineItems: Array<{ __typename?: 'DeliveryOrderLineItem', id: string, source: string, requestedVolume?: number | null, volume?: number | null, status: string, product?: { __typename?: 'Product', id: string, name?: string | null, unit?: string | null, deliveryType?: string | null } | null, subscription?: { __typename?: 'Subscription', product: { __typename?: 'Product', category: string, name?: string | null, unit?: string | null, deliveryType?: string | null, brand?: { __typename?: 'Brand', id: string, name?: string | null } | null }, asset: { __typename?: 'Asset', category?: string | null, licensePlateNumber?: string | null } } | null }>, linkedOrders?: Array<{ __typename?: 'LoadingOrder', id: string, orderGroup?: { __typename?: 'OrderGroup', id: string } | null, terminal?: { __typename?: 'Terminal', id: string, name?: string | null } | null }> | null } | null, shift?: { __typename?: 'Shift', shiftDeliveryUnitsAssets?: Array<{ __typename?: 'ShiftDeliveryUnitsAsset', deliveryAsset?: { __typename?: 'DeliveryAsset', name?: string | null, licensePlateNumber?: string | null } | null }> | null } | null } };

export type FetchFilteredRecurrenceDataOnlyQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<OrderGroupFilter>;
  sorter?: InputMaybe<Array<OrderGroupSorter> | OrderGroupSorter>;
}>;


export type FetchFilteredRecurrenceDataOnlyQuery = { __typename?: 'Query', filteredOrderGroups: { __typename?: 'OrderGroupCollection', collection: Array<{ __typename?: 'OrderGroup', id: string, recurrenceData?: { __typename?: 'RecurrenceData', lastDelivery?: string | null, nextDate?: string | null, recurrence: { __typename?: 'RecurrenceOrderGroup', recurrenceFromTimestamp?: string | null, recurrenceType: Recurrence, recurrenceDates?: Array<string> | null, recurrenceDays?: Array<number> | null, recurrenceInterval?: number | null, recurrenceUntil?: string | null, recurrenceOccurrences?: number | null, recurrenceDaysOfWeek?: Array<DaysOfWeek> | null, recurrenceDaysInAdvance?: number | null, recurrenceAutoExpired?: boolean | null, recurrenceDayNthWeek?: { __typename?: 'RecurrenceDayNthWeek', sunday?: Array<number> | null, monday?: Array<number> | null, tuesday?: Array<number> | null, wednesday?: Array<number> | null, thursday?: Array<number> | null, friday?: Array<number> | null, saturday?: Array<number> | null } | null } } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FilteredBulkPlantsQueryVariables = Exact<{
  filter?: InputMaybe<BulkPlantsFiltersInput>;
}>;


export type FilteredBulkPlantsQuery = { __typename?: 'Query', bulkPlants: Array<{ __typename?: 'BulkPlantsShiftType', id: string, bulkPlantShiftResource?: { __typename?: 'BulkPlantsShiftResourceType', id: string, bulkPlantInventories?: Array<{ __typename?: 'BulkPlantInventory', id: string, retainQty?: string | null, product?: { __typename?: 'Product', id: string, name?: string | null } | null }> | null, resourceable?: { __typename: 'CompanyAsset', id: string, name?: string | null, licensePlateNumber?: string | null, compartments?: Array<{ __typename?: 'Compartment', id: string, name?: string | null, capacities?: Array<{ __typename?: 'Capacity', value: number }> | null }> | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, name?: string | null }> | null, subscriptions?: Array<{ __typename?: 'Subscription', product: { __typename?: 'Product', id: string, name?: string | null } }> | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null } | { __typename: 'Terminal', id: string, name?: string | null, products?: Array<{ __typename?: 'Product', id: string, name?: string | null }> | null } | null } | null }> };

export type ExtractionOrdersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter: OrderGroupFilter;
  sorter?: InputMaybe<Array<OrderGroupSorter> | OrderGroupSorter>;
}>;


export type ExtractionOrdersQuery = { __typename?: 'Query', filteredOrderGroups: { __typename?: 'OrderGroupCollection', collection: Array<{ __typename?: 'OrderGroup', id: string, carrierNumber?: string | null, poNumber?: string | null, startOnTimestamp?: number | null, status: string, latestInvoiceStatus?: string | null, driverAcceptance: string, completeOnTimestamp?: number | null, startedOnTimestamp?: number | null, completedOnTimestamp?: number | null, shiftId?: string | null, driver?: { __typename?: 'Driver', name?: string | null } | null, fees?: Array<{ __typename?: 'Fee', id: string, code?: string | null, price?: number | null, description?: string | null, name?: string | null }> | null, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, status: string, orderNumber?: string | null, deliveryInstruction?: string | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, erpId?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, erpId?: string | null, fees?: Array<{ __typename?: 'Fee', id: string, name?: string | null, price?: number | null }> | null } | null } | null, lineItems: Array<{ __typename?: 'DeliveryOrderLineItem', id: string, source: string, requestedVolume?: number | null, volume?: number | null, status: string, product?: { __typename?: 'Product', id: string, name?: string | null, unit?: string | null, deliveryType?: string | null } | null, subscription?: { __typename?: 'Subscription', product: { __typename?: 'Product', category: string, name?: string | null, unit?: string | null, deliveryType?: string | null, brand?: { __typename?: 'Brand', id: string, name?: string | null } | null }, asset: { __typename?: 'Asset', category?: string | null, licensePlateNumber?: string | null } } | null }>, linkedOrders?: Array<{ __typename?: 'LoadingOrder', id: string, orderGroup?: { __typename?: 'OrderGroup', id: string } | null, terminal?: { __typename?: 'Terminal', id: string, name?: string | null } | null }> | null } | null, shift?: { __typename?: 'Shift', shiftDeliveryUnitsAssets?: Array<{ __typename?: 'ShiftDeliveryUnitsAsset', deliveryAsset?: { __typename?: 'DeliveryAsset', name?: string | null, licensePlateNumber?: string | null } | null }> | null } | null }>, metadata: { __typename?: 'MetaQuery', totalCount?: number | null } } };

export type FilteredRecurrenceOrdersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<OrderGroupFilter>;
  sorter?: InputMaybe<Array<OrderGroupSorter> | OrderGroupSorter>;
}>;


export type FilteredRecurrenceOrdersQuery = { __typename?: 'Query', filteredOrderGroups: { __typename?: 'OrderGroupCollection', collection: Array<{ __typename?: 'OrderGroup', id: string, startOnTimestamp?: number | null, ccTenantId?: number | null, poNumber?: string | null, ccTenant?: { __typename?: 'CcTenant', id: string, carrierTenant: { __typename?: 'Tenant', id: string, name?: string | null } } | null, loadingOrder?: { __typename?: 'LoadingOrder', id: string, terminal?: { __typename?: 'Terminal', name?: string | null } | null, loadingOrderProducts?: Array<{ __typename?: 'LoadingOrderProduct', id: string, grossQuantity?: number | null, preferredSuppliers?: Array<{ __typename?: 'PreferredSupplier', id: string, loadingAccount?: { __typename?: 'LoadingAccount', id: string, loadingNumber?: string | null, carrierCustomerCode?: string | null, label?: string | null, name?: string | null, supplierCode?: string | null, supplier?: { __typename?: 'Supplier', id: string, erpId?: string | null, name: string, supplierCode?: string | null } | null } | null }> | null, product: { __typename?: 'Product', id: string, category: string, name?: string | null, productType: string, shortName?: string | null, unit?: string | null, deliveryType?: string | null, code?: string | null } }> | null, linkedOrders?: Array<{ __typename?: 'DeliveryOrder', id: string, orderGroupId?: number | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, status?: boolean | null, customer?: { __typename?: 'Customer', id: string, status?: number | null } | null } | null }> | null } | null, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, deliveryOrderLineItems: Array<{ __typename?: 'DeliveryOrderLineItem', id: string, topOff?: boolean | null, requestedVolume?: number | null, warehouseId?: string | null, warehouse?: { __typename?: 'Terminal', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name?: string | null, productType: string, shortName?: string | null, unit?: string | null, deliveryType?: string | null, code?: string | null, colorCode?: string | null } | null, subscription?: { __typename?: 'Subscription', id: string, asset: { __typename?: 'Asset', id: string, name?: string | null, erpId?: string | null, status?: string | null }, product: { __typename?: 'Product', id: string, name?: string | null } } | null }>, orderLinks?: Array<{ __typename?: 'OrderLink', loadingOrder?: { __typename?: 'LoadingOrder', orderGroupId?: number | null, id: string, terminal?: { __typename?: 'Terminal', name?: string | null } | null } | null }> | null } | null, extractionOrder?: { __typename?: 'ExtractionOrder', id: string } | null, hub?: { __typename?: 'Hub', id: string, name?: string | null, address?: any | null } | null, worker?: { __typename?: 'Worker', id: string, name?: string | null } | null, creatable?: { __typename?: 'Customer', type: 'Customer' } | { __typename?: 'Driver', type: 'Driver' } | { __typename?: 'UnknownGroupable', type: 'UnknownGroupable' } | { __typename?: 'User', name?: string | null, type: 'User' } | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, erpId?: string | null, address?: string | null, status?: boolean | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, erpId?: string | null, status?: number | null } | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FilteredShiftListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ShiftFilter>;
  sorter?: InputMaybe<Array<ShiftSorter> | ShiftSorter>;
}>;


export type FilteredShiftListQuery = { __typename?: 'Query', filteredShifts: { __typename?: 'ShiftCollection', collection: Array<{ __typename?: 'Shift', id: string, startOnTimestamp?: number | null, endOnTimestamp?: number | null, state?: string | null, worker?: { __typename?: 'Worker', id: string, name?: string | null, status?: string | null, hubs?: Array<{ __typename?: 'Hub', name?: string | null }> | null } | null, shiftDeliveryUnitsAssets?: Array<{ __typename?: 'ShiftDeliveryUnitsAsset', id: string, deliveryAsset?: { __typename?: 'DeliveryAsset', id: string, licensePlateNumber?: string | null, name?: string | null, category?: string | null } | null }> | null, orderGroups?: Array<{ __typename?: 'OrderGroup', loadingOrder?: { __typename?: 'LoadingOrder', id: string, terminal?: { __typename?: 'Terminal', id: string, name?: string | null } | null } | null, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null } | null }> | null }>, metadata: { __typename?: 'MetaQuery', totalCount?: number | null, hasMore: boolean } } };

export type FetchLoadingOrderByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchLoadingOrderByIdQuery = { __typename?: 'Query', orderGroup: { __typename?: 'OrderGroup', id: string, startOnTimestamp?: number | null, status: string, startedOnTimestamp?: number | null, completedOnTimestamp?: number | null, priority?: OrderGroupPriorityEnum | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null, driver?: { __typename?: 'Driver', name?: string | null } | null, loadingOrder?: { __typename?: 'LoadingOrder', id: string, status: string, bolNumbers?: string | null, terminal?: { __typename?: 'Terminal', id: string, name?: string | null, suppliers?: Array<{ __typename?: 'Supplier', id: string, name: string }> | null } | null, loadingOrderProducts?: Array<{ __typename?: 'LoadingOrderProduct', id: string, quantity?: number | null, product: { __typename?: 'Product', id: string, name?: string | null, unit?: string | null, deliveryType?: string | null } }> | null, lineItems: Array<{ __typename?: 'LoadingOrderLineItem', id: string, netAmount?: number | null, product?: { __typename?: 'Product', id: string, name?: string | null, unit?: string | null, deliveryType?: string | null } | null, compartment?: { __typename?: 'Compartment', asset?: { __typename?: 'Asset', id: string, licensePlateNumber?: string | null, name?: string | null } | null } | null }>, orderLinks?: Array<{ __typename?: 'OrderLink', deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null } | null }> | null } | null, shift?: { __typename?: 'Shift', shiftDeliveryUnitsAssets?: Array<{ __typename?: 'ShiftDeliveryUnitsAsset', deliveryAsset?: { __typename?: 'DeliveryAsset', name?: string | null, licensePlateNumber?: string | null } | null }> | null } | null } };

export type LoadingOrdersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter: OrderGroupFilter;
  sorter?: InputMaybe<Array<OrderGroupSorter> | OrderGroupSorter>;
}>;


export type LoadingOrdersQuery = { __typename?: 'Query', filteredOrderGroups: { __typename?: 'OrderGroupCollection', collection: Array<{ __typename?: 'OrderGroup', id: string, startOnTimestamp?: number | null, status: string, startedOnTimestamp?: number | null, completedOnTimestamp?: number | null, priority?: OrderGroupPriorityEnum | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null, driver?: { __typename?: 'Driver', name?: string | null } | null, loadingOrder?: { __typename?: 'LoadingOrder', id: string, status: string, bolNumbers?: string | null, terminal?: { __typename?: 'Terminal', id: string, name?: string | null, suppliers?: Array<{ __typename?: 'Supplier', id: string, name: string }> | null } | null, loadingOrderProducts?: Array<{ __typename?: 'LoadingOrderProduct', id: string, quantity?: number | null, product: { __typename?: 'Product', id: string, name?: string | null, unit?: string | null, deliveryType?: string | null }, preferredSuppliers?: Array<{ __typename?: 'PreferredSupplier', loadingAccount?: { __typename?: 'LoadingAccount', supplier?: { __typename?: 'Supplier', name: string } | null } | null }> | null }> | null, lineItems: Array<{ __typename?: 'LoadingOrderLineItem', id: string, netAmount?: number | null, product?: { __typename?: 'Product', id: string, name?: string | null, unit?: string | null, deliveryType?: string | null } | null, compartment?: { __typename?: 'Compartment', asset?: { __typename?: 'Asset', id: string, licensePlateNumber?: string | null, name?: string | null } | null } | null }>, orderLinks?: Array<{ __typename?: 'OrderLink', deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null } | null }> | null } | null, shift?: { __typename?: 'Shift', shiftDeliveryUnitsAssets?: Array<{ __typename?: 'ShiftDeliveryUnitsAsset', deliveryAsset?: { __typename?: 'DeliveryAsset', name?: string | null, licensePlateNumber?: string | null } | null }> | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FilteredOrderGroupQueryVariables = Exact<{
  perPage?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  customFilter?: InputMaybe<OrderGroupFilter>;
}>;


export type FilteredOrderGroupQuery = { __typename?: 'Query', filteredOrderGroups: { __typename?: 'OrderGroupCollection', collection: Array<{ __typename?: 'OrderGroup', id: string, ticketId: number, createdAtTimestamp: number, startOnTimestamp?: number | null, departedOnTimestamp?: number | null, startedOnTimestamp?: number | null, completedOnTimestamp?: number | null, completeOnTimestamp?: number | null, status: string, latestInvoiceStatus?: string | null, driverAcceptance: string, priority?: OrderGroupPriorityEnum | null, driver?: { __typename?: 'Driver', name?: string | null } | null, deliveryOrder?: { __typename?: 'DeliveryOrder', type?: string | null, id: string, status: string, orderNumber?: string | null, deliveryInstruction?: string | null, source?: string | null, orderLinks?: Array<{ __typename?: 'OrderLink', id: string, loadingOrder?: { __typename?: 'LoadingOrder', id: string, bolNumbers?: string | null, status: string, terminal?: { __typename?: 'Terminal', id: string, name?: string | null } | null } | null, extractionOrder?: { __typename?: 'ExtractionOrder', id: string, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null } | null }> | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, address?: string | null, site?: { __typename?: 'Site', lat?: string | null, lng?: string | null, radius?: number | null } | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, address?: string | null } | null } | null, lineItems: Array<{ __typename?: 'DeliveryOrderLineItem', id: string, requestedVolume?: number | null, volume?: number | null, status: string, product?: { __typename?: 'Product', id: string, name?: string | null, unit?: string | null, deliveryType?: string | null } | null, subscription?: { __typename?: 'Subscription', product: { __typename?: 'Product', name?: string | null }, asset: { __typename?: 'Asset', category?: string | null, licensePlateNumber?: string | null } } | null }> } | null, loadingOrder?: { __typename?: 'LoadingOrder', id: string, status: string, terminal?: { __typename?: 'Terminal', id: string, name?: string | null, site?: { __typename?: 'Site', lat?: string | null, lng?: string | null, radius?: number | null, address?: any | null } | null, suppliers?: Array<{ __typename?: 'Supplier', id: string, name: string, loadingAccounts?: Array<{ __typename?: 'LoadingAccount', id: string, carrierCustomerCode?: string | null, loadingNumber?: string | null }> | null }> | null } | null, orderLinks?: Array<{ __typename?: 'OrderLink', id: string, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, orderGroupId?: number | null } | null, loadingOrder?: { __typename?: 'LoadingOrder', id: string } | null }> | null, loadingOrderProducts?: Array<{ __typename?: 'LoadingOrderProduct', id: string, quantity?: number | null, product: { __typename?: 'Product', name?: string | null, code?: string | null, unit?: string | null, deliveryType?: string | null }, preferredSuppliers?: Array<{ __typename?: 'PreferredSupplier', priority?: number | null, loadingAccount?: { __typename?: 'LoadingAccount', loadingNumber?: string | null, supplier?: { __typename?: 'Supplier', name: string, erpId?: string | null, supplierId?: string | null } | null } | null }> | null }> | null, lineItems: Array<{ __typename?: 'LoadingOrderLineItem', id: string, netAmount?: number | null, product?: { __typename?: 'Product', id: string, name?: string | null, unit?: string | null, deliveryType?: string | null } | null, compartment?: { __typename?: 'Compartment', asset?: { __typename?: 'Asset', id: string, licensePlateNumber?: string | null, name?: string | null } | null } | null }> } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FetchOrderGroupGeoFenceTimestampsQueryVariables = Exact<{
  orderGroupId: Scalars['ID'];
}>;


export type FetchOrderGroupGeoFenceTimestampsQuery = { __typename?: 'Query', orderGroup: { __typename?: 'OrderGroup', id: string, fenceIns?: Array<{ __typename?: 'GeofenceRecord', lat?: string | null, lng?: string | null, timestamp?: number | null }> | null, fenceOuts?: Array<{ __typename?: 'GeofenceRecord', lat?: string | null, lng?: string | null, timestamp?: number | null }> | null } };

export type FetchShiftListQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchShiftListQuery = { __typename?: 'Query', shift: { __typename?: 'Shift', id: string, startOnTimestamp?: number | null, endOnTimestamp?: number | null, state?: string | null, worker?: { __typename?: 'Worker', id: string, name?: string | null, status?: string | null, hubs?: Array<{ __typename?: 'Hub', name?: string | null }> | null } | null, shiftDeliveryUnitsAssets?: Array<{ __typename?: 'ShiftDeliveryUnitsAsset', id: string, deliveryAsset?: { __typename?: 'DeliveryAsset', id: string, licensePlateNumber?: string | null, name?: string | null, category?: string | null } | null }> | null, orderGroups?: Array<{ __typename?: 'OrderGroup', loadingOrder?: { __typename?: 'LoadingOrder', id: string, terminal?: { __typename?: 'Terminal', id: string, name?: string | null } | null } | null, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null } | null }> | null } };

export type FilteredTransferOrderQueryVariables = Exact<{
  perPage?: InputMaybe<Scalars['Int']>;
  offSet?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<TransferOrderSorter> | TransferOrderSorter>;
  customFilter?: InputMaybe<TransferOrderFilter>;
}>;


export type FilteredTransferOrderQuery = { __typename?: 'Query', filteredTransferOrders: { __typename?: 'TransferOrderCollection', collection: Array<{ __typename?: 'TransferOrder', id: string, transferDateTimestamp?: any | null, orderGroupId?: number | null, orderGroup?: { __typename?: 'OrderGroup', status: string } | null, fromDriver?: { __typename?: 'Driver', name?: string | null } | null, fromAsset?: { __typename?: 'Asset', licensePlateNumber?: string | null, name?: string | null } | null, fromShift?: { __typename?: 'Shift', id: string, worker?: { __typename?: 'Worker', name?: string | null } | null } | null, toDriver?: { __typename?: 'Driver', name?: string | null } | null, toAsset?: { __typename?: 'Asset', licensePlateNumber?: string | null, name?: string | null } | null, toShift?: { __typename?: 'Shift', id: string, worker?: { __typename?: 'Worker', name?: string | null } | null } | null, lineItemSummary?: Array<{ __typename?: 'LineItem', deliveredVolume?: number | null }> | null, lineItems?: Array<{ __typename?: 'TransferOrderLineItem', fromCompartment?: { __typename?: 'Compartment', id: string, name?: string | null } | null, toCompartment?: { __typename?: 'Compartment', id: string, name?: string | null } | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FetchTransferOrderByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchTransferOrderByIdQuery = { __typename?: 'Query', orderGroup: { __typename?: 'OrderGroup', id: string, startOnTimestamp?: number | null, transferOrder?: { __typename?: 'TransferOrder', id: string, transferDateTimestamp?: any | null, orderGroupId?: number | null, orderGroup?: { __typename?: 'OrderGroup', status: string } | null, fromDriver?: { __typename?: 'Driver', name?: string | null } | null, fromAsset?: { __typename?: 'Asset', name?: string | null } | null, fromShift?: { __typename?: 'Shift', id: string, worker?: { __typename?: 'Worker', name?: string | null } | null } | null, toDriver?: { __typename?: 'Driver', name?: string | null } | null, toAsset?: { __typename?: 'Asset', name?: string | null } | null, toShift?: { __typename?: 'Shift', id: string, worker?: { __typename?: 'Worker', name?: string | null } | null } | null, lineItems?: Array<{ __typename?: 'TransferOrderLineItem', fromCompartment?: { __typename?: 'Compartment', id: string, name?: string | null } | null, toCompartment?: { __typename?: 'Compartment', id: string, name?: string | null } | null }> | null } | null } };

export type FilteredNotesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter: NotesFilter;
}>;


export type FilteredNotesQuery = { __typename?: 'Query', filteredNotes: { __typename?: 'NoteCollection', collection: Array<{ __typename?: 'Note', id: string, createdAtTimestamp?: number | null, noteType?: string | null, notableType?: string | null, content?: string | null, commenter?: string | null, acknowledger?: string | null, acknowledgedAt?: number | null, orderGroup?: { __typename?: 'OrderGroup', id: string, customerBranch?: { __typename?: 'CustomerBranch', name?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null } | null } | null, hub?: { __typename?: 'Hub', id: string, name?: string | null, address?: any | null } | null, loadingOrder?: { __typename?: 'LoadingOrder', id: string, terminal?: { __typename?: 'Terminal', id: string, name?: string | null } | null, loadingReceipts?: Array<{ __typename?: 'LoadingReceipt', id: string, terminalsSupplier?: { __typename?: 'TerminalsSupplier', id: string, supplier: { __typename?: 'Supplier', id: string, name: string } } | null }> | null } | null, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, postDeliveryNote?: { __typename?: 'Note', content?: string | null, noteType?: string | null, createdAtTimestamp?: number | null } | null } | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type ModifyInventoryMutationVariables = Exact<{
  input: ModifyInventoryInput;
}>;


export type ModifyInventoryMutation = { __typename?: 'Mutation', modifyInventory?: { __typename?: 'ModifyInventoryPayload', shift?: { __typename?: 'Shift', id: string } | null } | null };

export type UpdateExportOrdersMutationVariables = Exact<{
  input: ExportOrdersInput;
}>;


export type UpdateExportOrdersMutation = { __typename?: 'Mutation', exportOrders?: { __typename?: 'ExportOrdersPayload', message: string, exportDocument?: { __typename?: 'ExportDocument', id: string, status?: string | null } | null } | null };

export type CopyPreviousRecordsMutationVariables = Exact<{
  input: CopyPreviousRecordsInput;
}>;


export type CopyPreviousRecordsMutation = { __typename?: 'Mutation', copyPreviousRecords?: { __typename?: 'CopyPreviousRecordsPayload', success: boolean } | null };

export type CreateDriverRatesMutationVariables = Exact<{
  input: CreateDriverRatesInput;
}>;


export type CreateDriverRatesMutation = { __typename?: 'Mutation', createDriverRates?: { __typename?: 'CreateDriverRatesPayload', driverRate?: { __typename?: 'DriverRate', id: string } | null } | null };

export type CreateMarginMutationVariables = Exact<{
  input: CreateMarginInput;
}>;


export type CreateMarginMutation = { __typename?: 'Mutation', createMargin?: { __typename?: 'CreateMarginPayload', margin?: { __typename?: 'Margin', id?: string | null, name?: string | null, marginType?: string | null, marginUnit?: string | null, marginRate?: number | null, range?: Array<{ __typename?: 'MarginRangeAttribute', endRange?: string | null, rangeRate?: string | null, startRange?: string | null }> | null } | null } | null };

export type CreateMarketMutationVariables = Exact<{
  input: CreateMarketsInput;
}>;


export type CreateMarketMutation = { __typename?: 'Mutation', createMarket?: { __typename?: 'CreateMarketsPayload', market?: { __typename?: 'Market', id: string } | null } | null };

export type CreatePricingMutationVariables = Exact<{
  input: CreatePricingInput;
}>;


export type CreatePricingMutation = { __typename?: 'Mutation', createPricings?: { __typename?: 'CreatePricingPayload', pricing?: { __typename?: 'Pricing', id?: string | null } | null } | null };

export type CreateRateTypeMutationVariables = Exact<{
  input: CreateRateInput;
}>;


export type CreateRateTypeMutation = { __typename?: 'Mutation', createRateType?: { __typename?: 'CreateRatePayload', rateType?: { __typename?: 'RateType', id: string } | null } | null };

export type CreateResourcePricingsMutationVariables = Exact<{
  input: CreateResourcePricingsInput;
}>;


export type CreateResourcePricingsMutation = { __typename?: 'Mutation', createResourcePricings?: { __typename?: 'CreateResourcePricingPayload', resourcePricing?: { __typename?: 'ResourcePricing', id: string, resourceId: string, resourceType: string, priceConfigurations: Array<{ __typename?: 'PriceConfiguration', id: string, pricing: { __typename?: 'Pricing', id?: string | null, supplierId?: string | null, hubId?: string | null } }> } | null } | null };

export type CreateTaxMutationVariables = Exact<{
  input: CreateTaxInput;
}>;


export type CreateTaxMutation = { __typename?: 'Mutation', createTax?: { __typename?: 'CreateTaxPayload', tax?: { __typename?: 'Tax', id?: string | null, name?: string | null } | null } | null };

export type CreateUpdateAliasMappingMutationVariables = Exact<{
  mapper: AliasMappingInput;
}>;


export type CreateUpdateAliasMappingMutation = { __typename?: 'Mutation', createUpdateAliasMapping?: { __typename?: 'CreateUpdateAliasMappingPayload', aliasMapping?: { __typename?: 'AliasMapping', id: string, dataSource: string, sourceValue?: string | null, mappableId?: string | null, mappableType?: MappableTypeEnum | null, mappable?: { __typename?: 'Market', id: string, nullableName?: string | null } | { __typename?: 'Product', id: string, nullableName?: string | null } | { __typename?: 'RateType', id: string, name: string } | { __typename?: 'Supplier', id: string, name: string } | null } | null } | null };

export type DataImportCsvQueryVariables = Exact<{
  importableType?: InputMaybe<ImportableTypeEnum>;
}>;


export type DataImportCsvQuery = { __typename?: 'Query', dataImports: Array<{ __typename?: 'DataImport', id: string, errorFileUrl?: string | null, importableId?: string | null, importableType?: ImportableTypeEnum | null, pandaDocumentId?: string | null, status?: string | null, filename?: string | null, createdAtTimestamp?: number | null, user?: { __typename?: 'User', id: string, name?: string | null, email: string, isSuperAdmin: boolean } | null }> };

export type DeleteMarketMutationVariables = Exact<{
  input: DeleteResourceInput;
}>;


export type DeleteMarketMutation = { __typename?: 'Mutation', deleteResource?: { __typename?: 'DeleteResourcePayload', clientMutationId?: string | null, result?: any | null } | null };

export type EmailResourcePricingMutationVariables = Exact<{
  data: EmailResourcePricingsInput;
}>;


export type EmailResourcePricingMutation = { __typename?: 'Mutation', emailResourcePricing?: { __typename?: 'EmailResourcePricingPayload', resourcePricing?: { __typename?: 'ResourcePricing', id: string } | null } | null };

export type FetchAppliedFeesForCustomerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchAppliedFeesForCustomerQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, marketResources?: Array<{ __typename?: 'MarketResource', id: string, market: { __typename?: 'Market', id: string, name?: string | null } }> | null, applicableFees?: Array<{ __typename?: 'ApplicableFee', id: string, isDefault?: boolean | null, fee?: { __typename?: 'Fee', id: string, name?: string | null, applicableType?: string | null } | null }> | null } };

export type FetchAppliedFeesForCustomerBranchQueryVariables = Exact<{
  id: Scalars['ID'];
  includeParentFeeId?: InputMaybe<Scalars['Boolean']>;
}>;


export type FetchAppliedFeesForCustomerBranchQuery = { __typename?: 'Query', customerBranch: { __typename?: 'CustomerBranch', id: string, marketResources?: Array<{ __typename?: 'MarketResource', id: string, market: { __typename?: 'Market', id: string, name?: string | null } }> | null, customer?: { __typename?: 'Customer', applicableFees?: Array<{ __typename?: 'ApplicableFee', id: string, isDefault?: boolean | null, fee?: { __typename?: 'Fee', id: string, name?: string | null, applicableType?: string | null } | null }> | null } | null, applicableFees?: Array<{ __typename?: 'ApplicableFee', id: string, isDefault?: boolean | null, parentFeeId?: string | null, fee?: { __typename?: 'Fee', id: string, name?: string | null, applicableType?: string | null } | null }> | null } };

export type FetchCustomerPricingQueryVariables = Exact<{
  filter?: InputMaybe<ResourcePricingFiltersInput>;
}>;


export type FetchCustomerPricingQuery = { __typename?: 'Query', resourcePricings: Array<{ __typename?: 'ResourcePricing', id: string, resourceType: string, resourceId: string, pocEmail?: string | null }> };

export type FetchCustomerPricingConfigurationQueryVariables = Exact<{
  id: Scalars['ID'];
  filter?: InputMaybe<ResourcePricingFilter>;
}>;


export type FetchCustomerPricingConfigurationQuery = { __typename?: 'Query', resourcePricing: { __typename?: 'ResourcePricing', id: string, discountUnit?: string | null, discount?: number | null, priceConfigurations: Array<{ __typename?: 'PriceConfiguration', id: string, calculatedFees?: any | null, calculatedTaxes?: any | null, calculatedMargins?: any | null, calculatedDiscount?: number | null, totalPrice?: number | null, pricing: { __typename?: 'Pricing', id?: string | null, hubId?: string | null, supplierId?: string | null, marketId?: string | null, terminalId?: string | null, productId?: string | null, price?: number | null, effectiveStartTimestamp?: string | null, effectiveEndTimestamp?: string | null, rateType?: { __typename?: 'RateType', name: string } | null } }> } };

export type FetchCustomerPricingPopOverDetailsQueryVariables = Exact<{
  customerId: Scalars['ID'];
  resourceId: Scalars['ID'];
}>;


export type FetchCustomerPricingPopOverDetailsQuery = { __typename?: 'Query', resourcePricing: { __typename?: 'ResourcePricing', id: string, resourceId: string, discount?: number | null, discountUnit?: string | null, pocName?: string | null, pocEmail?: string | null, pocPhone?: string | null, applicableTaxes: Array<{ __typename?: 'ApplicableTax', tax?: { __typename?: 'Tax', name?: string | null } | null }>, applicableMargins: Array<{ __typename?: 'ApplicableMargin', margin?: { __typename?: 'Margin', name?: string | null } | null }>, rateType: { __typename?: 'RateType', name: string, description?: string | null }, productCategories?: Array<{ __typename?: 'ProductCategory', name?: string | null }> | null }, customer: { __typename?: 'Customer', id: string, name?: string | null, marketResources?: Array<{ __typename?: 'MarketResource', market: { __typename?: 'Market', name?: string | null } }> | null, applicableFees?: Array<{ __typename?: 'ApplicableFee', fee?: { __typename?: 'Fee', name?: string | null } | null }> | null } };

export type ResourcePricingPopOverFragmentFragment = { __typename?: 'ResourcePricing', id: string, resourceId: string, discount?: number | null, discountUnit?: string | null, pocName?: string | null, pocEmail?: string | null, pocPhone?: string | null, applicableTaxes: Array<{ __typename?: 'ApplicableTax', tax?: { __typename?: 'Tax', name?: string | null } | null }>, applicableMargins: Array<{ __typename?: 'ApplicableMargin', margin?: { __typename?: 'Margin', name?: string | null } | null }>, rateType: { __typename?: 'RateType', name: string, description?: string | null }, productCategories?: Array<{ __typename?: 'ProductCategory', name?: string | null }> | null };

export type FetchFilteredCustomerBranchForDropDownQueryVariables = Exact<{
  filter?: InputMaybe<CustomerBranchFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<CustomerBranchSorter> | CustomerBranchSorter>;
}>;


export type FetchFilteredCustomerBranchForDropDownQuery = { __typename?: 'Query', filteredCustomerBranches: { __typename?: 'CustomerBranchCollection', collection: Array<{ __typename?: 'CustomerBranch', id: string, name?: string | null, erpId?: string | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean } } };

export type FetchFilteredCustomersForDropDownQueryVariables = Exact<{
  sorter?: InputMaybe<Array<BaseSorter> | BaseSorter>;
  perPage?: InputMaybe<Scalars['Int']>;
  offSet?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type FetchFilteredCustomersForDropDownQuery = { __typename?: 'Query', filteredCustomers: { __typename?: 'CustomerCollection', collection: Array<{ __typename?: 'Customer', id: string, name?: string | null, erpId?: string | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean } } };

export type FetchFilteredDriverRatesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  all?: InputMaybe<Scalars['String']>;
}>;


export type FetchFilteredDriverRatesQuery = { __typename?: 'Query', filteredDriverRates: { __typename?: 'DriverRateCollection', collection: Array<{ __typename?: 'DriverRate', id: string, rate?: number | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null } | null } | null, terminal?: { __typename?: 'Terminal', id: string, name?: string | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null } } };

export type MarginFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type MarginFiltersQuery = { __typename?: 'Query', filteredMargins: { __typename?: 'MarginCollection', collection: Array<{ __typename?: 'Margin', id?: string | null, name?: string | null, marginRate?: number | null, marginType?: string | null, marginUnit?: string | null, range?: Array<{ __typename?: 'MarginRangeAttribute', endRange?: string | null, rangeRate?: string | null, startRange?: string | null }> | null }> } };

export type FetchFilteredPricingsQueryVariables = Exact<{
  rateTypeId: Scalars['ID'];
  productIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type FetchFilteredPricingsQuery = { __typename?: 'Query', filteredPricings: Array<{ __typename?: 'Pricing', id?: string | null, hubId?: string | null, supplierId?: string | null, marketId?: string | null, productId?: string | null, terminalId?: string | null, effectiveStartTimestamp?: string | null, effectiveEndTimestamp?: string | null }> };

export type FetchFilteredResourcePricingsQueryVariables = Exact<{
  filter?: InputMaybe<ResourcePricingFiltersInput>;
}>;


export type FetchFilteredResourcePricingsQuery = { __typename?: 'Query', resourcePricings: Array<{ __typename: 'ResourcePricing', id: string, resourceType: string, resourceId: string, pocEmail?: string | null, applicableTaxes: Array<{ __typename?: 'ApplicableTax', id?: string | null, tax?: { __typename?: 'Tax', id?: string | null, name?: string | null } | null }>, applicableMargins: Array<{ __typename?: 'ApplicableMargin', id?: string | null, margin?: { __typename?: 'Margin', id?: string | null, name?: string | null } | null }> }> };

export type TaxFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type TaxFiltersQuery = { __typename?: 'Query', filteredTaxes: { __typename?: 'TaxCollection', collection: Array<{ __typename?: 'Tax', id?: string | null, name?: string | null, rateInPercent?: number | null, rateType?: string | null, rateInCurrency?: number | null, marketId?: string | null, productCategoryId?: string | null, calculationType?: string | null, glCode?: string | null, erpId?: string | null, description?: string | null, productCategoryResources?: Array<{ __typename?: 'ProductCategoryResource', id: string, productCategory: { __typename?: 'ProductCategory', id: string, name?: string | null } }> | null, productTaxes?: Array<{ __typename?: 'ProductTax', id?: string | null, productId?: string | null }> | null }> } };

export type FetchFilteredTerminalsForDropDownQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  all?: InputMaybe<Scalars['String']>;
  isWarehouse?: InputMaybe<Scalars['Boolean']>;
  sorter?: InputMaybe<Array<TerminalSorter> | TerminalSorter>;
}>;


export type FetchFilteredTerminalsForDropDownQuery = { __typename?: 'Query', filteredTerminals: { __typename?: 'TerminalCollection', collection: Array<{ __typename?: 'Terminal', id: string, name?: string | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type MarginQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MarginQuery = { __typename?: 'Query', margin: { __typename?: 'Margin', id?: string | null, name?: string | null, marginRate?: number | null, marginType?: string | null, marginUnit?: string | null, range?: Array<{ __typename?: 'MarginRangeAttribute', endRange?: string | null, rangeRate?: string | null, startRange?: string | null }> | null } };

export type FetchMarketQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchMarketQuery = { __typename?: 'Query', markets: Array<{ __typename?: 'Market', id: string, name?: string | null, address?: string | null, active?: boolean | null, hubResources?: Array<{ __typename?: 'HubResource', id: string, hub: { __typename?: 'Hub', id: string, name?: string | null, address?: any | null } }> | null }> };

export type MarketQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MarketQuery = { __typename?: 'Query', market: { __typename?: 'Market', id: string, name?: string | null, address?: string | null, active?: boolean | null, hubResources?: Array<{ __typename?: 'HubResource', id: string, hub: { __typename?: 'Hub', id: string, name?: string | null, address?: any | null } }> | null } };

export type FetchMarketsForPricingFormQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchMarketsForPricingFormQuery = { __typename?: 'Query', markets: Array<{ __typename?: 'Market', id: string, name?: string | null }> };

export type ProductCategoryProductIdsQueryVariables = Exact<{
  filter?: InputMaybe<ProductFilter>;
}>;


export type ProductCategoryProductIdsQuery = { __typename?: 'Query', filteredProducts: { __typename?: 'ProductCollection', collection: Array<{ __typename?: 'Product', id: string, name?: string | null, active: boolean }> } };

export type FetchProductForDropDownQueryVariables = Exact<{
  customFilter?: InputMaybe<ProductFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type FetchProductForDropDownQuery = { __typename?: 'Query', filteredProducts: { __typename?: 'ProductCollection', collection: Array<{ __typename?: 'Product', id: string, name?: string | null, active: boolean }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean } } };

export type FetchProductForTaxFormQueryVariables = Exact<{
  customFilter?: InputMaybe<ProductFilter>;
}>;


export type FetchProductForTaxFormQuery = { __typename?: 'Query', filteredProducts: { __typename?: 'ProductCollection', collection: Array<{ __typename?: 'Product', name?: string | null, id: string, active: boolean }> } };

export type FetchRateTypeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchRateTypeQuery = { __typename?: 'Query', rateType: { __typename?: 'RateType', id: string, name: string, description?: string | null, status: string } };

export type FetchRateTypesQueryVariables = Exact<{
  filter?: InputMaybe<FiltersInput>;
}>;


export type FetchRateTypesQuery = { __typename?: 'Query', rateTypes: Array<{ __typename?: 'RateType', id: string, name: string, status: string, description?: string | null }> };

export type FetchRawPricingImportSessionsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  sorter?: InputMaybe<Array<BaseSorter> | BaseSorter>;
}>;


export type FetchRawPricingImportSessionsQuery = { __typename?: 'Query', rawPricingImportSessions: { __typename?: 'RawPricingImportSessionCollection', collection: Array<{ __typename?: 'RawPricingImportSession', id: string, state: ImportSessionStateEnum, createdAt: any, updatedAt: any, provider: string, dataSource?: string | null, sourceDocument: { __typename?: 'PandaDocument', blobFileUrlDownload?: string | null }, normalizedDocument?: { __typename?: 'PandaDocument', blobFileUrlDownload?: string | null } | null, errorDocument?: { __typename?: 'PandaDocument', blobFileUrlDownload?: string | null } | null, aliasMappings: Array<{ __typename?: 'AliasMapping', id: string, dataSource: string, sourceValue?: string | null, mappableId?: string | null, mappableType?: MappableTypeEnum | null, mappable?: { __typename?: 'Market', id: string, nullableName?: string | null } | { __typename?: 'Product', id: string, nullableName?: string | null } | { __typename?: 'RateType', id: string, name: string } | { __typename?: 'Supplier', id: string, name: string } | null }> }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null } } };

export type FetchResourceNamesQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  resource: ResourceFetchEnum;
}>;


export type FetchResourceNamesQuery = { __typename?: 'Query', fetchResourceNames: any };

export type FetchResourcePricingDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchResourcePricingDetailQuery = { __typename?: 'Query', resourcePricing: { __typename?: 'ResourcePricing', id: string, discountUnit?: string | null, discount?: number | null, resourceId: string, resourceType: string, pocName?: string | null, pocEmail?: string | null, pocPhone?: string | null, marginsProducts?: Array<{ __typename?: 'MarginsProduct', id?: string | null, productId: string, margin?: { __typename?: 'Margin', id?: string | null } | null }> | null, productCategoryResources?: Array<{ __typename?: 'ProductCategoryResource', id: string, productCategory: { __typename?: 'ProductCategory', id: string, name?: string | null } }> | null, rateType: { __typename?: 'RateType', id: string }, priceConfigurations: Array<{ __typename?: 'PriceConfiguration', id: string, pricing: { __typename?: 'Pricing', id?: string | null, hubId?: string | null, supplierId?: string | null, marketId?: string | null, productId?: string | null } }>, applicableMargins: Array<{ __typename?: 'ApplicableMargin', id?: string | null, margin?: { __typename?: 'Margin', id?: string | null, name?: string | null } | null }>, applicableTaxes: Array<{ __typename?: 'ApplicableTax', id?: string | null, parentTaxId?: string | null, tax?: { __typename?: 'Tax', id?: string | null, name?: string | null, erpId?: string | null } | null }> } };

export type FetchResourcePricingHistoryQueryVariables = Exact<{
  resourcePricingId: Scalars['ID'];
}>;


export type FetchResourcePricingHistoryQuery = { __typename?: 'Query', pricingHistory?: Array<{ __typename?: 'PricingHistory', id: string, historableName: string, historableType: string, userName?: string | null, effectiveToTimestamp?: number | null, effectiveFromTimestamp?: number | null, status: string, resourcePricing: { __typename?: 'ResourcePricing', id: string } }> | null };

export type FetchShipToPricingPopOverDetailsQueryVariables = Exact<{
  customerBranchId: Scalars['ID'];
  resourceId: Scalars['ID'];
}>;


export type FetchShipToPricingPopOverDetailsQuery = { __typename?: 'Query', resourcePricing: { __typename?: 'ResourcePricing', id: string, resourceId: string, discount?: number | null, discountUnit?: string | null, pocName?: string | null, pocEmail?: string | null, pocPhone?: string | null, applicableTaxes: Array<{ __typename?: 'ApplicableTax', tax?: { __typename?: 'Tax', name?: string | null } | null }>, applicableMargins: Array<{ __typename?: 'ApplicableMargin', margin?: { __typename?: 'Margin', name?: string | null } | null }>, rateType: { __typename?: 'RateType', name: string, description?: string | null }, productCategories?: Array<{ __typename?: 'ProductCategory', name?: string | null }> | null }, customerBranch: { __typename?: 'CustomerBranch', id: string, name?: string | null, customer?: { __typename?: 'Customer', id: string } | null, marketResources?: Array<{ __typename?: 'MarketResource', market: { __typename?: 'Market', name?: string | null } }> | null, applicableFees?: Array<{ __typename?: 'ApplicableFee', fee?: { __typename?: 'Fee', name?: string | null } | null }> | null } };

export type FetchSuppliersForPricingFormQueryVariables = Exact<{
  filter?: InputMaybe<SupplierFilter>;
}>;


export type FetchSuppliersForPricingFormQuery = { __typename?: 'Query', filteredSuppliers: { __typename?: 'SupplierCollection', collection: Array<{ __typename?: 'Supplier', id: string, name: string }> } };

export type TaxQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TaxQuery = { __typename?: 'Query', tax: { __typename?: 'Tax', id?: string | null, name?: string | null, rateType?: string | null, rateInCurrency?: number | null, rateInPercent?: number | null, productCategoryId?: string | null, marketId?: string | null, erpId?: string | null, glCode?: string | null, description?: string | null, doNotRoundUpRate?: boolean | null, exempt?: boolean | null, amountType?: string | null, calculationType?: string | null, productCategoryResources?: Array<{ __typename?: 'ProductCategoryResource', id: string, productCategory: { __typename?: 'ProductCategory', id: string, name?: string | null } }> | null, productTaxes?: Array<{ __typename?: 'ProductTax', id?: string | null, pandaPriceTaxId?: string | null, productId?: string | null }> | null, dateRangeAttribute?: Array<{ __typename?: 'TaxRangeAttribute', startRange?: number | null, endRange?: number | null, rangeRate?: string | null }> | null } };

export type FetchTodaysPricingQueryVariables = Exact<{
  filter?: InputMaybe<PricingFilter>;
}>;


export type FetchTodaysPricingQuery = { __typename?: 'Query', todaysPricings: { __typename?: 'PricingCollection', collection: Array<{ __typename?: 'Pricing', id?: string | null, productId?: string | null, supplierId?: string | null, terminalId?: string | null, hubId?: string | null, marketId?: string | null, price?: number | null, previousPrice?: number | null, effectiveEndTimestamp?: string | null, effectiveStartTimestamp?: string | null, createdAtTimestamp?: string | null, rateType?: { __typename?: 'RateType', id: string, name: string } | null }> } };

export type FilteredDataFetchLoggerQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  filter?: InputMaybe<DataFetchLoggerFilter>;
  sorter?: InputMaybe<Array<DataFetchLoggerSorter> | DataFetchLoggerSorter>;
}>;


export type FilteredDataFetchLoggerQuery = { __typename?: 'Query', filteredDataFetchLogger: { __typename?: 'DataFetchLoggerCollection', collection: Array<{ __typename?: 'DataFetchLogger', id: string, createdAtTimestamp: number }>, metadata: { __typename?: 'MetaQuery', totalCount?: number | null } } };

export type FilteredFeesForPricingFormQueryVariables = Exact<{
  filter?: InputMaybe<FeeFilter>;
}>;


export type FilteredFeesForPricingFormQuery = { __typename?: 'Query', filteredFees: { __typename?: 'FeeCollection', collection: Array<{ __typename?: 'Fee', id: string, name?: string | null, applicableType?: string | null }> } };

export type FilteredMarginsForPricingFormQueryVariables = Exact<{ [key: string]: never; }>;


export type FilteredMarginsForPricingFormQuery = { __typename?: 'Query', filteredMargins: { __typename?: 'MarginCollection', collection: Array<{ __typename?: 'Margin', id?: string | null, name?: string | null }> } };

export type FilteredTaxesForPricingFormQueryVariables = Exact<{ [key: string]: never; }>;


export type FilteredTaxesForPricingFormQuery = { __typename?: 'Query', filteredTaxes: { __typename?: 'TaxCollection', collection: Array<{ __typename?: 'Tax', id?: string | null, name?: string | null, erpId?: string | null }> } };

export type FilteredTemporaryPricingCustomerBranchesQueryVariables = Exact<{
  customerId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  all?: InputMaybe<Scalars['String']>;
}>;


export type FilteredTemporaryPricingCustomerBranchesQuery = { __typename?: 'Query', filteredTemporaryPricingCustomerBranches: { __typename?: 'CustomerBranchCollection', metadata: { __typename?: 'MetaQuery', totalCount?: number | null, hasMore: boolean }, collection: Array<{ __typename?: 'CustomerBranch', id: string, erpId?: string | null, name?: string | null, customer?: { __typename?: 'Customer', id: string, erpId?: string | null, name?: string | null } | null, site?: { __typename?: 'Site', id: string, address?: any | null } | null }> } };

export type FilteredTemporaryPricingCustomersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  all?: InputMaybe<Scalars['String']>;
}>;


export type FilteredTemporaryPricingCustomersQuery = { __typename?: 'Query', filteredTemporaryPricingCustomers: { __typename?: 'CustomerCollection', metadata: { __typename?: 'MetaQuery', totalCount?: number | null, hasMore: boolean }, collection: Array<{ __typename?: 'Customer', id: string, erpId?: string | null, name?: string | null, site?: { __typename?: 'Site', id: string, address?: any | null } | null }> } };

export type FilteredTemporaryPricingsQueryVariables = Exact<{
  customerBranchId: Scalars['ID'];
}>;


export type FilteredTemporaryPricingsQuery = { __typename?: 'Query', filteredTemporaryPricings: Array<{ __typename?: 'Pricing', id?: string | null, productId?: string | null, price?: number | null, markup?: number | null, freight?: number | null, taxes?: number | null, isTemporary?: boolean | null, customerBranchId?: string | null, expirationDatetimeTimestamp?: string | null, effectiveStartTimestamp?: string | null, effectiveEndTimestamp?: string | null }> };

export type ImportRecordsMutationVariables = Exact<{
  input: ImportRecordsInput;
}>;


export type ImportRecordsMutation = { __typename?: 'Mutation', importRecords?: { __typename?: 'ImportRecordsPayload', dataImport?: { __typename?: 'DataImport', id: string } | null, pandaDocument?: { __typename?: 'PandaDocument', id: string } | null } | null };

export type ImportTemporaryPricingRecordsMutationVariables = Exact<{
  input: ImportRecordsInput;
}>;


export type ImportTemporaryPricingRecordsMutation = { __typename?: 'Mutation', importRecords?: { __typename?: 'ImportRecordsPayload', pandaDocument?: { __typename?: 'PandaDocument', id: string } | null, dataImport?: { __typename?: 'DataImport', id: string, status?: string | null, errorFileUrl?: string | null, filename?: string | null, createdAtTimestamp?: number | null } | null } | null };

export type UpdateMarginMutationVariables = Exact<{
  input: UpdateMarginInput;
}>;


export type UpdateMarginMutation = { __typename?: 'Mutation', updateMargin?: { __typename?: 'UpdateMarginPayload', margin?: { __typename?: 'Margin', id?: string | null, name?: string | null } | null } | null };

export type UpdateMarketMutationVariables = Exact<{
  input: UpdateMarketInput;
}>;


export type UpdateMarketMutation = { __typename?: 'Mutation', updateMarket?: { __typename?: 'UpdateMarketsPayload', market?: { __typename?: 'Market', id: string } | null } | null };

export type UpdatePricingsMutationVariables = Exact<{
  input: UpdatePricingInput;
}>;


export type UpdatePricingsMutation = { __typename?: 'Mutation', updatePricings?: { __typename: 'UpdatePricingPayload', response?: { __typename?: 'DeletePricingResponse', id: string, error?: string | null, success: boolean } | null } | null };

export type UpdateRateTypeMutationVariables = Exact<{
  input: UpdateRateTypeInput;
}>;


export type UpdateRateTypeMutation = { __typename?: 'Mutation', updateRateType?: { __typename?: 'UpdateRatePayload', rateType?: { __typename?: 'RateType', id: string, status: string } | null } | null };

export type UpdateRawPricingImportSessionMutationVariables = Exact<{
  input: UpdateRawPricingImportSessionInput;
}>;


export type UpdateRawPricingImportSessionMutation = { __typename?: 'Mutation', updateRawPricingImportSession?: { __typename?: 'UpdateRawPricingImportSessionPayload', rawPricingImportSession: { __typename?: 'RawPricingImportSession', id: string, state: ImportSessionStateEnum, createdAt: any, updatedAt: any, provider: string, dataSource?: string | null, sourceDocument: { __typename?: 'PandaDocument', blobFileUrlDownload?: string | null }, normalizedDocument?: { __typename?: 'PandaDocument', blobFileUrlDownload?: string | null } | null, errorDocument?: { __typename?: 'PandaDocument', blobFileUrlDownload?: string | null } | null, aliasMappings: Array<{ __typename?: 'AliasMapping', id: string, dataSource: string, sourceValue?: string | null, mappableId?: string | null, mappableType?: MappableTypeEnum | null, mappable?: { __typename?: 'Market', id: string, nullableName?: string | null } | { __typename?: 'Product', id: string, nullableName?: string | null } | { __typename?: 'RateType', id: string, name: string } | { __typename?: 'Supplier', id: string, name: string } | null }> } } | null };

export type UpdateResourcePricingsMutationVariables = Exact<{
  data: UpdateResourcePricingsInput;
}>;


export type UpdateResourcePricingsMutation = { __typename?: 'Mutation', updateResourcePricings?: { __typename?: 'UpdateResourcePricingPayload', resourcePricing?: { __typename?: 'ResourcePricing', id: string } | null } | null };

export type UpdateTaxMutationVariables = Exact<{
  input: UpdateTaxInput;
}>;


export type UpdateTaxMutation = { __typename?: 'Mutation', updateTax?: { __typename?: 'UpdateTaxPayload', tax?: { __typename?: 'Tax', id?: string | null, name?: string | null, erpId?: string | null, productTaxes?: Array<{ __typename?: 'ProductTax', id?: string | null, productId?: string | null }> | null } | null } | null };

export type RequestContactOtpMutationVariables = Exact<{
  input: RequestContactOtpInput;
}>;


export type RequestContactOtpMutation = { __typename?: 'Mutation', requestContactOtp?: { __typename?: 'RequestContactOtpPayload', success: boolean } | null };

export type UpdateUserProfileMutationVariables = Exact<{
  input: UpdateUsersInput;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UpdateUsersPayload', user?: { __typename?: 'User', id: string } | null } | null };

export type VerifyAndUpdateUserMutationVariables = Exact<{
  input: VerifyAndUpdateUserInput;
}>;


export type VerifyAndUpdateUserMutation = { __typename?: 'Mutation', verifyAndUpdateUser?: { __typename?: 'VerifyAndUpdateUserPayload', user?: { __typename?: 'User', id: string } | null } | null };

export type FetchRateTypesDropdownQueryVariables = Exact<{
  filter?: InputMaybe<FiltersInput>;
}>;


export type FetchRateTypesDropdownQuery = { __typename?: 'Query', rateTypes: Array<{ __typename?: 'RateType', id: string, name: string, status: string }> };

export type FetchProductsDropdownQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchProductsDropdownQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', id: string, name?: string | null, active: boolean }> };

export type FetchAssetMovementOrderIdsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchAssetMovementOrderIdsQuery = { __typename?: 'Query', asset: { __typename?: 'Asset', id: string, name?: string | null, existingActiveMovementOrderIds?: Array<string> | null } };

export type AddCodeToAssetMutationVariables = Exact<{
  input: AddCodeToAssetInput;
}>;


export type AddCodeToAssetMutation = { __typename?: 'Mutation', addCodeToAsset?: { __typename?: 'AddCodeToAssetPayload', clientMutationId?: string | null } | null };

export type AddQrCodeToAssetMutationVariables = Exact<{
  input: AddQrCodeToAssetInput;
}>;


export type AddQrCodeToAssetMutation = { __typename?: 'Mutation', addQrCodeToAsset?: { __typename?: 'AddQrCodeToAssetPayload', clientMutationId?: string | null } | null };

export type AddShipToSupplierPreferenceMutationVariables = Exact<{
  input: UpdateCustomerBranchInput;
}>;


export type AddShipToSupplierPreferenceMutation = { __typename?: 'Mutation', updateCustomerBranch?: { __typename?: 'UpdateCustomerBranchesPayload', customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, preferredProductTerminals?: Array<{ __typename?: 'PreferredProductTerminal', id: string, terminal: { __typename?: 'Terminal', id: string }, product: { __typename?: 'Product', id: string }, preferredProductTerminalSuppliers?: Array<{ __typename?: 'PreferredProductTerminalSupplier', id: string, supplier: { __typename?: 'Supplier', id: string } }> | null }> | null } | null } | null };

export type UpdateAssignPandaBoxMutationVariables = Exact<{
  input: AssignPandaBoxInput;
}>;


export type UpdateAssignPandaBoxMutation = { __typename?: 'Mutation', assignPandaBox?: { __typename?: 'AssignPandaBoxPayload', success: boolean, errors?: string | null } | null };

export type CreateAppVersionMutationVariables = Exact<{
  input: CreateAppVersionInput;
}>;


export type CreateAppVersionMutation = { __typename?: 'Mutation', createAppVersion?: { __typename?: 'CreateAppVersionPayload', errors?: Array<string> | null, success: boolean, appVersion?: { __typename?: 'AppVersion', id: string } | null } | null };

export type CreateAssetMutationVariables = Exact<{
  input: CreateAssetsInput;
}>;


export type CreateAssetMutation = { __typename?: 'Mutation', createAsset?: { __typename?: 'CreateAssetsPayload', asset?: { __typename?: 'Asset', id: string, customer?: { __typename?: 'Customer', tankReadingThreshold?: number | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null } | null, customerBranch?: { __typename?: 'CustomerBranch', hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null } | null } | null } | null };

export type CreateBrandMutationVariables = Exact<{
  input: CreateBrandsInput;
}>;


export type CreateBrandMutation = { __typename?: 'Mutation', createBrand?: { __typename?: 'CreateBrandsPayload', brand?: { __typename?: 'Brand', id: string } | null } | null };

export type CreateCommonCarrierMutationVariables = Exact<{
  input: CreateCommonCarrierInput;
}>;


export type CreateCommonCarrierMutation = { __typename?: 'Mutation', createCommonCarrier?: { __typename?: 'CreateCommonCarrierPayload', errorMsg?: string | null, ccTenant?: { __typename?: 'CcTenant', id: string, erpId?: string | null, address?: string | null, site?: { __typename?: 'Site', city?: string | null, state?: string | null, zip?: string | null, lat?: string | null, lng?: string | null, radius?: number | null } | null, carrierTenant: { __typename?: 'Tenant', id: string, name?: string | null, slug?: string | null, adminUsers?: Array<{ __typename?: 'User', id: string, name?: string | null, email: string, phone?: string | null }> | null } } | null } | null };

export type CreateCustomerMutationVariables = Exact<{
  input: CreateCustomerInput;
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomer?: { __typename?: 'CreateCustomersPayload', customer?: { __typename?: 'Customer', id: string, name?: string | null } | null } | null };

export type CreateCustomerBranchMutationVariables = Exact<{
  input: CreateCustomerBranchInput;
}>;


export type CreateCustomerBranchMutation = { __typename?: 'Mutation', createCustomerBranch?: { __typename?: 'CreateCustomerBranchesPayload', customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null } | null };

export type CreateCustomerSegmentMutationVariables = Exact<{
  input: CreateCustomerSegmentsInput;
}>;


export type CreateCustomerSegmentMutation = { __typename?: 'Mutation', createCustomerSegment?: { __typename?: 'CreateCustomerSegmentsPayload', customerSegment?: { __typename?: 'CustomerSegment', id: string, name?: string | null, code?: string | null, segmentType?: string | null } | null } | null };

export type CreateDirectUploadMutationVariables = Exact<{
  input: CreateDirectUpload;
}>;


export type CreateDirectUploadMutation = { __typename?: 'Mutation', createDirectUpload?: { __typename?: 'DirectUpload', blobId?: string | null, headers?: string | null, signedBlobId?: string | null, url?: string | null } | null };

export type CreateDriverMutationVariables = Exact<{
  input: CreateDriverInput;
}>;


export type CreateDriverMutation = { __typename?: 'Mutation', createDriver?: { __typename?: 'CreateDriversPayload', driver?: { __typename?: 'Driver', id: string, name?: string | null, erpId?: string | null } | null } | null };

export type CreateDriverDemurrageMutationVariables = Exact<{
  input: CreateDriverDemurrageInput;
}>;


export type CreateDriverDemurrageMutation = { __typename?: 'Mutation', createDriverDemurrage?: { __typename?: 'CreateDriverDemurragePayload', driverDemurrage?: { __typename?: 'DriverDemurrage', id?: string | null, customer?: { __typename?: 'Customer', name?: string | null } | null } | null } | null };

export type CreateFeeMutationVariables = Exact<{
  input: CreateFeesInput;
}>;


export type CreateFeeMutation = { __typename?: 'Mutation', createFee?: { __typename?: 'CreateFeesPayload', fee?: { __typename?: 'Fee', id: string, name?: string | null } | null } | null };

export type CreateLineOfServiceMutationVariables = Exact<{
  input: CreateLineOfServicesInput;
}>;


export type CreateLineOfServiceMutation = { __typename?: 'Mutation', createLineOfService?: { __typename?: 'CreateLineOfServicesPayload', lineOfService?: { __typename?: 'LineOfService', id: string } | null } | null };

export type CreateLoadingAccountMutationVariables = Exact<{
  input: CreateLoadingAccountsInput;
}>;


export type CreateLoadingAccountMutation = { __typename?: 'Mutation', createLoadingAccount?: { __typename?: 'CreateLoadingAccountsPayload', loadingAccount?: { __typename?: 'LoadingAccount', id: string } | null } | null };

export type CreatePandaBoxMutationVariables = Exact<{
  input: CreatePandaBoxInput;
}>;


export type CreatePandaBoxMutation = { __typename?: 'Mutation', createPandaBox?: { __typename?: 'CreatePandaBoxPayload', errors?: Array<string> | null, success: boolean, pandaBox?: { __typename?: 'PandaBox', id: string } | null } | null };

export type CreatePaymentTermMutationVariables = Exact<{
  input: CreatePaymentTermsInput;
}>;


export type CreatePaymentTermMutation = { __typename?: 'Mutation', createPaymentTerm?: { __typename?: 'CreatePaymentTermsPayload', paymentTerm?: { __typename?: 'PaymentTerm', id: string, name?: string | null, description?: string | null, netDaysToPay?: number | null } | null } | null };

export type CreatePeripheralMutationVariables = Exact<{
  input: CreatePeripheralInput;
}>;


export type CreatePeripheralMutation = { __typename?: 'Mutation', createPeripheral?: { __typename?: 'CreatePeripheralPayload', peripheral?: { __typename?: 'Peripheral', id: string } | null } | null };

export type CreateProductMutationVariables = Exact<{
  input: CreateProductsInput;
}>;


export type CreateProductMutation = { __typename?: 'Mutation', createProduct?: { __typename?: 'CreateProductsPayload', product?: { __typename?: 'Product', id: string } | null } | null };

export type CreateProductPurchaseLimitMutationVariables = Exact<{
  input: CreateProductPurchaseLimitsInput;
}>;


export type CreateProductPurchaseLimitMutation = { __typename?: 'Mutation', createProductPurchaseLimit?: { __typename?: 'CreateProductPurchaseLimitsPayload', productPurchaseLimit?: { __typename?: 'ProductPurchaseLimit', id: string } | null } | null };

export type CreateResourceScheduleMutationVariables = Exact<{
  input: CreateResourceScheduleInput;
}>;


export type CreateResourceScheduleMutation = { __typename?: 'Mutation', createResourceSchedule?: { __typename?: 'CreateResourceSchedulePayload', resourceSchedule?: { __typename?: 'ResourceSchedule', id?: string | null, preferrableId?: string | null, preferrableType?: PreferrableTypeEnum | null, availability?: Array<{ __typename?: 'Availability', day?: string | null, startTime?: string | null, endTime?: string | null, bestStartTime?: string | null, bestEndTime?: string | null, preferredStartTime?: string | null, preferredEndTime?: string | null }> | null, unavailability?: Array<{ __typename?: 'Unavailability', reason?: string | null, unStartTime?: string | null }> | null } | null } | null };

export type CreateSupplierMutationVariables = Exact<{
  input: CreateSupplierInput;
}>;


export type CreateSupplierMutation = { __typename?: 'Mutation', createSupplier?: { __typename?: 'CreateSuppliersPayload', supplier?: { __typename?: 'Supplier', id: string } | null } | null };

export type CreateTerminalMutationVariables = Exact<{
  input: TerminalInput;
}>;


export type CreateTerminalMutation = { __typename?: 'Mutation', createTerminal?: { __typename?: 'CreateTerminalsPayload', terminal?: { __typename?: 'Terminal', id: string, name?: string | null } | null } | null };

export type CreateUserMutationVariables = Exact<{
  input: CreateCustomerUsersInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createCustomerUser?: { __typename?: 'CreateCustomerUsersPayload', customerUser?: { __typename?: 'CustomerUser', id: string } | null } | null };

export type DeleteAssetsMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAssetsMutation = { __typename?: 'Mutation', deleteAsset?: { __typename?: 'DeleteAssetsPayload', asset?: { __typename?: 'Asset', id: string, name?: string | null, erpId?: string | null } | null } | null };

export type DeleteBrandMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteBrandMutation = { __typename?: 'Mutation', deleteBrand?: { __typename?: 'DeleteBrandsPayload', response?: { __typename?: 'DeleteResponse', success: boolean, id: string } | null } | null };

export type DeleteCustomerBranchMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCustomerBranchMutation = { __typename?: 'Mutation', deleteCustomerBranch?: { __typename?: 'DeleteCustomerBranchesPayload', response?: { __typename?: 'DeleteResponse', id: string, success: boolean } | null } | null };

export type DeleteFeeMutationVariables = Exact<{
  input: DeleteFeesInput;
}>;


export type DeleteFeeMutation = { __typename?: 'Mutation', deleteFee?: { __typename?: 'DeleteFeesPayload', response?: { __typename?: 'DeleteResponse', id: string, error?: string | null, success: boolean } | null } | null };

export type DeletePeripheralMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePeripheralMutation = { __typename?: 'Mutation', deletePeripheral?: { __typename?: 'DeletePeripheralPayload', success?: boolean | null, message?: string | null, peripheral?: { __typename?: 'Peripheral', id: string, peripheralCategory?: { __typename?: 'PeripheralCategory', id: string, name?: string | null } | null } | null } | null };

export type DeleteSupplierMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteSupplierMutation = { __typename?: 'Mutation', deleteSupplier?: { __typename?: 'DeleteSuppliersPayload', supplier?: { __typename?: 'Supplier', id: string, name: string, erpId?: string | null } | null } | null };

export type DeleteTerminalMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTerminalMutation = { __typename?: 'Mutation', deleteTerminal?: { __typename?: 'DeleteTerminalsPayload', terminal?: { __typename?: 'Terminal', id: string, name?: string | null, erpId?: string | null } | null } | null };

export type DirectUploadPandaDocumentMutationVariables = Exact<{
  data: DirectAttachmentInput;
}>;


export type DirectUploadPandaDocumentMutation = { __typename?: 'Mutation', directUploadPandaDocument?: { __typename?: 'DirectUploadPandaDocumentPayload', pandaDocument?: { __typename?: 'PandaDocument', id: string } | null } | null };

export type FetchAssetsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<AssetSorter> | AssetSorter>;
  customerIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  customerBranchId?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  filter?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<AssetTypeEnum> | AssetTypeEnum>;
}>;


export type FetchAssetsQuery = { __typename?: 'Query', filteredAssets: { __typename?: 'AssetCollection', collection: Array<{ __typename?: 'Asset', id: string, status?: string | null, name?: string | null, category?: string | null, qrCodeText?: string | null, licensePlateNumber?: string | null, erpId?: string | null, irelyId?: string | null, lastSyncedTime?: string | null, netsuiteId?: string | null, lastActiveTenantId?: string | null, rfidCode?: string | null, assignedPandaBox?: { __typename?: 'PandaBox', id: string, name: string } | null, subscriptions?: Array<{ __typename?: 'Subscription', id: string, product: { __typename?: 'Product', id: string, erpId?: string | null, name?: string | null } }> | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, address?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, address?: string | null } | null } | null, assetProductCategories?: Array<{ __typename?: 'AssetProductCategory', id: string, networkName?: string | null, networkNumber?: string | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FetchAssetsWithHubsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<AssetSorter> | AssetSorter>;
  customerIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  customerBranchId?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  filter?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<AssetTypeEnum> | AssetTypeEnum>;
}>;


export type FetchAssetsWithHubsQuery = { __typename?: 'Query', filteredAssets: { __typename?: 'AssetCollection', collection: Array<{ __typename?: 'Asset', id: string, status?: string | null, name?: string | null, category?: string | null, qrCodeText?: string | null, licensePlateNumber?: string | null, erpId?: string | null, irelyId?: string | null, lastSyncedTime?: string | null, lastActiveTenantId?: string | null, rfidCode?: string | null, createdBy?: { __typename?: 'User', name?: string | null } | null, assignedPandaBox?: { __typename?: 'PandaBox', id: string, name: string } | null, subscriptions?: Array<{ __typename?: 'Subscription', id: string, product: { __typename?: 'Product', id: string, erpId?: string | null, name?: string | null } }> | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, address?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, address?: string | null } | null } | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null, assetProductCategories?: Array<{ __typename?: 'AssetProductCategory', id: string, networkName?: string | null, networkNumber?: string | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type BranchRelatedToCustomerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BranchRelatedToCustomerQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', customerBranches?: Array<{ __typename?: 'CustomerBranch', id: string, name?: string | null, deliveryInstruction?: string | null, erpId?: string | null, netsuiteName?: string | null, site?: { __typename?: 'Site', address?: any | null, id: string, lat?: string | null, lng?: string | null, radius?: number | null } | null }> | null } };

export type BrandQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BrandQuery = { __typename?: 'Query', brand: { __typename?: 'Brand', id: string, name?: string | null } };

export type FetchBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchBrandsQuery = { __typename?: 'Query', brands: Array<{ __typename?: 'Brand', id: string, name?: string | null }> };

export type CapacityTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type CapacityTypesQuery = { __typename?: 'Query', capacityTypes: Array<{ __typename?: 'CapacityTypes', description: string, value: string }> };

export type FetchCommonCarriersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  customFilter?: InputMaybe<CcTenantFilter>;
  sorter?: InputMaybe<Array<CcTenantSorter> | CcTenantSorter>;
}>;


export type FetchCommonCarriersQuery = { __typename?: 'Query', filteredCcTenants?: { __typename?: 'CcTenantCollection', collection: Array<{ __typename?: 'CcTenant', erpId?: string | null, name: string, id: string, secondaryEmails?: Array<string> | null, userAttributes?: any | null, carrierTenantId: string, carrierTenant: { __typename?: 'Tenant', id: string, name?: string | null, slug?: string | null, adminUsers?: Array<{ __typename?: 'User', id: string, name?: string | null, email: string, phone?: string | null }> | null }, site?: { __typename?: 'Site', id: string, address?: any | null, city?: string | null, state?: string | null, zip?: string | null, lat?: string | null, lng?: string | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null } } | null };

export type FetchCreditExceededCustomersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  creditLimitExceededFilter?: InputMaybe<Scalars['Boolean']>;
}>;


export type FetchCreditExceededCustomersQuery = { __typename?: 'Query', filteredCustomers: { __typename?: 'CustomerCollection', collection: Array<{ __typename?: 'Customer', id: string, name?: string | null, creditLimitExceeded?: boolean | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type CustomerAssetDataFragment = { __typename?: 'Asset', id: string, name?: string | null, licensePlateNumber?: string | null, category?: string | null, fuelCategories?: Array<string> | null, color?: string | null, erpId?: string | null, make?: string | null, model?: string | null, status?: string | null, useInDelivery?: boolean | null, isRunningFuelOffsetAsset?: boolean | null, isTransport?: boolean | null, year?: number | null, qrCodeText?: string | null, barcodeText?: string | null, netsuiteId?: string | null, data?: any | null, type?: string | null, lat?: string | null, lng?: string | null, margin?: number | null, installDate?: any | null, rfidCode?: string | null, enableZone?: boolean | null, noOfZone?: number | null, trackInventory?: boolean | null, lastActiveTenantId?: string | null, lastActiveTenantName?: string | null, estimatedGallonsPerMonth?: number | null, tankType?: string | null, tankSize?: string | null, costOfTank?: number | null, marketValue?: number | null, purchasedOn?: any | null, routingVehicleType?: string | null, createdBy?: { __typename?: 'User', name?: string | null } | null, taggings?: Array<{ __typename?: 'Tagging', id: string, tag?: { __typename?: 'Tag', id: string, name: string, colorCode?: string | null, iconName?: string | null, description?: string | null } | null }> | null, assetMovementLocation?: { __typename?: 'AssetMovementLocation', id: string, lat?: string | null, lng?: string | null, updatedAt?: any | null, updatable?: { __typename?: 'Driver' } | { __typename?: 'User', id: string, name?: string | null } | { __typename?: 'Worker', id: string, name?: string | null } | null } | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, nameWithAncestors?: string | null }> | null, assignedPandaBox?: { __typename?: 'PandaBox', id: string, name: string, imeiNumber?: string | null, version?: string | null, pandaBoxAssets: Array<{ __typename?: 'PandaBoxAsset', id: string, active: boolean, pandaBox?: { __typename?: 'PandaBox', id: string } | null }>, pandaBoxMeters?: Array<{ __typename?: 'PandaBoxMeter', id: string, meterModel?: string | null, meterName?: string | null, lcpNode?: string | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null } | null, assetProductCategories?: Array<{ __typename?: 'AssetProductCategory', id: string, networkName?: string | null, networkNumber?: string | null, registerModel?: string | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null, subscriptions?: Array<{ __typename?: 'Subscription', id: string, status?: string | null, product: { __typename?: 'Product', id: string, name?: string | null, erpId?: string | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null } }> | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, tankReadingThreshold?: number | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null } | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, address?: string | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null, site?: { __typename?: 'Site', lat?: string | null, lng?: string | null } | null } | null, terminals?: Array<{ __typename?: 'Terminal', id: string, name?: string | null }> | null, pandaDocuments?: Array<{ __typename?: 'PandaDocument', id: string, documentType?: string | null, externalFileData?: { __typename?: 'AttachedFile', id?: string | null, contentType?: string | null, filename?: string | null, url?: string | null } | null }> | null, fuelTypeProducts?: Array<{ __typename?: 'Product', id: string, name?: string | null }> | null, compartments?: Array<{ __typename?: 'Compartment', id: string, name?: string | null, diameter?: number | null, erpId?: string | null, length?: number | null, alignment?: string | null, capacities?: Array<{ __typename?: 'Capacity', id: string, fuelType: string, value: number, unit: string, usablePercentage?: number | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null }> | null, hubResources?: Array<{ __typename?: 'HubResource', id: string, hub: { __typename?: 'Hub', id: string, name?: string | null } }> | null, assetsPeripherals?: Array<{ __typename?: 'AssetsPeripheral', id: string, assetId?: string | null, peripheralId: string, assetsPeripheralsRecords?: Array<{ __typename?: 'AssetsPeripheralsRecord', id: string, peripheralAttributeId: number, assetsPeripheralId?: number | null, value?: string | null, fileUrl?: string | null }> | null }> | null };

export type FetchCustomerAssetQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchCustomerAssetQuery = { __typename?: 'Query', asset: { __typename?: 'Asset', id: string, name?: string | null, licensePlateNumber?: string | null, category?: string | null, fuelCategories?: Array<string> | null, color?: string | null, erpId?: string | null, make?: string | null, model?: string | null, status?: string | null, useInDelivery?: boolean | null, isRunningFuelOffsetAsset?: boolean | null, isTransport?: boolean | null, year?: number | null, qrCodeText?: string | null, barcodeText?: string | null, netsuiteId?: string | null, data?: any | null, type?: string | null, lat?: string | null, lng?: string | null, margin?: number | null, installDate?: any | null, rfidCode?: string | null, enableZone?: boolean | null, noOfZone?: number | null, trackInventory?: boolean | null, lastActiveTenantId?: string | null, lastActiveTenantName?: string | null, estimatedGallonsPerMonth?: number | null, tankType?: string | null, tankSize?: string | null, costOfTank?: number | null, marketValue?: number | null, purchasedOn?: any | null, routingVehicleType?: string | null, createdBy?: { __typename?: 'User', name?: string | null } | null, taggings?: Array<{ __typename?: 'Tagging', id: string, tag?: { __typename?: 'Tag', id: string, name: string, colorCode?: string | null, iconName?: string | null, description?: string | null } | null }> | null, assetMovementLocation?: { __typename?: 'AssetMovementLocation', id: string, lat?: string | null, lng?: string | null, updatedAt?: any | null, updatable?: { __typename?: 'Driver' } | { __typename?: 'User', id: string, name?: string | null } | { __typename?: 'Worker', id: string, name?: string | null } | null } | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, nameWithAncestors?: string | null }> | null, assignedPandaBox?: { __typename?: 'PandaBox', id: string, name: string, imeiNumber?: string | null, version?: string | null, pandaBoxAssets: Array<{ __typename?: 'PandaBoxAsset', id: string, active: boolean, pandaBox?: { __typename?: 'PandaBox', id: string } | null }>, pandaBoxMeters?: Array<{ __typename?: 'PandaBoxMeter', id: string, meterModel?: string | null, meterName?: string | null, lcpNode?: string | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null } | null, assetProductCategories?: Array<{ __typename?: 'AssetProductCategory', id: string, networkName?: string | null, networkNumber?: string | null, registerModel?: string | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null, subscriptions?: Array<{ __typename?: 'Subscription', id: string, status?: string | null, product: { __typename?: 'Product', id: string, name?: string | null, erpId?: string | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null } }> | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, tankReadingThreshold?: number | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null } | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, address?: string | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null, site?: { __typename?: 'Site', lat?: string | null, lng?: string | null } | null } | null, terminals?: Array<{ __typename?: 'Terminal', id: string, name?: string | null }> | null, pandaDocuments?: Array<{ __typename?: 'PandaDocument', id: string, documentType?: string | null, externalFileData?: { __typename?: 'AttachedFile', id?: string | null, contentType?: string | null, filename?: string | null, url?: string | null } | null }> | null, fuelTypeProducts?: Array<{ __typename?: 'Product', id: string, name?: string | null }> | null, compartments?: Array<{ __typename?: 'Compartment', id: string, name?: string | null, diameter?: number | null, erpId?: string | null, length?: number | null, alignment?: string | null, capacities?: Array<{ __typename?: 'Capacity', id: string, fuelType: string, value: number, unit: string, usablePercentage?: number | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null }> | null, hubResources?: Array<{ __typename?: 'HubResource', id: string, hub: { __typename?: 'Hub', id: string, name?: string | null } }> | null, assetsPeripherals?: Array<{ __typename?: 'AssetsPeripheral', id: string, assetId?: string | null, peripheralId: string, assetsPeripheralsRecords?: Array<{ __typename?: 'AssetsPeripheralsRecord', id: string, peripheralAttributeId: number, assetsPeripheralId?: number | null, value?: string | null, fileUrl?: string | null }> | null }> | null } };

export type FetchCustomerAssetFormContextQueryVariables = Exact<{
  customerId: Scalars['ID'];
}>;


export type FetchCustomerAssetFormContextQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, customerBranches?: Array<{ __typename?: 'CustomerBranch', id: string, name?: string | null, address?: string | null, status?: boolean | null, site?: { __typename?: 'Site', lat?: string | null, lng?: string | null } | null }> | null }, productCategories: Array<{ __typename?: 'ProductCategory', id: string, name?: string | null }> };

export type FetchCustomerAssetsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<AssetSorter> | AssetSorter>;
  customerIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  customerBranchId?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  filter?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<AssetTypeEnum> | AssetTypeEnum>;
  approvalStatus?: InputMaybe<AssetApprovalStatusEnum>;
}>;


export type FetchCustomerAssetsQuery = { __typename?: 'Query', filteredAssets: { __typename?: 'AssetCollection', collection: Array<{ __typename?: 'Asset', id: string, status?: string | null, name?: string | null, category?: string | null, data?: any | null, qrCodeText?: string | null, licensePlateNumber?: string | null, installDate?: any | null, erpId?: string | null, netsuiteId?: string | null, rfidCode?: string | null, lastActiveTenantId?: string | null, createdBy?: { __typename?: 'User', name?: string | null } | null, customer?: { __typename?: 'Customer', id: string, tankReadingThreshold?: number | null } | null, subscriptions?: Array<{ __typename?: 'Subscription', id: string, product: { __typename?: 'Product', id: string, erpId?: string | null, productType: string, name?: string | null } }> | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, address?: string | null, purchaseOrder?: boolean | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, address?: string | null } | null } | null, assetProductCategories?: Array<{ __typename?: 'AssetProductCategory', id: string, networkName?: string | null, networkNumber?: string | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type CustomerBranchQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomerBranchQuery = { __typename?: 'Query', customerBranch: { __typename?: 'CustomerBranch', id: string, name?: string | null, deliveryInstructionUpdatedAt?: any | null, deliveryInstructionUpdatedBy?: string | null, resourcePricingId?: string | null, deliveryInstruction?: string | null, cardLockSiteNumber?: string | null, erpId?: string | null, priceCode?: string | null, purchaseOrderType?: PurchaseOrderTypeEnum | null, purchaseOrder?: boolean | null, poNumber?: string | null, autoEmailDeliveryTicket: boolean, netsuiteId?: string | null, netsuiteName?: string | null, isHub?: boolean | null, attachBolOnDeliveryTicket: boolean, isCustomerSignatureRequired: boolean, nonEditableRecords?: Array<any> | null, qboItemizeLineItemOnSalesOrder?: boolean | null, onlyShowGrossGallonsInDeliveryTicket?: boolean | null, syncSalesToD1?: boolean | null, status?: boolean | null, taggings?: Array<{ __typename?: 'Tagging', id: string, tag?: { __typename?: 'Tag', id: string, name: string, colorCode?: string | null, iconName?: string | null, description?: string | null } | null }> | null, crudePricings?: Array<{ __typename?: 'CrudePricing', id?: string | null, range?: any | null, productId?: string | null, pandaPriceRateType?: { __typename?: 'RateType', id: string, name: string } | null }> | null, hubResources?: Array<{ __typename?: 'HubResource', id: string, hub: { __typename?: 'Hub', id: string, name?: string | null, address?: any | null, status?: boolean | null } }> | null, pickupPointCodes?: Array<{ __typename?: 'PickupPointCode', id: string, name?: string | null, code?: string | null }> | null, loadingAccounts?: Array<{ __typename?: 'LoadingAccount', id: string }> | null, suppliers?: Array<{ __typename?: 'Supplier', id: string, name: string, active?: boolean | null }> | null, addressBooks?: Array<{ __typename?: 'AddressBook', id: string, name?: string | null, email?: string | null, phone?: string | null, address?: string | null, note?: string | null, jobTitle?: string | null, addressBookType?: string | null, hasAccessToCustomerPortal?: boolean | null, isDeliveryTicketRecipient?: boolean | null }> | null, site?: { __typename?: 'Site', address?: any | null, id: string, lat?: string | null, lng?: string | null, radius?: number | null } | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, nameWithAncestors?: string | null }> | null, applicableFees?: Array<{ __typename?: 'ApplicableFee', id: string, parentFeeId?: string | null, isDefault?: boolean | null, hardcoded?: boolean | null, netsuiteId?: string | null, quantity?: number | null, price?: number | null, fee?: { __typename?: 'Fee', id: string, name?: string | null, price?: number | null, applicableType?: string | null } | null }> | null, pandaDocuments?: Array<{ __typename?: 'PandaDocument', id: string, documentType?: string | null, externalFileData?: { __typename?: 'AttachedFile', id?: string | null, contentType?: string | null, filename?: string | null, url?: string | null } | null }> | null, customer?: { __typename?: 'Customer', id: string } | null } };

export type CustomerBranchDetailPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomerBranchDetailPageQuery = { __typename?: 'Query', customerBranch: { __typename?: 'CustomerBranch', id: string, name?: string | null, resourcePricingId?: string | null, irelyId?: string | null, site?: { __typename?: 'Site', address?: any | null, id: string, lat?: string | null, lng?: string | null, radius?: number | null } | null, customer?: { __typename?: 'Customer', resourcePricingId?: string | null } | null } };

export type CustomerBranchResourceScheduleQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomerBranchResourceScheduleQuery = { __typename?: 'Query', customerBranch: { __typename?: 'CustomerBranch', id: string, resourceSchedule?: { __typename?: 'ResourceSchedule', preferrableType?: PreferrableTypeEnum | null, preferrableId?: string | null, id?: string | null, availability?: Array<{ __typename?: 'Availability', day?: string | null, startTime?: string | null, endTime?: string | null, bestEndTime?: string | null, bestStartTime?: string | null }> | null } | null } };

export type CustomerProfileQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomerProfileQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, resourcePricingId?: string | null, name?: string | null, groupName?: string | null, thirdPartyDelivery?: boolean | null, poBoxNumber?: string | null, erpId?: string | null, accountId?: string | null, status?: number | null, poNumber?: string | null, quickbridgeId?: string | null, purchaseOrder?: boolean | null, purchaseOrderType?: PurchaseOrderTypeEnum | null, address?: string | null, exemptStatus?: Array<string> | null, netsuiteId?: string | null, netsuiteName?: string | null, creditChecked?: boolean | null, attachPostDeliveryImageOnDeliveryTicket?: boolean | null, creditLimitPercentageBuffer?: string | null, creditLimitDaysOverdueBuffer?: string | null, creditLimit?: string | null, currentBalance?: string | null, daysOverdue?: string | null, dueDate?: string | null, vendorErpId?: string | null, arDivisionNumber?: string | null, deliveryInstruction?: string | null, fleetCardNumbers?: Array<string> | null, enableCreateDeliveryOrder?: boolean | null, customerPortalPermissions?: any | null, portalAccessLevel?: PortalAccessLevelEnum | null, tankReadingThreshold?: number | null, permitNumber?: string | null, totalRequestedVolume?: any | null, productPurchaseLimitId?: string | null, irelyId?: string | null, nonEditableRecords?: Array<any> | null, epaId?: string | null, agreedLoadGallon?: number | null, paymentTypeName?: PaymentTypeEnum | null, feinNumber?: string | null, hideVendorPricing?: boolean | null, productPurchaseLimit?: { __typename?: 'ProductPurchaseLimit', id: string, name?: string | null, volume?: string | null, timeUnit?: TimeUnitEnum | null, product?: { __typename?: 'Product', id: string, name?: string | null } | null } | null, site?: { __typename?: 'Site', id: string, lat?: string | null, lng?: string | null } | null, preferredDrivers?: Array<{ __typename?: 'Worker', id: string, name?: string | null }> | null, applicableFees?: Array<{ __typename?: 'ApplicableFee', id: string, isDefault?: boolean | null, hardcoded?: boolean | null, netsuiteId?: string | null, fee?: { __typename?: 'Fee', id: string, name?: string | null, price?: number | null, applicableType?: string | null } | null }> | null, crudePricings?: Array<{ __typename?: 'CrudePricing', id?: string | null, range?: any | null, productId?: string | null, pandaPriceRateType?: { __typename?: 'RateType', id: string, name: string } | null }> | null, addressBooks?: Array<{ __typename?: 'AddressBook', id: string, name?: string | null, email?: string | null, phone?: string | null, address?: string | null, note?: string | null, jobTitle?: string | null, isDeliveryTicketRecipient?: boolean | null, hasAccessToCustomerPortal?: boolean | null, showInviteLink?: boolean | null, image?: { __typename?: 'AttachedFile', url?: string | null } | null }> | null, users?: Array<{ __typename?: 'User', id: string, name?: string | null, email: string, phone?: string | null, status?: number | null }> | null, hubResources?: Array<{ __typename?: 'HubResource', id: string, hub: { __typename?: 'Hub', id: string, name?: string | null, address?: any | null, status?: boolean | null } }> | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, nameWithAncestors?: string | null }> | null, customerSegment?: { __typename?: 'CustomerSegment', id: string } | null, paymentTerm?: { __typename?: 'PaymentTerm', id: string } | null, taggings?: Array<{ __typename?: 'Tagging', id: string, tag?: { __typename?: 'Tag', id: string, name: string, colorCode?: string | null, iconName?: string | null, description?: string | null } | null }> | null } };

export type FetchCustomerFeesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchCustomerFeesQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, applicableFees?: Array<{ __typename?: 'ApplicableFee', id: string, isDefault?: boolean | null, hardcoded?: boolean | null, netsuiteId?: string | null, fee?: { __typename?: 'Fee', id: string, name?: string | null, price?: number | null, applicableType?: string | null } | null }> | null } };

export type CustomerFormContextQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerFormContextQuery = { __typename?: 'Query', drivers: Array<{ __typename?: 'Driver', id: string, name?: string | null }>, fees: Array<{ __typename?: 'Fee', id: string, name?: string | null, applicableType?: string | null }> };

export type FetchCustomerNameAndIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchCustomerNameAndIdQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, name?: string | null, tankReadingThreshold?: number | null, addressBooks?: Array<{ __typename?: 'AddressBook', id: string, name?: string | null }> | null } };

export type FetchCustomerPointOfContactQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchCustomerPointOfContactQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, addressBooks?: Array<{ __typename?: 'AddressBook', id: string, note?: string | null, name?: string | null, email?: string | null, phone?: string | null, addressBookType?: string | null, address?: string | null, jobTitle?: string | null, isDeliveryTicketRecipient?: boolean | null, hasAccessToCustomerPortal?: boolean | null, image?: { __typename?: 'AttachedFile', url?: string | null } | null }> | null } };

export type CustomerResourceScheduleQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomerResourceScheduleQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, resourceSchedule?: { __typename?: 'ResourceSchedule', preferrableType?: PreferrableTypeEnum | null, preferrableId?: string | null, id?: string | null, availability?: Array<{ __typename?: 'Availability', day?: string | null, startTime?: string | null, endTime?: string | null, bestEndTime?: string | null, bestStartTime?: string | null }> | null } | null } };

export type FetchCustomerSegmentDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchCustomerSegmentDetailsQuery = { __typename?: 'Query', customerSegment: { __typename?: 'CustomerSegment', id: string, name?: string | null, code?: string | null, segmentType?: string | null } };

export type FetchCustomerSegmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchCustomerSegmentsQuery = { __typename?: 'Query', customerSegments: Array<{ __typename?: 'CustomerSegment', id: string, name?: string | null, code?: string | null, segmentType?: string | null }> };

export type FetchCustomerShipToAddressQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchCustomerShipToAddressQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, customerBranches?: Array<{ __typename?: 'CustomerBranch', address?: string | null }> | null } };

export type FetchCustomerUserQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type FetchCustomerUserQuery = { __typename?: 'Query', filteredCustomerUsers: { __typename?: 'CustomerUserCollection', collection: Array<{ __typename?: 'CustomerUser', id: string, active?: boolean | null, customer?: { __typename?: 'Customer', id: string } | null, user?: { __typename?: 'User', id: string } | null, hubResources?: Array<{ __typename?: 'HubResource', id: string, hub: { __typename?: 'Hub', id: string, name?: string | null, address?: any | null } }> | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, nameWithAncestors?: string | null, name?: string | null }> | null }> } };

export type FetchCustomerUsersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<CustomerUserSorter> | CustomerUserSorter>;
  customerId: Scalars['ID'];
  filter?: InputMaybe<Scalars['String']>;
}>;


export type FetchCustomerUsersQuery = { __typename?: 'Query', customerUsers: { __typename?: 'CustomerUserCollection', collection: Array<{ __typename?: 'CustomerUser', active?: boolean | null, customerUserId: string, user?: { __typename?: 'User', id: string, status?: number | null, name?: string | null, otp?: string | null, phone?: string | null, email: string, roles?: Array<{ __typename?: 'Role', id: string, name?: string | null }> | null } | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, nameWithAncestors?: string | null, name?: string | null }> | null }>, metadata: { __typename?: 'MetaQuery', totalCount?: number | null } } };

export type DriverDemurrageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DriverDemurrageQuery = { __typename?: 'Query', driverDemurrage: { __typename?: 'DriverDemurrage', id?: string | null, offsetAmount?: number | null, offsetRate?: number | null, offsetType?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, erpId?: string | null } | null, rangeAttribute?: Array<{ __typename?: 'RangeAttribute', startRange?: string | null, endRange?: string | null, rangeRate?: string | null }> | null } };

export type DriverQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DriverQuery = { __typename?: 'Query', driver: { __typename?: 'Driver', id: string, erpId?: string | null, name?: string | null, email?: string | null, homeAddress?: string | null, licenceExpiryDate?: string | null, contractSignDate?: string | null, reasonForLeaving?: string | null, startDate?: string | null, endDate?: string | null, paymentStrategy?: string | null, status?: string | null, hourlyRate?: number | null, phoneNumbers?: Array<{ __typename?: 'DriverPhoneNumber', device?: string | null, id: string, primary?: boolean | null, status?: string | null, value?: string | null }> | null, image?: { __typename?: 'AttachedFile', filename?: string | null, id?: string | null, url?: string | null } | null, s3BackgroundCheck?: { __typename?: 'AttachedFile', filename?: string | null, id?: string | null, url?: string | null } | null, s3DriverApplication?: { __typename?: 'AttachedFile', filename?: string | null, id?: string | null, url?: string | null } | null, s3H6?: { __typename?: 'AttachedFile', filename?: string | null, id?: string | null, url?: string | null } | null, s3Licenses?: Array<{ __typename?: 'AttachedFile', filename?: string | null, id?: string | null, url?: string | null }> | null, hubResources?: Array<{ __typename?: 'HubResource', id: string, hub: { __typename?: 'Hub', id: string, name?: string | null, address?: any | null } }> | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, nameWithAncestors?: string | null, name?: string | null }> | null, weeklySchedules?: Array<{ __typename?: 'WeeklySchedule', id: string, breakMinutes?: number | null, earliest?: number | null, latest?: number | null, scheduleType: WeeklyScheduleTypeEnum, weekDay: WeekDayEnum }> | null, resourceSchedule?: { __typename?: 'ResourceSchedule', id?: string | null, preferrableId?: string | null, preferrableType?: PreferrableTypeEnum | null, availability?: Array<{ __typename?: 'Availability', day?: string | null, preferredStartTime?: string | null, preferredEndTime?: string | null }> | null, unavailability?: Array<{ __typename?: 'Unavailability', unStartTime?: string | null, unEndTime?: string | null, reason?: string | null }> | null } | null } };

export type DriversQueryVariables = Exact<{
  driverTypes?: InputMaybe<Array<DriverTypeEnum> | DriverTypeEnum>;
}>;


export type DriversQuery = { __typename?: 'Query', drivers: Array<{ __typename?: 'Driver', id: string, name?: string | null, status?: string | null, isNonFuel?: boolean | null }> };

export type FeeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FeeQuery = { __typename?: 'Query', fee: { __typename?: 'Fee', id: string, name?: string | null, code?: string | null, erpId?: string | null, description?: string | null, glCode?: string | null, price?: number | null, nonEditableRecords?: Array<any> | null, nsManualVolume?: boolean | null, offset?: number | null, offsetRate?: number | null, roundUpQuantity?: boolean | null, feeType?: string | null, applyAsOnFee?: string | null, calculatedAsOnFee?: string | null, rangeTypeOnFee?: string | null, rangeCalculatedAsOnFee?: string | null, rateUnitOnFee?: string | null, rateOnFee?: number | null, percentOnFee?: number | null, applicableType?: string | null, baseFeeId?: string | null, feeProductCategories?: Array<{ __typename?: 'FeeProductCategory', id: string, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, nameWithAncestors?: string | null }> | null, parentFee?: { __typename?: 'Fee', id: string, name?: string | null } | null, rangeAttribute?: Array<{ __typename?: 'RangeAttribute', endRange?: string | null, rangeRate?: string | null, startRange?: string | null }> | null } };

export type FetchFilteredProductsDropdownQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  all?: InputMaybe<Scalars['String']>;
}>;


export type FetchFilteredProductsDropdownQuery = { __typename?: 'Query', filteredProducts: { __typename?: 'ProductCollection', collection: Array<{ __typename?: 'Product', id: string, name?: string | null, erpId?: string | null, productCategory?: { __typename?: 'ProductCategory', id: string } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FetchGraphDataQueryVariables = Exact<{
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type FetchGraphDataQuery = { __typename?: 'Query', fetchGraphData?: { __typename?: 'Graph', data: Array<any>, metadata?: any | null } | null };

export type FetchLeasedAssetsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<AssetSorter> | AssetSorter>;
  customerIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  filter?: InputMaybe<Scalars['String']>;
  useInDelivery?: InputMaybe<Scalars['Boolean']>;
  types?: InputMaybe<Array<AssetTypeEnum> | AssetTypeEnum>;
  atSelfCustomerLocation?: InputMaybe<Scalars['Boolean']>;
  statuses?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type FetchLeasedAssetsQuery = { __typename?: 'Query', filteredAssets: { __typename?: 'AssetCollection', collection: Array<{ __typename?: 'Asset', id: string, averageDaysBetweenFills?: number | null, status?: string | null, name?: string | null, category?: string | null, color?: string | null, qrCodeText?: string | null, licensePlateNumber?: string | null, erpId?: string | null, fuelCategories?: Array<string> | null, netsuiteId?: string | null, type?: string | null, tankSize?: string | null, tankType?: string | null, averageUtilization?: number | null, startDate?: any | null, numberOfDays?: number | null, rentalAssetAtCustomer: boolean, lastDeliveredTimestamp?: number | null, actualRoi?: number | null, expectedRoi?: number | null, lastActiveTenantId?: string | null, subscriptions?: Array<{ __typename?: 'Subscription', id: string, product: { __typename?: 'Product', id: string, erpId?: string | null, productType: string, name?: string | null } }> | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, address?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, address?: string | null } | null } | null, compartments?: Array<{ __typename?: 'Compartment', id: string, name?: string | null, capacities?: Array<{ __typename?: 'Capacity', id: string, fuelType: string, unit: string, value: number, usablePercentage?: number | null }> | null }> | null, assetProductCategories?: Array<{ __typename?: 'AssetProductCategory', id: string, networkName?: string | null, networkNumber?: string | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FetchLeasedAssetsWithHubsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<AssetSorter> | AssetSorter>;
  customerIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  filter?: InputMaybe<Scalars['String']>;
  useInDelivery?: InputMaybe<Scalars['Boolean']>;
  types?: InputMaybe<Array<AssetTypeEnum> | AssetTypeEnum>;
  atSelfCustomerLocation?: InputMaybe<Scalars['Boolean']>;
  statuses?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type FetchLeasedAssetsWithHubsQuery = { __typename?: 'Query', filteredAssets: { __typename?: 'AssetCollection', collection: Array<{ __typename?: 'Asset', id: string, averageDaysBetweenFills?: number | null, status?: string | null, name?: string | null, category?: string | null, color?: string | null, qrCodeText?: string | null, licensePlateNumber?: string | null, erpId?: string | null, fuelCategories?: Array<string> | null, netsuiteId?: string | null, type?: string | null, tankSize?: string | null, tankType?: string | null, averageUtilization?: number | null, startDate?: any | null, numberOfDays?: number | null, rentalAssetAtCustomer: boolean, lastDeliveredTimestamp?: number | null, lastActiveTenantId?: string | null, actualRoi?: number | null, expectedRoi?: number | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null, subscriptions?: Array<{ __typename?: 'Subscription', id: string, product: { __typename?: 'Product', id: string, erpId?: string | null, productType: string, name?: string | null } }> | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, address?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, address?: string | null } | null } | null, compartments?: Array<{ __typename?: 'Compartment', id: string, name?: string | null, capacities?: Array<{ __typename?: 'Capacity', id: string, fuelType: string, unit: string, value: number, usablePercentage?: number | null }> | null }> | null, assetProductCategories?: Array<{ __typename?: 'AssetProductCategory', id: string, networkName?: string | null, networkNumber?: string | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type LineOfServiceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LineOfServiceQuery = { __typename?: 'Query', lineOfService: { __typename?: 'LineOfService', id: string, name?: string | null, active?: boolean | null, erpId?: string | null, shortName?: string | null, nonEditableRecords?: Array<any> | null, parent?: { __typename?: 'LineOfService', id: string, nameWithAncestors?: string | null } | null } };

export type LineOfServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type LineOfServicesQuery = { __typename?: 'Query', lineOfServices: Array<{ __typename?: 'LineOfService', id: string, nameWithAncestors?: string | null }> };

export type LoadingAccountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LoadingAccountQuery = { __typename?: 'Query', loadingAccount: { __typename?: 'LoadingAccount', id: string, name?: string | null, carrierCustomerCode?: string | null, loadingNumber?: string | null, supplierCode?: string | null, destinationState?: string | null, abbreviatedDestinationState?: string | null, description?: string | null, supplier?: { __typename?: 'Supplier', id: string, name: string } | null } };

export type FetchLoadingAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchLoadingAccountsQuery = { __typename?: 'Query', filteredLoadingAccounts: { __typename?: 'LoadingAccountCollection', collection: Array<{ __typename?: 'LoadingAccount', id: string, name?: string | null, carrierCustomerCode?: string | null, destinationState?: string | null, abbreviatedDestinationState?: string | null, loadingNumber?: string | null }> } };

export type FetchMoveAssetFormContextQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type FetchMoveAssetFormContextQuery = { __typename?: 'Query', filteredCustomers: { __typename?: 'CustomerCollection', collection: Array<{ __typename?: 'Customer', name?: string | null, id: string, address?: string | null, erpId?: string | null }> } };

export type FetchPandaBoxQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchPandaBoxQuery = { __typename?: 'Query', pandaBox: { __typename?: 'PandaBox', id: string, imeiNumber?: string | null, version?: string | null, name: string, pandaBoxAssets: Array<{ __typename?: 'PandaBoxAsset', id: string, active: boolean, lastAssignedAt?: number | null, asset?: { __typename?: 'Asset', id: string, name?: string | null } | null }>, assignedAsset?: { __typename?: 'Asset', id: string, name?: string | null } | null, pandaBoxMeters?: Array<{ __typename?: 'PandaBoxMeter', id: string, lcpNode?: string | null, meterModel?: string | null, lastSyncedAt?: number | null, portNumber?: string | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null, pandaDocuments?: Array<{ __typename?: 'PandaDocument', id: string, documentType?: string | null, fileName?: string | null, blobFileUrl?: string | null }> | null }> | null, pandaDocuments?: Array<{ __typename?: 'PandaDocument', id: string, documentType?: string | null, fileName?: string | null, blobFileUrl?: string | null }> | null } };

export type FetchPaymentTermsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchPaymentTermsQuery = { __typename?: 'Query', paymentTerms: Array<{ __typename?: 'PaymentTerm', id: string, name?: string | null, description?: string | null, netDaysToPay?: number | null }> };

export type FetchPaymentTermDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchPaymentTermDetailsQuery = { __typename?: 'Query', paymentTerm: { __typename?: 'PaymentTerm', id: string, name?: string | null, description?: string | null, netDaysToPay?: number | null } };

export type FetchPeripheralAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchPeripheralAttributesQuery = { __typename?: 'Query', peripheralAttributes: Array<{ __typename?: 'PeripheralAttribute', id?: string | null, formName?: string | null, formLabel?: string | null, peripheralAttributeType?: string | null, peripheralFormAttributeType?: { __typename?: 'PeripheralFormAttribute', placeholder?: string | null, options?: Array<{ __typename?: 'PeripheralFormOptionAttribute', label?: string | null, value?: string | null }> | null } | null }> };

export type FetchPeripheralCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchPeripheralCategoriesQuery = { __typename?: 'Query', peripheralsCategories: Array<{ __typename?: 'PeripheralCategory', id: string, name?: string | null }> };

export type PeripheralQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PeripheralQuery = { __typename?: 'Query', peripheral: { __typename?: 'Peripheral', id: string, legalDescription?: string | null, soldAs?: string | null, subType?: string | null, status?: string | null, erpId?: string | null, cost?: number | null, flowRate?: number | null, flowRateUnit?: FlowRateUnit | null, peripheralCategory?: { __typename?: 'PeripheralCategory', id: string, name?: string | null } | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, name?: string | null, nameWithAncestors?: string | null }> | null } };

export type FetchPeripheralsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchPeripheralsQuery = { __typename?: 'Query', peripherals: Array<{ __typename?: 'Peripheral', id: string, legalDescription?: string | null, soldAs?: string | null, subType?: string | null, erpId?: string | null, status?: string | null, cost?: number | null, flowRate?: number | null, flowRateUnit?: FlowRateUnit | null, peripheralCategory?: { __typename?: 'PeripheralCategory', id: string, name?: string | null } | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, name?: string | null, nameWithAncestors?: string | null }> | null }> };

export type FetchPickupPointCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchPickupPointCodesQuery = { __typename?: 'Query', pickupPointCodes: Array<{ __typename?: 'PickupPointCode', id: string, name?: string | null, code?: string | null }> };

export type FetchProductCategoriesPandaBoxQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchProductCategoriesPandaBoxQuery = { __typename?: 'Query', productCategories: Array<{ __typename?: 'ProductCategory', id: string, name?: string | null }> };

export type FetchProductCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchProductCategoriesQuery = { __typename?: 'Query', productCategories: Array<{ __typename?: 'ProductCategory', id: string, name?: string | null }> };

export type ProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProductQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: string, active: boolean, category: string, glNumber?: string | null, phoenixNumber?: string | null, code?: string | null, subCategory?: string | null, erpId?: string | null, shortName?: string | null, unit?: string | null, deliveryType?: string | null, productType: string, legalDescription?: string | null, longDescription?: string | null, soldAs?: string | null, nonEditableRecords?: Array<any> | null, ignoreNsPush?: boolean | null, flowRate?: number | null, allowTopUp?: boolean | null, barcode?: string | null, qrCode?: string | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null, productSubCategory?: { __typename?: 'ProductSubCategory', id: string, name?: string | null } | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, nameWithAncestors?: string | null }> | null, comparableProducts?: Array<{ __typename?: 'ProductResource', id: string, resourceId: string }> | null, downgradableProducts?: Array<{ __typename?: 'ProductResource', id: string, resourceId: string }> | null, productConstituents?: Array<{ __typename?: 'ProductConstituent', id: string, percentage?: number | null, basicProduct: { __typename?: 'Product', id: string, name?: string | null } }> | null, hubResource?: { __typename?: 'HubResource', id: string, hub: { __typename?: 'Hub', id: string, name?: string | null, address?: any | null } } | null, brand?: { __typename?: 'Brand', id: string, name?: string | null } | null } };

export type FetchProductFormContextQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchProductFormContextQuery = { __typename?: 'Query', capacityTypes: Array<{ __typename?: 'CapacityTypes', description: string, value: string }>, lineOfServices: Array<{ __typename?: 'LineOfService', id: string, nameWithAncestors?: string | null }>, products: Array<{ __typename?: 'Product', id: string, shortName?: string | null, erpId?: string | null, active: boolean }> };

export type FetchProductPurchaseLimitQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchProductPurchaseLimitQuery = { __typename?: 'Query', productPurchaseLimit: { __typename?: 'ProductPurchaseLimit', id: string, name?: string | null, volume?: string | null, product?: { __typename?: 'Product', id: string, name?: string | null } | null, customers?: Array<{ __typename?: 'Customer', id: string, name?: string | null }> | null } };

export type FetchProductSubCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchProductSubCategoriesQuery = { __typename?: 'Query', productSubCategories: Array<{ __typename?: 'ProductSubCategory', id: string, name?: string | null }> };

export type ProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', id: string, name?: string | null, category: string, productType: string, erpId?: string | null, active: boolean }> };

export type RouteFlushingsQueryVariables = Exact<{ [key: string]: never; }>;


export type RouteFlushingsQuery = { __typename?: 'Query', fetchRouteFlushings: Array<{ __typename?: 'Flushing', id: string, volume: number, fromConditions: Array<{ __typename?: 'Condition', field: string, value: string }>, toConditions: Array<{ __typename?: 'Condition', field: string, value: string }> }> };

export type FetchRouteSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchRouteSettingsQuery = { __typename?: 'Query', routeSettings: { __typename?: 'SettingCollection', collection: Array<{ __typename?: 'Setting', id: string, name: string, value?: string | null }> } };

export type FetchRoutesStaticTimesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchRoutesStaticTimesQuery = { __typename?: 'Query', routeStaticTimes: { __typename?: 'RouteStaticTimeCollection', collection: Array<{ __typename?: 'RouteStaticTime', id: string, name: string, time: number, timeType: string }> } };

export type SelfCustomerAssetDataFragment = { __typename?: 'Asset', id: string, name?: string | null, licensePlateNumber?: string | null, category?: string | null, fuelCategories?: Array<string> | null, color?: string | null, erpId?: string | null, make?: string | null, model?: string | null, status?: string | null, useInDelivery?: boolean | null, isRunningFuelOffsetAsset?: boolean | null, isTransport?: boolean | null, year?: number | null, qrCodeText?: string | null, barcodeText?: string | null, netsuiteId?: string | null, data?: any | null, type?: string | null, lat?: string | null, lng?: string | null, margin?: number | null, rfidCode?: string | null, enableZone?: boolean | null, noOfZone?: number | null, trackInventory?: boolean | null, lastActiveTenantId?: string | null, lastActiveTenantName?: string | null, estimatedGallonsPerMonth?: number | null, tankType?: string | null, tankSize?: string | null, costOfTank?: number | null, marketValue?: number | null, purchasedOn?: any | null, routingVehicleType?: string | null, taggings?: Array<{ __typename?: 'Tagging', id: string, tag?: { __typename?: 'Tag', id: string, name: string, colorCode?: string | null, iconName?: string | null, description?: string | null } | null }> | null, assetMovementLocation?: { __typename?: 'AssetMovementLocation', id: string, lat?: string | null, lng?: string | null, updatedAt?: any | null, updatable?: { __typename?: 'Driver' } | { __typename?: 'User', id: string, name?: string | null } | { __typename?: 'Worker', id: string, name?: string | null } | null } | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, nameWithAncestors?: string | null }> | null, assignedPandaBox?: { __typename?: 'PandaBox', id: string, name: string, imeiNumber?: string | null, version?: string | null, pandaBoxAssets: Array<{ __typename?: 'PandaBoxAsset', id: string, active: boolean, pandaBox?: { __typename?: 'PandaBox', id: string } | null }>, pandaBoxMeters?: Array<{ __typename?: 'PandaBoxMeter', id: string, meterModel?: string | null, meterName?: string | null, lcpNode?: string | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null } | null, assetProductCategories?: Array<{ __typename?: 'AssetProductCategory', id: string, networkName?: string | null, networkNumber?: string | null, registerModel?: string | null, product?: { __typename?: 'Product', id: string, name?: string | null } | null }> | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, tankReadingThreshold?: number | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null } | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, address?: string | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null, site?: { __typename?: 'Site', lat?: string | null, lng?: string | null } | null } | null, terminals?: Array<{ __typename?: 'Terminal', id: string, name?: string | null }> | null, pandaDocuments?: Array<{ __typename?: 'PandaDocument', id: string, documentType?: string | null, externalFileData?: { __typename?: 'AttachedFile', id?: string | null, contentType?: string | null, filename?: string | null, url?: string | null } | null }> | null, fuelTypeProducts?: Array<{ __typename?: 'Product', id: string, name?: string | null }> | null, compartments?: Array<{ __typename?: 'Compartment', id: string, name?: string | null, diameter?: number | null, erpId?: string | null, length?: number | null, alignment?: string | null, capacities?: Array<{ __typename?: 'Capacity', id: string, fuelType: string, value: number, unit: string, usablePercentage?: number | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null }> | null, hubResources?: Array<{ __typename?: 'HubResource', id: string, hub: { __typename?: 'Hub', id: string, name?: string | null } }> | null, assetsPeripherals?: Array<{ __typename?: 'AssetsPeripheral', id: string, assetId?: string | null, peripheralId: string, assetsPeripheralsRecords?: Array<{ __typename?: 'AssetsPeripheralsRecord', id: string, peripheralAttributeId: number, assetsPeripheralId?: number | null, value?: string | null, fileUrl?: string | null }> | null }> | null, productSubscriptions?: Array<{ __typename?: 'Subscription', id: string, status?: string | null, product: { __typename?: 'Product', id: string, name?: string | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }, compartment?: { __typename?: 'Compartment', id: string, name?: string | null, erpId?: string | null, capacities?: Array<{ __typename?: 'Capacity', id: string, unit: string, value: number, fuelType: string }> | null } | null }> | null };

export type FetchSelfCustomerAssetQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchSelfCustomerAssetQuery = { __typename?: 'Query', asset: { __typename?: 'Asset', id: string, name?: string | null, licensePlateNumber?: string | null, category?: string | null, fuelCategories?: Array<string> | null, color?: string | null, erpId?: string | null, make?: string | null, model?: string | null, status?: string | null, useInDelivery?: boolean | null, isRunningFuelOffsetAsset?: boolean | null, isTransport?: boolean | null, year?: number | null, qrCodeText?: string | null, barcodeText?: string | null, netsuiteId?: string | null, data?: any | null, type?: string | null, lat?: string | null, lng?: string | null, margin?: number | null, rfidCode?: string | null, enableZone?: boolean | null, noOfZone?: number | null, trackInventory?: boolean | null, lastActiveTenantId?: string | null, lastActiveTenantName?: string | null, estimatedGallonsPerMonth?: number | null, tankType?: string | null, tankSize?: string | null, costOfTank?: number | null, marketValue?: number | null, purchasedOn?: any | null, routingVehicleType?: string | null, taggings?: Array<{ __typename?: 'Tagging', id: string, tag?: { __typename?: 'Tag', id: string, name: string, colorCode?: string | null, iconName?: string | null, description?: string | null } | null }> | null, assetMovementLocation?: { __typename?: 'AssetMovementLocation', id: string, lat?: string | null, lng?: string | null, updatedAt?: any | null, updatable?: { __typename?: 'Driver' } | { __typename?: 'User', id: string, name?: string | null } | { __typename?: 'Worker', id: string, name?: string | null } | null } | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, nameWithAncestors?: string | null }> | null, assignedPandaBox?: { __typename?: 'PandaBox', id: string, name: string, imeiNumber?: string | null, version?: string | null, pandaBoxAssets: Array<{ __typename?: 'PandaBoxAsset', id: string, active: boolean, pandaBox?: { __typename?: 'PandaBox', id: string } | null }>, pandaBoxMeters?: Array<{ __typename?: 'PandaBoxMeter', id: string, meterModel?: string | null, meterName?: string | null, lcpNode?: string | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null } | null, assetProductCategories?: Array<{ __typename?: 'AssetProductCategory', id: string, networkName?: string | null, networkNumber?: string | null, registerModel?: string | null, product?: { __typename?: 'Product', id: string, name?: string | null } | null }> | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, tankReadingThreshold?: number | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null } | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, address?: string | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null, site?: { __typename?: 'Site', lat?: string | null, lng?: string | null } | null } | null, terminals?: Array<{ __typename?: 'Terminal', id: string, name?: string | null }> | null, pandaDocuments?: Array<{ __typename?: 'PandaDocument', id: string, documentType?: string | null, externalFileData?: { __typename?: 'AttachedFile', id?: string | null, contentType?: string | null, filename?: string | null, url?: string | null } | null }> | null, fuelTypeProducts?: Array<{ __typename?: 'Product', id: string, name?: string | null }> | null, compartments?: Array<{ __typename?: 'Compartment', id: string, name?: string | null, diameter?: number | null, erpId?: string | null, length?: number | null, alignment?: string | null, capacities?: Array<{ __typename?: 'Capacity', id: string, fuelType: string, value: number, unit: string, usablePercentage?: number | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null }> | null, hubResources?: Array<{ __typename?: 'HubResource', id: string, hub: { __typename?: 'Hub', id: string, name?: string | null } }> | null, assetsPeripherals?: Array<{ __typename?: 'AssetsPeripheral', id: string, assetId?: string | null, peripheralId: string, assetsPeripheralsRecords?: Array<{ __typename?: 'AssetsPeripheralsRecord', id: string, peripheralAttributeId: number, assetsPeripheralId?: number | null, value?: string | null, fileUrl?: string | null }> | null }> | null, productSubscriptions?: Array<{ __typename?: 'Subscription', id: string, status?: string | null, product: { __typename?: 'Product', id: string, name?: string | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }, compartment?: { __typename?: 'Compartment', id: string, name?: string | null, erpId?: string | null, capacities?: Array<{ __typename?: 'Capacity', id: string, unit: string, value: number, fuelType: string }> | null } | null }> | null } };

export type FetchSelfCustomerAssetCustomerDetailsQueryVariables = Exact<{
  customerId: Scalars['ID'];
}>;


export type FetchSelfCustomerAssetCustomerDetailsQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, customerBranches?: Array<{ __typename?: 'CustomerBranch', id: string, name?: string | null, address?: string | null, status?: boolean | null, site?: { __typename?: 'Site', lat?: string | null, lng?: string | null } | null }> | null } };

export type ShipToFormContextQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipToFormContextQuery = { __typename?: 'Query', fees: Array<{ __typename?: 'Fee', id: string, name?: string | null, price?: number | null, standard?: boolean | null, netsuiteId?: string | null, applicableType?: string | null }>, lineOfServices: Array<{ __typename?: 'LineOfService', id: string, nameWithAncestors?: string | null }> };

export type FetchShipToSupplierPreferenceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchShipToSupplierPreferenceQuery = { __typename?: 'Query', customerBranch: { __typename?: 'CustomerBranch', id: string, name?: string | null, preferredProductTerminals?: Array<{ __typename?: 'PreferredProductTerminal', id: string, isDefault?: boolean | null, rate?: number | null, terminal: { __typename?: 'Terminal', id: string }, fee?: { __typename?: 'Fee', id: string, name?: string | null } | null, product: { __typename?: 'Product', id: string }, preferredProductTerminalSuppliers?: Array<{ __typename?: 'PreferredProductTerminalSupplier', id: string, supplier: { __typename?: 'Supplier', id: string } }> | null }> | null } };

export type SupplierQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SupplierQuery = { __typename?: 'Query', supplier: { __typename?: 'Supplier', id: string, name: string, supplierCode?: string | null, erpId?: string | null, active?: boolean | null, netsuiteId?: string | null, nonEditableRecords?: Array<any> | null, isIrelyInternalSupplier?: boolean | null, irelyShipFromLocation?: string | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, nameWithAncestors?: string | null }> | null, terminalsSuppliers?: Array<{ __typename?: 'TerminalsSupplier', bolTimeAt?: BolTimeAtEnum | null, id: string, terminal: { __typename?: 'Terminal', id: string, name?: string | null, active?: boolean | null }, pickupPointCodes?: Array<{ __typename?: 'PickupPointCode', id: string, code?: string | null, loadingAccountId?: string | null, name?: string | null }> | null }> | null, loadingAccounts?: Array<{ __typename?: 'LoadingAccount', id: string, carrierCustomerCode?: string | null, destinationState?: string | null, abbreviatedDestinationState?: string | null, loadingNumber?: string | null, name?: string | null, description?: string | null, supplierCode?: string | null }> | null } };

export type SuppliersQueryVariables = Exact<{ [key: string]: never; }>;


export type SuppliersQuery = { __typename?: 'Query', suppliers: Array<{ __typename?: 'Supplier', id: string, name: string, active?: boolean | null, netsuiteId?: string | null, loadingAccounts?: Array<{ __typename?: 'LoadingAccount', id: string, carrierCustomerCode?: string | null, loadingNumber?: string | null, name?: string | null }> | null }> };

export type TerminalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TerminalQuery = { __typename?: 'Query', terminal: { __typename?: 'Terminal', id: string, name?: string | null, erpId?: string | null, isWarehouse?: boolean | null, feinNumber?: string | null, active?: boolean | null, nonEditableRecords?: Array<any> | null, nsTags?: Array<string> | null, isOwnBulkTank?: boolean | null, site?: { __typename?: 'Site', id: string, address?: any | null, lat?: string | null, lng?: string | null, radius?: number | null } | null, products?: Array<{ __typename?: 'Product', id: string, name?: string | null }> | null, terminalsSuppliers?: Array<{ __typename?: 'TerminalsSupplier', id: string, bolTimeAt?: BolTimeAtEnum | null, irelySubstituteTerminal?: string | null, pickupPointCodes?: Array<{ __typename?: 'PickupPointCode', id: string, name?: string | null, code?: string | null, loadingAccountId?: string | null }> | null, supplier: { __typename?: 'Supplier', id: string, name: string, active?: boolean | null } }> | null, productTerminals?: Array<{ __typename?: 'ProductTerminal', id: string, minimalLoad?: number | null, product: { __typename?: 'Product', id: string, name?: string | null, erpId?: string | null } }> | null, terminalManagers?: Array<{ __typename?: 'TerminalManager', id?: string | null, user?: { __typename?: 'User', id: string, name?: string | null } | null }> | null } };

export type FetchTerminalsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchTerminalsQuery = { __typename?: 'Query', terminals: Array<{ __typename?: 'Terminal', id: string, name?: string | null, active?: boolean | null, isWarehouse?: boolean | null }> };

export type FetchUserFormDataQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type FetchUserFormDataQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, name?: string | null, address?: string | null, email: string, phone?: string | null, status?: number | null, roles?: Array<{ __typename?: 'Role', id: string, name?: string | null }> | null } };

export type FetchUserListQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type FetchUserListQuery = { __typename?: 'Query', filteredCustomerUsers: { __typename?: 'CustomerUserCollection', collection: Array<{ __typename?: 'CustomerUser', user?: { __typename?: 'User', id: string, name?: string | null } | null }> } };

export type FetchUsersFormContextQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchUsersFormContextQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id: string, name?: string | null, adminRole?: boolean | null }> };

export type FilterRouteSettingsHistoryQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<RouteSettingsPaginationFilter>;
}>;


export type FilterRouteSettingsHistoryQuery = { __typename?: 'Query', filterRouteSettingsHistory: { __typename?: 'VersionCollection', collection: Array<{ __typename?: 'Version', date?: string | null, event: string, id: string, itemType: string, changeset?: Array<{ __typename?: 'Changeset', key: string, values: Array<string | null> }> | null, whodunnit?: { __typename?: 'User', name?: string | null } | null }>, metadata: { __typename?: 'MetaQuery', totalCount?: number | null, hasMore: boolean, total_entries?: number | null } } };

export type FilteredAddressBooksQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  all?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<Array<AddressBookSorter> | AddressBookSorter>;
}>;


export type FilteredAddressBooksQuery = { __typename?: 'Query', filteredAddressBooks: { __typename?: 'AddressBookCollection', collection: Array<{ __typename?: 'AddressBook', id: string, name?: string | null, phone?: string | null, email?: string | null, address?: string | null, addressBookType?: string | null, hasAccessToCustomerPortal?: boolean | null, isDeliveryTicketRecipient?: boolean | null, showInviteLink?: boolean | null, customers?: Array<{ __typename?: 'Customer', name?: string | null }> | null, customerBranches?: Array<{ __typename?: 'CustomerBranch', name?: string | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FilteredAppVersionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type FilteredAppVersionsQuery = { __typename?: 'Query', filteredAppVersions: { __typename?: 'AppVersionCollection', collection: Array<{ __typename?: 'AppVersion', id: string, environment?: string | null, platform: string, updatedAt?: number | null, versionNumber?: string | null, buildNumber?: string | null, firmwareFiles?: Array<{ __typename?: 'AttachedFile', id?: string | null, filename?: string | null }> | null }> } };

export type FilteredBoxTransactionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<BoxTransactionFilter>;
}>;


export type FilteredBoxTransactionsQuery = { __typename?: 'Query', filteredBoxTransactions: { __typename?: 'PandaBoxTransactionCollection', collection: Array<{ __typename?: 'PandaBoxTransaction', id: string, finalTotalizer?: number | null, discrepancy?: number | null, readingMode?: string | null, delivered?: string | null, totalizers?: any | null, pandaBoxMeter?: { __typename?: 'PandaBoxMeter', id: string, lcpNode?: string | null } | null, extractionOrder?: { __typename?: 'ExtractionOrder', id: string, orderGroup?: { __typename?: 'OrderGroup', id: string } | null } | null, transferOrder?: { __typename?: 'TransferOrder', id: string, orderGroup?: { __typename?: 'OrderGroup', id: string } | null } | null, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, deliveryDateTimestamp?: number | null, orderGroup?: { __typename?: 'OrderGroup', id: string } | null } | null }> } };

export type FilteredCcTenantsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type FilteredCcTenantsQuery = { __typename?: 'Query', filteredCcTenants?: { __typename?: 'CcTenantCollection', collection: Array<{ __typename?: 'CcTenant', address?: string | null, erpId?: string | null, id: string, carrierTenantId: string, carrierTenant: { __typename?: 'Tenant', id: string, name?: string | null, slug?: string | null, adminUsers?: Array<{ __typename?: 'User', id: string, name?: string | null, email: string, phone?: string | null }> | null }, site?: { __typename?: 'Site', address?: any | null, city?: string | null, state?: string | null, zip?: string | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } | null };

export type FilteredCustomerBranchListQueryVariables = Exact<{
  customerId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type FilteredCustomerBranchListQuery = { __typename?: 'Query', filteredCustomerBranches: { __typename?: 'CustomerBranchCollection', collection: Array<{ __typename?: 'CustomerBranch', id: string, name?: string | null, address?: string | null, status?: boolean | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean } } };

export type FilteredCustomerBranchesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  customerId?: InputMaybe<Scalars['ID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  all?: InputMaybe<Scalars['String']>;
  isHub?: InputMaybe<Scalars['Boolean']>;
}>;


export type FilteredCustomerBranchesQuery = { __typename?: 'Query', filteredCustomerBranches: { __typename?: 'CustomerBranchCollection', collection: Array<{ __typename?: 'CustomerBranch', id: string, name?: string | null, erpId?: string | null, irelyId?: string | null, address?: string | null, netsuiteId?: string | null, netsuiteName?: string | null, isHub?: boolean | null, qbName?: string | null, qbAddress?: string | null, status?: boolean | null, poNumber?: string | null, site?: { __typename?: 'Site', radius?: number | null, city?: string | null, state?: string | null, zip?: string | null } | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, name?: string | null }> | null, hubs?: Array<{ __typename?: 'Hub', name?: string | null }> | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, isTenant?: boolean | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FilteredCustomerQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  creditLimitExceededFilter?: InputMaybe<Scalars['Boolean']>;
  sorter?: InputMaybe<Array<CustomerSorter> | CustomerSorter>;
  resource?: InputMaybe<CustomerFilterEnum>;
  customersName?: InputMaybe<Scalars['String']>;
  customerBranchesName?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
}>;


export type FilteredCustomerQuery = { __typename?: 'Query', filteredCustomersSorter: { __typename?: 'CustomerCollection', collection: Array<{ __typename?: 'Customer', id: string, name?: string | null, groupName?: string | null, erpId?: string | null, poBoxNumber?: string | null, address?: string | null, creditChecked?: boolean | null, creditLimitExceeded?: boolean | null, creditLimitPercentageBuffer?: string | null, creditLimitDaysOverdueBuffer?: string | null, netsuiteId?: string | null, creditLimit?: string | null, currentBalance?: string | null, daysOverdue?: string | null, dueDate?: string | null, vendorErpId?: string | null, arDivisionNumber?: string | null, status?: number | null, quickbridgeId?: string | null, netsuiteName?: string | null, irelyId?: string | null, lastSyncedTime?: string | null, isTenant?: boolean | null, customerBranchNames?: string | null, site?: { __typename?: 'Site', city?: string | null, zip?: string | null, state?: string | null } | null, hubs?: Array<{ __typename?: 'Hub', name?: string | null }> | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, name?: string | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FilteredDriverDemurrageQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<BaseSorter> | BaseSorter>;
  filter?: InputMaybe<DriverDemurragesFilter>;
}>;


export type FilteredDriverDemurrageQuery = { __typename?: 'Query', filteredDriverDemurrage: { __typename?: 'DriverDemurrageCollection', collection: Array<{ __typename?: 'DriverDemurrage', id?: string | null, offsetType?: string | null, offsetAmount?: number | null, offsetRate?: number | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, erpId?: string | null } | null, rangeAttribute?: Array<{ __typename?: 'RangeAttribute', startRange?: string | null, rangeRate?: string | null, endRange?: string | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FilteredDriversQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  all?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<Array<DriverSorter> | DriverSorter>;
  driverTypes?: InputMaybe<Array<DriverTypeEnum> | DriverTypeEnum>;
}>;


export type FilteredDriversQuery = { __typename?: 'Query', filteredDrivers: { __typename?: 'DriverCollection', collection: Array<{ __typename?: 'Driver', id: string, name?: string | null, otp?: string | null, email?: string | null, status?: string | null, homeAddress?: string | null, erpId?: string | null, irelyId?: string | null, lastSyncedTime?: string | null, hourlyRate?: number | null, phoneNumbers?: Array<{ __typename?: 'DriverPhoneNumber', id: string, ownerType?: string | null, primary?: boolean | null, status?: string | null, value?: string | null }> | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, name?: string | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FilteredFeesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  all?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<Array<FeeSorter> | FeeSorter>;
  types?: InputMaybe<Array<ApplicableTypeEnum> | ApplicableTypeEnum>;
}>;


export type FilteredFeesQuery = { __typename?: 'Query', filteredFees: { __typename?: 'FeeCollection', collection: Array<{ __typename?: 'Fee', id: string, name?: string | null, feeType?: string | null, code?: string | null, erpId?: string | null, rateOnFee?: number | null, description?: string | null, netsuiteId?: string | null, standard?: boolean | null, glCode?: string | null, irelyId?: string | null, lastSyncedTime?: string | null, offset?: number | null, offsetRate?: number | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, name?: string | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FilteredHubsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  customerId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  isHub?: InputMaybe<Scalars['Boolean']>;
  all?: InputMaybe<Scalars['String']>;
}>;


export type FilteredHubsQuery = { __typename?: 'Query', filteredCustomerBranches: { __typename?: 'CustomerBranchCollection', collection: Array<{ __typename?: 'CustomerBranch', id: string, name?: string | null, isHub?: boolean | null, address?: string | null, status?: boolean | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FilteredLineOfServicesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  all?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<Array<LineOfServiceSorter> | LineOfServiceSorter>;
}>;


export type FilteredLineOfServicesQuery = { __typename?: 'Query', filteredLineOfServices: { __typename?: 'LineOfServiceCollection', collection: Array<{ __typename?: 'LineOfService', id: string, name?: string | null, shortName?: string | null, active?: boolean | null, erpId?: string | null, parent?: { __typename?: 'LineOfService', id: string, nameWithAncestors?: string | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null } } };

export type FilteredLoadingAccountsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  all?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<Array<LoadingAccountSorter> | LoadingAccountSorter>;
}>;


export type FilteredLoadingAccountsQuery = { __typename?: 'Query', filteredLoadingAccounts: { __typename?: 'LoadingAccountCollection', collection: Array<{ __typename?: 'LoadingAccount', id: string, name?: string | null, carrierCustomerCode?: string | null, loadingNumber?: string | null, supplierCode?: string | null, destinationState?: string | null, abbreviatedDestinationState?: string | null, lineOfServices?: Array<{ __typename?: 'LineOfService', name?: string | null }> | null, supplier?: { __typename?: 'Supplier', name: string } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null } } };

export type FilteredOrderGroupsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  fromTime?: InputMaybe<Scalars['Int']>;
  toTime?: InputMaybe<Scalars['Int']>;
  all?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<Array<OrderGroupSorter> | OrderGroupSorter>;
}>;


export type FilteredOrderGroupsQuery = { __typename?: 'Query', filteredOrderGroups: { __typename?: 'OrderGroupCollection', collection: Array<{ __typename?: 'OrderGroup', id: string, fromCustomerPortal?: boolean | null, status: string, poNumber?: string | null, carrierNumber?: string | null, startOnTimestamp?: number | null, driverAcceptance: string, startedOnTimestamp?: number | null, completeOnTimestamp?: number | null, completedOnTimestamp?: number | null, driver?: { __typename?: 'Driver', name?: string | null } | null, hub?: { __typename?: 'Hub', name?: string | null, address?: any | null } | null, shift?: { __typename?: 'Shift', shiftDeliveryUnitsAssets?: Array<{ __typename?: 'ShiftDeliveryUnitsAsset', deliveryAsset?: { __typename?: 'DeliveryAsset', name?: string | null, licensePlateNumber?: string | null } | null }> | null } | null, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, status: string, orderNumber?: string | null, deliveryInstruction?: string | null, source?: string | null, tenantName?: string | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, erpId?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, erpId?: string | null, fees?: Array<{ __typename?: 'Fee', id: string, name?: string | null, price?: number | null }> | null } | null } | null, lineItems: Array<{ __typename?: 'DeliveryOrderLineItem', id: string, source: string, requestedVolume?: number | null, volume?: number | null, status: string, subscription?: { __typename?: 'Subscription', asset: { __typename?: 'Asset', category?: string | null, licensePlateNumber?: string | null } } | null, product?: { __typename?: 'Product', name?: string | null } | null }> } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FilteredPandaBoxAssetsQueryVariables = Exact<{ [key: string]: never; }>;


export type FilteredPandaBoxAssetsQuery = { __typename?: 'Query', filteredPandaBoxAssets: Array<{ __typename?: 'Asset', id: string, name?: string | null, assignedPandaBox?: { __typename?: 'PandaBox', id: string, assignedAsset?: { __typename?: 'Asset', id: string, name?: string | null } | null, pandaBoxAssets: Array<{ __typename?: 'PandaBoxAsset', id: string, active: boolean, asset?: { __typename?: 'Asset', id: string, name?: string | null } | null }> } | null }> };

export type FilteredPandaBoxesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<PandaBoxFilter>;
}>;


export type FilteredPandaBoxesQuery = { __typename?: 'Query', filteredPandaBoxes: { __typename?: 'PandaBoxCollection', collection: Array<{ __typename?: 'PandaBox', id: string, imeiNumber?: string | null, version?: string | null, name: string, pandaBoxAssets: Array<{ __typename?: 'PandaBoxAsset', id: string, lastAssignedAt?: number | null, active: boolean, asset?: { __typename?: 'Asset', id: string, name?: string | null } | null }>, assignedAsset?: { __typename?: 'Asset', id: string, name?: string | null } | null, pandaBoxMeters?: Array<{ __typename?: 'PandaBoxMeter', id: string, lcpNode?: string | null, lastSyncedAt?: number | null, meterModel?: string | null, totalizers?: number | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FilteredPeripheralsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<Array<BaseSorter> | BaseSorter>;
}>;


export type FilteredPeripheralsQuery = { __typename?: 'Query', filteredPeripherals: { __typename?: 'PeripheralCollection', collection: Array<{ __typename?: 'Peripheral', id: string, legalDescription?: string | null, soldAs?: string | null, status?: string | null, subType?: string | null, erpId?: string | null, cost?: number | null, peripheralCategory?: { __typename?: 'PeripheralCategory', id: string, name?: string | null } | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, name?: string | null, nameWithAncestors?: string | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FilteredPickupPointCodesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  all?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<Array<PickupPointCodeSorter> | PickupPointCodeSorter>;
}>;


export type FilteredPickupPointCodesQuery = { __typename?: 'Query', filteredPickupPointCodes: { __typename?: 'PickupPointCodeCollection', collection: Array<{ __typename?: 'PickupPointCode', id: string, name?: string | null, code?: string | null, netsuiteId?: string | null, terminal: { __typename?: 'Terminal', id: string, name?: string | null }, supplier: { __typename?: 'Supplier', id: string, name: string }, terminalsSupplier: { __typename?: 'TerminalsSupplier', id: string, bolTimeAt?: BolTimeAtEnum | null } }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FilteredProductPurchaseLimitQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type FilteredProductPurchaseLimitQuery = { __typename?: 'Query', filteredProductPurchaseLimit: { __typename?: 'ProductPurchaseLimitCollection', collection: Array<{ __typename?: 'ProductPurchaseLimit', id: string, name?: string | null, volume?: string | null, timeUnit?: TimeUnitEnum | null, product?: { __typename?: 'Product', id: string, name?: string | null } | null, customers?: Array<{ __typename?: 'Customer', id: string, name?: string | null }> | null }>, metadata: { __typename?: 'MetaQuery', totalCount?: number | null } } };

export type FilteredProductsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  all?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<Array<ProductSorter> | ProductSorter>;
}>;


export type FilteredProductsQuery = { __typename?: 'Query', filteredProducts: { __typename?: 'ProductCollection', collection: Array<{ __typename?: 'Product', id: string, active: boolean, name?: string | null, shortName?: string | null, productType: string, unit?: string | null, deliveryType?: string | null, code?: string | null, erpId?: string | null, irelyId?: string | null, lastSyncedTime?: string | null, soldAs?: string | null, glNumber?: string | null, legalDescription?: string | null, netsuiteId?: string | null, nonEditableRecords?: Array<any> | null, productSubCategory?: { __typename?: 'ProductSubCategory', id: string, name?: string | null } | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, name?: string | null }> | null, hub?: { __typename?: 'Hub', name?: string | null, address?: any | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FilteredSidekiqRequestsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  all?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<Array<SidekiqRequestSorter> | SidekiqRequestSorter>;
}>;


export type FilteredSidekiqRequestsQuery = { __typename?: 'Query', filteredSidekiqRequest: { __typename?: 'SidekiqRequestCollection', collection: Array<{ __typename?: 'SidekiqRequest', id: string, caller: string, status: string, description?: string | null, createdAtTimestamp?: number | null, resultExists?: boolean | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FilteredSuppliersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  all?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<Array<SupplierSorter> | SupplierSorter>;
}>;


export type FilteredSuppliersQuery = { __typename?: 'Query', filteredSuppliers: { __typename?: 'SupplierCollection', collection: Array<{ __typename?: 'Supplier', id: string, name: string, erpId?: string | null, active?: boolean | null, supplierCode?: string | null, irelyId?: string | null, lastSyncedTime?: string | null, netsuiteId?: string | null, terminalsSuppliers?: Array<{ __typename?: 'TerminalsSupplier', id: string, terminal: { __typename?: 'Terminal', name?: string | null, active?: boolean | null } }> | null, loadingAccounts?: Array<{ __typename?: 'LoadingAccount', id: string, carrierCustomerCode?: string | null, loadingNumber?: string | null }> | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, name?: string | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FilteredSuppliersForDropDownOptionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  all?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<Array<SupplierSorter> | SupplierSorter>;
}>;


export type FilteredSuppliersForDropDownOptionsQuery = { __typename?: 'Query', filteredSuppliers: { __typename?: 'SupplierCollection', collection: Array<{ __typename?: 'Supplier', id: string, name: string, erpId?: string | null, active?: boolean | null, supplierCode?: string | null, irelyId?: string | null, netsuiteId?: string | null, terminalsSuppliers?: Array<{ __typename?: 'TerminalsSupplier', id: string, terminal: { __typename?: 'Terminal', name?: string | null, active?: boolean | null } }> | null, loadingAccounts?: Array<{ __typename?: 'LoadingAccount', id: string, carrierCustomerCode?: string | null, loadingNumber?: string | null }> | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, name?: string | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FilteredTerminalsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  all?: InputMaybe<Scalars['String']>;
  isWarehouse?: InputMaybe<Scalars['Boolean']>;
  sorter?: InputMaybe<Array<TerminalSorter> | TerminalSorter>;
}>;


export type FilteredTerminalsQuery = { __typename?: 'Query', filteredTerminals: { __typename?: 'TerminalCollection', collection: Array<{ __typename?: 'Terminal', id: string, name?: string | null, erpId?: string | null, isWarehouse?: boolean | null, active?: boolean | null, irelyId?: string | null, lastSyncedTime?: string | null, site?: { __typename?: 'Site', radius?: number | null, address?: any | null } | null, suppliers?: Array<{ __typename?: 'Supplier', name: string, active?: boolean | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FilteredTerminalsSuppliersQueryVariables = Exact<{
  filter?: InputMaybe<TerminalsSupplierFilter>;
}>;


export type FilteredTerminalsSuppliersQuery = { __typename?: 'Query', filteredTerminalsSuppliers: { __typename?: 'TerminalsSupplierCollection', collection: Array<{ __typename?: 'TerminalsSupplier', id: string, bolTimeAt?: BolTimeAtEnum | null, nonEditableRecords?: Array<any> | null, supplier: { __typename?: 'Supplier', id: string, name: string, active?: boolean | null, netsuiteId?: string | null }, terminal: { __typename?: 'Terminal', id: string, name?: string | null }, pickupPointCodes?: Array<{ __typename?: 'PickupPointCode', id: string, name?: string | null, code?: string | null, loadingAccountId?: string | null }> | null }> } };

export type InviteCustomerToPortalMutationVariables = Exact<{
  input: CustomerPortalInput;
}>;


export type InviteCustomerToPortalMutation = { __typename?: 'Mutation', inviteCustomerToPortal?: { __typename?: 'InviteCustomerToPortalPayload', addressBook?: { __typename?: 'AddressBook', id: string, name?: string | null, email?: string | null, phone?: string | null } | null } | null };

export type MergeCustomerResourcesMutationVariables = Exact<{
  data: CustomerResourceInput;
}>;


export type MergeCustomerResourcesMutation = { __typename?: 'Mutation', mergeCustomerResources?: { __typename?: 'CustomerResourcesPayload', success?: boolean | null } | null };

export type RefetchCustomersAsynchronouslyMutationVariables = Exact<{
  input: RefetchCustomersAsynchronouslyInput;
}>;


export type RefetchCustomersAsynchronouslyMutation = { __typename?: 'Mutation', refetchCustomersAsynchronously?: { __typename?: 'RefetchCustomersAsynchronouslyPayload', success?: boolean | null } | null };

export type RemoveCodeFromAssetMutationVariables = Exact<{
  input: RemoveCodeInput;
}>;


export type RemoveCodeFromAssetMutation = { __typename?: 'Mutation', removeCodeFromAsset?: { __typename?: 'RemoveCodePayload', success?: boolean | null } | null };

export type RemoveQrCodeFromAssetMutationVariables = Exact<{
  input: RemoveQrCodeInput;
}>;


export type RemoveQrCodeFromAssetMutation = { __typename?: 'Mutation', removeQrCodeFromAsset?: { __typename?: 'RemoveQrCodePayload', asset?: { __typename?: 'Asset', id: string } | null } | null };

export type SidekiqRequestDetailsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type SidekiqRequestDetailsQuery = { __typename?: 'Query', filteredSidekiqRequest: { __typename?: 'SidekiqRequestCollection', collection: Array<{ __typename?: 'SidekiqRequest', id: string, caller: string, status: string, request: any, result?: any | null }> } };

export type SyncDataFromVendorMutationVariables = Exact<{
  input: SyncDataFromVendorInput;
}>;


export type SyncDataFromVendorMutation = { __typename?: 'Mutation', syncDataFromVendor?: { __typename?: 'SyncDataFromVendorPayload', success?: boolean | null } | null };

export type UpdateAssetMutationVariables = Exact<{
  input: UpdateAssetsInput;
}>;


export type UpdateAssetMutation = { __typename?: 'Mutation', updateAsset?: { __typename?: 'UpdateAssetsPayload', asset?: { __typename?: 'Asset', id: string, name?: string | null, licensePlateNumber?: string | null, category?: string | null, fuelCategories?: Array<string> | null, color?: string | null, erpId?: string | null, make?: string | null, model?: string | null, status?: string | null, useInDelivery?: boolean | null, isRunningFuelOffsetAsset?: boolean | null, isTransport?: boolean | null, year?: number | null, qrCodeText?: string | null, barcodeText?: string | null, netsuiteId?: string | null, data?: any | null, type?: string | null, lat?: string | null, lng?: string | null, margin?: number | null, installDate?: any | null, rfidCode?: string | null, enableZone?: boolean | null, noOfZone?: number | null, trackInventory?: boolean | null, lastActiveTenantId?: string | null, lastActiveTenantName?: string | null, estimatedGallonsPerMonth?: number | null, tankType?: string | null, tankSize?: string | null, costOfTank?: number | null, marketValue?: number | null, purchasedOn?: any | null, routingVehicleType?: string | null, createdBy?: { __typename?: 'User', name?: string | null } | null, taggings?: Array<{ __typename?: 'Tagging', id: string, tag?: { __typename?: 'Tag', id: string, name: string, colorCode?: string | null, iconName?: string | null, description?: string | null } | null }> | null, assetMovementLocation?: { __typename?: 'AssetMovementLocation', id: string, lat?: string | null, lng?: string | null, updatedAt?: any | null, updatable?: { __typename?: 'Driver' } | { __typename?: 'User', id: string, name?: string | null } | { __typename?: 'Worker', id: string, name?: string | null } | null } | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, nameWithAncestors?: string | null }> | null, assignedPandaBox?: { __typename?: 'PandaBox', id: string, name: string, imeiNumber?: string | null, version?: string | null, pandaBoxAssets: Array<{ __typename?: 'PandaBoxAsset', id: string, active: boolean, pandaBox?: { __typename?: 'PandaBox', id: string } | null }>, pandaBoxMeters?: Array<{ __typename?: 'PandaBoxMeter', id: string, meterModel?: string | null, meterName?: string | null, lcpNode?: string | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null } | null, assetProductCategories?: Array<{ __typename?: 'AssetProductCategory', id: string, networkName?: string | null, networkNumber?: string | null, registerModel?: string | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null, subscriptions?: Array<{ __typename?: 'Subscription', id: string, status?: string | null, product: { __typename?: 'Product', id: string, name?: string | null, erpId?: string | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null } }> | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, tankReadingThreshold?: number | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null } | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, address?: string | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null, site?: { __typename?: 'Site', lat?: string | null, lng?: string | null } | null } | null, terminals?: Array<{ __typename?: 'Terminal', id: string, name?: string | null }> | null, pandaDocuments?: Array<{ __typename?: 'PandaDocument', id: string, documentType?: string | null, externalFileData?: { __typename?: 'AttachedFile', id?: string | null, contentType?: string | null, filename?: string | null, url?: string | null } | null }> | null, fuelTypeProducts?: Array<{ __typename?: 'Product', id: string, name?: string | null }> | null, compartments?: Array<{ __typename?: 'Compartment', id: string, name?: string | null, diameter?: number | null, erpId?: string | null, length?: number | null, alignment?: string | null, capacities?: Array<{ __typename?: 'Capacity', id: string, fuelType: string, value: number, unit: string, usablePercentage?: number | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null }> | null, hubResources?: Array<{ __typename?: 'HubResource', id: string, hub: { __typename?: 'Hub', id: string, name?: string | null } }> | null, assetsPeripherals?: Array<{ __typename?: 'AssetsPeripheral', id: string, assetId?: string | null, peripheralId: string, assetsPeripheralsRecords?: Array<{ __typename?: 'AssetsPeripheralsRecord', id: string, peripheralAttributeId: number, assetsPeripheralId?: number | null, value?: string | null, fileUrl?: string | null }> | null }> | null } | null } | null };

export type UpdateBrandMutationVariables = Exact<{
  input: UpdateBrandInput;
}>;


export type UpdateBrandMutation = { __typename?: 'Mutation', updateBrand?: { __typename?: 'UpdateBrandsPayload', brand?: { __typename?: 'Brand', id: string, name?: string | null } | null } | null };

export type UpdateCustomerMutationVariables = Exact<{
  input: UpdateCustomerInput;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer?: { __typename?: 'UpdateCustomersPayload', customer?: { __typename?: 'Customer', id: string, name?: string | null, enableCreateDeliveryOrder?: boolean | null, customerPortalPermissions?: any | null, portalAccessLevel?: PortalAccessLevelEnum | null } | null } | null };

export type UpdateCustomerBranchMutationVariables = Exact<{
  input: UpdateCustomerBranchInput;
}>;


export type UpdateCustomerBranchMutation = { __typename?: 'Mutation', updateCustomerBranch?: { __typename?: 'UpdateCustomerBranchesPayload', customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, addressBooks?: Array<{ __typename?: 'AddressBook', id: string, name?: string | null, email?: string | null, addressBookType?: string | null, hasAccessToCustomerPortal?: boolean | null }> | null } | null } | null };

export type UpdateCustomerPreferencesMutationVariables = Exact<{
  input: UpdateCustomerPreferencesInput;
}>;


export type UpdateCustomerPreferencesMutation = { __typename?: 'Mutation', updateCustomerPreferences?: { __typename?: 'UpdateCustomerPreferencesPayload', error?: string | null, message?: string | null, customer?: { __typename?: 'Customer', id: string, addressBooks?: Array<{ __typename?: 'AddressBook', image?: { __typename?: 'AttachedFile', url?: string | null } | null }> | null } | null } | null };

export type UpdateCustomerSegmentMutationVariables = Exact<{
  input: CustomerSegmentInput;
}>;


export type UpdateCustomerSegmentMutation = { __typename?: 'Mutation', updateCustomerSegment?: { __typename?: 'UpdateCustomerSegmentsPayload', customerSegment?: { __typename?: 'CustomerSegment', id: string, name?: string | null, code?: string | null, segmentType?: string | null } | null } | null };

export type UpdateDriverMutationVariables = Exact<{
  input: UpdateDriverInput;
}>;


export type UpdateDriverMutation = { __typename?: 'Mutation', updateDriver?: { __typename?: 'UpdateDriversPayload', driver?: { __typename?: 'Driver', id: string, name?: string | null, erpId?: string | null } | null } | null };

export type UpdateDriverDemurrageMutationVariables = Exact<{
  input: UpdateDriverDemurrageInput;
}>;


export type UpdateDriverDemurrageMutation = { __typename?: 'Mutation', updateDriverDemurrage?: { __typename?: 'UpdateDriverDemurragePayload', driverDemurrage?: { __typename?: 'DriverDemurrage', id?: string | null, customer?: { __typename?: 'Customer', name?: string | null } | null } | null } | null };

export type UpdateDriverOtpMutationVariables = Exact<{
  driverId: Scalars['ID'];
}>;


export type UpdateDriverOtpMutation = { __typename?: 'Mutation', updateDriverOtp?: { __typename?: 'ChangeDriverOtpPayload', clientMutationId?: string | null, driver?: { __typename?: 'Driver', otp?: string | null } | null } | null };

export type UpdateFeeMutationVariables = Exact<{
  input: UpdateFeesInput;
}>;


export type UpdateFeeMutation = { __typename?: 'Mutation', updateFee?: { __typename?: 'UpdateFeesPayload', fee?: { __typename?: 'Fee', id: string } | null } | null };

export type UpdateLineOfServiceMutationVariables = Exact<{
  input: UpdateLineOfServiceInput;
}>;


export type UpdateLineOfServiceMutation = { __typename?: 'Mutation', updateLineOfService?: { __typename?: 'UpdateLineOfServicesPayload', lineOfService?: { __typename?: 'LineOfService', id: string, name?: string | null } | null } | null };

export type UpdateLoadingAccountMutationVariables = Exact<{
  input: UpdateLoadingAccountsInput;
}>;


export type UpdateLoadingAccountMutation = { __typename?: 'Mutation', updateLoadingAccount?: { __typename?: 'UpdateLoadingAccountsPayload', loadingAccount?: { __typename?: 'LoadingAccount', id: string } | null } | null };

export type UpdatePaymentTermMutationVariables = Exact<{
  input: PaymentTermInput;
}>;


export type UpdatePaymentTermMutation = { __typename?: 'Mutation', updatePaymentTerm?: { __typename?: 'UpdatePaymentTermsPayload', paymentTerm?: { __typename?: 'PaymentTerm', id: string, name?: string | null, description?: string | null, netDaysToPay?: number | null } | null } | null };

export type UpdatePeripheralMutationVariables = Exact<{
  input: PeripheralInput;
}>;


export type UpdatePeripheralMutation = { __typename?: 'Mutation', updatePeripheral?: { __typename?: 'UpdatePeripheralPayload', peripheral?: { __typename?: 'Peripheral', id: string } | null } | null };

export type UpdateProductMutationVariables = Exact<{
  input: UpdateProductsInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct?: { __typename?: 'UpdateProductsPayload', product?: { __typename?: 'Product', id: string } | null } | null };

export type UpdateProductPurchaseLimitsMutationVariables = Exact<{
  input: UpdateProductPurchaseLimitsInput;
}>;


export type UpdateProductPurchaseLimitsMutation = { __typename?: 'Mutation', updateProductPurchaseLimit?: { __typename?: 'UpdateProductPurchaseLimitsPayload', productPurchaseLimit?: { __typename?: 'ProductPurchaseLimit', id: string } | null } | null };

export type UpdateRouteConfigMutationVariables = Exact<{
  input: UpdateRouteConfigInput;
}>;


export type UpdateRouteConfigMutation = { __typename?: 'Mutation', updateRouteConfig?: { __typename?: 'UpdateRouteConfigPayload', success?: boolean | null, errors?: Array<string> | null } | null };

export type UpdateSupplierMutationVariables = Exact<{
  input: UpdateSupplierInput;
}>;


export type UpdateSupplierMutation = { __typename?: 'Mutation', updateSupplier?: { __typename?: 'UpdateSuppliersPayload', supplier?: { __typename?: 'Supplier', id: string } | null } | null };

export type UpdateTerminalMutationVariables = Exact<{
  input: UpdateTerminalInput;
}>;


export type UpdateTerminalMutation = { __typename?: 'Mutation', updateTerminal?: { __typename?: 'UpdateTerminalsPayload', terminal?: { __typename?: 'Terminal', id: string } | null } | null };

export type UpdateTerminalsSupplierMutationVariables = Exact<{
  input: UpdateTerminalsSuppliersInput;
}>;


export type UpdateTerminalsSupplierMutation = { __typename?: 'Mutation', updateTerminalsSupplier?: { __typename?: 'UpdateTerminalsSuppliersPayload', terminalsSupplier?: { __typename?: 'TerminalsSupplier', id: string } | null } | null };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateCustomerUsersInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateCustomerUser?: { __typename?: 'UpdateCustomerUsersPayload', customerUser?: { __typename?: 'CustomerUser', id: string } | null } | null };

export type UpdateUserOtpMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type UpdateUserOtpMutation = { __typename?: 'Mutation', updateUserOtp?: { __typename?: 'ChangeUserOtpPayload', clientMutationId?: string | null, user?: { __typename?: 'User', otp?: string | null } | null } | null };

export type CreateResourceComponentMutationVariables = Exact<{
  input: CreateResourceComponentInput;
}>;


export type CreateResourceComponentMutation = { __typename?: 'Mutation', createResourceComponent?: { __typename?: 'CreateResourceComponentPayload', resourceComponentType: { __typename?: 'ResourceComponent', error?: string | null, success: boolean, resourceTenant?: { __typename?: 'ResourceTenant', id: string, previousResource?: { __typename?: 'Asset', status?: string | null, lastActiveTenantId?: string | null } | null } | null } } | null };

export type FetchAssociatedTenantsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchAssociatedTenantsQuery = { __typename?: 'Query', associatedTenants?: Array<{ __typename?: 'Tenant', id: string, name?: string | null }> | null };

export type FetchProductsAssetFormQueryVariables = Exact<{
  customFilter?: InputMaybe<ProductFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type FetchProductsAssetFormQuery = { __typename?: 'Query', filteredProducts: { __typename?: 'ProductCollection', collection: Array<{ __typename?: 'Product', id: string, name?: string | null, category: string, productType: string }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean } } };

export type FetchResourceTenantCustomerBranchesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<CustomerBranchesFilter>;
}>;


export type FetchResourceTenantCustomerBranchesQuery = { __typename?: 'Query', fetchResourceTenantCustomerBranches: { __typename?: 'ResourceTenantCustomerBranchCollection', collection: Array<{ __typename?: 'ResourceTenantCustomerBranch', id?: string | null, name?: string | null, site?: { __typename?: 'Site', address?: any | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean } } };

export type FetchResourceTenantCustomersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<CustomersFilter>;
}>;


export type FetchResourceTenantCustomersQuery = { __typename?: 'Query', fetchResourceTenantCustomers: { __typename?: 'ResourceTenantCustomerCollection', collection: Array<{ __typename?: 'ResourceTenantCustomer', id?: string | null, name?: string | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean } } };

export type AssociateIrelyEntityWithFpMutationVariables = Exact<{
  input: AssociateIrelyEntityInput;
}>;


export type AssociateIrelyEntityWithFpMutation = { __typename?: 'Mutation', associateIrelyEntityWithFp?: { __typename?: 'AssociateIrelyEntityWithFpPayload', success?: boolean | null } | null };

export type CreateUpdateIrelyFilterMutationVariables = Exact<{
  input: IrelyFilterInput;
}>;


export type CreateUpdateIrelyFilterMutation = { __typename?: 'Mutation', createUpdateIrelyFilter?: { __typename?: 'CreateUpdateIrelyFilterPayload', irelyFilter?: { __typename?: 'IrelyFilter', id: string, entity?: FilterableEntityEnum | null, filter?: string | null } | null } | null };

export type FetchIrelyFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchIrelyFiltersQuery = { __typename?: 'Query', irelyFilters?: Array<{ __typename?: 'IrelyFilter', id: string, entity?: FilterableEntityEnum | null, filter?: string | null, filterType?: FilterTypeEnum | null }> | null };

export type FetchIrelyProductCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchIrelyProductCategoriesQuery = { __typename?: 'Query', irelyProductCategories?: Array<{ __typename?: 'IrelyProductCategory', id: string, categoryCode?: string | null, description?: string | null, lineOfBusiness?: string | null, erpId?: number | null, isRetailValuation?: boolean | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null };

export type FetchIrelyUomsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchIrelyUomsQuery = { __typename?: 'Query', irelyUoms?: Array<{ __typename?: 'IrelyUom', id: string, erpId?: number | null, name?: string | null, symbol?: string | null, unitType?: string | null, decimalPlaces?: number | null, fpValue?: string | null }> | null };

export type DeleteLineOfServiceMutationVariables = Exact<{
  input: DeleteLineOfServicesInput;
}>;


export type DeleteLineOfServiceMutation = { __typename?: 'Mutation', deleteLineOfService?: { __typename?: 'DeleteLineOfServicesPayload', response?: { __typename?: 'DeleteResponse', id: string, success: boolean, error?: string | null } | null } | null };

export type FetchFilteredLineOfServicesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<LineOfServiceFilter>;
  sorter?: InputMaybe<Array<LineOfServiceSorter> | LineOfServiceSorter>;
}>;


export type FetchFilteredLineOfServicesQuery = { __typename?: 'Query', filteredLineOfServices: { __typename?: 'LineOfServiceCollection', collection: Array<{ __typename?: 'LineOfService', id: string, name?: string | null, shortName?: string | null, active?: boolean | null, erpId?: string | null, parent?: { __typename?: 'LineOfService', id: string, nameWithAncestors?: string | null } | null, suppliers?: Array<{ __typename?: 'Supplier', id: string, name: string }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null } } };

export type FetchLosExportCsvQueryVariables = Exact<{
  losId?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  parentLos?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type FetchLosExportCsvQuery = { __typename?: 'Query', exportLineOfServicesCsv?: { __typename?: 'DoliCsv', content?: string | null, fileName?: string | null, error?: string | null } | null };

export type FetchParentLosQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchParentLosQuery = { __typename?: 'Query', lineOfServices: Array<{ __typename: 'LineOfService', id: string, nameWithAncestors?: string | null }> };

export type DeletePickupPointCodeMutationVariables = Exact<{
  input: DeletePickupPointCodesInput;
}>;


export type DeletePickupPointCodeMutation = { __typename?: 'Mutation', deletePickupPointCode?: { __typename?: 'DeletePickupPointCodesPayload', response?: { __typename?: 'DeleteResponse', id: string, success: boolean, error?: string | null } | null } | null };

export type ExportPpcCsvQueryVariables = Exact<{ [key: string]: never; }>;


export type ExportPpcCsvQuery = { __typename?: 'Query', exportPpcCsv?: { __typename?: 'DoliCsv', content?: string | null, fileName?: string | null, error?: string | null } | null };

export type FetchFilteredPickupPointCodesV2QueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  all?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<Array<PickupPointCodeSorter> | PickupPointCodeSorter>;
}>;


export type FetchFilteredPickupPointCodesV2Query = { __typename?: 'Query', filteredPickupPointCodes: { __typename?: 'PickupPointCodeCollection', collection: Array<{ __typename?: 'PickupPointCode', id: string, name?: string | null, code?: string | null, erpId?: string | null, loadingAccount?: { __typename?: 'LoadingAccount', id: string, loadingNumber?: string | null } | null, terminal: { __typename?: 'Terminal', id: string, name?: string | null, products?: Array<{ __typename?: 'Product', id: string, name?: string | null }> | null }, supplier: { __typename?: 'Supplier', id: string, name: string }, products: Array<{ __typename?: 'Product', id: string, name?: string | null }>, terminalsSupplier: { __typename?: 'TerminalsSupplier', id: string, bolTimeAt?: BolTimeAtEnum | null } }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null } } };

export type UpdatePickupPointCodeMutationVariables = Exact<{
  input: UpdatePickupPointCodesInput;
}>;


export type UpdatePickupPointCodeMutation = { __typename?: 'Mutation', updatePickupPointCode?: { __typename?: 'UpdatePickupPointCodesPayload', pickupPointCode?: { __typename?: 'PickupPointCode', id: string, code?: string | null, erpId?: string | null, products: Array<{ __typename?: 'Product', id: string, name?: string | null }> } | null } | null };

export type CreateRackMarketMutationVariables = Exact<{
  input: CreateRackMarketInput;
}>;


export type CreateRackMarketMutation = { __typename?: 'Mutation', createRackMarket?: { __typename?: 'CreateRackMarketPayload', rackMarket?: { __typename?: 'RackMarket', id: string, name?: string | null, active?: boolean | null } | null } | null };

export type DeleteRackMarketMutationVariables = Exact<{
  input: DeleteRackMarketInput;
}>;


export type DeleteRackMarketMutation = { __typename?: 'Mutation', deleteRackMarket?: { __typename?: 'DeleteRackMarketPayload', response?: { __typename?: 'DeleteResponse', id: string, success: boolean, error?: string | null } | null } | null };

export type FetchFilteredRackMarketsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<RackMarketFilter>;
}>;


export type FetchFilteredRackMarketsQuery = { __typename?: 'Query', rackMarkets: { __typename?: 'RackMarketCollection', collection: Array<{ __typename?: 'RackMarket', id: string, name?: string | null, active?: boolean | null, erpId?: string | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null, terminals?: Array<{ __typename?: 'Terminal', id: string, name?: string | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null } } };

export type FetchHubsForRackMarketQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['ID']>;
}>;


export type FetchHubsForRackMarketQuery = { __typename?: 'Query', filteredCustomerBranches: { __typename?: 'CustomerBranchCollection', collection: Array<{ __typename?: 'CustomerBranch', id: string, name?: string | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean } } };

export type FetchRackMarketExportCsvQueryVariables = Exact<{
  rackMarketId?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  terminalId?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  hubId?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type FetchRackMarketExportCsvQuery = { __typename?: 'Query', exportRackMarketsCsv?: { __typename?: 'DoliCsv', content?: string | null, fileName?: string | null, error?: string | null } | null };

export type UpdateRackMarketMutationVariables = Exact<{
  input: UpdateRackMarketInput;
}>;


export type UpdateRackMarketMutation = { __typename?: 'Mutation', updateRackMarket?: { __typename?: 'UpdateRackMarketPayload', rackMarket?: { __typename?: 'RackMarket', id: string, name?: string | null, active?: boolean | null } | null } | null };

export type FetchLosQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type FetchLosQuery = { __typename?: 'Query', filteredLineOfServices: { __typename?: 'LineOfServiceCollection', collection: Array<{ __typename?: 'LineOfService', id: string, name?: string | null, active?: boolean | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null } } };

export type FetchRackMarketWithTerminalsQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type FetchRackMarketWithTerminalsQuery = { __typename?: 'Query', rackMarkets: { __typename?: 'RackMarketCollection', collection: Array<{ __typename?: 'RackMarket', name?: string | null, id: string, terminals?: Array<{ __typename?: 'Terminal', id: string, name?: string | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean } } };

export type FetchSuppliersWithTerminalsQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type FetchSuppliersWithTerminalsQuery = { __typename?: 'Query', filteredSuppliers: { __typename?: 'SupplierCollection', collection: Array<{ __typename?: 'Supplier', id: string, name: string, terminalsSuppliers?: Array<{ __typename?: 'TerminalsSupplier', terminal: { __typename?: 'Terminal', id: string, name?: string | null, rackMarket?: { __typename?: 'RackMarket', id: string, name?: string | null } | null } }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean } } };

export type CreateSupplierTerminalV2MutationVariables = Exact<{
  input: CreateSupplierInput;
}>;


export type CreateSupplierTerminalV2Mutation = { __typename?: 'Mutation', createSupplierV2?: { __typename?: 'CreateSuppliersV2Payload', supplier?: { __typename?: 'Supplier', id: string } | null } | null };

export type CreateSupplierTerminalV3MutationVariables = Exact<{
  input: CreateSupplierInputV3;
}>;


export type CreateSupplierTerminalV3Mutation = { __typename?: 'Mutation', createSupplierV3?: { __typename?: 'CreateSuppliersV3Payload', supplier?: { __typename?: 'Supplier', id: string } | null } | null };

export type FetchFilteredBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchFilteredBrandsQuery = { __typename?: 'Query', brands: Array<{ __typename: 'Brand', id: string, name?: string | null }> };

export type FetchFilteredProductQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  customFilter?: InputMaybe<ProductFilter>;
}>;


export type FetchFilteredProductQuery = { __typename?: 'Query', filteredProducts: { __typename?: 'ProductCollection', collection: Array<{ __typename?: 'Product', name?: string | null, id: string, brandId?: string | null, active: boolean }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null } } };

export type FetchFilteredSuppliersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<SupplierFilter>;
  sorter?: InputMaybe<Array<SupplierSorter> | SupplierSorter>;
}>;


export type FetchFilteredSuppliersQuery = { __typename?: 'Query', filteredSuppliers: { __typename?: 'SupplierCollection', collection: Array<{ __typename?: 'Supplier', id: string, name: string, erpId?: string | null, active?: boolean | null, supplierCode?: string | null, irelyId?: string | null, lastSyncedTime?: string | null, supplierType?: SupplierTypeEnum | null, netsuiteId?: string | null, terminalsSuppliers?: Array<{ __typename?: 'TerminalsSupplier', id: string, terminal: { __typename?: 'Terminal', name?: string | null, active?: boolean | null, rackMarket?: { __typename?: 'RackMarket', name?: string | null } | null } }> | null, loadingAccounts?: Array<{ __typename?: 'LoadingAccount', id: string, carrierCustomerCode?: string | null, loadingNumber?: string | null, name?: string | null }> | null, lineOfServices?: Array<{ __typename?: 'LineOfService', id: string, name?: string | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FetchFilteredTerminalListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<TerminalFilter>;
}>;


export type FetchFilteredTerminalListQuery = { __typename?: 'Query', filteredTerminals: { __typename?: 'TerminalCollection', collection: Array<{ __typename?: 'Terminal', id: string, name?: string | null, erpId?: string | null, active?: boolean | null }> } };

export type FetchLineOfServicesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<LineOfServiceFilter>;
  sorter?: InputMaybe<Array<LineOfServiceSorter> | LineOfServiceSorter>;
}>;


export type FetchLineOfServicesQuery = { __typename?: 'Query', filteredLineOfServices: { __typename?: 'LineOfServiceCollection', collection: Array<{ __typename?: 'LineOfService', id: string, name?: string | null, shortName?: string | null, active?: boolean | null, erpId?: string | null, parent?: { __typename?: 'LineOfService', id: string, nameWithAncestors?: string | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null } } };

export type FetchRackMarketQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<RackMarketFilter>;
}>;


export type FetchRackMarketQuery = { __typename?: 'Query', rackMarkets: { __typename?: 'RackMarketCollection', collection: Array<{ __typename?: 'RackMarket', id: string, name?: string | null, active?: boolean | null, terminals?: Array<{ __typename?: 'Terminal', id: string, name?: string | null, active?: boolean | null, isWarehouse?: boolean | null }> | null }> } };

export type FetchSupplierDetailV3QueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchSupplierDetailV3Query = { __typename?: 'Query', supplierDetailV3?: { __typename?: 'SupplierDetailV3Supplier', id: string, name: string, active?: boolean | null, supplierType?: SupplierTypeEnum | null, erpId?: string | null, supplierCode?: string | null, lineOfServices?: Array<{ __typename: 'LineOfService', id: string, name?: string | null }> | null, loadingAccounts?: Array<{ __typename?: 'SupplierDetailV3LoadingAccount', id: string, loadingNumber?: string | null, name?: string | null, destinationState?: string | null, rackMarkets?: Array<{ __typename?: 'SupplierDetailV3RackMarket', id: string, name?: string | null, terminals?: Array<{ __typename?: 'SupplierDetailV3Terminal', pickupPointCodes?: Array<{ __typename?: 'PickupPointCode', id: string, code?: string | null, name?: string | null, erpId?: string | null, products: Array<{ __typename?: 'Product', id: string, name?: string | null }> }> | null, terminalsSupplier?: { __typename?: 'TerminalsSupplier', id: string, bolTimeAt?: BolTimeAtEnum | null, terminal: { __typename?: 'Terminal', id: string, name?: string | null } } | null, terminalProducts?: Array<{ __typename?: 'SupplierDetailV3TerminalProduct', id: string, brandTypes: Array<LatpBrandTypeEnum>, product?: { __typename?: 'Product', id: string, name?: string | null } | null }> | null }> | null }> | null }> | null } | null };

export type FetchSupplierDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchSupplierDetailQuery = { __typename?: 'Query', supplierDetail?: { __typename?: 'SupplierDetailSupplier', id: string, name: string, supplierType?: SupplierTypeEnum | null, erpId?: string | null, supplierCode?: string | null, lineOfServices?: Array<{ __typename: 'LineOfService', id: string, name?: string | null }> | null, loadingAccounts?: Array<{ __typename?: 'SupplierDetailLoadingAccount', id: string, loadingNumber?: string | null, name?: string | null, destinationState?: string | null, rackMarkets?: Array<{ __typename?: 'SupplierDetailRackMarket', id: string, name?: string | null, terminals?: Array<{ __typename?: 'SupplierDetailTerminal', pickupPointCodes?: Array<{ __typename?: 'PickupPointCode', id: string, code?: string | null, name?: string | null }> | null, terminalsSupplier?: { __typename?: 'TerminalsSupplier', id: string, bolTimeAt?: BolTimeAtEnum | null, terminal: { __typename?: 'Terminal', id: string, name?: string | null } } | null, products?: Array<{ __typename?: 'Product', id: string, name?: string | null }> | null }> | null }> | null }> | null } | null };

export type FetchSupplierExportCsvMutationVariables = Exact<{
  supplierIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  terminalIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  supplierTypes?: InputMaybe<Array<InputMaybe<SupplierTypeEnum>> | InputMaybe<SupplierTypeEnum>>;
  rackMarketIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  lineOfServiceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type FetchSupplierExportCsvMutation = { __typename?: 'Mutation', exportSuppliersCsv: { __typename?: 'ExportSuppliersCsvPayload', csv?: string | null, success: boolean, message: string } };

export type UpdateSupplierTerminalV2MutationVariables = Exact<{
  input: UpdateSupplierInput;
}>;


export type UpdateSupplierTerminalV2Mutation = { __typename?: 'Mutation', updateSupplierV2?: { __typename?: 'UpdateSuppliersV2Payload', supplier?: { __typename?: 'Supplier', id: string } | null } | null };

export type UpdateSupplierTerminalV3MutationVariables = Exact<{
  input: UpdateSupplierInputV3;
}>;


export type UpdateSupplierTerminalV3Mutation = { __typename?: 'Mutation', updateSupplierV3?: { __typename?: 'UpdateSuppliersV3Payload', supplier?: { __typename?: 'Supplier', id: string } | null } | null };

export type CreateOrUpdateTagMutationVariables = Exact<{
  input: CreateOrUpdateTagInput;
}>;


export type CreateOrUpdateTagMutation = { __typename?: 'Mutation', createOrUpdateTags?: { __typename?: 'CreateOrUpdateTagPayload', success: boolean, error?: string | null, tag?: { __typename?: 'Tag', tagType?: string | null } | null } | null };

export type FetchFilteredTagsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<TagFilter>;
  sorter?: InputMaybe<Array<BaseSorter> | BaseSorter>;
}>;


export type FetchFilteredTagsQuery = { __typename?: 'Query', filteredTags: { __typename?: 'TagCollection', collection: Array<{ __typename?: 'Tag', id: string, name: string, status?: StatusStringEnum | null, tagType?: string | null, description?: string | null, erpId?: string | null, colorCode?: string | null, iconName?: string | null }>, metadata: { __typename?: 'MetaQuery', totalCount?: number | null } } };

export type FetchTagQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchTagQuery = { __typename?: 'Query', tag?: { __typename?: 'Tag', id: string, name: string, iconName?: string | null, status?: StatusStringEnum | null, tagType?: string | null, colorCode?: string | null, description?: string | null, erpId?: string | null } | null };

export type FetchTerminalsWithSuppliersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<TerminalFilter>;
}>;


export type FetchTerminalsWithSuppliersQuery = { __typename?: 'Query', filteredTerminals: { __typename?: 'TerminalCollection', collection: Array<{ __typename?: 'Terminal', id: string, name?: string | null, suppliers?: Array<{ __typename?: 'Supplier', id: string, name: string }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean } } };

export type CreateTerminalWithRackMarketMutationVariables = Exact<{
  input: TerminalInput;
}>;


export type CreateTerminalWithRackMarketMutation = { __typename?: 'Mutation', createTerminal?: { __typename?: 'CreateTerminalsPayload', terminal?: { __typename?: 'Terminal', id: string, name?: string | null } | null } | null };

export type FetchFilteredTerminalsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<TerminalFilter>;
  sorter?: InputMaybe<Array<TerminalSorter> | TerminalSorter>;
}>;


export type FetchFilteredTerminalsQuery = { __typename?: 'Query', filteredTerminals: { __typename?: 'TerminalCollection', collection: Array<{ __typename?: 'Terminal', id: string, name?: string | null, erpId?: string | null, active?: boolean | null, suppliers?: Array<{ __typename?: 'Supplier', id: string, name: string, loadingAccounts?: Array<{ __typename?: 'LoadingAccount', id: string, name?: string | null, loadingNumber?: string | null }> | null }> | null, site?: { __typename?: 'Site', address?: any | null, radius?: number | null, lat?: string | null, lng?: string | null } | null, rackMarket?: { __typename?: 'RackMarket', id: string, name?: string | null } | null, loadingOrders?: Array<{ __typename: 'LoadingOrder', id: string, orderGroupId?: number | null, orderGroup?: { __typename?: 'OrderGroup', priority?: OrderGroupPriorityEnum | null, startOn?: any | null } | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FetchTerminalDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchTerminalDetailsQuery = { __typename?: 'Query', terminal: { __typename?: 'Terminal', id: string, name?: string | null, erpId?: string | null, active?: boolean | null, suppliers?: Array<{ __typename?: 'Supplier', id: string, name: string }> | null, site?: { __typename?: 'Site', address?: any | null, radius?: number | null, lat?: string | null, lng?: string | null } | null, rackMarket?: { __typename?: 'RackMarket', id: string, name?: string | null } | null } };

export type FetchTerminalExportCsvQueryVariables = Exact<{
  supplierId?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  terminalId?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  rackMarketId?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  status?: InputMaybe<Scalars['Boolean']>;
}>;


export type FetchTerminalExportCsvQuery = { __typename?: 'Query', exportTerminalsCsv?: { __typename?: 'DoliCsv', content?: string | null, fileName?: string | null, error?: string | null } | null };

export type UpdateTerminalWithRackMarketMutationVariables = Exact<{
  input: UpdateTerminalInput;
}>;


export type UpdateTerminalWithRackMarketMutation = { __typename?: 'Mutation', updateTerminal?: { __typename?: 'UpdateTerminalsPayload', terminal?: { __typename?: 'Terminal', id: string, name?: string | null } | null } | null };

export type CreateInventoryRecordMutationVariables = Exact<{
  input: CreateInventoryRecordInput;
}>;


export type CreateInventoryRecordMutation = { __typename?: 'Mutation', createInventoryRecord?: { __typename?: 'CreateInventoryRecordPayload', inventoryRecord?: { __typename?: 'AssetsInventoriesInventoryRecordType', asset: { __typename?: 'Asset', id: string } } | null } | null };

export type FetchAssetCompartmentDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchAssetCompartmentDetailsQuery = { __typename?: 'Query', asset: { __typename?: 'Asset', compartments?: Array<{ __typename?: 'Compartment', id: string, name?: string | null }> | null } };

export type FetchAssetInventorySummaryQueryVariables = Exact<{
  fromDate?: InputMaybe<Scalars['Int']>;
  toDate?: InputMaybe<Scalars['Int']>;
  assetId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
}>;


export type FetchAssetInventorySummaryQuery = { __typename?: 'Query', assetInventorySummary: any };

export type FetchBolReportsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<BolReportFilter>;
}>;


export type FetchBolReportsQuery = { __typename?: 'Query', bolReports: { __typename?: 'BolReportCollection', collection: Array<{ __typename?: 'BolReport', id: string, bol: string, asset?: string | null, externalId?: string | null, grossVolume?: number | null, netVolume?: number | null, notes?: string | null, adjustedVolume?: number | null, residualVolume?: number | null, deliveries?: Array<any> | null, fromState?: string | null, transfers?: Array<any> | null, product?: { __typename?: 'Product', id: string, name?: string | null } | null, loadingOrder?: { __typename?: 'LoadingOrder', id: string, orderGroup?: { __typename?: 'OrderGroup', completedOn?: number | null } | null } | null, terminal?: { __typename?: 'Terminal', id: string, name?: string | null } | null, supplier?: { __typename?: 'Supplier', id: string, name: string } | null, worker?: { __typename?: 'Driver', name?: string | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null } } };

export type FetchDivergenceReportsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<BolReportFilter>;
}>;


export type FetchDivergenceReportsQuery = { __typename?: 'Query', bolReports: { __typename?: 'BolReportCollection', collection: Array<{ __typename?: 'BolReport', id: string, bol: string, asset?: string | null, externalId?: string | null, grossVolume?: number | null, netVolume?: number | null, notes?: string | null, adjustedVolume?: number | null, residualVolume?: number | null, deliveries?: Array<any> | null, fromState?: string | null, transfers?: Array<any> | null, product?: { __typename?: 'Product', id: string, name?: string | null } | null, loadingOrder?: { __typename?: 'LoadingOrder', id: string, orderGroup?: { __typename?: 'OrderGroup', completedOn?: number | null } | null } | null, terminal?: { __typename?: 'Terminal', id: string, name?: string | null } | null, supplier?: { __typename?: 'Supplier', id: string, name: string } | null, worker?: { __typename?: 'Driver', name?: string | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null } } };

export type FetchFilteredAssetInventoriesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<AssetInventoriesFilter>;
}>;


export type FetchFilteredAssetInventoriesQuery = { __typename?: 'Query', assetInventories: { __typename?: 'AssetsInventoriesInventoryRecordTypeCollection', collection: Array<{ __typename?: 'AssetsInventoriesInventoryRecordType', transactionType?: string | null, quantity?: number | null, date: number, users?: string | null, totalCost?: number | null, linkedReferences: Array<any>, averageCost?: number | null, startingBalance?: number | null, product?: { __typename?: 'Product', id: string, name?: string | null } | null }>, metadata: { __typename?: 'MetaQuery', totalCount?: number | null } } };

export type FetchFilteredAssetsInventoriesRecordsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<AssetInventoryFilter>;
}>;


export type FetchFilteredAssetsInventoriesRecordsQuery = { __typename?: 'Query', assetsInventories: { __typename?: 'AssetsInventoriesInventoryRecordTypeCollection', collection: Array<{ __typename?: 'AssetsInventoriesInventoryRecordType', averageCost?: number | null, totalSalesVolume?: number | null, totalPurchaseVolume?: number | null, totalTransferVolume?: number | null, totalAdjustmentVolume?: number | null, totalExtractedVolume?: number | null, startingBalance?: number | null, date: number, volume?: number | null, asset: { __typename?: 'Asset', id: string, name?: string | null }, product?: { __typename?: 'Product', id: string, name?: string | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null } } };

export type FetchFilteredCustomerReportsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<CustomerReportFilter>;
  sorter?: InputMaybe<Array<CustomerReportSorter> | CustomerReportSorter>;
}>;


export type FetchFilteredCustomerReportsQuery = { __typename?: 'Query', filteredCustomerReports: { __typename?: 'CustomerReportCollection', collection: Array<{ __typename?: 'CustomerReport', id: string, name: string, lastViewedAt?: any | null, receipients?: string | null, updatedAt: any, lastViewedBy?: { __typename?: 'User', name?: string | null } | null, owner: { __typename?: 'User', name?: string | null }, recurrence?: { __typename?: 'RecurrenceOrderGroup', recurrenceAutoExpired?: boolean | null, recurrenceDates?: Array<string> | null, recurrenceDaysInAdvance?: number | null, recurrenceDaysOfWeek?: Array<DaysOfWeek> | null, recurrenceFromTimestamp?: string | null, recurrenceInterval?: number | null, recurrenceType: Recurrence, recurrenceUntil?: string | null, recurrenceDays?: Array<number> | null, recurrenceDayNthWeek?: { __typename?: 'RecurrenceDayNthWeek', friday?: Array<number> | null, monday?: Array<number> | null, saturday?: Array<number> | null, sunday?: Array<number> | null, thursday?: Array<number> | null, tuesday?: Array<number> | null, wednesday?: Array<number> | null } | null } | null }>, metadata: { __typename?: 'MetaQuery', totalCount?: number | null } } };

export type FilteredLeaReportQueryVariables = Exact<{
  filter?: InputMaybe<LeaReportFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type FilteredLeaReportQuery = { __typename?: 'Query', filteredLeaReport: { __typename?: 'MovementOrderCollection', collection: Array<{ __typename?: 'MovementOrder', id: string, requestedTankSize?: string | null, totalDeliveriesCount?: number | null, totalGallonsDelivered?: number | null, orderGroup: { __typename?: 'OrderGroup', id: string, status: string, createdAtTimestamp: number, startedOnTimestamp?: number | null, completedOnTimestamp?: number | null }, asset?: { __typename: 'Asset', id: string, name?: string | null, status?: string | null, erpId?: string | null, tankSize?: string | null, category?: string | null, licensePlateNumber?: string | null } | null, toCustomerBranch: { __typename?: 'CustomerBranch', erpId?: string | null, name?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null } | null }, leaLineItem?: { __typename?: 'LeaLineItem', gallonPerMonth?: string | null, marginPerGallonInCents?: string | null, bdrCommissionInPercent?: string | null, requestProduct?: { __typename?: 'Product', id: string, name?: string | null } | null, leaCore?: { __typename?: 'LeaCore', parentLeaCore?: { __typename?: 'LeaCore', isSigned?: boolean | null, leaQuestionnaire?: { __typename?: 'LeaQuestionnaire', salesRepresentative?: { __typename?: 'User', id: string, name?: string | null } | null } | null } | null } | null } | null }>, metadata: { __typename?: 'MetaQuery', totalCount?: number | null } } };

export type FetchFilteredLoadingReceiptsQueryVariables = Exact<{
  filter?: InputMaybe<LoadingReceiptsFilter>;
}>;


export type FetchFilteredLoadingReceiptsQuery = { __typename?: 'Query', loadingReceipts?: Array<{ __typename?: 'LoadingReceipt', id: string, receiptNumber?: string | null, bolPricings?: Array<{ __typename?: 'BolPricing', quantity?: number | null, total?: number | null, product: { __typename?: 'Product', id: string, name?: string | null } }> | null, orderGroupsFees?: Array<{ __typename?: 'OrderGroupsFee', price?: number | null, quantity: number }> | null, loadingOrder: { __typename?: 'LoadingOrder', orderGroup?: { __typename?: 'OrderGroup', id: string, startOnTimestamp?: number | null } | null } }> | null };

export type GetFilteredSyncedOrdersQueryVariables = Exact<{
  filter?: InputMaybe<SyncOrdersFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetFilteredSyncedOrdersQuery = { __typename?: 'Query', filteredSyncedOrders: { __typename?: 'OrderGroupSyncReportCollection', collection: Array<{ __typename?: 'OrderGroupSyncReport', id: string, ticketId: number, status: string, isSynced: boolean, createdAtTimestamp: number, departedOnTimestamp?: number | null, startOnTimestamp?: number | null, startedOnTimestamp?: number | null, completedOnTimestamp?: number | null, completeOnTimestamp?: number | null, latestInvoiceStatus?: string | null, driverAcceptance: string, priority?: OrderGroupPriorityEnum | null, vendor?: VendorNameEnum | null, driver?: { __typename?: 'Driver', id: string, name?: string | null } | null, deliveryOrder?: { __typename?: 'DeliveryOrder', type?: string | null, id: string, status: string, orderNumber?: string | null, deliveryInstruction?: string | null, source?: string | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, address?: string | null, site?: { __typename?: 'Site', lat?: string | null, lng?: string | null, radius?: number | null } | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, address?: string | null } | null } | null, lineItems: Array<{ __typename?: 'DeliveryOrderLineItem', id: string, requestedVolume?: number | null, volume?: number | null, status: string, product?: { __typename?: 'Product', id: string, name?: string | null, unit?: string | null, deliveryType?: string | null } | null, subscription?: { __typename?: 'Subscription', product: { __typename?: 'Product', name?: string | null }, asset: { __typename?: 'Asset', category?: string | null, licensePlateNumber?: string | null } } | null }>, orderLinks?: Array<{ __typename?: 'OrderLink', id: string, loadingOrder?: { __typename?: 'LoadingOrder', id: string, bolNumbers?: string | null, status: string, terminal?: { __typename?: 'Terminal', id: string, name?: string | null } | null } | null, extractionOrder?: { __typename?: 'ExtractionOrder', id: string, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null } | null }> | null } | null, loadingOrder?: { __typename?: 'LoadingOrder', id: string, status: string, terminal?: { __typename?: 'Terminal', id: string, name?: string | null, site?: { __typename?: 'Site', lat?: string | null, lng?: string | null, radius?: number | null, address?: any | null } | null, suppliers?: Array<{ __typename?: 'Supplier', id: string, name: string, loadingAccounts?: Array<{ __typename?: 'LoadingAccount', id: string, carrierCustomerCode?: string | null, loadingNumber?: string | null }> | null }> | null } | null, orderLinks?: Array<{ __typename?: 'OrderLink', id: string, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, orderGroupId?: number | null } | null, loadingOrder?: { __typename?: 'LoadingOrder', id: string } | null }> | null, loadingOrderProducts?: Array<{ __typename?: 'LoadingOrderProduct', id: string, quantity?: number | null, product: { __typename?: 'Product', name?: string | null, code?: string | null, unit?: string | null, deliveryType?: string | null }, preferredSuppliers?: Array<{ __typename?: 'PreferredSupplier', priority?: number | null, loadingAccount?: { __typename?: 'LoadingAccount', loadingNumber?: string | null, supplier?: { __typename?: 'Supplier', name: string, erpId?: string | null, supplierId?: string | null } | null } | null }> | null }> | null, lineItems: Array<{ __typename?: 'LoadingOrderLineItem', id: string, netAmount?: number | null, product?: { __typename?: 'Product', id: string, name?: string | null, unit?: string | null, deliveryType?: string | null } | null, compartment?: { __typename?: 'Compartment', asset?: { __typename?: 'Asset', id: string, licensePlateNumber?: string | null, name?: string | null } | null } | null }> } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FilteredTaxReportQueryVariables = Exact<{
  filters?: InputMaybe<TaxReportFilterInput>;
  startOnTimestamp?: InputMaybe<Scalars['Int']>;
  endOnTimestamp?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type FilteredTaxReportQuery = { __typename?: 'Query', filteredTaxReport?: any | null };

export type FilteredSalesReportQueryVariables = Exact<{
  filters?: InputMaybe<SalesReportFilterInput>;
  startOnTimestamp?: InputMaybe<Scalars['Int']>;
  endOnTimestamp?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type FilteredSalesReportQuery = { __typename?: 'Query', filteredSalesReport?: any | null };

export type GeneratePresignedMetabaseUrlMutationVariables = Exact<{
  reportId: Scalars['ID'];
}>;


export type GeneratePresignedMetabaseUrlMutation = { __typename?: 'Mutation', generatePresignedMetabaseUrl?: { __typename?: 'GeneratePresignedMetabaseUrlPayload', url: string } | null };

export type GenerateSalesReportMutationVariables = Exact<{
  input: GenerateSalesReportInput;
}>;


export type GenerateSalesReportMutation = { __typename?: 'Mutation', generateSalesReport?: { __typename?: 'GenerateSalesReportPayload', pandaDocument?: { __typename?: 'PandaDocument', fileUrl?: string | null } | null } | null };

export type GenerateTaxReportMutationVariables = Exact<{
  input: GenerateTaxReportInput;
}>;


export type GenerateTaxReportMutation = { __typename?: 'Mutation', generateTaxReport?: { __typename?: 'GenerateTaxReportPayload', pandaDocument?: { __typename?: 'PandaDocument', fileUrl?: string | null } | null } | null };

export type RecalculateInventoryRecordsMutationVariables = Exact<{ [key: string]: never; }>;


export type RecalculateInventoryRecordsMutation = { __typename?: 'Mutation', recalculateInventoryRecords?: { __typename?: 'RecalculateInventoryRecordsPayload', success?: boolean | null } | null };

export type UpdateCustomerReportMutationVariables = Exact<{
  input: UpdateCustomerReportInput;
}>;


export type UpdateCustomerReportMutation = { __typename?: 'Mutation', updateCustomerReport?: { __typename?: 'CustomerReport', id: string, lastViewedAt?: any | null, receipients?: string | null, updatedAt: any, recurrence?: { __typename?: 'RecurrenceOrderGroup', recurrenceAutoExpired?: boolean | null, recurrenceDates?: Array<string> | null, recurrenceDaysInAdvance?: number | null, recurrenceDaysOfWeek?: Array<DaysOfWeek> | null, recurrenceFromTimestamp?: string | null, recurrenceInterval?: number | null, recurrenceType: Recurrence, recurrenceUntil?: string | null, recurrenceDays?: Array<number> | null, recurrenceDayNthWeek?: { __typename?: 'RecurrenceDayNthWeek', friday?: Array<number> | null, monday?: Array<number> | null, saturday?: Array<number> | null, sunday?: Array<number> | null, thursday?: Array<number> | null, tuesday?: Array<number> | null, wednesday?: Array<number> | null } | null } | null } | null };

export type CreateRouteMutationVariables = Exact<{
  rawShiftAttributes?: InputMaybe<RawShiftCreateInput>;
}>;


export type CreateRouteMutation = { __typename?: 'Mutation', createRawShift?: { __typename?: 'CreateRawShiftPayload', rawShift?: { __typename?: 'RawShift', id: string } | null } | null };

export type DeleteRouteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteRouteMutation = { __typename?: 'Mutation', deleteRawShift?: { __typename?: 'DeleteRawShiftPayload', rawShift?: { __typename?: 'RawShift', id: string } | null } | null };

export type FetchProductSummaryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchProductSummaryQuery = { __typename?: 'Query', deliveryOrder: { __typename?: 'DeliveryOrder', id: string, lineItemSummary?: Array<{ __typename?: 'LineItem', product?: string | null, orderedVolume?: number | null }> | null } };

export type FetchRouteQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchRouteQuery = { __typename?: 'Query', rawShift: { __typename?: 'RawShift', id: string, name: string, status?: string | null, startOnTimestamp?: number | null, endOnTimestamp?: number | null, creatable?: { __typename?: 'User', name?: string | null } | null, dispatchable?: { __typename?: 'User', name?: string | null } | null, startHub?: { __typename?: 'CustomerBranch', id: string, name?: string | null, site?: { __typename?: 'Site', lat?: string | null, lng?: string | null } | null } | null, endHub?: { __typename?: 'CustomerBranch', id: string, name?: string | null, site?: { __typename?: 'Site', lat?: string | null, lng?: string | null } | null } | null, worker?: { __typename?: 'Worker', id: string, name?: string | null } | null, asset?: { __typename?: 'Asset', id: string, name?: string | null } | null, orderGroups?: Array<{ __typename?: 'OrderGroup', id: string, routingOrder?: number | null, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, deliveryOrderLineItems: Array<{ __typename?: 'DeliveryOrderLineItem', requestedVolume?: number | null, product?: { __typename?: 'Product', id: string, name?: string | null } | null }>, orderLinks?: Array<{ __typename?: 'OrderLink', id: string, loadingOrder?: { __typename?: 'LoadingOrder', id: string, terminal?: { __typename?: 'Terminal', id: string, name?: string | null, suppliers?: Array<{ __typename?: 'Supplier', id: string, name: string }> | null } | null } | null }> | null } | null, loadingOrder?: { __typename?: 'LoadingOrder', id: string, terminal?: { __typename?: 'Terminal', id: string, name?: string | null, suppliers?: Array<{ __typename?: 'Supplier', id: string, name: string }> | null, site?: { __typename?: 'Site', address?: any | null } | null } | null } | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, address?: string | null, resourceSchedule?: { __typename?: 'ResourceSchedule', availability?: Array<{ __typename?: 'Availability', day?: string | null, startTime?: string | null, endTime?: string | null }> | null } | null, customer?: { __typename?: 'Customer', address?: string | null } | null, site?: { __typename?: 'Site', lat?: string | null, lng?: string | null } | null } | null }> | null } };

export type FetchRouteDriverScheduleQueryVariables = Exact<{
  driverId: Scalars['ID'];
}>;


export type FetchRouteDriverScheduleQuery = { __typename?: 'Query', driver: { __typename?: 'Driver', id: string, name?: string | null, resourceSchedule?: { __typename?: 'ResourceSchedule', id?: string | null, availability?: Array<{ __typename?: 'Availability', day?: string | null, preferredStartTime?: string | null, preferredEndTime?: string | null }> | null, unavailability?: Array<{ __typename?: 'Unavailability', unStartTime?: string | null, unEndTime?: string | null, reason?: string | null }> | null } | null } };

export type FetchRouteDurationSummaryQueryVariables = Exact<{
  rawShiftId: Scalars['ID'];
  refresh?: InputMaybe<Scalars['Boolean']>;
  routeCalculationType?: InputMaybe<RouteCalculationEnum>;
}>;


export type FetchRouteDurationSummaryQuery = { __typename?: 'Query', rawShiftSummary?: { __typename?: 'RawShiftSummary', estimatedDistance?: number | null, estimatedDuration?: number | null, estimatedDurationInTraffic?: number | null, estimatedFuelingDuration?: number | null, rawShiftStops?: any | null } | null };

export type FetchStagingOrdersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ShiftBuilderOrderWellFilter>;
  sorter?: InputMaybe<Array<ShiftBuilderOrderSorter> | ShiftBuilderOrderSorter>;
}>;


export type FetchStagingOrdersQuery = { __typename?: 'Query', filteredShiftBuilderOrders: { __typename?: 'OrderWellCollection', collection: Array<{ __typename?: 'OrderWell', id: string, orderId: string, ticketId: string, status?: string | null, type?: string | null, plannedAt?: number | null, customerName?: string | null, shipToName?: string | null, address?: string | null, source?: string | null, startAt?: number | null, endAt?: number | null, createdAtTimestamp?: number | null, productNames?: Array<string> | null, driverName?: string | null, driverId?: string | null, deliveryTruckNames?: Array<string> | null, createdBy?: string | null, assignedBy?: string | null, plannedGal?: number | null, deliveredGal?: number | null, priority?: OrderGroupPriorityEnum | null, preferredSupplierNames?: Array<string> | null, supplierNames?: Array<string> | null, hubName?: string | null, state?: string | null, zip?: string | null, city?: string | null, poNumber?: string | null, coordinates?: { __typename?: 'Coordinates', lat?: string | null, lng?: string | null } | null }>, metadata: { __typename?: 'MetaQuery', totalCount?: number | null } } };

export type FilteredRoutesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<RawShiftFilter>;
  sorter?: InputMaybe<Array<RawShiftSorter> | RawShiftSorter>;
}>;


export type FilteredRoutesQuery = { __typename?: 'Query', filteredRawShifts: { __typename?: 'RawShiftCollection', collection: Array<{ __typename?: 'RawShift', id: string, name: string, status?: string | null, createdAtTimestamp?: number | null, dispatchedOnTimestamp?: number | null, startOnTimestamp?: number | null, endOnTimestamp?: number | null, tags?: Array<string> | null, totalOrderGroups?: number | null, completedOrderGroups?: number | null, startHub?: { __typename?: 'CustomerBranch', id: string, name?: string | null, site?: { __typename?: 'Site', lat?: string | null, lng?: string | null } | null } | null, endHub?: { __typename?: 'CustomerBranch', id: string, name?: string | null, site?: { __typename?: 'Site', lat?: string | null, lng?: string | null } | null } | null, worker?: { __typename?: 'Worker', id: string, name?: string | null } | null, asset?: { __typename?: 'Asset', id: string, name?: string | null } | null, dispatchable?: { __typename?: 'User', id: string, name?: string | null } | null, creatable?: { __typename?: 'User', id: string, name?: string | null } | null, orderGroups?: Array<{ __typename?: 'OrderGroup', routingOrder?: number | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, site?: { __typename?: 'Site', lat?: string | null, lng?: string | null } | null } | null, loadingOrder?: { __typename?: 'LoadingOrder', id: string, terminal?: { __typename?: 'Terminal', id: string, name?: string | null, suppliers?: Array<{ __typename?: 'Supplier', id: string, name: string }> | null } | null } | null }> | null }>, metadata: { __typename?: 'MetaQuery', totalCount?: number | null } } };

export type FilteredRoutesListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<RawShiftFilter>;
  sorter?: InputMaybe<Array<RawShiftSorter> | RawShiftSorter>;
}>;


export type FilteredRoutesListQuery = { __typename?: 'Query', filteredRawShifts: { __typename?: 'RawShiftCollection', collection: Array<{ __typename?: 'RawShift', id: string, name: string, orderGroups?: Array<{ __typename?: 'OrderGroup', id: string, routingOrder?: number | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, address?: string | null } | null, loadingOrder?: { __typename?: 'LoadingOrder', id: string, terminal?: { __typename?: 'Terminal', id: string, name?: string | null, suppliers?: Array<{ __typename?: 'Supplier', id: string, name: string }> | null } | null } | null }> | null }> } };

export type UpdateRouteMutationVariables = Exact<{
  rawShiftAttributes?: InputMaybe<RawShiftCreateInput>;
}>;


export type UpdateRouteMutation = { __typename?: 'Mutation', updateRawShift?: { __typename?: 'UpdateRawShiftPayload', rawShift?: { __typename?: 'RawShift', id: string } | null } | null };

export type DeleteShiftPlanByIdMutationVariables = Exact<{
  shiftPlanId: Scalars['ID'];
}>;


export type DeleteShiftPlanByIdMutation = { __typename?: 'Mutation', deleteShiftPlan?: { __typename?: 'DeleteShiftPlanPayload', shiftPlan?: { __typename?: 'ShiftPlan', id: string } | null } | null };

export type CustomerUserDetailQueryVariables = Exact<{
  userId: Scalars['ID'];
  customerId: Scalars['ID'];
}>;


export type CustomerUserDetailQuery = { __typename?: 'Query', filteredCustomerUsers: { __typename?: 'CustomerUserCollection', collection: Array<{ __typename?: 'CustomerUser', id: string, customer?: { __typename?: 'Customer', id: string } | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null, user?: { __typename?: 'User', id: string } | null }> } };

export type OptimizedShiftDetailQueryVariables = Exact<{
  shiftId: Scalars['ID'];
}>;


export type OptimizedShiftDetailQuery = { __typename?: 'Query', filteredShiftPlans: { __typename?: 'ShiftPlanCollection', collection: Array<{ __typename?: 'ShiftPlan', id: string, shiftDate: any, truckId: string, status: string, customerPods?: string | null, earliestStart?: number | null, deliveriesRoutes?: Array<any> | null, hub?: { __typename?: 'ShiftPlanHub', address: string, lat: number, lon: number, name?: string | null } | null, completedDeliveries?: Array<{ __typename?: 'ShiftPlanDelivery', address: string, customerId?: string | null, customerName?: string | null, lat?: number | null, lon?: number | null, podNo?: number | null, product?: string | null, volume?: number | null, inconsistent?: boolean | null, type?: string | null, arriveDateTime?: string | null, completeDateTime?: string | null, distanceMiles?: number | null, drivingTimeSeconds?: number | null }> | null, completedDeliveriesMetrics?: { __typename?: 'ShiftPlanDeliveryMetric', distance?: number | null, time?: string | null, timeSeconds?: number | null, deliveriesCount?: number | null, volumeDelivered?: number | null, serviceTime?: number | null, missing?: Array<string> | null } | null, plannedMetrics?: { __typename?: 'ShiftPlanDeliveryMetric', deliveriesCount?: number | null, volumeDelivered?: number | null } | null, planned?: Array<{ __typename?: 'ShiftPlanDelivery', address: string, customerName?: string | null, product?: string | null, volume?: number | null, estimatedVolume?: number | null, podNo?: number | null, customerId?: string | null }> | null, deliveries?: Array<{ __typename?: 'ShiftPlanDelivery', address: string, customerId?: string | null, customerName?: string | null, lat?: number | null, lon?: number | null, podNo?: number | null, product?: string | null, volume?: number | null, inconsistent?: boolean | null, estimatedVolume?: number | null, distanceMiles?: number | null, drivingTimeSeconds?: number | null, waitingTimeSeconds?: number | null, lastEndTime?: number | null, timeSeconds?: number | null, lastDistanceInMiles?: number | null, lastWaitingTime?: number | null, type?: string | null, arrTime?: number | null, arrivingTime?: number | null, lastDrivingTime?: number | null, flushing?: boolean | null, hoseTime?: number | null, timeAdder?: number | null, inventory?: boolean | null, index?: number | null, compartment?: string | null, productUsed?: string | null, volumeUsed?: number | null, productCode?: string | null, timeWindows?: Array<{ __typename?: 'ShiftPlanDeliveryTimeWindows', earliest?: number | null, latest?: number | null }> | null }> | null, deliveriesMetrics?: { __typename?: 'ShiftPlanDeliveryMetric', distance?: number | null, time?: string | null, timeSeconds?: number | null, deliveriesCount?: number | null, volumeDelivered?: number | null, serviceTime?: number | null } | null }> } };

export type ShiftPlanDetailForPdfQueryVariables = Exact<{
  shiftIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ShiftPlanDetailForPdfQuery = { __typename?: 'Query', filteredShiftPlans: { __typename?: 'ShiftPlanCollection', collection: Array<{ __typename?: 'ShiftPlan', truckId: string, shiftDate: any, deliveries?: Array<{ __typename?: 'ShiftPlanDelivery', customerName?: string | null, inconsistent?: boolean | null, product?: string | null, volume?: number | null, customerId?: string | null, podNo?: number | null, orderNumber?: string | null, tankSize?: number | null, productCode?: string | null, deliveryInstruction?: string | null, lastDeliveryDate?: string | null, secondLastDeliveryDate?: string | null, ffm?: string | null, contact?: string | null, address: string, deliveryZone?: string | null, division?: string | null, lineComment?: string | null }> | null }> } };

export type ShiftPlanMapQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type ShiftPlanMapQuery = { __typename?: 'Query', filteredShiftPlans: { __typename?: 'ShiftPlanCollection', collection: Array<{ __typename?: 'ShiftPlan', id: string, optimized: boolean, routingRequestId?: string | null, deliveriesRoutes?: Array<any> | null, planned?: Array<{ __typename?: 'ShiftPlanDelivery', address: string, estimatedVolume?: number | null, lat?: number | null, lon?: number | null, customerName?: string | null, orderNumber?: string | null }> | null, deliveries?: Array<{ __typename?: 'ShiftPlanDelivery', lat?: number | null, lon?: number | null, inconsistent?: boolean | null, volume?: number | null, estimatedVolume?: number | null, customerName?: string | null, orderNumber?: string | null }> | null, hub?: { __typename?: 'ShiftPlanHub', address: string, lat: number, lon: number, name?: string | null } | null }> } };

export type ShiftPlansTableDataQueryVariables = Exact<{
  perPage?: InputMaybe<Scalars['Int']>;
  offSet?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<ShiftPlanSorter> | ShiftPlanSorter>;
  fromTime?: InputMaybe<Scalars['Int']>;
  toTime?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  truckId?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ShiftPlansTableDataQuery = { __typename?: 'Query', filteredShiftPlans: { __typename?: 'ShiftPlanCollection', collection: Array<{ __typename?: 'ShiftPlan', id: string, shiftDate: any, truckId: string, status: string, shift: number, customerPods?: string | null, optimized: boolean, productsDelivered?: string | null, errors?: Array<string> | null, location?: string | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type TenantCustomerBranchesQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantCustomerBranchesQuery = { __typename?: 'Query', filteredCustomerBranches: { __typename?: 'CustomerBranchCollection', collection: Array<{ __typename?: 'CustomerBranch', id: string, name?: string | null }> } };

export type OptimizeShiftPlanMutationVariables = Exact<{
  shiftIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type OptimizeShiftPlanMutation = { __typename?: 'Mutation', optimizeShiftPlan?: { __typename?: 'OptimizeShiftPlanPayload', queued?: boolean | null } | null };

export type UpdateCommonCarrierMutationVariables = Exact<{
  input: UpdateCommonCarrierInput;
}>;


export type UpdateCommonCarrierMutation = { __typename?: 'Mutation', updateCommonCarrier?: { __typename?: 'UpdateCommonCarrierPayload', success: boolean, error?: string | null, ccTenant?: { __typename?: 'CcTenant', id: string, erpId?: string | null, name: string, address?: string | null, carrierTenantId: string, secondaryEmails?: Array<string> | null, site?: { __typename?: 'Site', address?: any | null, city?: string | null, lat?: string | null, lng?: string | null, radius?: number | null, state?: string | null, qbAddress?: string | null, tags?: any | null } | null } | null } | null };

export type CreateSettingMutationVariables = Exact<{
  input: CreateSettingInput;
}>;


export type CreateSettingMutation = { __typename?: 'Mutation', createSetting?: { __typename?: 'CreateSettingPayload', setting?: { __typename?: 'Setting', id: string, name: string, value?: string | null } | null } | null };

export type IndexResourceMutationVariables = Exact<{
  resource: IndexResourceInput;
}>;


export type IndexResourceMutation = { __typename?: 'Mutation', indexResource?: { __typename?: 'IndexResourcePayload', setting: { __typename?: 'Setting', id: string, name: string, value?: string | null } } | null };

export type RefreshApiTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshApiTokenMutation = { __typename?: 'Mutation', refreshApiToken?: { __typename?: 'RefreshApiTokenPayload', setting?: { __typename?: 'Setting', id: string, name: string, value?: string | null } | null } | null };

export type UpdateResourceMutationVariables = Exact<{
  resource: UpdateResourceInput;
}>;


export type UpdateResourceMutation = { __typename?: 'Mutation', updateResource?: { __typename?: 'UpdateResourcePayload', error?: string | null, success: boolean, records?: Array<{ __typename?: 'BolRetain' } | { __typename?: 'CcTenant', id: string, name: string, erpId?: string | null, secondaryEmails?: Array<string> | null } | { __typename?: 'DriverRate', id: string, rate?: number | null } | { __typename?: 'Setting', id: string, name: string, value?: string | null } | { __typename?: 'Site', id: string, address?: any | null, city?: string | null, zip?: string | null, state?: string | null }> | null } | null };

export type OptimizedOrderGroupsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  fromTimestamp: Scalars['Int'];
  toTimestamp: Scalars['Int'];
  workerIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type OptimizedOrderGroupsQuery = { __typename?: 'Query', filteredOrderGroups: { __typename?: 'OrderGroupCollection', metadata: { __typename?: 'MetaQuery', hasMore: boolean }, collection: Array<{ __typename?: 'OrderGroup', id: string, status: string, startOn?: any | null, startOnTimestamp?: number | null, worker?: { __typename?: 'Worker', id: string, name?: string | null } | null, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, type?: string | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, address?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, address?: string | null } | null } | null } | null, loadingOrder?: { __typename?: 'LoadingOrder', id: string, terminal?: { __typename?: 'Terminal', id: string, name?: string | null } | null } | null, transferOrder?: { __typename?: 'TransferOrder', id: string } | null }> } };

export type ChangeOrderAssignmentMutationVariables = Exact<{
  groupId: Scalars['ID'];
  startTime?: InputMaybe<Scalars['String']>;
  driverId: Scalars['ID'];
}>;


export type ChangeOrderAssignmentMutation = { __typename?: 'Mutation', changeOrderGroupAssignment?: { __typename?: 'ChangeOrderGroupAssignmentPayload', orderGroup: { __typename?: 'OrderGroup', id: string, startOnTimestamp?: number | null, driver?: { __typename?: 'Driver', id: string } | null } } | null };

export type FetchDeliveryShiftDetailsQueryVariables = Exact<{
  shiftId: Scalars['ID'];
}>;


export type FetchDeliveryShiftDetailsQuery = { __typename?: 'Query', shift: { __typename?: 'Shift', id: string, shiftDeliveryUnitsAssets?: Array<{ __typename?: 'ShiftDeliveryUnitsAsset', deliveryAsset?: { __typename?: 'DeliveryAsset', id: string, name?: string | null, licensePlateNumber?: string | null, category?: string | null, compartments?: Array<{ __typename?: 'Compartment', id: string, length?: number | null, name?: string | null }> | null } | null }> | null } };

export type FilterCommonCarrierQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  customFilter?: InputMaybe<CcTenantFilter>;
}>;


export type FilterCommonCarrierQuery = { __typename?: 'Query', filteredCcTenants?: { __typename?: 'CcTenantCollection', metadata: { __typename?: 'MetaQuery', hasMore: boolean }, collection: Array<{ __typename?: 'CcTenant', id: string, name: string }> } | null };

export type FilterDriverQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<DriverSorter> | DriverSorter>;
  customFilter?: InputMaybe<DriverFilter>;
}>;


export type FilterDriverQuery = { __typename?: 'Query', filteredDrivers: { __typename?: 'DriverCollection', metadata: { __typename?: 'MetaQuery', hasMore: boolean }, collection: Array<{ __typename?: 'Driver', id: string, name?: string | null, status?: string | null }> } };

export type FilterDriverGroupsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<GroupSorter> | GroupSorter>;
}>;


export type FilterDriverGroupsQuery = { __typename?: 'Query', filteredGroups: { __typename?: 'GroupCollection', metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null }, collection: Array<{ __typename?: 'Group', id: string, name: string, groupMemberships?: Array<{ __typename?: 'GroupMembership', id: string, groupable?: { __typename?: 'Customer', type: 'Customer' } | { __typename?: 'Driver', id: string, name?: string | null, status?: string | null, type: 'Driver' } | { __typename?: 'UnknownGroupable', type: 'UnknownGroupable' } | { __typename?: 'User', type: 'User' } | null }> | null }> } };

export type DeliveryOrderGroupFragment = { __typename?: 'OrderGroup', id: string, startOnTimestamp?: number | null, toStartOnTimestamp?: number | null, startedOnTimestamp?: number | null, outsideAvailability?: boolean | null, completedOnTimestamp?: number | null, createdAtTimestamp: number, carrierNumber?: string | null, purchaseOrderType?: string | null, purchaseOrderRequired?: boolean | null, ccTenantId?: number | null, ticketId: number, poNumber?: string | null, shiftId?: string | null, status: string, priority?: OrderGroupPriorityEnum | null, ccTenant?: { __typename?: 'CcTenant', id: string, name: string } | null, driver?: { __typename?: 'Driver', id: string, name?: string | null, isCarrier?: boolean | null } | null, hub?: { __typename?: 'Hub', id: string, name?: string | null, address?: any | null } | null, lineOfService?: { __typename?: 'LineOfService', id: string, name?: string | null, shortName?: string | null } | null, deliveryOrder?: { __typename?: 'DeliveryOrder', deliveryInstruction?: string | null } | null, shift?: { __typename?: 'Shift', state?: string | null } | null };

export type UpdateDeliveryOrderMutationVariables = Exact<{
  input: UpdateDeliveryOrderInput;
}>;


export type UpdateDeliveryOrderMutation = { __typename?: 'Mutation', updateDeliveryOrder?: { __typename?: 'UpdateDeliveryOrderPayload', deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, orderGroup?: { __typename?: 'OrderGroup', shift?: { __typename?: 'Shift', shiftDeliveryUnitsAssets?: Array<{ __typename?: 'ShiftDeliveryUnitsAsset', deliveryAsset?: { __typename?: 'DeliveryAsset', id: string, name?: string | null, licensePlateNumber?: string | null, category?: string | null, compartments?: Array<{ __typename?: 'Compartment', id: string, name?: string | null }> | null } | null }> | null } | null } | null, lineItems: Array<{ __typename?: 'DeliveryOrderLineItem', id: string, status: string, source: string, topOff?: boolean | null, requestedVolume?: number | null, volume?: number | null, skipReason?: string | null, data?: any | null, isExtraction?: boolean | null, canSyncRequestedLoadingVolume: boolean, warehouseId?: string | null, notes?: string | null, product?: { __typename?: 'Product', id: string, category: string, name?: string | null, colorCode?: string | null, shortName?: string | null, code?: string | null, unit?: string | null, brand?: { __typename?: 'Brand', id: string, name?: string | null } | null } | null, asset?: { __typename?: 'Asset', id: string, licensePlateNumber?: string | null, name?: string | null, category?: string | null, lat?: string | null, lng?: string | null } | null, sourceCompartments?: Array<{ __typename?: 'SourceCompartment', id: string, dispensedVolume?: number | null, compartment: { __typename?: 'Compartment', id: string, name?: string | null, asset?: { __typename?: 'Asset', id: string, name?: string | null, licensePlateNumber?: string | null, category?: string | null } | null } }> | null, targetCompartmentInstance?: { __typename?: 'CompartmentInstance', id: string, beforeStick?: string | null, beforeStickUnit?: string | null, afterStick?: string | null, afterStickUnit?: string | null } | null, subscription?: { __typename?: 'Subscription', id: string } | null }> } | null } | null };

export type UpdateDeliveryOrderGroupMutationVariables = Exact<{
  input: UpdateOrderGroupMutationInput;
}>;


export type UpdateDeliveryOrderGroupMutation = { __typename?: 'Mutation', updateOrderGroup?: { __typename?: 'UpdateOrderGroupMutationPayload', orderGroup?: { __typename?: 'OrderGroup', id: string, startOnTimestamp?: number | null, toStartOnTimestamp?: number | null, startedOnTimestamp?: number | null, outsideAvailability?: boolean | null, completedOnTimestamp?: number | null, createdAtTimestamp: number, carrierNumber?: string | null, purchaseOrderType?: string | null, purchaseOrderRequired?: boolean | null, ccTenantId?: number | null, ticketId: number, poNumber?: string | null, shiftId?: string | null, status: string, priority?: OrderGroupPriorityEnum | null, ccTenant?: { __typename?: 'CcTenant', id: string, name: string } | null, driver?: { __typename?: 'Driver', id: string, name?: string | null, isCarrier?: boolean | null } | null, hub?: { __typename?: 'Hub', id: string, name?: string | null, address?: any | null } | null, lineOfService?: { __typename?: 'LineOfService', id: string, name?: string | null, shortName?: string | null } | null, deliveryOrder?: { __typename?: 'DeliveryOrder', deliveryInstruction?: string | null } | null, shift?: { __typename?: 'Shift', state?: string | null } | null } | null } | null };

export type UpdateDeliveryOrderLineItemMutationVariables = Exact<{
  input: UpdateDeliveryOrderLineItemInput;
}>;


export type UpdateDeliveryOrderLineItemMutation = { __typename?: 'Mutation', updateDeliveryOrderLineItem?: { __typename?: 'UpdateDeliveryOrderLineItemPayload', deliveryOrderLineItem?: { __typename?: 'DeliveryOrderLineItem', id: string } | null } | null };

export type CreateOrUpdateRoleMutationVariables = Exact<{
  input: CreateOrUpdateRoleInput;
}>;


export type CreateOrUpdateRoleMutation = { __typename?: 'Mutation', createOrUpdateRole?: { __typename?: 'CreateOrUpdateRolePayload', role?: { __typename?: 'Role', id: string, name?: string | null, label?: string | null, adminRole?: boolean | null } | null } | null };

export type FetchRoleByIdQueryVariables = Exact<{
  roleId: Scalars['ID'];
}>;


export type FetchRoleByIdQuery = { __typename?: 'Query', role: { __typename?: 'Role', id: string, label?: string | null, name?: string | null, adminRole?: boolean | null, enabledFeatures?: Array<{ __typename?: 'EnabledFeature', id: string, featureId: string }> | null } };

export type FetchRoleFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchRoleFeaturesQuery = { __typename?: 'Query', features: Array<{ __typename?: 'Feature', id: string, key: string, name?: string | null }> };

export type FetchRoleListQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchRoleListQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id: string, name?: string | null, label?: string | null, resourceType?: string | null }> };

export type TmCreateSaveViewMutationVariables = Exact<{
  input: CreateSavedViewInput;
}>;


export type TmCreateSaveViewMutation = { __typename?: 'Mutation', createSavedView?: { __typename?: 'CreateSavedViewPayload', errors?: Array<string> | null, savedView?: { __typename?: 'SavedView', config?: any | null, id: string, name: string, viewType: SavedViewEnum } | null } | null };

export type TmDeleteSavedViewMutationVariables = Exact<{
  input: DeleteResourceInput;
}>;


export type TmDeleteSavedViewMutation = { __typename?: 'Mutation', deleteResource?: { __typename: 'DeleteResourcePayload', result?: any | null } | null };

export type TmGetSavedViewListQueryVariables = Exact<{
  viewType: SavedViewEnum;
}>;


export type TmGetSavedViewListQuery = { __typename?: 'Query', savedViews?: Array<{ __typename: 'SavedView', id: string, name: string }> | null };

export type TmSelectedSavedViewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TmSelectedSavedViewQuery = { __typename?: 'Query', savedView?: { __typename: 'SavedView', id: string, config?: any | null } | null };

export type TmUpdateSavedViewMutationVariables = Exact<{
  input: UpdateSavedViewInput;
}>;


export type TmUpdateSavedViewMutation = { __typename?: 'Mutation', updateSavedView?: { __typename: 'UpdateSavedViewPayload', errors?: Array<string> | null, savedView?: { __typename: 'SavedView', id: string, config?: any | null } | null } | null };

export type FetchFilterProductsQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type FetchFilterProductsQuery = { __typename?: 'Query', filteredProducts: { __typename?: 'ProductCollection', collection: Array<{ __typename?: 'Product', id: string, name?: string | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean } } };

export type FetchFilterTankMonitorQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type FetchFilterTankMonitorQuery = { __typename?: 'Query', filteredTankMonitors: { __typename?: 'DeviceCollection', collection: Array<{ __typename?: 'Device', id: string, deviceId: string, deviceProvider?: string | null }>, metadata: { __typename?: 'TankMonitorMetaDataQuery', hasMore: boolean } } };

export type FetchTankMonitorCountQueryVariables = Exact<{
  filter?: InputMaybe<DeviceFilterInput>;
}>;


export type FetchTankMonitorCountQuery = { __typename?: 'Query', filteredTankMonitors: { __typename?: 'DeviceCollection', metadata: { __typename?: 'TankMonitorMetaDataQuery', totalCount?: number | null } } };

export type TmApproveOrCancelOrdersMutationVariables = Exact<{
  input: TmApproveOrCancelOrdersInput;
}>;


export type TmApproveOrCancelOrdersMutation = { __typename?: 'Mutation', tmApproveOrCancelOrders?: { __typename?: 'TmApproveOrCancelOrdersPayload', success: boolean, errors: Array<string> } | null };

export type CreateAutoOrderTankMonitorMutationVariables = Exact<{
  input: UpdateAttachedAssetInput;
}>;


export type CreateAutoOrderTankMonitorMutation = { __typename?: 'Mutation', updateAttachedAssets?: { __typename?: 'UpdateAttachedAssetPayload', attachedAsset?: { __typename?: 'AttachedAsset', id?: string | null, autoOrder?: boolean | null, topOffBy?: string | null, refuelTanksThreshold?: number | null, topOffQuantity?: number | null, purchaseOrder?: boolean | null, orderConfirmation?: boolean | null, orderFillPercentage?: number | null, preferenceAvailability?: Array<{ __typename?: 'AttachedAssetAvailability', day?: string | null, startTime?: string | null, endTime?: string | null, bestStartTime?: string | null, bestEndTime?: string | null, preferredStartTime?: string | null, preferredEndTime?: string | null }> | null } | null } | null };

export type DetachAttachedAssetMutationVariables = Exact<{
  input: DetachAssetInput;
}>;


export type DetachAttachedAssetMutation = { __typename?: 'Mutation', detachAttachedAsset?: { __typename?: 'DetachAssetPayload', attachedAsset?: { __typename?: 'AttachedAsset', id?: string | null } | null } | null };

export type FetchLinkedDataQueryVariables = Exact<{
  perPage?: InputMaybe<Scalars['Int']>;
  offSet?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<DeviceFilterInput>;
  sorter?: InputMaybe<Array<TankMonitorSorter> | TankMonitorSorter>;
}>;


export type FetchLinkedDataQuery = { __typename?: 'Query', filteredTankMonitors: { __typename?: 'DeviceCollection', collection: Array<{ __typename?: 'Device', id: string, name?: string | null, deviceId: string, deviceProvider?: string | null, tankCapacity?: string | null, reading?: any | null, attachedAsset?: any | null, consumptionSummary?: any | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, hubs?: Array<{ __typename?: 'Hub', name?: string | null }> | null } | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, hubs?: Array<{ __typename?: 'Hub', name?: string | null }> | null } | null, asset?: { __typename?: 'Asset', id: string, name?: string | null, tmLastDeliveredTimestamp?: number | null, tmLastDeliveredVolume?: number | null, lineOfServices?: Array<{ __typename?: 'LineOfService', name?: string | null }> | null, subscriptions?: Array<{ __typename?: 'Subscription', product: { __typename?: 'Product', name?: string | null } }> | null } | null }>, metadata: { __typename?: 'TankMonitorMetaDataQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FetchUnLinkedDataQueryVariables = Exact<{
  perPage?: InputMaybe<Scalars['Int']>;
  offSet?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<DeviceFilterInput>;
  sorter?: InputMaybe<Array<TankMonitorSorter> | TankMonitorSorter>;
}>;


export type FetchUnLinkedDataQuery = { __typename?: 'Query', filteredTankMonitors: { __typename?: 'DeviceCollection', collection: Array<{ __typename?: 'Device', id: string, name?: string | null, deviceId: string, deviceProvider?: string | null, tankCapacity?: string | null, reading?: any | null, attachedAsset?: any | null, consumptionSummary?: any | null, customer?: { __typename?: 'Customer', id: string, name?: string | null } | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null, asset?: { __typename?: 'Asset', id: string, name?: string | null, subscriptions?: Array<{ __typename?: 'Subscription', product: { __typename?: 'Product', name?: string | null } }> | null } | null }>, metadata: { __typename?: 'TankMonitorMetaDataQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FetchGroupByCustomerQueryVariables = Exact<{
  perPage?: InputMaybe<Scalars['Int']>;
  offSet?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<DynamicFiltersInput>;
}>;


export type FetchGroupByCustomerQuery = { __typename?: 'Query', tmFilteredCustomers: { __typename?: 'GroupedSubject', groupedCustomer?: Array<{ __typename?: 'GroupedCustomer', tankMonitorMetadata?: any | null, customers: Array<{ __typename?: 'Customer', id: string, name?: string | null }> }> | null, metadata?: { __typename?: 'TankMonitorMetaDataQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } | null } };

export type FetchGroupByShipToQueryVariables = Exact<{
  perPage?: InputMaybe<Scalars['Int']>;
  offSet?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<DynamicFiltersInput>;
}>;


export type FetchGroupByShipToQuery = { __typename?: 'Query', tmFilteredCustomerBranches: { __typename?: 'GroupedSubject', groupedCustomerBranch?: Array<{ __typename?: 'GroupedCustomerBranch', tankMonitorMetadata?: any | null, customerBranches: Array<{ __typename?: 'CustomerBranch', id: string, name?: string | null, customer?: { __typename?: 'Customer', name?: string | null } | null }> }> | null, metadata?: { __typename?: 'TankMonitorMetaDataQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } | null } };

export type FetchGroupByStatusQueryVariables = Exact<{
  filter?: InputMaybe<DynamicFiltersInput>;
}>;


export type FetchGroupByStatusQuery = { __typename?: 'Query', tmFilteredOrderGroups: { __typename?: 'GroupedSubject', groupedOrder?: Array<{ __typename?: 'GroupedOrder', orderGroupStatus: TankMonitorOrderEnum, metadata?: any | null }> | null, metadata?: { __typename?: 'TankMonitorMetaDataQuery', totalCount?: number | null, total_entries?: number | null } | null } };

export type TmCreateMultiOrderTopOffMutationVariables = Exact<{
  deviceIds: Array<Scalars['ID']> | Scalars['ID'];
  isSelectAll?: InputMaybe<Scalars['Boolean']>;
}>;


export type TmCreateMultiOrderTopOffMutation = { __typename?: 'Mutation', tmCreateMultiOrderTopOff?: { __typename?: 'TmCreateMultiOrderTopOffPayload', success: boolean, errors: Array<string> } | null };

export type FetchAssetDetailsForTankMonitorQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchAssetDetailsForTankMonitorQuery = { __typename?: 'Query', asset: { __typename?: 'Asset', id: string, tankSize?: string | null, name?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, erpId?: string | null } | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null } | null, subscriptions?: Array<{ __typename?: 'Subscription', id: string, product: { __typename?: 'Product', id: string, name?: string | null } }> | null } };

export type FetchTankMonitorCustomerBranchByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchTankMonitorCustomerBranchByIdQuery = { __typename?: 'Query', customerBranch: { __typename?: 'CustomerBranch', id: string, poNumber?: string | null, purchaseOrderType?: PurchaseOrderTypeEnum | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null, address?: any | null }> | null } };

export type FetchFilteredApplicableFeesForTankMonitorQueryVariables = Exact<{
  filter?: InputMaybe<ApplicableFeeFilter>;
}>;


export type FetchFilteredApplicableFeesForTankMonitorQuery = { __typename?: 'Query', filteredApplicableFees: { __typename?: 'ApplicableFeeCollection', collection: Array<{ __typename?: 'ApplicableFee', id: string, isDefault?: boolean | null, price?: number | null, quantity?: number | null, fee?: { __typename?: 'Fee', id: string, code?: string | null, name?: string | null, price?: number | null, deleted?: boolean | null, applicableType?: string | null } | null }> } };

export type FetchOrderHistoryQueryVariables = Exact<{
  perPage?: InputMaybe<Scalars['Int']>;
  offSet?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<DoliHistoryFilterInput>;
  sorter?: InputMaybe<Array<DeliveryOrderLineItemsSorter> | DeliveryOrderLineItemsSorter>;
}>;


export type FetchOrderHistoryQuery = { __typename?: 'Query', filteredDeliveryOrderLineItems: { __typename?: 'DeliveryOrderLineItemCollection', collection: Array<{ __typename?: 'DeliveryOrderLineItem', id: string, source: string, volume?: number | null, deliveryDateTimestamp?: number | null, product?: { __typename?: 'Product', shortName?: string | null } | null, asset?: { __typename?: 'Asset', name?: string | null } | null, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, orderGroupId?: number | null, customerBranch?: { __typename?: 'CustomerBranch', name?: string | null, customer?: { __typename?: 'Customer', name?: string | null } | null } | null, orderGroup?: { __typename?: 'OrderGroup', id: string, startOn?: any | null, status: string, createdAtTimestamp: number, completedOnTimestamp?: number | null } | null } | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null } } };

export type FetchSelectedGroupByDataQueryVariables = Exact<{
  perPage?: InputMaybe<Scalars['Int']>;
  offSet?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<DeviceFilterInput>;
  sorter?: InputMaybe<Array<TankMonitorSorter> | TankMonitorSorter>;
}>;


export type FetchSelectedGroupByDataQuery = { __typename?: 'Query', filteredTankMonitors: { __typename?: 'DeviceCollection', collection: Array<{ __typename?: 'Device', id: string, name?: string | null, deviceId: string, deviceProvider?: string | null, tankCapacity?: string | null, reading?: any | null, attachedAsset?: any | null, consumptionSummary?: any | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, hubs?: Array<{ __typename?: 'Hub', name?: string | null }> | null } | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, hubs?: Array<{ __typename?: 'Hub', name?: string | null }> | null } | null, asset?: { __typename?: 'Asset', id: string, name?: string | null, tmLastDeliveredTimestamp?: number | null, tmLastDeliveredVolume?: number | null, lineOfServices?: Array<{ __typename?: 'LineOfService', name?: string | null }> | null, subscriptions?: Array<{ __typename?: 'Subscription', product: { __typename?: 'Product', name?: string | null } }> | null } | null }>, metadata: { __typename?: 'TankMonitorMetaDataQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FetchTankMonitorTotalCountQueryVariables = Exact<{
  filter?: InputMaybe<DeviceFilterInput>;
}>;


export type FetchTankMonitorTotalCountQuery = { __typename?: 'Query', devicesSummary: any };

export type FetchUnlinkedAssetsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<AssetSorter> | AssetSorter>;
  customerIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  customerBranchId?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  filter?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  types?: InputMaybe<Array<AssetTypeEnum> | AssetTypeEnum>;
  unlinked?: InputMaybe<Scalars['Boolean']>;
}>;


export type FetchUnlinkedAssetsQuery = { __typename?: 'Query', filteredAssets: { __typename: 'AssetCollection', collection: Array<{ __typename: 'Asset', id: string, name?: string | null, erpId?: string | null, status?: string | null, customerBranch?: { __typename: 'CustomerBranch', id: string, name?: string | null, customer?: { __typename: 'Customer', id: string, name?: string | null } | null } | null, subscriptions?: Array<{ __typename: 'Subscription', id: string, product: { __typename: 'Product', id: string, name?: string | null } }> | null }>, metadata: { __typename: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type GetDeliveryOrderLineItemCsvForTmQueryVariables = Exact<{
  customerBranchId?: InputMaybe<Scalars['ID']>;
  assetId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  status?: InputMaybe<Array<StatusTypeEnum> | StatusTypeEnum>;
  isTankMonitor?: InputMaybe<Scalars['Boolean']>;
  deliveryType?: InputMaybe<DeliveryOrderLineItemDeliveryTypeEnum>;
}>;


export type GetDeliveryOrderLineItemCsvForTmQuery = { __typename?: 'Query', deliveryOrderLineItemCsv?: { __typename?: 'DoliCsv', fileName?: string | null, content?: string | null, error?: string | null } | null };

export type LinkAssetToTankMonitorMutationVariables = Exact<{
  input: Array<CreateAttachedAssetsInput> | CreateAttachedAssetsInput;
}>;


export type LinkAssetToTankMonitorMutation = { __typename?: 'Mutation', createAttachedAsset?: { __typename?: 'CreateAttachedAssetPayload', attachedAsset?: Array<{ __typename?: 'AttachedAsset', id?: string | null, assetId?: string | null, draftAssetId?: string | null, status?: string | null, consumptionCalculationDays?: number | null, autoOrder?: boolean | null, minThreshold?: number | null, maxThreshold?: number | null, orderFillPercentage?: number | null, orderConfirmation?: boolean | null, purchaseOrder?: boolean | null, asset?: { __typename?: 'Asset', id: string, subscriptions?: Array<{ __typename?: 'Subscription', product: { __typename?: 'Product', name?: string | null } }> | null } | null, customerBranch?: { __typename?: 'CustomerBranch', name?: string | null, address?: string | null } | null, customer?: { __typename?: 'Customer', name?: string | null } | null }> | null } | null };

export type UpdateLinkAssetToTmMutationVariables = Exact<{
  input: UpdateAttachedAssetInput;
}>;


export type UpdateLinkAssetToTmMutation = { __typename?: 'Mutation', updateAttachedAssets?: { __typename?: 'UpdateAttachedAssetPayload', attachedAsset?: { __typename?: 'AttachedAsset', id?: string | null, assetId?: string | null, draftAssetId?: string | null, status?: string | null, consumptionCalculationDays?: number | null, autoOrder?: boolean | null, minThreshold?: number | null, maxThreshold?: number | null, orderConfirmation?: boolean | null, orderFillPercentage?: number | null, purchaseOrder?: boolean | null, asset?: { __typename?: 'Asset', id: string, subscriptions?: Array<{ __typename?: 'Subscription', product: { __typename?: 'Product', name?: string | null } }> | null } | null, customerBranch?: { __typename?: 'CustomerBranch', name?: string | null, address?: string | null } | null, customer?: { __typename?: 'Customer', name?: string | null } | null } | null } | null };

export type FilteredTankMonitorDevicesQueryVariables = Exact<{
  perPage?: InputMaybe<Scalars['Int']>;
  offSet?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<DeviceFilterInput>;
  sorter?: InputMaybe<Array<TankMonitorSorter> | TankMonitorSorter>;
}>;


export type FilteredTankMonitorDevicesQuery = { __typename?: 'Query', filteredTankMonitors: { __typename?: 'DeviceCollection', collection: Array<{ __typename?: 'Device', id: string, name?: string | null, deviceId: string, deviceProvider?: string | null, tankCapacity?: string | null, reading?: any | null, attachedAsset?: any | null, consumptionSummary?: any | null }>, metadata: { __typename?: 'TankMonitorMetaDataQuery', totalCount?: number | null } } };

export type FetchDevicesSummaryQueryVariables = Exact<{
  filter?: InputMaybe<DeviceFilterInput>;
}>;


export type FetchDevicesSummaryQuery = { __typename?: 'Query', devicesSummary: any };

export type FetchFilteredAssetListForDropDownQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<AssetSorter> | AssetSorter>;
  customerIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  customerBranchId?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  filter?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  types?: InputMaybe<Array<AssetTypeEnum> | AssetTypeEnum>;
}>;


export type FetchFilteredAssetListForDropDownQuery = { __typename?: 'Query', filteredAssets: { __typename?: 'AssetCollection', collection: Array<{ __typename?: 'Asset', id: string, name?: string | null, erpId?: string | null, status?: string | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null } | null } | null, subscriptions?: Array<{ __typename?: 'Subscription', id: string, product: { __typename?: 'Product', id: string, name?: string | null } }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FetchOrderGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchOrderGroupQuery = { __typename?: 'Query', orderGroup: { __typename?: 'OrderGroup', id: string, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string } | null } };

export type FetchResourceByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  resource: ResourceFetchEnum;
}>;


export type FetchResourceByIdsQuery = { __typename?: 'Query', fetchResourceByIds: Array<{ __typename: 'Asset', id: string, name?: string | null, type?: string | null, category?: string | null, lastDeliveredTimestamp?: number | null, lastDeliveredVolume?: number | null, licensePlateNumber?: string | null, customer?: { __typename?: 'Customer', id: string, erpId?: string | null, name?: string | null, purchaseOrder?: boolean | null, address?: string | null, addressBooks?: Array<{ __typename?: 'AddressBook', id: string, name?: string | null }> | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null } | null, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, address?: string | null, purchaseOrder?: boolean | null, hubs?: Array<{ __typename?: 'Hub', id: string, name?: string | null }> | null } | null, subscriptions?: Array<{ __typename?: 'Subscription', product: { __typename?: 'Product', name?: string | null } }> | null } | { __typename: 'DeliveryAsset' }> };

export type FetchSyncAllStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchSyncAllStatusQuery = { __typename?: 'Query', syncAllStatus: any };

export type SyncAllTanksMutationVariables = Exact<{
  input: SyncAllInput;
}>;


export type SyncAllTanksMutation = { __typename?: 'Mutation', syncAllTanks?: { __typename?: 'SyncAllPayload', response?: string | null } | null };

export type CreateAttachedAssetMutationVariables = Exact<{
  input: Array<CreateAttachedAssetsInput> | CreateAttachedAssetsInput;
}>;


export type CreateAttachedAssetMutation = { __typename?: 'Mutation', createAttachedAsset?: { __typename?: 'CreateAttachedAssetPayload', attachedAsset?: Array<{ __typename?: 'AttachedAsset', id?: string | null, assetId?: string | null }> | null } | null };

export type TankMonitorDetachAttachedAssetMutationVariables = Exact<{
  input: DetachAssetInput;
}>;


export type TankMonitorDetachAttachedAssetMutation = { __typename?: 'Mutation', detachAttachedAsset?: { __typename?: 'DetachAssetPayload', attachedAsset?: { __typename?: 'AttachedAsset', id?: string | null, assetId?: string | null } | null } | null };

export type SyncIndividualTankMutationVariables = Exact<{
  input: SyncIndividualTankInput;
}>;


export type SyncIndividualTankMutation = { __typename?: 'Mutation', syncIndividualTank?: { __typename?: 'SyncIndividualTankPayload', response?: string | null } | null };

export type UpdateAttachedAssetMutationVariables = Exact<{
  input: UpdateAttachedAssetsInput;
}>;


export type UpdateAttachedAssetMutation = { __typename?: 'Mutation', updateAttachedAssets?: { __typename?: 'UpdateAttachedAssetPayload', attachedAsset?: { __typename?: 'AttachedAsset', id?: string | null, minThreshold?: number | null, assetId?: string | null } | null } | null };

export type FetchPreshiftChecklistsQueryVariables = Exact<{
  shiftId?: InputMaybe<Scalars['ID']>;
}>;


export type FetchPreshiftChecklistsQuery = { __typename?: 'Query', preshiftChecklists: Array<{ __typename?: 'ShiftChecklist', id: string, name?: string | null, position?: number | null, checkedCount?: number | null, totalItemsCount?: number | null, items?: Array<{ __typename?: 'ChecklistItems', id: string, name?: string | null, checked?: boolean | null, position?: number | null }> | null }> };

export type FetchAssetsDeviceQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type FetchAssetsDeviceQuery = { __typename?: 'Query', assetsDevice: Array<{ __typename?: 'Device', deviceId: string, deviceProvider?: string | null, reading?: any | null, attachedAsset?: any | null, tankCapacity?: string | null }> };

export type FetchFilteredV3TerminalQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  all?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<Array<TerminalSorter> | TerminalSorter>;
  isWarehouse?: InputMaybe<Scalars['Boolean']>;
}>;


export type FetchFilteredV3TerminalQuery = { __typename?: 'Query', filteredTerminals: { __typename?: 'TerminalCollection', collection: Array<{ __typename?: 'Terminal', id: string, active?: boolean | null, name?: string | null, erpId?: string | null, site?: { __typename?: 'Site', radius?: number | null, address?: any | null } | null, suppliers?: Array<{ __typename?: 'Supplier', id: string, supplierId?: string | null, name: string, active?: boolean | null, loadingAccounts?: Array<{ __typename?: 'LoadingAccount', id: string, carrierCustomerCode?: string | null, loadingNumber?: string | null, supplierCode?: string | null, name?: string | null, supplierId?: string | null }> | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FilteredOrderGroupForOrderHistoryV2QueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<OrderGroupFilter>;
  sorter?: InputMaybe<Array<OrderGroupSorter> | OrderGroupSorter>;
}>;


export type FilteredOrderGroupForOrderHistoryV2Query = { __typename?: 'Query', filteredOrderGroups: { __typename?: 'OrderGroupCollection', collection: Array<{ __typename?: 'OrderGroup', id: string, status: string, shift?: { __typename?: 'Shift', id: string, deliveryTruck?: { __typename?: 'DeliveryAsset', id: string, name?: string | null } | null } | null, worker?: { __typename?: 'Worker', name?: string | null } | null, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, status: string, deliveryDateTimestamp?: number | null, orderedProductsSummary?: Array<{ __typename?: 'DeliveryOrderOrderedProductsSummary', totalDeliveredVolume: number, totalRequestedVolume: number, productId?: string | null }> | null } | null }> } };

export type FetchPreferredProductTerminalQueryVariables = Exact<{
  customerBranchId: Scalars['ID'];
}>;


export type FetchPreferredProductTerminalQuery = { __typename?: 'Query', customerBranch: { __typename?: 'CustomerBranch', id: string, name?: string | null, preferredProductTerminals?: Array<{ __typename?: 'PreferredProductTerminal', id: string, isDefault?: boolean | null, terminal: { __typename?: 'Terminal', id: string, active?: boolean | null, isWarehouse?: boolean | null, name?: string | null, site?: { __typename?: 'Site', address?: any | null } | null, suppliers?: Array<{ __typename?: 'Supplier', id: string, name: string, supplierId?: string | null, active?: boolean | null, loadingAccounts?: Array<{ __typename?: 'LoadingAccount', carrierCustomerCode?: string | null, id: string, label?: string | null, loadingNumber?: string | null, name?: string | null, supplierCode?: string | null, supplierId?: string | null }> | null }> | null }, product: { __typename?: 'Product', id: string, name?: string | null, active: boolean, soldAs?: string | null }, preferredProductTerminalSuppliers?: Array<{ __typename?: 'PreferredProductTerminalSupplier', id: string, priority: number, supplier: { __typename?: 'Supplier', id: string, name: string, supplierId?: string | null, loadingAccounts?: Array<{ __typename?: 'LoadingAccount', carrierCustomerCode?: string | null, id: string, label?: string | null, loadingNumber?: string | null, name?: string | null, supplierCode?: string | null, supplierId?: string | null }> | null } }> | null }> | null } };

export type FetchFilteredOrderGroupsQueryVariables = Exact<{
  filter?: InputMaybe<OrderGroupFilter>;
}>;


export type FetchFilteredOrderGroupsQuery = { __typename?: 'Query', filteredOrderGroups: { __typename?: 'OrderGroupCollection', collection: Array<{ __typename?: 'OrderGroup', id: string, status: string, customerBranch?: { __typename?: 'CustomerBranch', id: string, name?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, status?: number | null } | null } | null, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, type?: string | null, orderLinks?: Array<{ __typename?: 'OrderLink', id: string, loadingOrder?: { __typename?: 'LoadingOrder', id: string, terminal?: { __typename?: 'Terminal', id: string, name?: string | null } | null } | null }> | null } | null, extractionOrder?: { __typename?: 'ExtractionOrder', id: string, type?: string | null, orderLinks?: Array<{ __typename?: 'OrderLink', id: string, loadingOrder?: { __typename?: 'LoadingOrder', id: string, terminal?: { __typename?: 'Terminal', id: string, name?: string | null } | null } | null }> | null } | null, recurrenceData?: { __typename?: 'RecurrenceData', lastDelivery?: string | null, nextDate?: string | null, recurrence: { __typename?: 'RecurrenceOrderGroup', recurrenceType: Recurrence, recurrenceUntil?: string | null } } | null }>, metadata: { __typename?: 'MetaQuery', totalCount?: number | null } } };

export type FetchFilteredTerminalQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  all?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<Array<TerminalSorter> | TerminalSorter>;
  isWarehouse?: InputMaybe<Scalars['Boolean']>;
}>;


export type FetchFilteredTerminalQuery = { __typename?: 'Query', filteredTerminals: { __typename?: 'TerminalCollection', collection: Array<{ __typename?: 'Terminal', id: string, active?: boolean | null, name?: string | null, erpId?: string | null, site?: { __typename?: 'Site', radius?: number | null, address?: any | null } | null, products?: Array<{ __typename?: 'Product', id: string, name?: string | null, soldAs?: string | null, productType: string, deliveryType?: string | null, productCategory?: { __typename?: 'ProductCategory', id: string } | null }> | null, suppliers?: Array<{ __typename?: 'Supplier', id: string, supplierId?: string | null, name: string, active?: boolean | null, loadingAccounts?: Array<{ __typename?: 'LoadingAccount', id: string, carrierCustomerCode?: string | null, loadingNumber?: string | null, destinationState?: string | null, supplierCode?: string | null, name?: string | null, supplierId?: string | null }> | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null, total_entries?: number | null } } };

export type FetchPackageProductQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ProductFilter>;
}>;


export type FetchPackageProductQuery = { __typename?: 'Query', filteredProducts: { __typename?: 'ProductCollection', metadata: { __typename?: 'MetaQuery', hasMore: boolean }, collection: Array<{ __typename?: 'Product', id: string, unit?: string | null, code?: string | null, name?: string | null, erpId?: string | null, soldAs?: string | null, active: boolean, brand?: { __typename?: 'Brand', id: string, name?: string | null } | null }> } };

export type FetchProcessingRecurrenceStatusForUpdateOrderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchProcessingRecurrenceStatusForUpdateOrderQuery = { __typename?: 'Query', orderGroup: { __typename?: 'OrderGroup', processingRecurrence?: boolean | null } };

export type FetchTotalCustomerRequestedVolumeQueryVariables = Exact<{
  customerId: Scalars['ID'];
  fromDate?: InputMaybe<Scalars['Int']>;
  toDate?: InputMaybe<Scalars['Int']>;
}>;


export type FetchTotalCustomerRequestedVolumeQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', totalRequestedVolume?: any | null } };

export type FilteredOrderGroupForOrderHistoryQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<OrderGroupFilter>;
  sorter?: InputMaybe<Array<OrderGroupSorter> | OrderGroupSorter>;
}>;


export type FilteredOrderGroupForOrderHistoryQuery = { __typename?: 'Query', filteredOrderGroups: { __typename?: 'OrderGroupCollection', collection: Array<{ __typename?: 'OrderGroup', id: string, status: string, shift?: { __typename?: 'Shift', id: string, deliveryTruck?: { __typename?: 'DeliveryAsset', id: string, name?: string | null } | null } | null, worker?: { __typename?: 'Worker', name?: string | null } | null, deliveryOrder?: { __typename?: 'DeliveryOrder', id: string, status: string, deliveryDateTimestamp?: number | null, orderedProductsSummary?: Array<{ __typename?: 'DeliveryOrderOrderedProductsSummary', totalDeliveredVolume: number, totalRequestedVolume: number, productId?: string | null }> | null } | null }> } };

export type CreateOrderQuoteMutationVariables = Exact<{
  input: CreateQuoteInput;
}>;


export type CreateOrderQuoteMutation = { __typename?: 'Mutation', createOrderQuote?: { __typename?: 'CreateQuotePayload', error?: string | null, response?: { __typename?: 'Quote', fileUrl?: string | null, productSummary?: Array<{ __typename?: 'ProductDetail', productId?: string | null, topOff?: boolean | null, error?: string | null, productPricingDetails?: { __typename?: 'ItemsDetail', name: string, rate: number, quantity: number, type: string, total: number, rateUnit?: string | null } | null, applicableTaxDetails?: Array<{ __typename?: 'TaxDetail', name: string, erpId?: string | null, rate: number, quantity: number, rateUnit?: string | null, type: string, total: number }> | null }> | null, applicableFeeDetails?: Array<{ __typename?: 'ItemsDetail', name: string, rate: number, quantity: number, rateUnit?: string | null, type: string, total: number }> | null } | null } | null };

export type FetchAssetProductsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchAssetProductsQuery = { __typename?: 'Query', asset: { __typename?: 'Asset', id: string, name?: string | null, fuelTypeProducts?: Array<{ __typename?: 'Product', id: string, code?: string | null, colorCode?: string | null, name?: string | null, longDescription?: string | null, productType: string, active: boolean }> | null } };

export type CreateSavedViewMutationVariables = Exact<{
  input: CreateSavedViewInput;
}>;


export type CreateSavedViewMutation = { __typename?: 'Mutation', createSavedView?: { __typename?: 'CreateSavedViewPayload', errors?: Array<string> | null, savedView?: { __typename?: 'SavedView', config?: any | null, id: string, name: string, viewType: SavedViewEnum } | null } | null };

export type FetchCarriersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  customFilter?: InputMaybe<CcTenantFilter>;
}>;


export type FetchCarriersQuery = { __typename?: 'Query', filteredCcTenants?: { __typename?: 'CcTenantCollection', collection: Array<{ __typename?: 'CcTenant', name: string, id: string }> } | null };

export type FetchDriverGroupQueryVariables = Exact<{
  filter?: InputMaybe<GroupFilter>;
  sorter?: InputMaybe<Array<GroupSorter> | GroupSorter>;
}>;


export type FetchDriverGroupQuery = { __typename?: 'Query', filteredGroups: { __typename?: 'GroupCollection', collection: Array<{ __typename?: 'Group', id: string, name: string, groupMemberships?: Array<{ __typename?: 'GroupMembership', groupable?: { __typename?: 'Customer' } | { __typename?: 'Driver', id: string, name?: string | null } | { __typename?: 'UnknownGroupable' } | { __typename?: 'User' } | null }> | null }> } };

export type FetchDriversQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  all?: InputMaybe<Scalars['String']>;
  sorter?: InputMaybe<Array<DriverSorter> | DriverSorter>;
  driverTypes?: InputMaybe<Array<DriverTypeEnum> | DriverTypeEnum>;
}>;


export type FetchDriversQuery = { __typename?: 'Query', filteredDrivers: { __typename?: 'DriverCollection', collection: Array<{ __typename?: 'Driver', id: string, name?: string | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null } } };

export type FetchFilteredOrderWellQueryVariables = Exact<{
  filter?: InputMaybe<OrderWellFilter>;
}>;


export type FetchFilteredOrderWellQuery = { __typename?: 'Query', filteredOrderWell: { __typename?: 'OrderWellCollection', collection: Array<{ __typename?: 'OrderWell', id: string, mainOrderGroupId?: string | null, orderId: string, type?: string | null, shipToName?: string | null }> } };

export type OrderWellGroupSummaryQueryVariables = Exact<{
  groupBy: OrderWellGroupByEnum;
  filter?: InputMaybe<OrderWellFilter>;
}>;


export type OrderWellGroupSummaryQuery = { __typename?: 'Query', orderWellGroupingSummary: Array<{ __typename?: 'OrderWellGroupingSummary', count: number, groupValue?: string | null, groupValueId?: string | null }> };

export type FetchSavedViewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchSavedViewQuery = { __typename?: 'Query', savedView?: { __typename?: 'SavedView', id: string, config?: any | null } | null };

export type FetchSavedViewsQueryVariables = Exact<{
  viewType: SavedViewEnum;
}>;


export type FetchSavedViewsQuery = { __typename?: 'Query', savedViews?: Array<{ __typename?: 'SavedView', id: string, name: string, position?: number | null, pinned: boolean, preset: boolean, isDefault?: boolean | null }> | null };

export type FetchTagsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<TagFilter>;
  sorter?: InputMaybe<Array<BaseSorter> | BaseSorter>;
}>;


export type FetchTagsQuery = { __typename?: 'Query', filteredTags: { __typename?: 'TagCollection', collection: Array<{ __typename?: 'Tag', id: string, name: string, status?: StatusStringEnum | null, tagType?: string | null, colorCode?: string | null, iconName?: string | null }> } };

export type FetchTruckQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  customFilter?: InputMaybe<DeliveryAssetFilter>;
  sorter?: InputMaybe<Array<BaseSorter> | BaseSorter>;
}>;


export type FetchTruckQuery = { __typename?: 'Query', filteredDeliveryAssets: { __typename?: 'DeliveryAssetCollection', collection: Array<{ __typename?: 'DeliveryAsset', id: string, name?: string | null, category?: string | null, assetProductCategories?: Array<{ __typename?: 'AssetProductCategory', id: string, product?: { __typename?: 'Product', id: string, name?: string | null } | null }> | null, compartments?: Array<{ __typename?: 'Compartment', id: string, length?: number | null }> | null }> } };

export type UpdatePositionSaveViewsMutationVariables = Exact<{
  input: CreateOrUpdateConfigViewInput;
}>;


export type UpdatePositionSaveViewsMutation = { __typename?: 'Mutation', configView?: { __typename?: 'CreateOrUpdateConfigViewPayload', errors?: Array<string> | null, savedViews?: Array<{ __typename?: 'SavedView', id: string, name: string, position?: number | null, preset: boolean, pinned: boolean, isDefault?: boolean | null }> | null } | null };

export type UpdateSavedViewMutationVariables = Exact<{
  input: UpdateSavedViewInput;
}>;


export type UpdateSavedViewMutation = { __typename?: 'Mutation', updateSavedView?: { __typename?: 'UpdateSavedViewPayload', errors?: Array<string> | null, savedView?: { __typename?: 'SavedView', id: string, config?: any | null } | null } | null };

export type FetchFilteredAssetsQueryVariables = Exact<{
  customFilter?: InputMaybe<AssetFilter>;
  sorter?: InputMaybe<Array<AssetSorter> | AssetSorter>;
}>;


export type FetchFilteredAssetsQuery = { __typename?: 'Query', filteredAssets: { __typename?: 'AssetCollection', collection: Array<{ __typename?: 'Asset', id: string, name?: string | null, category?: string | null, licensePlateNumber?: string | null, compartments?: Array<{ __typename?: 'Compartment', id: string, length?: number | null, name?: string | null }> | null }>, metadata: { __typename?: 'MetaQuery', hasMore: boolean, totalCount?: number | null } } };

export type DeleteBolAdjustmentMutationVariables = Exact<{
  input: DeleteResourceInput;
}>;


export type DeleteBolAdjustmentMutation = { __typename?: 'Mutation', deleteResource?: { __typename?: 'DeleteResourcePayload', clientMutationId?: string | null, result?: any | null } | null };

export type PushToAgvanceMutationVariables = Exact<{
  vendorName: VendorNameEnum;
  shiftIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type PushToAgvanceMutation = { __typename?: 'Mutation', accountingAsync?: { __typename?: 'AccountingAsyncPayload', success?: boolean | null } | null };

export type PushToBookworksMutationVariables = Exact<{
  vendorName: VendorNameEnum;
  shiftIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type PushToBookworksMutation = { __typename?: 'Mutation', accountingAsync?: { __typename?: 'AccountingAsyncPayload', success?: boolean | null } | null };

export type PushToHuntandSonsMutationVariables = Exact<{
  vendorName: VendorNameEnum;
  shiftIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type PushToHuntandSonsMutation = { __typename?: 'Mutation', accountingAsync?: { __typename?: 'AccountingAsyncPayload', success?: boolean | null } | null };

export type FetchFilteredOrderGroupsBolLinkQueryVariables = Exact<{
  fromTimestamp?: InputMaybe<Scalars['Int']>;
  toTimestamp?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<OrderGroupTypeEnum>;
  productName?: InputMaybe<Scalars['String']>;
  isExtractionOrder?: InputMaybe<Scalars['Boolean']>;
}>;


export type FetchFilteredOrderGroupsBolLinkQuery = { __typename?: 'Query', filteredOrderGroups: { __typename?: 'OrderGroupCollection', collection: Array<{ __typename?: 'OrderGroup', id: string, startOnTimestamp?: number | null, startedOnTimestamp?: number | null, status: string, worker?: { __typename?: 'Worker', name?: string | null } | null, extractionOrder?: { __typename?: 'ExtractionOrder', id: string, type?: string | null, lineItems: Array<{ __typename?: 'ExtractionOrderLineItem', asset?: { __typename?: 'Asset', id: string, licensePlateNumber?: string | null, name?: string | null } | null }>, orderedProductsSummary?: Array<{ __typename?: 'ExtractionOrderOrderedProductsSummary', productId?: string | null, totalExtractedVolume: number, totalRequestedVolume: number }> | null } | null }> } };

export type ExtractionOrderFragmentFragment = { __typename?: 'ExtractionOrder', id: string, type?: string | null, lineItems: Array<{ __typename?: 'ExtractionOrderLineItem', asset?: { __typename?: 'Asset', id: string, licensePlateNumber?: string | null, name?: string | null } | null }>, orderedProductsSummary?: Array<{ __typename?: 'ExtractionOrderOrderedProductsSummary', productId?: string | null, totalExtractedVolume: number, totalRequestedVolume: number }> | null };

export type AdjustmentInventoryMutationVariables = Exact<{
  input: AdjustInventoryInput;
}>;


export type AdjustmentInventoryMutation = { __typename?: 'Mutation', adjustInventory?: { __typename?: 'AdjustInventoryPayload', shift?: { __typename?: 'Shift', id: string, orderGroups?: Array<{ __typename?: 'OrderGroup', deliveryOrder?: { __typename?: 'DeliveryOrder', id: string } | null }> | null, adjustedInventories?: Array<{ __typename?: 'InventoryAdjustment', id: string, data?: any | null, product: { __typename?: 'Product', id: string, name?: string | null } }> | null } | null } | null };

export type FetchAdjustmnetDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchAdjustmnetDetailsQuery = { __typename?: 'Query', fetchOrderGroup: { __typename?: 'OrderGroupAdjustment', id: string, lineItems?: any | null } };

export type FetchFilteredDeliveryAssetsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchFilteredDeliveryAssetsQuery = { __typename?: 'Query', filteredDeliveryAssets: { __typename?: 'DeliveryAssetCollection', collection: Array<{ __typename?: 'DeliveryAsset', id: string, name?: string | null, category?: string | null, enableZone?: boolean | null, compartments?: Array<{ __typename?: 'Compartment', id: string, length?: number | null, name?: string | null }> | null }> } };

export type SuppliersForCriteriaQueryVariables = Exact<{
  terminalId: Scalars['ID'];
  state: Scalars['String'];
  productCategoryId: Scalars['ID'];
}>;


export type SuppliersForCriteriaQuery = { __typename?: 'Query', suppliersForCriteria: Array<{ __typename?: 'Supplier', id: string, name: string, supplierId?: string | null, active?: boolean | null, loadingAccounts?: Array<{ __typename?: 'LoadingAccount', id: string, loadingNumber?: string | null, carrierCustomerCode?: string | null, name?: string | null, label?: string | null, destinationState?: string | null, isAutoSelected?: boolean | null, matchScore: number }> | null }> };

export type UpdateTransferOrderAssetsMutationVariables = Exact<{
  input: UpdateTransferOrderAssetsInput;
}>;


export type UpdateTransferOrderAssetsMutation = { __typename?: 'Mutation', updateTransferOrderAssets?: { __typename?: 'UpdateTransferOrderAssetsPayload', orderGroup: { __typename?: 'OrderGroup', id: string } } | null };

export type AssetWithProductCategoryNamesFragment = { __typename?: 'Asset', assetProductCategories?: Array<{ __typename?: 'AssetProductCategory', id: string, networkName?: string | null, networkNumber?: string | null, productCategory?: { __typename?: 'ProductCategory', id: string, name?: string | null } | null }> | null };

export type AssetWithProductNamesFragment = { __typename?: 'Asset', subscriptions?: Array<{ __typename?: 'Subscription', id: string, product: { __typename?: 'Product', id: string, name?: string | null } }> | null };

export type DeleteResourceMutationVariables = Exact<{
  input: DeleteResourceInput;
}>;


export type DeleteResourceMutation = { __typename?: 'Mutation', deleteResource?: { __typename?: 'DeleteResourcePayload', result?: any | null } | null };

export const OrderGroupFragmentDoc = gql`
    fragment orderGroup on OrderGroup {
  id
  status
  startOnTimestamp
  toStartOnTimestamp
  completedOnTimestamp
  poNumber
  priority
  movementOrder {
    id
    orderType
    requestedProducts {
      name
    }
    assetMovementLocation {
      id
      lat
      lng
      orderGroupId
    }
    orderGroup {
      id
      driver {
        id
        name
      }
      user {
        id
        name
      }
      worker {
        id
        name
      }
    }
    asset {
      id
      name
    }
    fromCustomerBranch {
      id
      name
      customer {
        name
      }
    }
    toCustomerBranch {
      id
      name
      customer {
        name
      }
    }
    hub {
      id
      name
      address
    }
    product {
      name
    }
    orderNotes
    requestedTankSize
    requestedTankType
    assignedTankSize
    assignedTankType
  }
}
    `;
export const DeliveryOrderGroupPandaBoxFragmentFragmentDoc = gql`
    fragment deliveryOrderGroupPandaBoxFragment on OrderGroup {
  id
  startOnTimestamp
  toStartOnTimestamp
  startedOnTimestamp
  completedOnTimestamp
  ratePrecision
  amountPrecision
  creatable {
    __typename
    ... on User {
      name
      email
    }
  }
  productLineOfServices
  createdAtTimestamp
  carrierNumber
  outsideAvailability
  paymentTypeName
  purchaseOrderType
  purchaseOrderRequired
  mainOrderGroupId
  ccOrderGroupId
  mainOrderGroupTenant
  ccDeliveryAddress
  ccTenantId
  ccTenant {
    id
    name
    secondaryEmails
    carrierTenant {
      adminUsers {
        email
      }
    }
  }
  ticketId
  poNumber
  shiftId
  status
  priority
  driver {
    id
    name
    email
    isCarrier
  }
  hub {
    id
    name
    address
  }
  lineOfService {
    id
    name
    shortName
  }
  shift {
    state
    deliveryTruck {
      id
      name
    }
  }
  invoiceNumbers
  invoices {
    id
    status
    invoiceNumber
    createdOn
  }
  enableRebill
  pandaDocuments {
    id
    blobFileUrl
    fileUrl
    fileName
  }
  orderGroupTaxes {
    id
    total
  }
}
    `;
export const DeliveryOrderGroupFragmentFragmentDoc = gql`
    fragment deliveryOrderGroupFragment on OrderGroup {
  id
  startOnTimestamp
  toStartOnTimestamp
  startedOnTimestamp
  completedOnTimestamp
  ratePrecision
  amountPrecision
  creatable {
    __typename
    ... on User {
      name
      email
    }
  }
  productLineOfServices
  createdAtTimestamp
  carrierNumber
  outsideAvailability
  paymentTypeName
  purchaseOrderType
  purchaseOrderRequired
  mainOrderGroupId
  ccOrderGroupId
  mainOrderGroupTenant
  ccDeliveryAddress
  ccTenantId
  ccTenant {
    id
    name
    secondaryEmails
    carrierTenant {
      adminUsers {
        email
      }
    }
  }
  ticketId
  poNumber
  shiftId
  status
  priority
  driver {
    id
    name
    email
    isCarrier
  }
  hub {
    id
    name
    address
  }
  lineOfService {
    id
    name
    shortName
  }
  shift {
    state
    deliveryTruck {
      id
      name
    }
  }
  invoiceNumbers
  invoices {
    id
    status
    invoiceNumber
    createdOn
  }
  enableRebill
  pandaDocuments {
    id
    blobFileUrl
    fileUrl
    fileName
  }
  orderGroupTaxes {
    id
    total
  }
}
    `;
export const ResourcePricingPopOverFragmentFragmentDoc = gql`
    fragment ResourcePricingPopOverFragment on ResourcePricing {
  id
  resourceId
  applicableTaxes {
    tax {
      name
    }
  }
  applicableMargins {
    margin {
      name
    }
  }
  discount
  discountUnit
  rateType {
    name
    description
  }
  pocName
  pocEmail
  pocPhone
  productCategories {
    name
  }
}
    `;
export const CustomerAssetDataFragmentDoc = gql`
    fragment customerAssetData on Asset {
  id
  name
  licensePlateNumber
  category
  fuelCategories
  color
  erpId
  make
  model
  status
  useInDelivery
  isRunningFuelOffsetAsset
  isTransport
  year
  qrCodeText
  barcodeText
  netsuiteId
  data
  type
  lat
  lng
  margin
  installDate
  createdBy {
    name
  }
  rfidCode
  enableZone
  noOfZone
  trackInventory
  lastActiveTenantId
  lastActiveTenantName
  estimatedGallonsPerMonth
  taggings {
    id
    tag {
      id
      name
      colorCode
      iconName
      description
    }
  }
  assetMovementLocation {
    id
    lat
    lng
    updatable {
      ... on User {
        id
        name
      }
      ... on Worker {
        id
        name
      }
    }
    updatedAt
  }
  tankType
  tankSize
  costOfTank
  marketValue
  purchasedOn
  lineOfServices {
    id
    nameWithAncestors
  }
  assignedPandaBox {
    id
    name
    imeiNumber
    version
    pandaBoxAssets {
      id
      active
      pandaBox {
        id
      }
    }
    pandaBoxMeters {
      id
      meterModel
      meterName
      lcpNode
      productCategory {
        id
        name
      }
    }
  }
  assetProductCategories {
    id
    networkName
    networkNumber
    registerModel
    productCategory {
      id
      name
    }
  }
  subscriptions(showAll: true) {
    id
    status
    product {
      id
      name
      erpId
      productCategory {
        id
        name
      }
    }
  }
  customer {
    id
    name
    tankReadingThreshold
    hubs {
      id
      name
    }
  }
  customerBranch {
    id
    name
    address
    hubs {
      id
      name
    }
    site {
      lat
      lng
    }
  }
  terminals {
    id
    name
  }
  pandaDocuments {
    id
    documentType
    externalFileData {
      id
      contentType
      filename
      url
    }
  }
  fuelTypeProducts {
    id
    name
  }
  compartments {
    id
    name
    diameter
    erpId
    length
    alignment
    capacities {
      id
      fuelType
      value
      unit
      usablePercentage
      productCategory {
        id
        name
      }
    }
  }
  hubResources {
    id
    hub {
      id
      name
    }
  }
  assetsPeripherals {
    id
    assetId
    peripheralId
    assetsPeripheralsRecords {
      id
      peripheralAttributeId
      assetsPeripheralId
      value
      fileUrl
    }
  }
  routingVehicleType
}
    `;
export const SelfCustomerAssetDataFragmentDoc = gql`
    fragment selfCustomerAssetData on Asset {
  id
  name
  licensePlateNumber
  category
  fuelCategories
  color
  erpId
  make
  model
  status
  useInDelivery
  isRunningFuelOffsetAsset
  isTransport
  year
  qrCodeText
  barcodeText
  netsuiteId
  data
  type
  lat
  lng
  margin
  rfidCode
  enableZone
  noOfZone
  trackInventory
  lastActiveTenantId
  lastActiveTenantName
  estimatedGallonsPerMonth
  taggings {
    id
    tag {
      id
      name
      colorCode
      iconName
      description
    }
  }
  assetMovementLocation {
    id
    lat
    lng
    updatable {
      ... on User {
        id
        name
      }
      ... on Worker {
        id
        name
      }
    }
    updatedAt
  }
  tankType
  tankSize
  costOfTank
  marketValue
  purchasedOn
  lineOfServices {
    id
    nameWithAncestors
  }
  assignedPandaBox {
    id
    name
    imeiNumber
    version
    pandaBoxAssets {
      id
      active
      pandaBox {
        id
      }
    }
    pandaBoxMeters {
      id
      meterModel
      meterName
      lcpNode
      productCategory {
        id
        name
      }
    }
  }
  assetProductCategories {
    id
    networkName
    networkNumber
    registerModel
    product {
      id
      name
    }
  }
  customer {
    id
    name
    tankReadingThreshold
    hubs {
      id
      name
    }
  }
  customerBranch {
    id
    name
    address
    hubs {
      id
      name
    }
    site {
      lat
      lng
    }
  }
  terminals {
    id
    name
  }
  pandaDocuments {
    id
    documentType
    externalFileData {
      id
      contentType
      filename
      url
    }
  }
  fuelTypeProducts {
    id
    name
  }
  compartments {
    id
    name
    diameter
    erpId
    length
    alignment
    capacities {
      id
      fuelType
      value
      unit
      usablePercentage
      productCategory {
        id
        name
      }
    }
  }
  hubResources {
    id
    hub {
      id
      name
    }
  }
  assetsPeripherals {
    id
    assetId
    peripheralId
    assetsPeripheralsRecords {
      id
      peripheralAttributeId
      assetsPeripheralId
      value
      fileUrl
    }
  }
  routingVehicleType
  productSubscriptions {
    id
    status
    product {
      id
      name
      productCategory {
        id
        name
      }
    }
    compartment {
      id
      name
      erpId
      capacities {
        id
        unit
        value
        fuelType
      }
    }
  }
}
    `;
export const DeliveryOrderGroupFragmentDoc = gql`
    fragment deliveryOrderGroup on OrderGroup {
  id
  startOnTimestamp
  toStartOnTimestamp
  startedOnTimestamp
  outsideAvailability
  completedOnTimestamp
  createdAtTimestamp
  carrierNumber
  purchaseOrderType
  purchaseOrderRequired
  ccTenantId
  ccTenant {
    id
    name
  }
  ticketId
  poNumber
  shiftId
  status
  priority
  driver {
    id
    name
    isCarrier
  }
  hub {
    id
    name
    address
  }
  lineOfService {
    id
    name
    shortName
  }
  deliveryOrder {
    deliveryInstruction
  }
  shift {
    state
  }
}
    `;
export const ExtractionOrderFragmentFragmentDoc = gql`
    fragment extractionOrderFragment on ExtractionOrder {
  id
  type
  lineItems {
    asset {
      id
      licensePlateNumber
      name
    }
  }
  orderedProductsSummary {
    productId
    totalExtractedVolume
    totalRequestedVolume
  }
}
    `;
export const AssetWithProductCategoryNamesFragmentDoc = gql`
    fragment AssetWithProductCategoryNames on Asset {
  assetProductCategories {
    id
    networkName
    networkNumber
    productCategory {
      id
      name
    }
  }
}
    `;
export const AssetWithProductNamesFragmentDoc = gql`
    fragment AssetWithProductNames on Asset {
  subscriptions {
    id
    product {
      id
      name
    }
  }
}
    `;
export const BulkEmailToDriverSummaryDocument = gql`
    query BulkEmailToDriverSummary($orderGroupIds: [ID!]!) {
  bulkEmailSummary(orderGroupIds: $orderGroupIds) {
    driverEmail
    driverName
    orderGroupId
    deliveryOrder {
      customer
      customerBranch
      plannedAt
      toPlannedAt
      deliveryInstruction
      deliveryOrderLineItems {
        productName
        quantity
        assetName
      }
    }
    loadingOrderDetails {
      terminal
      terminalAddress
      loadingInstruction
      isSplitOrder
      orderGroupId
      loadingOrderLineItems {
        productName
        quantity
        preferredSuppliers {
          carrierCustomerCode
          loadingAccountNumber
          supplierName
        }
      }
    }
  }
}
    `;

/**
 * __useBulkEmailToDriverSummaryQuery__
 *
 * To run a query within a React component, call `useBulkEmailToDriverSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkEmailToDriverSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkEmailToDriverSummaryQuery({
 *   variables: {
 *      orderGroupIds: // value for 'orderGroupIds'
 *   },
 * });
 */
export function useBulkEmailToDriverSummaryQuery(baseOptions: Apollo.QueryHookOptions<BulkEmailToDriverSummaryQuery, BulkEmailToDriverSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkEmailToDriverSummaryQuery, BulkEmailToDriverSummaryQueryVariables>(BulkEmailToDriverSummaryDocument, options);
      }
export function useBulkEmailToDriverSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkEmailToDriverSummaryQuery, BulkEmailToDriverSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkEmailToDriverSummaryQuery, BulkEmailToDriverSummaryQueryVariables>(BulkEmailToDriverSummaryDocument, options);
        }
export type BulkEmailToDriverSummaryQueryHookResult = ReturnType<typeof useBulkEmailToDriverSummaryQuery>;
export type BulkEmailToDriverSummaryLazyQueryHookResult = ReturnType<typeof useBulkEmailToDriverSummaryLazyQuery>;
export type BulkEmailToDriverSummaryQueryResult = Apollo.QueryResult<BulkEmailToDriverSummaryQuery, BulkEmailToDriverSummaryQueryVariables>;
export const SendBulkOrderEmailToDriverDocument = gql`
    mutation SendBulkOrderEmailToDriver($input: SendBulkOrderEmailToDriverInput!) {
  sendBulkOrderEmailToDriver(input: $input) {
    success
  }
}
    `;
export type SendBulkOrderEmailToDriverMutationFn = Apollo.MutationFunction<SendBulkOrderEmailToDriverMutation, SendBulkOrderEmailToDriverMutationVariables>;

/**
 * __useSendBulkOrderEmailToDriverMutation__
 *
 * To run a mutation, you first call `useSendBulkOrderEmailToDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBulkOrderEmailToDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBulkOrderEmailToDriverMutation, { data, loading, error }] = useSendBulkOrderEmailToDriverMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendBulkOrderEmailToDriverMutation(baseOptions?: Apollo.MutationHookOptions<SendBulkOrderEmailToDriverMutation, SendBulkOrderEmailToDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendBulkOrderEmailToDriverMutation, SendBulkOrderEmailToDriverMutationVariables>(SendBulkOrderEmailToDriverDocument, options);
      }
export type SendBulkOrderEmailToDriverMutationHookResult = ReturnType<typeof useSendBulkOrderEmailToDriverMutation>;
export type SendBulkOrderEmailToDriverMutationResult = Apollo.MutationResult<SendBulkOrderEmailToDriverMutation>;
export type SendBulkOrderEmailToDriverMutationOptions = Apollo.BaseMutationOptions<SendBulkOrderEmailToDriverMutation, SendBulkOrderEmailToDriverMutationVariables>;
export const UpdateOrderGroupStatusDocument = gql`
    mutation UpdateOrderGroupStatus($input: UpdateOrderGroupMutationInput!) {
  updateOrderGroup(input: $input) {
    orderGroup {
      id
      status
    }
  }
}
    `;
export type UpdateOrderGroupStatusMutationFn = Apollo.MutationFunction<UpdateOrderGroupStatusMutation, UpdateOrderGroupStatusMutationVariables>;

/**
 * __useUpdateOrderGroupStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrderGroupStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderGroupStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderGroupStatusMutation, { data, loading, error }] = useUpdateOrderGroupStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderGroupStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderGroupStatusMutation, UpdateOrderGroupStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderGroupStatusMutation, UpdateOrderGroupStatusMutationVariables>(UpdateOrderGroupStatusDocument, options);
      }
export type UpdateOrderGroupStatusMutationHookResult = ReturnType<typeof useUpdateOrderGroupStatusMutation>;
export type UpdateOrderGroupStatusMutationResult = Apollo.MutationResult<UpdateOrderGroupStatusMutation>;
export type UpdateOrderGroupStatusMutationOptions = Apollo.BaseMutationOptions<UpdateOrderGroupStatusMutation, UpdateOrderGroupStatusMutationVariables>;
export const UpdateOrderGroupTagsDocument = gql`
    mutation UpdateOrderGroupTags($input: LinkOrUnlinkTagsInput!) {
  linkOrUnlinkTags(input: $input) {
    orderGroup {
      id
      taggings {
        tag {
          id
          name
          erpId
          description
          colorCode
          iconName
          status
          tagType
        }
      }
    }
    error
    success
  }
}
    `;
export type UpdateOrderGroupTagsMutationFn = Apollo.MutationFunction<UpdateOrderGroupTagsMutation, UpdateOrderGroupTagsMutationVariables>;

/**
 * __useUpdateOrderGroupTagsMutation__
 *
 * To run a mutation, you first call `useUpdateOrderGroupTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderGroupTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderGroupTagsMutation, { data, loading, error }] = useUpdateOrderGroupTagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderGroupTagsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderGroupTagsMutation, UpdateOrderGroupTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderGroupTagsMutation, UpdateOrderGroupTagsMutationVariables>(UpdateOrderGroupTagsDocument, options);
      }
export type UpdateOrderGroupTagsMutationHookResult = ReturnType<typeof useUpdateOrderGroupTagsMutation>;
export type UpdateOrderGroupTagsMutationResult = Apollo.MutationResult<UpdateOrderGroupTagsMutation>;
export type UpdateOrderGroupTagsMutationOptions = Apollo.BaseMutationOptions<UpdateOrderGroupTagsMutation, UpdateOrderGroupTagsMutationVariables>;
export const FetchRentalAssetsDocument = gql`
    query FetchRentalAssets($types: [AssetTypeEnum!], $statuses: [String!], $limit: Int, $offset: Int, $all: String) {
  filteredAssets(
    filter: {types: $types, statuses: $statuses, all: $all}
    limit: $limit
    offset: $offset
  ) {
    collection {
      id
      name
      existingActiveMovementOrderIds
    }
    metadata {
      hasMore
    }
  }
}
    `;

/**
 * __useFetchRentalAssetsQuery__
 *
 * To run a query within a React component, call `useFetchRentalAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRentalAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRentalAssetsQuery({
 *   variables: {
 *      types: // value for 'types'
 *      statuses: // value for 'statuses'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      all: // value for 'all'
 *   },
 * });
 */
export function useFetchRentalAssetsQuery(baseOptions?: Apollo.QueryHookOptions<FetchRentalAssetsQuery, FetchRentalAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRentalAssetsQuery, FetchRentalAssetsQueryVariables>(FetchRentalAssetsDocument, options);
      }
export function useFetchRentalAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRentalAssetsQuery, FetchRentalAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRentalAssetsQuery, FetchRentalAssetsQueryVariables>(FetchRentalAssetsDocument, options);
        }
export type FetchRentalAssetsQueryHookResult = ReturnType<typeof useFetchRentalAssetsQuery>;
export type FetchRentalAssetsLazyQueryHookResult = ReturnType<typeof useFetchRentalAssetsLazyQuery>;
export type FetchRentalAssetsQueryResult = Apollo.QueryResult<FetchRentalAssetsQuery, FetchRentalAssetsQueryVariables>;
export const FetchMovementOrderOtherDetailsDocument = gql`
    query FetchMovementOrderOtherDetails($id: ID!) {
  movementOrder(id: $id) {
    id
    orderNotes
    instruction
    assetDetailsNotes
    signature {
      blobFileUrl
    }
    orderGroup {
      id
      pandaDocuments {
        id
        fileName
        fileUrl
        blobFileUrl
        blobFileUrlDownload
        externalFileData {
          filename
          url
        }
      }
    }
  }
}
    `;

/**
 * __useFetchMovementOrderOtherDetailsQuery__
 *
 * To run a query within a React component, call `useFetchMovementOrderOtherDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMovementOrderOtherDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMovementOrderOtherDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchMovementOrderOtherDetailsQuery(baseOptions: Apollo.QueryHookOptions<FetchMovementOrderOtherDetailsQuery, FetchMovementOrderOtherDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchMovementOrderOtherDetailsQuery, FetchMovementOrderOtherDetailsQueryVariables>(FetchMovementOrderOtherDetailsDocument, options);
      }
export function useFetchMovementOrderOtherDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchMovementOrderOtherDetailsQuery, FetchMovementOrderOtherDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchMovementOrderOtherDetailsQuery, FetchMovementOrderOtherDetailsQueryVariables>(FetchMovementOrderOtherDetailsDocument, options);
        }
export type FetchMovementOrderOtherDetailsQueryHookResult = ReturnType<typeof useFetchMovementOrderOtherDetailsQuery>;
export type FetchMovementOrderOtherDetailsLazyQueryHookResult = ReturnType<typeof useFetchMovementOrderOtherDetailsLazyQuery>;
export type FetchMovementOrderOtherDetailsQueryResult = Apollo.QueryResult<FetchMovementOrderOtherDetailsQuery, FetchMovementOrderOtherDetailsQueryVariables>;
export const CreateAssetMovementOrderDocument = gql`
    mutation CreateAssetMovementOrder($input: CreateOrderGroupInput!) {
  createOrderGroup(input: $input) {
    orderGroup {
      id
      movementOrder {
        id
        requestedTankSize
        requestedTankType
      }
    }
  }
}
    `;
export type CreateAssetMovementOrderMutationFn = Apollo.MutationFunction<CreateAssetMovementOrderMutation, CreateAssetMovementOrderMutationVariables>;

/**
 * __useCreateAssetMovementOrderMutation__
 *
 * To run a mutation, you first call `useCreateAssetMovementOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetMovementOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetMovementOrderMutation, { data, loading, error }] = useCreateAssetMovementOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssetMovementOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssetMovementOrderMutation, CreateAssetMovementOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssetMovementOrderMutation, CreateAssetMovementOrderMutationVariables>(CreateAssetMovementOrderDocument, options);
      }
export type CreateAssetMovementOrderMutationHookResult = ReturnType<typeof useCreateAssetMovementOrderMutation>;
export type CreateAssetMovementOrderMutationResult = Apollo.MutationResult<CreateAssetMovementOrderMutation>;
export type CreateAssetMovementOrderMutationOptions = Apollo.BaseMutationOptions<CreateAssetMovementOrderMutation, CreateAssetMovementOrderMutationVariables>;
export const CreateNoteDocument = gql`
    mutation createNote($input: CreateNoteInput!) {
  createNote(input: $input) {
    note {
      id
      createdAtTimestamp
      content
      generated
      showInDeliveryTicket
      showInInvoice
      commenterUser {
        id
        name
        avatar
        type
      }
      pandaDocument {
        id
        blobFileUrl
      }
    }
  }
}
    `;
export type CreateNoteMutationFn = Apollo.MutationFunction<CreateNoteMutation, CreateNoteMutationVariables>;

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoteMutation, CreateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNoteMutation, CreateNoteMutationVariables>(CreateNoteDocument, options);
      }
export type CreateNoteMutationHookResult = ReturnType<typeof useCreateNoteMutation>;
export type CreateNoteMutationResult = Apollo.MutationResult<CreateNoteMutation>;
export type CreateNoteMutationOptions = Apollo.BaseMutationOptions<CreateNoteMutation, CreateNoteMutationVariables>;
export const FetchAssetMovementOrderFeesDocument = gql`
    query FetchAssetMovementOrderFees($orderId: ID!) {
  movementOrder(id: $orderId) {
    id
    orderGroupId
    orderGroup {
      orderGroupsFees {
        id
        price
        quantity
        fee {
          id
          description
          name
          standard
          deleted
        }
      }
    }
  }
}
    `;

/**
 * __useFetchAssetMovementOrderFeesQuery__
 *
 * To run a query within a React component, call `useFetchAssetMovementOrderFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAssetMovementOrderFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAssetMovementOrderFeesQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useFetchAssetMovementOrderFeesQuery(baseOptions: Apollo.QueryHookOptions<FetchAssetMovementOrderFeesQuery, FetchAssetMovementOrderFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAssetMovementOrderFeesQuery, FetchAssetMovementOrderFeesQueryVariables>(FetchAssetMovementOrderFeesDocument, options);
      }
export function useFetchAssetMovementOrderFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAssetMovementOrderFeesQuery, FetchAssetMovementOrderFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAssetMovementOrderFeesQuery, FetchAssetMovementOrderFeesQueryVariables>(FetchAssetMovementOrderFeesDocument, options);
        }
export type FetchAssetMovementOrderFeesQueryHookResult = ReturnType<typeof useFetchAssetMovementOrderFeesQuery>;
export type FetchAssetMovementOrderFeesLazyQueryHookResult = ReturnType<typeof useFetchAssetMovementOrderFeesLazyQuery>;
export type FetchAssetMovementOrderFeesQueryResult = Apollo.QueryResult<FetchAssetMovementOrderFeesQuery, FetchAssetMovementOrderFeesQueryVariables>;
export const FetchMovementOrderHistoryDocument = gql`
    query FetchMovementOrderHistory($id: ID!) {
  assetMovementOrderHistory(id: $id) {
    actualRoi
    expectedRoi
    startedDate
    completedDate
    customerBranchName
    customerName
    numberOfDays
    customerBranchId
    averageDaysBetweenFills
  }
}
    `;

/**
 * __useFetchMovementOrderHistoryQuery__
 *
 * To run a query within a React component, call `useFetchMovementOrderHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMovementOrderHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMovementOrderHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchMovementOrderHistoryQuery(baseOptions: Apollo.QueryHookOptions<FetchMovementOrderHistoryQuery, FetchMovementOrderHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchMovementOrderHistoryQuery, FetchMovementOrderHistoryQueryVariables>(FetchMovementOrderHistoryDocument, options);
      }
export function useFetchMovementOrderHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchMovementOrderHistoryQuery, FetchMovementOrderHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchMovementOrderHistoryQuery, FetchMovementOrderHistoryQueryVariables>(FetchMovementOrderHistoryDocument, options);
        }
export type FetchMovementOrderHistoryQueryHookResult = ReturnType<typeof useFetchMovementOrderHistoryQuery>;
export type FetchMovementOrderHistoryLazyQueryHookResult = ReturnType<typeof useFetchMovementOrderHistoryLazyQuery>;
export type FetchMovementOrderHistoryQueryResult = Apollo.QueryResult<FetchMovementOrderHistoryQuery, FetchMovementOrderHistoryQueryVariables>;
export const FetchMovementOrderHistoryListDocument = gql`
    query FetchMovementOrderHistoryList($limit: Int, $offset: Int, $filter: AssetMovementOrderHistoryListFilter, $sorter: [AssetMovementOrderHistorySorter!]) {
  filteredAssetMovementOrderHistoryList(
    limit: $limit
    offset: $offset
    filter: $filter
    sorter: $sorter
  ) {
    collection {
      driverName
      productName
      volume
      completedOn
      licensePlateNumber
    }
    metadata {
      totalCount
      hasMore
      total_entries
    }
  }
}
    `;

/**
 * __useFetchMovementOrderHistoryListQuery__
 *
 * To run a query within a React component, call `useFetchMovementOrderHistoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMovementOrderHistoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMovementOrderHistoryListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchMovementOrderHistoryListQuery(baseOptions?: Apollo.QueryHookOptions<FetchMovementOrderHistoryListQuery, FetchMovementOrderHistoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchMovementOrderHistoryListQuery, FetchMovementOrderHistoryListQueryVariables>(FetchMovementOrderHistoryListDocument, options);
      }
export function useFetchMovementOrderHistoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchMovementOrderHistoryListQuery, FetchMovementOrderHistoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchMovementOrderHistoryListQuery, FetchMovementOrderHistoryListQueryVariables>(FetchMovementOrderHistoryListDocument, options);
        }
export type FetchMovementOrderHistoryListQueryHookResult = ReturnType<typeof useFetchMovementOrderHistoryListQuery>;
export type FetchMovementOrderHistoryListLazyQueryHookResult = ReturnType<typeof useFetchMovementOrderHistoryListLazyQuery>;
export type FetchMovementOrderHistoryListQueryResult = Apollo.QueryResult<FetchMovementOrderHistoryListQuery, FetchMovementOrderHistoryListQueryVariables>;
export const FetchAssetMovementOrderWellDocument = gql`
    query fetchAssetMovementOrderWell($limit: Int, $offset: Int, $filter: OrderGroupFilter, $sorter: [OrderGroupSorter!]) {
  filteredOrderGroups(
    limit: $limit
    offset: $offset
    filter: $filter
    sorter: $sorter
  ) {
    collection {
      ...orderGroup
    }
    metadata {
      totalCount
      hasMore
    }
  }
}
    ${OrderGroupFragmentDoc}`;

/**
 * __useFetchAssetMovementOrderWellQuery__
 *
 * To run a query within a React component, call `useFetchAssetMovementOrderWellQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAssetMovementOrderWellQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAssetMovementOrderWellQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchAssetMovementOrderWellQuery(baseOptions?: Apollo.QueryHookOptions<FetchAssetMovementOrderWellQuery, FetchAssetMovementOrderWellQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAssetMovementOrderWellQuery, FetchAssetMovementOrderWellQueryVariables>(FetchAssetMovementOrderWellDocument, options);
      }
export function useFetchAssetMovementOrderWellLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAssetMovementOrderWellQuery, FetchAssetMovementOrderWellQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAssetMovementOrderWellQuery, FetchAssetMovementOrderWellQueryVariables>(FetchAssetMovementOrderWellDocument, options);
        }
export type FetchAssetMovementOrderWellQueryHookResult = ReturnType<typeof useFetchAssetMovementOrderWellQuery>;
export type FetchAssetMovementOrderWellLazyQueryHookResult = ReturnType<typeof useFetchAssetMovementOrderWellLazyQuery>;
export type FetchAssetMovementOrderWellQueryResult = Apollo.QueryResult<FetchAssetMovementOrderWellQuery, FetchAssetMovementOrderWellQueryVariables>;
export const FetchCustomItemsForLeoDocument = gql`
    query FetchCustomItemsForLeo($id: ID!) {
  movementOrder(id: $id) {
    id
    data {
      customItems {
        name
        qty
      }
    }
  }
}
    `;

/**
 * __useFetchCustomItemsForLeoQuery__
 *
 * To run a query within a React component, call `useFetchCustomItemsForLeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomItemsForLeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomItemsForLeoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchCustomItemsForLeoQuery(baseOptions: Apollo.QueryHookOptions<FetchCustomItemsForLeoQuery, FetchCustomItemsForLeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomItemsForLeoQuery, FetchCustomItemsForLeoQueryVariables>(FetchCustomItemsForLeoDocument, options);
      }
export function useFetchCustomItemsForLeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomItemsForLeoQuery, FetchCustomItemsForLeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomItemsForLeoQuery, FetchCustomItemsForLeoQueryVariables>(FetchCustomItemsForLeoDocument, options);
        }
export type FetchCustomItemsForLeoQueryHookResult = ReturnType<typeof useFetchCustomItemsForLeoQuery>;
export type FetchCustomItemsForLeoLazyQueryHookResult = ReturnType<typeof useFetchCustomItemsForLeoLazyQuery>;
export type FetchCustomItemsForLeoQueryResult = Apollo.QueryResult<FetchCustomItemsForLeoQuery, FetchCustomItemsForLeoQueryVariables>;
export const FetchLineItemsForLeoDocument = gql`
    query FetchLineItemsForLeo($id: ID!) {
  movementOrder(id: $id) {
    id
    orderType
    movementOrderLineItems {
      id
      action
      ownershipStatus
      isPeripheralRemoved
      peripheral {
        id
        erpId
        subType
        peripheralCategory {
          id
          name
        }
      }
      peripheralInstances {
        id
        value
        peripheralAttribute {
          id
          formName
          formLabel
          peripheralAttributeType
        }
      }
    }
  }
}
    `;

/**
 * __useFetchLineItemsForLeoQuery__
 *
 * To run a query within a React component, call `useFetchLineItemsForLeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLineItemsForLeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLineItemsForLeoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchLineItemsForLeoQuery(baseOptions: Apollo.QueryHookOptions<FetchLineItemsForLeoQuery, FetchLineItemsForLeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLineItemsForLeoQuery, FetchLineItemsForLeoQueryVariables>(FetchLineItemsForLeoDocument, options);
      }
export function useFetchLineItemsForLeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLineItemsForLeoQuery, FetchLineItemsForLeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLineItemsForLeoQuery, FetchLineItemsForLeoQueryVariables>(FetchLineItemsForLeoDocument, options);
        }
export type FetchLineItemsForLeoQueryHookResult = ReturnType<typeof useFetchLineItemsForLeoQuery>;
export type FetchLineItemsForLeoLazyQueryHookResult = ReturnType<typeof useFetchLineItemsForLeoLazyQuery>;
export type FetchLineItemsForLeoQueryResult = Apollo.QueryResult<FetchLineItemsForLeoQuery, FetchLineItemsForLeoQueryVariables>;
export const FetchMovementOrderDocument = gql`
    query FetchMovementOrder($id: ID!) {
  movementOrder(id: $id) {
    id
    orderType
    hasActiveAddendumAgreement
    addendumAgreementDocuments {
      name
      url
      documentType
    }
    orderGroup {
      id
      status
      startOnTimestamp
      toStartOnTimestamp
      createdAtTimestamp
      completedOnTimestamp
      poNumber
      driver {
        id
        name
      }
      user {
        id
        name
      }
    }
    data {
      customItems {
        name
        qty
        unitCost
      }
    }
    assetMovementLocation {
      id
      lat
      lng
      orderGroupId
    }
    asset {
      id
      name
      erpId
      type
      tankSize
      tankType
      licensePlateNumber
      assetProductCategories {
        productCategory {
          id
          name
        }
      }
      compartments {
        id
      }
      assetMovementLocation {
        lat
        lng
      }
      customerBranch {
        id
        name
      }
      customer {
        id
        name
        erpId
      }
      hubs {
        id
        name
        address
      }
      fuelTypeProducts {
        id
        name
      }
    }
    toCustomerBranch {
      id
      name
      address
      deliveryInstruction
      customer {
        name
        erpId
        deliveryInstruction
      }
    }
    fromCustomerBranch {
      id
      name
      customer {
        name
      }
    }
    hub {
      id
      name
      address
    }
    product {
      id
      name
    }
    orderNotes
    instruction
    requestedTankSize
    requestedTankType
    assignedTankSize
    assignedTankType
  }
}
    `;

/**
 * __useFetchMovementOrderQuery__
 *
 * To run a query within a React component, call `useFetchMovementOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMovementOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMovementOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchMovementOrderQuery(baseOptions: Apollo.QueryHookOptions<FetchMovementOrderQuery, FetchMovementOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchMovementOrderQuery, FetchMovementOrderQueryVariables>(FetchMovementOrderDocument, options);
      }
export function useFetchMovementOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchMovementOrderQuery, FetchMovementOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchMovementOrderQuery, FetchMovementOrderQueryVariables>(FetchMovementOrderDocument, options);
        }
export type FetchMovementOrderQueryHookResult = ReturnType<typeof useFetchMovementOrderQuery>;
export type FetchMovementOrderLazyQueryHookResult = ReturnType<typeof useFetchMovementOrderLazyQuery>;
export type FetchMovementOrderQueryResult = Apollo.QueryResult<FetchMovementOrderQuery, FetchMovementOrderQueryVariables>;
export const FetchMovementOrderLineItemsDocument = gql`
    query FetchMovementOrderLineItems($id: ID!) {
  movementOrder(id: $id) {
    id
    movementOrderLineItems {
      id
      peripheral {
        id
        soldAs
        subType
        legalDescription
        peripheralCategory {
          id
          name
        }
      }
      peripheralInstances {
        id
        value
        peripheralAttribute {
          id
          name
          peripheralAttributeType
        }
      }
      resourceStatuses {
        id
        name
        preValue
        postValue
        resourceStatusType {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useFetchMovementOrderLineItemsQuery__
 *
 * To run a query within a React component, call `useFetchMovementOrderLineItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMovementOrderLineItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMovementOrderLineItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchMovementOrderLineItemsQuery(baseOptions: Apollo.QueryHookOptions<FetchMovementOrderLineItemsQuery, FetchMovementOrderLineItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchMovementOrderLineItemsQuery, FetchMovementOrderLineItemsQueryVariables>(FetchMovementOrderLineItemsDocument, options);
      }
export function useFetchMovementOrderLineItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchMovementOrderLineItemsQuery, FetchMovementOrderLineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchMovementOrderLineItemsQuery, FetchMovementOrderLineItemsQueryVariables>(FetchMovementOrderLineItemsDocument, options);
        }
export type FetchMovementOrderLineItemsQueryHookResult = ReturnType<typeof useFetchMovementOrderLineItemsQuery>;
export type FetchMovementOrderLineItemsLazyQueryHookResult = ReturnType<typeof useFetchMovementOrderLineItemsLazyQuery>;
export type FetchMovementOrderLineItemsQueryResult = Apollo.QueryResult<FetchMovementOrderLineItemsQuery, FetchMovementOrderLineItemsQueryVariables>;
export const FetchMovementOrderLinkOrdersDocument = gql`
    query FetchMovementOrderLinkOrders($id: ID!) {
  movementOrder(id: $id) {
    id
    orderLinks {
      id
      deliveryOrder {
        id
        orderGroup {
          id
        }
      }
      extractionOrder {
        id
        orderGroup {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useFetchMovementOrderLinkOrdersQuery__
 *
 * To run a query within a React component, call `useFetchMovementOrderLinkOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMovementOrderLinkOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMovementOrderLinkOrdersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchMovementOrderLinkOrdersQuery(baseOptions: Apollo.QueryHookOptions<FetchMovementOrderLinkOrdersQuery, FetchMovementOrderLinkOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchMovementOrderLinkOrdersQuery, FetchMovementOrderLinkOrdersQueryVariables>(FetchMovementOrderLinkOrdersDocument, options);
      }
export function useFetchMovementOrderLinkOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchMovementOrderLinkOrdersQuery, FetchMovementOrderLinkOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchMovementOrderLinkOrdersQuery, FetchMovementOrderLinkOrdersQueryVariables>(FetchMovementOrderLinkOrdersDocument, options);
        }
export type FetchMovementOrderLinkOrdersQueryHookResult = ReturnType<typeof useFetchMovementOrderLinkOrdersQuery>;
export type FetchMovementOrderLinkOrdersLazyQueryHookResult = ReturnType<typeof useFetchMovementOrderLinkOrdersLazyQuery>;
export type FetchMovementOrderLinkOrdersQueryResult = Apollo.QueryResult<FetchMovementOrderLinkOrdersQuery, FetchMovementOrderLinkOrdersQueryVariables>;
export const FetchMovementOrderNotesDocument = gql`
    query FetchMovementOrderNotes($id: ID!) {
  movementOrder(id: $id) {
    id
    resourceStatuses {
      id
      createdAtTimestamp
      preValue
      postValue
      resourceStatusType {
        resourceAttributeType
      }
    }
    orderGroup {
      id
      allNotes {
        id
        createdAtTimestamp
        content
        generated
        showInDeliveryTicket
        commenterUser {
          id
          name
          avatar
          type
        }
      }
      driver {
        name
      }
    }
  }
}
    `;

/**
 * __useFetchMovementOrderNotesQuery__
 *
 * To run a query within a React component, call `useFetchMovementOrderNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMovementOrderNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMovementOrderNotesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchMovementOrderNotesQuery(baseOptions: Apollo.QueryHookOptions<FetchMovementOrderNotesQuery, FetchMovementOrderNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchMovementOrderNotesQuery, FetchMovementOrderNotesQueryVariables>(FetchMovementOrderNotesDocument, options);
      }
export function useFetchMovementOrderNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchMovementOrderNotesQuery, FetchMovementOrderNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchMovementOrderNotesQuery, FetchMovementOrderNotesQueryVariables>(FetchMovementOrderNotesDocument, options);
        }
export type FetchMovementOrderNotesQueryHookResult = ReturnType<typeof useFetchMovementOrderNotesQuery>;
export type FetchMovementOrderNotesLazyQueryHookResult = ReturnType<typeof useFetchMovementOrderNotesLazyQuery>;
export type FetchMovementOrderNotesQueryResult = Apollo.QueryResult<FetchMovementOrderNotesQuery, FetchMovementOrderNotesQueryVariables>;
export const FetchMovementOrderRequestedLineItemsDocument = gql`
    query FetchMovementOrderRequestedLineItems($id: ID!) {
  movementOrder(id: $id) {
    id
    asset {
      id
    }
    requestedMovementOrderLineItems {
      id
      peripheralApprovedStatus
      peripheral {
        id
        soldAs
        subType
        legalDescription
        peripheralCategory {
          id
          name
        }
      }
      requestedPeripheralInstances {
        id
        value
        peripheralAttribute {
          id
          name
          peripheralAttributeType
        }
      }
    }
  }
}
    `;

/**
 * __useFetchMovementOrderRequestedLineItemsQuery__
 *
 * To run a query within a React component, call `useFetchMovementOrderRequestedLineItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMovementOrderRequestedLineItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMovementOrderRequestedLineItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchMovementOrderRequestedLineItemsQuery(baseOptions: Apollo.QueryHookOptions<FetchMovementOrderRequestedLineItemsQuery, FetchMovementOrderRequestedLineItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchMovementOrderRequestedLineItemsQuery, FetchMovementOrderRequestedLineItemsQueryVariables>(FetchMovementOrderRequestedLineItemsDocument, options);
      }
export function useFetchMovementOrderRequestedLineItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchMovementOrderRequestedLineItemsQuery, FetchMovementOrderRequestedLineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchMovementOrderRequestedLineItemsQuery, FetchMovementOrderRequestedLineItemsQueryVariables>(FetchMovementOrderRequestedLineItemsDocument, options);
        }
export type FetchMovementOrderRequestedLineItemsQueryHookResult = ReturnType<typeof useFetchMovementOrderRequestedLineItemsQuery>;
export type FetchMovementOrderRequestedLineItemsLazyQueryHookResult = ReturnType<typeof useFetchMovementOrderRequestedLineItemsLazyQuery>;
export type FetchMovementOrderRequestedLineItemsQueryResult = Apollo.QueryResult<FetchMovementOrderRequestedLineItemsQuery, FetchMovementOrderRequestedLineItemsQueryVariables>;
export const FetchPeripheralsForNewMovementOrderDocument = gql`
    query FetchPeripheralsForNewMovementOrder {
  peripherals {
    id
    erpId
    soldAs
    status
    subType
    peripheralCategory {
      id
      name
    }
  }
}
    `;

/**
 * __useFetchPeripheralsForNewMovementOrderQuery__
 *
 * To run a query within a React component, call `useFetchPeripheralsForNewMovementOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPeripheralsForNewMovementOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPeripheralsForNewMovementOrderQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchPeripheralsForNewMovementOrderQuery(baseOptions?: Apollo.QueryHookOptions<FetchPeripheralsForNewMovementOrderQuery, FetchPeripheralsForNewMovementOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPeripheralsForNewMovementOrderQuery, FetchPeripheralsForNewMovementOrderQueryVariables>(FetchPeripheralsForNewMovementOrderDocument, options);
      }
export function useFetchPeripheralsForNewMovementOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPeripheralsForNewMovementOrderQuery, FetchPeripheralsForNewMovementOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPeripheralsForNewMovementOrderQuery, FetchPeripheralsForNewMovementOrderQueryVariables>(FetchPeripheralsForNewMovementOrderDocument, options);
        }
export type FetchPeripheralsForNewMovementOrderQueryHookResult = ReturnType<typeof useFetchPeripheralsForNewMovementOrderQuery>;
export type FetchPeripheralsForNewMovementOrderLazyQueryHookResult = ReturnType<typeof useFetchPeripheralsForNewMovementOrderLazyQuery>;
export type FetchPeripheralsForNewMovementOrderQueryResult = Apollo.QueryResult<FetchPeripheralsForNewMovementOrderQuery, FetchPeripheralsForNewMovementOrderQueryVariables>;
export const FetchResourceStatusTypeDocument = gql`
    query FetchResourceStatusType {
  resourceStatusType {
    id
    resourceAttributeType
    name
  }
}
    `;

/**
 * __useFetchResourceStatusTypeQuery__
 *
 * To run a query within a React component, call `useFetchResourceStatusTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchResourceStatusTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchResourceStatusTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchResourceStatusTypeQuery(baseOptions?: Apollo.QueryHookOptions<FetchResourceStatusTypeQuery, FetchResourceStatusTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchResourceStatusTypeQuery, FetchResourceStatusTypeQueryVariables>(FetchResourceStatusTypeDocument, options);
      }
export function useFetchResourceStatusTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchResourceStatusTypeQuery, FetchResourceStatusTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchResourceStatusTypeQuery, FetchResourceStatusTypeQueryVariables>(FetchResourceStatusTypeDocument, options);
        }
export type FetchResourceStatusTypeQueryHookResult = ReturnType<typeof useFetchResourceStatusTypeQuery>;
export type FetchResourceStatusTypeLazyQueryHookResult = ReturnType<typeof useFetchResourceStatusTypeLazyQuery>;
export type FetchResourceStatusTypeQueryResult = Apollo.QueryResult<FetchResourceStatusTypeQuery, FetchResourceStatusTypeQueryVariables>;
export const FilteredFeesForMovementOrderDetailDocument = gql`
    query FilteredFeesForMovementOrderDetail($filter: FeeFilter) {
  filteredFees(filter: $filter) {
    collection {
      id
      description
      name
      standard
      deleted
    }
  }
}
    `;

/**
 * __useFilteredFeesForMovementOrderDetailQuery__
 *
 * To run a query within a React component, call `useFilteredFeesForMovementOrderDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredFeesForMovementOrderDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredFeesForMovementOrderDetailQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFilteredFeesForMovementOrderDetailQuery(baseOptions?: Apollo.QueryHookOptions<FilteredFeesForMovementOrderDetailQuery, FilteredFeesForMovementOrderDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredFeesForMovementOrderDetailQuery, FilteredFeesForMovementOrderDetailQueryVariables>(FilteredFeesForMovementOrderDetailDocument, options);
      }
export function useFilteredFeesForMovementOrderDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredFeesForMovementOrderDetailQuery, FilteredFeesForMovementOrderDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredFeesForMovementOrderDetailQuery, FilteredFeesForMovementOrderDetailQueryVariables>(FilteredFeesForMovementOrderDetailDocument, options);
        }
export type FilteredFeesForMovementOrderDetailQueryHookResult = ReturnType<typeof useFilteredFeesForMovementOrderDetailQuery>;
export type FilteredFeesForMovementOrderDetailLazyQueryHookResult = ReturnType<typeof useFilteredFeesForMovementOrderDetailLazyQuery>;
export type FilteredFeesForMovementOrderDetailQueryResult = Apollo.QueryResult<FilteredFeesForMovementOrderDetailQuery, FilteredFeesForMovementOrderDetailQueryVariables>;
export const UpdateMovementOrderDocument = gql`
    mutation UpdateMovementOrder($input: UpdateMovementOrderInput!) {
  updateMovementOrder(input: $input) {
    movementOrder {
      id
    }
  }
}
    `;
export type UpdateMovementOrderMutationFn = Apollo.MutationFunction<UpdateMovementOrderMutation, UpdateMovementOrderMutationVariables>;

/**
 * __useUpdateMovementOrderMutation__
 *
 * To run a mutation, you first call `useUpdateMovementOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMovementOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMovementOrderMutation, { data, loading, error }] = useUpdateMovementOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMovementOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMovementOrderMutation, UpdateMovementOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMovementOrderMutation, UpdateMovementOrderMutationVariables>(UpdateMovementOrderDocument, options);
      }
export type UpdateMovementOrderMutationHookResult = ReturnType<typeof useUpdateMovementOrderMutation>;
export type UpdateMovementOrderMutationResult = Apollo.MutationResult<UpdateMovementOrderMutation>;
export type UpdateMovementOrderMutationOptions = Apollo.BaseMutationOptions<UpdateMovementOrderMutation, UpdateMovementOrderMutationVariables>;
export const UpdateOrderGroupDocument = gql`
    mutation UpdateOrderGroup($input: UpdateOrderGroupMutationInput!) {
  updateOrderGroup(input: $input) {
    orderGroup {
      ...orderGroup
    }
  }
}
    ${OrderGroupFragmentDoc}`;
export type UpdateOrderGroupMutationFn = Apollo.MutationFunction<UpdateOrderGroupMutation, UpdateOrderGroupMutationVariables>;

/**
 * __useUpdateOrderGroupMutation__
 *
 * To run a mutation, you first call `useUpdateOrderGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderGroupMutation, { data, loading, error }] = useUpdateOrderGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderGroupMutation, UpdateOrderGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderGroupMutation, UpdateOrderGroupMutationVariables>(UpdateOrderGroupDocument, options);
      }
export type UpdateOrderGroupMutationHookResult = ReturnType<typeof useUpdateOrderGroupMutation>;
export type UpdateOrderGroupMutationResult = Apollo.MutationResult<UpdateOrderGroupMutation>;
export type UpdateOrderGroupMutationOptions = Apollo.BaseMutationOptions<UpdateOrderGroupMutation, UpdateOrderGroupMutationVariables>;
export const FetchCurrentDocument = gql`
    query fetchCurrent {
  current {
    pusherChannelName
    accessibleCustomers {
      id
      name
    }
    isCarrierOnly
    user {
      id
      name
      email
      phone
      address
      roles {
        name
      }
      isSuperAdmin
      image {
        id
        filename
        url
      }
    }
    userFeatureFlags: features
    customer {
      id
      tenantSlug
      name
      site {
        lat
        lng
      }
    }
    customerSettings: settingFeatures
    settings {
      id
      name
      value
    }
    tenant {
      id
      name
      slug
    }
    isCustomerClient
  }
}
    `;

/**
 * __useFetchCurrentQuery__
 *
 * To run a query within a React component, call `useFetchCurrentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCurrentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCurrentQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchCurrentQuery(baseOptions?: Apollo.QueryHookOptions<FetchCurrentQuery, FetchCurrentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCurrentQuery, FetchCurrentQueryVariables>(FetchCurrentDocument, options);
      }
export function useFetchCurrentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCurrentQuery, FetchCurrentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCurrentQuery, FetchCurrentQueryVariables>(FetchCurrentDocument, options);
        }
export type FetchCurrentQueryHookResult = ReturnType<typeof useFetchCurrentQuery>;
export type FetchCurrentLazyQueryHookResult = ReturnType<typeof useFetchCurrentLazyQuery>;
export type FetchCurrentQueryResult = Apollo.QueryResult<FetchCurrentQuery, FetchCurrentQueryVariables>;
export const SettingsDocument = gql`
    query Settings {
  settings {
    id
    name
    value
  }
}
    `;

/**
 * __useSettingsQuery__
 *
 * To run a query within a React component, call `useSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSettingsQuery(baseOptions?: Apollo.QueryHookOptions<SettingsQuery, SettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettingsQuery, SettingsQueryVariables>(SettingsDocument, options);
      }
export function useSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettingsQuery, SettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettingsQuery, SettingsQueryVariables>(SettingsDocument, options);
        }
export type SettingsQueryHookResult = ReturnType<typeof useSettingsQuery>;
export type SettingsLazyQueryHookResult = ReturnType<typeof useSettingsLazyQuery>;
export type SettingsQueryResult = Apollo.QueryResult<SettingsQuery, SettingsQueryVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input) {
    errors
    message
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SendPasswordResetInstructionDocument = gql`
    mutation SendPasswordResetInstruction($email: String!) {
  sendPasswordResetInstruction(input: {email: $email}) {
    clientMutationId
    errors
    message
  }
}
    `;
export type SendPasswordResetInstructionMutationFn = Apollo.MutationFunction<SendPasswordResetInstructionMutation, SendPasswordResetInstructionMutationVariables>;

/**
 * __useSendPasswordResetInstructionMutation__
 *
 * To run a mutation, you first call `useSendPasswordResetInstructionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetInstructionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordResetInstructionMutation, { data, loading, error }] = useSendPasswordResetInstructionMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendPasswordResetInstructionMutation(baseOptions?: Apollo.MutationHookOptions<SendPasswordResetInstructionMutation, SendPasswordResetInstructionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPasswordResetInstructionMutation, SendPasswordResetInstructionMutationVariables>(SendPasswordResetInstructionDocument, options);
      }
export type SendPasswordResetInstructionMutationHookResult = ReturnType<typeof useSendPasswordResetInstructionMutation>;
export type SendPasswordResetInstructionMutationResult = Apollo.MutationResult<SendPasswordResetInstructionMutation>;
export type SendPasswordResetInstructionMutationOptions = Apollo.BaseMutationOptions<SendPasswordResetInstructionMutation, SendPasswordResetInstructionMutationVariables>;
export const UserSignInDocument = gql`
    mutation UserSignIn($credentials: AuthInput!) {
  signInUser(input: {credentials: $credentials}) {
    token
    message
    refreshToken
    clientMutationId
    isCustomerClient
    requires2fa
    otpRequiredForLogin
    user {
      id
      name
      phone
      email
    }
  }
}
    `;
export type UserSignInMutationFn = Apollo.MutationFunction<UserSignInMutation, UserSignInMutationVariables>;

/**
 * __useUserSignInMutation__
 *
 * To run a mutation, you first call `useUserSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSignInMutation, { data, loading, error }] = useUserSignInMutation({
 *   variables: {
 *      credentials: // value for 'credentials'
 *   },
 * });
 */
export function useUserSignInMutation(baseOptions?: Apollo.MutationHookOptions<UserSignInMutation, UserSignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserSignInMutation, UserSignInMutationVariables>(UserSignInDocument, options);
      }
export type UserSignInMutationHookResult = ReturnType<typeof useUserSignInMutation>;
export type UserSignInMutationResult = Apollo.MutationResult<UserSignInMutation>;
export type UserSignInMutationOptions = Apollo.BaseMutationOptions<UserSignInMutation, UserSignInMutationVariables>;
export const SwitchTenantDocument = gql`
    mutation SwitchTenant($input: SwitchTenantInput!) {
  switchTenant(input: $input) {
    accessToken
    clientMutationId
  }
}
    `;
export type SwitchTenantMutationFn = Apollo.MutationFunction<SwitchTenantMutation, SwitchTenantMutationVariables>;

/**
 * __useSwitchTenantMutation__
 *
 * To run a mutation, you first call `useSwitchTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchTenantMutation, { data, loading, error }] = useSwitchTenantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwitchTenantMutation(baseOptions?: Apollo.MutationHookOptions<SwitchTenantMutation, SwitchTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchTenantMutation, SwitchTenantMutationVariables>(SwitchTenantDocument, options);
      }
export type SwitchTenantMutationHookResult = ReturnType<typeof useSwitchTenantMutation>;
export type SwitchTenantMutationResult = Apollo.MutationResult<SwitchTenantMutation>;
export type SwitchTenantMutationOptions = Apollo.BaseMutationOptions<SwitchTenantMutation, SwitchTenantMutationVariables>;
export const ValidateTokenDocument = gql`
    mutation ValidateToken($input: ValidateTokenInput!) {
  validateToken(input: $input) {
    clientMutationId
    errors
    message
  }
}
    `;
export type ValidateTokenMutationFn = Apollo.MutationFunction<ValidateTokenMutation, ValidateTokenMutationVariables>;

/**
 * __useValidateTokenMutation__
 *
 * To run a mutation, you first call `useValidateTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateTokenMutation, { data, loading, error }] = useValidateTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateTokenMutation(baseOptions?: Apollo.MutationHookOptions<ValidateTokenMutation, ValidateTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateTokenMutation, ValidateTokenMutationVariables>(ValidateTokenDocument, options);
      }
export type ValidateTokenMutationHookResult = ReturnType<typeof useValidateTokenMutation>;
export type ValidateTokenMutationResult = Apollo.MutationResult<ValidateTokenMutation>;
export type ValidateTokenMutationOptions = Apollo.BaseMutationOptions<ValidateTokenMutation, ValidateTokenMutationVariables>;
export const CreateInvoiceDocument = gql`
    mutation CreateInvoice($input: CreateInvoiceInput!) {
  createInvoice(input: $input) {
    invoices {
      id
    }
  }
}
    `;
export type CreateInvoiceMutationFn = Apollo.MutationFunction<CreateInvoiceMutation, CreateInvoiceMutationVariables>;

/**
 * __useCreateInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceMutation, { data, loading, error }] = useCreateInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvoiceMutation, CreateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvoiceMutation, CreateInvoiceMutationVariables>(CreateInvoiceDocument, options);
      }
export type CreateInvoiceMutationHookResult = ReturnType<typeof useCreateInvoiceMutation>;
export type CreateInvoiceMutationResult = Apollo.MutationResult<CreateInvoiceMutation>;
export type CreateInvoiceMutationOptions = Apollo.BaseMutationOptions<CreateInvoiceMutation, CreateInvoiceMutationVariables>;
export const EmailInvoiceDocument = gql`
    mutation EmailInvoice($data: [ID!]!) {
  generateInvoice(input: {data: $data}) {
    success
  }
}
    `;
export type EmailInvoiceMutationFn = Apollo.MutationFunction<EmailInvoiceMutation, EmailInvoiceMutationVariables>;

/**
 * __useEmailInvoiceMutation__
 *
 * To run a mutation, you first call `useEmailInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailInvoiceMutation, { data, loading, error }] = useEmailInvoiceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useEmailInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<EmailInvoiceMutation, EmailInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailInvoiceMutation, EmailInvoiceMutationVariables>(EmailInvoiceDocument, options);
      }
export type EmailInvoiceMutationHookResult = ReturnType<typeof useEmailInvoiceMutation>;
export type EmailInvoiceMutationResult = Apollo.MutationResult<EmailInvoiceMutation>;
export type EmailInvoiceMutationOptions = Apollo.BaseMutationOptions<EmailInvoiceMutation, EmailInvoiceMutationVariables>;
export const FetchCardLockTranscationsDocument = gql`
    query FetchCardLockTranscations($limit: Int, $offset: Int, $filter: CardLockTransactionFilters) {
  distinctCardLockCustomers(limit: $limit, offset: $offset, filter: $filter) {
    collection {
      id
      erpId
      name
    }
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useFetchCardLockTranscationsQuery__
 *
 * To run a query within a React component, call `useFetchCardLockTranscationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCardLockTranscationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCardLockTranscationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchCardLockTranscationsQuery(baseOptions?: Apollo.QueryHookOptions<FetchCardLockTranscationsQuery, FetchCardLockTranscationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCardLockTranscationsQuery, FetchCardLockTranscationsQueryVariables>(FetchCardLockTranscationsDocument, options);
      }
export function useFetchCardLockTranscationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCardLockTranscationsQuery, FetchCardLockTranscationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCardLockTranscationsQuery, FetchCardLockTranscationsQueryVariables>(FetchCardLockTranscationsDocument, options);
        }
export type FetchCardLockTranscationsQueryHookResult = ReturnType<typeof useFetchCardLockTranscationsQuery>;
export type FetchCardLockTranscationsLazyQueryHookResult = ReturnType<typeof useFetchCardLockTranscationsLazyQuery>;
export type FetchCardLockTranscationsQueryResult = Apollo.QueryResult<FetchCardLockTranscationsQuery, FetchCardLockTranscationsQueryVariables>;
export const FetchInvoiceDetailsDocument = gql`
    query FetchInvoiceDetails($id: ID!) {
  invoice(id: $id) {
    id
    invoiceNumber
    status
    createdOn
    creatable {
      ... on User {
        id
        name
      }
      ... on Worker {
        id
        name
      }
      ... on Driver {
        id
        name
      }
    }
    generatedOn
    glDate
    generatable {
      ... on User {
        id
        name
      }
      ... on Worker {
        id
        name
      }
      ... on Driver {
        id
        name
      }
    }
    closedOn
    closeable {
      ... on User {
        id
        name
      }
      ... on Worker {
        id
        name
      }
      ... on Driver {
        id
        name
      }
    }
    amount
    customer {
      name
      address
      site {
        address
      }
      erpId
    }
    invoiceLineItems {
      product {
        id
        name
        erpId
      }
      customerBranch {
        id
        name
      }
      amount
      rate
      quantity
      sumTotal
    }
    invoiceFees {
      product {
        id
      }
      customerBranchId
      fee {
        name
      }
      amount
      rate
      quantity
    }
    invoiceOrderGroupFees {
      fee {
        name
      }
      total
      rate
      quantity
    }
    invoiceOrderGroupTaxes {
      tax {
        name
        rateType
      }
      total
      rate
      quantity
    }
    invoiceTaxes {
      product {
        id
      }
      customerBranchId
      tax {
        name
        erpId
        rateType
      }
      amount
      rate
      quantity
    }
    orderGroup {
      id
      completedOnTimestamp
      ratePrecision
      amountPrecision
      customerBranch {
        erpId
      }
    }
  }
}
    `;

/**
 * __useFetchInvoiceDetailsQuery__
 *
 * To run a query within a React component, call `useFetchInvoiceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchInvoiceDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchInvoiceDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchInvoiceDetailsQuery(baseOptions: Apollo.QueryHookOptions<FetchInvoiceDetailsQuery, FetchInvoiceDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchInvoiceDetailsQuery, FetchInvoiceDetailsQueryVariables>(FetchInvoiceDetailsDocument, options);
      }
export function useFetchInvoiceDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchInvoiceDetailsQuery, FetchInvoiceDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchInvoiceDetailsQuery, FetchInvoiceDetailsQueryVariables>(FetchInvoiceDetailsDocument, options);
        }
export type FetchInvoiceDetailsQueryHookResult = ReturnType<typeof useFetchInvoiceDetailsQuery>;
export type FetchInvoiceDetailsLazyQueryHookResult = ReturnType<typeof useFetchInvoiceDetailsLazyQuery>;
export type FetchInvoiceDetailsQueryResult = Apollo.QueryResult<FetchInvoiceDetailsQuery, FetchInvoiceDetailsQueryVariables>;
export const FilteredCardLockTranscationsDocument = gql`
    query FilteredCardLockTranscations($limit: Int, $offset: Int, $filter: CardLockFilters) {
  filteredCardLockTransactions(limit: $limit, offset: $offset, filter: $filter) {
    collection {
      id
      customer {
        id
        name
      }
      fleetCardNumber
      gallon
      invoiceStatus
      invoiceNumbers
      price
      product {
        erpId
        shortName
      }
      pump
      sequenceNumbers
      site
      total
      transactionTime
      truckNumber
    }
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useFilteredCardLockTranscationsQuery__
 *
 * To run a query within a React component, call `useFilteredCardLockTranscationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredCardLockTranscationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredCardLockTranscationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFilteredCardLockTranscationsQuery(baseOptions?: Apollo.QueryHookOptions<FilteredCardLockTranscationsQuery, FilteredCardLockTranscationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredCardLockTranscationsQuery, FilteredCardLockTranscationsQueryVariables>(FilteredCardLockTranscationsDocument, options);
      }
export function useFilteredCardLockTranscationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredCardLockTranscationsQuery, FilteredCardLockTranscationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredCardLockTranscationsQuery, FilteredCardLockTranscationsQueryVariables>(FilteredCardLockTranscationsDocument, options);
        }
export type FilteredCardLockTranscationsQueryHookResult = ReturnType<typeof useFilteredCardLockTranscationsQuery>;
export type FilteredCardLockTranscationsLazyQueryHookResult = ReturnType<typeof useFilteredCardLockTranscationsLazyQuery>;
export type FilteredCardLockTranscationsQueryResult = Apollo.QueryResult<FilteredCardLockTranscationsQuery, FilteredCardLockTranscationsQueryVariables>;
export const FilteredInvoicesDocument = gql`
    query FilteredInvoices($limit: Int, $offset: Int, $filter: InvoiceFilter, $sorter: [BaseSorter!]) {
  filteredInvoice(
    limit: $limit
    offset: $offset
    filter: $filter
    sorter: $sorter
  ) {
    metadata {
      hasMore
      totalCount
    }
    collection {
      id
      invoiceNumber
      status
      createdOn
      creatable {
        ... on User {
          id
          name
        }
        ... on Worker {
          id
          name
        }
        ... on Driver {
          id
          name
        }
      }
      generatedOn
      generatable {
        ... on User {
          id
          name
        }
        ... on Worker {
          id
          name
        }
        ... on Driver {
          id
          name
        }
      }
      closedOn
      closeable {
        ... on User {
          id
          name
        }
        ... on Worker {
          id
          name
        }
        ... on Driver {
          id
          name
        }
      }
      amount
      customer {
        name
        site {
          address
        }
      }
      reversedInvoices {
        id
        invoiceNumber
      }
      orderGroup {
        deliveryOrder {
          id
          type
          customerBranch {
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFilteredInvoicesQuery__
 *
 * To run a query within a React component, call `useFilteredInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredInvoicesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilteredInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<FilteredInvoicesQuery, FilteredInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredInvoicesQuery, FilteredInvoicesQueryVariables>(FilteredInvoicesDocument, options);
      }
export function useFilteredInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredInvoicesQuery, FilteredInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredInvoicesQuery, FilteredInvoicesQueryVariables>(FilteredInvoicesDocument, options);
        }
export type FilteredInvoicesQueryHookResult = ReturnType<typeof useFilteredInvoicesQuery>;
export type FilteredInvoicesLazyQueryHookResult = ReturnType<typeof useFilteredInvoicesLazyQuery>;
export type FilteredInvoicesQueryResult = Apollo.QueryResult<FilteredInvoicesQuery, FilteredInvoicesQueryVariables>;
export const UpdateInvoiceDocument = gql`
    mutation UpdateInvoice($data: InvoiceInput!) {
  updateInvoice(input: {data: $data}) {
    invoice {
      id
    }
  }
}
    `;
export type UpdateInvoiceMutationFn = Apollo.MutationFunction<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;

/**
 * __useUpdateInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceMutation, { data, loading, error }] = useUpdateInvoiceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>(UpdateInvoiceDocument, options);
      }
export type UpdateInvoiceMutationHookResult = ReturnType<typeof useUpdateInvoiceMutation>;
export type UpdateInvoiceMutationResult = Apollo.MutationResult<UpdateInvoiceMutation>;
export type UpdateInvoiceMutationOptions = Apollo.BaseMutationOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;
export const ExportTransactionDocument = gql`
    mutation ExportTransaction($input: ExportTransactionInput!) {
  exportTransactions(input: $input) {
    exportDocument {
      id
      status
      __typename
    }
    __typename
  }
}
    `;
export type ExportTransactionMutationFn = Apollo.MutationFunction<ExportTransactionMutation, ExportTransactionMutationVariables>;

/**
 * __useExportTransactionMutation__
 *
 * To run a mutation, you first call `useExportTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportTransactionMutation, { data, loading, error }] = useExportTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportTransactionMutation(baseOptions?: Apollo.MutationHookOptions<ExportTransactionMutation, ExportTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportTransactionMutation, ExportTransactionMutationVariables>(ExportTransactionDocument, options);
      }
export type ExportTransactionMutationHookResult = ReturnType<typeof useExportTransactionMutation>;
export type ExportTransactionMutationResult = Apollo.MutationResult<ExportTransactionMutation>;
export type ExportTransactionMutationOptions = Apollo.BaseMutationOptions<ExportTransactionMutation, ExportTransactionMutationVariables>;
export const FetchCreditLedgerMonthlyStatsDocument = gql`
    query FetchCreditLedgerMonthlyStats($customerId: ID!, $fromTimestamp: Int, $toTimestamp: Int) {
  creditLedgerMonthlyStats(
    customerId: $customerId
    fromTimestamp: $fromTimestamp
    toTimestamp: $toTimestamp
  ) {
    amountDebited
    amountCredited
    netAmount
  }
}
    `;

/**
 * __useFetchCreditLedgerMonthlyStatsQuery__
 *
 * To run a query within a React component, call `useFetchCreditLedgerMonthlyStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCreditLedgerMonthlyStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCreditLedgerMonthlyStatsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      fromTimestamp: // value for 'fromTimestamp'
 *      toTimestamp: // value for 'toTimestamp'
 *   },
 * });
 */
export function useFetchCreditLedgerMonthlyStatsQuery(baseOptions: Apollo.QueryHookOptions<FetchCreditLedgerMonthlyStatsQuery, FetchCreditLedgerMonthlyStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCreditLedgerMonthlyStatsQuery, FetchCreditLedgerMonthlyStatsQueryVariables>(FetchCreditLedgerMonthlyStatsDocument, options);
      }
export function useFetchCreditLedgerMonthlyStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCreditLedgerMonthlyStatsQuery, FetchCreditLedgerMonthlyStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCreditLedgerMonthlyStatsQuery, FetchCreditLedgerMonthlyStatsQueryVariables>(FetchCreditLedgerMonthlyStatsDocument, options);
        }
export type FetchCreditLedgerMonthlyStatsQueryHookResult = ReturnType<typeof useFetchCreditLedgerMonthlyStatsQuery>;
export type FetchCreditLedgerMonthlyStatsLazyQueryHookResult = ReturnType<typeof useFetchCreditLedgerMonthlyStatsLazyQuery>;
export type FetchCreditLedgerMonthlyStatsQueryResult = Apollo.QueryResult<FetchCreditLedgerMonthlyStatsQuery, FetchCreditLedgerMonthlyStatsQueryVariables>;
export const FetchCreditLedgerTransactionsDocument = gql`
    query FetchCreditLedgerTransactions($limit: Int, $offset: Int, $filter: CreditLedgerTransactionFilters) {
  fetchCreditLedgerTransactions(limit: $limit, offset: $offset, filter: $filter) {
    collection {
      id
      closingBalance
      transactionType
      createdAt
      amount
      description
      orderGroup {
        id
        deliveryOrder {
          id
        }
      }
      customer {
        id
        name
      }
      creatable {
        id
        name
      }
    }
    metadata {
      hasMore
      totalCount
    }
  }
}
    `;

/**
 * __useFetchCreditLedgerTransactionsQuery__
 *
 * To run a query within a React component, call `useFetchCreditLedgerTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCreditLedgerTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCreditLedgerTransactionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchCreditLedgerTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<FetchCreditLedgerTransactionsQuery, FetchCreditLedgerTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCreditLedgerTransactionsQuery, FetchCreditLedgerTransactionsQueryVariables>(FetchCreditLedgerTransactionsDocument, options);
      }
export function useFetchCreditLedgerTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCreditLedgerTransactionsQuery, FetchCreditLedgerTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCreditLedgerTransactionsQuery, FetchCreditLedgerTransactionsQueryVariables>(FetchCreditLedgerTransactionsDocument, options);
        }
export type FetchCreditLedgerTransactionsQueryHookResult = ReturnType<typeof useFetchCreditLedgerTransactionsQuery>;
export type FetchCreditLedgerTransactionsLazyQueryHookResult = ReturnType<typeof useFetchCreditLedgerTransactionsLazyQuery>;
export type FetchCreditLedgerTransactionsQueryResult = Apollo.QueryResult<FetchCreditLedgerTransactionsQuery, FetchCreditLedgerTransactionsQueryVariables>;
export const FetchCreditLedgerBalanceDocument = gql`
    query FetchCreditLedgerBalance($id: ID!) {
  customer(id: $id) {
    id
    creditLedgerBalance
    creditLimitExceeded
  }
}
    `;

/**
 * __useFetchCreditLedgerBalanceQuery__
 *
 * To run a query within a React component, call `useFetchCreditLedgerBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCreditLedgerBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCreditLedgerBalanceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchCreditLedgerBalanceQuery(baseOptions: Apollo.QueryHookOptions<FetchCreditLedgerBalanceQuery, FetchCreditLedgerBalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCreditLedgerBalanceQuery, FetchCreditLedgerBalanceQueryVariables>(FetchCreditLedgerBalanceDocument, options);
      }
export function useFetchCreditLedgerBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCreditLedgerBalanceQuery, FetchCreditLedgerBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCreditLedgerBalanceQuery, FetchCreditLedgerBalanceQueryVariables>(FetchCreditLedgerBalanceDocument, options);
        }
export type FetchCreditLedgerBalanceQueryHookResult = ReturnType<typeof useFetchCreditLedgerBalanceQuery>;
export type FetchCreditLedgerBalanceLazyQueryHookResult = ReturnType<typeof useFetchCreditLedgerBalanceLazyQuery>;
export type FetchCreditLedgerBalanceQueryResult = Apollo.QueryResult<FetchCreditLedgerBalanceQuery, FetchCreditLedgerBalanceQueryVariables>;
export const FundCustomerBalanceDocument = gql`
    mutation FundCustomerBalance($input: FundCustomerBalanceInput!) {
  fundCustomerBalance(input: $input) {
    creditLedgerType {
      success
      error
      creditLedgerTransaction {
        id
        amount
      }
    }
  }
}
    `;
export type FundCustomerBalanceMutationFn = Apollo.MutationFunction<FundCustomerBalanceMutation, FundCustomerBalanceMutationVariables>;

/**
 * __useFundCustomerBalanceMutation__
 *
 * To run a mutation, you first call `useFundCustomerBalanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFundCustomerBalanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fundCustomerBalanceMutation, { data, loading, error }] = useFundCustomerBalanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFundCustomerBalanceMutation(baseOptions?: Apollo.MutationHookOptions<FundCustomerBalanceMutation, FundCustomerBalanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FundCustomerBalanceMutation, FundCustomerBalanceMutationVariables>(FundCustomerBalanceDocument, options);
      }
export type FundCustomerBalanceMutationHookResult = ReturnType<typeof useFundCustomerBalanceMutation>;
export type FundCustomerBalanceMutationResult = Apollo.MutationResult<FundCustomerBalanceMutation>;
export type FundCustomerBalanceMutationOptions = Apollo.BaseMutationOptions<FundCustomerBalanceMutation, FundCustomerBalanceMutationVariables>;
export const CreateOrUpdateCustomerPortalConfigurationDocument = gql`
    mutation CreateOrUpdateCustomerPortalConfiguration($input: CreateOrUpdateCustomerPortalConfigurationInput!) {
  createOrUpdateCustomerPortalConfiguration(input: $input) {
    customerPortalConfiguration {
      id
      landscapeLogoUrl
      squareLogoUrl
      primaryColor
      secondaryColor
      welcomeMessage
      notificationEmails
    }
    success
    errors
  }
}
    `;
export type CreateOrUpdateCustomerPortalConfigurationMutationFn = Apollo.MutationFunction<CreateOrUpdateCustomerPortalConfigurationMutation, CreateOrUpdateCustomerPortalConfigurationMutationVariables>;

/**
 * __useCreateOrUpdateCustomerPortalConfigurationMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateCustomerPortalConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateCustomerPortalConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateCustomerPortalConfigurationMutation, { data, loading, error }] = useCreateOrUpdateCustomerPortalConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateCustomerPortalConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateCustomerPortalConfigurationMutation, CreateOrUpdateCustomerPortalConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateCustomerPortalConfigurationMutation, CreateOrUpdateCustomerPortalConfigurationMutationVariables>(CreateOrUpdateCustomerPortalConfigurationDocument, options);
      }
export type CreateOrUpdateCustomerPortalConfigurationMutationHookResult = ReturnType<typeof useCreateOrUpdateCustomerPortalConfigurationMutation>;
export type CreateOrUpdateCustomerPortalConfigurationMutationResult = Apollo.MutationResult<CreateOrUpdateCustomerPortalConfigurationMutation>;
export type CreateOrUpdateCustomerPortalConfigurationMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateCustomerPortalConfigurationMutation, CreateOrUpdateCustomerPortalConfigurationMutationVariables>;
export const FetchCustomerPortalConfigDocument = gql`
    query FetchCustomerPortalConfig {
  customerPortalConfig {
    secondaryColor
    primaryColor
    landscapeLogoUrl
    squareLogoUrl
    welcomeMessage
    id
    domains
    notificationEmails
    notificationPhones
    notificationChannels
  }
}
    `;

/**
 * __useFetchCustomerPortalConfigQuery__
 *
 * To run a query within a React component, call `useFetchCustomerPortalConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomerPortalConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomerPortalConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchCustomerPortalConfigQuery(baseOptions?: Apollo.QueryHookOptions<FetchCustomerPortalConfigQuery, FetchCustomerPortalConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomerPortalConfigQuery, FetchCustomerPortalConfigQueryVariables>(FetchCustomerPortalConfigDocument, options);
      }
export function useFetchCustomerPortalConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomerPortalConfigQuery, FetchCustomerPortalConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomerPortalConfigQuery, FetchCustomerPortalConfigQueryVariables>(FetchCustomerPortalConfigDocument, options);
        }
export type FetchCustomerPortalConfigQueryHookResult = ReturnType<typeof useFetchCustomerPortalConfigQuery>;
export type FetchCustomerPortalConfigLazyQueryHookResult = ReturnType<typeof useFetchCustomerPortalConfigLazyQuery>;
export type FetchCustomerPortalConfigQueryResult = Apollo.QueryResult<FetchCustomerPortalConfigQuery, FetchCustomerPortalConfigQueryVariables>;
export const CreateOrderGroupsDocument = gql`
    mutation CreateOrderGroups($orderGroups: [OrderGroupInput!]!) {
  createOrderGroups(input: {orderGroupsAttributes: $orderGroups}) {
    orderGroups {
      id
    }
  }
}
    `;
export type CreateOrderGroupsMutationFn = Apollo.MutationFunction<CreateOrderGroupsMutation, CreateOrderGroupsMutationVariables>;

/**
 * __useCreateOrderGroupsMutation__
 *
 * To run a mutation, you first call `useCreateOrderGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderGroupsMutation, { data, loading, error }] = useCreateOrderGroupsMutation({
 *   variables: {
 *      orderGroups: // value for 'orderGroups'
 *   },
 * });
 */
export function useCreateOrderGroupsMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderGroupsMutation, CreateOrderGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderGroupsMutation, CreateOrderGroupsMutationVariables>(CreateOrderGroupsDocument, options);
      }
export type CreateOrderGroupsMutationHookResult = ReturnType<typeof useCreateOrderGroupsMutation>;
export type CreateOrderGroupsMutationResult = Apollo.MutationResult<CreateOrderGroupsMutation>;
export type CreateOrderGroupsMutationOptions = Apollo.BaseMutationOptions<CreateOrderGroupsMutation, CreateOrderGroupsMutationVariables>;
export const CreateSiteRecurrenceDocument = gql`
    mutation CreateSiteRecurrence($input: CreateSiteRecurrenceInput!) {
  createSiteRecurrence(input: $input) {
    orderGroup {
      id
    }
  }
}
    `;
export type CreateSiteRecurrenceMutationFn = Apollo.MutationFunction<CreateSiteRecurrenceMutation, CreateSiteRecurrenceMutationVariables>;

/**
 * __useCreateSiteRecurrenceMutation__
 *
 * To run a mutation, you first call `useCreateSiteRecurrenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSiteRecurrenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSiteRecurrenceMutation, { data, loading, error }] = useCreateSiteRecurrenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSiteRecurrenceMutation(baseOptions?: Apollo.MutationHookOptions<CreateSiteRecurrenceMutation, CreateSiteRecurrenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSiteRecurrenceMutation, CreateSiteRecurrenceMutationVariables>(CreateSiteRecurrenceDocument, options);
      }
export type CreateSiteRecurrenceMutationHookResult = ReturnType<typeof useCreateSiteRecurrenceMutation>;
export type CreateSiteRecurrenceMutationResult = Apollo.MutationResult<CreateSiteRecurrenceMutation>;
export type CreateSiteRecurrenceMutationOptions = Apollo.BaseMutationOptions<CreateSiteRecurrenceMutation, CreateSiteRecurrenceMutationVariables>;
export const FetchCustomerByIdForOrderDocument = gql`
    query FetchCustomerByIdForOrder($customerId: ID!) {
  customer(id: $customerId) {
    id
    name
    address
    purchaseOrderType
    customerBranches {
      id
      name
      email
      phone
      address
      purchaseOrder
      purchaseOrderType
      deliveryInstruction
      site {
        address
      }
      storageAssets {
        id
        name
        category
        useInDelivery
        licensePlateNumber
        subscriptions {
          id
          product {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchCustomerByIdForOrderQuery__
 *
 * To run a query within a React component, call `useFetchCustomerByIdForOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomerByIdForOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomerByIdForOrderQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useFetchCustomerByIdForOrderQuery(baseOptions: Apollo.QueryHookOptions<FetchCustomerByIdForOrderQuery, FetchCustomerByIdForOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomerByIdForOrderQuery, FetchCustomerByIdForOrderQueryVariables>(FetchCustomerByIdForOrderDocument, options);
      }
export function useFetchCustomerByIdForOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomerByIdForOrderQuery, FetchCustomerByIdForOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomerByIdForOrderQuery, FetchCustomerByIdForOrderQueryVariables>(FetchCustomerByIdForOrderDocument, options);
        }
export type FetchCustomerByIdForOrderQueryHookResult = ReturnType<typeof useFetchCustomerByIdForOrderQuery>;
export type FetchCustomerByIdForOrderLazyQueryHookResult = ReturnType<typeof useFetchCustomerByIdForOrderLazyQuery>;
export type FetchCustomerByIdForOrderQueryResult = Apollo.QueryResult<FetchCustomerByIdForOrderQuery, FetchCustomerByIdForOrderQueryVariables>;
export const FilteredCustomerBranchesForDropdownDocument = gql`
    query FilteredCustomerBranchesForDropdown($sorter: [CustomerBranchSorter!], $perPage: Int, $offSet: Int, $searchText: String, $customerId: ID) {
  filteredCustomerBranches(
    limit: $perPage
    offset: $offSet
    sorter: $sorter
    filter: {customerId: $customerId, name: $searchText}
  ) {
    collection {
      id
      name
      address
      status
      deliveryInstruction
    }
    metadata {
      hasMore
    }
  }
}
    `;

/**
 * __useFilteredCustomerBranchesForDropdownQuery__
 *
 * To run a query within a React component, call `useFilteredCustomerBranchesForDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredCustomerBranchesForDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredCustomerBranchesForDropdownQuery({
 *   variables: {
 *      sorter: // value for 'sorter'
 *      perPage: // value for 'perPage'
 *      offSet: // value for 'offSet'
 *      searchText: // value for 'searchText'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useFilteredCustomerBranchesForDropdownQuery(baseOptions?: Apollo.QueryHookOptions<FilteredCustomerBranchesForDropdownQuery, FilteredCustomerBranchesForDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredCustomerBranchesForDropdownQuery, FilteredCustomerBranchesForDropdownQueryVariables>(FilteredCustomerBranchesForDropdownDocument, options);
      }
export function useFilteredCustomerBranchesForDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredCustomerBranchesForDropdownQuery, FilteredCustomerBranchesForDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredCustomerBranchesForDropdownQuery, FilteredCustomerBranchesForDropdownQueryVariables>(FilteredCustomerBranchesForDropdownDocument, options);
        }
export type FilteredCustomerBranchesForDropdownQueryHookResult = ReturnType<typeof useFilteredCustomerBranchesForDropdownQuery>;
export type FilteredCustomerBranchesForDropdownLazyQueryHookResult = ReturnType<typeof useFilteredCustomerBranchesForDropdownLazyQuery>;
export type FilteredCustomerBranchesForDropdownQueryResult = Apollo.QueryResult<FilteredCustomerBranchesForDropdownQuery, FilteredCustomerBranchesForDropdownQueryVariables>;
export const FilteredCustomerBranchesShipToDocument = gql`
    query FilteredCustomerBranchesShipTo($sorter: [CustomerBranchSorter!], $perPage: Int, $offSet: Int, $searchText: String) {
  filteredCustomerBranches(
    limit: $perPage
    offset: $offSet
    sorter: $sorter
    filter: {all: $searchText}
  ) {
    collection {
      id
      name
      customer {
        id
        name
      }
    }
    metadata {
      hasMore
    }
  }
}
    `;

/**
 * __useFilteredCustomerBranchesShipToQuery__
 *
 * To run a query within a React component, call `useFilteredCustomerBranchesShipToQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredCustomerBranchesShipToQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredCustomerBranchesShipToQuery({
 *   variables: {
 *      sorter: // value for 'sorter'
 *      perPage: // value for 'perPage'
 *      offSet: // value for 'offSet'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useFilteredCustomerBranchesShipToQuery(baseOptions?: Apollo.QueryHookOptions<FilteredCustomerBranchesShipToQuery, FilteredCustomerBranchesShipToQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredCustomerBranchesShipToQuery, FilteredCustomerBranchesShipToQueryVariables>(FilteredCustomerBranchesShipToDocument, options);
      }
export function useFilteredCustomerBranchesShipToLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredCustomerBranchesShipToQuery, FilteredCustomerBranchesShipToQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredCustomerBranchesShipToQuery, FilteredCustomerBranchesShipToQueryVariables>(FilteredCustomerBranchesShipToDocument, options);
        }
export type FilteredCustomerBranchesShipToQueryHookResult = ReturnType<typeof useFilteredCustomerBranchesShipToQuery>;
export type FilteredCustomerBranchesShipToLazyQueryHookResult = ReturnType<typeof useFilteredCustomerBranchesShipToLazyQuery>;
export type FilteredCustomerBranchesShipToQueryResult = Apollo.QueryResult<FilteredCustomerBranchesShipToQuery, FilteredCustomerBranchesShipToQueryVariables>;
export const FilteredCustomersDocument = gql`
    query filteredCustomers($sorter: [BaseSorter!], $perPage: Int, $offSet: Int, $searchText: String, $active: Boolean) {
  filteredCustomers(
    limit: $perPage
    offset: $offSet
    sorter: $sorter
    filter: {name: $searchText, resource: Customer, active: $active}
  ) {
    collection {
      id
      name
      address
      erpId
      deliveryInstruction
    }
    metadata {
      hasMore
    }
  }
}
    `;

/**
 * __useFilteredCustomersQuery__
 *
 * To run a query within a React component, call `useFilteredCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredCustomersQuery({
 *   variables: {
 *      sorter: // value for 'sorter'
 *      perPage: // value for 'perPage'
 *      offSet: // value for 'offSet'
 *      searchText: // value for 'searchText'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useFilteredCustomersQuery(baseOptions?: Apollo.QueryHookOptions<FilteredCustomersQuery, FilteredCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredCustomersQuery, FilteredCustomersQueryVariables>(FilteredCustomersDocument, options);
      }
export function useFilteredCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredCustomersQuery, FilteredCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredCustomersQuery, FilteredCustomersQueryVariables>(FilteredCustomersDocument, options);
        }
export type FilteredCustomersQueryHookResult = ReturnType<typeof useFilteredCustomersQuery>;
export type FilteredCustomersLazyQueryHookResult = ReturnType<typeof useFilteredCustomersLazyQuery>;
export type FilteredCustomersQueryResult = Apollo.QueryResult<FilteredCustomersQuery, FilteredCustomersQueryVariables>;
export const FetchFilteredRecurrenceOrdersDocument = gql`
    query FetchFilteredRecurrenceOrders($limit: Int, $offset: Int, $sorter: [OrderGroupSorter!], $filter: OrderGroupFilter) {
  filteredOrderGroups(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: $filter
  ) {
    collection {
      id
      status
      creatable {
        type: __typename
        ... on User {
          name
        }
      }
      recurrenceData {
        lastDelivery
        nextDate
        recurrence {
          recurrenceFromTimestamp
          recurrenceType
          recurrenceDates
          recurrenceDays
          recurrenceInterval
          recurrenceUntil
          recurrenceOccurrences
          recurrenceDaysOfWeek
          recurrenceDaysInAdvance
          recurrenceAutoExpired
          recurrenceDayNthWeek {
            sunday
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
          }
        }
      }
      deliveryOrder {
        id
        status
        source
        deliveryOrderLineItems {
          id
          topOff
          requestedVolume
          warehouseId
          warehouse {
            id
            name
          }
          product {
            id
            name
            productType
            shortName
            unit
            code
            colorCode
          }
          subscription {
            id
            asset {
              id
              name
              status
            }
            product {
              id
              name
            }
          }
        }
        customerBranch {
          id
          name
          status
          customer {
            id
            name
          }
        }
        tenantName
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFetchFilteredRecurrenceOrdersQuery__
 *
 * To run a query within a React component, call `useFetchFilteredRecurrenceOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredRecurrenceOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredRecurrenceOrdersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchFilteredRecurrenceOrdersQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredRecurrenceOrdersQuery, FetchFilteredRecurrenceOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredRecurrenceOrdersQuery, FetchFilteredRecurrenceOrdersQueryVariables>(FetchFilteredRecurrenceOrdersDocument, options);
      }
export function useFetchFilteredRecurrenceOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredRecurrenceOrdersQuery, FetchFilteredRecurrenceOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredRecurrenceOrdersQuery, FetchFilteredRecurrenceOrdersQueryVariables>(FetchFilteredRecurrenceOrdersDocument, options);
        }
export type FetchFilteredRecurrenceOrdersQueryHookResult = ReturnType<typeof useFetchFilteredRecurrenceOrdersQuery>;
export type FetchFilteredRecurrenceOrdersLazyQueryHookResult = ReturnType<typeof useFetchFilteredRecurrenceOrdersLazyQuery>;
export type FetchFilteredRecurrenceOrdersQueryResult = Apollo.QueryResult<FetchFilteredRecurrenceOrdersQuery, FetchFilteredRecurrenceOrdersQueryVariables>;
export const UpdateSiteRecurrenceDocument = gql`
    mutation UpdateSiteRecurrence($input: UpdateSiteRecurrenceInput!) {
  updateSiteRecurrence(input: $input) {
    orderGroups {
      id
    }
  }
}
    `;
export type UpdateSiteRecurrenceMutationFn = Apollo.MutationFunction<UpdateSiteRecurrenceMutation, UpdateSiteRecurrenceMutationVariables>;

/**
 * __useUpdateSiteRecurrenceMutation__
 *
 * To run a mutation, you first call `useUpdateSiteRecurrenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteRecurrenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteRecurrenceMutation, { data, loading, error }] = useUpdateSiteRecurrenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSiteRecurrenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteRecurrenceMutation, UpdateSiteRecurrenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteRecurrenceMutation, UpdateSiteRecurrenceMutationVariables>(UpdateSiteRecurrenceDocument, options);
      }
export type UpdateSiteRecurrenceMutationHookResult = ReturnType<typeof useUpdateSiteRecurrenceMutation>;
export type UpdateSiteRecurrenceMutationResult = Apollo.MutationResult<UpdateSiteRecurrenceMutation>;
export type UpdateSiteRecurrenceMutationOptions = Apollo.BaseMutationOptions<UpdateSiteRecurrenceMutation, UpdateSiteRecurrenceMutationVariables>;
export const BulkAssignDocument = gql`
    mutation BulkAssign($input: BatchOperationsInput!) {
  bulkAssigns(input: $input) {
    result {
      orderGroups {
        successIds
        failureIds
        errors
      }
    }
  }
}
    `;
export type BulkAssignMutationFn = Apollo.MutationFunction<BulkAssignMutation, BulkAssignMutationVariables>;

/**
 * __useBulkAssignMutation__
 *
 * To run a mutation, you first call `useBulkAssignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAssignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAssignMutation, { data, loading, error }] = useBulkAssignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkAssignMutation(baseOptions?: Apollo.MutationHookOptions<BulkAssignMutation, BulkAssignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkAssignMutation, BulkAssignMutationVariables>(BulkAssignDocument, options);
      }
export type BulkAssignMutationHookResult = ReturnType<typeof useBulkAssignMutation>;
export type BulkAssignMutationResult = Apollo.MutationResult<BulkAssignMutation>;
export type BulkAssignMutationOptions = Apollo.BaseMutationOptions<BulkAssignMutation, BulkAssignMutationVariables>;
export const BulkOrderUnblockDocument = gql`
    mutation BulkOrderUnblock($orderIds: [ID!]!) {
  bulkOrderUnblocks(input: {ids: $orderIds}) {
    result {
      successIds
      failureIds
      invalidIds
      errors
    }
  }
}
    `;
export type BulkOrderUnblockMutationFn = Apollo.MutationFunction<BulkOrderUnblockMutation, BulkOrderUnblockMutationVariables>;

/**
 * __useBulkOrderUnblockMutation__
 *
 * To run a mutation, you first call `useBulkOrderUnblockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkOrderUnblockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkOrderUnblockMutation, { data, loading, error }] = useBulkOrderUnblockMutation({
 *   variables: {
 *      orderIds: // value for 'orderIds'
 *   },
 * });
 */
export function useBulkOrderUnblockMutation(baseOptions?: Apollo.MutationHookOptions<BulkOrderUnblockMutation, BulkOrderUnblockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkOrderUnblockMutation, BulkOrderUnblockMutationVariables>(BulkOrderUnblockDocument, options);
      }
export type BulkOrderUnblockMutationHookResult = ReturnType<typeof useBulkOrderUnblockMutation>;
export type BulkOrderUnblockMutationResult = Apollo.MutationResult<BulkOrderUnblockMutation>;
export type BulkOrderUnblockMutationOptions = Apollo.BaseMutationOptions<BulkOrderUnblockMutation, BulkOrderUnblockMutationVariables>;
export const CcTenantsDocument = gql`
    query ccTenants($filter: CcTenantFilterInput) {
  ccTenants(filter: $filter) {
    id
    name
    carrierTenant {
      id
    }
  }
}
    `;

/**
 * __useCcTenantsQuery__
 *
 * To run a query within a React component, call `useCcTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCcTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCcTenantsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCcTenantsQuery(baseOptions?: Apollo.QueryHookOptions<CcTenantsQuery, CcTenantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CcTenantsQuery, CcTenantsQueryVariables>(CcTenantsDocument, options);
      }
export function useCcTenantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CcTenantsQuery, CcTenantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CcTenantsQuery, CcTenantsQueryVariables>(CcTenantsDocument, options);
        }
export type CcTenantsQueryHookResult = ReturnType<typeof useCcTenantsQuery>;
export type CcTenantsLazyQueryHookResult = ReturnType<typeof useCcTenantsLazyQuery>;
export type CcTenantsQueryResult = Apollo.QueryResult<CcTenantsQuery, CcTenantsQueryVariables>;
export const FetchCustomerTimeDocument = gql`
    query FetchCustomerTime($customerId: ID!) {
  customer(id: $customerId) {
    resourceSchedule {
      availability {
        day
        startTime
        endTime
      }
    }
  }
}
    `;

/**
 * __useFetchCustomerTimeQuery__
 *
 * To run a query within a React component, call `useFetchCustomerTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomerTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomerTimeQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useFetchCustomerTimeQuery(baseOptions: Apollo.QueryHookOptions<FetchCustomerTimeQuery, FetchCustomerTimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomerTimeQuery, FetchCustomerTimeQueryVariables>(FetchCustomerTimeDocument, options);
      }
export function useFetchCustomerTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomerTimeQuery, FetchCustomerTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomerTimeQuery, FetchCustomerTimeQueryVariables>(FetchCustomerTimeDocument, options);
        }
export type FetchCustomerTimeQueryHookResult = ReturnType<typeof useFetchCustomerTimeQuery>;
export type FetchCustomerTimeLazyQueryHookResult = ReturnType<typeof useFetchCustomerTimeLazyQuery>;
export type FetchCustomerTimeQueryResult = Apollo.QueryResult<FetchCustomerTimeQuery, FetchCustomerTimeQueryVariables>;
export const FetchShipToTimeDocument = gql`
    query FetchShipToTime($customerBranchId: ID!) {
  customerBranch(id: $customerBranchId) {
    resourceSchedule {
      availability {
        day
        startTime
        endTime
        bestEndTime
        bestStartTime
      }
    }
  }
}
    `;

/**
 * __useFetchShipToTimeQuery__
 *
 * To run a query within a React component, call `useFetchShipToTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchShipToTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchShipToTimeQuery({
 *   variables: {
 *      customerBranchId: // value for 'customerBranchId'
 *   },
 * });
 */
export function useFetchShipToTimeQuery(baseOptions: Apollo.QueryHookOptions<FetchShipToTimeQuery, FetchShipToTimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchShipToTimeQuery, FetchShipToTimeQueryVariables>(FetchShipToTimeDocument, options);
      }
export function useFetchShipToTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchShipToTimeQuery, FetchShipToTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchShipToTimeQuery, FetchShipToTimeQueryVariables>(FetchShipToTimeDocument, options);
        }
export type FetchShipToTimeQueryHookResult = ReturnType<typeof useFetchShipToTimeQuery>;
export type FetchShipToTimeLazyQueryHookResult = ReturnType<typeof useFetchShipToTimeLazyQuery>;
export type FetchShipToTimeQueryResult = Apollo.QueryResult<FetchShipToTimeQuery, FetchShipToTimeQueryVariables>;
export const FetchActiveCountDocument = gql`
    query fetchActiveCount($filter: UnifiedTankFilterInput) {
  degreeDayTanks(limit: 0, offset: 0, filter: $filter) {
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useFetchActiveCountQuery__
 *
 * To run a query within a React component, call `useFetchActiveCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchActiveCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchActiveCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchActiveCountQuery(baseOptions?: Apollo.QueryHookOptions<FetchActiveCountQuery, FetchActiveCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchActiveCountQuery, FetchActiveCountQueryVariables>(FetchActiveCountDocument, options);
      }
export function useFetchActiveCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchActiveCountQuery, FetchActiveCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchActiveCountQuery, FetchActiveCountQueryVariables>(FetchActiveCountDocument, options);
        }
export type FetchActiveCountQueryHookResult = ReturnType<typeof useFetchActiveCountQuery>;
export type FetchActiveCountLazyQueryHookResult = ReturnType<typeof useFetchActiveCountLazyQuery>;
export type FetchActiveCountQueryResult = Apollo.QueryResult<FetchActiveCountQuery, FetchActiveCountQueryVariables>;
export const FetchFilterCustomerBranchDocument = gql`
    query fetchFilterCustomerBranch($isHub: Boolean, $searchText: String, $customerId: ID) {
  filteredCustomerBranches(
    limit: 10
    offset: 0
    filter: {name: $searchText, isHub: $isHub, customerId: $customerId}
  ) {
    collection {
      id
      name
    }
    metadata {
      hasMore
    }
  }
}
    `;

/**
 * __useFetchFilterCustomerBranchQuery__
 *
 * To run a query within a React component, call `useFetchFilterCustomerBranchQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilterCustomerBranchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilterCustomerBranchQuery({
 *   variables: {
 *      isHub: // value for 'isHub'
 *      searchText: // value for 'searchText'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useFetchFilterCustomerBranchQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilterCustomerBranchQuery, FetchFilterCustomerBranchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilterCustomerBranchQuery, FetchFilterCustomerBranchQueryVariables>(FetchFilterCustomerBranchDocument, options);
      }
export function useFetchFilterCustomerBranchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilterCustomerBranchQuery, FetchFilterCustomerBranchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilterCustomerBranchQuery, FetchFilterCustomerBranchQueryVariables>(FetchFilterCustomerBranchDocument, options);
        }
export type FetchFilterCustomerBranchQueryHookResult = ReturnType<typeof useFetchFilterCustomerBranchQuery>;
export type FetchFilterCustomerBranchLazyQueryHookResult = ReturnType<typeof useFetchFilterCustomerBranchLazyQuery>;
export type FetchFilterCustomerBranchQueryResult = Apollo.QueryResult<FetchFilterCustomerBranchQuery, FetchFilterCustomerBranchQueryVariables>;
export const FetchFilterCustomersDocument = gql`
    query fetchFilterCustomers($searchText: String) {
  filteredCustomers(limit: 10, offset: 0, filter: {name: $searchText}) {
    collection {
      id
      name
    }
    metadata {
      hasMore
    }
  }
}
    `;

/**
 * __useFetchFilterCustomersQuery__
 *
 * To run a query within a React component, call `useFetchFilterCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilterCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilterCustomersQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useFetchFilterCustomersQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilterCustomersQuery, FetchFilterCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilterCustomersQuery, FetchFilterCustomersQueryVariables>(FetchFilterCustomersDocument, options);
      }
export function useFetchFilterCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilterCustomersQuery, FetchFilterCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilterCustomersQuery, FetchFilterCustomersQueryVariables>(FetchFilterCustomersDocument, options);
        }
export type FetchFilterCustomersQueryHookResult = ReturnType<typeof useFetchFilterCustomersQuery>;
export type FetchFilterCustomersLazyQueryHookResult = ReturnType<typeof useFetchFilterCustomersLazyQuery>;
export type FetchFilterCustomersQueryResult = Apollo.QueryResult<FetchFilterCustomersQuery, FetchFilterCustomersQueryVariables>;
export const FetchFilterOrderIdDocument = gql`
    query fetchFilterOrderId($searchText: String) {
  filteredDeliveryOrderLineItems(
    sorter: {field: planned_at, order: desc}
    limit: 10
    offset: 0
    filter: {all: $searchText}
  ) {
    collection {
      id
      deliveryOrder {
        orderGroup {
          id
        }
      }
    }
    metadata {
      hasMore
    }
  }
}
    `;

/**
 * __useFetchFilterOrderIdQuery__
 *
 * To run a query within a React component, call `useFetchFilterOrderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilterOrderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilterOrderIdQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useFetchFilterOrderIdQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilterOrderIdQuery, FetchFilterOrderIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilterOrderIdQuery, FetchFilterOrderIdQueryVariables>(FetchFilterOrderIdDocument, options);
      }
export function useFetchFilterOrderIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilterOrderIdQuery, FetchFilterOrderIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilterOrderIdQuery, FetchFilterOrderIdQueryVariables>(FetchFilterOrderIdDocument, options);
        }
export type FetchFilterOrderIdQueryHookResult = ReturnType<typeof useFetchFilterOrderIdQuery>;
export type FetchFilterOrderIdLazyQueryHookResult = ReturnType<typeof useFetchFilterOrderIdLazyQuery>;
export type FetchFilterOrderIdQueryResult = Apollo.QueryResult<FetchFilterOrderIdQuery, FetchFilterOrderIdQueryVariables>;
export const FetchFilterTanksDocument = gql`
    query fetchFilterTanks($searchText: String) {
  filteredAssets(limit: 10, offset: 0, filter: {all: $searchText}) {
    collection {
      id
      name
    }
    metadata {
      hasMore
    }
  }
}
    `;

/**
 * __useFetchFilterTanksQuery__
 *
 * To run a query within a React component, call `useFetchFilterTanksQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilterTanksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilterTanksQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useFetchFilterTanksQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilterTanksQuery, FetchFilterTanksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilterTanksQuery, FetchFilterTanksQueryVariables>(FetchFilterTanksDocument, options);
      }
export function useFetchFilterTanksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilterTanksQuery, FetchFilterTanksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilterTanksQuery, FetchFilterTanksQueryVariables>(FetchFilterTanksDocument, options);
        }
export type FetchFilterTanksQueryHookResult = ReturnType<typeof useFetchFilterTanksQuery>;
export type FetchFilterTanksLazyQueryHookResult = ReturnType<typeof useFetchFilterTanksLazyQuery>;
export type FetchFilterTanksQueryResult = Apollo.QueryResult<FetchFilterTanksQuery, FetchFilterTanksQueryVariables>;
export const FetchOrderHistoryCountDocument = gql`
    query fetchOrderHistoryCount($filter: DoliHistoryFilterInput) {
  filteredDeliveryOrderLineItems(limit: 0, offset: 0, filter: $filter) {
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useFetchOrderHistoryCountQuery__
 *
 * To run a query within a React component, call `useFetchOrderHistoryCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOrderHistoryCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOrderHistoryCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchOrderHistoryCountQuery(baseOptions?: Apollo.QueryHookOptions<FetchOrderHistoryCountQuery, FetchOrderHistoryCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchOrderHistoryCountQuery, FetchOrderHistoryCountQueryVariables>(FetchOrderHistoryCountDocument, options);
      }
export function useFetchOrderHistoryCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchOrderHistoryCountQuery, FetchOrderHistoryCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchOrderHistoryCountQuery, FetchOrderHistoryCountQueryVariables>(FetchOrderHistoryCountDocument, options);
        }
export type FetchOrderHistoryCountQueryHookResult = ReturnType<typeof useFetchOrderHistoryCountQuery>;
export type FetchOrderHistoryCountLazyQueryHookResult = ReturnType<typeof useFetchOrderHistoryCountLazyQuery>;
export type FetchOrderHistoryCountQueryResult = Apollo.QueryResult<FetchOrderHistoryCountQuery, FetchOrderHistoryCountQueryVariables>;
export const CreateDegreeDaySettingDocument = gql`
    mutation CreateDegreeDaySetting($input: [DegreeDaySettingInput!]!) {
  createDegreeDaySetting(input: $input) {
    degreeDaySettings {
      adjustmentUnit
      adjustmentQuantity
      assetId
      autoOrdering
      createdAt
      daysToEmptyThreshold
      degreeDayReset
      disabledAt
      enabled
      hubIds
      id
      kFactor
      orderConfirmation
      orderNumber
      orderStatus
      purchaseOrderRequired
      safeLimit
      tankCapacity
      tankType
      tenantId
      updatedAt
    }
    errors
    success
  }
}
    `;
export type CreateDegreeDaySettingMutationFn = Apollo.MutationFunction<CreateDegreeDaySettingMutation, CreateDegreeDaySettingMutationVariables>;

/**
 * __useCreateDegreeDaySettingMutation__
 *
 * To run a mutation, you first call `useCreateDegreeDaySettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDegreeDaySettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDegreeDaySettingMutation, { data, loading, error }] = useCreateDegreeDaySettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDegreeDaySettingMutation(baseOptions?: Apollo.MutationHookOptions<CreateDegreeDaySettingMutation, CreateDegreeDaySettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDegreeDaySettingMutation, CreateDegreeDaySettingMutationVariables>(CreateDegreeDaySettingDocument, options);
      }
export type CreateDegreeDaySettingMutationHookResult = ReturnType<typeof useCreateDegreeDaySettingMutation>;
export type CreateDegreeDaySettingMutationResult = Apollo.MutationResult<CreateDegreeDaySettingMutation>;
export type CreateDegreeDaySettingMutationOptions = Apollo.BaseMutationOptions<CreateDegreeDaySettingMutation, CreateDegreeDaySettingMutationVariables>;
export const CreateAutoOrderDocument = gql`
    mutation CreateAutoOrder($input: [DegreeDaySettingInput!]!) {
  updateDegreeDaySetting(input: $input) {
    degreeDaySettings {
      id
      assetId
      autoOrdering
    }
    errors
    success
  }
}
    `;
export type CreateAutoOrderMutationFn = Apollo.MutationFunction<CreateAutoOrderMutation, CreateAutoOrderMutationVariables>;

/**
 * __useCreateAutoOrderMutation__
 *
 * To run a mutation, you first call `useCreateAutoOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutoOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAutoOrderMutation, { data, loading, error }] = useCreateAutoOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAutoOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateAutoOrderMutation, CreateAutoOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAutoOrderMutation, CreateAutoOrderMutationVariables>(CreateAutoOrderDocument, options);
      }
export type CreateAutoOrderMutationHookResult = ReturnType<typeof useCreateAutoOrderMutation>;
export type CreateAutoOrderMutationResult = Apollo.MutationResult<CreateAutoOrderMutation>;
export type CreateAutoOrderMutationOptions = Apollo.BaseMutationOptions<CreateAutoOrderMutation, CreateAutoOrderMutationVariables>;
export const CreateMultiOrderTopOffDocument = gql`
    mutation CreateMultiOrderTopOff($assetIds: [ID!]!, $isSelectAll: Boolean) {
  createMultiOrderTopOff(assetIds: $assetIds, isSelectAll: $isSelectAll) {
    success
    errors
  }
}
    `;
export type CreateMultiOrderTopOffMutationFn = Apollo.MutationFunction<CreateMultiOrderTopOffMutation, CreateMultiOrderTopOffMutationVariables>;

/**
 * __useCreateMultiOrderTopOffMutation__
 *
 * To run a mutation, you first call `useCreateMultiOrderTopOffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMultiOrderTopOffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMultiOrderTopOffMutation, { data, loading, error }] = useCreateMultiOrderTopOffMutation({
 *   variables: {
 *      assetIds: // value for 'assetIds'
 *      isSelectAll: // value for 'isSelectAll'
 *   },
 * });
 */
export function useCreateMultiOrderTopOffMutation(baseOptions?: Apollo.MutationHookOptions<CreateMultiOrderTopOffMutation, CreateMultiOrderTopOffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMultiOrderTopOffMutation, CreateMultiOrderTopOffMutationVariables>(CreateMultiOrderTopOffDocument, options);
      }
export type CreateMultiOrderTopOffMutationHookResult = ReturnType<typeof useCreateMultiOrderTopOffMutation>;
export type CreateMultiOrderTopOffMutationResult = Apollo.MutationResult<CreateMultiOrderTopOffMutation>;
export type CreateMultiOrderTopOffMutationOptions = Apollo.BaseMutationOptions<CreateMultiOrderTopOffMutation, CreateMultiOrderTopOffMutationVariables>;
export const ConfirmOrCancelOrdersDocument = gql`
    mutation confirmOrCancelOrders($input: ConfirmOrCancelOrderInput!) {
  confirmOrCancelOrders(input: $input) {
    errors
    success
  }
}
    `;
export type ConfirmOrCancelOrdersMutationFn = Apollo.MutationFunction<ConfirmOrCancelOrdersMutation, ConfirmOrCancelOrdersMutationVariables>;

/**
 * __useConfirmOrCancelOrdersMutation__
 *
 * To run a mutation, you first call `useConfirmOrCancelOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmOrCancelOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmOrCancelOrdersMutation, { data, loading, error }] = useConfirmOrCancelOrdersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmOrCancelOrdersMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmOrCancelOrdersMutation, ConfirmOrCancelOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmOrCancelOrdersMutation, ConfirmOrCancelOrdersMutationVariables>(ConfirmOrCancelOrdersDocument, options);
      }
export type ConfirmOrCancelOrdersMutationHookResult = ReturnType<typeof useConfirmOrCancelOrdersMutation>;
export type ConfirmOrCancelOrdersMutationResult = Apollo.MutationResult<ConfirmOrCancelOrdersMutation>;
export type ConfirmOrCancelOrdersMutationOptions = Apollo.BaseMutationOptions<ConfirmOrCancelOrdersMutation, ConfirmOrCancelOrdersMutationVariables>;
export const CreateManualOrderDocument = gql`
    mutation CreateManualOrder($input: CreateOrderGroupsInput!) {
  createOrderGroups(input: $input) {
    orderGroups {
      id
      startedOn
      deliveryOrder {
        id
      }
    }
  }
}
    `;
export type CreateManualOrderMutationFn = Apollo.MutationFunction<CreateManualOrderMutation, CreateManualOrderMutationVariables>;

/**
 * __useCreateManualOrderMutation__
 *
 * To run a mutation, you first call `useCreateManualOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManualOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManualOrderMutation, { data, loading, error }] = useCreateManualOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateManualOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateManualOrderMutation, CreateManualOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManualOrderMutation, CreateManualOrderMutationVariables>(CreateManualOrderDocument, options);
      }
export type CreateManualOrderMutationHookResult = ReturnType<typeof useCreateManualOrderMutation>;
export type CreateManualOrderMutationResult = Apollo.MutationResult<CreateManualOrderMutation>;
export type CreateManualOrderMutationOptions = Apollo.BaseMutationOptions<CreateManualOrderMutation, CreateManualOrderMutationVariables>;
export const DegreeDaysActiveTanksListDocument = gql`
    query DegreeDaysActiveTanksList($limit: Int!, $offset: Int!, $sorter: [UnifiedTankSorter!], $filter: UnifiedTankFilterInput) {
  degreeDayTanks(limit: $limit, offset: $offset, sorter: $sorter, filter: $filter) {
    collection {
      id
      currentDegreeDaySetting {
        id
        orderNumber
        orderType
        autoOrdering
      }
      customerName
      shiptoName
      name
      autoOrdering
      tankCapacity
      daysToEmptyThreshold
      lastDeliveryDate
      orderStatus
      customerBranchId
      currentTankLevel
      customerId
      customerBranchAddress
      settingId
      avgDailyUsage
      kFactor
      avgDailyTemp
      totalDegreeDays
      hubName
      latestDegreeDay {
        degreeDaysPerDay
        createdAt
        currentTankLevel
        gallonsDelivered
        estTillEmptyDays
        estimatedRunOutDate
      }
    }
    metadata {
      totalCount
      hasMore
    }
  }
}
    `;

/**
 * __useDegreeDaysActiveTanksListQuery__
 *
 * To run a query within a React component, call `useDegreeDaysActiveTanksListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDegreeDaysActiveTanksListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDegreeDaysActiveTanksListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDegreeDaysActiveTanksListQuery(baseOptions: Apollo.QueryHookOptions<DegreeDaysActiveTanksListQuery, DegreeDaysActiveTanksListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DegreeDaysActiveTanksListQuery, DegreeDaysActiveTanksListQueryVariables>(DegreeDaysActiveTanksListDocument, options);
      }
export function useDegreeDaysActiveTanksListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DegreeDaysActiveTanksListQuery, DegreeDaysActiveTanksListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DegreeDaysActiveTanksListQuery, DegreeDaysActiveTanksListQueryVariables>(DegreeDaysActiveTanksListDocument, options);
        }
export type DegreeDaysActiveTanksListQueryHookResult = ReturnType<typeof useDegreeDaysActiveTanksListQuery>;
export type DegreeDaysActiveTanksListLazyQueryHookResult = ReturnType<typeof useDegreeDaysActiveTanksListLazyQuery>;
export type DegreeDaysActiveTanksListQueryResult = Apollo.QueryResult<DegreeDaysActiveTanksListQuery, DegreeDaysActiveTanksListQueryVariables>;
export const DegreeDaysInactiveTanksCountDocument = gql`
    query DegreeDaysInactiveTanksCount {
  degreeDayTanks(filter: {enabled: false}) {
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useDegreeDaysInactiveTanksCountQuery__
 *
 * To run a query within a React component, call `useDegreeDaysInactiveTanksCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useDegreeDaysInactiveTanksCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDegreeDaysInactiveTanksCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useDegreeDaysInactiveTanksCountQuery(baseOptions?: Apollo.QueryHookOptions<DegreeDaysInactiveTanksCountQuery, DegreeDaysInactiveTanksCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DegreeDaysInactiveTanksCountQuery, DegreeDaysInactiveTanksCountQueryVariables>(DegreeDaysInactiveTanksCountDocument, options);
      }
export function useDegreeDaysInactiveTanksCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DegreeDaysInactiveTanksCountQuery, DegreeDaysInactiveTanksCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DegreeDaysInactiveTanksCountQuery, DegreeDaysInactiveTanksCountQueryVariables>(DegreeDaysInactiveTanksCountDocument, options);
        }
export type DegreeDaysInactiveTanksCountQueryHookResult = ReturnType<typeof useDegreeDaysInactiveTanksCountQuery>;
export type DegreeDaysInactiveTanksCountLazyQueryHookResult = ReturnType<typeof useDegreeDaysInactiveTanksCountLazyQuery>;
export type DegreeDaysInactiveTanksCountQueryResult = Apollo.QueryResult<DegreeDaysInactiveTanksCountQuery, DegreeDaysInactiveTanksCountQueryVariables>;
export const DegreeDaysInactiveTanksListDocument = gql`
    query DegreeDaysInactiveTanksList($limit: Int!, $offset: Int!, $sorter: [UnifiedTankSorter!], $filter: UnifiedTankFilterInput) {
  degreeDayTanks(limit: $limit, offset: $offset, sorter: $sorter, filter: $filter) {
    collection {
      id
      adjustmentUnit
      adjustmentQuantity
      currentDegreeDaySetting {
        degreeDayReset
      }
      customerName
      shiptoName
      name
      autoOrdering
      tankCapacity
      daysToEmptyThreshold
      customerBranchId
      customerId
      customerBranchAddress
      settingId
      kFactor
      avgDailyTemp
      totalDegreeDays
      disabledAt
      degreeDayReset
      enabled
      safeLimit
    }
    metadata {
      totalCount
      hasMore
    }
  }
}
    `;

/**
 * __useDegreeDaysInactiveTanksListQuery__
 *
 * To run a query within a React component, call `useDegreeDaysInactiveTanksListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDegreeDaysInactiveTanksListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDegreeDaysInactiveTanksListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDegreeDaysInactiveTanksListQuery(baseOptions: Apollo.QueryHookOptions<DegreeDaysInactiveTanksListQuery, DegreeDaysInactiveTanksListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DegreeDaysInactiveTanksListQuery, DegreeDaysInactiveTanksListQueryVariables>(DegreeDaysInactiveTanksListDocument, options);
      }
export function useDegreeDaysInactiveTanksListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DegreeDaysInactiveTanksListQuery, DegreeDaysInactiveTanksListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DegreeDaysInactiveTanksListQuery, DegreeDaysInactiveTanksListQueryVariables>(DegreeDaysInactiveTanksListDocument, options);
        }
export type DegreeDaysInactiveTanksListQueryHookResult = ReturnType<typeof useDegreeDaysInactiveTanksListQuery>;
export type DegreeDaysInactiveTanksListLazyQueryHookResult = ReturnType<typeof useDegreeDaysInactiveTanksListLazyQuery>;
export type DegreeDaysInactiveTanksListQueryResult = Apollo.QueryResult<DegreeDaysInactiveTanksListQuery, DegreeDaysInactiveTanksListQueryVariables>;
export const DegreeDaysLowFuelTanksCountDocument = gql`
    query DegreeDaysLowFuelTanksCount($filter: UnifiedTankFilterInput) {
  degreeDayTanks(filter: $filter) {
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useDegreeDaysLowFuelTanksCountQuery__
 *
 * To run a query within a React component, call `useDegreeDaysLowFuelTanksCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useDegreeDaysLowFuelTanksCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDegreeDaysLowFuelTanksCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDegreeDaysLowFuelTanksCountQuery(baseOptions?: Apollo.QueryHookOptions<DegreeDaysLowFuelTanksCountQuery, DegreeDaysLowFuelTanksCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DegreeDaysLowFuelTanksCountQuery, DegreeDaysLowFuelTanksCountQueryVariables>(DegreeDaysLowFuelTanksCountDocument, options);
      }
export function useDegreeDaysLowFuelTanksCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DegreeDaysLowFuelTanksCountQuery, DegreeDaysLowFuelTanksCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DegreeDaysLowFuelTanksCountQuery, DegreeDaysLowFuelTanksCountQueryVariables>(DegreeDaysLowFuelTanksCountDocument, options);
        }
export type DegreeDaysLowFuelTanksCountQueryHookResult = ReturnType<typeof useDegreeDaysLowFuelTanksCountQuery>;
export type DegreeDaysLowFuelTanksCountLazyQueryHookResult = ReturnType<typeof useDegreeDaysLowFuelTanksCountLazyQuery>;
export type DegreeDaysLowFuelTanksCountQueryResult = Apollo.QueryResult<DegreeDaysLowFuelTanksCountQuery, DegreeDaysLowFuelTanksCountQueryVariables>;
export const DegreeDaysSummaryReportDocument = gql`
    query DegreeDaysSummaryReport($assetId: ID!, $startDate: ISO8601Date, $endDate: ISO8601Date) {
  degreeDayReportSummary(
    assetId: $assetId
    startDate: $startDate
    endDate: $endDate
  )
}
    `;

/**
 * __useDegreeDaysSummaryReportQuery__
 *
 * To run a query within a React component, call `useDegreeDaysSummaryReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDegreeDaysSummaryReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDegreeDaysSummaryReportQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useDegreeDaysSummaryReportQuery(baseOptions: Apollo.QueryHookOptions<DegreeDaysSummaryReportQuery, DegreeDaysSummaryReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DegreeDaysSummaryReportQuery, DegreeDaysSummaryReportQueryVariables>(DegreeDaysSummaryReportDocument, options);
      }
export function useDegreeDaysSummaryReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DegreeDaysSummaryReportQuery, DegreeDaysSummaryReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DegreeDaysSummaryReportQuery, DegreeDaysSummaryReportQueryVariables>(DegreeDaysSummaryReportDocument, options);
        }
export type DegreeDaysSummaryReportQueryHookResult = ReturnType<typeof useDegreeDaysSummaryReportQuery>;
export type DegreeDaysSummaryReportLazyQueryHookResult = ReturnType<typeof useDegreeDaysSummaryReportLazyQuery>;
export type DegreeDaysSummaryReportQueryResult = Apollo.QueryResult<DegreeDaysSummaryReportQuery, DegreeDaysSummaryReportQueryVariables>;
export const DegreeDaysViewReportDocument = gql`
    query DegreeDaysViewReport($limit: Int, $offset: Int, $sorter: [DegreeDaySorter!], $filter: DegreeDayFilterInput) {
  degreeDays(limit: $limit, offset: $offset, sorter: $sorter, filter: $filter) {
    collection {
      id
      orderGroupId
      deliveryDate
      kFactor
      gallonsDelivered
      degreeDaysPerDay
      cumulativeDegreeDays
    }
    metadata {
      hasMore
      totalCount
    }
  }
}
    `;

/**
 * __useDegreeDaysViewReportQuery__
 *
 * To run a query within a React component, call `useDegreeDaysViewReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDegreeDaysViewReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDegreeDaysViewReportQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDegreeDaysViewReportQuery(baseOptions?: Apollo.QueryHookOptions<DegreeDaysViewReportQuery, DegreeDaysViewReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DegreeDaysViewReportQuery, DegreeDaysViewReportQueryVariables>(DegreeDaysViewReportDocument, options);
      }
export function useDegreeDaysViewReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DegreeDaysViewReportQuery, DegreeDaysViewReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DegreeDaysViewReportQuery, DegreeDaysViewReportQueryVariables>(DegreeDaysViewReportDocument, options);
        }
export type DegreeDaysViewReportQueryHookResult = ReturnType<typeof useDegreeDaysViewReportQuery>;
export type DegreeDaysViewReportLazyQueryHookResult = ReturnType<typeof useDegreeDaysViewReportLazyQuery>;
export type DegreeDaysViewReportQueryResult = Apollo.QueryResult<DegreeDaysViewReportQuery, DegreeDaysViewReportQueryVariables>;
export const FetchAssetDetailsForDegreeDaysDocument = gql`
    query FetchAssetDetailsForDegreeDays($id: ID!) {
  asset(id: $id) {
    id
    tankSize
    subscriptions {
      id
      product {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useFetchAssetDetailsForDegreeDaysQuery__
 *
 * To run a query within a React component, call `useFetchAssetDetailsForDegreeDaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAssetDetailsForDegreeDaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAssetDetailsForDegreeDaysQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchAssetDetailsForDegreeDaysQuery(baseOptions: Apollo.QueryHookOptions<FetchAssetDetailsForDegreeDaysQuery, FetchAssetDetailsForDegreeDaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAssetDetailsForDegreeDaysQuery, FetchAssetDetailsForDegreeDaysQueryVariables>(FetchAssetDetailsForDegreeDaysDocument, options);
      }
export function useFetchAssetDetailsForDegreeDaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAssetDetailsForDegreeDaysQuery, FetchAssetDetailsForDegreeDaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAssetDetailsForDegreeDaysQuery, FetchAssetDetailsForDegreeDaysQueryVariables>(FetchAssetDetailsForDegreeDaysDocument, options);
        }
export type FetchAssetDetailsForDegreeDaysQueryHookResult = ReturnType<typeof useFetchAssetDetailsForDegreeDaysQuery>;
export type FetchAssetDetailsForDegreeDaysLazyQueryHookResult = ReturnType<typeof useFetchAssetDetailsForDegreeDaysLazyQuery>;
export type FetchAssetDetailsForDegreeDaysQueryResult = Apollo.QueryResult<FetchAssetDetailsForDegreeDaysQuery, FetchAssetDetailsForDegreeDaysQueryVariables>;
export const FetchDegreeDaySettingByAssetDocument = gql`
    query FetchDegreeDaySettingByAsset($assetId: Int!) {
  degreeDaySettingByAsset(assetId: $assetId) {
    adjustmentQuantity
    adjustmentUnit
    asset {
      name
      customerName
      customerBranchAddress
    }
    assetId
    autoOrdering
    createdAt
    daysToEmptyThreshold
    degreeDayReset
    disabledAt
    enabled
    hubIds
    id
    gracePeriod
    gracePeriodType
    kFactor
    orderConfirmation
    orderNumber
    orderStatus
    preferenceAvailability {
      bestEndTime
      bestStartTime
      day
      endTime
      preferredEndTime
      preferredStartTime
      startTime
    }
    purchaseOrderRequired
    safeLimit
    tankCapacity
    tankType
    tenantId
    updatedAt
  }
}
    `;

/**
 * __useFetchDegreeDaySettingByAssetQuery__
 *
 * To run a query within a React component, call `useFetchDegreeDaySettingByAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDegreeDaySettingByAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDegreeDaySettingByAssetQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useFetchDegreeDaySettingByAssetQuery(baseOptions: Apollo.QueryHookOptions<FetchDegreeDaySettingByAssetQuery, FetchDegreeDaySettingByAssetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDegreeDaySettingByAssetQuery, FetchDegreeDaySettingByAssetQueryVariables>(FetchDegreeDaySettingByAssetDocument, options);
      }
export function useFetchDegreeDaySettingByAssetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDegreeDaySettingByAssetQuery, FetchDegreeDaySettingByAssetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDegreeDaySettingByAssetQuery, FetchDegreeDaySettingByAssetQueryVariables>(FetchDegreeDaySettingByAssetDocument, options);
        }
export type FetchDegreeDaySettingByAssetQueryHookResult = ReturnType<typeof useFetchDegreeDaySettingByAssetQuery>;
export type FetchDegreeDaySettingByAssetLazyQueryHookResult = ReturnType<typeof useFetchDegreeDaySettingByAssetLazyQuery>;
export type FetchDegreeDaySettingByAssetQueryResult = Apollo.QueryResult<FetchDegreeDaySettingByAssetQuery, FetchDegreeDaySettingByAssetQueryVariables>;
export const FetchFilteredApplicableFeesForDegreeDaysDocument = gql`
    query FetchFilteredApplicableFeesForDegreeDays($filter: ApplicableFeeFilter) {
  filteredApplicableFees(filter: $filter) {
    collection {
      fee {
        id
        code
        name
        price
        deleted
        applicableType
      }
      id
      isDefault
      price
      quantity
    }
  }
}
    `;

/**
 * __useFetchFilteredApplicableFeesForDegreeDaysQuery__
 *
 * To run a query within a React component, call `useFetchFilteredApplicableFeesForDegreeDaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredApplicableFeesForDegreeDaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredApplicableFeesForDegreeDaysQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchFilteredApplicableFeesForDegreeDaysQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredApplicableFeesForDegreeDaysQuery, FetchFilteredApplicableFeesForDegreeDaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredApplicableFeesForDegreeDaysQuery, FetchFilteredApplicableFeesForDegreeDaysQueryVariables>(FetchFilteredApplicableFeesForDegreeDaysDocument, options);
      }
export function useFetchFilteredApplicableFeesForDegreeDaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredApplicableFeesForDegreeDaysQuery, FetchFilteredApplicableFeesForDegreeDaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredApplicableFeesForDegreeDaysQuery, FetchFilteredApplicableFeesForDegreeDaysQueryVariables>(FetchFilteredApplicableFeesForDegreeDaysDocument, options);
        }
export type FetchFilteredApplicableFeesForDegreeDaysQueryHookResult = ReturnType<typeof useFetchFilteredApplicableFeesForDegreeDaysQuery>;
export type FetchFilteredApplicableFeesForDegreeDaysLazyQueryHookResult = ReturnType<typeof useFetchFilteredApplicableFeesForDegreeDaysLazyQuery>;
export type FetchFilteredApplicableFeesForDegreeDaysQueryResult = Apollo.QueryResult<FetchFilteredApplicableFeesForDegreeDaysQuery, FetchFilteredApplicableFeesForDegreeDaysQueryVariables>;
export const FilteredDeliveryOrderLineItemsDocument = gql`
    query FilteredDeliveryOrderLineItems($limit: Int, $offset: Int, $filter: DoliHistoryFilterInput, $sorter: [DeliveryOrderLineItemsSorter!]) {
  filteredDeliveryOrderLineItems(
    limit: $limit
    offset: $offset
    filter: $filter
    sorter: $sorter
  ) {
    collection {
      id
      asset {
        name
      }
      volume
      source
      deliveryOrder {
        id
        customerBranch {
          id
          name
          customer {
            id
            name
          }
        }
        orderGroup {
          id
          startOn
          createdAtTimestamp
          status
        }
      }
      deliveryDateTimestamp
    }
    metadata {
      hasMore
      totalCount
    }
  }
}
    `;

/**
 * __useFilteredDeliveryOrderLineItemsQuery__
 *
 * To run a query within a React component, call `useFilteredDeliveryOrderLineItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredDeliveryOrderLineItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredDeliveryOrderLineItemsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilteredDeliveryOrderLineItemsQuery(baseOptions?: Apollo.QueryHookOptions<FilteredDeliveryOrderLineItemsQuery, FilteredDeliveryOrderLineItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredDeliveryOrderLineItemsQuery, FilteredDeliveryOrderLineItemsQueryVariables>(FilteredDeliveryOrderLineItemsDocument, options);
      }
export function useFilteredDeliveryOrderLineItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredDeliveryOrderLineItemsQuery, FilteredDeliveryOrderLineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredDeliveryOrderLineItemsQuery, FilteredDeliveryOrderLineItemsQueryVariables>(FilteredDeliveryOrderLineItemsDocument, options);
        }
export type FilteredDeliveryOrderLineItemsQueryHookResult = ReturnType<typeof useFilteredDeliveryOrderLineItemsQuery>;
export type FilteredDeliveryOrderLineItemsLazyQueryHookResult = ReturnType<typeof useFilteredDeliveryOrderLineItemsLazyQuery>;
export type FilteredDeliveryOrderLineItemsQueryResult = Apollo.QueryResult<FilteredDeliveryOrderLineItemsQuery, FilteredDeliveryOrderLineItemsQueryVariables>;
export const GetDegreeDaysViewReportCsvDocument = gql`
    query getDegreeDaysViewReportCsv($assetId: ID, $startDate: ISO8601Date, $endDate: ISO8601Date) {
  degreeDaysCsv(assetId: $assetId, startDate: $startDate, endDate: $endDate) {
    fileName
    content
    error
  }
}
    `;

/**
 * __useGetDegreeDaysViewReportCsvQuery__
 *
 * To run a query within a React component, call `useGetDegreeDaysViewReportCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDegreeDaysViewReportCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDegreeDaysViewReportCsvQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetDegreeDaysViewReportCsvQuery(baseOptions?: Apollo.QueryHookOptions<GetDegreeDaysViewReportCsvQuery, GetDegreeDaysViewReportCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDegreeDaysViewReportCsvQuery, GetDegreeDaysViewReportCsvQueryVariables>(GetDegreeDaysViewReportCsvDocument, options);
      }
export function useGetDegreeDaysViewReportCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDegreeDaysViewReportCsvQuery, GetDegreeDaysViewReportCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDegreeDaysViewReportCsvQuery, GetDegreeDaysViewReportCsvQueryVariables>(GetDegreeDaysViewReportCsvDocument, options);
        }
export type GetDegreeDaysViewReportCsvQueryHookResult = ReturnType<typeof useGetDegreeDaysViewReportCsvQuery>;
export type GetDegreeDaysViewReportCsvLazyQueryHookResult = ReturnType<typeof useGetDegreeDaysViewReportCsvLazyQuery>;
export type GetDegreeDaysViewReportCsvQueryResult = Apollo.QueryResult<GetDegreeDaysViewReportCsvQuery, GetDegreeDaysViewReportCsvQueryVariables>;
export const GetDeliveryOrderLineItemCsvDocument = gql`
    query getDeliveryOrderLineItemCsv($customerBranchId: ID, $assetId: ID, $startDate: ISO8601Date, $endDate: ISO8601Date, $status: [StatusTypeEnum!]) {
  deliveryOrderLineItemCsv(
    customerBranchId: $customerBranchId
    assetId: $assetId
    startDate: $startDate
    endDate: $endDate
    status: $status
  ) {
    fileName
    content
    error
  }
}
    `;

/**
 * __useGetDeliveryOrderLineItemCsvQuery__
 *
 * To run a query within a React component, call `useGetDeliveryOrderLineItemCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryOrderLineItemCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryOrderLineItemCsvQuery({
 *   variables: {
 *      customerBranchId: // value for 'customerBranchId'
 *      assetId: // value for 'assetId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetDeliveryOrderLineItemCsvQuery(baseOptions?: Apollo.QueryHookOptions<GetDeliveryOrderLineItemCsvQuery, GetDeliveryOrderLineItemCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliveryOrderLineItemCsvQuery, GetDeliveryOrderLineItemCsvQueryVariables>(GetDeliveryOrderLineItemCsvDocument, options);
      }
export function useGetDeliveryOrderLineItemCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliveryOrderLineItemCsvQuery, GetDeliveryOrderLineItemCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliveryOrderLineItemCsvQuery, GetDeliveryOrderLineItemCsvQueryVariables>(GetDeliveryOrderLineItemCsvDocument, options);
        }
export type GetDeliveryOrderLineItemCsvQueryHookResult = ReturnType<typeof useGetDeliveryOrderLineItemCsvQuery>;
export type GetDeliveryOrderLineItemCsvLazyQueryHookResult = ReturnType<typeof useGetDeliveryOrderLineItemCsvLazyQuery>;
export type GetDeliveryOrderLineItemCsvQueryResult = Apollo.QueryResult<GetDeliveryOrderLineItemCsvQuery, GetDeliveryOrderLineItemCsvQueryVariables>;
export const UpdateDegreeDaySettingDocument = gql`
    mutation UpdateDegreeDaySetting($input: [DegreeDaySettingInput!]!) {
  updateDegreeDaySetting(input: $input) {
    degreeDaySettings {
      adjustmentQuantity
      adjustmentUnit
      assetId
      autoOrdering
      createdAt
      daysToEmptyThreshold
      degreeDayReset
      disabledAt
      enabled
      hubIds
      id
      kFactor
      orderConfirmation
      orderNumber
      orderStatus
      purchaseOrderRequired
      safeLimit
      tankCapacity
      tankType
      tenantId
      updatedAt
    }
    errors
    success
  }
}
    `;
export type UpdateDegreeDaySettingMutationFn = Apollo.MutationFunction<UpdateDegreeDaySettingMutation, UpdateDegreeDaySettingMutationVariables>;

/**
 * __useUpdateDegreeDaySettingMutation__
 *
 * To run a mutation, you first call `useUpdateDegreeDaySettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDegreeDaySettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDegreeDaySettingMutation, { data, loading, error }] = useUpdateDegreeDaySettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDegreeDaySettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDegreeDaySettingMutation, UpdateDegreeDaySettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDegreeDaySettingMutation, UpdateDegreeDaySettingMutationVariables>(UpdateDegreeDaySettingDocument, options);
      }
export type UpdateDegreeDaySettingMutationHookResult = ReturnType<typeof useUpdateDegreeDaySettingMutation>;
export type UpdateDegreeDaySettingMutationResult = Apollo.MutationResult<UpdateDegreeDaySettingMutation>;
export type UpdateDegreeDaySettingMutationOptions = Apollo.BaseMutationOptions<UpdateDegreeDaySettingMutation, UpdateDegreeDaySettingMutationVariables>;
export const CreateOrUpdateQrDocument = gql`
    mutation CreateOrUpdateQr($input: CreateOrUpdateQrCodeInput!) {
  createOrUpdateQrCode(input: $input) {
    qrCode {
      id
      code
      image
    }
  }
}
    `;
export type CreateOrUpdateQrMutationFn = Apollo.MutationFunction<CreateOrUpdateQrMutation, CreateOrUpdateQrMutationVariables>;

/**
 * __useCreateOrUpdateQrMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateQrMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateQrMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateQrMutation, { data, loading, error }] = useCreateOrUpdateQrMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateQrMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateQrMutation, CreateOrUpdateQrMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateQrMutation, CreateOrUpdateQrMutationVariables>(CreateOrUpdateQrDocument, options);
      }
export type CreateOrUpdateQrMutationHookResult = ReturnType<typeof useCreateOrUpdateQrMutation>;
export type CreateOrUpdateQrMutationResult = Apollo.MutationResult<CreateOrUpdateQrMutation>;
export type CreateOrUpdateQrMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateQrMutation, CreateOrUpdateQrMutationVariables>;
export const FetchFilteredDriversDocument = gql`
    query FetchFilteredDrivers($sorter: [DriverSorter!]) {
  filteredDrivers(sorter: $sorter) {
    metadata {
      hasMore
    }
    collection {
      id
      name
      group {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useFetchFilteredDriversQuery__
 *
 * To run a query within a React component, call `useFetchFilteredDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredDriversQuery({
 *   variables: {
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchFilteredDriversQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredDriversQuery, FetchFilteredDriversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredDriversQuery, FetchFilteredDriversQueryVariables>(FetchFilteredDriversDocument, options);
      }
export function useFetchFilteredDriversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredDriversQuery, FetchFilteredDriversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredDriversQuery, FetchFilteredDriversQueryVariables>(FetchFilteredDriversDocument, options);
        }
export type FetchFilteredDriversQueryHookResult = ReturnType<typeof useFetchFilteredDriversQuery>;
export type FetchFilteredDriversLazyQueryHookResult = ReturnType<typeof useFetchFilteredDriversLazyQuery>;
export type FetchFilteredDriversQueryResult = Apollo.QueryResult<FetchFilteredDriversQuery, FetchFilteredDriversQueryVariables>;
export const FilteredQrCodesDocument = gql`
    query FilteredQrCodes($limit: Int, $offset: Int, $sorter: [QrCodeSorter!], $filter: QrCodeFilter) {
  filteredQrCodes(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: $filter
  ) {
    collection {
      id
      code
      image
      purpose
    }
    metadata {
      totalCount
      hasMore
    }
  }
}
    `;

/**
 * __useFilteredQrCodesQuery__
 *
 * To run a query within a React component, call `useFilteredQrCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredQrCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredQrCodesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFilteredQrCodesQuery(baseOptions?: Apollo.QueryHookOptions<FilteredQrCodesQuery, FilteredQrCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredQrCodesQuery, FilteredQrCodesQueryVariables>(FilteredQrCodesDocument, options);
      }
export function useFilteredQrCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredQrCodesQuery, FilteredQrCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredQrCodesQuery, FilteredQrCodesQueryVariables>(FilteredQrCodesDocument, options);
        }
export type FilteredQrCodesQueryHookResult = ReturnType<typeof useFilteredQrCodesQuery>;
export type FilteredQrCodesLazyQueryHookResult = ReturnType<typeof useFilteredQrCodesLazyQuery>;
export type FilteredQrCodesQueryResult = Apollo.QueryResult<FilteredQrCodesQuery, FilteredQrCodesQueryVariables>;
export const GenerateQrCodesDocument = gql`
    mutation GenerateQrCodes($input: GenerateQrCodesInput!) {
  generateQrCodes(input: $input) {
    qrCodePdfString
  }
}
    `;
export type GenerateQrCodesMutationFn = Apollo.MutationFunction<GenerateQrCodesMutation, GenerateQrCodesMutationVariables>;

/**
 * __useGenerateQrCodesMutation__
 *
 * To run a mutation, you first call `useGenerateQrCodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateQrCodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateQrCodesMutation, { data, loading, error }] = useGenerateQrCodesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateQrCodesMutation(baseOptions?: Apollo.MutationHookOptions<GenerateQrCodesMutation, GenerateQrCodesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateQrCodesMutation, GenerateQrCodesMutationVariables>(GenerateQrCodesDocument, options);
      }
export type GenerateQrCodesMutationHookResult = ReturnType<typeof useGenerateQrCodesMutation>;
export type GenerateQrCodesMutationResult = Apollo.MutationResult<GenerateQrCodesMutation>;
export type GenerateQrCodesMutationOptions = Apollo.BaseMutationOptions<GenerateQrCodesMutation, GenerateQrCodesMutationVariables>;
export const CreateLeaseEquipmentOrderDocument = gql`
    mutation CreateLeaseEquipmentOrder($input: CreateOrderGroupInput!) {
  createOrderGroup(input: $input) {
    orderGroup {
      id
    }
  }
}
    `;
export type CreateLeaseEquipmentOrderMutationFn = Apollo.MutationFunction<CreateLeaseEquipmentOrderMutation, CreateLeaseEquipmentOrderMutationVariables>;

/**
 * __useCreateLeaseEquipmentOrderMutation__
 *
 * To run a mutation, you first call `useCreateLeaseEquipmentOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeaseEquipmentOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeaseEquipmentOrderMutation, { data, loading, error }] = useCreateLeaseEquipmentOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLeaseEquipmentOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeaseEquipmentOrderMutation, CreateLeaseEquipmentOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeaseEquipmentOrderMutation, CreateLeaseEquipmentOrderMutationVariables>(CreateLeaseEquipmentOrderDocument, options);
      }
export type CreateLeaseEquipmentOrderMutationHookResult = ReturnType<typeof useCreateLeaseEquipmentOrderMutation>;
export type CreateLeaseEquipmentOrderMutationResult = Apollo.MutationResult<CreateLeaseEquipmentOrderMutation>;
export type CreateLeaseEquipmentOrderMutationOptions = Apollo.BaseMutationOptions<CreateLeaseEquipmentOrderMutation, CreateLeaseEquipmentOrderMutationVariables>;
export const CreateOrUpdateFormProgressDocument = gql`
    mutation CreateOrUpdateFormProgress($input: FormProgressInput!) {
  createOrUpdateFormProgress(input: {formProgressAttributes: $input}) {
    formProgress {
      id
      currentStep
      formData
      formType
    }
    errors
  }
}
    `;
export type CreateOrUpdateFormProgressMutationFn = Apollo.MutationFunction<CreateOrUpdateFormProgressMutation, CreateOrUpdateFormProgressMutationVariables>;

/**
 * __useCreateOrUpdateFormProgressMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateFormProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateFormProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateFormProgressMutation, { data, loading, error }] = useCreateOrUpdateFormProgressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateFormProgressMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateFormProgressMutation, CreateOrUpdateFormProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateFormProgressMutation, CreateOrUpdateFormProgressMutationVariables>(CreateOrUpdateFormProgressDocument, options);
      }
export type CreateOrUpdateFormProgressMutationHookResult = ReturnType<typeof useCreateOrUpdateFormProgressMutation>;
export type CreateOrUpdateFormProgressMutationResult = Apollo.MutationResult<CreateOrUpdateFormProgressMutation>;
export type CreateOrUpdateFormProgressMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateFormProgressMutation, CreateOrUpdateFormProgressMutationVariables>;
export const FetchCompartmentDataForLeoDocument = gql`
    query FetchCompartmentDataForLEO($id: ID!) {
  asset(id: $id) {
    id
    compartments {
      id
      name
      erpId
      subscriptionProducts {
        id
        name
      }
      capacities {
        id
        unit
        value
        fuelType
        productCategory {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useFetchCompartmentDataForLeoQuery__
 *
 * To run a query within a React component, call `useFetchCompartmentDataForLeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCompartmentDataForLeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCompartmentDataForLeoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchCompartmentDataForLeoQuery(baseOptions: Apollo.QueryHookOptions<FetchCompartmentDataForLeoQuery, FetchCompartmentDataForLeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCompartmentDataForLeoQuery, FetchCompartmentDataForLeoQueryVariables>(FetchCompartmentDataForLeoDocument, options);
      }
export function useFetchCompartmentDataForLeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCompartmentDataForLeoQuery, FetchCompartmentDataForLeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCompartmentDataForLeoQuery, FetchCompartmentDataForLeoQueryVariables>(FetchCompartmentDataForLeoDocument, options);
        }
export type FetchCompartmentDataForLeoQueryHookResult = ReturnType<typeof useFetchCompartmentDataForLeoQuery>;
export type FetchCompartmentDataForLeoLazyQueryHookResult = ReturnType<typeof useFetchCompartmentDataForLeoLazyQuery>;
export type FetchCompartmentDataForLeoQueryResult = Apollo.QueryResult<FetchCompartmentDataForLeoQuery, FetchCompartmentDataForLeoQueryVariables>;
export const FilteredDriversForLeoDocument = gql`
    query FilteredDriversForLEO($limit: Int, $offset: Int, $all: String, $sorter: [DriverSorter!], $driverTypes: [DriverTypeEnum!]) {
  filteredDrivers(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {all: $all, driverTypes: $driverTypes}
  ) {
    collection {
      id
      name
    }
    metadata {
      hasMore
      totalCount
    }
  }
}
    `;

/**
 * __useFilteredDriversForLeoQuery__
 *
 * To run a query within a React component, call `useFilteredDriversForLeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredDriversForLeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredDriversForLeoQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      all: // value for 'all'
 *      sorter: // value for 'sorter'
 *      driverTypes: // value for 'driverTypes'
 *   },
 * });
 */
export function useFilteredDriversForLeoQuery(baseOptions?: Apollo.QueryHookOptions<FilteredDriversForLeoQuery, FilteredDriversForLeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredDriversForLeoQuery, FilteredDriversForLeoQueryVariables>(FilteredDriversForLeoDocument, options);
      }
export function useFilteredDriversForLeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredDriversForLeoQuery, FilteredDriversForLeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredDriversForLeoQuery, FilteredDriversForLeoQueryVariables>(FilteredDriversForLeoDocument, options);
        }
export type FilteredDriversForLeoQueryHookResult = ReturnType<typeof useFilteredDriversForLeoQuery>;
export type FilteredDriversForLeoLazyQueryHookResult = ReturnType<typeof useFilteredDriversForLeoLazyQuery>;
export type FilteredDriversForLeoQueryResult = Apollo.QueryResult<FilteredDriversForLeoQuery, FilteredDriversForLeoQueryVariables>;
export const FetchFeesForLeoDocument = gql`
    query FetchFeesForLEO($filter: FeeFilter) {
  filteredFees(filter: $filter) {
    collection {
      id
      name
      defaultMovementFee
    }
  }
}
    `;

/**
 * __useFetchFeesForLeoQuery__
 *
 * To run a query within a React component, call `useFetchFeesForLeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFeesForLeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFeesForLeoQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchFeesForLeoQuery(baseOptions?: Apollo.QueryHookOptions<FetchFeesForLeoQuery, FetchFeesForLeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFeesForLeoQuery, FetchFeesForLeoQueryVariables>(FetchFeesForLeoDocument, options);
      }
export function useFetchFeesForLeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFeesForLeoQuery, FetchFeesForLeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFeesForLeoQuery, FetchFeesForLeoQueryVariables>(FetchFeesForLeoDocument, options);
        }
export type FetchFeesForLeoQueryHookResult = ReturnType<typeof useFetchFeesForLeoQuery>;
export type FetchFeesForLeoLazyQueryHookResult = ReturnType<typeof useFetchFeesForLeoLazyQuery>;
export type FetchFeesForLeoQueryResult = Apollo.QueryResult<FetchFeesForLeoQuery, FetchFeesForLeoQueryVariables>;
export const FetchFormProgressDocument = gql`
    query FetchFormProgress($formType: FormProgressTypeEnum!) {
  formProgresses(type: $formType) {
    id
    currentStep
    formData
    formType
  }
}
    `;

/**
 * __useFetchFormProgressQuery__
 *
 * To run a query within a React component, call `useFetchFormProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFormProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFormProgressQuery({
 *   variables: {
 *      formType: // value for 'formType'
 *   },
 * });
 */
export function useFetchFormProgressQuery(baseOptions: Apollo.QueryHookOptions<FetchFormProgressQuery, FetchFormProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFormProgressQuery, FetchFormProgressQueryVariables>(FetchFormProgressDocument, options);
      }
export function useFetchFormProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFormProgressQuery, FetchFormProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFormProgressQuery, FetchFormProgressQueryVariables>(FetchFormProgressDocument, options);
        }
export type FetchFormProgressQueryHookResult = ReturnType<typeof useFetchFormProgressQuery>;
export type FetchFormProgressLazyQueryHookResult = ReturnType<typeof useFetchFormProgressLazyQuery>;
export type FetchFormProgressQueryResult = Apollo.QueryResult<FetchFormProgressQuery, FetchFormProgressQueryVariables>;
export const FetchLeasedAssetsForLeoDocument = gql`
    query fetchLeasedAssetsForLEO($limit: Int, $offset: Int, $sorter: [AssetSorter!], $customFilter: AssetFilter = {}) {
  filteredAssets(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: $customFilter
  ) {
    collection {
      id
      status
      name
      category
      qrCodeText
      licensePlateNumber
      activeLease
      tankType
      tankSize
      compartments {
        id
        name
      }
      assetProductCategories {
        productCategory {
          id
          name
        }
      }
      tankMonitor {
        id
        name
        deviceId
        deviceProvider
      }
      assetsPeripherals {
        id
        peripheralId
        assetsPeripheralsRecords {
          id
          peripheralAttributeId
          value
        }
      }
    }
    metadata {
      hasMore
      totalCount
    }
  }
}
    `;

/**
 * __useFetchLeasedAssetsForLeoQuery__
 *
 * To run a query within a React component, call `useFetchLeasedAssetsForLeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLeasedAssetsForLeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLeasedAssetsForLeoQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      customFilter: // value for 'customFilter'
 *   },
 * });
 */
export function useFetchLeasedAssetsForLeoQuery(baseOptions?: Apollo.QueryHookOptions<FetchLeasedAssetsForLeoQuery, FetchLeasedAssetsForLeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLeasedAssetsForLeoQuery, FetchLeasedAssetsForLeoQueryVariables>(FetchLeasedAssetsForLeoDocument, options);
      }
export function useFetchLeasedAssetsForLeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLeasedAssetsForLeoQuery, FetchLeasedAssetsForLeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLeasedAssetsForLeoQuery, FetchLeasedAssetsForLeoQueryVariables>(FetchLeasedAssetsForLeoDocument, options);
        }
export type FetchLeasedAssetsForLeoQueryHookResult = ReturnType<typeof useFetchLeasedAssetsForLeoQuery>;
export type FetchLeasedAssetsForLeoLazyQueryHookResult = ReturnType<typeof useFetchLeasedAssetsForLeoLazyQuery>;
export type FetchLeasedAssetsForLeoQueryResult = Apollo.QueryResult<FetchLeasedAssetsForLeoQuery, FetchLeasedAssetsForLeoQueryVariables>;
export const LineOfServicesForLeoDocument = gql`
    query LineOfServicesForLEO {
  lineOfServices {
    id
    nameWithAncestors
  }
}
    `;

/**
 * __useLineOfServicesForLeoQuery__
 *
 * To run a query within a React component, call `useLineOfServicesForLeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useLineOfServicesForLeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLineOfServicesForLeoQuery({
 *   variables: {
 *   },
 * });
 */
export function useLineOfServicesForLeoQuery(baseOptions?: Apollo.QueryHookOptions<LineOfServicesForLeoQuery, LineOfServicesForLeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LineOfServicesForLeoQuery, LineOfServicesForLeoQueryVariables>(LineOfServicesForLeoDocument, options);
      }
export function useLineOfServicesForLeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LineOfServicesForLeoQuery, LineOfServicesForLeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LineOfServicesForLeoQuery, LineOfServicesForLeoQueryVariables>(LineOfServicesForLeoDocument, options);
        }
export type LineOfServicesForLeoQueryHookResult = ReturnType<typeof useLineOfServicesForLeoQuery>;
export type LineOfServicesForLeoLazyQueryHookResult = ReturnType<typeof useLineOfServicesForLeoLazyQuery>;
export type LineOfServicesForLeoQueryResult = Apollo.QueryResult<LineOfServicesForLeoQuery, LineOfServicesForLeoQueryVariables>;
export const FetchProductCategoriesForLeoDocument = gql`
    query FetchProductCategoriesForLEO {
  productCategories {
    id
    name
  }
}
    `;

/**
 * __useFetchProductCategoriesForLeoQuery__
 *
 * To run a query within a React component, call `useFetchProductCategoriesForLeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductCategoriesForLeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductCategoriesForLeoQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchProductCategoriesForLeoQuery(baseOptions?: Apollo.QueryHookOptions<FetchProductCategoriesForLeoQuery, FetchProductCategoriesForLeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchProductCategoriesForLeoQuery, FetchProductCategoriesForLeoQueryVariables>(FetchProductCategoriesForLeoDocument, options);
      }
export function useFetchProductCategoriesForLeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchProductCategoriesForLeoQuery, FetchProductCategoriesForLeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchProductCategoriesForLeoQuery, FetchProductCategoriesForLeoQueryVariables>(FetchProductCategoriesForLeoDocument, options);
        }
export type FetchProductCategoriesForLeoQueryHookResult = ReturnType<typeof useFetchProductCategoriesForLeoQuery>;
export type FetchProductCategoriesForLeoLazyQueryHookResult = ReturnType<typeof useFetchProductCategoriesForLeoLazyQuery>;
export type FetchProductCategoriesForLeoQueryResult = Apollo.QueryResult<FetchProductCategoriesForLeoQuery, FetchProductCategoriesForLeoQueryVariables>;
export const FetchYardForLeoDocument = gql`
    query FetchYardForLEO($limit: Int, $offset: Int, $customerId: ID, $name: String, $isHub: Boolean, $all: String, $active: Boolean) {
  filteredCustomerBranches(
    limit: $limit
    offset: $offset
    filter: {customerId: $customerId, name: $name, isHub: $isHub, all: $all, active: $active}
  ) {
    collection {
      id
      name
      isHub
      address
      status
      availableRentalAssetsCount
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFetchYardForLeoQuery__
 *
 * To run a query within a React component, call `useFetchYardForLeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchYardForLeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchYardForLeoQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      customerId: // value for 'customerId'
 *      name: // value for 'name'
 *      isHub: // value for 'isHub'
 *      all: // value for 'all'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useFetchYardForLeoQuery(baseOptions?: Apollo.QueryHookOptions<FetchYardForLeoQuery, FetchYardForLeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchYardForLeoQuery, FetchYardForLeoQueryVariables>(FetchYardForLeoDocument, options);
      }
export function useFetchYardForLeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchYardForLeoQuery, FetchYardForLeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchYardForLeoQuery, FetchYardForLeoQueryVariables>(FetchYardForLeoDocument, options);
        }
export type FetchYardForLeoQueryHookResult = ReturnType<typeof useFetchYardForLeoQuery>;
export type FetchYardForLeoLazyQueryHookResult = ReturnType<typeof useFetchYardForLeoLazyQuery>;
export type FetchYardForLeoQueryResult = Apollo.QueryResult<FetchYardForLeoQuery, FetchYardForLeoQueryVariables>;
export const RemoveFormProgressDocument = gql`
    mutation RemoveFormProgress($orderType: MovementOrderTypeEnum!) {
  removeFormProgress(input: {orderType: $orderType}) {
    success
  }
}
    `;
export type RemoveFormProgressMutationFn = Apollo.MutationFunction<RemoveFormProgressMutation, RemoveFormProgressMutationVariables>;

/**
 * __useRemoveFormProgressMutation__
 *
 * To run a mutation, you first call `useRemoveFormProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFormProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFormProgressMutation, { data, loading, error }] = useRemoveFormProgressMutation({
 *   variables: {
 *      orderType: // value for 'orderType'
 *   },
 * });
 */
export function useRemoveFormProgressMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFormProgressMutation, RemoveFormProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFormProgressMutation, RemoveFormProgressMutationVariables>(RemoveFormProgressDocument, options);
      }
export type RemoveFormProgressMutationHookResult = ReturnType<typeof useRemoveFormProgressMutation>;
export type RemoveFormProgressMutationResult = Apollo.MutationResult<RemoveFormProgressMutation>;
export type RemoveFormProgressMutationOptions = Apollo.BaseMutationOptions<RemoveFormProgressMutation, RemoveFormProgressMutationVariables>;
export const UnlinkTankMonitorDocument = gql`
    mutation UnlinkTankMonitor($assetId: ID!, $plannedTime: Int!) {
  unlinkTankMonitor(input: {assetId: $assetId, plannedTime: $plannedTime}) {
    success
  }
}
    `;
export type UnlinkTankMonitorMutationFn = Apollo.MutationFunction<UnlinkTankMonitorMutation, UnlinkTankMonitorMutationVariables>;

/**
 * __useUnlinkTankMonitorMutation__
 *
 * To run a mutation, you first call `useUnlinkTankMonitorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkTankMonitorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkTankMonitorMutation, { data, loading, error }] = useUnlinkTankMonitorMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      plannedTime: // value for 'plannedTime'
 *   },
 * });
 */
export function useUnlinkTankMonitorMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkTankMonitorMutation, UnlinkTankMonitorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkTankMonitorMutation, UnlinkTankMonitorMutationVariables>(UnlinkTankMonitorDocument, options);
      }
export type UnlinkTankMonitorMutationHookResult = ReturnType<typeof useUnlinkTankMonitorMutation>;
export type UnlinkTankMonitorMutationResult = Apollo.MutationResult<UnlinkTankMonitorMutation>;
export type UnlinkTankMonitorMutationOptions = Apollo.BaseMutationOptions<UnlinkTankMonitorMutation, UnlinkTankMonitorMutationVariables>;
export const CreateOrUpdateNotificationTemplateDocument = gql`
    mutation CreateOrUpdateNotificationTemplate($data: NotificationTemplateInput!) {
  createOrUpdateNotificationTemplate(input: {data: $data}) {
    notificationTemplate {
      id
      notificationType
      orderStatus
      status
      subject
      body
      logoUrl
      variables
    }
    success
    errors
  }
}
    `;
export type CreateOrUpdateNotificationTemplateMutationFn = Apollo.MutationFunction<CreateOrUpdateNotificationTemplateMutation, CreateOrUpdateNotificationTemplateMutationVariables>;

/**
 * __useCreateOrUpdateNotificationTemplateMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateNotificationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateNotificationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateNotificationTemplateMutation, { data, loading, error }] = useCreateOrUpdateNotificationTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOrUpdateNotificationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateNotificationTemplateMutation, CreateOrUpdateNotificationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateNotificationTemplateMutation, CreateOrUpdateNotificationTemplateMutationVariables>(CreateOrUpdateNotificationTemplateDocument, options);
      }
export type CreateOrUpdateNotificationTemplateMutationHookResult = ReturnType<typeof useCreateOrUpdateNotificationTemplateMutation>;
export type CreateOrUpdateNotificationTemplateMutationResult = Apollo.MutationResult<CreateOrUpdateNotificationTemplateMutation>;
export type CreateOrUpdateNotificationTemplateMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateNotificationTemplateMutation, CreateOrUpdateNotificationTemplateMutationVariables>;
export const GetNotificationTemplateDocument = gql`
    query GetNotificationTemplate($notificationType: String!, $orderStatus: String!) {
  notificationTemplate(
    notificationType: $notificationType
    orderStatus: $orderStatus
  ) {
    id
    notificationType
    orderStatus
    status
    subject
    body
    logoUrl
    variables
  }
}
    `;

/**
 * __useGetNotificationTemplateQuery__
 *
 * To run a query within a React component, call `useGetNotificationTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationTemplateQuery({
 *   variables: {
 *      notificationType: // value for 'notificationType'
 *      orderStatus: // value for 'orderStatus'
 *   },
 * });
 */
export function useGetNotificationTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationTemplateQuery, GetNotificationTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationTemplateQuery, GetNotificationTemplateQueryVariables>(GetNotificationTemplateDocument, options);
      }
export function useGetNotificationTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationTemplateQuery, GetNotificationTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationTemplateQuery, GetNotificationTemplateQueryVariables>(GetNotificationTemplateDocument, options);
        }
export type GetNotificationTemplateQueryHookResult = ReturnType<typeof useGetNotificationTemplateQuery>;
export type GetNotificationTemplateLazyQueryHookResult = ReturnType<typeof useGetNotificationTemplateLazyQuery>;
export type GetNotificationTemplateQueryResult = Apollo.QueryResult<GetNotificationTemplateQuery, GetNotificationTemplateQueryVariables>;
export const GetNotificationTemplatesDocument = gql`
    query GetNotificationTemplates {
  notificationTemplates {
    id
    notificationType
    orderStatus
    status
    subject
    body
    logoUrl
    variables
  }
}
    `;

/**
 * __useGetNotificationTemplatesQuery__
 *
 * To run a query within a React component, call `useGetNotificationTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationTemplatesQuery, GetNotificationTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationTemplatesQuery, GetNotificationTemplatesQueryVariables>(GetNotificationTemplatesDocument, options);
      }
export function useGetNotificationTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationTemplatesQuery, GetNotificationTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationTemplatesQuery, GetNotificationTemplatesQueryVariables>(GetNotificationTemplatesDocument, options);
        }
export type GetNotificationTemplatesQueryHookResult = ReturnType<typeof useGetNotificationTemplatesQuery>;
export type GetNotificationTemplatesLazyQueryHookResult = ReturnType<typeof useGetNotificationTemplatesLazyQuery>;
export type GetNotificationTemplatesQueryResult = Apollo.QueryResult<GetNotificationTemplatesQuery, GetNotificationTemplatesQueryVariables>;
export const SendTestNotificationTemplateDocument = gql`
    mutation SendTestNotificationTemplate($input: SendTestNotificationTemplateInput!) {
  sendTestNotificationTemplate(input: $input) {
    success
    errors
  }
}
    `;
export type SendTestNotificationTemplateMutationFn = Apollo.MutationFunction<SendTestNotificationTemplateMutation, SendTestNotificationTemplateMutationVariables>;

/**
 * __useSendTestNotificationTemplateMutation__
 *
 * To run a mutation, you first call `useSendTestNotificationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestNotificationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestNotificationTemplateMutation, { data, loading, error }] = useSendTestNotificationTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendTestNotificationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<SendTestNotificationTemplateMutation, SendTestNotificationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTestNotificationTemplateMutation, SendTestNotificationTemplateMutationVariables>(SendTestNotificationTemplateDocument, options);
      }
export type SendTestNotificationTemplateMutationHookResult = ReturnType<typeof useSendTestNotificationTemplateMutation>;
export type SendTestNotificationTemplateMutationResult = Apollo.MutationResult<SendTestNotificationTemplateMutation>;
export type SendTestNotificationTemplateMutationOptions = Apollo.BaseMutationOptions<SendTestNotificationTemplateMutation, SendTestNotificationTemplateMutationVariables>;
export const UpdateNotificationTemplateStatusDocument = gql`
    mutation UpdateNotificationTemplateStatus($id: ID!, $status: String!) {
  updateNotificationTemplateStatus(input: {id: $id, status: $status}) {
    notificationTemplate {
      id
      status
    }
    success
    errors
  }
}
    `;
export type UpdateNotificationTemplateStatusMutationFn = Apollo.MutationFunction<UpdateNotificationTemplateStatusMutation, UpdateNotificationTemplateStatusMutationVariables>;

/**
 * __useUpdateNotificationTemplateStatusMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationTemplateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationTemplateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationTemplateStatusMutation, { data, loading, error }] = useUpdateNotificationTemplateStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateNotificationTemplateStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationTemplateStatusMutation, UpdateNotificationTemplateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationTemplateStatusMutation, UpdateNotificationTemplateStatusMutationVariables>(UpdateNotificationTemplateStatusDocument, options);
      }
export type UpdateNotificationTemplateStatusMutationHookResult = ReturnType<typeof useUpdateNotificationTemplateStatusMutation>;
export type UpdateNotificationTemplateStatusMutationResult = Apollo.MutationResult<UpdateNotificationTemplateStatusMutation>;
export type UpdateNotificationTemplateStatusMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationTemplateStatusMutation, UpdateNotificationTemplateStatusMutationVariables>;
export const CreateNewLeaCoreDocument = gql`
    mutation CreateNewLeaCore($input: CreateLeaCoreInput!) {
  createLeaCore(input: $input) {
    leaType {
      leaCore {
        id
        state
        customer {
          id
          name
        }
        customerBranch {
          id
          name
        }
        leaNumber
        createdAtTimestamp
        interactionProgresses {
          completed
          currentStep
          data
          id
          subModule
          totalStep
        }
        leaQuestionnaire {
          id
          data {
            customer {
              id
            }
          }
        }
      }
      success
      error
    }
  }
}
    `;
export type CreateNewLeaCoreMutationFn = Apollo.MutationFunction<CreateNewLeaCoreMutation, CreateNewLeaCoreMutationVariables>;

/**
 * __useCreateNewLeaCoreMutation__
 *
 * To run a mutation, you first call `useCreateNewLeaCoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewLeaCoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewLeaCoreMutation, { data, loading, error }] = useCreateNewLeaCoreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNewLeaCoreMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewLeaCoreMutation, CreateNewLeaCoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewLeaCoreMutation, CreateNewLeaCoreMutationVariables>(CreateNewLeaCoreDocument, options);
      }
export type CreateNewLeaCoreMutationHookResult = ReturnType<typeof useCreateNewLeaCoreMutation>;
export type CreateNewLeaCoreMutationResult = Apollo.MutationResult<CreateNewLeaCoreMutation>;
export type CreateNewLeaCoreMutationOptions = Apollo.BaseMutationOptions<CreateNewLeaCoreMutation, CreateNewLeaCoreMutationVariables>;
export const CreateLeaMovementOrderDocument = gql`
    mutation CreateLeaMovementOrder($input: CreateLeaMovementOrdersInput!) {
  createLeaMovementOrders(input: $input) {
    leaType {
      leaCore {
        leaLineItems {
          movementOrder {
            id
            requestedTankSize
            requestedTankType
            asset {
              name
              averageUtilization
              hubs {
                id
                name
              }
            }
            assetMovementLocation {
              lat
              lng
            }
            orderGroup {
              status
              startOn
            }
          }
        }
      }
      success
      error
    }
  }
}
    `;
export type CreateLeaMovementOrderMutationFn = Apollo.MutationFunction<CreateLeaMovementOrderMutation, CreateLeaMovementOrderMutationVariables>;

/**
 * __useCreateLeaMovementOrderMutation__
 *
 * To run a mutation, you first call `useCreateLeaMovementOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeaMovementOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeaMovementOrderMutation, { data, loading, error }] = useCreateLeaMovementOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLeaMovementOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeaMovementOrderMutation, CreateLeaMovementOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeaMovementOrderMutation, CreateLeaMovementOrderMutationVariables>(CreateLeaMovementOrderDocument, options);
      }
export type CreateLeaMovementOrderMutationHookResult = ReturnType<typeof useCreateLeaMovementOrderMutation>;
export type CreateLeaMovementOrderMutationResult = Apollo.MutationResult<CreateLeaMovementOrderMutation>;
export type CreateLeaMovementOrderMutationOptions = Apollo.BaseMutationOptions<CreateLeaMovementOrderMutation, CreateLeaMovementOrderMutationVariables>;
export const FetchAssetDetailsDocument = gql`
    query FetchAssetDetails($id: ID!) {
  leaCore(id: $id) {
    id
    plannedDate
    createdAtTimestamp
    customerBranch {
      id
      name
    }
    leaLineItems {
      id
      requestProduct {
        id
        name
      }
      requestTankType
      requestTankSize
      status
      unitCost
      customItemData {
        name
        qty
        unitCost
      }
      leaPeripherals {
        id
        quantity
        peripheral {
          id
          soldAs
        }
        notes
        status
        unitCost
      }
      leaAppliedFees {
        id
        applicableFee {
          fee {
            name
          }
        }
      }
      movementOrder {
        id
        requestedTankSize
        requestedTankType
        asset {
          id
          name
        }
        orderGroup {
          id
          startOn
          status
        }
        assetMovementLocation {
          lat
          lng
        }
      }
    }
  }
}
    `;

/**
 * __useFetchAssetDetailsQuery__
 *
 * To run a query within a React component, call `useFetchAssetDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAssetDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAssetDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchAssetDetailsQuery(baseOptions: Apollo.QueryHookOptions<FetchAssetDetailsQuery, FetchAssetDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAssetDetailsQuery, FetchAssetDetailsQueryVariables>(FetchAssetDetailsDocument, options);
      }
export function useFetchAssetDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAssetDetailsQuery, FetchAssetDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAssetDetailsQuery, FetchAssetDetailsQueryVariables>(FetchAssetDetailsDocument, options);
        }
export type FetchAssetDetailsQueryHookResult = ReturnType<typeof useFetchAssetDetailsQuery>;
export type FetchAssetDetailsLazyQueryHookResult = ReturnType<typeof useFetchAssetDetailsLazyQuery>;
export type FetchAssetDetailsQueryResult = Apollo.QueryResult<FetchAssetDetailsQuery, FetchAssetDetailsQueryVariables>;
export const FetchChildLeaCoreDocument = gql`
    query FetchChildLeaCore($id: ID!) {
  leaCore(id: $id) {
    id
    leaNumber
    plannedDate
    status
    state
    customer {
      id
      name
    }
    customerBranch {
      id
      name
    }
    childLeaCore {
      id
      leaNumber
      plannedDate
      status
      data {
        computedMovementOrderIds
        computedSettledMovementOrderIds
      }
      customerBranch {
        id
        name
      }
      customer {
        id
        name
      }
      leaLineItems {
        id
        status
        requestTankSize
        requestTankType
        requestTankSize
        unitCost
        reasonType
        descriptiveReason
        asset {
          id
          name
          site {
            lat
            lng
          }
        }
        leaLineItemsNotes
        customItemData {
          name
          qty
          unitCost
        }
        requestProduct {
          id
          name
          shortName
        }
        leaPeripherals {
          id
          quantity
          unitCost
          notes
          status
          peripheral {
            id
            soldAs
            peripheralCategory {
              id
              name
            }
          }
        }
        leaAppliedFees {
          id
          applicableFee {
            id
            fee {
              id
              name
            }
          }
        }
        movementOrder {
          id
          requestedTankSize
          requestedTankType
          asset {
            name
            averageUtilization
            hubs {
              id
              name
            }
          }
          assetMovementLocation {
            lat
            lng
          }
          orderGroup {
            status
            startOn
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchChildLeaCoreQuery__
 *
 * To run a query within a React component, call `useFetchChildLeaCoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchChildLeaCoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchChildLeaCoreQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchChildLeaCoreQuery(baseOptions: Apollo.QueryHookOptions<FetchChildLeaCoreQuery, FetchChildLeaCoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchChildLeaCoreQuery, FetchChildLeaCoreQueryVariables>(FetchChildLeaCoreDocument, options);
      }
export function useFetchChildLeaCoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchChildLeaCoreQuery, FetchChildLeaCoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchChildLeaCoreQuery, FetchChildLeaCoreQueryVariables>(FetchChildLeaCoreDocument, options);
        }
export type FetchChildLeaCoreQueryHookResult = ReturnType<typeof useFetchChildLeaCoreQuery>;
export type FetchChildLeaCoreLazyQueryHookResult = ReturnType<typeof useFetchChildLeaCoreLazyQuery>;
export type FetchChildLeaCoreQueryResult = Apollo.QueryResult<FetchChildLeaCoreQuery, FetchChildLeaCoreQueryVariables>;
export const FetchFilteredAssetReportDocument = gql`
    query FetchFilteredAssetReport($filter: LeaReportFilter, $limit: Int, $offset: Int) {
  filteredLeaReport(filter: $filter, limit: $limit, offset: $offset) {
    collection {
      id
      requestedTankSize
      totalDeliveriesCount
      totalGallonsDelivered
      orderGroup {
        id
        status
        createdAtTimestamp
        startedOnTimestamp
        completedOnTimestamp
      }
      asset {
        id
        name
        status
        erpId
        tankSize
        category
        licensePlateNumber
        __typename
      }
      toCustomerBranch {
        erpId
        name
        customer {
          id
          name
        }
      }
      leaLineItem {
        requestProduct {
          id
          name
        }
        gallonPerMonth
        marginPerGallonInCents
        bdrCommissionInPercent
        leaCore {
          parentLeaCore {
            isSigned
            leaQuestionnaire {
              salesRepresentative {
                id
                name
              }
            }
          }
        }
      }
    }
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useFetchFilteredAssetReportQuery__
 *
 * To run a query within a React component, call `useFetchFilteredAssetReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredAssetReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredAssetReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFetchFilteredAssetReportQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredAssetReportQuery, FetchFilteredAssetReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredAssetReportQuery, FetchFilteredAssetReportQueryVariables>(FetchFilteredAssetReportDocument, options);
      }
export function useFetchFilteredAssetReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredAssetReportQuery, FetchFilteredAssetReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredAssetReportQuery, FetchFilteredAssetReportQueryVariables>(FetchFilteredAssetReportDocument, options);
        }
export type FetchFilteredAssetReportQueryHookResult = ReturnType<typeof useFetchFilteredAssetReportQuery>;
export type FetchFilteredAssetReportLazyQueryHookResult = ReturnType<typeof useFetchFilteredAssetReportLazyQuery>;
export type FetchFilteredAssetReportQueryResult = Apollo.QueryResult<FetchFilteredAssetReportQuery, FetchFilteredAssetReportQueryVariables>;
export const FilteredRoiReportDocument = gql`
    query FilteredRoiReport($filter: LeaLineItemFilter, $limit: Int, $offset: Int) {
  filteredLeaRoiReport(filter: $filter, limit: $limit, offset: $offset) {
    collection {
      id
      estimatedRoi
      customItemData {
        name
      }
      leaCore {
        customer {
          name
        }
        data {
          expiryDurationDays
        }
      }
      asset {
        id
        name
      }
      leaPeripherals {
        peripheral {
          soldAs
        }
      }
      equipmentsData {
        finalTotalCost
      }
    }
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useFilteredRoiReportQuery__
 *
 * To run a query within a React component, call `useFilteredRoiReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredRoiReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredRoiReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFilteredRoiReportQuery(baseOptions?: Apollo.QueryHookOptions<FilteredRoiReportQuery, FilteredRoiReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredRoiReportQuery, FilteredRoiReportQueryVariables>(FilteredRoiReportDocument, options);
      }
export function useFilteredRoiReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredRoiReportQuery, FilteredRoiReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredRoiReportQuery, FilteredRoiReportQueryVariables>(FilteredRoiReportDocument, options);
        }
export type FilteredRoiReportQueryHookResult = ReturnType<typeof useFilteredRoiReportQuery>;
export type FilteredRoiReportLazyQueryHookResult = ReturnType<typeof useFilteredRoiReportLazyQuery>;
export type FilteredRoiReportQueryResult = Apollo.QueryResult<FilteredRoiReportQuery, FilteredRoiReportQueryVariables>;
export const FetchLeaCoreDocument = gql`
    query FetchLeaCore($id: ID!) {
  leaCore(id: $id) {
    id
    leaNumber
    plannedDate
    createdAtTimestamp
    status
    termAndCondition
    data {
      expiryDurationDays
      expiryUnit
      expiryReminderDays
      reminderEmails
      computedMovementOrderIds
      computedSettledMovementOrderIds
      leaCoreNotes
    }
    childLeaCore {
      id
      data {
        computedMovementOrderIds
        computedSettledMovementOrderIds
      }
    }
    customerBranch {
      id
      name
    }
    customer {
      id
      name
    }
    leaLineItems {
      id
      leaLineItemsNotes
      reasonType
      descriptiveReason
      gallonPerMonth
      gallonPerVisit
      equipmentsData {
        assetTankTypes {
          name
          quantity
          unitCost
          totalCost
        }
        peripherals {
          name
          quantity
          unitCost
          totalCost
        }
        customItems {
          name
          quantity
          unitCost
          totalCost
        }
        finalTotalCost
      }
      movementOrder {
        id
        orderGroup {
          id
          status
          startOnTimestamp
          createdAtTimestamp
          completedOnTimestamp
          driver {
            id
            name
          }
          user {
            id
            name
          }
        }
        product {
          id
          shortName
        }
        assetMovementLocation {
          id
          lat
          lng
          orderGroupId
        }
        asset {
          id
          name
        }
        toCustomerBranch {
          id
          name
          customer {
            name
          }
        }
        fromCustomerBranch {
          id
          name
          customer {
            name
          }
        }
        requestedTankSize
        requestedTankType
        assignedTankSize
        assignedTankType
      }
      asset {
        id
        name
        hubs {
          id
          name
        }
      }
      requestProduct {
        id
        name
        shortName
      }
      assetPositionNumber
      requestTankType
      requestTankSize
      status
      leaPeripherals {
        id
        peripheral {
          id
          soldAs
          peripheralCategory {
            id
            name
          }
        }
        quantity
        notes
        unitCost
        status
      }
      customItemData {
        name
        qty
        unitCost
      }
      percentageOfCogs
      estimatedAssetValue
      estimatedMargin
      marginInPercentage
      marginPerGallonInCents
      totalMarginPerMonth
      bdrCommissionInPercent
      effectiveMarginInDollar
      effectiveMarginInPercent
      estimatedRoi
      unitCost
      leaAppliedFees {
        id
        applicableFee {
          id
          fee {
            id
            name
          }
        }
      }
    }
    interactionProgresses {
      completed
      currentStep
      data
      id
      subModule
      totalStep
    }
    leaQuestionnaire {
      id
      leaManager {
        id
        name
      }
      customerRepresentative {
        billingAddress
        city
        email
        name
        phone
        state
        zipCode
      }
      salesRepresentative {
        id
        name
        email
        phone
      }
      leaQuestionnaireAssets {
        product {
          id
          name
        }
        gallonPerMonth
        gallonPerDelivery
        tankSize
      }
      data {
        customer {
          id
          name
        }
        customerBranch {
          id
          name
        }
        notes
      }
    }
  }
}
    `;

/**
 * __useFetchLeaCoreQuery__
 *
 * To run a query within a React component, call `useFetchLeaCoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLeaCoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLeaCoreQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchLeaCoreQuery(baseOptions: Apollo.QueryHookOptions<FetchLeaCoreQuery, FetchLeaCoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLeaCoreQuery, FetchLeaCoreQueryVariables>(FetchLeaCoreDocument, options);
      }
export function useFetchLeaCoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLeaCoreQuery, FetchLeaCoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLeaCoreQuery, FetchLeaCoreQueryVariables>(FetchLeaCoreDocument, options);
        }
export type FetchLeaCoreQueryHookResult = ReturnType<typeof useFetchLeaCoreQuery>;
export type FetchLeaCoreLazyQueryHookResult = ReturnType<typeof useFetchLeaCoreLazyQuery>;
export type FetchLeaCoreQueryResult = Apollo.QueryResult<FetchLeaCoreQuery, FetchLeaCoreQueryVariables>;
export const FetchLeaListDocument = gql`
    query FetchLeaList($filter: LeaCoreFilter, $limit: Int, $offset: Int, $sorter: LeaCoreSorter) {
  filteredLeas(filter: $filter, limit: $limit, offset: $offset, sorter: $sorter) {
    collection {
      id
      state
      customer {
        id
        name
      }
      customerBranch {
        id
        name
      }
      leaNumber
      createdAtTimestamp
      interactionProgresses {
        completed
        currentStep
        data
        id
        subModule
        totalStep
      }
      leaQuestionnaire {
        id
        data {
          customer {
            id
            name
          }
        }
      }
    }
    metadata {
      totalCount
      hasMore
    }
  }
}
    `;

/**
 * __useFetchLeaListQuery__
 *
 * To run a query within a React component, call `useFetchLeaListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLeaListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLeaListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchLeaListQuery(baseOptions?: Apollo.QueryHookOptions<FetchLeaListQuery, FetchLeaListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLeaListQuery, FetchLeaListQueryVariables>(FetchLeaListDocument, options);
      }
export function useFetchLeaListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLeaListQuery, FetchLeaListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLeaListQuery, FetchLeaListQueryVariables>(FetchLeaListDocument, options);
        }
export type FetchLeaListQueryHookResult = ReturnType<typeof useFetchLeaListQuery>;
export type FetchLeaListLazyQueryHookResult = ReturnType<typeof useFetchLeaListLazyQuery>;
export type FetchLeaListQueryResult = Apollo.QueryResult<FetchLeaListQuery, FetchLeaListQueryVariables>;
export const FetchLeaMovementOrdersDocument = gql`
    query FetchLeaMovementOrders($id: ID!) {
  leaCore(id: $id) {
    id
    leaLineItems {
      id
      movementOrder {
        id
        orderGroup {
          id
          status
          startOnTimestamp
          createdAtTimestamp
          completedOnTimestamp
          driver {
            id
            name
          }
          user {
            id
            name
          }
        }
        product {
          id
          shortName
        }
        assetMovementLocation {
          id
          lat
          lng
          orderGroupId
        }
        asset {
          id
          name
        }
        toCustomerBranch {
          id
          name
          customer {
            name
          }
        }
        fromCustomerBranch {
          id
          name
          customer {
            name
          }
        }
        requestedTankSize
        requestedTankType
        assignedTankSize
        assignedTankType
      }
    }
  }
}
    `;

/**
 * __useFetchLeaMovementOrdersQuery__
 *
 * To run a query within a React component, call `useFetchLeaMovementOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLeaMovementOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLeaMovementOrdersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchLeaMovementOrdersQuery(baseOptions: Apollo.QueryHookOptions<FetchLeaMovementOrdersQuery, FetchLeaMovementOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLeaMovementOrdersQuery, FetchLeaMovementOrdersQueryVariables>(FetchLeaMovementOrdersDocument, options);
      }
export function useFetchLeaMovementOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLeaMovementOrdersQuery, FetchLeaMovementOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLeaMovementOrdersQuery, FetchLeaMovementOrdersQueryVariables>(FetchLeaMovementOrdersDocument, options);
        }
export type FetchLeaMovementOrdersQueryHookResult = ReturnType<typeof useFetchLeaMovementOrdersQuery>;
export type FetchLeaMovementOrdersLazyQueryHookResult = ReturnType<typeof useFetchLeaMovementOrdersLazyQuery>;
export type FetchLeaMovementOrdersQueryResult = Apollo.QueryResult<FetchLeaMovementOrdersQuery, FetchLeaMovementOrdersQueryVariables>;
export const FetchLeaRequestedAssetsDocument = gql`
    query FetchLeaRequestedAssets($limit: Int, $offset: Int, $sorter: [AssetSorter!], $filter: AssetFilter) {
  filteredAssets(limit: $limit, offset: $offset, sorter: $sorter, filter: $filter) {
    collection {
      id
      status
      name
      qrCodeText
      type
      tankSize
      tankType
      averageUtilization
      lastDeliveredTimestamp
      lastActiveTenantId
      actualRoi
      expectedRoi
      hubs {
        id
        name
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFetchLeaRequestedAssetsQuery__
 *
 * To run a query within a React component, call `useFetchLeaRequestedAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLeaRequestedAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLeaRequestedAssetsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchLeaRequestedAssetsQuery(baseOptions?: Apollo.QueryHookOptions<FetchLeaRequestedAssetsQuery, FetchLeaRequestedAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLeaRequestedAssetsQuery, FetchLeaRequestedAssetsQueryVariables>(FetchLeaRequestedAssetsDocument, options);
      }
export function useFetchLeaRequestedAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLeaRequestedAssetsQuery, FetchLeaRequestedAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLeaRequestedAssetsQuery, FetchLeaRequestedAssetsQueryVariables>(FetchLeaRequestedAssetsDocument, options);
        }
export type FetchLeaRequestedAssetsQueryHookResult = ReturnType<typeof useFetchLeaRequestedAssetsQuery>;
export type FetchLeaRequestedAssetsLazyQueryHookResult = ReturnType<typeof useFetchLeaRequestedAssetsLazyQuery>;
export type FetchLeaRequestedAssetsQueryResult = Apollo.QueryResult<FetchLeaRequestedAssetsQuery, FetchLeaRequestedAssetsQueryVariables>;
export const FetchLeaTenantContentDocument = gql`
    query FetchLeaTenantContent {
  fetchLeaTenantContent {
    content
    data
    updatedAt
    documentType
    tenant {
      name
    }
    title
  }
}
    `;

/**
 * __useFetchLeaTenantContentQuery__
 *
 * To run a query within a React component, call `useFetchLeaTenantContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLeaTenantContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLeaTenantContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchLeaTenantContentQuery(baseOptions?: Apollo.QueryHookOptions<FetchLeaTenantContentQuery, FetchLeaTenantContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLeaTenantContentQuery, FetchLeaTenantContentQueryVariables>(FetchLeaTenantContentDocument, options);
      }
export function useFetchLeaTenantContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLeaTenantContentQuery, FetchLeaTenantContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLeaTenantContentQuery, FetchLeaTenantContentQueryVariables>(FetchLeaTenantContentDocument, options);
        }
export type FetchLeaTenantContentQueryHookResult = ReturnType<typeof useFetchLeaTenantContentQuery>;
export type FetchLeaTenantContentLazyQueryHookResult = ReturnType<typeof useFetchLeaTenantContentLazyQuery>;
export type FetchLeaTenantContentQueryResult = Apollo.QueryResult<FetchLeaTenantContentQuery, FetchLeaTenantContentQueryVariables>;
export const FetchPostSignaturesDocument = gql`
    query FetchPostSignatures($id: ID!) {
  leaCore(id: $id) {
    id
    isSigned
    status
    leaNumber
    data {
      computedMovementOrderIds
      computedSettledMovementOrderIds
    }
    previewDocument(documentType: final_agreement) {
      fileName
      content
      error
    }
    leaPostSignatures {
      id
      fileUrl
      fileData
      fileName
      createdAt
      documentType
      documentableId
      leaUpdatedById
      leaDocumentType
      leaCreatedByName
      leaSignedDocument
    }
  }
}
    `;

/**
 * __useFetchPostSignaturesQuery__
 *
 * To run a query within a React component, call `useFetchPostSignaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPostSignaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPostSignaturesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchPostSignaturesQuery(baseOptions: Apollo.QueryHookOptions<FetchPostSignaturesQuery, FetchPostSignaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPostSignaturesQuery, FetchPostSignaturesQueryVariables>(FetchPostSignaturesDocument, options);
      }
export function useFetchPostSignaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPostSignaturesQuery, FetchPostSignaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPostSignaturesQuery, FetchPostSignaturesQueryVariables>(FetchPostSignaturesDocument, options);
        }
export type FetchPostSignaturesQueryHookResult = ReturnType<typeof useFetchPostSignaturesQuery>;
export type FetchPostSignaturesLazyQueryHookResult = ReturnType<typeof useFetchPostSignaturesLazyQuery>;
export type FetchPostSignaturesQueryResult = Apollo.QueryResult<FetchPostSignaturesQuery, FetchPostSignaturesQueryVariables>;
export const FetchFilteredApplicableFeesDocument = gql`
    query FetchFilteredApplicableFees($feeableId: ID) {
  filteredApplicableFees(
    filter: {feeableId: $feeableId, feeableType: "CustomerBranch"}
  ) {
    collection {
      id
      isDefault
      price
      quantity
      fee {
        id
        code
        name
        price
        deleted
        applicableType
      }
    }
  }
}
    `;

/**
 * __useFetchFilteredApplicableFeesQuery__
 *
 * To run a query within a React component, call `useFetchFilteredApplicableFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredApplicableFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredApplicableFeesQuery({
 *   variables: {
 *      feeableId: // value for 'feeableId'
 *   },
 * });
 */
export function useFetchFilteredApplicableFeesQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredApplicableFeesQuery, FetchFilteredApplicableFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredApplicableFeesQuery, FetchFilteredApplicableFeesQueryVariables>(FetchFilteredApplicableFeesDocument, options);
      }
export function useFetchFilteredApplicableFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredApplicableFeesQuery, FetchFilteredApplicableFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredApplicableFeesQuery, FetchFilteredApplicableFeesQueryVariables>(FetchFilteredApplicableFeesDocument, options);
        }
export type FetchFilteredApplicableFeesQueryHookResult = ReturnType<typeof useFetchFilteredApplicableFeesQuery>;
export type FetchFilteredApplicableFeesLazyQueryHookResult = ReturnType<typeof useFetchFilteredApplicableFeesLazyQuery>;
export type FetchFilteredApplicableFeesQueryResult = Apollo.QueryResult<FetchFilteredApplicableFeesQuery, FetchFilteredApplicableFeesQueryVariables>;
export const FilteredApplicableFeesByCustomerBranchDocument = gql`
    query FilteredApplicableFeesByCustomerBranch($customerId: ID) {
  filteredCustomerBranches(filter: {customerId: $customerId}) {
    collection {
      id
      name
      applicableFees {
        id
        fee {
          id
          name
          applicableType
        }
      }
    }
  }
}
    `;

/**
 * __useFilteredApplicableFeesByCustomerBranchQuery__
 *
 * To run a query within a React component, call `useFilteredApplicableFeesByCustomerBranchQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredApplicableFeesByCustomerBranchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredApplicableFeesByCustomerBranchQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useFilteredApplicableFeesByCustomerBranchQuery(baseOptions?: Apollo.QueryHookOptions<FilteredApplicableFeesByCustomerBranchQuery, FilteredApplicableFeesByCustomerBranchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredApplicableFeesByCustomerBranchQuery, FilteredApplicableFeesByCustomerBranchQueryVariables>(FilteredApplicableFeesByCustomerBranchDocument, options);
      }
export function useFilteredApplicableFeesByCustomerBranchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredApplicableFeesByCustomerBranchQuery, FilteredApplicableFeesByCustomerBranchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredApplicableFeesByCustomerBranchQuery, FilteredApplicableFeesByCustomerBranchQueryVariables>(FilteredApplicableFeesByCustomerBranchDocument, options);
        }
export type FilteredApplicableFeesByCustomerBranchQueryHookResult = ReturnType<typeof useFilteredApplicableFeesByCustomerBranchQuery>;
export type FilteredApplicableFeesByCustomerBranchLazyQueryHookResult = ReturnType<typeof useFilteredApplicableFeesByCustomerBranchLazyQuery>;
export type FilteredApplicableFeesByCustomerBranchQueryResult = Apollo.QueryResult<FilteredApplicableFeesByCustomerBranchQuery, FilteredApplicableFeesByCustomerBranchQueryVariables>;
export const FilteredLeasDocument = gql`
    query FilteredLeas($filter: LeaCoreFilter, $limit: Int, $offset: Int, $sorter: LeaCoreSorter) {
  filteredLeas(filter: $filter, limit: $limit, offset: $offset, sorter: $sorter) {
    collection {
      id
      interactionProgresses {
        completed
        currentStep
        data
        id
        subModule
        totalStep
      }
      leaNumber
      plannedDate
      status
      customer {
        id
        name
      }
      customerBranch {
        id
        name
      }
      data {
        expiryDurationDays
        expiryReminderDays
        reminderEmails
      }
      isSigned
      leaLineItems {
        id
        requestProduct {
          id
          name
        }
        requestTankSize
        requestTankType
        status
        leaPeripherals {
          id
          peripheral {
            id
            soldAs
            subType
            peripheralCategory {
              id
              name
            }
          }
          quantity
          notes
          unitCost
          status
        }
        marginInPercentage
        estimatedMargin
        estimatedAssetValue
        percentageOfCogs
        marginPerGallonInCents
        totalMarginPerMonth
        bdrCommissionInPercent
        effectiveMarginInDollar
        effectiveMarginInPercent
        estimatedRoi
        gallonPerMonth
        gallonPerVisit
        unitCost
        gallonPerMonth
        gallonPerVisit
        customItemData {
          name
          qty
          unitCost
        }
        movementOrder {
          id
          orderGroup {
            id
            status
            driver {
              id
              name
            }
            user {
              id
              name
            }
          }
          product {
            id
            shortName
          }
          asset {
            id
            name
          }
          toCustomerBranch {
            id
            name
            customer {
              id
              name
            }
          }
          fromCustomerBranch {
            id
            name
            customer {
              id
              name
            }
          }
          requestedTankSize
          requestedTankType
          assignedTankSize
          assignedTankType
        }
      }
      leaPreSignatures {
        id
        createdAt
        fileName
        fileUrl
        leaCreatedByName
        leaUpdatedById
        documentType
        leaDocumentType
        leaSignedDocument
      }
      leaPostSignatures {
        id
        createdAt
        fileName
        fileUrl
        leaCreatedByName
        leaUpdatedById
        documentType
        leaDocumentType
        leaSignedDocument
      }
      leaQuestionnaire {
        id
        data {
          customer {
            id
            name
          }
          customerBranch {
            id
            name
          }
        }
        leaManager {
          name
        }
        customerRepresentative {
          name
        }
        salesRepresentative {
          name
        }
        leaQuestionnaireAssets {
          product {
            id
            name
          }
          tankSize
        }
      }
      state
      createdAtTimestamp
    }
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useFilteredLeasQuery__
 *
 * To run a query within a React component, call `useFilteredLeasQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredLeasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredLeasQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilteredLeasQuery(baseOptions?: Apollo.QueryHookOptions<FilteredLeasQuery, FilteredLeasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredLeasQuery, FilteredLeasQueryVariables>(FilteredLeasDocument, options);
      }
export function useFilteredLeasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredLeasQuery, FilteredLeasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredLeasQuery, FilteredLeasQueryVariables>(FilteredLeasDocument, options);
        }
export type FilteredLeasQueryHookResult = ReturnType<typeof useFilteredLeasQuery>;
export type FilteredLeasLazyQueryHookResult = ReturnType<typeof useFilteredLeasLazyQuery>;
export type FilteredLeasQueryResult = Apollo.QueryResult<FilteredLeasQuery, FilteredLeasQueryVariables>;
export const LeaManagersDocument = gql`
    query LeaManagers {
  leaManagers {
    id
    name
    address
    email
    gravatar
    image {
      contentType
      filename
      id
      url
    }
    isSuperAdmin
    name
    otp
    phone
    status
  }
}
    `;

/**
 * __useLeaManagersQuery__
 *
 * To run a query within a React component, call `useLeaManagersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeaManagersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaManagersQuery({
 *   variables: {
 *   },
 * });
 */
export function useLeaManagersQuery(baseOptions?: Apollo.QueryHookOptions<LeaManagersQuery, LeaManagersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeaManagersQuery, LeaManagersQueryVariables>(LeaManagersDocument, options);
      }
export function useLeaManagersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeaManagersQuery, LeaManagersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeaManagersQuery, LeaManagersQueryVariables>(LeaManagersDocument, options);
        }
export type LeaManagersQueryHookResult = ReturnType<typeof useLeaManagersQuery>;
export type LeaManagersLazyQueryHookResult = ReturnType<typeof useLeaManagersLazyQuery>;
export type LeaManagersQueryResult = Apollo.QueryResult<LeaManagersQuery, LeaManagersQueryVariables>;
export const SendMailToPocDocument = gql`
    mutation sendMailToPoc($input: SendMailToPocInput!) {
  sendMailToPoc(input: $input) {
    success
  }
}
    `;
export type SendMailToPocMutationFn = Apollo.MutationFunction<SendMailToPocMutation, SendMailToPocMutationVariables>;

/**
 * __useSendMailToPocMutation__
 *
 * To run a mutation, you first call `useSendMailToPocMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMailToPocMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMailToPocMutation, { data, loading, error }] = useSendMailToPocMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendMailToPocMutation(baseOptions?: Apollo.MutationHookOptions<SendMailToPocMutation, SendMailToPocMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMailToPocMutation, SendMailToPocMutationVariables>(SendMailToPocDocument, options);
      }
export type SendMailToPocMutationHookResult = ReturnType<typeof useSendMailToPocMutation>;
export type SendMailToPocMutationResult = Apollo.MutationResult<SendMailToPocMutation>;
export type SendMailToPocMutationOptions = Apollo.BaseMutationOptions<SendMailToPocMutation, SendMailToPocMutationVariables>;
export const UpdateLeaCoreV2Document = gql`
    mutation updateLeaCoreV2($input: UpdateLeaCoreInput!) {
  updateLeaCore(input: $input) {
    leaType {
      leaCore {
        id
        leaNumber
        termAndCondition
        data {
          expiryDurationDays
          expiryReminderDays
          expiryUnit
          reminderEmails
          computedMovementOrderIds
          computedSettledMovementOrderIds
          leaCoreNotes
        }
        customerBranch {
          id
          name
        }
        customer {
          id
          name
        }
        leaLineItems {
          id
          leaLineItemsNotes
          equipmentsData {
            assetTankTypes {
              name
              quantity
              unitCost
              totalCost
            }
            peripherals {
              name
              quantity
              unitCost
              totalCost
            }
            customItems {
              name
              quantity
              unitCost
              totalCost
            }
            finalTotalCost
          }
          movementOrder {
            id
            orderGroup {
              id
              status
              startOnTimestamp
              createdAtTimestamp
              completedOnTimestamp
              driver {
                id
                name
              }
              user {
                id
                name
              }
            }
            product {
              id
              shortName
            }
            assetMovementLocation {
              id
              lat
              lng
              orderGroupId
            }
            asset {
              id
              name
            }
            toCustomerBranch {
              id
              name
              customer {
                name
              }
            }
            fromCustomerBranch {
              id
              name
              customer {
                name
              }
            }
            requestedTankSize
            requestedTankType
            assignedTankSize
            assignedTankType
          }
          requestProduct {
            id
            name
            shortName
          }
          assetPositionNumber
          requestTankType
          requestTankSize
          status
          leaPeripherals {
            id
            peripheral {
              id
              soldAs
              peripheralCategory {
                id
                name
              }
            }
            quantity
            notes
            unitCost
            status
          }
          customItemData {
            name
            qty
            unitCost
          }
          percentageOfCogs
          estimatedAssetValue
          estimatedMargin
          marginInPercentage
          marginPerGallonInCents
          totalMarginPerMonth
          bdrCommissionInPercent
          effectiveMarginInDollar
          effectiveMarginInPercent
          estimatedRoi
          unitCost
          gallonPerMonth
          gallonPerVisit
          leaAppliedFees {
            id
            applicableFee {
              id
              fee {
                id
                name
              }
            }
          }
        }
        interactionProgresses {
          completed
          currentStep
          data
          id
          subModule
          totalStep
        }
      }
      success
      error
    }
  }
}
    `;
export type UpdateLeaCoreV2MutationFn = Apollo.MutationFunction<UpdateLeaCoreV2Mutation, UpdateLeaCoreV2MutationVariables>;

/**
 * __useUpdateLeaCoreV2Mutation__
 *
 * To run a mutation, you first call `useUpdateLeaCoreV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeaCoreV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeaCoreV2Mutation, { data, loading, error }] = useUpdateLeaCoreV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLeaCoreV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeaCoreV2Mutation, UpdateLeaCoreV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeaCoreV2Mutation, UpdateLeaCoreV2MutationVariables>(UpdateLeaCoreV2Document, options);
      }
export type UpdateLeaCoreV2MutationHookResult = ReturnType<typeof useUpdateLeaCoreV2Mutation>;
export type UpdateLeaCoreV2MutationResult = Apollo.MutationResult<UpdateLeaCoreV2Mutation>;
export type UpdateLeaCoreV2MutationOptions = Apollo.BaseMutationOptions<UpdateLeaCoreV2Mutation, UpdateLeaCoreV2MutationVariables>;
export const CreateLeaCoreDocument = gql`
    mutation CreateLeaCore($input: CreateLeaCoreInput!) {
  createLeaCore(input: $input) {
    leaType {
      leaCore {
        id
      }
      success
      error
    }
  }
}
    `;
export type CreateLeaCoreMutationFn = Apollo.MutationFunction<CreateLeaCoreMutation, CreateLeaCoreMutationVariables>;

/**
 * __useCreateLeaCoreMutation__
 *
 * To run a mutation, you first call `useCreateLeaCoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeaCoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeaCoreMutation, { data, loading, error }] = useCreateLeaCoreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLeaCoreMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeaCoreMutation, CreateLeaCoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeaCoreMutation, CreateLeaCoreMutationVariables>(CreateLeaCoreDocument, options);
      }
export type CreateLeaCoreMutationHookResult = ReturnType<typeof useCreateLeaCoreMutation>;
export type CreateLeaCoreMutationResult = Apollo.MutationResult<CreateLeaCoreMutation>;
export type CreateLeaCoreMutationOptions = Apollo.BaseMutationOptions<CreateLeaCoreMutation, CreateLeaCoreMutationVariables>;
export const DeleteLeaCoreDocument = gql`
    mutation deleteLeaCore($input: DeleteLeaCoreInput!) {
  deleteLeaCore(input: $input) {
    leaType {
      leaCore {
        id
      }
      error
      success
    }
  }
}
    `;
export type DeleteLeaCoreMutationFn = Apollo.MutationFunction<DeleteLeaCoreMutation, DeleteLeaCoreMutationVariables>;

/**
 * __useDeleteLeaCoreMutation__
 *
 * To run a mutation, you first call `useDeleteLeaCoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLeaCoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLeaCoreMutation, { data, loading, error }] = useDeleteLeaCoreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLeaCoreMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLeaCoreMutation, DeleteLeaCoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLeaCoreMutation, DeleteLeaCoreMutationVariables>(DeleteLeaCoreDocument, options);
      }
export type DeleteLeaCoreMutationHookResult = ReturnType<typeof useDeleteLeaCoreMutation>;
export type DeleteLeaCoreMutationResult = Apollo.MutationResult<DeleteLeaCoreMutation>;
export type DeleteLeaCoreMutationOptions = Apollo.BaseMutationOptions<DeleteLeaCoreMutation, DeleteLeaCoreMutationVariables>;
export const FetchLeaDocumentDocument = gql`
    query FetchLeaDocument($id: ID!) {
  leaCore(id: $id) {
    id
    status
    previewDocument(documentType: final_agreement) {
      fileName
      content
      error
    }
  }
}
    `;

/**
 * __useFetchLeaDocumentQuery__
 *
 * To run a query within a React component, call `useFetchLeaDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLeaDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLeaDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchLeaDocumentQuery(baseOptions: Apollo.QueryHookOptions<FetchLeaDocumentQuery, FetchLeaDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLeaDocumentQuery, FetchLeaDocumentQueryVariables>(FetchLeaDocumentDocument, options);
      }
export function useFetchLeaDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLeaDocumentQuery, FetchLeaDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLeaDocumentQuery, FetchLeaDocumentQueryVariables>(FetchLeaDocumentDocument, options);
        }
export type FetchLeaDocumentQueryHookResult = ReturnType<typeof useFetchLeaDocumentQuery>;
export type FetchLeaDocumentLazyQueryHookResult = ReturnType<typeof useFetchLeaDocumentLazyQuery>;
export type FetchLeaDocumentQueryResult = Apollo.QueryResult<FetchLeaDocumentQuery, FetchLeaDocumentQueryVariables>;
export const FetchPreSignaturesForWorkOrderDocumentDocument = gql`
    query FetchPreSignaturesForWorkOrderDocument($id: ID!) {
  leaCore(id: $id) {
    id
    status
    isSigned
    leaNumber
    previewDocument {
      fileName
      content
      error
    }
    leaPreSignatures {
      id
      fileUrl
      fileData
      fileName
      createdAt
      documentType
      documentableId
      externalFileData {
        contentType
        filename
      }
      leaUpdatedById
      leaDocumentType
      leaCreatedByName
      leaSignedDocument
    }
  }
}
    `;

/**
 * __useFetchPreSignaturesForWorkOrderDocumentQuery__
 *
 * To run a query within a React component, call `useFetchPreSignaturesForWorkOrderDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPreSignaturesForWorkOrderDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPreSignaturesForWorkOrderDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchPreSignaturesForWorkOrderDocumentQuery(baseOptions: Apollo.QueryHookOptions<FetchPreSignaturesForWorkOrderDocumentQuery, FetchPreSignaturesForWorkOrderDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPreSignaturesForWorkOrderDocumentQuery, FetchPreSignaturesForWorkOrderDocumentQueryVariables>(FetchPreSignaturesForWorkOrderDocumentDocument, options);
      }
export function useFetchPreSignaturesForWorkOrderDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPreSignaturesForWorkOrderDocumentQuery, FetchPreSignaturesForWorkOrderDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPreSignaturesForWorkOrderDocumentQuery, FetchPreSignaturesForWorkOrderDocumentQueryVariables>(FetchPreSignaturesForWorkOrderDocumentDocument, options);
        }
export type FetchPreSignaturesForWorkOrderDocumentQueryHookResult = ReturnType<typeof useFetchPreSignaturesForWorkOrderDocumentQuery>;
export type FetchPreSignaturesForWorkOrderDocumentLazyQueryHookResult = ReturnType<typeof useFetchPreSignaturesForWorkOrderDocumentLazyQuery>;
export type FetchPreSignaturesForWorkOrderDocumentQueryResult = Apollo.QueryResult<FetchPreSignaturesForWorkOrderDocumentQuery, FetchPreSignaturesForWorkOrderDocumentQueryVariables>;
export const SaveTenantContentDocument = gql`
    mutation saveTenantContent($input: SaveTenantContentInput!) {
  saveTenantContent(input: $input) {
    tenantContent {
      id
    }
    success
    error
  }
}
    `;
export type SaveTenantContentMutationFn = Apollo.MutationFunction<SaveTenantContentMutation, SaveTenantContentMutationVariables>;

/**
 * __useSaveTenantContentMutation__
 *
 * To run a mutation, you first call `useSaveTenantContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTenantContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTenantContentMutation, { data, loading, error }] = useSaveTenantContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTenantContentMutation(baseOptions?: Apollo.MutationHookOptions<SaveTenantContentMutation, SaveTenantContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTenantContentMutation, SaveTenantContentMutationVariables>(SaveTenantContentDocument, options);
      }
export type SaveTenantContentMutationHookResult = ReturnType<typeof useSaveTenantContentMutation>;
export type SaveTenantContentMutationResult = Apollo.MutationResult<SaveTenantContentMutation>;
export type SaveTenantContentMutationOptions = Apollo.BaseMutationOptions<SaveTenantContentMutation, SaveTenantContentMutationVariables>;
export const SendmailDocument = gql`
    mutation sendmail($input: SendLeaMailInput!) {
  sendLeaMail(input: $input) {
    success
    toEmail
  }
}
    `;
export type SendmailMutationFn = Apollo.MutationFunction<SendmailMutation, SendmailMutationVariables>;

/**
 * __useSendmailMutation__
 *
 * To run a mutation, you first call `useSendmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendmailMutation, { data, loading, error }] = useSendmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendmailMutation(baseOptions?: Apollo.MutationHookOptions<SendmailMutation, SendmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendmailMutation, SendmailMutationVariables>(SendmailDocument, options);
      }
export type SendmailMutationHookResult = ReturnType<typeof useSendmailMutation>;
export type SendmailMutationResult = Apollo.MutationResult<SendmailMutation>;
export type SendmailMutationOptions = Apollo.BaseMutationOptions<SendmailMutation, SendmailMutationVariables>;
export const UpdateLeaCoreDocument = gql`
    mutation updateLeaCore($input: UpdateLeaCoreInput!) {
  updateLeaCore(input: $input) {
    leaType {
      leaCore {
        id
        interactionProgresses {
          completed
          currentStep
          data
          id
          subModule
          totalStep
        }
      }
      success
      error
    }
  }
}
    `;
export type UpdateLeaCoreMutationFn = Apollo.MutationFunction<UpdateLeaCoreMutation, UpdateLeaCoreMutationVariables>;

/**
 * __useUpdateLeaCoreMutation__
 *
 * To run a mutation, you first call `useUpdateLeaCoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeaCoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeaCoreMutation, { data, loading, error }] = useUpdateLeaCoreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLeaCoreMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeaCoreMutation, UpdateLeaCoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeaCoreMutation, UpdateLeaCoreMutationVariables>(UpdateLeaCoreDocument, options);
      }
export type UpdateLeaCoreMutationHookResult = ReturnType<typeof useUpdateLeaCoreMutation>;
export type UpdateLeaCoreMutationResult = Apollo.MutationResult<UpdateLeaCoreMutation>;
export type UpdateLeaCoreMutationOptions = Apollo.BaseMutationOptions<UpdateLeaCoreMutation, UpdateLeaCoreMutationVariables>;
export const UpdateLeaDocumentDocument = gql`
    mutation UpdateLeaDocument($input: UpdateLeaDocumentInput!) {
  updateLeaDocument(input: $input) {
    pandaDocument {
      id
      fileUrl
      leaSignedDocument
      leaDocumentType
      leaUpdatedById
      leaUpdatedByName
    }
  }
}
    `;
export type UpdateLeaDocumentMutationFn = Apollo.MutationFunction<UpdateLeaDocumentMutation, UpdateLeaDocumentMutationVariables>;

/**
 * __useUpdateLeaDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateLeaDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeaDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeaDocumentMutation, { data, loading, error }] = useUpdateLeaDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLeaDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeaDocumentMutation, UpdateLeaDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeaDocumentMutation, UpdateLeaDocumentMutationVariables>(UpdateLeaDocumentDocument, options);
      }
export type UpdateLeaDocumentMutationHookResult = ReturnType<typeof useUpdateLeaDocumentMutation>;
export type UpdateLeaDocumentMutationResult = Apollo.MutationResult<UpdateLeaDocumentMutation>;
export type UpdateLeaDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateLeaDocumentMutation, UpdateLeaDocumentMutationVariables>;
export const FetchDeliveryOrderBaseForUpdateDeliveryOrderPageDocument = gql`
    query FetchDeliveryOrderBaseForUpdateDeliveryOrderPage($id: ID!) {
  deliveryOrder(id: $id) {
    id
    deliveryDateTimestamp
    orderGroupId
    deliveryInstruction
    type
    diversionNumbers
    deliveryOrderLineItems {
      id
      status
      volume
      requestedVolume
      subscription {
        product {
          code
          id
          name
        }
        asset {
          id
          name
        }
      }
      product {
        active
        id
        name
        soldAs
        category
        productType
        comparableProducts {
          id
          productResource {
            id
            name
          }
        }
        productConstituents {
          id
          percentage
          basicProduct {
            id
            name
            category
          }
        }
      }
      asset {
        id
        name
        category
      }
      warehouse {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useFetchDeliveryOrderBaseForUpdateDeliveryOrderPageQuery__
 *
 * To run a query within a React component, call `useFetchDeliveryOrderBaseForUpdateDeliveryOrderPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDeliveryOrderBaseForUpdateDeliveryOrderPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDeliveryOrderBaseForUpdateDeliveryOrderPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchDeliveryOrderBaseForUpdateDeliveryOrderPageQuery(baseOptions: Apollo.QueryHookOptions<FetchDeliveryOrderBaseForUpdateDeliveryOrderPageQuery, FetchDeliveryOrderBaseForUpdateDeliveryOrderPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDeliveryOrderBaseForUpdateDeliveryOrderPageQuery, FetchDeliveryOrderBaseForUpdateDeliveryOrderPageQueryVariables>(FetchDeliveryOrderBaseForUpdateDeliveryOrderPageDocument, options);
      }
export function useFetchDeliveryOrderBaseForUpdateDeliveryOrderPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDeliveryOrderBaseForUpdateDeliveryOrderPageQuery, FetchDeliveryOrderBaseForUpdateDeliveryOrderPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDeliveryOrderBaseForUpdateDeliveryOrderPageQuery, FetchDeliveryOrderBaseForUpdateDeliveryOrderPageQueryVariables>(FetchDeliveryOrderBaseForUpdateDeliveryOrderPageDocument, options);
        }
export type FetchDeliveryOrderBaseForUpdateDeliveryOrderPageQueryHookResult = ReturnType<typeof useFetchDeliveryOrderBaseForUpdateDeliveryOrderPageQuery>;
export type FetchDeliveryOrderBaseForUpdateDeliveryOrderPageLazyQueryHookResult = ReturnType<typeof useFetchDeliveryOrderBaseForUpdateDeliveryOrderPageLazyQuery>;
export type FetchDeliveryOrderBaseForUpdateDeliveryOrderPageQueryResult = Apollo.QueryResult<FetchDeliveryOrderBaseForUpdateDeliveryOrderPageQuery, FetchDeliveryOrderBaseForUpdateDeliveryOrderPageQueryVariables>;
export const FetchOrderGroupForUpdateDeliveryOrderPageDocument = gql`
    query FetchOrderGroupForUpdateDeliveryOrderPage($id: ID!) {
  deliveryOrder(id: $id) {
    id
    orderGroup {
      hub {
        id
        name
      }
      purchaseOrderType
      ccTenantId
      sendCarrierEmail
      id
      priority
      carrierNumber
      poNumber
      purchaseOrderType
      startOnTimestamp
      worker {
        id
        name
      }
      orderGroupsFees {
        id
        price
        quantity
        fee {
          id
          code
          name
          price
          standard
          deleted
        }
      }
      taggings {
        id
        tag {
          id
          colorCode
          description
          erpId
          iconName
          name
          status
          tagType
        }
      }
      ccTenant {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useFetchOrderGroupForUpdateDeliveryOrderPageQuery__
 *
 * To run a query within a React component, call `useFetchOrderGroupForUpdateDeliveryOrderPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOrderGroupForUpdateDeliveryOrderPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOrderGroupForUpdateDeliveryOrderPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchOrderGroupForUpdateDeliveryOrderPageQuery(baseOptions: Apollo.QueryHookOptions<FetchOrderGroupForUpdateDeliveryOrderPageQuery, FetchOrderGroupForUpdateDeliveryOrderPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchOrderGroupForUpdateDeliveryOrderPageQuery, FetchOrderGroupForUpdateDeliveryOrderPageQueryVariables>(FetchOrderGroupForUpdateDeliveryOrderPageDocument, options);
      }
export function useFetchOrderGroupForUpdateDeliveryOrderPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchOrderGroupForUpdateDeliveryOrderPageQuery, FetchOrderGroupForUpdateDeliveryOrderPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchOrderGroupForUpdateDeliveryOrderPageQuery, FetchOrderGroupForUpdateDeliveryOrderPageQueryVariables>(FetchOrderGroupForUpdateDeliveryOrderPageDocument, options);
        }
export type FetchOrderGroupForUpdateDeliveryOrderPageQueryHookResult = ReturnType<typeof useFetchOrderGroupForUpdateDeliveryOrderPageQuery>;
export type FetchOrderGroupForUpdateDeliveryOrderPageLazyQueryHookResult = ReturnType<typeof useFetchOrderGroupForUpdateDeliveryOrderPageLazyQuery>;
export type FetchOrderGroupForUpdateDeliveryOrderPageQueryResult = Apollo.QueryResult<FetchOrderGroupForUpdateDeliveryOrderPageQuery, FetchOrderGroupForUpdateDeliveryOrderPageQueryVariables>;
export const FetchLinkedOrdersForUpdateDeliveryOrderPageDocument = gql`
    query FetchLinkedOrdersForUpdateDeliveryOrderPage($id: ID!) {
  deliveryOrder(id: $id) {
    id
    linkedOrders {
      id
      orderGroupId
      loadingInstruction
      loadingOrderProducts {
        id
        preferredSuppliers {
          id
          priority
          loadingAccount {
            id
            loadingNumber
            carrierCustomerCode
            destinationState
            supplierCode
            name
            label
            supplier {
              id
              erpId
              name
              supplierCode
            }
          }
        }
        product {
          id
          code
          name
          category
          colorCode
          shortName
          productType
          unit
          soldAs
          brand {
            id
            name
          }
        }
        blendLoadingProduct {
          id
          blendProduct {
            id
            name
            shortName
            code
            category
            colorCode
            soldAs
            productConstituents {
              id
              percentage
              basicProduct {
                id
                code
                name
                category
                colorCode
                shortName
                soldAs
              }
            }
          }
        }
      }
      terminal {
        id
        name
        active
        suppliers {
          id
          name
          supplierId
          active
          loadingAccounts {
            id
            carrierCustomerCode
            loadingNumber
            supplierCode
            name
            supplierId
            label
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchLinkedOrdersForUpdateDeliveryOrderPageQuery__
 *
 * To run a query within a React component, call `useFetchLinkedOrdersForUpdateDeliveryOrderPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLinkedOrdersForUpdateDeliveryOrderPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLinkedOrdersForUpdateDeliveryOrderPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchLinkedOrdersForUpdateDeliveryOrderPageQuery(baseOptions: Apollo.QueryHookOptions<FetchLinkedOrdersForUpdateDeliveryOrderPageQuery, FetchLinkedOrdersForUpdateDeliveryOrderPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLinkedOrdersForUpdateDeliveryOrderPageQuery, FetchLinkedOrdersForUpdateDeliveryOrderPageQueryVariables>(FetchLinkedOrdersForUpdateDeliveryOrderPageDocument, options);
      }
export function useFetchLinkedOrdersForUpdateDeliveryOrderPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLinkedOrdersForUpdateDeliveryOrderPageQuery, FetchLinkedOrdersForUpdateDeliveryOrderPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLinkedOrdersForUpdateDeliveryOrderPageQuery, FetchLinkedOrdersForUpdateDeliveryOrderPageQueryVariables>(FetchLinkedOrdersForUpdateDeliveryOrderPageDocument, options);
        }
export type FetchLinkedOrdersForUpdateDeliveryOrderPageQueryHookResult = ReturnType<typeof useFetchLinkedOrdersForUpdateDeliveryOrderPageQuery>;
export type FetchLinkedOrdersForUpdateDeliveryOrderPageLazyQueryHookResult = ReturnType<typeof useFetchLinkedOrdersForUpdateDeliveryOrderPageLazyQuery>;
export type FetchLinkedOrdersForUpdateDeliveryOrderPageQueryResult = Apollo.QueryResult<FetchLinkedOrdersForUpdateDeliveryOrderPageQuery, FetchLinkedOrdersForUpdateDeliveryOrderPageQueryVariables>;
export const FetchCustomerBranchForUpdateDeliveryOrderPageDocument = gql`
    query FetchCustomerBranchForUpdateDeliveryOrderPage($id: ID!) {
  deliveryOrder(id: $id) {
    id
    customerBranch {
      id
      name
      address
      erpId
      deliveryInstruction
      site {
        city
        state
      }
      addressBooks {
        name
        phone
        addressBookType
      }
      customer {
        id
        name
        totalRequestedVolume
        productPurchaseLimit {
          volume
          product {
            id
            name
          }
        }
        deliveryInstruction
        addressBooks {
          name
          phone
        }
        thirdPartyDelivery
        paymentTerm {
          id
          name
        }
        customerSegment {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useFetchCustomerBranchForUpdateDeliveryOrderPageQuery__
 *
 * To run a query within a React component, call `useFetchCustomerBranchForUpdateDeliveryOrderPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomerBranchForUpdateDeliveryOrderPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomerBranchForUpdateDeliveryOrderPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchCustomerBranchForUpdateDeliveryOrderPageQuery(baseOptions: Apollo.QueryHookOptions<FetchCustomerBranchForUpdateDeliveryOrderPageQuery, FetchCustomerBranchForUpdateDeliveryOrderPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomerBranchForUpdateDeliveryOrderPageQuery, FetchCustomerBranchForUpdateDeliveryOrderPageQueryVariables>(FetchCustomerBranchForUpdateDeliveryOrderPageDocument, options);
      }
export function useFetchCustomerBranchForUpdateDeliveryOrderPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomerBranchForUpdateDeliveryOrderPageQuery, FetchCustomerBranchForUpdateDeliveryOrderPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomerBranchForUpdateDeliveryOrderPageQuery, FetchCustomerBranchForUpdateDeliveryOrderPageQueryVariables>(FetchCustomerBranchForUpdateDeliveryOrderPageDocument, options);
        }
export type FetchCustomerBranchForUpdateDeliveryOrderPageQueryHookResult = ReturnType<typeof useFetchCustomerBranchForUpdateDeliveryOrderPageQuery>;
export type FetchCustomerBranchForUpdateDeliveryOrderPageLazyQueryHookResult = ReturnType<typeof useFetchCustomerBranchForUpdateDeliveryOrderPageLazyQuery>;
export type FetchCustomerBranchForUpdateDeliveryOrderPageQueryResult = Apollo.QueryResult<FetchCustomerBranchForUpdateDeliveryOrderPageQuery, FetchCustomerBranchForUpdateDeliveryOrderPageQueryVariables>;
export const CreateBolPricingDocument = gql`
    mutation CreateBOLPricing($input: CreateBolPricingInput!) {
  createBolPricing(input: $input) {
    bolPricing {
      id
      total
      itemType
      rate
      quantity
      tax {
        id
        name
        productCategoryId
        rateType
        name
      }
    }
  }
}
    `;
export type CreateBolPricingMutationFn = Apollo.MutationFunction<CreateBolPricingMutation, CreateBolPricingMutationVariables>;

/**
 * __useCreateBolPricingMutation__
 *
 * To run a mutation, you first call `useCreateBolPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBolPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBolPricingMutation, { data, loading, error }] = useCreateBolPricingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBolPricingMutation(baseOptions?: Apollo.MutationHookOptions<CreateBolPricingMutation, CreateBolPricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBolPricingMutation, CreateBolPricingMutationVariables>(CreateBolPricingDocument, options);
      }
export type CreateBolPricingMutationHookResult = ReturnType<typeof useCreateBolPricingMutation>;
export type CreateBolPricingMutationResult = Apollo.MutationResult<CreateBolPricingMutation>;
export type CreateBolPricingMutationOptions = Apollo.BaseMutationOptions<CreateBolPricingMutation, CreateBolPricingMutationVariables>;
export const AddFeesToOrderGroupDocument = gql`
    mutation AddFeesToOrderGroup($input: AddFeesToOrderGroupInput!) {
  addFeesToOrderGroup(input: $input) {
    orderGroup {
      id
      orderGroupsFees {
        id
        price
        quantity
        total
        offset
        offsetRate
        fee {
          id
          description
          name
          standard
          deleted
        }
      }
    }
  }
}
    `;
export type AddFeesToOrderGroupMutationFn = Apollo.MutationFunction<AddFeesToOrderGroupMutation, AddFeesToOrderGroupMutationVariables>;

/**
 * __useAddFeesToOrderGroupMutation__
 *
 * To run a mutation, you first call `useAddFeesToOrderGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFeesToOrderGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFeesToOrderGroupMutation, { data, loading, error }] = useAddFeesToOrderGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddFeesToOrderGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddFeesToOrderGroupMutation, AddFeesToOrderGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFeesToOrderGroupMutation, AddFeesToOrderGroupMutationVariables>(AddFeesToOrderGroupDocument, options);
      }
export type AddFeesToOrderGroupMutationHookResult = ReturnType<typeof useAddFeesToOrderGroupMutation>;
export type AddFeesToOrderGroupMutationResult = Apollo.MutationResult<AddFeesToOrderGroupMutation>;
export type AddFeesToOrderGroupMutationOptions = Apollo.BaseMutationOptions<AddFeesToOrderGroupMutation, AddFeesToOrderGroupMutationVariables>;
export const ChangeShiftAssetDocument = gql`
    mutation ChangeShiftAsset($input: ChangeAssetInput!) {
  changeShiftAsset(input: $input) {
    shift {
      id
      shiftDeliveryUnitsAssets {
        deliveryAsset {
          id
          name
          licensePlateNumber
          category
          compartments {
            id
            length
            name
          }
        }
      }
    }
  }
}
    `;
export type ChangeShiftAssetMutationFn = Apollo.MutationFunction<ChangeShiftAssetMutation, ChangeShiftAssetMutationVariables>;

/**
 * __useChangeShiftAssetMutation__
 *
 * To run a mutation, you first call `useChangeShiftAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeShiftAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeShiftAssetMutation, { data, loading, error }] = useChangeShiftAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeShiftAssetMutation(baseOptions?: Apollo.MutationHookOptions<ChangeShiftAssetMutation, ChangeShiftAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeShiftAssetMutation, ChangeShiftAssetMutationVariables>(ChangeShiftAssetDocument, options);
      }
export type ChangeShiftAssetMutationHookResult = ReturnType<typeof useChangeShiftAssetMutation>;
export type ChangeShiftAssetMutationResult = Apollo.MutationResult<ChangeShiftAssetMutation>;
export type ChangeShiftAssetMutationOptions = Apollo.BaseMutationOptions<ChangeShiftAssetMutation, ChangeShiftAssetMutationVariables>;
export const CreateOrderGroupTaxesDocument = gql`
    mutation createOrderGroupTaxes($input: CreateOrderGroupTaxesInput!) {
  addOrderGroupTax(input: $input) {
    response {
      error
      success
      orderGroupTax {
        id
        orderGroup {
          id
        }
        tax {
          id
          name
        }
        price
        total
        quantity
      }
    }
  }
}
    `;
export type CreateOrderGroupTaxesMutationFn = Apollo.MutationFunction<CreateOrderGroupTaxesMutation, CreateOrderGroupTaxesMutationVariables>;

/**
 * __useCreateOrderGroupTaxesMutation__
 *
 * To run a mutation, you first call `useCreateOrderGroupTaxesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderGroupTaxesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderGroupTaxesMutation, { data, loading, error }] = useCreateOrderGroupTaxesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderGroupTaxesMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderGroupTaxesMutation, CreateOrderGroupTaxesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderGroupTaxesMutation, CreateOrderGroupTaxesMutationVariables>(CreateOrderGroupTaxesDocument, options);
      }
export type CreateOrderGroupTaxesMutationHookResult = ReturnType<typeof useCreateOrderGroupTaxesMutation>;
export type CreateOrderGroupTaxesMutationResult = Apollo.MutationResult<CreateOrderGroupTaxesMutation>;
export type CreateOrderGroupTaxesMutationOptions = Apollo.BaseMutationOptions<CreateOrderGroupTaxesMutation, CreateOrderGroupTaxesMutationVariables>;
export const CreateOrderInvoiceDocument = gql`
    mutation createOrderInvoice($input: CreateOrderInvoiceInput!) {
  createOrderInvoice(input: $input) {
    response {
      error
      invoice {
        id
      }
      success
    }
  }
}
    `;
export type CreateOrderInvoiceMutationFn = Apollo.MutationFunction<CreateOrderInvoiceMutation, CreateOrderInvoiceMutationVariables>;

/**
 * __useCreateOrderInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateOrderInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderInvoiceMutation, { data, loading, error }] = useCreateOrderInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderInvoiceMutation, CreateOrderInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderInvoiceMutation, CreateOrderInvoiceMutationVariables>(CreateOrderInvoiceDocument, options);
      }
export type CreateOrderInvoiceMutationHookResult = ReturnType<typeof useCreateOrderInvoiceMutation>;
export type CreateOrderInvoiceMutationResult = Apollo.MutationResult<CreateOrderInvoiceMutation>;
export type CreateOrderInvoiceMutationOptions = Apollo.BaseMutationOptions<CreateOrderInvoiceMutation, CreateOrderInvoiceMutationVariables>;
export const CreateProductOrderFeesDocument = gql`
    mutation createProductOrderFees($input: CreateProductOrderFeesInput!) {
  createProductOrderFees(input: $input) {
    response {
      productOrderFees {
        id
        amount
        quantity
        total
        fee {
          id
          name
        }
        product {
          id
          name
        }
      }
      success
      error
    }
  }
}
    `;
export type CreateProductOrderFeesMutationFn = Apollo.MutationFunction<CreateProductOrderFeesMutation, CreateProductOrderFeesMutationVariables>;

/**
 * __useCreateProductOrderFeesMutation__
 *
 * To run a mutation, you first call `useCreateProductOrderFeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductOrderFeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductOrderFeesMutation, { data, loading, error }] = useCreateProductOrderFeesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductOrderFeesMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductOrderFeesMutation, CreateProductOrderFeesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductOrderFeesMutation, CreateProductOrderFeesMutationVariables>(CreateProductOrderFeesDocument, options);
      }
export type CreateProductOrderFeesMutationHookResult = ReturnType<typeof useCreateProductOrderFeesMutation>;
export type CreateProductOrderFeesMutationResult = Apollo.MutationResult<CreateProductOrderFeesMutation>;
export type CreateProductOrderFeesMutationOptions = Apollo.BaseMutationOptions<CreateProductOrderFeesMutation, CreateProductOrderFeesMutationVariables>;
export const CreateZoneProductBatchesDocument = gql`
    mutation CreateZoneProductBatches($input: CreateZoneProductBatchesInput!) {
  createZoneProductBatches(input: $input) {
    zoneProductBatches {
      id
    }
  }
}
    `;
export type CreateZoneProductBatchesMutationFn = Apollo.MutationFunction<CreateZoneProductBatchesMutation, CreateZoneProductBatchesMutationVariables>;

/**
 * __useCreateZoneProductBatchesMutation__
 *
 * To run a mutation, you first call `useCreateZoneProductBatchesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateZoneProductBatchesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createZoneProductBatchesMutation, { data, loading, error }] = useCreateZoneProductBatchesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateZoneProductBatchesMutation(baseOptions?: Apollo.MutationHookOptions<CreateZoneProductBatchesMutation, CreateZoneProductBatchesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateZoneProductBatchesMutation, CreateZoneProductBatchesMutationVariables>(CreateZoneProductBatchesDocument, options);
      }
export type CreateZoneProductBatchesMutationHookResult = ReturnType<typeof useCreateZoneProductBatchesMutation>;
export type CreateZoneProductBatchesMutationResult = Apollo.MutationResult<CreateZoneProductBatchesMutation>;
export type CreateZoneProductBatchesMutationOptions = Apollo.BaseMutationOptions<CreateZoneProductBatchesMutation, CreateZoneProductBatchesMutationVariables>;
export const DataImportProgressesDocument = gql`
    query DataImportProgresses($dataImportType: DataImportProgressImportEnum) {
  dataImportProgresses(dataImportType: $dataImportType) {
    status
  }
}
    `;

/**
 * __useDataImportProgressesQuery__
 *
 * To run a query within a React component, call `useDataImportProgressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataImportProgressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataImportProgressesQuery({
 *   variables: {
 *      dataImportType: // value for 'dataImportType'
 *   },
 * });
 */
export function useDataImportProgressesQuery(baseOptions?: Apollo.QueryHookOptions<DataImportProgressesQuery, DataImportProgressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataImportProgressesQuery, DataImportProgressesQueryVariables>(DataImportProgressesDocument, options);
      }
export function useDataImportProgressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataImportProgressesQuery, DataImportProgressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataImportProgressesQuery, DataImportProgressesQueryVariables>(DataImportProgressesDocument, options);
        }
export type DataImportProgressesQueryHookResult = ReturnType<typeof useDataImportProgressesQuery>;
export type DataImportProgressesLazyQueryHookResult = ReturnType<typeof useDataImportProgressesLazyQuery>;
export type DataImportProgressesQueryResult = Apollo.QueryResult<DataImportProgressesQuery, DataImportProgressesQueryVariables>;
export const DuplicateOrderDocument = gql`
    mutation DuplicateOrder($input: DuplicateOrderGroupInput!) {
  duplicateOrder(input: $input) {
    newOrderGroup {
      id
      deliveryOrder {
        id
        status
      }
      loadingOrder {
        id
      }
    }
    fromOrderGroup {
      id
    }
  }
}
    `;
export type DuplicateOrderMutationFn = Apollo.MutationFunction<DuplicateOrderMutation, DuplicateOrderMutationVariables>;

/**
 * __useDuplicateOrderMutation__
 *
 * To run a mutation, you first call `useDuplicateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateOrderMutation, { data, loading, error }] = useDuplicateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateOrderMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateOrderMutation, DuplicateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateOrderMutation, DuplicateOrderMutationVariables>(DuplicateOrderDocument, options);
      }
export type DuplicateOrderMutationHookResult = ReturnType<typeof useDuplicateOrderMutation>;
export type DuplicateOrderMutationResult = Apollo.MutationResult<DuplicateOrderMutation>;
export type DuplicateOrderMutationOptions = Apollo.BaseMutationOptions<DuplicateOrderMutation, DuplicateOrderMutationVariables>;
export const FetchAllNotesDocument = gql`
    query FetchAllNotes($orderId: ID!) {
  deliveryOrder(id: $orderId) {
    orderGroup {
      id
      createdAtTimestamp
      completedOnTimestamp
      driver {
        id
        name
      }
      allNotes {
        id
        createdAtTimestamp
        content
        acknowledger
        commenterUser {
          id
          name
          avatar
          type
        }
        generated
        commenter
        notableType
        noteType
        showInDeliveryTicket
        showInInvoice
        pandaDocument {
          id
          blobFileUrl
        }
      }
    }
    postDeliveryPhotos {
      id
      fileUrl
      blobFileUrl
      showInDeliveryTicket
    }
  }
}
    `;

/**
 * __useFetchAllNotesQuery__
 *
 * To run a query within a React component, call `useFetchAllNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllNotesQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useFetchAllNotesQuery(baseOptions: Apollo.QueryHookOptions<FetchAllNotesQuery, FetchAllNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllNotesQuery, FetchAllNotesQueryVariables>(FetchAllNotesDocument, options);
      }
export function useFetchAllNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllNotesQuery, FetchAllNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllNotesQuery, FetchAllNotesQueryVariables>(FetchAllNotesDocument, options);
        }
export type FetchAllNotesQueryHookResult = ReturnType<typeof useFetchAllNotesQuery>;
export type FetchAllNotesLazyQueryHookResult = ReturnType<typeof useFetchAllNotesLazyQuery>;
export type FetchAllNotesQueryResult = Apollo.QueryResult<FetchAllNotesQuery, FetchAllNotesQueryVariables>;
export const FetchBillingDetailDocument = gql`
    query FetchBillingDetail($orderGroupId: ID!, $orderStatus: String, $shiftStatus: String) {
  appliedPricings(
    orderGroupId: $orderGroupId
    orderStatus: $orderStatus
    shiftStatus: $shiftStatus
  ) {
    id
    isManuallyUpdated
    total
    price
    sumTotal
    productId
    error {
      description
      status
      type
    }
    success
    quantity
    discount
    loadingOrderLineItemIds
    deliveryOrderLineItemIds
    receiptNumber
    orderType
    orderGroupId
    resourcePricing {
      id
    }
    pricing {
      id
    }
    product {
      id
      name
    }
    appliedTaxes {
      id
      quantity
      price
      total
      applicableTax {
        tax {
          id
          name
          erpId
          rateType
          calculationType
        }
      }
    }
    appliedMargins {
      id
      quantity
      price
      total
      applicableMargin {
        margin {
          id
          name
        }
      }
      marginsProduct {
        margin {
          id
          name
        }
      }
    }
    terminalId
    supplierId
    cardInTime
    completedOn
    hubId
    marketId
    customer {
      id
    }
    customerBranch {
      id
    }
    isTemporaryPricing
    temporaryPricingData {
      price {
        rate
        quantity
        total
      }
      taxes {
        rate
        quantity
        total
      }
      markup {
        rate
        quantity
        total
      }
      freight {
        rate
        quantity
        total
      }
      totalPrice {
        rate
        quantity
        total
      }
    }
  }
}
    `;

/**
 * __useFetchBillingDetailQuery__
 *
 * To run a query within a React component, call `useFetchBillingDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBillingDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBillingDetailQuery({
 *   variables: {
 *      orderGroupId: // value for 'orderGroupId'
 *      orderStatus: // value for 'orderStatus'
 *      shiftStatus: // value for 'shiftStatus'
 *   },
 * });
 */
export function useFetchBillingDetailQuery(baseOptions: Apollo.QueryHookOptions<FetchBillingDetailQuery, FetchBillingDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchBillingDetailQuery, FetchBillingDetailQueryVariables>(FetchBillingDetailDocument, options);
      }
export function useFetchBillingDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchBillingDetailQuery, FetchBillingDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchBillingDetailQuery, FetchBillingDetailQueryVariables>(FetchBillingDetailDocument, options);
        }
export type FetchBillingDetailQueryHookResult = ReturnType<typeof useFetchBillingDetailQuery>;
export type FetchBillingDetailLazyQueryHookResult = ReturnType<typeof useFetchBillingDetailLazyQuery>;
export type FetchBillingDetailQueryResult = Apollo.QueryResult<FetchBillingDetailQuery, FetchBillingDetailQueryVariables>;
export const FetchBolandTransferDocument = gql`
    query FetchBolandTransfer($orderId: ID!) {
  deliveryOrder(id: $orderId) {
    id
    orderGroupId
    orderLinks {
      id
      loadingOrder {
        id
        bolNumbers
        status
        terminal {
          id
          name
        }
      }
      transferOrder {
        id
        toAsset {
          id
          name
        }
        orderGroup {
          id
        }
        orderGroupId
      }
      extractionOrder {
        id
        customerBranch {
          id
          name
        }
      }
      deliveryOrder {
        id
        customerBranch {
          id
          name
        }
      }
      movementOrder {
        id
      }
    }
  }
}
    `;

/**
 * __useFetchBolandTransferQuery__
 *
 * To run a query within a React component, call `useFetchBolandTransferQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBolandTransferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBolandTransferQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useFetchBolandTransferQuery(baseOptions: Apollo.QueryHookOptions<FetchBolandTransferQuery, FetchBolandTransferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchBolandTransferQuery, FetchBolandTransferQueryVariables>(FetchBolandTransferDocument, options);
      }
export function useFetchBolandTransferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchBolandTransferQuery, FetchBolandTransferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchBolandTransferQuery, FetchBolandTransferQueryVariables>(FetchBolandTransferDocument, options);
        }
export type FetchBolandTransferQueryHookResult = ReturnType<typeof useFetchBolandTransferQuery>;
export type FetchBolandTransferLazyQueryHookResult = ReturnType<typeof useFetchBolandTransferLazyQuery>;
export type FetchBolandTransferQueryResult = Apollo.QueryResult<FetchBolandTransferQuery, FetchBolandTransferQueryVariables>;
export const FetchComparableProductsDocument = gql`
    query FetchComparableProducts($id: ID!) {
  product(id: $id) {
    id
    name
    comparableProducts {
      id
      productResource {
        id
        name
        code
        colorCode
        productType
        soldAs
        unit
        brand {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useFetchComparableProductsQuery__
 *
 * To run a query within a React component, call `useFetchComparableProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchComparableProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchComparableProductsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchComparableProductsQuery(baseOptions: Apollo.QueryHookOptions<FetchComparableProductsQuery, FetchComparableProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchComparableProductsQuery, FetchComparableProductsQueryVariables>(FetchComparableProductsDocument, options);
      }
export function useFetchComparableProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchComparableProductsQuery, FetchComparableProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchComparableProductsQuery, FetchComparableProductsQueryVariables>(FetchComparableProductsDocument, options);
        }
export type FetchComparableProductsQueryHookResult = ReturnType<typeof useFetchComparableProductsQuery>;
export type FetchComparableProductsLazyQueryHookResult = ReturnType<typeof useFetchComparableProductsLazyQuery>;
export type FetchComparableProductsQueryResult = Apollo.QueryResult<FetchComparableProductsQuery, FetchComparableProductsQueryVariables>;
export const FetchCompartmentMismatchDocument = gql`
    query FetchCompartmentMismatch($orderGroupId: ID!, $type: CompartmentMismatchOrderTypeEnum!) {
  compartmentMismatch(orderGroupId: $orderGroupId, type: $type) {
    lineItemId
    currentProductId
    currentCompartmentId
    actualCompartmentId
    actualProductId
    volume
    error
  }
}
    `;

/**
 * __useFetchCompartmentMismatchQuery__
 *
 * To run a query within a React component, call `useFetchCompartmentMismatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCompartmentMismatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCompartmentMismatchQuery({
 *   variables: {
 *      orderGroupId: // value for 'orderGroupId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useFetchCompartmentMismatchQuery(baseOptions: Apollo.QueryHookOptions<FetchCompartmentMismatchQuery, FetchCompartmentMismatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCompartmentMismatchQuery, FetchCompartmentMismatchQueryVariables>(FetchCompartmentMismatchDocument, options);
      }
export function useFetchCompartmentMismatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCompartmentMismatchQuery, FetchCompartmentMismatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCompartmentMismatchQuery, FetchCompartmentMismatchQueryVariables>(FetchCompartmentMismatchDocument, options);
        }
export type FetchCompartmentMismatchQueryHookResult = ReturnType<typeof useFetchCompartmentMismatchQuery>;
export type FetchCompartmentMismatchLazyQueryHookResult = ReturnType<typeof useFetchCompartmentMismatchLazyQuery>;
export type FetchCompartmentMismatchQueryResult = Apollo.QueryResult<FetchCompartmentMismatchQuery, FetchCompartmentMismatchQueryVariables>;
export const FetchCustomerBranchByIdDocument = gql`
    query FetchCustomerBranchById($id: ID!) {
  customerBranch(id: $id) {
    id
    name
    purchaseOrder
    assets {
      id
      status
      category
      name
      licensePlateNumber
      useInDelivery
      customerBranch {
        id
        name
      }
      subscriptions {
        id
        product {
          id
          category
          code
          colorCode
          name
          shortName
          longDescription
          productType
        }
      }
    }
  }
}
    `;

/**
 * __useFetchCustomerBranchByIdQuery__
 *
 * To run a query within a React component, call `useFetchCustomerBranchByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomerBranchByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomerBranchByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchCustomerBranchByIdQuery(baseOptions: Apollo.QueryHookOptions<FetchCustomerBranchByIdQuery, FetchCustomerBranchByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomerBranchByIdQuery, FetchCustomerBranchByIdQueryVariables>(FetchCustomerBranchByIdDocument, options);
      }
export function useFetchCustomerBranchByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomerBranchByIdQuery, FetchCustomerBranchByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomerBranchByIdQuery, FetchCustomerBranchByIdQueryVariables>(FetchCustomerBranchByIdDocument, options);
        }
export type FetchCustomerBranchByIdQueryHookResult = ReturnType<typeof useFetchCustomerBranchByIdQuery>;
export type FetchCustomerBranchByIdLazyQueryHookResult = ReturnType<typeof useFetchCustomerBranchByIdLazyQuery>;
export type FetchCustomerBranchByIdQueryResult = Apollo.QueryResult<FetchCustomerBranchByIdQuery, FetchCustomerBranchByIdQueryVariables>;
export const FetchDeliveryOrderFeesDocument = gql`
    query FetchDeliveryOrderFees($orderId: ID!, $fetchCustomerFees: Boolean = true) {
  deliveryOrder(id: $orderId) {
    id
    orderGroupId
    orderGroup {
      applicableFees {
        id
        fee {
          id
          description
          name
          standard
          deleted
          applyAsOnFee
        }
        netsuiteId
        price
        quantity
      }
      customerBranch {
        customer @include(if: $fetchCustomerFees) {
          id
          applicableFees {
            id
            price
            netsuiteId
            isDefault
            fee {
              id
              name
              standard
              deleted
              applyAsOnFee
            }
          }
        }
        applicableFees {
          id
          fee {
            id
            description
            name
            standard
            deleted
            applyAsOnFee
          }
          netsuiteId
          price
          quantity
        }
      }
      orderGroupsFees {
        id
        price
        quantity
        total
        offset
        offsetRate
        fee {
          id
          applicableType
          applyAsOnFee
          description
          name
          standard
          deleted
        }
      }
    }
  }
}
    `;

/**
 * __useFetchDeliveryOrderFeesQuery__
 *
 * To run a query within a React component, call `useFetchDeliveryOrderFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDeliveryOrderFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDeliveryOrderFeesQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      fetchCustomerFees: // value for 'fetchCustomerFees'
 *   },
 * });
 */
export function useFetchDeliveryOrderFeesQuery(baseOptions: Apollo.QueryHookOptions<FetchDeliveryOrderFeesQuery, FetchDeliveryOrderFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDeliveryOrderFeesQuery, FetchDeliveryOrderFeesQueryVariables>(FetchDeliveryOrderFeesDocument, options);
      }
export function useFetchDeliveryOrderFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDeliveryOrderFeesQuery, FetchDeliveryOrderFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDeliveryOrderFeesQuery, FetchDeliveryOrderFeesQueryVariables>(FetchDeliveryOrderFeesDocument, options);
        }
export type FetchDeliveryOrderFeesQueryHookResult = ReturnType<typeof useFetchDeliveryOrderFeesQuery>;
export type FetchDeliveryOrderFeesLazyQueryHookResult = ReturnType<typeof useFetchDeliveryOrderFeesLazyQuery>;
export type FetchDeliveryOrderFeesQueryResult = Apollo.QueryResult<FetchDeliveryOrderFeesQuery, FetchDeliveryOrderFeesQueryVariables>;
export const FetchDeliveryOrderWithPandaBoxDetailsDocument = gql`
    query FetchDeliveryOrderWithPandaBoxDetails($orderId: ID!) {
  deliveryOrder(id: $orderId) {
    id
    orderNumber
    ticketId
    source
    pushToFdn
    deliveryInstruction
    ticketMailedAtTimestamp
    orderGroupId
    externalBoId
    invoiceNumber
    diversionNumbers
    divergenceOrder
    totalizers {
      discrepancy
      final
      initial
      meterName
    }
    pandaBoxNotes {
      id
      content
      createdAtTimestamp
    }
    pandaDocumentInvoices {
      id
      blobFileUrl
    }
    customerBranch {
      id
      name
      address
      erpId
      deliveryInstruction
      site {
        city
        state
      }
      addressBooks {
        name
        phone
        addressBookType
      }
      resourceSchedule {
        availability {
          day
          startTime
          endTime
          bestEndTime
          bestStartTime
        }
      }
      customer {
        id
        name
        totalRequestedVolume
        productPurchaseLimit {
          volume
          product {
            id
            name
          }
        }
        deliveryInstruction
        addressBooks {
          name
          phone
        }
        thirdPartyDelivery
        paymentTerm {
          id
          name
        }
        customerSegment {
          id
          name
        }
        resourceSchedule {
          availability {
            day
            startTime
            endTime
          }
        }
      }
    }
    orderGroup {
      ...deliveryOrderGroupPandaBoxFragment
      warehouseAsset {
        id
        name
      }
    }
    signature {
      id
      fileUrl
      fileName
      blobFileUrl
      blobFileUrlDownload
    }
  }
}
    ${DeliveryOrderGroupPandaBoxFragmentFragmentDoc}`;

/**
 * __useFetchDeliveryOrderWithPandaBoxDetailsQuery__
 *
 * To run a query within a React component, call `useFetchDeliveryOrderWithPandaBoxDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDeliveryOrderWithPandaBoxDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDeliveryOrderWithPandaBoxDetailsQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useFetchDeliveryOrderWithPandaBoxDetailsQuery(baseOptions: Apollo.QueryHookOptions<FetchDeliveryOrderWithPandaBoxDetailsQuery, FetchDeliveryOrderWithPandaBoxDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDeliveryOrderWithPandaBoxDetailsQuery, FetchDeliveryOrderWithPandaBoxDetailsQueryVariables>(FetchDeliveryOrderWithPandaBoxDetailsDocument, options);
      }
export function useFetchDeliveryOrderWithPandaBoxDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDeliveryOrderWithPandaBoxDetailsQuery, FetchDeliveryOrderWithPandaBoxDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDeliveryOrderWithPandaBoxDetailsQuery, FetchDeliveryOrderWithPandaBoxDetailsQueryVariables>(FetchDeliveryOrderWithPandaBoxDetailsDocument, options);
        }
export type FetchDeliveryOrderWithPandaBoxDetailsQueryHookResult = ReturnType<typeof useFetchDeliveryOrderWithPandaBoxDetailsQuery>;
export type FetchDeliveryOrderWithPandaBoxDetailsLazyQueryHookResult = ReturnType<typeof useFetchDeliveryOrderWithPandaBoxDetailsLazyQuery>;
export type FetchDeliveryOrderWithPandaBoxDetailsQueryResult = Apollo.QueryResult<FetchDeliveryOrderWithPandaBoxDetailsQuery, FetchDeliveryOrderWithPandaBoxDetailsQueryVariables>;
export const FetchDeliveryOrderDocument = gql`
    query FetchDeliveryOrder($orderId: ID!) {
  deliveryOrder(id: $orderId) {
    id
    orderNumber
    ticketId
    pushToFdn
    deliveryInstruction
    ticketMailedAtTimestamp
    orderGroupId
    externalBoId
    source
    invoiceNumber
    diversionNumbers
    divergenceOrder
    pandaDocumentInvoices {
      id
      blobFileUrl
    }
    customerBranch {
      id
      name
      address
      erpId
      deliveryInstruction
      site {
        city
        state
      }
      addressBooks {
        name
        phone
        addressBookType
      }
      resourceSchedule {
        availability {
          day
          startTime
          endTime
          bestEndTime
          bestStartTime
        }
      }
      customer {
        id
        name
        totalRequestedVolume
        productPurchaseLimit {
          volume
          product {
            id
            name
          }
        }
        deliveryInstruction
        addressBooks {
          name
          phone
        }
        thirdPartyDelivery
        paymentTerm {
          id
          name
        }
        customerSegment {
          id
          name
        }
        resourceSchedule {
          availability {
            day
            startTime
            endTime
          }
        }
      }
    }
    orderGroup {
      ...deliveryOrderGroupFragment
      warehouseAsset {
        id
        name
      }
    }
    signature {
      id
      fileUrl
      fileName
      blobFileUrl
      blobFileUrlDownload
    }
  }
}
    ${DeliveryOrderGroupFragmentFragmentDoc}`;

/**
 * __useFetchDeliveryOrderQuery__
 *
 * To run a query within a React component, call `useFetchDeliveryOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDeliveryOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDeliveryOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useFetchDeliveryOrderQuery(baseOptions: Apollo.QueryHookOptions<FetchDeliveryOrderQuery, FetchDeliveryOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDeliveryOrderQuery, FetchDeliveryOrderQueryVariables>(FetchDeliveryOrderDocument, options);
      }
export function useFetchDeliveryOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDeliveryOrderQuery, FetchDeliveryOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDeliveryOrderQuery, FetchDeliveryOrderQueryVariables>(FetchDeliveryOrderDocument, options);
        }
export type FetchDeliveryOrderQueryHookResult = ReturnType<typeof useFetchDeliveryOrderQuery>;
export type FetchDeliveryOrderLazyQueryHookResult = ReturnType<typeof useFetchDeliveryOrderLazyQuery>;
export type FetchDeliveryOrderQueryResult = Apollo.QueryResult<FetchDeliveryOrderQuery, FetchDeliveryOrderQueryVariables>;
export const FetchFilteredFeesDocument = gql`
    query FetchFilteredFees {
  filteredFees {
    collection {
      id
      name
      rateOnFee
    }
  }
}
    `;

/**
 * __useFetchFilteredFeesQuery__
 *
 * To run a query within a React component, call `useFetchFilteredFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredFeesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchFilteredFeesQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredFeesQuery, FetchFilteredFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredFeesQuery, FetchFilteredFeesQueryVariables>(FetchFilteredFeesDocument, options);
      }
export function useFetchFilteredFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredFeesQuery, FetchFilteredFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredFeesQuery, FetchFilteredFeesQueryVariables>(FetchFilteredFeesDocument, options);
        }
export type FetchFilteredFeesQueryHookResult = ReturnType<typeof useFetchFilteredFeesQuery>;
export type FetchFilteredFeesLazyQueryHookResult = ReturnType<typeof useFetchFilteredFeesLazyQuery>;
export type FetchFilteredFeesQueryResult = Apollo.QueryResult<FetchFilteredFeesQuery, FetchFilteredFeesQueryVariables>;
export const FetchLineItemsDocument = gql`
    query FetchLineItems($orderId: ID!) {
  deliveryOrder(id: $orderId) {
    id
    lineItems {
      meterName
      id
      status
      source
      topOff
      requestedVolume
      volume
      skipReason
      backofficeId
      backofficeStatus
      data
      isExtraction
      canSyncRequestedLoadingVolume
      warehouseId
      notes
      warehouse {
        id
        name
      }
      product {
        id
        category
        name
        colorCode
        shortName
        code
        deliveryType
        unit
        soldAs
        brand {
          id
          name
        }
        comparableProducts {
          comparableProductId
          id
          productResource {
            id
            name
            code
            colorCode
            productType
            soldAs
            unit
            deliveryType
            brand {
              id
              name
            }
          }
        }
      }
      comparableProduct {
        id
        name
        shortName
      }
      asset {
        id
        licensePlateNumber
        name
        category
        data
        lat
        lng
        transitCustomerBranch {
          id
        }
        compartments {
          id
        }
      }
      sourceAssets {
        id
        dispensedQty
        asset {
          id
          name
        }
        zoneProductBatch {
          id
          zoneIndex
          batch {
            id
            batchNumber
          }
        }
      }
      sourceCompartments {
        id
        dispensedVolume
        compartment {
          id
          name
          asset {
            id
            name
            licensePlateNumber
            category
          }
        }
      }
      targetCompartmentInstance {
        id
        beforeStick
        beforeStickUnit
        afterStick
        afterStickUnit
        generatorRunningHours
      }
      subscription {
        id
      }
    }
  }
}
    `;

/**
 * __useFetchLineItemsQuery__
 *
 * To run a query within a React component, call `useFetchLineItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLineItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLineItemsQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useFetchLineItemsQuery(baseOptions: Apollo.QueryHookOptions<FetchLineItemsQuery, FetchLineItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLineItemsQuery, FetchLineItemsQueryVariables>(FetchLineItemsDocument, options);
      }
export function useFetchLineItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLineItemsQuery, FetchLineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLineItemsQuery, FetchLineItemsQueryVariables>(FetchLineItemsDocument, options);
        }
export type FetchLineItemsQueryHookResult = ReturnType<typeof useFetchLineItemsQuery>;
export type FetchLineItemsLazyQueryHookResult = ReturnType<typeof useFetchLineItemsLazyQuery>;
export type FetchLineItemsQueryResult = Apollo.QueryResult<FetchLineItemsQuery, FetchLineItemsQueryVariables>;
export const FetchNestedLinkedOrderGroupIdsDocument = gql`
    query FetchNestedLinkedOrderGroupIds($orderGroupId: ID!) {
  fetchNestedLinkedOrderGroupIds(id: $orderGroupId, orderGroupType: DeliveryOrder)
}
    `;

/**
 * __useFetchNestedLinkedOrderGroupIdsQuery__
 *
 * To run a query within a React component, call `useFetchNestedLinkedOrderGroupIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchNestedLinkedOrderGroupIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchNestedLinkedOrderGroupIdsQuery({
 *   variables: {
 *      orderGroupId: // value for 'orderGroupId'
 *   },
 * });
 */
export function useFetchNestedLinkedOrderGroupIdsQuery(baseOptions: Apollo.QueryHookOptions<FetchNestedLinkedOrderGroupIdsQuery, FetchNestedLinkedOrderGroupIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchNestedLinkedOrderGroupIdsQuery, FetchNestedLinkedOrderGroupIdsQueryVariables>(FetchNestedLinkedOrderGroupIdsDocument, options);
      }
export function useFetchNestedLinkedOrderGroupIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchNestedLinkedOrderGroupIdsQuery, FetchNestedLinkedOrderGroupIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchNestedLinkedOrderGroupIdsQuery, FetchNestedLinkedOrderGroupIdsQueryVariables>(FetchNestedLinkedOrderGroupIdsDocument, options);
        }
export type FetchNestedLinkedOrderGroupIdsQueryHookResult = ReturnType<typeof useFetchNestedLinkedOrderGroupIdsQuery>;
export type FetchNestedLinkedOrderGroupIdsLazyQueryHookResult = ReturnType<typeof useFetchNestedLinkedOrderGroupIdsLazyQuery>;
export type FetchNestedLinkedOrderGroupIdsQueryResult = Apollo.QueryResult<FetchNestedLinkedOrderGroupIdsQuery, FetchNestedLinkedOrderGroupIdsQueryVariables>;
export const FetchLinkedOrdersDriverListDocument = gql`
    query fetchLinkedOrdersDriverList($orderGroupId: ID!) {
  linkedOrdersDriversLists(orderGroupId: $orderGroupId) {
    workerWithPendingOrderStatus {
      id
      name
    }
    workerWithoutPendingOrderStatus {
      id
      name
    }
    unassigned
  }
}
    `;

/**
 * __useFetchLinkedOrdersDriverListQuery__
 *
 * To run a query within a React component, call `useFetchLinkedOrdersDriverListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLinkedOrdersDriverListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLinkedOrdersDriverListQuery({
 *   variables: {
 *      orderGroupId: // value for 'orderGroupId'
 *   },
 * });
 */
export function useFetchLinkedOrdersDriverListQuery(baseOptions: Apollo.QueryHookOptions<FetchLinkedOrdersDriverListQuery, FetchLinkedOrdersDriverListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLinkedOrdersDriverListQuery, FetchLinkedOrdersDriverListQueryVariables>(FetchLinkedOrdersDriverListDocument, options);
      }
export function useFetchLinkedOrdersDriverListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLinkedOrdersDriverListQuery, FetchLinkedOrdersDriverListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLinkedOrdersDriverListQuery, FetchLinkedOrdersDriverListQueryVariables>(FetchLinkedOrdersDriverListDocument, options);
        }
export type FetchLinkedOrdersDriverListQueryHookResult = ReturnType<typeof useFetchLinkedOrdersDriverListQuery>;
export type FetchLinkedOrdersDriverListLazyQueryHookResult = ReturnType<typeof useFetchLinkedOrdersDriverListLazyQuery>;
export type FetchLinkedOrdersDriverListQueryResult = Apollo.QueryResult<FetchLinkedOrdersDriverListQuery, FetchLinkedOrdersDriverListQueryVariables>;
export const FetchOrderGroupTagsDocument = gql`
    query FetchOrderGroupTags($id: ID!) {
  orderGroup(id: $id) {
    id
    taggings {
      id
      tag {
        id
        name
        erpId
        description
        colorCode
        iconName
        status
        tagType
      }
    }
  }
}
    `;

/**
 * __useFetchOrderGroupTagsQuery__
 *
 * To run a query within a React component, call `useFetchOrderGroupTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOrderGroupTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOrderGroupTagsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchOrderGroupTagsQuery(baseOptions: Apollo.QueryHookOptions<FetchOrderGroupTagsQuery, FetchOrderGroupTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchOrderGroupTagsQuery, FetchOrderGroupTagsQueryVariables>(FetchOrderGroupTagsDocument, options);
      }
export function useFetchOrderGroupTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchOrderGroupTagsQuery, FetchOrderGroupTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchOrderGroupTagsQuery, FetchOrderGroupTagsQueryVariables>(FetchOrderGroupTagsDocument, options);
        }
export type FetchOrderGroupTagsQueryHookResult = ReturnType<typeof useFetchOrderGroupTagsQuery>;
export type FetchOrderGroupTagsLazyQueryHookResult = ReturnType<typeof useFetchOrderGroupTagsLazyQuery>;
export type FetchOrderGroupTagsQueryResult = Apollo.QueryResult<FetchOrderGroupTagsQuery, FetchOrderGroupTagsQueryVariables>;
export const FetchOrderGroupTaxesDocument = gql`
    query FetchOrderGroupTaxes($orderGroupId: ID!) {
  orderGroup(id: $orderGroupId) {
    id
    status
    orderGroupTaxes {
      id
      price
      quantity
      total
      tax {
        id
        name
        erpId
        rateType
      }
      orderGroup {
        id
        status
      }
    }
  }
}
    `;

/**
 * __useFetchOrderGroupTaxesQuery__
 *
 * To run a query within a React component, call `useFetchOrderGroupTaxesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOrderGroupTaxesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOrderGroupTaxesQuery({
 *   variables: {
 *      orderGroupId: // value for 'orderGroupId'
 *   },
 * });
 */
export function useFetchOrderGroupTaxesQuery(baseOptions: Apollo.QueryHookOptions<FetchOrderGroupTaxesQuery, FetchOrderGroupTaxesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchOrderGroupTaxesQuery, FetchOrderGroupTaxesQueryVariables>(FetchOrderGroupTaxesDocument, options);
      }
export function useFetchOrderGroupTaxesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchOrderGroupTaxesQuery, FetchOrderGroupTaxesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchOrderGroupTaxesQuery, FetchOrderGroupTaxesQueryVariables>(FetchOrderGroupTaxesDocument, options);
        }
export type FetchOrderGroupTaxesQueryHookResult = ReturnType<typeof useFetchOrderGroupTaxesQuery>;
export type FetchOrderGroupTaxesLazyQueryHookResult = ReturnType<typeof useFetchOrderGroupTaxesLazyQuery>;
export type FetchOrderGroupTaxesQueryResult = Apollo.QueryResult<FetchOrderGroupTaxesQuery, FetchOrderGroupTaxesQueryVariables>;
export const FetchPandaBoxLogsDocument = gql`
    query FetchPandaBoxLogs($orderId: String!) {
  pandaBoxLogs(orderId: $orderId) {
    key
    lastModifiedAt
    presignedUrl
    size
    body
  }
}
    `;

/**
 * __useFetchPandaBoxLogsQuery__
 *
 * To run a query within a React component, call `useFetchPandaBoxLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPandaBoxLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPandaBoxLogsQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useFetchPandaBoxLogsQuery(baseOptions: Apollo.QueryHookOptions<FetchPandaBoxLogsQuery, FetchPandaBoxLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPandaBoxLogsQuery, FetchPandaBoxLogsQueryVariables>(FetchPandaBoxLogsDocument, options);
      }
export function useFetchPandaBoxLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPandaBoxLogsQuery, FetchPandaBoxLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPandaBoxLogsQuery, FetchPandaBoxLogsQueryVariables>(FetchPandaBoxLogsDocument, options);
        }
export type FetchPandaBoxLogsQueryHookResult = ReturnType<typeof useFetchPandaBoxLogsQuery>;
export type FetchPandaBoxLogsLazyQueryHookResult = ReturnType<typeof useFetchPandaBoxLogsLazyQuery>;
export type FetchPandaBoxLogsQueryResult = Apollo.QueryResult<FetchPandaBoxLogsQuery, FetchPandaBoxLogsQueryVariables>;
export const FetchProcessingRecurrenceStatusDocument = gql`
    query FetchProcessingRecurrenceStatus($id: ID!) {
  deliveryOrder(id: $id) {
    orderGroup {
      processingRecurrence
    }
  }
}
    `;

/**
 * __useFetchProcessingRecurrenceStatusQuery__
 *
 * To run a query within a React component, call `useFetchProcessingRecurrenceStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProcessingRecurrenceStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProcessingRecurrenceStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchProcessingRecurrenceStatusQuery(baseOptions: Apollo.QueryHookOptions<FetchProcessingRecurrenceStatusQuery, FetchProcessingRecurrenceStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchProcessingRecurrenceStatusQuery, FetchProcessingRecurrenceStatusQueryVariables>(FetchProcessingRecurrenceStatusDocument, options);
      }
export function useFetchProcessingRecurrenceStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchProcessingRecurrenceStatusQuery, FetchProcessingRecurrenceStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchProcessingRecurrenceStatusQuery, FetchProcessingRecurrenceStatusQueryVariables>(FetchProcessingRecurrenceStatusDocument, options);
        }
export type FetchProcessingRecurrenceStatusQueryHookResult = ReturnType<typeof useFetchProcessingRecurrenceStatusQuery>;
export type FetchProcessingRecurrenceStatusLazyQueryHookResult = ReturnType<typeof useFetchProcessingRecurrenceStatusLazyQuery>;
export type FetchProcessingRecurrenceStatusQueryResult = Apollo.QueryResult<FetchProcessingRecurrenceStatusQuery, FetchProcessingRecurrenceStatusQueryVariables>;
export const FetchProductOrderFeesDocument = gql`
    query FetchProductOrderFees($orderGroupId: ID!) {
  orderGroup(id: $orderGroupId) {
    id
    status
    productOrderFees {
      id
      isManuallyUpdated
      amount
      fee {
        id
        name
      }
      quantity
      total
      product {
        id
        name
      }
      orderGroup {
        id
      }
    }
  }
}
    `;

/**
 * __useFetchProductOrderFeesQuery__
 *
 * To run a query within a React component, call `useFetchProductOrderFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductOrderFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductOrderFeesQuery({
 *   variables: {
 *      orderGroupId: // value for 'orderGroupId'
 *   },
 * });
 */
export function useFetchProductOrderFeesQuery(baseOptions: Apollo.QueryHookOptions<FetchProductOrderFeesQuery, FetchProductOrderFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchProductOrderFeesQuery, FetchProductOrderFeesQueryVariables>(FetchProductOrderFeesDocument, options);
      }
export function useFetchProductOrderFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchProductOrderFeesQuery, FetchProductOrderFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchProductOrderFeesQuery, FetchProductOrderFeesQueryVariables>(FetchProductOrderFeesDocument, options);
        }
export type FetchProductOrderFeesQueryHookResult = ReturnType<typeof useFetchProductOrderFeesQuery>;
export type FetchProductOrderFeesLazyQueryHookResult = ReturnType<typeof useFetchProductOrderFeesLazyQuery>;
export type FetchProductOrderFeesQueryResult = Apollo.QueryResult<FetchProductOrderFeesQuery, FetchProductOrderFeesQueryVariables>;
export const FetchProductsDocument = gql`
    query FetchProducts($limit: Int = 20, $offset: Int = 0, $customFilter: ProductFilter = {}, $sorter: [ProductSorter!]) {
  filteredProducts(
    limit: $limit
    offset: $offset
    filter: $customFilter
    sorter: $sorter
  ) {
    metadata {
      hasMore
      totalCount
      __typename
    }
    collection {
      id
      name
      code
      colorCode
      productType
      soldAs
      unit
      deliveryType
      brand {
        id
        name
      }
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useFetchProductsQuery__
 *
 * To run a query within a React component, call `useFetchProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      customFilter: // value for 'customFilter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchProductsQuery(baseOptions?: Apollo.QueryHookOptions<FetchProductsQuery, FetchProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchProductsQuery, FetchProductsQueryVariables>(FetchProductsDocument, options);
      }
export function useFetchProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchProductsQuery, FetchProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchProductsQuery, FetchProductsQueryVariables>(FetchProductsDocument, options);
        }
export type FetchProductsQueryHookResult = ReturnType<typeof useFetchProductsQuery>;
export type FetchProductsLazyQueryHookResult = ReturnType<typeof useFetchProductsLazyQuery>;
export type FetchProductsQueryResult = Apollo.QueryResult<FetchProductsQuery, FetchProductsQueryVariables>;
export const FilterCommonCarrierDodmDocument = gql`
    query FilterCommonCarrierDodm($limit: Int = 20, $offset: Int = 0, $customFilter: CcTenantFilter, $sorter: [CcTenantSorter!]) {
  filteredCcTenants(
    limit: $limit
    offset: $offset
    filter: $customFilter
    sorter: $sorter
  ) {
    metadata {
      hasMore
    }
    collection {
      id
      name
    }
  }
}
    `;

/**
 * __useFilterCommonCarrierDodmQuery__
 *
 * To run a query within a React component, call `useFilterCommonCarrierDodmQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterCommonCarrierDodmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterCommonCarrierDodmQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      customFilter: // value for 'customFilter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilterCommonCarrierDodmQuery(baseOptions?: Apollo.QueryHookOptions<FilterCommonCarrierDodmQuery, FilterCommonCarrierDodmQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterCommonCarrierDodmQuery, FilterCommonCarrierDodmQueryVariables>(FilterCommonCarrierDodmDocument, options);
      }
export function useFilterCommonCarrierDodmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterCommonCarrierDodmQuery, FilterCommonCarrierDodmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterCommonCarrierDodmQuery, FilterCommonCarrierDodmQueryVariables>(FilterCommonCarrierDodmDocument, options);
        }
export type FilterCommonCarrierDodmQueryHookResult = ReturnType<typeof useFilterCommonCarrierDodmQuery>;
export type FilterCommonCarrierDodmLazyQueryHookResult = ReturnType<typeof useFilterCommonCarrierDodmLazyQuery>;
export type FilterCommonCarrierDodmQueryResult = Apollo.QueryResult<FilterCommonCarrierDodmQuery, FilterCommonCarrierDodmQueryVariables>;
export const FilteredAssetsByCustomerBranchIdDocument = gql`
    query filteredAssetsByCustomerBranchId($limit: Int = 20, $offset: Int = 0, $customFilter: AssetFilter = {}, $sorter: [AssetSorter!]) {
  filteredAssets(
    limit: $limit
    offset: $offset
    filter: $customFilter
    sorter: $sorter
  ) {
    collection {
      id
      status
      category
      name
      licensePlateNumber
      useInDelivery
      subscriptions {
        id
        product {
          id
          category
          code
          colorCode
          name
          shortName
          longDescription
          productType
        }
      }
    }
    metadata {
      hasMore
    }
  }
}
    `;

/**
 * __useFilteredAssetsByCustomerBranchIdQuery__
 *
 * To run a query within a React component, call `useFilteredAssetsByCustomerBranchIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredAssetsByCustomerBranchIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredAssetsByCustomerBranchIdQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      customFilter: // value for 'customFilter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilteredAssetsByCustomerBranchIdQuery(baseOptions?: Apollo.QueryHookOptions<FilteredAssetsByCustomerBranchIdQuery, FilteredAssetsByCustomerBranchIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredAssetsByCustomerBranchIdQuery, FilteredAssetsByCustomerBranchIdQueryVariables>(FilteredAssetsByCustomerBranchIdDocument, options);
      }
export function useFilteredAssetsByCustomerBranchIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredAssetsByCustomerBranchIdQuery, FilteredAssetsByCustomerBranchIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredAssetsByCustomerBranchIdQuery, FilteredAssetsByCustomerBranchIdQueryVariables>(FilteredAssetsByCustomerBranchIdDocument, options);
        }
export type FilteredAssetsByCustomerBranchIdQueryHookResult = ReturnType<typeof useFilteredAssetsByCustomerBranchIdQuery>;
export type FilteredAssetsByCustomerBranchIdLazyQueryHookResult = ReturnType<typeof useFilteredAssetsByCustomerBranchIdLazyQuery>;
export type FilteredAssetsByCustomerBranchIdQueryResult = Apollo.QueryResult<FilteredAssetsByCustomerBranchIdQuery, FilteredAssetsByCustomerBranchIdQueryVariables>;
export const FilteredDeliveryAssetsDocument = gql`
    query FilteredDeliveryAssets($limit: Int = 20, $offset: Int = 0, $customFilter: DeliveryAssetFilter = {}, $sorter: [BaseSorter!]) {
  filteredDeliveryAssets(
    limit: $limit
    offset: $offset
    filter: $customFilter
    sorter: $sorter
  ) {
    metadata {
      hasMore
    }
    collection {
      id
      name
      category
      compartments {
        id
        length
        name
      }
    }
  }
}
    `;

/**
 * __useFilteredDeliveryAssetsQuery__
 *
 * To run a query within a React component, call `useFilteredDeliveryAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredDeliveryAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredDeliveryAssetsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      customFilter: // value for 'customFilter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilteredDeliveryAssetsQuery(baseOptions?: Apollo.QueryHookOptions<FilteredDeliveryAssetsQuery, FilteredDeliveryAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredDeliveryAssetsQuery, FilteredDeliveryAssetsQueryVariables>(FilteredDeliveryAssetsDocument, options);
      }
export function useFilteredDeliveryAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredDeliveryAssetsQuery, FilteredDeliveryAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredDeliveryAssetsQuery, FilteredDeliveryAssetsQueryVariables>(FilteredDeliveryAssetsDocument, options);
        }
export type FilteredDeliveryAssetsQueryHookResult = ReturnType<typeof useFilteredDeliveryAssetsQuery>;
export type FilteredDeliveryAssetsLazyQueryHookResult = ReturnType<typeof useFilteredDeliveryAssetsLazyQuery>;
export type FilteredDeliveryAssetsQueryResult = Apollo.QueryResult<FilteredDeliveryAssetsQuery, FilteredDeliveryAssetsQueryVariables>;
export const ModifyLineItemProductsDocument = gql`
    mutation ModifyLineItemProducts($input: ModifyLineItemProductInput!) {
  modifyLineItemProduct(input: $input) {
    orderGroup {
      id
      deliveryOrder {
        lineItems {
          id
          subscription {
            id
          }
        }
      }
    }
  }
}
    `;
export type ModifyLineItemProductsMutationFn = Apollo.MutationFunction<ModifyLineItemProductsMutation, ModifyLineItemProductsMutationVariables>;

/**
 * __useModifyLineItemProductsMutation__
 *
 * To run a mutation, you first call `useModifyLineItemProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyLineItemProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyLineItemProductsMutation, { data, loading, error }] = useModifyLineItemProductsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModifyLineItemProductsMutation(baseOptions?: Apollo.MutationHookOptions<ModifyLineItemProductsMutation, ModifyLineItemProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyLineItemProductsMutation, ModifyLineItemProductsMutationVariables>(ModifyLineItemProductsDocument, options);
      }
export type ModifyLineItemProductsMutationHookResult = ReturnType<typeof useModifyLineItemProductsMutation>;
export type ModifyLineItemProductsMutationResult = Apollo.MutationResult<ModifyLineItemProductsMutation>;
export type ModifyLineItemProductsMutationOptions = Apollo.BaseMutationOptions<ModifyLineItemProductsMutation, ModifyLineItemProductsMutationVariables>;
export const OrderPricingImportCompletionDocument = gql`
    query OrderPricingImportCompletion($selected: ShiftOrOrderEnum!, $id: ID!) {
  orderPricingImportCompletion(selected: $selected, id: $id)
}
    `;

/**
 * __useOrderPricingImportCompletionQuery__
 *
 * To run a query within a React component, call `useOrderPricingImportCompletionQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderPricingImportCompletionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderPricingImportCompletionQuery({
 *   variables: {
 *      selected: // value for 'selected'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderPricingImportCompletionQuery(baseOptions: Apollo.QueryHookOptions<OrderPricingImportCompletionQuery, OrderPricingImportCompletionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderPricingImportCompletionQuery, OrderPricingImportCompletionQueryVariables>(OrderPricingImportCompletionDocument, options);
      }
export function useOrderPricingImportCompletionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderPricingImportCompletionQuery, OrderPricingImportCompletionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderPricingImportCompletionQuery, OrderPricingImportCompletionQueryVariables>(OrderPricingImportCompletionDocument, options);
        }
export type OrderPricingImportCompletionQueryHookResult = ReturnType<typeof useOrderPricingImportCompletionQuery>;
export type OrderPricingImportCompletionLazyQueryHookResult = ReturnType<typeof useOrderPricingImportCompletionLazyQuery>;
export type OrderPricingImportCompletionQueryResult = Apollo.QueryResult<OrderPricingImportCompletionQuery, OrderPricingImportCompletionQueryVariables>;
export const PushOrderTo3PlDocument = gql`
    mutation PushOrderTo3PL($input: PushOrderToFdnInput!) {
  pushOrderToFdn(input: $input) {
    message
    data {
      loadingOrderGroupIds
    }
  }
}
    `;
export type PushOrderTo3PlMutationFn = Apollo.MutationFunction<PushOrderTo3PlMutation, PushOrderTo3PlMutationVariables>;

/**
 * __usePushOrderTo3PlMutation__
 *
 * To run a mutation, you first call `usePushOrderTo3PlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePushOrderTo3PlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pushOrderTo3PlMutation, { data, loading, error }] = usePushOrderTo3PlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePushOrderTo3PlMutation(baseOptions?: Apollo.MutationHookOptions<PushOrderTo3PlMutation, PushOrderTo3PlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PushOrderTo3PlMutation, PushOrderTo3PlMutationVariables>(PushOrderTo3PlDocument, options);
      }
export type PushOrderTo3PlMutationHookResult = ReturnType<typeof usePushOrderTo3PlMutation>;
export type PushOrderTo3PlMutationResult = Apollo.MutationResult<PushOrderTo3PlMutation>;
export type PushOrderTo3PlMutationOptions = Apollo.BaseMutationOptions<PushOrderTo3PlMutation, PushOrderTo3PlMutationVariables>;
export const RecalculatePricingDocument = gql`
    mutation RecalculatePricing($input: RecalculatePricingInput!) {
  recalculatePricing(input: $input) {
    appliedPricings {
      id
    }
  }
}
    `;
export type RecalculatePricingMutationFn = Apollo.MutationFunction<RecalculatePricingMutation, RecalculatePricingMutationVariables>;

/**
 * __useRecalculatePricingMutation__
 *
 * To run a mutation, you first call `useRecalculatePricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecalculatePricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recalculatePricingMutation, { data, loading, error }] = useRecalculatePricingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecalculatePricingMutation(baseOptions?: Apollo.MutationHookOptions<RecalculatePricingMutation, RecalculatePricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecalculatePricingMutation, RecalculatePricingMutationVariables>(RecalculatePricingDocument, options);
      }
export type RecalculatePricingMutationHookResult = ReturnType<typeof useRecalculatePricingMutation>;
export type RecalculatePricingMutationResult = Apollo.MutationResult<RecalculatePricingMutation>;
export type RecalculatePricingMutationOptions = Apollo.BaseMutationOptions<RecalculatePricingMutation, RecalculatePricingMutationVariables>;
export const DeleteBolPricingDocument = gql`
    mutation DeleteBolPricing($input: DeleteBolPricingInput!) {
  deleteBolPricing(input: $input) {
    response {
      id
      error
      success
    }
  }
}
    `;
export type DeleteBolPricingMutationFn = Apollo.MutationFunction<DeleteBolPricingMutation, DeleteBolPricingMutationVariables>;

/**
 * __useDeleteBolPricingMutation__
 *
 * To run a mutation, you first call `useDeleteBolPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBolPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBolPricingMutation, { data, loading, error }] = useDeleteBolPricingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBolPricingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBolPricingMutation, DeleteBolPricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBolPricingMutation, DeleteBolPricingMutationVariables>(DeleteBolPricingDocument, options);
      }
export type DeleteBolPricingMutationHookResult = ReturnType<typeof useDeleteBolPricingMutation>;
export type DeleteBolPricingMutationResult = Apollo.MutationResult<DeleteBolPricingMutation>;
export type DeleteBolPricingMutationOptions = Apollo.BaseMutationOptions<DeleteBolPricingMutation, DeleteBolPricingMutationVariables>;
export const RemoveFeesFromOrderGroupDocument = gql`
    mutation RemoveFeesFromOrderGroup($input: RemoveFeesFromOrderGroupInput!) {
  removeFeesFromOrderGroup(input: $input) {
    orderGroup {
      id
    }
  }
}
    `;
export type RemoveFeesFromOrderGroupMutationFn = Apollo.MutationFunction<RemoveFeesFromOrderGroupMutation, RemoveFeesFromOrderGroupMutationVariables>;

/**
 * __useRemoveFeesFromOrderGroupMutation__
 *
 * To run a mutation, you first call `useRemoveFeesFromOrderGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFeesFromOrderGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFeesFromOrderGroupMutation, { data, loading, error }] = useRemoveFeesFromOrderGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveFeesFromOrderGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFeesFromOrderGroupMutation, RemoveFeesFromOrderGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFeesFromOrderGroupMutation, RemoveFeesFromOrderGroupMutationVariables>(RemoveFeesFromOrderGroupDocument, options);
      }
export type RemoveFeesFromOrderGroupMutationHookResult = ReturnType<typeof useRemoveFeesFromOrderGroupMutation>;
export type RemoveFeesFromOrderGroupMutationResult = Apollo.MutationResult<RemoveFeesFromOrderGroupMutation>;
export type RemoveFeesFromOrderGroupMutationOptions = Apollo.BaseMutationOptions<RemoveFeesFromOrderGroupMutation, RemoveFeesFromOrderGroupMutationVariables>;
export const ResetAppliedPricingDocument = gql`
    mutation ResetAppliedPricing($data: ManualUpdateInput!) {
  resetPricing(input: {data: $data}) {
    appliedPricing {
      id
    }
  }
}
    `;
export type ResetAppliedPricingMutationFn = Apollo.MutationFunction<ResetAppliedPricingMutation, ResetAppliedPricingMutationVariables>;

/**
 * __useResetAppliedPricingMutation__
 *
 * To run a mutation, you first call `useResetAppliedPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetAppliedPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetAppliedPricingMutation, { data, loading, error }] = useResetAppliedPricingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useResetAppliedPricingMutation(baseOptions?: Apollo.MutationHookOptions<ResetAppliedPricingMutation, ResetAppliedPricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetAppliedPricingMutation, ResetAppliedPricingMutationVariables>(ResetAppliedPricingDocument, options);
      }
export type ResetAppliedPricingMutationHookResult = ReturnType<typeof useResetAppliedPricingMutation>;
export type ResetAppliedPricingMutationResult = Apollo.MutationResult<ResetAppliedPricingMutation>;
export type ResetAppliedPricingMutationOptions = Apollo.BaseMutationOptions<ResetAppliedPricingMutation, ResetAppliedPricingMutationVariables>;
export const SendCommonCarrierEmailDocument = gql`
    mutation SendCommonCarrierEmail($input: SendCommonCarrierEmailInput!) {
  sendCommonCarrierEmail(input: $input) {
    orderGroup {
      sendCarrierEmail
      carrierEmailSentAt
    }
  }
}
    `;
export type SendCommonCarrierEmailMutationFn = Apollo.MutationFunction<SendCommonCarrierEmailMutation, SendCommonCarrierEmailMutationVariables>;

/**
 * __useSendCommonCarrierEmailMutation__
 *
 * To run a mutation, you first call `useSendCommonCarrierEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCommonCarrierEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCommonCarrierEmailMutation, { data, loading, error }] = useSendCommonCarrierEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendCommonCarrierEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendCommonCarrierEmailMutation, SendCommonCarrierEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCommonCarrierEmailMutation, SendCommonCarrierEmailMutationVariables>(SendCommonCarrierEmailDocument, options);
      }
export type SendCommonCarrierEmailMutationHookResult = ReturnType<typeof useSendCommonCarrierEmailMutation>;
export type SendCommonCarrierEmailMutationResult = Apollo.MutationResult<SendCommonCarrierEmailMutation>;
export type SendCommonCarrierEmailMutationOptions = Apollo.BaseMutationOptions<SendCommonCarrierEmailMutation, SendCommonCarrierEmailMutationVariables>;
export const UpdateAppliedPricingDocument = gql`
    mutation UpdateAppliedPricing($input: UpdateAppliedPricingInput!) {
  updateAppliedPricing(input: $input) {
    appliedPricings {
      id
      isManuallyUpdated
      total
      price
      productId
      error {
        description
        status
        type
      }
      success
      quantity
      discount
      loadingOrderLineItemIds
      deliveryOrderLineItemIds
      receiptNumber
      orderType
      orderGroupId
      resourcePricing {
        id
      }
      pricing {
        id
      }
      product {
        id
        name
      }
      appliedTaxes {
        id
        quantity
        price
        total
        applicableTax {
          tax {
            id
            name
          }
        }
      }
      appliedMargins {
        id
        quantity
        price
        total
        applicableMargin {
          margin {
            id
            name
          }
        }
        marginsProduct {
          margin {
            id
            name
          }
        }
      }
      terminalId
      supplierId
      cardInTime
      completedOn
      hubId
      marketId
      customer {
        id
      }
      customerBranch {
        id
      }
    }
  }
}
    `;
export type UpdateAppliedPricingMutationFn = Apollo.MutationFunction<UpdateAppliedPricingMutation, UpdateAppliedPricingMutationVariables>;

/**
 * __useUpdateAppliedPricingMutation__
 *
 * To run a mutation, you first call `useUpdateAppliedPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppliedPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppliedPricingMutation, { data, loading, error }] = useUpdateAppliedPricingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAppliedPricingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppliedPricingMutation, UpdateAppliedPricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppliedPricingMutation, UpdateAppliedPricingMutationVariables>(UpdateAppliedPricingDocument, options);
      }
export type UpdateAppliedPricingMutationHookResult = ReturnType<typeof useUpdateAppliedPricingMutation>;
export type UpdateAppliedPricingMutationResult = Apollo.MutationResult<UpdateAppliedPricingMutation>;
export type UpdateAppliedPricingMutationOptions = Apollo.BaseMutationOptions<UpdateAppliedPricingMutation, UpdateAppliedPricingMutationVariables>;
export const UpdateAssetMovementLocationDocument = gql`
    mutation UpdateAssetMovementLocation($input: UpdateAssetsInput!) {
  updateAsset(input: $input) {
    asset {
      id
    }
  }
}
    `;
export type UpdateAssetMovementLocationMutationFn = Apollo.MutationFunction<UpdateAssetMovementLocationMutation, UpdateAssetMovementLocationMutationVariables>;

/**
 * __useUpdateAssetMovementLocationMutation__
 *
 * To run a mutation, you first call `useUpdateAssetMovementLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssetMovementLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssetMovementLocationMutation, { data, loading, error }] = useUpdateAssetMovementLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssetMovementLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssetMovementLocationMutation, UpdateAssetMovementLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssetMovementLocationMutation, UpdateAssetMovementLocationMutationVariables>(UpdateAssetMovementLocationDocument, options);
      }
export type UpdateAssetMovementLocationMutationHookResult = ReturnType<typeof useUpdateAssetMovementLocationMutation>;
export type UpdateAssetMovementLocationMutationResult = Apollo.MutationResult<UpdateAssetMovementLocationMutation>;
export type UpdateAssetMovementLocationMutationOptions = Apollo.BaseMutationOptions<UpdateAssetMovementLocationMutation, UpdateAssetMovementLocationMutationVariables>;
export const UpdateBolPricingDocument = gql`
    mutation UpdateBolPricing($input: UpdateBolPricingInput!) {
  updateBolPricing(input: $input) {
    bolPricing {
      id
      itemType
      rate
      quantity
      tax {
        id
        name
        productCategoryId
        rateType
      }
      total
    }
  }
}
    `;
export type UpdateBolPricingMutationFn = Apollo.MutationFunction<UpdateBolPricingMutation, UpdateBolPricingMutationVariables>;

/**
 * __useUpdateBolPricingMutation__
 *
 * To run a mutation, you first call `useUpdateBolPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBolPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBolPricingMutation, { data, loading, error }] = useUpdateBolPricingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBolPricingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBolPricingMutation, UpdateBolPricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBolPricingMutation, UpdateBolPricingMutationVariables>(UpdateBolPricingDocument, options);
      }
export type UpdateBolPricingMutationHookResult = ReturnType<typeof useUpdateBolPricingMutation>;
export type UpdateBolPricingMutationResult = Apollo.MutationResult<UpdateBolPricingMutation>;
export type UpdateBolPricingMutationOptions = Apollo.BaseMutationOptions<UpdateBolPricingMutation, UpdateBolPricingMutationVariables>;
export const UpdateFeeOfOrderGroupDocument = gql`
    mutation UpdateFeeOfOrderGroup($input: AddFeeToOrderGroupInput!) {
  addFeeToOrderGroup(input: $input) {
    orderGroup {
      id
      orderGroupsFees {
        id
        price
        offset
        offsetRate
        quantity
        total
        fee {
          id
          description
          name
          standard
          deleted
        }
      }
    }
  }
}
    `;
export type UpdateFeeOfOrderGroupMutationFn = Apollo.MutationFunction<UpdateFeeOfOrderGroupMutation, UpdateFeeOfOrderGroupMutationVariables>;

/**
 * __useUpdateFeeOfOrderGroupMutation__
 *
 * To run a mutation, you first call `useUpdateFeeOfOrderGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeeOfOrderGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeeOfOrderGroupMutation, { data, loading, error }] = useUpdateFeeOfOrderGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeeOfOrderGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeeOfOrderGroupMutation, UpdateFeeOfOrderGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeeOfOrderGroupMutation, UpdateFeeOfOrderGroupMutationVariables>(UpdateFeeOfOrderGroupDocument, options);
      }
export type UpdateFeeOfOrderGroupMutationHookResult = ReturnType<typeof useUpdateFeeOfOrderGroupMutation>;
export type UpdateFeeOfOrderGroupMutationResult = Apollo.MutationResult<UpdateFeeOfOrderGroupMutation>;
export type UpdateFeeOfOrderGroupMutationOptions = Apollo.BaseMutationOptions<UpdateFeeOfOrderGroupMutation, UpdateFeeOfOrderGroupMutationVariables>;
export const UpdateNoteDocument = gql`
    mutation UpdateNote($input: UpdateNoteInput!) {
  updateNote(input: $input) {
    note {
      id
      acknowledger
    }
  }
}
    `;
export type UpdateNoteMutationFn = Apollo.MutationFunction<UpdateNoteMutation, UpdateNoteMutationVariables>;

/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteMutation, { data, loading, error }] = useUpdateNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteMutation, UpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteMutation, UpdateNoteMutationVariables>(UpdateNoteDocument, options);
      }
export type UpdateNoteMutationHookResult = ReturnType<typeof useUpdateNoteMutation>;
export type UpdateNoteMutationResult = Apollo.MutationResult<UpdateNoteMutation>;
export type UpdateNoteMutationOptions = Apollo.BaseMutationOptions<UpdateNoteMutation, UpdateNoteMutationVariables>;
export const UpdatePostDeliveryPhotoForDeliveryOrderDocument = gql`
    mutation UpdatePostDeliveryPhotoForDeliveryOrder($input: UpdatePostDeliveryPhotoInput!) {
  updatePostDeliveryPhoto(input: $input) {
    clientMutationId
  }
}
    `;
export type UpdatePostDeliveryPhotoForDeliveryOrderMutationFn = Apollo.MutationFunction<UpdatePostDeliveryPhotoForDeliveryOrderMutation, UpdatePostDeliveryPhotoForDeliveryOrderMutationVariables>;

/**
 * __useUpdatePostDeliveryPhotoForDeliveryOrderMutation__
 *
 * To run a mutation, you first call `useUpdatePostDeliveryPhotoForDeliveryOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostDeliveryPhotoForDeliveryOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostDeliveryPhotoForDeliveryOrderMutation, { data, loading, error }] = useUpdatePostDeliveryPhotoForDeliveryOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePostDeliveryPhotoForDeliveryOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePostDeliveryPhotoForDeliveryOrderMutation, UpdatePostDeliveryPhotoForDeliveryOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePostDeliveryPhotoForDeliveryOrderMutation, UpdatePostDeliveryPhotoForDeliveryOrderMutationVariables>(UpdatePostDeliveryPhotoForDeliveryOrderDocument, options);
      }
export type UpdatePostDeliveryPhotoForDeliveryOrderMutationHookResult = ReturnType<typeof useUpdatePostDeliveryPhotoForDeliveryOrderMutation>;
export type UpdatePostDeliveryPhotoForDeliveryOrderMutationResult = Apollo.MutationResult<UpdatePostDeliveryPhotoForDeliveryOrderMutation>;
export type UpdatePostDeliveryPhotoForDeliveryOrderMutationOptions = Apollo.BaseMutationOptions<UpdatePostDeliveryPhotoForDeliveryOrderMutation, UpdatePostDeliveryPhotoForDeliveryOrderMutationVariables>;
export const UpdateZoneProductBatchesDocument = gql`
    mutation UpdateZoneProductBatches($input: UpdateZoneProductBatchesInput!) {
  updateZoneProductBatches(input: $input) {
    zoneProductBatches {
      orderGroup {
        id
      }
    }
  }
}
    `;
export type UpdateZoneProductBatchesMutationFn = Apollo.MutationFunction<UpdateZoneProductBatchesMutation, UpdateZoneProductBatchesMutationVariables>;

/**
 * __useUpdateZoneProductBatchesMutation__
 *
 * To run a mutation, you first call `useUpdateZoneProductBatchesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateZoneProductBatchesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateZoneProductBatchesMutation, { data, loading, error }] = useUpdateZoneProductBatchesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateZoneProductBatchesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateZoneProductBatchesMutation, UpdateZoneProductBatchesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateZoneProductBatchesMutation, UpdateZoneProductBatchesMutationVariables>(UpdateZoneProductBatchesDocument, options);
      }
export type UpdateZoneProductBatchesMutationHookResult = ReturnType<typeof useUpdateZoneProductBatchesMutation>;
export type UpdateZoneProductBatchesMutationResult = Apollo.MutationResult<UpdateZoneProductBatchesMutation>;
export type UpdateZoneProductBatchesMutationOptions = Apollo.BaseMutationOptions<UpdateZoneProductBatchesMutation, UpdateZoneProductBatchesMutationVariables>;
export const ExportOrdersCsvDocument = gql`
    mutation ExportOrdersCsv($filter: OrderGroupFilter, $sorter: [OrderGroupSorter!]) {
  exportOrdersCsv(input: {filter: $filter, sorter: $sorter}) {
    success
    message
  }
}
    `;
export type ExportOrdersCsvMutationFn = Apollo.MutationFunction<ExportOrdersCsvMutation, ExportOrdersCsvMutationVariables>;

/**
 * __useExportOrdersCsvMutation__
 *
 * To run a mutation, you first call `useExportOrdersCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportOrdersCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportOrdersCsvMutation, { data, loading, error }] = useExportOrdersCsvMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useExportOrdersCsvMutation(baseOptions?: Apollo.MutationHookOptions<ExportOrdersCsvMutation, ExportOrdersCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportOrdersCsvMutation, ExportOrdersCsvMutationVariables>(ExportOrdersCsvDocument, options);
      }
export type ExportOrdersCsvMutationHookResult = ReturnType<typeof useExportOrdersCsvMutation>;
export type ExportOrdersCsvMutationResult = Apollo.MutationResult<ExportOrdersCsvMutation>;
export type ExportOrdersCsvMutationOptions = Apollo.BaseMutationOptions<ExportOrdersCsvMutation, ExportOrdersCsvMutationVariables>;
export const DeleteDeliveryOrderDocument = gql`
    mutation DeleteDeliveryOrder($id: ID!) {
  deleteDeliveryOrder(input: {id: $id}) {
    orderGroup {
      id
    }
  }
}
    `;
export type DeleteDeliveryOrderMutationFn = Apollo.MutationFunction<DeleteDeliveryOrderMutation, DeleteDeliveryOrderMutationVariables>;

/**
 * __useDeleteDeliveryOrderMutation__
 *
 * To run a mutation, you first call `useDeleteDeliveryOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeliveryOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeliveryOrderMutation, { data, loading, error }] = useDeleteDeliveryOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDeliveryOrderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeliveryOrderMutation, DeleteDeliveryOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeliveryOrderMutation, DeleteDeliveryOrderMutationVariables>(DeleteDeliveryOrderDocument, options);
      }
export type DeleteDeliveryOrderMutationHookResult = ReturnType<typeof useDeleteDeliveryOrderMutation>;
export type DeleteDeliveryOrderMutationResult = Apollo.MutationResult<DeleteDeliveryOrderMutation>;
export type DeleteDeliveryOrderMutationOptions = Apollo.BaseMutationOptions<DeleteDeliveryOrderMutation, DeleteDeliveryOrderMutationVariables>;
export const ChangeOrderGroupAssignmentDocument = gql`
    mutation ChangeOrderGroupAssignment($id: ID!) {
  changeOrderGroupAssignment(input: {orderGroupId: $id}) {
    orderGroup {
      id
      status
    }
  }
}
    `;
export type ChangeOrderGroupAssignmentMutationFn = Apollo.MutationFunction<ChangeOrderGroupAssignmentMutation, ChangeOrderGroupAssignmentMutationVariables>;

/**
 * __useChangeOrderGroupAssignmentMutation__
 *
 * To run a mutation, you first call `useChangeOrderGroupAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeOrderGroupAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeOrderGroupAssignmentMutation, { data, loading, error }] = useChangeOrderGroupAssignmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChangeOrderGroupAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<ChangeOrderGroupAssignmentMutation, ChangeOrderGroupAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeOrderGroupAssignmentMutation, ChangeOrderGroupAssignmentMutationVariables>(ChangeOrderGroupAssignmentDocument, options);
      }
export type ChangeOrderGroupAssignmentMutationHookResult = ReturnType<typeof useChangeOrderGroupAssignmentMutation>;
export type ChangeOrderGroupAssignmentMutationResult = Apollo.MutationResult<ChangeOrderGroupAssignmentMutation>;
export type ChangeOrderGroupAssignmentMutationOptions = Apollo.BaseMutationOptions<ChangeOrderGroupAssignmentMutation, ChangeOrderGroupAssignmentMutationVariables>;
export const FetchDoListCustomerBranchDocument = gql`
    query FetchDOListCustomerBranch($limit: Int, $offset: Int, $sorter: [OrderGroupSorter!], $filter: OrderGroupFilter) {
  filteredOrderGroups(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: $filter
  ) {
    collection {
      id
      deliveryOrder {
        id
        customerBranch {
          id
          address
          addressBooks {
            name
            addressBookType
          }
        }
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFetchDoListCustomerBranchQuery__
 *
 * To run a query within a React component, call `useFetchDoListCustomerBranchQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDoListCustomerBranchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDoListCustomerBranchQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchDoListCustomerBranchQuery(baseOptions?: Apollo.QueryHookOptions<FetchDoListCustomerBranchQuery, FetchDoListCustomerBranchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDoListCustomerBranchQuery, FetchDoListCustomerBranchQueryVariables>(FetchDoListCustomerBranchDocument, options);
      }
export function useFetchDoListCustomerBranchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDoListCustomerBranchQuery, FetchDoListCustomerBranchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDoListCustomerBranchQuery, FetchDoListCustomerBranchQueryVariables>(FetchDoListCustomerBranchDocument, options);
        }
export type FetchDoListCustomerBranchQueryHookResult = ReturnType<typeof useFetchDoListCustomerBranchQuery>;
export type FetchDoListCustomerBranchLazyQueryHookResult = ReturnType<typeof useFetchDoListCustomerBranchLazyQuery>;
export type FetchDoListCustomerBranchQueryResult = Apollo.QueryResult<FetchDoListCustomerBranchQuery, FetchDoListCustomerBranchQueryVariables>;
export const FetchDoListLineItemsDocument = gql`
    query FetchDOListLineItems($limit: Int, $offset: Int, $sorter: [OrderGroupSorter!], $filter: OrderGroupFilter) {
  filteredOrderGroups(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: $filter
  ) {
    collection {
      id
      deliveryOrder {
        id
        lineItems {
          id
          requestedVolume
          volume
          topOff
          product {
            id
            unit
            name
            deliveryType
          }
        }
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFetchDoListLineItemsQuery__
 *
 * To run a query within a React component, call `useFetchDoListLineItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDoListLineItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDoListLineItemsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchDoListLineItemsQuery(baseOptions?: Apollo.QueryHookOptions<FetchDoListLineItemsQuery, FetchDoListLineItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDoListLineItemsQuery, FetchDoListLineItemsQueryVariables>(FetchDoListLineItemsDocument, options);
      }
export function useFetchDoListLineItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDoListLineItemsQuery, FetchDoListLineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDoListLineItemsQuery, FetchDoListLineItemsQueryVariables>(FetchDoListLineItemsDocument, options);
        }
export type FetchDoListLineItemsQueryHookResult = ReturnType<typeof useFetchDoListLineItemsQuery>;
export type FetchDoListLineItemsLazyQueryHookResult = ReturnType<typeof useFetchDoListLineItemsLazyQuery>;
export type FetchDoListLineItemsQueryResult = Apollo.QueryResult<FetchDoListLineItemsQuery, FetchDoListLineItemsQueryVariables>;
export const FetchDoListLinkedOrdersDocument = gql`
    query FetchDOListLinkedOrders($limit: Int, $offset: Int, $sorter: [OrderGroupSorter!], $filter: OrderGroupFilter) {
  filteredOrderGroups(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: $filter
  ) {
    collection {
      id
      deliveryOrder {
        id
        orderLinks {
          id
          extractionOrder {
            id
            customerBranch {
              id
              name
            }
          }
          loadingOrder {
            bolNumbers
            terminal {
              name
            }
            lineItems {
              grossAmount
            }
          }
        }
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFetchDoListLinkedOrdersQuery__
 *
 * To run a query within a React component, call `useFetchDoListLinkedOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDoListLinkedOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDoListLinkedOrdersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchDoListLinkedOrdersQuery(baseOptions?: Apollo.QueryHookOptions<FetchDoListLinkedOrdersQuery, FetchDoListLinkedOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDoListLinkedOrdersQuery, FetchDoListLinkedOrdersQueryVariables>(FetchDoListLinkedOrdersDocument, options);
      }
export function useFetchDoListLinkedOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDoListLinkedOrdersQuery, FetchDoListLinkedOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDoListLinkedOrdersQuery, FetchDoListLinkedOrdersQueryVariables>(FetchDoListLinkedOrdersDocument, options);
        }
export type FetchDoListLinkedOrdersQueryHookResult = ReturnType<typeof useFetchDoListLinkedOrdersQuery>;
export type FetchDoListLinkedOrdersLazyQueryHookResult = ReturnType<typeof useFetchDoListLinkedOrdersLazyQuery>;
export type FetchDoListLinkedOrdersQueryResult = Apollo.QueryResult<FetchDoListLinkedOrdersQuery, FetchDoListLinkedOrdersQueryVariables>;
export const FetchDoListOrderGroupDocument = gql`
    query fetchDOListOrderGroup($limit: Int, $offset: Int, $sorter: [OrderGroupSorter!], $filter: OrderGroupFilter) {
  filteredOrderGroups(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: $filter
  ) {
    collection {
      id
      poNumber
      startOnTimestamp
      completeOnTimestamp
      startedOnTimestamp
      completedOnTimestamp
      priority
      verifiedBy
      latestInvoiceStatus
      feesPricingStatus
      pricingMarginStatus
      hub {
        name
        address
      }
      driver {
        name
        group {
          name
        }
      }
      deliveryOrder {
        id
        status
        customerBranch {
          id
          name
          erpId
          customer {
            id
            name
            erpId
          }
        }
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFetchDoListOrderGroupQuery__
 *
 * To run a query within a React component, call `useFetchDoListOrderGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDoListOrderGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDoListOrderGroupQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchDoListOrderGroupQuery(baseOptions?: Apollo.QueryHookOptions<FetchDoListOrderGroupQuery, FetchDoListOrderGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDoListOrderGroupQuery, FetchDoListOrderGroupQueryVariables>(FetchDoListOrderGroupDocument, options);
      }
export function useFetchDoListOrderGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDoListOrderGroupQuery, FetchDoListOrderGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDoListOrderGroupQuery, FetchDoListOrderGroupQueryVariables>(FetchDoListOrderGroupDocument, options);
        }
export type FetchDoListOrderGroupQueryHookResult = ReturnType<typeof useFetchDoListOrderGroupQuery>;
export type FetchDoListOrderGroupLazyQueryHookResult = ReturnType<typeof useFetchDoListOrderGroupLazyQuery>;
export type FetchDoListOrderGroupQueryResult = Apollo.QueryResult<FetchDoListOrderGroupQuery, FetchDoListOrderGroupQueryVariables>;
export const FetchDoListShiftDocument = gql`
    query FetchDOListShift($limit: Int, $offset: Int, $sorter: [OrderGroupSorter!], $filter: OrderGroupFilter) {
  filteredOrderGroups(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: $filter
  ) {
    collection {
      id
      shift {
        startOnTimestamp
        endOnTimestamp
        shiftDeliveryUnitsAssets {
          deliveryAsset {
            name
            licensePlateNumber
          }
        }
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFetchDoListShiftQuery__
 *
 * To run a query within a React component, call `useFetchDoListShiftQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDoListShiftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDoListShiftQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchDoListShiftQuery(baseOptions?: Apollo.QueryHookOptions<FetchDoListShiftQuery, FetchDoListShiftQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDoListShiftQuery, FetchDoListShiftQueryVariables>(FetchDoListShiftDocument, options);
      }
export function useFetchDoListShiftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDoListShiftQuery, FetchDoListShiftQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDoListShiftQuery, FetchDoListShiftQueryVariables>(FetchDoListShiftDocument, options);
        }
export type FetchDoListShiftQueryHookResult = ReturnType<typeof useFetchDoListShiftQuery>;
export type FetchDoListShiftLazyQueryHookResult = ReturnType<typeof useFetchDoListShiftLazyQuery>;
export type FetchDoListShiftQueryResult = Apollo.QueryResult<FetchDoListShiftQuery, FetchDoListShiftQueryVariables>;
export const AcknowledgeNoteDocument = gql`
    mutation AcknowledgeNote($input: NoteAcknowledgeInput!) {
  acknowledgeNote(input: {data: $input}) {
    note {
      acknowledger
      notableType
      acknowledgedAt
    }
  }
}
    `;
export type AcknowledgeNoteMutationFn = Apollo.MutationFunction<AcknowledgeNoteMutation, AcknowledgeNoteMutationVariables>;

/**
 * __useAcknowledgeNoteMutation__
 *
 * To run a mutation, you first call `useAcknowledgeNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeNoteMutation, { data, loading, error }] = useAcknowledgeNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcknowledgeNoteMutation(baseOptions?: Apollo.MutationHookOptions<AcknowledgeNoteMutation, AcknowledgeNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcknowledgeNoteMutation, AcknowledgeNoteMutationVariables>(AcknowledgeNoteDocument, options);
      }
export type AcknowledgeNoteMutationHookResult = ReturnType<typeof useAcknowledgeNoteMutation>;
export type AcknowledgeNoteMutationResult = Apollo.MutationResult<AcknowledgeNoteMutation>;
export type AcknowledgeNoteMutationOptions = Apollo.BaseMutationOptions<AcknowledgeNoteMutation, AcknowledgeNoteMutationVariables>;
export const CreateDuplicateOrderDocument = gql`
    mutation createDuplicateOrder($input: DuplicateOrderGroupInput!) {
  duplicateOrder(input: $input) {
    fromOrderGroup {
      id
    }
    newOrderGroup {
      deliveryOrder {
        id
        status
      }
      loadingOrder {
        id
      }
    }
  }
}
    `;
export type CreateDuplicateOrderMutationFn = Apollo.MutationFunction<CreateDuplicateOrderMutation, CreateDuplicateOrderMutationVariables>;

/**
 * __useCreateDuplicateOrderMutation__
 *
 * To run a mutation, you first call `useCreateDuplicateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDuplicateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDuplicateOrderMutation, { data, loading, error }] = useCreateDuplicateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDuplicateOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateDuplicateOrderMutation, CreateDuplicateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDuplicateOrderMutation, CreateDuplicateOrderMutationVariables>(CreateDuplicateOrderDocument, options);
      }
export type CreateDuplicateOrderMutationHookResult = ReturnType<typeof useCreateDuplicateOrderMutation>;
export type CreateDuplicateOrderMutationResult = Apollo.MutationResult<CreateDuplicateOrderMutation>;
export type CreateDuplicateOrderMutationOptions = Apollo.BaseMutationOptions<CreateDuplicateOrderMutation, CreateDuplicateOrderMutationVariables>;
export const DeleteRecurringOrdersByIdsDocument = gql`
    mutation DeleteRecurringOrdersByIds($recurringOrderIds: [ID!]!) {
  deleteSiteRecurrence(input: {ids: $recurringOrderIds}) {
    success
  }
}
    `;
export type DeleteRecurringOrdersByIdsMutationFn = Apollo.MutationFunction<DeleteRecurringOrdersByIdsMutation, DeleteRecurringOrdersByIdsMutationVariables>;

/**
 * __useDeleteRecurringOrdersByIdsMutation__
 *
 * To run a mutation, you first call `useDeleteRecurringOrdersByIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecurringOrdersByIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecurringOrdersByIdsMutation, { data, loading, error }] = useDeleteRecurringOrdersByIdsMutation({
 *   variables: {
 *      recurringOrderIds: // value for 'recurringOrderIds'
 *   },
 * });
 */
export function useDeleteRecurringOrdersByIdsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRecurringOrdersByIdsMutation, DeleteRecurringOrdersByIdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRecurringOrdersByIdsMutation, DeleteRecurringOrdersByIdsMutationVariables>(DeleteRecurringOrdersByIdsDocument, options);
      }
export type DeleteRecurringOrdersByIdsMutationHookResult = ReturnType<typeof useDeleteRecurringOrdersByIdsMutation>;
export type DeleteRecurringOrdersByIdsMutationResult = Apollo.MutationResult<DeleteRecurringOrdersByIdsMutation>;
export type DeleteRecurringOrdersByIdsMutationOptions = Apollo.BaseMutationOptions<DeleteRecurringOrdersByIdsMutation, DeleteRecurringOrdersByIdsMutationVariables>;
export const FilteredDeliveryOrderDocument = gql`
    query FilteredDeliveryOrder($perPage: Int, $offset: Int, $sorter: [OrderGroupSorter!], $customFilter: OrderGroupFilter) {
  filteredOrderGroups(
    limit: $perPage
    offset: $offset
    sorter: $sorter
    filter: $customFilter
  ) {
    collection {
      id
      poNumber
      startOnTimestamp
      completeOnTimestamp
      startedOnTimestamp
      completedOnTimestamp
      priority
      verifiedBy
      latestInvoiceStatus
      feesPricingStatus
      pricingMarginStatus
      hub {
        name
        address
      }
      driver {
        name
        group {
          name
        }
      }
      deliveryOrder {
        id
        status
        orderNumber
        tenantName
        source
        orderLinks {
          loadingOrder {
            bolNumbers
            terminal {
              name
            }
            lineItems {
              grossAmount
            }
          }
        }
        customerBranch {
          id
          name
          erpId
          address
          customer {
            id
            name
            erpId
          }
          addressBooks {
            name
            addressBookType
          }
        }
        lineItems {
          id
          requestedVolume
          volume
          topOff
          product {
            id
            unit
            name
            deliveryType
          }
          subscription {
            asset {
              category
              licensePlateNumber
            }
          }
        }
        orderLinks {
          id
          loadingOrder {
            id
            terminal {
              id
              name
            }
          }
          extractionOrder {
            id
            customerBranch {
              id
              name
            }
          }
        }
      }
      shift {
        startOnTimestamp
        endOnTimestamp
        shiftDeliveryUnitsAssets {
          deliveryAsset {
            name
            licensePlateNumber
          }
        }
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFilteredDeliveryOrderQuery__
 *
 * To run a query within a React component, call `useFilteredDeliveryOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredDeliveryOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredDeliveryOrderQuery({
 *   variables: {
 *      perPage: // value for 'perPage'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      customFilter: // value for 'customFilter'
 *   },
 * });
 */
export function useFilteredDeliveryOrderQuery(baseOptions?: Apollo.QueryHookOptions<FilteredDeliveryOrderQuery, FilteredDeliveryOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredDeliveryOrderQuery, FilteredDeliveryOrderQueryVariables>(FilteredDeliveryOrderDocument, options);
      }
export function useFilteredDeliveryOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredDeliveryOrderQuery, FilteredDeliveryOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredDeliveryOrderQuery, FilteredDeliveryOrderQueryVariables>(FilteredDeliveryOrderDocument, options);
        }
export type FilteredDeliveryOrderQueryHookResult = ReturnType<typeof useFilteredDeliveryOrderQuery>;
export type FilteredDeliveryOrderLazyQueryHookResult = ReturnType<typeof useFilteredDeliveryOrderLazyQuery>;
export type FilteredDeliveryOrderQueryResult = Apollo.QueryResult<FilteredDeliveryOrderQuery, FilteredDeliveryOrderQueryVariables>;
export const FetchDeliveryOrderByIdDocument = gql`
    query FetchDeliveryOrderById($id: ID!) {
  orderGroup(id: $id) {
    id
    poNumber
    startOnTimestamp
    completeOnTimestamp
    startedOnTimestamp
    completedOnTimestamp
    priority
    verifiedBy
    latestInvoiceStatus
    feesPricingStatus
    pricingMarginStatus
    hub {
      name
      address
    }
    driver {
      name
      group {
        name
      }
    }
    deliveryOrder {
      id
      status
      orderNumber
      customerBranch {
        id
        name
        erpId
        customer {
          id
          name
          address
          erpId
        }
        address
        addressBooks {
          name
          addressBookType
        }
      }
      lineItems {
        id
        requestedVolume
        volume
        topOff
        product {
          id
          unit
          deliveryType
        }
        subscription {
          asset {
            category
            licensePlateNumber
          }
        }
      }
      orderLinks {
        id
        loadingOrder {
          id
          terminal {
            id
            name
          }
        }
        extractionOrder {
          id
          customerBranch {
            id
            name
          }
        }
      }
    }
    shift {
      startOnTimestamp
      endOnTimestamp
      shiftDeliveryUnitsAssets {
        deliveryAsset {
          name
          licensePlateNumber
        }
      }
    }
  }
}
    `;

/**
 * __useFetchDeliveryOrderByIdQuery__
 *
 * To run a query within a React component, call `useFetchDeliveryOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDeliveryOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDeliveryOrderByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchDeliveryOrderByIdQuery(baseOptions: Apollo.QueryHookOptions<FetchDeliveryOrderByIdQuery, FetchDeliveryOrderByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDeliveryOrderByIdQuery, FetchDeliveryOrderByIdQueryVariables>(FetchDeliveryOrderByIdDocument, options);
      }
export function useFetchDeliveryOrderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDeliveryOrderByIdQuery, FetchDeliveryOrderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDeliveryOrderByIdQuery, FetchDeliveryOrderByIdQueryVariables>(FetchDeliveryOrderByIdDocument, options);
        }
export type FetchDeliveryOrderByIdQueryHookResult = ReturnType<typeof useFetchDeliveryOrderByIdQuery>;
export type FetchDeliveryOrderByIdLazyQueryHookResult = ReturnType<typeof useFetchDeliveryOrderByIdLazyQuery>;
export type FetchDeliveryOrderByIdQueryResult = Apollo.QueryResult<FetchDeliveryOrderByIdQuery, FetchDeliveryOrderByIdQueryVariables>;
export const FetchExportDocumentDocument = gql`
    query FetchExportDocument($exportDocumentId: ID!) {
  exportDocument(exportDocumentId: $exportDocumentId) {
    id
    fileUrl
    status
    remarks
  }
}
    `;

/**
 * __useFetchExportDocumentQuery__
 *
 * To run a query within a React component, call `useFetchExportDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchExportDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchExportDocumentQuery({
 *   variables: {
 *      exportDocumentId: // value for 'exportDocumentId'
 *   },
 * });
 */
export function useFetchExportDocumentQuery(baseOptions: Apollo.QueryHookOptions<FetchExportDocumentQuery, FetchExportDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchExportDocumentQuery, FetchExportDocumentQueryVariables>(FetchExportDocumentDocument, options);
      }
export function useFetchExportDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchExportDocumentQuery, FetchExportDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchExportDocumentQuery, FetchExportDocumentQueryVariables>(FetchExportDocumentDocument, options);
        }
export type FetchExportDocumentQueryHookResult = ReturnType<typeof useFetchExportDocumentQuery>;
export type FetchExportDocumentLazyQueryHookResult = ReturnType<typeof useFetchExportDocumentLazyQuery>;
export type FetchExportDocumentQueryResult = Apollo.QueryResult<FetchExportDocumentQuery, FetchExportDocumentQueryVariables>;
export const FetchExtractionOrderByIdDocument = gql`
    query fetchExtractionOrderById($id: ID!) {
  orderGroup(id: $id) {
    id
    carrierNumber
    poNumber
    startOnTimestamp
    status
    latestInvoiceStatus
    driverAcceptance
    completeOnTimestamp
    startedOnTimestamp
    completedOnTimestamp
    driver {
      name
    }
    fees {
      id
      code
      price
      description
      name
    }
    deliveryOrder {
      id
      status
      orderNumber
      deliveryInstruction
      customerBranch {
        id
        name
        erpId
        customer {
          id
          name
          erpId
          fees {
            id
            name
            price
          }
        }
      }
      lineItems {
        id
        source
        requestedVolume
        volume
        status
        product {
          id
          name
          unit
          deliveryType
        }
        subscription {
          product {
            category
            name
            unit
            deliveryType
            brand {
              id
              name
            }
          }
          asset {
            category
            licensePlateNumber
          }
        }
      }
      linkedOrders {
        id
        orderGroup {
          id
        }
        terminal {
          id
          name
        }
      }
    }
    shiftId
    shift {
      shiftDeliveryUnitsAssets {
        deliveryAsset {
          name
          licensePlateNumber
        }
      }
    }
  }
}
    `;

/**
 * __useFetchExtractionOrderByIdQuery__
 *
 * To run a query within a React component, call `useFetchExtractionOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchExtractionOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchExtractionOrderByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchExtractionOrderByIdQuery(baseOptions: Apollo.QueryHookOptions<FetchExtractionOrderByIdQuery, FetchExtractionOrderByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchExtractionOrderByIdQuery, FetchExtractionOrderByIdQueryVariables>(FetchExtractionOrderByIdDocument, options);
      }
export function useFetchExtractionOrderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchExtractionOrderByIdQuery, FetchExtractionOrderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchExtractionOrderByIdQuery, FetchExtractionOrderByIdQueryVariables>(FetchExtractionOrderByIdDocument, options);
        }
export type FetchExtractionOrderByIdQueryHookResult = ReturnType<typeof useFetchExtractionOrderByIdQuery>;
export type FetchExtractionOrderByIdLazyQueryHookResult = ReturnType<typeof useFetchExtractionOrderByIdLazyQuery>;
export type FetchExtractionOrderByIdQueryResult = Apollo.QueryResult<FetchExtractionOrderByIdQuery, FetchExtractionOrderByIdQueryVariables>;
export const FetchFilteredRecurrenceDataOnlyDocument = gql`
    query FetchFilteredRecurrenceDataOnly($limit: Int, $offset: Int, $filter: OrderGroupFilter, $sorter: [OrderGroupSorter!]) {
  filteredOrderGroups(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: $filter
  ) {
    collection {
      id
      recurrenceData {
        lastDelivery
        nextDate
        recurrence {
          recurrenceFromTimestamp
          recurrenceType
          recurrenceDates
          recurrenceDays
          recurrenceInterval
          recurrenceUntil
          recurrenceOccurrences
          recurrenceDaysOfWeek
          recurrenceDaysInAdvance
          recurrenceAutoExpired
          recurrenceDayNthWeek {
            sunday
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
          }
        }
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFetchFilteredRecurrenceDataOnlyQuery__
 *
 * To run a query within a React component, call `useFetchFilteredRecurrenceDataOnlyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredRecurrenceDataOnlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredRecurrenceDataOnlyQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchFilteredRecurrenceDataOnlyQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredRecurrenceDataOnlyQuery, FetchFilteredRecurrenceDataOnlyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredRecurrenceDataOnlyQuery, FetchFilteredRecurrenceDataOnlyQueryVariables>(FetchFilteredRecurrenceDataOnlyDocument, options);
      }
export function useFetchFilteredRecurrenceDataOnlyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredRecurrenceDataOnlyQuery, FetchFilteredRecurrenceDataOnlyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredRecurrenceDataOnlyQuery, FetchFilteredRecurrenceDataOnlyQueryVariables>(FetchFilteredRecurrenceDataOnlyDocument, options);
        }
export type FetchFilteredRecurrenceDataOnlyQueryHookResult = ReturnType<typeof useFetchFilteredRecurrenceDataOnlyQuery>;
export type FetchFilteredRecurrenceDataOnlyLazyQueryHookResult = ReturnType<typeof useFetchFilteredRecurrenceDataOnlyLazyQuery>;
export type FetchFilteredRecurrenceDataOnlyQueryResult = Apollo.QueryResult<FetchFilteredRecurrenceDataOnlyQuery, FetchFilteredRecurrenceDataOnlyQueryVariables>;
export const FilteredBulkPlantsDocument = gql`
    query FilteredBulkPlants($filter: BulkPlantsFiltersInput) {
  bulkPlants(filter: $filter) {
    id
    bulkPlantShiftResource {
      id
      bulkPlantInventories {
        id
        retainQty
        product {
          id
          name
        }
      }
      resourceable {
        __typename
        ... on CompanyAsset {
          id
          name
          compartments {
            id
            name
            capacities {
              value
            }
          }
          licensePlateNumber
          lineOfServices {
            id
            name
          }
          subscriptions {
            product {
              id
              name
            }
          }
          hubs {
            id
            name
          }
        }
        ... on Terminal {
          id
          name
          products {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFilteredBulkPlantsQuery__
 *
 * To run a query within a React component, call `useFilteredBulkPlantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredBulkPlantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredBulkPlantsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFilteredBulkPlantsQuery(baseOptions?: Apollo.QueryHookOptions<FilteredBulkPlantsQuery, FilteredBulkPlantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredBulkPlantsQuery, FilteredBulkPlantsQueryVariables>(FilteredBulkPlantsDocument, options);
      }
export function useFilteredBulkPlantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredBulkPlantsQuery, FilteredBulkPlantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredBulkPlantsQuery, FilteredBulkPlantsQueryVariables>(FilteredBulkPlantsDocument, options);
        }
export type FilteredBulkPlantsQueryHookResult = ReturnType<typeof useFilteredBulkPlantsQuery>;
export type FilteredBulkPlantsLazyQueryHookResult = ReturnType<typeof useFilteredBulkPlantsLazyQuery>;
export type FilteredBulkPlantsQueryResult = Apollo.QueryResult<FilteredBulkPlantsQuery, FilteredBulkPlantsQueryVariables>;
export const ExtractionOrdersDocument = gql`
    query ExtractionOrders($limit: Int, $offset: Int, $filter: OrderGroupFilter!, $sorter: [OrderGroupSorter!]) {
  filteredOrderGroups(
    limit: $limit
    offset: $offset
    filter: $filter
    sorter: $sorter
  ) {
    collection {
      id
      carrierNumber
      poNumber
      startOnTimestamp
      status
      latestInvoiceStatus
      driverAcceptance
      completeOnTimestamp
      startedOnTimestamp
      completedOnTimestamp
      driver {
        name
      }
      fees {
        id
        code
        price
        description
        name
      }
      deliveryOrder {
        id
        status
        orderNumber
        deliveryInstruction
        customerBranch {
          id
          name
          erpId
          customer {
            id
            name
            erpId
            fees {
              id
              name
              price
            }
          }
        }
        lineItems {
          id
          source
          requestedVolume
          volume
          status
          product {
            id
            name
            unit
            deliveryType
          }
          subscription {
            product {
              category
              name
              unit
              deliveryType
              brand {
                id
                name
              }
            }
            asset {
              category
              licensePlateNumber
            }
          }
        }
        linkedOrders {
          id
          orderGroup {
            id
          }
          terminal {
            id
            name
          }
        }
      }
      shiftId
      shift {
        shiftDeliveryUnitsAssets {
          deliveryAsset {
            name
            licensePlateNumber
          }
        }
      }
    }
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useExtractionOrdersQuery__
 *
 * To run a query within a React component, call `useExtractionOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtractionOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtractionOrdersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useExtractionOrdersQuery(baseOptions: Apollo.QueryHookOptions<ExtractionOrdersQuery, ExtractionOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExtractionOrdersQuery, ExtractionOrdersQueryVariables>(ExtractionOrdersDocument, options);
      }
export function useExtractionOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExtractionOrdersQuery, ExtractionOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExtractionOrdersQuery, ExtractionOrdersQueryVariables>(ExtractionOrdersDocument, options);
        }
export type ExtractionOrdersQueryHookResult = ReturnType<typeof useExtractionOrdersQuery>;
export type ExtractionOrdersLazyQueryHookResult = ReturnType<typeof useExtractionOrdersLazyQuery>;
export type ExtractionOrdersQueryResult = Apollo.QueryResult<ExtractionOrdersQuery, ExtractionOrdersQueryVariables>;
export const FilteredRecurrenceOrdersDocument = gql`
    query FilteredRecurrenceOrders($limit: Int, $offset: Int, $filter: OrderGroupFilter, $sorter: [OrderGroupSorter!]) {
  filteredOrderGroups(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: $filter
  ) {
    collection {
      id
      startOnTimestamp
      ccTenantId
      poNumber
      ccTenant {
        id
        carrierTenant {
          id
          name
        }
      }
      loadingOrder {
        id
        terminal {
          name
        }
        loadingOrderProducts {
          id
          grossQuantity
          preferredSuppliers {
            id
            loadingAccount {
              id
              loadingNumber
              carrierCustomerCode
              label
              name
              supplierCode
              supplier {
                id
                erpId
                name
                supplierCode
              }
            }
          }
          product {
            id
            category
            name
            productType
            shortName
            unit
            deliveryType
            code
          }
        }
        linkedOrders {
          id
          orderGroupId
          customerBranch {
            id
            name
            status
            customer {
              id
              status
            }
          }
        }
      }
      deliveryOrder {
        id
        deliveryOrderLineItems {
          id
          topOff
          requestedVolume
          warehouse {
            id
            name
          }
          warehouseId
          product {
            id
            name
            productType
            shortName
            unit
            deliveryType
            code
            colorCode
          }
          subscription {
            id
            asset {
              id
              name
              erpId
              status
            }
            product {
              id
              name
            }
          }
        }
        orderLinks {
          loadingOrder {
            orderGroupId
            id
            terminal {
              name
            }
          }
        }
      }
      extractionOrder {
        id
      }
      hub {
        id
        name
        address
      }
      worker {
        id
        name
      }
      creatable {
        type: __typename
        ... on User {
          name
        }
      }
      customerBranch {
        id
        name
        erpId
        address
        status
        customer {
          id
          name
          erpId
          status
        }
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFilteredRecurrenceOrdersQuery__
 *
 * To run a query within a React component, call `useFilteredRecurrenceOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredRecurrenceOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredRecurrenceOrdersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilteredRecurrenceOrdersQuery(baseOptions?: Apollo.QueryHookOptions<FilteredRecurrenceOrdersQuery, FilteredRecurrenceOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredRecurrenceOrdersQuery, FilteredRecurrenceOrdersQueryVariables>(FilteredRecurrenceOrdersDocument, options);
      }
export function useFilteredRecurrenceOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredRecurrenceOrdersQuery, FilteredRecurrenceOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredRecurrenceOrdersQuery, FilteredRecurrenceOrdersQueryVariables>(FilteredRecurrenceOrdersDocument, options);
        }
export type FilteredRecurrenceOrdersQueryHookResult = ReturnType<typeof useFilteredRecurrenceOrdersQuery>;
export type FilteredRecurrenceOrdersLazyQueryHookResult = ReturnType<typeof useFilteredRecurrenceOrdersLazyQuery>;
export type FilteredRecurrenceOrdersQueryResult = Apollo.QueryResult<FilteredRecurrenceOrdersQuery, FilteredRecurrenceOrdersQueryVariables>;
export const FilteredShiftListDocument = gql`
    query FilteredShiftList($limit: Int, $offset: Int, $filter: ShiftFilter, $sorter: [ShiftSorter!]) {
  filteredShifts(limit: $limit, offset: $offset, filter: $filter, sorter: $sorter) {
    collection {
      id
      startOnTimestamp
      endOnTimestamp
      state
      worker {
        id
        name
        status
        hubs {
          name
        }
      }
      shiftDeliveryUnitsAssets {
        id
        deliveryAsset {
          id
          licensePlateNumber
          name
          category
        }
      }
      orderGroups {
        loadingOrder {
          id
          terminal {
            id
            name
          }
        }
        deliveryOrder {
          id
          customerBranch {
            id
            name
          }
        }
      }
    }
    metadata {
      totalCount
      hasMore
    }
  }
}
    `;

/**
 * __useFilteredShiftListQuery__
 *
 * To run a query within a React component, call `useFilteredShiftListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredShiftListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredShiftListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilteredShiftListQuery(baseOptions?: Apollo.QueryHookOptions<FilteredShiftListQuery, FilteredShiftListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredShiftListQuery, FilteredShiftListQueryVariables>(FilteredShiftListDocument, options);
      }
export function useFilteredShiftListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredShiftListQuery, FilteredShiftListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredShiftListQuery, FilteredShiftListQueryVariables>(FilteredShiftListDocument, options);
        }
export type FilteredShiftListQueryHookResult = ReturnType<typeof useFilteredShiftListQuery>;
export type FilteredShiftListLazyQueryHookResult = ReturnType<typeof useFilteredShiftListLazyQuery>;
export type FilteredShiftListQueryResult = Apollo.QueryResult<FilteredShiftListQuery, FilteredShiftListQueryVariables>;
export const FetchLoadingOrderByIdDocument = gql`
    query FetchLoadingOrderById($id: ID!) {
  orderGroup(id: $id) {
    id
    startOnTimestamp
    status
    startedOnTimestamp
    completedOnTimestamp
    priority
    customerBranch {
      id
      name
    }
    driver {
      name
    }
    loadingOrder {
      id
      status
      bolNumbers
      terminal {
        id
        name
        suppliers {
          id
          name
        }
      }
      loadingOrderProducts {
        id
        quantity
        product {
          id
          name
          unit
          deliveryType
        }
      }
      lineItems {
        id
        netAmount
        product {
          id
          name
          unit
          deliveryType
        }
        compartment {
          asset {
            id
            licensePlateNumber
            name
          }
        }
      }
      orderLinks {
        deliveryOrder {
          id
          customerBranch {
            id
            name
          }
        }
      }
    }
    shift {
      shiftDeliveryUnitsAssets {
        deliveryAsset {
          name
          licensePlateNumber
        }
      }
    }
  }
}
    `;

/**
 * __useFetchLoadingOrderByIdQuery__
 *
 * To run a query within a React component, call `useFetchLoadingOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLoadingOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLoadingOrderByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchLoadingOrderByIdQuery(baseOptions: Apollo.QueryHookOptions<FetchLoadingOrderByIdQuery, FetchLoadingOrderByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLoadingOrderByIdQuery, FetchLoadingOrderByIdQueryVariables>(FetchLoadingOrderByIdDocument, options);
      }
export function useFetchLoadingOrderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLoadingOrderByIdQuery, FetchLoadingOrderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLoadingOrderByIdQuery, FetchLoadingOrderByIdQueryVariables>(FetchLoadingOrderByIdDocument, options);
        }
export type FetchLoadingOrderByIdQueryHookResult = ReturnType<typeof useFetchLoadingOrderByIdQuery>;
export type FetchLoadingOrderByIdLazyQueryHookResult = ReturnType<typeof useFetchLoadingOrderByIdLazyQuery>;
export type FetchLoadingOrderByIdQueryResult = Apollo.QueryResult<FetchLoadingOrderByIdQuery, FetchLoadingOrderByIdQueryVariables>;
export const LoadingOrdersDocument = gql`
    query LoadingOrders($limit: Int, $offset: Int, $filter: OrderGroupFilter!, $sorter: [OrderGroupSorter!]) {
  filteredOrderGroups(
    limit: $limit
    offset: $offset
    filter: $filter
    sorter: $sorter
  ) {
    collection {
      id
      startOnTimestamp
      status
      startedOnTimestamp
      completedOnTimestamp
      priority
      customerBranch {
        id
        name
      }
      driver {
        name
      }
      loadingOrder {
        id
        status
        bolNumbers
        terminal {
          id
          name
          suppliers {
            id
            name
          }
        }
        loadingOrderProducts {
          id
          quantity
          product {
            id
            name
            unit
            deliveryType
          }
          preferredSuppliers {
            loadingAccount {
              supplier {
                name
              }
            }
          }
        }
        lineItems {
          id
          netAmount
          product {
            id
            name
            unit
            deliveryType
          }
          compartment {
            asset {
              id
              licensePlateNumber
              name
            }
          }
        }
        orderLinks {
          deliveryOrder {
            id
            customerBranch {
              id
              name
            }
          }
        }
      }
      shift {
        shiftDeliveryUnitsAssets {
          deliveryAsset {
            name
            licensePlateNumber
          }
        }
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useLoadingOrdersQuery__
 *
 * To run a query within a React component, call `useLoadingOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadingOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadingOrdersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useLoadingOrdersQuery(baseOptions: Apollo.QueryHookOptions<LoadingOrdersQuery, LoadingOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadingOrdersQuery, LoadingOrdersQueryVariables>(LoadingOrdersDocument, options);
      }
export function useLoadingOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadingOrdersQuery, LoadingOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadingOrdersQuery, LoadingOrdersQueryVariables>(LoadingOrdersDocument, options);
        }
export type LoadingOrdersQueryHookResult = ReturnType<typeof useLoadingOrdersQuery>;
export type LoadingOrdersLazyQueryHookResult = ReturnType<typeof useLoadingOrdersLazyQuery>;
export type LoadingOrdersQueryResult = Apollo.QueryResult<LoadingOrdersQuery, LoadingOrdersQueryVariables>;
export const FilteredOrderGroupDocument = gql`
    query FilteredOrderGroup($perPage: Int, $offset: Int, $customFilter: OrderGroupFilter) {
  filteredOrderGroups(limit: $perPage, offset: $offset, filter: $customFilter) {
    collection {
      id
      ticketId
      createdAtTimestamp
      startOnTimestamp
      departedOnTimestamp
      startedOnTimestamp
      completedOnTimestamp
      completeOnTimestamp
      status
      latestInvoiceStatus
      driverAcceptance
      priority
      driver {
        name
      }
      deliveryOrder {
        type
        id
        status
        orderLinks {
          id
          loadingOrder {
            id
            bolNumbers
            status
            terminal {
              id
              name
            }
          }
          extractionOrder {
            id
            customerBranch {
              id
              name
            }
          }
        }
        orderNumber
        deliveryInstruction
        source
        customerBranch {
          id
          name
          address
          site {
            lat
            lng
            radius
          }
          customer {
            id
            name
            address
          }
        }
        lineItems {
          id
          requestedVolume
          volume
          status
          product {
            id
            name
            unit
            deliveryType
          }
          subscription {
            product {
              name
            }
            asset {
              category
              licensePlateNumber
            }
          }
        }
      }
      loadingOrder {
        id
        status
        terminal {
          id
          name
          site {
            lat
            lng
            radius
            address
          }
          suppliers {
            id
            name
            loadingAccounts {
              id
              carrierCustomerCode
              loadingNumber
            }
          }
        }
        orderLinks {
          id
          deliveryOrder {
            id
            orderGroupId
          }
          loadingOrder {
            id
          }
        }
        loadingOrderProducts {
          id
          quantity
          product {
            name
            code
            unit
            deliveryType
          }
          preferredSuppliers {
            priority
            loadingAccount {
              loadingNumber
              supplier {
                name
                erpId
                supplierId
              }
            }
          }
        }
        lineItems {
          id
          netAmount
          product {
            id
            name
            unit
            deliveryType
          }
          compartment {
            asset {
              id
              licensePlateNumber
              name
            }
          }
        }
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFilteredOrderGroupQuery__
 *
 * To run a query within a React component, call `useFilteredOrderGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredOrderGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredOrderGroupQuery({
 *   variables: {
 *      perPage: // value for 'perPage'
 *      offset: // value for 'offset'
 *      customFilter: // value for 'customFilter'
 *   },
 * });
 */
export function useFilteredOrderGroupQuery(baseOptions?: Apollo.QueryHookOptions<FilteredOrderGroupQuery, FilteredOrderGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredOrderGroupQuery, FilteredOrderGroupQueryVariables>(FilteredOrderGroupDocument, options);
      }
export function useFilteredOrderGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredOrderGroupQuery, FilteredOrderGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredOrderGroupQuery, FilteredOrderGroupQueryVariables>(FilteredOrderGroupDocument, options);
        }
export type FilteredOrderGroupQueryHookResult = ReturnType<typeof useFilteredOrderGroupQuery>;
export type FilteredOrderGroupLazyQueryHookResult = ReturnType<typeof useFilteredOrderGroupLazyQuery>;
export type FilteredOrderGroupQueryResult = Apollo.QueryResult<FilteredOrderGroupQuery, FilteredOrderGroupQueryVariables>;
export const FetchOrderGroupGeoFenceTimestampsDocument = gql`
    query FetchOrderGroupGeoFenceTimestamps($orderGroupId: ID!) {
  orderGroup(id: $orderGroupId) {
    id
    fenceIns {
      lat
      lng
      timestamp
    }
    fenceOuts {
      lat
      lng
      timestamp
    }
  }
}
    `;

/**
 * __useFetchOrderGroupGeoFenceTimestampsQuery__
 *
 * To run a query within a React component, call `useFetchOrderGroupGeoFenceTimestampsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOrderGroupGeoFenceTimestampsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOrderGroupGeoFenceTimestampsQuery({
 *   variables: {
 *      orderGroupId: // value for 'orderGroupId'
 *   },
 * });
 */
export function useFetchOrderGroupGeoFenceTimestampsQuery(baseOptions: Apollo.QueryHookOptions<FetchOrderGroupGeoFenceTimestampsQuery, FetchOrderGroupGeoFenceTimestampsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchOrderGroupGeoFenceTimestampsQuery, FetchOrderGroupGeoFenceTimestampsQueryVariables>(FetchOrderGroupGeoFenceTimestampsDocument, options);
      }
export function useFetchOrderGroupGeoFenceTimestampsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchOrderGroupGeoFenceTimestampsQuery, FetchOrderGroupGeoFenceTimestampsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchOrderGroupGeoFenceTimestampsQuery, FetchOrderGroupGeoFenceTimestampsQueryVariables>(FetchOrderGroupGeoFenceTimestampsDocument, options);
        }
export type FetchOrderGroupGeoFenceTimestampsQueryHookResult = ReturnType<typeof useFetchOrderGroupGeoFenceTimestampsQuery>;
export type FetchOrderGroupGeoFenceTimestampsLazyQueryHookResult = ReturnType<typeof useFetchOrderGroupGeoFenceTimestampsLazyQuery>;
export type FetchOrderGroupGeoFenceTimestampsQueryResult = Apollo.QueryResult<FetchOrderGroupGeoFenceTimestampsQuery, FetchOrderGroupGeoFenceTimestampsQueryVariables>;
export const FetchShiftListDocument = gql`
    query FetchShiftList($id: ID!) {
  shift(id: $id) {
    id
    startOnTimestamp
    endOnTimestamp
    state
    worker {
      id
      name
      status
      hubs {
        name
      }
    }
    shiftDeliveryUnitsAssets {
      id
      deliveryAsset {
        id
        licensePlateNumber
        name
        category
      }
    }
    orderGroups {
      loadingOrder {
        id
        terminal {
          id
          name
        }
      }
      deliveryOrder {
        id
        customerBranch {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useFetchShiftListQuery__
 *
 * To run a query within a React component, call `useFetchShiftListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchShiftListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchShiftListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchShiftListQuery(baseOptions: Apollo.QueryHookOptions<FetchShiftListQuery, FetchShiftListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchShiftListQuery, FetchShiftListQueryVariables>(FetchShiftListDocument, options);
      }
export function useFetchShiftListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchShiftListQuery, FetchShiftListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchShiftListQuery, FetchShiftListQueryVariables>(FetchShiftListDocument, options);
        }
export type FetchShiftListQueryHookResult = ReturnType<typeof useFetchShiftListQuery>;
export type FetchShiftListLazyQueryHookResult = ReturnType<typeof useFetchShiftListLazyQuery>;
export type FetchShiftListQueryResult = Apollo.QueryResult<FetchShiftListQuery, FetchShiftListQueryVariables>;
export const FilteredTransferOrderDocument = gql`
    query FilteredTransferOrder($perPage: Int, $offSet: Int, $sorter: [TransferOrderSorter!], $customFilter: TransferOrderFilter) {
  filteredTransferOrders(
    limit: $perPage
    offset: $offSet
    sorter: $sorter
    filter: $customFilter
  ) {
    collection {
      id
      transferDateTimestamp
      orderGroupId
      orderGroup {
        status
      }
      fromDriver {
        name
      }
      fromAsset {
        licensePlateNumber
        name
      }
      fromShift {
        id
        worker {
          name
        }
      }
      toDriver {
        name
      }
      toAsset {
        licensePlateNumber
        name
      }
      toShift {
        id
        worker {
          name
        }
      }
      lineItemSummary {
        deliveredVolume
      }
      lineItems {
        fromCompartment {
          id
          name
        }
        toCompartment {
          id
          name
        }
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFilteredTransferOrderQuery__
 *
 * To run a query within a React component, call `useFilteredTransferOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredTransferOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredTransferOrderQuery({
 *   variables: {
 *      perPage: // value for 'perPage'
 *      offSet: // value for 'offSet'
 *      sorter: // value for 'sorter'
 *      customFilter: // value for 'customFilter'
 *   },
 * });
 */
export function useFilteredTransferOrderQuery(baseOptions?: Apollo.QueryHookOptions<FilteredTransferOrderQuery, FilteredTransferOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredTransferOrderQuery, FilteredTransferOrderQueryVariables>(FilteredTransferOrderDocument, options);
      }
export function useFilteredTransferOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredTransferOrderQuery, FilteredTransferOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredTransferOrderQuery, FilteredTransferOrderQueryVariables>(FilteredTransferOrderDocument, options);
        }
export type FilteredTransferOrderQueryHookResult = ReturnType<typeof useFilteredTransferOrderQuery>;
export type FilteredTransferOrderLazyQueryHookResult = ReturnType<typeof useFilteredTransferOrderLazyQuery>;
export type FilteredTransferOrderQueryResult = Apollo.QueryResult<FilteredTransferOrderQuery, FilteredTransferOrderQueryVariables>;
export const FetchTransferOrderByIdDocument = gql`
    query FetchTransferOrderById($id: ID!) {
  orderGroup(id: $id) {
    id
    startOnTimestamp
    transferOrder {
      id
      transferDateTimestamp
      orderGroupId
      orderGroup {
        status
      }
      fromDriver {
        name
      }
      fromAsset {
        name
      }
      fromShift {
        id
        worker {
          name
        }
      }
      toDriver {
        name
      }
      toAsset {
        name
      }
      toShift {
        id
        worker {
          name
        }
      }
      lineItems {
        fromCompartment {
          id
          name
        }
        toCompartment {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useFetchTransferOrderByIdQuery__
 *
 * To run a query within a React component, call `useFetchTransferOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTransferOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTransferOrderByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchTransferOrderByIdQuery(baseOptions: Apollo.QueryHookOptions<FetchTransferOrderByIdQuery, FetchTransferOrderByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTransferOrderByIdQuery, FetchTransferOrderByIdQueryVariables>(FetchTransferOrderByIdDocument, options);
      }
export function useFetchTransferOrderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTransferOrderByIdQuery, FetchTransferOrderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTransferOrderByIdQuery, FetchTransferOrderByIdQueryVariables>(FetchTransferOrderByIdDocument, options);
        }
export type FetchTransferOrderByIdQueryHookResult = ReturnType<typeof useFetchTransferOrderByIdQuery>;
export type FetchTransferOrderByIdLazyQueryHookResult = ReturnType<typeof useFetchTransferOrderByIdLazyQuery>;
export type FetchTransferOrderByIdQueryResult = Apollo.QueryResult<FetchTransferOrderByIdQuery, FetchTransferOrderByIdQueryVariables>;
export const FilteredNotesDocument = gql`
    query FilteredNotes($limit: Int, $offset: Int, $filter: NotesFilter!) {
  filteredNotes(limit: $limit, offset: $offset, filter: $filter) {
    collection {
      id
      createdAtTimestamp
      noteType
      notableType
      content
      commenter
      orderGroup {
        customerBranch {
          customer {
            id
            name
          }
          name
        }
        hub {
          id
          name
          address
        }
        id
        loadingOrder {
          id
          terminal {
            id
            name
          }
          loadingReceipts {
            id
            terminalsSupplier {
              id
              supplier {
                id
                name
              }
            }
          }
        }
        deliveryOrder {
          id
          postDeliveryNote {
            content
            noteType
            createdAtTimestamp
          }
        }
      }
      acknowledger
      acknowledgedAt
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFilteredNotesQuery__
 *
 * To run a query within a React component, call `useFilteredNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredNotesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFilteredNotesQuery(baseOptions: Apollo.QueryHookOptions<FilteredNotesQuery, FilteredNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredNotesQuery, FilteredNotesQueryVariables>(FilteredNotesDocument, options);
      }
export function useFilteredNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredNotesQuery, FilteredNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredNotesQuery, FilteredNotesQueryVariables>(FilteredNotesDocument, options);
        }
export type FilteredNotesQueryHookResult = ReturnType<typeof useFilteredNotesQuery>;
export type FilteredNotesLazyQueryHookResult = ReturnType<typeof useFilteredNotesLazyQuery>;
export type FilteredNotesQueryResult = Apollo.QueryResult<FilteredNotesQuery, FilteredNotesQueryVariables>;
export const ModifyInventoryDocument = gql`
    mutation ModifyInventory($input: ModifyInventoryInput!) {
  modifyInventory(input: $input) {
    shift {
      id
    }
  }
}
    `;
export type ModifyInventoryMutationFn = Apollo.MutationFunction<ModifyInventoryMutation, ModifyInventoryMutationVariables>;

/**
 * __useModifyInventoryMutation__
 *
 * To run a mutation, you first call `useModifyInventoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyInventoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyInventoryMutation, { data, loading, error }] = useModifyInventoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModifyInventoryMutation(baseOptions?: Apollo.MutationHookOptions<ModifyInventoryMutation, ModifyInventoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyInventoryMutation, ModifyInventoryMutationVariables>(ModifyInventoryDocument, options);
      }
export type ModifyInventoryMutationHookResult = ReturnType<typeof useModifyInventoryMutation>;
export type ModifyInventoryMutationResult = Apollo.MutationResult<ModifyInventoryMutation>;
export type ModifyInventoryMutationOptions = Apollo.BaseMutationOptions<ModifyInventoryMutation, ModifyInventoryMutationVariables>;
export const UpdateExportOrdersDocument = gql`
    mutation UpdateExportOrders($input: ExportOrdersInput!) {
  exportOrders(input: $input) {
    exportDocument {
      id
      status
    }
    message
  }
}
    `;
export type UpdateExportOrdersMutationFn = Apollo.MutationFunction<UpdateExportOrdersMutation, UpdateExportOrdersMutationVariables>;

/**
 * __useUpdateExportOrdersMutation__
 *
 * To run a mutation, you first call `useUpdateExportOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExportOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExportOrdersMutation, { data, loading, error }] = useUpdateExportOrdersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExportOrdersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExportOrdersMutation, UpdateExportOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExportOrdersMutation, UpdateExportOrdersMutationVariables>(UpdateExportOrdersDocument, options);
      }
export type UpdateExportOrdersMutationHookResult = ReturnType<typeof useUpdateExportOrdersMutation>;
export type UpdateExportOrdersMutationResult = Apollo.MutationResult<UpdateExportOrdersMutation>;
export type UpdateExportOrdersMutationOptions = Apollo.BaseMutationOptions<UpdateExportOrdersMutation, UpdateExportOrdersMutationVariables>;
export const CopyPreviousRecordsDocument = gql`
    mutation CopyPreviousRecords($input: CopyPreviousRecordsInput!) {
  copyPreviousRecords(input: $input) {
    success
  }
}
    `;
export type CopyPreviousRecordsMutationFn = Apollo.MutationFunction<CopyPreviousRecordsMutation, CopyPreviousRecordsMutationVariables>;

/**
 * __useCopyPreviousRecordsMutation__
 *
 * To run a mutation, you first call `useCopyPreviousRecordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyPreviousRecordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyPreviousRecordsMutation, { data, loading, error }] = useCopyPreviousRecordsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyPreviousRecordsMutation(baseOptions?: Apollo.MutationHookOptions<CopyPreviousRecordsMutation, CopyPreviousRecordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyPreviousRecordsMutation, CopyPreviousRecordsMutationVariables>(CopyPreviousRecordsDocument, options);
      }
export type CopyPreviousRecordsMutationHookResult = ReturnType<typeof useCopyPreviousRecordsMutation>;
export type CopyPreviousRecordsMutationResult = Apollo.MutationResult<CopyPreviousRecordsMutation>;
export type CopyPreviousRecordsMutationOptions = Apollo.BaseMutationOptions<CopyPreviousRecordsMutation, CopyPreviousRecordsMutationVariables>;
export const CreateDriverRatesDocument = gql`
    mutation CreateDriverRates($input: CreateDriverRatesInput!) {
  createDriverRates(input: $input) {
    driverRate {
      id
    }
  }
}
    `;
export type CreateDriverRatesMutationFn = Apollo.MutationFunction<CreateDriverRatesMutation, CreateDriverRatesMutationVariables>;

/**
 * __useCreateDriverRatesMutation__
 *
 * To run a mutation, you first call `useCreateDriverRatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDriverRatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDriverRatesMutation, { data, loading, error }] = useCreateDriverRatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDriverRatesMutation(baseOptions?: Apollo.MutationHookOptions<CreateDriverRatesMutation, CreateDriverRatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDriverRatesMutation, CreateDriverRatesMutationVariables>(CreateDriverRatesDocument, options);
      }
export type CreateDriverRatesMutationHookResult = ReturnType<typeof useCreateDriverRatesMutation>;
export type CreateDriverRatesMutationResult = Apollo.MutationResult<CreateDriverRatesMutation>;
export type CreateDriverRatesMutationOptions = Apollo.BaseMutationOptions<CreateDriverRatesMutation, CreateDriverRatesMutationVariables>;
export const CreateMarginDocument = gql`
    mutation CreateMargin($input: CreateMarginInput!) {
  createMargin(input: $input) {
    margin {
      id
      name
      marginType
      marginUnit
      marginRate
      range {
        endRange
        rangeRate
        startRange
      }
    }
  }
}
    `;
export type CreateMarginMutationFn = Apollo.MutationFunction<CreateMarginMutation, CreateMarginMutationVariables>;

/**
 * __useCreateMarginMutation__
 *
 * To run a mutation, you first call `useCreateMarginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMarginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMarginMutation, { data, loading, error }] = useCreateMarginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMarginMutation(baseOptions?: Apollo.MutationHookOptions<CreateMarginMutation, CreateMarginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMarginMutation, CreateMarginMutationVariables>(CreateMarginDocument, options);
      }
export type CreateMarginMutationHookResult = ReturnType<typeof useCreateMarginMutation>;
export type CreateMarginMutationResult = Apollo.MutationResult<CreateMarginMutation>;
export type CreateMarginMutationOptions = Apollo.BaseMutationOptions<CreateMarginMutation, CreateMarginMutationVariables>;
export const CreateMarketDocument = gql`
    mutation CreateMarket($input: CreateMarketsInput!) {
  createMarket(input: $input) {
    market {
      id
    }
  }
}
    `;
export type CreateMarketMutationFn = Apollo.MutationFunction<CreateMarketMutation, CreateMarketMutationVariables>;

/**
 * __useCreateMarketMutation__
 *
 * To run a mutation, you first call `useCreateMarketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMarketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMarketMutation, { data, loading, error }] = useCreateMarketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMarketMutation(baseOptions?: Apollo.MutationHookOptions<CreateMarketMutation, CreateMarketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMarketMutation, CreateMarketMutationVariables>(CreateMarketDocument, options);
      }
export type CreateMarketMutationHookResult = ReturnType<typeof useCreateMarketMutation>;
export type CreateMarketMutationResult = Apollo.MutationResult<CreateMarketMutation>;
export type CreateMarketMutationOptions = Apollo.BaseMutationOptions<CreateMarketMutation, CreateMarketMutationVariables>;
export const CreatePricingDocument = gql`
    mutation CreatePricing($input: CreatePricingInput!) {
  createPricings(input: $input) {
    pricing {
      id
    }
  }
}
    `;
export type CreatePricingMutationFn = Apollo.MutationFunction<CreatePricingMutation, CreatePricingMutationVariables>;

/**
 * __useCreatePricingMutation__
 *
 * To run a mutation, you first call `useCreatePricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPricingMutation, { data, loading, error }] = useCreatePricingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePricingMutation(baseOptions?: Apollo.MutationHookOptions<CreatePricingMutation, CreatePricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePricingMutation, CreatePricingMutationVariables>(CreatePricingDocument, options);
      }
export type CreatePricingMutationHookResult = ReturnType<typeof useCreatePricingMutation>;
export type CreatePricingMutationResult = Apollo.MutationResult<CreatePricingMutation>;
export type CreatePricingMutationOptions = Apollo.BaseMutationOptions<CreatePricingMutation, CreatePricingMutationVariables>;
export const CreateRateTypeDocument = gql`
    mutation CreateRateType($input: CreateRateInput!) {
  createRateType(input: $input) {
    rateType {
      id
    }
  }
}
    `;
export type CreateRateTypeMutationFn = Apollo.MutationFunction<CreateRateTypeMutation, CreateRateTypeMutationVariables>;

/**
 * __useCreateRateTypeMutation__
 *
 * To run a mutation, you first call `useCreateRateTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRateTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRateTypeMutation, { data, loading, error }] = useCreateRateTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRateTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateRateTypeMutation, CreateRateTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRateTypeMutation, CreateRateTypeMutationVariables>(CreateRateTypeDocument, options);
      }
export type CreateRateTypeMutationHookResult = ReturnType<typeof useCreateRateTypeMutation>;
export type CreateRateTypeMutationResult = Apollo.MutationResult<CreateRateTypeMutation>;
export type CreateRateTypeMutationOptions = Apollo.BaseMutationOptions<CreateRateTypeMutation, CreateRateTypeMutationVariables>;
export const CreateResourcePricingsDocument = gql`
    mutation createResourcePricings($input: CreateResourcePricingsInput!) {
  createResourcePricings(input: {data: $input}) {
    resourcePricing {
      id
      resourceId
      resourceType
      priceConfigurations {
        id
        pricing {
          id
          supplierId
          hubId
        }
      }
    }
  }
}
    `;
export type CreateResourcePricingsMutationFn = Apollo.MutationFunction<CreateResourcePricingsMutation, CreateResourcePricingsMutationVariables>;

/**
 * __useCreateResourcePricingsMutation__
 *
 * To run a mutation, you first call `useCreateResourcePricingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResourcePricingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResourcePricingsMutation, { data, loading, error }] = useCreateResourcePricingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateResourcePricingsMutation(baseOptions?: Apollo.MutationHookOptions<CreateResourcePricingsMutation, CreateResourcePricingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResourcePricingsMutation, CreateResourcePricingsMutationVariables>(CreateResourcePricingsDocument, options);
      }
export type CreateResourcePricingsMutationHookResult = ReturnType<typeof useCreateResourcePricingsMutation>;
export type CreateResourcePricingsMutationResult = Apollo.MutationResult<CreateResourcePricingsMutation>;
export type CreateResourcePricingsMutationOptions = Apollo.BaseMutationOptions<CreateResourcePricingsMutation, CreateResourcePricingsMutationVariables>;
export const CreateTaxDocument = gql`
    mutation CreateTax($input: CreateTaxInput!) {
  createTax(input: $input) {
    tax {
      id
      name
    }
  }
}
    `;
export type CreateTaxMutationFn = Apollo.MutationFunction<CreateTaxMutation, CreateTaxMutationVariables>;

/**
 * __useCreateTaxMutation__
 *
 * To run a mutation, you first call `useCreateTaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaxMutation, { data, loading, error }] = useCreateTaxMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaxMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaxMutation, CreateTaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaxMutation, CreateTaxMutationVariables>(CreateTaxDocument, options);
      }
export type CreateTaxMutationHookResult = ReturnType<typeof useCreateTaxMutation>;
export type CreateTaxMutationResult = Apollo.MutationResult<CreateTaxMutation>;
export type CreateTaxMutationOptions = Apollo.BaseMutationOptions<CreateTaxMutation, CreateTaxMutationVariables>;
export const CreateUpdateAliasMappingDocument = gql`
    mutation CreateUpdateAliasMapping($mapper: AliasMappingInput!) {
  createUpdateAliasMapping(input: {mapper: $mapper}) {
    aliasMapping {
      id
      dataSource
      sourceValue
      mappableId
      mappableType
      mappable {
        ... on Product {
          id
          nullableName: name
        }
        ... on Market {
          id
          nullableName: name
        }
        ... on Supplier {
          id
          name
        }
        ... on RateType {
          id
          name
        }
      }
    }
  }
}
    `;
export type CreateUpdateAliasMappingMutationFn = Apollo.MutationFunction<CreateUpdateAliasMappingMutation, CreateUpdateAliasMappingMutationVariables>;

/**
 * __useCreateUpdateAliasMappingMutation__
 *
 * To run a mutation, you first call `useCreateUpdateAliasMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateAliasMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateAliasMappingMutation, { data, loading, error }] = useCreateUpdateAliasMappingMutation({
 *   variables: {
 *      mapper: // value for 'mapper'
 *   },
 * });
 */
export function useCreateUpdateAliasMappingMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateAliasMappingMutation, CreateUpdateAliasMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateAliasMappingMutation, CreateUpdateAliasMappingMutationVariables>(CreateUpdateAliasMappingDocument, options);
      }
export type CreateUpdateAliasMappingMutationHookResult = ReturnType<typeof useCreateUpdateAliasMappingMutation>;
export type CreateUpdateAliasMappingMutationResult = Apollo.MutationResult<CreateUpdateAliasMappingMutation>;
export type CreateUpdateAliasMappingMutationOptions = Apollo.BaseMutationOptions<CreateUpdateAliasMappingMutation, CreateUpdateAliasMappingMutationVariables>;
export const DataImportCsvDocument = gql`
    query DataImportCsv($importableType: ImportableTypeEnum) {
  dataImports(importableType: $importableType) {
    id
    errorFileUrl
    importableId
    importableType
    pandaDocumentId
    status
    filename
    createdAtTimestamp
    user {
      id
      name
      email
      isSuperAdmin
    }
  }
}
    `;

/**
 * __useDataImportCsvQuery__
 *
 * To run a query within a React component, call `useDataImportCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataImportCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataImportCsvQuery({
 *   variables: {
 *      importableType: // value for 'importableType'
 *   },
 * });
 */
export function useDataImportCsvQuery(baseOptions?: Apollo.QueryHookOptions<DataImportCsvQuery, DataImportCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataImportCsvQuery, DataImportCsvQueryVariables>(DataImportCsvDocument, options);
      }
export function useDataImportCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataImportCsvQuery, DataImportCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataImportCsvQuery, DataImportCsvQueryVariables>(DataImportCsvDocument, options);
        }
export type DataImportCsvQueryHookResult = ReturnType<typeof useDataImportCsvQuery>;
export type DataImportCsvLazyQueryHookResult = ReturnType<typeof useDataImportCsvLazyQuery>;
export type DataImportCsvQueryResult = Apollo.QueryResult<DataImportCsvQuery, DataImportCsvQueryVariables>;
export const DeleteMarketDocument = gql`
    mutation DeleteMarket($input: DeleteResourceInput!) {
  deleteResource(input: $input) {
    clientMutationId
    result
  }
}
    `;
export type DeleteMarketMutationFn = Apollo.MutationFunction<DeleteMarketMutation, DeleteMarketMutationVariables>;

/**
 * __useDeleteMarketMutation__
 *
 * To run a mutation, you first call `useDeleteMarketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMarketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMarketMutation, { data, loading, error }] = useDeleteMarketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMarketMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMarketMutation, DeleteMarketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMarketMutation, DeleteMarketMutationVariables>(DeleteMarketDocument, options);
      }
export type DeleteMarketMutationHookResult = ReturnType<typeof useDeleteMarketMutation>;
export type DeleteMarketMutationResult = Apollo.MutationResult<DeleteMarketMutation>;
export type DeleteMarketMutationOptions = Apollo.BaseMutationOptions<DeleteMarketMutation, DeleteMarketMutationVariables>;
export const EmailResourcePricingDocument = gql`
    mutation EmailResourcePricing($data: EmailResourcePricingsInput!) {
  emailResourcePricing(input: {data: $data}) {
    resourcePricing {
      id
    }
  }
}
    `;
export type EmailResourcePricingMutationFn = Apollo.MutationFunction<EmailResourcePricingMutation, EmailResourcePricingMutationVariables>;

/**
 * __useEmailResourcePricingMutation__
 *
 * To run a mutation, you first call `useEmailResourcePricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailResourcePricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailResourcePricingMutation, { data, loading, error }] = useEmailResourcePricingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useEmailResourcePricingMutation(baseOptions?: Apollo.MutationHookOptions<EmailResourcePricingMutation, EmailResourcePricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailResourcePricingMutation, EmailResourcePricingMutationVariables>(EmailResourcePricingDocument, options);
      }
export type EmailResourcePricingMutationHookResult = ReturnType<typeof useEmailResourcePricingMutation>;
export type EmailResourcePricingMutationResult = Apollo.MutationResult<EmailResourcePricingMutation>;
export type EmailResourcePricingMutationOptions = Apollo.BaseMutationOptions<EmailResourcePricingMutation, EmailResourcePricingMutationVariables>;
export const FetchAppliedFeesForCustomerDocument = gql`
    query FetchAppliedFeesForCustomer($id: ID!) {
  customer(id: $id) {
    id
    marketResources {
      id
      market {
        id
        name
      }
    }
    applicableFees {
      id
      isDefault
      fee {
        id
        name
        applicableType
      }
    }
  }
}
    `;

/**
 * __useFetchAppliedFeesForCustomerQuery__
 *
 * To run a query within a React component, call `useFetchAppliedFeesForCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAppliedFeesForCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAppliedFeesForCustomerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchAppliedFeesForCustomerQuery(baseOptions: Apollo.QueryHookOptions<FetchAppliedFeesForCustomerQuery, FetchAppliedFeesForCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAppliedFeesForCustomerQuery, FetchAppliedFeesForCustomerQueryVariables>(FetchAppliedFeesForCustomerDocument, options);
      }
export function useFetchAppliedFeesForCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAppliedFeesForCustomerQuery, FetchAppliedFeesForCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAppliedFeesForCustomerQuery, FetchAppliedFeesForCustomerQueryVariables>(FetchAppliedFeesForCustomerDocument, options);
        }
export type FetchAppliedFeesForCustomerQueryHookResult = ReturnType<typeof useFetchAppliedFeesForCustomerQuery>;
export type FetchAppliedFeesForCustomerLazyQueryHookResult = ReturnType<typeof useFetchAppliedFeesForCustomerLazyQuery>;
export type FetchAppliedFeesForCustomerQueryResult = Apollo.QueryResult<FetchAppliedFeesForCustomerQuery, FetchAppliedFeesForCustomerQueryVariables>;
export const FetchAppliedFeesForCustomerBranchDocument = gql`
    query FetchAppliedFeesForCustomerBranch($id: ID!, $includeParentFeeId: Boolean = false) {
  customerBranch(id: $id) {
    id
    marketResources {
      id
      market {
        id
        name
      }
    }
    customer @include(if: $includeParentFeeId) {
      applicableFees {
        id
        isDefault
        fee {
          id
          name
          applicableType
        }
      }
    }
    applicableFees {
      id
      isDefault
      parentFeeId @include(if: $includeParentFeeId)
      fee {
        id
        name
        applicableType
      }
    }
  }
}
    `;

/**
 * __useFetchAppliedFeesForCustomerBranchQuery__
 *
 * To run a query within a React component, call `useFetchAppliedFeesForCustomerBranchQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAppliedFeesForCustomerBranchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAppliedFeesForCustomerBranchQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeParentFeeId: // value for 'includeParentFeeId'
 *   },
 * });
 */
export function useFetchAppliedFeesForCustomerBranchQuery(baseOptions: Apollo.QueryHookOptions<FetchAppliedFeesForCustomerBranchQuery, FetchAppliedFeesForCustomerBranchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAppliedFeesForCustomerBranchQuery, FetchAppliedFeesForCustomerBranchQueryVariables>(FetchAppliedFeesForCustomerBranchDocument, options);
      }
export function useFetchAppliedFeesForCustomerBranchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAppliedFeesForCustomerBranchQuery, FetchAppliedFeesForCustomerBranchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAppliedFeesForCustomerBranchQuery, FetchAppliedFeesForCustomerBranchQueryVariables>(FetchAppliedFeesForCustomerBranchDocument, options);
        }
export type FetchAppliedFeesForCustomerBranchQueryHookResult = ReturnType<typeof useFetchAppliedFeesForCustomerBranchQuery>;
export type FetchAppliedFeesForCustomerBranchLazyQueryHookResult = ReturnType<typeof useFetchAppliedFeesForCustomerBranchLazyQuery>;
export type FetchAppliedFeesForCustomerBranchQueryResult = Apollo.QueryResult<FetchAppliedFeesForCustomerBranchQuery, FetchAppliedFeesForCustomerBranchQueryVariables>;
export const FetchCustomerPricingDocument = gql`
    query FetchCustomerPricing($filter: ResourcePricingFiltersInput) {
  resourcePricings(filter: $filter) {
    id
    resourceType
    resourceId
    pocEmail
  }
}
    `;

/**
 * __useFetchCustomerPricingQuery__
 *
 * To run a query within a React component, call `useFetchCustomerPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomerPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomerPricingQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchCustomerPricingQuery(baseOptions?: Apollo.QueryHookOptions<FetchCustomerPricingQuery, FetchCustomerPricingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomerPricingQuery, FetchCustomerPricingQueryVariables>(FetchCustomerPricingDocument, options);
      }
export function useFetchCustomerPricingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomerPricingQuery, FetchCustomerPricingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomerPricingQuery, FetchCustomerPricingQueryVariables>(FetchCustomerPricingDocument, options);
        }
export type FetchCustomerPricingQueryHookResult = ReturnType<typeof useFetchCustomerPricingQuery>;
export type FetchCustomerPricingLazyQueryHookResult = ReturnType<typeof useFetchCustomerPricingLazyQuery>;
export type FetchCustomerPricingQueryResult = Apollo.QueryResult<FetchCustomerPricingQuery, FetchCustomerPricingQueryVariables>;
export const FetchCustomerPricingConfigurationDocument = gql`
    query FetchCustomerPricingConfiguration($id: ID!, $filter: ResourcePricingFilter) {
  resourcePricing(id: $id, filter: $filter) {
    id
    discountUnit
    discount
    priceConfigurations {
      id
      pricing {
        id
        hubId
        supplierId
        marketId
        terminalId
        productId
        rateType {
          name
        }
        price
        effectiveStartTimestamp
        effectiveEndTimestamp
      }
      calculatedFees
      calculatedTaxes
      calculatedMargins
      calculatedDiscount
      totalPrice
    }
  }
}
    `;

/**
 * __useFetchCustomerPricingConfigurationQuery__
 *
 * To run a query within a React component, call `useFetchCustomerPricingConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomerPricingConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomerPricingConfigurationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchCustomerPricingConfigurationQuery(baseOptions: Apollo.QueryHookOptions<FetchCustomerPricingConfigurationQuery, FetchCustomerPricingConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomerPricingConfigurationQuery, FetchCustomerPricingConfigurationQueryVariables>(FetchCustomerPricingConfigurationDocument, options);
      }
export function useFetchCustomerPricingConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomerPricingConfigurationQuery, FetchCustomerPricingConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomerPricingConfigurationQuery, FetchCustomerPricingConfigurationQueryVariables>(FetchCustomerPricingConfigurationDocument, options);
        }
export type FetchCustomerPricingConfigurationQueryHookResult = ReturnType<typeof useFetchCustomerPricingConfigurationQuery>;
export type FetchCustomerPricingConfigurationLazyQueryHookResult = ReturnType<typeof useFetchCustomerPricingConfigurationLazyQuery>;
export type FetchCustomerPricingConfigurationQueryResult = Apollo.QueryResult<FetchCustomerPricingConfigurationQuery, FetchCustomerPricingConfigurationQueryVariables>;
export const FetchCustomerPricingPopOverDetailsDocument = gql`
    query FetchCustomerPricingPopOverDetails($customerId: ID!, $resourceId: ID!) {
  resourcePricing(id: $resourceId) {
    ...ResourcePricingPopOverFragment
  }
  customer(id: $customerId) {
    id
    name
    marketResources {
      market {
        name
      }
    }
    applicableFees {
      fee {
        name
      }
    }
  }
}
    ${ResourcePricingPopOverFragmentFragmentDoc}`;

/**
 * __useFetchCustomerPricingPopOverDetailsQuery__
 *
 * To run a query within a React component, call `useFetchCustomerPricingPopOverDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomerPricingPopOverDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomerPricingPopOverDetailsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useFetchCustomerPricingPopOverDetailsQuery(baseOptions: Apollo.QueryHookOptions<FetchCustomerPricingPopOverDetailsQuery, FetchCustomerPricingPopOverDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomerPricingPopOverDetailsQuery, FetchCustomerPricingPopOverDetailsQueryVariables>(FetchCustomerPricingPopOverDetailsDocument, options);
      }
export function useFetchCustomerPricingPopOverDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomerPricingPopOverDetailsQuery, FetchCustomerPricingPopOverDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomerPricingPopOverDetailsQuery, FetchCustomerPricingPopOverDetailsQueryVariables>(FetchCustomerPricingPopOverDetailsDocument, options);
        }
export type FetchCustomerPricingPopOverDetailsQueryHookResult = ReturnType<typeof useFetchCustomerPricingPopOverDetailsQuery>;
export type FetchCustomerPricingPopOverDetailsLazyQueryHookResult = ReturnType<typeof useFetchCustomerPricingPopOverDetailsLazyQuery>;
export type FetchCustomerPricingPopOverDetailsQueryResult = Apollo.QueryResult<FetchCustomerPricingPopOverDetailsQuery, FetchCustomerPricingPopOverDetailsQueryVariables>;
export const FetchFilteredCustomerBranchForDropDownDocument = gql`
    query FetchFilteredCustomerBranchForDropDown($filter: CustomerBranchFilter, $limit: Int, $offset: Int, $sorter: [CustomerBranchSorter!]) {
  filteredCustomerBranches(
    filter: $filter
    sorter: $sorter
    limit: $limit
    offset: $offset
  ) {
    collection {
      id
      name
      erpId
    }
    metadata {
      hasMore
    }
  }
}
    `;

/**
 * __useFetchFilteredCustomerBranchForDropDownQuery__
 *
 * To run a query within a React component, call `useFetchFilteredCustomerBranchForDropDownQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredCustomerBranchForDropDownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredCustomerBranchForDropDownQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchFilteredCustomerBranchForDropDownQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredCustomerBranchForDropDownQuery, FetchFilteredCustomerBranchForDropDownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredCustomerBranchForDropDownQuery, FetchFilteredCustomerBranchForDropDownQueryVariables>(FetchFilteredCustomerBranchForDropDownDocument, options);
      }
export function useFetchFilteredCustomerBranchForDropDownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredCustomerBranchForDropDownQuery, FetchFilteredCustomerBranchForDropDownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredCustomerBranchForDropDownQuery, FetchFilteredCustomerBranchForDropDownQueryVariables>(FetchFilteredCustomerBranchForDropDownDocument, options);
        }
export type FetchFilteredCustomerBranchForDropDownQueryHookResult = ReturnType<typeof useFetchFilteredCustomerBranchForDropDownQuery>;
export type FetchFilteredCustomerBranchForDropDownLazyQueryHookResult = ReturnType<typeof useFetchFilteredCustomerBranchForDropDownLazyQuery>;
export type FetchFilteredCustomerBranchForDropDownQueryResult = Apollo.QueryResult<FetchFilteredCustomerBranchForDropDownQuery, FetchFilteredCustomerBranchForDropDownQueryVariables>;
export const FetchFilteredCustomersForDropDownDocument = gql`
    query FetchFilteredCustomersForDropDown($sorter: [BaseSorter!], $perPage: Int, $offSet: Int, $searchText: String) {
  filteredCustomers(
    limit: $perPage
    offset: $offSet
    sorter: $sorter
    filter: {name: $searchText}
  ) {
    collection {
      id
      name
      erpId
    }
    metadata {
      hasMore
    }
  }
}
    `;

/**
 * __useFetchFilteredCustomersForDropDownQuery__
 *
 * To run a query within a React component, call `useFetchFilteredCustomersForDropDownQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredCustomersForDropDownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredCustomersForDropDownQuery({
 *   variables: {
 *      sorter: // value for 'sorter'
 *      perPage: // value for 'perPage'
 *      offSet: // value for 'offSet'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useFetchFilteredCustomersForDropDownQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredCustomersForDropDownQuery, FetchFilteredCustomersForDropDownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredCustomersForDropDownQuery, FetchFilteredCustomersForDropDownQueryVariables>(FetchFilteredCustomersForDropDownDocument, options);
      }
export function useFetchFilteredCustomersForDropDownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredCustomersForDropDownQuery, FetchFilteredCustomersForDropDownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredCustomersForDropDownQuery, FetchFilteredCustomersForDropDownQueryVariables>(FetchFilteredCustomersForDropDownDocument, options);
        }
export type FetchFilteredCustomersForDropDownQueryHookResult = ReturnType<typeof useFetchFilteredCustomersForDropDownQuery>;
export type FetchFilteredCustomersForDropDownLazyQueryHookResult = ReturnType<typeof useFetchFilteredCustomersForDropDownLazyQuery>;
export type FetchFilteredCustomersForDropDownQueryResult = Apollo.QueryResult<FetchFilteredCustomersForDropDownQuery, FetchFilteredCustomersForDropDownQueryVariables>;
export const FetchFilteredDriverRatesDocument = gql`
    query FetchFilteredDriverRates($limit: Int, $offset: Int, $all: String) {
  filteredDriverRates(limit: $limit, offset: $offset, filter: {all: $all}) {
    collection {
      id
      customerBranch {
        id
        name
        customer {
          id
          name
        }
      }
      rate
      terminal {
        id
        name
      }
    }
    metadata {
      hasMore
      totalCount
    }
  }
}
    `;

/**
 * __useFetchFilteredDriverRatesQuery__
 *
 * To run a query within a React component, call `useFetchFilteredDriverRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredDriverRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredDriverRatesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      all: // value for 'all'
 *   },
 * });
 */
export function useFetchFilteredDriverRatesQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredDriverRatesQuery, FetchFilteredDriverRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredDriverRatesQuery, FetchFilteredDriverRatesQueryVariables>(FetchFilteredDriverRatesDocument, options);
      }
export function useFetchFilteredDriverRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredDriverRatesQuery, FetchFilteredDriverRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredDriverRatesQuery, FetchFilteredDriverRatesQueryVariables>(FetchFilteredDriverRatesDocument, options);
        }
export type FetchFilteredDriverRatesQueryHookResult = ReturnType<typeof useFetchFilteredDriverRatesQuery>;
export type FetchFilteredDriverRatesLazyQueryHookResult = ReturnType<typeof useFetchFilteredDriverRatesLazyQuery>;
export type FetchFilteredDriverRatesQueryResult = Apollo.QueryResult<FetchFilteredDriverRatesQuery, FetchFilteredDriverRatesQueryVariables>;
export const MarginFiltersDocument = gql`
    query MarginFilters {
  filteredMargins {
    collection {
      id
      name
      marginRate
      marginType
      marginUnit
      range {
        endRange
        rangeRate
        startRange
      }
    }
  }
}
    `;

/**
 * __useMarginFiltersQuery__
 *
 * To run a query within a React component, call `useMarginFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarginFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarginFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarginFiltersQuery(baseOptions?: Apollo.QueryHookOptions<MarginFiltersQuery, MarginFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarginFiltersQuery, MarginFiltersQueryVariables>(MarginFiltersDocument, options);
      }
export function useMarginFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarginFiltersQuery, MarginFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarginFiltersQuery, MarginFiltersQueryVariables>(MarginFiltersDocument, options);
        }
export type MarginFiltersQueryHookResult = ReturnType<typeof useMarginFiltersQuery>;
export type MarginFiltersLazyQueryHookResult = ReturnType<typeof useMarginFiltersLazyQuery>;
export type MarginFiltersQueryResult = Apollo.QueryResult<MarginFiltersQuery, MarginFiltersQueryVariables>;
export const FetchFilteredPricingsDocument = gql`
    query FetchFilteredPricings($rateTypeId: ID!, $productIds: [ID!]!) {
  filteredPricings(filter: {productIds: $productIds, rateTypeId: $rateTypeId}) {
    id
    hubId
    supplierId
    marketId
    productId
    terminalId
    effectiveStartTimestamp
    effectiveEndTimestamp
  }
}
    `;

/**
 * __useFetchFilteredPricingsQuery__
 *
 * To run a query within a React component, call `useFetchFilteredPricingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredPricingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredPricingsQuery({
 *   variables: {
 *      rateTypeId: // value for 'rateTypeId'
 *      productIds: // value for 'productIds'
 *   },
 * });
 */
export function useFetchFilteredPricingsQuery(baseOptions: Apollo.QueryHookOptions<FetchFilteredPricingsQuery, FetchFilteredPricingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredPricingsQuery, FetchFilteredPricingsQueryVariables>(FetchFilteredPricingsDocument, options);
      }
export function useFetchFilteredPricingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredPricingsQuery, FetchFilteredPricingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredPricingsQuery, FetchFilteredPricingsQueryVariables>(FetchFilteredPricingsDocument, options);
        }
export type FetchFilteredPricingsQueryHookResult = ReturnType<typeof useFetchFilteredPricingsQuery>;
export type FetchFilteredPricingsLazyQueryHookResult = ReturnType<typeof useFetchFilteredPricingsLazyQuery>;
export type FetchFilteredPricingsQueryResult = Apollo.QueryResult<FetchFilteredPricingsQuery, FetchFilteredPricingsQueryVariables>;
export const FetchFilteredResourcePricingsDocument = gql`
    query FetchFilteredResourcePricings($filter: ResourcePricingFiltersInput) {
  resourcePricings(filter: $filter) {
    id
    resourceType
    resourceId
    applicableTaxes {
      id
      tax {
        id
        name
      }
    }
    applicableMargins {
      id
      margin {
        id
        name
      }
    }
    pocEmail
    __typename
  }
}
    `;

/**
 * __useFetchFilteredResourcePricingsQuery__
 *
 * To run a query within a React component, call `useFetchFilteredResourcePricingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredResourcePricingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredResourcePricingsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchFilteredResourcePricingsQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredResourcePricingsQuery, FetchFilteredResourcePricingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredResourcePricingsQuery, FetchFilteredResourcePricingsQueryVariables>(FetchFilteredResourcePricingsDocument, options);
      }
export function useFetchFilteredResourcePricingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredResourcePricingsQuery, FetchFilteredResourcePricingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredResourcePricingsQuery, FetchFilteredResourcePricingsQueryVariables>(FetchFilteredResourcePricingsDocument, options);
        }
export type FetchFilteredResourcePricingsQueryHookResult = ReturnType<typeof useFetchFilteredResourcePricingsQuery>;
export type FetchFilteredResourcePricingsLazyQueryHookResult = ReturnType<typeof useFetchFilteredResourcePricingsLazyQuery>;
export type FetchFilteredResourcePricingsQueryResult = Apollo.QueryResult<FetchFilteredResourcePricingsQuery, FetchFilteredResourcePricingsQueryVariables>;
export const TaxFiltersDocument = gql`
    query TaxFilters {
  filteredTaxes {
    collection {
      id
      name
      rateInPercent
      rateType
      rateInCurrency
      marketId
      productCategoryId
      calculationType
      glCode
      productCategoryResources {
        id
        productCategory {
          id
          name
        }
      }
      erpId
      description
      productTaxes {
        id
        productId
      }
    }
  }
}
    `;

/**
 * __useTaxFiltersQuery__
 *
 * To run a query within a React component, call `useTaxFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaxFiltersQuery(baseOptions?: Apollo.QueryHookOptions<TaxFiltersQuery, TaxFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxFiltersQuery, TaxFiltersQueryVariables>(TaxFiltersDocument, options);
      }
export function useTaxFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxFiltersQuery, TaxFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxFiltersQuery, TaxFiltersQueryVariables>(TaxFiltersDocument, options);
        }
export type TaxFiltersQueryHookResult = ReturnType<typeof useTaxFiltersQuery>;
export type TaxFiltersLazyQueryHookResult = ReturnType<typeof useTaxFiltersLazyQuery>;
export type TaxFiltersQueryResult = Apollo.QueryResult<TaxFiltersQuery, TaxFiltersQueryVariables>;
export const FetchFilteredTerminalsForDropDownDocument = gql`
    query FetchFilteredTerminalsForDropDown($limit: Int, $offset: Int, $all: String, $isWarehouse: Boolean, $sorter: [TerminalSorter!]) {
  filteredTerminals(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {all: $all, isWarehouse: $isWarehouse, active: true}
  ) {
    collection {
      id
      name
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFetchFilteredTerminalsForDropDownQuery__
 *
 * To run a query within a React component, call `useFetchFilteredTerminalsForDropDownQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredTerminalsForDropDownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredTerminalsForDropDownQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      all: // value for 'all'
 *      isWarehouse: // value for 'isWarehouse'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchFilteredTerminalsForDropDownQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredTerminalsForDropDownQuery, FetchFilteredTerminalsForDropDownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredTerminalsForDropDownQuery, FetchFilteredTerminalsForDropDownQueryVariables>(FetchFilteredTerminalsForDropDownDocument, options);
      }
export function useFetchFilteredTerminalsForDropDownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredTerminalsForDropDownQuery, FetchFilteredTerminalsForDropDownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredTerminalsForDropDownQuery, FetchFilteredTerminalsForDropDownQueryVariables>(FetchFilteredTerminalsForDropDownDocument, options);
        }
export type FetchFilteredTerminalsForDropDownQueryHookResult = ReturnType<typeof useFetchFilteredTerminalsForDropDownQuery>;
export type FetchFilteredTerminalsForDropDownLazyQueryHookResult = ReturnType<typeof useFetchFilteredTerminalsForDropDownLazyQuery>;
export type FetchFilteredTerminalsForDropDownQueryResult = Apollo.QueryResult<FetchFilteredTerminalsForDropDownQuery, FetchFilteredTerminalsForDropDownQueryVariables>;
export const MarginDocument = gql`
    query Margin($id: ID!) {
  margin(id: $id) {
    id
    name
    marginRate
    marginType
    marginUnit
    range {
      endRange
      rangeRate
      startRange
    }
  }
}
    `;

/**
 * __useMarginQuery__
 *
 * To run a query within a React component, call `useMarginQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarginQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarginQuery(baseOptions: Apollo.QueryHookOptions<MarginQuery, MarginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarginQuery, MarginQueryVariables>(MarginDocument, options);
      }
export function useMarginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarginQuery, MarginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarginQuery, MarginQueryVariables>(MarginDocument, options);
        }
export type MarginQueryHookResult = ReturnType<typeof useMarginQuery>;
export type MarginLazyQueryHookResult = ReturnType<typeof useMarginLazyQuery>;
export type MarginQueryResult = Apollo.QueryResult<MarginQuery, MarginQueryVariables>;
export const FetchMarketDocument = gql`
    query FetchMarket {
  markets {
    id
    name
    address
    active
    hubResources {
      id
      hub {
        id
        name
        address
      }
    }
  }
}
    `;

/**
 * __useFetchMarketQuery__
 *
 * To run a query within a React component, call `useFetchMarketQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMarketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMarketQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchMarketQuery(baseOptions?: Apollo.QueryHookOptions<FetchMarketQuery, FetchMarketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchMarketQuery, FetchMarketQueryVariables>(FetchMarketDocument, options);
      }
export function useFetchMarketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchMarketQuery, FetchMarketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchMarketQuery, FetchMarketQueryVariables>(FetchMarketDocument, options);
        }
export type FetchMarketQueryHookResult = ReturnType<typeof useFetchMarketQuery>;
export type FetchMarketLazyQueryHookResult = ReturnType<typeof useFetchMarketLazyQuery>;
export type FetchMarketQueryResult = Apollo.QueryResult<FetchMarketQuery, FetchMarketQueryVariables>;
export const MarketDocument = gql`
    query Market($id: ID!) {
  market(id: $id) {
    id
    name
    address
    active
    hubResources {
      id
      hub {
        id
        name
        address
      }
    }
  }
}
    `;

/**
 * __useMarketQuery__
 *
 * To run a query within a React component, call `useMarketQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarketQuery(baseOptions: Apollo.QueryHookOptions<MarketQuery, MarketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketQuery, MarketQueryVariables>(MarketDocument, options);
      }
export function useMarketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketQuery, MarketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketQuery, MarketQueryVariables>(MarketDocument, options);
        }
export type MarketQueryHookResult = ReturnType<typeof useMarketQuery>;
export type MarketLazyQueryHookResult = ReturnType<typeof useMarketLazyQuery>;
export type MarketQueryResult = Apollo.QueryResult<MarketQuery, MarketQueryVariables>;
export const FetchMarketsForPricingFormDocument = gql`
    query FetchMarketsForPricingForm {
  markets {
    id
    name
  }
}
    `;

/**
 * __useFetchMarketsForPricingFormQuery__
 *
 * To run a query within a React component, call `useFetchMarketsForPricingFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMarketsForPricingFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMarketsForPricingFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchMarketsForPricingFormQuery(baseOptions?: Apollo.QueryHookOptions<FetchMarketsForPricingFormQuery, FetchMarketsForPricingFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchMarketsForPricingFormQuery, FetchMarketsForPricingFormQueryVariables>(FetchMarketsForPricingFormDocument, options);
      }
export function useFetchMarketsForPricingFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchMarketsForPricingFormQuery, FetchMarketsForPricingFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchMarketsForPricingFormQuery, FetchMarketsForPricingFormQueryVariables>(FetchMarketsForPricingFormDocument, options);
        }
export type FetchMarketsForPricingFormQueryHookResult = ReturnType<typeof useFetchMarketsForPricingFormQuery>;
export type FetchMarketsForPricingFormLazyQueryHookResult = ReturnType<typeof useFetchMarketsForPricingFormLazyQuery>;
export type FetchMarketsForPricingFormQueryResult = Apollo.QueryResult<FetchMarketsForPricingFormQuery, FetchMarketsForPricingFormQueryVariables>;
export const ProductCategoryProductIdsDocument = gql`
    query ProductCategoryProductIds($filter: ProductFilter) {
  filteredProducts(filter: $filter) {
    collection {
      id
      name
      active
    }
  }
}
    `;

/**
 * __useProductCategoryProductIdsQuery__
 *
 * To run a query within a React component, call `useProductCategoryProductIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCategoryProductIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCategoryProductIdsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProductCategoryProductIdsQuery(baseOptions?: Apollo.QueryHookOptions<ProductCategoryProductIdsQuery, ProductCategoryProductIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductCategoryProductIdsQuery, ProductCategoryProductIdsQueryVariables>(ProductCategoryProductIdsDocument, options);
      }
export function useProductCategoryProductIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductCategoryProductIdsQuery, ProductCategoryProductIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductCategoryProductIdsQuery, ProductCategoryProductIdsQueryVariables>(ProductCategoryProductIdsDocument, options);
        }
export type ProductCategoryProductIdsQueryHookResult = ReturnType<typeof useProductCategoryProductIdsQuery>;
export type ProductCategoryProductIdsLazyQueryHookResult = ReturnType<typeof useProductCategoryProductIdsLazyQuery>;
export type ProductCategoryProductIdsQueryResult = Apollo.QueryResult<ProductCategoryProductIdsQuery, ProductCategoryProductIdsQueryVariables>;
export const FetchProductForDropDownDocument = gql`
    query FetchProductForDropDown($customFilter: ProductFilter, $limit: Int, $offset: Int) {
  filteredProducts(filter: $customFilter, limit: $limit, offset: $offset) {
    collection {
      id
      name
      active
    }
    metadata {
      hasMore
    }
  }
}
    `;

/**
 * __useFetchProductForDropDownQuery__
 *
 * To run a query within a React component, call `useFetchProductForDropDownQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductForDropDownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductForDropDownQuery({
 *   variables: {
 *      customFilter: // value for 'customFilter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFetchProductForDropDownQuery(baseOptions?: Apollo.QueryHookOptions<FetchProductForDropDownQuery, FetchProductForDropDownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchProductForDropDownQuery, FetchProductForDropDownQueryVariables>(FetchProductForDropDownDocument, options);
      }
export function useFetchProductForDropDownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchProductForDropDownQuery, FetchProductForDropDownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchProductForDropDownQuery, FetchProductForDropDownQueryVariables>(FetchProductForDropDownDocument, options);
        }
export type FetchProductForDropDownQueryHookResult = ReturnType<typeof useFetchProductForDropDownQuery>;
export type FetchProductForDropDownLazyQueryHookResult = ReturnType<typeof useFetchProductForDropDownLazyQuery>;
export type FetchProductForDropDownQueryResult = Apollo.QueryResult<FetchProductForDropDownQuery, FetchProductForDropDownQueryVariables>;
export const FetchProductForTaxFormDocument = gql`
    query FetchProductForTaxForm($customFilter: ProductFilter = {}) {
  filteredProducts(filter: $customFilter) {
    collection {
      name
      id
      active
    }
  }
}
    `;

/**
 * __useFetchProductForTaxFormQuery__
 *
 * To run a query within a React component, call `useFetchProductForTaxFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductForTaxFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductForTaxFormQuery({
 *   variables: {
 *      customFilter: // value for 'customFilter'
 *   },
 * });
 */
export function useFetchProductForTaxFormQuery(baseOptions?: Apollo.QueryHookOptions<FetchProductForTaxFormQuery, FetchProductForTaxFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchProductForTaxFormQuery, FetchProductForTaxFormQueryVariables>(FetchProductForTaxFormDocument, options);
      }
export function useFetchProductForTaxFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchProductForTaxFormQuery, FetchProductForTaxFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchProductForTaxFormQuery, FetchProductForTaxFormQueryVariables>(FetchProductForTaxFormDocument, options);
        }
export type FetchProductForTaxFormQueryHookResult = ReturnType<typeof useFetchProductForTaxFormQuery>;
export type FetchProductForTaxFormLazyQueryHookResult = ReturnType<typeof useFetchProductForTaxFormLazyQuery>;
export type FetchProductForTaxFormQueryResult = Apollo.QueryResult<FetchProductForTaxFormQuery, FetchProductForTaxFormQueryVariables>;
export const FetchRateTypeDocument = gql`
    query FetchRateType($id: ID!) {
  rateType(id: $id) {
    id
    name
    description
    status
  }
}
    `;

/**
 * __useFetchRateTypeQuery__
 *
 * To run a query within a React component, call `useFetchRateTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRateTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRateTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchRateTypeQuery(baseOptions: Apollo.QueryHookOptions<FetchRateTypeQuery, FetchRateTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRateTypeQuery, FetchRateTypeQueryVariables>(FetchRateTypeDocument, options);
      }
export function useFetchRateTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRateTypeQuery, FetchRateTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRateTypeQuery, FetchRateTypeQueryVariables>(FetchRateTypeDocument, options);
        }
export type FetchRateTypeQueryHookResult = ReturnType<typeof useFetchRateTypeQuery>;
export type FetchRateTypeLazyQueryHookResult = ReturnType<typeof useFetchRateTypeLazyQuery>;
export type FetchRateTypeQueryResult = Apollo.QueryResult<FetchRateTypeQuery, FetchRateTypeQueryVariables>;
export const FetchRateTypesDocument = gql`
    query FetchRateTypes($filter: FiltersInput) {
  rateTypes(filter: $filter) {
    id
    name
    status
    description
  }
}
    `;

/**
 * __useFetchRateTypesQuery__
 *
 * To run a query within a React component, call `useFetchRateTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRateTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRateTypesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchRateTypesQuery(baseOptions?: Apollo.QueryHookOptions<FetchRateTypesQuery, FetchRateTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRateTypesQuery, FetchRateTypesQueryVariables>(FetchRateTypesDocument, options);
      }
export function useFetchRateTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRateTypesQuery, FetchRateTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRateTypesQuery, FetchRateTypesQueryVariables>(FetchRateTypesDocument, options);
        }
export type FetchRateTypesQueryHookResult = ReturnType<typeof useFetchRateTypesQuery>;
export type FetchRateTypesLazyQueryHookResult = ReturnType<typeof useFetchRateTypesLazyQuery>;
export type FetchRateTypesQueryResult = Apollo.QueryResult<FetchRateTypesQuery, FetchRateTypesQueryVariables>;
export const FetchRawPricingImportSessionsDocument = gql`
    query FetchRawPricingImportSessions($limit: Int!, $offset: Int!, $sorter: [BaseSorter!]) {
  rawPricingImportSessions(limit: $limit, offset: $offset, sorter: $sorter) {
    collection {
      id
      state
      createdAt
      updatedAt
      state
      provider
      dataSource
      sourceDocument {
        blobFileUrlDownload
      }
      normalizedDocument {
        blobFileUrlDownload
      }
      errorDocument {
        blobFileUrlDownload
      }
      aliasMappings {
        id
        dataSource
        sourceValue
        mappableId
        mappableType
        mappable {
          ... on Product {
            id
            nullableName: name
          }
          ... on Market {
            id
            nullableName: name
          }
          ... on Supplier {
            id
            name
          }
          ... on RateType {
            id
            name
          }
        }
      }
    }
    metadata {
      hasMore
      totalCount
    }
  }
}
    `;

/**
 * __useFetchRawPricingImportSessionsQuery__
 *
 * To run a query within a React component, call `useFetchRawPricingImportSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRawPricingImportSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRawPricingImportSessionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchRawPricingImportSessionsQuery(baseOptions: Apollo.QueryHookOptions<FetchRawPricingImportSessionsQuery, FetchRawPricingImportSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRawPricingImportSessionsQuery, FetchRawPricingImportSessionsQueryVariables>(FetchRawPricingImportSessionsDocument, options);
      }
export function useFetchRawPricingImportSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRawPricingImportSessionsQuery, FetchRawPricingImportSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRawPricingImportSessionsQuery, FetchRawPricingImportSessionsQueryVariables>(FetchRawPricingImportSessionsDocument, options);
        }
export type FetchRawPricingImportSessionsQueryHookResult = ReturnType<typeof useFetchRawPricingImportSessionsQuery>;
export type FetchRawPricingImportSessionsLazyQueryHookResult = ReturnType<typeof useFetchRawPricingImportSessionsLazyQuery>;
export type FetchRawPricingImportSessionsQueryResult = Apollo.QueryResult<FetchRawPricingImportSessionsQuery, FetchRawPricingImportSessionsQueryVariables>;
export const FetchResourceNamesDocument = gql`
    query FetchResourceNames($ids: [ID!]!, $resource: ResourceFetchEnum!) {
  fetchResourceNames(ids: $ids, resource: $resource)
}
    `;

/**
 * __useFetchResourceNamesQuery__
 *
 * To run a query within a React component, call `useFetchResourceNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchResourceNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchResourceNamesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      resource: // value for 'resource'
 *   },
 * });
 */
export function useFetchResourceNamesQuery(baseOptions: Apollo.QueryHookOptions<FetchResourceNamesQuery, FetchResourceNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchResourceNamesQuery, FetchResourceNamesQueryVariables>(FetchResourceNamesDocument, options);
      }
export function useFetchResourceNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchResourceNamesQuery, FetchResourceNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchResourceNamesQuery, FetchResourceNamesQueryVariables>(FetchResourceNamesDocument, options);
        }
export type FetchResourceNamesQueryHookResult = ReturnType<typeof useFetchResourceNamesQuery>;
export type FetchResourceNamesLazyQueryHookResult = ReturnType<typeof useFetchResourceNamesLazyQuery>;
export type FetchResourceNamesQueryResult = Apollo.QueryResult<FetchResourceNamesQuery, FetchResourceNamesQueryVariables>;
export const FetchResourcePricingDetailDocument = gql`
    query FetchResourcePricingDetail($id: ID!) {
  resourcePricing(id: $id) {
    id
    discountUnit
    discount
    marginsProducts {
      id
      productId
      margin {
        id
      }
    }
    productCategoryResources {
      id
      productCategory {
        id
        name
      }
    }
    rateType {
      id
    }
    resourceId
    resourceType
    priceConfigurations {
      id
      pricing {
        id
        hubId
        supplierId
        marketId
        productId
      }
    }
    applicableMargins {
      id
      margin {
        id
        name
      }
    }
    applicableTaxes {
      id
      tax {
        id
        name
        erpId
      }
      parentTaxId
    }
    pocName
    pocEmail
    pocPhone
  }
}
    `;

/**
 * __useFetchResourcePricingDetailQuery__
 *
 * To run a query within a React component, call `useFetchResourcePricingDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchResourcePricingDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchResourcePricingDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchResourcePricingDetailQuery(baseOptions: Apollo.QueryHookOptions<FetchResourcePricingDetailQuery, FetchResourcePricingDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchResourcePricingDetailQuery, FetchResourcePricingDetailQueryVariables>(FetchResourcePricingDetailDocument, options);
      }
export function useFetchResourcePricingDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchResourcePricingDetailQuery, FetchResourcePricingDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchResourcePricingDetailQuery, FetchResourcePricingDetailQueryVariables>(FetchResourcePricingDetailDocument, options);
        }
export type FetchResourcePricingDetailQueryHookResult = ReturnType<typeof useFetchResourcePricingDetailQuery>;
export type FetchResourcePricingDetailLazyQueryHookResult = ReturnType<typeof useFetchResourcePricingDetailLazyQuery>;
export type FetchResourcePricingDetailQueryResult = Apollo.QueryResult<FetchResourcePricingDetailQuery, FetchResourcePricingDetailQueryVariables>;
export const FetchResourcePricingHistoryDocument = gql`
    query FetchResourcePricingHistory($resourcePricingId: ID!) {
  pricingHistory(resourcePricingId: $resourcePricingId) {
    id
    historableName
    historableType
    userName
    effectiveToTimestamp
    effectiveFromTimestamp
    resourcePricing {
      id
    }
    status
  }
}
    `;

/**
 * __useFetchResourcePricingHistoryQuery__
 *
 * To run a query within a React component, call `useFetchResourcePricingHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchResourcePricingHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchResourcePricingHistoryQuery({
 *   variables: {
 *      resourcePricingId: // value for 'resourcePricingId'
 *   },
 * });
 */
export function useFetchResourcePricingHistoryQuery(baseOptions: Apollo.QueryHookOptions<FetchResourcePricingHistoryQuery, FetchResourcePricingHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchResourcePricingHistoryQuery, FetchResourcePricingHistoryQueryVariables>(FetchResourcePricingHistoryDocument, options);
      }
export function useFetchResourcePricingHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchResourcePricingHistoryQuery, FetchResourcePricingHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchResourcePricingHistoryQuery, FetchResourcePricingHistoryQueryVariables>(FetchResourcePricingHistoryDocument, options);
        }
export type FetchResourcePricingHistoryQueryHookResult = ReturnType<typeof useFetchResourcePricingHistoryQuery>;
export type FetchResourcePricingHistoryLazyQueryHookResult = ReturnType<typeof useFetchResourcePricingHistoryLazyQuery>;
export type FetchResourcePricingHistoryQueryResult = Apollo.QueryResult<FetchResourcePricingHistoryQuery, FetchResourcePricingHistoryQueryVariables>;
export const FetchShipToPricingPopOverDetailsDocument = gql`
    query FetchShipToPricingPopOverDetails($customerBranchId: ID!, $resourceId: ID!) {
  resourcePricing(id: $resourceId) {
    ...ResourcePricingPopOverFragment
  }
  customerBranch(id: $customerBranchId) {
    id
    name
    customer {
      id
    }
    marketResources {
      market {
        name
      }
    }
    applicableFees {
      fee {
        name
      }
    }
  }
}
    ${ResourcePricingPopOverFragmentFragmentDoc}`;

/**
 * __useFetchShipToPricingPopOverDetailsQuery__
 *
 * To run a query within a React component, call `useFetchShipToPricingPopOverDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchShipToPricingPopOverDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchShipToPricingPopOverDetailsQuery({
 *   variables: {
 *      customerBranchId: // value for 'customerBranchId'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useFetchShipToPricingPopOverDetailsQuery(baseOptions: Apollo.QueryHookOptions<FetchShipToPricingPopOverDetailsQuery, FetchShipToPricingPopOverDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchShipToPricingPopOverDetailsQuery, FetchShipToPricingPopOverDetailsQueryVariables>(FetchShipToPricingPopOverDetailsDocument, options);
      }
export function useFetchShipToPricingPopOverDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchShipToPricingPopOverDetailsQuery, FetchShipToPricingPopOverDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchShipToPricingPopOverDetailsQuery, FetchShipToPricingPopOverDetailsQueryVariables>(FetchShipToPricingPopOverDetailsDocument, options);
        }
export type FetchShipToPricingPopOverDetailsQueryHookResult = ReturnType<typeof useFetchShipToPricingPopOverDetailsQuery>;
export type FetchShipToPricingPopOverDetailsLazyQueryHookResult = ReturnType<typeof useFetchShipToPricingPopOverDetailsLazyQuery>;
export type FetchShipToPricingPopOverDetailsQueryResult = Apollo.QueryResult<FetchShipToPricingPopOverDetailsQuery, FetchShipToPricingPopOverDetailsQueryVariables>;
export const FetchSuppliersForPricingFormDocument = gql`
    query FetchSuppliersForPricingForm($filter: SupplierFilter) {
  filteredSuppliers(filter: $filter) {
    collection {
      id
      name
    }
  }
}
    `;

/**
 * __useFetchSuppliersForPricingFormQuery__
 *
 * To run a query within a React component, call `useFetchSuppliersForPricingFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSuppliersForPricingFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSuppliersForPricingFormQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchSuppliersForPricingFormQuery(baseOptions?: Apollo.QueryHookOptions<FetchSuppliersForPricingFormQuery, FetchSuppliersForPricingFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSuppliersForPricingFormQuery, FetchSuppliersForPricingFormQueryVariables>(FetchSuppliersForPricingFormDocument, options);
      }
export function useFetchSuppliersForPricingFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSuppliersForPricingFormQuery, FetchSuppliersForPricingFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSuppliersForPricingFormQuery, FetchSuppliersForPricingFormQueryVariables>(FetchSuppliersForPricingFormDocument, options);
        }
export type FetchSuppliersForPricingFormQueryHookResult = ReturnType<typeof useFetchSuppliersForPricingFormQuery>;
export type FetchSuppliersForPricingFormLazyQueryHookResult = ReturnType<typeof useFetchSuppliersForPricingFormLazyQuery>;
export type FetchSuppliersForPricingFormQueryResult = Apollo.QueryResult<FetchSuppliersForPricingFormQuery, FetchSuppliersForPricingFormQueryVariables>;
export const TaxDocument = gql`
    query Tax($id: ID!) {
  tax(id: $id) {
    id
    name
    rateType
    rateInCurrency
    rateInPercent
    productCategoryId
    marketId
    erpId
    glCode
    description
    doNotRoundUpRate
    exempt
    amountType
    calculationType
    productCategoryResources {
      id
      productCategory {
        id
        name
      }
    }
    productTaxes {
      id
      pandaPriceTaxId
      productId
    }
    dateRangeAttribute {
      startRange
      endRange
      rangeRate
    }
  }
}
    `;

/**
 * __useTaxQuery__
 *
 * To run a query within a React component, call `useTaxQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaxQuery(baseOptions: Apollo.QueryHookOptions<TaxQuery, TaxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxQuery, TaxQueryVariables>(TaxDocument, options);
      }
export function useTaxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxQuery, TaxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxQuery, TaxQueryVariables>(TaxDocument, options);
        }
export type TaxQueryHookResult = ReturnType<typeof useTaxQuery>;
export type TaxLazyQueryHookResult = ReturnType<typeof useTaxLazyQuery>;
export type TaxQueryResult = Apollo.QueryResult<TaxQuery, TaxQueryVariables>;
export const FetchTodaysPricingDocument = gql`
    query FetchTodaysPricing($filter: PricingFilter) {
  todaysPricings(filter: $filter) {
    collection {
      id
      rateType {
        id
        name
      }
      productId
      supplierId
      terminalId
      hubId
      marketId
      price
      previousPrice
      effectiveEndTimestamp
      effectiveStartTimestamp
      createdAtTimestamp
    }
  }
}
    `;

/**
 * __useFetchTodaysPricingQuery__
 *
 * To run a query within a React component, call `useFetchTodaysPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTodaysPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTodaysPricingQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchTodaysPricingQuery(baseOptions?: Apollo.QueryHookOptions<FetchTodaysPricingQuery, FetchTodaysPricingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTodaysPricingQuery, FetchTodaysPricingQueryVariables>(FetchTodaysPricingDocument, options);
      }
export function useFetchTodaysPricingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTodaysPricingQuery, FetchTodaysPricingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTodaysPricingQuery, FetchTodaysPricingQueryVariables>(FetchTodaysPricingDocument, options);
        }
export type FetchTodaysPricingQueryHookResult = ReturnType<typeof useFetchTodaysPricingQuery>;
export type FetchTodaysPricingLazyQueryHookResult = ReturnType<typeof useFetchTodaysPricingLazyQuery>;
export type FetchTodaysPricingQueryResult = Apollo.QueryResult<FetchTodaysPricingQuery, FetchTodaysPricingQueryVariables>;
export const FilteredDataFetchLoggerDocument = gql`
    query FilteredDataFetchLogger($limit: Int!, $offset: Int!, $filter: DataFetchLoggerFilter, $sorter: [DataFetchLoggerSorter!]) {
  filteredDataFetchLogger(
    limit: $limit
    offset: $offset
    filter: $filter
    sorter: $sorter
  ) {
    collection {
      id
      createdAtTimestamp
    }
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useFilteredDataFetchLoggerQuery__
 *
 * To run a query within a React component, call `useFilteredDataFetchLoggerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredDataFetchLoggerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredDataFetchLoggerQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilteredDataFetchLoggerQuery(baseOptions: Apollo.QueryHookOptions<FilteredDataFetchLoggerQuery, FilteredDataFetchLoggerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredDataFetchLoggerQuery, FilteredDataFetchLoggerQueryVariables>(FilteredDataFetchLoggerDocument, options);
      }
export function useFilteredDataFetchLoggerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredDataFetchLoggerQuery, FilteredDataFetchLoggerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredDataFetchLoggerQuery, FilteredDataFetchLoggerQueryVariables>(FilteredDataFetchLoggerDocument, options);
        }
export type FilteredDataFetchLoggerQueryHookResult = ReturnType<typeof useFilteredDataFetchLoggerQuery>;
export type FilteredDataFetchLoggerLazyQueryHookResult = ReturnType<typeof useFilteredDataFetchLoggerLazyQuery>;
export type FilteredDataFetchLoggerQueryResult = Apollo.QueryResult<FilteredDataFetchLoggerQuery, FilteredDataFetchLoggerQueryVariables>;
export const FilteredFeesForPricingFormDocument = gql`
    query FilteredFeesForPricingForm($filter: FeeFilter) {
  filteredFees(filter: $filter) {
    collection {
      id
      name
      applicableType
    }
  }
}
    `;

/**
 * __useFilteredFeesForPricingFormQuery__
 *
 * To run a query within a React component, call `useFilteredFeesForPricingFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredFeesForPricingFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredFeesForPricingFormQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFilteredFeesForPricingFormQuery(baseOptions?: Apollo.QueryHookOptions<FilteredFeesForPricingFormQuery, FilteredFeesForPricingFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredFeesForPricingFormQuery, FilteredFeesForPricingFormQueryVariables>(FilteredFeesForPricingFormDocument, options);
      }
export function useFilteredFeesForPricingFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredFeesForPricingFormQuery, FilteredFeesForPricingFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredFeesForPricingFormQuery, FilteredFeesForPricingFormQueryVariables>(FilteredFeesForPricingFormDocument, options);
        }
export type FilteredFeesForPricingFormQueryHookResult = ReturnType<typeof useFilteredFeesForPricingFormQuery>;
export type FilteredFeesForPricingFormLazyQueryHookResult = ReturnType<typeof useFilteredFeesForPricingFormLazyQuery>;
export type FilteredFeesForPricingFormQueryResult = Apollo.QueryResult<FilteredFeesForPricingFormQuery, FilteredFeesForPricingFormQueryVariables>;
export const FilteredMarginsForPricingFormDocument = gql`
    query FilteredMarginsForPricingForm {
  filteredMargins {
    collection {
      id
      name
    }
  }
}
    `;

/**
 * __useFilteredMarginsForPricingFormQuery__
 *
 * To run a query within a React component, call `useFilteredMarginsForPricingFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredMarginsForPricingFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredMarginsForPricingFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useFilteredMarginsForPricingFormQuery(baseOptions?: Apollo.QueryHookOptions<FilteredMarginsForPricingFormQuery, FilteredMarginsForPricingFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredMarginsForPricingFormQuery, FilteredMarginsForPricingFormQueryVariables>(FilteredMarginsForPricingFormDocument, options);
      }
export function useFilteredMarginsForPricingFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredMarginsForPricingFormQuery, FilteredMarginsForPricingFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredMarginsForPricingFormQuery, FilteredMarginsForPricingFormQueryVariables>(FilteredMarginsForPricingFormDocument, options);
        }
export type FilteredMarginsForPricingFormQueryHookResult = ReturnType<typeof useFilteredMarginsForPricingFormQuery>;
export type FilteredMarginsForPricingFormLazyQueryHookResult = ReturnType<typeof useFilteredMarginsForPricingFormLazyQuery>;
export type FilteredMarginsForPricingFormQueryResult = Apollo.QueryResult<FilteredMarginsForPricingFormQuery, FilteredMarginsForPricingFormQueryVariables>;
export const FilteredTaxesForPricingFormDocument = gql`
    query FilteredTaxesForPricingForm {
  filteredTaxes {
    collection {
      id
      name
      erpId
    }
  }
}
    `;

/**
 * __useFilteredTaxesForPricingFormQuery__
 *
 * To run a query within a React component, call `useFilteredTaxesForPricingFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredTaxesForPricingFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredTaxesForPricingFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useFilteredTaxesForPricingFormQuery(baseOptions?: Apollo.QueryHookOptions<FilteredTaxesForPricingFormQuery, FilteredTaxesForPricingFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredTaxesForPricingFormQuery, FilteredTaxesForPricingFormQueryVariables>(FilteredTaxesForPricingFormDocument, options);
      }
export function useFilteredTaxesForPricingFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredTaxesForPricingFormQuery, FilteredTaxesForPricingFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredTaxesForPricingFormQuery, FilteredTaxesForPricingFormQueryVariables>(FilteredTaxesForPricingFormDocument, options);
        }
export type FilteredTaxesForPricingFormQueryHookResult = ReturnType<typeof useFilteredTaxesForPricingFormQuery>;
export type FilteredTaxesForPricingFormLazyQueryHookResult = ReturnType<typeof useFilteredTaxesForPricingFormLazyQuery>;
export type FilteredTaxesForPricingFormQueryResult = Apollo.QueryResult<FilteredTaxesForPricingFormQuery, FilteredTaxesForPricingFormQueryVariables>;
export const FilteredTemporaryPricingCustomerBranchesDocument = gql`
    query FilteredTemporaryPricingCustomerBranches($customerId: ID!, $limit: Int, $offset: Int, $all: String) {
  filteredTemporaryPricingCustomerBranches(
    limit: $limit
    offset: $offset
    filter: {customerId: $customerId, all: $all}
  ) {
    metadata {
      totalCount
      hasMore
    }
    collection {
      id
      erpId
      name
      customer {
        id
        erpId
        name
      }
      site {
        id
        address
      }
    }
  }
}
    `;

/**
 * __useFilteredTemporaryPricingCustomerBranchesQuery__
 *
 * To run a query within a React component, call `useFilteredTemporaryPricingCustomerBranchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredTemporaryPricingCustomerBranchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredTemporaryPricingCustomerBranchesQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      all: // value for 'all'
 *   },
 * });
 */
export function useFilteredTemporaryPricingCustomerBranchesQuery(baseOptions: Apollo.QueryHookOptions<FilteredTemporaryPricingCustomerBranchesQuery, FilteredTemporaryPricingCustomerBranchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredTemporaryPricingCustomerBranchesQuery, FilteredTemporaryPricingCustomerBranchesQueryVariables>(FilteredTemporaryPricingCustomerBranchesDocument, options);
      }
export function useFilteredTemporaryPricingCustomerBranchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredTemporaryPricingCustomerBranchesQuery, FilteredTemporaryPricingCustomerBranchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredTemporaryPricingCustomerBranchesQuery, FilteredTemporaryPricingCustomerBranchesQueryVariables>(FilteredTemporaryPricingCustomerBranchesDocument, options);
        }
export type FilteredTemporaryPricingCustomerBranchesQueryHookResult = ReturnType<typeof useFilteredTemporaryPricingCustomerBranchesQuery>;
export type FilteredTemporaryPricingCustomerBranchesLazyQueryHookResult = ReturnType<typeof useFilteredTemporaryPricingCustomerBranchesLazyQuery>;
export type FilteredTemporaryPricingCustomerBranchesQueryResult = Apollo.QueryResult<FilteredTemporaryPricingCustomerBranchesQuery, FilteredTemporaryPricingCustomerBranchesQueryVariables>;
export const FilteredTemporaryPricingCustomersDocument = gql`
    query FilteredTemporaryPricingCustomers($limit: Int, $offset: Int, $all: String) {
  filteredTemporaryPricingCustomers(
    limit: $limit
    offset: $offset
    filter: {all: $all}
  ) {
    metadata {
      totalCount
      hasMore
    }
    collection {
      id
      erpId
      name
      site {
        id
        address
      }
    }
  }
}
    `;

/**
 * __useFilteredTemporaryPricingCustomersQuery__
 *
 * To run a query within a React component, call `useFilteredTemporaryPricingCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredTemporaryPricingCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredTemporaryPricingCustomersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      all: // value for 'all'
 *   },
 * });
 */
export function useFilteredTemporaryPricingCustomersQuery(baseOptions?: Apollo.QueryHookOptions<FilteredTemporaryPricingCustomersQuery, FilteredTemporaryPricingCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredTemporaryPricingCustomersQuery, FilteredTemporaryPricingCustomersQueryVariables>(FilteredTemporaryPricingCustomersDocument, options);
      }
export function useFilteredTemporaryPricingCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredTemporaryPricingCustomersQuery, FilteredTemporaryPricingCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredTemporaryPricingCustomersQuery, FilteredTemporaryPricingCustomersQueryVariables>(FilteredTemporaryPricingCustomersDocument, options);
        }
export type FilteredTemporaryPricingCustomersQueryHookResult = ReturnType<typeof useFilteredTemporaryPricingCustomersQuery>;
export type FilteredTemporaryPricingCustomersLazyQueryHookResult = ReturnType<typeof useFilteredTemporaryPricingCustomersLazyQuery>;
export type FilteredTemporaryPricingCustomersQueryResult = Apollo.QueryResult<FilteredTemporaryPricingCustomersQuery, FilteredTemporaryPricingCustomersQueryVariables>;
export const FilteredTemporaryPricingsDocument = gql`
    query FilteredTemporaryPricings($customerBranchId: ID!) {
  filteredTemporaryPricings(filter: {customerBranchId: $customerBranchId}) {
    id
    productId
    price
    markup
    freight
    taxes
    isTemporary
    customerBranchId
    expirationDatetimeTimestamp
    effectiveStartTimestamp
    effectiveEndTimestamp
  }
}
    `;

/**
 * __useFilteredTemporaryPricingsQuery__
 *
 * To run a query within a React component, call `useFilteredTemporaryPricingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredTemporaryPricingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredTemporaryPricingsQuery({
 *   variables: {
 *      customerBranchId: // value for 'customerBranchId'
 *   },
 * });
 */
export function useFilteredTemporaryPricingsQuery(baseOptions: Apollo.QueryHookOptions<FilteredTemporaryPricingsQuery, FilteredTemporaryPricingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredTemporaryPricingsQuery, FilteredTemporaryPricingsQueryVariables>(FilteredTemporaryPricingsDocument, options);
      }
export function useFilteredTemporaryPricingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredTemporaryPricingsQuery, FilteredTemporaryPricingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredTemporaryPricingsQuery, FilteredTemporaryPricingsQueryVariables>(FilteredTemporaryPricingsDocument, options);
        }
export type FilteredTemporaryPricingsQueryHookResult = ReturnType<typeof useFilteredTemporaryPricingsQuery>;
export type FilteredTemporaryPricingsLazyQueryHookResult = ReturnType<typeof useFilteredTemporaryPricingsLazyQuery>;
export type FilteredTemporaryPricingsQueryResult = Apollo.QueryResult<FilteredTemporaryPricingsQuery, FilteredTemporaryPricingsQueryVariables>;
export const ImportRecordsDocument = gql`
    mutation ImportRecords($input: ImportRecordsInput!) {
  importRecords(input: $input) {
    dataImport {
      id
    }
    pandaDocument {
      id
    }
  }
}
    `;
export type ImportRecordsMutationFn = Apollo.MutationFunction<ImportRecordsMutation, ImportRecordsMutationVariables>;

/**
 * __useImportRecordsMutation__
 *
 * To run a mutation, you first call `useImportRecordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportRecordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importRecordsMutation, { data, loading, error }] = useImportRecordsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportRecordsMutation(baseOptions?: Apollo.MutationHookOptions<ImportRecordsMutation, ImportRecordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportRecordsMutation, ImportRecordsMutationVariables>(ImportRecordsDocument, options);
      }
export type ImportRecordsMutationHookResult = ReturnType<typeof useImportRecordsMutation>;
export type ImportRecordsMutationResult = Apollo.MutationResult<ImportRecordsMutation>;
export type ImportRecordsMutationOptions = Apollo.BaseMutationOptions<ImportRecordsMutation, ImportRecordsMutationVariables>;
export const ImportTemporaryPricingRecordsDocument = gql`
    mutation ImportTemporaryPricingRecords($input: ImportRecordsInput!) {
  importRecords(input: $input) {
    pandaDocument {
      id
    }
    dataImport {
      id
      status
      errorFileUrl
      filename
      createdAtTimestamp
    }
  }
}
    `;
export type ImportTemporaryPricingRecordsMutationFn = Apollo.MutationFunction<ImportTemporaryPricingRecordsMutation, ImportTemporaryPricingRecordsMutationVariables>;

/**
 * __useImportTemporaryPricingRecordsMutation__
 *
 * To run a mutation, you first call `useImportTemporaryPricingRecordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportTemporaryPricingRecordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importTemporaryPricingRecordsMutation, { data, loading, error }] = useImportTemporaryPricingRecordsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportTemporaryPricingRecordsMutation(baseOptions?: Apollo.MutationHookOptions<ImportTemporaryPricingRecordsMutation, ImportTemporaryPricingRecordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportTemporaryPricingRecordsMutation, ImportTemporaryPricingRecordsMutationVariables>(ImportTemporaryPricingRecordsDocument, options);
      }
export type ImportTemporaryPricingRecordsMutationHookResult = ReturnType<typeof useImportTemporaryPricingRecordsMutation>;
export type ImportTemporaryPricingRecordsMutationResult = Apollo.MutationResult<ImportTemporaryPricingRecordsMutation>;
export type ImportTemporaryPricingRecordsMutationOptions = Apollo.BaseMutationOptions<ImportTemporaryPricingRecordsMutation, ImportTemporaryPricingRecordsMutationVariables>;
export const UpdateMarginDocument = gql`
    mutation UpdateMargin($input: UpdateMarginInput!) {
  updateMargin(input: $input) {
    margin {
      id
      name
    }
  }
}
    `;
export type UpdateMarginMutationFn = Apollo.MutationFunction<UpdateMarginMutation, UpdateMarginMutationVariables>;

/**
 * __useUpdateMarginMutation__
 *
 * To run a mutation, you first call `useUpdateMarginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMarginMutation, { data, loading, error }] = useUpdateMarginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMarginMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMarginMutation, UpdateMarginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMarginMutation, UpdateMarginMutationVariables>(UpdateMarginDocument, options);
      }
export type UpdateMarginMutationHookResult = ReturnType<typeof useUpdateMarginMutation>;
export type UpdateMarginMutationResult = Apollo.MutationResult<UpdateMarginMutation>;
export type UpdateMarginMutationOptions = Apollo.BaseMutationOptions<UpdateMarginMutation, UpdateMarginMutationVariables>;
export const UpdateMarketDocument = gql`
    mutation UpdateMarket($input: UpdateMarketInput!) {
  updateMarket(input: {data: $input}) {
    market {
      id
    }
  }
}
    `;
export type UpdateMarketMutationFn = Apollo.MutationFunction<UpdateMarketMutation, UpdateMarketMutationVariables>;

/**
 * __useUpdateMarketMutation__
 *
 * To run a mutation, you first call `useUpdateMarketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMarketMutation, { data, loading, error }] = useUpdateMarketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMarketMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMarketMutation, UpdateMarketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMarketMutation, UpdateMarketMutationVariables>(UpdateMarketDocument, options);
      }
export type UpdateMarketMutationHookResult = ReturnType<typeof useUpdateMarketMutation>;
export type UpdateMarketMutationResult = Apollo.MutationResult<UpdateMarketMutation>;
export type UpdateMarketMutationOptions = Apollo.BaseMutationOptions<UpdateMarketMutation, UpdateMarketMutationVariables>;
export const UpdatePricingsDocument = gql`
    mutation updatePricings($input: UpdatePricingInput!) {
  updatePricings(input: $input) {
    response {
      id
      error
      success
    }
    __typename
  }
}
    `;
export type UpdatePricingsMutationFn = Apollo.MutationFunction<UpdatePricingsMutation, UpdatePricingsMutationVariables>;

/**
 * __useUpdatePricingsMutation__
 *
 * To run a mutation, you first call `useUpdatePricingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePricingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePricingsMutation, { data, loading, error }] = useUpdatePricingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePricingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePricingsMutation, UpdatePricingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePricingsMutation, UpdatePricingsMutationVariables>(UpdatePricingsDocument, options);
      }
export type UpdatePricingsMutationHookResult = ReturnType<typeof useUpdatePricingsMutation>;
export type UpdatePricingsMutationResult = Apollo.MutationResult<UpdatePricingsMutation>;
export type UpdatePricingsMutationOptions = Apollo.BaseMutationOptions<UpdatePricingsMutation, UpdatePricingsMutationVariables>;
export const UpdateRateTypeDocument = gql`
    mutation UpdateRateType($input: UpdateRateTypeInput!) {
  updateRateType(input: {data: $input}) {
    rateType {
      id
      status
    }
  }
}
    `;
export type UpdateRateTypeMutationFn = Apollo.MutationFunction<UpdateRateTypeMutation, UpdateRateTypeMutationVariables>;

/**
 * __useUpdateRateTypeMutation__
 *
 * To run a mutation, you first call `useUpdateRateTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRateTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRateTypeMutation, { data, loading, error }] = useUpdateRateTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRateTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRateTypeMutation, UpdateRateTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRateTypeMutation, UpdateRateTypeMutationVariables>(UpdateRateTypeDocument, options);
      }
export type UpdateRateTypeMutationHookResult = ReturnType<typeof useUpdateRateTypeMutation>;
export type UpdateRateTypeMutationResult = Apollo.MutationResult<UpdateRateTypeMutation>;
export type UpdateRateTypeMutationOptions = Apollo.BaseMutationOptions<UpdateRateTypeMutation, UpdateRateTypeMutationVariables>;
export const UpdateRawPricingImportSessionDocument = gql`
    mutation UpdateRawPricingImportSession($input: UpdateRawPricingImportSessionInput!) {
  updateRawPricingImportSession(input: $input) {
    rawPricingImportSession {
      id
      state
      createdAt
      updatedAt
      state
      provider
      dataSource
      sourceDocument {
        blobFileUrlDownload
      }
      normalizedDocument {
        blobFileUrlDownload
      }
      errorDocument {
        blobFileUrlDownload
      }
      aliasMappings {
        id
        dataSource
        sourceValue
        mappableId
        mappableType
        mappable {
          ... on Product {
            id
            nullableName: name
          }
          ... on Market {
            id
            nullableName: name
          }
          ... on Supplier {
            id
            name
          }
          ... on RateType {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export type UpdateRawPricingImportSessionMutationFn = Apollo.MutationFunction<UpdateRawPricingImportSessionMutation, UpdateRawPricingImportSessionMutationVariables>;

/**
 * __useUpdateRawPricingImportSessionMutation__
 *
 * To run a mutation, you first call `useUpdateRawPricingImportSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRawPricingImportSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRawPricingImportSessionMutation, { data, loading, error }] = useUpdateRawPricingImportSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRawPricingImportSessionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRawPricingImportSessionMutation, UpdateRawPricingImportSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRawPricingImportSessionMutation, UpdateRawPricingImportSessionMutationVariables>(UpdateRawPricingImportSessionDocument, options);
      }
export type UpdateRawPricingImportSessionMutationHookResult = ReturnType<typeof useUpdateRawPricingImportSessionMutation>;
export type UpdateRawPricingImportSessionMutationResult = Apollo.MutationResult<UpdateRawPricingImportSessionMutation>;
export type UpdateRawPricingImportSessionMutationOptions = Apollo.BaseMutationOptions<UpdateRawPricingImportSessionMutation, UpdateRawPricingImportSessionMutationVariables>;
export const UpdateResourcePricingsDocument = gql`
    mutation updateResourcePricings($data: UpdateResourcePricingsInput!) {
  updateResourcePricings(input: {data: $data}) {
    resourcePricing {
      id
    }
  }
}
    `;
export type UpdateResourcePricingsMutationFn = Apollo.MutationFunction<UpdateResourcePricingsMutation, UpdateResourcePricingsMutationVariables>;

/**
 * __useUpdateResourcePricingsMutation__
 *
 * To run a mutation, you first call `useUpdateResourcePricingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourcePricingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourcePricingsMutation, { data, loading, error }] = useUpdateResourcePricingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateResourcePricingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResourcePricingsMutation, UpdateResourcePricingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResourcePricingsMutation, UpdateResourcePricingsMutationVariables>(UpdateResourcePricingsDocument, options);
      }
export type UpdateResourcePricingsMutationHookResult = ReturnType<typeof useUpdateResourcePricingsMutation>;
export type UpdateResourcePricingsMutationResult = Apollo.MutationResult<UpdateResourcePricingsMutation>;
export type UpdateResourcePricingsMutationOptions = Apollo.BaseMutationOptions<UpdateResourcePricingsMutation, UpdateResourcePricingsMutationVariables>;
export const UpdateTaxDocument = gql`
    mutation UpdateTax($input: UpdateTaxInput!) {
  updateTax(input: $input) {
    tax {
      id
      name
      erpId
      productTaxes {
        id
        productId
      }
    }
  }
}
    `;
export type UpdateTaxMutationFn = Apollo.MutationFunction<UpdateTaxMutation, UpdateTaxMutationVariables>;

/**
 * __useUpdateTaxMutation__
 *
 * To run a mutation, you first call `useUpdateTaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaxMutation, { data, loading, error }] = useUpdateTaxMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaxMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaxMutation, UpdateTaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaxMutation, UpdateTaxMutationVariables>(UpdateTaxDocument, options);
      }
export type UpdateTaxMutationHookResult = ReturnType<typeof useUpdateTaxMutation>;
export type UpdateTaxMutationResult = Apollo.MutationResult<UpdateTaxMutation>;
export type UpdateTaxMutationOptions = Apollo.BaseMutationOptions<UpdateTaxMutation, UpdateTaxMutationVariables>;
export const RequestContactOtpDocument = gql`
    mutation requestContactOtp($input: RequestContactOtpInput!) {
  requestContactOtp(input: $input) {
    success
  }
}
    `;
export type RequestContactOtpMutationFn = Apollo.MutationFunction<RequestContactOtpMutation, RequestContactOtpMutationVariables>;

/**
 * __useRequestContactOtpMutation__
 *
 * To run a mutation, you first call `useRequestContactOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestContactOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestContactOtpMutation, { data, loading, error }] = useRequestContactOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestContactOtpMutation(baseOptions?: Apollo.MutationHookOptions<RequestContactOtpMutation, RequestContactOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestContactOtpMutation, RequestContactOtpMutationVariables>(RequestContactOtpDocument, options);
      }
export type RequestContactOtpMutationHookResult = ReturnType<typeof useRequestContactOtpMutation>;
export type RequestContactOtpMutationResult = Apollo.MutationResult<RequestContactOtpMutation>;
export type RequestContactOtpMutationOptions = Apollo.BaseMutationOptions<RequestContactOtpMutation, RequestContactOtpMutationVariables>;
export const UpdateUserProfileDocument = gql`
    mutation updateUserProfile($input: UpdateUsersInput!) {
  updateUser(input: $input) {
    user {
      id
    }
  }
}
    `;
export type UpdateUserProfileMutationFn = Apollo.MutationFunction<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>(UpdateUserProfileDocument, options);
      }
export type UpdateUserProfileMutationHookResult = ReturnType<typeof useUpdateUserProfileMutation>;
export type UpdateUserProfileMutationResult = Apollo.MutationResult<UpdateUserProfileMutation>;
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const VerifyAndUpdateUserDocument = gql`
    mutation verifyAndUpdateUser($input: VerifyAndUpdateUserInput!) {
  verifyAndUpdateUser(input: $input) {
    user {
      id
    }
  }
}
    `;
export type VerifyAndUpdateUserMutationFn = Apollo.MutationFunction<VerifyAndUpdateUserMutation, VerifyAndUpdateUserMutationVariables>;

/**
 * __useVerifyAndUpdateUserMutation__
 *
 * To run a mutation, you first call `useVerifyAndUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAndUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAndUpdateUserMutation, { data, loading, error }] = useVerifyAndUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyAndUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<VerifyAndUpdateUserMutation, VerifyAndUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyAndUpdateUserMutation, VerifyAndUpdateUserMutationVariables>(VerifyAndUpdateUserDocument, options);
      }
export type VerifyAndUpdateUserMutationHookResult = ReturnType<typeof useVerifyAndUpdateUserMutation>;
export type VerifyAndUpdateUserMutationResult = Apollo.MutationResult<VerifyAndUpdateUserMutation>;
export type VerifyAndUpdateUserMutationOptions = Apollo.BaseMutationOptions<VerifyAndUpdateUserMutation, VerifyAndUpdateUserMutationVariables>;
export const FetchRateTypesDropdownDocument = gql`
    query FetchRateTypesDropdown($filter: FiltersInput) {
  rateTypes(filter: $filter) {
    id
    name
    status
  }
}
    `;

/**
 * __useFetchRateTypesDropdownQuery__
 *
 * To run a query within a React component, call `useFetchRateTypesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRateTypesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRateTypesDropdownQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchRateTypesDropdownQuery(baseOptions?: Apollo.QueryHookOptions<FetchRateTypesDropdownQuery, FetchRateTypesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRateTypesDropdownQuery, FetchRateTypesDropdownQueryVariables>(FetchRateTypesDropdownDocument, options);
      }
export function useFetchRateTypesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRateTypesDropdownQuery, FetchRateTypesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRateTypesDropdownQuery, FetchRateTypesDropdownQueryVariables>(FetchRateTypesDropdownDocument, options);
        }
export type FetchRateTypesDropdownQueryHookResult = ReturnType<typeof useFetchRateTypesDropdownQuery>;
export type FetchRateTypesDropdownLazyQueryHookResult = ReturnType<typeof useFetchRateTypesDropdownLazyQuery>;
export type FetchRateTypesDropdownQueryResult = Apollo.QueryResult<FetchRateTypesDropdownQuery, FetchRateTypesDropdownQueryVariables>;
export const FetchProductsDropdownDocument = gql`
    query FetchProductsDropdown {
  products {
    id
    name
    active
  }
}
    `;

/**
 * __useFetchProductsDropdownQuery__
 *
 * To run a query within a React component, call `useFetchProductsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductsDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchProductsDropdownQuery(baseOptions?: Apollo.QueryHookOptions<FetchProductsDropdownQuery, FetchProductsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchProductsDropdownQuery, FetchProductsDropdownQueryVariables>(FetchProductsDropdownDocument, options);
      }
export function useFetchProductsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchProductsDropdownQuery, FetchProductsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchProductsDropdownQuery, FetchProductsDropdownQueryVariables>(FetchProductsDropdownDocument, options);
        }
export type FetchProductsDropdownQueryHookResult = ReturnType<typeof useFetchProductsDropdownQuery>;
export type FetchProductsDropdownLazyQueryHookResult = ReturnType<typeof useFetchProductsDropdownLazyQuery>;
export type FetchProductsDropdownQueryResult = Apollo.QueryResult<FetchProductsDropdownQuery, FetchProductsDropdownQueryVariables>;
export const FetchAssetMovementOrderIdsDocument = gql`
    query FetchAssetMovementOrderIds($id: ID!) {
  asset(id: $id) {
    id
    name
    existingActiveMovementOrderIds
  }
}
    `;

/**
 * __useFetchAssetMovementOrderIdsQuery__
 *
 * To run a query within a React component, call `useFetchAssetMovementOrderIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAssetMovementOrderIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAssetMovementOrderIdsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchAssetMovementOrderIdsQuery(baseOptions: Apollo.QueryHookOptions<FetchAssetMovementOrderIdsQuery, FetchAssetMovementOrderIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAssetMovementOrderIdsQuery, FetchAssetMovementOrderIdsQueryVariables>(FetchAssetMovementOrderIdsDocument, options);
      }
export function useFetchAssetMovementOrderIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAssetMovementOrderIdsQuery, FetchAssetMovementOrderIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAssetMovementOrderIdsQuery, FetchAssetMovementOrderIdsQueryVariables>(FetchAssetMovementOrderIdsDocument, options);
        }
export type FetchAssetMovementOrderIdsQueryHookResult = ReturnType<typeof useFetchAssetMovementOrderIdsQuery>;
export type FetchAssetMovementOrderIdsLazyQueryHookResult = ReturnType<typeof useFetchAssetMovementOrderIdsLazyQuery>;
export type FetchAssetMovementOrderIdsQueryResult = Apollo.QueryResult<FetchAssetMovementOrderIdsQuery, FetchAssetMovementOrderIdsQueryVariables>;
export const AddCodeToAssetDocument = gql`
    mutation addCodeToAsset($input: AddCodeToAssetInput!) {
  addCodeToAsset(input: $input) {
    clientMutationId
  }
}
    `;
export type AddCodeToAssetMutationFn = Apollo.MutationFunction<AddCodeToAssetMutation, AddCodeToAssetMutationVariables>;

/**
 * __useAddCodeToAssetMutation__
 *
 * To run a mutation, you first call `useAddCodeToAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCodeToAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCodeToAssetMutation, { data, loading, error }] = useAddCodeToAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCodeToAssetMutation(baseOptions?: Apollo.MutationHookOptions<AddCodeToAssetMutation, AddCodeToAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCodeToAssetMutation, AddCodeToAssetMutationVariables>(AddCodeToAssetDocument, options);
      }
export type AddCodeToAssetMutationHookResult = ReturnType<typeof useAddCodeToAssetMutation>;
export type AddCodeToAssetMutationResult = Apollo.MutationResult<AddCodeToAssetMutation>;
export type AddCodeToAssetMutationOptions = Apollo.BaseMutationOptions<AddCodeToAssetMutation, AddCodeToAssetMutationVariables>;
export const AddQrCodeToAssetDocument = gql`
    mutation addQrCodeToAsset($input: AddQrCodeToAssetInput!) {
  addQrCodeToAsset(input: $input) {
    clientMutationId
  }
}
    `;
export type AddQrCodeToAssetMutationFn = Apollo.MutationFunction<AddQrCodeToAssetMutation, AddQrCodeToAssetMutationVariables>;

/**
 * __useAddQrCodeToAssetMutation__
 *
 * To run a mutation, you first call `useAddQrCodeToAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddQrCodeToAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addQrCodeToAssetMutation, { data, loading, error }] = useAddQrCodeToAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddQrCodeToAssetMutation(baseOptions?: Apollo.MutationHookOptions<AddQrCodeToAssetMutation, AddQrCodeToAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddQrCodeToAssetMutation, AddQrCodeToAssetMutationVariables>(AddQrCodeToAssetDocument, options);
      }
export type AddQrCodeToAssetMutationHookResult = ReturnType<typeof useAddQrCodeToAssetMutation>;
export type AddQrCodeToAssetMutationResult = Apollo.MutationResult<AddQrCodeToAssetMutation>;
export type AddQrCodeToAssetMutationOptions = Apollo.BaseMutationOptions<AddQrCodeToAssetMutation, AddQrCodeToAssetMutationVariables>;
export const AddShipToSupplierPreferenceDocument = gql`
    mutation AddShipToSupplierPreference($input: UpdateCustomerBranchInput!) {
  updateCustomerBranch(input: {data: $input}) {
    customerBranch {
      id
      name
      preferredProductTerminals {
        id
        terminal {
          id
        }
        product {
          id
        }
        preferredProductTerminalSuppliers {
          id
          supplier {
            id
          }
        }
      }
    }
  }
}
    `;
export type AddShipToSupplierPreferenceMutationFn = Apollo.MutationFunction<AddShipToSupplierPreferenceMutation, AddShipToSupplierPreferenceMutationVariables>;

/**
 * __useAddShipToSupplierPreferenceMutation__
 *
 * To run a mutation, you first call `useAddShipToSupplierPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddShipToSupplierPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addShipToSupplierPreferenceMutation, { data, loading, error }] = useAddShipToSupplierPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddShipToSupplierPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<AddShipToSupplierPreferenceMutation, AddShipToSupplierPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddShipToSupplierPreferenceMutation, AddShipToSupplierPreferenceMutationVariables>(AddShipToSupplierPreferenceDocument, options);
      }
export type AddShipToSupplierPreferenceMutationHookResult = ReturnType<typeof useAddShipToSupplierPreferenceMutation>;
export type AddShipToSupplierPreferenceMutationResult = Apollo.MutationResult<AddShipToSupplierPreferenceMutation>;
export type AddShipToSupplierPreferenceMutationOptions = Apollo.BaseMutationOptions<AddShipToSupplierPreferenceMutation, AddShipToSupplierPreferenceMutationVariables>;
export const UpdateAssignPandaBoxDocument = gql`
    mutation UpdateAssignPandaBox($input: AssignPandaBoxInput!) {
  assignPandaBox(input: $input) {
    success
    errors
  }
}
    `;
export type UpdateAssignPandaBoxMutationFn = Apollo.MutationFunction<UpdateAssignPandaBoxMutation, UpdateAssignPandaBoxMutationVariables>;

/**
 * __useUpdateAssignPandaBoxMutation__
 *
 * To run a mutation, you first call `useUpdateAssignPandaBoxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssignPandaBoxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssignPandaBoxMutation, { data, loading, error }] = useUpdateAssignPandaBoxMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssignPandaBoxMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssignPandaBoxMutation, UpdateAssignPandaBoxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssignPandaBoxMutation, UpdateAssignPandaBoxMutationVariables>(UpdateAssignPandaBoxDocument, options);
      }
export type UpdateAssignPandaBoxMutationHookResult = ReturnType<typeof useUpdateAssignPandaBoxMutation>;
export type UpdateAssignPandaBoxMutationResult = Apollo.MutationResult<UpdateAssignPandaBoxMutation>;
export type UpdateAssignPandaBoxMutationOptions = Apollo.BaseMutationOptions<UpdateAssignPandaBoxMutation, UpdateAssignPandaBoxMutationVariables>;
export const CreateAppVersionDocument = gql`
    mutation CreateAppVersion($input: CreateAppVersionInput!) {
  createAppVersion(input: $input) {
    appVersion {
      id
    }
    errors
    success
  }
}
    `;
export type CreateAppVersionMutationFn = Apollo.MutationFunction<CreateAppVersionMutation, CreateAppVersionMutationVariables>;

/**
 * __useCreateAppVersionMutation__
 *
 * To run a mutation, you first call `useCreateAppVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppVersionMutation, { data, loading, error }] = useCreateAppVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAppVersionMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppVersionMutation, CreateAppVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppVersionMutation, CreateAppVersionMutationVariables>(CreateAppVersionDocument, options);
      }
export type CreateAppVersionMutationHookResult = ReturnType<typeof useCreateAppVersionMutation>;
export type CreateAppVersionMutationResult = Apollo.MutationResult<CreateAppVersionMutation>;
export type CreateAppVersionMutationOptions = Apollo.BaseMutationOptions<CreateAppVersionMutation, CreateAppVersionMutationVariables>;
export const CreateAssetDocument = gql`
    mutation createAsset($input: CreateAssetsInput!) {
  createAsset(input: $input) {
    asset {
      id
      customer {
        tankReadingThreshold
        hubs {
          id
          name
        }
      }
      customerBranch {
        hubs {
          id
          name
        }
      }
    }
  }
}
    `;
export type CreateAssetMutationFn = Apollo.MutationFunction<CreateAssetMutation, CreateAssetMutationVariables>;

/**
 * __useCreateAssetMutation__
 *
 * To run a mutation, you first call `useCreateAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetMutation, { data, loading, error }] = useCreateAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssetMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssetMutation, CreateAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssetMutation, CreateAssetMutationVariables>(CreateAssetDocument, options);
      }
export type CreateAssetMutationHookResult = ReturnType<typeof useCreateAssetMutation>;
export type CreateAssetMutationResult = Apollo.MutationResult<CreateAssetMutation>;
export type CreateAssetMutationOptions = Apollo.BaseMutationOptions<CreateAssetMutation, CreateAssetMutationVariables>;
export const CreateBrandDocument = gql`
    mutation CreateBrand($input: CreateBrandsInput!) {
  createBrand(input: $input) {
    brand {
      id
    }
  }
}
    `;
export type CreateBrandMutationFn = Apollo.MutationFunction<CreateBrandMutation, CreateBrandMutationVariables>;

/**
 * __useCreateBrandMutation__
 *
 * To run a mutation, you first call `useCreateBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBrandMutation, { data, loading, error }] = useCreateBrandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBrandMutation(baseOptions?: Apollo.MutationHookOptions<CreateBrandMutation, CreateBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBrandMutation, CreateBrandMutationVariables>(CreateBrandDocument, options);
      }
export type CreateBrandMutationHookResult = ReturnType<typeof useCreateBrandMutation>;
export type CreateBrandMutationResult = Apollo.MutationResult<CreateBrandMutation>;
export type CreateBrandMutationOptions = Apollo.BaseMutationOptions<CreateBrandMutation, CreateBrandMutationVariables>;
export const CreateCommonCarrierDocument = gql`
    mutation CreateCommonCarrier($input: CreateCommonCarrierInput!) {
  createCommonCarrier(input: $input) {
    ccTenant {
      id
      erpId
      address
      site {
        city
        state
        zip
        lat
        lng
        radius
      }
      carrierTenant {
        id
        name
        slug
        adminUsers {
          id
          name
          email
          phone
        }
      }
    }
    errorMsg
  }
}
    `;
export type CreateCommonCarrierMutationFn = Apollo.MutationFunction<CreateCommonCarrierMutation, CreateCommonCarrierMutationVariables>;

/**
 * __useCreateCommonCarrierMutation__
 *
 * To run a mutation, you first call `useCreateCommonCarrierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommonCarrierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommonCarrierMutation, { data, loading, error }] = useCreateCommonCarrierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommonCarrierMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommonCarrierMutation, CreateCommonCarrierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommonCarrierMutation, CreateCommonCarrierMutationVariables>(CreateCommonCarrierDocument, options);
      }
export type CreateCommonCarrierMutationHookResult = ReturnType<typeof useCreateCommonCarrierMutation>;
export type CreateCommonCarrierMutationResult = Apollo.MutationResult<CreateCommonCarrierMutation>;
export type CreateCommonCarrierMutationOptions = Apollo.BaseMutationOptions<CreateCommonCarrierMutation, CreateCommonCarrierMutationVariables>;
export const CreateCustomerDocument = gql`
    mutation CreateCustomer($input: CreateCustomerInput!) {
  createCustomer(input: {data: $input}) {
    customer {
      id
      name
    }
  }
}
    `;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const CreateCustomerBranchDocument = gql`
    mutation CreateCustomerBranch($input: CreateCustomerBranchInput!) {
  createCustomerBranch(input: {data: $input}) {
    customerBranch {
      id
      name
    }
  }
}
    `;
export type CreateCustomerBranchMutationFn = Apollo.MutationFunction<CreateCustomerBranchMutation, CreateCustomerBranchMutationVariables>;

/**
 * __useCreateCustomerBranchMutation__
 *
 * To run a mutation, you first call `useCreateCustomerBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerBranchMutation, { data, loading, error }] = useCreateCustomerBranchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerBranchMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerBranchMutation, CreateCustomerBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerBranchMutation, CreateCustomerBranchMutationVariables>(CreateCustomerBranchDocument, options);
      }
export type CreateCustomerBranchMutationHookResult = ReturnType<typeof useCreateCustomerBranchMutation>;
export type CreateCustomerBranchMutationResult = Apollo.MutationResult<CreateCustomerBranchMutation>;
export type CreateCustomerBranchMutationOptions = Apollo.BaseMutationOptions<CreateCustomerBranchMutation, CreateCustomerBranchMutationVariables>;
export const CreateCustomerSegmentDocument = gql`
    mutation CreateCustomerSegment($input: CreateCustomerSegmentsInput!) {
  createCustomerSegment(input: $input) {
    customerSegment {
      id
      name
      code
      segmentType
    }
  }
}
    `;
export type CreateCustomerSegmentMutationFn = Apollo.MutationFunction<CreateCustomerSegmentMutation, CreateCustomerSegmentMutationVariables>;

/**
 * __useCreateCustomerSegmentMutation__
 *
 * To run a mutation, you first call `useCreateCustomerSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerSegmentMutation, { data, loading, error }] = useCreateCustomerSegmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerSegmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerSegmentMutation, CreateCustomerSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerSegmentMutation, CreateCustomerSegmentMutationVariables>(CreateCustomerSegmentDocument, options);
      }
export type CreateCustomerSegmentMutationHookResult = ReturnType<typeof useCreateCustomerSegmentMutation>;
export type CreateCustomerSegmentMutationResult = Apollo.MutationResult<CreateCustomerSegmentMutation>;
export type CreateCustomerSegmentMutationOptions = Apollo.BaseMutationOptions<CreateCustomerSegmentMutation, CreateCustomerSegmentMutationVariables>;
export const CreateDirectUploadDocument = gql`
    mutation CreateDirectUpload($input: CreateDirectUpload!) {
  createDirectUpload(input: {input: $input}) {
    blobId
    headers
    signedBlobId
    url
  }
}
    `;
export type CreateDirectUploadMutationFn = Apollo.MutationFunction<CreateDirectUploadMutation, CreateDirectUploadMutationVariables>;

/**
 * __useCreateDirectUploadMutation__
 *
 * To run a mutation, you first call `useCreateDirectUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDirectUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDirectUploadMutation, { data, loading, error }] = useCreateDirectUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDirectUploadMutation(baseOptions?: Apollo.MutationHookOptions<CreateDirectUploadMutation, CreateDirectUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDirectUploadMutation, CreateDirectUploadMutationVariables>(CreateDirectUploadDocument, options);
      }
export type CreateDirectUploadMutationHookResult = ReturnType<typeof useCreateDirectUploadMutation>;
export type CreateDirectUploadMutationResult = Apollo.MutationResult<CreateDirectUploadMutation>;
export type CreateDirectUploadMutationOptions = Apollo.BaseMutationOptions<CreateDirectUploadMutation, CreateDirectUploadMutationVariables>;
export const CreateDriverDocument = gql`
    mutation CreateDriver($input: CreateDriverInput!) {
  createDriver(input: {data: $input}) {
    driver {
      id
      name
      erpId
    }
  }
}
    `;
export type CreateDriverMutationFn = Apollo.MutationFunction<CreateDriverMutation, CreateDriverMutationVariables>;

/**
 * __useCreateDriverMutation__
 *
 * To run a mutation, you first call `useCreateDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDriverMutation, { data, loading, error }] = useCreateDriverMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDriverMutation(baseOptions?: Apollo.MutationHookOptions<CreateDriverMutation, CreateDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDriverMutation, CreateDriverMutationVariables>(CreateDriverDocument, options);
      }
export type CreateDriverMutationHookResult = ReturnType<typeof useCreateDriverMutation>;
export type CreateDriverMutationResult = Apollo.MutationResult<CreateDriverMutation>;
export type CreateDriverMutationOptions = Apollo.BaseMutationOptions<CreateDriverMutation, CreateDriverMutationVariables>;
export const CreateDriverDemurrageDocument = gql`
    mutation CreateDriverDemurrage($input: CreateDriverDemurrageInput!) {
  createDriverDemurrage(input: $input) {
    driverDemurrage {
      id
      customer {
        name
      }
    }
  }
}
    `;
export type CreateDriverDemurrageMutationFn = Apollo.MutationFunction<CreateDriverDemurrageMutation, CreateDriverDemurrageMutationVariables>;

/**
 * __useCreateDriverDemurrageMutation__
 *
 * To run a mutation, you first call `useCreateDriverDemurrageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDriverDemurrageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDriverDemurrageMutation, { data, loading, error }] = useCreateDriverDemurrageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDriverDemurrageMutation(baseOptions?: Apollo.MutationHookOptions<CreateDriverDemurrageMutation, CreateDriverDemurrageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDriverDemurrageMutation, CreateDriverDemurrageMutationVariables>(CreateDriverDemurrageDocument, options);
      }
export type CreateDriverDemurrageMutationHookResult = ReturnType<typeof useCreateDriverDemurrageMutation>;
export type CreateDriverDemurrageMutationResult = Apollo.MutationResult<CreateDriverDemurrageMutation>;
export type CreateDriverDemurrageMutationOptions = Apollo.BaseMutationOptions<CreateDriverDemurrageMutation, CreateDriverDemurrageMutationVariables>;
export const CreateFeeDocument = gql`
    mutation CreateFee($input: CreateFeesInput!) {
  createFee(input: $input) {
    fee {
      id
      name
    }
  }
}
    `;
export type CreateFeeMutationFn = Apollo.MutationFunction<CreateFeeMutation, CreateFeeMutationVariables>;

/**
 * __useCreateFeeMutation__
 *
 * To run a mutation, you first call `useCreateFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeeMutation, { data, loading, error }] = useCreateFeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeeMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeeMutation, CreateFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeeMutation, CreateFeeMutationVariables>(CreateFeeDocument, options);
      }
export type CreateFeeMutationHookResult = ReturnType<typeof useCreateFeeMutation>;
export type CreateFeeMutationResult = Apollo.MutationResult<CreateFeeMutation>;
export type CreateFeeMutationOptions = Apollo.BaseMutationOptions<CreateFeeMutation, CreateFeeMutationVariables>;
export const CreateLineOfServiceDocument = gql`
    mutation CreateLineOfService($input: CreateLineOfServicesInput!) {
  createLineOfService(input: $input) {
    lineOfService {
      id
    }
  }
}
    `;
export type CreateLineOfServiceMutationFn = Apollo.MutationFunction<CreateLineOfServiceMutation, CreateLineOfServiceMutationVariables>;

/**
 * __useCreateLineOfServiceMutation__
 *
 * To run a mutation, you first call `useCreateLineOfServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLineOfServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLineOfServiceMutation, { data, loading, error }] = useCreateLineOfServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLineOfServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateLineOfServiceMutation, CreateLineOfServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLineOfServiceMutation, CreateLineOfServiceMutationVariables>(CreateLineOfServiceDocument, options);
      }
export type CreateLineOfServiceMutationHookResult = ReturnType<typeof useCreateLineOfServiceMutation>;
export type CreateLineOfServiceMutationResult = Apollo.MutationResult<CreateLineOfServiceMutation>;
export type CreateLineOfServiceMutationOptions = Apollo.BaseMutationOptions<CreateLineOfServiceMutation, CreateLineOfServiceMutationVariables>;
export const CreateLoadingAccountDocument = gql`
    mutation CreateLoadingAccount($input: CreateLoadingAccountsInput!) {
  createLoadingAccount(input: $input) {
    loadingAccount {
      id
    }
  }
}
    `;
export type CreateLoadingAccountMutationFn = Apollo.MutationFunction<CreateLoadingAccountMutation, CreateLoadingAccountMutationVariables>;

/**
 * __useCreateLoadingAccountMutation__
 *
 * To run a mutation, you first call `useCreateLoadingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLoadingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLoadingAccountMutation, { data, loading, error }] = useCreateLoadingAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLoadingAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateLoadingAccountMutation, CreateLoadingAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLoadingAccountMutation, CreateLoadingAccountMutationVariables>(CreateLoadingAccountDocument, options);
      }
export type CreateLoadingAccountMutationHookResult = ReturnType<typeof useCreateLoadingAccountMutation>;
export type CreateLoadingAccountMutationResult = Apollo.MutationResult<CreateLoadingAccountMutation>;
export type CreateLoadingAccountMutationOptions = Apollo.BaseMutationOptions<CreateLoadingAccountMutation, CreateLoadingAccountMutationVariables>;
export const CreatePandaBoxDocument = gql`
    mutation CreatePandaBox($input: CreatePandaBoxInput!) {
  createPandaBox(input: $input) {
    pandaBox {
      id
    }
    errors
    success
  }
}
    `;
export type CreatePandaBoxMutationFn = Apollo.MutationFunction<CreatePandaBoxMutation, CreatePandaBoxMutationVariables>;

/**
 * __useCreatePandaBoxMutation__
 *
 * To run a mutation, you first call `useCreatePandaBoxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePandaBoxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPandaBoxMutation, { data, loading, error }] = useCreatePandaBoxMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePandaBoxMutation(baseOptions?: Apollo.MutationHookOptions<CreatePandaBoxMutation, CreatePandaBoxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePandaBoxMutation, CreatePandaBoxMutationVariables>(CreatePandaBoxDocument, options);
      }
export type CreatePandaBoxMutationHookResult = ReturnType<typeof useCreatePandaBoxMutation>;
export type CreatePandaBoxMutationResult = Apollo.MutationResult<CreatePandaBoxMutation>;
export type CreatePandaBoxMutationOptions = Apollo.BaseMutationOptions<CreatePandaBoxMutation, CreatePandaBoxMutationVariables>;
export const CreatePaymentTermDocument = gql`
    mutation CreatePaymentTerm($input: CreatePaymentTermsInput!) {
  createPaymentTerm(input: $input) {
    paymentTerm {
      id
      name
      description
      netDaysToPay
    }
  }
}
    `;
export type CreatePaymentTermMutationFn = Apollo.MutationFunction<CreatePaymentTermMutation, CreatePaymentTermMutationVariables>;

/**
 * __useCreatePaymentTermMutation__
 *
 * To run a mutation, you first call `useCreatePaymentTermMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentTermMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentTermMutation, { data, loading, error }] = useCreatePaymentTermMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaymentTermMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentTermMutation, CreatePaymentTermMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentTermMutation, CreatePaymentTermMutationVariables>(CreatePaymentTermDocument, options);
      }
export type CreatePaymentTermMutationHookResult = ReturnType<typeof useCreatePaymentTermMutation>;
export type CreatePaymentTermMutationResult = Apollo.MutationResult<CreatePaymentTermMutation>;
export type CreatePaymentTermMutationOptions = Apollo.BaseMutationOptions<CreatePaymentTermMutation, CreatePaymentTermMutationVariables>;
export const CreatePeripheralDocument = gql`
    mutation CreatePeripheral($input: CreatePeripheralInput!) {
  createPeripheral(input: $input) {
    peripheral {
      id
    }
  }
}
    `;
export type CreatePeripheralMutationFn = Apollo.MutationFunction<CreatePeripheralMutation, CreatePeripheralMutationVariables>;

/**
 * __useCreatePeripheralMutation__
 *
 * To run a mutation, you first call `useCreatePeripheralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePeripheralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPeripheralMutation, { data, loading, error }] = useCreatePeripheralMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePeripheralMutation(baseOptions?: Apollo.MutationHookOptions<CreatePeripheralMutation, CreatePeripheralMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePeripheralMutation, CreatePeripheralMutationVariables>(CreatePeripheralDocument, options);
      }
export type CreatePeripheralMutationHookResult = ReturnType<typeof useCreatePeripheralMutation>;
export type CreatePeripheralMutationResult = Apollo.MutationResult<CreatePeripheralMutation>;
export type CreatePeripheralMutationOptions = Apollo.BaseMutationOptions<CreatePeripheralMutation, CreatePeripheralMutationVariables>;
export const CreateProductDocument = gql`
    mutation CreateProduct($input: CreateProductsInput!) {
  createProduct(input: $input) {
    product {
      id
    }
  }
}
    `;
export type CreateProductMutationFn = Apollo.MutationFunction<CreateProductMutation, CreateProductMutationVariables>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductMutation, CreateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductMutation, CreateProductMutationVariables>(CreateProductDocument, options);
      }
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = Apollo.MutationResult<CreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<CreateProductMutation, CreateProductMutationVariables>;
export const CreateProductPurchaseLimitDocument = gql`
    mutation CreateProductPurchaseLimit($input: CreateProductPurchaseLimitsInput!) {
  createProductPurchaseLimit(input: $input) {
    productPurchaseLimit {
      id
    }
  }
}
    `;
export type CreateProductPurchaseLimitMutationFn = Apollo.MutationFunction<CreateProductPurchaseLimitMutation, CreateProductPurchaseLimitMutationVariables>;

/**
 * __useCreateProductPurchaseLimitMutation__
 *
 * To run a mutation, you first call `useCreateProductPurchaseLimitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductPurchaseLimitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductPurchaseLimitMutation, { data, loading, error }] = useCreateProductPurchaseLimitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductPurchaseLimitMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductPurchaseLimitMutation, CreateProductPurchaseLimitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductPurchaseLimitMutation, CreateProductPurchaseLimitMutationVariables>(CreateProductPurchaseLimitDocument, options);
      }
export type CreateProductPurchaseLimitMutationHookResult = ReturnType<typeof useCreateProductPurchaseLimitMutation>;
export type CreateProductPurchaseLimitMutationResult = Apollo.MutationResult<CreateProductPurchaseLimitMutation>;
export type CreateProductPurchaseLimitMutationOptions = Apollo.BaseMutationOptions<CreateProductPurchaseLimitMutation, CreateProductPurchaseLimitMutationVariables>;
export const CreateResourceScheduleDocument = gql`
    mutation CreateResourceSchedule($input: CreateResourceScheduleInput!) {
  createResourceSchedule(input: $input) {
    resourceSchedule {
      id
      preferrableId
      preferrableType
      availability {
        day
        startTime
        endTime
        bestStartTime
        bestEndTime
        preferredStartTime
        preferredEndTime
      }
      unavailability {
        reason
        unStartTime
        unStartTime
      }
    }
  }
}
    `;
export type CreateResourceScheduleMutationFn = Apollo.MutationFunction<CreateResourceScheduleMutation, CreateResourceScheduleMutationVariables>;

/**
 * __useCreateResourceScheduleMutation__
 *
 * To run a mutation, you first call `useCreateResourceScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResourceScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResourceScheduleMutation, { data, loading, error }] = useCreateResourceScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateResourceScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreateResourceScheduleMutation, CreateResourceScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResourceScheduleMutation, CreateResourceScheduleMutationVariables>(CreateResourceScheduleDocument, options);
      }
export type CreateResourceScheduleMutationHookResult = ReturnType<typeof useCreateResourceScheduleMutation>;
export type CreateResourceScheduleMutationResult = Apollo.MutationResult<CreateResourceScheduleMutation>;
export type CreateResourceScheduleMutationOptions = Apollo.BaseMutationOptions<CreateResourceScheduleMutation, CreateResourceScheduleMutationVariables>;
export const CreateSupplierDocument = gql`
    mutation CreateSupplier($input: CreateSupplierInput!) {
  createSupplier(input: {data: $input}) {
    supplier {
      id
    }
  }
}
    `;
export type CreateSupplierMutationFn = Apollo.MutationFunction<CreateSupplierMutation, CreateSupplierMutationVariables>;

/**
 * __useCreateSupplierMutation__
 *
 * To run a mutation, you first call `useCreateSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplierMutation, { data, loading, error }] = useCreateSupplierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSupplierMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupplierMutation, CreateSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupplierMutation, CreateSupplierMutationVariables>(CreateSupplierDocument, options);
      }
export type CreateSupplierMutationHookResult = ReturnType<typeof useCreateSupplierMutation>;
export type CreateSupplierMutationResult = Apollo.MutationResult<CreateSupplierMutation>;
export type CreateSupplierMutationOptions = Apollo.BaseMutationOptions<CreateSupplierMutation, CreateSupplierMutationVariables>;
export const CreateTerminalDocument = gql`
    mutation CreateTerminal($input: TerminalInput!) {
  createTerminal(input: {data: $input}) {
    terminal {
      id
      name
    }
  }
}
    `;
export type CreateTerminalMutationFn = Apollo.MutationFunction<CreateTerminalMutation, CreateTerminalMutationVariables>;

/**
 * __useCreateTerminalMutation__
 *
 * To run a mutation, you first call `useCreateTerminalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTerminalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTerminalMutation, { data, loading, error }] = useCreateTerminalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTerminalMutation(baseOptions?: Apollo.MutationHookOptions<CreateTerminalMutation, CreateTerminalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTerminalMutation, CreateTerminalMutationVariables>(CreateTerminalDocument, options);
      }
export type CreateTerminalMutationHookResult = ReturnType<typeof useCreateTerminalMutation>;
export type CreateTerminalMutationResult = Apollo.MutationResult<CreateTerminalMutation>;
export type CreateTerminalMutationOptions = Apollo.BaseMutationOptions<CreateTerminalMutation, CreateTerminalMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($input: CreateCustomerUsersInput!) {
  createCustomerUser(input: $input) {
    customerUser {
      id
    }
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const DeleteAssetsDocument = gql`
    mutation DeleteAssets($id: ID!) {
  deleteAsset(input: {id: $id}) {
    asset {
      id
      name
      erpId
    }
  }
}
    `;
export type DeleteAssetsMutationFn = Apollo.MutationFunction<DeleteAssetsMutation, DeleteAssetsMutationVariables>;

/**
 * __useDeleteAssetsMutation__
 *
 * To run a mutation, you first call `useDeleteAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssetsMutation, { data, loading, error }] = useDeleteAssetsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAssetsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssetsMutation, DeleteAssetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssetsMutation, DeleteAssetsMutationVariables>(DeleteAssetsDocument, options);
      }
export type DeleteAssetsMutationHookResult = ReturnType<typeof useDeleteAssetsMutation>;
export type DeleteAssetsMutationResult = Apollo.MutationResult<DeleteAssetsMutation>;
export type DeleteAssetsMutationOptions = Apollo.BaseMutationOptions<DeleteAssetsMutation, DeleteAssetsMutationVariables>;
export const DeleteBrandDocument = gql`
    mutation DeleteBrand($id: ID!) {
  deleteBrand(input: {id: $id}) {
    response {
      success
      id
    }
  }
}
    `;
export type DeleteBrandMutationFn = Apollo.MutationFunction<DeleteBrandMutation, DeleteBrandMutationVariables>;

/**
 * __useDeleteBrandMutation__
 *
 * To run a mutation, you first call `useDeleteBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBrandMutation, { data, loading, error }] = useDeleteBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBrandMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBrandMutation, DeleteBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBrandMutation, DeleteBrandMutationVariables>(DeleteBrandDocument, options);
      }
export type DeleteBrandMutationHookResult = ReturnType<typeof useDeleteBrandMutation>;
export type DeleteBrandMutationResult = Apollo.MutationResult<DeleteBrandMutation>;
export type DeleteBrandMutationOptions = Apollo.BaseMutationOptions<DeleteBrandMutation, DeleteBrandMutationVariables>;
export const DeleteCustomerBranchDocument = gql`
    mutation DeleteCustomerBranch($id: ID!) {
  deleteCustomerBranch(input: {id: $id}) {
    response {
      id
      success
    }
  }
}
    `;
export type DeleteCustomerBranchMutationFn = Apollo.MutationFunction<DeleteCustomerBranchMutation, DeleteCustomerBranchMutationVariables>;

/**
 * __useDeleteCustomerBranchMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerBranchMutation, { data, loading, error }] = useDeleteCustomerBranchMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomerBranchMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerBranchMutation, DeleteCustomerBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerBranchMutation, DeleteCustomerBranchMutationVariables>(DeleteCustomerBranchDocument, options);
      }
export type DeleteCustomerBranchMutationHookResult = ReturnType<typeof useDeleteCustomerBranchMutation>;
export type DeleteCustomerBranchMutationResult = Apollo.MutationResult<DeleteCustomerBranchMutation>;
export type DeleteCustomerBranchMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerBranchMutation, DeleteCustomerBranchMutationVariables>;
export const DeleteFeeDocument = gql`
    mutation DeleteFee($input: DeleteFeesInput!) {
  deleteFee(input: $input) {
    response {
      id
      error
      success
    }
  }
}
    `;
export type DeleteFeeMutationFn = Apollo.MutationFunction<DeleteFeeMutation, DeleteFeeMutationVariables>;

/**
 * __useDeleteFeeMutation__
 *
 * To run a mutation, you first call `useDeleteFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeeMutation, { data, loading, error }] = useDeleteFeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFeeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFeeMutation, DeleteFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFeeMutation, DeleteFeeMutationVariables>(DeleteFeeDocument, options);
      }
export type DeleteFeeMutationHookResult = ReturnType<typeof useDeleteFeeMutation>;
export type DeleteFeeMutationResult = Apollo.MutationResult<DeleteFeeMutation>;
export type DeleteFeeMutationOptions = Apollo.BaseMutationOptions<DeleteFeeMutation, DeleteFeeMutationVariables>;
export const DeletePeripheralDocument = gql`
    mutation DeletePeripheral($id: ID!) {
  deletePeripheral(input: {id: $id}) {
    success
    message
    peripheral {
      id
      peripheralCategory {
        id
        name
      }
    }
  }
}
    `;
export type DeletePeripheralMutationFn = Apollo.MutationFunction<DeletePeripheralMutation, DeletePeripheralMutationVariables>;

/**
 * __useDeletePeripheralMutation__
 *
 * To run a mutation, you first call `useDeletePeripheralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePeripheralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePeripheralMutation, { data, loading, error }] = useDeletePeripheralMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePeripheralMutation(baseOptions?: Apollo.MutationHookOptions<DeletePeripheralMutation, DeletePeripheralMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePeripheralMutation, DeletePeripheralMutationVariables>(DeletePeripheralDocument, options);
      }
export type DeletePeripheralMutationHookResult = ReturnType<typeof useDeletePeripheralMutation>;
export type DeletePeripheralMutationResult = Apollo.MutationResult<DeletePeripheralMutation>;
export type DeletePeripheralMutationOptions = Apollo.BaseMutationOptions<DeletePeripheralMutation, DeletePeripheralMutationVariables>;
export const DeleteSupplierDocument = gql`
    mutation DeleteSupplier($id: ID!) {
  deleteSupplier(input: {id: $id}) {
    supplier {
      id
      name
      erpId
    }
  }
}
    `;
export type DeleteSupplierMutationFn = Apollo.MutationFunction<DeleteSupplierMutation, DeleteSupplierMutationVariables>;

/**
 * __useDeleteSupplierMutation__
 *
 * To run a mutation, you first call `useDeleteSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSupplierMutation, { data, loading, error }] = useDeleteSupplierMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSupplierMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSupplierMutation, DeleteSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSupplierMutation, DeleteSupplierMutationVariables>(DeleteSupplierDocument, options);
      }
export type DeleteSupplierMutationHookResult = ReturnType<typeof useDeleteSupplierMutation>;
export type DeleteSupplierMutationResult = Apollo.MutationResult<DeleteSupplierMutation>;
export type DeleteSupplierMutationOptions = Apollo.BaseMutationOptions<DeleteSupplierMutation, DeleteSupplierMutationVariables>;
export const DeleteTerminalDocument = gql`
    mutation DeleteTerminal($id: ID!) {
  deleteTerminal(input: {id: $id}) {
    terminal {
      id
      name
      erpId
    }
  }
}
    `;
export type DeleteTerminalMutationFn = Apollo.MutationFunction<DeleteTerminalMutation, DeleteTerminalMutationVariables>;

/**
 * __useDeleteTerminalMutation__
 *
 * To run a mutation, you first call `useDeleteTerminalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTerminalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTerminalMutation, { data, loading, error }] = useDeleteTerminalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTerminalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTerminalMutation, DeleteTerminalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTerminalMutation, DeleteTerminalMutationVariables>(DeleteTerminalDocument, options);
      }
export type DeleteTerminalMutationHookResult = ReturnType<typeof useDeleteTerminalMutation>;
export type DeleteTerminalMutationResult = Apollo.MutationResult<DeleteTerminalMutation>;
export type DeleteTerminalMutationOptions = Apollo.BaseMutationOptions<DeleteTerminalMutation, DeleteTerminalMutationVariables>;
export const DirectUploadPandaDocumentDocument = gql`
    mutation DirectUploadPandaDocument($data: DirectAttachmentInput!) {
  directUploadPandaDocument(input: {data: $data}) {
    pandaDocument {
      id
    }
  }
}
    `;
export type DirectUploadPandaDocumentMutationFn = Apollo.MutationFunction<DirectUploadPandaDocumentMutation, DirectUploadPandaDocumentMutationVariables>;

/**
 * __useDirectUploadPandaDocumentMutation__
 *
 * To run a mutation, you first call `useDirectUploadPandaDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDirectUploadPandaDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [directUploadPandaDocumentMutation, { data, loading, error }] = useDirectUploadPandaDocumentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDirectUploadPandaDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DirectUploadPandaDocumentMutation, DirectUploadPandaDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DirectUploadPandaDocumentMutation, DirectUploadPandaDocumentMutationVariables>(DirectUploadPandaDocumentDocument, options);
      }
export type DirectUploadPandaDocumentMutationHookResult = ReturnType<typeof useDirectUploadPandaDocumentMutation>;
export type DirectUploadPandaDocumentMutationResult = Apollo.MutationResult<DirectUploadPandaDocumentMutation>;
export type DirectUploadPandaDocumentMutationOptions = Apollo.BaseMutationOptions<DirectUploadPandaDocumentMutation, DirectUploadPandaDocumentMutationVariables>;
export const FetchAssetsDocument = gql`
    query fetchAssets($limit: Int, $offset: Int, $sorter: [AssetSorter!], $customerIds: [ID!], $customerBranchId: [ID!], $filter: String, $types: [AssetTypeEnum!]) {
  filteredAssets(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {customerIds: $customerIds, customerBranchId: $customerBranchId, all: $filter, types: $types}
  ) {
    collection {
      id
      status
      name
      category
      qrCodeText
      licensePlateNumber
      erpId
      irelyId
      lastSyncedTime
      netsuiteId
      lastActiveTenantId
      rfidCode
      assignedPandaBox {
        id
        name
      }
      subscriptions {
        id
        product {
          id
          erpId
          name
        }
      }
      customerBranch {
        id
        name
        address
        customer {
          id
          name
          address
        }
      }
      ...AssetWithProductCategoryNames
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    ${AssetWithProductCategoryNamesFragmentDoc}`;

/**
 * __useFetchAssetsQuery__
 *
 * To run a query within a React component, call `useFetchAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAssetsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      customerIds: // value for 'customerIds'
 *      customerBranchId: // value for 'customerBranchId'
 *      filter: // value for 'filter'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useFetchAssetsQuery(baseOptions?: Apollo.QueryHookOptions<FetchAssetsQuery, FetchAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAssetsQuery, FetchAssetsQueryVariables>(FetchAssetsDocument, options);
      }
export function useFetchAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAssetsQuery, FetchAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAssetsQuery, FetchAssetsQueryVariables>(FetchAssetsDocument, options);
        }
export type FetchAssetsQueryHookResult = ReturnType<typeof useFetchAssetsQuery>;
export type FetchAssetsLazyQueryHookResult = ReturnType<typeof useFetchAssetsLazyQuery>;
export type FetchAssetsQueryResult = Apollo.QueryResult<FetchAssetsQuery, FetchAssetsQueryVariables>;
export const FetchAssetsWithHubsDocument = gql`
    query fetchAssetsWithHubs($limit: Int, $offset: Int, $sorter: [AssetSorter!], $customerIds: [ID!], $customerBranchId: [ID!], $filter: String, $types: [AssetTypeEnum!]) {
  filteredAssets(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {customerIds: $customerIds, customerBranchId: $customerBranchId, all: $filter, types: $types}
  ) {
    collection {
      id
      status
      name
      category
      qrCodeText
      licensePlateNumber
      erpId
      irelyId
      lastSyncedTime
      lastActiveTenantId
      rfidCode
      createdBy {
        name
      }
      assignedPandaBox {
        id
        name
      }
      subscriptions {
        id
        product {
          id
          erpId
          name
        }
      }
      customerBranch {
        id
        name
        address
        customer {
          id
          name
          address
        }
      }
      hubs {
        id
        name
      }
      ...AssetWithProductCategoryNames
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    ${AssetWithProductCategoryNamesFragmentDoc}`;

/**
 * __useFetchAssetsWithHubsQuery__
 *
 * To run a query within a React component, call `useFetchAssetsWithHubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAssetsWithHubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAssetsWithHubsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      customerIds: // value for 'customerIds'
 *      customerBranchId: // value for 'customerBranchId'
 *      filter: // value for 'filter'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useFetchAssetsWithHubsQuery(baseOptions?: Apollo.QueryHookOptions<FetchAssetsWithHubsQuery, FetchAssetsWithHubsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAssetsWithHubsQuery, FetchAssetsWithHubsQueryVariables>(FetchAssetsWithHubsDocument, options);
      }
export function useFetchAssetsWithHubsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAssetsWithHubsQuery, FetchAssetsWithHubsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAssetsWithHubsQuery, FetchAssetsWithHubsQueryVariables>(FetchAssetsWithHubsDocument, options);
        }
export type FetchAssetsWithHubsQueryHookResult = ReturnType<typeof useFetchAssetsWithHubsQuery>;
export type FetchAssetsWithHubsLazyQueryHookResult = ReturnType<typeof useFetchAssetsWithHubsLazyQuery>;
export type FetchAssetsWithHubsQueryResult = Apollo.QueryResult<FetchAssetsWithHubsQuery, FetchAssetsWithHubsQueryVariables>;
export const BranchRelatedToCustomerDocument = gql`
    query BranchRelatedToCustomer($id: ID!) {
  customer(id: $id) {
    customerBranches {
      id
      name
      deliveryInstruction
      erpId
      netsuiteName
      site {
        address
        id
        lat
        lng
        radius
      }
    }
  }
}
    `;

/**
 * __useBranchRelatedToCustomerQuery__
 *
 * To run a query within a React component, call `useBranchRelatedToCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useBranchRelatedToCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBranchRelatedToCustomerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBranchRelatedToCustomerQuery(baseOptions: Apollo.QueryHookOptions<BranchRelatedToCustomerQuery, BranchRelatedToCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BranchRelatedToCustomerQuery, BranchRelatedToCustomerQueryVariables>(BranchRelatedToCustomerDocument, options);
      }
export function useBranchRelatedToCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BranchRelatedToCustomerQuery, BranchRelatedToCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BranchRelatedToCustomerQuery, BranchRelatedToCustomerQueryVariables>(BranchRelatedToCustomerDocument, options);
        }
export type BranchRelatedToCustomerQueryHookResult = ReturnType<typeof useBranchRelatedToCustomerQuery>;
export type BranchRelatedToCustomerLazyQueryHookResult = ReturnType<typeof useBranchRelatedToCustomerLazyQuery>;
export type BranchRelatedToCustomerQueryResult = Apollo.QueryResult<BranchRelatedToCustomerQuery, BranchRelatedToCustomerQueryVariables>;
export const BrandDocument = gql`
    query Brand($id: ID!) {
  brand(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useBrandQuery__
 *
 * To run a query within a React component, call `useBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBrandQuery(baseOptions: Apollo.QueryHookOptions<BrandQuery, BrandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandQuery, BrandQueryVariables>(BrandDocument, options);
      }
export function useBrandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandQuery, BrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandQuery, BrandQueryVariables>(BrandDocument, options);
        }
export type BrandQueryHookResult = ReturnType<typeof useBrandQuery>;
export type BrandLazyQueryHookResult = ReturnType<typeof useBrandLazyQuery>;
export type BrandQueryResult = Apollo.QueryResult<BrandQuery, BrandQueryVariables>;
export const FetchBrandsDocument = gql`
    query FetchBrands {
  brands {
    id
    name
  }
}
    `;

/**
 * __useFetchBrandsQuery__
 *
 * To run a query within a React component, call `useFetchBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchBrandsQuery(baseOptions?: Apollo.QueryHookOptions<FetchBrandsQuery, FetchBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchBrandsQuery, FetchBrandsQueryVariables>(FetchBrandsDocument, options);
      }
export function useFetchBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchBrandsQuery, FetchBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchBrandsQuery, FetchBrandsQueryVariables>(FetchBrandsDocument, options);
        }
export type FetchBrandsQueryHookResult = ReturnType<typeof useFetchBrandsQuery>;
export type FetchBrandsLazyQueryHookResult = ReturnType<typeof useFetchBrandsLazyQuery>;
export type FetchBrandsQueryResult = Apollo.QueryResult<FetchBrandsQuery, FetchBrandsQueryVariables>;
export const CapacityTypesDocument = gql`
    query CapacityTypes {
  capacityTypes {
    description
    value
  }
}
    `;

/**
 * __useCapacityTypesQuery__
 *
 * To run a query within a React component, call `useCapacityTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapacityTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapacityTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCapacityTypesQuery(baseOptions?: Apollo.QueryHookOptions<CapacityTypesQuery, CapacityTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CapacityTypesQuery, CapacityTypesQueryVariables>(CapacityTypesDocument, options);
      }
export function useCapacityTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CapacityTypesQuery, CapacityTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CapacityTypesQuery, CapacityTypesQueryVariables>(CapacityTypesDocument, options);
        }
export type CapacityTypesQueryHookResult = ReturnType<typeof useCapacityTypesQuery>;
export type CapacityTypesLazyQueryHookResult = ReturnType<typeof useCapacityTypesLazyQuery>;
export type CapacityTypesQueryResult = Apollo.QueryResult<CapacityTypesQuery, CapacityTypesQueryVariables>;
export const FetchCommonCarriersDocument = gql`
    query FetchCommonCarriers($limit: Int = 20, $offset: Int = 0, $customFilter: CcTenantFilter = {}, $sorter: [CcTenantSorter!]) {
  filteredCcTenants(
    limit: $limit
    offset: $offset
    filter: $customFilter
    sorter: $sorter
  ) {
    collection {
      erpId
      name
      id
      secondaryEmails
      userAttributes
      carrierTenant {
        id
        name
        slug
        adminUsers {
          id
          name
          email
          phone
        }
      }
      site {
        id
        address
        city
        state
        zip
        lat
        lng
      }
      carrierTenantId
    }
    metadata {
      hasMore
      totalCount
    }
  }
}
    `;

/**
 * __useFetchCommonCarriersQuery__
 *
 * To run a query within a React component, call `useFetchCommonCarriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCommonCarriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCommonCarriersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      customFilter: // value for 'customFilter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchCommonCarriersQuery(baseOptions?: Apollo.QueryHookOptions<FetchCommonCarriersQuery, FetchCommonCarriersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCommonCarriersQuery, FetchCommonCarriersQueryVariables>(FetchCommonCarriersDocument, options);
      }
export function useFetchCommonCarriersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCommonCarriersQuery, FetchCommonCarriersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCommonCarriersQuery, FetchCommonCarriersQueryVariables>(FetchCommonCarriersDocument, options);
        }
export type FetchCommonCarriersQueryHookResult = ReturnType<typeof useFetchCommonCarriersQuery>;
export type FetchCommonCarriersLazyQueryHookResult = ReturnType<typeof useFetchCommonCarriersLazyQuery>;
export type FetchCommonCarriersQueryResult = Apollo.QueryResult<FetchCommonCarriersQuery, FetchCommonCarriersQueryVariables>;
export const FetchCreditExceededCustomersDocument = gql`
    query FetchCreditExceededCustomers($limit: Int, $offset: Int, $creditLimitExceededFilter: Boolean) {
  filteredCustomers(
    limit: $limit
    offset: $offset
    filter: {creditLimitExceeded: $creditLimitExceededFilter}
  ) {
    collection {
      id
      name
      creditLimitExceeded
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFetchCreditExceededCustomersQuery__
 *
 * To run a query within a React component, call `useFetchCreditExceededCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCreditExceededCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCreditExceededCustomersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      creditLimitExceededFilter: // value for 'creditLimitExceededFilter'
 *   },
 * });
 */
export function useFetchCreditExceededCustomersQuery(baseOptions?: Apollo.QueryHookOptions<FetchCreditExceededCustomersQuery, FetchCreditExceededCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCreditExceededCustomersQuery, FetchCreditExceededCustomersQueryVariables>(FetchCreditExceededCustomersDocument, options);
      }
export function useFetchCreditExceededCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCreditExceededCustomersQuery, FetchCreditExceededCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCreditExceededCustomersQuery, FetchCreditExceededCustomersQueryVariables>(FetchCreditExceededCustomersDocument, options);
        }
export type FetchCreditExceededCustomersQueryHookResult = ReturnType<typeof useFetchCreditExceededCustomersQuery>;
export type FetchCreditExceededCustomersLazyQueryHookResult = ReturnType<typeof useFetchCreditExceededCustomersLazyQuery>;
export type FetchCreditExceededCustomersQueryResult = Apollo.QueryResult<FetchCreditExceededCustomersQuery, FetchCreditExceededCustomersQueryVariables>;
export const FetchCustomerAssetDocument = gql`
    query fetchCustomerAsset($id: ID!) {
  asset(id: $id) {
    ...customerAssetData
  }
}
    ${CustomerAssetDataFragmentDoc}`;

/**
 * __useFetchCustomerAssetQuery__
 *
 * To run a query within a React component, call `useFetchCustomerAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomerAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomerAssetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchCustomerAssetQuery(baseOptions: Apollo.QueryHookOptions<FetchCustomerAssetQuery, FetchCustomerAssetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomerAssetQuery, FetchCustomerAssetQueryVariables>(FetchCustomerAssetDocument, options);
      }
export function useFetchCustomerAssetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomerAssetQuery, FetchCustomerAssetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomerAssetQuery, FetchCustomerAssetQueryVariables>(FetchCustomerAssetDocument, options);
        }
export type FetchCustomerAssetQueryHookResult = ReturnType<typeof useFetchCustomerAssetQuery>;
export type FetchCustomerAssetLazyQueryHookResult = ReturnType<typeof useFetchCustomerAssetLazyQuery>;
export type FetchCustomerAssetQueryResult = Apollo.QueryResult<FetchCustomerAssetQuery, FetchCustomerAssetQueryVariables>;
export const FetchCustomerAssetFormContextDocument = gql`
    query fetchCustomerAssetFormContext($customerId: ID!) {
  customer(id: $customerId) {
    id
    customerBranches {
      id
      name
      address
      status
      site {
        lat
        lng
      }
    }
  }
  productCategories {
    id
    name
  }
}
    `;

/**
 * __useFetchCustomerAssetFormContextQuery__
 *
 * To run a query within a React component, call `useFetchCustomerAssetFormContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomerAssetFormContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomerAssetFormContextQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useFetchCustomerAssetFormContextQuery(baseOptions: Apollo.QueryHookOptions<FetchCustomerAssetFormContextQuery, FetchCustomerAssetFormContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomerAssetFormContextQuery, FetchCustomerAssetFormContextQueryVariables>(FetchCustomerAssetFormContextDocument, options);
      }
export function useFetchCustomerAssetFormContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomerAssetFormContextQuery, FetchCustomerAssetFormContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomerAssetFormContextQuery, FetchCustomerAssetFormContextQueryVariables>(FetchCustomerAssetFormContextDocument, options);
        }
export type FetchCustomerAssetFormContextQueryHookResult = ReturnType<typeof useFetchCustomerAssetFormContextQuery>;
export type FetchCustomerAssetFormContextLazyQueryHookResult = ReturnType<typeof useFetchCustomerAssetFormContextLazyQuery>;
export type FetchCustomerAssetFormContextQueryResult = Apollo.QueryResult<FetchCustomerAssetFormContextQuery, FetchCustomerAssetFormContextQueryVariables>;
export const FetchCustomerAssetsDocument = gql`
    query fetchCustomerAssets($limit: Int, $offset: Int, $sorter: [AssetSorter!], $customerIds: [ID!], $customerBranchId: [ID!], $filter: String, $types: [AssetTypeEnum!], $approvalStatus: AssetApprovalStatusEnum) {
  filteredAssets(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {customerIds: $customerIds, customerBranchId: $customerBranchId, all: $filter, types: $types, approvalStatus: $approvalStatus}
  ) {
    collection {
      id
      status
      name
      category
      data
      qrCodeText
      licensePlateNumber
      installDate
      erpId
      netsuiteId
      rfidCode
      lastActiveTenantId
      createdBy {
        name
      }
      customer {
        id
        tankReadingThreshold
      }
      subscriptions {
        id
        product {
          id
          erpId
          productType
        }
      }
      customerBranch {
        id
        name
        address
        purchaseOrder
        hubs {
          id
          name
        }
        customer {
          id
          name
          address
        }
      }
      ...AssetWithProductCategoryNames
      ...AssetWithProductNames
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    ${AssetWithProductCategoryNamesFragmentDoc}
${AssetWithProductNamesFragmentDoc}`;

/**
 * __useFetchCustomerAssetsQuery__
 *
 * To run a query within a React component, call `useFetchCustomerAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomerAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomerAssetsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      customerIds: // value for 'customerIds'
 *      customerBranchId: // value for 'customerBranchId'
 *      filter: // value for 'filter'
 *      types: // value for 'types'
 *      approvalStatus: // value for 'approvalStatus'
 *   },
 * });
 */
export function useFetchCustomerAssetsQuery(baseOptions?: Apollo.QueryHookOptions<FetchCustomerAssetsQuery, FetchCustomerAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomerAssetsQuery, FetchCustomerAssetsQueryVariables>(FetchCustomerAssetsDocument, options);
      }
export function useFetchCustomerAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomerAssetsQuery, FetchCustomerAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomerAssetsQuery, FetchCustomerAssetsQueryVariables>(FetchCustomerAssetsDocument, options);
        }
export type FetchCustomerAssetsQueryHookResult = ReturnType<typeof useFetchCustomerAssetsQuery>;
export type FetchCustomerAssetsLazyQueryHookResult = ReturnType<typeof useFetchCustomerAssetsLazyQuery>;
export type FetchCustomerAssetsQueryResult = Apollo.QueryResult<FetchCustomerAssetsQuery, FetchCustomerAssetsQueryVariables>;
export const CustomerBranchDocument = gql`
    query CustomerBranch($id: ID!) {
  customerBranch(id: $id) {
    id
    name
    deliveryInstructionUpdatedAt
    deliveryInstructionUpdatedBy
    resourcePricingId
    deliveryInstruction
    cardLockSiteNumber
    erpId
    priceCode
    purchaseOrderType
    purchaseOrder
    taggings {
      id
      tag {
        id
        name
        colorCode
        iconName
        description
      }
    }
    poNumber
    autoEmailDeliveryTicket
    netsuiteId
    netsuiteName
    isHub
    attachBolOnDeliveryTicket
    isCustomerSignatureRequired
    nonEditableRecords
    qboItemizeLineItemOnSalesOrder
    onlyShowGrossGallonsInDeliveryTicket
    syncSalesToD1
    crudePricings {
      id
      range
      pandaPriceRateType {
        id
        name
      }
      productId
    }
    hubResources {
      id
      hub {
        id
        name
        address
        status
      }
    }
    pickupPointCodes {
      id
      name
      code
    }
    loadingAccounts {
      id
    }
    suppliers {
      id
      name
      active
    }
    addressBooks {
      id
      name
      email
      phone
      address
      note
      jobTitle
      addressBookType
      hasAccessToCustomerPortal
      isDeliveryTicketRecipient
    }
    site {
      address
      id
      lat
      lng
      radius
    }
    status
    lineOfServices {
      id
      nameWithAncestors
    }
    applicableFees {
      id
      parentFeeId
      isDefault
      hardcoded
      netsuiteId
      quantity
      price
      fee {
        id
        name
        price
        applicableType
      }
    }
    pandaDocuments {
      id
      documentType
      externalFileData {
        id
        contentType
        filename
        url
      }
    }
    customer {
      id
    }
  }
}
    `;

/**
 * __useCustomerBranchQuery__
 *
 * To run a query within a React component, call `useCustomerBranchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerBranchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerBranchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerBranchQuery(baseOptions: Apollo.QueryHookOptions<CustomerBranchQuery, CustomerBranchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerBranchQuery, CustomerBranchQueryVariables>(CustomerBranchDocument, options);
      }
export function useCustomerBranchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerBranchQuery, CustomerBranchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerBranchQuery, CustomerBranchQueryVariables>(CustomerBranchDocument, options);
        }
export type CustomerBranchQueryHookResult = ReturnType<typeof useCustomerBranchQuery>;
export type CustomerBranchLazyQueryHookResult = ReturnType<typeof useCustomerBranchLazyQuery>;
export type CustomerBranchQueryResult = Apollo.QueryResult<CustomerBranchQuery, CustomerBranchQueryVariables>;
export const CustomerBranchDetailPageDocument = gql`
    query CustomerBranchDetailPage($id: ID!) {
  customerBranch(id: $id) {
    id
    name
    resourcePricingId
    irelyId
    site {
      address
      id
      lat
      lng
      radius
    }
    customer {
      resourcePricingId
    }
  }
}
    `;

/**
 * __useCustomerBranchDetailPageQuery__
 *
 * To run a query within a React component, call `useCustomerBranchDetailPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerBranchDetailPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerBranchDetailPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerBranchDetailPageQuery(baseOptions: Apollo.QueryHookOptions<CustomerBranchDetailPageQuery, CustomerBranchDetailPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerBranchDetailPageQuery, CustomerBranchDetailPageQueryVariables>(CustomerBranchDetailPageDocument, options);
      }
export function useCustomerBranchDetailPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerBranchDetailPageQuery, CustomerBranchDetailPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerBranchDetailPageQuery, CustomerBranchDetailPageQueryVariables>(CustomerBranchDetailPageDocument, options);
        }
export type CustomerBranchDetailPageQueryHookResult = ReturnType<typeof useCustomerBranchDetailPageQuery>;
export type CustomerBranchDetailPageLazyQueryHookResult = ReturnType<typeof useCustomerBranchDetailPageLazyQuery>;
export type CustomerBranchDetailPageQueryResult = Apollo.QueryResult<CustomerBranchDetailPageQuery, CustomerBranchDetailPageQueryVariables>;
export const CustomerBranchResourceScheduleDocument = gql`
    query CustomerBranchResourceSchedule($id: ID!) {
  customerBranch(id: $id) {
    id
    resourceSchedule {
      preferrableType
      preferrableId
      id
      availability {
        day
        startTime
        endTime
        bestEndTime
        bestStartTime
      }
    }
  }
}
    `;

/**
 * __useCustomerBranchResourceScheduleQuery__
 *
 * To run a query within a React component, call `useCustomerBranchResourceScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerBranchResourceScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerBranchResourceScheduleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerBranchResourceScheduleQuery(baseOptions: Apollo.QueryHookOptions<CustomerBranchResourceScheduleQuery, CustomerBranchResourceScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerBranchResourceScheduleQuery, CustomerBranchResourceScheduleQueryVariables>(CustomerBranchResourceScheduleDocument, options);
      }
export function useCustomerBranchResourceScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerBranchResourceScheduleQuery, CustomerBranchResourceScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerBranchResourceScheduleQuery, CustomerBranchResourceScheduleQueryVariables>(CustomerBranchResourceScheduleDocument, options);
        }
export type CustomerBranchResourceScheduleQueryHookResult = ReturnType<typeof useCustomerBranchResourceScheduleQuery>;
export type CustomerBranchResourceScheduleLazyQueryHookResult = ReturnType<typeof useCustomerBranchResourceScheduleLazyQuery>;
export type CustomerBranchResourceScheduleQueryResult = Apollo.QueryResult<CustomerBranchResourceScheduleQuery, CustomerBranchResourceScheduleQueryVariables>;
export const CustomerProfileDocument = gql`
    query CustomerProfile($id: ID!) {
  customer(id: $id) {
    id
    resourcePricingId
    name
    groupName
    thirdPartyDelivery
    poBoxNumber
    erpId
    accountId
    status
    poNumber
    quickbridgeId
    purchaseOrder
    purchaseOrderType
    address
    exemptStatus
    netsuiteId
    netsuiteName
    creditChecked
    attachPostDeliveryImageOnDeliveryTicket
    creditLimitPercentageBuffer
    creditLimitDaysOverdueBuffer
    creditLimit
    currentBalance
    daysOverdue
    dueDate
    vendorErpId
    arDivisionNumber
    deliveryInstruction
    fleetCardNumbers
    enableCreateDeliveryOrder
    customerPortalPermissions
    portalAccessLevel
    tankReadingThreshold
    permitNumber
    totalRequestedVolume
    productPurchaseLimitId
    irelyId
    productPurchaseLimit {
      id
      name
      product {
        id
        name
      }
      volume
      timeUnit
    }
    site {
      id
      lat
      lng
    }
    nonEditableRecords
    preferredDrivers {
      id
      name
    }
    applicableFees {
      id
      isDefault
      hardcoded
      netsuiteId
      fee {
        id
        name
        price
        applicableType
      }
    }
    crudePricings {
      id
      range
      pandaPriceRateType {
        id
        name
      }
      productId
    }
    addressBooks {
      id
      name
      email
      phone
      address
      note
      jobTitle
      isDeliveryTicketRecipient
      hasAccessToCustomerPortal
      showInviteLink
      image {
        url
      }
    }
    users {
      id
      name
      email
      phone
      status
    }
    hubResources {
      id
      hub {
        id
        name
        address
        status
      }
    }
    nonEditableRecords
    lineOfServices {
      id
      nameWithAncestors
    }
    epaId
    agreedLoadGallon
    customerSegment {
      id
    }
    paymentTerm {
      id
    }
    paymentTypeName
    feinNumber
    taggings {
      id
      tag {
        id
        name
        colorCode
        iconName
        description
      }
    }
    hideVendorPricing
  }
}
    `;

/**
 * __useCustomerProfileQuery__
 *
 * To run a query within a React component, call `useCustomerProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerProfileQuery(baseOptions: Apollo.QueryHookOptions<CustomerProfileQuery, CustomerProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerProfileQuery, CustomerProfileQueryVariables>(CustomerProfileDocument, options);
      }
export function useCustomerProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerProfileQuery, CustomerProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerProfileQuery, CustomerProfileQueryVariables>(CustomerProfileDocument, options);
        }
export type CustomerProfileQueryHookResult = ReturnType<typeof useCustomerProfileQuery>;
export type CustomerProfileLazyQueryHookResult = ReturnType<typeof useCustomerProfileLazyQuery>;
export type CustomerProfileQueryResult = Apollo.QueryResult<CustomerProfileQuery, CustomerProfileQueryVariables>;
export const FetchCustomerFeesDocument = gql`
    query fetchCustomerFees($id: ID!) {
  customer(id: $id) {
    id
    applicableFees {
      id
      isDefault
      hardcoded
      netsuiteId
      fee {
        id
        name
        price
        applicableType
      }
    }
  }
}
    `;

/**
 * __useFetchCustomerFeesQuery__
 *
 * To run a query within a React component, call `useFetchCustomerFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomerFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomerFeesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchCustomerFeesQuery(baseOptions: Apollo.QueryHookOptions<FetchCustomerFeesQuery, FetchCustomerFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomerFeesQuery, FetchCustomerFeesQueryVariables>(FetchCustomerFeesDocument, options);
      }
export function useFetchCustomerFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomerFeesQuery, FetchCustomerFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomerFeesQuery, FetchCustomerFeesQueryVariables>(FetchCustomerFeesDocument, options);
        }
export type FetchCustomerFeesQueryHookResult = ReturnType<typeof useFetchCustomerFeesQuery>;
export type FetchCustomerFeesLazyQueryHookResult = ReturnType<typeof useFetchCustomerFeesLazyQuery>;
export type FetchCustomerFeesQueryResult = Apollo.QueryResult<FetchCustomerFeesQuery, FetchCustomerFeesQueryVariables>;
export const CustomerFormContextDocument = gql`
    query CustomerFormContext {
  drivers {
    id
    name
  }
  fees {
    id
    name
    applicableType
  }
}
    `;

/**
 * __useCustomerFormContextQuery__
 *
 * To run a query within a React component, call `useCustomerFormContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerFormContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerFormContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerFormContextQuery(baseOptions?: Apollo.QueryHookOptions<CustomerFormContextQuery, CustomerFormContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerFormContextQuery, CustomerFormContextQueryVariables>(CustomerFormContextDocument, options);
      }
export function useCustomerFormContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerFormContextQuery, CustomerFormContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerFormContextQuery, CustomerFormContextQueryVariables>(CustomerFormContextDocument, options);
        }
export type CustomerFormContextQueryHookResult = ReturnType<typeof useCustomerFormContextQuery>;
export type CustomerFormContextLazyQueryHookResult = ReturnType<typeof useCustomerFormContextLazyQuery>;
export type CustomerFormContextQueryResult = Apollo.QueryResult<CustomerFormContextQuery, CustomerFormContextQueryVariables>;
export const FetchCustomerNameAndIdDocument = gql`
    query FetchCustomerNameAndId($id: ID!) {
  customer(id: $id) {
    id
    name
    addressBooks {
      id
      name
    }
    tankReadingThreshold
  }
}
    `;

/**
 * __useFetchCustomerNameAndIdQuery__
 *
 * To run a query within a React component, call `useFetchCustomerNameAndIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomerNameAndIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomerNameAndIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchCustomerNameAndIdQuery(baseOptions: Apollo.QueryHookOptions<FetchCustomerNameAndIdQuery, FetchCustomerNameAndIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomerNameAndIdQuery, FetchCustomerNameAndIdQueryVariables>(FetchCustomerNameAndIdDocument, options);
      }
export function useFetchCustomerNameAndIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomerNameAndIdQuery, FetchCustomerNameAndIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomerNameAndIdQuery, FetchCustomerNameAndIdQueryVariables>(FetchCustomerNameAndIdDocument, options);
        }
export type FetchCustomerNameAndIdQueryHookResult = ReturnType<typeof useFetchCustomerNameAndIdQuery>;
export type FetchCustomerNameAndIdLazyQueryHookResult = ReturnType<typeof useFetchCustomerNameAndIdLazyQuery>;
export type FetchCustomerNameAndIdQueryResult = Apollo.QueryResult<FetchCustomerNameAndIdQuery, FetchCustomerNameAndIdQueryVariables>;
export const FetchCustomerPointOfContactDocument = gql`
    query fetchCustomerPointOfContact($id: ID!) {
  customer(id: $id) {
    id
    addressBooks {
      id
      note
      name
      email
      phone
      addressBookType
      image {
        url
      }
      address
      jobTitle
      isDeliveryTicketRecipient
      hasAccessToCustomerPortal
    }
  }
}
    `;

/**
 * __useFetchCustomerPointOfContactQuery__
 *
 * To run a query within a React component, call `useFetchCustomerPointOfContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomerPointOfContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomerPointOfContactQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchCustomerPointOfContactQuery(baseOptions: Apollo.QueryHookOptions<FetchCustomerPointOfContactQuery, FetchCustomerPointOfContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomerPointOfContactQuery, FetchCustomerPointOfContactQueryVariables>(FetchCustomerPointOfContactDocument, options);
      }
export function useFetchCustomerPointOfContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomerPointOfContactQuery, FetchCustomerPointOfContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomerPointOfContactQuery, FetchCustomerPointOfContactQueryVariables>(FetchCustomerPointOfContactDocument, options);
        }
export type FetchCustomerPointOfContactQueryHookResult = ReturnType<typeof useFetchCustomerPointOfContactQuery>;
export type FetchCustomerPointOfContactLazyQueryHookResult = ReturnType<typeof useFetchCustomerPointOfContactLazyQuery>;
export type FetchCustomerPointOfContactQueryResult = Apollo.QueryResult<FetchCustomerPointOfContactQuery, FetchCustomerPointOfContactQueryVariables>;
export const CustomerResourceScheduleDocument = gql`
    query CustomerResourceSchedule($id: ID!) {
  customer(id: $id) {
    id
    resourceSchedule {
      preferrableType
      preferrableId
      id
      availability {
        day
        startTime
        endTime
        bestEndTime
        bestStartTime
      }
    }
  }
}
    `;

/**
 * __useCustomerResourceScheduleQuery__
 *
 * To run a query within a React component, call `useCustomerResourceScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerResourceScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerResourceScheduleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerResourceScheduleQuery(baseOptions: Apollo.QueryHookOptions<CustomerResourceScheduleQuery, CustomerResourceScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerResourceScheduleQuery, CustomerResourceScheduleQueryVariables>(CustomerResourceScheduleDocument, options);
      }
export function useCustomerResourceScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerResourceScheduleQuery, CustomerResourceScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerResourceScheduleQuery, CustomerResourceScheduleQueryVariables>(CustomerResourceScheduleDocument, options);
        }
export type CustomerResourceScheduleQueryHookResult = ReturnType<typeof useCustomerResourceScheduleQuery>;
export type CustomerResourceScheduleLazyQueryHookResult = ReturnType<typeof useCustomerResourceScheduleLazyQuery>;
export type CustomerResourceScheduleQueryResult = Apollo.QueryResult<CustomerResourceScheduleQuery, CustomerResourceScheduleQueryVariables>;
export const FetchCustomerSegmentDetailsDocument = gql`
    query FetchCustomerSegmentDetails($id: ID!) {
  customerSegment(id: $id) {
    id
    name
    code
    segmentType
  }
}
    `;

/**
 * __useFetchCustomerSegmentDetailsQuery__
 *
 * To run a query within a React component, call `useFetchCustomerSegmentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomerSegmentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomerSegmentDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchCustomerSegmentDetailsQuery(baseOptions: Apollo.QueryHookOptions<FetchCustomerSegmentDetailsQuery, FetchCustomerSegmentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomerSegmentDetailsQuery, FetchCustomerSegmentDetailsQueryVariables>(FetchCustomerSegmentDetailsDocument, options);
      }
export function useFetchCustomerSegmentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomerSegmentDetailsQuery, FetchCustomerSegmentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomerSegmentDetailsQuery, FetchCustomerSegmentDetailsQueryVariables>(FetchCustomerSegmentDetailsDocument, options);
        }
export type FetchCustomerSegmentDetailsQueryHookResult = ReturnType<typeof useFetchCustomerSegmentDetailsQuery>;
export type FetchCustomerSegmentDetailsLazyQueryHookResult = ReturnType<typeof useFetchCustomerSegmentDetailsLazyQuery>;
export type FetchCustomerSegmentDetailsQueryResult = Apollo.QueryResult<FetchCustomerSegmentDetailsQuery, FetchCustomerSegmentDetailsQueryVariables>;
export const FetchCustomerSegmentsDocument = gql`
    query FetchCustomerSegments {
  customerSegments {
    id
    name
    code
    segmentType
  }
}
    `;

/**
 * __useFetchCustomerSegmentsQuery__
 *
 * To run a query within a React component, call `useFetchCustomerSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomerSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomerSegmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchCustomerSegmentsQuery(baseOptions?: Apollo.QueryHookOptions<FetchCustomerSegmentsQuery, FetchCustomerSegmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomerSegmentsQuery, FetchCustomerSegmentsQueryVariables>(FetchCustomerSegmentsDocument, options);
      }
export function useFetchCustomerSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomerSegmentsQuery, FetchCustomerSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomerSegmentsQuery, FetchCustomerSegmentsQueryVariables>(FetchCustomerSegmentsDocument, options);
        }
export type FetchCustomerSegmentsQueryHookResult = ReturnType<typeof useFetchCustomerSegmentsQuery>;
export type FetchCustomerSegmentsLazyQueryHookResult = ReturnType<typeof useFetchCustomerSegmentsLazyQuery>;
export type FetchCustomerSegmentsQueryResult = Apollo.QueryResult<FetchCustomerSegmentsQuery, FetchCustomerSegmentsQueryVariables>;
export const FetchCustomerShipToAddressDocument = gql`
    query FetchCustomerShipToAddress($id: ID!) {
  customer(id: $id) {
    id
    customerBranches {
      address
    }
  }
}
    `;

/**
 * __useFetchCustomerShipToAddressQuery__
 *
 * To run a query within a React component, call `useFetchCustomerShipToAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomerShipToAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomerShipToAddressQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchCustomerShipToAddressQuery(baseOptions: Apollo.QueryHookOptions<FetchCustomerShipToAddressQuery, FetchCustomerShipToAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomerShipToAddressQuery, FetchCustomerShipToAddressQueryVariables>(FetchCustomerShipToAddressDocument, options);
      }
export function useFetchCustomerShipToAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomerShipToAddressQuery, FetchCustomerShipToAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomerShipToAddressQuery, FetchCustomerShipToAddressQueryVariables>(FetchCustomerShipToAddressDocument, options);
        }
export type FetchCustomerShipToAddressQueryHookResult = ReturnType<typeof useFetchCustomerShipToAddressQuery>;
export type FetchCustomerShipToAddressLazyQueryHookResult = ReturnType<typeof useFetchCustomerShipToAddressLazyQuery>;
export type FetchCustomerShipToAddressQueryResult = Apollo.QueryResult<FetchCustomerShipToAddressQuery, FetchCustomerShipToAddressQueryVariables>;
export const FetchCustomerUserDocument = gql`
    query fetchCustomerUser($id: ID) {
  filteredCustomerUsers(filter: {id: $id}) {
    collection {
      id
      active
      customer {
        id
      }
      user {
        id
      }
      hubResources {
        id
        hub {
          id
          name
          address
        }
      }
      lineOfServices {
        id
        nameWithAncestors
        name
      }
    }
  }
}
    `;

/**
 * __useFetchCustomerUserQuery__
 *
 * To run a query within a React component, call `useFetchCustomerUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomerUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomerUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchCustomerUserQuery(baseOptions?: Apollo.QueryHookOptions<FetchCustomerUserQuery, FetchCustomerUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomerUserQuery, FetchCustomerUserQueryVariables>(FetchCustomerUserDocument, options);
      }
export function useFetchCustomerUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomerUserQuery, FetchCustomerUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomerUserQuery, FetchCustomerUserQueryVariables>(FetchCustomerUserDocument, options);
        }
export type FetchCustomerUserQueryHookResult = ReturnType<typeof useFetchCustomerUserQuery>;
export type FetchCustomerUserLazyQueryHookResult = ReturnType<typeof useFetchCustomerUserLazyQuery>;
export type FetchCustomerUserQueryResult = Apollo.QueryResult<FetchCustomerUserQuery, FetchCustomerUserQueryVariables>;
export const FetchCustomerUsersDocument = gql`
    query fetchCustomerUsers($limit: Int, $offset: Int, $sorter: [CustomerUserSorter!], $customerId: ID!, $filter: String) {
  customerUsers: filteredCustomerUsers(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {customerId: $customerId, all: $filter}
  ) {
    collection {
      customerUserId: id
      active
      user {
        id
        status
        name
        otp
        phone
        email
        roles {
          id
          name
        }
      }
      lineOfServices {
        id
        nameWithAncestors
        name
      }
    }
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useFetchCustomerUsersQuery__
 *
 * To run a query within a React component, call `useFetchCustomerUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomerUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomerUsersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      customerId: // value for 'customerId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchCustomerUsersQuery(baseOptions: Apollo.QueryHookOptions<FetchCustomerUsersQuery, FetchCustomerUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomerUsersQuery, FetchCustomerUsersQueryVariables>(FetchCustomerUsersDocument, options);
      }
export function useFetchCustomerUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomerUsersQuery, FetchCustomerUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomerUsersQuery, FetchCustomerUsersQueryVariables>(FetchCustomerUsersDocument, options);
        }
export type FetchCustomerUsersQueryHookResult = ReturnType<typeof useFetchCustomerUsersQuery>;
export type FetchCustomerUsersLazyQueryHookResult = ReturnType<typeof useFetchCustomerUsersLazyQuery>;
export type FetchCustomerUsersQueryResult = Apollo.QueryResult<FetchCustomerUsersQuery, FetchCustomerUsersQueryVariables>;
export const DriverDemurrageDocument = gql`
    query DriverDemurrage($id: ID!) {
  driverDemurrage(id: $id) {
    id
    customer {
      id
      name
      erpId
    }
    offsetAmount
    offsetRate
    offsetType
    rangeAttribute {
      startRange
      endRange
      rangeRate
    }
  }
}
    `;

/**
 * __useDriverDemurrageQuery__
 *
 * To run a query within a React component, call `useDriverDemurrageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDriverDemurrageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDriverDemurrageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDriverDemurrageQuery(baseOptions: Apollo.QueryHookOptions<DriverDemurrageQuery, DriverDemurrageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DriverDemurrageQuery, DriverDemurrageQueryVariables>(DriverDemurrageDocument, options);
      }
export function useDriverDemurrageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DriverDemurrageQuery, DriverDemurrageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DriverDemurrageQuery, DriverDemurrageQueryVariables>(DriverDemurrageDocument, options);
        }
export type DriverDemurrageQueryHookResult = ReturnType<typeof useDriverDemurrageQuery>;
export type DriverDemurrageLazyQueryHookResult = ReturnType<typeof useDriverDemurrageLazyQuery>;
export type DriverDemurrageQueryResult = Apollo.QueryResult<DriverDemurrageQuery, DriverDemurrageQueryVariables>;
export const DriverDocument = gql`
    query Driver($id: ID!) {
  driver(id: $id) {
    id
    erpId
    name
    email
    homeAddress
    licenceExpiryDate
    contractSignDate
    reasonForLeaving
    startDate
    endDate
    paymentStrategy
    status
    phoneNumbers {
      device
      id
      primary
      status
      value
    }
    image {
      filename
      id
      url
    }
    s3BackgroundCheck {
      filename
      id
      url
    }
    s3DriverApplication {
      filename
      id
      url
    }
    s3H6 {
      filename
      id
      url
    }
    s3Licenses {
      filename
      id
      url
    }
    hubResources {
      id
      hub {
        id
        name
        address
      }
    }
    lineOfServices {
      id
      nameWithAncestors
      name
    }
    weeklySchedules {
      id
      breakMinutes
      earliest
      latest
      scheduleType
      weekDay
    }
    resourceSchedule {
      id
      preferrableId
      preferrableType
      availability {
        day
        preferredStartTime
        preferredEndTime
      }
      unavailability {
        unStartTime
        unEndTime
        reason
      }
    }
    hourlyRate
  }
}
    `;

/**
 * __useDriverQuery__
 *
 * To run a query within a React component, call `useDriverQuery` and pass it any options that fit your needs.
 * When your component renders, `useDriverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDriverQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDriverQuery(baseOptions: Apollo.QueryHookOptions<DriverQuery, DriverQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DriverQuery, DriverQueryVariables>(DriverDocument, options);
      }
export function useDriverLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DriverQuery, DriverQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DriverQuery, DriverQueryVariables>(DriverDocument, options);
        }
export type DriverQueryHookResult = ReturnType<typeof useDriverQuery>;
export type DriverLazyQueryHookResult = ReturnType<typeof useDriverLazyQuery>;
export type DriverQueryResult = Apollo.QueryResult<DriverQuery, DriverQueryVariables>;
export const DriversDocument = gql`
    query Drivers($driverTypes: [DriverTypeEnum!]) {
  drivers(filter: {driverTypes: $driverTypes}) {
    id
    name
    status
    isNonFuel
  }
}
    `;

/**
 * __useDriversQuery__
 *
 * To run a query within a React component, call `useDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDriversQuery({
 *   variables: {
 *      driverTypes: // value for 'driverTypes'
 *   },
 * });
 */
export function useDriversQuery(baseOptions?: Apollo.QueryHookOptions<DriversQuery, DriversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DriversQuery, DriversQueryVariables>(DriversDocument, options);
      }
export function useDriversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DriversQuery, DriversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DriversQuery, DriversQueryVariables>(DriversDocument, options);
        }
export type DriversQueryHookResult = ReturnType<typeof useDriversQuery>;
export type DriversLazyQueryHookResult = ReturnType<typeof useDriversLazyQuery>;
export type DriversQueryResult = Apollo.QueryResult<DriversQuery, DriversQueryVariables>;
export const FeeDocument = gql`
    query Fee($id: ID!) {
  fee(id: $id) {
    id
    name
    code
    erpId
    description
    glCode
    price
    nonEditableRecords
    nsManualVolume
    offset
    offsetRate
    roundUpQuantity
    feeProductCategories {
      id
      productCategory {
        id
        name
      }
    }
    lineOfServices {
      id
      nameWithAncestors
    }
    feeType
    applyAsOnFee
    calculatedAsOnFee
    parentFee {
      id
      name
    }
    rangeAttribute {
      endRange
      rangeRate
      startRange
    }
    rangeTypeOnFee
    rangeCalculatedAsOnFee
    rateUnitOnFee
    rateOnFee
    percentOnFee
    applicableType
    baseFeeId
  }
}
    `;

/**
 * __useFeeQuery__
 *
 * To run a query within a React component, call `useFeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFeeQuery(baseOptions: Apollo.QueryHookOptions<FeeQuery, FeeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeeQuery, FeeQueryVariables>(FeeDocument, options);
      }
export function useFeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeeQuery, FeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeeQuery, FeeQueryVariables>(FeeDocument, options);
        }
export type FeeQueryHookResult = ReturnType<typeof useFeeQuery>;
export type FeeLazyQueryHookResult = ReturnType<typeof useFeeLazyQuery>;
export type FeeQueryResult = Apollo.QueryResult<FeeQuery, FeeQueryVariables>;
export const FetchFilteredProductsDropdownDocument = gql`
    query FetchFilteredProductsDropdown($limit: Int, $offset: Int, $all: String) {
  filteredProducts(limit: $limit, offset: $offset, filter: {all: $all}) {
    collection {
      id
      name
      erpId
      productCategory {
        id
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFetchFilteredProductsDropdownQuery__
 *
 * To run a query within a React component, call `useFetchFilteredProductsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredProductsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredProductsDropdownQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      all: // value for 'all'
 *   },
 * });
 */
export function useFetchFilteredProductsDropdownQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredProductsDropdownQuery, FetchFilteredProductsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredProductsDropdownQuery, FetchFilteredProductsDropdownQueryVariables>(FetchFilteredProductsDropdownDocument, options);
      }
export function useFetchFilteredProductsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredProductsDropdownQuery, FetchFilteredProductsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredProductsDropdownQuery, FetchFilteredProductsDropdownQueryVariables>(FetchFilteredProductsDropdownDocument, options);
        }
export type FetchFilteredProductsDropdownQueryHookResult = ReturnType<typeof useFetchFilteredProductsDropdownQuery>;
export type FetchFilteredProductsDropdownLazyQueryHookResult = ReturnType<typeof useFetchFilteredProductsDropdownLazyQuery>;
export type FetchFilteredProductsDropdownQueryResult = Apollo.QueryResult<FetchFilteredProductsDropdownQuery, FetchFilteredProductsDropdownQueryVariables>;
export const FetchGraphDataDocument = gql`
    query FetchGraphData($fromTimestamp: Int, $toTimestamp: Int, $limit: Int, $offset: Int) {
  fetchGraphData(
    fromTimestamp: $fromTimestamp
    toTimestamp: $toTimestamp
    limit: $limit
    offset: $offset
  ) {
    data
    metadata
  }
}
    `;

/**
 * __useFetchGraphDataQuery__
 *
 * To run a query within a React component, call `useFetchGraphDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchGraphDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchGraphDataQuery({
 *   variables: {
 *      fromTimestamp: // value for 'fromTimestamp'
 *      toTimestamp: // value for 'toTimestamp'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFetchGraphDataQuery(baseOptions?: Apollo.QueryHookOptions<FetchGraphDataQuery, FetchGraphDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchGraphDataQuery, FetchGraphDataQueryVariables>(FetchGraphDataDocument, options);
      }
export function useFetchGraphDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchGraphDataQuery, FetchGraphDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchGraphDataQuery, FetchGraphDataQueryVariables>(FetchGraphDataDocument, options);
        }
export type FetchGraphDataQueryHookResult = ReturnType<typeof useFetchGraphDataQuery>;
export type FetchGraphDataLazyQueryHookResult = ReturnType<typeof useFetchGraphDataLazyQuery>;
export type FetchGraphDataQueryResult = Apollo.QueryResult<FetchGraphDataQuery, FetchGraphDataQueryVariables>;
export const FetchLeasedAssetsDocument = gql`
    query fetchLeasedAssets($limit: Int, $offset: Int, $sorter: [AssetSorter!], $customerIds: [ID!], $filter: String, $useInDelivery: Boolean, $types: [AssetTypeEnum!], $atSelfCustomerLocation: Boolean, $statuses: [String!]) {
  filteredAssets(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {customerIds: $customerIds, all: $filter, useInDelivery: $useInDelivery, types: $types, atSelfCustomerLocation: $atSelfCustomerLocation, statuses: $statuses}
  ) {
    collection {
      id
      averageDaysBetweenFills
      status
      name
      category
      color
      qrCodeText
      licensePlateNumber
      erpId
      fuelCategories
      netsuiteId
      type
      tankSize
      tankType
      averageUtilization
      startDate
      numberOfDays
      rentalAssetAtCustomer
      lastDeliveredTimestamp
      actualRoi
      expectedRoi
      lastActiveTenantId
      subscriptions {
        id
        product {
          id
          erpId
          productType
        }
      }
      customerBranch {
        id
        name
        address
        customer {
          id
          name
          address
        }
      }
      compartments {
        id
        name
        capacities {
          id
          fuelType
          unit
          value
          usablePercentage
        }
      }
      ...AssetWithProductCategoryNames
      ...AssetWithProductNames
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    ${AssetWithProductCategoryNamesFragmentDoc}
${AssetWithProductNamesFragmentDoc}`;

/**
 * __useFetchLeasedAssetsQuery__
 *
 * To run a query within a React component, call `useFetchLeasedAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLeasedAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLeasedAssetsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      customerIds: // value for 'customerIds'
 *      filter: // value for 'filter'
 *      useInDelivery: // value for 'useInDelivery'
 *      types: // value for 'types'
 *      atSelfCustomerLocation: // value for 'atSelfCustomerLocation'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useFetchLeasedAssetsQuery(baseOptions?: Apollo.QueryHookOptions<FetchLeasedAssetsQuery, FetchLeasedAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLeasedAssetsQuery, FetchLeasedAssetsQueryVariables>(FetchLeasedAssetsDocument, options);
      }
export function useFetchLeasedAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLeasedAssetsQuery, FetchLeasedAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLeasedAssetsQuery, FetchLeasedAssetsQueryVariables>(FetchLeasedAssetsDocument, options);
        }
export type FetchLeasedAssetsQueryHookResult = ReturnType<typeof useFetchLeasedAssetsQuery>;
export type FetchLeasedAssetsLazyQueryHookResult = ReturnType<typeof useFetchLeasedAssetsLazyQuery>;
export type FetchLeasedAssetsQueryResult = Apollo.QueryResult<FetchLeasedAssetsQuery, FetchLeasedAssetsQueryVariables>;
export const FetchLeasedAssetsWithHubsDocument = gql`
    query fetchLeasedAssetsWithHubs($limit: Int, $offset: Int, $sorter: [AssetSorter!], $customerIds: [ID!], $filter: String, $useInDelivery: Boolean, $types: [AssetTypeEnum!], $atSelfCustomerLocation: Boolean, $statuses: [String!]) {
  filteredAssets(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {customerIds: $customerIds, all: $filter, useInDelivery: $useInDelivery, types: $types, atSelfCustomerLocation: $atSelfCustomerLocation, statuses: $statuses}
  ) {
    collection {
      id
      averageDaysBetweenFills
      status
      name
      category
      color
      qrCodeText
      licensePlateNumber
      erpId
      fuelCategories
      netsuiteId
      type
      tankSize
      tankType
      averageUtilization
      startDate
      numberOfDays
      rentalAssetAtCustomer
      lastDeliveredTimestamp
      lastActiveTenantId
      actualRoi
      expectedRoi
      hubs {
        id
        name
      }
      subscriptions {
        id
        product {
          id
          erpId
          productType
        }
      }
      customerBranch {
        id
        name
        address
        customer {
          id
          name
          address
        }
      }
      compartments {
        id
        name
        capacities {
          id
          fuelType
          unit
          value
          usablePercentage
        }
      }
      ...AssetWithProductCategoryNames
      ...AssetWithProductNames
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    ${AssetWithProductCategoryNamesFragmentDoc}
${AssetWithProductNamesFragmentDoc}`;

/**
 * __useFetchLeasedAssetsWithHubsQuery__
 *
 * To run a query within a React component, call `useFetchLeasedAssetsWithHubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLeasedAssetsWithHubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLeasedAssetsWithHubsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      customerIds: // value for 'customerIds'
 *      filter: // value for 'filter'
 *      useInDelivery: // value for 'useInDelivery'
 *      types: // value for 'types'
 *      atSelfCustomerLocation: // value for 'atSelfCustomerLocation'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useFetchLeasedAssetsWithHubsQuery(baseOptions?: Apollo.QueryHookOptions<FetchLeasedAssetsWithHubsQuery, FetchLeasedAssetsWithHubsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLeasedAssetsWithHubsQuery, FetchLeasedAssetsWithHubsQueryVariables>(FetchLeasedAssetsWithHubsDocument, options);
      }
export function useFetchLeasedAssetsWithHubsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLeasedAssetsWithHubsQuery, FetchLeasedAssetsWithHubsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLeasedAssetsWithHubsQuery, FetchLeasedAssetsWithHubsQueryVariables>(FetchLeasedAssetsWithHubsDocument, options);
        }
export type FetchLeasedAssetsWithHubsQueryHookResult = ReturnType<typeof useFetchLeasedAssetsWithHubsQuery>;
export type FetchLeasedAssetsWithHubsLazyQueryHookResult = ReturnType<typeof useFetchLeasedAssetsWithHubsLazyQuery>;
export type FetchLeasedAssetsWithHubsQueryResult = Apollo.QueryResult<FetchLeasedAssetsWithHubsQuery, FetchLeasedAssetsWithHubsQueryVariables>;
export const LineOfServiceDocument = gql`
    query LineOfService($id: ID!) {
  lineOfService(id: $id) {
    id
    name
    active
    erpId
    shortName
    nonEditableRecords
    parent {
      id
      nameWithAncestors
    }
  }
}
    `;

/**
 * __useLineOfServiceQuery__
 *
 * To run a query within a React component, call `useLineOfServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useLineOfServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLineOfServiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLineOfServiceQuery(baseOptions: Apollo.QueryHookOptions<LineOfServiceQuery, LineOfServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LineOfServiceQuery, LineOfServiceQueryVariables>(LineOfServiceDocument, options);
      }
export function useLineOfServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LineOfServiceQuery, LineOfServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LineOfServiceQuery, LineOfServiceQueryVariables>(LineOfServiceDocument, options);
        }
export type LineOfServiceQueryHookResult = ReturnType<typeof useLineOfServiceQuery>;
export type LineOfServiceLazyQueryHookResult = ReturnType<typeof useLineOfServiceLazyQuery>;
export type LineOfServiceQueryResult = Apollo.QueryResult<LineOfServiceQuery, LineOfServiceQueryVariables>;
export const LineOfServicesDocument = gql`
    query LineOfServices {
  lineOfServices {
    id
    nameWithAncestors
  }
}
    `;

/**
 * __useLineOfServicesQuery__
 *
 * To run a query within a React component, call `useLineOfServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLineOfServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLineOfServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLineOfServicesQuery(baseOptions?: Apollo.QueryHookOptions<LineOfServicesQuery, LineOfServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LineOfServicesQuery, LineOfServicesQueryVariables>(LineOfServicesDocument, options);
      }
export function useLineOfServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LineOfServicesQuery, LineOfServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LineOfServicesQuery, LineOfServicesQueryVariables>(LineOfServicesDocument, options);
        }
export type LineOfServicesQueryHookResult = ReturnType<typeof useLineOfServicesQuery>;
export type LineOfServicesLazyQueryHookResult = ReturnType<typeof useLineOfServicesLazyQuery>;
export type LineOfServicesQueryResult = Apollo.QueryResult<LineOfServicesQuery, LineOfServicesQueryVariables>;
export const LoadingAccountDocument = gql`
    query LoadingAccount($id: ID!) {
  loadingAccount(id: $id) {
    id
    name
    carrierCustomerCode
    loadingNumber
    supplierCode
    destinationState
    abbreviatedDestinationState
    description
    supplier {
      id
      name
    }
  }
}
    `;

/**
 * __useLoadingAccountQuery__
 *
 * To run a query within a React component, call `useLoadingAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadingAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadingAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoadingAccountQuery(baseOptions: Apollo.QueryHookOptions<LoadingAccountQuery, LoadingAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadingAccountQuery, LoadingAccountQueryVariables>(LoadingAccountDocument, options);
      }
export function useLoadingAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadingAccountQuery, LoadingAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadingAccountQuery, LoadingAccountQueryVariables>(LoadingAccountDocument, options);
        }
export type LoadingAccountQueryHookResult = ReturnType<typeof useLoadingAccountQuery>;
export type LoadingAccountLazyQueryHookResult = ReturnType<typeof useLoadingAccountLazyQuery>;
export type LoadingAccountQueryResult = Apollo.QueryResult<LoadingAccountQuery, LoadingAccountQueryVariables>;
export const FetchLoadingAccountsDocument = gql`
    query FetchLoadingAccounts {
  filteredLoadingAccounts(sorter: {field: NAME, order: asc}) {
    collection {
      id
      name
      carrierCustomerCode
      destinationState
      abbreviatedDestinationState
      loadingNumber
    }
  }
}
    `;

/**
 * __useFetchLoadingAccountsQuery__
 *
 * To run a query within a React component, call `useFetchLoadingAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLoadingAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLoadingAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchLoadingAccountsQuery(baseOptions?: Apollo.QueryHookOptions<FetchLoadingAccountsQuery, FetchLoadingAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLoadingAccountsQuery, FetchLoadingAccountsQueryVariables>(FetchLoadingAccountsDocument, options);
      }
export function useFetchLoadingAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLoadingAccountsQuery, FetchLoadingAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLoadingAccountsQuery, FetchLoadingAccountsQueryVariables>(FetchLoadingAccountsDocument, options);
        }
export type FetchLoadingAccountsQueryHookResult = ReturnType<typeof useFetchLoadingAccountsQuery>;
export type FetchLoadingAccountsLazyQueryHookResult = ReturnType<typeof useFetchLoadingAccountsLazyQuery>;
export type FetchLoadingAccountsQueryResult = Apollo.QueryResult<FetchLoadingAccountsQuery, FetchLoadingAccountsQueryVariables>;
export const FetchMoveAssetFormContextDocument = gql`
    query FetchMoveAssetFormContext($limit: Int, $offset: Int, $name: String) {
  filteredCustomers(limit: $limit, offset: $offset, filter: {name: $name}) {
    collection {
      name
      id
      address
      erpId
    }
  }
}
    `;

/**
 * __useFetchMoveAssetFormContextQuery__
 *
 * To run a query within a React component, call `useFetchMoveAssetFormContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMoveAssetFormContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMoveAssetFormContextQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useFetchMoveAssetFormContextQuery(baseOptions?: Apollo.QueryHookOptions<FetchMoveAssetFormContextQuery, FetchMoveAssetFormContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchMoveAssetFormContextQuery, FetchMoveAssetFormContextQueryVariables>(FetchMoveAssetFormContextDocument, options);
      }
export function useFetchMoveAssetFormContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchMoveAssetFormContextQuery, FetchMoveAssetFormContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchMoveAssetFormContextQuery, FetchMoveAssetFormContextQueryVariables>(FetchMoveAssetFormContextDocument, options);
        }
export type FetchMoveAssetFormContextQueryHookResult = ReturnType<typeof useFetchMoveAssetFormContextQuery>;
export type FetchMoveAssetFormContextLazyQueryHookResult = ReturnType<typeof useFetchMoveAssetFormContextLazyQuery>;
export type FetchMoveAssetFormContextQueryResult = Apollo.QueryResult<FetchMoveAssetFormContextQuery, FetchMoveAssetFormContextQueryVariables>;
export const FetchPandaBoxDocument = gql`
    query FetchPandaBox($id: ID!) {
  pandaBox(id: $id) {
    id
    imeiNumber
    version
    name
    pandaBoxAssets {
      id
      active
      lastAssignedAt
      asset {
        id
        name
      }
    }
    assignedAsset {
      id
      name
    }
    pandaBoxMeters {
      id
      lcpNode
      meterModel
      lastSyncedAt
      portNumber
      productCategory {
        id
        name
      }
      pandaDocuments {
        id
        documentType
        fileName
        blobFileUrl
      }
    }
    pandaDocuments {
      id
      documentType
      fileName
      blobFileUrl
    }
  }
}
    `;

/**
 * __useFetchPandaBoxQuery__
 *
 * To run a query within a React component, call `useFetchPandaBoxQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPandaBoxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPandaBoxQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchPandaBoxQuery(baseOptions: Apollo.QueryHookOptions<FetchPandaBoxQuery, FetchPandaBoxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPandaBoxQuery, FetchPandaBoxQueryVariables>(FetchPandaBoxDocument, options);
      }
export function useFetchPandaBoxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPandaBoxQuery, FetchPandaBoxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPandaBoxQuery, FetchPandaBoxQueryVariables>(FetchPandaBoxDocument, options);
        }
export type FetchPandaBoxQueryHookResult = ReturnType<typeof useFetchPandaBoxQuery>;
export type FetchPandaBoxLazyQueryHookResult = ReturnType<typeof useFetchPandaBoxLazyQuery>;
export type FetchPandaBoxQueryResult = Apollo.QueryResult<FetchPandaBoxQuery, FetchPandaBoxQueryVariables>;
export const FetchPaymentTermsDocument = gql`
    query FetchPaymentTerms {
  paymentTerms {
    id
    name
    description
    netDaysToPay
  }
}
    `;

/**
 * __useFetchPaymentTermsQuery__
 *
 * To run a query within a React component, call `useFetchPaymentTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPaymentTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPaymentTermsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchPaymentTermsQuery(baseOptions?: Apollo.QueryHookOptions<FetchPaymentTermsQuery, FetchPaymentTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPaymentTermsQuery, FetchPaymentTermsQueryVariables>(FetchPaymentTermsDocument, options);
      }
export function useFetchPaymentTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPaymentTermsQuery, FetchPaymentTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPaymentTermsQuery, FetchPaymentTermsQueryVariables>(FetchPaymentTermsDocument, options);
        }
export type FetchPaymentTermsQueryHookResult = ReturnType<typeof useFetchPaymentTermsQuery>;
export type FetchPaymentTermsLazyQueryHookResult = ReturnType<typeof useFetchPaymentTermsLazyQuery>;
export type FetchPaymentTermsQueryResult = Apollo.QueryResult<FetchPaymentTermsQuery, FetchPaymentTermsQueryVariables>;
export const FetchPaymentTermDetailsDocument = gql`
    query FetchPaymentTermDetails($id: ID!) {
  paymentTerm(id: $id) {
    id
    name
    description
    netDaysToPay
  }
}
    `;

/**
 * __useFetchPaymentTermDetailsQuery__
 *
 * To run a query within a React component, call `useFetchPaymentTermDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPaymentTermDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPaymentTermDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchPaymentTermDetailsQuery(baseOptions: Apollo.QueryHookOptions<FetchPaymentTermDetailsQuery, FetchPaymentTermDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPaymentTermDetailsQuery, FetchPaymentTermDetailsQueryVariables>(FetchPaymentTermDetailsDocument, options);
      }
export function useFetchPaymentTermDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPaymentTermDetailsQuery, FetchPaymentTermDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPaymentTermDetailsQuery, FetchPaymentTermDetailsQueryVariables>(FetchPaymentTermDetailsDocument, options);
        }
export type FetchPaymentTermDetailsQueryHookResult = ReturnType<typeof useFetchPaymentTermDetailsQuery>;
export type FetchPaymentTermDetailsLazyQueryHookResult = ReturnType<typeof useFetchPaymentTermDetailsLazyQuery>;
export type FetchPaymentTermDetailsQueryResult = Apollo.QueryResult<FetchPaymentTermDetailsQuery, FetchPaymentTermDetailsQueryVariables>;
export const FetchPeripheralAttributesDocument = gql`
    query fetchPeripheralAttributes {
  peripheralAttributes {
    id
    formName
    formLabel
    peripheralAttributeType
    peripheralFormAttributeType {
      options {
        label
        value
      }
      placeholder
    }
  }
}
    `;

/**
 * __useFetchPeripheralAttributesQuery__
 *
 * To run a query within a React component, call `useFetchPeripheralAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPeripheralAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPeripheralAttributesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchPeripheralAttributesQuery(baseOptions?: Apollo.QueryHookOptions<FetchPeripheralAttributesQuery, FetchPeripheralAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPeripheralAttributesQuery, FetchPeripheralAttributesQueryVariables>(FetchPeripheralAttributesDocument, options);
      }
export function useFetchPeripheralAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPeripheralAttributesQuery, FetchPeripheralAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPeripheralAttributesQuery, FetchPeripheralAttributesQueryVariables>(FetchPeripheralAttributesDocument, options);
        }
export type FetchPeripheralAttributesQueryHookResult = ReturnType<typeof useFetchPeripheralAttributesQuery>;
export type FetchPeripheralAttributesLazyQueryHookResult = ReturnType<typeof useFetchPeripheralAttributesLazyQuery>;
export type FetchPeripheralAttributesQueryResult = Apollo.QueryResult<FetchPeripheralAttributesQuery, FetchPeripheralAttributesQueryVariables>;
export const FetchPeripheralCategoriesDocument = gql`
    query FetchPeripheralCategories {
  peripheralsCategories {
    id
    name
  }
}
    `;

/**
 * __useFetchPeripheralCategoriesQuery__
 *
 * To run a query within a React component, call `useFetchPeripheralCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPeripheralCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPeripheralCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchPeripheralCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<FetchPeripheralCategoriesQuery, FetchPeripheralCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPeripheralCategoriesQuery, FetchPeripheralCategoriesQueryVariables>(FetchPeripheralCategoriesDocument, options);
      }
export function useFetchPeripheralCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPeripheralCategoriesQuery, FetchPeripheralCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPeripheralCategoriesQuery, FetchPeripheralCategoriesQueryVariables>(FetchPeripheralCategoriesDocument, options);
        }
export type FetchPeripheralCategoriesQueryHookResult = ReturnType<typeof useFetchPeripheralCategoriesQuery>;
export type FetchPeripheralCategoriesLazyQueryHookResult = ReturnType<typeof useFetchPeripheralCategoriesLazyQuery>;
export type FetchPeripheralCategoriesQueryResult = Apollo.QueryResult<FetchPeripheralCategoriesQuery, FetchPeripheralCategoriesQueryVariables>;
export const PeripheralDocument = gql`
    query peripheral($id: ID!) {
  peripheral(id: $id) {
    id
    legalDescription
    soldAs
    subType
    status
    erpId
    cost
    peripheralCategory {
      id
      name
    }
    lineOfServices {
      id
      name
      nameWithAncestors
    }
    flowRate
    flowRateUnit
  }
}
    `;

/**
 * __usePeripheralQuery__
 *
 * To run a query within a React component, call `usePeripheralQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeripheralQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeripheralQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePeripheralQuery(baseOptions: Apollo.QueryHookOptions<PeripheralQuery, PeripheralQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeripheralQuery, PeripheralQueryVariables>(PeripheralDocument, options);
      }
export function usePeripheralLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeripheralQuery, PeripheralQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeripheralQuery, PeripheralQueryVariables>(PeripheralDocument, options);
        }
export type PeripheralQueryHookResult = ReturnType<typeof usePeripheralQuery>;
export type PeripheralLazyQueryHookResult = ReturnType<typeof usePeripheralLazyQuery>;
export type PeripheralQueryResult = Apollo.QueryResult<PeripheralQuery, PeripheralQueryVariables>;
export const FetchPeripheralsDocument = gql`
    query FetchPeripherals {
  peripherals {
    id
    legalDescription
    soldAs
    subType
    erpId
    status
    peripheralCategory {
      id
      name
    }
    lineOfServices {
      id
      name
      nameWithAncestors
    }
    cost
    flowRate
    flowRateUnit
  }
}
    `;

/**
 * __useFetchPeripheralsQuery__
 *
 * To run a query within a React component, call `useFetchPeripheralsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPeripheralsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPeripheralsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchPeripheralsQuery(baseOptions?: Apollo.QueryHookOptions<FetchPeripheralsQuery, FetchPeripheralsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPeripheralsQuery, FetchPeripheralsQueryVariables>(FetchPeripheralsDocument, options);
      }
export function useFetchPeripheralsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPeripheralsQuery, FetchPeripheralsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPeripheralsQuery, FetchPeripheralsQueryVariables>(FetchPeripheralsDocument, options);
        }
export type FetchPeripheralsQueryHookResult = ReturnType<typeof useFetchPeripheralsQuery>;
export type FetchPeripheralsLazyQueryHookResult = ReturnType<typeof useFetchPeripheralsLazyQuery>;
export type FetchPeripheralsQueryResult = Apollo.QueryResult<FetchPeripheralsQuery, FetchPeripheralsQueryVariables>;
export const FetchPickupPointCodesDocument = gql`
    query FetchPickupPointCodes {
  pickupPointCodes {
    id
    name
    code
  }
}
    `;

/**
 * __useFetchPickupPointCodesQuery__
 *
 * To run a query within a React component, call `useFetchPickupPointCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPickupPointCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPickupPointCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchPickupPointCodesQuery(baseOptions?: Apollo.QueryHookOptions<FetchPickupPointCodesQuery, FetchPickupPointCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPickupPointCodesQuery, FetchPickupPointCodesQueryVariables>(FetchPickupPointCodesDocument, options);
      }
export function useFetchPickupPointCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPickupPointCodesQuery, FetchPickupPointCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPickupPointCodesQuery, FetchPickupPointCodesQueryVariables>(FetchPickupPointCodesDocument, options);
        }
export type FetchPickupPointCodesQueryHookResult = ReturnType<typeof useFetchPickupPointCodesQuery>;
export type FetchPickupPointCodesLazyQueryHookResult = ReturnType<typeof useFetchPickupPointCodesLazyQuery>;
export type FetchPickupPointCodesQueryResult = Apollo.QueryResult<FetchPickupPointCodesQuery, FetchPickupPointCodesQueryVariables>;
export const FetchProductCategoriesPandaBoxDocument = gql`
    query fetchProductCategoriesPandaBox {
  productCategories(onlyBoxMeasured: true) {
    id
    name
  }
}
    `;

/**
 * __useFetchProductCategoriesPandaBoxQuery__
 *
 * To run a query within a React component, call `useFetchProductCategoriesPandaBoxQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductCategoriesPandaBoxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductCategoriesPandaBoxQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchProductCategoriesPandaBoxQuery(baseOptions?: Apollo.QueryHookOptions<FetchProductCategoriesPandaBoxQuery, FetchProductCategoriesPandaBoxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchProductCategoriesPandaBoxQuery, FetchProductCategoriesPandaBoxQueryVariables>(FetchProductCategoriesPandaBoxDocument, options);
      }
export function useFetchProductCategoriesPandaBoxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchProductCategoriesPandaBoxQuery, FetchProductCategoriesPandaBoxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchProductCategoriesPandaBoxQuery, FetchProductCategoriesPandaBoxQueryVariables>(FetchProductCategoriesPandaBoxDocument, options);
        }
export type FetchProductCategoriesPandaBoxQueryHookResult = ReturnType<typeof useFetchProductCategoriesPandaBoxQuery>;
export type FetchProductCategoriesPandaBoxLazyQueryHookResult = ReturnType<typeof useFetchProductCategoriesPandaBoxLazyQuery>;
export type FetchProductCategoriesPandaBoxQueryResult = Apollo.QueryResult<FetchProductCategoriesPandaBoxQuery, FetchProductCategoriesPandaBoxQueryVariables>;
export const FetchProductCategoriesDocument = gql`
    query fetchProductCategories {
  productCategories {
    id
    name
  }
}
    `;

/**
 * __useFetchProductCategoriesQuery__
 *
 * To run a query within a React component, call `useFetchProductCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchProductCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<FetchProductCategoriesQuery, FetchProductCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchProductCategoriesQuery, FetchProductCategoriesQueryVariables>(FetchProductCategoriesDocument, options);
      }
export function useFetchProductCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchProductCategoriesQuery, FetchProductCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchProductCategoriesQuery, FetchProductCategoriesQueryVariables>(FetchProductCategoriesDocument, options);
        }
export type FetchProductCategoriesQueryHookResult = ReturnType<typeof useFetchProductCategoriesQuery>;
export type FetchProductCategoriesLazyQueryHookResult = ReturnType<typeof useFetchProductCategoriesLazyQuery>;
export type FetchProductCategoriesQueryResult = Apollo.QueryResult<FetchProductCategoriesQuery, FetchProductCategoriesQueryVariables>;
export const ProductDocument = gql`
    query Product($id: ID!) {
  product(id: $id) {
    id
    active
    category
    glNumber
    phoenixNumber
    productCategory {
      id
      name
    }
    productSubCategory {
      id
      name
    }
    code
    subCategory
    erpId
    shortName
    unit
    deliveryType
    productType
    legalDescription
    longDescription
    soldAs
    nonEditableRecords
    ignoreNsPush
    flowRate
    allowTopUp
    lineOfServices {
      id
      nameWithAncestors
    }
    comparableProducts {
      id
      resourceId
    }
    downgradableProducts {
      id
      resourceId
    }
    productConstituents {
      id
      basicProduct {
        id
        name
      }
      percentage
    }
    hubResource {
      id
      hub {
        id
        name
        address
      }
    }
    barcode
    qrCode
    brand {
      id
      name
    }
  }
}
    `;

/**
 * __useProductQuery__
 *
 * To run a query within a React component, call `useProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductQuery(baseOptions: Apollo.QueryHookOptions<ProductQuery, ProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
      }
export function useProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductQuery, ProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
        }
export type ProductQueryHookResult = ReturnType<typeof useProductQuery>;
export type ProductLazyQueryHookResult = ReturnType<typeof useProductLazyQuery>;
export type ProductQueryResult = Apollo.QueryResult<ProductQuery, ProductQueryVariables>;
export const FetchProductFormContextDocument = gql`
    query fetchProductFormContext {
  capacityTypes {
    description
    value
  }
  lineOfServices {
    id
    nameWithAncestors
  }
  products {
    id
    shortName
    erpId
    active
  }
}
    `;

/**
 * __useFetchProductFormContextQuery__
 *
 * To run a query within a React component, call `useFetchProductFormContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductFormContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductFormContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchProductFormContextQuery(baseOptions?: Apollo.QueryHookOptions<FetchProductFormContextQuery, FetchProductFormContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchProductFormContextQuery, FetchProductFormContextQueryVariables>(FetchProductFormContextDocument, options);
      }
export function useFetchProductFormContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchProductFormContextQuery, FetchProductFormContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchProductFormContextQuery, FetchProductFormContextQueryVariables>(FetchProductFormContextDocument, options);
        }
export type FetchProductFormContextQueryHookResult = ReturnType<typeof useFetchProductFormContextQuery>;
export type FetchProductFormContextLazyQueryHookResult = ReturnType<typeof useFetchProductFormContextLazyQuery>;
export type FetchProductFormContextQueryResult = Apollo.QueryResult<FetchProductFormContextQuery, FetchProductFormContextQueryVariables>;
export const FetchProductPurchaseLimitDocument = gql`
    query FetchProductPurchaseLimit($id: ID!) {
  productPurchaseLimit(id: $id) {
    id
    name
    volume
    product {
      id
      name
    }
    customers {
      id
      name
    }
  }
}
    `;

/**
 * __useFetchProductPurchaseLimitQuery__
 *
 * To run a query within a React component, call `useFetchProductPurchaseLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductPurchaseLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductPurchaseLimitQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchProductPurchaseLimitQuery(baseOptions: Apollo.QueryHookOptions<FetchProductPurchaseLimitQuery, FetchProductPurchaseLimitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchProductPurchaseLimitQuery, FetchProductPurchaseLimitQueryVariables>(FetchProductPurchaseLimitDocument, options);
      }
export function useFetchProductPurchaseLimitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchProductPurchaseLimitQuery, FetchProductPurchaseLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchProductPurchaseLimitQuery, FetchProductPurchaseLimitQueryVariables>(FetchProductPurchaseLimitDocument, options);
        }
export type FetchProductPurchaseLimitQueryHookResult = ReturnType<typeof useFetchProductPurchaseLimitQuery>;
export type FetchProductPurchaseLimitLazyQueryHookResult = ReturnType<typeof useFetchProductPurchaseLimitLazyQuery>;
export type FetchProductPurchaseLimitQueryResult = Apollo.QueryResult<FetchProductPurchaseLimitQuery, FetchProductPurchaseLimitQueryVariables>;
export const FetchProductSubCategoriesDocument = gql`
    query fetchProductSubCategories {
  productSubCategories {
    id
    name
  }
}
    `;

/**
 * __useFetchProductSubCategoriesQuery__
 *
 * To run a query within a React component, call `useFetchProductSubCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductSubCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductSubCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchProductSubCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<FetchProductSubCategoriesQuery, FetchProductSubCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchProductSubCategoriesQuery, FetchProductSubCategoriesQueryVariables>(FetchProductSubCategoriesDocument, options);
      }
export function useFetchProductSubCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchProductSubCategoriesQuery, FetchProductSubCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchProductSubCategoriesQuery, FetchProductSubCategoriesQueryVariables>(FetchProductSubCategoriesDocument, options);
        }
export type FetchProductSubCategoriesQueryHookResult = ReturnType<typeof useFetchProductSubCategoriesQuery>;
export type FetchProductSubCategoriesLazyQueryHookResult = ReturnType<typeof useFetchProductSubCategoriesLazyQuery>;
export type FetchProductSubCategoriesQueryResult = Apollo.QueryResult<FetchProductSubCategoriesQuery, FetchProductSubCategoriesQueryVariables>;
export const ProductsDocument = gql`
    query Products {
  products {
    id
    name
    category
    productType
    erpId
    active
  }
}
    `;

/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductsQuery(baseOptions?: Apollo.QueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
      }
export function useProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
        }
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>;
export type ProductsLazyQueryHookResult = ReturnType<typeof useProductsLazyQuery>;
export type ProductsQueryResult = Apollo.QueryResult<ProductsQuery, ProductsQueryVariables>;
export const RouteFlushingsDocument = gql`
    query routeFlushings {
  fetchRouteFlushings {
    id
    volume
    fromConditions {
      field
      value
    }
    toConditions {
      field
      value
    }
  }
}
    `;

/**
 * __useRouteFlushingsQuery__
 *
 * To run a query within a React component, call `useRouteFlushingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteFlushingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteFlushingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRouteFlushingsQuery(baseOptions?: Apollo.QueryHookOptions<RouteFlushingsQuery, RouteFlushingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RouteFlushingsQuery, RouteFlushingsQueryVariables>(RouteFlushingsDocument, options);
      }
export function useRouteFlushingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RouteFlushingsQuery, RouteFlushingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RouteFlushingsQuery, RouteFlushingsQueryVariables>(RouteFlushingsDocument, options);
        }
export type RouteFlushingsQueryHookResult = ReturnType<typeof useRouteFlushingsQuery>;
export type RouteFlushingsLazyQueryHookResult = ReturnType<typeof useRouteFlushingsLazyQuery>;
export type RouteFlushingsQueryResult = Apollo.QueryResult<RouteFlushingsQuery, RouteFlushingsQueryVariables>;
export const FetchRouteSettingsDocument = gql`
    query fetchRouteSettings {
  routeSettings {
    collection {
      id
      name
      value
    }
  }
}
    `;

/**
 * __useFetchRouteSettingsQuery__
 *
 * To run a query within a React component, call `useFetchRouteSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRouteSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRouteSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchRouteSettingsQuery(baseOptions?: Apollo.QueryHookOptions<FetchRouteSettingsQuery, FetchRouteSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRouteSettingsQuery, FetchRouteSettingsQueryVariables>(FetchRouteSettingsDocument, options);
      }
export function useFetchRouteSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRouteSettingsQuery, FetchRouteSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRouteSettingsQuery, FetchRouteSettingsQueryVariables>(FetchRouteSettingsDocument, options);
        }
export type FetchRouteSettingsQueryHookResult = ReturnType<typeof useFetchRouteSettingsQuery>;
export type FetchRouteSettingsLazyQueryHookResult = ReturnType<typeof useFetchRouteSettingsLazyQuery>;
export type FetchRouteSettingsQueryResult = Apollo.QueryResult<FetchRouteSettingsQuery, FetchRouteSettingsQueryVariables>;
export const FetchRoutesStaticTimesDocument = gql`
    query fetchRoutesStaticTimes {
  routeStaticTimes {
    collection {
      id
      name
      time
      timeType
    }
  }
}
    `;

/**
 * __useFetchRoutesStaticTimesQuery__
 *
 * To run a query within a React component, call `useFetchRoutesStaticTimesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRoutesStaticTimesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRoutesStaticTimesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchRoutesStaticTimesQuery(baseOptions?: Apollo.QueryHookOptions<FetchRoutesStaticTimesQuery, FetchRoutesStaticTimesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRoutesStaticTimesQuery, FetchRoutesStaticTimesQueryVariables>(FetchRoutesStaticTimesDocument, options);
      }
export function useFetchRoutesStaticTimesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRoutesStaticTimesQuery, FetchRoutesStaticTimesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRoutesStaticTimesQuery, FetchRoutesStaticTimesQueryVariables>(FetchRoutesStaticTimesDocument, options);
        }
export type FetchRoutesStaticTimesQueryHookResult = ReturnType<typeof useFetchRoutesStaticTimesQuery>;
export type FetchRoutesStaticTimesLazyQueryHookResult = ReturnType<typeof useFetchRoutesStaticTimesLazyQuery>;
export type FetchRoutesStaticTimesQueryResult = Apollo.QueryResult<FetchRoutesStaticTimesQuery, FetchRoutesStaticTimesQueryVariables>;
export const FetchSelfCustomerAssetDocument = gql`
    query fetchSelfCustomerAsset($id: ID!) {
  asset(id: $id) {
    ...selfCustomerAssetData
  }
}
    ${SelfCustomerAssetDataFragmentDoc}`;

/**
 * __useFetchSelfCustomerAssetQuery__
 *
 * To run a query within a React component, call `useFetchSelfCustomerAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSelfCustomerAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSelfCustomerAssetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchSelfCustomerAssetQuery(baseOptions: Apollo.QueryHookOptions<FetchSelfCustomerAssetQuery, FetchSelfCustomerAssetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSelfCustomerAssetQuery, FetchSelfCustomerAssetQueryVariables>(FetchSelfCustomerAssetDocument, options);
      }
export function useFetchSelfCustomerAssetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSelfCustomerAssetQuery, FetchSelfCustomerAssetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSelfCustomerAssetQuery, FetchSelfCustomerAssetQueryVariables>(FetchSelfCustomerAssetDocument, options);
        }
export type FetchSelfCustomerAssetQueryHookResult = ReturnType<typeof useFetchSelfCustomerAssetQuery>;
export type FetchSelfCustomerAssetLazyQueryHookResult = ReturnType<typeof useFetchSelfCustomerAssetLazyQuery>;
export type FetchSelfCustomerAssetQueryResult = Apollo.QueryResult<FetchSelfCustomerAssetQuery, FetchSelfCustomerAssetQueryVariables>;
export const FetchSelfCustomerAssetCustomerDetailsDocument = gql`
    query fetchSelfCustomerAssetCustomerDetails($customerId: ID!) {
  customer(id: $customerId) {
    id
    customerBranches {
      id
      name
      address
      status
      site {
        lat
        lng
      }
    }
  }
}
    `;

/**
 * __useFetchSelfCustomerAssetCustomerDetailsQuery__
 *
 * To run a query within a React component, call `useFetchSelfCustomerAssetCustomerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSelfCustomerAssetCustomerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSelfCustomerAssetCustomerDetailsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useFetchSelfCustomerAssetCustomerDetailsQuery(baseOptions: Apollo.QueryHookOptions<FetchSelfCustomerAssetCustomerDetailsQuery, FetchSelfCustomerAssetCustomerDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSelfCustomerAssetCustomerDetailsQuery, FetchSelfCustomerAssetCustomerDetailsQueryVariables>(FetchSelfCustomerAssetCustomerDetailsDocument, options);
      }
export function useFetchSelfCustomerAssetCustomerDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSelfCustomerAssetCustomerDetailsQuery, FetchSelfCustomerAssetCustomerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSelfCustomerAssetCustomerDetailsQuery, FetchSelfCustomerAssetCustomerDetailsQueryVariables>(FetchSelfCustomerAssetCustomerDetailsDocument, options);
        }
export type FetchSelfCustomerAssetCustomerDetailsQueryHookResult = ReturnType<typeof useFetchSelfCustomerAssetCustomerDetailsQuery>;
export type FetchSelfCustomerAssetCustomerDetailsLazyQueryHookResult = ReturnType<typeof useFetchSelfCustomerAssetCustomerDetailsLazyQuery>;
export type FetchSelfCustomerAssetCustomerDetailsQueryResult = Apollo.QueryResult<FetchSelfCustomerAssetCustomerDetailsQuery, FetchSelfCustomerAssetCustomerDetailsQueryVariables>;
export const ShipToFormContextDocument = gql`
    query ShipToFormContext {
  fees {
    id
    name
    price
    standard
    netsuiteId
    applicableType
  }
  lineOfServices {
    id
    nameWithAncestors
  }
}
    `;

/**
 * __useShipToFormContextQuery__
 *
 * To run a query within a React component, call `useShipToFormContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipToFormContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipToFormContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useShipToFormContextQuery(baseOptions?: Apollo.QueryHookOptions<ShipToFormContextQuery, ShipToFormContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipToFormContextQuery, ShipToFormContextQueryVariables>(ShipToFormContextDocument, options);
      }
export function useShipToFormContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipToFormContextQuery, ShipToFormContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipToFormContextQuery, ShipToFormContextQueryVariables>(ShipToFormContextDocument, options);
        }
export type ShipToFormContextQueryHookResult = ReturnType<typeof useShipToFormContextQuery>;
export type ShipToFormContextLazyQueryHookResult = ReturnType<typeof useShipToFormContextLazyQuery>;
export type ShipToFormContextQueryResult = Apollo.QueryResult<ShipToFormContextQuery, ShipToFormContextQueryVariables>;
export const FetchShipToSupplierPreferenceDocument = gql`
    query FetchShipToSupplierPreference($id: ID!) {
  customerBranch(id: $id) {
    id
    name
    preferredProductTerminals {
      id
      isDefault
      terminal {
        id
      }
      fee {
        id
        name
      }
      rate
      product {
        id
      }
      preferredProductTerminalSuppliers {
        id
        supplier {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useFetchShipToSupplierPreferenceQuery__
 *
 * To run a query within a React component, call `useFetchShipToSupplierPreferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchShipToSupplierPreferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchShipToSupplierPreferenceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchShipToSupplierPreferenceQuery(baseOptions: Apollo.QueryHookOptions<FetchShipToSupplierPreferenceQuery, FetchShipToSupplierPreferenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchShipToSupplierPreferenceQuery, FetchShipToSupplierPreferenceQueryVariables>(FetchShipToSupplierPreferenceDocument, options);
      }
export function useFetchShipToSupplierPreferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchShipToSupplierPreferenceQuery, FetchShipToSupplierPreferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchShipToSupplierPreferenceQuery, FetchShipToSupplierPreferenceQueryVariables>(FetchShipToSupplierPreferenceDocument, options);
        }
export type FetchShipToSupplierPreferenceQueryHookResult = ReturnType<typeof useFetchShipToSupplierPreferenceQuery>;
export type FetchShipToSupplierPreferenceLazyQueryHookResult = ReturnType<typeof useFetchShipToSupplierPreferenceLazyQuery>;
export type FetchShipToSupplierPreferenceQueryResult = Apollo.QueryResult<FetchShipToSupplierPreferenceQuery, FetchShipToSupplierPreferenceQueryVariables>;
export const SupplierDocument = gql`
    query Supplier($id: ID!) {
  supplier(id: $id) {
    id
    name
    supplierCode
    erpId
    active
    netsuiteId
    nonEditableRecords
    isIrelyInternalSupplier
    irelyShipFromLocation
    lineOfServices {
      id
      nameWithAncestors
    }
    terminalsSuppliers {
      terminal {
        id
        name
        active
      }
      pickupPointCodes {
        id
        code
        loadingAccountId
        name
      }
      bolTimeAt
      id
    }
    loadingAccounts {
      id
      carrierCustomerCode
      destinationState
      abbreviatedDestinationState
      loadingNumber
      name
      description
      supplierCode
    }
  }
}
    `;

/**
 * __useSupplierQuery__
 *
 * To run a query within a React component, call `useSupplierQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSupplierQuery(baseOptions: Apollo.QueryHookOptions<SupplierQuery, SupplierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplierQuery, SupplierQueryVariables>(SupplierDocument, options);
      }
export function useSupplierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierQuery, SupplierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplierQuery, SupplierQueryVariables>(SupplierDocument, options);
        }
export type SupplierQueryHookResult = ReturnType<typeof useSupplierQuery>;
export type SupplierLazyQueryHookResult = ReturnType<typeof useSupplierLazyQuery>;
export type SupplierQueryResult = Apollo.QueryResult<SupplierQuery, SupplierQueryVariables>;
export const SuppliersDocument = gql`
    query Suppliers {
  suppliers {
    id
    name
    active
    loadingAccounts {
      id
      carrierCustomerCode
      loadingNumber
      name
    }
    netsuiteId
  }
}
    `;

/**
 * __useSuppliersQuery__
 *
 * To run a query within a React component, call `useSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuppliersQuery({
 *   variables: {
 *   },
 * });
 */
export function useSuppliersQuery(baseOptions?: Apollo.QueryHookOptions<SuppliersQuery, SuppliersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuppliersQuery, SuppliersQueryVariables>(SuppliersDocument, options);
      }
export function useSuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuppliersQuery, SuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuppliersQuery, SuppliersQueryVariables>(SuppliersDocument, options);
        }
export type SuppliersQueryHookResult = ReturnType<typeof useSuppliersQuery>;
export type SuppliersLazyQueryHookResult = ReturnType<typeof useSuppliersLazyQuery>;
export type SuppliersQueryResult = Apollo.QueryResult<SuppliersQuery, SuppliersQueryVariables>;
export const TerminalDocument = gql`
    query Terminal($id: ID!) {
  terminal(id: $id) {
    id
    name
    erpId
    isWarehouse
    feinNumber
    active
    nonEditableRecords
    nsTags
    isOwnBulkTank
    site {
      id
      address
      lat
      lng
      radius
    }
    products {
      id
      name
    }
    terminalsSuppliers {
      id
      pickupPointCodes {
        id
        name
        code
        loadingAccountId
      }
      bolTimeAt
      supplier {
        id
        name
        active
      }
      irelySubstituteTerminal
    }
    productTerminals {
      id
      product {
        id
        name
        erpId
      }
      minimalLoad
    }
    terminalManagers {
      id
      user {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useTerminalQuery__
 *
 * To run a query within a React component, call `useTerminalQuery` and pass it any options that fit your needs.
 * When your component renders, `useTerminalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTerminalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTerminalQuery(baseOptions: Apollo.QueryHookOptions<TerminalQuery, TerminalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TerminalQuery, TerminalQueryVariables>(TerminalDocument, options);
      }
export function useTerminalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TerminalQuery, TerminalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TerminalQuery, TerminalQueryVariables>(TerminalDocument, options);
        }
export type TerminalQueryHookResult = ReturnType<typeof useTerminalQuery>;
export type TerminalLazyQueryHookResult = ReturnType<typeof useTerminalLazyQuery>;
export type TerminalQueryResult = Apollo.QueryResult<TerminalQuery, TerminalQueryVariables>;
export const FetchTerminalsDocument = gql`
    query fetchTerminals {
  terminals {
    id
    name
    active
    isWarehouse
  }
}
    `;

/**
 * __useFetchTerminalsQuery__
 *
 * To run a query within a React component, call `useFetchTerminalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTerminalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTerminalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchTerminalsQuery(baseOptions?: Apollo.QueryHookOptions<FetchTerminalsQuery, FetchTerminalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTerminalsQuery, FetchTerminalsQueryVariables>(FetchTerminalsDocument, options);
      }
export function useFetchTerminalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTerminalsQuery, FetchTerminalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTerminalsQuery, FetchTerminalsQueryVariables>(FetchTerminalsDocument, options);
        }
export type FetchTerminalsQueryHookResult = ReturnType<typeof useFetchTerminalsQuery>;
export type FetchTerminalsLazyQueryHookResult = ReturnType<typeof useFetchTerminalsLazyQuery>;
export type FetchTerminalsQueryResult = Apollo.QueryResult<FetchTerminalsQuery, FetchTerminalsQueryVariables>;
export const FetchUserFormDataDocument = gql`
    query fetchUserFormData($userId: ID!) {
  user(id: $userId) {
    id
    name
    address
    email
    phone
    status
    roles {
      id
      name
    }
  }
}
    `;

/**
 * __useFetchUserFormDataQuery__
 *
 * To run a query within a React component, call `useFetchUserFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserFormDataQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFetchUserFormDataQuery(baseOptions: Apollo.QueryHookOptions<FetchUserFormDataQuery, FetchUserFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUserFormDataQuery, FetchUserFormDataQueryVariables>(FetchUserFormDataDocument, options);
      }
export function useFetchUserFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUserFormDataQuery, FetchUserFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUserFormDataQuery, FetchUserFormDataQueryVariables>(FetchUserFormDataDocument, options);
        }
export type FetchUserFormDataQueryHookResult = ReturnType<typeof useFetchUserFormDataQuery>;
export type FetchUserFormDataLazyQueryHookResult = ReturnType<typeof useFetchUserFormDataLazyQuery>;
export type FetchUserFormDataQueryResult = Apollo.QueryResult<FetchUserFormDataQuery, FetchUserFormDataQueryVariables>;
export const FetchUserListDocument = gql`
    query fetchUserList($id: ID) {
  filteredCustomerUsers(filter: {id: $id}) {
    collection {
      user {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useFetchUserListQuery__
 *
 * To run a query within a React component, call `useFetchUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchUserListQuery(baseOptions?: Apollo.QueryHookOptions<FetchUserListQuery, FetchUserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUserListQuery, FetchUserListQueryVariables>(FetchUserListDocument, options);
      }
export function useFetchUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUserListQuery, FetchUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUserListQuery, FetchUserListQueryVariables>(FetchUserListDocument, options);
        }
export type FetchUserListQueryHookResult = ReturnType<typeof useFetchUserListQuery>;
export type FetchUserListLazyQueryHookResult = ReturnType<typeof useFetchUserListLazyQuery>;
export type FetchUserListQueryResult = Apollo.QueryResult<FetchUserListQuery, FetchUserListQueryVariables>;
export const FetchUsersFormContextDocument = gql`
    query fetchUsersFormContext {
  roles {
    id
    name
    adminRole
  }
}
    `;

/**
 * __useFetchUsersFormContextQuery__
 *
 * To run a query within a React component, call `useFetchUsersFormContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUsersFormContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUsersFormContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchUsersFormContextQuery(baseOptions?: Apollo.QueryHookOptions<FetchUsersFormContextQuery, FetchUsersFormContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUsersFormContextQuery, FetchUsersFormContextQueryVariables>(FetchUsersFormContextDocument, options);
      }
export function useFetchUsersFormContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUsersFormContextQuery, FetchUsersFormContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUsersFormContextQuery, FetchUsersFormContextQueryVariables>(FetchUsersFormContextDocument, options);
        }
export type FetchUsersFormContextQueryHookResult = ReturnType<typeof useFetchUsersFormContextQuery>;
export type FetchUsersFormContextLazyQueryHookResult = ReturnType<typeof useFetchUsersFormContextLazyQuery>;
export type FetchUsersFormContextQueryResult = Apollo.QueryResult<FetchUsersFormContextQuery, FetchUsersFormContextQueryVariables>;
export const FilterRouteSettingsHistoryDocument = gql`
    query filterRouteSettingsHistory($limit: Int, $offset: Int, $filter: RouteSettingsPaginationFilter) {
  filterRouteSettingsHistory(limit: $limit, offset: $offset, filter: $filter) {
    collection {
      changeset {
        key
        values
      }
      date
      event
      id
      itemType
      whodunnit {
        name
      }
    }
    metadata {
      totalCount
      hasMore
      total_entries
    }
  }
}
    `;

/**
 * __useFilterRouteSettingsHistoryQuery__
 *
 * To run a query within a React component, call `useFilterRouteSettingsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterRouteSettingsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterRouteSettingsHistoryQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFilterRouteSettingsHistoryQuery(baseOptions?: Apollo.QueryHookOptions<FilterRouteSettingsHistoryQuery, FilterRouteSettingsHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterRouteSettingsHistoryQuery, FilterRouteSettingsHistoryQueryVariables>(FilterRouteSettingsHistoryDocument, options);
      }
export function useFilterRouteSettingsHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterRouteSettingsHistoryQuery, FilterRouteSettingsHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterRouteSettingsHistoryQuery, FilterRouteSettingsHistoryQueryVariables>(FilterRouteSettingsHistoryDocument, options);
        }
export type FilterRouteSettingsHistoryQueryHookResult = ReturnType<typeof useFilterRouteSettingsHistoryQuery>;
export type FilterRouteSettingsHistoryLazyQueryHookResult = ReturnType<typeof useFilterRouteSettingsHistoryLazyQuery>;
export type FilterRouteSettingsHistoryQueryResult = Apollo.QueryResult<FilterRouteSettingsHistoryQuery, FilterRouteSettingsHistoryQueryVariables>;
export const FilteredAddressBooksDocument = gql`
    query FilteredAddressBooks($limit: Int, $offset: Int, $all: String, $sorter: [AddressBookSorter!]) {
  filteredAddressBooks(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {all: $all}
  ) {
    collection {
      id
      name
      phone
      email
      address
      addressBookType
      hasAccessToCustomerPortal
      isDeliveryTicketRecipient
      showInviteLink
      customers {
        name
      }
      customerBranches {
        name
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFilteredAddressBooksQuery__
 *
 * To run a query within a React component, call `useFilteredAddressBooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredAddressBooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredAddressBooksQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      all: // value for 'all'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilteredAddressBooksQuery(baseOptions?: Apollo.QueryHookOptions<FilteredAddressBooksQuery, FilteredAddressBooksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredAddressBooksQuery, FilteredAddressBooksQueryVariables>(FilteredAddressBooksDocument, options);
      }
export function useFilteredAddressBooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredAddressBooksQuery, FilteredAddressBooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredAddressBooksQuery, FilteredAddressBooksQueryVariables>(FilteredAddressBooksDocument, options);
        }
export type FilteredAddressBooksQueryHookResult = ReturnType<typeof useFilteredAddressBooksQuery>;
export type FilteredAddressBooksLazyQueryHookResult = ReturnType<typeof useFilteredAddressBooksLazyQuery>;
export type FilteredAddressBooksQueryResult = Apollo.QueryResult<FilteredAddressBooksQuery, FilteredAddressBooksQueryVariables>;
export const FilteredAppVersionsDocument = gql`
    query FilteredAppVersions($limit: Int, $offset: Int) {
  filteredAppVersions(limit: $limit, offset: $offset) {
    collection {
      id
      environment
      platform
      updatedAt
      versionNumber
      buildNumber
      firmwareFiles {
        id
        filename
      }
    }
  }
}
    `;

/**
 * __useFilteredAppVersionsQuery__
 *
 * To run a query within a React component, call `useFilteredAppVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredAppVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredAppVersionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFilteredAppVersionsQuery(baseOptions?: Apollo.QueryHookOptions<FilteredAppVersionsQuery, FilteredAppVersionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredAppVersionsQuery, FilteredAppVersionsQueryVariables>(FilteredAppVersionsDocument, options);
      }
export function useFilteredAppVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredAppVersionsQuery, FilteredAppVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredAppVersionsQuery, FilteredAppVersionsQueryVariables>(FilteredAppVersionsDocument, options);
        }
export type FilteredAppVersionsQueryHookResult = ReturnType<typeof useFilteredAppVersionsQuery>;
export type FilteredAppVersionsLazyQueryHookResult = ReturnType<typeof useFilteredAppVersionsLazyQuery>;
export type FilteredAppVersionsQueryResult = Apollo.QueryResult<FilteredAppVersionsQuery, FilteredAppVersionsQueryVariables>;
export const FilteredBoxTransactionsDocument = gql`
    query FilteredBoxTransactions($limit: Int, $offset: Int, $filter: BoxTransactionFilter) {
  filteredBoxTransactions(limit: $limit, offset: $offset, filter: $filter) {
    collection {
      id
      finalTotalizer
      discrepancy
      readingMode
      delivered
      totalizers
      pandaBoxMeter {
        id
        lcpNode
      }
      extractionOrder {
        id
        orderGroup {
          id
        }
      }
      transferOrder {
        id
        orderGroup {
          id
        }
      }
      deliveryOrder {
        id
        orderGroup {
          id
        }
        deliveryDateTimestamp
      }
    }
  }
}
    `;

/**
 * __useFilteredBoxTransactionsQuery__
 *
 * To run a query within a React component, call `useFilteredBoxTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredBoxTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredBoxTransactionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFilteredBoxTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<FilteredBoxTransactionsQuery, FilteredBoxTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredBoxTransactionsQuery, FilteredBoxTransactionsQueryVariables>(FilteredBoxTransactionsDocument, options);
      }
export function useFilteredBoxTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredBoxTransactionsQuery, FilteredBoxTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredBoxTransactionsQuery, FilteredBoxTransactionsQueryVariables>(FilteredBoxTransactionsDocument, options);
        }
export type FilteredBoxTransactionsQueryHookResult = ReturnType<typeof useFilteredBoxTransactionsQuery>;
export type FilteredBoxTransactionsLazyQueryHookResult = ReturnType<typeof useFilteredBoxTransactionsLazyQuery>;
export type FilteredBoxTransactionsQueryResult = Apollo.QueryResult<FilteredBoxTransactionsQuery, FilteredBoxTransactionsQueryVariables>;
export const FilteredCcTenantsDocument = gql`
    query FilteredCcTenants($limit: Int, $offset: Int, $name: String) {
  filteredCcTenants(limit: $limit, offset: $offset, filter: {name: $name}) {
    collection {
      address
      erpId
      id
      carrierTenant {
        id
        name
        slug
        adminUsers {
          id
          name
          email
          phone
        }
      }
      site {
        address
        city
        state
        zip
      }
      carrierTenantId
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFilteredCcTenantsQuery__
 *
 * To run a query within a React component, call `useFilteredCcTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredCcTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredCcTenantsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useFilteredCcTenantsQuery(baseOptions?: Apollo.QueryHookOptions<FilteredCcTenantsQuery, FilteredCcTenantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredCcTenantsQuery, FilteredCcTenantsQueryVariables>(FilteredCcTenantsDocument, options);
      }
export function useFilteredCcTenantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredCcTenantsQuery, FilteredCcTenantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredCcTenantsQuery, FilteredCcTenantsQueryVariables>(FilteredCcTenantsDocument, options);
        }
export type FilteredCcTenantsQueryHookResult = ReturnType<typeof useFilteredCcTenantsQuery>;
export type FilteredCcTenantsLazyQueryHookResult = ReturnType<typeof useFilteredCcTenantsLazyQuery>;
export type FilteredCcTenantsQueryResult = Apollo.QueryResult<FilteredCcTenantsQuery, FilteredCcTenantsQueryVariables>;
export const FilteredCustomerBranchListDocument = gql`
    query FilteredCustomerBranchList($customerId: ID, $limit: Int, $offset: Int, $searchText: String) {
  filteredCustomerBranches(
    filter: {customerId: $customerId, name: $searchText}
    sorter: {field: NAME, order: asc}
    limit: $limit
    offset: $offset
  ) {
    collection {
      id
      name
      address
      status
    }
    metadata {
      hasMore
    }
  }
}
    `;

/**
 * __useFilteredCustomerBranchListQuery__
 *
 * To run a query within a React component, call `useFilteredCustomerBranchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredCustomerBranchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredCustomerBranchListQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useFilteredCustomerBranchListQuery(baseOptions?: Apollo.QueryHookOptions<FilteredCustomerBranchListQuery, FilteredCustomerBranchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredCustomerBranchListQuery, FilteredCustomerBranchListQueryVariables>(FilteredCustomerBranchListDocument, options);
      }
export function useFilteredCustomerBranchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredCustomerBranchListQuery, FilteredCustomerBranchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredCustomerBranchListQuery, FilteredCustomerBranchListQueryVariables>(FilteredCustomerBranchListDocument, options);
        }
export type FilteredCustomerBranchListQueryHookResult = ReturnType<typeof useFilteredCustomerBranchListQuery>;
export type FilteredCustomerBranchListLazyQueryHookResult = ReturnType<typeof useFilteredCustomerBranchListLazyQuery>;
export type FilteredCustomerBranchListQueryResult = Apollo.QueryResult<FilteredCustomerBranchListQuery, FilteredCustomerBranchListQueryVariables>;
export const FilteredCustomerBranchesDocument = gql`
    query FilteredCustomerBranches($limit: Int, $offset: Int, $customerId: ID, $active: Boolean, $all: String, $isHub: Boolean) {
  filteredCustomerBranches(
    limit: $limit
    offset: $offset
    filter: {customerId: $customerId, active: $active, all: $all, isHub: $isHub}
  ) {
    collection {
      id
      name
      erpId
      irelyId
      address
      netsuiteId
      netsuiteName
      isHub
      qbName
      qbAddress
      status
      site {
        radius
        city
        state
        zip
      }
      poNumber
      lineOfServices {
        id
        name
      }
      hubs {
        name
      }
      customer {
        id
        name
        isTenant
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFilteredCustomerBranchesQuery__
 *
 * To run a query within a React component, call `useFilteredCustomerBranchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredCustomerBranchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredCustomerBranchesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      customerId: // value for 'customerId'
 *      active: // value for 'active'
 *      all: // value for 'all'
 *      isHub: // value for 'isHub'
 *   },
 * });
 */
export function useFilteredCustomerBranchesQuery(baseOptions?: Apollo.QueryHookOptions<FilteredCustomerBranchesQuery, FilteredCustomerBranchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredCustomerBranchesQuery, FilteredCustomerBranchesQueryVariables>(FilteredCustomerBranchesDocument, options);
      }
export function useFilteredCustomerBranchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredCustomerBranchesQuery, FilteredCustomerBranchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredCustomerBranchesQuery, FilteredCustomerBranchesQueryVariables>(FilteredCustomerBranchesDocument, options);
        }
export type FilteredCustomerBranchesQueryHookResult = ReturnType<typeof useFilteredCustomerBranchesQuery>;
export type FilteredCustomerBranchesLazyQueryHookResult = ReturnType<typeof useFilteredCustomerBranchesLazyQuery>;
export type FilteredCustomerBranchesQueryResult = Apollo.QueryResult<FilteredCustomerBranchesQuery, FilteredCustomerBranchesQueryVariables>;
export const FilteredCustomerDocument = gql`
    query FilteredCustomer($limit: Int, $offset: Int, $name: String, $creditLimitExceededFilter: Boolean, $sorter: [CustomerSorter!], $resource: CustomerFilterEnum, $customersName: String, $customerBranchesName: String, $address: String, $city: String, $state: String) {
  filteredCustomersSorter(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {name: $name, creditLimitExceeded: $creditLimitExceededFilter, resource: $resource, customersName: $customersName, customerBranchesName: $customerBranchesName, address: $address, city: $city, state: $state}
  ) {
    collection {
      id
      name
      groupName
      erpId
      poBoxNumber
      address
      creditChecked
      creditLimitExceeded
      creditLimitPercentageBuffer
      creditLimitDaysOverdueBuffer
      netsuiteId
      creditLimit
      currentBalance
      daysOverdue
      dueDate
      vendorErpId
      arDivisionNumber
      status
      quickbridgeId
      netsuiteName
      irelyId
      lastSyncedTime
      isTenant
      site {
        city
        zip
        state
      }
      customerBranchNames
      hubs {
        name
      }
      lineOfServices {
        id
        name
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFilteredCustomerQuery__
 *
 * To run a query within a React component, call `useFilteredCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredCustomerQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      name: // value for 'name'
 *      creditLimitExceededFilter: // value for 'creditLimitExceededFilter'
 *      sorter: // value for 'sorter'
 *      resource: // value for 'resource'
 *      customersName: // value for 'customersName'
 *      customerBranchesName: // value for 'customerBranchesName'
 *      address: // value for 'address'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useFilteredCustomerQuery(baseOptions?: Apollo.QueryHookOptions<FilteredCustomerQuery, FilteredCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredCustomerQuery, FilteredCustomerQueryVariables>(FilteredCustomerDocument, options);
      }
export function useFilteredCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredCustomerQuery, FilteredCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredCustomerQuery, FilteredCustomerQueryVariables>(FilteredCustomerDocument, options);
        }
export type FilteredCustomerQueryHookResult = ReturnType<typeof useFilteredCustomerQuery>;
export type FilteredCustomerLazyQueryHookResult = ReturnType<typeof useFilteredCustomerLazyQuery>;
export type FilteredCustomerQueryResult = Apollo.QueryResult<FilteredCustomerQuery, FilteredCustomerQueryVariables>;
export const FilteredDriverDemurrageDocument = gql`
    query FilteredDriverDemurrage($limit: Int, $offset: Int, $sorter: [BaseSorter!], $filter: DriverDemurragesFilter) {
  filteredDriverDemurrage(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: $filter
  ) {
    collection {
      id
      customer {
        id
        name
        erpId
      }
      offsetType
      offsetAmount
      offsetRate
      rangeAttribute {
        startRange
        rangeRate
        endRange
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFilteredDriverDemurrageQuery__
 *
 * To run a query within a React component, call `useFilteredDriverDemurrageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredDriverDemurrageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredDriverDemurrageQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFilteredDriverDemurrageQuery(baseOptions?: Apollo.QueryHookOptions<FilteredDriverDemurrageQuery, FilteredDriverDemurrageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredDriverDemurrageQuery, FilteredDriverDemurrageQueryVariables>(FilteredDriverDemurrageDocument, options);
      }
export function useFilteredDriverDemurrageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredDriverDemurrageQuery, FilteredDriverDemurrageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredDriverDemurrageQuery, FilteredDriverDemurrageQueryVariables>(FilteredDriverDemurrageDocument, options);
        }
export type FilteredDriverDemurrageQueryHookResult = ReturnType<typeof useFilteredDriverDemurrageQuery>;
export type FilteredDriverDemurrageLazyQueryHookResult = ReturnType<typeof useFilteredDriverDemurrageLazyQuery>;
export type FilteredDriverDemurrageQueryResult = Apollo.QueryResult<FilteredDriverDemurrageQuery, FilteredDriverDemurrageQueryVariables>;
export const FilteredDriversDocument = gql`
    query FilteredDrivers($limit: Int, $offset: Int, $all: String, $sorter: [DriverSorter!], $driverTypes: [DriverTypeEnum!]) {
  filteredDrivers(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {all: $all, driverTypes: $driverTypes}
  ) {
    collection {
      id
      name
      otp
      email
      status
      homeAddress
      erpId
      irelyId
      lastSyncedTime
      phoneNumbers {
        id
        ownerType
        primary
        status
        value
      }
      hubs {
        id
        name
      }
      lineOfServices {
        id
        name
      }
      hourlyRate
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFilteredDriversQuery__
 *
 * To run a query within a React component, call `useFilteredDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredDriversQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      all: // value for 'all'
 *      sorter: // value for 'sorter'
 *      driverTypes: // value for 'driverTypes'
 *   },
 * });
 */
export function useFilteredDriversQuery(baseOptions?: Apollo.QueryHookOptions<FilteredDriversQuery, FilteredDriversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredDriversQuery, FilteredDriversQueryVariables>(FilteredDriversDocument, options);
      }
export function useFilteredDriversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredDriversQuery, FilteredDriversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredDriversQuery, FilteredDriversQueryVariables>(FilteredDriversDocument, options);
        }
export type FilteredDriversQueryHookResult = ReturnType<typeof useFilteredDriversQuery>;
export type FilteredDriversLazyQueryHookResult = ReturnType<typeof useFilteredDriversLazyQuery>;
export type FilteredDriversQueryResult = Apollo.QueryResult<FilteredDriversQuery, FilteredDriversQueryVariables>;
export const FilteredFeesDocument = gql`
    query FilteredFees($limit: Int, $offset: Int, $all: String, $sorter: [FeeSorter!], $types: [ApplicableTypeEnum!]) {
  filteredFees(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {all: $all, types: $types}
  ) {
    collection {
      id
      name
      feeType
      code
      erpId
      rateOnFee
      description
      netsuiteId
      standard
      glCode
      irelyId
      lastSyncedTime
      lineOfServices {
        id
        name
      }
      offset
      offsetRate
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFilteredFeesQuery__
 *
 * To run a query within a React component, call `useFilteredFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredFeesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      all: // value for 'all'
 *      sorter: // value for 'sorter'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useFilteredFeesQuery(baseOptions?: Apollo.QueryHookOptions<FilteredFeesQuery, FilteredFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredFeesQuery, FilteredFeesQueryVariables>(FilteredFeesDocument, options);
      }
export function useFilteredFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredFeesQuery, FilteredFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredFeesQuery, FilteredFeesQueryVariables>(FilteredFeesDocument, options);
        }
export type FilteredFeesQueryHookResult = ReturnType<typeof useFilteredFeesQuery>;
export type FilteredFeesLazyQueryHookResult = ReturnType<typeof useFilteredFeesLazyQuery>;
export type FilteredFeesQueryResult = Apollo.QueryResult<FilteredFeesQuery, FilteredFeesQueryVariables>;
export const FilteredHubsDocument = gql`
    query FilteredHubs($limit: Int, $offset: Int, $customerId: ID, $name: String, $isHub: Boolean, $all: String) {
  filteredCustomerBranches(
    limit: $limit
    offset: $offset
    filter: {customerId: $customerId, name: $name, isHub: $isHub, all: $all}
  ) {
    collection {
      id
      name
      isHub
      address
      status
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFilteredHubsQuery__
 *
 * To run a query within a React component, call `useFilteredHubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredHubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredHubsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      customerId: // value for 'customerId'
 *      name: // value for 'name'
 *      isHub: // value for 'isHub'
 *      all: // value for 'all'
 *   },
 * });
 */
export function useFilteredHubsQuery(baseOptions?: Apollo.QueryHookOptions<FilteredHubsQuery, FilteredHubsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredHubsQuery, FilteredHubsQueryVariables>(FilteredHubsDocument, options);
      }
export function useFilteredHubsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredHubsQuery, FilteredHubsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredHubsQuery, FilteredHubsQueryVariables>(FilteredHubsDocument, options);
        }
export type FilteredHubsQueryHookResult = ReturnType<typeof useFilteredHubsQuery>;
export type FilteredHubsLazyQueryHookResult = ReturnType<typeof useFilteredHubsLazyQuery>;
export type FilteredHubsQueryResult = Apollo.QueryResult<FilteredHubsQuery, FilteredHubsQueryVariables>;
export const FilteredLineOfServicesDocument = gql`
    query FilteredLineOfServices($limit: Int, $offset: Int, $all: String, $sorter: [LineOfServiceSorter!]) {
  filteredLineOfServices(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {all: $all}
  ) {
    collection {
      id
      name
      shortName
      active
      erpId
      parent {
        id
        nameWithAncestors
      }
    }
    metadata {
      hasMore
      totalCount
    }
  }
}
    `;

/**
 * __useFilteredLineOfServicesQuery__
 *
 * To run a query within a React component, call `useFilteredLineOfServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredLineOfServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredLineOfServicesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      all: // value for 'all'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilteredLineOfServicesQuery(baseOptions?: Apollo.QueryHookOptions<FilteredLineOfServicesQuery, FilteredLineOfServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredLineOfServicesQuery, FilteredLineOfServicesQueryVariables>(FilteredLineOfServicesDocument, options);
      }
export function useFilteredLineOfServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredLineOfServicesQuery, FilteredLineOfServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredLineOfServicesQuery, FilteredLineOfServicesQueryVariables>(FilteredLineOfServicesDocument, options);
        }
export type FilteredLineOfServicesQueryHookResult = ReturnType<typeof useFilteredLineOfServicesQuery>;
export type FilteredLineOfServicesLazyQueryHookResult = ReturnType<typeof useFilteredLineOfServicesLazyQuery>;
export type FilteredLineOfServicesQueryResult = Apollo.QueryResult<FilteredLineOfServicesQuery, FilteredLineOfServicesQueryVariables>;
export const FilteredLoadingAccountsDocument = gql`
    query FilteredLoadingAccounts($limit: Int, $offset: Int, $all: String, $sorter: [LoadingAccountSorter!]) {
  filteredLoadingAccounts(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {all: $all}
  ) {
    collection {
      id
      name
      carrierCustomerCode
      loadingNumber
      supplierCode
      destinationState
      abbreviatedDestinationState
      lineOfServices {
        name
      }
      supplier {
        name
      }
    }
    metadata {
      hasMore
      totalCount
    }
  }
}
    `;

/**
 * __useFilteredLoadingAccountsQuery__
 *
 * To run a query within a React component, call `useFilteredLoadingAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredLoadingAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredLoadingAccountsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      all: // value for 'all'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilteredLoadingAccountsQuery(baseOptions?: Apollo.QueryHookOptions<FilteredLoadingAccountsQuery, FilteredLoadingAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredLoadingAccountsQuery, FilteredLoadingAccountsQueryVariables>(FilteredLoadingAccountsDocument, options);
      }
export function useFilteredLoadingAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredLoadingAccountsQuery, FilteredLoadingAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredLoadingAccountsQuery, FilteredLoadingAccountsQueryVariables>(FilteredLoadingAccountsDocument, options);
        }
export type FilteredLoadingAccountsQueryHookResult = ReturnType<typeof useFilteredLoadingAccountsQuery>;
export type FilteredLoadingAccountsLazyQueryHookResult = ReturnType<typeof useFilteredLoadingAccountsLazyQuery>;
export type FilteredLoadingAccountsQueryResult = Apollo.QueryResult<FilteredLoadingAccountsQuery, FilteredLoadingAccountsQueryVariables>;
export const FilteredOrderGroupsDocument = gql`
    query FilteredOrderGroups($limit: Int, $offset: Int, $fromTime: Int, $toTime: Int, $all: String, $sorter: [OrderGroupSorter!]) {
  filteredOrderGroups(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {fromTimestamp: $fromTime, toTimestamp: $toTime, all: $all, type: delivery, recurring: false}
  ) {
    collection {
      id
      fromCustomerPortal
      status
      poNumber
      carrierNumber
      startOnTimestamp
      driverAcceptance
      startedOnTimestamp
      completeOnTimestamp
      completedOnTimestamp
      driver {
        name
      }
      hub {
        name
        address
      }
      shift {
        shiftDeliveryUnitsAssets {
          deliveryAsset {
            name
            licensePlateNumber
          }
        }
      }
      deliveryOrder {
        id
        status
        orderNumber
        deliveryInstruction
        source
        customerBranch {
          id
          name
          erpId
          customer {
            id
            name
            erpId
            fees {
              id
              name
              price
            }
          }
        }
        lineItems {
          id
          source
          requestedVolume
          volume
          status
          subscription {
            asset {
              category
              licensePlateNumber
            }
          }
          product {
            name
          }
        }
        tenantName
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFilteredOrderGroupsQuery__
 *
 * To run a query within a React component, call `useFilteredOrderGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredOrderGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredOrderGroupsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      fromTime: // value for 'fromTime'
 *      toTime: // value for 'toTime'
 *      all: // value for 'all'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilteredOrderGroupsQuery(baseOptions?: Apollo.QueryHookOptions<FilteredOrderGroupsQuery, FilteredOrderGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredOrderGroupsQuery, FilteredOrderGroupsQueryVariables>(FilteredOrderGroupsDocument, options);
      }
export function useFilteredOrderGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredOrderGroupsQuery, FilteredOrderGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredOrderGroupsQuery, FilteredOrderGroupsQueryVariables>(FilteredOrderGroupsDocument, options);
        }
export type FilteredOrderGroupsQueryHookResult = ReturnType<typeof useFilteredOrderGroupsQuery>;
export type FilteredOrderGroupsLazyQueryHookResult = ReturnType<typeof useFilteredOrderGroupsLazyQuery>;
export type FilteredOrderGroupsQueryResult = Apollo.QueryResult<FilteredOrderGroupsQuery, FilteredOrderGroupsQueryVariables>;
export const FilteredPandaBoxAssetsDocument = gql`
    query FilteredPandaBoxAssets {
  filteredPandaBoxAssets {
    id
    name
    assignedPandaBox {
      id
      assignedAsset {
        id
        name
      }
      pandaBoxAssets {
        id
        active
        asset {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useFilteredPandaBoxAssetsQuery__
 *
 * To run a query within a React component, call `useFilteredPandaBoxAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredPandaBoxAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredPandaBoxAssetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFilteredPandaBoxAssetsQuery(baseOptions?: Apollo.QueryHookOptions<FilteredPandaBoxAssetsQuery, FilteredPandaBoxAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredPandaBoxAssetsQuery, FilteredPandaBoxAssetsQueryVariables>(FilteredPandaBoxAssetsDocument, options);
      }
export function useFilteredPandaBoxAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredPandaBoxAssetsQuery, FilteredPandaBoxAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredPandaBoxAssetsQuery, FilteredPandaBoxAssetsQueryVariables>(FilteredPandaBoxAssetsDocument, options);
        }
export type FilteredPandaBoxAssetsQueryHookResult = ReturnType<typeof useFilteredPandaBoxAssetsQuery>;
export type FilteredPandaBoxAssetsLazyQueryHookResult = ReturnType<typeof useFilteredPandaBoxAssetsLazyQuery>;
export type FilteredPandaBoxAssetsQueryResult = Apollo.QueryResult<FilteredPandaBoxAssetsQuery, FilteredPandaBoxAssetsQueryVariables>;
export const FilteredPandaBoxesDocument = gql`
    query FilteredPandaBoxes($limit: Int, $offset: Int, $filter: PandaBoxFilter) {
  filteredPandaBoxes(limit: $limit, offset: $offset, filter: $filter) {
    collection {
      id
      imeiNumber
      version
      name
      pandaBoxAssets {
        id
        lastAssignedAt
        active
        asset {
          id
          name
        }
      }
      assignedAsset {
        id
        name
      }
      pandaBoxMeters {
        id
        lcpNode
        lastSyncedAt
        meterModel
        productCategory {
          id
          name
        }
        totalizers
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFilteredPandaBoxesQuery__
 *
 * To run a query within a React component, call `useFilteredPandaBoxesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredPandaBoxesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredPandaBoxesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFilteredPandaBoxesQuery(baseOptions?: Apollo.QueryHookOptions<FilteredPandaBoxesQuery, FilteredPandaBoxesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredPandaBoxesQuery, FilteredPandaBoxesQueryVariables>(FilteredPandaBoxesDocument, options);
      }
export function useFilteredPandaBoxesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredPandaBoxesQuery, FilteredPandaBoxesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredPandaBoxesQuery, FilteredPandaBoxesQueryVariables>(FilteredPandaBoxesDocument, options);
        }
export type FilteredPandaBoxesQueryHookResult = ReturnType<typeof useFilteredPandaBoxesQuery>;
export type FilteredPandaBoxesLazyQueryHookResult = ReturnType<typeof useFilteredPandaBoxesLazyQuery>;
export type FilteredPandaBoxesQueryResult = Apollo.QueryResult<FilteredPandaBoxesQuery, FilteredPandaBoxesQueryVariables>;
export const FilteredPeripheralsDocument = gql`
    query FilteredPeripherals($limit: Int, $offset: Int, $name: String, $sorter: [BaseSorter!]) {
  filteredPeripherals(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {name: $name}
  ) {
    collection {
      id
      legalDescription
      soldAs
      status
      subType
      erpId
      peripheralCategory {
        id
        name
      }
      lineOfServices {
        id
        name
        nameWithAncestors
      }
      cost
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFilteredPeripheralsQuery__
 *
 * To run a query within a React component, call `useFilteredPeripheralsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredPeripheralsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredPeripheralsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      name: // value for 'name'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilteredPeripheralsQuery(baseOptions?: Apollo.QueryHookOptions<FilteredPeripheralsQuery, FilteredPeripheralsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredPeripheralsQuery, FilteredPeripheralsQueryVariables>(FilteredPeripheralsDocument, options);
      }
export function useFilteredPeripheralsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredPeripheralsQuery, FilteredPeripheralsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredPeripheralsQuery, FilteredPeripheralsQueryVariables>(FilteredPeripheralsDocument, options);
        }
export type FilteredPeripheralsQueryHookResult = ReturnType<typeof useFilteredPeripheralsQuery>;
export type FilteredPeripheralsLazyQueryHookResult = ReturnType<typeof useFilteredPeripheralsLazyQuery>;
export type FilteredPeripheralsQueryResult = Apollo.QueryResult<FilteredPeripheralsQuery, FilteredPeripheralsQueryVariables>;
export const FilteredPickupPointCodesDocument = gql`
    query FilteredPickupPointCodes($limit: Int, $offset: Int, $all: String, $sorter: [PickupPointCodeSorter!]) {
  filteredPickupPointCodes(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {all: $all}
  ) {
    collection {
      id
      name
      code
      terminal {
        id
        name
      }
      supplier {
        id
        name
      }
      netsuiteId
      terminalsSupplier {
        id
        bolTimeAt
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFilteredPickupPointCodesQuery__
 *
 * To run a query within a React component, call `useFilteredPickupPointCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredPickupPointCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredPickupPointCodesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      all: // value for 'all'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilteredPickupPointCodesQuery(baseOptions?: Apollo.QueryHookOptions<FilteredPickupPointCodesQuery, FilteredPickupPointCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredPickupPointCodesQuery, FilteredPickupPointCodesQueryVariables>(FilteredPickupPointCodesDocument, options);
      }
export function useFilteredPickupPointCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredPickupPointCodesQuery, FilteredPickupPointCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredPickupPointCodesQuery, FilteredPickupPointCodesQueryVariables>(FilteredPickupPointCodesDocument, options);
        }
export type FilteredPickupPointCodesQueryHookResult = ReturnType<typeof useFilteredPickupPointCodesQuery>;
export type FilteredPickupPointCodesLazyQueryHookResult = ReturnType<typeof useFilteredPickupPointCodesLazyQuery>;
export type FilteredPickupPointCodesQueryResult = Apollo.QueryResult<FilteredPickupPointCodesQuery, FilteredPickupPointCodesQueryVariables>;
export const FilteredProductPurchaseLimitDocument = gql`
    query FilteredProductPurchaseLimit($name: String, $limit: Int, $offset: Int) {
  filteredProductPurchaseLimit(
    filter: {name: $name}
    limit: $limit
    offset: $offset
  ) {
    collection {
      id
      name
      volume
      product {
        id
        name
      }
      timeUnit
      customers {
        id
        name
      }
    }
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useFilteredProductPurchaseLimitQuery__
 *
 * To run a query within a React component, call `useFilteredProductPurchaseLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredProductPurchaseLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredProductPurchaseLimitQuery({
 *   variables: {
 *      name: // value for 'name'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFilteredProductPurchaseLimitQuery(baseOptions?: Apollo.QueryHookOptions<FilteredProductPurchaseLimitQuery, FilteredProductPurchaseLimitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredProductPurchaseLimitQuery, FilteredProductPurchaseLimitQueryVariables>(FilteredProductPurchaseLimitDocument, options);
      }
export function useFilteredProductPurchaseLimitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredProductPurchaseLimitQuery, FilteredProductPurchaseLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredProductPurchaseLimitQuery, FilteredProductPurchaseLimitQueryVariables>(FilteredProductPurchaseLimitDocument, options);
        }
export type FilteredProductPurchaseLimitQueryHookResult = ReturnType<typeof useFilteredProductPurchaseLimitQuery>;
export type FilteredProductPurchaseLimitLazyQueryHookResult = ReturnType<typeof useFilteredProductPurchaseLimitLazyQuery>;
export type FilteredProductPurchaseLimitQueryResult = Apollo.QueryResult<FilteredProductPurchaseLimitQuery, FilteredProductPurchaseLimitQueryVariables>;
export const FilteredProductsDocument = gql`
    query FilteredProducts($limit: Int, $offset: Int, $all: String, $sorter: [ProductSorter!]) {
  filteredProducts(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {all: $all}
  ) {
    collection {
      id
      active
      name
      shortName
      productType
      unit
      deliveryType
      code
      erpId
      irelyId
      lastSyncedTime
      soldAs
      glNumber
      productSubCategory {
        id
        name
      }
      legalDescription
      productCategory {
        id
        name
      }
      netsuiteId
      lineOfServices {
        id
        name
      }
      nonEditableRecords
      hub {
        name
        address
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFilteredProductsQuery__
 *
 * To run a query within a React component, call `useFilteredProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredProductsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      all: // value for 'all'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilteredProductsQuery(baseOptions?: Apollo.QueryHookOptions<FilteredProductsQuery, FilteredProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredProductsQuery, FilteredProductsQueryVariables>(FilteredProductsDocument, options);
      }
export function useFilteredProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredProductsQuery, FilteredProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredProductsQuery, FilteredProductsQueryVariables>(FilteredProductsDocument, options);
        }
export type FilteredProductsQueryHookResult = ReturnType<typeof useFilteredProductsQuery>;
export type FilteredProductsLazyQueryHookResult = ReturnType<typeof useFilteredProductsLazyQuery>;
export type FilteredProductsQueryResult = Apollo.QueryResult<FilteredProductsQuery, FilteredProductsQueryVariables>;
export const FilteredSidekiqRequestsDocument = gql`
    query FilteredSidekiqRequests($limit: Int, $offset: Int, $all: String, $sorter: [SidekiqRequestSorter!]) {
  filteredSidekiqRequest(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {all: $all}
  ) {
    collection {
      id
      caller
      status
      description
      createdAtTimestamp
      resultExists
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFilteredSidekiqRequestsQuery__
 *
 * To run a query within a React component, call `useFilteredSidekiqRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredSidekiqRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredSidekiqRequestsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      all: // value for 'all'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilteredSidekiqRequestsQuery(baseOptions?: Apollo.QueryHookOptions<FilteredSidekiqRequestsQuery, FilteredSidekiqRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredSidekiqRequestsQuery, FilteredSidekiqRequestsQueryVariables>(FilteredSidekiqRequestsDocument, options);
      }
export function useFilteredSidekiqRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredSidekiqRequestsQuery, FilteredSidekiqRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredSidekiqRequestsQuery, FilteredSidekiqRequestsQueryVariables>(FilteredSidekiqRequestsDocument, options);
        }
export type FilteredSidekiqRequestsQueryHookResult = ReturnType<typeof useFilteredSidekiqRequestsQuery>;
export type FilteredSidekiqRequestsLazyQueryHookResult = ReturnType<typeof useFilteredSidekiqRequestsLazyQuery>;
export type FilteredSidekiqRequestsQueryResult = Apollo.QueryResult<FilteredSidekiqRequestsQuery, FilteredSidekiqRequestsQueryVariables>;
export const FilteredSuppliersDocument = gql`
    query FilteredSuppliers($limit: Int, $offset: Int, $all: String, $sorter: [SupplierSorter!]) {
  filteredSuppliers(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {all: $all}
  ) {
    collection {
      id
      name
      erpId
      active
      supplierCode
      irelyId
      lastSyncedTime
      terminalsSuppliers {
        id
        terminal {
          name
          active
        }
      }
      loadingAccounts {
        id
        carrierCustomerCode
        loadingNumber
      }
      netsuiteId
      lineOfServices {
        id
        name
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFilteredSuppliersQuery__
 *
 * To run a query within a React component, call `useFilteredSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredSuppliersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      all: // value for 'all'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilteredSuppliersQuery(baseOptions?: Apollo.QueryHookOptions<FilteredSuppliersQuery, FilteredSuppliersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredSuppliersQuery, FilteredSuppliersQueryVariables>(FilteredSuppliersDocument, options);
      }
export function useFilteredSuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredSuppliersQuery, FilteredSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredSuppliersQuery, FilteredSuppliersQueryVariables>(FilteredSuppliersDocument, options);
        }
export type FilteredSuppliersQueryHookResult = ReturnType<typeof useFilteredSuppliersQuery>;
export type FilteredSuppliersLazyQueryHookResult = ReturnType<typeof useFilteredSuppliersLazyQuery>;
export type FilteredSuppliersQueryResult = Apollo.QueryResult<FilteredSuppliersQuery, FilteredSuppliersQueryVariables>;
export const FilteredSuppliersForDropDownOptionsDocument = gql`
    query FilteredSuppliersForDropDownOptions($limit: Int, $offset: Int, $all: String, $sorter: [SupplierSorter!]) {
  filteredSuppliers(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {all: $all, active: true}
  ) {
    collection {
      id
      name
      erpId
      active
      supplierCode
      irelyId
      terminalsSuppliers {
        id
        terminal {
          name
          active
        }
      }
      loadingAccounts {
        id
        carrierCustomerCode
        loadingNumber
      }
      netsuiteId
      lineOfServices {
        id
        name
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFilteredSuppliersForDropDownOptionsQuery__
 *
 * To run a query within a React component, call `useFilteredSuppliersForDropDownOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredSuppliersForDropDownOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredSuppliersForDropDownOptionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      all: // value for 'all'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilteredSuppliersForDropDownOptionsQuery(baseOptions?: Apollo.QueryHookOptions<FilteredSuppliersForDropDownOptionsQuery, FilteredSuppliersForDropDownOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredSuppliersForDropDownOptionsQuery, FilteredSuppliersForDropDownOptionsQueryVariables>(FilteredSuppliersForDropDownOptionsDocument, options);
      }
export function useFilteredSuppliersForDropDownOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredSuppliersForDropDownOptionsQuery, FilteredSuppliersForDropDownOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredSuppliersForDropDownOptionsQuery, FilteredSuppliersForDropDownOptionsQueryVariables>(FilteredSuppliersForDropDownOptionsDocument, options);
        }
export type FilteredSuppliersForDropDownOptionsQueryHookResult = ReturnType<typeof useFilteredSuppliersForDropDownOptionsQuery>;
export type FilteredSuppliersForDropDownOptionsLazyQueryHookResult = ReturnType<typeof useFilteredSuppliersForDropDownOptionsLazyQuery>;
export type FilteredSuppliersForDropDownOptionsQueryResult = Apollo.QueryResult<FilteredSuppliersForDropDownOptionsQuery, FilteredSuppliersForDropDownOptionsQueryVariables>;
export const FilteredTerminalsDocument = gql`
    query FilteredTerminals($limit: Int, $offset: Int, $all: String, $isWarehouse: Boolean, $sorter: [TerminalSorter!]) {
  filteredTerminals(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {all: $all, isWarehouse: $isWarehouse}
  ) {
    collection {
      id
      name
      erpId
      isWarehouse
      active
      irelyId
      lastSyncedTime
      site {
        radius
        address
      }
      suppliers {
        name
        active
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFilteredTerminalsQuery__
 *
 * To run a query within a React component, call `useFilteredTerminalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredTerminalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredTerminalsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      all: // value for 'all'
 *      isWarehouse: // value for 'isWarehouse'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilteredTerminalsQuery(baseOptions?: Apollo.QueryHookOptions<FilteredTerminalsQuery, FilteredTerminalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredTerminalsQuery, FilteredTerminalsQueryVariables>(FilteredTerminalsDocument, options);
      }
export function useFilteredTerminalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredTerminalsQuery, FilteredTerminalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredTerminalsQuery, FilteredTerminalsQueryVariables>(FilteredTerminalsDocument, options);
        }
export type FilteredTerminalsQueryHookResult = ReturnType<typeof useFilteredTerminalsQuery>;
export type FilteredTerminalsLazyQueryHookResult = ReturnType<typeof useFilteredTerminalsLazyQuery>;
export type FilteredTerminalsQueryResult = Apollo.QueryResult<FilteredTerminalsQuery, FilteredTerminalsQueryVariables>;
export const FilteredTerminalsSuppliersDocument = gql`
    query FilteredTerminalsSuppliers($filter: TerminalsSupplierFilter) {
  filteredTerminalsSuppliers(filter: $filter) {
    collection {
      id
      bolTimeAt
      nonEditableRecords
      supplier {
        id
        name
        active
        netsuiteId
      }
      terminal {
        id
        name
      }
      pickupPointCodes {
        id
        name
        code
        loadingAccountId
      }
    }
  }
}
    `;

/**
 * __useFilteredTerminalsSuppliersQuery__
 *
 * To run a query within a React component, call `useFilteredTerminalsSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredTerminalsSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredTerminalsSuppliersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFilteredTerminalsSuppliersQuery(baseOptions?: Apollo.QueryHookOptions<FilteredTerminalsSuppliersQuery, FilteredTerminalsSuppliersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredTerminalsSuppliersQuery, FilteredTerminalsSuppliersQueryVariables>(FilteredTerminalsSuppliersDocument, options);
      }
export function useFilteredTerminalsSuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredTerminalsSuppliersQuery, FilteredTerminalsSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredTerminalsSuppliersQuery, FilteredTerminalsSuppliersQueryVariables>(FilteredTerminalsSuppliersDocument, options);
        }
export type FilteredTerminalsSuppliersQueryHookResult = ReturnType<typeof useFilteredTerminalsSuppliersQuery>;
export type FilteredTerminalsSuppliersLazyQueryHookResult = ReturnType<typeof useFilteredTerminalsSuppliersLazyQuery>;
export type FilteredTerminalsSuppliersQueryResult = Apollo.QueryResult<FilteredTerminalsSuppliersQuery, FilteredTerminalsSuppliersQueryVariables>;
export const InviteCustomerToPortalDocument = gql`
    mutation InviteCustomerToPortal($input: CustomerPortalInput!) {
  inviteCustomerToPortal(input: {data: $input}) {
    addressBook {
      id
      name
      email
      phone
    }
  }
}
    `;
export type InviteCustomerToPortalMutationFn = Apollo.MutationFunction<InviteCustomerToPortalMutation, InviteCustomerToPortalMutationVariables>;

/**
 * __useInviteCustomerToPortalMutation__
 *
 * To run a mutation, you first call `useInviteCustomerToPortalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteCustomerToPortalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteCustomerToPortalMutation, { data, loading, error }] = useInviteCustomerToPortalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteCustomerToPortalMutation(baseOptions?: Apollo.MutationHookOptions<InviteCustomerToPortalMutation, InviteCustomerToPortalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteCustomerToPortalMutation, InviteCustomerToPortalMutationVariables>(InviteCustomerToPortalDocument, options);
      }
export type InviteCustomerToPortalMutationHookResult = ReturnType<typeof useInviteCustomerToPortalMutation>;
export type InviteCustomerToPortalMutationResult = Apollo.MutationResult<InviteCustomerToPortalMutation>;
export type InviteCustomerToPortalMutationOptions = Apollo.BaseMutationOptions<InviteCustomerToPortalMutation, InviteCustomerToPortalMutationVariables>;
export const MergeCustomerResourcesDocument = gql`
    mutation mergeCustomerResources($data: CustomerResourceInput!) {
  mergeCustomerResources(input: {data: $data}) {
    success
  }
}
    `;
export type MergeCustomerResourcesMutationFn = Apollo.MutationFunction<MergeCustomerResourcesMutation, MergeCustomerResourcesMutationVariables>;

/**
 * __useMergeCustomerResourcesMutation__
 *
 * To run a mutation, you first call `useMergeCustomerResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeCustomerResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeCustomerResourcesMutation, { data, loading, error }] = useMergeCustomerResourcesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMergeCustomerResourcesMutation(baseOptions?: Apollo.MutationHookOptions<MergeCustomerResourcesMutation, MergeCustomerResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeCustomerResourcesMutation, MergeCustomerResourcesMutationVariables>(MergeCustomerResourcesDocument, options);
      }
export type MergeCustomerResourcesMutationHookResult = ReturnType<typeof useMergeCustomerResourcesMutation>;
export type MergeCustomerResourcesMutationResult = Apollo.MutationResult<MergeCustomerResourcesMutation>;
export type MergeCustomerResourcesMutationOptions = Apollo.BaseMutationOptions<MergeCustomerResourcesMutation, MergeCustomerResourcesMutationVariables>;
export const RefetchCustomersAsynchronouslyDocument = gql`
    mutation refetchCustomersAsynchronously($input: RefetchCustomersAsynchronouslyInput!) {
  refetchCustomersAsynchronously(input: $input) {
    success
  }
}
    `;
export type RefetchCustomersAsynchronouslyMutationFn = Apollo.MutationFunction<RefetchCustomersAsynchronouslyMutation, RefetchCustomersAsynchronouslyMutationVariables>;

/**
 * __useRefetchCustomersAsynchronouslyMutation__
 *
 * To run a mutation, you first call `useRefetchCustomersAsynchronouslyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefetchCustomersAsynchronouslyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refetchCustomersAsynchronouslyMutation, { data, loading, error }] = useRefetchCustomersAsynchronouslyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefetchCustomersAsynchronouslyMutation(baseOptions?: Apollo.MutationHookOptions<RefetchCustomersAsynchronouslyMutation, RefetchCustomersAsynchronouslyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefetchCustomersAsynchronouslyMutation, RefetchCustomersAsynchronouslyMutationVariables>(RefetchCustomersAsynchronouslyDocument, options);
      }
export type RefetchCustomersAsynchronouslyMutationHookResult = ReturnType<typeof useRefetchCustomersAsynchronouslyMutation>;
export type RefetchCustomersAsynchronouslyMutationResult = Apollo.MutationResult<RefetchCustomersAsynchronouslyMutation>;
export type RefetchCustomersAsynchronouslyMutationOptions = Apollo.BaseMutationOptions<RefetchCustomersAsynchronouslyMutation, RefetchCustomersAsynchronouslyMutationVariables>;
export const RemoveCodeFromAssetDocument = gql`
    mutation removeCodeFromAsset($input: RemoveCodeInput!) {
  removeCodeFromAsset(input: $input) {
    success
  }
}
    `;
export type RemoveCodeFromAssetMutationFn = Apollo.MutationFunction<RemoveCodeFromAssetMutation, RemoveCodeFromAssetMutationVariables>;

/**
 * __useRemoveCodeFromAssetMutation__
 *
 * To run a mutation, you first call `useRemoveCodeFromAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCodeFromAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCodeFromAssetMutation, { data, loading, error }] = useRemoveCodeFromAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCodeFromAssetMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCodeFromAssetMutation, RemoveCodeFromAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCodeFromAssetMutation, RemoveCodeFromAssetMutationVariables>(RemoveCodeFromAssetDocument, options);
      }
export type RemoveCodeFromAssetMutationHookResult = ReturnType<typeof useRemoveCodeFromAssetMutation>;
export type RemoveCodeFromAssetMutationResult = Apollo.MutationResult<RemoveCodeFromAssetMutation>;
export type RemoveCodeFromAssetMutationOptions = Apollo.BaseMutationOptions<RemoveCodeFromAssetMutation, RemoveCodeFromAssetMutationVariables>;
export const RemoveQrCodeFromAssetDocument = gql`
    mutation removeQrCodeFromAsset($input: RemoveQrCodeInput!) {
  removeQrCodeFromAsset(input: $input) {
    asset {
      id
    }
  }
}
    `;
export type RemoveQrCodeFromAssetMutationFn = Apollo.MutationFunction<RemoveQrCodeFromAssetMutation, RemoveQrCodeFromAssetMutationVariables>;

/**
 * __useRemoveQrCodeFromAssetMutation__
 *
 * To run a mutation, you first call `useRemoveQrCodeFromAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveQrCodeFromAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeQrCodeFromAssetMutation, { data, loading, error }] = useRemoveQrCodeFromAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveQrCodeFromAssetMutation(baseOptions?: Apollo.MutationHookOptions<RemoveQrCodeFromAssetMutation, RemoveQrCodeFromAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveQrCodeFromAssetMutation, RemoveQrCodeFromAssetMutationVariables>(RemoveQrCodeFromAssetDocument, options);
      }
export type RemoveQrCodeFromAssetMutationHookResult = ReturnType<typeof useRemoveQrCodeFromAssetMutation>;
export type RemoveQrCodeFromAssetMutationResult = Apollo.MutationResult<RemoveQrCodeFromAssetMutation>;
export type RemoveQrCodeFromAssetMutationOptions = Apollo.BaseMutationOptions<RemoveQrCodeFromAssetMutation, RemoveQrCodeFromAssetMutationVariables>;
export const SidekiqRequestDetailsDocument = gql`
    query SidekiqRequestDetails($id: ID) {
  filteredSidekiqRequest(filter: {id: $id}) {
    collection {
      id
      caller
      status
      request
      result
    }
  }
}
    `;

/**
 * __useSidekiqRequestDetailsQuery__
 *
 * To run a query within a React component, call `useSidekiqRequestDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSidekiqRequestDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSidekiqRequestDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSidekiqRequestDetailsQuery(baseOptions?: Apollo.QueryHookOptions<SidekiqRequestDetailsQuery, SidekiqRequestDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SidekiqRequestDetailsQuery, SidekiqRequestDetailsQueryVariables>(SidekiqRequestDetailsDocument, options);
      }
export function useSidekiqRequestDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SidekiqRequestDetailsQuery, SidekiqRequestDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SidekiqRequestDetailsQuery, SidekiqRequestDetailsQueryVariables>(SidekiqRequestDetailsDocument, options);
        }
export type SidekiqRequestDetailsQueryHookResult = ReturnType<typeof useSidekiqRequestDetailsQuery>;
export type SidekiqRequestDetailsLazyQueryHookResult = ReturnType<typeof useSidekiqRequestDetailsLazyQuery>;
export type SidekiqRequestDetailsQueryResult = Apollo.QueryResult<SidekiqRequestDetailsQuery, SidekiqRequestDetailsQueryVariables>;
export const SyncDataFromVendorDocument = gql`
    mutation syncDataFromVendor($input: SyncDataFromVendorInput!) {
  syncDataFromVendor(input: $input) {
    success
  }
}
    `;
export type SyncDataFromVendorMutationFn = Apollo.MutationFunction<SyncDataFromVendorMutation, SyncDataFromVendorMutationVariables>;

/**
 * __useSyncDataFromVendorMutation__
 *
 * To run a mutation, you first call `useSyncDataFromVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncDataFromVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncDataFromVendorMutation, { data, loading, error }] = useSyncDataFromVendorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncDataFromVendorMutation(baseOptions?: Apollo.MutationHookOptions<SyncDataFromVendorMutation, SyncDataFromVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncDataFromVendorMutation, SyncDataFromVendorMutationVariables>(SyncDataFromVendorDocument, options);
      }
export type SyncDataFromVendorMutationHookResult = ReturnType<typeof useSyncDataFromVendorMutation>;
export type SyncDataFromVendorMutationResult = Apollo.MutationResult<SyncDataFromVendorMutation>;
export type SyncDataFromVendorMutationOptions = Apollo.BaseMutationOptions<SyncDataFromVendorMutation, SyncDataFromVendorMutationVariables>;
export const UpdateAssetDocument = gql`
    mutation updateAsset($input: UpdateAssetsInput!) {
  updateAsset(input: $input) {
    asset {
      ...customerAssetData
    }
  }
}
    ${CustomerAssetDataFragmentDoc}`;
export type UpdateAssetMutationFn = Apollo.MutationFunction<UpdateAssetMutation, UpdateAssetMutationVariables>;

/**
 * __useUpdateAssetMutation__
 *
 * To run a mutation, you first call `useUpdateAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssetMutation, { data, loading, error }] = useUpdateAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssetMutation, UpdateAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssetMutation, UpdateAssetMutationVariables>(UpdateAssetDocument, options);
      }
export type UpdateAssetMutationHookResult = ReturnType<typeof useUpdateAssetMutation>;
export type UpdateAssetMutationResult = Apollo.MutationResult<UpdateAssetMutation>;
export type UpdateAssetMutationOptions = Apollo.BaseMutationOptions<UpdateAssetMutation, UpdateAssetMutationVariables>;
export const UpdateBrandDocument = gql`
    mutation UpdateBrand($input: UpdateBrandInput!) {
  updateBrand(input: {data: $input}) {
    brand {
      id
      name
    }
  }
}
    `;
export type UpdateBrandMutationFn = Apollo.MutationFunction<UpdateBrandMutation, UpdateBrandMutationVariables>;

/**
 * __useUpdateBrandMutation__
 *
 * To run a mutation, you first call `useUpdateBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandMutation, { data, loading, error }] = useUpdateBrandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBrandMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrandMutation, UpdateBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrandMutation, UpdateBrandMutationVariables>(UpdateBrandDocument, options);
      }
export type UpdateBrandMutationHookResult = ReturnType<typeof useUpdateBrandMutation>;
export type UpdateBrandMutationResult = Apollo.MutationResult<UpdateBrandMutation>;
export type UpdateBrandMutationOptions = Apollo.BaseMutationOptions<UpdateBrandMutation, UpdateBrandMutationVariables>;
export const UpdateCustomerDocument = gql`
    mutation UpdateCustomer($input: UpdateCustomerInput!) {
  updateCustomer(input: {data: $input}) {
    customer {
      id
      name
      enableCreateDeliveryOrder
      customerPortalPermissions
      portalAccessLevel
    }
  }
}
    `;
export type UpdateCustomerMutationFn = Apollo.MutationFunction<UpdateCustomerMutation, UpdateCustomerMutationVariables>;

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>(UpdateCustomerDocument, options);
      }
export type UpdateCustomerMutationHookResult = ReturnType<typeof useUpdateCustomerMutation>;
export type UpdateCustomerMutationResult = Apollo.MutationResult<UpdateCustomerMutation>;
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const UpdateCustomerBranchDocument = gql`
    mutation UpdateCustomerBranch($input: UpdateCustomerBranchInput!) {
  updateCustomerBranch(input: {data: $input}) {
    customerBranch {
      id
      name
      addressBooks {
        id
        name
        email
        addressBookType
        hasAccessToCustomerPortal
      }
    }
  }
}
    `;
export type UpdateCustomerBranchMutationFn = Apollo.MutationFunction<UpdateCustomerBranchMutation, UpdateCustomerBranchMutationVariables>;

/**
 * __useUpdateCustomerBranchMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerBranchMutation, { data, loading, error }] = useUpdateCustomerBranchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerBranchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerBranchMutation, UpdateCustomerBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerBranchMutation, UpdateCustomerBranchMutationVariables>(UpdateCustomerBranchDocument, options);
      }
export type UpdateCustomerBranchMutationHookResult = ReturnType<typeof useUpdateCustomerBranchMutation>;
export type UpdateCustomerBranchMutationResult = Apollo.MutationResult<UpdateCustomerBranchMutation>;
export type UpdateCustomerBranchMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerBranchMutation, UpdateCustomerBranchMutationVariables>;
export const UpdateCustomerPreferencesDocument = gql`
    mutation UpdateCustomerPreferences($input: UpdateCustomerPreferencesInput!) {
  updateCustomerPreferences(input: $input) {
    customer {
      id
      addressBooks {
        image {
          url
        }
      }
    }
    error
    message
  }
}
    `;
export type UpdateCustomerPreferencesMutationFn = Apollo.MutationFunction<UpdateCustomerPreferencesMutation, UpdateCustomerPreferencesMutationVariables>;

/**
 * __useUpdateCustomerPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerPreferencesMutation, { data, loading, error }] = useUpdateCustomerPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerPreferencesMutation, UpdateCustomerPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerPreferencesMutation, UpdateCustomerPreferencesMutationVariables>(UpdateCustomerPreferencesDocument, options);
      }
export type UpdateCustomerPreferencesMutationHookResult = ReturnType<typeof useUpdateCustomerPreferencesMutation>;
export type UpdateCustomerPreferencesMutationResult = Apollo.MutationResult<UpdateCustomerPreferencesMutation>;
export type UpdateCustomerPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerPreferencesMutation, UpdateCustomerPreferencesMutationVariables>;
export const UpdateCustomerSegmentDocument = gql`
    mutation UpdateCustomerSegment($input: CustomerSegmentInput!) {
  updateCustomerSegment(input: {data: $input}) {
    customerSegment {
      id
      name
      code
      segmentType
    }
  }
}
    `;
export type UpdateCustomerSegmentMutationFn = Apollo.MutationFunction<UpdateCustomerSegmentMutation, UpdateCustomerSegmentMutationVariables>;

/**
 * __useUpdateCustomerSegmentMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerSegmentMutation, { data, loading, error }] = useUpdateCustomerSegmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerSegmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerSegmentMutation, UpdateCustomerSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerSegmentMutation, UpdateCustomerSegmentMutationVariables>(UpdateCustomerSegmentDocument, options);
      }
export type UpdateCustomerSegmentMutationHookResult = ReturnType<typeof useUpdateCustomerSegmentMutation>;
export type UpdateCustomerSegmentMutationResult = Apollo.MutationResult<UpdateCustomerSegmentMutation>;
export type UpdateCustomerSegmentMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerSegmentMutation, UpdateCustomerSegmentMutationVariables>;
export const UpdateDriverDocument = gql`
    mutation UpdateDriver($input: UpdateDriverInput!) {
  updateDriver(input: {data: $input}) {
    driver {
      id
      name
      erpId
    }
  }
}
    `;
export type UpdateDriverMutationFn = Apollo.MutationFunction<UpdateDriverMutation, UpdateDriverMutationVariables>;

/**
 * __useUpdateDriverMutation__
 *
 * To run a mutation, you first call `useUpdateDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverMutation, { data, loading, error }] = useUpdateDriverMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDriverMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDriverMutation, UpdateDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDriverMutation, UpdateDriverMutationVariables>(UpdateDriverDocument, options);
      }
export type UpdateDriverMutationHookResult = ReturnType<typeof useUpdateDriverMutation>;
export type UpdateDriverMutationResult = Apollo.MutationResult<UpdateDriverMutation>;
export type UpdateDriverMutationOptions = Apollo.BaseMutationOptions<UpdateDriverMutation, UpdateDriverMutationVariables>;
export const UpdateDriverDemurrageDocument = gql`
    mutation UpdateDriverDemurrage($input: UpdateDriverDemurrageInput!) {
  updateDriverDemurrage(input: $input) {
    driverDemurrage {
      id
      customer {
        name
      }
    }
  }
}
    `;
export type UpdateDriverDemurrageMutationFn = Apollo.MutationFunction<UpdateDriverDemurrageMutation, UpdateDriverDemurrageMutationVariables>;

/**
 * __useUpdateDriverDemurrageMutation__
 *
 * To run a mutation, you first call `useUpdateDriverDemurrageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverDemurrageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverDemurrageMutation, { data, loading, error }] = useUpdateDriverDemurrageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDriverDemurrageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDriverDemurrageMutation, UpdateDriverDemurrageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDriverDemurrageMutation, UpdateDriverDemurrageMutationVariables>(UpdateDriverDemurrageDocument, options);
      }
export type UpdateDriverDemurrageMutationHookResult = ReturnType<typeof useUpdateDriverDemurrageMutation>;
export type UpdateDriverDemurrageMutationResult = Apollo.MutationResult<UpdateDriverDemurrageMutation>;
export type UpdateDriverDemurrageMutationOptions = Apollo.BaseMutationOptions<UpdateDriverDemurrageMutation, UpdateDriverDemurrageMutationVariables>;
export const UpdateDriverOtpDocument = gql`
    mutation UpdateDriverOtp($driverId: ID!) {
  updateDriverOtp(input: {driverId: $driverId}) {
    clientMutationId
    driver {
      otp
    }
  }
}
    `;
export type UpdateDriverOtpMutationFn = Apollo.MutationFunction<UpdateDriverOtpMutation, UpdateDriverOtpMutationVariables>;

/**
 * __useUpdateDriverOtpMutation__
 *
 * To run a mutation, you first call `useUpdateDriverOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverOtpMutation, { data, loading, error }] = useUpdateDriverOtpMutation({
 *   variables: {
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useUpdateDriverOtpMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDriverOtpMutation, UpdateDriverOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDriverOtpMutation, UpdateDriverOtpMutationVariables>(UpdateDriverOtpDocument, options);
      }
export type UpdateDriverOtpMutationHookResult = ReturnType<typeof useUpdateDriverOtpMutation>;
export type UpdateDriverOtpMutationResult = Apollo.MutationResult<UpdateDriverOtpMutation>;
export type UpdateDriverOtpMutationOptions = Apollo.BaseMutationOptions<UpdateDriverOtpMutation, UpdateDriverOtpMutationVariables>;
export const UpdateFeeDocument = gql`
    mutation UpdateFee($input: UpdateFeesInput!) {
  updateFee(input: $input) {
    fee {
      id
    }
  }
}
    `;
export type UpdateFeeMutationFn = Apollo.MutationFunction<UpdateFeeMutation, UpdateFeeMutationVariables>;

/**
 * __useUpdateFeeMutation__
 *
 * To run a mutation, you first call `useUpdateFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeeMutation, { data, loading, error }] = useUpdateFeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeeMutation, UpdateFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeeMutation, UpdateFeeMutationVariables>(UpdateFeeDocument, options);
      }
export type UpdateFeeMutationHookResult = ReturnType<typeof useUpdateFeeMutation>;
export type UpdateFeeMutationResult = Apollo.MutationResult<UpdateFeeMutation>;
export type UpdateFeeMutationOptions = Apollo.BaseMutationOptions<UpdateFeeMutation, UpdateFeeMutationVariables>;
export const UpdateLineOfServiceDocument = gql`
    mutation UpdateLineOfService($input: UpdateLineOfServiceInput!) {
  updateLineOfService(input: {data: $input}) {
    lineOfService {
      id
      name
    }
  }
}
    `;
export type UpdateLineOfServiceMutationFn = Apollo.MutationFunction<UpdateLineOfServiceMutation, UpdateLineOfServiceMutationVariables>;

/**
 * __useUpdateLineOfServiceMutation__
 *
 * To run a mutation, you first call `useUpdateLineOfServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLineOfServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLineOfServiceMutation, { data, loading, error }] = useUpdateLineOfServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLineOfServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLineOfServiceMutation, UpdateLineOfServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLineOfServiceMutation, UpdateLineOfServiceMutationVariables>(UpdateLineOfServiceDocument, options);
      }
export type UpdateLineOfServiceMutationHookResult = ReturnType<typeof useUpdateLineOfServiceMutation>;
export type UpdateLineOfServiceMutationResult = Apollo.MutationResult<UpdateLineOfServiceMutation>;
export type UpdateLineOfServiceMutationOptions = Apollo.BaseMutationOptions<UpdateLineOfServiceMutation, UpdateLineOfServiceMutationVariables>;
export const UpdateLoadingAccountDocument = gql`
    mutation UpdateLoadingAccount($input: UpdateLoadingAccountsInput!) {
  updateLoadingAccount(input: $input) {
    loadingAccount {
      id
    }
  }
}
    `;
export type UpdateLoadingAccountMutationFn = Apollo.MutationFunction<UpdateLoadingAccountMutation, UpdateLoadingAccountMutationVariables>;

/**
 * __useUpdateLoadingAccountMutation__
 *
 * To run a mutation, you first call `useUpdateLoadingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoadingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoadingAccountMutation, { data, loading, error }] = useUpdateLoadingAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLoadingAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLoadingAccountMutation, UpdateLoadingAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLoadingAccountMutation, UpdateLoadingAccountMutationVariables>(UpdateLoadingAccountDocument, options);
      }
export type UpdateLoadingAccountMutationHookResult = ReturnType<typeof useUpdateLoadingAccountMutation>;
export type UpdateLoadingAccountMutationResult = Apollo.MutationResult<UpdateLoadingAccountMutation>;
export type UpdateLoadingAccountMutationOptions = Apollo.BaseMutationOptions<UpdateLoadingAccountMutation, UpdateLoadingAccountMutationVariables>;
export const UpdatePaymentTermDocument = gql`
    mutation UpdatePaymentTerm($input: PaymentTermInput!) {
  updatePaymentTerm(input: {data: $input}) {
    paymentTerm {
      id
      name
      description
      netDaysToPay
    }
  }
}
    `;
export type UpdatePaymentTermMutationFn = Apollo.MutationFunction<UpdatePaymentTermMutation, UpdatePaymentTermMutationVariables>;

/**
 * __useUpdatePaymentTermMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentTermMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentTermMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentTermMutation, { data, loading, error }] = useUpdatePaymentTermMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaymentTermMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentTermMutation, UpdatePaymentTermMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentTermMutation, UpdatePaymentTermMutationVariables>(UpdatePaymentTermDocument, options);
      }
export type UpdatePaymentTermMutationHookResult = ReturnType<typeof useUpdatePaymentTermMutation>;
export type UpdatePaymentTermMutationResult = Apollo.MutationResult<UpdatePaymentTermMutation>;
export type UpdatePaymentTermMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentTermMutation, UpdatePaymentTermMutationVariables>;
export const UpdatePeripheralDocument = gql`
    mutation UpdatePeripheral($input: PeripheralInput!) {
  updatePeripheral(input: {data: $input}) {
    peripheral {
      id
    }
  }
}
    `;
export type UpdatePeripheralMutationFn = Apollo.MutationFunction<UpdatePeripheralMutation, UpdatePeripheralMutationVariables>;

/**
 * __useUpdatePeripheralMutation__
 *
 * To run a mutation, you first call `useUpdatePeripheralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePeripheralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePeripheralMutation, { data, loading, error }] = useUpdatePeripheralMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePeripheralMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePeripheralMutation, UpdatePeripheralMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePeripheralMutation, UpdatePeripheralMutationVariables>(UpdatePeripheralDocument, options);
      }
export type UpdatePeripheralMutationHookResult = ReturnType<typeof useUpdatePeripheralMutation>;
export type UpdatePeripheralMutationResult = Apollo.MutationResult<UpdatePeripheralMutation>;
export type UpdatePeripheralMutationOptions = Apollo.BaseMutationOptions<UpdatePeripheralMutation, UpdatePeripheralMutationVariables>;
export const UpdateProductDocument = gql`
    mutation UpdateProduct($input: UpdateProductsInput!) {
  updateProduct(input: $input) {
    product {
      id
    }
  }
}
    `;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const UpdateProductPurchaseLimitsDocument = gql`
    mutation UpdateProductPurchaseLimits($input: UpdateProductPurchaseLimitsInput!) {
  updateProductPurchaseLimit(input: $input) {
    productPurchaseLimit {
      id
    }
  }
}
    `;
export type UpdateProductPurchaseLimitsMutationFn = Apollo.MutationFunction<UpdateProductPurchaseLimitsMutation, UpdateProductPurchaseLimitsMutationVariables>;

/**
 * __useUpdateProductPurchaseLimitsMutation__
 *
 * To run a mutation, you first call `useUpdateProductPurchaseLimitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductPurchaseLimitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductPurchaseLimitsMutation, { data, loading, error }] = useUpdateProductPurchaseLimitsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductPurchaseLimitsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductPurchaseLimitsMutation, UpdateProductPurchaseLimitsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductPurchaseLimitsMutation, UpdateProductPurchaseLimitsMutationVariables>(UpdateProductPurchaseLimitsDocument, options);
      }
export type UpdateProductPurchaseLimitsMutationHookResult = ReturnType<typeof useUpdateProductPurchaseLimitsMutation>;
export type UpdateProductPurchaseLimitsMutationResult = Apollo.MutationResult<UpdateProductPurchaseLimitsMutation>;
export type UpdateProductPurchaseLimitsMutationOptions = Apollo.BaseMutationOptions<UpdateProductPurchaseLimitsMutation, UpdateProductPurchaseLimitsMutationVariables>;
export const UpdateRouteConfigDocument = gql`
    mutation UpdateRouteConfig($input: UpdateRouteConfigInput!) {
  updateRouteConfig(input: $input) {
    success
    errors
  }
}
    `;
export type UpdateRouteConfigMutationFn = Apollo.MutationFunction<UpdateRouteConfigMutation, UpdateRouteConfigMutationVariables>;

/**
 * __useUpdateRouteConfigMutation__
 *
 * To run a mutation, you first call `useUpdateRouteConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRouteConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRouteConfigMutation, { data, loading, error }] = useUpdateRouteConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRouteConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRouteConfigMutation, UpdateRouteConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRouteConfigMutation, UpdateRouteConfigMutationVariables>(UpdateRouteConfigDocument, options);
      }
export type UpdateRouteConfigMutationHookResult = ReturnType<typeof useUpdateRouteConfigMutation>;
export type UpdateRouteConfigMutationResult = Apollo.MutationResult<UpdateRouteConfigMutation>;
export type UpdateRouteConfigMutationOptions = Apollo.BaseMutationOptions<UpdateRouteConfigMutation, UpdateRouteConfigMutationVariables>;
export const UpdateSupplierDocument = gql`
    mutation UpdateSupplier($input: UpdateSupplierInput!) {
  updateSupplier(input: {data: $input}) {
    supplier {
      id
    }
  }
}
    `;
export type UpdateSupplierMutationFn = Apollo.MutationFunction<UpdateSupplierMutation, UpdateSupplierMutationVariables>;

/**
 * __useUpdateSupplierMutation__
 *
 * To run a mutation, you first call `useUpdateSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplierMutation, { data, loading, error }] = useUpdateSupplierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSupplierMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupplierMutation, UpdateSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupplierMutation, UpdateSupplierMutationVariables>(UpdateSupplierDocument, options);
      }
export type UpdateSupplierMutationHookResult = ReturnType<typeof useUpdateSupplierMutation>;
export type UpdateSupplierMutationResult = Apollo.MutationResult<UpdateSupplierMutation>;
export type UpdateSupplierMutationOptions = Apollo.BaseMutationOptions<UpdateSupplierMutation, UpdateSupplierMutationVariables>;
export const UpdateTerminalDocument = gql`
    mutation UpdateTerminal($input: UpdateTerminalInput!) {
  updateTerminal(input: {data: $input}) {
    terminal {
      id
    }
  }
}
    `;
export type UpdateTerminalMutationFn = Apollo.MutationFunction<UpdateTerminalMutation, UpdateTerminalMutationVariables>;

/**
 * __useUpdateTerminalMutation__
 *
 * To run a mutation, you first call `useUpdateTerminalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTerminalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTerminalMutation, { data, loading, error }] = useUpdateTerminalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTerminalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTerminalMutation, UpdateTerminalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTerminalMutation, UpdateTerminalMutationVariables>(UpdateTerminalDocument, options);
      }
export type UpdateTerminalMutationHookResult = ReturnType<typeof useUpdateTerminalMutation>;
export type UpdateTerminalMutationResult = Apollo.MutationResult<UpdateTerminalMutation>;
export type UpdateTerminalMutationOptions = Apollo.BaseMutationOptions<UpdateTerminalMutation, UpdateTerminalMutationVariables>;
export const UpdateTerminalsSupplierDocument = gql`
    mutation UpdateTerminalsSupplier($input: UpdateTerminalsSuppliersInput!) {
  updateTerminalsSupplier(input: $input) {
    terminalsSupplier {
      id
    }
  }
}
    `;
export type UpdateTerminalsSupplierMutationFn = Apollo.MutationFunction<UpdateTerminalsSupplierMutation, UpdateTerminalsSupplierMutationVariables>;

/**
 * __useUpdateTerminalsSupplierMutation__
 *
 * To run a mutation, you first call `useUpdateTerminalsSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTerminalsSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTerminalsSupplierMutation, { data, loading, error }] = useUpdateTerminalsSupplierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTerminalsSupplierMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTerminalsSupplierMutation, UpdateTerminalsSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTerminalsSupplierMutation, UpdateTerminalsSupplierMutationVariables>(UpdateTerminalsSupplierDocument, options);
      }
export type UpdateTerminalsSupplierMutationHookResult = ReturnType<typeof useUpdateTerminalsSupplierMutation>;
export type UpdateTerminalsSupplierMutationResult = Apollo.MutationResult<UpdateTerminalsSupplierMutation>;
export type UpdateTerminalsSupplierMutationOptions = Apollo.BaseMutationOptions<UpdateTerminalsSupplierMutation, UpdateTerminalsSupplierMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($input: UpdateCustomerUsersInput!) {
  updateCustomerUser(input: $input) {
    customerUser {
      id
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserOtpDocument = gql`
    mutation UpdateUserOtp($userId: ID!) {
  updateUserOtp(input: {userId: $userId}) {
    clientMutationId
    user {
      otp
    }
  }
}
    `;
export type UpdateUserOtpMutationFn = Apollo.MutationFunction<UpdateUserOtpMutation, UpdateUserOtpMutationVariables>;

/**
 * __useUpdateUserOtpMutation__
 *
 * To run a mutation, you first call `useUpdateUserOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserOtpMutation, { data, loading, error }] = useUpdateUserOtpMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateUserOtpMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserOtpMutation, UpdateUserOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserOtpMutation, UpdateUserOtpMutationVariables>(UpdateUserOtpDocument, options);
      }
export type UpdateUserOtpMutationHookResult = ReturnType<typeof useUpdateUserOtpMutation>;
export type UpdateUserOtpMutationResult = Apollo.MutationResult<UpdateUserOtpMutation>;
export type UpdateUserOtpMutationOptions = Apollo.BaseMutationOptions<UpdateUserOtpMutation, UpdateUserOtpMutationVariables>;
export const CreateResourceComponentDocument = gql`
    mutation CreateResourceComponent($input: CreateResourceComponentInput!) {
  createResourceComponent(input: $input) {
    resourceComponentType {
      error
      success
      resourceTenant {
        id
        previousResource {
          ... on Asset {
            status
            lastActiveTenantId
          }
        }
      }
    }
  }
}
    `;
export type CreateResourceComponentMutationFn = Apollo.MutationFunction<CreateResourceComponentMutation, CreateResourceComponentMutationVariables>;

/**
 * __useCreateResourceComponentMutation__
 *
 * To run a mutation, you first call `useCreateResourceComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResourceComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResourceComponentMutation, { data, loading, error }] = useCreateResourceComponentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateResourceComponentMutation(baseOptions?: Apollo.MutationHookOptions<CreateResourceComponentMutation, CreateResourceComponentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResourceComponentMutation, CreateResourceComponentMutationVariables>(CreateResourceComponentDocument, options);
      }
export type CreateResourceComponentMutationHookResult = ReturnType<typeof useCreateResourceComponentMutation>;
export type CreateResourceComponentMutationResult = Apollo.MutationResult<CreateResourceComponentMutation>;
export type CreateResourceComponentMutationOptions = Apollo.BaseMutationOptions<CreateResourceComponentMutation, CreateResourceComponentMutationVariables>;
export const FetchAssociatedTenantsDocument = gql`
    query FetchAssociatedTenants($id: ID!) {
  associatedTenants(tenantId: $id) {
    id
    name
  }
}
    `;

/**
 * __useFetchAssociatedTenantsQuery__
 *
 * To run a query within a React component, call `useFetchAssociatedTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAssociatedTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAssociatedTenantsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchAssociatedTenantsQuery(baseOptions: Apollo.QueryHookOptions<FetchAssociatedTenantsQuery, FetchAssociatedTenantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAssociatedTenantsQuery, FetchAssociatedTenantsQueryVariables>(FetchAssociatedTenantsDocument, options);
      }
export function useFetchAssociatedTenantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAssociatedTenantsQuery, FetchAssociatedTenantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAssociatedTenantsQuery, FetchAssociatedTenantsQueryVariables>(FetchAssociatedTenantsDocument, options);
        }
export type FetchAssociatedTenantsQueryHookResult = ReturnType<typeof useFetchAssociatedTenantsQuery>;
export type FetchAssociatedTenantsLazyQueryHookResult = ReturnType<typeof useFetchAssociatedTenantsLazyQuery>;
export type FetchAssociatedTenantsQueryResult = Apollo.QueryResult<FetchAssociatedTenantsQuery, FetchAssociatedTenantsQueryVariables>;
export const FetchProductsAssetFormDocument = gql`
    query FetchProductsAssetForm($customFilter: ProductFilter, $limit: Int, $offset: Int) {
  filteredProducts(filter: $customFilter, limit: $limit, offset: $offset) {
    collection {
      id
      name
      category
      productType
    }
    metadata {
      hasMore
    }
  }
}
    `;

/**
 * __useFetchProductsAssetFormQuery__
 *
 * To run a query within a React component, call `useFetchProductsAssetFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductsAssetFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductsAssetFormQuery({
 *   variables: {
 *      customFilter: // value for 'customFilter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFetchProductsAssetFormQuery(baseOptions?: Apollo.QueryHookOptions<FetchProductsAssetFormQuery, FetchProductsAssetFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchProductsAssetFormQuery, FetchProductsAssetFormQueryVariables>(FetchProductsAssetFormDocument, options);
      }
export function useFetchProductsAssetFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchProductsAssetFormQuery, FetchProductsAssetFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchProductsAssetFormQuery, FetchProductsAssetFormQueryVariables>(FetchProductsAssetFormDocument, options);
        }
export type FetchProductsAssetFormQueryHookResult = ReturnType<typeof useFetchProductsAssetFormQuery>;
export type FetchProductsAssetFormLazyQueryHookResult = ReturnType<typeof useFetchProductsAssetFormLazyQuery>;
export type FetchProductsAssetFormQueryResult = Apollo.QueryResult<FetchProductsAssetFormQuery, FetchProductsAssetFormQueryVariables>;
export const FetchResourceTenantCustomerBranchesDocument = gql`
    query FetchResourceTenantCustomerBranches($limit: Int, $offset: Int, $filter: CustomerBranchesFilter) {
  fetchResourceTenantCustomerBranches(
    limit: $limit
    offset: $offset
    filter: $filter
  ) {
    collection {
      id
      name
      site {
        address
      }
    }
    metadata {
      hasMore
    }
  }
}
    `;

/**
 * __useFetchResourceTenantCustomerBranchesQuery__
 *
 * To run a query within a React component, call `useFetchResourceTenantCustomerBranchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchResourceTenantCustomerBranchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchResourceTenantCustomerBranchesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchResourceTenantCustomerBranchesQuery(baseOptions?: Apollo.QueryHookOptions<FetchResourceTenantCustomerBranchesQuery, FetchResourceTenantCustomerBranchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchResourceTenantCustomerBranchesQuery, FetchResourceTenantCustomerBranchesQueryVariables>(FetchResourceTenantCustomerBranchesDocument, options);
      }
export function useFetchResourceTenantCustomerBranchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchResourceTenantCustomerBranchesQuery, FetchResourceTenantCustomerBranchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchResourceTenantCustomerBranchesQuery, FetchResourceTenantCustomerBranchesQueryVariables>(FetchResourceTenantCustomerBranchesDocument, options);
        }
export type FetchResourceTenantCustomerBranchesQueryHookResult = ReturnType<typeof useFetchResourceTenantCustomerBranchesQuery>;
export type FetchResourceTenantCustomerBranchesLazyQueryHookResult = ReturnType<typeof useFetchResourceTenantCustomerBranchesLazyQuery>;
export type FetchResourceTenantCustomerBranchesQueryResult = Apollo.QueryResult<FetchResourceTenantCustomerBranchesQuery, FetchResourceTenantCustomerBranchesQueryVariables>;
export const FetchResourceTenantCustomersDocument = gql`
    query FetchResourceTenantCustomers($limit: Int, $offset: Int, $filter: CustomersFilter) {
  fetchResourceTenantCustomers(limit: $limit, offset: $offset, filter: $filter) {
    collection {
      id
      name
    }
    metadata {
      hasMore
    }
  }
}
    `;

/**
 * __useFetchResourceTenantCustomersQuery__
 *
 * To run a query within a React component, call `useFetchResourceTenantCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchResourceTenantCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchResourceTenantCustomersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchResourceTenantCustomersQuery(baseOptions?: Apollo.QueryHookOptions<FetchResourceTenantCustomersQuery, FetchResourceTenantCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchResourceTenantCustomersQuery, FetchResourceTenantCustomersQueryVariables>(FetchResourceTenantCustomersDocument, options);
      }
export function useFetchResourceTenantCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchResourceTenantCustomersQuery, FetchResourceTenantCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchResourceTenantCustomersQuery, FetchResourceTenantCustomersQueryVariables>(FetchResourceTenantCustomersDocument, options);
        }
export type FetchResourceTenantCustomersQueryHookResult = ReturnType<typeof useFetchResourceTenantCustomersQuery>;
export type FetchResourceTenantCustomersLazyQueryHookResult = ReturnType<typeof useFetchResourceTenantCustomersLazyQuery>;
export type FetchResourceTenantCustomersQueryResult = Apollo.QueryResult<FetchResourceTenantCustomersQuery, FetchResourceTenantCustomersQueryVariables>;
export const AssociateIrelyEntityWithFpDocument = gql`
    mutation associateIrelyEntityWithFp($input: AssociateIrelyEntityInput!) {
  associateIrelyEntityWithFp(input: {associateIrelyEntityAttributes: $input}) {
    success
  }
}
    `;
export type AssociateIrelyEntityWithFpMutationFn = Apollo.MutationFunction<AssociateIrelyEntityWithFpMutation, AssociateIrelyEntityWithFpMutationVariables>;

/**
 * __useAssociateIrelyEntityWithFpMutation__
 *
 * To run a mutation, you first call `useAssociateIrelyEntityWithFpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateIrelyEntityWithFpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateIrelyEntityWithFpMutation, { data, loading, error }] = useAssociateIrelyEntityWithFpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssociateIrelyEntityWithFpMutation(baseOptions?: Apollo.MutationHookOptions<AssociateIrelyEntityWithFpMutation, AssociateIrelyEntityWithFpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssociateIrelyEntityWithFpMutation, AssociateIrelyEntityWithFpMutationVariables>(AssociateIrelyEntityWithFpDocument, options);
      }
export type AssociateIrelyEntityWithFpMutationHookResult = ReturnType<typeof useAssociateIrelyEntityWithFpMutation>;
export type AssociateIrelyEntityWithFpMutationResult = Apollo.MutationResult<AssociateIrelyEntityWithFpMutation>;
export type AssociateIrelyEntityWithFpMutationOptions = Apollo.BaseMutationOptions<AssociateIrelyEntityWithFpMutation, AssociateIrelyEntityWithFpMutationVariables>;
export const CreateUpdateIrelyFilterDocument = gql`
    mutation createUpdateIrelyFilter($input: IrelyFilterInput!) {
  createUpdateIrelyFilter(input: {irelyFilterAttributes: $input}) {
    irelyFilter {
      id
      entity
      filter
    }
  }
}
    `;
export type CreateUpdateIrelyFilterMutationFn = Apollo.MutationFunction<CreateUpdateIrelyFilterMutation, CreateUpdateIrelyFilterMutationVariables>;

/**
 * __useCreateUpdateIrelyFilterMutation__
 *
 * To run a mutation, you first call `useCreateUpdateIrelyFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateIrelyFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateIrelyFilterMutation, { data, loading, error }] = useCreateUpdateIrelyFilterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUpdateIrelyFilterMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateIrelyFilterMutation, CreateUpdateIrelyFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateIrelyFilterMutation, CreateUpdateIrelyFilterMutationVariables>(CreateUpdateIrelyFilterDocument, options);
      }
export type CreateUpdateIrelyFilterMutationHookResult = ReturnType<typeof useCreateUpdateIrelyFilterMutation>;
export type CreateUpdateIrelyFilterMutationResult = Apollo.MutationResult<CreateUpdateIrelyFilterMutation>;
export type CreateUpdateIrelyFilterMutationOptions = Apollo.BaseMutationOptions<CreateUpdateIrelyFilterMutation, CreateUpdateIrelyFilterMutationVariables>;
export const FetchIrelyFiltersDocument = gql`
    query fetchIrelyFilters {
  irelyFilters {
    id
    entity
    filter
    filterType
  }
}
    `;

/**
 * __useFetchIrelyFiltersQuery__
 *
 * To run a query within a React component, call `useFetchIrelyFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchIrelyFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchIrelyFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchIrelyFiltersQuery(baseOptions?: Apollo.QueryHookOptions<FetchIrelyFiltersQuery, FetchIrelyFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchIrelyFiltersQuery, FetchIrelyFiltersQueryVariables>(FetchIrelyFiltersDocument, options);
      }
export function useFetchIrelyFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchIrelyFiltersQuery, FetchIrelyFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchIrelyFiltersQuery, FetchIrelyFiltersQueryVariables>(FetchIrelyFiltersDocument, options);
        }
export type FetchIrelyFiltersQueryHookResult = ReturnType<typeof useFetchIrelyFiltersQuery>;
export type FetchIrelyFiltersLazyQueryHookResult = ReturnType<typeof useFetchIrelyFiltersLazyQuery>;
export type FetchIrelyFiltersQueryResult = Apollo.QueryResult<FetchIrelyFiltersQuery, FetchIrelyFiltersQueryVariables>;
export const FetchIrelyProductCategoriesDocument = gql`
    query fetchIrelyProductCategories {
  irelyProductCategories {
    id
    categoryCode
    description
    lineOfBusiness
    erpId
    isRetailValuation
    productCategory {
      id
      name
    }
  }
}
    `;

/**
 * __useFetchIrelyProductCategoriesQuery__
 *
 * To run a query within a React component, call `useFetchIrelyProductCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchIrelyProductCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchIrelyProductCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchIrelyProductCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<FetchIrelyProductCategoriesQuery, FetchIrelyProductCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchIrelyProductCategoriesQuery, FetchIrelyProductCategoriesQueryVariables>(FetchIrelyProductCategoriesDocument, options);
      }
export function useFetchIrelyProductCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchIrelyProductCategoriesQuery, FetchIrelyProductCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchIrelyProductCategoriesQuery, FetchIrelyProductCategoriesQueryVariables>(FetchIrelyProductCategoriesDocument, options);
        }
export type FetchIrelyProductCategoriesQueryHookResult = ReturnType<typeof useFetchIrelyProductCategoriesQuery>;
export type FetchIrelyProductCategoriesLazyQueryHookResult = ReturnType<typeof useFetchIrelyProductCategoriesLazyQuery>;
export type FetchIrelyProductCategoriesQueryResult = Apollo.QueryResult<FetchIrelyProductCategoriesQuery, FetchIrelyProductCategoriesQueryVariables>;
export const FetchIrelyUomsDocument = gql`
    query fetchIrelyUoms {
  irelyUoms {
    id
    erpId
    name
    symbol
    unitType
    decimalPlaces
    fpValue
  }
}
    `;

/**
 * __useFetchIrelyUomsQuery__
 *
 * To run a query within a React component, call `useFetchIrelyUomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchIrelyUomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchIrelyUomsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchIrelyUomsQuery(baseOptions?: Apollo.QueryHookOptions<FetchIrelyUomsQuery, FetchIrelyUomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchIrelyUomsQuery, FetchIrelyUomsQueryVariables>(FetchIrelyUomsDocument, options);
      }
export function useFetchIrelyUomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchIrelyUomsQuery, FetchIrelyUomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchIrelyUomsQuery, FetchIrelyUomsQueryVariables>(FetchIrelyUomsDocument, options);
        }
export type FetchIrelyUomsQueryHookResult = ReturnType<typeof useFetchIrelyUomsQuery>;
export type FetchIrelyUomsLazyQueryHookResult = ReturnType<typeof useFetchIrelyUomsLazyQuery>;
export type FetchIrelyUomsQueryResult = Apollo.QueryResult<FetchIrelyUomsQuery, FetchIrelyUomsQueryVariables>;
export const DeleteLineOfServiceDocument = gql`
    mutation DeleteLineOfService($input: DeleteLineOfServicesInput!) {
  deleteLineOfService(input: $input) {
    response {
      id
      success
      error
    }
  }
}
    `;
export type DeleteLineOfServiceMutationFn = Apollo.MutationFunction<DeleteLineOfServiceMutation, DeleteLineOfServiceMutationVariables>;

/**
 * __useDeleteLineOfServiceMutation__
 *
 * To run a mutation, you first call `useDeleteLineOfServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLineOfServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLineOfServiceMutation, { data, loading, error }] = useDeleteLineOfServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLineOfServiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLineOfServiceMutation, DeleteLineOfServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLineOfServiceMutation, DeleteLineOfServiceMutationVariables>(DeleteLineOfServiceDocument, options);
      }
export type DeleteLineOfServiceMutationHookResult = ReturnType<typeof useDeleteLineOfServiceMutation>;
export type DeleteLineOfServiceMutationResult = Apollo.MutationResult<DeleteLineOfServiceMutation>;
export type DeleteLineOfServiceMutationOptions = Apollo.BaseMutationOptions<DeleteLineOfServiceMutation, DeleteLineOfServiceMutationVariables>;
export const FetchFilteredLineOfServicesDocument = gql`
    query FetchFilteredLineOfServices($limit: Int, $offset: Int, $filter: LineOfServiceFilter, $sorter: [LineOfServiceSorter!]) {
  filteredLineOfServices(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: $filter
  ) {
    collection {
      id
      name
      shortName
      active
      erpId
      parent {
        id
        nameWithAncestors
      }
      suppliers {
        id
        name
      }
    }
    metadata {
      hasMore
      totalCount
    }
  }
}
    `;

/**
 * __useFetchFilteredLineOfServicesQuery__
 *
 * To run a query within a React component, call `useFetchFilteredLineOfServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredLineOfServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredLineOfServicesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchFilteredLineOfServicesQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredLineOfServicesQuery, FetchFilteredLineOfServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredLineOfServicesQuery, FetchFilteredLineOfServicesQueryVariables>(FetchFilteredLineOfServicesDocument, options);
      }
export function useFetchFilteredLineOfServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredLineOfServicesQuery, FetchFilteredLineOfServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredLineOfServicesQuery, FetchFilteredLineOfServicesQueryVariables>(FetchFilteredLineOfServicesDocument, options);
        }
export type FetchFilteredLineOfServicesQueryHookResult = ReturnType<typeof useFetchFilteredLineOfServicesQuery>;
export type FetchFilteredLineOfServicesLazyQueryHookResult = ReturnType<typeof useFetchFilteredLineOfServicesLazyQuery>;
export type FetchFilteredLineOfServicesQueryResult = Apollo.QueryResult<FetchFilteredLineOfServicesQuery, FetchFilteredLineOfServicesQueryVariables>;
export const FetchLosExportCsvDocument = gql`
    query FetchLOSExportCSV($losId: [ID!], $parentLos: [ID!], $active: Boolean) {
  exportLineOfServicesCsv(losId: $losId, parentLos: $parentLos, active: $active) {
    content
    fileName
    error
  }
}
    `;

/**
 * __useFetchLosExportCsvQuery__
 *
 * To run a query within a React component, call `useFetchLosExportCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLosExportCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLosExportCsvQuery({
 *   variables: {
 *      losId: // value for 'losId'
 *      parentLos: // value for 'parentLos'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useFetchLosExportCsvQuery(baseOptions?: Apollo.QueryHookOptions<FetchLosExportCsvQuery, FetchLosExportCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLosExportCsvQuery, FetchLosExportCsvQueryVariables>(FetchLosExportCsvDocument, options);
      }
export function useFetchLosExportCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLosExportCsvQuery, FetchLosExportCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLosExportCsvQuery, FetchLosExportCsvQueryVariables>(FetchLosExportCsvDocument, options);
        }
export type FetchLosExportCsvQueryHookResult = ReturnType<typeof useFetchLosExportCsvQuery>;
export type FetchLosExportCsvLazyQueryHookResult = ReturnType<typeof useFetchLosExportCsvLazyQuery>;
export type FetchLosExportCsvQueryResult = Apollo.QueryResult<FetchLosExportCsvQuery, FetchLosExportCsvQueryVariables>;
export const FetchParentLosDocument = gql`
    query FetchParentLOS {
  lineOfServices {
    id
    nameWithAncestors
    __typename
  }
}
    `;

/**
 * __useFetchParentLosQuery__
 *
 * To run a query within a React component, call `useFetchParentLosQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchParentLosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchParentLosQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchParentLosQuery(baseOptions?: Apollo.QueryHookOptions<FetchParentLosQuery, FetchParentLosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchParentLosQuery, FetchParentLosQueryVariables>(FetchParentLosDocument, options);
      }
export function useFetchParentLosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchParentLosQuery, FetchParentLosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchParentLosQuery, FetchParentLosQueryVariables>(FetchParentLosDocument, options);
        }
export type FetchParentLosQueryHookResult = ReturnType<typeof useFetchParentLosQuery>;
export type FetchParentLosLazyQueryHookResult = ReturnType<typeof useFetchParentLosLazyQuery>;
export type FetchParentLosQueryResult = Apollo.QueryResult<FetchParentLosQuery, FetchParentLosQueryVariables>;
export const DeletePickupPointCodeDocument = gql`
    mutation DeletePickupPointCode($input: DeletePickupPointCodesInput!) {
  deletePickupPointCode(input: $input) {
    response {
      id
      success
      error
    }
  }
}
    `;
export type DeletePickupPointCodeMutationFn = Apollo.MutationFunction<DeletePickupPointCodeMutation, DeletePickupPointCodeMutationVariables>;

/**
 * __useDeletePickupPointCodeMutation__
 *
 * To run a mutation, you first call `useDeletePickupPointCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePickupPointCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePickupPointCodeMutation, { data, loading, error }] = useDeletePickupPointCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePickupPointCodeMutation(baseOptions?: Apollo.MutationHookOptions<DeletePickupPointCodeMutation, DeletePickupPointCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePickupPointCodeMutation, DeletePickupPointCodeMutationVariables>(DeletePickupPointCodeDocument, options);
      }
export type DeletePickupPointCodeMutationHookResult = ReturnType<typeof useDeletePickupPointCodeMutation>;
export type DeletePickupPointCodeMutationResult = Apollo.MutationResult<DeletePickupPointCodeMutation>;
export type DeletePickupPointCodeMutationOptions = Apollo.BaseMutationOptions<DeletePickupPointCodeMutation, DeletePickupPointCodeMutationVariables>;
export const ExportPpcCsvDocument = gql`
    query ExportPpcCsv {
  exportPpcCsv {
    content
    fileName
    error
  }
}
    `;

/**
 * __useExportPpcCsvQuery__
 *
 * To run a query within a React component, call `useExportPpcCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportPpcCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportPpcCsvQuery({
 *   variables: {
 *   },
 * });
 */
export function useExportPpcCsvQuery(baseOptions?: Apollo.QueryHookOptions<ExportPpcCsvQuery, ExportPpcCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportPpcCsvQuery, ExportPpcCsvQueryVariables>(ExportPpcCsvDocument, options);
      }
export function useExportPpcCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportPpcCsvQuery, ExportPpcCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportPpcCsvQuery, ExportPpcCsvQueryVariables>(ExportPpcCsvDocument, options);
        }
export type ExportPpcCsvQueryHookResult = ReturnType<typeof useExportPpcCsvQuery>;
export type ExportPpcCsvLazyQueryHookResult = ReturnType<typeof useExportPpcCsvLazyQuery>;
export type ExportPpcCsvQueryResult = Apollo.QueryResult<ExportPpcCsvQuery, ExportPpcCsvQueryVariables>;
export const FetchFilteredPickupPointCodesV2Document = gql`
    query FetchFilteredPickupPointCodesV2($limit: Int, $offset: Int, $all: String, $sorter: [PickupPointCodeSorter!]) {
  filteredPickupPointCodes(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {all: $all}
  ) {
    collection {
      id
      name
      code
      erpId
      loadingAccount {
        id
        loadingNumber
      }
      terminal {
        id
        name
        products {
          id
          name
        }
      }
      supplier {
        id
        name
      }
      products {
        id
        name
      }
      terminalsSupplier {
        id
        bolTimeAt
      }
    }
    metadata {
      hasMore
      totalCount
    }
  }
}
    `;

/**
 * __useFetchFilteredPickupPointCodesV2Query__
 *
 * To run a query within a React component, call `useFetchFilteredPickupPointCodesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredPickupPointCodesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredPickupPointCodesV2Query({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      all: // value for 'all'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchFilteredPickupPointCodesV2Query(baseOptions?: Apollo.QueryHookOptions<FetchFilteredPickupPointCodesV2Query, FetchFilteredPickupPointCodesV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredPickupPointCodesV2Query, FetchFilteredPickupPointCodesV2QueryVariables>(FetchFilteredPickupPointCodesV2Document, options);
      }
export function useFetchFilteredPickupPointCodesV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredPickupPointCodesV2Query, FetchFilteredPickupPointCodesV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredPickupPointCodesV2Query, FetchFilteredPickupPointCodesV2QueryVariables>(FetchFilteredPickupPointCodesV2Document, options);
        }
export type FetchFilteredPickupPointCodesV2QueryHookResult = ReturnType<typeof useFetchFilteredPickupPointCodesV2Query>;
export type FetchFilteredPickupPointCodesV2LazyQueryHookResult = ReturnType<typeof useFetchFilteredPickupPointCodesV2LazyQuery>;
export type FetchFilteredPickupPointCodesV2QueryResult = Apollo.QueryResult<FetchFilteredPickupPointCodesV2Query, FetchFilteredPickupPointCodesV2QueryVariables>;
export const UpdatePickupPointCodeDocument = gql`
    mutation UpdatePickupPointCode($input: UpdatePickupPointCodesInput!) {
  updatePickupPointCode(input: $input) {
    pickupPointCode {
      id
      code
      erpId
      products {
        id
        name
      }
    }
  }
}
    `;
export type UpdatePickupPointCodeMutationFn = Apollo.MutationFunction<UpdatePickupPointCodeMutation, UpdatePickupPointCodeMutationVariables>;

/**
 * __useUpdatePickupPointCodeMutation__
 *
 * To run a mutation, you first call `useUpdatePickupPointCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePickupPointCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePickupPointCodeMutation, { data, loading, error }] = useUpdatePickupPointCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePickupPointCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePickupPointCodeMutation, UpdatePickupPointCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePickupPointCodeMutation, UpdatePickupPointCodeMutationVariables>(UpdatePickupPointCodeDocument, options);
      }
export type UpdatePickupPointCodeMutationHookResult = ReturnType<typeof useUpdatePickupPointCodeMutation>;
export type UpdatePickupPointCodeMutationResult = Apollo.MutationResult<UpdatePickupPointCodeMutation>;
export type UpdatePickupPointCodeMutationOptions = Apollo.BaseMutationOptions<UpdatePickupPointCodeMutation, UpdatePickupPointCodeMutationVariables>;
export const CreateRackMarketDocument = gql`
    mutation CreateRackMarket($input: CreateRackMarketInput!) {
  createRackMarket(input: $input) {
    rackMarket {
      id
      name
      active
    }
  }
}
    `;
export type CreateRackMarketMutationFn = Apollo.MutationFunction<CreateRackMarketMutation, CreateRackMarketMutationVariables>;

/**
 * __useCreateRackMarketMutation__
 *
 * To run a mutation, you first call `useCreateRackMarketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRackMarketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRackMarketMutation, { data, loading, error }] = useCreateRackMarketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRackMarketMutation(baseOptions?: Apollo.MutationHookOptions<CreateRackMarketMutation, CreateRackMarketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRackMarketMutation, CreateRackMarketMutationVariables>(CreateRackMarketDocument, options);
      }
export type CreateRackMarketMutationHookResult = ReturnType<typeof useCreateRackMarketMutation>;
export type CreateRackMarketMutationResult = Apollo.MutationResult<CreateRackMarketMutation>;
export type CreateRackMarketMutationOptions = Apollo.BaseMutationOptions<CreateRackMarketMutation, CreateRackMarketMutationVariables>;
export const DeleteRackMarketDocument = gql`
    mutation DeleteRackMarket($input: DeleteRackMarketInput!) {
  deleteRackMarket(input: $input) {
    response {
      id
      success
      error
    }
  }
}
    `;
export type DeleteRackMarketMutationFn = Apollo.MutationFunction<DeleteRackMarketMutation, DeleteRackMarketMutationVariables>;

/**
 * __useDeleteRackMarketMutation__
 *
 * To run a mutation, you first call `useDeleteRackMarketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRackMarketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRackMarketMutation, { data, loading, error }] = useDeleteRackMarketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRackMarketMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRackMarketMutation, DeleteRackMarketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRackMarketMutation, DeleteRackMarketMutationVariables>(DeleteRackMarketDocument, options);
      }
export type DeleteRackMarketMutationHookResult = ReturnType<typeof useDeleteRackMarketMutation>;
export type DeleteRackMarketMutationResult = Apollo.MutationResult<DeleteRackMarketMutation>;
export type DeleteRackMarketMutationOptions = Apollo.BaseMutationOptions<DeleteRackMarketMutation, DeleteRackMarketMutationVariables>;
export const FetchFilteredRackMarketsDocument = gql`
    query FetchFilteredRackMarkets($limit: Int, $offset: Int, $filter: RackMarketFilter) {
  rackMarkets(limit: $limit, offset: $offset, filter: $filter) {
    collection {
      id
      name
      active
      erpId
      hubs {
        id
        name
      }
      terminals {
        id
        name
      }
    }
    metadata {
      hasMore
      totalCount
    }
  }
}
    `;

/**
 * __useFetchFilteredRackMarketsQuery__
 *
 * To run a query within a React component, call `useFetchFilteredRackMarketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredRackMarketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredRackMarketsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchFilteredRackMarketsQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredRackMarketsQuery, FetchFilteredRackMarketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredRackMarketsQuery, FetchFilteredRackMarketsQueryVariables>(FetchFilteredRackMarketsDocument, options);
      }
export function useFetchFilteredRackMarketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredRackMarketsQuery, FetchFilteredRackMarketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredRackMarketsQuery, FetchFilteredRackMarketsQueryVariables>(FetchFilteredRackMarketsDocument, options);
        }
export type FetchFilteredRackMarketsQueryHookResult = ReturnType<typeof useFetchFilteredRackMarketsQuery>;
export type FetchFilteredRackMarketsLazyQueryHookResult = ReturnType<typeof useFetchFilteredRackMarketsLazyQuery>;
export type FetchFilteredRackMarketsQueryResult = Apollo.QueryResult<FetchFilteredRackMarketsQuery, FetchFilteredRackMarketsQueryVariables>;
export const FetchHubsForRackMarketDocument = gql`
    query FetchHubsForRackMarket($limit: Int, $offset: Int, $searchText: String, $customerId: ID) {
  filteredCustomerBranches(
    limit: $limit
    offset: $offset
    filter: {isHub: true, active: true, all: $searchText, customerId: $customerId}
  ) {
    collection {
      id
      name
    }
    metadata {
      hasMore
    }
  }
}
    `;

/**
 * __useFetchHubsForRackMarketQuery__
 *
 * To run a query within a React component, call `useFetchHubsForRackMarketQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchHubsForRackMarketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchHubsForRackMarketQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      searchText: // value for 'searchText'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useFetchHubsForRackMarketQuery(baseOptions?: Apollo.QueryHookOptions<FetchHubsForRackMarketQuery, FetchHubsForRackMarketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchHubsForRackMarketQuery, FetchHubsForRackMarketQueryVariables>(FetchHubsForRackMarketDocument, options);
      }
export function useFetchHubsForRackMarketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchHubsForRackMarketQuery, FetchHubsForRackMarketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchHubsForRackMarketQuery, FetchHubsForRackMarketQueryVariables>(FetchHubsForRackMarketDocument, options);
        }
export type FetchHubsForRackMarketQueryHookResult = ReturnType<typeof useFetchHubsForRackMarketQuery>;
export type FetchHubsForRackMarketLazyQueryHookResult = ReturnType<typeof useFetchHubsForRackMarketLazyQuery>;
export type FetchHubsForRackMarketQueryResult = Apollo.QueryResult<FetchHubsForRackMarketQuery, FetchHubsForRackMarketQueryVariables>;
export const FetchRackMarketExportCsvDocument = gql`
    query FetchRackMarketExportCSV($rackMarketId: [ID!], $terminalId: [ID!], $hubId: [ID!], $active: Boolean) {
  exportRackMarketsCsv(
    rackMarketId: $rackMarketId
    terminalId: $terminalId
    hubId: $hubId
    active: $active
  ) {
    content
    fileName
    error
  }
}
    `;

/**
 * __useFetchRackMarketExportCsvQuery__
 *
 * To run a query within a React component, call `useFetchRackMarketExportCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRackMarketExportCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRackMarketExportCsvQuery({
 *   variables: {
 *      rackMarketId: // value for 'rackMarketId'
 *      terminalId: // value for 'terminalId'
 *      hubId: // value for 'hubId'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useFetchRackMarketExportCsvQuery(baseOptions?: Apollo.QueryHookOptions<FetchRackMarketExportCsvQuery, FetchRackMarketExportCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRackMarketExportCsvQuery, FetchRackMarketExportCsvQueryVariables>(FetchRackMarketExportCsvDocument, options);
      }
export function useFetchRackMarketExportCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRackMarketExportCsvQuery, FetchRackMarketExportCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRackMarketExportCsvQuery, FetchRackMarketExportCsvQueryVariables>(FetchRackMarketExportCsvDocument, options);
        }
export type FetchRackMarketExportCsvQueryHookResult = ReturnType<typeof useFetchRackMarketExportCsvQuery>;
export type FetchRackMarketExportCsvLazyQueryHookResult = ReturnType<typeof useFetchRackMarketExportCsvLazyQuery>;
export type FetchRackMarketExportCsvQueryResult = Apollo.QueryResult<FetchRackMarketExportCsvQuery, FetchRackMarketExportCsvQueryVariables>;
export const UpdateRackMarketDocument = gql`
    mutation UpdateRackMarket($input: UpdateRackMarketInput!) {
  updateRackMarket(input: $input) {
    rackMarket {
      id
      name
      active
    }
  }
}
    `;
export type UpdateRackMarketMutationFn = Apollo.MutationFunction<UpdateRackMarketMutation, UpdateRackMarketMutationVariables>;

/**
 * __useUpdateRackMarketMutation__
 *
 * To run a mutation, you first call `useUpdateRackMarketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRackMarketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRackMarketMutation, { data, loading, error }] = useUpdateRackMarketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRackMarketMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRackMarketMutation, UpdateRackMarketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRackMarketMutation, UpdateRackMarketMutationVariables>(UpdateRackMarketDocument, options);
      }
export type UpdateRackMarketMutationHookResult = ReturnType<typeof useUpdateRackMarketMutation>;
export type UpdateRackMarketMutationResult = Apollo.MutationResult<UpdateRackMarketMutation>;
export type UpdateRackMarketMutationOptions = Apollo.BaseMutationOptions<UpdateRackMarketMutation, UpdateRackMarketMutationVariables>;
export const FetchLosDocument = gql`
    query FetchLOS($searchText: String) {
  filteredLineOfServices(limit: 10, offset: 0, filter: {all: $searchText}) {
    collection {
      id
      name
      active
    }
    metadata {
      hasMore
      totalCount
    }
  }
}
    `;

/**
 * __useFetchLosQuery__
 *
 * To run a query within a React component, call `useFetchLosQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLosQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useFetchLosQuery(baseOptions?: Apollo.QueryHookOptions<FetchLosQuery, FetchLosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLosQuery, FetchLosQueryVariables>(FetchLosDocument, options);
      }
export function useFetchLosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLosQuery, FetchLosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLosQuery, FetchLosQueryVariables>(FetchLosDocument, options);
        }
export type FetchLosQueryHookResult = ReturnType<typeof useFetchLosQuery>;
export type FetchLosLazyQueryHookResult = ReturnType<typeof useFetchLosLazyQuery>;
export type FetchLosQueryResult = Apollo.QueryResult<FetchLosQuery, FetchLosQueryVariables>;
export const FetchRackMarketWithTerminalsDocument = gql`
    query FetchRackMarketWithTerminals($searchText: String, $limit: Int, $offset: Int) {
  rackMarkets(limit: $limit, offset: $offset, filter: {all: $searchText}) {
    collection {
      name
      id
      terminals {
        id
        name
      }
    }
    metadata {
      hasMore
    }
  }
}
    `;

/**
 * __useFetchRackMarketWithTerminalsQuery__
 *
 * To run a query within a React component, call `useFetchRackMarketWithTerminalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRackMarketWithTerminalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRackMarketWithTerminalsQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFetchRackMarketWithTerminalsQuery(baseOptions?: Apollo.QueryHookOptions<FetchRackMarketWithTerminalsQuery, FetchRackMarketWithTerminalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRackMarketWithTerminalsQuery, FetchRackMarketWithTerminalsQueryVariables>(FetchRackMarketWithTerminalsDocument, options);
      }
export function useFetchRackMarketWithTerminalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRackMarketWithTerminalsQuery, FetchRackMarketWithTerminalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRackMarketWithTerminalsQuery, FetchRackMarketWithTerminalsQueryVariables>(FetchRackMarketWithTerminalsDocument, options);
        }
export type FetchRackMarketWithTerminalsQueryHookResult = ReturnType<typeof useFetchRackMarketWithTerminalsQuery>;
export type FetchRackMarketWithTerminalsLazyQueryHookResult = ReturnType<typeof useFetchRackMarketWithTerminalsLazyQuery>;
export type FetchRackMarketWithTerminalsQueryResult = Apollo.QueryResult<FetchRackMarketWithTerminalsQuery, FetchRackMarketWithTerminalsQueryVariables>;
export const FetchSuppliersWithTerminalsDocument = gql`
    query FetchSuppliersWithTerminals($searchText: String, $limit: Int, $offset: Int) {
  filteredSuppliers(limit: $limit, offset: $offset, filter: {all: $searchText}) {
    collection {
      id
      name
      terminalsSuppliers {
        terminal {
          id
          name
          rackMarket {
            id
            name
          }
        }
      }
    }
    metadata {
      hasMore
    }
  }
}
    `;

/**
 * __useFetchSuppliersWithTerminalsQuery__
 *
 * To run a query within a React component, call `useFetchSuppliersWithTerminalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSuppliersWithTerminalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSuppliersWithTerminalsQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFetchSuppliersWithTerminalsQuery(baseOptions?: Apollo.QueryHookOptions<FetchSuppliersWithTerminalsQuery, FetchSuppliersWithTerminalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSuppliersWithTerminalsQuery, FetchSuppliersWithTerminalsQueryVariables>(FetchSuppliersWithTerminalsDocument, options);
      }
export function useFetchSuppliersWithTerminalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSuppliersWithTerminalsQuery, FetchSuppliersWithTerminalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSuppliersWithTerminalsQuery, FetchSuppliersWithTerminalsQueryVariables>(FetchSuppliersWithTerminalsDocument, options);
        }
export type FetchSuppliersWithTerminalsQueryHookResult = ReturnType<typeof useFetchSuppliersWithTerminalsQuery>;
export type FetchSuppliersWithTerminalsLazyQueryHookResult = ReturnType<typeof useFetchSuppliersWithTerminalsLazyQuery>;
export type FetchSuppliersWithTerminalsQueryResult = Apollo.QueryResult<FetchSuppliersWithTerminalsQuery, FetchSuppliersWithTerminalsQueryVariables>;
export const CreateSupplierTerminalV2Document = gql`
    mutation CreateSupplierTerminalV2($input: CreateSupplierInput!) {
  createSupplierV2(input: {data: $input}) {
    supplier {
      id
    }
  }
}
    `;
export type CreateSupplierTerminalV2MutationFn = Apollo.MutationFunction<CreateSupplierTerminalV2Mutation, CreateSupplierTerminalV2MutationVariables>;

/**
 * __useCreateSupplierTerminalV2Mutation__
 *
 * To run a mutation, you first call `useCreateSupplierTerminalV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplierTerminalV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplierTerminalV2Mutation, { data, loading, error }] = useCreateSupplierTerminalV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSupplierTerminalV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateSupplierTerminalV2Mutation, CreateSupplierTerminalV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupplierTerminalV2Mutation, CreateSupplierTerminalV2MutationVariables>(CreateSupplierTerminalV2Document, options);
      }
export type CreateSupplierTerminalV2MutationHookResult = ReturnType<typeof useCreateSupplierTerminalV2Mutation>;
export type CreateSupplierTerminalV2MutationResult = Apollo.MutationResult<CreateSupplierTerminalV2Mutation>;
export type CreateSupplierTerminalV2MutationOptions = Apollo.BaseMutationOptions<CreateSupplierTerminalV2Mutation, CreateSupplierTerminalV2MutationVariables>;
export const CreateSupplierTerminalV3Document = gql`
    mutation CreateSupplierTerminalV3($input: CreateSupplierInputV3!) {
  createSupplierV3(input: {data: $input}) {
    supplier {
      id
    }
  }
}
    `;
export type CreateSupplierTerminalV3MutationFn = Apollo.MutationFunction<CreateSupplierTerminalV3Mutation, CreateSupplierTerminalV3MutationVariables>;

/**
 * __useCreateSupplierTerminalV3Mutation__
 *
 * To run a mutation, you first call `useCreateSupplierTerminalV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplierTerminalV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplierTerminalV3Mutation, { data, loading, error }] = useCreateSupplierTerminalV3Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSupplierTerminalV3Mutation(baseOptions?: Apollo.MutationHookOptions<CreateSupplierTerminalV3Mutation, CreateSupplierTerminalV3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupplierTerminalV3Mutation, CreateSupplierTerminalV3MutationVariables>(CreateSupplierTerminalV3Document, options);
      }
export type CreateSupplierTerminalV3MutationHookResult = ReturnType<typeof useCreateSupplierTerminalV3Mutation>;
export type CreateSupplierTerminalV3MutationResult = Apollo.MutationResult<CreateSupplierTerminalV3Mutation>;
export type CreateSupplierTerminalV3MutationOptions = Apollo.BaseMutationOptions<CreateSupplierTerminalV3Mutation, CreateSupplierTerminalV3MutationVariables>;
export const FetchFilteredBrandsDocument = gql`
    query FetchFilteredBrands {
  brands {
    id
    name
    __typename
  }
}
    `;

/**
 * __useFetchFilteredBrandsQuery__
 *
 * To run a query within a React component, call `useFetchFilteredBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchFilteredBrandsQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredBrandsQuery, FetchFilteredBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredBrandsQuery, FetchFilteredBrandsQueryVariables>(FetchFilteredBrandsDocument, options);
      }
export function useFetchFilteredBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredBrandsQuery, FetchFilteredBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredBrandsQuery, FetchFilteredBrandsQueryVariables>(FetchFilteredBrandsDocument, options);
        }
export type FetchFilteredBrandsQueryHookResult = ReturnType<typeof useFetchFilteredBrandsQuery>;
export type FetchFilteredBrandsLazyQueryHookResult = ReturnType<typeof useFetchFilteredBrandsLazyQuery>;
export type FetchFilteredBrandsQueryResult = Apollo.QueryResult<FetchFilteredBrandsQuery, FetchFilteredBrandsQueryVariables>;
export const FetchFilteredProductDocument = gql`
    query FetchFilteredProduct($limit: Int, $offset: Int, $customFilter: ProductFilter = {}) {
  filteredProducts(limit: $limit, offset: $offset, filter: $customFilter) {
    collection {
      name
      id
      brandId
      active
    }
    metadata {
      hasMore
      totalCount
    }
  }
}
    `;

/**
 * __useFetchFilteredProductQuery__
 *
 * To run a query within a React component, call `useFetchFilteredProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredProductQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      customFilter: // value for 'customFilter'
 *   },
 * });
 */
export function useFetchFilteredProductQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredProductQuery, FetchFilteredProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredProductQuery, FetchFilteredProductQueryVariables>(FetchFilteredProductDocument, options);
      }
export function useFetchFilteredProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredProductQuery, FetchFilteredProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredProductQuery, FetchFilteredProductQueryVariables>(FetchFilteredProductDocument, options);
        }
export type FetchFilteredProductQueryHookResult = ReturnType<typeof useFetchFilteredProductQuery>;
export type FetchFilteredProductLazyQueryHookResult = ReturnType<typeof useFetchFilteredProductLazyQuery>;
export type FetchFilteredProductQueryResult = Apollo.QueryResult<FetchFilteredProductQuery, FetchFilteredProductQueryVariables>;
export const FetchFilteredSuppliersDocument = gql`
    query FetchFilteredSuppliers($limit: Int, $offset: Int, $filter: SupplierFilter, $sorter: [SupplierSorter!]) {
  filteredSuppliers(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: $filter
  ) {
    collection {
      id
      name
      erpId
      active
      supplierCode
      irelyId
      lastSyncedTime
      supplierType
      terminalsSuppliers {
        id
        terminal {
          name
          active
          rackMarket {
            name
          }
        }
      }
      loadingAccounts {
        id
        carrierCustomerCode
        loadingNumber
        name
      }
      netsuiteId
      lineOfServices {
        id
        name
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFetchFilteredSuppliersQuery__
 *
 * To run a query within a React component, call `useFetchFilteredSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredSuppliersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchFilteredSuppliersQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredSuppliersQuery, FetchFilteredSuppliersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredSuppliersQuery, FetchFilteredSuppliersQueryVariables>(FetchFilteredSuppliersDocument, options);
      }
export function useFetchFilteredSuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredSuppliersQuery, FetchFilteredSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredSuppliersQuery, FetchFilteredSuppliersQueryVariables>(FetchFilteredSuppliersDocument, options);
        }
export type FetchFilteredSuppliersQueryHookResult = ReturnType<typeof useFetchFilteredSuppliersQuery>;
export type FetchFilteredSuppliersLazyQueryHookResult = ReturnType<typeof useFetchFilteredSuppliersLazyQuery>;
export type FetchFilteredSuppliersQueryResult = Apollo.QueryResult<FetchFilteredSuppliersQuery, FetchFilteredSuppliersQueryVariables>;
export const FetchFilteredTerminalListDocument = gql`
    query FetchFilteredTerminalList($limit: Int, $offset: Int, $filter: TerminalFilter) {
  filteredTerminals(limit: $limit, offset: $offset, filter: $filter) {
    collection {
      id
      name
      erpId
      active
    }
  }
}
    `;

/**
 * __useFetchFilteredTerminalListQuery__
 *
 * To run a query within a React component, call `useFetchFilteredTerminalListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredTerminalListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredTerminalListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchFilteredTerminalListQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredTerminalListQuery, FetchFilteredTerminalListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredTerminalListQuery, FetchFilteredTerminalListQueryVariables>(FetchFilteredTerminalListDocument, options);
      }
export function useFetchFilteredTerminalListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredTerminalListQuery, FetchFilteredTerminalListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredTerminalListQuery, FetchFilteredTerminalListQueryVariables>(FetchFilteredTerminalListDocument, options);
        }
export type FetchFilteredTerminalListQueryHookResult = ReturnType<typeof useFetchFilteredTerminalListQuery>;
export type FetchFilteredTerminalListLazyQueryHookResult = ReturnType<typeof useFetchFilteredTerminalListLazyQuery>;
export type FetchFilteredTerminalListQueryResult = Apollo.QueryResult<FetchFilteredTerminalListQuery, FetchFilteredTerminalListQueryVariables>;
export const FetchLineOfServicesDocument = gql`
    query FetchLineOfServices($limit: Int, $offset: Int, $filter: LineOfServiceFilter, $sorter: [LineOfServiceSorter!]) {
  filteredLineOfServices(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: $filter
  ) {
    collection {
      id
      name
      shortName
      active
      erpId
      parent {
        id
        nameWithAncestors
      }
    }
    metadata {
      hasMore
      totalCount
    }
  }
}
    `;

/**
 * __useFetchLineOfServicesQuery__
 *
 * To run a query within a React component, call `useFetchLineOfServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLineOfServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLineOfServicesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchLineOfServicesQuery(baseOptions?: Apollo.QueryHookOptions<FetchLineOfServicesQuery, FetchLineOfServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLineOfServicesQuery, FetchLineOfServicesQueryVariables>(FetchLineOfServicesDocument, options);
      }
export function useFetchLineOfServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLineOfServicesQuery, FetchLineOfServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLineOfServicesQuery, FetchLineOfServicesQueryVariables>(FetchLineOfServicesDocument, options);
        }
export type FetchLineOfServicesQueryHookResult = ReturnType<typeof useFetchLineOfServicesQuery>;
export type FetchLineOfServicesLazyQueryHookResult = ReturnType<typeof useFetchLineOfServicesLazyQuery>;
export type FetchLineOfServicesQueryResult = Apollo.QueryResult<FetchLineOfServicesQuery, FetchLineOfServicesQueryVariables>;
export const FetchRackMarketDocument = gql`
    query FetchRackMarket($limit: Int, $offset: Int, $filter: RackMarketFilter) {
  rackMarkets(limit: $limit, offset: $offset, filter: $filter) {
    collection {
      id
      name
      active
      terminals {
        id
        name
        active
        isWarehouse
      }
    }
  }
}
    `;

/**
 * __useFetchRackMarketQuery__
 *
 * To run a query within a React component, call `useFetchRackMarketQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRackMarketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRackMarketQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchRackMarketQuery(baseOptions?: Apollo.QueryHookOptions<FetchRackMarketQuery, FetchRackMarketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRackMarketQuery, FetchRackMarketQueryVariables>(FetchRackMarketDocument, options);
      }
export function useFetchRackMarketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRackMarketQuery, FetchRackMarketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRackMarketQuery, FetchRackMarketQueryVariables>(FetchRackMarketDocument, options);
        }
export type FetchRackMarketQueryHookResult = ReturnType<typeof useFetchRackMarketQuery>;
export type FetchRackMarketLazyQueryHookResult = ReturnType<typeof useFetchRackMarketLazyQuery>;
export type FetchRackMarketQueryResult = Apollo.QueryResult<FetchRackMarketQuery, FetchRackMarketQueryVariables>;
export const FetchSupplierDetailV3Document = gql`
    query FetchSupplierDetailV3($id: ID!) {
  supplierDetailV3(id: $id) {
    id
    name
    active
    supplierType
    erpId
    supplierCode
    lineOfServices {
      id
      name
      __typename
    }
    loadingAccounts {
      id
      loadingNumber
      name
      destinationState
      rackMarkets {
        id
        name
        terminals {
          pickupPointCodes {
            id
            code
            name
          }
          terminalsSupplier {
            id
            bolTimeAt
            terminal {
              id
              name
            }
          }
          terminalProducts {
            id
            product {
              id
              name
            }
            brandTypes
          }
          pickupPointCodes {
            id
            code
            erpId
            products {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchSupplierDetailV3Query__
 *
 * To run a query within a React component, call `useFetchSupplierDetailV3Query` and pass it any options that fit your needs.
 * When your component renders, `useFetchSupplierDetailV3Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSupplierDetailV3Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchSupplierDetailV3Query(baseOptions: Apollo.QueryHookOptions<FetchSupplierDetailV3Query, FetchSupplierDetailV3QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSupplierDetailV3Query, FetchSupplierDetailV3QueryVariables>(FetchSupplierDetailV3Document, options);
      }
export function useFetchSupplierDetailV3LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSupplierDetailV3Query, FetchSupplierDetailV3QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSupplierDetailV3Query, FetchSupplierDetailV3QueryVariables>(FetchSupplierDetailV3Document, options);
        }
export type FetchSupplierDetailV3QueryHookResult = ReturnType<typeof useFetchSupplierDetailV3Query>;
export type FetchSupplierDetailV3LazyQueryHookResult = ReturnType<typeof useFetchSupplierDetailV3LazyQuery>;
export type FetchSupplierDetailV3QueryResult = Apollo.QueryResult<FetchSupplierDetailV3Query, FetchSupplierDetailV3QueryVariables>;
export const FetchSupplierDetailDocument = gql`
    query FetchSupplierDetail($id: ID!) {
  supplierDetail(id: $id) {
    id
    name
    supplierType
    erpId
    supplierCode
    lineOfServices {
      id
      name
      __typename
    }
    loadingAccounts {
      id
      loadingNumber
      name
      destinationState
      rackMarkets {
        id
        name
        terminals {
          pickupPointCodes {
            id
            code
            name
          }
          terminalsSupplier {
            id
            bolTimeAt
            terminal {
              id
              name
            }
          }
          products {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchSupplierDetailQuery__
 *
 * To run a query within a React component, call `useFetchSupplierDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSupplierDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSupplierDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchSupplierDetailQuery(baseOptions: Apollo.QueryHookOptions<FetchSupplierDetailQuery, FetchSupplierDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSupplierDetailQuery, FetchSupplierDetailQueryVariables>(FetchSupplierDetailDocument, options);
      }
export function useFetchSupplierDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSupplierDetailQuery, FetchSupplierDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSupplierDetailQuery, FetchSupplierDetailQueryVariables>(FetchSupplierDetailDocument, options);
        }
export type FetchSupplierDetailQueryHookResult = ReturnType<typeof useFetchSupplierDetailQuery>;
export type FetchSupplierDetailLazyQueryHookResult = ReturnType<typeof useFetchSupplierDetailLazyQuery>;
export type FetchSupplierDetailQueryResult = Apollo.QueryResult<FetchSupplierDetailQuery, FetchSupplierDetailQueryVariables>;
export const FetchSupplierExportCsvDocument = gql`
    mutation FetchSupplierExportCSV($supplierIds: [ID], $terminalIds: [ID], $supplierTypes: [SupplierTypeEnum], $rackMarketIds: [ID], $lineOfServiceIds: [ID], $active: Boolean) {
  exportSuppliersCsv(
    input: {supplierIds: $supplierIds, terminalIds: $terminalIds, supplierTypes: $supplierTypes, rackMarketIds: $rackMarketIds, lineOfServiceIds: $lineOfServiceIds, active: $active}
  ) {
    csv
    success
    message
  }
}
    `;
export type FetchSupplierExportCsvMutationFn = Apollo.MutationFunction<FetchSupplierExportCsvMutation, FetchSupplierExportCsvMutationVariables>;

/**
 * __useFetchSupplierExportCsvMutation__
 *
 * To run a mutation, you first call `useFetchSupplierExportCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFetchSupplierExportCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fetchSupplierExportCsvMutation, { data, loading, error }] = useFetchSupplierExportCsvMutation({
 *   variables: {
 *      supplierIds: // value for 'supplierIds'
 *      terminalIds: // value for 'terminalIds'
 *      supplierTypes: // value for 'supplierTypes'
 *      rackMarketIds: // value for 'rackMarketIds'
 *      lineOfServiceIds: // value for 'lineOfServiceIds'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useFetchSupplierExportCsvMutation(baseOptions?: Apollo.MutationHookOptions<FetchSupplierExportCsvMutation, FetchSupplierExportCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FetchSupplierExportCsvMutation, FetchSupplierExportCsvMutationVariables>(FetchSupplierExportCsvDocument, options);
      }
export type FetchSupplierExportCsvMutationHookResult = ReturnType<typeof useFetchSupplierExportCsvMutation>;
export type FetchSupplierExportCsvMutationResult = Apollo.MutationResult<FetchSupplierExportCsvMutation>;
export type FetchSupplierExportCsvMutationOptions = Apollo.BaseMutationOptions<FetchSupplierExportCsvMutation, FetchSupplierExportCsvMutationVariables>;
export const UpdateSupplierTerminalV2Document = gql`
    mutation UpdateSupplierTerminalV2($input: UpdateSupplierInput!) {
  updateSupplierV2(input: {data: $input}) {
    supplier {
      id
    }
  }
}
    `;
export type UpdateSupplierTerminalV2MutationFn = Apollo.MutationFunction<UpdateSupplierTerminalV2Mutation, UpdateSupplierTerminalV2MutationVariables>;

/**
 * __useUpdateSupplierTerminalV2Mutation__
 *
 * To run a mutation, you first call `useUpdateSupplierTerminalV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplierTerminalV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplierTerminalV2Mutation, { data, loading, error }] = useUpdateSupplierTerminalV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSupplierTerminalV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupplierTerminalV2Mutation, UpdateSupplierTerminalV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupplierTerminalV2Mutation, UpdateSupplierTerminalV2MutationVariables>(UpdateSupplierTerminalV2Document, options);
      }
export type UpdateSupplierTerminalV2MutationHookResult = ReturnType<typeof useUpdateSupplierTerminalV2Mutation>;
export type UpdateSupplierTerminalV2MutationResult = Apollo.MutationResult<UpdateSupplierTerminalV2Mutation>;
export type UpdateSupplierTerminalV2MutationOptions = Apollo.BaseMutationOptions<UpdateSupplierTerminalV2Mutation, UpdateSupplierTerminalV2MutationVariables>;
export const UpdateSupplierTerminalV3Document = gql`
    mutation UpdateSupplierTerminalV3($input: UpdateSupplierInputV3!) {
  updateSupplierV3(input: {data: $input}) {
    supplier {
      id
    }
  }
}
    `;
export type UpdateSupplierTerminalV3MutationFn = Apollo.MutationFunction<UpdateSupplierTerminalV3Mutation, UpdateSupplierTerminalV3MutationVariables>;

/**
 * __useUpdateSupplierTerminalV3Mutation__
 *
 * To run a mutation, you first call `useUpdateSupplierTerminalV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplierTerminalV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplierTerminalV3Mutation, { data, loading, error }] = useUpdateSupplierTerminalV3Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSupplierTerminalV3Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupplierTerminalV3Mutation, UpdateSupplierTerminalV3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupplierTerminalV3Mutation, UpdateSupplierTerminalV3MutationVariables>(UpdateSupplierTerminalV3Document, options);
      }
export type UpdateSupplierTerminalV3MutationHookResult = ReturnType<typeof useUpdateSupplierTerminalV3Mutation>;
export type UpdateSupplierTerminalV3MutationResult = Apollo.MutationResult<UpdateSupplierTerminalV3Mutation>;
export type UpdateSupplierTerminalV3MutationOptions = Apollo.BaseMutationOptions<UpdateSupplierTerminalV3Mutation, UpdateSupplierTerminalV3MutationVariables>;
export const CreateOrUpdateTagDocument = gql`
    mutation CreateOrUpdateTag($input: CreateOrUpdateTagInput!) {
  createOrUpdateTags(input: $input) {
    success
    error
    tag {
      tagType
    }
  }
}
    `;
export type CreateOrUpdateTagMutationFn = Apollo.MutationFunction<CreateOrUpdateTagMutation, CreateOrUpdateTagMutationVariables>;

/**
 * __useCreateOrUpdateTagMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateTagMutation, { data, loading, error }] = useCreateOrUpdateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateTagMutation, CreateOrUpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateTagMutation, CreateOrUpdateTagMutationVariables>(CreateOrUpdateTagDocument, options);
      }
export type CreateOrUpdateTagMutationHookResult = ReturnType<typeof useCreateOrUpdateTagMutation>;
export type CreateOrUpdateTagMutationResult = Apollo.MutationResult<CreateOrUpdateTagMutation>;
export type CreateOrUpdateTagMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateTagMutation, CreateOrUpdateTagMutationVariables>;
export const FetchFilteredTagsDocument = gql`
    query FetchFilteredTags($limit: Int, $offset: Int, $filter: TagFilter, $sorter: [BaseSorter!]) {
  filteredTags(limit: $limit, offset: $offset, filter: $filter, sorter: $sorter) {
    collection {
      id
      name
      status
      tagType
      description
      erpId
      colorCode
      iconName
    }
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useFetchFilteredTagsQuery__
 *
 * To run a query within a React component, call `useFetchFilteredTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredTagsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchFilteredTagsQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredTagsQuery, FetchFilteredTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredTagsQuery, FetchFilteredTagsQueryVariables>(FetchFilteredTagsDocument, options);
      }
export function useFetchFilteredTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredTagsQuery, FetchFilteredTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredTagsQuery, FetchFilteredTagsQueryVariables>(FetchFilteredTagsDocument, options);
        }
export type FetchFilteredTagsQueryHookResult = ReturnType<typeof useFetchFilteredTagsQuery>;
export type FetchFilteredTagsLazyQueryHookResult = ReturnType<typeof useFetchFilteredTagsLazyQuery>;
export type FetchFilteredTagsQueryResult = Apollo.QueryResult<FetchFilteredTagsQuery, FetchFilteredTagsQueryVariables>;
export const FetchTagDocument = gql`
    query FetchTag($id: ID!) {
  tag(id: $id) {
    id
    name
    iconName
    status
    tagType
    colorCode
    description
    erpId
    iconName
  }
}
    `;

/**
 * __useFetchTagQuery__
 *
 * To run a query within a React component, call `useFetchTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchTagQuery(baseOptions: Apollo.QueryHookOptions<FetchTagQuery, FetchTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTagQuery, FetchTagQueryVariables>(FetchTagDocument, options);
      }
export function useFetchTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTagQuery, FetchTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTagQuery, FetchTagQueryVariables>(FetchTagDocument, options);
        }
export type FetchTagQueryHookResult = ReturnType<typeof useFetchTagQuery>;
export type FetchTagLazyQueryHookResult = ReturnType<typeof useFetchTagLazyQuery>;
export type FetchTagQueryResult = Apollo.QueryResult<FetchTagQuery, FetchTagQueryVariables>;
export const FetchTerminalsWithSuppliersDocument = gql`
    query FetchTerminalsWithSuppliers($limit: Int, $offset: Int, $filter: TerminalFilter) {
  filteredTerminals(limit: $limit, offset: $offset, filter: $filter) {
    collection {
      id
      name
      suppliers {
        id
        name
      }
    }
    metadata {
      hasMore
    }
  }
}
    `;

/**
 * __useFetchTerminalsWithSuppliersQuery__
 *
 * To run a query within a React component, call `useFetchTerminalsWithSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTerminalsWithSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTerminalsWithSuppliersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchTerminalsWithSuppliersQuery(baseOptions?: Apollo.QueryHookOptions<FetchTerminalsWithSuppliersQuery, FetchTerminalsWithSuppliersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTerminalsWithSuppliersQuery, FetchTerminalsWithSuppliersQueryVariables>(FetchTerminalsWithSuppliersDocument, options);
      }
export function useFetchTerminalsWithSuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTerminalsWithSuppliersQuery, FetchTerminalsWithSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTerminalsWithSuppliersQuery, FetchTerminalsWithSuppliersQueryVariables>(FetchTerminalsWithSuppliersDocument, options);
        }
export type FetchTerminalsWithSuppliersQueryHookResult = ReturnType<typeof useFetchTerminalsWithSuppliersQuery>;
export type FetchTerminalsWithSuppliersLazyQueryHookResult = ReturnType<typeof useFetchTerminalsWithSuppliersLazyQuery>;
export type FetchTerminalsWithSuppliersQueryResult = Apollo.QueryResult<FetchTerminalsWithSuppliersQuery, FetchTerminalsWithSuppliersQueryVariables>;
export const CreateTerminalWithRackMarketDocument = gql`
    mutation CreateTerminalWithRackMarket($input: TerminalInput!) {
  createTerminal(input: {data: $input}) {
    terminal {
      id
      name
    }
  }
}
    `;
export type CreateTerminalWithRackMarketMutationFn = Apollo.MutationFunction<CreateTerminalWithRackMarketMutation, CreateTerminalWithRackMarketMutationVariables>;

/**
 * __useCreateTerminalWithRackMarketMutation__
 *
 * To run a mutation, you first call `useCreateTerminalWithRackMarketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTerminalWithRackMarketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTerminalWithRackMarketMutation, { data, loading, error }] = useCreateTerminalWithRackMarketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTerminalWithRackMarketMutation(baseOptions?: Apollo.MutationHookOptions<CreateTerminalWithRackMarketMutation, CreateTerminalWithRackMarketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTerminalWithRackMarketMutation, CreateTerminalWithRackMarketMutationVariables>(CreateTerminalWithRackMarketDocument, options);
      }
export type CreateTerminalWithRackMarketMutationHookResult = ReturnType<typeof useCreateTerminalWithRackMarketMutation>;
export type CreateTerminalWithRackMarketMutationResult = Apollo.MutationResult<CreateTerminalWithRackMarketMutation>;
export type CreateTerminalWithRackMarketMutationOptions = Apollo.BaseMutationOptions<CreateTerminalWithRackMarketMutation, CreateTerminalWithRackMarketMutationVariables>;
export const FetchFilteredTerminalsDocument = gql`
    query FetchFilteredTerminals($limit: Int, $offset: Int, $filter: TerminalFilter, $sorter: [TerminalSorter!]) {
  filteredTerminals(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: $filter
  ) {
    collection {
      id
      name
      suppliers {
        id
        name
        loadingAccounts {
          id
          name
          loadingNumber
        }
      }
      erpId
      site {
        address
        radius
        lat
        lng
      }
      rackMarket {
        id
        name
      }
      loadingOrders {
        id
        orderGroupId
        orderGroup {
          priority
          startOn
        }
        __typename
      }
      active
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFetchFilteredTerminalsQuery__
 *
 * To run a query within a React component, call `useFetchFilteredTerminalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredTerminalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredTerminalsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchFilteredTerminalsQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredTerminalsQuery, FetchFilteredTerminalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredTerminalsQuery, FetchFilteredTerminalsQueryVariables>(FetchFilteredTerminalsDocument, options);
      }
export function useFetchFilteredTerminalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredTerminalsQuery, FetchFilteredTerminalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredTerminalsQuery, FetchFilteredTerminalsQueryVariables>(FetchFilteredTerminalsDocument, options);
        }
export type FetchFilteredTerminalsQueryHookResult = ReturnType<typeof useFetchFilteredTerminalsQuery>;
export type FetchFilteredTerminalsLazyQueryHookResult = ReturnType<typeof useFetchFilteredTerminalsLazyQuery>;
export type FetchFilteredTerminalsQueryResult = Apollo.QueryResult<FetchFilteredTerminalsQuery, FetchFilteredTerminalsQueryVariables>;
export const FetchTerminalDetailsDocument = gql`
    query FetchTerminalDetails($id: ID!) {
  terminal(id: $id) {
    id
    name
    suppliers {
      id
      name
    }
    erpId
    site {
      address
      radius
      lat
      lng
    }
    rackMarket {
      id
      name
    }
    active
  }
}
    `;

/**
 * __useFetchTerminalDetailsQuery__
 *
 * To run a query within a React component, call `useFetchTerminalDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTerminalDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTerminalDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchTerminalDetailsQuery(baseOptions: Apollo.QueryHookOptions<FetchTerminalDetailsQuery, FetchTerminalDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTerminalDetailsQuery, FetchTerminalDetailsQueryVariables>(FetchTerminalDetailsDocument, options);
      }
export function useFetchTerminalDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTerminalDetailsQuery, FetchTerminalDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTerminalDetailsQuery, FetchTerminalDetailsQueryVariables>(FetchTerminalDetailsDocument, options);
        }
export type FetchTerminalDetailsQueryHookResult = ReturnType<typeof useFetchTerminalDetailsQuery>;
export type FetchTerminalDetailsLazyQueryHookResult = ReturnType<typeof useFetchTerminalDetailsLazyQuery>;
export type FetchTerminalDetailsQueryResult = Apollo.QueryResult<FetchTerminalDetailsQuery, FetchTerminalDetailsQueryVariables>;
export const FetchTerminalExportCsvDocument = gql`
    query FetchTerminalExportCSV($supplierId: [ID!], $terminalId: [ID!], $rackMarketId: [ID!], $status: Boolean) {
  exportTerminalsCsv(
    supplierId: $supplierId
    terminalId: $terminalId
    rackMarketId: $rackMarketId
    status: $status
  ) {
    content
    fileName
    error
  }
}
    `;

/**
 * __useFetchTerminalExportCsvQuery__
 *
 * To run a query within a React component, call `useFetchTerminalExportCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTerminalExportCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTerminalExportCsvQuery({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *      terminalId: // value for 'terminalId'
 *      rackMarketId: // value for 'rackMarketId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useFetchTerminalExportCsvQuery(baseOptions?: Apollo.QueryHookOptions<FetchTerminalExportCsvQuery, FetchTerminalExportCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTerminalExportCsvQuery, FetchTerminalExportCsvQueryVariables>(FetchTerminalExportCsvDocument, options);
      }
export function useFetchTerminalExportCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTerminalExportCsvQuery, FetchTerminalExportCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTerminalExportCsvQuery, FetchTerminalExportCsvQueryVariables>(FetchTerminalExportCsvDocument, options);
        }
export type FetchTerminalExportCsvQueryHookResult = ReturnType<typeof useFetchTerminalExportCsvQuery>;
export type FetchTerminalExportCsvLazyQueryHookResult = ReturnType<typeof useFetchTerminalExportCsvLazyQuery>;
export type FetchTerminalExportCsvQueryResult = Apollo.QueryResult<FetchTerminalExportCsvQuery, FetchTerminalExportCsvQueryVariables>;
export const UpdateTerminalWithRackMarketDocument = gql`
    mutation UpdateTerminalWithRackMarket($input: UpdateTerminalInput!) {
  updateTerminal(input: {data: $input}) {
    terminal {
      id
      name
    }
  }
}
    `;
export type UpdateTerminalWithRackMarketMutationFn = Apollo.MutationFunction<UpdateTerminalWithRackMarketMutation, UpdateTerminalWithRackMarketMutationVariables>;

/**
 * __useUpdateTerminalWithRackMarketMutation__
 *
 * To run a mutation, you first call `useUpdateTerminalWithRackMarketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTerminalWithRackMarketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTerminalWithRackMarketMutation, { data, loading, error }] = useUpdateTerminalWithRackMarketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTerminalWithRackMarketMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTerminalWithRackMarketMutation, UpdateTerminalWithRackMarketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTerminalWithRackMarketMutation, UpdateTerminalWithRackMarketMutationVariables>(UpdateTerminalWithRackMarketDocument, options);
      }
export type UpdateTerminalWithRackMarketMutationHookResult = ReturnType<typeof useUpdateTerminalWithRackMarketMutation>;
export type UpdateTerminalWithRackMarketMutationResult = Apollo.MutationResult<UpdateTerminalWithRackMarketMutation>;
export type UpdateTerminalWithRackMarketMutationOptions = Apollo.BaseMutationOptions<UpdateTerminalWithRackMarketMutation, UpdateTerminalWithRackMarketMutationVariables>;
export const CreateInventoryRecordDocument = gql`
    mutation CreateInventoryRecord($input: CreateInventoryRecordInput!) {
  createInventoryRecord(input: $input) {
    inventoryRecord {
      asset {
        id
      }
    }
  }
}
    `;
export type CreateInventoryRecordMutationFn = Apollo.MutationFunction<CreateInventoryRecordMutation, CreateInventoryRecordMutationVariables>;

/**
 * __useCreateInventoryRecordMutation__
 *
 * To run a mutation, you first call `useCreateInventoryRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInventoryRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInventoryRecordMutation, { data, loading, error }] = useCreateInventoryRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInventoryRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateInventoryRecordMutation, CreateInventoryRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInventoryRecordMutation, CreateInventoryRecordMutationVariables>(CreateInventoryRecordDocument, options);
      }
export type CreateInventoryRecordMutationHookResult = ReturnType<typeof useCreateInventoryRecordMutation>;
export type CreateInventoryRecordMutationResult = Apollo.MutationResult<CreateInventoryRecordMutation>;
export type CreateInventoryRecordMutationOptions = Apollo.BaseMutationOptions<CreateInventoryRecordMutation, CreateInventoryRecordMutationVariables>;
export const FetchAssetCompartmentDetailsDocument = gql`
    query FetchAssetCompartmentDetails($id: ID!) {
  asset(id: $id) {
    compartments {
      id
      name
    }
  }
}
    `;

/**
 * __useFetchAssetCompartmentDetailsQuery__
 *
 * To run a query within a React component, call `useFetchAssetCompartmentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAssetCompartmentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAssetCompartmentDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchAssetCompartmentDetailsQuery(baseOptions: Apollo.QueryHookOptions<FetchAssetCompartmentDetailsQuery, FetchAssetCompartmentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAssetCompartmentDetailsQuery, FetchAssetCompartmentDetailsQueryVariables>(FetchAssetCompartmentDetailsDocument, options);
      }
export function useFetchAssetCompartmentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAssetCompartmentDetailsQuery, FetchAssetCompartmentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAssetCompartmentDetailsQuery, FetchAssetCompartmentDetailsQueryVariables>(FetchAssetCompartmentDetailsDocument, options);
        }
export type FetchAssetCompartmentDetailsQueryHookResult = ReturnType<typeof useFetchAssetCompartmentDetailsQuery>;
export type FetchAssetCompartmentDetailsLazyQueryHookResult = ReturnType<typeof useFetchAssetCompartmentDetailsLazyQuery>;
export type FetchAssetCompartmentDetailsQueryResult = Apollo.QueryResult<FetchAssetCompartmentDetailsQuery, FetchAssetCompartmentDetailsQueryVariables>;
export const FetchAssetInventorySummaryDocument = gql`
    query FetchAssetInventorySummary($fromDate: Int, $toDate: Int, $assetId: ID, $productId: ID) {
  assetInventorySummary(
    fromDate: $fromDate
    toDate: $toDate
    assetId: $assetId
    productId: $productId
  )
}
    `;

/**
 * __useFetchAssetInventorySummaryQuery__
 *
 * To run a query within a React component, call `useFetchAssetInventorySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAssetInventorySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAssetInventorySummaryQuery({
 *   variables: {
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      assetId: // value for 'assetId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useFetchAssetInventorySummaryQuery(baseOptions?: Apollo.QueryHookOptions<FetchAssetInventorySummaryQuery, FetchAssetInventorySummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAssetInventorySummaryQuery, FetchAssetInventorySummaryQueryVariables>(FetchAssetInventorySummaryDocument, options);
      }
export function useFetchAssetInventorySummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAssetInventorySummaryQuery, FetchAssetInventorySummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAssetInventorySummaryQuery, FetchAssetInventorySummaryQueryVariables>(FetchAssetInventorySummaryDocument, options);
        }
export type FetchAssetInventorySummaryQueryHookResult = ReturnType<typeof useFetchAssetInventorySummaryQuery>;
export type FetchAssetInventorySummaryLazyQueryHookResult = ReturnType<typeof useFetchAssetInventorySummaryLazyQuery>;
export type FetchAssetInventorySummaryQueryResult = Apollo.QueryResult<FetchAssetInventorySummaryQuery, FetchAssetInventorySummaryQueryVariables>;
export const FetchBolReportsDocument = gql`
    query FetchBolReports($limit: Int, $offset: Int, $filter: BolReportFilter) {
  bolReports(limit: $limit, offset: $offset, filter: $filter) {
    collection {
      id
      bol
      asset
      externalId
      product {
        id
        name
      }
      loadingOrder {
        id
        orderGroup {
          completedOn
        }
      }
      grossVolume
      netVolume
      notes
      adjustedVolume
      residualVolume
      deliveries
      fromState
      transfers
      terminal {
        id
        name
      }
      supplier {
        id
        name
      }
      worker {
        name
      }
    }
    metadata {
      hasMore
      totalCount
    }
  }
}
    `;

/**
 * __useFetchBolReportsQuery__
 *
 * To run a query within a React component, call `useFetchBolReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBolReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBolReportsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchBolReportsQuery(baseOptions?: Apollo.QueryHookOptions<FetchBolReportsQuery, FetchBolReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchBolReportsQuery, FetchBolReportsQueryVariables>(FetchBolReportsDocument, options);
      }
export function useFetchBolReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchBolReportsQuery, FetchBolReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchBolReportsQuery, FetchBolReportsQueryVariables>(FetchBolReportsDocument, options);
        }
export type FetchBolReportsQueryHookResult = ReturnType<typeof useFetchBolReportsQuery>;
export type FetchBolReportsLazyQueryHookResult = ReturnType<typeof useFetchBolReportsLazyQuery>;
export type FetchBolReportsQueryResult = Apollo.QueryResult<FetchBolReportsQuery, FetchBolReportsQueryVariables>;
export const FetchDivergenceReportsDocument = gql`
    query FetchDivergenceReports($limit: Int, $offset: Int, $filter: BolReportFilter) {
  bolReports(limit: $limit, offset: $offset, filter: $filter) {
    collection {
      id
      bol
      asset
      externalId
      product {
        id
        name
      }
      loadingOrder {
        id
        orderGroup {
          completedOn
        }
      }
      grossVolume
      netVolume
      notes
      adjustedVolume
      residualVolume
      deliveries
      fromState
      transfers
      terminal {
        id
        name
      }
      supplier {
        id
        name
      }
      worker {
        name
      }
    }
    metadata {
      hasMore
      totalCount
    }
  }
}
    `;

/**
 * __useFetchDivergenceReportsQuery__
 *
 * To run a query within a React component, call `useFetchDivergenceReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDivergenceReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDivergenceReportsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchDivergenceReportsQuery(baseOptions?: Apollo.QueryHookOptions<FetchDivergenceReportsQuery, FetchDivergenceReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDivergenceReportsQuery, FetchDivergenceReportsQueryVariables>(FetchDivergenceReportsDocument, options);
      }
export function useFetchDivergenceReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDivergenceReportsQuery, FetchDivergenceReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDivergenceReportsQuery, FetchDivergenceReportsQueryVariables>(FetchDivergenceReportsDocument, options);
        }
export type FetchDivergenceReportsQueryHookResult = ReturnType<typeof useFetchDivergenceReportsQuery>;
export type FetchDivergenceReportsLazyQueryHookResult = ReturnType<typeof useFetchDivergenceReportsLazyQuery>;
export type FetchDivergenceReportsQueryResult = Apollo.QueryResult<FetchDivergenceReportsQuery, FetchDivergenceReportsQueryVariables>;
export const FetchFilteredAssetInventoriesDocument = gql`
    query FetchFilteredAssetInventories($limit: Int, $offset: Int, $filter: AssetInventoriesFilter) {
  assetInventories(limit: $limit, offset: $offset, filter: $filter) {
    collection {
      transactionType
      quantity
      date
      users
      totalCost
      linkedReferences
      averageCost
      startingBalance
      product {
        id
        name
      }
    }
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useFetchFilteredAssetInventoriesQuery__
 *
 * To run a query within a React component, call `useFetchFilteredAssetInventoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredAssetInventoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredAssetInventoriesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchFilteredAssetInventoriesQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredAssetInventoriesQuery, FetchFilteredAssetInventoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredAssetInventoriesQuery, FetchFilteredAssetInventoriesQueryVariables>(FetchFilteredAssetInventoriesDocument, options);
      }
export function useFetchFilteredAssetInventoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredAssetInventoriesQuery, FetchFilteredAssetInventoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredAssetInventoriesQuery, FetchFilteredAssetInventoriesQueryVariables>(FetchFilteredAssetInventoriesDocument, options);
        }
export type FetchFilteredAssetInventoriesQueryHookResult = ReturnType<typeof useFetchFilteredAssetInventoriesQuery>;
export type FetchFilteredAssetInventoriesLazyQueryHookResult = ReturnType<typeof useFetchFilteredAssetInventoriesLazyQuery>;
export type FetchFilteredAssetInventoriesQueryResult = Apollo.QueryResult<FetchFilteredAssetInventoriesQuery, FetchFilteredAssetInventoriesQueryVariables>;
export const FetchFilteredAssetsInventoriesRecordsDocument = gql`
    query FetchFilteredAssetsInventoriesRecords($limit: Int, $offset: Int, $filter: AssetInventoryFilter) {
  assetsInventories(limit: $limit, offset: $offset, filter: $filter) {
    collection {
      averageCost
      totalSalesVolume
      totalPurchaseVolume
      totalTransferVolume
      totalAdjustmentVolume
      totalExtractedVolume
      startingBalance
      asset {
        id
        name
      }
      date
      product {
        id
        name
      }
      volume
    }
    metadata {
      hasMore
      totalCount
    }
  }
}
    `;

/**
 * __useFetchFilteredAssetsInventoriesRecordsQuery__
 *
 * To run a query within a React component, call `useFetchFilteredAssetsInventoriesRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredAssetsInventoriesRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredAssetsInventoriesRecordsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchFilteredAssetsInventoriesRecordsQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredAssetsInventoriesRecordsQuery, FetchFilteredAssetsInventoriesRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredAssetsInventoriesRecordsQuery, FetchFilteredAssetsInventoriesRecordsQueryVariables>(FetchFilteredAssetsInventoriesRecordsDocument, options);
      }
export function useFetchFilteredAssetsInventoriesRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredAssetsInventoriesRecordsQuery, FetchFilteredAssetsInventoriesRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredAssetsInventoriesRecordsQuery, FetchFilteredAssetsInventoriesRecordsQueryVariables>(FetchFilteredAssetsInventoriesRecordsDocument, options);
        }
export type FetchFilteredAssetsInventoriesRecordsQueryHookResult = ReturnType<typeof useFetchFilteredAssetsInventoriesRecordsQuery>;
export type FetchFilteredAssetsInventoriesRecordsLazyQueryHookResult = ReturnType<typeof useFetchFilteredAssetsInventoriesRecordsLazyQuery>;
export type FetchFilteredAssetsInventoriesRecordsQueryResult = Apollo.QueryResult<FetchFilteredAssetsInventoriesRecordsQuery, FetchFilteredAssetsInventoriesRecordsQueryVariables>;
export const FetchFilteredCustomerReportsDocument = gql`
    query FetchFilteredCustomerReports($limit: Int, $offset: Int, $filter: CustomerReportFilter, $sorter: [CustomerReportSorter!]) {
  filteredCustomerReports(
    limit: $limit
    offset: $offset
    filter: $filter
    sorter: $sorter
  ) {
    collection {
      id
      name
      lastViewedAt
      lastViewedBy {
        name
      }
      owner {
        name
      }
      receipients
      updatedAt
      recurrence {
        recurrenceAutoExpired
        recurrenceDates
        recurrenceDayNthWeek {
          friday
          monday
          saturday
          sunday
          thursday
          tuesday
          wednesday
        }
        recurrenceDaysInAdvance
        recurrenceDaysOfWeek
        recurrenceFromTimestamp
        recurrenceInterval
        recurrenceType
        recurrenceUntil
        recurrenceDays
      }
    }
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useFetchFilteredCustomerReportsQuery__
 *
 * To run a query within a React component, call `useFetchFilteredCustomerReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredCustomerReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredCustomerReportsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchFilteredCustomerReportsQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredCustomerReportsQuery, FetchFilteredCustomerReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredCustomerReportsQuery, FetchFilteredCustomerReportsQueryVariables>(FetchFilteredCustomerReportsDocument, options);
      }
export function useFetchFilteredCustomerReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredCustomerReportsQuery, FetchFilteredCustomerReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredCustomerReportsQuery, FetchFilteredCustomerReportsQueryVariables>(FetchFilteredCustomerReportsDocument, options);
        }
export type FetchFilteredCustomerReportsQueryHookResult = ReturnType<typeof useFetchFilteredCustomerReportsQuery>;
export type FetchFilteredCustomerReportsLazyQueryHookResult = ReturnType<typeof useFetchFilteredCustomerReportsLazyQuery>;
export type FetchFilteredCustomerReportsQueryResult = Apollo.QueryResult<FetchFilteredCustomerReportsQuery, FetchFilteredCustomerReportsQueryVariables>;
export const FilteredLeaReportDocument = gql`
    query FilteredLeaReport($filter: LeaReportFilter, $limit: Int, $offset: Int) {
  filteredLeaReport(filter: $filter, limit: $limit, offset: $offset) {
    collection {
      id
      requestedTankSize
      totalDeliveriesCount
      totalGallonsDelivered
      orderGroup {
        id
        status
        createdAtTimestamp
        startedOnTimestamp
        completedOnTimestamp
      }
      asset {
        id
        name
        status
        erpId
        tankSize
        category
        licensePlateNumber
        __typename
      }
      toCustomerBranch {
        erpId
        name
        customer {
          id
          name
        }
      }
      leaLineItem {
        requestProduct {
          id
          name
        }
        gallonPerMonth
        marginPerGallonInCents
        bdrCommissionInPercent
        leaCore {
          parentLeaCore {
            isSigned
            leaQuestionnaire {
              salesRepresentative {
                id
                name
              }
            }
          }
        }
      }
    }
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useFilteredLeaReportQuery__
 *
 * To run a query within a React component, call `useFilteredLeaReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredLeaReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredLeaReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFilteredLeaReportQuery(baseOptions?: Apollo.QueryHookOptions<FilteredLeaReportQuery, FilteredLeaReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredLeaReportQuery, FilteredLeaReportQueryVariables>(FilteredLeaReportDocument, options);
      }
export function useFilteredLeaReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredLeaReportQuery, FilteredLeaReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredLeaReportQuery, FilteredLeaReportQueryVariables>(FilteredLeaReportDocument, options);
        }
export type FilteredLeaReportQueryHookResult = ReturnType<typeof useFilteredLeaReportQuery>;
export type FilteredLeaReportLazyQueryHookResult = ReturnType<typeof useFilteredLeaReportLazyQuery>;
export type FilteredLeaReportQueryResult = Apollo.QueryResult<FilteredLeaReportQuery, FilteredLeaReportQueryVariables>;
export const FetchFilteredLoadingReceiptsDocument = gql`
    query FetchFilteredLoadingReceipts($filter: LoadingReceiptsFilter) {
  loadingReceipts(filter: $filter) {
    id
    bolPricings {
      quantity
      total
      product {
        id
        name
      }
    }
    receiptNumber
    orderGroupsFees {
      price
      quantity
    }
    loadingOrder {
      orderGroup {
        id
        startOnTimestamp
      }
    }
  }
}
    `;

/**
 * __useFetchFilteredLoadingReceiptsQuery__
 *
 * To run a query within a React component, call `useFetchFilteredLoadingReceiptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredLoadingReceiptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredLoadingReceiptsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchFilteredLoadingReceiptsQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredLoadingReceiptsQuery, FetchFilteredLoadingReceiptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredLoadingReceiptsQuery, FetchFilteredLoadingReceiptsQueryVariables>(FetchFilteredLoadingReceiptsDocument, options);
      }
export function useFetchFilteredLoadingReceiptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredLoadingReceiptsQuery, FetchFilteredLoadingReceiptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredLoadingReceiptsQuery, FetchFilteredLoadingReceiptsQueryVariables>(FetchFilteredLoadingReceiptsDocument, options);
        }
export type FetchFilteredLoadingReceiptsQueryHookResult = ReturnType<typeof useFetchFilteredLoadingReceiptsQuery>;
export type FetchFilteredLoadingReceiptsLazyQueryHookResult = ReturnType<typeof useFetchFilteredLoadingReceiptsLazyQuery>;
export type FetchFilteredLoadingReceiptsQueryResult = Apollo.QueryResult<FetchFilteredLoadingReceiptsQuery, FetchFilteredLoadingReceiptsQueryVariables>;
export const GetFilteredSyncedOrdersDocument = gql`
    query GetFilteredSyncedOrders($filter: SyncOrdersFilters, $limit: Int, $offset: Int) {
  filteredSyncedOrders(filter: $filter, limit: $limit, offset: $offset) {
    collection {
      id
      ticketId
      status
      isSynced
      createdAtTimestamp
      departedOnTimestamp
      startOnTimestamp
      startedOnTimestamp
      completedOnTimestamp
      completeOnTimestamp
      latestInvoiceStatus
      driverAcceptance
      priority
      driver {
        id
        name
      }
      deliveryOrder {
        type
        id
        status
        orderNumber
        deliveryInstruction
        source
        customerBranch {
          id
          name
          address
          site {
            lat
            lng
            radius
          }
          customer {
            id
            name
            address
          }
        }
        lineItems {
          id
          requestedVolume
          volume
          status
          product {
            id
            name
            unit
            deliveryType
          }
          subscription {
            product {
              name
            }
            asset {
              category
              licensePlateNumber
            }
          }
        }
        orderLinks {
          id
          loadingOrder {
            id
            bolNumbers
            status
            terminal {
              id
              name
            }
          }
          extractionOrder {
            id
            customerBranch {
              id
              name
            }
          }
        }
      }
      loadingOrder {
        id
        status
        terminal {
          id
          name
          site {
            lat
            lng
            radius
            address
          }
          suppliers {
            id
            name
            loadingAccounts {
              id
              carrierCustomerCode
              loadingNumber
            }
          }
        }
        orderLinks {
          id
          deliveryOrder {
            id
            orderGroupId
          }
          loadingOrder {
            id
          }
        }
        loadingOrderProducts {
          id
          quantity
          product {
            name
            code
            unit
            deliveryType
          }
          preferredSuppliers {
            priority
            loadingAccount {
              loadingNumber
              supplier {
                name
                erpId
                supplierId
              }
            }
          }
        }
        lineItems {
          id
          netAmount
          product {
            id
            name
            unit
            deliveryType
          }
          compartment {
            asset {
              id
              licensePlateNumber
              name
            }
          }
        }
      }
      vendor
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useGetFilteredSyncedOrdersQuery__
 *
 * To run a query within a React component, call `useGetFilteredSyncedOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilteredSyncedOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilteredSyncedOrdersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetFilteredSyncedOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetFilteredSyncedOrdersQuery, GetFilteredSyncedOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilteredSyncedOrdersQuery, GetFilteredSyncedOrdersQueryVariables>(GetFilteredSyncedOrdersDocument, options);
      }
export function useGetFilteredSyncedOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilteredSyncedOrdersQuery, GetFilteredSyncedOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilteredSyncedOrdersQuery, GetFilteredSyncedOrdersQueryVariables>(GetFilteredSyncedOrdersDocument, options);
        }
export type GetFilteredSyncedOrdersQueryHookResult = ReturnType<typeof useGetFilteredSyncedOrdersQuery>;
export type GetFilteredSyncedOrdersLazyQueryHookResult = ReturnType<typeof useGetFilteredSyncedOrdersLazyQuery>;
export type GetFilteredSyncedOrdersQueryResult = Apollo.QueryResult<GetFilteredSyncedOrdersQuery, GetFilteredSyncedOrdersQueryVariables>;
export const FilteredTaxReportDocument = gql`
    query FilteredTaxReport($filters: TaxReportFilterInput, $startOnTimestamp: Int, $endOnTimestamp: Int, $limit: Int, $offset: Int) {
  filteredTaxReport(
    filters: $filters
    limit: $limit
    offset: $offset
    startOnTimestamp: $startOnTimestamp
    endOnTimestamp: $endOnTimestamp
  )
}
    `;

/**
 * __useFilteredTaxReportQuery__
 *
 * To run a query within a React component, call `useFilteredTaxReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredTaxReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredTaxReportQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      startOnTimestamp: // value for 'startOnTimestamp'
 *      endOnTimestamp: // value for 'endOnTimestamp'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFilteredTaxReportQuery(baseOptions?: Apollo.QueryHookOptions<FilteredTaxReportQuery, FilteredTaxReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredTaxReportQuery, FilteredTaxReportQueryVariables>(FilteredTaxReportDocument, options);
      }
export function useFilteredTaxReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredTaxReportQuery, FilteredTaxReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredTaxReportQuery, FilteredTaxReportQueryVariables>(FilteredTaxReportDocument, options);
        }
export type FilteredTaxReportQueryHookResult = ReturnType<typeof useFilteredTaxReportQuery>;
export type FilteredTaxReportLazyQueryHookResult = ReturnType<typeof useFilteredTaxReportLazyQuery>;
export type FilteredTaxReportQueryResult = Apollo.QueryResult<FilteredTaxReportQuery, FilteredTaxReportQueryVariables>;
export const FilteredSalesReportDocument = gql`
    query FilteredSalesReport($filters: SalesReportFilterInput, $startOnTimestamp: Int, $endOnTimestamp: Int, $limit: Int, $offset: Int) {
  filteredSalesReport(
    filters: $filters
    limit: $limit
    offset: $offset
    startOnTimestamp: $startOnTimestamp
    endOnTimestamp: $endOnTimestamp
  )
}
    `;

/**
 * __useFilteredSalesReportQuery__
 *
 * To run a query within a React component, call `useFilteredSalesReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredSalesReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredSalesReportQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      startOnTimestamp: // value for 'startOnTimestamp'
 *      endOnTimestamp: // value for 'endOnTimestamp'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFilteredSalesReportQuery(baseOptions?: Apollo.QueryHookOptions<FilteredSalesReportQuery, FilteredSalesReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredSalesReportQuery, FilteredSalesReportQueryVariables>(FilteredSalesReportDocument, options);
      }
export function useFilteredSalesReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredSalesReportQuery, FilteredSalesReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredSalesReportQuery, FilteredSalesReportQueryVariables>(FilteredSalesReportDocument, options);
        }
export type FilteredSalesReportQueryHookResult = ReturnType<typeof useFilteredSalesReportQuery>;
export type FilteredSalesReportLazyQueryHookResult = ReturnType<typeof useFilteredSalesReportLazyQuery>;
export type FilteredSalesReportQueryResult = Apollo.QueryResult<FilteredSalesReportQuery, FilteredSalesReportQueryVariables>;
export const GeneratePresignedMetabaseUrlDocument = gql`
    mutation GeneratePresignedMetabaseUrl($reportId: ID!) {
  generatePresignedMetabaseUrl(input: {reportId: $reportId}) {
    url
  }
}
    `;
export type GeneratePresignedMetabaseUrlMutationFn = Apollo.MutationFunction<GeneratePresignedMetabaseUrlMutation, GeneratePresignedMetabaseUrlMutationVariables>;

/**
 * __useGeneratePresignedMetabaseUrlMutation__
 *
 * To run a mutation, you first call `useGeneratePresignedMetabaseUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePresignedMetabaseUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePresignedMetabaseUrlMutation, { data, loading, error }] = useGeneratePresignedMetabaseUrlMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useGeneratePresignedMetabaseUrlMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePresignedMetabaseUrlMutation, GeneratePresignedMetabaseUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePresignedMetabaseUrlMutation, GeneratePresignedMetabaseUrlMutationVariables>(GeneratePresignedMetabaseUrlDocument, options);
      }
export type GeneratePresignedMetabaseUrlMutationHookResult = ReturnType<typeof useGeneratePresignedMetabaseUrlMutation>;
export type GeneratePresignedMetabaseUrlMutationResult = Apollo.MutationResult<GeneratePresignedMetabaseUrlMutation>;
export type GeneratePresignedMetabaseUrlMutationOptions = Apollo.BaseMutationOptions<GeneratePresignedMetabaseUrlMutation, GeneratePresignedMetabaseUrlMutationVariables>;
export const GenerateSalesReportDocument = gql`
    mutation GenerateSalesReport($input: GenerateSalesReportInput!) {
  generateSalesReport(input: $input) {
    pandaDocument {
      fileUrl
    }
  }
}
    `;
export type GenerateSalesReportMutationFn = Apollo.MutationFunction<GenerateSalesReportMutation, GenerateSalesReportMutationVariables>;

/**
 * __useGenerateSalesReportMutation__
 *
 * To run a mutation, you first call `useGenerateSalesReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSalesReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSalesReportMutation, { data, loading, error }] = useGenerateSalesReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateSalesReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSalesReportMutation, GenerateSalesReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSalesReportMutation, GenerateSalesReportMutationVariables>(GenerateSalesReportDocument, options);
      }
export type GenerateSalesReportMutationHookResult = ReturnType<typeof useGenerateSalesReportMutation>;
export type GenerateSalesReportMutationResult = Apollo.MutationResult<GenerateSalesReportMutation>;
export type GenerateSalesReportMutationOptions = Apollo.BaseMutationOptions<GenerateSalesReportMutation, GenerateSalesReportMutationVariables>;
export const GenerateTaxReportDocument = gql`
    mutation GenerateTaxReport($input: GenerateTaxReportInput!) {
  generateTaxReport(input: $input) {
    pandaDocument {
      fileUrl
    }
  }
}
    `;
export type GenerateTaxReportMutationFn = Apollo.MutationFunction<GenerateTaxReportMutation, GenerateTaxReportMutationVariables>;

/**
 * __useGenerateTaxReportMutation__
 *
 * To run a mutation, you first call `useGenerateTaxReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTaxReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTaxReportMutation, { data, loading, error }] = useGenerateTaxReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateTaxReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTaxReportMutation, GenerateTaxReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateTaxReportMutation, GenerateTaxReportMutationVariables>(GenerateTaxReportDocument, options);
      }
export type GenerateTaxReportMutationHookResult = ReturnType<typeof useGenerateTaxReportMutation>;
export type GenerateTaxReportMutationResult = Apollo.MutationResult<GenerateTaxReportMutation>;
export type GenerateTaxReportMutationOptions = Apollo.BaseMutationOptions<GenerateTaxReportMutation, GenerateTaxReportMutationVariables>;
export const RecalculateInventoryRecordsDocument = gql`
    mutation RecalculateInventoryRecords {
  recalculateInventoryRecords(input: {}) {
    success
  }
}
    `;
export type RecalculateInventoryRecordsMutationFn = Apollo.MutationFunction<RecalculateInventoryRecordsMutation, RecalculateInventoryRecordsMutationVariables>;

/**
 * __useRecalculateInventoryRecordsMutation__
 *
 * To run a mutation, you first call `useRecalculateInventoryRecordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecalculateInventoryRecordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recalculateInventoryRecordsMutation, { data, loading, error }] = useRecalculateInventoryRecordsMutation({
 *   variables: {
 *   },
 * });
 */
export function useRecalculateInventoryRecordsMutation(baseOptions?: Apollo.MutationHookOptions<RecalculateInventoryRecordsMutation, RecalculateInventoryRecordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecalculateInventoryRecordsMutation, RecalculateInventoryRecordsMutationVariables>(RecalculateInventoryRecordsDocument, options);
      }
export type RecalculateInventoryRecordsMutationHookResult = ReturnType<typeof useRecalculateInventoryRecordsMutation>;
export type RecalculateInventoryRecordsMutationResult = Apollo.MutationResult<RecalculateInventoryRecordsMutation>;
export type RecalculateInventoryRecordsMutationOptions = Apollo.BaseMutationOptions<RecalculateInventoryRecordsMutation, RecalculateInventoryRecordsMutationVariables>;
export const UpdateCustomerReportDocument = gql`
    mutation UpdateCustomerReport($input: UpdateCustomerReportInput!) {
  updateCustomerReport(input: $input) {
    id
    lastViewedAt
    receipients
    updatedAt
    recurrence {
      recurrenceAutoExpired
      recurrenceDates
      recurrenceDayNthWeek {
        friday
        monday
        saturday
        sunday
        thursday
        tuesday
        wednesday
      }
      recurrenceDaysInAdvance
      recurrenceDaysOfWeek
      recurrenceFromTimestamp
      recurrenceInterval
      recurrenceType
      recurrenceUntil
      recurrenceDays
    }
  }
}
    `;
export type UpdateCustomerReportMutationFn = Apollo.MutationFunction<UpdateCustomerReportMutation, UpdateCustomerReportMutationVariables>;

/**
 * __useUpdateCustomerReportMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerReportMutation, { data, loading, error }] = useUpdateCustomerReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerReportMutation, UpdateCustomerReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerReportMutation, UpdateCustomerReportMutationVariables>(UpdateCustomerReportDocument, options);
      }
export type UpdateCustomerReportMutationHookResult = ReturnType<typeof useUpdateCustomerReportMutation>;
export type UpdateCustomerReportMutationResult = Apollo.MutationResult<UpdateCustomerReportMutation>;
export type UpdateCustomerReportMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerReportMutation, UpdateCustomerReportMutationVariables>;
export const CreateRouteDocument = gql`
    mutation CreateRoute($rawShiftAttributes: RawShiftCreateInput) {
  createRawShift(input: {rawShiftAttributes: $rawShiftAttributes}) {
    rawShift {
      id
    }
  }
}
    `;
export type CreateRouteMutationFn = Apollo.MutationFunction<CreateRouteMutation, CreateRouteMutationVariables>;

/**
 * __useCreateRouteMutation__
 *
 * To run a mutation, you first call `useCreateRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRouteMutation, { data, loading, error }] = useCreateRouteMutation({
 *   variables: {
 *      rawShiftAttributes: // value for 'rawShiftAttributes'
 *   },
 * });
 */
export function useCreateRouteMutation(baseOptions?: Apollo.MutationHookOptions<CreateRouteMutation, CreateRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRouteMutation, CreateRouteMutationVariables>(CreateRouteDocument, options);
      }
export type CreateRouteMutationHookResult = ReturnType<typeof useCreateRouteMutation>;
export type CreateRouteMutationResult = Apollo.MutationResult<CreateRouteMutation>;
export type CreateRouteMutationOptions = Apollo.BaseMutationOptions<CreateRouteMutation, CreateRouteMutationVariables>;
export const DeleteRouteDocument = gql`
    mutation DeleteRoute($id: ID!) {
  deleteRawShift(input: {id: $id}) {
    rawShift {
      id
    }
  }
}
    `;
export type DeleteRouteMutationFn = Apollo.MutationFunction<DeleteRouteMutation, DeleteRouteMutationVariables>;

/**
 * __useDeleteRouteMutation__
 *
 * To run a mutation, you first call `useDeleteRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRouteMutation, { data, loading, error }] = useDeleteRouteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRouteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRouteMutation, DeleteRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRouteMutation, DeleteRouteMutationVariables>(DeleteRouteDocument, options);
      }
export type DeleteRouteMutationHookResult = ReturnType<typeof useDeleteRouteMutation>;
export type DeleteRouteMutationResult = Apollo.MutationResult<DeleteRouteMutation>;
export type DeleteRouteMutationOptions = Apollo.BaseMutationOptions<DeleteRouteMutation, DeleteRouteMutationVariables>;
export const FetchProductSummaryDocument = gql`
    query FetchProductSummary($id: ID!) {
  deliveryOrder(id: $id) {
    id
    lineItemSummary {
      product
      orderedVolume
    }
  }
}
    `;

/**
 * __useFetchProductSummaryQuery__
 *
 * To run a query within a React component, call `useFetchProductSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProductSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProductSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchProductSummaryQuery(baseOptions: Apollo.QueryHookOptions<FetchProductSummaryQuery, FetchProductSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchProductSummaryQuery, FetchProductSummaryQueryVariables>(FetchProductSummaryDocument, options);
      }
export function useFetchProductSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchProductSummaryQuery, FetchProductSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchProductSummaryQuery, FetchProductSummaryQueryVariables>(FetchProductSummaryDocument, options);
        }
export type FetchProductSummaryQueryHookResult = ReturnType<typeof useFetchProductSummaryQuery>;
export type FetchProductSummaryLazyQueryHookResult = ReturnType<typeof useFetchProductSummaryLazyQuery>;
export type FetchProductSummaryQueryResult = Apollo.QueryResult<FetchProductSummaryQuery, FetchProductSummaryQueryVariables>;
export const FetchRouteDocument = gql`
    query FetchRoute($id: ID!) {
  rawShift(id: $id) {
    id
    name
    status
    creatable {
      name
    }
    dispatchable {
      name
    }
    startHub {
      id
      name
      site {
        lat
        lng
      }
    }
    endHub {
      id
      name
      site {
        lat
        lng
      }
    }
    worker {
      id
      name
    }
    asset {
      id
      name
    }
    startOnTimestamp
    endOnTimestamp
    orderGroups {
      id
      routingOrder
      deliveryOrder {
        id
        deliveryOrderLineItems {
          requestedVolume
          product {
            id
            name
          }
        }
        orderLinks {
          id
          loadingOrder {
            id
            terminal {
              id
              name
              suppliers {
                id
                name
              }
            }
          }
        }
      }
      loadingOrder {
        id
        terminal {
          id
          name
          suppliers {
            id
            name
          }
          site {
            address
          }
        }
      }
      customerBranch {
        id
        name
        address
        resourceSchedule {
          availability {
            day
            startTime
            endTime
          }
        }
        customer {
          address
        }
        site {
          lat
          lng
        }
      }
    }
  }
}
    `;

/**
 * __useFetchRouteQuery__
 *
 * To run a query within a React component, call `useFetchRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRouteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchRouteQuery(baseOptions: Apollo.QueryHookOptions<FetchRouteQuery, FetchRouteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRouteQuery, FetchRouteQueryVariables>(FetchRouteDocument, options);
      }
export function useFetchRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRouteQuery, FetchRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRouteQuery, FetchRouteQueryVariables>(FetchRouteDocument, options);
        }
export type FetchRouteQueryHookResult = ReturnType<typeof useFetchRouteQuery>;
export type FetchRouteLazyQueryHookResult = ReturnType<typeof useFetchRouteLazyQuery>;
export type FetchRouteQueryResult = Apollo.QueryResult<FetchRouteQuery, FetchRouteQueryVariables>;
export const FetchRouteDriverScheduleDocument = gql`
    query FetchRouteDriverSchedule($driverId: ID!) {
  driver(id: $driverId) {
    id
    name
    resourceSchedule {
      id
      availability {
        day
        preferredStartTime
        preferredEndTime
      }
      unavailability {
        unStartTime
        unEndTime
        reason
      }
    }
  }
}
    `;

/**
 * __useFetchRouteDriverScheduleQuery__
 *
 * To run a query within a React component, call `useFetchRouteDriverScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRouteDriverScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRouteDriverScheduleQuery({
 *   variables: {
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useFetchRouteDriverScheduleQuery(baseOptions: Apollo.QueryHookOptions<FetchRouteDriverScheduleQuery, FetchRouteDriverScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRouteDriverScheduleQuery, FetchRouteDriverScheduleQueryVariables>(FetchRouteDriverScheduleDocument, options);
      }
export function useFetchRouteDriverScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRouteDriverScheduleQuery, FetchRouteDriverScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRouteDriverScheduleQuery, FetchRouteDriverScheduleQueryVariables>(FetchRouteDriverScheduleDocument, options);
        }
export type FetchRouteDriverScheduleQueryHookResult = ReturnType<typeof useFetchRouteDriverScheduleQuery>;
export type FetchRouteDriverScheduleLazyQueryHookResult = ReturnType<typeof useFetchRouteDriverScheduleLazyQuery>;
export type FetchRouteDriverScheduleQueryResult = Apollo.QueryResult<FetchRouteDriverScheduleQuery, FetchRouteDriverScheduleQueryVariables>;
export const FetchRouteDurationSummaryDocument = gql`
    query FetchRouteDurationSummary($rawShiftId: ID!, $refresh: Boolean = false, $routeCalculationType: RouteCalculationEnum) {
  rawShiftSummary(
    id: $rawShiftId
    refresh: $refresh
    routeCalculationType: $routeCalculationType
  ) {
    estimatedDistance
    estimatedDuration
    estimatedDurationInTraffic
    estimatedFuelingDuration
    rawShiftStops
  }
}
    `;

/**
 * __useFetchRouteDurationSummaryQuery__
 *
 * To run a query within a React component, call `useFetchRouteDurationSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRouteDurationSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRouteDurationSummaryQuery({
 *   variables: {
 *      rawShiftId: // value for 'rawShiftId'
 *      refresh: // value for 'refresh'
 *      routeCalculationType: // value for 'routeCalculationType'
 *   },
 * });
 */
export function useFetchRouteDurationSummaryQuery(baseOptions: Apollo.QueryHookOptions<FetchRouteDurationSummaryQuery, FetchRouteDurationSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRouteDurationSummaryQuery, FetchRouteDurationSummaryQueryVariables>(FetchRouteDurationSummaryDocument, options);
      }
export function useFetchRouteDurationSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRouteDurationSummaryQuery, FetchRouteDurationSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRouteDurationSummaryQuery, FetchRouteDurationSummaryQueryVariables>(FetchRouteDurationSummaryDocument, options);
        }
export type FetchRouteDurationSummaryQueryHookResult = ReturnType<typeof useFetchRouteDurationSummaryQuery>;
export type FetchRouteDurationSummaryLazyQueryHookResult = ReturnType<typeof useFetchRouteDurationSummaryLazyQuery>;
export type FetchRouteDurationSummaryQueryResult = Apollo.QueryResult<FetchRouteDurationSummaryQuery, FetchRouteDurationSummaryQueryVariables>;
export const FetchStagingOrdersDocument = gql`
    query FetchStagingOrders($limit: Int, $offset: Int, $filter: ShiftBuilderOrderWellFilter, $sorter: [ShiftBuilderOrderSorter!]) {
  filteredShiftBuilderOrders(
    limit: $limit
    offset: $offset
    filter: $filter
    sorter: $sorter
  ) {
    collection {
      id
      orderId
      ticketId
      status
      type
      plannedAt
      customerName
      shipToName
      address
      source
      startAt
      endAt
      createdAtTimestamp
      productNames
      driverName
      driverId
      deliveryTruckNames
      createdBy
      assignedBy
      plannedGal
      deliveredGal
      coordinates {
        lat
        lng
      }
      priority
      preferredSupplierNames
      supplierNames
      hubName
      state
      zip
      city
      poNumber
    }
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useFetchStagingOrdersQuery__
 *
 * To run a query within a React component, call `useFetchStagingOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchStagingOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchStagingOrdersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchStagingOrdersQuery(baseOptions?: Apollo.QueryHookOptions<FetchStagingOrdersQuery, FetchStagingOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchStagingOrdersQuery, FetchStagingOrdersQueryVariables>(FetchStagingOrdersDocument, options);
      }
export function useFetchStagingOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchStagingOrdersQuery, FetchStagingOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchStagingOrdersQuery, FetchStagingOrdersQueryVariables>(FetchStagingOrdersDocument, options);
        }
export type FetchStagingOrdersQueryHookResult = ReturnType<typeof useFetchStagingOrdersQuery>;
export type FetchStagingOrdersLazyQueryHookResult = ReturnType<typeof useFetchStagingOrdersLazyQuery>;
export type FetchStagingOrdersQueryResult = Apollo.QueryResult<FetchStagingOrdersQuery, FetchStagingOrdersQueryVariables>;
export const FilteredRoutesDocument = gql`
    query FilteredRoutes($limit: Int, $offset: Int, $filter: RawShiftFilter, $sorter: [RawShiftSorter!]) {
  filteredRawShifts(
    limit: $limit
    offset: $offset
    filter: $filter
    sorter: $sorter
  ) {
    collection {
      id
      name
      status
      createdAtTimestamp
      dispatchedOnTimestamp
      startOnTimestamp
      endOnTimestamp
      startHub {
        id
        name
        site {
          lat
          lng
        }
      }
      endHub {
        id
        name
        site {
          lat
          lng
        }
      }
      worker {
        id
        name
      }
      asset {
        id
        name
      }
      dispatchable {
        id
        name
      }
      creatable {
        id
        name
      }
      orderGroups {
        routingOrder
        customerBranch {
          id
          name
          site {
            lat
            lng
          }
        }
        loadingOrder {
          id
          terminal {
            id
            name
            suppliers {
              id
              name
            }
          }
        }
      }
      tags
      totalOrderGroups
      completedOrderGroups
    }
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useFilteredRoutesQuery__
 *
 * To run a query within a React component, call `useFilteredRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredRoutesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilteredRoutesQuery(baseOptions?: Apollo.QueryHookOptions<FilteredRoutesQuery, FilteredRoutesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredRoutesQuery, FilteredRoutesQueryVariables>(FilteredRoutesDocument, options);
      }
export function useFilteredRoutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredRoutesQuery, FilteredRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredRoutesQuery, FilteredRoutesQueryVariables>(FilteredRoutesDocument, options);
        }
export type FilteredRoutesQueryHookResult = ReturnType<typeof useFilteredRoutesQuery>;
export type FilteredRoutesLazyQueryHookResult = ReturnType<typeof useFilteredRoutesLazyQuery>;
export type FilteredRoutesQueryResult = Apollo.QueryResult<FilteredRoutesQuery, FilteredRoutesQueryVariables>;
export const FilteredRoutesListDocument = gql`
    query FilteredRoutesList($limit: Int, $offset: Int, $filter: RawShiftFilter, $sorter: [RawShiftSorter!]) {
  filteredRawShifts(
    limit: $limit
    offset: $offset
    filter: $filter
    sorter: $sorter
  ) {
    collection {
      id
      name
      orderGroups {
        id
        routingOrder
        customerBranch {
          id
          name
          address
        }
        loadingOrder {
          id
          terminal {
            id
            name
            suppliers {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFilteredRoutesListQuery__
 *
 * To run a query within a React component, call `useFilteredRoutesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredRoutesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredRoutesListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilteredRoutesListQuery(baseOptions?: Apollo.QueryHookOptions<FilteredRoutesListQuery, FilteredRoutesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredRoutesListQuery, FilteredRoutesListQueryVariables>(FilteredRoutesListDocument, options);
      }
export function useFilteredRoutesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredRoutesListQuery, FilteredRoutesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredRoutesListQuery, FilteredRoutesListQueryVariables>(FilteredRoutesListDocument, options);
        }
export type FilteredRoutesListQueryHookResult = ReturnType<typeof useFilteredRoutesListQuery>;
export type FilteredRoutesListLazyQueryHookResult = ReturnType<typeof useFilteredRoutesListLazyQuery>;
export type FilteredRoutesListQueryResult = Apollo.QueryResult<FilteredRoutesListQuery, FilteredRoutesListQueryVariables>;
export const UpdateRouteDocument = gql`
    mutation UpdateRoute($rawShiftAttributes: RawShiftCreateInput) {
  updateRawShift(input: {rawShiftAttributes: $rawShiftAttributes}) {
    rawShift {
      id
    }
  }
}
    `;
export type UpdateRouteMutationFn = Apollo.MutationFunction<UpdateRouteMutation, UpdateRouteMutationVariables>;

/**
 * __useUpdateRouteMutation__
 *
 * To run a mutation, you first call `useUpdateRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRouteMutation, { data, loading, error }] = useUpdateRouteMutation({
 *   variables: {
 *      rawShiftAttributes: // value for 'rawShiftAttributes'
 *   },
 * });
 */
export function useUpdateRouteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRouteMutation, UpdateRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRouteMutation, UpdateRouteMutationVariables>(UpdateRouteDocument, options);
      }
export type UpdateRouteMutationHookResult = ReturnType<typeof useUpdateRouteMutation>;
export type UpdateRouteMutationResult = Apollo.MutationResult<UpdateRouteMutation>;
export type UpdateRouteMutationOptions = Apollo.BaseMutationOptions<UpdateRouteMutation, UpdateRouteMutationVariables>;
export const DeleteShiftPlanByIdDocument = gql`
    mutation DeleteShiftPlanById($shiftPlanId: ID!) {
  deleteShiftPlan(input: {id: $shiftPlanId}) {
    shiftPlan {
      id
    }
  }
}
    `;
export type DeleteShiftPlanByIdMutationFn = Apollo.MutationFunction<DeleteShiftPlanByIdMutation, DeleteShiftPlanByIdMutationVariables>;

/**
 * __useDeleteShiftPlanByIdMutation__
 *
 * To run a mutation, you first call `useDeleteShiftPlanByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShiftPlanByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShiftPlanByIdMutation, { data, loading, error }] = useDeleteShiftPlanByIdMutation({
 *   variables: {
 *      shiftPlanId: // value for 'shiftPlanId'
 *   },
 * });
 */
export function useDeleteShiftPlanByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteShiftPlanByIdMutation, DeleteShiftPlanByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteShiftPlanByIdMutation, DeleteShiftPlanByIdMutationVariables>(DeleteShiftPlanByIdDocument, options);
      }
export type DeleteShiftPlanByIdMutationHookResult = ReturnType<typeof useDeleteShiftPlanByIdMutation>;
export type DeleteShiftPlanByIdMutationResult = Apollo.MutationResult<DeleteShiftPlanByIdMutation>;
export type DeleteShiftPlanByIdMutationOptions = Apollo.BaseMutationOptions<DeleteShiftPlanByIdMutation, DeleteShiftPlanByIdMutationVariables>;
export const CustomerUserDetailDocument = gql`
    query CustomerUserDetail($userId: ID!, $customerId: ID!) {
  filteredCustomerUsers(filter: {customerId: $customerId, userId: $userId}) {
    collection {
      id
      customer {
        id
      }
      hubs {
        id
        name
      }
      user {
        id
      }
    }
  }
}
    `;

/**
 * __useCustomerUserDetailQuery__
 *
 * To run a query within a React component, call `useCustomerUserDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerUserDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerUserDetailQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useCustomerUserDetailQuery(baseOptions: Apollo.QueryHookOptions<CustomerUserDetailQuery, CustomerUserDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerUserDetailQuery, CustomerUserDetailQueryVariables>(CustomerUserDetailDocument, options);
      }
export function useCustomerUserDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerUserDetailQuery, CustomerUserDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerUserDetailQuery, CustomerUserDetailQueryVariables>(CustomerUserDetailDocument, options);
        }
export type CustomerUserDetailQueryHookResult = ReturnType<typeof useCustomerUserDetailQuery>;
export type CustomerUserDetailLazyQueryHookResult = ReturnType<typeof useCustomerUserDetailLazyQuery>;
export type CustomerUserDetailQueryResult = Apollo.QueryResult<CustomerUserDetailQuery, CustomerUserDetailQueryVariables>;
export const OptimizedShiftDetailDocument = gql`
    query OptimizedShiftDetail($shiftId: ID!) {
  filteredShiftPlans(filter: {id: $shiftId}) {
    collection {
      id
      shiftDate
      truckId
      status
      customerPods
      earliestStart
      hub {
        address
        lat
        lon
        name
      }
      completedDeliveries {
        address
        customerId
        customerName
        lat
        lon
        podNo
        product
        podNo
        volume
        inconsistent
        type
        arriveDateTime
        completeDateTime
        distanceMiles
        drivingTimeSeconds
      }
      completedDeliveriesMetrics {
        distance
        time
        timeSeconds
        deliveriesCount
        volumeDelivered
        serviceTime
        missing
      }
      plannedMetrics {
        deliveriesCount
        volumeDelivered
      }
      planned {
        address
        customerName
        product
        volume
        estimatedVolume
        podNo
        customerId
      }
      deliveries {
        address
        customerId
        customerName
        lat
        lon
        podNo
        product
        volume
        inconsistent
        estimatedVolume
        distanceMiles
        drivingTimeSeconds
        waitingTimeSeconds
        lastEndTime
        timeSeconds
        lastDistanceInMiles
        lastWaitingTime
        type
        arrTime
        arrivingTime
        lastDrivingTime
        flushing
        hoseTime
        timeAdder
        inventory
        index
        compartment
        productUsed
        volumeUsed
        productCode
        timeWindows {
          earliest
          latest
        }
      }
      deliveriesMetrics {
        distance
        time
        timeSeconds
        deliveriesCount
        volumeDelivered
        serviceTime
      }
      deliveriesRoutes
    }
  }
}
    `;

/**
 * __useOptimizedShiftDetailQuery__
 *
 * To run a query within a React component, call `useOptimizedShiftDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptimizedShiftDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptimizedShiftDetailQuery({
 *   variables: {
 *      shiftId: // value for 'shiftId'
 *   },
 * });
 */
export function useOptimizedShiftDetailQuery(baseOptions: Apollo.QueryHookOptions<OptimizedShiftDetailQuery, OptimizedShiftDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OptimizedShiftDetailQuery, OptimizedShiftDetailQueryVariables>(OptimizedShiftDetailDocument, options);
      }
export function useOptimizedShiftDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OptimizedShiftDetailQuery, OptimizedShiftDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OptimizedShiftDetailQuery, OptimizedShiftDetailQueryVariables>(OptimizedShiftDetailDocument, options);
        }
export type OptimizedShiftDetailQueryHookResult = ReturnType<typeof useOptimizedShiftDetailQuery>;
export type OptimizedShiftDetailLazyQueryHookResult = ReturnType<typeof useOptimizedShiftDetailLazyQuery>;
export type OptimizedShiftDetailQueryResult = Apollo.QueryResult<OptimizedShiftDetailQuery, OptimizedShiftDetailQueryVariables>;
export const ShiftPlanDetailForPdfDocument = gql`
    query ShiftPlanDetailForPdf($shiftIds: [ID!]) {
  filteredShiftPlans(filter: {ids: $shiftIds}) {
    collection {
      truckId
      shiftDate
      deliveries {
        customerName
        inconsistent
        product
        volume
        customerId
        podNo
        orderNumber
        tankSize
        productCode
        deliveryInstruction
        lastDeliveryDate
        secondLastDeliveryDate
        ffm
        contact
        address
        deliveryZone
        division
        lineComment
      }
    }
  }
}
    `;

/**
 * __useShiftPlanDetailForPdfQuery__
 *
 * To run a query within a React component, call `useShiftPlanDetailForPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useShiftPlanDetailForPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShiftPlanDetailForPdfQuery({
 *   variables: {
 *      shiftIds: // value for 'shiftIds'
 *   },
 * });
 */
export function useShiftPlanDetailForPdfQuery(baseOptions?: Apollo.QueryHookOptions<ShiftPlanDetailForPdfQuery, ShiftPlanDetailForPdfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShiftPlanDetailForPdfQuery, ShiftPlanDetailForPdfQueryVariables>(ShiftPlanDetailForPdfDocument, options);
      }
export function useShiftPlanDetailForPdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShiftPlanDetailForPdfQuery, ShiftPlanDetailForPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShiftPlanDetailForPdfQuery, ShiftPlanDetailForPdfQueryVariables>(ShiftPlanDetailForPdfDocument, options);
        }
export type ShiftPlanDetailForPdfQueryHookResult = ReturnType<typeof useShiftPlanDetailForPdfQuery>;
export type ShiftPlanDetailForPdfLazyQueryHookResult = ReturnType<typeof useShiftPlanDetailForPdfLazyQuery>;
export type ShiftPlanDetailForPdfQueryResult = Apollo.QueryResult<ShiftPlanDetailForPdfQuery, ShiftPlanDetailForPdfQueryVariables>;
export const ShiftPlanMapDocument = gql`
    query ShiftPlanMap($id: ID) {
  filteredShiftPlans(filter: {id: $id}) {
    collection {
      id
      optimized
      routingRequestId
      planned {
        address
        estimatedVolume
        lat
        lon
        customerName
        orderNumber
      }
      deliveries {
        lat
        lon
        inconsistent
        volume
        estimatedVolume
        customerName
        orderNumber
      }
      deliveriesRoutes
      hub {
        address
        lat
        lon
        name
      }
    }
  }
}
    `;

/**
 * __useShiftPlanMapQuery__
 *
 * To run a query within a React component, call `useShiftPlanMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useShiftPlanMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShiftPlanMapQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useShiftPlanMapQuery(baseOptions?: Apollo.QueryHookOptions<ShiftPlanMapQuery, ShiftPlanMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShiftPlanMapQuery, ShiftPlanMapQueryVariables>(ShiftPlanMapDocument, options);
      }
export function useShiftPlanMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShiftPlanMapQuery, ShiftPlanMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShiftPlanMapQuery, ShiftPlanMapQueryVariables>(ShiftPlanMapDocument, options);
        }
export type ShiftPlanMapQueryHookResult = ReturnType<typeof useShiftPlanMapQuery>;
export type ShiftPlanMapLazyQueryHookResult = ReturnType<typeof useShiftPlanMapLazyQuery>;
export type ShiftPlanMapQueryResult = Apollo.QueryResult<ShiftPlanMapQuery, ShiftPlanMapQueryVariables>;
export const ShiftPlansTableDataDocument = gql`
    query ShiftPlansTableData($perPage: Int, $offSet: Int, $sorter: [ShiftPlanSorter!], $fromTime: Int, $toTime: Int, $searchText: String, $truckId: String, $product: String, $location: [String!]) {
  filteredShiftPlans(
    limit: $perPage
    offset: $offSet
    sorter: $sorter
    filter: {fromTimestamp: $fromTime, toTimestamp: $toTime, all: $searchText, truckId: $truckId, product: $product, location: $location}
  ) {
    collection {
      id
      shiftDate
      truckId
      status
      shift
      customerPods
      optimized
      productsDelivered
      errors
      location
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useShiftPlansTableDataQuery__
 *
 * To run a query within a React component, call `useShiftPlansTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useShiftPlansTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShiftPlansTableDataQuery({
 *   variables: {
 *      perPage: // value for 'perPage'
 *      offSet: // value for 'offSet'
 *      sorter: // value for 'sorter'
 *      fromTime: // value for 'fromTime'
 *      toTime: // value for 'toTime'
 *      searchText: // value for 'searchText'
 *      truckId: // value for 'truckId'
 *      product: // value for 'product'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useShiftPlansTableDataQuery(baseOptions?: Apollo.QueryHookOptions<ShiftPlansTableDataQuery, ShiftPlansTableDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShiftPlansTableDataQuery, ShiftPlansTableDataQueryVariables>(ShiftPlansTableDataDocument, options);
      }
export function useShiftPlansTableDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShiftPlansTableDataQuery, ShiftPlansTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShiftPlansTableDataQuery, ShiftPlansTableDataQueryVariables>(ShiftPlansTableDataDocument, options);
        }
export type ShiftPlansTableDataQueryHookResult = ReturnType<typeof useShiftPlansTableDataQuery>;
export type ShiftPlansTableDataLazyQueryHookResult = ReturnType<typeof useShiftPlansTableDataLazyQuery>;
export type ShiftPlansTableDataQueryResult = Apollo.QueryResult<ShiftPlansTableDataQuery, ShiftPlansTableDataQueryVariables>;
export const TenantCustomerBranchesDocument = gql`
    query TenantCustomerBranches {
  filteredCustomerBranches(
    filter: {isTenant: true}
    sorter: {field: NAME, order: asc}
  ) {
    collection {
      id
      name
    }
  }
}
    `;

/**
 * __useTenantCustomerBranchesQuery__
 *
 * To run a query within a React component, call `useTenantCustomerBranchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantCustomerBranchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantCustomerBranchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTenantCustomerBranchesQuery(baseOptions?: Apollo.QueryHookOptions<TenantCustomerBranchesQuery, TenantCustomerBranchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantCustomerBranchesQuery, TenantCustomerBranchesQueryVariables>(TenantCustomerBranchesDocument, options);
      }
export function useTenantCustomerBranchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantCustomerBranchesQuery, TenantCustomerBranchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantCustomerBranchesQuery, TenantCustomerBranchesQueryVariables>(TenantCustomerBranchesDocument, options);
        }
export type TenantCustomerBranchesQueryHookResult = ReturnType<typeof useTenantCustomerBranchesQuery>;
export type TenantCustomerBranchesLazyQueryHookResult = ReturnType<typeof useTenantCustomerBranchesLazyQuery>;
export type TenantCustomerBranchesQueryResult = Apollo.QueryResult<TenantCustomerBranchesQuery, TenantCustomerBranchesQueryVariables>;
export const OptimizeShiftPlanDocument = gql`
    mutation OptimizeShiftPlan($shiftIds: [ID!]!) {
  optimizeShiftPlan(input: {ids: $shiftIds}) {
    queued
  }
}
    `;
export type OptimizeShiftPlanMutationFn = Apollo.MutationFunction<OptimizeShiftPlanMutation, OptimizeShiftPlanMutationVariables>;

/**
 * __useOptimizeShiftPlanMutation__
 *
 * To run a mutation, you first call `useOptimizeShiftPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOptimizeShiftPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [optimizeShiftPlanMutation, { data, loading, error }] = useOptimizeShiftPlanMutation({
 *   variables: {
 *      shiftIds: // value for 'shiftIds'
 *   },
 * });
 */
export function useOptimizeShiftPlanMutation(baseOptions?: Apollo.MutationHookOptions<OptimizeShiftPlanMutation, OptimizeShiftPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OptimizeShiftPlanMutation, OptimizeShiftPlanMutationVariables>(OptimizeShiftPlanDocument, options);
      }
export type OptimizeShiftPlanMutationHookResult = ReturnType<typeof useOptimizeShiftPlanMutation>;
export type OptimizeShiftPlanMutationResult = Apollo.MutationResult<OptimizeShiftPlanMutation>;
export type OptimizeShiftPlanMutationOptions = Apollo.BaseMutationOptions<OptimizeShiftPlanMutation, OptimizeShiftPlanMutationVariables>;
export const UpdateCommonCarrierDocument = gql`
    mutation UpdateCommonCarrier($input: UpdateCommonCarrierInput!) {
  updateCommonCarrier(input: $input) {
    ccTenant {
      id
      erpId
      name
      address
      carrierTenantId
      secondaryEmails
      site {
        address
        city
        lat
        lng
        radius
        state
        qbAddress
        tags
      }
    }
    success
    error
  }
}
    `;
export type UpdateCommonCarrierMutationFn = Apollo.MutationFunction<UpdateCommonCarrierMutation, UpdateCommonCarrierMutationVariables>;

/**
 * __useUpdateCommonCarrierMutation__
 *
 * To run a mutation, you first call `useUpdateCommonCarrierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommonCarrierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommonCarrierMutation, { data, loading, error }] = useUpdateCommonCarrierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommonCarrierMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommonCarrierMutation, UpdateCommonCarrierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommonCarrierMutation, UpdateCommonCarrierMutationVariables>(UpdateCommonCarrierDocument, options);
      }
export type UpdateCommonCarrierMutationHookResult = ReturnType<typeof useUpdateCommonCarrierMutation>;
export type UpdateCommonCarrierMutationResult = Apollo.MutationResult<UpdateCommonCarrierMutation>;
export type UpdateCommonCarrierMutationOptions = Apollo.BaseMutationOptions<UpdateCommonCarrierMutation, UpdateCommonCarrierMutationVariables>;
export const CreateSettingDocument = gql`
    mutation CreateSetting($input: CreateSettingInput!) {
  createSetting(input: $input) {
    setting {
      id
      name
      value
    }
  }
}
    `;
export type CreateSettingMutationFn = Apollo.MutationFunction<CreateSettingMutation, CreateSettingMutationVariables>;

/**
 * __useCreateSettingMutation__
 *
 * To run a mutation, you first call `useCreateSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSettingMutation, { data, loading, error }] = useCreateSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSettingMutation(baseOptions?: Apollo.MutationHookOptions<CreateSettingMutation, CreateSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSettingMutation, CreateSettingMutationVariables>(CreateSettingDocument, options);
      }
export type CreateSettingMutationHookResult = ReturnType<typeof useCreateSettingMutation>;
export type CreateSettingMutationResult = Apollo.MutationResult<CreateSettingMutation>;
export type CreateSettingMutationOptions = Apollo.BaseMutationOptions<CreateSettingMutation, CreateSettingMutationVariables>;
export const IndexResourceDocument = gql`
    mutation IndexResource($resource: IndexResourceInput!) {
  indexResource(input: $resource) {
    setting {
      id
      name
      value
    }
  }
}
    `;
export type IndexResourceMutationFn = Apollo.MutationFunction<IndexResourceMutation, IndexResourceMutationVariables>;

/**
 * __useIndexResourceMutation__
 *
 * To run a mutation, you first call `useIndexResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIndexResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [indexResourceMutation, { data, loading, error }] = useIndexResourceMutation({
 *   variables: {
 *      resource: // value for 'resource'
 *   },
 * });
 */
export function useIndexResourceMutation(baseOptions?: Apollo.MutationHookOptions<IndexResourceMutation, IndexResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IndexResourceMutation, IndexResourceMutationVariables>(IndexResourceDocument, options);
      }
export type IndexResourceMutationHookResult = ReturnType<typeof useIndexResourceMutation>;
export type IndexResourceMutationResult = Apollo.MutationResult<IndexResourceMutation>;
export type IndexResourceMutationOptions = Apollo.BaseMutationOptions<IndexResourceMutation, IndexResourceMutationVariables>;
export const RefreshApiTokenDocument = gql`
    mutation RefreshApiToken {
  refreshApiToken(input: {}) {
    setting {
      id
      name
      value
    }
  }
}
    `;
export type RefreshApiTokenMutationFn = Apollo.MutationFunction<RefreshApiTokenMutation, RefreshApiTokenMutationVariables>;

/**
 * __useRefreshApiTokenMutation__
 *
 * To run a mutation, you first call `useRefreshApiTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshApiTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshApiTokenMutation, { data, loading, error }] = useRefreshApiTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshApiTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshApiTokenMutation, RefreshApiTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshApiTokenMutation, RefreshApiTokenMutationVariables>(RefreshApiTokenDocument, options);
      }
export type RefreshApiTokenMutationHookResult = ReturnType<typeof useRefreshApiTokenMutation>;
export type RefreshApiTokenMutationResult = Apollo.MutationResult<RefreshApiTokenMutation>;
export type RefreshApiTokenMutationOptions = Apollo.BaseMutationOptions<RefreshApiTokenMutation, RefreshApiTokenMutationVariables>;
export const UpdateResourceDocument = gql`
    mutation UpdateResource($resource: UpdateResourceInput!) {
  updateResource(input: $resource) {
    error
    success
    records {
      ... on Setting {
        id
        name
        value
      }
      ... on CcTenant {
        id
        name
        erpId
        secondaryEmails
      }
      ... on Site {
        id
        address
        city
        zip
        state
      }
      ... on DriverRate {
        id
        rate
      }
    }
  }
}
    `;
export type UpdateResourceMutationFn = Apollo.MutationFunction<UpdateResourceMutation, UpdateResourceMutationVariables>;

/**
 * __useUpdateResourceMutation__
 *
 * To run a mutation, you first call `useUpdateResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceMutation, { data, loading, error }] = useUpdateResourceMutation({
 *   variables: {
 *      resource: // value for 'resource'
 *   },
 * });
 */
export function useUpdateResourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResourceMutation, UpdateResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResourceMutation, UpdateResourceMutationVariables>(UpdateResourceDocument, options);
      }
export type UpdateResourceMutationHookResult = ReturnType<typeof useUpdateResourceMutation>;
export type UpdateResourceMutationResult = Apollo.MutationResult<UpdateResourceMutation>;
export type UpdateResourceMutationOptions = Apollo.BaseMutationOptions<UpdateResourceMutation, UpdateResourceMutationVariables>;
export const OptimizedOrderGroupsDocument = gql`
    query OptimizedOrderGroups($limit: Int = 20, $offset: Int = 0, $statuses: [String!], $fromTimestamp: Int!, $toTimestamp: Int!, $workerIds: [ID!]) {
  filteredOrderGroups(
    limit: $limit
    offset: $offset
    filter: {workerIds: $workerIds, statuses: $statuses, fromTimestamp: $fromTimestamp, toTimestamp: $toTimestamp, recurring: false}
  ) {
    metadata {
      hasMore
    }
    collection {
      id
      status
      startOn
      startOnTimestamp
      worker {
        id
        name
      }
      deliveryOrder {
        id
        type
        customerBranch {
          id
          name
          address
          customer {
            id
            name
            address
          }
        }
      }
      loadingOrder {
        id
        terminal {
          id
          name
        }
      }
      transferOrder {
        id
      }
    }
  }
}
    `;

/**
 * __useOptimizedOrderGroupsQuery__
 *
 * To run a query within a React component, call `useOptimizedOrderGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptimizedOrderGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptimizedOrderGroupsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      statuses: // value for 'statuses'
 *      fromTimestamp: // value for 'fromTimestamp'
 *      toTimestamp: // value for 'toTimestamp'
 *      workerIds: // value for 'workerIds'
 *   },
 * });
 */
export function useOptimizedOrderGroupsQuery(baseOptions: Apollo.QueryHookOptions<OptimizedOrderGroupsQuery, OptimizedOrderGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OptimizedOrderGroupsQuery, OptimizedOrderGroupsQueryVariables>(OptimizedOrderGroupsDocument, options);
      }
export function useOptimizedOrderGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OptimizedOrderGroupsQuery, OptimizedOrderGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OptimizedOrderGroupsQuery, OptimizedOrderGroupsQueryVariables>(OptimizedOrderGroupsDocument, options);
        }
export type OptimizedOrderGroupsQueryHookResult = ReturnType<typeof useOptimizedOrderGroupsQuery>;
export type OptimizedOrderGroupsLazyQueryHookResult = ReturnType<typeof useOptimizedOrderGroupsLazyQuery>;
export type OptimizedOrderGroupsQueryResult = Apollo.QueryResult<OptimizedOrderGroupsQuery, OptimizedOrderGroupsQueryVariables>;
export const ChangeOrderAssignmentDocument = gql`
    mutation changeOrderAssignment($groupId: ID!, $startTime: String, $driverId: ID!) {
  changeOrderGroupAssignment(
    input: {orderGroupId: $groupId, startTime: $startTime, driverId: $driverId}
  ) {
    orderGroup {
      id
      driver {
        id
      }
      startOnTimestamp
    }
  }
}
    `;
export type ChangeOrderAssignmentMutationFn = Apollo.MutationFunction<ChangeOrderAssignmentMutation, ChangeOrderAssignmentMutationVariables>;

/**
 * __useChangeOrderAssignmentMutation__
 *
 * To run a mutation, you first call `useChangeOrderAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeOrderAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeOrderAssignmentMutation, { data, loading, error }] = useChangeOrderAssignmentMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      startTime: // value for 'startTime'
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useChangeOrderAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<ChangeOrderAssignmentMutation, ChangeOrderAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeOrderAssignmentMutation, ChangeOrderAssignmentMutationVariables>(ChangeOrderAssignmentDocument, options);
      }
export type ChangeOrderAssignmentMutationHookResult = ReturnType<typeof useChangeOrderAssignmentMutation>;
export type ChangeOrderAssignmentMutationResult = Apollo.MutationResult<ChangeOrderAssignmentMutation>;
export type ChangeOrderAssignmentMutationOptions = Apollo.BaseMutationOptions<ChangeOrderAssignmentMutation, ChangeOrderAssignmentMutationVariables>;
export const FetchDeliveryShiftDetailsDocument = gql`
    query FetchDeliveryShiftDetails($shiftId: ID!) {
  shift(id: $shiftId) {
    id
    shiftDeliveryUnitsAssets {
      deliveryAsset {
        id
        name
        licensePlateNumber
        category
        compartments {
          id
          length
          name
        }
      }
    }
  }
}
    `;

/**
 * __useFetchDeliveryShiftDetailsQuery__
 *
 * To run a query within a React component, call `useFetchDeliveryShiftDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDeliveryShiftDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDeliveryShiftDetailsQuery({
 *   variables: {
 *      shiftId: // value for 'shiftId'
 *   },
 * });
 */
export function useFetchDeliveryShiftDetailsQuery(baseOptions: Apollo.QueryHookOptions<FetchDeliveryShiftDetailsQuery, FetchDeliveryShiftDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDeliveryShiftDetailsQuery, FetchDeliveryShiftDetailsQueryVariables>(FetchDeliveryShiftDetailsDocument, options);
      }
export function useFetchDeliveryShiftDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDeliveryShiftDetailsQuery, FetchDeliveryShiftDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDeliveryShiftDetailsQuery, FetchDeliveryShiftDetailsQueryVariables>(FetchDeliveryShiftDetailsDocument, options);
        }
export type FetchDeliveryShiftDetailsQueryHookResult = ReturnType<typeof useFetchDeliveryShiftDetailsQuery>;
export type FetchDeliveryShiftDetailsLazyQueryHookResult = ReturnType<typeof useFetchDeliveryShiftDetailsLazyQuery>;
export type FetchDeliveryShiftDetailsQueryResult = Apollo.QueryResult<FetchDeliveryShiftDetailsQuery, FetchDeliveryShiftDetailsQueryVariables>;
export const FilterCommonCarrierDocument = gql`
    query FilterCommonCarrier($limit: Int = 20, $offset: Int = 0, $customFilter: CcTenantFilter) {
  filteredCcTenants(limit: $limit, offset: $offset, filter: $customFilter) {
    metadata {
      hasMore
    }
    collection {
      id
      name
    }
  }
}
    `;

/**
 * __useFilterCommonCarrierQuery__
 *
 * To run a query within a React component, call `useFilterCommonCarrierQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterCommonCarrierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterCommonCarrierQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      customFilter: // value for 'customFilter'
 *   },
 * });
 */
export function useFilterCommonCarrierQuery(baseOptions?: Apollo.QueryHookOptions<FilterCommonCarrierQuery, FilterCommonCarrierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterCommonCarrierQuery, FilterCommonCarrierQueryVariables>(FilterCommonCarrierDocument, options);
      }
export function useFilterCommonCarrierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterCommonCarrierQuery, FilterCommonCarrierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterCommonCarrierQuery, FilterCommonCarrierQueryVariables>(FilterCommonCarrierDocument, options);
        }
export type FilterCommonCarrierQueryHookResult = ReturnType<typeof useFilterCommonCarrierQuery>;
export type FilterCommonCarrierLazyQueryHookResult = ReturnType<typeof useFilterCommonCarrierLazyQuery>;
export type FilterCommonCarrierQueryResult = Apollo.QueryResult<FilterCommonCarrierQuery, FilterCommonCarrierQueryVariables>;
export const FilterDriverDocument = gql`
    query FilterDriver($limit: Int = 20, $offset: Int = 0, $sorter: [DriverSorter!], $customFilter: DriverFilter = {hasGroup: false}) {
  filteredDrivers(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: $customFilter
  ) {
    metadata {
      hasMore
    }
    collection {
      id
      name
      status
    }
  }
}
    `;

/**
 * __useFilterDriverQuery__
 *
 * To run a query within a React component, call `useFilterDriverQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterDriverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterDriverQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      customFilter: // value for 'customFilter'
 *   },
 * });
 */
export function useFilterDriverQuery(baseOptions?: Apollo.QueryHookOptions<FilterDriverQuery, FilterDriverQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterDriverQuery, FilterDriverQueryVariables>(FilterDriverDocument, options);
      }
export function useFilterDriverLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterDriverQuery, FilterDriverQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterDriverQuery, FilterDriverQueryVariables>(FilterDriverDocument, options);
        }
export type FilterDriverQueryHookResult = ReturnType<typeof useFilterDriverQuery>;
export type FilterDriverLazyQueryHookResult = ReturnType<typeof useFilterDriverLazyQuery>;
export type FilterDriverQueryResult = Apollo.QueryResult<FilterDriverQuery, FilterDriverQueryVariables>;
export const FilterDriverGroupsDocument = gql`
    query FilterDriverGroups($limit: Int = 20, $offset: Int = 0, $sorter: [GroupSorter!]) {
  filteredGroups(limit: $limit, offset: $offset, sorter: $sorter) {
    metadata {
      hasMore
      totalCount
    }
    collection {
      id
      name
      groupMemberships {
        id
        groupable {
          type: __typename
          ... on Driver {
            id
            name
            status
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFilterDriverGroupsQuery__
 *
 * To run a query within a React component, call `useFilterDriverGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterDriverGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterDriverGroupsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilterDriverGroupsQuery(baseOptions?: Apollo.QueryHookOptions<FilterDriverGroupsQuery, FilterDriverGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterDriverGroupsQuery, FilterDriverGroupsQueryVariables>(FilterDriverGroupsDocument, options);
      }
export function useFilterDriverGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterDriverGroupsQuery, FilterDriverGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterDriverGroupsQuery, FilterDriverGroupsQueryVariables>(FilterDriverGroupsDocument, options);
        }
export type FilterDriverGroupsQueryHookResult = ReturnType<typeof useFilterDriverGroupsQuery>;
export type FilterDriverGroupsLazyQueryHookResult = ReturnType<typeof useFilterDriverGroupsLazyQuery>;
export type FilterDriverGroupsQueryResult = Apollo.QueryResult<FilterDriverGroupsQuery, FilterDriverGroupsQueryVariables>;
export const UpdateDeliveryOrderDocument = gql`
    mutation UpdateDeliveryOrder($input: UpdateDeliveryOrderInput!) {
  updateDeliveryOrder(input: $input) {
    deliveryOrder {
      id
      orderGroup {
        shift {
          shiftDeliveryUnitsAssets {
            deliveryAsset {
              id
              name
              licensePlateNumber
              category
              compartments {
                id
                name
              }
            }
          }
        }
      }
      lineItems {
        id
        status
        source
        topOff
        requestedVolume
        volume
        skipReason
        data
        isExtraction
        canSyncRequestedLoadingVolume
        warehouseId
        notes
        product {
          id
          category
          name
          colorCode
          shortName
          code
          unit
          brand {
            id
            name
          }
        }
        asset {
          id
          licensePlateNumber
          name
          category
          lat
          lng
        }
        sourceCompartments {
          id
          dispensedVolume
          compartment {
            id
            name
            asset {
              id
              name
              licensePlateNumber
              category
            }
          }
        }
        targetCompartmentInstance {
          id
          beforeStick
          beforeStickUnit
          afterStick
          afterStickUnit
        }
        subscription {
          id
        }
      }
    }
  }
}
    `;
export type UpdateDeliveryOrderMutationFn = Apollo.MutationFunction<UpdateDeliveryOrderMutation, UpdateDeliveryOrderMutationVariables>;

/**
 * __useUpdateDeliveryOrderMutation__
 *
 * To run a mutation, you first call `useUpdateDeliveryOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliveryOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliveryOrderMutation, { data, loading, error }] = useUpdateDeliveryOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDeliveryOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeliveryOrderMutation, UpdateDeliveryOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeliveryOrderMutation, UpdateDeliveryOrderMutationVariables>(UpdateDeliveryOrderDocument, options);
      }
export type UpdateDeliveryOrderMutationHookResult = ReturnType<typeof useUpdateDeliveryOrderMutation>;
export type UpdateDeliveryOrderMutationResult = Apollo.MutationResult<UpdateDeliveryOrderMutation>;
export type UpdateDeliveryOrderMutationOptions = Apollo.BaseMutationOptions<UpdateDeliveryOrderMutation, UpdateDeliveryOrderMutationVariables>;
export const UpdateDeliveryOrderGroupDocument = gql`
    mutation UpdateDeliveryOrderGroup($input: UpdateOrderGroupMutationInput!) {
  updateOrderGroup(input: $input) {
    orderGroup {
      ...deliveryOrderGroup
    }
  }
}
    ${DeliveryOrderGroupFragmentDoc}`;
export type UpdateDeliveryOrderGroupMutationFn = Apollo.MutationFunction<UpdateDeliveryOrderGroupMutation, UpdateDeliveryOrderGroupMutationVariables>;

/**
 * __useUpdateDeliveryOrderGroupMutation__
 *
 * To run a mutation, you first call `useUpdateDeliveryOrderGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliveryOrderGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliveryOrderGroupMutation, { data, loading, error }] = useUpdateDeliveryOrderGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDeliveryOrderGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeliveryOrderGroupMutation, UpdateDeliveryOrderGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeliveryOrderGroupMutation, UpdateDeliveryOrderGroupMutationVariables>(UpdateDeliveryOrderGroupDocument, options);
      }
export type UpdateDeliveryOrderGroupMutationHookResult = ReturnType<typeof useUpdateDeliveryOrderGroupMutation>;
export type UpdateDeliveryOrderGroupMutationResult = Apollo.MutationResult<UpdateDeliveryOrderGroupMutation>;
export type UpdateDeliveryOrderGroupMutationOptions = Apollo.BaseMutationOptions<UpdateDeliveryOrderGroupMutation, UpdateDeliveryOrderGroupMutationVariables>;
export const UpdateDeliveryOrderLineItemDocument = gql`
    mutation UpdateDeliveryOrderLineItem($input: UpdateDeliveryOrderLineItemInput!) {
  updateDeliveryOrderLineItem(input: $input) {
    deliveryOrderLineItem {
      id
    }
  }
}
    `;
export type UpdateDeliveryOrderLineItemMutationFn = Apollo.MutationFunction<UpdateDeliveryOrderLineItemMutation, UpdateDeliveryOrderLineItemMutationVariables>;

/**
 * __useUpdateDeliveryOrderLineItemMutation__
 *
 * To run a mutation, you first call `useUpdateDeliveryOrderLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliveryOrderLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliveryOrderLineItemMutation, { data, loading, error }] = useUpdateDeliveryOrderLineItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDeliveryOrderLineItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeliveryOrderLineItemMutation, UpdateDeliveryOrderLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeliveryOrderLineItemMutation, UpdateDeliveryOrderLineItemMutationVariables>(UpdateDeliveryOrderLineItemDocument, options);
      }
export type UpdateDeliveryOrderLineItemMutationHookResult = ReturnType<typeof useUpdateDeliveryOrderLineItemMutation>;
export type UpdateDeliveryOrderLineItemMutationResult = Apollo.MutationResult<UpdateDeliveryOrderLineItemMutation>;
export type UpdateDeliveryOrderLineItemMutationOptions = Apollo.BaseMutationOptions<UpdateDeliveryOrderLineItemMutation, UpdateDeliveryOrderLineItemMutationVariables>;
export const CreateOrUpdateRoleDocument = gql`
    mutation CreateOrUpdateRole($input: CreateOrUpdateRoleInput!) {
  createOrUpdateRole(input: $input) {
    role {
      id
      name
      label
      adminRole
    }
  }
}
    `;
export type CreateOrUpdateRoleMutationFn = Apollo.MutationFunction<CreateOrUpdateRoleMutation, CreateOrUpdateRoleMutationVariables>;

/**
 * __useCreateOrUpdateRoleMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateRoleMutation, { data, loading, error }] = useCreateOrUpdateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateRoleMutation, CreateOrUpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateRoleMutation, CreateOrUpdateRoleMutationVariables>(CreateOrUpdateRoleDocument, options);
      }
export type CreateOrUpdateRoleMutationHookResult = ReturnType<typeof useCreateOrUpdateRoleMutation>;
export type CreateOrUpdateRoleMutationResult = Apollo.MutationResult<CreateOrUpdateRoleMutation>;
export type CreateOrUpdateRoleMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateRoleMutation, CreateOrUpdateRoleMutationVariables>;
export const FetchRoleByIdDocument = gql`
    query FetchRoleById($roleId: ID!) {
  role(roleId: $roleId) {
    id
    label
    name
    adminRole
    enabledFeatures {
      id
      featureId
    }
  }
}
    `;

/**
 * __useFetchRoleByIdQuery__
 *
 * To run a query within a React component, call `useFetchRoleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRoleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRoleByIdQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useFetchRoleByIdQuery(baseOptions: Apollo.QueryHookOptions<FetchRoleByIdQuery, FetchRoleByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRoleByIdQuery, FetchRoleByIdQueryVariables>(FetchRoleByIdDocument, options);
      }
export function useFetchRoleByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRoleByIdQuery, FetchRoleByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRoleByIdQuery, FetchRoleByIdQueryVariables>(FetchRoleByIdDocument, options);
        }
export type FetchRoleByIdQueryHookResult = ReturnType<typeof useFetchRoleByIdQuery>;
export type FetchRoleByIdLazyQueryHookResult = ReturnType<typeof useFetchRoleByIdLazyQuery>;
export type FetchRoleByIdQueryResult = Apollo.QueryResult<FetchRoleByIdQuery, FetchRoleByIdQueryVariables>;
export const FetchRoleFeaturesDocument = gql`
    query FetchRoleFeatures {
  features {
    id
    key
    name
  }
}
    `;

/**
 * __useFetchRoleFeaturesQuery__
 *
 * To run a query within a React component, call `useFetchRoleFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRoleFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRoleFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchRoleFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<FetchRoleFeaturesQuery, FetchRoleFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRoleFeaturesQuery, FetchRoleFeaturesQueryVariables>(FetchRoleFeaturesDocument, options);
      }
export function useFetchRoleFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRoleFeaturesQuery, FetchRoleFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRoleFeaturesQuery, FetchRoleFeaturesQueryVariables>(FetchRoleFeaturesDocument, options);
        }
export type FetchRoleFeaturesQueryHookResult = ReturnType<typeof useFetchRoleFeaturesQuery>;
export type FetchRoleFeaturesLazyQueryHookResult = ReturnType<typeof useFetchRoleFeaturesLazyQuery>;
export type FetchRoleFeaturesQueryResult = Apollo.QueryResult<FetchRoleFeaturesQuery, FetchRoleFeaturesQueryVariables>;
export const FetchRoleListDocument = gql`
    query FetchRoleList {
  roles {
    id
    name
    label
    resourceType
  }
}
    `;

/**
 * __useFetchRoleListQuery__
 *
 * To run a query within a React component, call `useFetchRoleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRoleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRoleListQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchRoleListQuery(baseOptions?: Apollo.QueryHookOptions<FetchRoleListQuery, FetchRoleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRoleListQuery, FetchRoleListQueryVariables>(FetchRoleListDocument, options);
      }
export function useFetchRoleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRoleListQuery, FetchRoleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRoleListQuery, FetchRoleListQueryVariables>(FetchRoleListDocument, options);
        }
export type FetchRoleListQueryHookResult = ReturnType<typeof useFetchRoleListQuery>;
export type FetchRoleListLazyQueryHookResult = ReturnType<typeof useFetchRoleListLazyQuery>;
export type FetchRoleListQueryResult = Apollo.QueryResult<FetchRoleListQuery, FetchRoleListQueryVariables>;
export const TmCreateSaveViewDocument = gql`
    mutation TmCreateSaveView($input: CreateSavedViewInput!) {
  createSavedView(input: $input) {
    errors
    savedView {
      config
      id
      name
      viewType
    }
  }
}
    `;
export type TmCreateSaveViewMutationFn = Apollo.MutationFunction<TmCreateSaveViewMutation, TmCreateSaveViewMutationVariables>;

/**
 * __useTmCreateSaveViewMutation__
 *
 * To run a mutation, you first call `useTmCreateSaveViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTmCreateSaveViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tmCreateSaveViewMutation, { data, loading, error }] = useTmCreateSaveViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTmCreateSaveViewMutation(baseOptions?: Apollo.MutationHookOptions<TmCreateSaveViewMutation, TmCreateSaveViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TmCreateSaveViewMutation, TmCreateSaveViewMutationVariables>(TmCreateSaveViewDocument, options);
      }
export type TmCreateSaveViewMutationHookResult = ReturnType<typeof useTmCreateSaveViewMutation>;
export type TmCreateSaveViewMutationResult = Apollo.MutationResult<TmCreateSaveViewMutation>;
export type TmCreateSaveViewMutationOptions = Apollo.BaseMutationOptions<TmCreateSaveViewMutation, TmCreateSaveViewMutationVariables>;
export const TmDeleteSavedViewDocument = gql`
    mutation TmDeleteSavedView($input: DeleteResourceInput!) {
  deleteResource(input: $input) {
    result
    __typename
  }
}
    `;
export type TmDeleteSavedViewMutationFn = Apollo.MutationFunction<TmDeleteSavedViewMutation, TmDeleteSavedViewMutationVariables>;

/**
 * __useTmDeleteSavedViewMutation__
 *
 * To run a mutation, you first call `useTmDeleteSavedViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTmDeleteSavedViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tmDeleteSavedViewMutation, { data, loading, error }] = useTmDeleteSavedViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTmDeleteSavedViewMutation(baseOptions?: Apollo.MutationHookOptions<TmDeleteSavedViewMutation, TmDeleteSavedViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TmDeleteSavedViewMutation, TmDeleteSavedViewMutationVariables>(TmDeleteSavedViewDocument, options);
      }
export type TmDeleteSavedViewMutationHookResult = ReturnType<typeof useTmDeleteSavedViewMutation>;
export type TmDeleteSavedViewMutationResult = Apollo.MutationResult<TmDeleteSavedViewMutation>;
export type TmDeleteSavedViewMutationOptions = Apollo.BaseMutationOptions<TmDeleteSavedViewMutation, TmDeleteSavedViewMutationVariables>;
export const TmGetSavedViewListDocument = gql`
    query TmGetSavedViewList($viewType: SavedViewEnum!) {
  savedViews(viewType: $viewType) {
    id
    name
    __typename
  }
}
    `;

/**
 * __useTmGetSavedViewListQuery__
 *
 * To run a query within a React component, call `useTmGetSavedViewListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTmGetSavedViewListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTmGetSavedViewListQuery({
 *   variables: {
 *      viewType: // value for 'viewType'
 *   },
 * });
 */
export function useTmGetSavedViewListQuery(baseOptions: Apollo.QueryHookOptions<TmGetSavedViewListQuery, TmGetSavedViewListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TmGetSavedViewListQuery, TmGetSavedViewListQueryVariables>(TmGetSavedViewListDocument, options);
      }
export function useTmGetSavedViewListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TmGetSavedViewListQuery, TmGetSavedViewListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TmGetSavedViewListQuery, TmGetSavedViewListQueryVariables>(TmGetSavedViewListDocument, options);
        }
export type TmGetSavedViewListQueryHookResult = ReturnType<typeof useTmGetSavedViewListQuery>;
export type TmGetSavedViewListLazyQueryHookResult = ReturnType<typeof useTmGetSavedViewListLazyQuery>;
export type TmGetSavedViewListQueryResult = Apollo.QueryResult<TmGetSavedViewListQuery, TmGetSavedViewListQueryVariables>;
export const TmSelectedSavedViewDocument = gql`
    query TmSelectedSavedView($id: ID!) {
  savedView(id: $id) {
    id
    config
    __typename
  }
}
    `;

/**
 * __useTmSelectedSavedViewQuery__
 *
 * To run a query within a React component, call `useTmSelectedSavedViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTmSelectedSavedViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTmSelectedSavedViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTmSelectedSavedViewQuery(baseOptions: Apollo.QueryHookOptions<TmSelectedSavedViewQuery, TmSelectedSavedViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TmSelectedSavedViewQuery, TmSelectedSavedViewQueryVariables>(TmSelectedSavedViewDocument, options);
      }
export function useTmSelectedSavedViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TmSelectedSavedViewQuery, TmSelectedSavedViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TmSelectedSavedViewQuery, TmSelectedSavedViewQueryVariables>(TmSelectedSavedViewDocument, options);
        }
export type TmSelectedSavedViewQueryHookResult = ReturnType<typeof useTmSelectedSavedViewQuery>;
export type TmSelectedSavedViewLazyQueryHookResult = ReturnType<typeof useTmSelectedSavedViewLazyQuery>;
export type TmSelectedSavedViewQueryResult = Apollo.QueryResult<TmSelectedSavedViewQuery, TmSelectedSavedViewQueryVariables>;
export const TmUpdateSavedViewDocument = gql`
    mutation TmUpdateSavedView($input: UpdateSavedViewInput!) {
  updateSavedView(input: $input) {
    errors
    savedView {
      id
      config
      __typename
    }
    __typename
  }
}
    `;
export type TmUpdateSavedViewMutationFn = Apollo.MutationFunction<TmUpdateSavedViewMutation, TmUpdateSavedViewMutationVariables>;

/**
 * __useTmUpdateSavedViewMutation__
 *
 * To run a mutation, you first call `useTmUpdateSavedViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTmUpdateSavedViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tmUpdateSavedViewMutation, { data, loading, error }] = useTmUpdateSavedViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTmUpdateSavedViewMutation(baseOptions?: Apollo.MutationHookOptions<TmUpdateSavedViewMutation, TmUpdateSavedViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TmUpdateSavedViewMutation, TmUpdateSavedViewMutationVariables>(TmUpdateSavedViewDocument, options);
      }
export type TmUpdateSavedViewMutationHookResult = ReturnType<typeof useTmUpdateSavedViewMutation>;
export type TmUpdateSavedViewMutationResult = Apollo.MutationResult<TmUpdateSavedViewMutation>;
export type TmUpdateSavedViewMutationOptions = Apollo.BaseMutationOptions<TmUpdateSavedViewMutation, TmUpdateSavedViewMutationVariables>;
export const FetchFilterProductsDocument = gql`
    query fetchFilterProducts($searchText: String) {
  filteredProducts(limit: 10, offset: 0, filter: {all: $searchText}) {
    collection {
      id
      name
    }
    metadata {
      hasMore
    }
  }
}
    `;

/**
 * __useFetchFilterProductsQuery__
 *
 * To run a query within a React component, call `useFetchFilterProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilterProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilterProductsQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useFetchFilterProductsQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilterProductsQuery, FetchFilterProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilterProductsQuery, FetchFilterProductsQueryVariables>(FetchFilterProductsDocument, options);
      }
export function useFetchFilterProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilterProductsQuery, FetchFilterProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilterProductsQuery, FetchFilterProductsQueryVariables>(FetchFilterProductsDocument, options);
        }
export type FetchFilterProductsQueryHookResult = ReturnType<typeof useFetchFilterProductsQuery>;
export type FetchFilterProductsLazyQueryHookResult = ReturnType<typeof useFetchFilterProductsLazyQuery>;
export type FetchFilterProductsQueryResult = Apollo.QueryResult<FetchFilterProductsQuery, FetchFilterProductsQueryVariables>;
export const FetchFilterTankMonitorDocument = gql`
    query fetchFilterTankMonitor($searchText: String) {
  filteredTankMonitors(
    limit: 10
    offset: 0
    filter: {name: $searchText, isUnlinked: true}
  ) {
    collection {
      id
      deviceId
      deviceProvider
    }
    metadata {
      hasMore
    }
  }
}
    `;

/**
 * __useFetchFilterTankMonitorQuery__
 *
 * To run a query within a React component, call `useFetchFilterTankMonitorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilterTankMonitorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilterTankMonitorQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useFetchFilterTankMonitorQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilterTankMonitorQuery, FetchFilterTankMonitorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilterTankMonitorQuery, FetchFilterTankMonitorQueryVariables>(FetchFilterTankMonitorDocument, options);
      }
export function useFetchFilterTankMonitorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilterTankMonitorQuery, FetchFilterTankMonitorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilterTankMonitorQuery, FetchFilterTankMonitorQueryVariables>(FetchFilterTankMonitorDocument, options);
        }
export type FetchFilterTankMonitorQueryHookResult = ReturnType<typeof useFetchFilterTankMonitorQuery>;
export type FetchFilterTankMonitorLazyQueryHookResult = ReturnType<typeof useFetchFilterTankMonitorLazyQuery>;
export type FetchFilterTankMonitorQueryResult = Apollo.QueryResult<FetchFilterTankMonitorQuery, FetchFilterTankMonitorQueryVariables>;
export const FetchTankMonitorCountDocument = gql`
    query fetchTankMonitorCount($filter: DeviceFilterInput) {
  filteredTankMonitors(limit: 0, offset: 0, filter: $filter) {
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useFetchTankMonitorCountQuery__
 *
 * To run a query within a React component, call `useFetchTankMonitorCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTankMonitorCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTankMonitorCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchTankMonitorCountQuery(baseOptions?: Apollo.QueryHookOptions<FetchTankMonitorCountQuery, FetchTankMonitorCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTankMonitorCountQuery, FetchTankMonitorCountQueryVariables>(FetchTankMonitorCountDocument, options);
      }
export function useFetchTankMonitorCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTankMonitorCountQuery, FetchTankMonitorCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTankMonitorCountQuery, FetchTankMonitorCountQueryVariables>(FetchTankMonitorCountDocument, options);
        }
export type FetchTankMonitorCountQueryHookResult = ReturnType<typeof useFetchTankMonitorCountQuery>;
export type FetchTankMonitorCountLazyQueryHookResult = ReturnType<typeof useFetchTankMonitorCountLazyQuery>;
export type FetchTankMonitorCountQueryResult = Apollo.QueryResult<FetchTankMonitorCountQuery, FetchTankMonitorCountQueryVariables>;
export const TmApproveOrCancelOrdersDocument = gql`
    mutation TmApproveOrCancelOrders($input: TmApproveOrCancelOrdersInput!) {
  tmApproveOrCancelOrders(input: $input) {
    success
    errors
  }
}
    `;
export type TmApproveOrCancelOrdersMutationFn = Apollo.MutationFunction<TmApproveOrCancelOrdersMutation, TmApproveOrCancelOrdersMutationVariables>;

/**
 * __useTmApproveOrCancelOrdersMutation__
 *
 * To run a mutation, you first call `useTmApproveOrCancelOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTmApproveOrCancelOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tmApproveOrCancelOrdersMutation, { data, loading, error }] = useTmApproveOrCancelOrdersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTmApproveOrCancelOrdersMutation(baseOptions?: Apollo.MutationHookOptions<TmApproveOrCancelOrdersMutation, TmApproveOrCancelOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TmApproveOrCancelOrdersMutation, TmApproveOrCancelOrdersMutationVariables>(TmApproveOrCancelOrdersDocument, options);
      }
export type TmApproveOrCancelOrdersMutationHookResult = ReturnType<typeof useTmApproveOrCancelOrdersMutation>;
export type TmApproveOrCancelOrdersMutationResult = Apollo.MutationResult<TmApproveOrCancelOrdersMutation>;
export type TmApproveOrCancelOrdersMutationOptions = Apollo.BaseMutationOptions<TmApproveOrCancelOrdersMutation, TmApproveOrCancelOrdersMutationVariables>;
export const CreateAutoOrderTankMonitorDocument = gql`
    mutation CreateAutoOrderTankMonitor($input: UpdateAttachedAssetInput!) {
  updateAttachedAssets(input: $input) {
    attachedAsset {
      id
      autoOrder
      topOffBy
      refuelTanksThreshold
      topOffQuantity
      purchaseOrder
      orderConfirmation
      orderFillPercentage
      preferenceAvailability {
        day
        startTime
        endTime
        bestStartTime
        bestEndTime
        preferredStartTime
        preferredEndTime
      }
    }
  }
}
    `;
export type CreateAutoOrderTankMonitorMutationFn = Apollo.MutationFunction<CreateAutoOrderTankMonitorMutation, CreateAutoOrderTankMonitorMutationVariables>;

/**
 * __useCreateAutoOrderTankMonitorMutation__
 *
 * To run a mutation, you first call `useCreateAutoOrderTankMonitorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutoOrderTankMonitorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAutoOrderTankMonitorMutation, { data, loading, error }] = useCreateAutoOrderTankMonitorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAutoOrderTankMonitorMutation(baseOptions?: Apollo.MutationHookOptions<CreateAutoOrderTankMonitorMutation, CreateAutoOrderTankMonitorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAutoOrderTankMonitorMutation, CreateAutoOrderTankMonitorMutationVariables>(CreateAutoOrderTankMonitorDocument, options);
      }
export type CreateAutoOrderTankMonitorMutationHookResult = ReturnType<typeof useCreateAutoOrderTankMonitorMutation>;
export type CreateAutoOrderTankMonitorMutationResult = Apollo.MutationResult<CreateAutoOrderTankMonitorMutation>;
export type CreateAutoOrderTankMonitorMutationOptions = Apollo.BaseMutationOptions<CreateAutoOrderTankMonitorMutation, CreateAutoOrderTankMonitorMutationVariables>;
export const DetachAttachedAssetDocument = gql`
    mutation DetachAttachedAsset($input: DetachAssetInput!) {
  detachAttachedAsset(input: $input) {
    attachedAsset {
      id
    }
  }
}
    `;
export type DetachAttachedAssetMutationFn = Apollo.MutationFunction<DetachAttachedAssetMutation, DetachAttachedAssetMutationVariables>;

/**
 * __useDetachAttachedAssetMutation__
 *
 * To run a mutation, you first call `useDetachAttachedAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachAttachedAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachAttachedAssetMutation, { data, loading, error }] = useDetachAttachedAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDetachAttachedAssetMutation(baseOptions?: Apollo.MutationHookOptions<DetachAttachedAssetMutation, DetachAttachedAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DetachAttachedAssetMutation, DetachAttachedAssetMutationVariables>(DetachAttachedAssetDocument, options);
      }
export type DetachAttachedAssetMutationHookResult = ReturnType<typeof useDetachAttachedAssetMutation>;
export type DetachAttachedAssetMutationResult = Apollo.MutationResult<DetachAttachedAssetMutation>;
export type DetachAttachedAssetMutationOptions = Apollo.BaseMutationOptions<DetachAttachedAssetMutation, DetachAttachedAssetMutationVariables>;
export const FetchLinkedDataDocument = gql`
    query FetchLinkedData($perPage: Int, $offSet: Int, $filter: DeviceFilterInput, $sorter: [TankMonitorSorter!]) {
  filteredTankMonitors(
    limit: $perPage
    offset: $offSet
    filter: $filter
    sorter: $sorter
  ) {
    collection {
      id
      name
      deviceId
      deviceProvider
      tankCapacity
      reading
      attachedAsset
      consumptionSummary
      customer {
        id
        name
        hubs {
          name
        }
      }
      customerBranch {
        id
        name
        hubs {
          name
        }
      }
      asset {
        id
        name
        tmLastDeliveredTimestamp
        tmLastDeliveredVolume
        lineOfServices {
          name
        }
        subscriptions {
          product {
            name
          }
        }
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFetchLinkedDataQuery__
 *
 * To run a query within a React component, call `useFetchLinkedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLinkedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLinkedDataQuery({
 *   variables: {
 *      perPage: // value for 'perPage'
 *      offSet: // value for 'offSet'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchLinkedDataQuery(baseOptions?: Apollo.QueryHookOptions<FetchLinkedDataQuery, FetchLinkedDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLinkedDataQuery, FetchLinkedDataQueryVariables>(FetchLinkedDataDocument, options);
      }
export function useFetchLinkedDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLinkedDataQuery, FetchLinkedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLinkedDataQuery, FetchLinkedDataQueryVariables>(FetchLinkedDataDocument, options);
        }
export type FetchLinkedDataQueryHookResult = ReturnType<typeof useFetchLinkedDataQuery>;
export type FetchLinkedDataLazyQueryHookResult = ReturnType<typeof useFetchLinkedDataLazyQuery>;
export type FetchLinkedDataQueryResult = Apollo.QueryResult<FetchLinkedDataQuery, FetchLinkedDataQueryVariables>;
export const FetchUnLinkedDataDocument = gql`
    query FetchUnLinkedData($perPage: Int, $offSet: Int, $filter: DeviceFilterInput, $sorter: [TankMonitorSorter!]) {
  filteredTankMonitors(
    limit: $perPage
    offset: $offSet
    filter: $filter
    sorter: $sorter
  ) {
    collection {
      id
      name
      deviceId
      deviceProvider
      customer {
        id
        name
      }
      customerBranch {
        id
        name
      }
      asset {
        id
        name
        subscriptions {
          product {
            name
          }
        }
      }
      tankCapacity
      reading
      attachedAsset
      consumptionSummary
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFetchUnLinkedDataQuery__
 *
 * To run a query within a React component, call `useFetchUnLinkedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUnLinkedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUnLinkedDataQuery({
 *   variables: {
 *      perPage: // value for 'perPage'
 *      offSet: // value for 'offSet'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchUnLinkedDataQuery(baseOptions?: Apollo.QueryHookOptions<FetchUnLinkedDataQuery, FetchUnLinkedDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUnLinkedDataQuery, FetchUnLinkedDataQueryVariables>(FetchUnLinkedDataDocument, options);
      }
export function useFetchUnLinkedDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUnLinkedDataQuery, FetchUnLinkedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUnLinkedDataQuery, FetchUnLinkedDataQueryVariables>(FetchUnLinkedDataDocument, options);
        }
export type FetchUnLinkedDataQueryHookResult = ReturnType<typeof useFetchUnLinkedDataQuery>;
export type FetchUnLinkedDataLazyQueryHookResult = ReturnType<typeof useFetchUnLinkedDataLazyQuery>;
export type FetchUnLinkedDataQueryResult = Apollo.QueryResult<FetchUnLinkedDataQuery, FetchUnLinkedDataQueryVariables>;
export const FetchGroupByCustomerDocument = gql`
    query FetchGroupByCustomer($perPage: Int, $offSet: Int, $filter: DynamicFiltersInput) {
  tmFilteredCustomers(limit: $perPage, offset: $offSet, filter: $filter) {
    groupedCustomer {
      customers {
        id
        name
      }
      tankMonitorMetadata
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFetchGroupByCustomerQuery__
 *
 * To run a query within a React component, call `useFetchGroupByCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchGroupByCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchGroupByCustomerQuery({
 *   variables: {
 *      perPage: // value for 'perPage'
 *      offSet: // value for 'offSet'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchGroupByCustomerQuery(baseOptions?: Apollo.QueryHookOptions<FetchGroupByCustomerQuery, FetchGroupByCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchGroupByCustomerQuery, FetchGroupByCustomerQueryVariables>(FetchGroupByCustomerDocument, options);
      }
export function useFetchGroupByCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchGroupByCustomerQuery, FetchGroupByCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchGroupByCustomerQuery, FetchGroupByCustomerQueryVariables>(FetchGroupByCustomerDocument, options);
        }
export type FetchGroupByCustomerQueryHookResult = ReturnType<typeof useFetchGroupByCustomerQuery>;
export type FetchGroupByCustomerLazyQueryHookResult = ReturnType<typeof useFetchGroupByCustomerLazyQuery>;
export type FetchGroupByCustomerQueryResult = Apollo.QueryResult<FetchGroupByCustomerQuery, FetchGroupByCustomerQueryVariables>;
export const FetchGroupByShipToDocument = gql`
    query FetchGroupByShipTo($perPage: Int, $offSet: Int, $filter: DynamicFiltersInput) {
  tmFilteredCustomerBranches(limit: $perPage, offset: $offSet, filter: $filter) {
    groupedCustomerBranch {
      customerBranches {
        id
        name
        customer {
          name
        }
      }
      tankMonitorMetadata
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFetchGroupByShipToQuery__
 *
 * To run a query within a React component, call `useFetchGroupByShipToQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchGroupByShipToQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchGroupByShipToQuery({
 *   variables: {
 *      perPage: // value for 'perPage'
 *      offSet: // value for 'offSet'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchGroupByShipToQuery(baseOptions?: Apollo.QueryHookOptions<FetchGroupByShipToQuery, FetchGroupByShipToQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchGroupByShipToQuery, FetchGroupByShipToQueryVariables>(FetchGroupByShipToDocument, options);
      }
export function useFetchGroupByShipToLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchGroupByShipToQuery, FetchGroupByShipToQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchGroupByShipToQuery, FetchGroupByShipToQueryVariables>(FetchGroupByShipToDocument, options);
        }
export type FetchGroupByShipToQueryHookResult = ReturnType<typeof useFetchGroupByShipToQuery>;
export type FetchGroupByShipToLazyQueryHookResult = ReturnType<typeof useFetchGroupByShipToLazyQuery>;
export type FetchGroupByShipToQueryResult = Apollo.QueryResult<FetchGroupByShipToQuery, FetchGroupByShipToQueryVariables>;
export const FetchGroupByStatusDocument = gql`
    query FetchGroupByStatus($filter: DynamicFiltersInput) {
  tmFilteredOrderGroups(filter: $filter) {
    groupedOrder {
      orderGroupStatus
      metadata
    }
    metadata {
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFetchGroupByStatusQuery__
 *
 * To run a query within a React component, call `useFetchGroupByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchGroupByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchGroupByStatusQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchGroupByStatusQuery(baseOptions?: Apollo.QueryHookOptions<FetchGroupByStatusQuery, FetchGroupByStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchGroupByStatusQuery, FetchGroupByStatusQueryVariables>(FetchGroupByStatusDocument, options);
      }
export function useFetchGroupByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchGroupByStatusQuery, FetchGroupByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchGroupByStatusQuery, FetchGroupByStatusQueryVariables>(FetchGroupByStatusDocument, options);
        }
export type FetchGroupByStatusQueryHookResult = ReturnType<typeof useFetchGroupByStatusQuery>;
export type FetchGroupByStatusLazyQueryHookResult = ReturnType<typeof useFetchGroupByStatusLazyQuery>;
export type FetchGroupByStatusQueryResult = Apollo.QueryResult<FetchGroupByStatusQuery, FetchGroupByStatusQueryVariables>;
export const TmCreateMultiOrderTopOffDocument = gql`
    mutation TmCreateMultiOrderTopOff($deviceIds: [ID!]!, $isSelectAll: Boolean) {
  tmCreateMultiOrderTopOff(deviceIds: $deviceIds, isSelectAll: $isSelectAll) {
    success
    errors
  }
}
    `;
export type TmCreateMultiOrderTopOffMutationFn = Apollo.MutationFunction<TmCreateMultiOrderTopOffMutation, TmCreateMultiOrderTopOffMutationVariables>;

/**
 * __useTmCreateMultiOrderTopOffMutation__
 *
 * To run a mutation, you first call `useTmCreateMultiOrderTopOffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTmCreateMultiOrderTopOffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tmCreateMultiOrderTopOffMutation, { data, loading, error }] = useTmCreateMultiOrderTopOffMutation({
 *   variables: {
 *      deviceIds: // value for 'deviceIds'
 *      isSelectAll: // value for 'isSelectAll'
 *   },
 * });
 */
export function useTmCreateMultiOrderTopOffMutation(baseOptions?: Apollo.MutationHookOptions<TmCreateMultiOrderTopOffMutation, TmCreateMultiOrderTopOffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TmCreateMultiOrderTopOffMutation, TmCreateMultiOrderTopOffMutationVariables>(TmCreateMultiOrderTopOffDocument, options);
      }
export type TmCreateMultiOrderTopOffMutationHookResult = ReturnType<typeof useTmCreateMultiOrderTopOffMutation>;
export type TmCreateMultiOrderTopOffMutationResult = Apollo.MutationResult<TmCreateMultiOrderTopOffMutation>;
export type TmCreateMultiOrderTopOffMutationOptions = Apollo.BaseMutationOptions<TmCreateMultiOrderTopOffMutation, TmCreateMultiOrderTopOffMutationVariables>;
export const FetchAssetDetailsForTankMonitorDocument = gql`
    query FetchAssetDetailsForTankMonitor($id: ID!) {
  asset(id: $id) {
    id
    tankSize
    name
    customer {
      id
      name
      erpId
    }
    customerBranch {
      id
      name
    }
    subscriptions {
      id
      product {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useFetchAssetDetailsForTankMonitorQuery__
 *
 * To run a query within a React component, call `useFetchAssetDetailsForTankMonitorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAssetDetailsForTankMonitorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAssetDetailsForTankMonitorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchAssetDetailsForTankMonitorQuery(baseOptions: Apollo.QueryHookOptions<FetchAssetDetailsForTankMonitorQuery, FetchAssetDetailsForTankMonitorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAssetDetailsForTankMonitorQuery, FetchAssetDetailsForTankMonitorQueryVariables>(FetchAssetDetailsForTankMonitorDocument, options);
      }
export function useFetchAssetDetailsForTankMonitorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAssetDetailsForTankMonitorQuery, FetchAssetDetailsForTankMonitorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAssetDetailsForTankMonitorQuery, FetchAssetDetailsForTankMonitorQueryVariables>(FetchAssetDetailsForTankMonitorDocument, options);
        }
export type FetchAssetDetailsForTankMonitorQueryHookResult = ReturnType<typeof useFetchAssetDetailsForTankMonitorQuery>;
export type FetchAssetDetailsForTankMonitorLazyQueryHookResult = ReturnType<typeof useFetchAssetDetailsForTankMonitorLazyQuery>;
export type FetchAssetDetailsForTankMonitorQueryResult = Apollo.QueryResult<FetchAssetDetailsForTankMonitorQuery, FetchAssetDetailsForTankMonitorQueryVariables>;
export const FetchTankMonitorCustomerBranchByIdDocument = gql`
    query FetchTankMonitorCustomerBranchById($id: ID!) {
  customerBranch(id: $id) {
    id
    hubs {
      id
      name
      address
    }
    poNumber
    purchaseOrderType
  }
}
    `;

/**
 * __useFetchTankMonitorCustomerBranchByIdQuery__
 *
 * To run a query within a React component, call `useFetchTankMonitorCustomerBranchByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTankMonitorCustomerBranchByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTankMonitorCustomerBranchByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchTankMonitorCustomerBranchByIdQuery(baseOptions: Apollo.QueryHookOptions<FetchTankMonitorCustomerBranchByIdQuery, FetchTankMonitorCustomerBranchByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTankMonitorCustomerBranchByIdQuery, FetchTankMonitorCustomerBranchByIdQueryVariables>(FetchTankMonitorCustomerBranchByIdDocument, options);
      }
export function useFetchTankMonitorCustomerBranchByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTankMonitorCustomerBranchByIdQuery, FetchTankMonitorCustomerBranchByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTankMonitorCustomerBranchByIdQuery, FetchTankMonitorCustomerBranchByIdQueryVariables>(FetchTankMonitorCustomerBranchByIdDocument, options);
        }
export type FetchTankMonitorCustomerBranchByIdQueryHookResult = ReturnType<typeof useFetchTankMonitorCustomerBranchByIdQuery>;
export type FetchTankMonitorCustomerBranchByIdLazyQueryHookResult = ReturnType<typeof useFetchTankMonitorCustomerBranchByIdLazyQuery>;
export type FetchTankMonitorCustomerBranchByIdQueryResult = Apollo.QueryResult<FetchTankMonitorCustomerBranchByIdQuery, FetchTankMonitorCustomerBranchByIdQueryVariables>;
export const FetchFilteredApplicableFeesForTankMonitorDocument = gql`
    query FetchFilteredApplicableFeesForTankMonitor($filter: ApplicableFeeFilter) {
  filteredApplicableFees(filter: $filter) {
    collection {
      fee {
        id
        code
        name
        price
        deleted
        applicableType
      }
      id
      isDefault
      price
      quantity
    }
  }
}
    `;

/**
 * __useFetchFilteredApplicableFeesForTankMonitorQuery__
 *
 * To run a query within a React component, call `useFetchFilteredApplicableFeesForTankMonitorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredApplicableFeesForTankMonitorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredApplicableFeesForTankMonitorQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchFilteredApplicableFeesForTankMonitorQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredApplicableFeesForTankMonitorQuery, FetchFilteredApplicableFeesForTankMonitorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredApplicableFeesForTankMonitorQuery, FetchFilteredApplicableFeesForTankMonitorQueryVariables>(FetchFilteredApplicableFeesForTankMonitorDocument, options);
      }
export function useFetchFilteredApplicableFeesForTankMonitorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredApplicableFeesForTankMonitorQuery, FetchFilteredApplicableFeesForTankMonitorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredApplicableFeesForTankMonitorQuery, FetchFilteredApplicableFeesForTankMonitorQueryVariables>(FetchFilteredApplicableFeesForTankMonitorDocument, options);
        }
export type FetchFilteredApplicableFeesForTankMonitorQueryHookResult = ReturnType<typeof useFetchFilteredApplicableFeesForTankMonitorQuery>;
export type FetchFilteredApplicableFeesForTankMonitorLazyQueryHookResult = ReturnType<typeof useFetchFilteredApplicableFeesForTankMonitorLazyQuery>;
export type FetchFilteredApplicableFeesForTankMonitorQueryResult = Apollo.QueryResult<FetchFilteredApplicableFeesForTankMonitorQuery, FetchFilteredApplicableFeesForTankMonitorQueryVariables>;
export const FetchOrderHistoryDocument = gql`
    query fetchOrderHistory($perPage: Int, $offSet: Int, $filter: DoliHistoryFilterInput, $sorter: [DeliveryOrderLineItemsSorter!]) {
  filteredDeliveryOrderLineItems(
    limit: $perPage
    offset: $offSet
    filter: $filter
    sorter: $sorter
  ) {
    collection {
      id
      product {
        shortName
      }
      asset {
        name
      }
      source
      volume
      deliveryOrder {
        id
        customerBranch {
          name
          customer {
            name
          }
        }
        orderGroupId
        orderGroup {
          id
          startOn
          status
          createdAtTimestamp
          completedOnTimestamp
        }
      }
      deliveryDateTimestamp
    }
    metadata {
      hasMore
      totalCount
    }
  }
}
    `;

/**
 * __useFetchOrderHistoryQuery__
 *
 * To run a query within a React component, call `useFetchOrderHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOrderHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOrderHistoryQuery({
 *   variables: {
 *      perPage: // value for 'perPage'
 *      offSet: // value for 'offSet'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchOrderHistoryQuery(baseOptions?: Apollo.QueryHookOptions<FetchOrderHistoryQuery, FetchOrderHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchOrderHistoryQuery, FetchOrderHistoryQueryVariables>(FetchOrderHistoryDocument, options);
      }
export function useFetchOrderHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchOrderHistoryQuery, FetchOrderHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchOrderHistoryQuery, FetchOrderHistoryQueryVariables>(FetchOrderHistoryDocument, options);
        }
export type FetchOrderHistoryQueryHookResult = ReturnType<typeof useFetchOrderHistoryQuery>;
export type FetchOrderHistoryLazyQueryHookResult = ReturnType<typeof useFetchOrderHistoryLazyQuery>;
export type FetchOrderHistoryQueryResult = Apollo.QueryResult<FetchOrderHistoryQuery, FetchOrderHistoryQueryVariables>;
export const FetchSelectedGroupByDataDocument = gql`
    query fetchSelectedGroupByData($perPage: Int, $offSet: Int, $filter: DeviceFilterInput, $sorter: [TankMonitorSorter!]) {
  filteredTankMonitors(
    limit: $perPage
    offset: $offSet
    filter: $filter
    sorter: $sorter
  ) {
    collection {
      id
      name
      deviceId
      deviceProvider
      tankCapacity
      reading
      attachedAsset
      consumptionSummary
      customer {
        id
        name
        hubs {
          name
        }
      }
      customerBranch {
        id
        name
        hubs {
          name
        }
      }
      asset {
        id
        name
        tmLastDeliveredTimestamp
        tmLastDeliveredVolume
        lineOfServices {
          name
        }
        subscriptions {
          product {
            name
          }
        }
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFetchSelectedGroupByDataQuery__
 *
 * To run a query within a React component, call `useFetchSelectedGroupByDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSelectedGroupByDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSelectedGroupByDataQuery({
 *   variables: {
 *      perPage: // value for 'perPage'
 *      offSet: // value for 'offSet'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchSelectedGroupByDataQuery(baseOptions?: Apollo.QueryHookOptions<FetchSelectedGroupByDataQuery, FetchSelectedGroupByDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSelectedGroupByDataQuery, FetchSelectedGroupByDataQueryVariables>(FetchSelectedGroupByDataDocument, options);
      }
export function useFetchSelectedGroupByDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSelectedGroupByDataQuery, FetchSelectedGroupByDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSelectedGroupByDataQuery, FetchSelectedGroupByDataQueryVariables>(FetchSelectedGroupByDataDocument, options);
        }
export type FetchSelectedGroupByDataQueryHookResult = ReturnType<typeof useFetchSelectedGroupByDataQuery>;
export type FetchSelectedGroupByDataLazyQueryHookResult = ReturnType<typeof useFetchSelectedGroupByDataLazyQuery>;
export type FetchSelectedGroupByDataQueryResult = Apollo.QueryResult<FetchSelectedGroupByDataQuery, FetchSelectedGroupByDataQueryVariables>;
export const FetchTankMonitorTotalCountDocument = gql`
    query fetchTankMonitorTotalCount($filter: DeviceFilterInput) {
  devicesSummary(filter: $filter)
}
    `;

/**
 * __useFetchTankMonitorTotalCountQuery__
 *
 * To run a query within a React component, call `useFetchTankMonitorTotalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTankMonitorTotalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTankMonitorTotalCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchTankMonitorTotalCountQuery(baseOptions?: Apollo.QueryHookOptions<FetchTankMonitorTotalCountQuery, FetchTankMonitorTotalCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTankMonitorTotalCountQuery, FetchTankMonitorTotalCountQueryVariables>(FetchTankMonitorTotalCountDocument, options);
      }
export function useFetchTankMonitorTotalCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTankMonitorTotalCountQuery, FetchTankMonitorTotalCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTankMonitorTotalCountQuery, FetchTankMonitorTotalCountQueryVariables>(FetchTankMonitorTotalCountDocument, options);
        }
export type FetchTankMonitorTotalCountQueryHookResult = ReturnType<typeof useFetchTankMonitorTotalCountQuery>;
export type FetchTankMonitorTotalCountLazyQueryHookResult = ReturnType<typeof useFetchTankMonitorTotalCountLazyQuery>;
export type FetchTankMonitorTotalCountQueryResult = Apollo.QueryResult<FetchTankMonitorTotalCountQuery, FetchTankMonitorTotalCountQueryVariables>;
export const FetchUnlinkedAssetsDocument = gql`
    query fetchUnlinkedAssets($limit: Int, $offset: Int, $sorter: [AssetSorter!], $customerIds: [ID!], $customerBranchId: [ID!], $filter: String, $statuses: [String!], $types: [AssetTypeEnum!], $unlinked: Boolean) {
  filteredAssets(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {customerIds: $customerIds, customerBranchId: $customerBranchId, all: $filter, types: $types, statuses: $statuses, unlinked: $unlinked}
  ) {
    collection {
      id
      name
      erpId
      status
      customerBranch {
        id
        name
        customer {
          id
          name
          __typename
        }
        __typename
      }
      subscriptions {
        id
        product {
          id
          name
          __typename
        }
        __typename
      }
      __typename
    }
    metadata {
      hasMore
      totalCount
      total_entries
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useFetchUnlinkedAssetsQuery__
 *
 * To run a query within a React component, call `useFetchUnlinkedAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUnlinkedAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUnlinkedAssetsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      customerIds: // value for 'customerIds'
 *      customerBranchId: // value for 'customerBranchId'
 *      filter: // value for 'filter'
 *      statuses: // value for 'statuses'
 *      types: // value for 'types'
 *      unlinked: // value for 'unlinked'
 *   },
 * });
 */
export function useFetchUnlinkedAssetsQuery(baseOptions?: Apollo.QueryHookOptions<FetchUnlinkedAssetsQuery, FetchUnlinkedAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUnlinkedAssetsQuery, FetchUnlinkedAssetsQueryVariables>(FetchUnlinkedAssetsDocument, options);
      }
export function useFetchUnlinkedAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUnlinkedAssetsQuery, FetchUnlinkedAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUnlinkedAssetsQuery, FetchUnlinkedAssetsQueryVariables>(FetchUnlinkedAssetsDocument, options);
        }
export type FetchUnlinkedAssetsQueryHookResult = ReturnType<typeof useFetchUnlinkedAssetsQuery>;
export type FetchUnlinkedAssetsLazyQueryHookResult = ReturnType<typeof useFetchUnlinkedAssetsLazyQuery>;
export type FetchUnlinkedAssetsQueryResult = Apollo.QueryResult<FetchUnlinkedAssetsQuery, FetchUnlinkedAssetsQueryVariables>;
export const GetDeliveryOrderLineItemCsvForTmDocument = gql`
    query getDeliveryOrderLineItemCsvForTm($customerBranchId: ID, $assetId: ID, $startDate: ISO8601Date, $endDate: ISO8601Date, $status: [StatusTypeEnum!], $isTankMonitor: Boolean, $deliveryType: DeliveryOrderLineItemDeliveryTypeEnum) {
  deliveryOrderLineItemCsv(
    customerBranchId: $customerBranchId
    assetId: $assetId
    startDate: $startDate
    endDate: $endDate
    status: $status
    isTankMonitor: $isTankMonitor
    deliveryType: $deliveryType
  ) {
    fileName
    content
    error
  }
}
    `;

/**
 * __useGetDeliveryOrderLineItemCsvForTmQuery__
 *
 * To run a query within a React component, call `useGetDeliveryOrderLineItemCsvForTmQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryOrderLineItemCsvForTmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryOrderLineItemCsvForTmQuery({
 *   variables: {
 *      customerBranchId: // value for 'customerBranchId'
 *      assetId: // value for 'assetId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      status: // value for 'status'
 *      isTankMonitor: // value for 'isTankMonitor'
 *      deliveryType: // value for 'deliveryType'
 *   },
 * });
 */
export function useGetDeliveryOrderLineItemCsvForTmQuery(baseOptions?: Apollo.QueryHookOptions<GetDeliveryOrderLineItemCsvForTmQuery, GetDeliveryOrderLineItemCsvForTmQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliveryOrderLineItemCsvForTmQuery, GetDeliveryOrderLineItemCsvForTmQueryVariables>(GetDeliveryOrderLineItemCsvForTmDocument, options);
      }
export function useGetDeliveryOrderLineItemCsvForTmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliveryOrderLineItemCsvForTmQuery, GetDeliveryOrderLineItemCsvForTmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliveryOrderLineItemCsvForTmQuery, GetDeliveryOrderLineItemCsvForTmQueryVariables>(GetDeliveryOrderLineItemCsvForTmDocument, options);
        }
export type GetDeliveryOrderLineItemCsvForTmQueryHookResult = ReturnType<typeof useGetDeliveryOrderLineItemCsvForTmQuery>;
export type GetDeliveryOrderLineItemCsvForTmLazyQueryHookResult = ReturnType<typeof useGetDeliveryOrderLineItemCsvForTmLazyQuery>;
export type GetDeliveryOrderLineItemCsvForTmQueryResult = Apollo.QueryResult<GetDeliveryOrderLineItemCsvForTmQuery, GetDeliveryOrderLineItemCsvForTmQueryVariables>;
export const LinkAssetToTankMonitorDocument = gql`
    mutation LinkAssetToTankMonitor($input: [CreateAttachedAssetsInput!]!) {
  createAttachedAsset(input: {data: $input}) {
    attachedAsset {
      id
      assetId
      draftAssetId
      status
      consumptionCalculationDays
      autoOrder
      minThreshold
      maxThreshold
      orderFillPercentage
      orderConfirmation
      purchaseOrder
      asset {
        id
        subscriptions {
          product {
            name
          }
        }
      }
      customerBranch {
        name
        address
      }
      customer {
        name
      }
    }
  }
}
    `;
export type LinkAssetToTankMonitorMutationFn = Apollo.MutationFunction<LinkAssetToTankMonitorMutation, LinkAssetToTankMonitorMutationVariables>;

/**
 * __useLinkAssetToTankMonitorMutation__
 *
 * To run a mutation, you first call `useLinkAssetToTankMonitorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkAssetToTankMonitorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkAssetToTankMonitorMutation, { data, loading, error }] = useLinkAssetToTankMonitorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkAssetToTankMonitorMutation(baseOptions?: Apollo.MutationHookOptions<LinkAssetToTankMonitorMutation, LinkAssetToTankMonitorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkAssetToTankMonitorMutation, LinkAssetToTankMonitorMutationVariables>(LinkAssetToTankMonitorDocument, options);
      }
export type LinkAssetToTankMonitorMutationHookResult = ReturnType<typeof useLinkAssetToTankMonitorMutation>;
export type LinkAssetToTankMonitorMutationResult = Apollo.MutationResult<LinkAssetToTankMonitorMutation>;
export type LinkAssetToTankMonitorMutationOptions = Apollo.BaseMutationOptions<LinkAssetToTankMonitorMutation, LinkAssetToTankMonitorMutationVariables>;
export const UpdateLinkAssetToTmDocument = gql`
    mutation UpdateLinkAssetToTm($input: UpdateAttachedAssetInput!) {
  updateAttachedAssets(input: $input) {
    attachedAsset {
      id
      assetId
      draftAssetId
      status
      consumptionCalculationDays
      autoOrder
      minThreshold
      maxThreshold
      orderConfirmation
      orderFillPercentage
      purchaseOrder
      asset {
        id
        subscriptions {
          product {
            name
          }
        }
      }
      customerBranch {
        name
        address
      }
      customer {
        name
      }
    }
  }
}
    `;
export type UpdateLinkAssetToTmMutationFn = Apollo.MutationFunction<UpdateLinkAssetToTmMutation, UpdateLinkAssetToTmMutationVariables>;

/**
 * __useUpdateLinkAssetToTmMutation__
 *
 * To run a mutation, you first call `useUpdateLinkAssetToTmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLinkAssetToTmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLinkAssetToTmMutation, { data, loading, error }] = useUpdateLinkAssetToTmMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLinkAssetToTmMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLinkAssetToTmMutation, UpdateLinkAssetToTmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLinkAssetToTmMutation, UpdateLinkAssetToTmMutationVariables>(UpdateLinkAssetToTmDocument, options);
      }
export type UpdateLinkAssetToTmMutationHookResult = ReturnType<typeof useUpdateLinkAssetToTmMutation>;
export type UpdateLinkAssetToTmMutationResult = Apollo.MutationResult<UpdateLinkAssetToTmMutation>;
export type UpdateLinkAssetToTmMutationOptions = Apollo.BaseMutationOptions<UpdateLinkAssetToTmMutation, UpdateLinkAssetToTmMutationVariables>;
export const FilteredTankMonitorDevicesDocument = gql`
    query FilteredTankMonitorDevices($perPage: Int, $offSet: Int, $filter: DeviceFilterInput, $sorter: [TankMonitorSorter!]) {
  filteredTankMonitors(
    limit: $perPage
    offset: $offSet
    filter: $filter
    sorter: $sorter
  ) {
    collection {
      id
      name
      deviceId
      deviceProvider
      tankCapacity
      reading
      attachedAsset
      consumptionSummary
    }
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useFilteredTankMonitorDevicesQuery__
 *
 * To run a query within a React component, call `useFilteredTankMonitorDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredTankMonitorDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredTankMonitorDevicesQuery({
 *   variables: {
 *      perPage: // value for 'perPage'
 *      offSet: // value for 'offSet'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilteredTankMonitorDevicesQuery(baseOptions?: Apollo.QueryHookOptions<FilteredTankMonitorDevicesQuery, FilteredTankMonitorDevicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredTankMonitorDevicesQuery, FilteredTankMonitorDevicesQueryVariables>(FilteredTankMonitorDevicesDocument, options);
      }
export function useFilteredTankMonitorDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredTankMonitorDevicesQuery, FilteredTankMonitorDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredTankMonitorDevicesQuery, FilteredTankMonitorDevicesQueryVariables>(FilteredTankMonitorDevicesDocument, options);
        }
export type FilteredTankMonitorDevicesQueryHookResult = ReturnType<typeof useFilteredTankMonitorDevicesQuery>;
export type FilteredTankMonitorDevicesLazyQueryHookResult = ReturnType<typeof useFilteredTankMonitorDevicesLazyQuery>;
export type FilteredTankMonitorDevicesQueryResult = Apollo.QueryResult<FilteredTankMonitorDevicesQuery, FilteredTankMonitorDevicesQueryVariables>;
export const FetchDevicesSummaryDocument = gql`
    query FetchDevicesSummary($filter: DeviceFilterInput) {
  devicesSummary(filter: $filter)
}
    `;

/**
 * __useFetchDevicesSummaryQuery__
 *
 * To run a query within a React component, call `useFetchDevicesSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDevicesSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDevicesSummaryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchDevicesSummaryQuery(baseOptions?: Apollo.QueryHookOptions<FetchDevicesSummaryQuery, FetchDevicesSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDevicesSummaryQuery, FetchDevicesSummaryQueryVariables>(FetchDevicesSummaryDocument, options);
      }
export function useFetchDevicesSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDevicesSummaryQuery, FetchDevicesSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDevicesSummaryQuery, FetchDevicesSummaryQueryVariables>(FetchDevicesSummaryDocument, options);
        }
export type FetchDevicesSummaryQueryHookResult = ReturnType<typeof useFetchDevicesSummaryQuery>;
export type FetchDevicesSummaryLazyQueryHookResult = ReturnType<typeof useFetchDevicesSummaryLazyQuery>;
export type FetchDevicesSummaryQueryResult = Apollo.QueryResult<FetchDevicesSummaryQuery, FetchDevicesSummaryQueryVariables>;
export const FetchFilteredAssetListForDropDownDocument = gql`
    query FetchFilteredAssetListForDropDown($limit: Int, $offset: Int, $sorter: [AssetSorter!], $customerIds: [ID!], $customerBranchId: [ID!], $filter: String, $statuses: [String!], $types: [AssetTypeEnum!]) {
  filteredAssets(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {customerIds: $customerIds, customerBranchId: $customerBranchId, all: $filter, types: $types, statuses: $statuses}
  ) {
    collection {
      id
      name
      erpId
      status
      customerBranch {
        id
        name
        customer {
          id
          name
        }
      }
      subscriptions {
        id
        product {
          id
          name
        }
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFetchFilteredAssetListForDropDownQuery__
 *
 * To run a query within a React component, call `useFetchFilteredAssetListForDropDownQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredAssetListForDropDownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredAssetListForDropDownQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      customerIds: // value for 'customerIds'
 *      customerBranchId: // value for 'customerBranchId'
 *      filter: // value for 'filter'
 *      statuses: // value for 'statuses'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useFetchFilteredAssetListForDropDownQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredAssetListForDropDownQuery, FetchFilteredAssetListForDropDownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredAssetListForDropDownQuery, FetchFilteredAssetListForDropDownQueryVariables>(FetchFilteredAssetListForDropDownDocument, options);
      }
export function useFetchFilteredAssetListForDropDownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredAssetListForDropDownQuery, FetchFilteredAssetListForDropDownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredAssetListForDropDownQuery, FetchFilteredAssetListForDropDownQueryVariables>(FetchFilteredAssetListForDropDownDocument, options);
        }
export type FetchFilteredAssetListForDropDownQueryHookResult = ReturnType<typeof useFetchFilteredAssetListForDropDownQuery>;
export type FetchFilteredAssetListForDropDownLazyQueryHookResult = ReturnType<typeof useFetchFilteredAssetListForDropDownLazyQuery>;
export type FetchFilteredAssetListForDropDownQueryResult = Apollo.QueryResult<FetchFilteredAssetListForDropDownQuery, FetchFilteredAssetListForDropDownQueryVariables>;
export const FetchOrderGroupDocument = gql`
    query fetchOrderGroup($id: ID!) {
  orderGroup(id: $id) {
    id
    deliveryOrder {
      id
    }
  }
}
    `;

/**
 * __useFetchOrderGroupQuery__
 *
 * To run a query within a React component, call `useFetchOrderGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOrderGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOrderGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchOrderGroupQuery(baseOptions: Apollo.QueryHookOptions<FetchOrderGroupQuery, FetchOrderGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchOrderGroupQuery, FetchOrderGroupQueryVariables>(FetchOrderGroupDocument, options);
      }
export function useFetchOrderGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchOrderGroupQuery, FetchOrderGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchOrderGroupQuery, FetchOrderGroupQueryVariables>(FetchOrderGroupDocument, options);
        }
export type FetchOrderGroupQueryHookResult = ReturnType<typeof useFetchOrderGroupQuery>;
export type FetchOrderGroupLazyQueryHookResult = ReturnType<typeof useFetchOrderGroupLazyQuery>;
export type FetchOrderGroupQueryResult = Apollo.QueryResult<FetchOrderGroupQuery, FetchOrderGroupQueryVariables>;
export const FetchResourceByIdsDocument = gql`
    query FetchResourceByIds($ids: [ID!]!, $resource: ResourceFetchEnum!) {
  fetchResourceByIds(ids: $ids, resource: $resource) {
    __typename
    ... on Asset {
      id
      name
      type
      category
      lastDeliveredTimestamp
      lastDeliveredVolume
      licensePlateNumber
      customer {
        id
        erpId
        name
        purchaseOrder
        address
        addressBooks {
          id
          name
        }
        hubs {
          id
          name
        }
      }
      customerBranch {
        id
        name
        address
        purchaseOrder
        hubs {
          id
          name
        }
      }
      subscriptions {
        product {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useFetchResourceByIdsQuery__
 *
 * To run a query within a React component, call `useFetchResourceByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchResourceByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchResourceByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      resource: // value for 'resource'
 *   },
 * });
 */
export function useFetchResourceByIdsQuery(baseOptions: Apollo.QueryHookOptions<FetchResourceByIdsQuery, FetchResourceByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchResourceByIdsQuery, FetchResourceByIdsQueryVariables>(FetchResourceByIdsDocument, options);
      }
export function useFetchResourceByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchResourceByIdsQuery, FetchResourceByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchResourceByIdsQuery, FetchResourceByIdsQueryVariables>(FetchResourceByIdsDocument, options);
        }
export type FetchResourceByIdsQueryHookResult = ReturnType<typeof useFetchResourceByIdsQuery>;
export type FetchResourceByIdsLazyQueryHookResult = ReturnType<typeof useFetchResourceByIdsLazyQuery>;
export type FetchResourceByIdsQueryResult = Apollo.QueryResult<FetchResourceByIdsQuery, FetchResourceByIdsQueryVariables>;
export const FetchSyncAllStatusDocument = gql`
    query FetchSyncAllStatus {
  syncAllStatus
}
    `;

/**
 * __useFetchSyncAllStatusQuery__
 *
 * To run a query within a React component, call `useFetchSyncAllStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSyncAllStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSyncAllStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchSyncAllStatusQuery(baseOptions?: Apollo.QueryHookOptions<FetchSyncAllStatusQuery, FetchSyncAllStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSyncAllStatusQuery, FetchSyncAllStatusQueryVariables>(FetchSyncAllStatusDocument, options);
      }
export function useFetchSyncAllStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSyncAllStatusQuery, FetchSyncAllStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSyncAllStatusQuery, FetchSyncAllStatusQueryVariables>(FetchSyncAllStatusDocument, options);
        }
export type FetchSyncAllStatusQueryHookResult = ReturnType<typeof useFetchSyncAllStatusQuery>;
export type FetchSyncAllStatusLazyQueryHookResult = ReturnType<typeof useFetchSyncAllStatusLazyQuery>;
export type FetchSyncAllStatusQueryResult = Apollo.QueryResult<FetchSyncAllStatusQuery, FetchSyncAllStatusQueryVariables>;
export const SyncAllTanksDocument = gql`
    mutation SyncAllTanks($input: SyncAllInput!) {
  syncAllTanks(input: $input) {
    response
  }
}
    `;
export type SyncAllTanksMutationFn = Apollo.MutationFunction<SyncAllTanksMutation, SyncAllTanksMutationVariables>;

/**
 * __useSyncAllTanksMutation__
 *
 * To run a mutation, you first call `useSyncAllTanksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncAllTanksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncAllTanksMutation, { data, loading, error }] = useSyncAllTanksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncAllTanksMutation(baseOptions?: Apollo.MutationHookOptions<SyncAllTanksMutation, SyncAllTanksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncAllTanksMutation, SyncAllTanksMutationVariables>(SyncAllTanksDocument, options);
      }
export type SyncAllTanksMutationHookResult = ReturnType<typeof useSyncAllTanksMutation>;
export type SyncAllTanksMutationResult = Apollo.MutationResult<SyncAllTanksMutation>;
export type SyncAllTanksMutationOptions = Apollo.BaseMutationOptions<SyncAllTanksMutation, SyncAllTanksMutationVariables>;
export const CreateAttachedAssetDocument = gql`
    mutation CreateAttachedAsset($input: [CreateAttachedAssetsInput!]!) {
  createAttachedAsset(input: {data: $input}) {
    attachedAsset {
      id
      assetId
    }
  }
}
    `;
export type CreateAttachedAssetMutationFn = Apollo.MutationFunction<CreateAttachedAssetMutation, CreateAttachedAssetMutationVariables>;

/**
 * __useCreateAttachedAssetMutation__
 *
 * To run a mutation, you first call `useCreateAttachedAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttachedAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttachedAssetMutation, { data, loading, error }] = useCreateAttachedAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAttachedAssetMutation(baseOptions?: Apollo.MutationHookOptions<CreateAttachedAssetMutation, CreateAttachedAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAttachedAssetMutation, CreateAttachedAssetMutationVariables>(CreateAttachedAssetDocument, options);
      }
export type CreateAttachedAssetMutationHookResult = ReturnType<typeof useCreateAttachedAssetMutation>;
export type CreateAttachedAssetMutationResult = Apollo.MutationResult<CreateAttachedAssetMutation>;
export type CreateAttachedAssetMutationOptions = Apollo.BaseMutationOptions<CreateAttachedAssetMutation, CreateAttachedAssetMutationVariables>;
export const TankMonitorDetachAttachedAssetDocument = gql`
    mutation TankMonitorDetachAttachedAsset($input: DetachAssetInput!) {
  detachAttachedAsset(input: $input) {
    attachedAsset {
      id
      assetId
    }
  }
}
    `;
export type TankMonitorDetachAttachedAssetMutationFn = Apollo.MutationFunction<TankMonitorDetachAttachedAssetMutation, TankMonitorDetachAttachedAssetMutationVariables>;

/**
 * __useTankMonitorDetachAttachedAssetMutation__
 *
 * To run a mutation, you first call `useTankMonitorDetachAttachedAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTankMonitorDetachAttachedAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tankMonitorDetachAttachedAssetMutation, { data, loading, error }] = useTankMonitorDetachAttachedAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTankMonitorDetachAttachedAssetMutation(baseOptions?: Apollo.MutationHookOptions<TankMonitorDetachAttachedAssetMutation, TankMonitorDetachAttachedAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TankMonitorDetachAttachedAssetMutation, TankMonitorDetachAttachedAssetMutationVariables>(TankMonitorDetachAttachedAssetDocument, options);
      }
export type TankMonitorDetachAttachedAssetMutationHookResult = ReturnType<typeof useTankMonitorDetachAttachedAssetMutation>;
export type TankMonitorDetachAttachedAssetMutationResult = Apollo.MutationResult<TankMonitorDetachAttachedAssetMutation>;
export type TankMonitorDetachAttachedAssetMutationOptions = Apollo.BaseMutationOptions<TankMonitorDetachAttachedAssetMutation, TankMonitorDetachAttachedAssetMutationVariables>;
export const SyncIndividualTankDocument = gql`
    mutation SyncIndividualTank($input: SyncIndividualTankInput!) {
  syncIndividualTank(input: $input) {
    response
  }
}
    `;
export type SyncIndividualTankMutationFn = Apollo.MutationFunction<SyncIndividualTankMutation, SyncIndividualTankMutationVariables>;

/**
 * __useSyncIndividualTankMutation__
 *
 * To run a mutation, you first call `useSyncIndividualTankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncIndividualTankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncIndividualTankMutation, { data, loading, error }] = useSyncIndividualTankMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncIndividualTankMutation(baseOptions?: Apollo.MutationHookOptions<SyncIndividualTankMutation, SyncIndividualTankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncIndividualTankMutation, SyncIndividualTankMutationVariables>(SyncIndividualTankDocument, options);
      }
export type SyncIndividualTankMutationHookResult = ReturnType<typeof useSyncIndividualTankMutation>;
export type SyncIndividualTankMutationResult = Apollo.MutationResult<SyncIndividualTankMutation>;
export type SyncIndividualTankMutationOptions = Apollo.BaseMutationOptions<SyncIndividualTankMutation, SyncIndividualTankMutationVariables>;
export const UpdateAttachedAssetDocument = gql`
    mutation UpdateAttachedAsset($input: UpdateAttachedAssetsInput!) {
  updateAttachedAssets(input: {data: $input}) {
    attachedAsset {
      id
      minThreshold
      assetId
    }
  }
}
    `;
export type UpdateAttachedAssetMutationFn = Apollo.MutationFunction<UpdateAttachedAssetMutation, UpdateAttachedAssetMutationVariables>;

/**
 * __useUpdateAttachedAssetMutation__
 *
 * To run a mutation, you first call `useUpdateAttachedAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttachedAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAttachedAssetMutation, { data, loading, error }] = useUpdateAttachedAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAttachedAssetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAttachedAssetMutation, UpdateAttachedAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAttachedAssetMutation, UpdateAttachedAssetMutationVariables>(UpdateAttachedAssetDocument, options);
      }
export type UpdateAttachedAssetMutationHookResult = ReturnType<typeof useUpdateAttachedAssetMutation>;
export type UpdateAttachedAssetMutationResult = Apollo.MutationResult<UpdateAttachedAssetMutation>;
export type UpdateAttachedAssetMutationOptions = Apollo.BaseMutationOptions<UpdateAttachedAssetMutation, UpdateAttachedAssetMutationVariables>;
export const FetchPreshiftChecklistsDocument = gql`
    query FetchPreshiftChecklists($shiftId: ID) {
  preshiftChecklists(shiftId: $shiftId) {
    id
    name
    position
    checkedCount
    totalItemsCount
    items {
      id
      name
      checked
      position
    }
  }
}
    `;

/**
 * __useFetchPreshiftChecklistsQuery__
 *
 * To run a query within a React component, call `useFetchPreshiftChecklistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPreshiftChecklistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPreshiftChecklistsQuery({
 *   variables: {
 *      shiftId: // value for 'shiftId'
 *   },
 * });
 */
export function useFetchPreshiftChecklistsQuery(baseOptions?: Apollo.QueryHookOptions<FetchPreshiftChecklistsQuery, FetchPreshiftChecklistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPreshiftChecklistsQuery, FetchPreshiftChecklistsQueryVariables>(FetchPreshiftChecklistsDocument, options);
      }
export function useFetchPreshiftChecklistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPreshiftChecklistsQuery, FetchPreshiftChecklistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPreshiftChecklistsQuery, FetchPreshiftChecklistsQueryVariables>(FetchPreshiftChecklistsDocument, options);
        }
export type FetchPreshiftChecklistsQueryHookResult = ReturnType<typeof useFetchPreshiftChecklistsQuery>;
export type FetchPreshiftChecklistsLazyQueryHookResult = ReturnType<typeof useFetchPreshiftChecklistsLazyQuery>;
export type FetchPreshiftChecklistsQueryResult = Apollo.QueryResult<FetchPreshiftChecklistsQuery, FetchPreshiftChecklistsQueryVariables>;
export const FetchAssetsDeviceDocument = gql`
    query FetchAssetsDevice($ids: [ID!]!) {
  assetsDevice(ids: $ids) {
    deviceId
    deviceProvider
    reading
    attachedAsset
    tankCapacity
  }
}
    `;

/**
 * __useFetchAssetsDeviceQuery__
 *
 * To run a query within a React component, call `useFetchAssetsDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAssetsDeviceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAssetsDeviceQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useFetchAssetsDeviceQuery(baseOptions: Apollo.QueryHookOptions<FetchAssetsDeviceQuery, FetchAssetsDeviceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAssetsDeviceQuery, FetchAssetsDeviceQueryVariables>(FetchAssetsDeviceDocument, options);
      }
export function useFetchAssetsDeviceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAssetsDeviceQuery, FetchAssetsDeviceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAssetsDeviceQuery, FetchAssetsDeviceQueryVariables>(FetchAssetsDeviceDocument, options);
        }
export type FetchAssetsDeviceQueryHookResult = ReturnType<typeof useFetchAssetsDeviceQuery>;
export type FetchAssetsDeviceLazyQueryHookResult = ReturnType<typeof useFetchAssetsDeviceLazyQuery>;
export type FetchAssetsDeviceQueryResult = Apollo.QueryResult<FetchAssetsDeviceQuery, FetchAssetsDeviceQueryVariables>;
export const FetchFilteredV3TerminalDocument = gql`
    query FetchFilteredV3Terminal($limit: Int, $offset: Int, $all: String, $sorter: [TerminalSorter!], $isWarehouse: Boolean) {
  filteredTerminals(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {all: $all, active: true, isWarehouse: $isWarehouse}
  ) {
    collection {
      id
      active
      name
      erpId
      site {
        radius
        address
      }
      suppliers {
        id
        supplierId
        loadingAccounts {
          id
          carrierCustomerCode
          loadingNumber
          supplierCode
          name
          supplierId
        }
        name
        active
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFetchFilteredV3TerminalQuery__
 *
 * To run a query within a React component, call `useFetchFilteredV3TerminalQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredV3TerminalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredV3TerminalQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      all: // value for 'all'
 *      sorter: // value for 'sorter'
 *      isWarehouse: // value for 'isWarehouse'
 *   },
 * });
 */
export function useFetchFilteredV3TerminalQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredV3TerminalQuery, FetchFilteredV3TerminalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredV3TerminalQuery, FetchFilteredV3TerminalQueryVariables>(FetchFilteredV3TerminalDocument, options);
      }
export function useFetchFilteredV3TerminalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredV3TerminalQuery, FetchFilteredV3TerminalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredV3TerminalQuery, FetchFilteredV3TerminalQueryVariables>(FetchFilteredV3TerminalDocument, options);
        }
export type FetchFilteredV3TerminalQueryHookResult = ReturnType<typeof useFetchFilteredV3TerminalQuery>;
export type FetchFilteredV3TerminalLazyQueryHookResult = ReturnType<typeof useFetchFilteredV3TerminalLazyQuery>;
export type FetchFilteredV3TerminalQueryResult = Apollo.QueryResult<FetchFilteredV3TerminalQuery, FetchFilteredV3TerminalQueryVariables>;
export const FilteredOrderGroupForOrderHistoryV2Document = gql`
    query FilteredOrderGroupForOrderHistoryV2($limit: Int, $offset: Int, $filter: OrderGroupFilter, $sorter: [OrderGroupSorter!]) {
  filteredOrderGroups(
    limit: $limit
    offset: $offset
    filter: $filter
    sorter: $sorter
  ) {
    collection {
      id
      status
      shift {
        id
        deliveryTruck {
          id
          name
        }
      }
      worker {
        name
      }
      deliveryOrder {
        id
        status
        deliveryDateTimestamp
        orderedProductsSummary {
          totalDeliveredVolume
          totalRequestedVolume
          productId
        }
      }
    }
  }
}
    `;

/**
 * __useFilteredOrderGroupForOrderHistoryV2Query__
 *
 * To run a query within a React component, call `useFilteredOrderGroupForOrderHistoryV2Query` and pass it any options that fit your needs.
 * When your component renders, `useFilteredOrderGroupForOrderHistoryV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredOrderGroupForOrderHistoryV2Query({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilteredOrderGroupForOrderHistoryV2Query(baseOptions?: Apollo.QueryHookOptions<FilteredOrderGroupForOrderHistoryV2Query, FilteredOrderGroupForOrderHistoryV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredOrderGroupForOrderHistoryV2Query, FilteredOrderGroupForOrderHistoryV2QueryVariables>(FilteredOrderGroupForOrderHistoryV2Document, options);
      }
export function useFilteredOrderGroupForOrderHistoryV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredOrderGroupForOrderHistoryV2Query, FilteredOrderGroupForOrderHistoryV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredOrderGroupForOrderHistoryV2Query, FilteredOrderGroupForOrderHistoryV2QueryVariables>(FilteredOrderGroupForOrderHistoryV2Document, options);
        }
export type FilteredOrderGroupForOrderHistoryV2QueryHookResult = ReturnType<typeof useFilteredOrderGroupForOrderHistoryV2Query>;
export type FilteredOrderGroupForOrderHistoryV2LazyQueryHookResult = ReturnType<typeof useFilteredOrderGroupForOrderHistoryV2LazyQuery>;
export type FilteredOrderGroupForOrderHistoryV2QueryResult = Apollo.QueryResult<FilteredOrderGroupForOrderHistoryV2Query, FilteredOrderGroupForOrderHistoryV2QueryVariables>;
export const FetchPreferredProductTerminalDocument = gql`
    query FetchPreferredProductTerminal($customerBranchId: ID!) {
  customerBranch(id: $customerBranchId) {
    id
    name
    preferredProductTerminals {
      id
      isDefault
      terminal {
        id
        active
        isWarehouse
        name
        site {
          address
        }
        suppliers {
          id
          name
          supplierId
          active
          loadingAccounts {
            carrierCustomerCode
            id
            label
            loadingNumber
            name
            supplierCode
            supplierId
          }
        }
      }
      product {
        id
        name
        active
        soldAs
      }
      preferredProductTerminalSuppliers {
        id
        priority
        supplier {
          id
          name
          supplierId
          loadingAccounts {
            carrierCustomerCode
            id
            label
            loadingNumber
            name
            supplierCode
            supplierId
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchPreferredProductTerminalQuery__
 *
 * To run a query within a React component, call `useFetchPreferredProductTerminalQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPreferredProductTerminalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPreferredProductTerminalQuery({
 *   variables: {
 *      customerBranchId: // value for 'customerBranchId'
 *   },
 * });
 */
export function useFetchPreferredProductTerminalQuery(baseOptions: Apollo.QueryHookOptions<FetchPreferredProductTerminalQuery, FetchPreferredProductTerminalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPreferredProductTerminalQuery, FetchPreferredProductTerminalQueryVariables>(FetchPreferredProductTerminalDocument, options);
      }
export function useFetchPreferredProductTerminalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPreferredProductTerminalQuery, FetchPreferredProductTerminalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPreferredProductTerminalQuery, FetchPreferredProductTerminalQueryVariables>(FetchPreferredProductTerminalDocument, options);
        }
export type FetchPreferredProductTerminalQueryHookResult = ReturnType<typeof useFetchPreferredProductTerminalQuery>;
export type FetchPreferredProductTerminalLazyQueryHookResult = ReturnType<typeof useFetchPreferredProductTerminalLazyQuery>;
export type FetchPreferredProductTerminalQueryResult = Apollo.QueryResult<FetchPreferredProductTerminalQuery, FetchPreferredProductTerminalQueryVariables>;
export const FetchFilteredOrderGroupsDocument = gql`
    query FetchFilteredOrderGroups($filter: OrderGroupFilter) {
  filteredOrderGroups(filter: $filter) {
    collection {
      id
      status
      customerBranch {
        id
        name
        customer {
          id
          name
          status
        }
      }
      deliveryOrder {
        id
        type
        orderLinks {
          id
          loadingOrder {
            id
            terminal {
              id
              name
            }
          }
        }
      }
      extractionOrder {
        id
        type
        orderLinks {
          id
          loadingOrder {
            id
            terminal {
              id
              name
            }
          }
        }
      }
      recurrenceData {
        lastDelivery
        nextDate
        recurrence {
          recurrenceType
          recurrenceUntil
        }
      }
    }
    metadata {
      totalCount
    }
  }
}
    `;

/**
 * __useFetchFilteredOrderGroupsQuery__
 *
 * To run a query within a React component, call `useFetchFilteredOrderGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredOrderGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredOrderGroupsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchFilteredOrderGroupsQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredOrderGroupsQuery, FetchFilteredOrderGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredOrderGroupsQuery, FetchFilteredOrderGroupsQueryVariables>(FetchFilteredOrderGroupsDocument, options);
      }
export function useFetchFilteredOrderGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredOrderGroupsQuery, FetchFilteredOrderGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredOrderGroupsQuery, FetchFilteredOrderGroupsQueryVariables>(FetchFilteredOrderGroupsDocument, options);
        }
export type FetchFilteredOrderGroupsQueryHookResult = ReturnType<typeof useFetchFilteredOrderGroupsQuery>;
export type FetchFilteredOrderGroupsLazyQueryHookResult = ReturnType<typeof useFetchFilteredOrderGroupsLazyQuery>;
export type FetchFilteredOrderGroupsQueryResult = Apollo.QueryResult<FetchFilteredOrderGroupsQuery, FetchFilteredOrderGroupsQueryVariables>;
export const FetchFilteredTerminalDocument = gql`
    query FetchFilteredTerminal($limit: Int, $offset: Int, $all: String, $sorter: [TerminalSorter!], $isWarehouse: Boolean) {
  filteredTerminals(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {all: $all, active: true, isWarehouse: $isWarehouse}
  ) {
    collection {
      id
      active
      name
      erpId
      site {
        radius
        address
      }
      products {
        id
        name
        soldAs
        productType
        deliveryType
        productCategory {
          id
        }
      }
      suppliers {
        id
        supplierId
        loadingAccounts {
          id
          carrierCustomerCode
          loadingNumber
          destinationState
          supplierCode
          name
          supplierId
        }
        name
        active
      }
    }
    metadata {
      hasMore
      totalCount
      total_entries
    }
  }
}
    `;

/**
 * __useFetchFilteredTerminalQuery__
 *
 * To run a query within a React component, call `useFetchFilteredTerminalQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredTerminalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredTerminalQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      all: // value for 'all'
 *      sorter: // value for 'sorter'
 *      isWarehouse: // value for 'isWarehouse'
 *   },
 * });
 */
export function useFetchFilteredTerminalQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredTerminalQuery, FetchFilteredTerminalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredTerminalQuery, FetchFilteredTerminalQueryVariables>(FetchFilteredTerminalDocument, options);
      }
export function useFetchFilteredTerminalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredTerminalQuery, FetchFilteredTerminalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredTerminalQuery, FetchFilteredTerminalQueryVariables>(FetchFilteredTerminalDocument, options);
        }
export type FetchFilteredTerminalQueryHookResult = ReturnType<typeof useFetchFilteredTerminalQuery>;
export type FetchFilteredTerminalLazyQueryHookResult = ReturnType<typeof useFetchFilteredTerminalLazyQuery>;
export type FetchFilteredTerminalQueryResult = Apollo.QueryResult<FetchFilteredTerminalQuery, FetchFilteredTerminalQueryVariables>;
export const FetchPackageProductDocument = gql`
    query FetchPackageProduct($limit: Int, $offset: Int, $filter: ProductFilter) {
  filteredProducts(limit: $limit, offset: $offset, filter: $filter) {
    metadata {
      hasMore
    }
    collection {
      id
      unit
      code
      name
      erpId
      soldAs
      active
      brand {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useFetchPackageProductQuery__
 *
 * To run a query within a React component, call `useFetchPackageProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPackageProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPackageProductQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchPackageProductQuery(baseOptions?: Apollo.QueryHookOptions<FetchPackageProductQuery, FetchPackageProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPackageProductQuery, FetchPackageProductQueryVariables>(FetchPackageProductDocument, options);
      }
export function useFetchPackageProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPackageProductQuery, FetchPackageProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPackageProductQuery, FetchPackageProductQueryVariables>(FetchPackageProductDocument, options);
        }
export type FetchPackageProductQueryHookResult = ReturnType<typeof useFetchPackageProductQuery>;
export type FetchPackageProductLazyQueryHookResult = ReturnType<typeof useFetchPackageProductLazyQuery>;
export type FetchPackageProductQueryResult = Apollo.QueryResult<FetchPackageProductQuery, FetchPackageProductQueryVariables>;
export const FetchProcessingRecurrenceStatusForUpdateOrderDocument = gql`
    query FetchProcessingRecurrenceStatusForUpdateOrder($id: ID!) {
  orderGroup(id: $id) {
    processingRecurrence
  }
}
    `;

/**
 * __useFetchProcessingRecurrenceStatusForUpdateOrderQuery__
 *
 * To run a query within a React component, call `useFetchProcessingRecurrenceStatusForUpdateOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProcessingRecurrenceStatusForUpdateOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProcessingRecurrenceStatusForUpdateOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchProcessingRecurrenceStatusForUpdateOrderQuery(baseOptions: Apollo.QueryHookOptions<FetchProcessingRecurrenceStatusForUpdateOrderQuery, FetchProcessingRecurrenceStatusForUpdateOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchProcessingRecurrenceStatusForUpdateOrderQuery, FetchProcessingRecurrenceStatusForUpdateOrderQueryVariables>(FetchProcessingRecurrenceStatusForUpdateOrderDocument, options);
      }
export function useFetchProcessingRecurrenceStatusForUpdateOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchProcessingRecurrenceStatusForUpdateOrderQuery, FetchProcessingRecurrenceStatusForUpdateOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchProcessingRecurrenceStatusForUpdateOrderQuery, FetchProcessingRecurrenceStatusForUpdateOrderQueryVariables>(FetchProcessingRecurrenceStatusForUpdateOrderDocument, options);
        }
export type FetchProcessingRecurrenceStatusForUpdateOrderQueryHookResult = ReturnType<typeof useFetchProcessingRecurrenceStatusForUpdateOrderQuery>;
export type FetchProcessingRecurrenceStatusForUpdateOrderLazyQueryHookResult = ReturnType<typeof useFetchProcessingRecurrenceStatusForUpdateOrderLazyQuery>;
export type FetchProcessingRecurrenceStatusForUpdateOrderQueryResult = Apollo.QueryResult<FetchProcessingRecurrenceStatusForUpdateOrderQuery, FetchProcessingRecurrenceStatusForUpdateOrderQueryVariables>;
export const FetchTotalCustomerRequestedVolumeDocument = gql`
    query FetchTotalCustomerRequestedVolume($customerId: ID!, $fromDate: Int, $toDate: Int) {
  customer(id: $customerId) {
    totalRequestedVolume(fromDate: $fromDate, toDate: $toDate)
  }
}
    `;

/**
 * __useFetchTotalCustomerRequestedVolumeQuery__
 *
 * To run a query within a React component, call `useFetchTotalCustomerRequestedVolumeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTotalCustomerRequestedVolumeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTotalCustomerRequestedVolumeQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useFetchTotalCustomerRequestedVolumeQuery(baseOptions: Apollo.QueryHookOptions<FetchTotalCustomerRequestedVolumeQuery, FetchTotalCustomerRequestedVolumeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTotalCustomerRequestedVolumeQuery, FetchTotalCustomerRequestedVolumeQueryVariables>(FetchTotalCustomerRequestedVolumeDocument, options);
      }
export function useFetchTotalCustomerRequestedVolumeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTotalCustomerRequestedVolumeQuery, FetchTotalCustomerRequestedVolumeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTotalCustomerRequestedVolumeQuery, FetchTotalCustomerRequestedVolumeQueryVariables>(FetchTotalCustomerRequestedVolumeDocument, options);
        }
export type FetchTotalCustomerRequestedVolumeQueryHookResult = ReturnType<typeof useFetchTotalCustomerRequestedVolumeQuery>;
export type FetchTotalCustomerRequestedVolumeLazyQueryHookResult = ReturnType<typeof useFetchTotalCustomerRequestedVolumeLazyQuery>;
export type FetchTotalCustomerRequestedVolumeQueryResult = Apollo.QueryResult<FetchTotalCustomerRequestedVolumeQuery, FetchTotalCustomerRequestedVolumeQueryVariables>;
export const FilteredOrderGroupForOrderHistoryDocument = gql`
    query FilteredOrderGroupForOrderHistory($limit: Int, $offset: Int, $filter: OrderGroupFilter, $sorter: [OrderGroupSorter!]) {
  filteredOrderGroups(
    limit: $limit
    offset: $offset
    filter: $filter
    sorter: $sorter
  ) {
    collection {
      id
      status
      shift {
        id
        deliveryTruck {
          id
          name
        }
      }
      worker {
        name
      }
      deliveryOrder {
        id
        status
        deliveryDateTimestamp
        orderedProductsSummary {
          totalDeliveredVolume
          totalRequestedVolume
          productId
        }
      }
    }
  }
}
    `;

/**
 * __useFilteredOrderGroupForOrderHistoryQuery__
 *
 * To run a query within a React component, call `useFilteredOrderGroupForOrderHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredOrderGroupForOrderHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredOrderGroupForOrderHistoryQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFilteredOrderGroupForOrderHistoryQuery(baseOptions?: Apollo.QueryHookOptions<FilteredOrderGroupForOrderHistoryQuery, FilteredOrderGroupForOrderHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredOrderGroupForOrderHistoryQuery, FilteredOrderGroupForOrderHistoryQueryVariables>(FilteredOrderGroupForOrderHistoryDocument, options);
      }
export function useFilteredOrderGroupForOrderHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredOrderGroupForOrderHistoryQuery, FilteredOrderGroupForOrderHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredOrderGroupForOrderHistoryQuery, FilteredOrderGroupForOrderHistoryQueryVariables>(FilteredOrderGroupForOrderHistoryDocument, options);
        }
export type FilteredOrderGroupForOrderHistoryQueryHookResult = ReturnType<typeof useFilteredOrderGroupForOrderHistoryQuery>;
export type FilteredOrderGroupForOrderHistoryLazyQueryHookResult = ReturnType<typeof useFilteredOrderGroupForOrderHistoryLazyQuery>;
export type FilteredOrderGroupForOrderHistoryQueryResult = Apollo.QueryResult<FilteredOrderGroupForOrderHistoryQuery, FilteredOrderGroupForOrderHistoryQueryVariables>;
export const CreateOrderQuoteDocument = gql`
    mutation CreateOrderQuote($input: CreateQuoteInput!) {
  createOrderQuote(input: $input) {
    response {
      productSummary {
        productId
        topOff
        productPricingDetails {
          name
          rate
          quantity
          type
          total
          rateUnit
        }
        applicableTaxDetails {
          name
          erpId
          rate
          quantity
          rateUnit
          type
          total
        }
        error
      }
      applicableFeeDetails {
        name
        rate
        quantity
        rateUnit
        type
        total
      }
      fileUrl
    }
    error
  }
}
    `;
export type CreateOrderQuoteMutationFn = Apollo.MutationFunction<CreateOrderQuoteMutation, CreateOrderQuoteMutationVariables>;

/**
 * __useCreateOrderQuoteMutation__
 *
 * To run a mutation, you first call `useCreateOrderQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderQuoteMutation, { data, loading, error }] = useCreateOrderQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderQuoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderQuoteMutation, CreateOrderQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderQuoteMutation, CreateOrderQuoteMutationVariables>(CreateOrderQuoteDocument, options);
      }
export type CreateOrderQuoteMutationHookResult = ReturnType<typeof useCreateOrderQuoteMutation>;
export type CreateOrderQuoteMutationResult = Apollo.MutationResult<CreateOrderQuoteMutation>;
export type CreateOrderQuoteMutationOptions = Apollo.BaseMutationOptions<CreateOrderQuoteMutation, CreateOrderQuoteMutationVariables>;
export const FetchAssetProductsDocument = gql`
    query FetchAssetProducts($id: ID!) {
  asset(id: $id) {
    id
    name
    fuelTypeProducts {
      id
      code
      colorCode
      name
      longDescription
      productType
      active
    }
  }
}
    `;

/**
 * __useFetchAssetProductsQuery__
 *
 * To run a query within a React component, call `useFetchAssetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAssetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAssetProductsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchAssetProductsQuery(baseOptions: Apollo.QueryHookOptions<FetchAssetProductsQuery, FetchAssetProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAssetProductsQuery, FetchAssetProductsQueryVariables>(FetchAssetProductsDocument, options);
      }
export function useFetchAssetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAssetProductsQuery, FetchAssetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAssetProductsQuery, FetchAssetProductsQueryVariables>(FetchAssetProductsDocument, options);
        }
export type FetchAssetProductsQueryHookResult = ReturnType<typeof useFetchAssetProductsQuery>;
export type FetchAssetProductsLazyQueryHookResult = ReturnType<typeof useFetchAssetProductsLazyQuery>;
export type FetchAssetProductsQueryResult = Apollo.QueryResult<FetchAssetProductsQuery, FetchAssetProductsQueryVariables>;
export const CreateSavedViewDocument = gql`
    mutation CreateSavedView($input: CreateSavedViewInput!) {
  createSavedView(input: $input) {
    errors
    savedView {
      config
      id
      name
      viewType
    }
  }
}
    `;
export type CreateSavedViewMutationFn = Apollo.MutationFunction<CreateSavedViewMutation, CreateSavedViewMutationVariables>;

/**
 * __useCreateSavedViewMutation__
 *
 * To run a mutation, you first call `useCreateSavedViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSavedViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSavedViewMutation, { data, loading, error }] = useCreateSavedViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSavedViewMutation(baseOptions?: Apollo.MutationHookOptions<CreateSavedViewMutation, CreateSavedViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSavedViewMutation, CreateSavedViewMutationVariables>(CreateSavedViewDocument, options);
      }
export type CreateSavedViewMutationHookResult = ReturnType<typeof useCreateSavedViewMutation>;
export type CreateSavedViewMutationResult = Apollo.MutationResult<CreateSavedViewMutation>;
export type CreateSavedViewMutationOptions = Apollo.BaseMutationOptions<CreateSavedViewMutation, CreateSavedViewMutationVariables>;
export const FetchCarriersDocument = gql`
    query FetchCarriers($limit: Int = 20, $offset: Int = 0, $customFilter: CcTenantFilter = {}) {
  filteredCcTenants(limit: $limit, offset: $offset, filter: $customFilter) {
    collection {
      name
      id
    }
  }
}
    `;

/**
 * __useFetchCarriersQuery__
 *
 * To run a query within a React component, call `useFetchCarriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCarriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCarriersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      customFilter: // value for 'customFilter'
 *   },
 * });
 */
export function useFetchCarriersQuery(baseOptions?: Apollo.QueryHookOptions<FetchCarriersQuery, FetchCarriersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCarriersQuery, FetchCarriersQueryVariables>(FetchCarriersDocument, options);
      }
export function useFetchCarriersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCarriersQuery, FetchCarriersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCarriersQuery, FetchCarriersQueryVariables>(FetchCarriersDocument, options);
        }
export type FetchCarriersQueryHookResult = ReturnType<typeof useFetchCarriersQuery>;
export type FetchCarriersLazyQueryHookResult = ReturnType<typeof useFetchCarriersLazyQuery>;
export type FetchCarriersQueryResult = Apollo.QueryResult<FetchCarriersQuery, FetchCarriersQueryVariables>;
export const FetchDriverGroupDocument = gql`
    query FetchDriverGroup($filter: GroupFilter, $sorter: [GroupSorter!]) {
  filteredGroups(filter: $filter, sorter: $sorter) {
    collection {
      id
      name
      groupMemberships {
        groupable {
          ... on Driver {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchDriverGroupQuery__
 *
 * To run a query within a React component, call `useFetchDriverGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDriverGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDriverGroupQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchDriverGroupQuery(baseOptions?: Apollo.QueryHookOptions<FetchDriverGroupQuery, FetchDriverGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDriverGroupQuery, FetchDriverGroupQueryVariables>(FetchDriverGroupDocument, options);
      }
export function useFetchDriverGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDriverGroupQuery, FetchDriverGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDriverGroupQuery, FetchDriverGroupQueryVariables>(FetchDriverGroupDocument, options);
        }
export type FetchDriverGroupQueryHookResult = ReturnType<typeof useFetchDriverGroupQuery>;
export type FetchDriverGroupLazyQueryHookResult = ReturnType<typeof useFetchDriverGroupLazyQuery>;
export type FetchDriverGroupQueryResult = Apollo.QueryResult<FetchDriverGroupQuery, FetchDriverGroupQueryVariables>;
export const FetchDriversDocument = gql`
    query FetchDrivers($limit: Int, $offset: Int, $all: String, $sorter: [DriverSorter!], $driverTypes: [DriverTypeEnum!]) {
  filteredDrivers(
    limit: $limit
    offset: $offset
    sorter: $sorter
    filter: {all: $all, driverTypes: $driverTypes}
  ) {
    collection {
      id
      name
    }
    metadata {
      hasMore
      totalCount
    }
  }
}
    `;

/**
 * __useFetchDriversQuery__
 *
 * To run a query within a React component, call `useFetchDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDriversQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      all: // value for 'all'
 *      sorter: // value for 'sorter'
 *      driverTypes: // value for 'driverTypes'
 *   },
 * });
 */
export function useFetchDriversQuery(baseOptions?: Apollo.QueryHookOptions<FetchDriversQuery, FetchDriversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDriversQuery, FetchDriversQueryVariables>(FetchDriversDocument, options);
      }
export function useFetchDriversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDriversQuery, FetchDriversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDriversQuery, FetchDriversQueryVariables>(FetchDriversDocument, options);
        }
export type FetchDriversQueryHookResult = ReturnType<typeof useFetchDriversQuery>;
export type FetchDriversLazyQueryHookResult = ReturnType<typeof useFetchDriversLazyQuery>;
export type FetchDriversQueryResult = Apollo.QueryResult<FetchDriversQuery, FetchDriversQueryVariables>;
export const FetchFilteredOrderWellDocument = gql`
    query FetchFilteredOrderWell($filter: OrderWellFilter) {
  filteredOrderWell(filter: $filter) {
    collection {
      id
      mainOrderGroupId
      orderId
      type
      shipToName
    }
  }
}
    `;

/**
 * __useFetchFilteredOrderWellQuery__
 *
 * To run a query within a React component, call `useFetchFilteredOrderWellQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredOrderWellQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredOrderWellQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchFilteredOrderWellQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredOrderWellQuery, FetchFilteredOrderWellQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredOrderWellQuery, FetchFilteredOrderWellQueryVariables>(FetchFilteredOrderWellDocument, options);
      }
export function useFetchFilteredOrderWellLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredOrderWellQuery, FetchFilteredOrderWellQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredOrderWellQuery, FetchFilteredOrderWellQueryVariables>(FetchFilteredOrderWellDocument, options);
        }
export type FetchFilteredOrderWellQueryHookResult = ReturnType<typeof useFetchFilteredOrderWellQuery>;
export type FetchFilteredOrderWellLazyQueryHookResult = ReturnType<typeof useFetchFilteredOrderWellLazyQuery>;
export type FetchFilteredOrderWellQueryResult = Apollo.QueryResult<FetchFilteredOrderWellQuery, FetchFilteredOrderWellQueryVariables>;
export const OrderWellGroupSummaryDocument = gql`
    query OrderWellGroupSummary($groupBy: OrderWellGroupByEnum!, $filter: OrderWellFilter) {
  orderWellGroupingSummary(groupBy: $groupBy, filter: $filter) {
    count
    groupValue
    groupValueId
  }
}
    `;

/**
 * __useOrderWellGroupSummaryQuery__
 *
 * To run a query within a React component, call `useOrderWellGroupSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderWellGroupSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderWellGroupSummaryQuery({
 *   variables: {
 *      groupBy: // value for 'groupBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrderWellGroupSummaryQuery(baseOptions: Apollo.QueryHookOptions<OrderWellGroupSummaryQuery, OrderWellGroupSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderWellGroupSummaryQuery, OrderWellGroupSummaryQueryVariables>(OrderWellGroupSummaryDocument, options);
      }
export function useOrderWellGroupSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderWellGroupSummaryQuery, OrderWellGroupSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderWellGroupSummaryQuery, OrderWellGroupSummaryQueryVariables>(OrderWellGroupSummaryDocument, options);
        }
export type OrderWellGroupSummaryQueryHookResult = ReturnType<typeof useOrderWellGroupSummaryQuery>;
export type OrderWellGroupSummaryLazyQueryHookResult = ReturnType<typeof useOrderWellGroupSummaryLazyQuery>;
export type OrderWellGroupSummaryQueryResult = Apollo.QueryResult<OrderWellGroupSummaryQuery, OrderWellGroupSummaryQueryVariables>;
export const FetchSavedViewDocument = gql`
    query FetchSavedView($id: ID!) {
  savedView(id: $id) {
    id
    config
  }
}
    `;

/**
 * __useFetchSavedViewQuery__
 *
 * To run a query within a React component, call `useFetchSavedViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSavedViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSavedViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchSavedViewQuery(baseOptions: Apollo.QueryHookOptions<FetchSavedViewQuery, FetchSavedViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSavedViewQuery, FetchSavedViewQueryVariables>(FetchSavedViewDocument, options);
      }
export function useFetchSavedViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSavedViewQuery, FetchSavedViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSavedViewQuery, FetchSavedViewQueryVariables>(FetchSavedViewDocument, options);
        }
export type FetchSavedViewQueryHookResult = ReturnType<typeof useFetchSavedViewQuery>;
export type FetchSavedViewLazyQueryHookResult = ReturnType<typeof useFetchSavedViewLazyQuery>;
export type FetchSavedViewQueryResult = Apollo.QueryResult<FetchSavedViewQuery, FetchSavedViewQueryVariables>;
export const FetchSavedViewsDocument = gql`
    query FetchSavedViews($viewType: SavedViewEnum!) {
  savedViews(viewType: $viewType) {
    id
    name
    position
    pinned
    preset
    isDefault
  }
}
    `;

/**
 * __useFetchSavedViewsQuery__
 *
 * To run a query within a React component, call `useFetchSavedViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSavedViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSavedViewsQuery({
 *   variables: {
 *      viewType: // value for 'viewType'
 *   },
 * });
 */
export function useFetchSavedViewsQuery(baseOptions: Apollo.QueryHookOptions<FetchSavedViewsQuery, FetchSavedViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSavedViewsQuery, FetchSavedViewsQueryVariables>(FetchSavedViewsDocument, options);
      }
export function useFetchSavedViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSavedViewsQuery, FetchSavedViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSavedViewsQuery, FetchSavedViewsQueryVariables>(FetchSavedViewsDocument, options);
        }
export type FetchSavedViewsQueryHookResult = ReturnType<typeof useFetchSavedViewsQuery>;
export type FetchSavedViewsLazyQueryHookResult = ReturnType<typeof useFetchSavedViewsLazyQuery>;
export type FetchSavedViewsQueryResult = Apollo.QueryResult<FetchSavedViewsQuery, FetchSavedViewsQueryVariables>;
export const FetchTagsDocument = gql`
    query FetchTags($limit: Int, $offset: Int, $filter: TagFilter, $sorter: [BaseSorter!]) {
  filteredTags(limit: $limit, offset: $offset, filter: $filter, sorter: $sorter) {
    collection {
      id
      name
      status
      tagType
      colorCode
      iconName
    }
  }
}
    `;

/**
 * __useFetchTagsQuery__
 *
 * To run a query within a React component, call `useFetchTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTagsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchTagsQuery(baseOptions?: Apollo.QueryHookOptions<FetchTagsQuery, FetchTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTagsQuery, FetchTagsQueryVariables>(FetchTagsDocument, options);
      }
export function useFetchTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTagsQuery, FetchTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTagsQuery, FetchTagsQueryVariables>(FetchTagsDocument, options);
        }
export type FetchTagsQueryHookResult = ReturnType<typeof useFetchTagsQuery>;
export type FetchTagsLazyQueryHookResult = ReturnType<typeof useFetchTagsLazyQuery>;
export type FetchTagsQueryResult = Apollo.QueryResult<FetchTagsQuery, FetchTagsQueryVariables>;
export const FetchTruckDocument = gql`
    query FetchTruck($limit: Int, $offset: Int, $customFilter: DeliveryAssetFilter = {}, $sorter: [BaseSorter!]) {
  filteredDeliveryAssets(
    limit: $limit
    offset: $offset
    filter: $customFilter
    sorter: $sorter
  ) {
    collection {
      id
      name
      category
      assetProductCategories {
        id
        product {
          id
          name
        }
      }
      compartments {
        id
        length
      }
    }
  }
}
    `;

/**
 * __useFetchTruckQuery__
 *
 * To run a query within a React component, call `useFetchTruckQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTruckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTruckQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      customFilter: // value for 'customFilter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchTruckQuery(baseOptions?: Apollo.QueryHookOptions<FetchTruckQuery, FetchTruckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTruckQuery, FetchTruckQueryVariables>(FetchTruckDocument, options);
      }
export function useFetchTruckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTruckQuery, FetchTruckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTruckQuery, FetchTruckQueryVariables>(FetchTruckDocument, options);
        }
export type FetchTruckQueryHookResult = ReturnType<typeof useFetchTruckQuery>;
export type FetchTruckLazyQueryHookResult = ReturnType<typeof useFetchTruckLazyQuery>;
export type FetchTruckQueryResult = Apollo.QueryResult<FetchTruckQuery, FetchTruckQueryVariables>;
export const UpdatePositionSaveViewsDocument = gql`
    mutation UpdatePositionSaveViews($input: CreateOrUpdateConfigViewInput!) {
  configView(input: $input) {
    errors
    savedViews {
      id
      name
      position
      preset
      pinned
      isDefault
    }
  }
}
    `;
export type UpdatePositionSaveViewsMutationFn = Apollo.MutationFunction<UpdatePositionSaveViewsMutation, UpdatePositionSaveViewsMutationVariables>;

/**
 * __useUpdatePositionSaveViewsMutation__
 *
 * To run a mutation, you first call `useUpdatePositionSaveViewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePositionSaveViewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePositionSaveViewsMutation, { data, loading, error }] = useUpdatePositionSaveViewsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePositionSaveViewsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePositionSaveViewsMutation, UpdatePositionSaveViewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePositionSaveViewsMutation, UpdatePositionSaveViewsMutationVariables>(UpdatePositionSaveViewsDocument, options);
      }
export type UpdatePositionSaveViewsMutationHookResult = ReturnType<typeof useUpdatePositionSaveViewsMutation>;
export type UpdatePositionSaveViewsMutationResult = Apollo.MutationResult<UpdatePositionSaveViewsMutation>;
export type UpdatePositionSaveViewsMutationOptions = Apollo.BaseMutationOptions<UpdatePositionSaveViewsMutation, UpdatePositionSaveViewsMutationVariables>;
export const UpdateSavedViewDocument = gql`
    mutation UpdateSavedView($input: UpdateSavedViewInput!) {
  updateSavedView(input: $input) {
    errors
    savedView {
      id
      config
    }
  }
}
    `;
export type UpdateSavedViewMutationFn = Apollo.MutationFunction<UpdateSavedViewMutation, UpdateSavedViewMutationVariables>;

/**
 * __useUpdateSavedViewMutation__
 *
 * To run a mutation, you first call `useUpdateSavedViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSavedViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSavedViewMutation, { data, loading, error }] = useUpdateSavedViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSavedViewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSavedViewMutation, UpdateSavedViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSavedViewMutation, UpdateSavedViewMutationVariables>(UpdateSavedViewDocument, options);
      }
export type UpdateSavedViewMutationHookResult = ReturnType<typeof useUpdateSavedViewMutation>;
export type UpdateSavedViewMutationResult = Apollo.MutationResult<UpdateSavedViewMutation>;
export type UpdateSavedViewMutationOptions = Apollo.BaseMutationOptions<UpdateSavedViewMutation, UpdateSavedViewMutationVariables>;
export const FetchFilteredAssetsDocument = gql`
    query FetchFilteredAssets($customFilter: AssetFilter = {}, $sorter: [AssetSorter!]) {
  filteredAssets(filter: $customFilter, sorter: $sorter) {
    collection {
      id
      name
      category
      licensePlateNumber
      compartments {
        id
        length
        name
      }
    }
    metadata {
      hasMore
      totalCount
    }
  }
}
    `;

/**
 * __useFetchFilteredAssetsQuery__
 *
 * To run a query within a React component, call `useFetchFilteredAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredAssetsQuery({
 *   variables: {
 *      customFilter: // value for 'customFilter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useFetchFilteredAssetsQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredAssetsQuery, FetchFilteredAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredAssetsQuery, FetchFilteredAssetsQueryVariables>(FetchFilteredAssetsDocument, options);
      }
export function useFetchFilteredAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredAssetsQuery, FetchFilteredAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredAssetsQuery, FetchFilteredAssetsQueryVariables>(FetchFilteredAssetsDocument, options);
        }
export type FetchFilteredAssetsQueryHookResult = ReturnType<typeof useFetchFilteredAssetsQuery>;
export type FetchFilteredAssetsLazyQueryHookResult = ReturnType<typeof useFetchFilteredAssetsLazyQuery>;
export type FetchFilteredAssetsQueryResult = Apollo.QueryResult<FetchFilteredAssetsQuery, FetchFilteredAssetsQueryVariables>;
export const DeleteBolAdjustmentDocument = gql`
    mutation DeleteBolAdjustment($input: DeleteResourceInput!) {
  deleteResource(input: $input) {
    clientMutationId
    result
  }
}
    `;
export type DeleteBolAdjustmentMutationFn = Apollo.MutationFunction<DeleteBolAdjustmentMutation, DeleteBolAdjustmentMutationVariables>;

/**
 * __useDeleteBolAdjustmentMutation__
 *
 * To run a mutation, you first call `useDeleteBolAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBolAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBolAdjustmentMutation, { data, loading, error }] = useDeleteBolAdjustmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBolAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBolAdjustmentMutation, DeleteBolAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBolAdjustmentMutation, DeleteBolAdjustmentMutationVariables>(DeleteBolAdjustmentDocument, options);
      }
export type DeleteBolAdjustmentMutationHookResult = ReturnType<typeof useDeleteBolAdjustmentMutation>;
export type DeleteBolAdjustmentMutationResult = Apollo.MutationResult<DeleteBolAdjustmentMutation>;
export type DeleteBolAdjustmentMutationOptions = Apollo.BaseMutationOptions<DeleteBolAdjustmentMutation, DeleteBolAdjustmentMutationVariables>;
export const PushToAgvanceDocument = gql`
    mutation PushToAgvance($vendorName: VendorNameEnum!, $shiftIds: [ID!]!) {
  accountingAsync(
    input: {accountingAsyncAttributes: {vendorName: $vendorName, shiftIds: $shiftIds}}
  ) {
    success
  }
}
    `;
export type PushToAgvanceMutationFn = Apollo.MutationFunction<PushToAgvanceMutation, PushToAgvanceMutationVariables>;

/**
 * __usePushToAgvanceMutation__
 *
 * To run a mutation, you first call `usePushToAgvanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePushToAgvanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pushToAgvanceMutation, { data, loading, error }] = usePushToAgvanceMutation({
 *   variables: {
 *      vendorName: // value for 'vendorName'
 *      shiftIds: // value for 'shiftIds'
 *   },
 * });
 */
export function usePushToAgvanceMutation(baseOptions?: Apollo.MutationHookOptions<PushToAgvanceMutation, PushToAgvanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PushToAgvanceMutation, PushToAgvanceMutationVariables>(PushToAgvanceDocument, options);
      }
export type PushToAgvanceMutationHookResult = ReturnType<typeof usePushToAgvanceMutation>;
export type PushToAgvanceMutationResult = Apollo.MutationResult<PushToAgvanceMutation>;
export type PushToAgvanceMutationOptions = Apollo.BaseMutationOptions<PushToAgvanceMutation, PushToAgvanceMutationVariables>;
export const PushToBookworksDocument = gql`
    mutation PushToBookworks($vendorName: VendorNameEnum!, $shiftIds: [ID!]!) {
  accountingAsync(
    input: {accountingAsyncAttributes: {vendorName: $vendorName, shiftIds: $shiftIds}}
  ) {
    success
  }
}
    `;
export type PushToBookworksMutationFn = Apollo.MutationFunction<PushToBookworksMutation, PushToBookworksMutationVariables>;

/**
 * __usePushToBookworksMutation__
 *
 * To run a mutation, you first call `usePushToBookworksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePushToBookworksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pushToBookworksMutation, { data, loading, error }] = usePushToBookworksMutation({
 *   variables: {
 *      vendorName: // value for 'vendorName'
 *      shiftIds: // value for 'shiftIds'
 *   },
 * });
 */
export function usePushToBookworksMutation(baseOptions?: Apollo.MutationHookOptions<PushToBookworksMutation, PushToBookworksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PushToBookworksMutation, PushToBookworksMutationVariables>(PushToBookworksDocument, options);
      }
export type PushToBookworksMutationHookResult = ReturnType<typeof usePushToBookworksMutation>;
export type PushToBookworksMutationResult = Apollo.MutationResult<PushToBookworksMutation>;
export type PushToBookworksMutationOptions = Apollo.BaseMutationOptions<PushToBookworksMutation, PushToBookworksMutationVariables>;
export const PushToHuntandSonsDocument = gql`
    mutation PushToHuntandSons($vendorName: VendorNameEnum!, $shiftIds: [ID!]!) {
  accountingAsync(
    input: {accountingAsyncAttributes: {vendorName: $vendorName, shiftIds: $shiftIds}}
  ) {
    success
  }
}
    `;
export type PushToHuntandSonsMutationFn = Apollo.MutationFunction<PushToHuntandSonsMutation, PushToHuntandSonsMutationVariables>;

/**
 * __usePushToHuntandSonsMutation__
 *
 * To run a mutation, you first call `usePushToHuntandSonsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePushToHuntandSonsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pushToHuntandSonsMutation, { data, loading, error }] = usePushToHuntandSonsMutation({
 *   variables: {
 *      vendorName: // value for 'vendorName'
 *      shiftIds: // value for 'shiftIds'
 *   },
 * });
 */
export function usePushToHuntandSonsMutation(baseOptions?: Apollo.MutationHookOptions<PushToHuntandSonsMutation, PushToHuntandSonsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PushToHuntandSonsMutation, PushToHuntandSonsMutationVariables>(PushToHuntandSonsDocument, options);
      }
export type PushToHuntandSonsMutationHookResult = ReturnType<typeof usePushToHuntandSonsMutation>;
export type PushToHuntandSonsMutationResult = Apollo.MutationResult<PushToHuntandSonsMutation>;
export type PushToHuntandSonsMutationOptions = Apollo.BaseMutationOptions<PushToHuntandSonsMutation, PushToHuntandSonsMutationVariables>;
export const FetchFilteredOrderGroupsBolLinkDocument = gql`
    query FetchFilteredOrderGroupsBOLLink($fromTimestamp: Int, $toTimestamp: Int, $type: OrderGroupTypeEnum, $productName: String, $isExtractionOrder: Boolean = false) {
  filteredOrderGroups(
    filter: {fromTimestamp: $fromTimestamp, toTimestamp: $toTimestamp, type: $type, product: $productName}
  ) {
    collection {
      id
      startOnTimestamp
      startedOnTimestamp
      status
      worker {
        name
      }
      extractionOrder @include(if: $isExtractionOrder) {
        ...extractionOrderFragment
      }
    }
  }
}
    ${ExtractionOrderFragmentFragmentDoc}`;

/**
 * __useFetchFilteredOrderGroupsBolLinkQuery__
 *
 * To run a query within a React component, call `useFetchFilteredOrderGroupsBolLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredOrderGroupsBolLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredOrderGroupsBolLinkQuery({
 *   variables: {
 *      fromTimestamp: // value for 'fromTimestamp'
 *      toTimestamp: // value for 'toTimestamp'
 *      type: // value for 'type'
 *      productName: // value for 'productName'
 *      isExtractionOrder: // value for 'isExtractionOrder'
 *   },
 * });
 */
export function useFetchFilteredOrderGroupsBolLinkQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredOrderGroupsBolLinkQuery, FetchFilteredOrderGroupsBolLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredOrderGroupsBolLinkQuery, FetchFilteredOrderGroupsBolLinkQueryVariables>(FetchFilteredOrderGroupsBolLinkDocument, options);
      }
export function useFetchFilteredOrderGroupsBolLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredOrderGroupsBolLinkQuery, FetchFilteredOrderGroupsBolLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredOrderGroupsBolLinkQuery, FetchFilteredOrderGroupsBolLinkQueryVariables>(FetchFilteredOrderGroupsBolLinkDocument, options);
        }
export type FetchFilteredOrderGroupsBolLinkQueryHookResult = ReturnType<typeof useFetchFilteredOrderGroupsBolLinkQuery>;
export type FetchFilteredOrderGroupsBolLinkLazyQueryHookResult = ReturnType<typeof useFetchFilteredOrderGroupsBolLinkLazyQuery>;
export type FetchFilteredOrderGroupsBolLinkQueryResult = Apollo.QueryResult<FetchFilteredOrderGroupsBolLinkQuery, FetchFilteredOrderGroupsBolLinkQueryVariables>;
export const AdjustmentInventoryDocument = gql`
    mutation AdjustmentInventory($input: AdjustInventoryInput!) {
  adjustInventory(input: $input) {
    shift {
      id
      orderGroups {
        deliveryOrder {
          id
        }
      }
      adjustedInventories {
        id
        product {
          id
          name
        }
        data
      }
    }
  }
}
    `;
export type AdjustmentInventoryMutationFn = Apollo.MutationFunction<AdjustmentInventoryMutation, AdjustmentInventoryMutationVariables>;

/**
 * __useAdjustmentInventoryMutation__
 *
 * To run a mutation, you first call `useAdjustmentInventoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdjustmentInventoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adjustmentInventoryMutation, { data, loading, error }] = useAdjustmentInventoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdjustmentInventoryMutation(baseOptions?: Apollo.MutationHookOptions<AdjustmentInventoryMutation, AdjustmentInventoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdjustmentInventoryMutation, AdjustmentInventoryMutationVariables>(AdjustmentInventoryDocument, options);
      }
export type AdjustmentInventoryMutationHookResult = ReturnType<typeof useAdjustmentInventoryMutation>;
export type AdjustmentInventoryMutationResult = Apollo.MutationResult<AdjustmentInventoryMutation>;
export type AdjustmentInventoryMutationOptions = Apollo.BaseMutationOptions<AdjustmentInventoryMutation, AdjustmentInventoryMutationVariables>;
export const FetchAdjustmnetDetailsDocument = gql`
    query fetchAdjustmnetDetails($id: ID!) {
  fetchOrderGroup(id: $id) {
    id
    lineItems
  }
}
    `;

/**
 * __useFetchAdjustmnetDetailsQuery__
 *
 * To run a query within a React component, call `useFetchAdjustmnetDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAdjustmnetDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAdjustmnetDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchAdjustmnetDetailsQuery(baseOptions: Apollo.QueryHookOptions<FetchAdjustmnetDetailsQuery, FetchAdjustmnetDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAdjustmnetDetailsQuery, FetchAdjustmnetDetailsQueryVariables>(FetchAdjustmnetDetailsDocument, options);
      }
export function useFetchAdjustmnetDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAdjustmnetDetailsQuery, FetchAdjustmnetDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAdjustmnetDetailsQuery, FetchAdjustmnetDetailsQueryVariables>(FetchAdjustmnetDetailsDocument, options);
        }
export type FetchAdjustmnetDetailsQueryHookResult = ReturnType<typeof useFetchAdjustmnetDetailsQuery>;
export type FetchAdjustmnetDetailsLazyQueryHookResult = ReturnType<typeof useFetchAdjustmnetDetailsLazyQuery>;
export type FetchAdjustmnetDetailsQueryResult = Apollo.QueryResult<FetchAdjustmnetDetailsQuery, FetchAdjustmnetDetailsQueryVariables>;
export const FetchFilteredDeliveryAssetsDocument = gql`
    query FetchFilteredDeliveryAssets {
  filteredDeliveryAssets {
    collection {
      id
      name
      category
      enableZone
      compartments {
        id
        length
        name
      }
    }
  }
}
    `;

/**
 * __useFetchFilteredDeliveryAssetsQuery__
 *
 * To run a query within a React component, call `useFetchFilteredDeliveryAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFilteredDeliveryAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFilteredDeliveryAssetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchFilteredDeliveryAssetsQuery(baseOptions?: Apollo.QueryHookOptions<FetchFilteredDeliveryAssetsQuery, FetchFilteredDeliveryAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFilteredDeliveryAssetsQuery, FetchFilteredDeliveryAssetsQueryVariables>(FetchFilteredDeliveryAssetsDocument, options);
      }
export function useFetchFilteredDeliveryAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFilteredDeliveryAssetsQuery, FetchFilteredDeliveryAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFilteredDeliveryAssetsQuery, FetchFilteredDeliveryAssetsQueryVariables>(FetchFilteredDeliveryAssetsDocument, options);
        }
export type FetchFilteredDeliveryAssetsQueryHookResult = ReturnType<typeof useFetchFilteredDeliveryAssetsQuery>;
export type FetchFilteredDeliveryAssetsLazyQueryHookResult = ReturnType<typeof useFetchFilteredDeliveryAssetsLazyQuery>;
export type FetchFilteredDeliveryAssetsQueryResult = Apollo.QueryResult<FetchFilteredDeliveryAssetsQuery, FetchFilteredDeliveryAssetsQueryVariables>;
export const SuppliersForCriteriaDocument = gql`
    query SuppliersForCriteria($terminalId: ID!, $state: String!, $productCategoryId: ID!) {
  suppliersForCriteria(
    terminalId: $terminalId
    state: $state
    productCategoryId: $productCategoryId
  ) {
    id
    name
    supplierId
    active
    loadingAccounts {
      id
      loadingNumber
      carrierCustomerCode
      name
      label
      destinationState
      isAutoSelected
      matchScore(state: $state, productCategoryId: $productCategoryId)
    }
  }
}
    `;

/**
 * __useSuppliersForCriteriaQuery__
 *
 * To run a query within a React component, call `useSuppliersForCriteriaQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuppliersForCriteriaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuppliersForCriteriaQuery({
 *   variables: {
 *      terminalId: // value for 'terminalId'
 *      state: // value for 'state'
 *      productCategoryId: // value for 'productCategoryId'
 *   },
 * });
 */
export function useSuppliersForCriteriaQuery(baseOptions: Apollo.QueryHookOptions<SuppliersForCriteriaQuery, SuppliersForCriteriaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuppliersForCriteriaQuery, SuppliersForCriteriaQueryVariables>(SuppliersForCriteriaDocument, options);
      }
export function useSuppliersForCriteriaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuppliersForCriteriaQuery, SuppliersForCriteriaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuppliersForCriteriaQuery, SuppliersForCriteriaQueryVariables>(SuppliersForCriteriaDocument, options);
        }
export type SuppliersForCriteriaQueryHookResult = ReturnType<typeof useSuppliersForCriteriaQuery>;
export type SuppliersForCriteriaLazyQueryHookResult = ReturnType<typeof useSuppliersForCriteriaLazyQuery>;
export type SuppliersForCriteriaQueryResult = Apollo.QueryResult<SuppliersForCriteriaQuery, SuppliersForCriteriaQueryVariables>;
export const UpdateTransferOrderAssetsDocument = gql`
    mutation UpdateTransferOrderAssets($input: UpdateTransferOrderAssetsInput!) {
  updateTransferOrderAssets(input: $input) {
    orderGroup {
      id
    }
  }
}
    `;
export type UpdateTransferOrderAssetsMutationFn = Apollo.MutationFunction<UpdateTransferOrderAssetsMutation, UpdateTransferOrderAssetsMutationVariables>;

/**
 * __useUpdateTransferOrderAssetsMutation__
 *
 * To run a mutation, you first call `useUpdateTransferOrderAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransferOrderAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransferOrderAssetsMutation, { data, loading, error }] = useUpdateTransferOrderAssetsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTransferOrderAssetsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransferOrderAssetsMutation, UpdateTransferOrderAssetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransferOrderAssetsMutation, UpdateTransferOrderAssetsMutationVariables>(UpdateTransferOrderAssetsDocument, options);
      }
export type UpdateTransferOrderAssetsMutationHookResult = ReturnType<typeof useUpdateTransferOrderAssetsMutation>;
export type UpdateTransferOrderAssetsMutationResult = Apollo.MutationResult<UpdateTransferOrderAssetsMutation>;
export type UpdateTransferOrderAssetsMutationOptions = Apollo.BaseMutationOptions<UpdateTransferOrderAssetsMutation, UpdateTransferOrderAssetsMutationVariables>;
export const DeleteResourceDocument = gql`
    mutation DeleteResource($input: DeleteResourceInput!) {
  deleteResource(input: $input) {
    result
  }
}
    `;
export type DeleteResourceMutationFn = Apollo.MutationFunction<DeleteResourceMutation, DeleteResourceMutationVariables>;

/**
 * __useDeleteResourceMutation__
 *
 * To run a mutation, you first call `useDeleteResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResourceMutation, { data, loading, error }] = useDeleteResourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteResourceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResourceMutation, DeleteResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResourceMutation, DeleteResourceMutationVariables>(DeleteResourceDocument, options);
      }
export type DeleteResourceMutationHookResult = ReturnType<typeof useDeleteResourceMutation>;
export type DeleteResourceMutationResult = Apollo.MutationResult<DeleteResourceMutation>;
export type DeleteResourceMutationOptions = Apollo.BaseMutationOptions<DeleteResourceMutation, DeleteResourceMutationVariables>;